
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("bPcgy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "MaybeInlineCreateActiveIndexContainer", () => $5ff2ee5124cf17be$export$88c9e8ba5ac9f501);
$parcel$export(module.exports, "default", () => $5ff2ee5124cf17be$export$2e2bcd8739ae039);
$parcel$export(module.exports, "NativeIssueTableEntryPoint", () => $5ff2ee5124cf17be$export$1c6b4acc188098eb);

var $eifR1 = parcelRequire("eifR1");

var $azntM = parcelRequire("azntM");

var $lxGBY = parcelRequire("lxGBY");

var $d4XVp = parcelRequire("d4XVp");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");

var $dqoiX = parcelRequire("dqoiX");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $bHZac = parcelRequire("bHZac");

var $6UDcM = parcelRequire("6UDcM");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $fc4cz = parcelRequire("fc4cz");

var $f7PHy = parcelRequire("f7PHy");

var $5FoyW = parcelRequire("5FoyW");

var $65VLO = parcelRequire("65VLO");

var $czfFt = parcelRequire("czfFt");

var $ceawz = parcelRequire("ceawz");

var $3JOwB = parcelRequire("3JOwB");

var $hxGva = parcelRequire("hxGva");

var $xhiHy = parcelRequire("xhiHy");

var $92cNq = parcelRequire("92cNq");

var $aB7bN = parcelRequire("aB7bN");

var $kYFm9 = parcelRequire("kYFm9");

var $cyLEh = parcelRequire("cyLEh");

var $1wHMz = parcelRequire("1wHMz");

var $fh5X0 = parcelRequire("fh5X0");

var $50ctA = parcelRequire("50ctA");

var $0147U = parcelRequire("0147U");

var $Br57E = parcelRequire("Br57E");

var $kJsz8 = parcelRequire("kJsz8");

var $3I8L4 = parcelRequire("3I8L4");

var $96pci = parcelRequire("96pci");

var $1sTzn = parcelRequire("1sTzn");

var $6HbWX = parcelRequire("6HbWX");

var $b54lr = parcelRequire("b54lr");

var $albIr = parcelRequire("albIr");

var $hmiXQ = parcelRequire("hmiXQ");

var $9dYOM = parcelRequire("9dYOM");

var $hUzfK = parcelRequire("hUzfK");

var $6EzQE = parcelRequire("6EzQE");

var $lT42R = parcelRequire("lT42R");

var $9zTUm = parcelRequire("9zTUm");

var $dFuGx = parcelRequire("dFuGx");

var $1MqPV = parcelRequire("1MqPV");

var $lIAUI = parcelRequire("lIAUI");

var $7BEpL = parcelRequire("7BEpL");

var $iTiuC = parcelRequire("iTiuC");
const $5ff2ee5124cf17be$var$MaybeCustomComponentsProvider = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira_native_issue_table_extra_custom_components'), (0, $1sTzn.CustomComponentsProvider), ({ children: children })=>children);
const $5ff2ee5124cf17be$var$MaybeHierarchyContainer = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes'), (0, $fc4cz.HierarchyContainer), ({ children: children })=>children);
const $5ff2ee5124cf17be$export$88c9e8ba5ac9f501 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira_inline_field_config_gate'), (0, $50ctA.InlineCreateActiveIndexContainer), ({ children: children })=>children);
const $5ff2ee5124cf17be$var$MaybeConnectionsListContainer = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('decouple_connection_register_hooks_from_realtime'), (0, $5FoyW.ConnectionsListContainer), ({ children: children })=>children);
const $5ff2ee5124cf17be$var$NativeIssueTable = ({ issues: issues, groups: groups, columns: columns, project: project, columnWidthOverrides: columnWidthOverrides, columnConfigOverrides: columnConfigOverrides, components: components, loading: loading = false, selectedRow: selectedRow = null, eventHandlers: eventHandlers, isInlineEditingEnabled: isInlineEditingEnabled = true, isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled = false, onSelectedRowChange: onSelectedRowChange, sortField: sortField, sortDirection: sortDirection = (0, $czfFt.SORT_ASC), onReady: onReady, onSortChange: onSortChange, onColumnsChange: onColumnsChange, onColumnResize: onColumnResize, onRestoreDefaultColumns: onRestoreDefaultColumns, issueSearchBaseUrl: issueSearchBaseUrl = '/issues', useColumnLoader: useColumnLoader, isColumnPickerLoading: isColumnPickerLoading, projectContext: projectContext, density: density = (0, $czfFt.DENSITY_COMPACT), isIssueHierarchyEnabled: isIssueHierarchyEnabled = false, isHideDoneItemsEnabled: isHideDoneItemsEnabled = false, areShortcutsEnabled: areShortcutsEnabled = true, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled = false, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled = false, isIssueCreateEnabled: isIssueCreateEnabled = false, enableMultiSelect: enableMultiSelect = false, tableBorderRadius: tableBorderRadius, onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld, onIssueFlatListUpdated: onIssueFlatListUpdated, jql: jql, isStatusTrackingEnabled: isStatusTrackingEnabled = false, isMergedColumnEnabled: isMergedColumnEnabled = false, isIssueRankingEnabled: isIssueRankingEnabled = false, isTimelineEnabled: isTimelineEnabled = false, onPageChange: // Discrete pagination props
onPageChange, onLoadNext: // Infinite scroll pagination props
onLoadNext, onLoadPrevious: onLoadPrevious, isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, activationThreshold: activationThreshold, isGroupingSupported: // Experiment value props
isGroupingSupported = false, isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled = true, isCompactColumnEnabled: isCompactColumnEnabled = false, isReparentingEnabled: isReparentingEnabled = false, isColumnBordersEnabled: isColumnBordersEnabled = true, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled = false, onRowReorder: // Row reordering props
onRowReorder, isEntireRowDraggable: isEntireRowDraggable, ifcConfig: ifcConfig, onRefetch: onRefetch, isStickyColumnsEnabled: isStickyColumnsEnabled = false, stickyColumnIds: stickyColumnIds, preloadedQueries: // Conditional Formatting
preloadedQueries })=>{
    const tableRef = (0, $5uXOq.useRef)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iTiuC.useKeyboardNavigation)(tableRef);
    const issuesData = (0, $8Uumt.useFragment)((0, $d4XVp.default), issues ?? null);
    const groupData = (0, $8Uumt.useFragment)((0, $lxGBY.default), groups ?? null); /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ 
    const columnsData = (0, $8Uumt.useFragment)((0, $azntM.default), columns); /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ 
    const projectData = (0, $8Uumt.useFragment)((0, $eifR1.default), project ?? null);
    const isInitialDataLoaded = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && !isInitialDataLoaded.current) isInitialDataLoaded.current = true;
    }, [
        loading
    ]);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>{
        const issueTableNumberOfColumns = columnsData.totalCount;
        const issueTableFieldTypesSet = new Set();
        if (!(0, $4R6GH.fg)('add_analytics_attributes_in_nin_for_tanuki')) {
            columnsData.edges.map((edge)=>edge?.node.type).filter((0, $aB7bN.isNonNullish)).forEach(issueTableFieldTypesSet.add, issueTableFieldTypesSet);
            const issueTableFieldTypes = Array.from(issueTableFieldTypesSet).sort();
            return {
                issueTableNumberOfColumns: issueTableNumberOfColumns,
                issueTableFieldTypes: issueTableFieldTypes
            };
        }
        const issueTableFieldTypesWithCount = columnsData.edges.map((edge)=>edge?.node.type).filter((0, $aB7bN.isNonNullish)).sort().reduce((acc, type)=>{
            acc[type] = (acc[type] || 0) + 1;
            return acc;
        }, {});
        const issueTableFieldTypes = Object.keys(issueTableFieldTypesWithCount);
        return {
            issueTableNumberOfColumns: issueTableNumberOfColumns,
            issueTableFieldTypes: issueTableFieldTypes,
            issueTableFieldTypesWithCount: issueTableFieldTypesWithCount
        };
    }, [
        columnsData.edges,
        columnsData.totalCount
    ]);
    const canViewColumnConfiguration = useColumnLoader !== undefined;
    const canEditColumnConfiguration = onColumnsChange !== undefined;
    const isColumnResizingEnabled = onColumnResize != null;
    const isRowReorderingEnabled = onRowReorder != null;
    const isInfiniteScrollEnabled = onLoadNext != null && onLoadPrevious != null;
    const userHasEditIssuePermission = projectData?.editIssues?.canPerform === true;
    const userHasCreateIssuePermission = projectData?.createIssues?.canPerform === true;
    if (isInfiniteScrollEnabled && density === (0, $czfFt.DENSITY_FULL)) throw new Error(`Infinite scroll is not allowed when density=${density}`);
    const onColumnPickerChange = (0, $5uXOq.useCallback)((pickerArgs)=>{
        if (Array.isArray(pickerArgs)) onColumnsChange && onColumnsChange(pickerArgs, (0, $czfFt.MODIFY_COLUMNS));
        else if ((0, $4R6GH.fg)('jira_inline_field_config_gate')) {
            const { columnIds: columnIds, isHorizontalAutoScrollNeeded: isHorizontalAutoScrollNeeded, isHorizontalAutoScrollLeftNeeded: isHorizontalAutoScrollLeftNeeded, onSuccessCallback: onSuccessCallback, onErrorCallback: onErrorCallback, retries: retries, analyticsAttributes: attributes, skipRefetch: skipRefetch = false } = pickerArgs;
            if (isHorizontalAutoScrollLeftNeeded && isMergedColumnEnabled && (0, $4R6GH.fg)('jira_list_merged_column_gate')) tableRef?.current?.parentElement?.scrollTo({
                left: 0,
                behavior: 'smooth'
            });
            else if (isHorizontalAutoScrollNeeded) tableRef?.current?.parentElement?.scrollTo({
                left: tableRef?.current.scrollWidth,
                behavior: 'smooth'
            });
            onColumnsChange && onColumnsChange(columnIds, (0, $czfFt.MODIFY_COLUMNS), undefined, onSuccessCallback, onErrorCallback, retries, attributes, skipRefetch);
        }
    }, [
        isMergedColumnEnabled,
        onColumnsChange
    ]);
    const isMergedColumnVisible = (0, $5uXOq.useMemo)(()=>{
        if (isMergedColumnEnabled && (0, $4R6GH.fg)('jira_list_merged_column_gate')) return columnsData.edges.some((edge)=>edge?.node?.type === (0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_KEY || edge?.node?.type === (0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_TYPE || edge?.node?.type === (0, $65VLO.KNOWN_COLUMN_TYPES).SUMMARY);
        return false;
    }, [
        isMergedColumnEnabled,
        columnsData
    ]);
    const mappedColumnConfig = (0, $5uXOq.useMemo)(()=>{
        const columnConfig = (0, $xhiHy.getColumnConfig)(formatMessage);
        const columnsWithConfig = [];
        const types = columnsData.edges.filter((0, $aB7bN.isNonNullish)).map((edge)=>edge.node.type);
        if (isIssueHierarchyEnabled && !(isMergedColumnEnabled && (0, $4R6GH.fg)('jira_list_merged_column_gate')) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) columnsWithConfig.push({
            id: (0, $czfFt.COLUMN_ID_EXPAND_BUTTON),
            type: (0, $65VLO.KNOWN_COLUMN_TYPES).EXPAND_BUTTON,
            title: '',
            fieldTypeDisplayName: '',
            jqlTerm: '',
            customHeader: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                name: "expand-column-header"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ceawz.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7PHy.HierarchyOnboarding), null)),
            ...columnConfig[(0, $65VLO.KNOWN_COLUMN_TYPES).EXPAND_BUTTON](),
            ...columnConfigOverrides?.[(0, $65VLO.KNOWN_COLUMN_TYPES).EXPAND_BUTTON](types)
        });
        columnsData.edges.map((edge)=>edge?.node).filter((0, $aB7bN.isNonNullish)).forEach((node)=>{
            const { fieldSetId: fieldSetId, type: type, displayName: displayName, jqlTerm: jqlTerm, isSortable: isSortable, fieldSetPreferences: fieldSetPreferences, isPlaceHolderField: isPlaceHolderField, fieldsMetadata: fieldsMetadata } = node;
            let configureableFieldId;
            if (fieldsMetadata && (0, $4R6GH.fg)('jira_inline_field_config_gate')) {
                const configureableField = fieldsMetadata?.edges?.find((edge)=>edge?.node?.canBeConfigured);
                if (configureableField != null) configureableFieldId = configureableField?.node?.fieldId;
            }
            const baseConfig = {
                id: fieldSetId,
                type: type,
                title: displayName ?? '',
                jqlTerm: jqlTerm,
                fieldTypeDisplayName: '',
                isSortable: isSortable ?? undefined,
                currentSorting: jqlTerm === sortField ? sortDirection : (0, $czfFt.SORT_NONE),
                onSortOrderChanged: onSortChange,
                customWidth: columnWidthOverrides?.[fieldSetId] ?? fieldSetPreferences?.width ?? undefined,
                ...type === (0, $czfFt.COLUMN_TYPE_PARENT_LINK) && {
                    warningText: formatMessage((0, $6EzQE.default).deprecatedParentLinkMessage, {
                        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                                color: "color.text.inverse",
                                as: "strong"
                            }, chunks)
                    })
                },
                configureableFieldId: configureableFieldId
            };
            if ((0, $aB7bN.isKnownColumnType)(type)) {
                const getColumnTypeConfig = columnConfig[type];
                const knownColumnTypeConfig = getColumnTypeConfig();
                const getColumnConfigOverride = columnConfigOverrides?.[type];
                const columnConfigOverride = getColumnConfigOverride?.(types);
                columnsWithConfig.push({
                    ...baseConfig,
                    ...knownColumnTypeConfig,
                    ...columnConfigOverride,
                    isSortable: knownColumnTypeConfig.isSortable ?? true,
                    isPlaceHolderField: !!isPlaceHolderField
                });
            } else columnsWithConfig.push({
                ...baseConfig,
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                isPlaceHolderField: !!isPlaceHolderField
            });
        });
        if (canViewColumnConfiguration || isIssueOperationMeatballMenuEnabled) columnsWithConfig.push({
            id: (0, $czfFt.COLUMN_ID_MEATBALL_MENU),
            type: (0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS,
            title: '',
            fieldTypeDisplayName: '',
            jqlTerm: '',
            customHeader: canViewColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                alignInline: "end"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UDcM.default), {
                columns: columnsData,
                components: isInlineFieldConfigEnabled && (0, $4R6GH.fg)('jira_inline_field_config_gate') ? {
                    ...components?.columnPicker,
                    Footer: (0, $96pci.IFCFooter)
                } : components?.columnPicker,
                onChange: canEditColumnConfiguration ? onColumnPickerChange : undefined,
                onRestoreDefaultColumns: onRestoreDefaultColumns,
                useColumnLoader: useColumnLoader,
                isLoading: isColumnPickerLoading || loading,
                isMergedColumnEnabled: isMergedColumnEnabled && (0, $4R6GH.fg)('jira_list_merged_column_gate')
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), null, formatMessage((0, $6EzQE.default).columnHeaderIssueActions)),
            ...columnConfig[(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS](),
            ...columnConfigOverrides?.[(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS](types)
        });
        return columnsWithConfig;
    }, [
        isMergedColumnEnabled,
        formatMessage,
        columnsData,
        isIssueHierarchyEnabled,
        canViewColumnConfiguration,
        isIssueOperationMeatballMenuEnabled,
        columnConfigOverrides,
        sortField,
        sortDirection,
        onSortChange,
        columnWidthOverrides,
        isInlineFieldConfigEnabled,
        components?.columnPicker,
        canEditColumnConfiguration,
        onColumnPickerChange,
        onRestoreDefaultColumns,
        useColumnLoader,
        isColumnPickerLoading,
        loading
    ]);
    const checkboxColumnConfig = (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        const checkboxConfig = (0, $xhiHy.getColumnConfig)(formatMessage)[(0, $65VLO.KNOWN_COLUMN_TYPES).CHECKBOX]();
        return {
            id: (0, $czfFt.COLUMN_ID_CHECKBOX),
            type: (0, $65VLO.KNOWN_COLUMN_TYPES).CHECKBOX,
            title: '',
            fieldTypeDisplayName: '',
            jqlTerm: '',
            customHeader: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3JOwB.HeaderCheckboxCell), {
                groupByFieldId: groupData?.groupByField ?? null,
                selectableIssueIds: issuesData?.edges?.map((edge)=>edge?.node?.issueId ?? '') ?? []
            }),
            ...checkboxConfig
        };
    }, [
        formatMessage,
        issuesData?.edges,
        groupData?.groupByField
    ]) : undefined;
    const mappedColumns = (0, $5uXOq.useMemo)(()=>{
        // Step 1: get columnConfigs based on bulk ops gate (when enabled)
        let computedMappedColumns = mappedColumnConfig;
        if ((0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false)) {
            if (enableMultiSelect) // Remove type assertion when cleaning up `bulk_operations_in_nin`
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            computedMappedColumns = [
                checkboxColumnConfig,
                ...mappedColumnConfig
            ];
        } // Step 2: get columnConfigs with merged column when enabled.
        if (isMergedColumnEnabled && (0, $4R6GH.fg)('jira_list_merged_column_gate')) computedMappedColumns = (0, $6HbWX.getMergedColumnConfig)(computedMappedColumns, isIssueHierarchyEnabled, formatMessage);
         // Step 3: get columnConfigs with sticky attributes when frozen columns enabled.
        if (isStickyColumnsEnabled && (0, $4R6GH.fg)('issue_table_frozen_columns')) computedMappedColumns = (0, $92cNq.getColumnsWithStickyOffsets)(computedMappedColumns, stickyColumnIds);
        return computedMappedColumns;
    }, [
        checkboxColumnConfig,
        enableMultiSelect,
        formatMessage,
        isMergedColumnEnabled,
        isIssueHierarchyEnabled,
        isStickyColumnsEnabled,
        mappedColumnConfig,
        stickyColumnIds
    ]);
    const handleOnColumnsChange = (0, $5uXOq.useCallback)((newColumns)=>{
        if (onColumnsChange) {
            let columnsWithIssueData = newColumns.filter(({ id: id })=>Boolean(id) && ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') || (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) || isMergedColumnVisible && (0, $4R6GH.fg)('jira_list_merged_column_gate') ? !(0, $czfFt.ACTION_COLUMNS).includes(id) : id !== (0, $czfFt.COLUMN_ID_MEATBALL_MENU))); // make sure merged fields (key, type, summary) are passed to the onColumnsChange
            if (isMergedColumnVisible && (0, $4R6GH.fg)('jira_list_merged_column_gate')) {
                const mergedColumns = newColumns.find((col)=>col?.id === (0, $65VLO.COLUMN_ID_MERGED_COLUMN))?.mergedColumns;
                if (mergedColumns?.length) columnsWithIssueData = [
                    ...mergedColumns,
                    ...columnsWithIssueData
                ];
            }
            const columnIds = columnsWithIssueData.map(({ id: id })=>id);
            const edges = columnsWithIssueData.map(({ id: id, type: type, title: title, jqlTerm: jqlTerm, isSortable: isSortable, fieldTypeDisplayName: fieldTypeDisplayName, customWidth: customWidth })=>({
                    node: {
                        fieldSetId: id,
                        type: type ?? null,
                        displayName: title,
                        jqlTerm: jqlTerm ?? null,
                        isSortable: isSortable ?? null,
                        fieldType: fieldTypeDisplayName ? {
                            displayName: fieldTypeDisplayName
                        } : null,
                        fieldSetPreferences: customWidth ? {
                            width: customWidth
                        } : null,
                        fieldsMetadata: null
                    }
                }));
            const optimisticFieldSets = {
                totalCount: columnsData.totalCount,
                edges: edges
            };
            onColumnsChange(columnIds, (0, $czfFt.REORDER_COLUMNS), optimisticFieldSets);
        }
    }, [
        columnsData.totalCount,
        isMergedColumnVisible,
        onColumnsChange
    ]); // TODO: HRZ-1643 Handle shortcuts with grouping
    const issueKeys = (0, $5uXOq.useMemo)(()=>(0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? undefined : issuesData?.edges?.map((edge)=>edge?.node?.key ?? ''), [
        issuesData?.edges
    ]);
    const tableInjectedProps = (0, $5uXOq.useMemo)(()=>({
            ...eventHandlers,
            issueSearchBaseUrl: issueSearchBaseUrl
        }), [
        eventHandlers,
        issueSearchBaseUrl
    ]);
    const columnPickerProps = (0, $5uXOq.useMemo)(()=>isInBetweenColumnPickerEnabled && canViewColumnConfiguration ? {
            columns: columnsData,
            components: components?.columnPicker,
            onChange: canEditColumnConfiguration ? onColumnPickerChange : undefined,
            onRestoreDefaultColumns: onRestoreDefaultColumns,
            useColumnLoader: useColumnLoader,
            isLoading: isColumnPickerLoading || loading
        } : undefined, [
        canEditColumnConfiguration,
        canViewColumnConfiguration,
        columnsData,
        components?.columnPicker,
        isColumnPickerLoading,
        isInBetweenColumnPickerEnabled,
        loading,
        onColumnPickerChange,
        onRestoreDefaultColumns,
        useColumnLoader
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onReady && (0, $4R6GH.fg)('endeavour_nin_filter_results_gadget') && onReady();
    }, [
        onReady
    ]);
    const conditionalOnColumnsChange = canEditColumnConfiguration ? handleOnColumnsChange : undefined; // Show the skeleton if we are loading on initial render as we may only have partial row data
    if (loading && !isInitialDataLoaded.current) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hxGva.IssueTableSkeleton), null);
    const footer = issuesData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $albIr.default), {
        Footer: components?.Footer,
        IssueCount: components?.IssueCount,
        issues: issuesData,
        onPageChange: onPageChange
    }) : null;
    const connectionsSubscriber = components?.ConnectionsSubscriber && (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lIAUI.ConnectionsSubscriberContainer), {
        ConnectionsSubscriber: components.ConnectionsSubscriber
    }) : null;
    const hierarchyRemountKey = `${isIssueHierarchyEnabled}-${isGroupingSupported ? groupData?.jql || issuesData?.jql : ''}-${groupData?.groupByField}`;
    const ScrollContainer = (0, $4R6GH.fg)('jira_native_issue_table_extra_custom_components') ? components?.ScrollContainer ?? (0, $9zTUm.ScrollContainer) : (0, $9zTUm.ScrollContainer);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "nativeIssueTable",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyLEh.FeaturesContainer), {
        density: density,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isInfiniteScrollEnabled: isInfiniteScrollEnabled,
        isInlineEditingEnabled: isInlineEditingEnabled,
        isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled,
        isIssueCreateEnabled: (0, $4R6GH.fg)('jira_list_check_issue_create_permissions') ? isIssueCreateEnabled && userHasCreateIssuePermission : isIssueCreateEnabled,
        projectContext: projectContext,
        isIssueHierarchyEnabled: isIssueHierarchyEnabled,
        ...(0, $4R6GH.fg)('jsc_list_reranking_gate_technical') && {
            isIssueRankingEnabled: isIssueRankingEnabled
        },
        isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled,
        isRowReorderingEnabled: isRowReorderingEnabled,
        isEntireRowDraggable: isEntireRowDraggable,
        isReparentingEnabled: isReparentingEnabled && isIssueHierarchyEnabled && (!groupData || !groupData?.groupByField) && userHasEditIssuePermission,
        sortDirection: sortDirection,
        sortField: sortField,
        jql: jql ?? '',
        isColumnBordersEnabled: isColumnBordersEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        isHideDoneItemsEnabled: isHideDoneItemsEnabled,
        isMergedColumnEnabled: isMergedColumnEnabled,
        isMergedColumnVisible: isMergedColumnVisible,
        isStickyColumnsEnabled: isStickyColumnsEnabled,
        isConditionalFormattingEnabled: (0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate') ? preloadedQueries?.formatRulesQuery != null : undefined,
        isTimelineEnabled: isTimelineEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ff2ee5124cf17be$var$MaybeCustomComponentsProvider, {
        components: components
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0147U.TableIntersectionObserverContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hmiXQ.IssueFetchQueryVariables), {
        columns: columnsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ff2ee5124cf17be$export$88c9e8ba5ac9f501, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fh5X0.SiblingCreateActiveIndexContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ff2ee5124cf17be$var$MaybeHierarchyContainer // Key used to reset the container store when the hierarchy settings change
    , {
        // Without it there may be flickering when Concurrent Mode is enabled
        key: hierarchyRemountKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3I8L4.DraggableRowsContainer), {
        onRowReorder: onRowReorder,
        issueConnectionId: issuesData?.__id || '',
        instanceId: issuesData?.__id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ff2ee5124cf17be$var$MainContainer, {
        tableBorderRadius: tableBorderRadius,
        "data-vc": `issue-table-main-container${false ? '-ssr' : ''}`,
        ...false && {
            'data-ssr-placeholder': 'issue-table-main-container-placeholder'
        },
        ...!false && {
            'data-ssr-placeholder-replace': 'issue-table-main-container-placeholder'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kYFm9.ElementSizeProvider), {
        elementRef: tableRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ff2ee5124cf17be$var$MaybeConnectionsListContainer // Key used to reset the container store when the hierarchy settings change
    , {
        // Without it there may be flickering when Concurrent Mode is enabled
        key: hierarchyRemountKey
    }, connectionsSubscriber, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b54lr.SortChangeContextProvider), {
        value: {
            onSortChange: onSortChange
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ScrollContainer, {
        footer: footer,
        onLoadNext: onLoadNext,
        onLoadPrevious: onLoadPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        activationThreshold: activationThreshold,
        loading: loading,
        isGrouping: isGroupingSupported && !!groupData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Br57E.LazyEditabilityLoaderContainer), {
        scope: (0, $czfFt.LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJsz8.LazyMediaViewContextLoaderContainer), {
        scope: (0, $czfFt.LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wHMz.SelectedRowContainer), {
        selectedRowIndex: selectedRow,
        amountOfRows: issuesData?.edges?.length ?? 0,
        onRowChange: onSelectedRowChange,
        onPageChange: onPageChange,
        issues: issuesData ?? null
    }, areShortcutsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hUzfK.default), {
        issueKeys: issueKeys,
        onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bHZac.ColumnPickerContainer), isInBetweenColumnPickerEnabled && {
        scope: (0, $czfFt.COLUMN_PICKER_CONFIGURATION_CONTAINER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1MqPV.CopyPasteContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dYOM.default), {
        columnPickerProps: columnPickerProps,
        issueResults: issuesData ?? null,
        groupResults: groupData ?? null,
        project: projectData ?? null,
        columns: mappedColumns,
        canViewColumnConfiguration: canViewColumnConfiguration,
        canEditColumnConfiguration: canEditColumnConfiguration,
        loading: loading,
        tableInjectedProps: tableInjectedProps,
        onColumnsChange: conditionalOnColumnsChange,
        onResizeColumn: onColumnResize,
        NoColumns: components?.NoColumns,
        NoIssues: components?.NoIssues,
        tableRef: tableRef,
        isGroupingSupported: isGroupingSupported,
        isCompactColumnEnabled: isCompactColumnEnabled,
        tableBorderRadius: tableBorderRadius,
        onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld,
        onIssueFlatListUpdated: onIssueFlatListUpdated,
        ifcConfig: ifcConfig,
        columnsQueryRef: columnsData
    })))))))), (0, $4R6GH.fg)('decouple_connection_register_hooks_from_realtime') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7BEpL.RootConnectionRegister), {
        issues: issuesData
    }), projectData && (0, $4R6GH.fg)('decouple_connection_register_hooks_from_realtime') && (0, $6s1PB.expVal)('jira_list_realtime_updates_with_queue', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lT42R.RealtimeUpdater), {
        project: projectData,
        issues: issuesData,
        groups: groupData,
        isHierarchyEnabled: isIssueHierarchyEnabled,
        isStatusTrackingEnabled: isStatusTrackingEnabled,
        onRefetch: onRefetch
    })))))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTable"
    }));
};
const $5ff2ee5124cf17be$var$ConditionalNativeIssueTable = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false), (0, $dFuGx.IssueTableSelectedIssuesProvider)($5ff2ee5124cf17be$var$NativeIssueTable), $5ff2ee5124cf17be$var$NativeIssueTable);
var $5ff2ee5124cf17be$export$2e2bcd8739ae039 = $5ff2ee5124cf17be$var$ConditionalNativeIssueTable;
const $5ff2ee5124cf17be$export$1c6b4acc188098eb = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ff2ee5124cf17be$var$ConditionalNativeIssueTable, props); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5ff2ee5124cf17be$var$MainContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { tableBorderRadius: tableBorderRadius, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1n261q9c _1reo15vq _18m915vq _1h6dmuej _1dqonqa1 _189et94y _1e0c1txw",
            __cmplp.tableBorderRadius ?? "_2rkopd34",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eifR1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2e6f3c7f5f2caf8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<170e3faa100796f10c8082cb5a468af5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d2e6f3c7f5f2caf8$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "ui_nativeIssueTable_NativeIssueTable_project",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "editIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": v0 /*: any*/ ,
                        "storageKey": "action(type:\"EDIT_ISSUES\")"
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "createIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "CREATE_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": v0 /*: any*/ ,
                        "storageKey": "action(type:\"CREATE_ISSUES\")"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "realtimeUpdater_nativeIssueTable_project"
            },
            {
                "kind": "FragmentSpread",
                "name": "issueTable_nativeIssueTable_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$d2e6f3c7f5f2caf8$var$node.hash = "d6107ec7f348fe4a46d5d38f78f56bc1";
var $d2e6f3c7f5f2caf8$export$2e2bcd8739ae039 = $d2e6f3c7f5f2caf8$var$node;

});

parcelRegister("azntM", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaf44108ae8244b8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ea8a798f583ede4d2a3c284e5170eae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $eaf44108ae8244b8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "ui_nativeIssueTable_NativeIssueTable_columns",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "issueFetchQueryVariables_nativeIssueTable"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalCount"
            },
            "action": "THROW",
            "path": "totalCount"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueSearchFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "fieldSetId"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.fieldSetId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "type"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.type"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.displayName"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "jqlTerm"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.jqlTerm"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSortable"
                                },
                                {
                                    "concreteType": "JiraFieldSetPreferences",
                                    "kind": "LinkedField",
                                    "name": "fieldSetPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsMetadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canBeConfigured"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fieldId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPlaceHolderField"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "edges.node"
                    }
                ]
            },
            "action": "THROW",
            "path": "edges"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueTableColumnPicker_ColumnConfig"
        },
        {
            "kind": "FragmentSpread",
            "name": "context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef"
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$eaf44108ae8244b8$var$node.hash = "dbaceccd57480b7c89a03b8fd3ef1a79";
var $eaf44108ae8244b8$export$2e2bcd8739ae039 = $eaf44108ae8244b8$var$node;

});

parcelRegister("lxGBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1882e715df993f4e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f9c33eb0f6245701a5ed690c1959ac6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1882e715df993f4e$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": true,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isPaginating"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "ui_nativeIssueTable_NativeIssueTable_groups",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "groupByField"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isPaginating",
                    "variableName": "isPaginating"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "issueTable_nativeIssueTable_groupResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "realtimeUpdater_nativeIssueTable_groups"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$1882e715df993f4e$var$node.hash = "94063ad2285f405f84cca247ee667702";
var $1882e715df993f4e$export$2e2bcd8739ae039 = $1882e715df993f4e$var$node;

});

parcelRegister("d4XVp", function(module, exports) {

$parcel$export(module.exports, "default", () => $907abd4c69f05b79$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<73ce547519391e970ce37e514f130d10>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $907abd4c69f05b79$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "pageSize",
            "variableName": "pageSize"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "pageSize"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "ui_nativeIssueTable_NativeIssueTable_issues",
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "issueId"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "jql"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isDensityFull",
                        "variableName": "isDensityFull"
                    },
                    {
                        "kind": "Variable",
                        "name": "isInlineEditingEnabled",
                        "variableName": "isInlineEditingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isReparentingEnabled",
                        "variableName": "isReparentingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isTimelineEnabled",
                        "variableName": "isTimelineEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKey",
                        "variableName": "projectKey"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKeys",
                        "variableName": "projectKeys"
                    },
                    {
                        "kind": "Variable",
                        "name": "shouldQueryHasChildren",
                        "variableName": "shouldQueryHasChildren"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "issueTable_nativeIssueTable_issueResults"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "footerRenderer_nativeIssueTable"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "selectedRowState_nativeIssueTable_SelectedRowContainer"
            },
            {
                "kind": "FragmentSpread",
                "name": "realtimeUpdater_nativeIssueTable_issues"
            },
            {
                "kind": "FragmentSpread",
                "name": "rootConnectionRegister_nativeIssueTable_issues"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$907abd4c69f05b79$var$node.hash = "34c8122caa6c3f00f221ffbcecf5b227";
var $907abd4c69f05b79$export$2e2bcd8739ae039 = $907abd4c69f05b79$var$node;

});

parcelRegister("bHZac", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerContainer", () => $cceed226e735615f$export$e1286e1cb3fa0dec);
$parcel$export(module.exports, "useColumnPickerOpenState", () => $cceed226e735615f$export$81588ffe8d9d4add);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $cceed226e735615f$export$e1286e1cb3fa0dec = (0, $gg7kZ.createContainer)();
const $cceed226e735615f$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'ColumnPickerOpenState',
    containedBy: $cceed226e735615f$export$e1286e1cb3fa0dec
});
const $cceed226e735615f$export$81588ffe8d9d4add = (0, $3sQ5x.createHook)($cceed226e735615f$var$Store);

});

parcelRegister("6UDcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f496a1b75b734d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");

var $4R6GH = parcelRequire("4R6GH");

var $7CMCs = parcelRequire("7CMCs");

var $Y0ZJB = parcelRequire("Y0ZJB");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $10TJn = parcelRequire("10TJn");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c3f496a1b75b734d$var$ColumnConfig = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hLQQ6")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/issue-table/column-picker/src/ui/main.tsx"
});
const $c3f496a1b75b734d$var$ErrorFallback = ({ onRetry: onRetry, customIcon: customIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10TJn.default), {
                ...props,
                ref: triggerRef,
                customIcon: customIcon
            }),
        placement: "bottom-end",
        spacing: "compact",
        shouldRenderToParent: (0, $4R6GH.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Y0ZJB.ErrorState), {
        onRetry: onRetry,
        pageAction: "columnPicker"
    }));
const $c3f496a1b75b734d$var$AsyncColumnConfig = (props)=>{
    const [resetCaughtError, setResetCaughtError] = (0, $5uXOq.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraIssueTableColumnPicker",
        id: "unhandled",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3f496a1b75b734d$var$ErrorFallback, {
                onRetry: ()=>setResetCaughtError(error),
                customIcon: props.components?.Icon
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-column-config",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10TJn.PickerButtonFallback), {
            customIcon: props.components?.Icon,
            isInBetweenColumnPickerEnabled: props.isInBetweenColumnPickerEnabled
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3f496a1b75b734d$var$ColumnConfig, props)));
};
var $c3f496a1b75b734d$export$2e2bcd8739ae039 = $c3f496a1b75b734d$var$AsyncColumnConfig;

});
parcelRegister("Y0ZJB", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $a04e313879f6b069$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fVnbM = parcelRequire("fVnbM");

var $dD7Zc = parcelRequire("dD7Zc");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6TIqn = parcelRequire("6TIqn");

var $4MFPU = parcelRequire("4MFPU");
const $a04e313879f6b069$var$BOX_HEIGHT = (0, $gwIPs.gridSize) * 18;
const $a04e313879f6b069$var$ERROR_ICON_BOX_WRAPPER_HEIGHT = (0, $gwIPs.gridSize) * 9;
const $a04e313879f6b069$var$ICON_SIZE = (0, $gwIPs.gridSize) * 9;
const $a04e313879f6b069$export$c1ed4f415b9e7023 = (props)=>{
    const { pageAction: pageAction, onRetry: onRetry, description: description, role: role } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = ()=>{
        onRetry();
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${pageAction}Retry clicked`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a04e313879f6b069$var$StyledBox, {
        height: $a04e313879f6b069$var$BOX_HEIGHT,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a04e313879f6b069$var$StyledBox, {
        height: $a04e313879f6b069$var$ERROR_ICON_BOX_WRAPPER_HEIGHT,
        iconSize: $a04e313879f6b069$var$ICON_SIZE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4MFPU.StyledText), null, description !== undefined ? description : formatMessage((0, $6TIqn.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClick,
        appearance: "link",
        testId: "issue-navigator-actions-common.ui.error.button"
    }, formatMessage((0, $6TIqn.default).retryMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a04e313879f6b069$var$StyledBox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $lD23V.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6TIqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c213a9b9cc23628d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c213a9b9cc23628d$var$messages = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-actions-common.error.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-actions-common.error.retry-message",
        "defaultMessage": "Click to retry"
    }
});
var $c213a9b9cc23628d$export$2e2bcd8739ae039 = $c213a9b9cc23628d$var$messages;

});

parcelRegister("4MFPU", function(module, exports) {

$parcel$export(module.exports, "StyledText", () => $acc4659069112fb0$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $l1N8i = parcelRequire("l1N8i");
const $acc4659069112fb0$export$d675f139b342d51a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $lD23V.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $acc4659069112fb0$var$StyledTextComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $acc4659069112fb0$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($acc4659069112fb0$var$StyledTextComponent, props));

});


parcelRegister("10TJn", function(module, exports) {

$parcel$export(module.exports, "PickerButtonFallback", () => $2597b3b12b1b161d$export$d2ed0044a1cffec6);
$parcel$export(module.exports, "default", () => $2597b3b12b1b161d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $dZbEw = parcelRequire("dZbEw");

var $8EsNC = parcelRequire("8EsNC");

var $8jMCF = parcelRequire("8jMCF");

var $3bDjY = parcelRequire("3bDjY");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $8HKGu = parcelRequire("8HKGu");
const $2597b3b12b1b161d$var$PickerButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, isLoading: isLoading = false, isSelected: isSelected = false, customIcon: customIcon, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, onPickerMouseEnter: onPickerMouseEnter, onPickerMouseLeave: onPickerMouseLeave }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const iconColor = isSelected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon, #44546F)";
    const tooltipContent = formatMessage(isInBetweenColumnPickerEnabled && (0, $4R6GH.fg)('jira_inline_field_config_gate') ? (0, $8HKGu.default).addColumnTooltipText : (0, $8HKGu.default).tooltipText);
    const tooltipOptions = {
        position: 'bottom',
        content: tooltipContent,
        delay: 0
    };
    const isDisabled = !isSelected && isLoading;
    if (isInBetweenColumnPickerEnabled && (0, $4R6GH.fg)('jira_inline_field_config_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "bottom",
        content: tooltipContent,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: $2597b3b12b1b161d$var$pressableStyles,
        testId: "issue-table-column-picker.ui.column-picker.picker-button.pressable-add-column",
        isDisabled: isDisabled,
        onClick: onClick,
        onMouseEnter: onPickerMouseEnter,
        onMouseLeave: onPickerMouseLeave,
        ref: ref,
        "aria-haspopup": "true",
        "aria-expanded": isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
        label: tooltipContent
    })));
    const icon = customIcon ?? ((0, $4R6GH.fg)('jira_inline_field_config_gate') ? (0, (/*@__PURE__*/$parcel$interopDefault($8EsNC))) : (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))));
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: icon,
        testId: "issue-table-column-picker.ui.column-picker.picker-button.picker-button",
        label: tooltipContent,
        appearance: "subtle",
        isDisabled: isDisabled,
        onClick: onClick,
        ref: ref,
        "aria-haspopup": "true",
        "aria-expanded": isSelected,
        isSelected: isSelected,
        tooltip: tooltipOptions,
        isTooltipDisabled: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "bottom",
        content: tooltipContent,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        testId: "issue-table-column-picker.ui.column-picker.picker-button.picker-button",
        "aria-label": tooltipContent,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jMCF))), {
            label: "",
            spacing: "spacious",
            LEGACY_size: "medium",
            color: iconColor
        }),
        isDisabled: isDisabled,
        onClick: onClick,
        ref: ref,
        "aria-haspopup": "true",
        "aria-expanded": isSelected,
        isSelected: isSelected
    }));
});
const $2597b3b12b1b161d$export$d2ed0044a1cffec6 = ({ customIcon: customIcon, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = formatMessage(isInBetweenColumnPickerEnabled && (0, $4R6GH.fg)('jira_inline_field_config_gate') ? (0, $8HKGu.default).addColumnTooltipText : (0, $8HKGu.default).tooltipText);
    if (isInBetweenColumnPickerEnabled && (0, $4R6GH.fg)('jira_inline_field_config_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "bottom",
        content: tooltipContent,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: $2597b3b12b1b161d$var$pressableStyles,
        isDisabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
        label: tooltipContent
    })));
    const icon = customIcon ?? ((0, $4R6GH.fg)('jira_inline_field_config_gate') ? (0, (/*@__PURE__*/$parcel$interopDefault($8EsNC))) : (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))));
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: icon,
        label: tooltipContent,
        appearance: "subtle",
        isDisabled: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        "aria-label": formatMessage((0, $8HKGu.default).tooltipText),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jMCF))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium"
        }),
        isDisabled: true
    });
};
const $2597b3b12b1b161d$var$pressableStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '24px',
    width: '24px',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    position: 'relative',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    boxShadow: 'elevation.shadow.overlay',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
var $2597b3b12b1b161d$export$2e2bcd8739ae039 = $2597b3b12b1b161d$var$PickerButton;

});
parcelRegister("8jMCF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59e43c1f00fcc95f49aa5b3733f7f372>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60e5d086aacc57a4$var$_react = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $60e5d086aacc57a4$var$_customize = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("4QAwn")));

var $60e5d086aacc57a4$var$_preferences = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("5KZxU")));
function $60e5d086aacc57a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CustomizeIcon.
 * This component is CustomizeIcon, with `UNSAFE_fallbackIcon` set to "PreferencesIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60e5d086aacc57a4$var$CustomizeIcon = (props)=>/*#__PURE__*/ $60e5d086aacc57a4$var$_react.default.createElement($60e5d086aacc57a4$var$_customize.default, Object.assign({
        LEGACY_fallbackIcon: $60e5d086aacc57a4$var$_preferences.default
    }, props));
$60e5d086aacc57a4$var$CustomizeIcon.Name = 'CustomizeIconMigration';
var $60e5d086aacc57a4$var$_default = module.exports.default = $60e5d086aacc57a4$var$CustomizeIcon;

});
parcelRegister("4QAwn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8bb9804f9ea7eaa10f227008c94bcff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3878591d802e976a$var$_react = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3878591d802e976a$var$_baseNew = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3878591d802e976a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3878591d802e976a$var$CustomizeIcon = (props)=>/*#__PURE__*/ $3878591d802e976a$var$_react.default.createElement($3878591d802e976a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.375C3 1.615 3.616 1 4.375 1h1.75c.76 0 1.375.616 1.375 1.375v4.25C7.5 7.385 6.884 8 6.125 8h-1.75C3.615 8 3 7.384 3 6.625V5.25H0v-1.5h3zm1.5.125v4H6v-4zM16 5.25H8.5v-1.5H16zM8.5 9.375C8.5 8.615 9.116 8 9.875 8h1.75C12.385 8 13 8.616 13 9.375v1.375h3v1.5h-3v1.375c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zM10 9.5v4h1.5v-4zM0 12.25v-1.5h7.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$3878591d802e976a$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $3878591d802e976a$var$_default = module.exports.default = $3878591d802e976a$var$CustomizeIcon;

});

parcelRegister("5KZxU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4310fd5ff8fcaeb0$var$_react = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4310fd5ff8fcaeb0$var$_customize = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("4QAwn")));
function $4310fd5ff8fcaeb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4310fd5ff8fcaeb0$var$PreferencesIcon = (props)=>/*#__PURE__*/ $4310fd5ff8fcaeb0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props, {
        newIcon: $4310fd5ff8fcaeb0$var$_customize.default
    }));
$4310fd5ff8fcaeb0$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $4310fd5ff8fcaeb0$var$_default = module.exports.default = $4310fd5ff8fcaeb0$var$PreferencesIcon;

});


parcelRegister("8HKGu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a66c96e4e556a7f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a66c96e4e556a7f1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltipText: {
        "id": "issue-table-column-picker.column-picker.picker-button.tooltip-text",
        "defaultMessage": "Configure columns"
    },
    addColumnTooltipText: {
        "id": "issue-table-column-picker.column-picker.picker-button.add-column-tooltip-text",
        "defaultMessage": "Add column"
    },
    columnPickerButtonText: {
        "id": "issue-table-column-picker.column-picker.picker-button.column-picker-button-text",
        "defaultMessage": "Column picker menu"
    },
    chevronDownIconText: {
        "id": "issue-table-column-picker.column-picker.picker-button.chevron-down-icon-text",
        "defaultMessage": "Chevron down icon"
    },
    boardIconText: {
        "id": "issue-table-column-picker.column-picker.picker-button.board-icon-text",
        "defaultMessage": "board icon"
    }
});

});


parcelRegister("hLQQ6", function(module, exports) {

let $ceffd0457ead5357$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ceffd0457ead5357$var$load("eVqS8").then(()=>parcelRequire('hazUT'));

});


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("fc4cz", function(module, exports) {

$parcel$export(module.exports, "filterNonIssueItems", () => $2805cee9578bb845$export$3bf3427e3d5241d1);
$parcel$export(module.exports, "getItemKey", () => $2805cee9578bb845$export$424834ba1b0663bc);
$parcel$export(module.exports, "getChildIssueCreateItemKey", () => $2805cee9578bb845$export$5dbc02cdc002848d);
$parcel$export(module.exports, "getShowMoreItemKey", () => $2805cee9578bb845$export$b262bb2cd2ab9f00);
$parcel$export(module.exports, "HierarchyContainer", () => $2805cee9578bb845$export$4666215eda1bff58);
$parcel$export(module.exports, "useHierarchyStore", () => $2805cee9578bb845$export$2fc259d06066fab6);
$parcel$export(module.exports, "useHierarchyActions", () => $2805cee9578bb845$export$4fd9d94900cdff43);
$parcel$export(module.exports, "useIsItemExpanded", () => $2805cee9578bb845$export$d11bf3cdf2aca60f);
$parcel$export(module.exports, "useIsSelected", () => $2805cee9578bb845$export$fb40a80c530e5f2b);
$parcel$export(module.exports, "useIsFocused", () => $2805cee9578bb845$export$a774b9356e1b793);
$parcel$export(module.exports, "useIsItemLoading", () => $2805cee9578bb845$export$d169440ae865c511);
$parcel$export(module.exports, "useSelectedRow", () => $2805cee9578bb845$export$11a86b67953bcc50);
$parcel$export(module.exports, "useVisibleDepth", () => $2805cee9578bb845$export$ebb5be32d1c1b3ea);
$parcel$export(module.exports, "useFlatList", () => $2805cee9578bb845$export$e8de618a961e45f5);
$parcel$export(module.exports, "useIssueIds", () => $2805cee9578bb845$export$85c95ca9de9161bf);
$parcel$export(module.exports, "useFlatListIssueKeys", () => $2805cee9578bb845$export$9f91dbe98f60bbaa);
$parcel$export(module.exports, "useHasExpandedItems", () => $2805cee9578bb845$export$d77963246cf4131);
$parcel$export(module.exports, "useSelectedIssueKey", () => $2805cee9578bb845$export$7cedcbfb2da7e49d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $52ESs = parcelRequire("52ESs");
const $2805cee9578bb845$var$initialState = {
    selectedItem: null,
    focusedItem: null,
    expandedItems: {},
    rootConnectionId: null,
    connectionMap: {},
    connectionItems: {},
    loadingItems: {},
    /**
	 * Indicates the maximum expanded hierarhcy level:
	 * - Starts with 0 on initial load (flat list)
	 * - Expanding each level increments the value
	 */ visibleDepth: 0,
    flatList: [],
    issueKeys: [],
    listMetadata: [],
    amountOfRows: 0
};
const $2805cee9578bb845$var$CHILD_ISSUE_CREATE_PREFIX = 'CHILD_ISSUE_CREATE';
const $2805cee9578bb845$var$SHOW_MORE_PREFIX = 'SHOW_MORE';
const $2805cee9578bb845$var$LOADING_ROW_PREFIX = 'LOADING_ROW';
const $2805cee9578bb845$var$isSpecialItem = (id)=>id?.startsWith($2805cee9578bb845$var$CHILD_ISSUE_CREATE_PREFIX) || id?.startsWith($2805cee9578bb845$var$SHOW_MORE_PREFIX) || id?.startsWith($2805cee9578bb845$var$LOADING_ROW_PREFIX);
const $2805cee9578bb845$export$3bf3427e3d5241d1 = (list)=>list.filter(Boolean).filter((item)=>!$2805cee9578bb845$var$isSpecialItem(item));
const $2805cee9578bb845$export$424834ba1b0663bc = (itemsConnectionId, itemId, groupId)=>`${itemsConnectionId}::${itemId}${groupId ? `::${groupId}` : ''}`;
const $2805cee9578bb845$export$5dbc02cdc002848d = (parentItemId)=>`${$2805cee9578bb845$var$CHILD_ISSUE_CREATE_PREFIX}_${parentItemId}`;
const $2805cee9578bb845$export$b262bb2cd2ab9f00 = (parentItemId)=>`${$2805cee9578bb845$var$SHOW_MORE_PREFIX}_${parentItemId}`;
const $2805cee9578bb845$export$4db25121b2596d32 = (parentItemId)=>`${$2805cee9578bb845$var$LOADING_ROW_PREFIX}_${parentItemId}`;
const $2805cee9578bb845$export$4aad0fc50e1251e4 = (key)=>{
    if (typeof key !== 'string') return {
        connectionId: null,
        itemId: null
    };
    const [connectionId, itemId] = key.split('::');
    return {
        connectionId: connectionId,
        itemId: itemId
    };
};
const $2805cee9578bb845$var$actions = {
    populateConnection: ({ parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentConnectionId: parentConnectionId, list: list, hasNext: hasNext, isChildIssueCreateRowVisible: isChildIssueCreateRowVisible, groupId: groupId })=>{
        return ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            if (parentItemId === 'root') setState({
                rootConnectionId: itemsConnectionId
            });
            const key = $2805cee9578bb845$export$424834ba1b0663bc(itemsConnectionId, parentItemId, groupId);
            const state = getState();
            let nextList = list?.slice() ?? null;
            // adding [Show more] button to flat list so that virtualiser recognizes it
            if (hasNext && nextList) {
                const showMoreRowKey = $2805cee9578bb845$export$b262bb2cd2ab9f00(parentItemId);
                nextList = nextList.concat({
                    key: showMoreRowKey,
                    itemId: showMoreRowKey,
                    groupId: groupId
                });
            }
            if (isChildIssueCreateRowVisible && nextList) {
                const childIssueCreateRowKey = $2805cee9578bb845$export$5dbc02cdc002848d(parentItemId);
                nextList.unshift({
                    key: childIssueCreateRowKey,
                    itemId: childIssueCreateRowKey,
                    groupId: groupId
                });
            }
            const parentKey = $2805cee9578bb845$export$424834ba1b0663bc(parentConnectionId, parentItemId, // root doesn't have a groupId
            parentItemId === 'root' ? undefined : groupId);
            setState({
                connectionMap: {
                    ...state.connectionMap,
                    [parentKey]: key
                },
                connectionItems: {
                    ...state.connectionItems,
                    [key]: nextList
                }
            });
            dispatch($2805cee9578bb845$var$actions.traverseTreeAndUpdateState());
            dispatch($2805cee9578bb845$var$actions.clearSelectionIfItemIsNotInList());
        };
    },
    setItemIsLoading: ({ itemId: itemId, groupId: groupId, isLoading: isLoading })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { loadingItems: loadingItems, listMetadata: listMetadata, connectionItems: connectionItems } = getState();
            const loadingItemKey = $2805cee9578bb845$export$4db25121b2596d32(itemId);
            const metadataItem = listMetadata.find((metadata)=>metadata.itemId === itemId);
            const key = metadataItem ? $2805cee9578bb845$export$424834ba1b0663bc(metadataItem.connectionId, metadataItem.parentId, metadataItem.groupId) : null;
            if (!key || !connectionItems) return;
            let nextList = (connectionItems?.[key] ?? []).slice();
            if (isLoading) {
                const itemIndex = nextList.findIndex((item)=>item.itemId === itemId);
                if (itemIndex > -1) // insert loading row right after the expanded item
                nextList.splice(itemIndex + 1, 0, {
                    key: loadingItemKey,
                    itemId: loadingItemKey,
                    groupId: groupId
                });
            } else nextList = nextList.filter((item)=>item.itemId !== loadingItemKey);
            setState({
                loadingItems: {
                    ...loadingItems,
                    [itemId]: isLoading
                },
                connectionItems: {
                    ...connectionItems,
                    [key]: nextList
                }
            });
            dispatch($2805cee9578bb845$var$actions.traverseTreeAndUpdateState());
            dispatch($2805cee9578bb845$var$actions.clearSelectionIfItemIsNotInList());
        },
    toggleIsItemExpanded: (itemDetails, issueDepth)=>({ getState: getState, dispatch: dispatch })=>{
            if (!itemDetails) return;
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $2805cee9578bb845$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            const state = getState();
            const isExpanded = !state.expandedItems[key];
            dispatch($2805cee9578bb845$var$actions.setIsItemExpanded(itemDetails, isExpanded, issueDepth));
        },
    setIsItemExpanded: (itemDetails, isItemExpanded, issueDepth = 0)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            if (!itemDetails) return;
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $2805cee9578bb845$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            const state = getState();
            /*
				Update visibleDepth with the new depth if is expanded an item
				traverseTreeAndUpdateState function would update the visibleDepth when collapse
			*/ const optimisticVisibleDepth = issueDepth + 1;
            const currentVisibleDepth = state.visibleDepth;
            const newVisibleDepth = isItemExpanded && optimisticVisibleDepth > currentVisibleDepth ? optimisticVisibleDepth : state.visibleDepth;
            setState({
                expandedItems: {
                    ...state.expandedItems,
                    [key]: isItemExpanded
                },
                ...isItemExpanded === false ? {
                    connectionItems: {
                        ...state.connectionItems,
                        [key]: null
                    }
                } : {},
                visibleDepth: newVisibleDepth
            });
            dispatch($2805cee9578bb845$var$actions.traverseTreeAndUpdateState());
            dispatch($2805cee9578bb845$var$actions.clearSelectionIfItemIsNotInList());
        },
    traverseTreeAndUpdateState: ()=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const result = $2805cee9578bb845$export$dc56145edcd15e3e(getState());
            setState({
                flatList: result.flatlist,
                issueKeys: result.issueKeys,
                listMetadata: result.listMetadata,
                visibleDepth: result.hierarchyLevels[result.hierarchyLevels.length - 1]
            });
            dispatch($2805cee9578bb845$var$actions.setAmountOfRows(result.flatlist.length));
        },
    setSelectedRow: (itemDetails)=>({ setState: setState })=>{
            if (!itemDetails) {
                setState({
                    selectedItem: null,
                    focusedItem: null
                });
                return;
            }
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $2805cee9578bb845$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            setState({
                selectedItem: key,
                focusedItem: key
            });
        },
    selectNextRow: ()=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { listMetadata: listMetadata, selectedItem: selectedItem } = state;
            if (!selectedItem) return;
            const currentIndex = listMetadata.findIndex((item)=>item.key === selectedItem);
            const nextIndex = currentIndex + 1;
            if (nextIndex < listMetadata.length) dispatch($2805cee9578bb845$var$actions.setSelectedRow({
                itemsConnectionId: listMetadata[nextIndex].connectionId,
                itemId: listMetadata[nextIndex].itemId,
                groupId: listMetadata[nextIndex].groupId
            }));
        },
    selectPrevRow: ()=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { listMetadata: listMetadata, selectedItem: selectedItem } = state;
            if (!selectedItem) return;
            const currentIndex = listMetadata.findIndex((item)=>item.key === selectedItem);
            const previousIndex = currentIndex - 1;
            if (previousIndex >= 0) dispatch($2805cee9578bb845$var$actions.setSelectedRow({
                itemsConnectionId: listMetadata[previousIndex].connectionId,
                itemId: listMetadata[previousIndex].itemId,
                groupId: listMetadata[previousIndex].groupId
            }));
        },
    clearSelectionIfItemIsNotInList: ()=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { selectedItem: selectedItem } = state;
            if (!selectedItem || state.listMetadata.find((item)=>item.key === selectedItem)) return;
            dispatch($2805cee9578bb845$var$actions.setSelectedRow(null));
        },
    setAmountOfRows: (newAmountOfRows)=>({ getState: getState, setState: setState })=>{
            const { amountOfRows: amountOfRows } = getState();
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows
            });
        },
    resetFocus: ()=>({ getState: getState, setState: setState })=>{
            const { focusedItem: focusedItem } = getState();
            focusedItem !== null && setState({
                focusedItem: null
            });
        },
    resetHierarchyKeepingFirstGroupExpanded: ({ firstGroupId: firstGroupId, itemsConnectionId: itemsConnectionId })=>({ setState: setState, dispatch: dispatch })=>{
            if (firstGroupId && itemsConnectionId) {
                const firstGroupKey = $2805cee9578bb845$export$424834ba1b0663bc(itemsConnectionId, firstGroupId, firstGroupId);
                // First group is always expanded by default
                setState({
                    expandedItems: {
                        [firstGroupKey]: true
                    }
                });
            } else setState({
                expandedItems: {}
            });
            dispatch($2805cee9578bb845$var$actions.traverseTreeAndUpdateState());
        }
};
const $2805cee9578bb845$export$4666215eda1bff58 = (0, $gg7kZ.createContainer)();
const $2805cee9578bb845$var$Store = (0, $iXqE5.createStore)({
    initialState: $2805cee9578bb845$var$initialState,
    actions: $2805cee9578bb845$var$actions,
    name: 'hierarchy',
    containedBy: $2805cee9578bb845$export$4666215eda1bff58
});
const $2805cee9578bb845$export$2fc259d06066fab6 = (0, $3sQ5x.createHook)($2805cee9578bb845$var$Store);
const $2805cee9578bb845$export$4fd9d94900cdff43 = (0, $3sQ5x.createActionsHook)($2805cee9578bb845$var$Store);
const $2805cee9578bb845$export$d11bf3cdf2aca60f = (0, $3sQ5x.createHook)($2805cee9578bb845$var$Store, {
    selector: (state, itemDetails)=>{
        if (!itemDetails) return false;
        const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
        const key = $2805cee9578bb845$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
        return state.expandedItems[key] ?? false;
    }
});
const $2805cee9578bb845$export$fb40a80c530e5f2b = (0, $3sQ5x.createHook)($2805cee9578bb845$var$Store, {
    selector: (state, itemDetails)=>{
        if (!itemDetails) return false;
        const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
        return state.selectedItem === $2805cee9578bb845$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
    }
});
const $2805cee9578bb845$export$a774b9356e1b793 = (0, $3sQ5x.createHook)($2805cee9578bb845$var$Store, {
    selector: (state, itemDetails)=>{
        if (!itemDetails) return false;
        const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
        return state.focusedItem === $2805cee9578bb845$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
    }
});
const $2805cee9578bb845$var$getSelectedIndexSelector = (state)=>{
    const index = state.listMetadata.findIndex((item)=>item.key === state.selectedItem);
    if (index === -1) return null;
    return index;
};
const $2805cee9578bb845$export$d169440ae865c511 = (0, $3sQ5x.createHook)($2805cee9578bb845$var$Store, {
    selector: (state, itemId)=>Boolean(itemId && state.loadingItems[itemId])
});
const $2805cee9578bb845$export$11a86b67953bcc50 = (0, $3sQ5x.createHook)($2805cee9578bb845$var$Store, {
    selector: $2805cee9578bb845$var$getSelectedIndexSelector
});
const $2805cee9578bb845$export$dc56145edcd15e3e = (state)=>{
    const traverse = ({ itemsConnectionId: itemsConnectionId, parentId: parentId, flatlist: flatlist, issueKeys: issueKeys, listMetadata: listMetadata, hierarchyLevels: hierarchyLevels, depth: depth, groupId: groupId })=>{
        const key = $2805cee9578bb845$export$424834ba1b0663bc(itemsConnectionId, parentId, groupId);
        const connectionItem = state.connectionItems[key];
        if (!connectionItem) return {
            flatlist: flatlist,
            issueKeys: issueKeys,
            listMetadata: listMetadata,
            hierarchyLevels: hierarchyLevels
        };
        // itemGroupId is different from groupId at the root level
        connectionItem.forEach(({ itemId: id, key: issueKey, groupId: itemGroupId })=>{
            // groupId is needed in flatlist to make the issueId unique across multiple groups
            flatlist.push((0, $52ESs.getFlatListKey)({
                itemId: id,
                groupId: itemGroupId
            }));
            issueKeys.push(issueKey);
            const childConnectionKey = $2805cee9578bb845$export$424834ba1b0663bc(itemsConnectionId, id, itemGroupId);
            listMetadata.push({
                itemId: id,
                parentId: parentId,
                key: childConnectionKey,
                connectionId: itemsConnectionId,
                groupId: itemGroupId
            });
            const isExpanded = state.expandedItems[childConnectionKey];
            if (isExpanded) {
                const currentDepth = depth + 1;
                if (!hierarchyLevels.includes(currentDepth)) hierarchyLevels.push(currentDepth);
                const childrenConnection = state.connectionMap[childConnectionKey];
                const { connectionId: childrenConnectionId } = $2805cee9578bb845$export$4aad0fc50e1251e4(childrenConnection);
                if (childrenConnectionId) traverse({
                    itemsConnectionId: childrenConnectionId,
                    parentId: id,
                    flatlist: flatlist,
                    issueKeys: issueKeys,
                    listMetadata: listMetadata,
                    hierarchyLevels: hierarchyLevels,
                    depth: currentDepth,
                    groupId: itemGroupId
                });
            }
        });
        return {
            flatlist: flatlist,
            issueKeys: issueKeys,
            listMetadata: listMetadata,
            hierarchyLevels: hierarchyLevels
        };
    };
    const depth = 0;
    const flatlist = [];
    const issueKeys = [];
    const listMetadata = [];
    const hierarchyLevels = [
        depth
    ];
    if (!state.rootConnectionId) return {
        flatlist: flatlist,
        issueKeys: issueKeys,
        listMetadata: listMetadata,
        hierarchyLevels: hierarchyLevels
    };
    return traverse({
        itemsConnectionId: state.rootConnectionId,
        parentId: 'root',
        flatlist: flatlist,
        issueKeys: issueKeys,
        listMetadata: listMetadata,
        hierarchyLevels: hierarchyLevels,
        depth: depth
    });
};
const $2805cee9578bb845$export$ebb5be32d1c1b3ea = (0, $3sQ5x.createStateHook)($2805cee9578bb845$var$Store, {
    selector: (state)=>state.visibleDepth
});
const $2805cee9578bb845$export$e8de618a961e45f5 = (0, $3sQ5x.createStateHook)($2805cee9578bb845$var$Store, {
    selector: (state)=>state.flatList
});
const $2805cee9578bb845$var$getIssueIdsSelector = (0, $6dDSs.createSelector)((state)=>state.listMetadata, (listMetadata)=>listMetadata// filtering group headers out
    .filter(({ itemId: itemId, groupId: groupId })=>itemId !== groupId && !$2805cee9578bb845$var$isSpecialItem(itemId)).map(({ itemId: itemId })=>itemId));
const $2805cee9578bb845$export$85c95ca9de9161bf = (0, $3sQ5x.createStateHook)($2805cee9578bb845$var$Store, {
    selector: $2805cee9578bb845$var$getIssueIdsSelector
});
const $2805cee9578bb845$var$getIssueKeysSelector = (state)=>state.issueKeys;
const $2805cee9578bb845$var$getFlatListIssueKeysSelector = (0, $6dDSs.createSelector)($2805cee9578bb845$var$getIssueKeysSelector, (issueKeys)=>$2805cee9578bb845$export$3bf3427e3d5241d1(issueKeys));
const $2805cee9578bb845$export$9f91dbe98f60bbaa = (0, $3sQ5x.createStateHook)($2805cee9578bb845$var$Store, {
    selector: $2805cee9578bb845$var$getFlatListIssueKeysSelector
});
const $2805cee9578bb845$export$a5d72277eb099991 = (0, $3sQ5x.createHook)($2805cee9578bb845$var$Store, {
    selector: $2805cee9578bb845$var$getIssueKeysSelector
});
const $2805cee9578bb845$var$getSelectedIssueKeySelector = (0, $6dDSs.createSelector)($2805cee9578bb845$var$getSelectedIndexSelector, $2805cee9578bb845$var$getIssueKeysSelector, (selectedIndex, issueKeys)=>{
    if (selectedIndex === null) return null;
    return issueKeys[selectedIndex];
});
const $2805cee9578bb845$export$d77963246cf4131 = (0, $3sQ5x.createStateHook)($2805cee9578bb845$var$Store, {
    selector: (state)=>Object.values(state.expandedItems).some((isExpanded)=>isExpanded)
});
const $2805cee9578bb845$export$7cedcbfb2da7e49d = (0, $3sQ5x.createHook)($2805cee9578bb845$var$Store, {
    selector: $2805cee9578bb845$var$getSelectedIssueKeySelector
});

});
parcelRegister("52ESs", function(module, exports) {

$parcel$export(module.exports, "getFlatListKey", () => $12f3da1edd61d0a8$export$c15cfc620819beb5);
const $12f3da1edd61d0a8$export$c15cfc620819beb5 = ({ itemId: itemId, groupId: groupId })=>`${itemId}${groupId ? `::${groupId}` : ''}`;

});


parcelRegister("f7PHy", function(module, exports) {

$parcel$export(module.exports, "HierarchyOnboardingProvider", () => $2c829909fdbc1ce5$export$61ea399940cf79d6);
$parcel$export(module.exports, "useHierarchyOnboardingContext", () => $2c829909fdbc1ce5$export$34916c588fba606d);
$parcel$export(module.exports, "HierarchyOnboarding", () => $2c829909fdbc1ce5$export$19eb9bdb0cf578f5);
$parcel$export(module.exports, "HierarchyToggleOnboarding", () => $2c829909fdbc1ce5$export$e350c43a524c2f15);

var $5uXOq = parcelRequire("5uXOq");

var $kbqIt = parcelRequire("kbqIt");

var $1QiBP = parcelRequire("1QiBP");

var $ioD1B = parcelRequire("ioD1B");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $6s1PB = parcelRequire("6s1PB");

var $jA4v5 = parcelRequire("jA4v5");
const $2c829909fdbc1ce5$export$2d29273a16589c02 = 'jira-nin-hierarchy-onboarding-stg';
const $2c829909fdbc1ce5$export$e7deeb52c7c3e7a9 = 'jira-list-nin-hierarchy-onboarding';
const $2c829909fdbc1ce5$var$ENV_STAGING = 'staging';
const $2c829909fdbc1ce5$var$STARGATE_URL = '/gateway/api';
const $2c829909fdbc1ce5$var$HierarchyOnboardingContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $2c829909fdbc1ce5$export$61ea399940cf79d6 = ({ children: children })=>{
    const [showToggleOnboarding, setShowToggleOnboarding] = (0, $5uXOq.useState)(false);
    const value = (0, $5uXOq.useMemo)(()=>({
            showToggleOnboarding: showToggleOnboarding,
            setShowToggleOnboarding: setShowToggleOnboarding
        }), [
        showToggleOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2c829909fdbc1ce5$var$HierarchyOnboardingContext.Provider, {
        value: value
    }, children);
};
const $2c829909fdbc1ce5$export$34916c588fba606d = ()=>{
    const hierarchyContext = (0, $5uXOq.useContext)($2c829909fdbc1ce5$var$HierarchyOnboardingContext);
    if (!hierarchyContext) throw new Error('useHierarchyOnboardingContext must be used within a HierarchyOnboardingProvider');
    return hierarchyContext;
};
const $2c829909fdbc1ce5$export$19eb9bdb0cf578f5 = ()=>{
    const ONBOARDING_ENGAGEMENT_ID = (0, $2tT7R.useEnvironment)() === $2c829909fdbc1ce5$var$ENV_STAGING ? $2c829909fdbc1ce5$export$2d29273a16589c02 : $2c829909fdbc1ce5$export$e7deeb52c7c3e7a9;
    const { setShowToggleOnboarding: setShowToggleOnboarding } = $2c829909fdbc1ce5$export$34916c588fba606d();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    /**
   * Onboarding Experience is loaded manually on page load via EP's CoordinationClient class
   * Once loaded, if the message is active for this particular context, only then the HIERARCHY_ONBOARDING will be loaded and displayed
   */ const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, $2c829909fdbc1ce5$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(false);
    const [isEnrolled, stopEnrolment] = (0, $kbqIt.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $5uXOq.useEffect)(()=>{
        if (isEnrolled) {
            stopEnrolment(false);
            setIsSpotlightActive(true);
        }
    }, [
        isEnrolled,
        stopEnrolment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isEnrolled && isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        messageId: "issue-table-hierarchy.ui.hierarchy-onboarding.jira-spotlight.expand-column-header",
        messageType: "engagement",
        actionsBeforeElement: "1/2",
        actions: [
            {
                onClick: ()=>{
                    setIsSpotlightActive(false);
                    setShowToggleOnboarding(true);
                },
                text: formatMessage((0, $jA4v5.default).next)
            },
            {
                appearance: 'subtle',
                onClick: ()=>setIsSpotlightActive(false),
                text: formatMessage((0, $jA4v5.default).dismiss)
            }
        ],
        dialogWidth: 320,
        heading: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jA4v5.default).onboardingHeadingIssueTermRefresh : (0, $jA4v5.default).onboardingHeading),
        target: "expand-column-header",
        key: "expand-column-header",
        targetRadius: 3
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jA4v5.default).onboardingDescriptionIssueTermRefresh : (0, $jA4v5.default).onboardingDescription))));
};
const $2c829909fdbc1ce5$export$e350c43a524c2f15 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showToggleOnboarding: showToggleOnboarding, setShowToggleOnboarding: setShowToggleOnboarding } = $2c829909fdbc1ce5$export$34916c588fba606d();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    if (!isSpotlightActive || !showToggleOnboarding) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        messageId: "issue-table-hierarchy.ui.hierarchy-onboarding.jira-spotlight.hierarchy-feature-toggle",
        messageType: "engagement",
        actionsBeforeElement: "2/2",
        actions: [
            {
                onClick: ()=>{
                    setShowToggleOnboarding(false);
                    setIsSpotlightActive(false);
                },
                text: formatMessage((0, $jA4v5.default).ok)
            }
        ],
        dialogWidth: 320,
        target: "hierarchy-feature-toggle",
        key: "hierarchy-feature-toggle",
        targetRadius: 3
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jA4v5.default).toggleOnboardingIssueTermRefresh : (0, $jA4v5.default).toggleOnboarding)));
};

});
parcelRegister("jA4v5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac913e97fbfbe408$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ac913e97fbfbe408$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    onboardingHeading: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading",
        "defaultMessage": "View issue hierarchy"
    },
    onboardingHeadingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading-issue-term-refresh",
        "defaultMessage": "View hierarchy"
    },
    onboardingDescription: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child issues."
    },
    onboardingDescriptionIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description-issue-term-refresh",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child work items."
    },
    next: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.next",
        "defaultMessage": "Next"
    },
    toggleOnboarding: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding",
        "defaultMessage": "Use the toggle to show or hide the issue hierarchy."
    },
    toggleOnboardingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding-issue-term-refresh",
        "defaultMessage": "Use the toggle to show or hide the hierarchy."
    },
    ok: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.done",
        "defaultMessage": "Ok"
    },
    dismiss: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("5FoyW", function(module, exports) {

$parcel$export(module.exports, "ConnectionsListContainer", () => $463d9389cc554547$export$ba73231554574611);
$parcel$export(module.exports, "useConnectionsList", () => $463d9389cc554547$export$8d76c2ce1bf0921e);
$parcel$export(module.exports, "useConnectionsListActions", () => $463d9389cc554547$export$d656d29a379d1749);
$parcel$export(module.exports, "useRegisterConnection", () => $463d9389cc554547$export$f9bef9773768341d);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $5yJb9 = parcelRequire("5yJb9");
const $463d9389cc554547$var$INITIAL_CONNECTIONS_LIST_STATE = {
    connections: {}
};
const $463d9389cc554547$export$ba73231554574611 = (0, $gg7kZ.createContainer)();
const $463d9389cc554547$var$getKeyForConnection = (connection)=>{
    let key = connection.connectionId;
    if (connection.type === 'PARENT_CHILDREN') key = connection.parentId;
    if (connection.type === 'GROUP_CHILDREN') key = connection.groupId;
    // add some formatting to ensure it is not used for another purpose
    return `KEY_${key}`;
};
const $463d9389cc554547$var$actions = {
    addConnection: (connection)=>({ setState: setState, getState: getState })=>{
            const { connections: connections } = getState();
            const key = $463d9389cc554547$var$getKeyForConnection(connection);
            setState({
                connections: {
                    ...connections,
                    [key]: connection
                }
            });
        },
    removeConnection: (connection)=>({ setState: setState, getState: getState })=>{
            const { connections: connections } = getState();
            const key = $463d9389cc554547$var$getKeyForConnection(connection);
            const { [key]: _, ...newConnections } = connections;
            setState({
                connections: newConnections
            });
        }
};
const $463d9389cc554547$var$Store = (0, $iXqE5.createStore)({
    initialState: $463d9389cc554547$var$INITIAL_CONNECTIONS_LIST_STATE,
    name: 'ConnectionsListStore',
    containedBy: $463d9389cc554547$export$ba73231554574611,
    actions: $463d9389cc554547$var$actions,
    handlers: {
        onDestroy: ()=>({ getState: getState })=>{
                const { connections: connections } = getState();
                const environment = (0, $5yJb9.default)();
                Object.values(connections).forEach((connection)=>{
                    environment.commitUpdate((store)=>{
                        const connectionToInvalidate = store.get(connection.connectionId);
                        if (connectionToInvalidate) connectionToInvalidate.invalidateRecord();
                    });
                });
            }
    }
});
const $463d9389cc554547$export$8d76c2ce1bf0921e = (0, $3sQ5x.createStateHook)($463d9389cc554547$var$Store);
const $463d9389cc554547$export$d656d29a379d1749 = (0, $3sQ5x.createActionsHook)($463d9389cc554547$var$Store);
const $463d9389cc554547$export$f9bef9773768341d = (connection)=>{
    const { addConnection: addConnection } = $463d9389cc554547$export$d656d29a379d1749();
    (0, $5uXOq.useEffect)(()=>{
        if (connection) addConnection(connection);
    }, [
        addConnection,
        connection
    ]);
};

});

parcelRegister("ceawz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cebb6273f2cb2ef3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $dqoiX = parcelRequire("dqoiX");

var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $fc4cz = parcelRequire("fc4cz");

var $aiOSC = parcelRequire("aiOSC");
const $cebb6273f2cb2ef3$var$ExpandHeaderCell = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hasExpandedItems = (0, $fc4cz.useHasExpandedItems)();
    const getScreenReaderMessage = ()=>{
        if (hasExpandedItems) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $aiOSC.default).columnHeaderCollapseButtonIssueTermRefresh : (0, $aiOSC.default).columnHeaderCollapseButton;
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $aiOSC.default).columnHeaderExpandButtonIssueTermRefresh : (0, $aiOSC.default).columnHeaderExpandButton;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        xcss: $cebb6273f2cb2ef3$var$hierarchyHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $cebb6273f2cb2ef3$var$headerIconStyles
    }, hasExpandedItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
        label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $aiOSC.default).columnHeaderCollapseButtonIssueTermRefresh : (0, $aiOSC.default).columnHeaderCollapseButton),
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
        label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $aiOSC.default).columnHeaderExpandButtonIssueTermRefresh : (0, $aiOSC.default).columnHeaderExpandButton),
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), null, formatMessage(getScreenReaderMessage()))));
};
/* TODO: remove after cleaning jira_spreadsheet_component_m1 - style added for the onboarding spotlight  */ const $cebb6273f2cb2ef3$var$hierarchyHeaderStyles = (0, $8CUq3.xcss)({
    height: 'size.300'
});
const $cebb6273f2cb2ef3$var$headerIconStyles = (0, $8CUq3.xcss)({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
});
var $cebb6273f2cb2ef3$export$2e2bcd8739ae039 = $cebb6273f2cb2ef3$var$ExpandHeaderCell;

});
parcelRegister("aiOSC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d1fc1a905f857bc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1d1fc1a905f857bc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    columnHeaderExpandButton: {
        "id": "native-issue-table.column-header-expand-button",
        "defaultMessage": "Show all issues - expanded"
    },
    columnHeaderCollapseButton: {
        "id": "native-issue-table.column-header-collapse-button",
        "defaultMessage": "Show all issues - collapsed"
    },
    columnHeaderExpandButtonIssueTermRefresh: {
        "id": "native-issue-table.column-header-expand-button-issue-term-refresh",
        "defaultMessage": "Show all work items - expanded"
    },
    columnHeaderCollapseButtonIssueTermRefresh: {
        "id": "native-issue-table.column-header-collapse-button-issue-term-refresh",
        "defaultMessage": "Show all work items - collapsed"
    }
});

});


parcelRegister("3JOwB", function(module, exports) {

$parcel$export(module.exports, "CheckboxCell", () => $59a9330cd4577a40$export$e0722abfbf26acc0);
$parcel$export(module.exports, "HeaderCheckboxCell", () => $59a9330cd4577a40$export$b9d19e1dc166efac);

var $5uXOq = parcelRequire("5uXOq");

var $kkJfY = parcelRequire("kkJfY");

var $f5TWP = parcelRequire("f5TWP");

var $bFU4G = parcelRequire("bFU4G");

var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $bgZjH = parcelRequire("bgZjH");

var $6KtXs = parcelRequire("6KtXs");
const $59a9330cd4577a40$export$e0722abfbf26acc0 = ({ issueId: issueId, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6KtXs.messages).checkboxAriaLabelIssueTermRefresh : (0, $6KtXs.messages).checkboxAriaLabel),
        onClick: ()=>(0, $bFU4G.abortAll)('new_interaction'),
        ...checkboxProps
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgZjH.CheckboxCell), {
        issueId: issueId,
        ...checkboxProps
    });
};
const $59a9330cd4577a40$export$b9d19e1dc166efac = ({ selectableIssueIds: selectableIssueIds, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6KtXs.messages).checkboxAriaLabelIssueTermRefresh : (0, $6KtXs.messages).checkboxAriaLabel),
        onClick: ()=>(0, $bFU4G.abortAll)('new_interaction'),
        ...checkboxProps
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgZjH.HeaderCheckboxCell), {
        selectableIssueIds: selectableIssueIds,
        ...checkboxProps
    });
};

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    $3106eb14f9b0a593$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("bgZjH", function(module, exports) {

$parcel$export(module.exports, "CheckboxCell", () => $18109722e46221b2$export$e0722abfbf26acc0);
$parcel$export(module.exports, "HeaderCheckboxCell", () => $18109722e46221b2$export$b9d19e1dc166efac);

var $5uXOq = parcelRequire("5uXOq");

var $kkJfY = parcelRequire("kkJfY");

var $f5TWP = parcelRequire("f5TWP");

var $bFU4G = parcelRequire("bFU4G");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $fc4cz = parcelRequire("fc4cz");

var $48rMm = parcelRequire("48rMm");

var $1wHMz = parcelRequire("1wHMz");

var $6KtXs = parcelRequire("6KtXs");
const $18109722e46221b2$var$EMPTY_ARRAY = [];
const $18109722e46221b2$export$e0722abfbf26acc0 = ({ issueId: issueId, rowIndex: rowIndex, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isIssueSelected = (0, $48rMm.useIsIssueSelected)(issueId);
    // TODO Remove useSelectedRowActions when cleaning up jsc_m2_hierarchy_fe_changes
    const { checkRow: checkRowWithoutHierarchy } = (0, $1wHMz.useSelectedRowActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    let flatListIssueIds = $18109722e46221b2$var$EMPTY_ARRAY;
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    flatListIssueIds = (0, $fc4cz.useIssueIds)();
    const { selectedOnlyIssueId: selectedOnlyIssueId, checkIssueRow: checkIssueRow } = (0, $48rMm.useIssueTableSelectedIssuesActions)();
    const isShiftPressed = (0, $5uXOq.useRef)(false);
    const onCheckboxChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        const toggleCheckboxChecked = e.target.checked;
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'newIssueNavigatorTableRow', {
            isCheckboxChecked: toggleCheckboxChecked,
            selectionType: isShiftPressed.current ? 'shift' : 'default'
        });
        if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) checkIssueRow(issueId, toggleCheckboxChecked, isShiftPressed.current, flatListIssueIds);
        else checkRowWithoutHierarchy(rowIndex, toggleCheckboxChecked, isShiftPressed.current);
    }, [
        checkIssueRow,
        issueId,
        flatListIssueIds,
        checkRowWithoutHierarchy,
        rowIndex
    ]);
    const handleSelectedOnlyIssueId = (0, $5uXOq.useCallback)((ev)=>{
        ev.preventDefault();
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'checkbox',
            action: 'changed'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'newIssueNavigatorTableRow', {
            isCheckboxChecked: true,
            selectionType: 'ctrl'
        });
        selectedOnlyIssueId(issueId);
    }, [
        createAnalyticsEvent,
        selectedOnlyIssueId,
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        ...checkboxProps,
        "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6KtXs.messages).checkboxAriaLabelIssueTermRefresh : (0, $6KtXs.messages).checkboxAriaLabel),
        isChecked: isIssueSelected,
        onChange: onCheckboxChange,
        onClick: (ev)=>{
            isShiftPressed.current = ev.shiftKey;
            (0, $bFU4G.abortAll)('new_interaction');
        },
        onKeyDown: (ev)=>{
            if (!isIssueSelected && ev.ctrlKey && ev.code === 'Space') handleSelectedOnlyIssueId(ev);
        },
        onContextMenu: (ev)=>{
            if (!isIssueSelected && ev.ctrlKey) handleSelectedOnlyIssueId(ev);
        }
    }));
};
const $18109722e46221b2$export$b9d19e1dc166efac = ({ selectableIssueIds: selectableIssueIds, groupByFieldId: groupByFieldId, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectedIssueIds = (0, $48rMm.useIssueTableSelectedIssues)();
    const { insertSelectedIssueIds: insertSelectedIssueIds, reset: reset } = (0, $48rMm.useIssueTableSelectedIssuesActions)();
    const prevGroupByFieldId = (0, $5uXOq.useRef)(groupByFieldId);
    if (prevGroupByFieldId.current !== groupByFieldId) {
        prevGroupByFieldId.current = groupByFieldId;
        reset();
    }
    let issueIds;
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    issueIds = (0, $fc4cz.useIssueIds)();
    else issueIds = selectableIssueIds;
    const isChecked = (0, $48rMm.useAreAllIssuesSelected)(issueIds);
    const isIndeterminate = !isChecked && selectedIssueIds.length > 0;
    const onCheckboxChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        const toggleCheckboxChecked = e.target.checked;
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'bulkSelectTableRows', {
            isCheckboxChecked: toggleCheckboxChecked
        });
        if (isIndeterminate || !isChecked) insertSelectedIssueIds(issueIds);
        else if (isChecked) reset();
    }, [
        insertSelectedIssueIds,
        isChecked,
        isIndeterminate,
        reset,
        issueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        ...checkboxProps,
        "aria-label": formatMessage((0, $6KtXs.messages).headerCheckboxAriaLabel),
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        onChange: onCheckboxChange,
        onClick: ()=>{
            (0, $bFU4G.abortAll)('new_interaction');
        }
    }));
};

});
parcelRegister("48rMm", function(module, exports) {

$parcel$export(module.exports, "IssueTableSelectedIssuesContainer", () => $c785af315de8dae0$export$b11112517798dbed);
$parcel$export(module.exports, "useIssueTableSelectedIssuesActions", () => $c785af315de8dae0$export$b4602482fdfd31ed);
$parcel$export(module.exports, "useIssueTableSelectedIssues", () => $c785af315de8dae0$export$ad5f97924b14314b);
$parcel$export(module.exports, "useIsIssueSelected", () => $c785af315de8dae0$export$cfefd69fc8a5ac52);
$parcel$export(module.exports, "useAreAllIssuesSelected", () => $c785af315de8dae0$export$949e47631f4a60a5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $es90k = parcelRequire("es90k");
const $c785af315de8dae0$export$b11112517798dbed = (0, $gg7kZ.createContainer)();
const $c785af315de8dae0$var$Store = (0, $iXqE5.createStore)({
    initialState: $es90k.initialState,
    actions: $es90k.actions,
    name: 'jira-native-issue-table-selected-issues-state',
    containedBy: $c785af315de8dae0$export$b11112517798dbed
});
const $c785af315de8dae0$export$b4602482fdfd31ed = (0, $3sQ5x.createActionsHook)($c785af315de8dae0$var$Store);
const $c785af315de8dae0$var$getSelectedIssueIdsSelector = (state)=>{
    return Array.from(state.selectedIssueIds);
};
const $c785af315de8dae0$export$ad5f97924b14314b = (0, $3sQ5x.createStateHook)($c785af315de8dae0$var$Store, {
    selector: $c785af315de8dae0$var$getSelectedIssueIdsSelector
});
const $c785af315de8dae0$var$getIsIssueIdSelectedSelector = (state, issueId)=>{
    return state.selectedIssueIds.has(issueId);
};
const $c785af315de8dae0$export$cfefd69fc8a5ac52 = (0, $3sQ5x.createStateHook)($c785af315de8dae0$var$Store, {
    selector: $c785af315de8dae0$var$getIsIssueIdSelectedSelector
});
const $c785af315de8dae0$var$getAreAllIssuesSelectedSelector = (state, issueIds)=>{
    const selectedIssueIds = $c785af315de8dae0$var$getSelectedIssueIdsSelector(state);
    return issueIds.length > 0 && issueIds.every((issueId)=>selectedIssueIds.includes(issueId));
};
const $c785af315de8dae0$export$949e47631f4a60a5 = (0, $3sQ5x.createStateHook)($c785af315de8dae0$var$Store, {
    selector: $c785af315de8dae0$var$getAreAllIssuesSelectedSelector
});

});
parcelRegister("es90k", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $75d6ff2ec2275c29$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $75d6ff2ec2275c29$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $75d6ff2ec2275c29$export$d4c72bab9d6cc13a = {
    selectedIssueIds: new Set([]),
    lastSelectedRowIndex: null
};
const $75d6ff2ec2275c29$export$e324594224ef24da = {
    insertSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            onIssueSelected?.(selectedIssueIds);
            setState({
                selectedIssueIds: new Set([
                    ...currentState.selectedIssueIds,
                    ...selectedIssueIds
                ])
            });
        },
    removeSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            selectedIssueIds.forEach((selectedIssueId)=>{
                updatedSelectedIssueIds.delete(selectedIssueId);
            });
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    insertSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.add(selectedIssueId);
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    removeSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.delete(selectedIssueId);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    selectedOnlyIssueId: (selectedIssueId)=>({ setState: setState }, { onIssueSelected: onIssueSelected })=>{
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: new Set([
                    selectedIssueId
                ])
            });
        },
    updateLastSelectedRowIndex: (lastSelectedRowIndex)=>({ setState: setState })=>{
            setState({
                lastSelectedRowIndex: lastSelectedRowIndex
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState($75d6ff2ec2275c29$export$d4c72bab9d6cc13a);
        },
    checkIssueRow: (issueId, isChecked, isShiftPressed, flatList)=>({ dispatch: dispatch, getState: getState })=>{
            const selectedIssueIds = [
                issueId
            ];
            const currentState = getState();
            const currentCheckedIndex = flatList.findIndex((id)=>id === issueId);
            if (isShiftPressed && currentState.lastSelectedRowIndex !== null) {
                const start = Math.min(currentState.lastSelectedRowIndex, currentCheckedIndex);
                const end = Math.max(currentState.lastSelectedRowIndex, currentCheckedIndex);
                selectedIssueIds.push(...flatList.slice(start, end + 1).filter((id)=>id !== issueId));
            }
            dispatch($75d6ff2ec2275c29$export$e324594224ef24da.updateLastSelectedRowIndex(currentCheckedIndex));
            if (isChecked) dispatch($75d6ff2ec2275c29$export$e324594224ef24da.insertSelectedIssueIds(selectedIssueIds));
            else dispatch($75d6ff2ec2275c29$export$e324594224ef24da.removeSelectedIssueIds(selectedIssueIds));
        }
};

});


parcelRegister("1wHMz", function(module, exports) {

$parcel$export(module.exports, "SelectedRowContainer", () => $ae65fd4b5132615e$export$613ab77d2c52b90d);
$parcel$export(module.exports, "useSelectedRow", () => $ae65fd4b5132615e$export$11a86b67953bcc50);
$parcel$export(module.exports, "useIsSelected", () => $ae65fd4b5132615e$export$fb40a80c530e5f2b);
$parcel$export(module.exports, "useIsFocused", () => $ae65fd4b5132615e$export$a774b9356e1b793);
$parcel$export(module.exports, "useSelectedRowActions", () => $ae65fd4b5132615e$export$7b16b18429291a5c);

var $avlzM = parcelRequire("avlzM");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $6s1PB = parcelRequire("6s1PB");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $48rMm = parcelRequire("48rMm");

var $j0UHR = parcelRequire("j0UHR");
const $ae65fd4b5132615e$var$initialState = {
    selectedRowIndex: null,
    amountOfRows: 0,
    focusedRowIndex: null
};
const $ae65fd4b5132615e$var$Store = (0, $iXqE5.createStore)({
    initialState: $ae65fd4b5132615e$var$initialState,
    actions: $j0UHR.default,
    name: 'selectedRowState'
});
const $ae65fd4b5132615e$export$42a852a2b6b56249 = (0, $gg7kZ.createContainer)($ae65fd4b5132615e$var$Store, {
    onInit: ()=>({ setState: setState }, { selectedRowIndex: selectedRowIndex = null, amountOfRows: amountOfRows = 0 })=>{
            setState({
                selectedRowIndex: selectedRowIndex,
                amountOfRows: amountOfRows
            });
        },
    onUpdate: ()=>({ setState: setState, getState: getState }, { selectedRowIndex: newRowIndex, amountOfRows: newAmountOfRows })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            selectedRowIndex !== newRowIndex && setState({
                selectedRowIndex: newRowIndex ?? null
            });
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows ?? 0
            });
        }
});
const $ae65fd4b5132615e$export$613ab77d2c52b90d = ({ issues: issues, onPageChange: onPageChange, ...props })=>{
    // eslint-disable-next-line @atlassian/relay/query-restriction
    const data = (0, $8Uumt.useFragment)((0, $avlzM.default), issues);
    const { insertSelectedIssueIds: insertSelectedIssueIds, removeSelectedIssueIds: removeSelectedIssueIds } = (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $48rMm.useIssueTableSelectedIssuesActions)() : {
        insertSelectedIssueIds: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        removeSelectedIssueIds: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
    const lastSelectedRow = (0, $5uXOq.useRef)(null);
    const cursors = data?.pageCursors?.around;
    const currentPageIndex = (0, $5uXOq.useMemo)(()=>cursors?.findIndex((cursor)=>cursor?.isCurrent) ?? -1, [
        cursors
    ]);
    const onNextPage = (0, $5uXOq.useCallback)(()=>{
        if (onPageChange && currentPageIndex > -1) {
            const nextPage = cursors?.[currentPageIndex + 1];
            if (nextPage && nextPage.cursor != null) onPageChange(nextPage.cursor, false);
        }
    }, [
        currentPageIndex,
        cursors,
        onPageChange
    ]);
    const onPreviousPage = (0, $5uXOq.useCallback)(()=>{
        if (onPageChange && currentPageIndex > 0) {
            const previousPage = cursors?.[currentPageIndex - 1];
            if (previousPage && previousPage.cursor != null) onPageChange(previousPage.cursor, true);
        }
    }, [
        currentPageIndex,
        cursors,
        onPageChange
    ]);
    const onCheckRow = (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)((rowIndex, isChecked, isShiftSelected)=>{
        const initialIssueId = data?.edges?.[rowIndex]?.node?.issueId;
        if (!initialIssueId) return;
        const selectedIssueIds = [
            initialIssueId
        ];
        if (isShiftSelected && lastSelectedRow.current !== null) {
            const start = Math.min(lastSelectedRow.current, rowIndex);
            const end = Math.max(lastSelectedRow.current, rowIndex);
            for(let i = start; i <= end; i++){
                const currentIssueId = data?.edges?.[i]?.node?.issueId;
                if (i !== rowIndex && currentIssueId) selectedIssueIds.push(currentIssueId);
            }
        }
        lastSelectedRow.current = rowIndex;
        if (isChecked) insertSelectedIssueIds(selectedIssueIds);
        else removeSelectedIssueIds(selectedIssueIds);
    }, [
        data?.edges,
        insertSelectedIssueIds,
        removeSelectedIssueIds
    ]) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae65fd4b5132615e$export$42a852a2b6b56249, {
        ...props,
        onNextPage: onNextPage,
        onPreviousPage: onPreviousPage,
        ...(0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) && {
            onCheckRow: onCheckRow
        }
    });
};
const $ae65fd4b5132615e$export$11a86b67953bcc50 = (0, $3sQ5x.createHook)($ae65fd4b5132615e$var$Store, {
    selector: (state)=>state.selectedRowIndex
});
const $ae65fd4b5132615e$export$fb40a80c530e5f2b = (0, $3sQ5x.createHook)($ae65fd4b5132615e$var$Store, {
    selector: (state, { selectedRowIndex: selectedRowIndex })=>state.selectedRowIndex === selectedRowIndex
});
const $ae65fd4b5132615e$export$a774b9356e1b793 = (0, $3sQ5x.createHook)($ae65fd4b5132615e$var$Store, {
    selector: (state, { selectedRowIndex: selectedRowIndex })=>state.focusedRowIndex === selectedRowIndex
});
const $ae65fd4b5132615e$export$7b16b18429291a5c = (0, $3sQ5x.createActionsHook)($ae65fd4b5132615e$var$Store);
const $ae65fd4b5132615e$export$f8ee25964657042a = (0, $3sQ5x.createHook)($ae65fd4b5132615e$var$Store, {
    selector: (state)=>state.amountOfRows
});

});
parcelRegister("avlzM", function(module, exports) {

$parcel$export(module.exports, "default", () => $80a1f296d2fc37d5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<062fdfba47135a99742296f1356235f7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $80a1f296d2fc37d5$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageSize"
        }
    ],
    "kind": "Fragment",
    "name": "selectedRowState_nativeIssueTable_SelectedRowContainer",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "maxCursors",
                    "value": 7
                },
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                }
            ],
            "concreteType": "JiraPageCursors",
            "kind": "LinkedField",
            "name": "pageCursors",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraPageCursor",
                    "kind": "LinkedField",
                    "name": "around",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isCurrent"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$80a1f296d2fc37d5$var$node.hash = "558a18d92170dc40c5bb420aa3fa3826";
var $80a1f296d2fc37d5$export$2e2bcd8739ae039 = $80a1f296d2fc37d5$var$node;

});

parcelRegister("j0UHR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ca474b94ca72ef$export$2e2bcd8739ae039);
const $f2ca474b94ca72ef$var$actions = {
    setSelectedRow: (rowIndex)=>({ getState: getState, setState: setState }, { onRowChange: onRowChange })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            if (selectedRowIndex !== rowIndex && amountOfRows > 0) {
                setState({
                    selectedRowIndex: rowIndex,
                    focusedRowIndex: rowIndex
                });
                onRowChange && onRowChange(rowIndex);
            }
        },
    resetFocus: ()=>({ getState: getState, setState: setState })=>{
            const { focusedRowIndex: focusedRowIndex } = getState();
            focusedRowIndex !== null && setState({
                focusedRowIndex: null
            });
        },
    setAmountOfRows: (newAmountOfRows)=>({ setState: setState, getState: getState })=>{
            const { amountOfRows: amountOfRows } = getState();
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows
            });
        },
    selectNextRow: ()=>({ getState: getState, dispatch: dispatch }, { onNextPage: onNextPage })=>{
            const { amountOfRows: amountOfRows, selectedRowIndex: selectedRowIndex } = getState();
            if (amountOfRows === 0) return;
            // edge case: we have only blank issues in the list, we want to make it key accessible
            if (selectedRowIndex === null) dispatch($f2ca474b94ca72ef$var$actions.setSelectedRow(0));
            else if (selectedRowIndex < amountOfRows - 1) dispatch($f2ca474b94ca72ef$var$actions.setSelectedRow(selectedRowIndex + 1));
            else if (selectedRowIndex === amountOfRows - 1 && onNextPage) onNextPage();
        },
    selectPrevRow: ()=>({ getState: getState, dispatch: dispatch }, { onPreviousPage: onPreviousPage })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            if (amountOfRows === 0) return;
            // edge case: we have only one blank issues in the list, we want to make it key accessible
            if (selectedRowIndex === null) dispatch($f2ca474b94ca72ef$var$actions.setSelectedRow(0));
            else if (selectedRowIndex > 0) dispatch($f2ca474b94ca72ef$var$actions.setSelectedRow(selectedRowIndex - 1));
            else if (selectedRowIndex === 0 && onPreviousPage) onPreviousPage();
        },
    checkRow: (rowIndex, isChecked, isShiftPressed)=>(_, { onCheckRow: onCheckRow })=>{
            onCheckRow && onCheckRow(rowIndex, isChecked, isShiftPressed);
        }
};
var $f2ca474b94ca72ef$export$2e2bcd8739ae039 = $f2ca474b94ca72ef$var$actions;

});


parcelRegister("6KtXs", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bd86e4ab88880ff2$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bd86e4ab88880ff2$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    checkboxAriaLabel: {
        "id": "native-issue-table.common.issue-cells.checkbox.checkbox-aria-label",
        "defaultMessage": "Issue checkbox"
    },
    checkboxAriaLabelIssueTermRefresh: {
        "id": "native-issue-table.common.issue-cells.checkbox.checkbox-aria-label-issue-term-refresh",
        "defaultMessage": "Work item checkbox"
    },
    headerCheckboxAriaLabel: {
        "id": "native-issue-table.common.issue-cells.checkbox.header-checkbox-aria-label",
        "defaultMessage": "Select all checkbox"
    }
});

});



parcelRegister("hxGva", function(module, exports) {

$parcel$export(module.exports, "IssueTableSkeleton", () => $d6b3a71d2cc1f810$export$32020b6a5557f03e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k42jv = parcelRequire("k42jv");
const $d6b3a71d2cc1f810$export$32020b6a5557f03e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d6b3a71d2cc1f810$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k42jv.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6b3a71d2cc1f810$var$SkeletonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k42jv", function(module, exports) {

$parcel$export(module.exports, "NativeIssueTableSkeleton", () => $405e65301287bbc2$export$309a6db85e3f2aaa);
/* NativeIssueTableSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $67CMq = parcelRequire("67CMq");
const $405e65301287bbc2$var$customCssStyles = null;
const $405e65301287bbc2$var$containerStyles = {
    height: '448px'
};
const $405e65301287bbc2$export$309a6db85e3f2aaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($67CMq))),
        containerStyles: $405e65301287bbc2$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("67CMq", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.e6209376.svg", import.meta.url).toString();

});



parcelRegister("xhiHy", function(module, exports) {

$parcel$export(module.exports, "getColumnConfig", () => $2f5345758392c700$export$38a3f9395eadb298);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $cgL5K = parcelRequire("cgL5K");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $65VLO = parcelRequire("65VLO");

var $czfFt = parcelRequire("czfFt");

var $aqzzx = parcelRequire("aqzzx");
const $2f5345758392c700$export$47c53e05a89322a1 = (0, $8QpSo.default)((formatMessage)=>({
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ASSIGNEE]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CHECKBOX]: ()=>({
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CREATED]: ()=>({
                defaultWidth: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? 201 : 126,
                ascText: formatMessage((0, $aqzzx.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $aqzzx.default).newestToOldestOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).UPDATED]: ()=>({
                defaultWidth: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? 201 : 130,
                ascText: formatMessage((0, $aqzzx.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $aqzzx.default).newestToOldestOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).DUE_DATE]: ()=>({
                defaultWidth: 140,
                ascText: formatMessage((0, $aqzzx.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $aqzzx.default).newestToOldestOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).RESOLUTION_DATE]: ()=>({
                defaultWidth: 106,
                ascText: formatMessage((0, $aqzzx.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $aqzzx.default).newestToOldestOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).PRIORITY]: ()=>({
                defaultWidth: 140
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_KEY]: ()=>({
                defaultWidth: 96,
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).EXPAND_BUTTON]: ()=>({
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: ()=>({
                title: '',
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).STATUS]: ()=>({
                defaultWidth: 140
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).SUMMARY]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: ()=>({
                // Overrides title from the server's displayName from "Issue Type" to "Type" as per designs
                title: formatMessage((0, $aqzzx.default).columnHeaderIssueType),
                defaultWidth: 101,
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).RESOLUTION]: ()=>({
                defaultWidth: 106
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).REPORTER]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CREATOR]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).SPRINT]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).PARENT]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            }),
        // Labels renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
        // <Tag/> has a maxWidth of 180px with 4px of padding either side
        // And we need to accound for 5px & 8px for left and right padding on our cell respectively
        [(0, $65VLO.KNOWN_COLUMN_TYPES).LABELS]: ()=>({
                defaultWidth: 201
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).COMPONENTS]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).FIX_VERSIONS]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).STATUS_CATEGORY]: ()=>({
                defaultWidth: 140
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).PROJECT]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).EPIC_LINK]: ()=>({
                // EpicLink renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
                // <Tag/> has a maxWidth of 180px with 4px of padding either side
                // And we need to account for 5px & 8px for left and right padding on our cell respectively
                defaultWidth: 201,
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld),
                warningText: formatMessage((0, $aqzzx.default).deprecatedEpicLinkMessage, {
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                            color: "color.text.inverse",
                            as: "strong"
                        }, chunks)
                })
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).DESCRIPTION]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_LONG),
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ENVIRONMENT]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_LONG),
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).TEXT_AREA]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_LONG),
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).TEXT]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_SHORT),
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).READ_ONLY]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_SHORT),
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).AFFECTS_VERSIONS]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).REQUEST_TYPE]: ()=>({
                defaultWidth: 251,
                isSortable: false
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).NUMBER]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).USER_PICKER]: ()=>(0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? {
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
            } : {
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            },
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CUSTOM_LABELS]: ()=>({
                defaultWidth: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? 201 : (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).DATE_TIME]: ()=>({
                defaultWidth: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? 201 : (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).URL]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ...(0, $4R6GH.fg)('jsc_inline_editing_field_refactor') && {
                    ascText: formatMessage((0, $aqzzx.default).aToZOrderOld),
                    descText: formatMessage((0, $aqzzx.default).zToAOrderOld)
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).SINGLE_SELECT]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).MULTI_SELECT]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).MULTI_USER_PICKER]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).TEAM]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ORIGINAL_ESTIMATE]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).GOALS]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CASCADING_SELECT]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CONFLUENCE_PAGES]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).PEOPLE]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).DATE_PICKER]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).MERGED_COLUMN]: ()=>({
                defaultWidth: (0, $65VLO.MERGED_COLUMN_DEFAULT_WIDTH),
                isSortable: false
            })
    }));
const $2f5345758392c700$export$f7ea0b98861f6494 = (0, $8QpSo.default)((formatMessage)=>{
    const aToZOrder = (0, $4R6GH.fg)('jira_inline_field_config_gate') ? (0, $czfFt.SORT_A_TO_Z) : formatMessage((0, $aqzzx.default).aToZOrder);
    const zToAOrder = (0, $4R6GH.fg)('jira_inline_field_config_gate') ? (0, $czfFt.SORT_Z_TO_A) : formatMessage((0, $aqzzx.default).zToAOrder);
    const oldestToNewestOrder = (0, $4R6GH.fg)('jira_inline_field_config_gate') ? (0, $czfFt.SORT_OLDEST_TO_NEWEST) : formatMessage((0, $aqzzx.default).oldestToNewestOrder);
    const newestToOldestOrder = (0, $4R6GH.fg)('jira_inline_field_config_gate') ? (0, $czfFt.SORT_NEWEST_TO_OLDEST) : formatMessage((0, $aqzzx.default).newestToOldestOrder);
    return {
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ASSIGNEE]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CHECKBOX]: ()=>({
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CREATED]: ()=>({
                defaultWidth: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? 201 : 126,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).UPDATED]: ()=>({
                defaultWidth: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? 201 : 130,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).DUE_DATE]: ()=>({
                defaultWidth: 140,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).RESOLUTION_DATE]: ()=>({
                defaultWidth: 106,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).PRIORITY]: ()=>({
                defaultWidth: 140,
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $czfFt.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $czfFt.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_KEY]: ()=>({
                defaultWidth: 96,
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') ? {
                    ascText: (0, $czfFt.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $czfFt.SORT_HIGHEST_TO_LOWEST)
                } : {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).EXPAND_BUTTON]: ()=>({
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: ()=>({
                title: '',
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).STATUS]: ()=>({
                defaultWidth: 140
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).SUMMARY]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: ()=>({
                // Overrides title from the server's displayName from "Issue Type" to "Type" as per designs
                title: formatMessage((0, $aqzzx.default).columnHeaderIssueType),
                defaultWidth: 101,
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).RESOLUTION]: ()=>({
                defaultWidth: 106,
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).REPORTER]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CREATOR]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).SPRINT]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).PARENT]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        // Labels renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
        // <Tag/> has a maxWidth of 180px with 4px of padding either side
        // And we need to accound for 5px & 8px for left and right padding on our cell respectively
        [(0, $65VLO.KNOWN_COLUMN_TYPES).LABELS]: ()=>({
                defaultWidth: 201,
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).COMPONENTS]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).FIX_VERSIONS]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $czfFt.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $czfFt.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).STATUS_CATEGORY]: ()=>({
                defaultWidth: 140
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).PROJECT]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).EPIC_LINK]: ()=>({
                // EpicLink renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
                // <Tag/> has a maxWidth of 180px with 4px of padding either side
                // And we need to account for 5px & 8px for left and right padding on our cell respectively
                defaultWidth: 201,
                ascText: aToZOrder,
                descText: zToAOrder,
                warningText: formatMessage((0, $aqzzx.default).deprecatedEpicLinkMessage, {
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                            color: "color.text.inverse",
                            as: "strong"
                        }, chunks)
                })
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).DESCRIPTION]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_LONG),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ENVIRONMENT]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_LONG),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).TEXT_AREA]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_LONG),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).TEXT]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_SHORT),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).READ_ONLY]: ()=>({
                defaultWidth: (0, $czfFt.COLUMN_WIDTH_TEXT_SHORT),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).AFFECTS_VERSIONS]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).REQUEST_TYPE]: ()=>({
                defaultWidth: 251,
                isSortable: false
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).NUMBER]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $czfFt.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $czfFt.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).USER_PICKER]: ()=>(0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? {
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            } : {
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            },
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CUSTOM_LABELS]: ()=>({
                defaultWidth: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? 201 : (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).DATE_TIME]: ()=>({
                defaultWidth: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? 201 : (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                    ascText: oldestToNewestOrder,
                    descText: newestToOldestOrder
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).URL]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ...(0, $4R6GH.fg)('jsc_inline_editing_field_refactor') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).SINGLE_SELECT]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).MULTI_SELECT]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).MULTI_USER_PICKER]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).TEAM]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ORIGINAL_ESTIMATE]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $czfFt.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $czfFt.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).GOALS]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CASCADING_SELECT]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).CONFLUENCE_PAGES]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).PEOPLE]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).DATE_PICKER]: ()=>({
                defaultWidth: (0, $czfFt.DEFAULT_COLUMN_WIDTH),
                ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                    ascText: oldestToNewestOrder,
                    descText: newestToOldestOrder
                }
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).MERGED_COLUMN]: ()=>({
                defaultWidth: (0, $65VLO.MERGED_COLUMN_DEFAULT_WIDTH),
                isSortable: false
            })
    };
});
const $2f5345758392c700$export$38a3f9395eadb298 = (formatMessage)=>{
    return (0, $dCm1o.isVisualRefreshEnabled)() ? $2f5345758392c700$export$f7ea0b98861f6494(formatMessage) : $2f5345758392c700$export$47c53e05a89322a1(formatMessage);
};

});
parcelRegister("aqzzx", function(module, exports) {

$parcel$export(module.exports, "default", () => $84fb489cd622d95c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $84fb489cd622d95c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    columnHeaderIssueType: {
        "id": "native-issue-table.common.utils.get-column-config.column-header-issue-type",
        "defaultMessage": "Type"
    },
    aToZOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.a-to-z-order-old",
        "defaultMessage": "A \u279E Z"
    },
    zToAOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.z-to-a-order-old",
        "defaultMessage": "Z \u279E A"
    },
    oldestToNewestOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.oldest-to-newest-order-old",
        "defaultMessage": "oldest \u279E newest"
    },
    newestToOldestOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.newest-to-oldest-order-old",
        "defaultMessage": "newest \u279E oldest"
    },
    deprecatedEpicLinkMessage: {
        "id": "native-issue-table.common.utils.get-column-config.deprecated-epic-link-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>."
    },
    aToZOrder: {
        "id": "native-issue-table.common.utils.get-column-config.a-to-z-order",
        "defaultMessage": "A \u2192 Z"
    },
    zToAOrder: {
        "id": "native-issue-table.common.utils.get-column-config.z-to-a-order",
        "defaultMessage": "Z \u2192 A"
    },
    oldestToNewestOrder: {
        "id": "native-issue-table.common.utils.get-column-config.oldest-to-newest-order",
        "defaultMessage": "oldest \u2192 newest"
    },
    newestToOldestOrder: {
        "id": "native-issue-table.common.utils.get-column-config.newest-to-oldest-order",
        "defaultMessage": "newest \u2192 oldest"
    }
});

});


parcelRegister("92cNq", function(module, exports) {

$parcel$export(module.exports, "getColumnsWithStickyOffsets", () => $a86a78adc8db082c$export$6e976bf0e5378347);

var $65VLO = parcelRequire("65VLO");

var $czfFt = parcelRequire("czfFt");
const $a86a78adc8db082c$export$6e976bf0e5378347 = (columnConfig, stickyColumnIds)=>{
    const stickyColumnsById = {};
    const orderedStickyColumns = [];
    const nonStickyColumns = [];
    columnConfig.forEach((column)=>{
        const { id: id } = column;
        if (id === (0, $czfFt.COLUMN_ID_CHECKBOX) || id === (0, $czfFt.COLUMN_ID_EXPAND_BUTTON) || id === (0, $65VLO.COLUMN_ID_MERGED_COLUMN)) orderedStickyColumns.push(column);
        else if (stickyColumnIds?.includes(id)) stickyColumnsById[id] = column;
        else nonStickyColumns.push(column);
    });
    stickyColumnIds?.forEach((columnId)=>{
        if (stickyColumnsById[columnId]) orderedStickyColumns.push(stickyColumnsById[columnId]);
    });
    let cumulativeStickyOffset = 0;
    const processedStickyColumns = orderedStickyColumns.map((column)=>{
        const { id: id, customWidth: customWidth, defaultWidth: defaultWidth } = column;
        const stickyOffsets = cumulativeStickyOffset;
        if (id === (0, $czfFt.COLUMN_ID_EXPAND_BUTTON)) cumulativeStickyOffset += defaultWidth + (0, $czfFt.EXPAND_CELL_PADDING);
        else cumulativeStickyOffset += customWidth ?? defaultWidth;
        return {
            ...column,
            isColumnSticky: true,
            stickyOffsets: stickyOffsets
        };
    });
    return [
        ...processedStickyColumns,
        ...nonStickyColumns
    ];
};

});

parcelRegister("aB7bN", function(module, exports) {

$parcel$export(module.exports, "isNonNullish", () => $9f1ae0edfbf313d7$export$70573498ee17fe1d);
$parcel$export(module.exports, "isKnownColumnType", () => $9f1ae0edfbf313d7$export$e8280bcdc1c3f84);
$parcel$export(module.exports, "exclusiveGroupsOrIssuesFragment", () => $9f1ae0edfbf313d7$export$7ac78cf15a1a4ba3);
$parcel$export(module.exports, "getProjectKeyFromIssueKey", () => $9f1ae0edfbf313d7$export$defe38779a6b81d2);
$parcel$export(module.exports, "escapeBackslashes", () => $9f1ae0edfbf313d7$export$fbd15c27bb7e257c);

var $65VLO = parcelRequire("65VLO");

function $9f1ae0edfbf313d7$export$70573498ee17fe1d(value) {
    return value != null;
}
function $9f1ae0edfbf313d7$export$e8280bcdc1c3f84(value) {
    return value !== undefined && Object.values((0, $65VLO.KNOWN_COLUMN_TYPES)).includes(value);
}
function $9f1ae0edfbf313d7$export$7ac78cf15a1a4ba3({ groups: groups, issues: issues }) {
    if (issues) return {
        groups: null,
        issues: issues
    };
    if (groups) return {
        groups: groups,
        issues: null
    };
    return null;
}
function $9f1ae0edfbf313d7$export$defe38779a6b81d2(issueKey) {
    return issueKey.split('-')[0];
}
const $9f1ae0edfbf313d7$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');

});

parcelRegister("kYFm9", function(module, exports) {

$parcel$export(module.exports, "useElementSizeSelector", () => $9fb6972593b23474$export$6af5bd31f067d7e5);
$parcel$export(module.exports, "ElementSizeProvider", () => $9fb6972593b23474$export$73bf76c50625186);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $9fb6972593b23474$export$e4c0458e30711294 = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0
};
const $9fb6972593b23474$export$638cf470f916deb7 = (0, $gg7kZ.createContainer)({
    getIsConcurrentSafe: ()=>(0, $4R6GH.fg)('jira-concurrent-issue-table-rss-fix')
});
const $9fb6972593b23474$export$3378d8ea7d02abd0 = {
    height: 0,
    width: 0
};
const $9fb6972593b23474$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        }
};
const $9fb6972593b23474$var$Store = (0, $iXqE5.createStore)({
    containedBy: $9fb6972593b23474$export$638cf470f916deb7,
    initialState: $9fb6972593b23474$export$3378d8ea7d02abd0,
    name: 'ElementSize',
    actions: $9fb6972593b23474$var$actions,
    handlers: {
        onInit: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            },
        onContainerUpdate: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            }
    }
});
const $9fb6972593b23474$export$6af5bd31f067d7e5 = (0, $3sQ5x.createStateHook)($9fb6972593b23474$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $9fb6972593b23474$export$2b86bedf890eab8 = (elementRef)=>{
    const [size, setSize] = (0, $5uXOq.useState)($9fb6972593b23474$export$e4c0458e30711294);
    (0, $5uXOq.useEffect)(()=>{
        const element = elementRef.current;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                setSize({
                    height: element.clientHeight,
                    width: element.clientWidth,
                    scrollHeight: element.scrollHeight,
                    scrollWidth: element.scrollWidth
                });
            });
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        elementRef
    ]);
    return size;
};
const $9fb6972593b23474$export$73bf76c50625186 = ({ elementRef: elementRef, children: children })=>{
    const { width: width, height: height } = $9fb6972593b23474$export$2b86bedf890eab8(elementRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9fb6972593b23474$export$638cf470f916deb7, {
        width: width,
        height: height
    }, children);
};

});

parcelRegister("cyLEh", function(module, exports) {

$parcel$export(module.exports, "FeaturesContainer", () => $09f1f6a994f7fba5$export$449fd4f36db88f87);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $4R6GH = parcelRequire("4R6GH");

var $e9M6d = parcelRequire("e9M6d");

var $coJAK = parcelRequire("coJAK");
const $09f1f6a994f7fba5$var$ContextualFeatureAnalytics = ({ children: children })=>{
    const isDensityFull = (0, $e9M6d.useIsDensityFull)();
    const isVirtualizationEnabled = (0, $e9M6d.useIsVirtualizationEnabled)();
    const isColumnResizingEnabled = (0, $e9M6d.useIsColumnResizingEnabled)();
    const isFixedTableLayoutEnabled = (0, $e9M6d.useIsFixedTableLayoutEnabled)();
    const isInlineEditingEnabled = (0, $e9M6d.useIsInlineEditingEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isIssueCreateEnabled = (0, $e9M6d.useIsIssueCreateEnabled)();
    const isInfiniteScrollEnabled = (0, $e9M6d.useIsInfiniteScrollEnabled)();
    const isSiblingIssueCreateEnabled = (0, $e9M6d.useIsSiblingIssueCreateEnabled)();
    const isChildIssueCreateEnabled = (0, $e9M6d.useIsChildIssueCreateEnabled)();
    const isIssueRankDescending = (0, $e9M6d.useIsIssueRankDescending)();
    const isIssueHierarchyEnabled = (0, $e9M6d.useIsIssueHierarchyEnabled)();
    const isIssueOperationMeatballMenuEnabled = (0, $e9M6d.useIsIssueOperationMeatballMenuEnabled)();
    const isColumnBordersEnabled = (0, $e9M6d.useIsColumnBordersEnabled)();
    const isRowReorderingEnabled = (0, $e9M6d.useIsRowReorderingEnabled)();
    const isEntireRowDraggable = (0, $e9M6d.useIsEntireRowDraggable)();
    const isInlineFieldConfigEnabled = (0, $e9M6d.useIsInlineFieldConfigEnabled)();
    const isInBetweenColumnPickerEnabled = (0, $e9M6d.useIsInBetweenColumnPickerEnabled)();
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    const isHideDoneItemsEnabled = (0, $e9M6d.useIsHideDoneItemsEnabled)();
    const isMergedColumnEnabled = (0, $e9M6d.useIsMergedColumnEnabled)();
    const isMergedColumnVisible = (0, $e9M6d.useIsMergedColumnVisible)();
    const isStickyColumnsEnabled = (0, $e9M6d.useIsStickyColumnsEnabled)();
    let isConditionalFormattingEnabled = false;
    if ((0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isConditionalFormattingEnabled = (0, $e9M6d.useIsConditionalFormattingEnabled)();
    const isTimelineEnabled = (0, $e9M6d.useIsTimelineEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            issueTableFeatures: {
                isDensityFull: isDensityFull,
                isVirtualizationEnabled: isVirtualizationEnabled,
                isColumnResizingEnabled: isColumnResizingEnabled,
                isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled,
                isIssueCreateEnabled: isIssueCreateEnabled,
                isInfiniteScrollEnabled: isInfiniteScrollEnabled,
                isSiblingIssueCreateEnabled: isSiblingIssueCreateEnabled,
                isChildIssueCreateEnabled: isChildIssueCreateEnabled,
                isIssueRankDescending: isIssueRankDescending,
                isIssueHierarchyEnabled: isIssueHierarchyEnabled,
                isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled,
                isColumnBordersEnabled: isColumnBordersEnabled,
                isRowReorderingEnabled: isRowReorderingEnabled,
                isEntireRowDraggable: isEntireRowDraggable,
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
                isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                isMergedColumnEnabled: isMergedColumnEnabled,
                isMergedColumnVisible: isMergedColumnVisible,
                isStickyColumnsEnabled: isStickyColumnsEnabled,
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isTimelineEnabled: isTimelineEnabled
            }
        }
    }, children);
};
const $09f1f6a994f7fba5$export$449fd4f36db88f87 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coJAK.FeaturesContainerInternal), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($09f1f6a994f7fba5$var$ContextualFeatureAnalytics, null, children));
};

});
parcelRegister("e9M6d", function(module, exports) {

$parcel$export(module.exports, "useIsDensityFull", () => $bd35689f373df040$export$f031d973e8f9ebd1);
$parcel$export(module.exports, "useIsVirtualizationEnabled", () => $bd35689f373df040$export$e8cb30aec148fb72);
$parcel$export(module.exports, "useIsColumnResizingEnabled", () => $bd35689f373df040$export$928fba01e945632a);
$parcel$export(module.exports, "useIsFixedTableLayoutEnabled", () => $bd35689f373df040$export$bce4f421d3fcab1b);
$parcel$export(module.exports, "useIsInlineEditingEnabled", () => $bd35689f373df040$export$3e66c03eddc15634);
$parcel$export(module.exports, "useIsInlineEditingExtendedFieldSupportEnabled", () => $bd35689f373df040$export$2763573a98b052ad);
$parcel$export(module.exports, "useIsIssueCreateEnabled", () => $bd35689f373df040$export$543273904a8063c6);
$parcel$export(module.exports, "useIsInfiniteScrollEnabled", () => $bd35689f373df040$export$de7fbee8ed52ae4);
$parcel$export(module.exports, "useIsSiblingIssueCreateEnabled", () => $bd35689f373df040$export$f1842b07a822e21a);
$parcel$export(module.exports, "useIsChildIssueCreateEnabled", () => $bd35689f373df040$export$1c15679efffd4e2b);
$parcel$export(module.exports, "useIsIssueRankDescending", () => $bd35689f373df040$export$82982f49a24a3a9b);
$parcel$export(module.exports, "useIsIssueHierarchyEnabled", () => $bd35689f373df040$export$4f04f80fe2006454);
$parcel$export(module.exports, "useIsIssueOperationMeatballMenuEnabled", () => $bd35689f373df040$export$a99d862d213ae04);
$parcel$export(module.exports, "useIsRowReorderingEnabled", () => $bd35689f373df040$export$3c2a1b4963d788c8);
$parcel$export(module.exports, "useIsEntireRowDraggable", () => $bd35689f373df040$export$40143afd2a4a7546);
$parcel$export(module.exports, "useIsReparentingEnabled", () => $bd35689f373df040$export$64a4c7b004e35cb6);
$parcel$export(module.exports, "useIsDragAndDropEnabled", () => $bd35689f373df040$export$b4fbf34545c95b8e);
$parcel$export(module.exports, "useProjectContext", () => $bd35689f373df040$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useSortField", () => $bd35689f373df040$export$f8f71fe8cdc658b6);
$parcel$export(module.exports, "useSortDirection", () => $bd35689f373df040$export$c88af24ce42b9b94);
$parcel$export(module.exports, "useJql", () => $bd35689f373df040$export$f813789488fdc0c7);
$parcel$export(module.exports, "useIsColumnBordersEnabled", () => $bd35689f373df040$export$8136b1ebbacf80ef);
$parcel$export(module.exports, "useIsInlineFieldConfigEnabled", () => $bd35689f373df040$export$edb9f869c9fd4d6e);
$parcel$export(module.exports, "useIsInBetweenColumnPickerEnabled", () => $bd35689f373df040$export$9e70cd1d138c2276);
$parcel$export(module.exports, "useIsSingleLineRowHeightEnabled", () => $bd35689f373df040$export$626f961c251cf22e);
$parcel$export(module.exports, "useIsHideDoneItemsEnabled", () => $bd35689f373df040$export$41bad204cf3bf31b);
$parcel$export(module.exports, "useIsMergedColumnEnabled", () => $bd35689f373df040$export$f6d8bbcfea5cc718);
$parcel$export(module.exports, "useIsMergedColumnVisible", () => $bd35689f373df040$export$28416a110952f775);
$parcel$export(module.exports, "useIsIssueRankingEnabled", () => $bd35689f373df040$export$7fa8121781f45255);
$parcel$export(module.exports, "useIsStickyColumnsEnabled", () => $bd35689f373df040$export$6050cee0da5e731b);
$parcel$export(module.exports, "useIsConditionalFormattingEnabled", () => $bd35689f373df040$export$c799a83481d5936b);
$parcel$export(module.exports, "useIsTimelineEnabled", () => $bd35689f373df040$export$1a04536b4e3a55ba);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $czfFt = parcelRequire("czfFt");

var $coJAK = parcelRequire("coJAK");
const $bd35689f373df040$export$f031d973e8f9ebd1 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.density === (0, $czfFt.DENSITY_FULL)
});
const $bd35689f373df040$export$e8cb30aec148fb72 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.density === (0, $czfFt.DENSITY_COMPACT) && state.isInfiniteScrollEnabled
});
const $bd35689f373df040$export$928fba01e945632a = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isColumnResizingEnabled
});
const $bd35689f373df040$export$bce4f421d3fcab1b = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isFixedTableLayoutEnabled
});
const $bd35689f373df040$export$3e66c03eddc15634 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isInlineEditingEnabled
});
const $bd35689f373df040$export$2763573a98b052ad = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isInlineEditingExtendedFieldSupportEnabled
});
const $bd35689f373df040$export$543273904a8063c6 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled && state.isInfiniteScrollEnabled
});
const $bd35689f373df040$export$de7fbee8ed52ae4 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isInfiniteScrollEnabled
});
const $bd35689f373df040$export$f1842b07a822e21a = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled && state.isIssueRankingEnabled
});
const $bd35689f373df040$export$1c15679efffd4e2b = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled && state.isIssueHierarchyEnabled
});
const $bd35689f373df040$export$82982f49a24a3a9b = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isIssueRankDescending
});
const $bd35689f373df040$export$4f04f80fe2006454 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isIssueHierarchyEnabled && state.isInfiniteScrollEnabled
});
const $bd35689f373df040$export$a99d862d213ae04 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isIssueOperationMeatballMenuEnabled
});
const $bd35689f373df040$export$3c2a1b4963d788c8 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isRowReorderingEnabled
});
const $bd35689f373df040$export$40143afd2a4a7546 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isRowReorderingEnabled && state.isEntireRowDraggable
});
const $bd35689f373df040$export$64a4c7b004e35cb6 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isReparentingEnabled
});
const $bd35689f373df040$export$b4fbf34545c95b8e = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isRowReorderingEnabled || state.isReparentingEnabled || state.isIssueRankingEnabled
});
const $bd35689f373df040$export$8f31c2503e1efa93 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.projectContext
});
const $bd35689f373df040$export$f8f71fe8cdc658b6 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.sortField
});
const $bd35689f373df040$export$c88af24ce42b9b94 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.sortDirection
});
const $bd35689f373df040$export$f813789488fdc0c7 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.jql
});
const $bd35689f373df040$export$8136b1ebbacf80ef = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isColumnBordersEnabled
});
const $bd35689f373df040$export$edb9f869c9fd4d6e = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isInlineFieldConfigEnabled
});
const $bd35689f373df040$export$9e70cd1d138c2276 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isInBetweenColumnPickerEnabled
});
const $bd35689f373df040$export$626f961c251cf22e = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isSingleLineRowHeightEnabled
});
const $bd35689f373df040$export$41bad204cf3bf31b = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isHideDoneItemsEnabled
});
const $bd35689f373df040$export$f6d8bbcfea5cc718 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isMergedColumnEnabled
});
const $bd35689f373df040$export$28416a110952f775 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isMergedColumnVisible
});
const $bd35689f373df040$export$7fa8121781f45255 = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isIssueRankingEnabled
});
const $bd35689f373df040$export$6050cee0da5e731b = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isStickyColumnsEnabled
});
const $bd35689f373df040$export$c799a83481d5936b = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isConditionalFormattingEnabled
});
const $bd35689f373df040$export$1a04536b4e3a55ba = (0, $3sQ5x.createStateHook)((0, $coJAK.FeaturesStore), {
    selector: (state)=>state.isTimelineEnabled
});

});
parcelRegister("coJAK", function(module, exports) {

$parcel$export(module.exports, "FeaturesContainerInternal", () => $012aa9bf4d9a297d$export$8a9f5b92d3cec1ec);
$parcel$export(module.exports, "FeaturesStore", () => $012aa9bf4d9a297d$export$b78abb146634afd0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $czfFt = parcelRequire("czfFt");
const $012aa9bf4d9a297d$var$initialState = {
    density: (0, $czfFt.DENSITY_COMPACT),
    isColumnResizingEnabled: true,
    isFixedTableLayoutEnabled: true,
    isInlineEditingEnabled: true,
    isInlineEditingExtendedFieldSupportEnabled: false,
    isIssueCreateEnabled: false,
    projectContext: null,
    isInfiniteScrollEnabled: false,
    isIssueRankingEnabled: false,
    isIssueRankDescending: false,
    isIssueHierarchyEnabled: false,
    isIssueOperationMeatballMenuEnabled: true,
    isRowReorderingEnabled: false,
    isEntireRowDraggable: false,
    isReparentingEnabled: false,
    isColumnBordersEnabled: true,
    isInlineFieldConfigEnabled: false,
    isInBetweenColumnPickerEnabled: false,
    isSingleLineRowHeightEnabled: false,
    isHideDoneItemsEnabled: false,
    isMergedColumnEnabled: false,
    isMergedColumnVisible: false,
    isStickyColumnsEnabled: false,
    isConditionalFormattingEnabled: false,
    isTimelineEnabled: false
};
const $012aa9bf4d9a297d$export$8a9f5b92d3cec1ec = (0, $gg7kZ.createContainer)();
const $012aa9bf4d9a297d$var$updateStore = ({ setState: setState }, { density: density, isColumnResizingEnabled: isColumnResizingEnabled, isInlineEditingEnabled: isInlineEditingEnabled, isIssueCreateEnabled: isIssueCreateEnabled, isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled, projectContext: projectContext, isInfiniteScrollEnabled: isInfiniteScrollEnabled, sortDirection: sortDirection, sortField: sortField, isIssueHierarchyEnabled: isIssueHierarchyEnabled, isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled, isRowReorderingEnabled: isRowReorderingEnabled, isEntireRowDraggable: isEntireRowDraggable, isReparentingEnabled: isReparentingEnabled, jql: jql, isColumnBordersEnabled: isColumnBordersEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isMergedColumnEnabled: isMergedColumnEnabled, isMergedColumnVisible: isMergedColumnVisible, isIssueRankingEnabled: isIssueRankingEnabled, isStickyColumnsEnabled: isStickyColumnsEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled = false, isTimelineEnabled: isTimelineEnabled })=>{
    setState({
        density: density,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isFixedTableLayoutEnabled: isColumnResizingEnabled,
        isInlineEditingEnabled: isInlineEditingEnabled,
        isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled,
        isIssueCreateEnabled: isIssueCreateEnabled && Boolean(projectContext),
        projectContext: projectContext ?? null,
        isInfiniteScrollEnabled: isInfiniteScrollEnabled,
        isIssueHierarchyEnabled: isIssueHierarchyEnabled && Boolean(projectContext),
        isIssueRankingEnabled: isIssueRankingEnabled,
        isIssueRankDescending: sortDirection === (0, $czfFt.SORT_DESC),
        isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled,
        isRowReorderingEnabled: isRowReorderingEnabled,
        isEntireRowDraggable: isRowReorderingEnabled && Boolean(isEntireRowDraggable),
        isReparentingEnabled: isReparentingEnabled,
        sortDirection: sortDirection,
        sortField: sortField,
        jql: jql,
        isColumnBordersEnabled: isColumnBordersEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        isHideDoneItemsEnabled: isHideDoneItemsEnabled,
        isMergedColumnEnabled: isMergedColumnEnabled,
        isMergedColumnVisible: isMergedColumnVisible,
        isStickyColumnsEnabled: isStickyColumnsEnabled,
        isConditionalFormattingEnabled: isConditionalFormattingEnabled,
        isTimelineEnabled: isTimelineEnabled
    });
};
const $012aa9bf4d9a297d$export$b78abb146634afd0 = (0, $iXqE5.createStore)({
    initialState: $012aa9bf4d9a297d$var$initialState,
    actions: {},
    containedBy: $012aa9bf4d9a297d$export$8a9f5b92d3cec1ec,
    handlers: {
        onInit: ()=>$012aa9bf4d9a297d$var$updateStore,
        onContainerUpdate: ()=>$012aa9bf4d9a297d$var$updateStore
    }
});

});



parcelRegister("fh5X0", function(module, exports) {

$parcel$export(module.exports, "SiblingCreateActiveIndexContainer", () => $57af7f2f3e0a37e3$export$3bb3687dbfff2504);
$parcel$export(module.exports, "useIsSiblingIssueCreateActive", () => $57af7f2f3e0a37e3$export$1e0d27763664702c);
$parcel$export(module.exports, "useSiblingCreateActiveIndexActions", () => $57af7f2f3e0a37e3$export$c2ceb7cc1900ce28);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $57af7f2f3e0a37e3$var$CLEAR_DELAY = 300;
const $57af7f2f3e0a37e3$var$initialState = {
    issue: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    },
    field: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    }
};
const $57af7f2f3e0a37e3$var$actions = {
    setIndex: (key, index)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: index
                }
            });
            dispatch($57af7f2f3e0a37e3$var$actions.lockIndex(key));
        },
    clearIndex: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: undefined
                }
            });
            dispatch($57af7f2f3e0a37e3$var$actions.unlockIndex(key));
        },
    clearIndexAfterDelay: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const timeoutId = setTimeout(()=>{
                if (!getState()[key].isIndexLocked) {
                    dispatch($57af7f2f3e0a37e3$var$actions.clearIndex(key));
                    setState({
                        [key]: {
                            ...getState()[key],
                            timeoutId: undefined
                        }
                    });
                }
            }, $57af7f2f3e0a37e3$var$CLEAR_DELAY);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false,
                    timeoutId: timeoutId
                }
            });
        },
    lockIndex: (key)=>({ setState: setState, getState: getState })=>{
            const { timeoutId: timeoutId } = getState()[key];
            if (timeoutId) clearTimeout(timeoutId);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: true,
                    timeoutId: undefined
                }
            });
        },
    unlockIndex: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false
                }
            });
        }
};
const $57af7f2f3e0a37e3$export$3bb3687dbfff2504 = (0, $gg7kZ.createContainer)();
const $57af7f2f3e0a37e3$var$Store = (0, $iXqE5.createStore)({
    initialState: $57af7f2f3e0a37e3$var$initialState,
    actions: $57af7f2f3e0a37e3$var$actions,
    containedBy: $57af7f2f3e0a37e3$export$3bb3687dbfff2504
});
const $57af7f2f3e0a37e3$var$isIndexEqual = (a, b)=>a !== undefined && a[0] === b[0] && a[1] === b[1];
const $57af7f2f3e0a37e3$export$1e0d27763664702c = (0, $3sQ5x.createHook)($57af7f2f3e0a37e3$var$Store, {
    selector: (state, index)=>$57af7f2f3e0a37e3$var$isIndexEqual(state.issue.index, index)
});
const $57af7f2f3e0a37e3$export$c2ceb7cc1900ce28 = (0, $3sQ5x.createActionsHook)($57af7f2f3e0a37e3$var$Store);
const $57af7f2f3e0a37e3$export$7de76a106681e3b2 = (0, $3sQ5x.createHook)($57af7f2f3e0a37e3$var$Store);

});

parcelRegister("50ctA", function(module, exports) {

$parcel$export(module.exports, "InlineCreateActiveIndexContainer", () => $1994e08131db7039$export$293e9de3e94ac3e3);
$parcel$export(module.exports, "useInlineCreateActiveIndexActions", () => $1994e08131db7039$export$109b1f65f6277f1f);
$parcel$export(module.exports, "useInlineFieldCreateActiveIndex", () => $1994e08131db7039$export$b47f84449b2c30b5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $1994e08131db7039$var$CLEAR_DELAY = 300;
const $1994e08131db7039$export$3378d8ea7d02abd0 = {
    issue: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    },
    field: {
        index: undefined,
        isHovered: false,
        isIndexLocked: false,
        timeoutId: undefined
    }
};
const $1994e08131db7039$var$actions = {
    setIndex: (key, index)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: index
                }
            });
            dispatch($1994e08131db7039$var$actions.lockIndex(key));
        },
    clearIndex: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: undefined
                }
            });
            dispatch($1994e08131db7039$var$actions.unlockIndex(key));
        },
    clearIndexAfterDelay: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const timeoutId = setTimeout(()=>{
                if (!getState()[key].isIndexLocked) {
                    dispatch($1994e08131db7039$var$actions.clearIndex(key));
                    setState({
                        [key]: {
                            ...getState()[key],
                            timeoutId: undefined
                        }
                    });
                }
            }, $1994e08131db7039$var$CLEAR_DELAY);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false,
                    timeoutId: timeoutId
                }
            });
        },
    setIsHovered: (key)=>({ getState: getState, setState: setState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isHovered: true
                }
            });
        },
    clearIsHovered: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isHovered: false
                }
            });
        },
    lockIndex: (key)=>({ setState: setState, getState: getState })=>{
            const { timeoutId: timeoutId } = getState()[key];
            if (timeoutId) clearTimeout(timeoutId);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: true,
                    timeoutId: undefined
                }
            });
        },
    unlockIndex: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false
                }
            });
        }
};
const $1994e08131db7039$export$293e9de3e94ac3e3 = (0, $gg7kZ.createContainer)();
const $1994e08131db7039$var$Store = (0, $iXqE5.createStore)({
    initialState: $1994e08131db7039$export$3378d8ea7d02abd0,
    actions: $1994e08131db7039$var$actions,
    containedBy: $1994e08131db7039$export$293e9de3e94ac3e3
});
const $1994e08131db7039$export$121b3ed4dfcef179 = (0, $3sQ5x.createHook)($1994e08131db7039$var$Store);
const $1994e08131db7039$export$109b1f65f6277f1f = (0, $3sQ5x.createActionsHook)($1994e08131db7039$var$Store);
const $1994e08131db7039$var$getInlineIssueCreate = (state)=>state.issue;
const $1994e08131db7039$var$getInlineFieldCreate = (state)=>state.field;
const $1994e08131db7039$var$isIssueIndexEqual = (a, b)=>a !== undefined && a[0] === b[0] && a[1] === b[1];
const $1994e08131db7039$export$4e43a4c525201572 = (0, $3sQ5x.createHook)($1994e08131db7039$var$Store, {
    selector: (state, index)=>$1994e08131db7039$var$isIssueIndexEqual(state.issue.index, index)
});
const $1994e08131db7039$export$72e323294e39f1e1 = (0, $3sQ5x.createHook)($1994e08131db7039$var$Store, {
    selector: $1994e08131db7039$var$getInlineIssueCreate
});
const $1994e08131db7039$export$b47f84449b2c30b5 = (0, $3sQ5x.createHook)($1994e08131db7039$var$Store, {
    selector: $1994e08131db7039$var$getInlineFieldCreate
});

});

parcelRegister("0147U", function(module, exports) {

$parcel$export(module.exports, "TableIntersectionObserverContainer", () => $84ee8423f29bfeb3$export$d70db3a85b45c17e);
$parcel$export(module.exports, "useIntersectionObserver", () => $84ee8423f29bfeb3$export$a7395f9832c00176);
$parcel$export(module.exports, "useObserveItem", () => $84ee8423f29bfeb3$export$323a1519def7418e);
$parcel$export(module.exports, "useCalculateIssueInsertionPoint", () => $84ee8423f29bfeb3$export$736db8d31780fc97);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $czfFt = parcelRequire("czfFt");

var $67hk2 = parcelRequire("67hk2");
const $84ee8423f29bfeb3$export$d4c72bab9d6cc13a = {
    intersectionObserver: null,
    itemsObserved: new Map(),
    insertionPoint: null,
    isObserving: false
};
const $84ee8423f29bfeb3$export$d70db3a85b45c17e = (0, $gg7kZ.createContainer)();
const $84ee8423f29bfeb3$var$actions = {
    /**
	 * Starts the intersection observer to observer any stored item.
	 */ observeItems: ()=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, itemsObserved: itemsObserved, isObserving: isObserving } = getState();
            if (isObserving) return;
            if (intersectionObserver != null) itemsObserved.forEach((_, element)=>{
                intersectionObserver.observe(element);
            });
            setState({
                isObserving: true
            });
        },
    /**
	 * Stops the intersection observer.
	 */ unobserveItems: ()=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, isObserving: isObserving } = getState();
            if (!isObserving) return;
            if (intersectionObserver != null) intersectionObserver.disconnect();
            setState({
                isObserving: false
            });
        },
    /**
	 * Disconnect any previous intersection observer stored, if the stored is set to automatically observe,
	 * we start observing any stored item, finally we updated the stored with the new observer.
	 * @param {Object} config
	 * @param {IntersectionObserver} config.intersectionObserver - New IntersectionObserver to be added it
	 */ setIntersectionObserver: ({ intersectionObserver: newIntersectionObserver })=>({ setState: setState, getState: getState })=>{
            const { intersectionObserver: intersectionObserver, isObserving: isObserving, itemsObserved: itemsObserved } = getState();
            if (intersectionObserver != null) intersectionObserver.disconnect();
            if (isObserving) itemsObserved.forEach((_, element)=>{
                newIntersectionObserver.observe(element);
            });
            setState({
                intersectionObserver: newIntersectionObserver
            });
        },
    /**
	 * Add a HTML element ot the list of observed elements. It start's observing automatically
	 * if the stored is observing.
	 * @param {Object} config
	 * @param {HTMLElement} element - HTML Element to be observed
	 * @param {string} issueId - Id of the issue that is associated to the HTML Element that is been observed
	 */ observeItem: ({ element: element, issueId: issueId })=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, itemsObserved: itemsObserved, isObserving: isObserving } = getState();
            setState({
                itemsObserved: new Map([
                    ...itemsObserved.entries(),
                    [
                        element,
                        issueId
                    ]
                ])
            });
            if (intersectionObserver == null || !isObserving) return;
            intersectionObserver.observe(element);
        },
    /**
	 * Removes an element from been observed, I stop's observing the element automatically
	 * if the stored is observing
	 * @param {Object} config
	 * @param {HTMLElement} element - Element to be unobserved
	 */ unobserveItem: ({ element: element })=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, itemsObserved: itemsObserved, isObserving: isObserving } = getState();
            if (itemsObserved.has(element)) {
                const newItemsObserved = new Map(itemsObserved.entries());
                newItemsObserved.delete(element);
                setState({
                    itemsObserved: newItemsObserved
                });
            }
            if (intersectionObserver == null || !isObserving) return;
            intersectionObserver.unobserve(element);
        },
    /**
	 * It stored the insertion point in the stored
	 * @param {InsertionPoint} insertionPoint - Insertion point to be stored
	 */ setInsertionPoint: (insertionPoint)=>({ setState: setState })=>{
            setState({
                insertionPoint: insertionPoint
            });
        }
};
const $84ee8423f29bfeb3$export$bc23ad63575022d9 = (0, $iXqE5.createStore)({
    initialState: $84ee8423f29bfeb3$export$d4c72bab9d6cc13a,
    actions: $84ee8423f29bfeb3$var$actions,
    containedBy: $84ee8423f29bfeb3$export$d70db3a85b45c17e
});
const $84ee8423f29bfeb3$export$bfaae927f3082143 = (0, $3sQ5x.createHook)($84ee8423f29bfeb3$export$bc23ad63575022d9);
const $84ee8423f29bfeb3$export$bc925ad7e18c9ef8 = (0, $3sQ5x.createActionsHook)($84ee8423f29bfeb3$export$bc23ad63575022d9);
const $84ee8423f29bfeb3$var$ROW_HEIGHT_WITH_BORDER = (0, $czfFt.ROW_HEIGHT) + 1;
const $84ee8423f29bfeb3$export$a7395f9832c00176 = ()=>{
    const { setIntersectionObserver: setObserver, setInsertionPoint: setInsertionPoint } = $84ee8423f29bfeb3$export$bc925ad7e18c9ef8();
    return (0, $5uXOq.useCallback)((element)=>{
        if (element != null) {
            const observer = new IntersectionObserver((entries)=>{
                const isOverflow = element.scrollHeight > element.clientHeight;
                const mostRecentEntryCloseToFooter = entries.map((entry)=>{
                    if (entry.rootBounds == null) return;
                    const { top: top } = entry.boundingClientRect;
                    const { bottom: interceptLine } = entry.rootBounds;
                    /**
								 * When scrolling upward (mac), the top line of the item rect is
								 * passing from below to above the intercept line. We identify this
								 * because the entry rectangle will look like:
								 *
								 *  --------  -> Top of root
								 * |        |
								 * |        |
								 * =========  -> Top of item
								 * ---------  -> Bottom of root (aka intercept line)
								 * =========  -> Bottom of item (aka top + height )
								 */ const isBelow = top <= interceptLine && top + $84ee8423f29bfeb3$var$ROW_HEIGHT_WITH_BORDER >= interceptLine;
                    /**
								 * When scrolling downward (mac), the top line of the item rect is
								 * passing from above to below the intercept line. We identify this
								 * because the entry rectangle will look like:
								 *
								 *  --------  -> Top of root
								 * |        |
								 * |        |
								 * ---------  -> Bottom of root (aka intercept line)
								 * =========  -> Top of item
								 * |        |
								 * =========  -> Bottom of item (aka top + height )
								 * If top minus height is below that the intercept line, means that is
								 * rectangle fits
								 */ const isAbove = top >= interceptLine && top - $84ee8423f29bfeb3$var$ROW_HEIGHT_WITH_BORDER <= interceptLine;
                    // We prioritize below vs above when is possible.
                    if (isBelow) return {
                        position: 'below',
                        entry: entry
                    };
                    if (isAbove) return {
                        position: 'above',
                        entry: entry
                    };
                    // Otherwise; Is pass the intercept line ignored
                    return undefined;
                }).filter((a)=>a !== undefined)// put most recent entries on top, is possible that multiple
                // entries pass the intercept line
                .sort((a, b)=>{
                    if (b.entry.time !== a.entry.time) return b.entry.time - a.entry.time;
                    // Returns the closest to the bottom when the time is the same
                    if (b.entry.boundingClientRect.y > a.entry.boundingClientRect.y) return 1;
                    if (b.entry.boundingClientRect.y < a.entry.boundingClientRect.y) return -1;
                    return 0;
                })// get the most recent one
                .shift();
                if (mostRecentEntryCloseToFooter) setInsertionPoint({
                    element: mostRecentEntryCloseToFooter.entry.target,
                    // Always insert below when is not overflowing
                    position: isOverflow ? mostRecentEntryCloseToFooter.position : 'below'
                });
            }, {
                root: element,
                // We are placing the interceptor just below the header
                // and a row above the footer, as we want to insert the icon
                // at least a row above the footer to be visible
                rootMargin: `-40px 0px -${2 * $84ee8423f29bfeb3$var$ROW_HEIGHT_WITH_BORDER}px 0px`
            });
            setObserver({
                intersectionObserver: observer
            });
        }
    }, [
        setInsertionPoint,
        setObserver
    ]);
};
const $84ee8423f29bfeb3$export$323a1519def7418e = (issueId)=>{
    const { observeItem: observeItem, unobserveItem: unobserveItem } = $84ee8423f29bfeb3$export$bc925ad7e18c9ef8();
    const itemRef = (0, $5uXOq.useRef)();
    const wasObserved = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>()=>{
            itemRef.current != null && unobserveItem({
                element: itemRef.current
            });
        }, [
        unobserveItem
    ]);
    return (0, $5uXOq.useCallback)((element)=>{
        if (element != null) {
            itemRef.current = element;
            if (issueId != null) {
                observeItem({
                    element: element,
                    issueId: issueId
                });
                wasObserved.current = true;
            }
        }
    }, [
        issueId,
        observeItem
    ]);
};
const $84ee8423f29bfeb3$export$935a9e0cb21f3923 = (0, $3sQ5x.createStateHook)($84ee8423f29bfeb3$export$bc23ad63575022d9, {
    selector: (0, $67hk2.getInsertionPointSelector)
});
const $84ee8423f29bfeb3$export$736db8d31780fc97 = ()=>{
    const { observeItems: observeItems, unobserveItems: unobserveItems } = $84ee8423f29bfeb3$export$bc925ad7e18c9ef8();
    (0, $5uXOq.useEffect)(()=>{
        observeItems();
        return ()=>{
            unobserveItems();
        };
    }, [
        observeItems,
        unobserveItems
    ]);
    return $84ee8423f29bfeb3$export$935a9e0cb21f3923();
};

});
parcelRegister("67hk2", function(module, exports) {

$parcel$export(module.exports, "getInsertionPointSelector", () => $fda4cbfac17c5336$export$74f2307c2f2b1be0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6dDSs = parcelRequire("6dDSs");
const $fda4cbfac17c5336$var$getIssueIdSelector = (0, $6dDSs.createSelector)((state)=>state.itemsObserved, (_, element)=>element, (items, element)=>{
    const issueId = items.get(element);
    if (issueId === undefined) return null;
    return issueId;
});
const $fda4cbfac17c5336$export$74f2307c2f2b1be0 = (state)=>{
    const { insertionPoint: insertionPoint } = state;
    if (insertionPoint == null) return null;
    const { element: element, position: position } = insertionPoint;
    const issueId = $fda4cbfac17c5336$var$getIssueIdSelector(state, element);
    if (issueId == null) return null;
    return {
        issueId: issueId,
        position: position
    };
};

});


parcelRegister("Br57E", function(module, exports) {

$parcel$export(module.exports, "LazyEditabilityLoaderContainer", () => $af7bd304b8fe166e$export$9e924386fdd64f6e);
$parcel$export(module.exports, "useLazyLoadEditability", () => $af7bd304b8fe166e$export$9b127efb5c6c57e8);

var $5uXOq = parcelRequire("5uXOq");

var $hhZW9 = parcelRequire("hhZW9");

var $8Uumt = parcelRequire("8Uumt");

var $2RKeg = parcelRequire("2RKeg");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $7Kuk2 = parcelRequire("7Kuk2");

var $boeSj = parcelRequire("boeSj");

const $af7bd304b8fe166e$var$initialState = {
    loader: null,
    scheduler: null
};
const $af7bd304b8fe166e$var$Container = (0, $gg7kZ.createContainer)();
const $af7bd304b8fe166e$var$Store = (0, $iXqE5.createStore)({
    containedBy: $af7bd304b8fe166e$var$Container,
    initialState: $af7bd304b8fe166e$var$initialState,
    actions: $boeSj.actions,
    handlers: {
        onInit: ()=>({ setState: setState }, { environment: environment })=>{
                const scheduler = (0, $7Kuk2.createDataLoaderScheduler)(100);
                const loader = new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))((0, $boeSj.batchIsEditableInIssueViewFactory)(environment), {
                    maxBatchSize: (0, $657a4bfd9a98a9d1$export$fba142522eb62862),
                    batchScheduleFn: scheduler.schedule
                });
                setState({
                    loader: loader,
                    scheduler: scheduler
                });
            }
    }
});
const $af7bd304b8fe166e$export$9e924386fdd64f6e = ({ children: children, scope: scope })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af7bd304b8fe166e$var$Container, {
        scope: scope,
        environment: environment
    }, children);
};
const $af7bd304b8fe166e$export$ceb1f4a193b695d1 = (0, $3sQ5x.createActionsHook)($af7bd304b8fe166e$var$Store);
const $af7bd304b8fe166e$export$9b127efb5c6c57e8 = (id, isEditable)=>{
    const { load: load } = $af7bd304b8fe166e$export$ceb1f4a193b695d1();
    (0, $5uXOq.useEffect)(()=>{
        const executeLoad = async ()=>{
            // If there is no editability information for the issue field then queue a request to lazily fetch this data
            // We need to explicitly check the ID is an ARI to ignore fields for optimistically created issues, which
            // are initialised as a UUID.
            if (id != null && isEditable === undefined && (0, $2RKeg.JiraIssuefieldvalueAri).check(id)) load(id);
        };
        executeLoad();
    }, [
        isEditable,
        load,
        id
    ]);
};

});
parcelRegister("2RKeg", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $2164641f4a4b33a7$export$828c4931ae562af7);

var $gB07r = parcelRequire("gB07r");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/issuefieldvalue/manifest.ts
var $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $gB07r.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $gB07r.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $2164641f4a4b33a7$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("gB07r", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $c15031ac9edfd973$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $c15031ac9edfd973$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $c15031ac9edfd973$export$39e9358142fbbc64 = "jira", $c15031ac9edfd973$export$f9e57427271adc95 = "issuefieldvalue";

});


parcelRegister("7Kuk2", function(module, exports) {

$parcel$export(module.exports, "createDataLoaderScheduler", () => $9c5e5045a0e3631f$export$f3542fc7467ff455);

var $lFKmC = parcelRequire("lFKmC");
function $9c5e5045a0e3631f$export$f3542fc7467ff455(delay) {
    let cb = [];
    return {
        schedule (callback) {
            cb.push(callback);
        },
        dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            cb.forEach((callback)=>callback());
            cb = [];
        }, delay)
    };
}

});

parcelRegister("boeSj", function(module, exports) {

$parcel$export(module.exports, "batchIsEditableInIssueViewFactory", () => $20c5193b48797f4f$export$781008fa22e0792);
$parcel$export(module.exports, "actions", () => $20c5193b48797f4f$export$e324594224ef24da);

var $9TdL6 = parcelRequire("9TdL6");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $czfFt = parcelRequire("czfFt");

const $20c5193b48797f4f$export$781008fa22e0792 = (environment)=>async (fieldIds)=>{
        const isEditableMap = new Map();
        const promise = (0, $8Uumt.fetchQuery)(environment, (0, $9TdL6.default), {
            ids: fieldIds,
            first: (0, $657a4bfd9a98a9d1$export$fba142522eb62862)
        }).toPromise();
        try {
            const data = await promise;
            (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
                data?.jira?.issueFieldsByIds?.edges?.map((edge)=>edge?.node).filter(Boolean).forEach(({ __id: __id, id: id, isEditableInIssueView: isEditableInIssueView })=>{
                    isEditableMap.set(id, isEditableInIssueView ?? null);
                    // Set whether issue fields are editable as a new client-only field on the matching node in the Relay
                    // store
                    store.get(__id)?.setValue(isEditableInIssueView ?? null, 'lazyIsEditableInIssueView');
                });
            });
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'lazyEditabilityLoader',
                    packageName: (0, $czfFt.PACKAGE_NAME),
                    teamName: (0, $czfFt.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        // Ensure input argument order is preserved when returning batch results as required by the dataloader
        return fieldIds.map((id)=>isEditableMap.get(id) ?? null);
    };
const $20c5193b48797f4f$export$e324594224ef24da = {
    load: (fieldId)=>({ getState: getState })=>{
            const { loader: loader, scheduler: scheduler } = getState();
            const loading = loader ? loader.load(fieldId) : Promise.resolve(null);
            scheduler?.dispatch();
            return loading;
        }
};

});
parcelRegister("9TdL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4c67a54f5995653$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d8228d06ebe8452bee095ff8f5594dc9>>
 * @relayHash e0b6440748f83639ae3e7c7c2d3fe93e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24fe88e198b2feee72f5134490dbe0d574f365abdcf6a8e568c8988963268c89
const $d4c67a54f5995653$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ids"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "ids"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isEditableInIssueView"
    }, v5 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "actions_LazyLoadEditabilityQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "issueFieldsByIds",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "actions_LazyLoadEditabilityQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "issueFieldsByIds",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "24fe88e198b2feee72f5134490dbe0d574f365abdcf6a8e568c8988963268c89",
            "metadata": {},
            "name": "actions_LazyLoadEditabilityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d4c67a54f5995653$var$node.hash = "271711cb2a483cec7c4f662a4b4db511";
var $d4c67a54f5995653$export$2e2bcd8739ae039 = $d4c67a54f5995653$var$node;

});

const $657a4bfd9a98a9d1$export$fba142522eb62862 = 499;



parcelRegister("kJsz8", function(module, exports) {

$parcel$export(module.exports, "LazyMediaViewContextLoaderContainer", () => $97dc20c92afc3c4a$export$c268c26f941d1a5);
$parcel$export(module.exports, "useLazyMediaViewContext", () => $97dc20c92afc3c4a$export$5475aeba7ee80aa1);

var $5uXOq = parcelRequire("5uXOq");

var $hhZW9 = parcelRequire("hhZW9");

var $8Uumt = parcelRequire("8Uumt");

var $bDq2w = parcelRequire("bDq2w");

var $koeKL = parcelRequire("koeKL");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $7Kuk2 = parcelRequire("7Kuk2");

var $dtveY = parcelRequire("dtveY");

var $ehxrh = parcelRequire("ehxrh");
const $97dc20c92afc3c4a$var$initialState = {
    loader: null,
    scheduler: null
};
const $97dc20c92afc3c4a$var$Container = (0, $gg7kZ.createContainer)();
const $97dc20c92afc3c4a$var$Store = (0, $iXqE5.createStore)({
    containedBy: $97dc20c92afc3c4a$var$Container,
    initialState: $97dc20c92afc3c4a$var$initialState,
    actions: $dtveY.actions,
    handlers: {
        onInit: ()=>({ setState: setState }, { environment: environment, cloudId: cloudId })=>{
                const scheduler = (0, $7Kuk2.createDataLoaderScheduler)(100);
                const loader = new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))((0, $dtveY.batchMediaViewResponseFactory)(environment, cloudId), {
                    maxBatchSize: (0, $ehxrh.MAX_BATCH_SIZE),
                    batchScheduleFn: scheduler.schedule
                });
                setState({
                    loader: loader,
                    scheduler: scheduler
                });
            }
    }
});
const $97dc20c92afc3c4a$export$c268c26f941d1a5 = ({ children: children, scope: scope })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97dc20c92afc3c4a$var$Container, {
        scope: scope,
        environment: environment,
        cloudId: cloudId
    }, children);
};
const $97dc20c92afc3c4a$export$2ccec1e3fc6f5f = (0, $3sQ5x.createActionsHook)($97dc20c92afc3c4a$var$Store);
const $97dc20c92afc3c4a$export$5475aeba7ee80aa1 = (issueKey)=>{
    const { load: load } = $97dc20c92afc3c4a$export$2ccec1e3fc6f5f();
    const [viewContext, setViewContext] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        const executeLoad = async ()=>{
            // We only want to fetch when viewContext's value hasn't been initialised yet
            if (viewContext === undefined) {
                const viewResponse = await load(issueKey);
                if (viewResponse) setViewContext((0, $bDq2w.viewContextTransformer)(viewResponse));
                else setViewContext(null);
            }
        };
        executeLoad();
    }, [
        viewContext,
        load,
        issueKey
    ]);
    return viewContext ?? null;
};

});
parcelRegister("bDq2w", function(module, exports) {

$parcel$export(module.exports, "getTokenDeltaProps", () => $236ce381d87cfea9$export$4d271852dd07ca26);
$parcel$export(module.exports, "isTokenValid", () => $236ce381d87cfea9$export$d1a8c8b605234fe8);
$parcel$export(module.exports, "viewContextTransformer", () => $236ce381d87cfea9$export$5fb65caa7eb9e932);
// This has TS defs, so when we move to TS let's enable them again
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'jwt-decode'. '/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/jwt-decode/lib/index.js' implicitly has an 'any' type.

var $2hW3Y = parcelRequire("2hW3Y");
const $236ce381d87cfea9$var$TOKEN_NETWORK_BUFFER = 10000;
const $236ce381d87cfea9$export$e9df841c4c486a60 = (startTimestamp)=>startTimestamp ? startTimestamp - Date.now() + 0 : undefined;
const $236ce381d87cfea9$export$4d271852dd07ca26 = (token)=>{
    let decodedToken;
    try {
        decodedToken = (0, (/*@__PURE__*/$parcel$interopDefault($2hW3Y)))(token);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // why would this be the case
        return {
            tokenDecodeError: typeof error.message === 'string' ? error.message : undefined,
            localTimeDelta: undefined,
            tokenExpiryTime: undefined
        };
    }
    // In my testing, sometimes issued at was missing
    const startTimestamp = decodedToken.iat || decodedToken.nbf;
    return {
        tokenDecodeError: undefined,
        localTimeDelta: $236ce381d87cfea9$export$e9df841c4c486a60(startTimestamp * 1000),
        tokenExpiryTime: decodedToken.exp * 1000
    };
};
function $236ce381d87cfea9$export$d1a8c8b605234fe8({ token: token, tokenExpiryTime: tokenExpiryTime, localTimeDelta: localTimeDelta }) {
    if (typeof token !== 'string' || token.length === 0) return false;
    if (typeof tokenExpiryTime !== 'number' || typeof localTimeDelta !== 'number') return false;
    const actualExpiryTime = tokenExpiryTime + localTimeDelta - $236ce381d87cfea9$var$TOKEN_NETWORK_BUFFER;
    const timeUntilExpiry = actualExpiryTime - Date.now();
    const isValid = timeUntilExpiry >= 0;
    return isValid;
}
const $236ce381d87cfea9$export$5fb65caa7eb9e932 = (viewResponse)=>{
    const token = viewResponse.tokensWithFiles[0]?.token || null;
    const tokenProps = typeof token === 'string' ? $236ce381d87cfea9$export$4d271852dd07ca26(token) : {};
    return {
        clientId: viewResponse.clientId,
        serviceHost: viewResponse.endpointUrl,
        token: token,
        areTokenPermissionsUpToDate: true,
        tokenLifespanInMs: viewResponse.tokenLifespanInSeconds * 1000,
        collection: viewResponse.collection !== undefined && viewResponse.collection !== '' ? viewResponse.collection : null,
        tokenIssueTimestamp: Date.now() - $236ce381d87cfea9$var$TOKEN_NETWORK_BUFFER,
        tokenDecodeError: tokenProps.tokenDecodeError,
        localTimeDelta: tokenProps.localTimeDelta,
        tokenExpiryTime: tokenProps.tokenExpiryTime
    };
};

});
parcelRegister("2hW3Y", function(module, exports) {
'use strict';

var $2ep83 = parcelRequire("2ep83");
function $1aaa356e5fda3e32$var$InvalidTokenError(message) {
    this.message = message;
}
$1aaa356e5fda3e32$var$InvalidTokenError.prototype = new Error();
$1aaa356e5fda3e32$var$InvalidTokenError.prototype.name = 'InvalidTokenError';
module.exports = function(token, options) {
    if (typeof token !== 'string') throw new $1aaa356e5fda3e32$var$InvalidTokenError('Invalid token specified');
    options = options || {};
    var pos = options.header === true ? 0 : 1;
    try {
        return JSON.parse($2ep83(token.split('.')[pos]));
    } catch (e) {
        throw new $1aaa356e5fda3e32$var$InvalidTokenError('Invalid token specified: ' + e.message);
    }
};
module.exports.InvalidTokenError = $1aaa356e5fda3e32$var$InvalidTokenError;

});
parcelRegister("2ep83", function(module, exports) {

var $byIqd = parcelRequire("byIqd");
function $1a0061a3b7e63481$var$b64DecodeUnicode(str) {
    return decodeURIComponent($byIqd(str).replace(/(.)/g, function(m, p) {
        var code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = '0' + code;
        return '%' + code;
    }));
}
module.exports = function(str) {
    var output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return $1a0061a3b7e63481$var$b64DecodeUnicode(output);
    } catch (err) {
        return $byIqd(output);
    }
};

});
parcelRegister("byIqd", function(module, exports) {
/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */ var $86a553e97b24e6ed$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
function $86a553e97b24e6ed$var$InvalidCharacterError(message) {
    this.message = message;
}
$86a553e97b24e6ed$var$InvalidCharacterError.prototype = new Error();
$86a553e97b24e6ed$var$InvalidCharacterError.prototype.name = 'InvalidCharacterError';
function $86a553e97b24e6ed$var$polyfill(input) {
    var str = String(input).replace(/=+$/, '');
    if (str.length % 4 == 1) throw new $86a553e97b24e6ed$var$InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
    for(// initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = ''; // get next character
    buffer = str.charAt(idx++); // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    bc++ % 4) && (output += String.fromCharCode(255 & bs >> (-2 * bc & 6))))// try to find character in table (0-63, not found => -1)
    buffer = $86a553e97b24e6ed$var$chars.indexOf(buffer);
    return output;
}
module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || $86a553e97b24e6ed$var$polyfill;

});




parcelRegister("dtveY", function(module, exports) {

$parcel$export(module.exports, "batchMediaViewResponseFactory", () => $7fa56ea062c99d81$export$eedff7e9aaf52da1);
$parcel$export(module.exports, "actions", () => $7fa56ea062c99d81$export$e324594224ef24da);

var $9Bdwm = parcelRequire("9Bdwm");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $czfFt = parcelRequire("czfFt");

var $ehxrh = parcelRequire("ehxrh");
const $7fa56ea062c99d81$export$eedff7e9aaf52da1 = (environment, cloudId)=>async (issueKeys)=>{
        const issueKeysMap = new Map();
        const uniqueIssueKeys = [
            ...new Set(issueKeys)
        ];
        const promise = (0, $8Uumt.fetchQuery)(environment, (0, $9Bdwm.default), {
            issueKeys: uniqueIssueKeys,
            cloudId: cloudId,
            maxTokenLength: (0, $ehxrh.MAX_TOKEN_LENGTH)
        }).toPromise();
        try {
            const result = await promise;
            const issues = result?.jira?.issuesByKey;
            issues?.forEach((issue)=>{
                if (issue?.mediaReadToken) {
                    const { clientId: clientId, endpointUrl: endpointUrl, tokenLifespanInSeconds: tokenLifespanInSeconds, tokensWithFiles: tokensWithFiles } = issue?.mediaReadToken;
                    const tokensWithFilesFlattened = tokensWithFiles?.edges?.map((edge)=>edge?.node?.token ? {
                            token: edge.node.token
                        } : null).filter(Boolean);
                    if (clientId && endpointUrl && tokenLifespanInSeconds && tokensWithFilesFlattened) {
                        const viewResponse = {
                            clientId: clientId,
                            endpointUrl: endpointUrl,
                            tokenLifespanInSeconds: tokenLifespanInSeconds,
                            tokensWithFiles: tokensWithFilesFlattened
                        };
                        issueKeysMap.set(issue.key, viewResponse);
                    }
                }
            });
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'lazyMediaViewResponseFactory',
                    packageName: (0, $czfFt.PACKAGE_NAME),
                    teamName: (0, $czfFt.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        // Ensure input argument order is preserved when returning batch results as required by the dataloader
        return issueKeys.map((issueKey)=>issueKeysMap.get(issueKey) ?? null);
    };
const $7fa56ea062c99d81$export$e324594224ef24da = {
    load: (issueKey)=>({ getState: getState })=>{
            const { loader: loader, scheduler: scheduler } = getState();
            const loading = loader ? loader.load(issueKey) : Promise.resolve(null);
            scheduler?.dispatch();
            return loading;
        }
};

});
parcelRegister("9Bdwm", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc1524c4b1589756$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<038490e885f5ed59aebe309ed3d06370>>
 * @relayHash 88dc3fe18d2828d729fb2bf7929e7076
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 878b3b6282e98d324c50ccd49dbaf8a07c889063b5efed0881fe239f64e5160d
const $dc1524c4b1589756$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKeys"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "maxTokenLength"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "keys",
            "variableName": "issueKeys"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "actions_LazyLoadMediaReadTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issuesByKey",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "actions_LazyLoadMediaReadTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issuesByKey",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "878b3b6282e98d324c50ccd49dbaf8a07c889063b5efed0881fe239f64e5160d",
            "metadata": {},
            "name": "actions_LazyLoadMediaReadTokenQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$dc1524c4b1589756$var$node.hash = "a1b3499bc5d237db13d819b5abf7ce41";
var $dc1524c4b1589756$export$2e2bcd8739ae039 = $dc1524c4b1589756$var$node;

});

parcelRegister("ehxrh", function(module, exports) {

$parcel$export(module.exports, "MAX_BATCH_SIZE", () => $82203736b49e1661$export$b79d95ee17a87a);
$parcel$export(module.exports, "MAX_TOKEN_LENGTH", () => $82203736b49e1661$export$525f5433a110000f);

var $9wuCE = parcelRequire("9wuCE");
const $82203736b49e1661$export$b79d95ee17a87a = 100;
const $82203736b49e1661$export$525f5433a110000f = (0, $9wuCE.getMaxTokenLength)();

});
parcelRegister("9wuCE", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $ebb491dcc11e8362$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $ebb491dcc11e8362$var$nonIE11MaxTokenLength = 2 ** 16;
const $ebb491dcc11e8362$export$e40f2acaf1a50b00 = ()=>$ebb491dcc11e8362$var$nonIE11MaxTokenLength;

});




parcelRegister("3I8L4", function(module, exports) {

$parcel$export(module.exports, "DraggableRowsContainer", () => $1b7c591ba2fab0a9$export$d659f1efda86963d);
$parcel$export(module.exports, "Store", () => $1b7c591ba2fab0a9$export$390f32400eaf98c9);
$parcel$export(module.exports, "useDraggableRowsConnectionId", () => $1b7c591ba2fab0a9$export$ab74a8a2556419cd);

var $ajpes = parcelRequire("ajpes");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");
const $1b7c591ba2fab0a9$export$d4c72bab9d6cc13a = {
    currentDropTarget: null,
    instanceId: 'pdnd-issue-table-rows',
    issueConnectionId: '',
    items: new Map(),
    onRowReorder: undefined
};
const $1b7c591ba2fab0a9$var$actions = {
    setDropTarget: (dropTarget)=>({ setState: setState, getState: getState })=>{
            const currentDropTarget = getState().currentDropTarget;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(currentDropTarget, dropTarget)) setState({
                currentDropTarget: dropTarget
            });
        },
    reorderRows: (sourceIndex, destinationIndex)=>({ getState: getState })=>{
            const { items: items, onRowReorder: onRowReorder } = getState();
            onRowReorder?.({
                source: {
                    issueIds: [
                        items.get(sourceIndex) ?? ''
                    ],
                    rowIndex: sourceIndex
                },
                destination: {
                    relativeToIssueId: items.get(destinationIndex) ?? '',
                    rowIndex: destinationIndex
                },
                edge: sourceIndex > destinationIndex ? 'top' : 'bottom'
            });
        },
    registerItem: (edgeIndex, issueId)=>({ getState: getState, setState: setState })=>{
            const { items: items } = getState();
            setState({
                items: items.set(edgeIndex, issueId)
            });
        },
    unregisterItem: (edgeIndex)=>({ getState: getState, setState: setState })=>{
            const { items: items } = getState();
            if (items.delete(edgeIndex)) setState({
                items: items
            });
        }
};
const $1b7c591ba2fab0a9$export$d659f1efda86963d = (0, $gg7kZ.createContainer)({
    getIsConcurrentSafe: ()=>(0, $4R6GH.fg)('jira-concurrent-issue-table-rss-fix')
});
const $1b7c591ba2fab0a9$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: $1b7c591ba2fab0a9$export$d4c72bab9d6cc13a,
    actions: $1b7c591ba2fab0a9$var$actions,
    containedBy: $1b7c591ba2fab0a9$export$d659f1efda86963d,
    handlers: {
        onInit: ()=>({ setState: setState }, { instanceId: instanceId, onRowReorder: onRowReorder, issueConnectionId: issueConnectionId })=>{
                setState({
                    instanceId: instanceId ?? $1b7c591ba2fab0a9$export$d4c72bab9d6cc13a.instanceId,
                    onRowReorder: onRowReorder,
                    ...(0, $4R6GH.fg)('jsc_list_reranking_gate_technical') ? {
                        issueConnectionId: issueConnectionId
                    } : {}
                });
            },
        onContainerUpdate: (props, prevProps)=>({ setState: setState }, { instanceId: instanceId, onRowReorder: onRowReorder, issueConnectionId: issueConnectionId })=>{
                if ((0, $4R6GH.fg)('jira-issue-table-fix-reordering')) {
                    if (props.instanceId !== prevProps.instanceId || props.onRowReorder !== prevProps.onRowReorder || props.issueConnectionId !== prevProps.issueConnectionId && (0, $4R6GH.fg)('jsc_list_reranking_gate_technical')) setState({
                        instanceId: instanceId,
                        onRowReorder: onRowReorder,
                        ...(0, $4R6GH.fg)('jsc_list_reranking_gate_technical') ? {
                            issueConnectionId: issueConnectionId
                        } : {}
                    });
                } else if (props.instanceId !== prevProps.instanceId) setState({
                    instanceId: instanceId,
                    onRowReorder: onRowReorder,
                    ...(0, $4R6GH.fg)('jsc_list_reranking_gate_technical') ? {
                        issueConnectionId: issueConnectionId
                    } : {}
                });
            },
        onDestroy: ()=>({ getState: getState })=>{
                const { items: items } = getState();
                items.clear();
            }
    }
});
const $1b7c591ba2fab0a9$export$ab74a8a2556419cd = (0, $3sQ5x.createHook)($1b7c591ba2fab0a9$export$390f32400eaf98c9, {
    selector: ({ issueConnectionId: issueConnectionId })=>issueConnectionId
});

});

parcelRegister("96pci", function(module, exports) {

$parcel$export(module.exports, "IFCFooter", () => $a5289311908ecec7$export$7b0e717a6d1208a9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $5389t = parcelRequire("5389t");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");

var $eCeGD = parcelRequire("eCeGD");

var $99M5v = parcelRequire("99M5v");

var $1jWct = parcelRequire("1jWct");

var $jhmo0 = parcelRequire("jhmo0");

var $koVbs = parcelRequire("koVbs");

var $itmJb = parcelRequire("itmJb");

var $dAfqg = parcelRequire("dAfqg");

var $bZca2 = parcelRequire("bZca2");

var $4anLj = parcelRequire("4anLj");

var $6s1PB = parcelRequire("6s1PB");

var $50ctA = parcelRequire("50ctA");


var $5VaIm = parcelRequire("5VaIm");

var $gzbU9 = parcelRequire("gzbU9");

var $89whg = parcelRequire("89whg");

var $isCXd = parcelRequire("isCXd");
const $a5289311908ecec7$var$styles = {
    ifcFooter: "_1h6dmuej _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1e0c1txw _2lx2vrvc _15a5nqa1 _uwhke4h9 _1bah1h6o"
};
const $a5289311908ecec7$export$7b0e717a6d1208a9 = ({ onPickerClose: onPickerClose, columnsDataId: columnsDataId, columnInsertIndex: columnInsertIndex })=>{
    const { ifcConfig: ifcConfig, addFieldToColumns: addFieldToColumns } = (0, $5VaIm.useIFCConfigContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSiteAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = (0, $4anLj.useIsProjectAdmin)();
    const isTMP = (0, $dAfqg.useIsSimplifiedProject)();
    const isAdmin = isSiteAdmin || isProjectAdmin;
    const isCMPAdmin = isAdmin && !isTMP;
    const isTMPAdmin = isAdmin && isTMP;
    const { clearIndex: clearIndex } = (0, $50ctA.useInlineCreateActiveIndexActions)();
    const environment = (0, $5389t.useRelayEnvironment)();
    const editField = (0, $gzbU9.useIFCEditField)();
    const onStartFieldCreate = (0, $5uXOq.useCallback)(({ name: name, type: type })=>{
        const field = {
            fieldSetId: (0, $isCXd.TEMP_CREATE_FIELDSET_ID),
            name: name,
            type: type
        };
        (0, $bZca2.createOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: columnsDataId,
            fields: [
                field
            ],
            createIndex: columnInsertIndex
        });
    }, [
        columnInsertIndex,
        columnsDataId,
        environment
    ]);
    const onFieldCreated = (0, $5uXOq.useCallback)((fieldId, fieldSetId)=>{
        if (fieldSetId) {
            (0, $isCXd.updateTempOptimisticFieldSetId)({
                environment: environment,
                fieldConfigId: columnsDataId,
                fieldSetId: fieldSetId
            });
            addFieldToColumns?.(fieldSetId, columnInsertIndex, ()=>{
                (0, $bZca2.deleteOptimisticFieldConfig)({
                    environment: environment,
                    fieldConfigId: columnsDataId,
                    fields: [
                        {
                            fieldSetId: fieldSetId,
                            name: ''
                        }
                    ]
                });
            });
            editField(fieldId, fieldSetId);
        }
    }, [
        environment,
        columnsDataId,
        addFieldToColumns,
        columnInsertIndex,
        editField
    ]);
    const onFieldCreateError = (0, $5uXOq.useCallback)(()=>{
        (0, $bZca2.deleteOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: columnsDataId,
            fields: [
                {
                    fieldSetId: (0, $isCXd.TEMP_CREATE_FIELDSET_ID),
                    name: ''
                }
            ]
        });
    }, [
        columnsDataId,
        environment
    ]);
    const clickHandler = (0, $5uXOq.useCallback)((event)=>{
        onPickerClose?.(event);
        clearIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
        ifcConfig?.onCreate({
            onFieldCreated: onFieldCreated,
            onStartFieldCreate: onStartFieldCreate,
            onFieldCreateError: onFieldCreateError
        });
    }, [
        onPickerClose,
        clearIndex,
        ifcConfig,
        onFieldCreated,
        onStartFieldCreate,
        onFieldCreateError
    ]);
    if (!isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a5289311908ecec7$var$styles.ifcFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $89whg.default).contactAdmin, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
                href: "/secure/ContactAdministrators!default.jspa",
                target: "_blank"
            }, chunks)
    }))));
    if (isTMPAdmin && ifcConfig?.IFCTriggerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a5289311908ecec7$var$styles.ifcFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ifcConfig.IFCTriggerRef, null, ({ triggerRef: triggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            ref: triggerRef,
            onClick: clickHandler,
            shouldFitContainer: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.100",
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $89whg.default).createAnotherButton))))));
    if (isCMPAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a5289311908ecec7$var$styles.ifcFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $89whg.default).makeChangesInConfig, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
                href: (0, $6s1PB.expVal)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', false) ? '/jira/settings/issues/fields' : '/secure/admin/ViewCustomFields.jspa',
                target: "_blank"
            }, chunks)
    }))));
};

});
parcelRegister("5389t", function(module, exports) {
/**
 * Relay v0.0.0-main-5980a913
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("dA9Ki"));

});
parcelRegister("dA9Ki", function(module, exports) {
'use strict';

var $9YyJ0 = parcelRequire("9YyJ0");

var $a6M7O = parcelRequire("a6M7O");

var $aKraw = parcelRequire("aKraw");
var $9e363276a1c9481c$var$loadQuery = $aKraw.loadQuery;

var $1auXT = parcelRequire("1auXT");

var $GBSe8 = parcelRequire("GBSe8");

var $8fqWB = parcelRequire("8fqWB");

var $eofgg = parcelRequire("eofgg");

var $ITbUa = parcelRequire("ITbUa");

var $667zR = parcelRequire("667zR");

var $jZlQN = parcelRequire("jZlQN");

var $iEtZE = parcelRequire("iEtZE");

var $6FDcO = parcelRequire("6FDcO");

var $kxGyI = parcelRequire("kxGyI");

var $g3TRS = parcelRequire("g3TRS");

var $jLHdt = parcelRequire("jLHdt");

var $jfy4f = parcelRequire("jfy4f");

var $eiowN = parcelRequire("eiowN");
module.exports = {
    ConnectionHandler: $eiowN.ConnectionHandler,
    applyOptimisticMutation: $eiowN.applyOptimisticMutation,
    commitLocalUpdate: $eiowN.commitLocalUpdate,
    commitMutation: $eiowN.commitMutation,
    graphql: $eiowN.graphql,
    readInlineData: $eiowN.readInlineData,
    requestSubscription: $eiowN.requestSubscription,
    EntryPointContainer: $9YyJ0,
    RelayEnvironmentProvider: $GBSe8,
    ProfilerContext: $1auXT,
    fetchQuery: $eiowN.fetchQuery,
    loadQuery: $9e363276a1c9481c$var$loadQuery,
    loadEntryPoint: $a6M7O,
    useFragment: $eofgg,
    useLazyLoadQuery: $ITbUa,
    useEntryPointLoader: $8fqWB,
    useQueryLoader: $6FDcO,
    useMutation: $667zR,
    usePaginationFragment: $jZlQN,
    usePreloadedQuery: $iEtZE,
    useRefetchableFragment: $kxGyI,
    useRelayEnvironment: $g3TRS,
    useSubscribeToInvalidationState: $jLHdt,
    useSubscription: $jfy4f
};

});


parcelRegister("bZca2", function(module, exports) {

$parcel$export(module.exports, "isOnlyUnselectableField", () => $9a19e48adde00a3a$export$bf5bbd6344a5f1aa);
$parcel$export(module.exports, "getFieldDisabledMessage", () => $9a19e48adde00a3a$export$b547e1f9b04ac0ef);
$parcel$export(module.exports, "findNewInsertFields", () => $9a19e48adde00a3a$export$60fa8135877879de);
$parcel$export(module.exports, "findRemovedFields", () => $9a19e48adde00a3a$export$bcbd9324b737d43e);
$parcel$export(module.exports, "getUpdatedOptions", () => $9a19e48adde00a3a$export$f35b98a37123c93f);
$parcel$export(module.exports, "sortMergedColumnOptions", () => $9a19e48adde00a3a$export$9c9602c008ed572e);
$parcel$export(module.exports, "createOptimisticFieldConfig", () => $9a19e48adde00a3a$export$156c6a7908536c2c);
$parcel$export(module.exports, "deleteOptimisticFieldConfig", () => $9a19e48adde00a3a$export$c2b4d8461d595052);
$parcel$export(module.exports, "getRollbackFields", () => $9a19e48adde00a3a$export$f07a9aef49bee569);
$parcel$export(module.exports, "rollbackOptimisticFieldConfig", () => $9a19e48adde00a3a$export$4b8e679985e2412d);

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");

var $8Uumt = parcelRequire("8Uumt");

var $7Jxgt = parcelRequire("7Jxgt");

var $cgL5K = parcelRequire("cgL5K");

var $65VLO = parcelRequire("65VLO");

var $b1Er6 = parcelRequire("b1Er6");
const $9a19e48adde00a3a$export$bf5bbd6344a5f1aa = (fieldType, canEditColumnConfiguration)=>{
    // Epic Link can only be unselected
    if (fieldType === 'com.pyxis.greenhopper.jira:gh-epic-link') return canEditColumnConfiguration;
    // Parent Link can only be unselected
    if (fieldType === 'com.atlassian.jpo:jpo-custom-field-parent') return canEditColumnConfiguration;
    return false;
};
const $9a19e48adde00a3a$export$b547e1f9b04ac0ef = (fieldType, formatMessage)=>{
    // Epic Link deprecation message
    if (fieldType === 'com.pyxis.greenhopper.jira:gh-epic-link') return formatMessage((0, $b1Er6.default).deprecatedEpicMessage, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong"
            }, chunks)
    });
    // Parent Link deprecation message
    if (fieldType === 'com.atlassian.jpo:jpo-custom-field-parent') return formatMessage((0, $b1Er6.default).deprecatedParentLinkMessage, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong"
            }, chunks)
    });
    return undefined;
};
const $9a19e48adde00a3a$export$60fa8135877879de = (options, selectedColumns)=>{
    return options.filter((option)=>!selectedColumns.some((prevOption)=>{
            if ('value' in prevOption && 'value' in option) return prevOption.value === option.value;
            return false;
        }));
};
const $9a19e48adde00a3a$export$bcbd9324b737d43e = (options, selectedColumns)=>{
    const removedFields = [];
    const existingValues = new Set(options.map((opt)=>'value' in opt ? opt.value : ''));
    selectedColumns.forEach((option)=>{
        if ('value' in option && !existingValues.has(option.value)) removedFields.push({
            name: option.label,
            fieldSetId: option.value
        });
    });
    return removedFields;
};
const $9a19e48adde00a3a$export$f35b98a37123c93f = (options, insertFields, insertIndex)=>{
    if (insertIndex !== undefined) {
        const updatedOptions = [
            ...options
        ];
        updatedOptions.splice(insertIndex, 0, ...insertFields);
        return updatedOptions;
    }
    return [
        ...options,
        ...insertFields
    ];
};
const $9a19e48adde00a3a$export$9c9602c008ed572e = (options)=>{
    let issuekey;
    let issuetype;
    let summary;
    const otherOptions = [];
    options.forEach((option)=>{
        if ('type' in option) {
            if (option.value === (0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_TYPE) issuetype = option;
            else if (option.value === (0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_KEY) issuekey = option;
            else if (option.value === (0, $65VLO.KNOWN_COLUMN_TYPES).SUMMARY) summary = option;
            else otherOptions.push(option);
        } else otherOptions.push(option);
    });
    return [
        issuetype,
        issuekey,
        summary,
        ...otherOptions
    ].filter(Boolean);
};
const $9a19e48adde00a3a$export$156c6a7908536c2c = ({ environment: environment, fieldConfigId: fieldConfigId, fields: newFields, createIndex: createIndex })=>{
    if (fieldConfigId) (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const createdFields = [];
            newFields.forEach((field)=>{
                const exists = fields?.find((edge)=>edge.getLinkedRecord('node')?.getValue('fieldSetId') === field.fieldSetId);
                if (!exists) createdFields.push($9a19e48adde00a3a$var$createFieldInStore(field, store));
            });
            if (fields) {
                if (createIndex !== undefined && createIndex >= 0 && createIndex <= fields.length) {
                    const updatedFields = [
                        ...fields
                    ];
                    updatedFields.splice(createIndex, 0, ...createdFields);
                    store.get(fieldConfigId)?.setLinkedRecords(updatedFields, 'edges');
                } else store.get(fieldConfigId)?.setLinkedRecords([
                    ...fields,
                    ...createdFields
                ], 'edges');
                store.get(fieldConfigId)?.setValue(fields.length + createdFields.length, 'totalCount');
            }
        }
    });
    const rollback = ()=>{
        if (fieldConfigId) (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            const fieldSetsConnection = store.get(fieldConfigId);
            if (fieldConfigId) {
                fieldSetsConnection?.getLinkedRecords('edges')?.forEach((edge)=>{
                    const node = edge.getLinkedRecord('node');
                    const exists = newFields?.find((field)=>node?.getValue('fieldSetId') === field.fieldSetId);
                    if (exists) {
                        const nodeId = node?.getDataID();
                        nodeId && (0, $eiowN.ConnectionHandler).deleteNode(fieldSetsConnection, nodeId);
                    }
                });
                const newTotalCount = fieldSetsConnection?.getLinkedRecords('edges')?.length;
                store.get(fieldConfigId)?.setValue(newTotalCount, 'totalCount');
            }
        });
    };
    return rollback;
};
const $9a19e48adde00a3a$export$c2b4d8461d595052 = ({ environment: environment, fieldConfigId: fieldConfigId, fields: deletedFields })=>{
    if (fieldConfigId) (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
        const fieldSetsConnection = store.get(fieldConfigId);
        const deletedFieldsSetIds = new Set(deletedFields.map((field)=>field.fieldSetId));
        fieldSetsConnection?.getLinkedRecords('edges')?.forEach((edge)=>{
            const node = edge.getLinkedRecord('node');
            const fieldSetId = node?.getValue('fieldSetId')?.toString();
            if (fieldSetId && deletedFieldsSetIds.has(fieldSetId)) {
                const nodeId = node?.getDataID();
                nodeId && (0, $eiowN.ConnectionHandler).deleteNode(fieldSetsConnection, nodeId);
            }
        });
        const newTotalCount = fieldSetsConnection?.getLinkedRecords('edges')?.length;
        store.get(fieldConfigId)?.setValue(newTotalCount, 'totalCount');
    });
};
const $9a19e48adde00a3a$export$f07a9aef49bee569 = ({ environment: environment, fieldConfigId: fieldConfigId })=>{
    const backupFields = [];
    (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fieldSetsConnection = store.get(fieldConfigId);
            fieldSetsConnection?.getLinkedRecords('edges')?.forEach((edge)=>{
                const node = edge.getLinkedRecord('node');
                const fieldSetPreferences = node?.getLinkedRecord('fieldSetPreferences');
                const width = fieldSetPreferences?.getValue('width')?.toString();
                const field = {
                    fieldSetId: node?.getValue('fieldSetId')?.toString() || '',
                    jqlTerm: node?.getValue('jqlTerm')?.toString() || '',
                    type: node?.getValue('type')?.toString() || '',
                    name: node?.getValue('displayName')?.toString() || '',
                    customWidth: width ? Number(width) : undefined
                };
                backupFields.push(field);
            });
        }
    });
    return backupFields;
};
const $9a19e48adde00a3a$export$4b8e679985e2412d = ({ environment: environment, fieldConfigId: fieldConfigId, fields: backupFields })=>{
    if (fieldConfigId && backupFields.length > 0) (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
        const fieldSetsConnection = store.get(fieldConfigId);
        // Create new edges for each backup node and completely replace the current edges
        const restoredEdges = backupFields.map((field)=>$9a19e48adde00a3a$var$createFieldInStore(field, store));
        if (fieldSetsConnection) {
            fieldSetsConnection.setLinkedRecords(restoredEdges, 'edges');
            fieldSetsConnection.setValue(restoredEdges.length, 'totalCount');
        }
    });
};
const $9a19e48adde00a3a$var$createFieldInStore = (newField, store)=>{
    const fieldJqlTerm = 'jql-placeholder-only';
    const edge = store.create((0, $7Jxgt.v4)(), 'JiraIssueSearchFieldSetEdge');
    const aField = store.create((0, $7Jxgt.v4)(), 'JiraIssueSearchFieldSet');
    aField.setValue(newField.fieldSetId, 'fieldSetId');
    aField.setValue(newField.jqlTerm ?? fieldJqlTerm, 'jqlTerm');
    aField.setValue(newField.type, 'type');
    aField.setValue(newField.name, 'displayName');
    if (!newField.jqlTerm) aField.setValue(true, 'isPlaceHolderField');
    if (newField.customWidth) {
        const preferences = store.create((0, $7Jxgt.v4)(), 'FieldSetPreferences');
        preferences.setValue(newField.customWidth, 'width');
        aField.setLinkedRecord(preferences, 'fieldSetPreferences');
    }
    edge.setLinkedRecord(aField, 'node');
    return edge;
};

});
parcelRegister("b1Er6", function(module, exports) {

$parcel$export(module.exports, "default", () => $44ec9d03e2e91142$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $44ec9d03e2e91142$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issuetype: {
        "id": "issue-table-column-picker.issuetype",
        "defaultMessage": "Issue Type"
    },
    issuekey: {
        "id": "issue-table-column-picker.issuekey",
        "defaultMessage": "Key"
    },
    summary: {
        "id": "issue-table-column-picker.summary",
        "defaultMessage": "Summary"
    },
    assignee: {
        "id": "issue-table-column-picker.assignee",
        "defaultMessage": "Assignee"
    },
    reporter: {
        "id": "issue-table-column-picker.reporter",
        "defaultMessage": "Reporter"
    },
    priority: {
        "id": "issue-table-column-picker.priority",
        "defaultMessage": "Priority"
    },
    status: {
        "id": "issue-table-column-picker.status",
        "defaultMessage": "Status"
    },
    resolution: {
        "id": "issue-table-column-picker.resolution",
        "defaultMessage": "Resolution"
    },
    created: {
        "id": "issue-table-column-picker.created",
        "defaultMessage": "Created"
    },
    updated: {
        "id": "issue-table-column-picker.updated",
        "defaultMessage": "Updated"
    },
    duedate: {
        "id": "issue-table-column-picker.duedate",
        "defaultMessage": "Due date"
    },
    deprecatedParentLinkMessage: {
        "id": "issue-table-column-picker.deprecated-parent-link-message",
        "defaultMessage": "<strong>Parent Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    deprecatedEpicMessage: {
        "id": "issue-table-column-picker.deprecated-epic-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    issuetypeIssueTerminologyRefreshM4: {
        "id": "issue-table-column-picker.issuetype-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    }
});

});


parcelRegister("4anLj", function(module, exports) {

$parcel$export(module.exports, "useIsProjectAdmin", () => $28cdc31165a564f1$export$9facd8d31b938a25);

var $dAfqg = parcelRequire("dAfqg");
const $28cdc31165a564f1$export$9facd8d31b938a25 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    return !!data?.isProjectAdmin;
};

});

const $7c774df2bdb90654$export$76a449e52fa0e1e8 = 'issue';
const $7c774df2bdb90654$export$d6f887e0c1be1b74 = 'field';

parcelRegister("5VaIm", function(module, exports) {

$parcel$export(module.exports, "useIFCConfigContext", () => $51f9e6556a872169$export$e3a7198c51d237d7);
$parcel$export(module.exports, "IFCConfigContextProviderComponent", () => $51f9e6556a872169$export$8df178a0d1abc310);

var $dTT00 = parcelRequire("dTT00");

var $1DxLW = parcelRequire("1DxLW");

var $5uXOq = parcelRequire("5uXOq");

var $5389t = parcelRequire("5389t");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $65VLO = parcelRequire("65VLO");

var $bZca2 = parcelRequire("bZca2");

var $czfFt = parcelRequire("czfFt");

var $isCXd = parcelRequire("isCXd");

var $6YqUX = parcelRequire("6YqUX");
const $51f9e6556a872169$export$be578a14685d978b = /*#__PURE__*/ (0, $5uXOq.createContext)({
    ifcConfig: undefined
});
const $51f9e6556a872169$export$16276ffbd566ecbc = ({ children: children, ifcConfig: ifcConfig, columns: columns, onColumnsChange: onColumnsChange, queryRef: queryRef, columnsQueryRef: columnsQueryRef })=>{
    const columnRef = (0, $5uXOq.useRef)(columns);
    const currentIssuesRef = (0, $5uXOq.useRef)(null);
    const processedIssuesRef = (0, $5uXOq.useRef)({
        issuesRef: null,
        fieldId: null
    });
    const selectedOptions = (0, $5uXOq.useRef)(undefined);
    if (columnRef.current !== columns) columnRef.current = columns;
    const environment = (0, $5389t.useRelayEnvironment)();
    const issuesQueryRef = (0, $5389t.useFragment)((0, $1DxLW.default), queryRef);
    const fieldConfig = (0, $5389t.useFragment)((0, $dTT00.default), columnsQueryRef);
    if (currentIssuesRef.current !== issuesQueryRef) currentIssuesRef.current = issuesQueryRef ?? null;
    const optimisticDeleteField = (0, $5uXOq.useCallback)((fieldSetId)=>{
        (0, $bZca2.deleteOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: fieldConfig?.__id,
            fields: [
                {
                    fieldSetId: fieldSetId,
                    name: ''
                }
            ]
        });
    }, [
        environment,
        fieldConfig?.__id
    ]);
    const replaceFieldSetInColumns = (0, $5uXOq.useCallback)((fieldSetId, newfieldSetId, fieldId)=>{
        (0, $isCXd.optimisticUpdateColumnConfigFieldSetIdById)({
            environment: environment,
            fieldConfigId: fieldConfig?.__id,
            field: {
                fieldId: fieldId,
                fieldSetId: newfieldSetId
            }
        });
        (0, $6YqUX.optimisticUpdateIssuesFieldSetId)(environment, currentIssuesRef.current, fieldId, newfieldSetId);
        const columnIds = columnRef.current?.map(({ id: id })=>id)?.filter((id)=>!id.startsWith((0, $czfFt.COLUMN_ID_INTERNAL_COLUMN)) && id !== (0, $isCXd.TEMP_CREATE_FIELDSET_ID));
        const insertIndex = columnIds.findIndex((id)=>id === fieldSetId);
        if (insertIndex > -1) {
            columnIds[insertIndex] = newfieldSetId;
            onColumnsChange?.({
                columnIds: columnIds,
                retries: 3,
                onErrorCallback: ()=>{
                    optimisticDeleteField(newfieldSetId);
                },
                isHorizontalAutoScrollNeeded: false,
                skipRefetch: true
            });
        }
    }, [
        environment,
        fieldConfig?.__id,
        onColumnsChange,
        optimisticDeleteField
    ]);
    const addFieldToColumns = (0, $5uXOq.useCallback)((fieldSetId, index, onErrorCallback)=>{
        const columnIds = columnRef.current?.map(({ id: id })=>id)?.filter((id)=>!id.startsWith((0, $czfFt.COLUMN_ID_INTERNAL_COLUMN)) && id !== (0, $isCXd.TEMP_CREATE_FIELDSET_ID));
        const insertIndex = index == null ? columnIds.length : index;
        columnIds.splice(insertIndex, 0, fieldSetId);
        onColumnsChange?.({
            columnIds: columnIds,
            retries: 3,
            onErrorCallback: onErrorCallback,
            isHorizontalAutoScrollNeeded: index === undefined
        });
    }, [
        onColumnsChange
    ]);
    const updateSelectedOptions = (0, $5uXOq.useCallback)((fieldId, type, options)=>{
        if (type !== (0, $65VLO.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT && type !== (0, $65VLO.KNOWN_COLUMN_TYPES).SINGLE_SELECT) return;
        if (processedIssuesRef.current.issuesRef !== currentIssuesRef.current || processedIssuesRef.current.fieldId !== fieldId) {
            selectedOptions.current = (0, $6YqUX.getSelectedOptions)(currentIssuesRef.current, fieldId, type);
            processedIssuesRef.current.issuesRef = currentIssuesRef.current;
            processedIssuesRef.current.fieldId = fieldId;
        }
        if (selectedOptions.current) (0, $6YqUX.optimisticUpdatesSelectedOptions)(environment, type, selectedOptions.current, options);
    }, [
        environment
    ]);
    const optimisticUpdateField = (0, $5uXOq.useCallback)((fieldId, field)=>{
        if (fieldConfig?.__id) {
            (0, $isCXd.updateOptimisticFieldName)({
                environment: environment,
                fieldConfigId: fieldConfig?.__id,
                field: {
                    fieldId: fieldId,
                    name: field.name
                }
            });
            if (field.options) updateSelectedOptions?.(fieldId, field.type, field.options);
        }
    }, [
        environment,
        fieldConfig?.__id,
        updateSelectedOptions
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            ifcConfig: ifcConfig,
            addFieldToColumns: addFieldToColumns,
            updateSelectedOptions: updateSelectedOptions,
            replaceFieldSetInColumns: replaceFieldSetInColumns,
            optimisticUpdateField: optimisticUpdateField,
            optimisticDeleteField: optimisticDeleteField
        }), [
        ifcConfig,
        addFieldToColumns,
        updateSelectedOptions,
        replaceFieldSetInColumns,
        optimisticUpdateField,
        optimisticDeleteField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51f9e6556a872169$export$be578a14685d978b.Provider, {
        value: value
    }, children);
};
const $51f9e6556a872169$export$e3a7198c51d237d7 = ()=>{
    return (0, $5uXOq.useContext)($51f9e6556a872169$export$be578a14685d978b);
};
const $51f9e6556a872169$export$8df178a0d1abc310 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira_inline_field_config_gate'), $51f9e6556a872169$export$16276ffbd566ecbc, ({ children: children })=>children);

});
parcelRegister("dTT00", function(module, exports) {

$parcel$export(module.exports, "default", () => $89dea6bfd888f66a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab771d6d7f14313f1bf27206756b3ede>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $89dea6bfd888f66a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$89dea6bfd888f66a$var$node.hash = "da9cc8f15ae8ed9e7e4b651383cc3495";
var $89dea6bfd888f66a$export$2e2bcd8739ae039 = $89dea6bfd888f66a$var$node;

});

parcelRegister("1DxLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1776edb2489b4d43$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<69f00035022823978209c37b80d6e7f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1776edb2489b4d43$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "type"
    }, v1 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "context_nativeIssueTable_IFCConfigContextProvider_queryRef",
        "selections": [
            {
                "kind": "InlineDataFragmentSpread",
                "name": "optimisticUpdatesSelectedOptionsQuery",
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 500
                                            }
                                        ],
                                        "concreteType": "JiraIssueFieldSetConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldSets",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldSetEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldSet",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueFieldConnection",
                                                                "kind": "LinkedField",
                                                                "name": "fields",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "__typename"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "fieldId"
                                                                                    },
                                                                                    v0 /*: any*/ ,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraOptionConnection",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "selectedOptions",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraOptionEdge",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "edges",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraOption",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "node",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "id"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "value"
                                                                                                                    }
                                                                                                                ]
                                                                                                            },
                                                                                                            v1 /*: any*/ 
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraCheckboxesField"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraOption",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "fieldOption",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "optionId"
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraSingleSelectField"
                                                                                    },
                                                                                    v1 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            v1 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "fieldSets(first:500)"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "argumentDefinitions": [
                    {
                        "kind": "RootArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                    }
                ]
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$1776edb2489b4d43$var$node.hash = "f0f5032440126e7680db215f36484487";
var $1776edb2489b4d43$export$2e2bcd8739ae039 = $1776edb2489b4d43$var$node;

});

parcelRegister("isCXd", function(module, exports) {

$parcel$export(module.exports, "TEMP_CREATE_FIELDSET_ID", () => $a73a2317a73a841f$export$6ec0f6605f2c959e);
$parcel$export(module.exports, "updateTempOptimisticFieldSetId", () => $a73a2317a73a841f$export$983fb13ccb9ab7e0);
$parcel$export(module.exports, "updateOptimisticFieldName", () => $a73a2317a73a841f$export$1ba75d43b01f9290);
$parcel$export(module.exports, "optimisticUpdateColumnConfigFieldSetIdById", () => $a73a2317a73a841f$export$28a743eeaeb242db);

var $5389t = parcelRequire("5389t");
const $a73a2317a73a841f$export$6ec0f6605f2c959e = 'temp_new_fieldset_id';
const $a73a2317a73a841f$export$983fb13ccb9ab7e0 = ({ environment: environment, fieldConfigId: fieldConfigId, fieldSetId: fieldSetId })=>{
    (0, $5389t.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const currentField = fields?.find((edge)=>edge.getLinkedRecord('node')?.getValue('fieldSetId') === $a73a2317a73a841f$export$6ec0f6605f2c959e);
            if (currentField) currentField.getLinkedRecord('node')?.setValue(fieldSetId, 'fieldSetId');
        }
    });
};
const $a73a2317a73a841f$export$1ba75d43b01f9290 = ({ environment: environment, fieldConfigId: fieldConfigId, field: { fieldId: fieldId, name: name } })=>{
    (0, $5389t.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const currentField = fields?.find((edge)=>{
                const metadata = edge.getLinkedRecord('node')?.getLinkedRecord('fieldsMetadata');
                const fsFields = metadata?.getLinkedRecords('edges');
                const fsField = fsFields?.find((fedge)=>fedge?.getLinkedRecord('node')?.getValue('fieldId') === fieldId);
                return !!fsField;
            });
            if (currentField) currentField.getLinkedRecord('node')?.setValue(name, 'displayName');
        }
    });
};
const $a73a2317a73a841f$export$28a743eeaeb242db = ({ environment: environment, fieldConfigId: fieldConfigId, field: { fieldId: fieldId, fieldSetId: fieldSetId } })=>{
    (0, $5389t.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const currentField = fields?.find((edge)=>{
                const metadata = edge.getLinkedRecord('node')?.getLinkedRecord('fieldsMetadata');
                const fsFields = metadata?.getLinkedRecords('edges');
                const fsField = fsFields?.find((fedge)=>fedge?.getLinkedRecord('node')?.getValue('fieldId') === fieldId);
                return !!fsField;
            });
            if (currentField) currentField.getLinkedRecord('node')?.setValue(fieldSetId, 'fieldSetId');
        }
    });
};

});

parcelRegister("6YqUX", function(module, exports) {

$parcel$export(module.exports, "getSelectedOptions", () => $c478fb97b6e6b1a8$export$dd5cf00ceb58ef45);
$parcel$export(module.exports, "optimisticUpdatesSelectedOptions", () => $c478fb97b6e6b1a8$export$b96cfa9b16d1cfb3);
$parcel$export(module.exports, "optimisticUpdateIssuesFieldSetId", () => $c478fb97b6e6b1a8$export$6b82cef47b481f3a);

var $dqaG1 = parcelRequire("dqaG1");

var $8Uumt = parcelRequire("8Uumt");

var $5389t = parcelRequire("5389t");

var $erdwt = parcelRequire("erdwt");

var $65VLO = parcelRequire("65VLO");
const $c478fb97b6e6b1a8$var$readIssuesData = (queryRef)=>{
    return (0, $8Uumt.readInlineData)((0, $dqaG1.default), queryRef);
};
const $c478fb97b6e6b1a8$export$dd5cf00ceb58ef45 = (queryRef, fieldId, type)=>{
    if (!queryRef) return;
    const selectedOptions = $c478fb97b6e6b1a8$var$readIssuesData(queryRef);
    const selectedOptionMap = {};
    switch(type){
        case (0, $65VLO.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT:
            selectedOptions?.edges?.forEach((issue)=>{
                const fieldsets = issue?.fieldSets?.edges?.filter((fieldSet)=>fieldSet?.node?.type === (0, $65VLO.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT);
                fieldsets?.forEach((fieldSet)=>{
                    const field = fieldSet?.node?.fields?.edges?.find((f)=>f?.node?.fieldId === fieldId);
                    field?.node?.selectedOptions?.edges?.forEach((option)=>{
                        if (option?.__id != null && option?.node?.id != null) {
                            const optionId = option?.__id ?? '';
                            selectedOptionMap[optionId] = option?.node?.id;
                        }
                    });
                });
            });
            break;
        case (0, $65VLO.KNOWN_COLUMN_TYPES).SINGLE_SELECT:
            selectedOptions?.edges?.forEach((issue)=>{
                const fieldsets = issue?.fieldSets?.edges?.filter((fieldSet)=>fieldSet?.node?.type === (0, $65VLO.KNOWN_COLUMN_TYPES).SINGLE_SELECT);
                fieldsets?.forEach((fieldSet)=>{
                    const field = fieldSet?.node?.fields?.edges?.find((f)=>{
                        return f?.node?.fieldId === fieldId;
                    });
                    if (field?.node?.__id != null && field?.node?.fieldOption?.optionId) selectedOptionMap[field?.node?.__id ?? ''] = field?.node?.fieldOption?.optionId;
                });
            });
            break;
        default:
            break;
    }
    return selectedOptionMap;
};
const $c478fb97b6e6b1a8$export$b96cfa9b16d1cfb3 = (environment, type, selectedOptionMap, options)=>{
    if (type !== (0, $65VLO.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT && type !== (0, $65VLO.KNOWN_COLUMN_TYPES).SINGLE_SELECT) return;
    (0, $5389t.commitLocalUpdate)(environment, (store)=>{
        const ids = Object.keys(selectedOptionMap);
        if (ids.length > 0) {
            const optionMap = {};
            options.forEach((opt)=>{
                optionMap[opt.id] = opt.value;
            });
            switch(type){
                case (0, $65VLO.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT:
                    ids.forEach((id)=>{
                        const option = store.get(id)?.getLinkedRecord('node');
                        const optionId = (0, $erdwt.JiraIssueFieldOptionAri).parse(selectedOptionMap[id]).optionId;
                        option?.setValue(optionMap[optionId], 'value');
                    });
                    break;
                case (0, $65VLO.KNOWN_COLUMN_TYPES).SINGLE_SELECT:
                    ids.forEach((id)=>{
                        const option = store.get(id)?.getLinkedRecord('fieldOption');
                        const optionId = selectedOptionMap[id];
                        option?.setValue(optionMap[optionId], 'value');
                    });
                    break;
                default:
                    break;
            }
        }
    });
};
const $c478fb97b6e6b1a8$export$6b82cef47b481f3a = (environment, queryRef, fieldId, fieldSetId)=>{
    (0, $5389t.commitLocalUpdate)(environment, (store)=>{
        const issues = $c478fb97b6e6b1a8$var$readIssuesData(queryRef);
        issues?.edges?.forEach((issue)=>{
            const fieldsets = issue?.fieldSets?.edges;
            fieldsets?.forEach((fieldSet)=>{
                const field = fieldSet?.node?.fields?.edges?.find((f)=>f?.node?.fieldId === fieldId);
                if (field) {
                    const id = fieldSet?.node?.__id ?? '';
                    const fieldSetToUpdate = store.get(id);
                    fieldSetToUpdate?.setValue(fieldSetId, 'fieldSetId');
                }
            });
        });
    });
};

});
parcelRegister("dqaG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d738191468ba531$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ddd18863e2a61a00004cb181111aeaf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0d738191468ba531$var$node = {
    "kind": "InlineDataFragment",
    "name": "optimisticUpdatesSelectedOptionsQuery"
};
$0d738191468ba531$var$node.hash = "83a7011bc7cd3ad661e263d72491a025";
var $0d738191468ba531$export$2e2bcd8739ae039 = $0d738191468ba531$var$node;

});

parcelRegister("erdwt", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $a82e13aa7ad841f1$export$e3bc1ec22f941fbe);

var $aeXsV = parcelRequire("aeXsV");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/issue-field-option/manifest.ts
var $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $aeXsV.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $aeXsV.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/,
        // eslint-disable-line no-useless-escape
        optionId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $a82e13aa7ad841f1$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("aeXsV", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $774956c9da7baac8$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $774956c9da7baac8$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $774956c9da7baac8$export$eb4f4cf0880fe5a8 = "jira", $774956c9da7baac8$export$4bec333360908e78 = "issue-field-option";

});




parcelRegister("gzbU9", function(module, exports) {

$parcel$export(module.exports, "useIFCEditField", () => $5edabbdfb673098b$export$9e12f6c6c7e366bd);

var $5uXOq = parcelRequire("5uXOq");

var $jDrwg = parcelRequire("jDrwg");

var $5VaIm = parcelRequire("5VaIm");
const $5edabbdfb673098b$export$9e12f6c6c7e366bd = ()=>{
    const { ifcConfig: ifcConfig, optimisticUpdateField: optimisticUpdateField, replaceFieldSetInColumns: replaceFieldSetInColumns, optimisticDeleteField: optimisticDeleteField } = (0, $5VaIm.useIFCConfigContext)();
    const currentFieldSetId = (0, $5uXOq.useRef)();
    const isUpdateInProgress = (0, $5uXOq.useRef)();
    const onStartFieldUpdate = (0, $5uXOq.useCallback)((id, field)=>{
        isUpdateInProgress.current = true;
        optimisticUpdateField?.(id, field);
    }, [
        optimisticUpdateField
    ]);
    const [onDebouncedFieldUpdated] = (0, $jDrwg.default)((fieldId, field)=>{
        if (field?.collapsedName && currentFieldSetId.current && !isUpdateInProgress.current) {
            // skip saving fieldset config when there is no change in name
            if (field?.collapsedName !== currentFieldSetId.current) replaceFieldSetInColumns?.(currentFieldSetId.current, field.collapsedName, fieldId);
            currentFieldSetId.current = field?.collapsedName;
        }
    }, 1000);
    const onFieldUpdated = (0, $5uXOq.useCallback)((fieldId, field)=>{
        isUpdateInProgress.current = false;
        onDebouncedFieldUpdated(fieldId, field);
    }, [
        onDebouncedFieldUpdated
    ]);
    const onFieldDeleted = (0, $5uXOq.useCallback)(()=>{
        if (currentFieldSetId.current) optimisticDeleteField?.(currentFieldSetId.current);
    }, [
        optimisticDeleteField
    ]);
    const onUpdate = (fieldId, fieldSetId)=>{
        currentFieldSetId.current = fieldSetId;
        ifcConfig?.onUpdate({
            fieldId: fieldId,
            onStartFieldUpdate: (field)=>onStartFieldUpdate(fieldId, field),
            onFieldUpdated: onFieldUpdated,
            onFieldDeleted: onFieldDeleted
        });
    };
    return onUpdate;
};

});
parcelRegister("jDrwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $049f084810e3e7c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $5uXOq.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $5uXOq.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});


parcelRegister("89whg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4efdecee02c1954$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a4efdecee02c1954$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createAnotherButton: {
        "id": "native-issue-table.inline-field-config-footer.create-another-button",
        "defaultMessage": "Create another"
    },
    contactAdmin: {
        "id": "native-issue-table.inline-field-config-footer.contact-admin-text",
        "defaultMessage": "<link>Contact your project admin</link> to make changes"
    },
    makeChangesInConfig: {
        "id": "native-issue-table.inline-field-config-footer.make-config-changes-text",
        "defaultMessage": "Make changes in <link>configurations</link>"
    }
});

});


parcelRegister("1sTzn", function(module, exports) {

$parcel$export(module.exports, "CustomComponentsProvider", () => $fd8bed18b04b7822$export$e4fb02e50022594f);
$parcel$export(module.exports, "useCustomComponents", () => $fd8bed18b04b7822$export$b0e9d19f717d0a5c);

var $5uXOq = parcelRequire("5uXOq");
const $fd8bed18b04b7822$var$CustomComponentsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $fd8bed18b04b7822$export$e4fb02e50022594f = ({ children: children, components: components })=>{
    // Memoize individual components to avoid re-rendering if a new object with
    // the same values is passed in via NativeIssueTable’s components prop
    const columnPicker = (0, $5uXOq.useMemo)(()=>({
            Container: components?.columnPicker?.Container,
            EmptyState: components?.columnPicker?.EmptyState,
            Footer: components?.columnPicker?.Footer,
            Icon: components?.columnPicker?.Icon,
            PopupComponent: components?.columnPicker?.PopupComponent
        }), [
        components?.columnPicker?.Container,
        components?.columnPicker?.EmptyState,
        components?.columnPicker?.Footer,
        components?.columnPicker?.Icon,
        components?.columnPicker?.PopupComponent
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            ConnectionsSubscriber: components?.ConnectionsSubscriber,
            Footer: components?.Footer,
            IssueCount: components?.IssueCount,
            NoColumns: components?.NoColumns,
            NoIssues: components?.NoIssues,
            RowsAdditionalContent: components?.RowsAdditionalContent,
            ScrollContainer: components?.ScrollContainer,
            columnPicker: columnPicker
        }), [
        columnPicker,
        components?.ConnectionsSubscriber,
        components?.Footer,
        components?.IssueCount,
        components?.NoColumns,
        components?.NoIssues,
        components?.RowsAdditionalContent,
        components?.ScrollContainer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd8bed18b04b7822$var$CustomComponentsContext.Provider, {
        value: value
    }, children);
};
const $fd8bed18b04b7822$export$b0e9d19f717d0a5c = ()=>{
    const context = (0, $5uXOq.useContext)($fd8bed18b04b7822$var$CustomComponentsContext);
    if (!context) throw new Error('useCustomComponents must be used within a CustomComponentsProvider');
    return context;
};

});

parcelRegister("6HbWX", function(module, exports) {

$parcel$export(module.exports, "getMergedColumnConfig", () => $435fe7291a44bb18$export$9fce51f35317a690);

var $5uXOq = parcelRequire("5uXOq");

var $65VLO = parcelRequire("65VLO");

var $xhiHy = parcelRequire("xhiHy");

var $ceawz = parcelRequire("ceawz");

var $8x2PM = parcelRequire("8x2PM");
const $435fe7291a44bb18$var$getColumnTitle = (mergedColumns, baseField, formatMessage)=>{
    if (mergedColumns.length === 0) return '';
    if (mergedColumns.length === 1 && baseField) return baseField.title;
    return formatMessage((0, $8x2PM.default).columnHeaderMergedColumn);
};
const $435fe7291a44bb18$export$9fce51f35317a690 = (columns, isIssueHierarchyEnabled, formatMessage)=>{
    const filteredColumns = [];
    let mergedColumns = [];
    let issueKeyColumn = null;
    let issueTypeColumn = null;
    let summaryColumn = null;
    let isCheckboxColumnEnabled = false;
    // Filter out the issue key, issue type, and summary columns
    columns.forEach((column)=>{
        if (column.type === (0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_KEY) issueKeyColumn = column;
        else if (column.type === (0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_TYPE) issueTypeColumn = column;
        else if (column.type === (0, $65VLO.KNOWN_COLUMN_TYPES).SUMMARY) summaryColumn = column;
        else filteredColumns.push(column);
        if (column.id === (0, $65VLO.COLUMN_ID_CHECKBOX)) isCheckboxColumnEnabled = true;
    });
    // Always preserve this order: issue type, key, summary
    mergedColumns = [
        issueTypeColumn,
        issueKeyColumn,
        summaryColumn
    ].filter(Boolean);
    // If there is no issue key, issue type, or summary column, we show only expand & child issue create icons
    const baseField = summaryColumn ?? issueKeyColumn ?? issueTypeColumn ?? null;
    // return original columns if hierarchy is OFF and merged fields are OFF
    if (!mergedColumns.length && !isIssueHierarchyEnabled) return columns;
    const columnConfig = baseField ?? (0, $xhiHy.getColumnConfig)(formatMessage)[(0, $65VLO.KNOWN_COLUMN_TYPES).MERGED_COLUMN]();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const resizeColumnId = baseField ? baseField.id : undefined;
    const icon = isIssueHierarchyEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ceawz.default), null) : undefined;
    const mergedColumn = {
        jqlTerm: '',
        fieldTypeDisplayName: '',
        ...columnConfig,
        id: (0, $65VLO.COLUMN_ID_MERGED_COLUMN),
        type: (0, $65VLO.KNOWN_COLUMN_TYPES).MERGED_COLUMN,
        title: $435fe7291a44bb18$var$getColumnTitle(mergedColumns, baseField, formatMessage),
        isSortable: false,
        mergedColumns: mergedColumns,
        resizeColumnId: resizeColumnId,
        customHeader: baseField ? undefined : icon,
        icon: icon
    };
    // insert the merged column after the checkbox column if it exists
    const mergedColumnIndex = isCheckboxColumnEnabled ? 1 : 0;
    return [
        ...filteredColumns.slice(0, mergedColumnIndex),
        mergedColumn,
        ...filteredColumns.slice(mergedColumnIndex)
    ];
};

});
parcelRegister("8x2PM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfcf31b0f5d51bd9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bfcf31b0f5d51bd9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    columnHeaderMergedColumn: {
        "id": "native-issue-table.common.utils.get-merged-column-config.column-header-merged-column",
        "defaultMessage": "Work items"
    }
});

});


parcelRegister("b54lr", function(module, exports) {

$parcel$export(module.exports, "SortChangeContextProvider", () => $4c0499ec297ed739$export$61767aa5bd260064);
$parcel$export(module.exports, "useSortContext", () => $4c0499ec297ed739$export$a3b9cb2711d4166);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");
const $4c0499ec297ed739$var$SortChangeContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
const $4c0499ec297ed739$export$61767aa5bd260064 = (0, $cSD7y.componentWithFG)('jsc_list_reranking_gate_technical', $4c0499ec297ed739$var$SortChangeContext.Provider, ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
const $4c0499ec297ed739$export$a3b9cb2711d4166 = ()=>{
    const context = (0, $5uXOq.useContext)($4c0499ec297ed739$var$SortChangeContext);
    return context !== undefined ? context : {};
};

});

parcelRegister("albIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $04ed626b47ec0c34$export$2e2bcd8739ae039);

var $eYrWA = parcelRequire("eYrWA");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dCm1o = parcelRequire("dCm1o");

var $35sx5 = parcelRequire("35sx5");

var $e9M6d = parcelRequire("e9M6d");

var $8LDbV = parcelRequire("8LDbV");

var $kNwwG = parcelRequire("kNwwG");

var $ddMwE = parcelRequire("ddMwE");
/**
 * Render the table footer, composing together the default IssueCount and Pagination UI elements.
 */ const $04ed626b47ec0c34$var$FooterRenderer = ({ Footer: Footer, IssueCount: IssueCount, issues: issues, onPageChange: onPageChange })=>{
    const issueData = (0, $8Uumt.useFragment)((0, $eYrWA.default), issues);
    const isIssueCreateEnabled = (0, $e9M6d.useIsIssueCreateEnabled)();
    const isInfiniteScrollEnabled = (0, $e9M6d.useIsInfiniteScrollEnabled)();
    // Use new Visual Refresh footer order if visual refresh or any m1 features are enabled to
    // simplfiy the number of cases we need to handle with the new features.
    // cleanup all isNewFooterOrderEnabled props with visual-refresh FG
    const isNewFooterOrderEnabled = (0, $dCm1o.isVisualRefreshEnabled)() || isIssueCreateEnabled || isInfiniteScrollEnabled;
    let start;
    let center;
    let end;
    // Show pagination controls only when discrete pagination is enabled
    if (onPageChange && !isInfiniteScrollEnabled) {
        const paginationControls = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ddMwE.PaginationControls), {
            issues: issueData,
            onPageChange: (after)=>onPageChange(after, false),
            isNewFooterOrderEnabled: isNewFooterOrderEnabled
        });
        if (isNewFooterOrderEnabled) center = paginationControls;
        else end = paginationControls;
    }
    // Show issue count when either pagination or infinite scroll are enabled
    if (onPageChange || isInfiniteScrollEnabled) {
        const issueCount = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LDbV.default), {
            issues: issueData,
            IssueCount: IssueCount,
            isNewFooterOrderEnabled: isNewFooterOrderEnabled,
            isInfiniteScrollEnabled: isInfiniteScrollEnabled
        });
        if (isNewFooterOrderEnabled) end = issueCount;
        else center = issueCount;
    }
    const hasIssues = (issueData.totalIssueSearchResultCount ?? 0) > 0;
    const hasIssueConnectionControls = hasIssues && (!!onPageChange || isInfiniteScrollEnabled);
    const hasControlsToDisplay = hasIssueConnectionControls || isIssueCreateEnabled;
    // Hide the footer if we have no issues UNLESS the consumer has provided a custom footer component, in which case
    // the consumer becomes responsible for when the footer should be shown/hidden.
    if (!hasControlsToDisplay && !Footer) return null;
    const FooterToRender = Footer ?? (0, $35sx5.Footer);
    if (isIssueCreateEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kNwwG.IssueCreateFooter), {
        Footer: FooterToRender,
        start: start,
        center: center,
        end: end,
        issues: issueData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FooterToRender, {
        start: start,
        center: center,
        end: end
    });
};
var $04ed626b47ec0c34$export$2e2bcd8739ae039 = $04ed626b47ec0c34$var$FooterRenderer;

});
parcelRegister("eYrWA", function(module, exports) {

$parcel$export(module.exports, "default", () => $54693c47af2260b9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a4730d872936c47da86755d7a3a7c4e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $54693c47af2260b9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageSize"
        }
    ],
    "kind": "Fragment",
    "name": "footerRenderer_nativeIssueTable",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_nativeIssueTable_IssueCountRenderer"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueCreateFooter_nativeIssueTable"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                }
            ],
            "kind": "FragmentSpread",
            "name": "paginationControls_nativeIssueTable"
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        }
    ],
    "type": "JiraIssueConnection"
};
$54693c47af2260b9$var$node.hash = "9d716ccc56cda13ca3b1ffc97af563b2";
var $54693c47af2260b9$export$2e2bcd8739ae039 = $54693c47af2260b9$var$node;

});

parcelRegister("35sx5", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $9ac639c2cf475c33$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kYFm9 = parcelRequire("kYFm9");

var $9CFBJ = parcelRequire("9CFBJ");
const $9ac639c2cf475c33$export$a06f1c675e846f6f = ({ start: start = $9ac639c2cf475c33$var$SpacerElement, center: center = $9ac639c2cf475c33$var$SpacerElement, end: end = $9ac639c2cf475c33$var$SpacerElement })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ac639c2cf475c33$var$FooterBase, null, start, center, end);
};
function $9ac639c2cf475c33$var$FooterBase({ children: children }) {
    const tableHeight = (0, $kYFm9.useElementSizeSelector)((size)=>size.height);
    const hasShadow = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>{
        const { height: containerHeight, scrollTop: scrollTop } = scrollState;
        // Scroll measurements are fractional, while height measurements are integer, so we need to round before comparing
        return containerHeight < tableHeight && Math.round(scrollTop) < tableHeight - containerHeight;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ac639c2cf475c33$var$FooterContainer, {
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: hasShadow
    }, children);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ac639c2cf475c33$var$FooterContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasShadow: hasShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb _1e0c1txw _2lx2vrvc _1n261q9c _kqsw1if8 _1ltvidpf _94n5idpf _bfhkvuon _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.hasShadow && "_16qsahas",
            __cmplp.className
        ])
    });
});
const $9ac639c2cf475c33$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $9ac639c2cf475c33$var$SpacerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ac639c2cf475c33$export$d7a54cba636a8cd6, null);

});
parcelRegister("9CFBJ", function(module, exports) {

$parcel$export(module.exports, "useScrollStateSelector", () => $502b0ac1011ec6e7$export$a2d79f83724ed591);
$parcel$export(module.exports, "useScrollElement", () => $502b0ac1011ec6e7$export$fae04c81b2201f65);
$parcel$export(module.exports, "ScrollStateProvider", () => $502b0ac1011ec6e7$export$9f9741e7dc6bdb9b);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $502b0ac1011ec6e7$export$50b6b7783d156e1b = 200;
const $502b0ac1011ec6e7$export$f9abcb6f103965a2 = (0, $gg7kZ.createContainer)();
const $502b0ac1011ec6e7$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null
};
const $502b0ac1011ec6e7$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        }
};
const $502b0ac1011ec6e7$var$Store = (0, $iXqE5.createStore)({
    containedBy: $502b0ac1011ec6e7$export$f9abcb6f103965a2,
    initialState: $502b0ac1011ec6e7$var$INITIAL_SCROLL_STATE,
    name: 'ScrollStateManager',
    actions: $502b0ac1011ec6e7$var$actions
});
const $502b0ac1011ec6e7$var$useScrollStateActions = (0, $3sQ5x.createActionsHook)($502b0ac1011ec6e7$var$Store);
const $502b0ac1011ec6e7$export$a2d79f83724ed591 = (0, $3sQ5x.createStateHook)($502b0ac1011ec6e7$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $502b0ac1011ec6e7$export$fae04c81b2201f65 = (0, $3sQ5x.createStateHook)($502b0ac1011ec6e7$var$Store, {
    selector: (state)=>state.scrollElement
});
const $502b0ac1011ec6e7$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $502b0ac1011ec6e7$var$useElementScrollState = (scrollRef)=>{
    const { update: update } = $502b0ac1011ec6e7$var$useScrollStateActions();
    (0, $5uXOq.useEffect)(()=>{
        const targetEl = scrollRef.current;
        // The element should always exists as the useEffect triggers after the reference is assigned.
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            update({
                scrollWidth: targetEl.scrollWidth,
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                isScrolling: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollWidth: targetEl.scrollWidth,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $502b0ac1011ec6e7$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            update({
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                height: targetEl.clientHeight,
                width: targetEl.clientWidth,
                scrollHeight: targetEl.scrollHeight,
                scrollWidth: targetEl.scrollWidth,
                isScrolling: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $502b0ac1011ec6e7$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $502b0ac1011ec6e7$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        update({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef,
        update
    ]);
};
const $502b0ac1011ec6e7$var$ScrollStateProviderInner = ({ scrollRef: scrollRef, children: children })=>{
    $502b0ac1011ec6e7$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $502b0ac1011ec6e7$export$9f9741e7dc6bdb9b = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($502b0ac1011ec6e7$export$f9abcb6f103965a2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($502b0ac1011ec6e7$var$ScrollStateProviderInner, props));
};

});


parcelRegister("8LDbV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d943442fd429320$export$2e2bcd8739ae039);

var $a9Wa8 = parcelRequire("a9Wa8");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cCAQR = parcelRequire("cCAQR");
const $0d943442fd429320$var$IssueCountRenderer = ({ issues: issues, IssueCount: IssueCount = (0, $cCAQR.IssueCount), isNewFooterOrderEnabled: isNewFooterOrderEnabled, isInfiniteScrollEnabled: isInfiniteScrollEnabled })=>{
    const data = (0, $8Uumt.useFragment)((0, $a9Wa8.default), issues);
    const startIssueRange = data.issueNavigatorPageInfo?.firstIssuePosition ?? 0;
    const endIssueRange = data.issueNavigatorPageInfo?.lastIssuePosition ?? 0;
    const loadedIssuesCount = data.edges?.length ?? 0;
    const total = data.totalIssueSearchResultCount ?? 0;
    const countExceedsMaxResults = !!data.isCappingIssueSearchResult;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueCount, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange,
        loadedIssuesCount: loadedIssuesCount,
        total: total,
        countExceedsMaxResults: countExceedsMaxResults,
        isNewFooterOrderEnabled: isNewFooterOrderEnabled,
        isInfiniteScrollEnabled: isInfiniteScrollEnabled
    });
};
var $0d943442fd429320$export$2e2bcd8739ae039 = $0d943442fd429320$var$IssueCountRenderer;

});
parcelRegister("a9Wa8", function(module, exports) {

$parcel$export(module.exports, "default", () => $62299bbf6d8ec30f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<58136de7036b95adc6365cb31a2bfcea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $62299bbf6d8ec30f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_nativeIssueTable_IssueCountRenderer",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "concreteType": "JiraIssueNavigatorPageInfo",
            "kind": "LinkedField",
            "name": "issueNavigatorPageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "firstIssuePosition"
                },
                {
                    "kind": "ScalarField",
                    "name": "lastIssuePosition"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$62299bbf6d8ec30f$var$node.hash = "26c8c81744afeed511fc1eca25e62e4d";
var $62299bbf6d8ec30f$export$2e2bcd8739ae039 = $62299bbf6d8ec30f$var$node;

});

parcelRegister("cCAQR", function(module, exports) {

$parcel$export(module.exports, "IssueCount", () => $1ef5fb316c272957$export$542fba90cc9c1bd1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $k4wwp = parcelRequire("k4wwp");
const $1ef5fb316c272957$export$542fba90cc9c1bd1 = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, loadedIssuesCount: loadedIssuesCount, total: total, countExceedsMaxResults: countExceedsMaxResults, isNewFooterOrderEnabled: isNewFooterOrderEnabled, isInfiniteScrollEnabled: isInfiniteScrollEnabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const totalNumberIssues = countExceedsMaxResults ? `${total}+` : total;
    const isTotalUnknown = total <= 0;
    if (isInfiniteScrollEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ef5fb316c272957$var$IssueCountContainer, {
        "data-testid": "native-issue-table.ui.footer-renderer.issue-count-renderer.issue-count.issue-count",
        isFlexEnd: true
    }, isTotalUnknown ? String(loadedIssuesCount) : formatMessage((0, $k4wwp.default).loadedIssuesTotalKnown, {
        loadedIssuesCount: loadedIssuesCount,
        totalNumberIssues: totalNumberIssues
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ef5fb316c272957$var$IssueCountContainer, {
        "data-testid": "native-issue-table.ui.footer-renderer.issue-count-renderer.issue-count.issue-count",
        isFlexEnd: isNewFooterOrderEnabled
    }, isTotalUnknown ? formatMessage((0, $k4wwp.default).issueRangeUnknown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange
    }) : formatMessage((0, $k4wwp.default).issueRangeKnown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange,
        totalNumberIssues: totalNumberIssues
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ef5fb316c272957$var$IssueCountContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexEnd: isFlexEnd, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _k48p1pd9",
            __cmplp.isFlexEnd ? "_1bahesu3" : "_1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k4wwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca83a55662060500$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ca83a55662060500$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadedIssuesTotalKnown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.loaded-issues-total-known",
        "defaultMessage": "{loadedIssuesCount} of {totalNumberIssues}"
    },
    issueRangeKnown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.issue-range-known",
        "defaultMessage": "{startIssueRange}-{endIssueRange} of {totalNumberIssues}"
    },
    issueRangeUnknown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.issue-range-unknown",
        "defaultMessage": "{startIssueRange}-{endIssueRange}"
    }
});

});



parcelRegister("kNwwG", function(module, exports) {

$parcel$export(module.exports, "IssueCreateFooter", () => $f57c5acea226052f$export$e3ef2bbdafbe53d8);

var $jzBjO = parcelRequire("jzBjO");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $2S8IK = parcelRequire("2S8IK");

var $8wqxH = parcelRequire("8wqxH");

var $5FBML = parcelRequire("5FBML");

var $6s1PB = parcelRequire("6s1PB");

var $35sx5 = parcelRequire("35sx5");

var $e9M6d = parcelRequire("e9M6d");

var $0147U = parcelRequire("0147U");

var $4BEu7 = parcelRequire("4BEu7");
const $f57c5acea226052f$var$FormWithInsertionPoint = ({ connectionId: connectionId, ...props })=>{
    const insertionPoint = (0, $0147U.useCalculateIssueInsertionPoint)();
    let jql;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    jql = (0, $e9M6d.useJql)();
    const handleIssueCreate = (0, $4BEu7.useIssueCreateMutation)({
        issueConnectionId: connectionId,
        jql: jql
    });
    const handleIssueCreateWithInsertionPoint = (0, $5uXOq.useCallback)((issueToCreate, contextualFields)=>{
        if (insertionPoint == null) return handleIssueCreate(issueToCreate, contextualFields);
        return handleIssueCreate(issueToCreate, contextualFields, {
            insertAfter: insertionPoint.position === 'below',
            insertNodeId: insertionPoint.issueId
        });
    }, [
        handleIssueCreate,
        insertionPoint
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f57c5acea226052f$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wqxH.default), {
        onCreateIssue: handleIssueCreateWithInsertionPoint,
        ...props
    }));
};
const $f57c5acea226052f$export$e3ef2bbdafbe53d8 = ({ Footer: Footer = (0, $35sx5.Footer), issues: issues, ...footerProps })=>{
    const issueData = (0, $8Uumt.useFragment)((0, $jzBjO.default), issues);
    const projectContext = (0, $e9M6d.useProjectContext)();
    const { isFormVisible: isFormVisible, formProps: formProps, triggerProps: triggerProps } = (0, $2S8IK.useInlineCreateHandlers)({
        projectKey: projectContext,
        minHierarchyLevel: 0
    });
    if (isFormVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f57c5acea226052f$var$FormWithInsertionPoint, {
        connectionId: issueData?.__id,
        ...formProps,
        appearance: "footer",
        depth: 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, {
        ...footerProps,
        start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $f57c5acea226052f$var$triggerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FBML.default), triggerProps))
    });
};
const $f57c5acea226052f$var$BORDER_WIDTH = '1px';
const $f57c5acea226052f$var$formContainerStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface',
    boxShadow: 'elevation.shadow.overflow',
    borderTopWidth: $f57c5acea226052f$var$BORDER_WIDTH,
    borderTopStyle: 'solid',
    borderTopColor: 'color.border'
});
const $f57c5acea226052f$var$triggerContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    minHeight: '32px'
});

});
parcelRegister("jzBjO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f0aa5a2a538cfcd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<533736002a141e9403872d1ccdba6e32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0f0aa5a2a538cfcd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueCreateFooter_nativeIssueTable",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$0f0aa5a2a538cfcd$var$node.hash = "21882e8690a78f8a13d547c13b7e7a79";
var $0f0aa5a2a538cfcd$export$2e2bcd8739ae039 = $0f0aa5a2a538cfcd$var$node;

});

parcelRegister("2S8IK", function(module, exports) {

$parcel$export(module.exports, "useInlineCreateHandlers", () => $b31c853b0b1937a8$export$bec6eb88acc84895);

var $5uXOq = parcelRequire("5uXOq");

var $47gW9 = parcelRequire("47gW9");

var $7mPT9 = parcelRequire("7mPT9");

var $8wqxH = parcelRequire("8wqxH");

var $fvDFy = parcelRequire("fvDFy");

var $5FBML = parcelRequire("5FBML");
const $b31c853b0b1937a8$export$bec6eb88acc84895 = ({ projectKey: projectKey, minHierarchyLevel: minHierarchyLevel, maxHierarchyLevel: maxHierarchyLevel })=>{
    const [isFormVisible, setIsFormVisible] = (0, $5uXOq.useState)(false);
    const formIssueDraftRef = (0, $5uXOq.useRef)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $fvDFy.useInlineIssueCreateEntryPoint)(projectKey, minHierarchyLevel, maxHierarchyLevel);
    const buttonRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const ref = (0, $5uXOq.useRef)(null);
    const merged = (0, $7mPT9.default)(ref, buttonRef);
    const handleTriggerClick = (0, $5uXOq.useCallback)(()=>{
        setIsFormVisible(true);
    }, []);
    const handleFormCancel = (0, $5uXOq.useCallback)(()=>{
        setIsFormVisible(false);
        ref.current?.focus();
    }, []);
    const onDraftUpdate = (0, $5uXOq.useCallback)((issueDraft)=>{
        formIssueDraftRef.current = issueDraft;
    }, []);
    return {
        isFormVisible: isFormVisible,
        entryPointActions: entryPointActions,
        formProps: {
            initialIssueDraft: formIssueDraftRef.current,
            onDraftUpdate: onDraftUpdate,
            onCancel: handleFormCancel,
            entryPointSubject: entryPointReferenceSubject
        },
        triggerProps: {
            onClick: handleTriggerClick,
            ref: merged
        }
    };
};
const $b31c853b0b1937a8$var$InlineCreate = ({ projectKey: projectKey, minHierarchyLevel: minHierarchyLevel, ...formProps })=>{
    const { isFormVisible: isFormVisible, formProps: formPropsAdditional, triggerProps: triggerProps } = $b31c853b0b1937a8$export$bec6eb88acc84895({
        projectKey: projectKey,
        minHierarchyLevel: minHierarchyLevel
    });
    return isFormVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wqxH.default), {
        ...formProps,
        ...formPropsAdditional
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FBML.default), triggerProps);
};
var $b31c853b0b1937a8$export$2e2bcd8739ae039 = $b31c853b0b1937a8$var$InlineCreate;

});
parcelRegister("8wqxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $25744483df2da317$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $7XluA = parcelRequire("7XluA");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $65VLO = parcelRequire("65VLO");


var $57wcg = parcelRequire("57wcg");

var $jVaWe = parcelRequire("jVaWe");

var $aUncN = parcelRequire("aUncN");

var $i6vYW = parcelRequire("i6vYW");

const $25744483df2da317$var$ICON_WIDTH = 24;
const $25744483df2da317$var$PADDING = 8;
const $25744483df2da317$export$35cad9398ceaeef0 = ()=>{
    const isReadyRef = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        setTimeout(()=>{
            isReadyRef.current = true;
        }, 100);
    }, []);
    return isReadyRef;
};
const $25744483df2da317$var$isComposing = (event)=>event.nativeEvent.isComposing;
const $25744483df2da317$export$848553d86b9bee59 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVaWe.IssueTypeDropdown), {
        project: null,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onProjectChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        selectedType: null
    });
const $25744483df2da317$var$InlineCreateForm = ({ initialIssueDraft: initialIssueDraft, onDraftUpdate: onDraftUpdate, onCreateIssue: onCreateIssue, onCancel: onCancel, entryPointSubject: entryPointSubject, appearance: appearance = 'row', depth: depth = 0, columns: columns })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [textContent, setTextContent] = (0, $5uXOq.useState)(initialIssueDraft?.summary ?? '');
    const [selectedType, setSelectedType] = (0, $5uXOq.useState)(initialIssueDraft?.issueType ?? null);
    const [selectedProject, setSelectedProject] = (0, $5uXOq.useState)(initialIssueDraft?.project ?? null);
    (0, $5uXOq.useEffect)(()=>{
        onDraftUpdate?.({
            summary: textContent,
            project: selectedProject ?? undefined,
            issueType: selectedType ?? undefined
        });
    }, [
        onDraftUpdate,
        selectedProject,
        selectedType,
        textContent
    ]);
    const formRef = (0, $5uXOq.useRef)(null);
    const isEmptyRef = (0, $5uXOq.useRef)(true);
    const textAreaRef = (0, $5uXOq.useRef)(null);
    isEmptyRef.current = textContent.trim().length === 0;
    const contextualFields = (0, $57wcg.useIssueCreateContextualFields)(); // prevent blurring from occurring when the form is first rendered
    const isReadyRef = $25744483df2da317$export$35cad9398ceaeef0();
    const handleCreateIssue = (0, $5uXOq.useCallback)(()=>{
        if (!isEmptyRef.current && selectedType && selectedProject) {
            onCreateIssue({
                summary: textContent,
                project: selectedProject,
                issueType: selectedType
            }, contextualFields);
            setTextContent('');
        }
    }, [
        contextualFields,
        onCreateIssue,
        selectedProject,
        selectedType,
        textContent
    ]);
    const handleCreateIssueRef = (0, $5uXOq.useRef)(handleCreateIssue);
    handleCreateIssueRef.current = handleCreateIssue;
    const handleBlur = (0, $5uXOq.useCallback)((event)=>{
        if (!isReadyRef.current) return;
         // make sure to make a local copy of the isEmptyRef value before it gets reset by the create handler
        const formEmpty = isEmptyRef.current; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const inForm = formRef.current?.contains(event.target) ?? false;
        if (!inForm) {
            onCancel?.();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                formEmpty: formEmpty,
                escapeKeyPressed: false
            });
        }
    }, [
        isReadyRef,
        onCancel,
        createAnalyticsEvent
    ]);
    const handleChange = (0, $5uXOq.useCallback)((e)=>{
        const content = e.target.value.replace(/[\n\r]+/g, ' ');
        setTextContent(content);
    }, []);
    const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (e.key === 'Enter' && !$25744483df2da317$var$isComposing(e)) {
            e.preventDefault();
            handleCreateIssue();
        }
    }, [
        handleCreateIssue
    ]);
    const handleFormKeyDown = (0, $5uXOq.useCallback)((e)=>{
        e.stopPropagation();
    }, []);
    const handleSubmit = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        handleCreateIssue();
    }, [
        handleCreateIssue
    ]);
    const handleCreateButtonClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineCreateSubmit');
    }, [
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // on mount, we want to move the cursor to the end of the input
        // TODO; Add test for this feature once we support pre-population of the summary
        textAreaRef.current?.setSelectionRange(textAreaRef.current.value.length, textAreaRef.current.value.length);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'form focused', 'inlineCreate');
    }, [
        createAnalyticsEvent
    ]);
    const handleEscape = (0, $5uXOq.useCallback)((e)=>{
        e.stopPropagation();
        if (e.key === 'Escape') {
            onCancel?.();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                formEmpty: isEmptyRef.current,
                escapeKeyPressed: true
            });
        }
        if (e.key === 'Enter') {
            e.preventDefault();
            handleCreateIssue();
        }
    }, [
        createAnalyticsEvent,
        handleCreateIssue,
        onCancel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!false) {
            document.addEventListener('click', handleBlur, true);
            document.addEventListener('keydown', handleEscape, true);
            return ()=>{
                document.removeEventListener('click', handleBlur, true);
                document.removeEventListener('keydown', handleEscape, true);
            };
        }
    }, [
        handleBlur,
        handleEscape
    ]);
    let paddingLeft = depth > 1 ? (depth - 1) * $25744483df2da317$var$ICON_WIDTH + $25744483df2da317$var$PADDING : $25744483df2da317$var$PADDING;
    const mergedColumn = (0, $4R6GH.fg)('jira_list_merged_column_gate') ? columns?.find(({ id: id })=>id === (0, $65VLO.COLUMN_ID_MERGED_COLUMN)) : undefined;
    if (mergedColumn) {
        const checkboxColumnWidth = columns?.find(({ id: id })=>id === (0, $65VLO.COLUMN_ID_CHECKBOX))?.defaultWidth ?? 0;
        const hasMergedFields = Number(mergedColumn.mergedColumns?.length) > 0;
        paddingLeft += (hasMergedFields ? $25744483df2da317$var$ICON_WIDTH : 0) + checkboxColumnWidth - $25744483df2da317$var$PADDING / 2;
    }
    return(// TODO: Check if we can catch the escape in a different level that removes below lint rule
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25744483df2da317$var$FullContent, {
        ref: formRef,
        onKeyDown: handleFormKeyDown,
        onSubmit: handleSubmit,
        appearance: appearance,
        paddingLeft: paddingLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointSubject,
        id: "async-issue-create-issue-type-dropdown",
        packageName: (0, $d4f18e56d7667f0b$export$b8b9d90f9e5bd72b),
        teamName: (0, $d4f18e56d7667f0b$export$d57b6b390e78d90f),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25744483df2da317$export$848553d86b9bee59, null),
        runtimeProps: {
            onChange: setSelectedType,
            onProjectChange: setSelectedProject,
            selectedType: selectedType
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $25744483df2da317$var$TextAreaStyles,
        as: "textarea",
        autoFocus: true,
        "aria-label": formatMessage((0, $aUncN.default).placeholderText),
        placeholder: formatMessage((0, $aUncN.default).placeholderText),
        value: textContent,
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        ref: textAreaRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        alignItems: "center",
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25744483df2da317$var$StyledCreateButton, {
        appearance: "primary",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6vYW.default), null),
        isDisabled: isEmptyRef.current,
        spacing: "compact",
        type: "submit",
        onClick: handleCreateButtonClick
    }, formatMessage((0, $aUncN.default).createButton)))));
};
const $25744483df2da317$var$InlineCreateFormWithContainer = ({ contextualFields: contextualFields, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "issue-table-inline-issue-create"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57wcg.IssueCreateContextualFieldsData), {
        payload: contextualFields
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25744483df2da317$var$InlineCreateForm, props)));
var $25744483df2da317$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($25744483df2da317$var$InlineCreateFormWithContainer);
const $25744483df2da317$var$FullContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { paddingLeft: paddingLeft, appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_to5f02": (0, $lD23V.default)(`${__cmplp.paddingLeft}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _v56416gf _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _bfhkvuon _16qs1yp9 _vchhusvi _1tke1ylp _2lx2vrvc _4cvr1h6o _4t3i1ylp _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvedk6",
            __cmplp.appearance === 'footer' ? "_mrkbpd34 _1o0zpd34" : "_2rkoiti9",
            __cmplp.className
        ])
    });
});
const $25744483df2da317$var$TextAreaStyles = (0, $8CUq3.xcss)({
    flex: '1',
    border: 'none',
    outline: 'none',
    margin: '0',
    padding: 'space.050',
    height: '20px',
    resize: 'none',
    backgroundColor: 'elevation.surface',
    color: 'color.text',
    font: 'font.body',
    scrollbarWidth: 'none',
    whiteSpace: 'pre',
    boxSizing: 'content-box',
    fontFamily: 'inherit'
}); // TODO: Maybe we can rewrite to pressable....
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $25744483df2da317$var$StyledCreateButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});
const $d4f18e56d7667f0b$export$b8b9d90f9e5bd72b = 'jiraIssueTableInlineIssueCreate';
const $d4f18e56d7667f0b$export$d57b6b390e78d90f = 'empanada';
const $d4f18e56d7667f0b$export$e77c67bc8157f49 = 'jsc_onboarding_inline_create';
const $d4f18e56d7667f0b$export$c7e6a6b283196232 = '/gateway/api';

parcelRegister("57wcg", function(module, exports) {

$parcel$export(module.exports, "IssueCreateContextualFieldsData", () => $979782d15f06404c$export$a4ac6f56634f61f4);
$parcel$export(module.exports, "useIssueCreateContextualFields", () => $979782d15f06404c$export$6bb8d4e3be0700f9);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $979782d15f06404c$var$initialState = {};
const $979782d15f06404c$var$Store = (0, $iXqE5.createStore)({
    initialState: $979782d15f06404c$var$initialState,
    actions: {}
});
const $979782d15f06404c$var$updateStore = ()=>({ setState: setState }, { payload: payload })=>setState(payload);
const $979782d15f06404c$var$Container = (0, $gg7kZ.createContainer)($979782d15f06404c$var$Store, {
    onInit: $979782d15f06404c$var$updateStore,
    onUpdate: $979782d15f06404c$var$updateStore
});
const $979782d15f06404c$export$a4ac6f56634f61f4 = ({ children: children, payload: payload })=>{
    const ancestorPayload = $979782d15f06404c$export$6bb8d4e3be0700f9();
    const nextPayload = (0, $5uXOq.useMemo)(()=>({
            ...ancestorPayload,
            ...payload
        }), [
        ancestorPayload,
        payload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($979782d15f06404c$var$Container, {
        payload: nextPayload
    }, children);
};
const $979782d15f06404c$export$6bb8d4e3be0700f9 = (0, $3sQ5x.createStateHook)($979782d15f06404c$var$Store);

});

parcelRegister("jVaWe", function(module, exports) {

$parcel$export(module.exports, "IssueTypeDropdown", () => $e801731cc35f8247$export$16aea7aa4bac227f);
$parcel$export(module.exports, "IssueTypeDropdownEntryPoint", () => $e801731cc35f8247$export$7b1e666ab7e366e1);

var $hBruS = parcelRequire("hBruS");

var $9Lv2a = parcelRequire("9Lv2a");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $5kElh = parcelRequire("5kElh");

var $iRKAP = parcelRequire("iRKAP");

var $4R6GH = parcelRequire("4R6GH");

var $cmfPH = parcelRequire("cmfPH");

var $8gdZO = parcelRequire("8gdZO");
const $e801731cc35f8247$var$createIssueTypeOption = (id, name, avatar)=>({
        label: name,
        value: id,
        avatar: {
            small: avatar
        }
    });
const $e801731cc35f8247$var$createIssueType = (id, issueTypeId, name, avatar, hierarchyLevel)=>({
        id: id,
        issueTypeId: issueTypeId,
        name: name,
        avatar: {
            small: avatar
        },
        ...typeof hierarchyLevel === 'number' ? {
            hierarchy: {
                level: hierarchyLevel
            }
        } : {}
    });
const $e801731cc35f8247$export$16aea7aa4bac227f = ({ onChange: onChange, onProjectChange: onProjectChange, project: project, selectedType: selectedType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isPristine = (0, $5uXOq.useRef)(true);
    // TODO; JSC-36  We need to integrate hierarchy level filter once JSC-59 is implemented
    const { data: data, refetch: refetch } = (0, $8Uumt.usePaginationFragment)((0, $9Lv2a.default), project);
    const [defaultIssueTypeId, { setDefaultIssueType: setDefaultIssueType }] = (0, $cmfPH.useDefaultIssueType)(data?.key ?? null);
    const selectedTypeOption = (0, $5uXOq.useMemo)(()=>{
        if (selectedType == null) return null;
        return $e801731cc35f8247$var$createIssueTypeOption(selectedType.id, selectedType.name, selectedType.avatar?.small);
    }, [
        selectedType
    ]);
    const handleGetRefetchVariables = (0, $5uXOq.useCallback)(()=>({
            id: data?.id || ''
        }), [
        data?.id
    ]);
    const handleIssueTypeChange = (0, $5uXOq.useCallback)((typeOption)=>{
        let newIssueType = null;
        if (typeOption != null) {
            const issueType = (data?.issueTypes?.edges || []).find((edge)=>edge?.node?.id === typeOption.value);
            if (issueType?.node != null && issueType.node.issueTypeId != null) newIssueType = $e801731cc35f8247$var$createIssueType(issueType.node.id, issueType.node.issueTypeId, issueType.node.name, issueType.node.avatar?.small, issueType.node.hierarchy?.level);
        }
        isPristine.current = false;
        onChange(newIssueType);
        if (newIssueType?.issueTypeId) setDefaultIssueType(data?.key ?? null, newIssueType?.issueTypeId);
    }, [
        data?.issueTypes?.edges,
        data?.key,
        onChange,
        setDefaultIssueType
    ]);
    // Initialize with the first default issue
    (0, $5uXOq.useEffect)(()=>{
        if (isPristine.current) {
            const defaultIssueTypeEdge = (data?.issueTypes?.edges || []).find((edge)=>edge?.node?.issueTypeId === defaultIssueTypeId);
            if (defaultIssueTypeEdge?.node != null && defaultIssueTypeEdge.node.issueTypeId != null) // Return default issue type if exists
            return onChange($e801731cc35f8247$var$createIssueType(defaultIssueTypeEdge.node.id, defaultIssueTypeEdge.node.issueTypeId, defaultIssueTypeEdge.node.name, defaultIssueTypeEdge.node.avatar?.small, defaultIssueTypeEdge.node.hierarchy?.level));
            const firstIssue = data?.issueTypes?.edges?.[0];
            if (firstIssue?.node != null && firstIssue.node.issueTypeId != null) // Return first issue type in the connection
            return onChange($e801731cc35f8247$var$createIssueType(firstIssue.node.id, firstIssue.node.issueTypeId, firstIssue.node.name, firstIssue.node.avatar?.small, firstIssue.node.hierarchy?.level));
        }
    }, [
        data?.issueTypes?.edges,
        defaultIssueTypeId,
        onChange
    ]);
    const prevProjectKey = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (data?.id != null && prevProjectKey.current !== data?.id && data.projectId != null) {
            onProjectChange({
                id: data.id,
                projectId: data.projectId,
                key: data.key,
                name: data.name,
                avatar: data.avatar ? {
                    large: data.avatar.large
                } : null
            });
            prevProjectKey.current = data?.id;
        }
    }, [
        data?.avatar,
        data?.id,
        data?.key,
        data?.name,
        data?.projectId,
        onProjectChange
    ]);
    // TODO: JSC-71 We need to updated below component styles to adapt more to JWM current design
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5kElh.IssueTypeEditViewWithIssueTypeConnection), {
        issueTypesFragmentRef: data?.issueTypes ?? null,
        menuPosition: "fixed",
        menuPlacement: "top",
        onChange: handleIssueTypeChange,
        onRefetch: refetch,
        onGetRefetchVariables: handleGetRefetchVariables,
        refetchQuery: (0, $iRKAP.default),
        value: selectedTypeOption,
        spacing: "compact",
        stopPropagationOfMenuEscape: true,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $8gdZO.default).labelIssueTerminologyRefreshM4 : (0, $8gdZO.default).label),
        iconsOnly: true,
        appearance: "subtle",
        isSearchable: !(0, $4R6GH.fg)('fix_icc_type_select_being_searchable')
    });
};
const $e801731cc35f8247$export$7b1e666ab7e366e1 = ({ queries: { projectData: projectData }, props: props })=>{
    const data = (0, $8Uumt.usePreloadedQuery)((0, $hBruS.default), projectData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e801731cc35f8247$export$16aea7aa4bac227f, {
        ...props,
        project: data.jira.jiraProjectByKey ?? null
    });
};
var $e801731cc35f8247$export$2e2bcd8739ae039 = $e801731cc35f8247$export$16aea7aa4bac227f;

});
parcelRegister("hBruS", function(module, exports) {

$parcel$export(module.exports, "default", () => $861423fac2cb61eb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ab7f0858672cb82645a3396e11f8fe0>>
 * @relayHash 0d9abbece612cf0b39d1b506df6ac887
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 88cc5b35279fc932bb73f89b79d29c75908b5950ef5010942a12dc207bfe4268
const $861423fac2cb61eb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasProjectKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v5 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = [
        v5 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTypeDropdownIssueType_projectDataQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "hasProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProjectByKey",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "kind": "FragmentSpread",
                                                    "name": "issueTypeDropdown_issueTableInlineIssueCreate"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraProjectByKey"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueTypeDropdownIssueType_projectDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "hasProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "large"
                                                }
                                            ]
                                        },
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "JiraIssueTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "issueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeId"
                                                                },
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "small"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                    "kind": "LinkedField",
                                                                    "name": "hierarchy",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "level"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "alias": "value",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v8 /*: any*/ ,
                                            "filters": [
                                                "filter"
                                            ],
                                            "handle": "connection",
                                            "key": "inlineIssueCreate_IssueTable_issueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "issueTypes"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "88cc5b35279fc932bb73f89b79d29c75908b5950ef5010942a12dc207bfe4268",
            "metadata": {},
            "name": "issueTypeDropdownIssueType_projectDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$861423fac2cb61eb$var$node.hash = "30a657670a87487d2fd2c30abf17ebc7";
var $861423fac2cb61eb$export$2e2bcd8739ae039 = $861423fac2cb61eb$var$node;

});

parcelRegister("9Lv2a", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbda29a23c4d2157$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e511847ce4b6e983a0b805f6c7186ccc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $iRKAP = parcelRequire("iRKAP");
const $dbda29a23c4d2157$var$node = function() {
    var v0 = [
        "issueTypes"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filter"
            },
            {
                "defaultValue": 10,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "cursor"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $iRKAP.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "issueTypeDropdown_issueTableInlineIssueCreate",
        "selections": [
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "projectId"
            },
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v2 /*: any*/ ,
            {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "large"
                    }
                ]
            },
            {
                "alias": "issueTypes",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "filter",
                        "variableName": "filter"
                    }
                ],
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "__inlineIssueCreate_IssueTable_issueTypes_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "issueTypeId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "concreteType": "JiraAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "small"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueTypeHierarchyLevel",
                                        "kind": "LinkedField",
                                        "name": "hierarchy",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "level"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$dbda29a23c4d2157$var$node.hash = "404aea827078dfb362c35ecb15dd8d3b";
var $dbda29a23c4d2157$export$2e2bcd8739ae039 = $dbda29a23c4d2157$var$node;

});
parcelRegister("iRKAP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7789b290155d167$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3ffc8c4257de96b52bfeb3d2dc90fc9b>>
 * @relayHash 7eefb6eeec213554db3d9a71ab4a3bb5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4208f182e24c74b313733c6747a0ff72e0249a271aadc573f28bb0de60cf2b96
const $e7789b290155d167$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cursor"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        },
        {
            "defaultValue": 10,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cursor",
                                    "variableName": "cursor"
                                },
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "issueTypeDropdown_issueTableInlineIssueCreate"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueTypeId"
                                                        },
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "level"
                                                                }
                                                            ]
                                                        },
                                                        v4 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "filters": [
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "inlineIssueCreate_IssueTable_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ],
                            "type": "JiraProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4208f182e24c74b313733c6747a0ff72e0249a271aadc573f28bb0de60cf2b96",
            "metadata": {},
            "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e7789b290155d167$var$node.hash = "404aea827078dfb362c35ecb15dd8d3b";
var $e7789b290155d167$export$2e2bcd8739ae039 = $e7789b290155d167$var$node;

});


parcelRegister("5kElh", function(module, exports) {

$parcel$export(module.exports, "IssueTypeEditViewWithIssueTypeConnection", () => $c1683ad428fba5d5$export$139e4bfeb055992c);
$parcel$export(module.exports, "IssueTypeEditView", () => $c1683ad428fba5d5$export$83fe9ca9fdf41761);

var $areLc = parcelRequire("areLc");

var $6OxRO = parcelRequire("6OxRO");

var $6xx4Y = parcelRequire("6xx4Y");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");

var $4R6GH = parcelRequire("4R6GH");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $cYlTx = parcelRequire("cYlTx");

var $3BhEA = parcelRequire("3BhEA");

var $lElIo = parcelRequire("lElIo");

var $1othz = parcelRequire("1othz");

var $jDrwg = parcelRequire("jDrwg");

var $hhhG0 = parcelRequire("hhhG0");

var $bV4zb = parcelRequire("bV4zb");
const $c1683ad428fba5d5$var$iconOnlySelectStyles = {
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $gwIPs.layers).modal
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, $gwIPs.layers).modal,
            minWidth: '120px',
            maxWidth: '440px',
            width: 'auto',
            overflowY: 'auto'
        }),
    control: (base)=>({
            ...base,
            '&:hover': {
                borderColor: 'transparent'
            }
        })
};
const $c1683ad428fba5d5$var$iconOnlySelectStylesOld = {
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $gwIPs.layers).modal
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, $gwIPs.layers).modal,
            minWidth: '120px',
            maxWidth: '440px',
            width: 'auto',
            overflowY: 'auto'
        })
};
const $c1683ad428fba5d5$export$6a277fd8285f68cf = ({ queryFragmentRef: queryFragmentRef, fieldId: fieldId, filterOptionsById: filterOptionsById = null, ...props })=>{
    const { data: issueTypesSearchData, refetch: refetchSuggestions } = (0, $8Uumt.usePaginationFragment)((0, $6xx4Y.default), queryFragmentRef);
    const onGetRefetchVariables = (0, $5uXOq.useCallback)((searchBy)=>({
            id: fieldId,
            searchBy: searchBy,
            filterById: filterOptionsById
        }), [
        fieldId,
        filterOptionsById
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1683ad428fba5d5$export$139e4bfeb055992c, {
        ...props,
        issueTypesFragmentRef: issueTypesSearchData.node?.issueTypes ?? null,
        onGetRefetchVariables: onGetRefetchVariables,
        refetchQuery: (0, $hhhG0.default),
        onRefetch: refetchSuggestions
    });
};
const $c1683ad428fba5d5$export$139e4bfeb055992c = ({ autoFocus: autoFocus = false, issueTypesFragmentRef: issueTypesFragmentRef, onChange: onChange, onGetRefetchVariables: onGetRefetchVariables, value: value, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, isInvalid: isInvalid, isDisabled: isDisabled = false, inputId: inputId, menuPosition: menuPosition, menuPlacement: menuPlacement, refetchQuery: refetchQuery, onRefetch: onRefetch, openMenuOnFocus: openMenuOnFocus, spacing: spacing, stopPropagationOfMenuEscape: stopPropagationOfMenuEscape, iconsOnly: iconsOnly = false, appearance: appearance = 'default', isSearchable: isSearchable = true })=>{
    const [menuIsOpen, setMenuIsOpen] = (0, $5uXOq.useState)(autoFocus);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>noOptionsMessage ?? formatMessage((0, $bV4zb.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $5uXOq.useCallback)(()=>loadingMessage ?? formatMessage((0, $bV4zb.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const placeholderMessage = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $bV4zb.default).placeholderIssueTerminologyRefreshM4 : (0, $bV4zb.default).placeholder);
    let selectStyles;
    if (iconsOnly) {
        if ((0, $4R6GH.fg)('jsc-828_remove_outline_in_hover_state')) selectStyles = $c1683ad428fba5d5$var$iconOnlySelectStyles;
        else // default icon‐only styling
        selectStyles = $c1683ad428fba5d5$var$iconOnlySelectStylesOld;
    } else selectStyles = (0, $lElIo.defaultSelectStyles);
     // #region Relay
    // suggestions fragment with pagination and refetch
    const data = (0, $8Uumt.useFragment)((0, $6OxRO.default), issueTypesFragmentRef); // #endregion
    // #region Common state (might be handy for other components)
    const [searchByString, setSearchByString] = (0, $5uXOq.useState)(''); // #endregion
    // #region Debounced suspensless refetch helpers
    const [searchSuspenselessRefetch, isLoading, lastFetchError] = (0, $1othz.useSuspenselessRefetch)(refetchQuery, onRefetch);
    const [searchDebouncedSuspenselessRefetch] = (0, $jDrwg.default)(searchSuspenselessRefetch, (0, $cYlTx.SEARCH_DEBOUNCE_TIMEOUT));
    (0, $5uXOq.useEffect)(()=>{
        if (autoFocus) searchSuspenselessRefetch(onGetRefetchVariables(searchByString));
    }, [
        searchSuspenselessRefetch,
        autoFocus,
        searchByString,
        onGetRefetchVariables
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (stopPropagationOfMenuEscape && menuIsOpen && e.key === 'Escape') e.stopPropagation();
    }, [
        menuIsOpen,
        stopPropagationOfMenuEscape
    ]); // #region Common callbacks for the selector
    const openMenu = ()=>setMenuIsOpen(true);
    const closeMenu = ()=>setMenuIsOpen(false);
    const onSelectFocus = (0, $5uXOq.useCallback)(()=>{
        searchSuspenselessRefetch(onGetRefetchVariables(searchByString));
    }, [
        searchSuspenselessRefetch,
        searchByString,
        onGetRefetchVariables
    ]);
    const onSearchByStringChangeFunction = (0, $5uXOq.useCallback)((newSearchByString)=>{
        setSearchByString(newSearchByString);
        searchDebouncedSuspenselessRefetch(onGetRefetchVariables(newSearchByString || ''));
    }, [
        onGetRefetchVariables,
        searchDebouncedSuspenselessRefetch
    ]); // #endregion
    // #region Transform options data from relay to AK Select
    const defaultFailedOption = (0, $5uXOq.useMemo)(()=>({
            label: formatMessage((0, $bV4zb.default).failedFetch),
            value: '',
            avatar: {
                small: ''
            },
            isDisabled: true
        }), [
        formatMessage
    ]);
    const renderIconOnlyOption = (option, formatOptionLabelMeta)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1683ad428fba5d5$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: $c1683ad428fba5d5$var$inlineIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
            src: option.avatar?.small || '',
            alt: option.label,
            width: 2 * (0, $gwIPs.gridSize),
            height: 2 * (0, $gwIPs.gridSize)
        })), formatOptionLabelMeta.context !== 'value' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, option.label));
    const renderIconWithTextOption = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1683ad428fba5d5$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1683ad428fba5d5$var$ImgSpan, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
            src: option.avatar?.small || '',
            alt: option.label,
            width: 2 * (0, $gwIPs.gridSize),
            height: 2 * (0, $gwIPs.gridSize)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, option.label));
    const selectFieldOptions = (0, $5uXOq.useMemo)(()=>{
        // checks for query errors
        if (lastFetchError != null) return [
            defaultFailedOption
        ];
        return data?.edges?.map((edge)=>edge?.node).filter(Boolean).map(({ label: optionLabel, value: optionValue, avatar: avatar })=>({
                label: optionLabel ?? '',
                value: optionValue,
                avatar: avatar
            })) ?? [];
    }, [
        lastFetchError,
        data,
        defaultFailedOption
    ]); // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        "aria-label": formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $bV4zb.default).labelIssueTerminologyRefreshM4 : (0, $bV4zb.default).label),
        formatOptionLabel: iconsOnly ? renderIconOnlyOption : renderIconWithTextOption,
        styles: selectStyles,
        value: value,
        options: selectFieldOptions,
        menuIsOpen: menuIsOpen,
        placeholder: placeholderMessage,
        noOptionsMessage: getNoOptionsMessage,
        loadingMessage: getLoadingMessage,
        filterOption: (0, $3BhEA.filterOptionByLabelAndFilterValues),
        onInputChange: onSearchByStringChangeFunction,
        onChange: onChange,
        openMenuOnFocus: openMenuOnFocus,
        onFocus: onSelectFocus,
        onKeyDown: onKeyDown,
        autoFocus: autoFocus,
        isInvalid: isInvalid,
        isDisabled: isDisabled,
        isLoading: isLoading && menuIsOpen,
        inputId: inputId,
        menuPosition: menuPosition,
        menuPlacement: menuPlacement,
        onMenuOpen: openMenu,
        onMenuClose: closeMenu,
        spacing: spacing,
        appearance: appearance,
        isSearchable: isSearchable
    });
};
const $c1683ad428fba5d5$export$83fe9ca9fdf41761 = (props)=>{
    const suggestionsData = (0, $8Uumt.useLazyLoadQuery)((0, $areLc.default), {
        id: props.fieldId,
        filterById: props.filterOptionsById
    }, {
        fetchPolicy: 'store-only'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1683ad428fba5d5$export$6a277fd8285f68cf, {
        ...props,
        queryFragmentRef: suggestionsData
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c1683ad428fba5d5$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c1683ad428fba5d5$var$ImgSpan = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $c1683ad428fba5d5$var$inlineIconStyle = (0, $8CUq3.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("areLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3178ee55c3237d44$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfa9b261ee662a6f57fc80f1429c11c9>>
 * @relayHash 29e5738373d98b44824fad02a3d3cd14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e50d5efb3e493597a605e3f7eb0d92c3151c4aaeb3ec7b9f8a450d447af2ab54
const $3178ee55c3237d44$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v4 = {
        "kind": "Literal",
        "name": "searchBy",
        "value": ""
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        v4 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueType_issueTypeSearchQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueType_issueTypeSearchQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "issueType_issueFieldIssueTypeEditviewFull_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "e50d5efb3e493597a605e3f7eb0d92c3151c4aaeb3ec7b9f8a450d447af2ab54",
            "metadata": {},
            "name": "issueType_issueTypeSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3178ee55c3237d44$var$node.hash = "a9ae551cfa917838f44cb5ad82166383";
var $3178ee55c3237d44$export$2e2bcd8739ae039 = $3178ee55c3237d44$var$node;

});

parcelRegister("6OxRO", function(module, exports) {

$parcel$export(module.exports, "default", () => $daab18275404f05e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e0227129a9b0594353e8c68d9a88930>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $daab18275404f05e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef",
    "selections": [
        {
            "concreteType": "JiraIssueTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "value",
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "alias": "label",
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "small"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueTypeConnection"
};
$daab18275404f05e$var$node.hash = "a3043f504a0b36b603fb3665ac2ae823";
var $daab18275404f05e$export$2e2bcd8739ae039 = $daab18275404f05e$var$node;

});

parcelRegister("6xx4Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a47cd84d350b08$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92d1e3360b2d69683e70b781460fce34>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $hhhG0 = parcelRequire("hhhG0");
const $47a47cd84d350b08$var$node = function() {
    var v0 = [
        "node",
        "issueTypes"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filterById"
            },
            {
                "defaultValue": 1000,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "id"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "searchBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $hhhG0.default)
            }
        },
        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "id"
                    }
                ],
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": "issueTypes",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterById",
                                        "variableName": "filterById"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "searchBy",
                                        "variableName": "searchBy"
                                    }
                                ],
                                "concreteType": "JiraIssueTypeConnection",
                                "kind": "LinkedField",
                                "name": "__issueType_issueFieldIssueTypeEditviewFull_issueTypes_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueTypeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef"
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraIssueTypeField"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$47a47cd84d350b08$var$node.hash = "54c04d4f507b644a10ef1cc8b3c0fc09";
var $47a47cd84d350b08$export$2e2bcd8739ae039 = $47a47cd84d350b08$var$node;

});
parcelRegister("hhhG0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea4ede4723c2b4a1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2fb7462fc58470e5f932ba5f158f8a16>>
 * @relayHash 53b193ba86b71b4b505947ef99d7bce3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ddf0f50c9d8d9f30aa48671b2fc60b8934c2cf6d1edc9897ed54f296df319cd4
const $ea4ede4723c2b4a1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        },
        {
            "defaultValue": 1000,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "searchBy"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v5 = {
        "kind": "Variable",
        "name": "searchBy",
        "variableName": "searchBy"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueType_SearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueType_SearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "issueType_issueFieldIssueTypeEditviewFull_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "ddf0f50c9d8d9f30aa48671b2fc60b8934c2cf6d1edc9897ed54f296df319cd4",
            "metadata": {},
            "name": "issueType_SearchRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ea4ede4723c2b4a1$var$node.hash = "54c04d4f507b644a10ef1cc8b3c0fc09";
var $ea4ede4723c2b4a1$export$2e2bcd8739ae039 = $ea4ede4723c2b4a1$var$node;

});


parcelRegister("cYlTx", function(module, exports) {

$parcel$export(module.exports, "FRAGMENT_FIELD_OPTIONS_FIRST", () => $2d3c7e7d3e90274a$export$971747fe11f2a6f4);
$parcel$export(module.exports, "FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST", () => $2d3c7e7d3e90274a$export$1a6463c5895cff9e);
$parcel$export(module.exports, "SELECTABLE_FIELD_PAGE_OPTIONS", () => $2d3c7e7d3e90274a$export$d1beabd8dceb4469);
$parcel$export(module.exports, "MULTI_VERSIONS_FIELD_OPTIONS_FETCH_FIRST", () => $2d3c7e7d3e90274a$export$176e9e0c749f88b2);
$parcel$export(module.exports, "SEARCH_DEBOUNCE_TIMEOUT", () => $2d3c7e7d3e90274a$export$228cc37ca8dce73);
$parcel$export(module.exports, "versionStatus", () => $2d3c7e7d3e90274a$export$7fc41a408a0533d3);
/**
 * This will be used to set the default value for the number of options
 * to be fetched in the first request for the field options.
 */ const $2d3c7e7d3e90274a$export$971747fe11f2a6f4 = 100;
const $2d3c7e7d3e90274a$export$1a6463c5895cff9e = 55;
const $2d3c7e7d3e90274a$export$d1beabd8dceb4469 = 50;
const $2d3c7e7d3e90274a$export$176e9e0c749f88b2 = 1000;
const $2d3c7e7d3e90274a$export$228cc37ca8dce73 = 300;
const $2d3c7e7d3e90274a$export$b983f2cb1f658a55 = 'RELEASED';
const $2d3c7e7d3e90274a$export$cb459d726a8530a5 = 'UNRELEASED';
const $2d3c7e7d3e90274a$export$c936349447a77fe0 = 'ARCHIVED';
const $2d3c7e7d3e90274a$export$7fc41a408a0533d3 = {
    RELEASED: $2d3c7e7d3e90274a$export$b983f2cb1f658a55,
    UNRELEASED: $2d3c7e7d3e90274a$export$cb459d726a8530a5,
    ARCHIVED: $2d3c7e7d3e90274a$export$c936349447a77fe0
};

});

parcelRegister("3BhEA", function(module, exports) {

$parcel$export(module.exports, "filterOptionByLabelAndFilterValues", () => $0eb6c4d40c779509$export$58bb91b619b113f6);

var $8QpSo = parcelRequire("8QpSo");

var $5JAlL = parcelRequire("5JAlL");
const $0eb6c4d40c779509$export$d3e698d53f63efcd = (val, inputValueIgnoredCase)=>// label can be Object for new option in CreatableSelect
    typeof val === 'string' && val// no need to .trim() since input is already trimmed and we search for .includes() so it does not matter if field has leading or trailing spaces
    .toLowerCase().includes(inputValueIgnoredCase);
const $0eb6c4d40c779509$var$stringifyLabelAndDataFilterValues = (option)=>{
    const { label: label, data: data } = option || {};
    const { filterValues: filterValues } = data || {};
    const labelString = typeof label === 'string' ? label : '';
    const filterValuesString = (filterValues || []).join(' ');
    return `${labelString} ${filterValuesString}`;
};
/**
 * By default react-select matches by both option.label and option.value: https://github.com/JedWatson/react-select/blob/b7868d23ccd0b9e623b277f971e89020d426fbdb/packages/react-select/src/filters.js#L14.
 * This leads to undesired UX, when filter result includes options without displayed text matching the query (which is very confusing for the user): BENTO-5735, BENTO-5655.
 * That's why we need this function.
 */ const $0eb6c4d40c779509$var$filterOptionByLabelAndFilterValuesInternal = (0, $8QpSo.default)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $5JAlL.createFilter)({
        // Take an option object and convert it to a string that needs to partially match the user's query
        stringify: $0eb6c4d40c779509$var$stringifyLabelAndDataFilterValues
    }));
const $0eb6c4d40c779509$export$58bb91b619b113f6 = (option, inputValue)=>$0eb6c4d40c779509$var$filterOptionByLabelAndFilterValuesInternal()(option, inputValue);

});

parcelRegister("1othz", function(module, exports) {

$parcel$export(module.exports, "useSuspenselessRefetchStateless", () => $7714fce489d6815b$export$ae1adabf094b2244);
$parcel$export(module.exports, "useSuspenselessRefetch", () => $7714fce489d6815b$export$c7ce5f64dc007896);
// eslint-disable-next-line jira/restricted/react-18

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $biQrn = parcelRequire("biQrn");

var $4R6GH = parcelRequire("4R6GH");

var $c1haS = parcelRequire("c1haS");
const $7714fce489d6815b$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
    const inFlightRequestsRef = (0, $5uXOq.useRef)([]);
    return (0, $5uXOq.useMemo)(()=>({
            onNewRequest: (request)=>{
                inFlightRequestsRef.current.push(request);
            },
            onRequestFinish: (request, /**
				 * Called only if the request hasn't been superceded by a more recent request's success / failure
				 */ onIfRequestIsRelevant)=>{
                // find the first occurrence of this request
                const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                // If the current request is still considered "in flight"
                if (inFlightRequestIndex !== -1) {
                    onIfRequestIsRelevant?.();
                    // Cut out the current and all proceeding requests from the in-flight queue
                    inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                    // Update isLoading to reflect the current number of in-flight requests
                    setIsLoading?.(!!inFlightRequestsRef.current.length);
                }
            }
        }), [
        setIsLoading
    ]);
};
const $7714fce489d6815b$var$useTransitionNoop = ()=>[
        null,
        null
    ];
const $7714fce489d6815b$export$ae1adabf094b2244 = (// Relay-generated query from the @refetchable annotation in a useRefetchableFragment
// or usePaginationFragment
query, // Refetch function from a useRefetchableFragment or usePaginationFragment
// (which ordinarily would trigger suspense)
refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const isMounted = (0, $biQrn.useIsMounted)();
    const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $7714fce489d6815b$var$useInFlightRequests({
        setIsLoading: setIsLoading
    });
    const useTransitionFG = (0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('jira-concurrent-suspenseless-refetch') // Done to prevent react-hooks/rules-of-hooks eslint error that is being ratcheted against
     ? (0, $5uXOq.useTransition) : $7714fce489d6815b$var$useTransitionNoop;
    const [_, startTransition] = useTransitionFG();
    return (0, $5uXOq.useCallback)((variables)=>{
        if (isMounted.current) setIsLoading?.(true);
        onNewRequest(variables);
        return (0, $8Uumt.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: networkCacheConfig
        }).subscribe({
            complete () {
                if (isMounted.current) {
                    if (startTransition && (0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('jira-concurrent-suspenseless-refetch')) // we need concurrent mode for useTransition to work
                    startTransition(()=>{
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                        });
                    });
                    else {
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                        });
                    }
                }
            },
            error (e) {
                if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
            }
        });
    }, [
        environment,
        fetchPolicy,
        isMounted,
        networkCacheConfig,
        onNewRequest,
        onRequestFinish,
        query,
        refetch,
        setIsLoading,
        setLastFetchError,
        startTransition
    ]);
};
const $7714fce489d6815b$export$c7ce5f64dc007896 = (query, refetch, options)=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [lastFetchError, setLastFetchError] = (0, $5uXOq.useState)(null);
    const refetchFunction = $7714fce489d6815b$export$ae1adabf094b2244(query, refetch, {
        ...options,
        setIsLoading: setIsLoading,
        setLastFetchError: setLastFetchError
    });
    return [
        refetchFunction,
        isLoading,
        lastFetchError
    ];
};

});
parcelRegister("biQrn", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c6adaed2787020bf$export$80c2a3957bcb42ea);

var $5uXOq = parcelRequire("5uXOq");
const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});


parcelRegister("bV4zb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c2d65b13355827$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e1c2d65b13355827$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    empty: {
        "id": "issue-field-issue-type-editview-full.issue-type.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-issue-type-editview-full.issue-type.failed-fetch",
        "defaultMessage": "Search failed."
    },
    loading: {
        "id": "issue-field-issue-type-editview-full.issue-type.loading",
        "defaultMessage": "Searching..."
    },
    placeholder: {
        "id": "issue-field-issue-type-editview-full.issue-type.placeholder",
        "defaultMessage": "Select Issue Type"
    },
    label: {
        "id": "issue-field-issue-type-editview-full.issue-type.label",
        "defaultMessage": "Issue Type"
    },
    placeholderIssueTerminologyRefreshM4: {
        "id": "issue-field-issue-type-editview-full.issue-type.placeholder-issue-terminology-refresh-m4",
        "defaultMessage": "Select work type"
    },
    labelIssueTerminologyRefreshM4: {
        "id": "issue-field-issue-type-editview-full.issue-type.label-issue-terminology-refresh-m4",
        "defaultMessage": "Work Type"
    }
});

});


parcelRegister("cmfPH", function(module, exports) {

$parcel$export(module.exports, "useDefaultIssueType", () => $c7779776cee20ae6$export$9c7f64b201a937e7);

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");

var $dHlro = parcelRequire("dHlro");
const $c7779776cee20ae6$var$defaultProjectConfigProjectConfig = {
    defaultIssueType: null
};
const $c7779776cee20ae6$var$selectProjectConfig = (0, $6dDSs.createSelector)((_, projectKey)=>projectKey, ({ projectConfigs: projectConfigs })=>projectConfigs, (projectKey, projectConfigs)=>{
    if (projectKey == null) return $c7779776cee20ae6$var$defaultProjectConfigProjectConfig;
    const config = projectConfigs[projectKey];
    if (config == null) return $c7779776cee20ae6$var$defaultProjectConfigProjectConfig;
    return config;
});
const $c7779776cee20ae6$var$selectIssueType = (0, $6dDSs.createSelector)($c7779776cee20ae6$var$selectProjectConfig, (config)=>config.defaultIssueType);
const $c7779776cee20ae6$export$9c7f64b201a937e7 = (0, $3sQ5x.createHook)((0, $dHlro.IICConfigStore), {
    selector: $c7779776cee20ae6$var$selectIssueType
});

});
parcelRegister("dHlro", function(module, exports) {

$parcel$export(module.exports, "IICConfigStore", () => $5f7276fc0ea67b49$export$9bd138189628b8f1);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $5f7276fc0ea67b49$var$initialState = {
    projectConfigs: {}
};
const $5f7276fc0ea67b49$var$actions = {
    setDefaultIssueType: (projectKey, issueType)=>({ setState: setState, getState: getState })=>{
            if (projectKey == null) return;
            const currentState = getState();
            let projectConfig = currentState.projectConfigs[projectKey];
            if (projectConfig == null) projectConfig = {
                defaultIssueType: null
            };
            projectConfig.defaultIssueType = issueType;
            setState({
                ...currentState,
                projectConfigs: {
                    ...currentState.projectConfigs,
                    [projectKey]: projectConfig
                }
            });
        }
};
const $5f7276fc0ea67b49$export$9bd138189628b8f1 = (0, $iXqE5.createStore)({
    initialState: $5f7276fc0ea67b49$var$initialState,
    actions: $5f7276fc0ea67b49$var$actions
});
const $5f7276fc0ea67b49$export$8b216441e8d7a953 = (0, $3sQ5x.createHook)($5f7276fc0ea67b49$export$9bd138189628b8f1);

});


parcelRegister("8gdZO", function(module, exports) {

$parcel$export(module.exports, "default", () => $942dbbc07b95057f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $942dbbc07b95057f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "issue-table-inline-issue-create.inline-create-from.issue-type-dropdown.label",
        "defaultMessage": "Issue type"
    },
    labelIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.inline-create-from.issue-type-dropdown.label-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    }
});

});


parcelRegister("aUncN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b4d414e35348921$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7b4d414e35348921$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createButton: {
        "id": "issue-table-inline-issue-create.inline-create-from.create-button",
        "defaultMessage": "Create"
    },
    placeholderText: {
        "id": "issue-table-inline-issue-create.inline-create-from.placeholder-text",
        "defaultMessage": "What needs to be done?"
    }
});

});

parcelRegister("i6vYW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c71c61c750dfdae0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $c71c61c750dfdae0$var$ReturnGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H21C22.6569 16 24 14.6569 24 13V3C24 1.34315 22.6569 0 21 0H3Z",
        fill: "var(--ds-background-inverse-subtle, #00000029)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M15.5 5.75V6.75C15.5 8.26878 14.2688 9.5 12.75 9.5H8.75C8.33579 9.5 8 9.16421 8 8.75C8 8.33579 8.33579 8 8.75 8H12.75C13.4404 8 14 7.44036 14 6.75V5.75C14 5.33579 14.3358 5 14.75 5C15.1642 5 15.5 5.33579 15.5 5.75Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.28033 9.28033L11.0303 7.53033C11.3232 7.23744 11.3232 6.76256 11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967L8.21967 8.21967C7.92678 8.51256 7.92678 8.98744 8.21967 9.28033C8.51256 9.57322 8.98744 9.57322 9.28033 9.28033Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.28033 8.21967L11.0303 9.96967C11.3232 10.2626 11.3232 10.7374 11.0303 11.0303C10.7374 11.3232 10.2626 11.3232 9.96967 11.0303L8.21967 9.28033C7.92678 8.98744 7.92678 8.51256 8.21967 8.21967C8.51256 7.92678 8.98744 7.92678 9.28033 8.21967Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));
const $c71c61c750dfdae0$var$ReturnIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $c71c61c750dfdae0$var$ReturnGlyph,
        label: ""
    });
var $c71c61c750dfdae0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($c71c61c750dfdae0$var$ReturnIcon);

});


parcelRegister("fvDFy", function(module, exports) {

$parcel$export(module.exports, "useInlineIssueCreateEntryPoint", () => $ab68b76d8d07298b$export$885248fb7870aaf0);

var $4mO32 = parcelRequire("4mO32");

var $koeKL = parcelRequire("koeKL");

var $cTWZ2 = parcelRequire("cTWZ2");
const $ab68b76d8d07298b$export$885248fb7870aaf0 = (projectKey, minHierarchyLevel, maxHierarchyLevel)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    return (0, $4mO32.useEntryPoint)((0, $cTWZ2.default), {
        cloudId: cloudId,
        projectKey: projectKey,
        minHierarchyLevel: minHierarchyLevel ?? undefined,
        maxHierarchyLevel: maxHierarchyLevel ?? undefined
    });
};

});
parcelRegister("cTWZ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6a2a68ac9651bd6$export$2e2bcd8739ae039);

var $hBruS = parcelRequire("hBruS");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $e6a2a68ac9651bd6$var$IssueTypeDropdownEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("jVaWe"))).then((module)=>module.IssueTypeDropdownEntryPoint), {
        moduleId: "2e71ceb4"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey, minHierarchyLevel: minHierarchyLevel, maxHierarchyLevel: maxHierarchyLevel })=>({
            queries: {
                projectData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $hBruS.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey ?? '',
                        hasProjectKey: !!projectKey,
                        ...minHierarchyLevel != null ? {
                            filter: {
                                minHierarchyLevel: minHierarchyLevel,
                                maxHierarchyLevel: maxHierarchyLevel
                            }
                        } : {}
                    }
                }
            }
        })
});
var $e6a2a68ac9651bd6$export$2e2bcd8739ae039 = $e6a2a68ac9651bd6$var$IssueTypeDropdownEntryPoint;

});


parcelRegister("5FBML", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f106054323540bd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $dZbEw = parcelRequire("dZbEw");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $14XJw = parcelRequire("14XJw");

var $koeKL = parcelRequire("koeKL");


var $gnXHx = parcelRequire("gnXHx");

var $kSFT2 = parcelRequire("kSFT2");
const $4f106054323540bd$var$InlineCreateTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const [isStoplightVisible, setIsSpotlightVisible] = (0, $5uXOq.useState)(false);
    const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, (0, $d4f18e56d7667f0b$export$c7e6a6b283196232), false, orgId), [
        cloudId,
        orgId
    ]);
    const startTour = (0, $5uXOq.useCallback)(async ()=>{
        const started = await coordinationClient?.start((0, $d4f18e56d7667f0b$export$e77c67bc8157f49));
        if (started) setIsSpotlightVisible(true);
    }, [
        coordinationClient
    ]);
    const endTour = (0, $5uXOq.useCallback)(()=>{
        setIsSpotlightVisible(false);
        coordinationClient?.stop?.((0, $d4f18e56d7667f0b$export$e77c67bc8157f49));
    }, [
        coordinationClient
    ]);
    (0, $5uXOq.useEffect)(()=>{
        startTour();
    }, [
        startTour
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClickCallback = (0, $5uXOq.useCallback)(()=>{
        onClick?.();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineIssueCreateButton');
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'inlineIssueCreateButton');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "inline-create-trigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onClickCallback,
        ref: ref,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw)))
    }, formatMessage((0, $gnXHx.default).createLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kSFT2.default), {
        showOnboarding: isStoplightVisible,
        onDismiss: endTour
    }));
});
var $4f106054323540bd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($4f106054323540bd$var$InlineCreateTrigger);

});
parcelRegister("gnXHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee28c65d9883b941$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ee28c65d9883b941$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createLabel: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.create-label",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("kSFT2", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc25ebb356c716b2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $7o200 = parcelRequire("7o200");
const $dc25ebb356c716b2$var$InlineCreateOnboardingSpotlight = ({ showOnboarding: showOnboarding, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, showOnboarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: onDismiss,
                text: formatMessage((0, $7o200.default).onboardingDismiss)
            }
        ],
        heading: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $7o200.default).onboardingHeaderIssueTerminologyRefreshM4 : (0, $7o200.default).onboardingHeader),
        target: "inline-create-trigger",
        key: "inline-create-trigger",
        messageType: "engagement",
        dialogPlacement: "top right",
        messageId: ((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $7o200.default).onboardingDescriptionIssueTerminologyRefreshM4 : (0, $7o200.default).onboardingDescription).id,
        dialogWidth: 275
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $7o200.default).onboardingDescriptionIssueTerminologyRefreshM4 : (0, $7o200.default).onboardingDescription)));
};
var $dc25ebb356c716b2$export$2e2bcd8739ae039 = $dc25ebb356c716b2$var$InlineCreateOnboardingSpotlight;

});
parcelRegister("7o200", function(module, exports) {

$parcel$export(module.exports, "default", () => $cea728a530fc5c2e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cea728a530fc5c2e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    onboardingDescription: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-description",
        "defaultMessage": "Quickly create issues on this page by selecting + Create below"
    },
    onboardingHeader: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-header",
        "defaultMessage": "Create issues in context"
    },
    onboardingDismiss: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-dismiss",
        "defaultMessage": "OK"
    },
    onboardingDescriptionIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-description-issue-terminology-refresh-m4",
        "defaultMessage": "Quickly create work items on this page by selecting + Create below"
    },
    onboardingHeaderIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-header-issue-terminology-refresh-m4",
        "defaultMessage": "Create work items in context"
    }
});

});




parcelRegister("4BEu7", function(module, exports) {

$parcel$export(module.exports, "useIssueCreateMutation", () => $7fd7c4325ea421a8$export$2a4bb6ab1e983642);
$parcel$export(module.exports, "CreateIssueController", () => $7fd7c4325ea421a8$export$dac3b0377215001c);

var $pRxzu = parcelRequire("pRxzu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $lQvun = parcelRequire("lQvun");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $eOucw = parcelRequire("eOucw");

var $b54lr = parcelRequire("b54lr");

var $17oPt = parcelRequire("17oPt");

var $czfFt = parcelRequire("czfFt");

var $e9M6d = parcelRequire("e9M6d");

var $i07Ny = parcelRequire("i07Ny");

var $67mCE = parcelRequire("67mCE");

var $8S82V = parcelRequire("8S82V");

var $3c1eX = parcelRequire("3c1eX");

var $28vJk = parcelRequire("28vJk");

var $2axqN = parcelRequire("2axqN");
const $7fd7c4325ea421a8$var$ACTION_SUBJECT_ID = 'issueTableIssueCreate';
const $7fd7c4325ea421a8$var$PACKAGE_LOCATION = 'jira-native-issue-table-inline-issue-create';
const $7fd7c4325ea421a8$var$issueConnectionMutationUpdater = (store, response, issueConnectionId, insertionArgs, parentItemConnectionId, projectKey, groupId)=>{
    const issue = response?.jira?.createIssue?.issue;
    if (!issue) return;
    (0, $i07Ny.issueConnectionUpdater)(store, {
        ...insertionArgs,
        issue: issue,
        issueConnectionId: issueConnectionId,
        parentItemConnectionId: parentItemConnectionId,
        issueRecordId: issue.__id,
        fieldSetsConnectionId: issue.fieldSetsById?.__id ?? '',
        projectKey: projectKey,
        groupId: groupId
    });
};
const $7fd7c4325ea421a8$export$2a4bb6ab1e983642 = ({ issueConnectionId: issueConnectionId, parentItemConnectionId: parentItemConnectionId, groupContextFieldInput: groupContextFieldInput, jql: jql })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const handleErrorIIC = (0, $lQvun.useIssueCreateOnError)();
    let shouldSkipIssuesConnectionUpdate;
    if ((0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_')) // eslint-disable-next-line react-hooks/rules-of-hooks
    shouldSkipIssuesConnectionUpdate = (0, $eOucw.useShouldSkipIssuesConnectionUpdate)();
    const { onSortChange: onSortChange } = (0, $4R6GH.fg)('jsc_list_reranking_gate_technical') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $b54lr.useSortContext)() : {
        onSortChange: undefined
    };
    const { fieldSetIds: fieldSetIds } = (0, $67mCE.useIssueFetchQueryVariables)();
    const onIssueFetchAndAppend = (0, $8S82V.useIssueFetchAndAppend)({
        issueConnectionId: issueConnectionId,
        groupContextFieldInput: groupContextFieldInput,
        jql: jql
    });
    const { generateOptimisticId: generateOptimisticId, getRealId: getRealId } = (0, $2axqN.useOptimisticId)();
    let queuedCommit;
    if ((0, $4R6GH.fg)('jsc_list_reranking_gate')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const generateDeferredVariables = (0, $5uXOq.useCallback)((oldVariables)=>{
            const rank = oldVariables.issueCreateInput.rank;
            if (rank) return {
                ...oldVariables,
                issueCreateInput: {
                    ...oldVariables.issueCreateInput,
                    rank: {
                        ...rank,
                        afterIssueId: rank.afterIssueId ? getRealId(rank.afterIssueId) ?? rank.afterIssueId : rank.afterIssueId,
                        beforeIssueId: rank.beforeIssueId ? getRealId(rank.beforeIssueId) ?? rank.beforeIssueId : rank.beforeIssueId
                    }
                }
            };
            return oldVariables;
        }, [
            getRealId
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        queuedCommit = (0, $17oPt.useQueuedMutationCommit)({
            generateDeferredVariables: generateDeferredVariables
        });
    }
    const [commit] = (0, $8Uumt.useMutation)((0, $pRxzu.default), queuedCommit);
    let projectKey;
    const isDensityFull = (0, $e9M6d.useIsDensityFull)();
    const isInlineEditingEnabled = (0, $e9M6d.useIsInlineEditingEnabled)();
    let isIssueHierarchyEnabled = false;
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isIssueHierarchyEnabled = (0, $e9M6d.useIsIssueHierarchyEnabled)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        projectKey = (0, $e9M6d.useProjectContext)();
    }
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $czfFt.INLINE_ISSUE_CREATE_EXPERIENCE),
        analyticsSource: (0, $czfFt.ANALYTICS_SOURCE)
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $czfFt.INLINE_ISSUE_CREATE_EXPERIENCE),
        attributes: (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? {
            isGroupIssueCreate: !!groupContextFieldInput
        } : {}
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $czfFt.INLINE_ISSUE_CREATE_EXPERIENCE)
    });
    let isIssueRankingEnabled = false;
    if ((0, $4R6GH.fg)('jsc_list_reranking_gate_technical')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isIssueRankingEnabled = (0, $e9M6d.useIsIssueRankingEnabled)();
    return (0, $5uXOq.useCallback)((issueToCreate, contextualFields, insertionArgs)=>{
        const issueCreateInput = (0, $3c1eX.toIssueCreateInput)(issueToCreate, contextualFields, groupContextFieldInput, insertionArgs, isIssueRankingEnabled);
        if (!issueCreateInput || issueConnectionId == null) return;
        const insertionArgsWithIdGetter = insertionArgs == null ? insertionArgs : {
            ...insertionArgs,
            getRealId: getRealId
        };
        const handleError = async (error)=>{
            const response = await handleErrorIIC({
                issueToCreate: issueToCreate,
                contextualFields: contextualFields,
                groupContextFieldInput: groupContextFieldInput,
                error: error,
                onFail: (e)=>onExperienceFail($7fd7c4325ea421a8$var$PACKAGE_LOCATION, e)
            });
            if (response) {
                onIssueFetchAndAppend(response, insertionArgsWithIdGetter);
                onExperienceSuccess();
            }
        };
        const { id: optimisticId, saveRealId: saveRealId } = generateOptimisticId();
        onExperienceStart();
        commit({
            variables: {
                issueCreateInput: issueCreateInput,
                fieldSetIds: fieldSetIds,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isDensityFull: isDensityFull,
                isIssueHierarchyEnabled: isIssueHierarchyEnabled,
                ...(0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? {
                    projectKey: projectKey
                } : {},
                ...groupContextFieldInput && (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? {
                    shouldQueryFieldsByIdOrAlias: true,
                    fieldIdsOrAliases: [
                        groupContextFieldInput.fieldId
                    ]
                } : {
                    shouldQueryFieldsByIdOrAlias: false,
                    fieldIdsOrAliases: []
                },
                ...jql && (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? {
                    shouldQueryMatchesIssueSearch: true,
                    issueSearchInput: {
                        jql: jql
                    }
                } : {
                    shouldQueryMatchesIssueSearch: false,
                    issueSearchInput: {
                        jql: ''
                    }
                }
            },
            optimisticResponse: (0, $28vJk.toOptimisticResponse)(issueToCreate, optimisticId, isIssueHierarchyEnabled, groupContextFieldInput),
            optimisticUpdater: (store, response)=>$7fd7c4325ea421a8$var$issueConnectionMutationUpdater(store, response, issueConnectionId, insertionArgsWithIdGetter, parentItemConnectionId, projectKey),
            updater: (store, response)=>{
                if (response != null && response?.jira?.createIssue?.issue?.id != null) saveRealId(response?.jira?.createIssue?.issue?.id);
                if (shouldSkipIssuesConnectionUpdate?.(groupContextFieldInput, response?.jira?.createIssue?.issue, isIssueRankingEnabled, onSortChange)) return;
                return $7fd7c4325ea421a8$var$issueConnectionMutationUpdater(store, response, issueConnectionId, insertionArgsWithIdGetter, parentItemConnectionId, projectKey, groupContextFieldInput?.groupId);
            },
            onCompleted: (response)=>{
                const { errors: errors, issue: issue } = response?.jira?.createIssue ?? {};
                if (!issue) {
                    // Handle any GraphQL errors that occurred during issue create
                    errors && handleError(errors);
                    return;
                }
                // Event contributes towards Jira Monthly Core User, see https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition#%3Ajira%3A-Jira.
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', $7fd7c4325ea421a8$var$ACTION_SUBJECT_ID);
                onExperienceSuccess();
                (0, $i07Ny.removeHighlightAfterDelay)(environment, issue);
            },
            onError: (error)=>{
                // Handle any network errors that occurred during issue create
                handleError(error);
            }
        });
    }, [
        groupContextFieldInput,
        issueConnectionId,
        getRealId,
        generateOptimisticId,
        onExperienceStart,
        commit,
        fieldSetIds,
        isInlineEditingEnabled,
        isDensityFull,
        isIssueHierarchyEnabled,
        projectKey,
        jql,
        handleErrorIIC,
        onExperienceFail,
        onIssueFetchAndAppend,
        onExperienceSuccess,
        parentItemConnectionId,
        shouldSkipIssuesConnectionUpdate,
        onSortChange,
        createAnalyticsEvent,
        environment,
        isIssueRankingEnabled
    ]);
};
const $7fd7c4325ea421a8$export$dac3b0377215001c = ({ childConnectionId: childConnectionId, parentItemConnectionId: parentItemConnectionId, groupContextFieldInput: groupContextFieldInput, setOnCreateIssue: setOnCreateIssue, jql: jql })=>{
    const onCreateIssue = $7fd7c4325ea421a8$export$2a4bb6ab1e983642({
        issueConnectionId: childConnectionId,
        parentItemConnectionId: parentItemConnectionId,
        groupContextFieldInput: groupContextFieldInput,
        jql: jql
    });
    setOnCreateIssue(onCreateIssue);
    return null;
};

});
parcelRegister("pRxzu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea821520f22ca15f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c5056522592f26189e4a673b688c43f6>>
 * @relayHash dca591c3db7e0f278f7bbd5834ea01ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ba3e5dfaad673a3fe6da611ce5580d6f22ec5de9eb8848e401b4207f1d90928

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $ea821520f22ca15f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldIdsOrAliases"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIssueHierarchyEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueCreateInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldsByIdOrAlias"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryMatchesIssueSearch"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "issueCreateInput"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "ScalarField",
        "name": "key"
    }, v14 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v15 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v16 = {
        "args": [
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "canHaveChildIssues"
    }, v17 = [
        {
            "kind": "Variable",
            "name": "idsOrAliases",
            "variableName": "fieldIdsOrAliases"
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "statusId"
    }, v21 = {
        "kind": "ScalarField",
        "name": "name"
    }, v22 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v23 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v24 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v25 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v26 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v27 = {
        "kind": "ScalarField",
        "name": "number"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            v27 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v29 = {
        "condition": "shouldQueryMatchesIssueSearch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "kind": "ScalarField",
                "name": "matchesIssueSearch"
            }
        ]
    }, v30 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v31 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v32 = [
        v12 /*: any*/ 
    ], v33 = {
        "kind": "ScalarField",
        "name": "type"
    }, v34 = {
        "kind": "ScalarField",
        "name": "value"
    }, v35 = [
        v34 /*: any*/ ,
        v12 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v36 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v37 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v38 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v39 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v40 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v41 = {
        "kind": "ScalarField",
        "name": "text"
    }, v42 = {
        "kind": "InlineFragment",
        "selections": [
            v41 /*: any*/ ,
            v21 /*: any*/ ,
            v36 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v43 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v44 = [
        v43 /*: any*/ 
    ], v45 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v12 /*: any*/ 
        ]
    }, v46 = [
        v45 /*: any*/ 
    ], v47 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v48 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v49 = [
        v21 /*: any*/ ,
        v12 /*: any*/ 
    ], v50 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v51 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v52 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v51 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v53 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v54 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v45 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v55 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v56 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v55 /*: any*/ ,
                    v21 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v12 /*: any*/ 
        ]
    }, v57 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v58 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueCreateMutation_useIssueCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "JiraIssueCreatePayload",
                            "kind": "LinkedField",
                            "name": "createIssue",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "highlightIssueRow_update_isHighlightedIssueRow"
                                        },
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "condition": "isIssueHierarchyEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryFieldsByIdOrAlias",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v17 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraStatusField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraPriorityField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v23 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v25 /*: any*/ ,
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedSprintsConnection(first:1)"
                                                                }
                                                            ],
                                                            "type": "JiraSprintField"
                                                        },
                                                        v28 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v29 /*: any*/ ,
                                        {
                                            "args": v30 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSetsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isDensityFull",
                                                            "variableName": "isDensityFull"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isInlineEditingEnabled",
                                                            "variableName": "isInlineEditingEnabled"
                                                        }
                                                    ],
                                                    "kind": "FragmentSpread",
                                                    "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        v31 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v8 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueCreateMutation_useIssueCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "JiraIssueCreatePayload",
                            "kind": "LinkedField",
                            "name": "createIssue",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v32 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "args": v30 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSetsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fieldSetId"
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ ,
                                                                                        v33 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        v12 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v21 /*: any*/ ,
                                                                                                                        v12 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraCascadingOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "cascadingOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v35 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "childOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v35 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCascadingSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v37 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v39 /*: any*/ ,
                                                                                                                                v12 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        },
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v40 /*: any*/ ,
                                                                                                        v21 /*: any*/ ,
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                v42 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCommentSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "commentSummary",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "canAddComment"
                                                                                                                },
                                                                                                                v43 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCommentSummaryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "uri"
                                                                                                        },
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraUrlField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": v44 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v34 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v46 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v46 /*: any*/ 
                                                                                                                },
                                                                                                                v12 /*: any*/ ,
                                                                                                                v24 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                v34 /*: any*/ ,
                                                                                                                                v24 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                v34 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v23 /*: any*/ ,
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                v47 /*: any*/ ,
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                v48 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "email"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraTeamView",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedTeam",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTeamViewField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v12 /*: any*/ ,
                                                                                                                        v36 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraEstimate",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "originalEstimate",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "timeInSeconds"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingSettings",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingSettings",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingHoursPerDay"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingDaysPerWeek"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultFormat"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultUnit"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v21 /*: any*/ ,
                                                                                                                        v33 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": "label",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "value"
                                                                                                                },
                                                                                                                v12 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v37 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v39 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "versionId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        },
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": v32 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "args": v37 /*: any*/ ,
                                                                                                            "concreteType": "JiraGoalConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGoals",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoal",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                v13 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v31 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                                        },
                                                                                                        v36 /*: any*/ ,
                                                                                                        v31 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraGoalsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v37 /*: any*/ ,
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "href"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v43 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                        },
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "componentsOld",
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v49 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "date"
                                                                                                },
                                                                                                v21 /*: any*/ ,
                                                                                                v50 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "summary"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        v42 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        v51 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        v20 /*: any*/ ,
                                                                                                        v52 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v37 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v21 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v43 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v21 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "small"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v21 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        v53 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                v54 /*: any*/ ,
                                                                                                                v56 /*: any*/ ,
                                                                                                                v53 /*: any*/ ,
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                v54 /*: any*/ ,
                                                                                                                v56 /*: any*/ ,
                                                                                                                v53 /*: any*/ ,
                                                                                                                v12 /*: any*/ ,
                                                                                                                v14 /*: any*/ ,
                                                                                                                v57 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "summary",
                                                                                                                                "issuetype",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                v41 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "issueTypeId"
                                                                                                                                                        },
                                                                                                                                                        v21 /*: any*/ ,
                                                                                                                                                        v55 /*: any*/ ,
                                                                                                                                                        v15 /*: any*/ ,
                                                                                                                                                        v12 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "status",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v52 /*: any*/ ,
                                                                                                                                                        v12 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v21 /*: any*/ ,
                                                                                                        v36 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v21 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": v49 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v12 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v21 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v21 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v23 /*: any*/ ,
                                                                                                        v47 /*: any*/ ,
                                                                                                        v21 /*: any*/ ,
                                                                                                        v12 /*: any*/ ,
                                                                                                        v48 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v21 /*: any*/ ,
                                                                                                v50 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v37 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v49 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "json"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        v55 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v25 /*: any*/ ,
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v43 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v57 /*: any*/ ,
                                                                                                                                v13 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v52 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v12 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                v12 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "relationName"
                                                                                                                        },
                                                                                                                        v12 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                v27 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        v58 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        v21 /*: any*/ ,
                                                                                                        v36 /*: any*/ ,
                                                                                                        v58 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v36 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGroupsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGroup",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "groupId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraFlag",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "flag",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isFlagged"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFlagField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v44 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "isIssueHierarchyEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v12 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryFieldsByIdOrAlias",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v17 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraStatusField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraPriorityField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v18 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v25 /*: any*/ ,
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v12 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedSprintsConnection(first:1)"
                                                                }
                                                            ],
                                                            "type": "JiraSprintField"
                                                        },
                                                        v28 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v29 /*: any*/ ,
                                        v31 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7ba3e5dfaad673a3fe6da611ce5580d6f22ec5de9eb8848e401b4207f1d90928",
            "metadata": {},
            "name": "issueCreateMutation_useIssueCreateMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$ea821520f22ca15f$var$node.hash = "f75004a488fd67302707f70737f0cb91";
var $ea821520f22ca15f$export$2e2bcd8739ae039 = $ea821520f22ca15f$var$node;

});

parcelRegister("lQvun", function(module, exports) {

$parcel$export(module.exports, "useIssueCreateOnError", () => $67f8adf0382f390f$export$5a42366aaf5bc501);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $d19oY = parcelRequire("d19oY");

var $hgsql = parcelRequire("hgsql");
const $67f8adf0382f390f$var$isMutationValidationError = (errors)=>errors.some((error)=>error.extensions?.statusCode === 400);
const $67f8adf0382f390f$var$toError = (errors)=>{
    const statusCodes = new Set();
    errors.forEach((err)=>{
        const sc = err.extensions?.statusCode;
        if (sc) statusCodes.add(String(sc));
    });
    return new Error(`Fail to fallback to GIC extension status codes: ${statusCodes.size > 0 ? Array.from(statusCodes.values()).join(',') : 'No status'}`);
};
const $67f8adf0382f390f$export$5a42366aaf5bc501 = ()=>{
    const onFallbackToGIC = (0, $d19oY.useFallbackToGIC)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    return (0, $5uXOq.useCallback)(({ issueToCreate: issueToCreate, contextualFields: contextualFields, groupContextFieldInput: groupContextFieldInput, error: error, onFail: onFail })=>{
        let shouldFallbackToGIC;
        if (error instanceof Error) shouldFallbackToGIC = error instanceof (0, $jJZqs.ValidationError);
        else shouldFallbackToGIC = $67f8adf0382f390f$var$isMutationValidationError(error);
        if (shouldFallbackToGIC) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'globalIssueCreate fallback', 'inlineIssueCreate');
            return onFallbackToGIC({
                issueToCreate: issueToCreate,
                contextualFields: contextualFields,
                groupContextFieldInput: groupContextFieldInput
            });
        }
        // Fire error analytics event and display flag if we were unable to fallback to GIC
        (0, $jcw0u.default)({
            event: createAnalyticsEvent({}),
            meta: {
                id: 'inlineIssueCreate',
                packageName: (0, $d4f18e56d7667f0b$export$b8b9d90f9e5bd72b),
                teamName: (0, $d4f18e56d7667f0b$export$d57b6b390e78d90f)
            },
            error: error instanceof Error ? error : undefined,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            type: 'error',
            title: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $hgsql.default).errorFlagTitleIssueTerminologyRefreshM4 : (0, $hgsql.default).errorFlagTitleNonFinal),
            description: formatMessage((0, $hgsql.default).errorFlagDescriptionNonFinal),
            messageId: 'issue-table-inline-issue-create.controllers.use-issue-create-on-error.show-flag.error',
            messageType: 'transactional'
        });
        onFail?.(error instanceof Error ? error : $67f8adf0382f390f$var$toError(error));
        return Promise.resolve(null);
    }, [
        createAnalyticsEvent,
        formatMessage,
        onFallbackToGIC,
        showFlag
    ]);
};

});
parcelRegister("d19oY", function(module, exports) {

$parcel$export(module.exports, "useFallbackToGIC", () => $649c67b5f2a1b9af$export$1682627434940303);

var $5uXOq = parcelRequire("5uXOq");

var $jUlV7 = parcelRequire("jUlV7");

var $4R6GH = parcelRequire("4R6GH");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $hULKg = parcelRequire("hULKg");

var $5rzqz = parcelRequire("5rzqz");

var $4N2h5 = parcelRequire("4N2h5");

var $5fc53 = parcelRequire("5fc53");
const $649c67b5f2a1b9af$var$toGICAdditionalFields = ({ rankFieldId: rankFieldId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId }, groupContextFieldInput)=>{
    const additionalFields = {};
    if (rankFieldId && (rankBeforeIssueId || rankAfterIssueId)) additionalFields[rankFieldId] = {
        ...rankBeforeIssueId ? {
            rankBeforeIssue: rankBeforeIssueId
        } : {},
        ...rankAfterIssueId ? {
            rankAfterIssue: rankAfterIssueId
        } : {}
    };
    if (groupContextFieldInput && (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_')) return {
        ...additionalFields,
        ...(0, $4N2h5.convertFieldToGICAdditionalFieldsPayload)(groupContextFieldInput)
    };
    return additionalFields;
};
const $649c67b5f2a1b9af$var$issueIdFromAri = (ari)=>(0, $jUlV7.JiraIssueAri).parse(ari).issueId;
const $649c67b5f2a1b9af$export$1682627434940303 = ()=>{
    const openIssueCreateModal = (0, $5rzqz.useOpenIssueCreateModal)();
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    return (0, $5uXOq.useCallback)(({ issueToCreate: issueToCreate, contextualFields: contextualFields, groupContextFieldInput: groupContextFieldInput })=>{
        const { project: { projectId: projectId }, issueType: { issueTypeId: issueTypeId }, summary: summary } = issueToCreate;
        const payload = {
            project: {
                projectId: projectId
            },
            issueType: {
                issueTypeId: issueTypeId
            },
            ...contextualFields.parentIssueAri && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? {
                parentId: {
                    parentId: $649c67b5f2a1b9af$var$issueIdFromAri(contextualFields.parentIssueAri)
                }
            } : {},
            ...groupContextFieldInput?.fieldType === (0, $5fc53.STATUS_TYPE) && (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? (0, $4N2h5.convertFieldToStatusGICInput)(groupContextFieldInput) : {},
            defaultValues: {
                singleLineTextFields: [
                    {
                        fieldId: 'summary',
                        text: summary
                    }
                ],
                ...contextualFields.parentIssueAri && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? {
                    parentField: {
                        issueId: $649c67b5f2a1b9af$var$issueIdFromAri(contextualFields.parentIssueAri)
                    }
                } : {},
                ...groupContextFieldInput && (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? (0, $4N2h5.convertFieldToIssueCreateInput)(groupContextFieldInput) : {}
            }
        };
        return new Promise((resolve)=>{
            const unsubscribe = subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                // the user cancelled editing
                onClose(null);
            });
            // resolve the promise once the GIC has been closed or cancelled
            const onClose = (data)=>{
                const result = data?.[0]?.issueKey ?? null;
                resolve(result);
                unsubscribe();
            };
            const isSubTaskCreationOpen = !!(issueToCreate.issueType?.hierarchy?.level === -1 && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes'));
            openIssueCreateModal({
                payload: payload,
                context: {
                    projectId: projectId,
                    submitApiData: {
                        additionalFields: $649c67b5f2a1b9af$var$toGICAdditionalFields(contextualFields, groupContextFieldInput)
                    }
                },
                onClose: onClose,
                isSubTaskCreationOpen: isSubTaskCreationOpen,
                triggerPointKey: (0, $hULKg.TRIGGER_POINT_KEY_NOT_DEFINED),
                disableProjectDropdown: true,
                disableIssueTypeDropdown: false,
                disableCreationSuccessFlag: true,
                minimizableModalView: 'mini'
            });
        });
    }, [
        openIssueCreateModal,
        subscribe
    ]);
};

});
parcelRegister("jUlV7", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $e7e440357f375b75$export$1da6808e89ee03e);

var $bQ5aj = parcelRequire("bQ5aj");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/issue/manifest.ts
var $e7e440357f375b75$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $bQ5aj.JiraIssueAriResourceOwner),
    resourceType: (0, $bQ5aj.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $e7e440357f375b75$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e7e440357f375b75$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $e7e440357f375b75$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e7e440357f375b75$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $e7e440357f375b75$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $e7e440357f375b75$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $e7e440357f375b75$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("bQ5aj", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $89e88ec215209f61$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $89e88ec215209f61$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $89e88ec215209f61$export$665a39f1b4e29e0a = "jira", $89e88ec215209f61$export$76beb4d0da177ad4 = "issue";

});


parcelRegister("5eGnF", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $700db8c378cd19d9$export$876003a5b887f37e);
const $700db8c378cd19d9$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("9svjh", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $d9b2e43e4699b192$export$e3ff72f196296fcc);

var $1mrD8 = parcelRequire("1mrD8");
const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, $1mrD8.PubSubHub)();
const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
        ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
    });

});
parcelRegister("1mrD8", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("4N2h5", function(module, exports) {

$parcel$export(module.exports, "isCreateIssueSupportedForFieldType", () => $e9da7e5b85e2e06d$export$6a7d6e7c75a0955e);
$parcel$export(module.exports, "convertFieldToStatusGICInput", () => $e9da7e5b85e2e06d$export$ff734d0b6c783fa9);
$parcel$export(module.exports, "convertFieldToGICAdditionalFieldsPayload", () => $e9da7e5b85e2e06d$export$2bcbed170a89c245);
$parcel$export(module.exports, "convertFieldToIssueCreateInput", () => $e9da7e5b85e2e06d$export$1492200cb52faf7c);
$parcel$export(module.exports, "toOptimisticField", () => $e9da7e5b85e2e06d$export$4905b0508c306b7b);

var $5fc53 = parcelRequire("5fc53");

var $ljy2T = parcelRequire("ljy2T");
const $e9da7e5b85e2e06d$export$2919a1ac88b5c214 = new Set([
    (0, $5fc53.PRIORITY_TYPE),
    (0, $5fc53.ASSIGNEE_TYPE),
    (0, $5fc53.STATUS_TYPE),
    (0, $5fc53.SPRINT_TYPE),
    (0, $5fc53.NUMBER_CF_TYPE),
    (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
    (0, $5fc53.CATEGORY_TYPE)
]);
const $e9da7e5b85e2e06d$export$6a7d6e7c75a0955e = (fieldType)=>Boolean(fieldType && $e9da7e5b85e2e06d$export$2919a1ac88b5c214.has(fieldType));
const $e9da7e5b85e2e06d$export$ff734d0b6c783fa9 = ({ fieldValue: fieldValue })=>{
    if (fieldValue === null) return null;
    return {
        status: {
            statusId: fieldValue
        }
    };
};
const $e9da7e5b85e2e06d$export$2bcbed170a89c245 = (groupContextFieldInput)=>{
    const { fieldType: fieldType, fieldValue: fieldValue, fieldId: fieldId } = groupContextFieldInput;
    if (fieldValue === null) return {};
    // Note: excluding status type as it's always shown in GIC
    switch(fieldType){
        case 0, $5fc53.PRIORITY_TYPE:
        case 0, $5fc53.ASSIGNEE_TYPE:
            return {
                [fieldId]: {
                    id: fieldValue
                }
            };
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $5fc53.NUMBER_CF_TYPE:
        case 0, $5fc53.SPRINT_TYPE:
            return {
                [fieldId]: {
                    id: fieldId,
                    value: fieldValue
                }
            };
        case 0, $5fc53.CATEGORY_TYPE:
            return {
                [fieldId]: {
                    id: fieldValue,
                    value: fieldValue
                }
            };
        default:
            return null;
    }
};
const $e9da7e5b85e2e06d$export$1492200cb52faf7c = ({ fieldType: fieldType, fieldValue: fieldValue, fieldId: fieldId })=>{
    if (fieldValue === null) return null;
    switch(fieldType){
        case 0, $5fc53.PRIORITY_TYPE:
            return {
                priority: {
                    priorityId: fieldValue
                }
            };
        case 0, $5fc53.ASSIGNEE_TYPE:
            return {
                singleSelectUserPickerFields: [
                    {
                        fieldId: fieldId,
                        user: {
                            accountId: fieldValue
                        }
                    }
                ]
            };
        case 0, $5fc53.STATUS_TYPE:
            return {
                status: {
                    statusId: fieldValue
                }
            };
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $5fc53.NUMBER_CF_TYPE:
            return {
                numberFields: [
                    {
                        fieldId: fieldId,
                        value: fieldValue
                    }
                ]
            };
        case 0, $5fc53.CATEGORY_TYPE:
            return {
                singleSelectFields: [
                    {
                        fieldId: fieldId,
                        option: {
                            id: fieldValue,
                            optionId: fieldValue
                        }
                    }
                ]
            };
        case 0, $5fc53.SPRINT_TYPE:
            return {
                sprintsField: {
                    fieldId: fieldId,
                    sprints: [
                        {
                            sprintId: fieldValue
                        }
                    ]
                }
            };
        default:
            return null;
    }
};
const $e9da7e5b85e2e06d$export$4905b0508c306b7b = (issueId, { fieldId: fieldId, fieldType: fieldType, optimisticResponse: optimisticResponse })=>{
    switch(optimisticResponse?.type){
        case 0, $5fc53.PRIORITY_TYPE:
            return (0, $ljy2T.toOptimisticPriority)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $5fc53.ASSIGNEE_TYPE:
            return (0, $ljy2T.toOptimisticUser)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $5fc53.STATUS_TYPE:
            return (0, $ljy2T.toOptimisticStatus)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $5fc53.CATEGORY_TYPE:
            return (0, $ljy2T.toOptimisticSingleSelect)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $5fc53.SPRINT_TYPE:
            return (0, $ljy2T.toOptimisticSprint)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $5fc53.NUMBER_CF_TYPE:
            return (0, $ljy2T.toOptimisticNumber)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        default:
            return null;
    }
};

});
parcelRegister("ljy2T", function(module, exports) {

$parcel$export(module.exports, "toOptimisticPriority", () => $2fa28777783b49a7$export$b0e8bb5f2ea51c4f);
$parcel$export(module.exports, "toOptimisticUser", () => $2fa28777783b49a7$export$afc99b621d72ef26);
$parcel$export(module.exports, "toOptimisticStatus", () => $2fa28777783b49a7$export$3e4b4b49e4ee4e20);
$parcel$export(module.exports, "toOptimisticSingleSelect", () => $2fa28777783b49a7$export$71ead0fa097cead6);
$parcel$export(module.exports, "toOptimisticSprint", () => $2fa28777783b49a7$export$d9be65aae3a85c75);
$parcel$export(module.exports, "toOptimisticNumber", () => $2fa28777783b49a7$export$4b7137aed66177e0);
const $2fa28777783b49a7$export$b0e8bb5f2ea51c4f = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { priority: priority } })=>({
        node: {
            fieldSetId: fieldType,
            type: fieldId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraPriorityField',
                            __isJiraIssueField: 'JiraPriorityField',
                            fieldId: fieldId,
                            id: `${issueId}/${fieldId}`,
                            type: fieldType,
                            name: 'Priority',
                            priority: priority
                        }
                    }
                ]
            }
        }
    });
const $2fa28777783b49a7$export$afc99b621d72ef26 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { user: user } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleSelectUserPickerField',
                            __isJiraIssueField: 'JiraSingleSelectUserPickerField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Assignee',
                            user: user ? {
                                __typename: 'AtlassianAccountUser',
                                accountStatus: 'active',
                                id: user.id,
                                accountId: user.accountId,
                                picture: user.picture,
                                name: user.name
                            } : null
                        }
                    }
                ]
            }
        }
    });
const $2fa28777783b49a7$export$3e4b4b49e4ee4e20 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { status: status } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraStatusField',
                            __isJiraIssueField: 'JiraStatusField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            status: status
                        }
                    }
                ]
            }
        }
    });
const $2fa28777783b49a7$export$71ead0fa097cead6 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { option: option } })=>({
        node: {
            type: fieldType,
            fieldSetId: 'Category[Category]',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleSelectField',
                            __isJiraIssueField: 'JiraSingleSelectField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Category',
                            fieldOptions: {
                                totalCount: 1
                            },
                            fieldOption: option ? {
                                id: option.id,
                                optionId: option.optionId,
                                value: option.value,
                                color: option.color
                            } : null
                        }
                    }
                ]
            }
        }
    });
const $2fa28777783b49a7$export$d9be65aae3a85c75 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { sprint: sprint } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSprintField',
                            __isJiraIssueField: 'JiraSprintField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Sprint',
                            selectedSprintsConnection: {
                                edges: sprint ? [
                                    {
                                        node: {
                                            id: sprint.id,
                                            sprintId: sprint.sprintId,
                                            name: sprint.name,
                                            state: sprint.state,
                                            endDate: sprint.endDate
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });
const $2fa28777783b49a7$export$4b7137aed66177e0 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { value: value, fieldSetId: fieldSetId, isStoryPointField: isStoryPointField } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraNumberField',
                            __isJiraIssueField: 'JiraNumberField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Story point estimate',
                            number: value,
                            isStoryPointField: isStoryPointField
                        }
                    }
                ]
            }
        }
    });

});



parcelRegister("hgsql", function(module, exports) {

$parcel$export(module.exports, "default", () => $161a2241ad9cf7e8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $161a2241ad9cf7e8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitleNonFinal: {
        "id": "issue-table-inline-issue-create.controllers.use-issue-create-on-error.error-flag-title-non-final",
        "defaultMessage": "We weren't able to create an issue"
    },
    errorFlagDescriptionNonFinal: {
        "id": "issue-table-inline-issue-create.controllers.use-issue-create-on-error.error-flag-description-non-final",
        "defaultMessage": "Refresh the page and try again."
    },
    errorFlagTitleIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.controllers.use-issue-create-on-error.error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "We weren't able to create a work item"
    }
});

});


parcelRegister("eOucw", function(module, exports) {

$parcel$export(module.exports, "useShouldSkipIssuesConnectionUpdate", () => $e4b512d969144356$export$39d39d16a578afb3);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $pa9q9 = parcelRequire("pa9q9");

var $bSSG7 = parcelRequire("bSSG7");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $kiGw0 = parcelRequire("kiGw0");
const $e4b512d969144356$export$ce7751641b93537d = (0, $bSSG7.createLocalStorageProvider)('jira-native-issue-table-inline-issue-create');
const $e4b512d969144356$export$39d39d16a578afb3 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((groupContextField, createdIssue, isIssueRankingEnabled = false, onSortChange)=>{
        if (!createdIssue) return false;
        // Determines whether to show the default success flag or the reranking prompt success flag
        const showDefaultSuccessFlag = (issueKey)=>{
            const issueCreatedCount = $e4b512d969144356$export$ce7751641b93537d.get('issueCreatedCount') ?? 0;
            // TODO: JSC-1896 Activate only when table is not sorted by rank
            if (issueCreatedCount < 3) {
                $e4b512d969144356$export$ce7751641b93537d.set('issueCreatedCount', issueCreatedCount + 1);
                showFlag((0, $kiGw0.getIssueCreateRerankingPromptSuccessFlag)({
                    issueKey: issueKey,
                    onSortChange: onSortChange
                }));
            } else showFlag((0, $kiGw0.getIssueCreateSuccessFlag)({
                issueKey: issueKey
            }));
        };
        const issueKey = createdIssue.key;
        if ((0, $6s1PB.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) {
            const event = createAnalyticsEvent({});
            const matchesIssueSearch = createdIssue.matchesIssueSearch !== false;
            const hasGroupValueChanged = !!groupContextField && (0, $kiGw0.getCreatedIssueFieldValue)(createdIssue, groupContextField.fieldId) !== groupContextField.fieldValue;
            if (!matchesIssueSearch) issueKey && showFlag((0, $kiGw0.getIssueCreateHiddenFlag)({
                issueKey: issueKey
            }));
            else if (hasGroupValueChanged && groupContextField?.fieldType === (0, $5fc53.STATUS_TYPE)) issueKey && showFlag((0, $kiGw0.getIssueCreateSuccessFlag)({
                issueKey: issueKey,
                statusName: (0, $kiGw0.getStatusName)(createdIssue)
            }));
            else if (!isIssueRankingEnabled && (0, $4R6GH.fg)('jsc_list_reranking_gate')) issueKey && showDefaultSuccessFlag(issueKey);
            else issueKey && showFlag((0, $kiGw0.getIssueCreateSuccessFlag)({
                issueKey: issueKey
            }));
            (0, $8zOmE.fireUIAnalytics)(event, 'issueCreatedInListFlag shown', {
                matchesIssueSearch: matchesIssueSearch,
                groupIssueCreateFieldType: groupContextField?.fieldType || null,
                hasGroupValueChanged: hasGroupValueChanged
            });
            return hasGroupValueChanged || !matchesIssueSearch;
        }
        if (issueKey && (0, $4R6GH.fg)('jsc_list_reranking_gate')) isIssueRankingEnabled ? showFlag((0, $kiGw0.getIssueCreateSuccessFlag)({
            issueKey: issueKey
        })) : showDefaultSuccessFlag(issueKey);
        return false;
    }, [
        showFlag,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("kiGw0", function(module, exports) {

$parcel$export(module.exports, "getCreatedIssueFieldValue", () => $b6f50741555b0dc9$export$6e13001df02cb10d);
$parcel$export(module.exports, "getStatusName", () => $b6f50741555b0dc9$export$25a87d7a26b3901c);
$parcel$export(module.exports, "getIssueCreateSuccessFlag", () => $b6f50741555b0dc9$export$d4c1d656d8898934);
$parcel$export(module.exports, "getIssueCreateRerankingPromptSuccessFlag", () => $b6f50741555b0dc9$export$3b825da3d0425a10);
$parcel$export(module.exports, "getIssueCreateHiddenFlag", () => $b6f50741555b0dc9$export$58532011dc58b882);

var $5uXOq = parcelRequire("5uXOq");

var $cgL5K = parcelRequire("cgL5K");

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $1DTGK = parcelRequire("1DTGK");
const $b6f50741555b0dc9$export$6e13001df02cb10d = (createdIssue, fieldId)=>{
    const issueField = createdIssue.fieldsByIdOrAlias?.find((field)=>field?.fieldId === fieldId);
    switch(issueField?.__typename){
        case 'JiraStatusField':
            return issueField.status?.statusId ?? null;
        case 'JiraPriorityField':
            return issueField.priority?.priorityId ?? null;
        case 'JiraSingleSelectUserPickerField':
            return issueField.user?.accountId ?? null;
        case 'JiraSingleSelectField':
            return issueField.fieldOption?.optionId ?? null;
        case 'JiraSprintField':
            return issueField.selectedSprintsConnection?.edges?.[0]?.node?.sprintId ?? null;
        case 'JiraNumberField':
            return issueField.number?.toString() ?? null;
        default:
            return null;
    }
};
const $b6f50741555b0dc9$export$25a87d7a26b3901c = (createdIssue)=>{
    const issueField = createdIssue.fieldsByIdOrAlias?.find((field)=>field?.fieldId === (0, $5fc53.STATUS_TYPE));
    return issueField?.status?.name;
};
const $b6f50741555b0dc9$var$Bold = (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong"
    }, chunk);
const $b6f50741555b0dc9$export$d4c1d656d8898934 = ({ issueKey: issueKey, statusName: statusName })=>({
        id: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-success',
        type: 'success',
        messageId: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-success',
        messageType: 'transactional',
        isAutoDismiss: true,
        title: [
            (0, $1DTGK.default).workItemCreatedSuccessfullyTitle,
            {
                issueKey: issueKey
            }
        ],
        description: statusName ? [
            (0, $1DTGK.default).workItemChangedStatusDescription,
            {
                issueKey: issueKey,
                statusName: statusName,
                Bold: $b6f50741555b0dc9$var$Bold
            }
        ] : undefined,
        actions: [
            {
                content: [
                    (0, $1DTGK.default).viewWorkItem,
                    {
                        issueKey: issueKey
                    }
                ],
                href: `/browse/${issueKey}`
            }
        ]
    });
const $b6f50741555b0dc9$export$3b825da3d0425a10 = ({ issueKey: issueKey, onSortChange: onSortChange })=>({
        id: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-reranking-prompt-success',
        type: 'success',
        messageId: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-reranking-prompt-success',
        messageType: 'transactional',
        isAutoDismiss: true,
        title: [
            (0, $1DTGK.default).workItemCreatedSuccessfullyTitle,
            {
                issueKey: issueKey
            }
        ],
        description: [
            (0, $1DTGK.default).rerankingPromptDescription,
            {
                issueKey: issueKey,
                Bold: $b6f50741555b0dc9$var$Bold
            }
        ],
        actions: [
            {
                content: (0, $1DTGK.default).clearSorting,
                onClick: ()=>onSortChange?.('', 'NONE')
            },
            {
                content: [
                    (0, $1DTGK.default).viewWorkItem,
                    {
                        issueKey: issueKey
                    }
                ],
                href: `/browse/${issueKey}`
            }
        ]
    });
const $b6f50741555b0dc9$export$58532011dc58b882 = ({ issueKey: issueKey })=>({
        id: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-hidden',
        type: 'success',
        messageId: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-hidden',
        messageType: 'transactional',
        isAutoDismiss: true,
        title: [
            (0, $1DTGK.default).workItemCreatedSuccessfullyTitle,
            {
                issueKey: issueKey
            }
        ],
        description: [
            (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $1DTGK.default).workItemHiddenDescription : (0, $1DTGK.default).issueHiddenDescription,
            {
                issueKey: issueKey,
                Bold: $b6f50741555b0dc9$var$Bold
            }
        ],
        actions: [
            {
                content: [
                    (0, $1DTGK.default).viewWorkItem,
                    {
                        issueKey: issueKey
                    }
                ],
                href: `/browse/${issueKey}`
            }
        ]
    });

});
parcelRegister("1DTGK", function(module, exports) {

$parcel$export(module.exports, "default", () => $54adb224f42ff162$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $54adb224f42ff162$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    workItemCreatedSuccessfullyTitle: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-created-successfully-title",
        "defaultMessage": "Created {issueKey}"
    },
    workItemChangedStatusDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-changed-status-description",
        "defaultMessage": "Created <Bold>{issueKey}</Bold> with <Bold>{statusName}</Bold> status"
    },
    workItemHiddenDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-hidden-description",
        "defaultMessage": "<Bold>{issueKey}</Bold> is hidden because a filter is applied. Clear the filter to see all work items."
    },
    rerankingPromptDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.reranking-prompt-description",
        "defaultMessage": "Select <Bold>clear sorting</Bold> to create and reorder work in specific positions."
    },
    clearSorting: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.clear-sorting",
        "defaultMessage": "Clear sorting"
    },
    viewWorkItem: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.view-work-item",
        "defaultMessage": "View {issueKey}"
    },
    issueHiddenDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.issue-hidden-description",
        "defaultMessage": "<Bold>{issueKey}</Bold> is hidden because a filter is applied. Clear the filter to see all issues."
    }
});

});



parcelRegister("17oPt", function(module, exports) {

$parcel$export(module.exports, "useQueuedMutationCommit", () => $fd50c90398a7b93d$export$4eb3ddef28ed9675);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");
const $fd50c90398a7b93d$export$4eb3ddef28ed9675 = ({ generateDeferredVariables: generateDeferredVariables })=>{
    const running = (0, $5uXOq.useRef)(false);
    const queue = (0, $5uXOq.useRef)([]);
    /**
   * Dispose of any queued commits (in backwards order) and requeue each commit (which will execute the first commit
   * immediately). We need to explicitly dispose and requeue commits so optimistic updates are performed in the
   * correct order when the first queued commit is executed.
   */ const dequeue = (0, $5uXOq.useCallback)(()=>{
        running.current = false;
        const requeue = [];
        while(queue.current.length){
            const entry = queue.current.pop();
            if (entry) {
                entry.dispose();
                requeue.unshift(entry.requeue);
            }
        }
        requeue.forEach((fn)=>fn());
    }, []);
    const queuedCommit = (0, $5uXOq.useCallback)((environment, config)=>{
        const disposables = [];
        const requeue = ()=>{
            disposables.push(queuedCommit(environment, config));
        };
        const dispose = ()=>{
            while(disposables.length)disposables.pop()?.dispose();
        };
        const commit = ()=>{
            running.current = true;
            const disposable = (0, $8Uumt.commitMutation)(environment, {
                ...config,
                variables: generateDeferredVariables ? generateDeferredVariables(config.variables) : config.variables,
                onCompleted: (response, errors)=>{
                    // Run any queued commits after the mutation has completed
                    dequeue();
                    config.onCompleted?.(response, errors);
                },
                onError: (error)=>{
                    // Run any queued commits after the mutation has failed
                    dequeue();
                    config.onError?.(error);
                }
            });
            disposables.push(disposable);
        };
        if (!running.current) commit();
        else {
            const optimisticDisposable = (0, $8Uumt.applyOptimisticMutation)(environment, config);
            disposables.push(optimisticDisposable);
            queue.current.push({
                requeue: requeue,
                dispose: dispose
            });
        }
        // Return a new disposable that cleans up the optimistic AND committed operations
        return {
            dispose: dispose
        };
    }, [
        dequeue,
        generateDeferredVariables
    ]);
    return queuedCommit;
};

});

parcelRegister("i07Ny", function(module, exports) {

$parcel$export(module.exports, "issueConnectionUpdater", () => $87a339949fd8ce19$export$340227f0fce3ad1b);
$parcel$export(module.exports, "removeHighlightAfterDelay", () => $87a339949fd8ce19$export$c6f131ddea3d52b7);

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $1z24L = parcelRequire("1z24L");

var $czfFt = parcelRequire("czfFt");

var $MMunf = parcelRequire("MMunf");

var $jlRQW = parcelRequire("jlRQW");
const $87a339949fd8ce19$export$340227f0fce3ad1b = (store, { issue: issue, issueConnectionId: issueConnectionId, parentItemConnectionId: parentItemConnectionId, issueRecordId: issueRecordId, fieldSetsConnectionId: fieldSetsConnectionId, insertAfter: insertAfter = true, insertNodeId: insertNodeId, getRealId: getRealId = (id)=>id, projectKey: projectKey, groupId: groupId })=>{
    (0, $1z24L.highlightIssueRow)(store, issue, true);
    const issueRecord = store.get(issueRecordId);
    const connectionRecord = store.get(issueConnectionId);
    const fieldSetsRecord = store.get(fieldSetsConnectionId);
    if (!issueRecord || !connectionRecord || !fieldSetsRecord) return;
    if (parentItemConnectionId) {
        const updateArgs = projectKey ? {
            filterByProjectKeys: [
                projectKey
            ]
        } : undefined;
        store.get(parentItemConnectionId)?.setValue(true, 'hasChildren', updateArgs);
    }
    const edge = (0, $8Uumt.ConnectionHandler).createEdge(store, connectionRecord, issueRecord, 'JiraIssueEdge');
    // don't insert the same edge in case optimisticUpdater gets called multiple times
    if ((0, $jlRQW.hasEdge)(connectionRecord, edge) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) return;
    if ((0, $4R6GH.fg)('jsc_canhavechildren_edge_update')) {
        const updateArgs = projectKey ? {
            projectKey: projectKey
        } : undefined;
        const canHaveChildIssues = issueRecord.getValue('canHaveChildIssues', updateArgs);
        if (canHaveChildIssues) edge.setValue(true, 'canHaveChildIssues', updateArgs);
    }
    let realNodeId = insertNodeId;
    if (insertNodeId != null) realNodeId = getRealId(insertNodeId) ?? insertNodeId;
    if (insertAfter) (0, $jlRQW.insertEdgeAfter)(connectionRecord, edge, realNodeId);
    else (0, $jlRQW.insertEdgeBefore)(connectionRecord, edge, realNodeId);
    const fieldSets = edge.getOrCreateLinkedRecord('fieldSets', 'JiraIssueFieldSetEdge', {
        first: 500
    });
    fieldSets.copyFieldsFrom(fieldSetsRecord);
    const totalIssues = connectionRecord.getValue('totalIssueSearchResultCount');
    if (totalIssues != null && typeof totalIssues === 'number') connectionRecord.setValue(totalIssues + 1, 'totalIssueSearchResultCount');
    if (groupId && (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_')) (0, $MMunf.updateGroupIssueCount)({
        store: store,
        groupId: groupId,
        netChangeInIssueCount: 1
    });
};
const $87a339949fd8ce19$export$c6f131ddea3d52b7 = (environment, issue)=>{
    setTimeout(()=>{
        (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            (0, $1z24L.highlightIssueRow)(store, issue, false);
        });
    }, (0, $czfFt.HIGHLIGHT_LINGER_DURATION_MS));
};

});
parcelRegister("1z24L", function(module, exports) {

$parcel$export(module.exports, "highlightIssueRow", () => $5dda4e80dcdfd12c$export$53e8a18b32fbb0d6);

var $cxDFA = parcelRequire("cxDFA");
const $5dda4e80dcdfd12c$export$53e8a18b32fbb0d6 = (store, issueRef, isHighlighted)=>{
    const { updatableData: updatableData } = store.readUpdatableFragment((0, $cxDFA.default), issueRef);
    updatableData.isHighlightedIssueRow = isHighlighted;
};

});
parcelRegister("cxDFA", function(module, exports) {

$parcel$export(module.exports, "default", () => $64ff9953eb0226e1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cbfd986a9695ce8be5f34b186061834a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $64ff9953eb0226e1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "highlightIssueRow_update_isHighlightedIssueRow",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isHighlightedIssueRow"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$64ff9953eb0226e1$var$node.hash = "5d94f587c290893134bcec9a782eee62";
var $64ff9953eb0226e1$export$2e2bcd8739ae039 = $64ff9953eb0226e1$var$node;

});


parcelRegister("MMunf", function(module, exports) {

$parcel$export(module.exports, "getIssueIndexInConnection", () => $d71adfea6671940f$export$fc68d8bf4e03e424);
$parcel$export(module.exports, "updateGroupIssueCount", () => $d71adfea6671940f$export$9d5e7224bfc56344);
$parcel$export(module.exports, "updateParentHasChildren", () => $d71adfea6671940f$export$49a0ddeeed46a5b);
$parcel$export(module.exports, "useUpdateConnectionDetails", () => $d71adfea6671940f$export$8ce878b875ed1164);
$parcel$export(module.exports, "insertNewGroupInGroupsConnection", () => $d71adfea6671940f$export$4369efd6760b11d0);

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");

var $iJZ8l = parcelRequire("iJZ8l");

var $4R6GH = parcelRequire("4R6GH");

var $5FoyW = parcelRequire("5FoyW");
const $d71adfea6671940f$var$JIRA_SPREADSHEET_GROUP_TYPENAME = 'JiraSpreadsheetGroup';
const $d71adfea6671940f$export$fc68d8bf4e03e424 = ({ issues: issues, issuesWithContext: issuesWithContext, context: context })=>{
    let foundMovedIssue = false;
    // There is a possible race condition where the bulk query for positions fires without all the issue subscriptions arriving (when an issue is created right as the timeout for the client finishes)
    // In those cases, we should use relative positioning instead of the absolute position where possible to prevent issues from being inserted at the wrong position
    const relativeIssueIndex = issues.findIndex((issue)=>{
        const issueId = issue.getLinkedRecord('node')?.getValue('issueId');
        if (issueId === context.sourceIssueId) foundMovedIssue = true;
        if (!issueId || typeof issueId === 'string' && issuesWithContext.has(issueId)) return false;
        return issueId === context.afterIssueId || issueId === context.beforeIssueId;
    });
    let relativePosition;
    if (relativeIssueIndex !== -1) {
        const relativeIssue = issues[relativeIssueIndex];
        const relativeIssueId = relativeIssue?.getLinkedRecord('node')?.getValue('issueId');
        if (relativeIssueId === context.afterIssueId) relativePosition = relativeIssueIndex;
        else if (relativeIssueId === context.beforeIssueId) relativePosition = relativeIssueIndex + 1;
        if (foundMovedIssue && relativePosition != null) // if we moved the issue down the list, we need to adjust the position otherwise its original position in the list impacts the index of all issues after
        relativePosition -= 1;
    }
    return relativePosition ?? context.position;
};
const $d71adfea6671940f$var$removeGroupFromConnection = ({ store: store, groupId: groupId, connectionId: connectionId, groupConnectionId: groupConnectionId })=>{
    if (!groupConnectionId) return;
    if (connectionId) {
        // invalidate connection for next incoming updates.
        const connectionRecord = store.get(connectionId);
        connectionRecord?.invalidateRecord();
    }
    const relayId = (0, $iJZ8l.default)({
        id: groupId
    }, $d71adfea6671940f$var$JIRA_SPREADSHEET_GROUP_TYPENAME);
    const groupConnectionRecord = store.get(groupConnectionId);
    if (!groupConnectionRecord || !relayId) return;
    (0, $eiowN.ConnectionHandler).deleteNode(groupConnectionRecord, relayId);
    // Remove the firstGroup reference if it's the same as the group being removed
    if (groupConnectionRecord.getLinkedRecord('firstGroup')?.getDataID() === relayId) groupConnectionRecord.setValue(null, 'firstGroup');
};
const $d71adfea6671940f$export$9d5e7224bfc56344 = ({ store: store, groupId: groupId, netChangeInIssueCount: netChangeInIssueCount, groupConnectionId: groupConnectionId, connectionId: connectionId })=>{
    const relayId = (0, $iJZ8l.default)({
        id: groupId
    }, $d71adfea6671940f$var$JIRA_SPREADSHEET_GROUP_TYPENAME);
    if (!relayId) return;
    const groupRecord = store.get(relayId);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueCount = groupRecord?.getValue('issueCount') || 0;
    const newIssueCount = issueCount + netChangeInIssueCount;
    if (newIssueCount <= 0) $d71adfea6671940f$var$removeGroupFromConnection({
        store: store,
        groupId: groupId,
        connectionId: connectionId,
        groupConnectionId: groupConnectionId
    });
    else groupRecord?.setValue(newIssueCount, 'issueCount');
};
const $d71adfea6671940f$export$49a0ddeeed46a5b = ({ store: store, parentIssueEdgeRecordId: parentIssueEdgeRecordId, connectionId: connectionId, hasChildren: hasChildren, projectKey: projectKey })=>{
    // returns whether an update was performed
    const parentIssueRecord = store.get(parentIssueEdgeRecordId);
    const updateArgs = projectKey ? {
        filterByProjectKeys: [
            projectKey
        ]
    } : undefined;
    if (parentIssueRecord && parentIssueRecord.getValue('hasChildren', updateArgs) !== hasChildren) {
        parentIssueRecord?.setValue(hasChildren, 'hasChildren', updateArgs);
        if (hasChildren === false && connectionId && (0, $4R6GH.fg)('jsc_list_reparenting')) {
            const connectionRecord = store.get(connectionId);
            connectionRecord?.invalidateRecord();
        }
        return true;
    }
    return false;
};
const $d71adfea6671940f$export$8ce878b875ed1164 = ()=>{
    const { removeConnection: removeConnectionFromList } = (0, $5FoyW.useConnectionsListActions)();
    return (0, $5uXOq.useCallback)(({ store: store, connection: connection, netChangeInIssueCount: netChangeInIssueCount, remainingIssueCount: remainingIssueCount, groupConnectionId: groupConnectionId, projectKey: projectKey })=>{
        if (remainingIssueCount === undefined) return;
        switch(connection.type){
            case 'GROUP_CHILDREN':
                $d71adfea6671940f$export$9d5e7224bfc56344({
                    store: store,
                    groupId: connection.groupId,
                    netChangeInIssueCount: netChangeInIssueCount,
                    groupConnectionId: groupConnectionId,
                    connectionId: connection.connectionId
                });
                break;
            case 'PARENT_CHILDREN':
                $d71adfea6671940f$export$49a0ddeeed46a5b({
                    store: store,
                    parentIssueEdgeRecordId: connection.parentRelayId,
                    connectionId: connection.connectionId,
                    hasChildren: remainingIssueCount > 0,
                    projectKey: projectKey
                });
                break;
            case 'ROOT_ISSUES':
                {
                    const connectionRecord = store.get(connection.connectionId);
                    if (!connectionRecord) break;
                    const totalIssues = connectionRecord.getValue('totalIssueSearchResultCount');
                    if (totalIssues != null && typeof totalIssues === 'number') connectionRecord.setValue(totalIssues + netChangeInIssueCount, 'totalIssueSearchResultCount');
                    break;
                }
            default:
        }
        if (remainingIssueCount === 0) removeConnectionFromList(connection);
    }, [
        removeConnectionFromList
    ]);
};
function $d71adfea6671940f$var$insertEdgeAtPosition(existingEdges, newEdge, index) {
    return [
        ...existingEdges.slice(0, index),
        newEdge,
        ...existingEdges.slice(index)
    ];
}
const $d71adfea6671940f$export$4369efd6760b11d0 = ({ store: store, groupsConnection: groupsConnection, newGroup: newGroup, groupEdges: groupEdges, afterGroupId: afterGroupId })=>{
    const newGroupEdge = (0, $eiowN.ConnectionHandler).createEdge(store, groupsConnection, newGroup, 'JiraSpreadsheetGroupEdge');
    if (afterGroupId === null) return $d71adfea6671940f$var$insertEdgeAtPosition(groupEdges, newGroupEdge, 0);
    const afterGroupIndex = groupEdges.findIndex((edge)=>edge.getLinkedRecord('node')?.getValue('id') === afterGroupId);
    if (afterGroupIndex !== -1) return $d71adfea6671940f$var$insertEdgeAtPosition(groupEdges, newGroupEdge, afterGroupIndex + 1);
    return groupEdges;
};

});

parcelRegister("jlRQW", function(module, exports) {

$parcel$export(module.exports, "insertEdgeBefore", () => $9817d114ba3f6103$export$af841f09852c57d0);
$parcel$export(module.exports, "insertEdgeAfter", () => $9817d114ba3f6103$export$10e6263a191d72a0);
$parcel$export(module.exports, "hasEdge", () => $9817d114ba3f6103$export$da04cd0b23213625);

var $eiowN = parcelRequire("eiowN");
const $9817d114ba3f6103$var$findEdgeIndex = (edges, id)=>{
    if (id == null) return -1;
    const { NODE: NODE } = (0, $eiowN.ConnectionInterface).get();
    return edges.findIndex((edge)=>edge.getLinkedRecord(NODE)?.getValue('id') === id);
};
const $9817d114ba3f6103$export$af841f09852c57d0 = (record, newEdge, id)=>{
    const { EDGES: EDGES } = (0, $eiowN.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES) ?? [];
    const index = $9817d114ba3f6103$var$findEdgeIndex(edges, id);
    let nextEdges;
    if (index === -1) nextEdges = [
        newEdge
    ].concat(edges);
    else nextEdges = edges.slice(0, index).concat(newEdge).concat(edges.slice(index));
    record.setLinkedRecords(nextEdges, EDGES);
};
const $9817d114ba3f6103$export$10e6263a191d72a0 = (record, newEdge, id)=>{
    const { EDGES: EDGES } = (0, $eiowN.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES) ?? [];
    const index = $9817d114ba3f6103$var$findEdgeIndex(edges, id);
    let nextEdges;
    if (index === -1) nextEdges = edges.concat(newEdge);
    else nextEdges = edges.slice(0, index + 1).concat(newEdge).concat(edges.slice(index + 1));
    record.setLinkedRecords(nextEdges, EDGES);
};
const $9817d114ba3f6103$export$da04cd0b23213625 = (record, edge)=>{
    const { NODE: NODE, EDGES: EDGES } = (0, $eiowN.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES) ?? [];
    const edgeIndex = edges.findIndex((e)=>e.getLinkedRecord(NODE)?.getValue('id') === edge.getLinkedRecord(NODE)?.getValue('id'));
    return edgeIndex > -1;
};

});


parcelRegister("67mCE", function(module, exports) {

$parcel$export(module.exports, "IssueFetchQueryVariablesContainer", () => $e374da3cb300fee1$export$72556f17a9cf678b);
$parcel$export(module.exports, "useIssueFetchQueryVariables", () => $e374da3cb300fee1$export$52ce8dcf7591a458);

var $ajpes = parcelRequire("ajpes");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $e374da3cb300fee1$export$72556f17a9cf678b = (0, $gg7kZ.createContainer)();
const $e374da3cb300fee1$export$d4c72bab9d6cc13a = {
    fieldSetIds: []
};
const $e374da3cb300fee1$var$updateStore = ()=>({ setState: setState, getState: getState }, { fieldSetIds: fieldSetIds })=>{
        const state = getState();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(fieldSetIds, state.fieldSetIds)) setState({
            fieldSetIds: fieldSetIds
        });
    };
const $e374da3cb300fee1$var$Store = (0, $iXqE5.createStore)({
    containedBy: $e374da3cb300fee1$export$72556f17a9cf678b,
    initialState: $e374da3cb300fee1$export$d4c72bab9d6cc13a,
    actions: {},
    handlers: {
        onInit: $e374da3cb300fee1$var$updateStore,
        onContainerUpdate: $e374da3cb300fee1$var$updateStore
    }
});
const $e374da3cb300fee1$export$52ce8dcf7591a458 = (0, $3sQ5x.createStateHook)($e374da3cb300fee1$var$Store);

});

parcelRegister("8S82V", function(module, exports) {

$parcel$export(module.exports, "useIssueFetchAndAppend", () => $7b3e2c0453b9da6f$export$e36c00c1dfa0c592);

var $bxPYe = parcelRequire("bxPYe");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koeKL = parcelRequire("koeKL");

var $eOucw = parcelRequire("eOucw");

var $4R6GH = parcelRequire("4R6GH");

var $e9M6d = parcelRequire("e9M6d");

var $i07Ny = parcelRequire("i07Ny");

var $67mCE = parcelRequire("67mCE");
const $7b3e2c0453b9da6f$var$issueConnectionQueryUpdater = (environment, response, issueConnectionId, insertionArgs, groupId)=>{
    const issue = response?.jira?.issueByKey;
    if (!issue) return;
    (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
        (0, $i07Ny.issueConnectionUpdater)(store, {
            ...insertionArgs,
            issue: issue,
            issueConnectionId: issueConnectionId,
            issueRecordId: issue.__id,
            fieldSetsConnectionId: issue.fieldSetsById.__id,
            groupId: groupId
        });
    });
    (0, $i07Ny.removeHighlightAfterDelay)(environment, issue);
};
const $7b3e2c0453b9da6f$export$e36c00c1dfa0c592 = ({ issueConnectionId: issueConnectionId, groupContextFieldInput: groupContextFieldInput, jql: jql })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const isDensityFull = (0, $e9M6d.useIsDensityFull)();
    const isInlineEditingEnabled = (0, $e9M6d.useIsInlineEditingEnabled)();
    const { fieldSetIds: fieldSetIds } = (0, $67mCE.useIssueFetchQueryVariables)();
    let shouldSkipIssuesConnectionUpdate;
    if ((0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_')) // eslint-disable-next-line react-hooks/rules-of-hooks
    shouldSkipIssuesConnectionUpdate = (0, $eOucw.useShouldSkipIssuesConnectionUpdate)();
    return (0, $5uXOq.useCallback)((issueKey, insertionArgs)=>{
        if (!issueConnectionId) return null;
        (0, $8Uumt.fetchQuery)(environment, (0, $bxPYe.default), {
            cloudId: cloudId,
            issueKey: issueKey,
            fieldSetIds: fieldSetIds,
            isInlineEditingEnabled: isInlineEditingEnabled,
            isDensityFull: isDensityFull,
            ...groupContextFieldInput && (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? {
                shouldQueryFieldsByIdOrAlias: true,
                fieldIdsOrAliases: [
                    groupContextFieldInput.fieldId
                ]
            } : {
                shouldQueryFieldsByIdOrAlias: false,
                fieldIdsOrAliases: []
            },
            ...jql && (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? {
                shouldQueryMatchesIssueSearch: true,
                issueSearchInput: {
                    jql: jql
                }
            } : {
                shouldQueryMatchesIssueSearch: false,
                issueSearchInput: {
                    jql: ''
                }
            }
        }).subscribe({
            next: (data)=>{
                if (shouldSkipIssuesConnectionUpdate?.(groupContextFieldInput, data?.jira?.issueByKey)) return;
                $7b3e2c0453b9da6f$var$issueConnectionQueryUpdater(environment, data, issueConnectionId, insertionArgs, groupContextFieldInput?.groupId);
            }
        });
    }, [
        cloudId,
        environment,
        fieldSetIds,
        isDensityFull,
        isInlineEditingEnabled,
        issueConnectionId,
        groupContextFieldInput,
        jql,
        shouldSkipIssuesConnectionUpdate
    ]);
};

});
parcelRegister("bxPYe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95cd7ad294f5555$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c623a67be2c113aeb31cff3e26f3ba26>>
 * @relayHash b71bb98ec57a1465cafefd029e516a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d7ae2f99294908c1c985e9e4da33ee3113ec9c6391c49f6eaa78a987c97ca8a

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $c95cd7ad294f5555$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldIdsOrAliases"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldsByIdOrAlias"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryMatchesIssueSearch"
    }, v9 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v12 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v13 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v14 = [
        {
            "kind": "Variable",
            "name": "idsOrAliases",
            "variableName": "fieldIdsOrAliases"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v17 = {
        "kind": "ScalarField",
        "name": "statusId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v21 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v22 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            v24 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v26 = {
        "condition": "shouldQueryMatchesIssueSearch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "kind": "ScalarField",
                "name": "matchesIssueSearch"
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "type"
    }, v28 = {
        "kind": "ScalarField",
        "name": "id"
    }, v29 = {
        "kind": "ScalarField",
        "name": "value"
    }, v30 = [
        v29 /*: any*/ ,
        v28 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v31 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v32 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v33 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v34 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v35 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v36 = {
        "kind": "ScalarField",
        "name": "text"
    }, v37 = {
        "kind": "InlineFragment",
        "selections": [
            v36 /*: any*/ ,
            v18 /*: any*/ ,
            v31 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v38 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v39 = [
        v38 /*: any*/ 
    ], v40 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v28 /*: any*/ 
        ]
    }, v41 = [
        v40 /*: any*/ 
    ], v42 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v43 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v44 = [
        v18 /*: any*/ ,
        v28 /*: any*/ 
    ], v45 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v46 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v47 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v46 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v48 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v36 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v49 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v50 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v51 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v50 /*: any*/ ,
                    v18 /*: any*/ ,
                    v28 /*: any*/ 
                ]
            },
            v28 /*: any*/ 
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v53 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueFetchAndAppendQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "highlightIssueRow_update_isHighlightedIssueRow"
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v12 /*: any*/ ,
                                        "concreteType": "JiraIssueFieldSetConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldSetsById",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isDensityFull",
                                                        "variableName": "isDensityFull"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isInlineEditingEnabled",
                                                        "variableName": "isInlineEditingEnabled"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
                                            },
                                            v13 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.issueByKey.fieldSetsById"
                                },
                                {
                                    "condition": "shouldQueryFieldsByIdOrAlias",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v14 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "fieldsByIdOrAlias",
                                            "plural": true,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                v18 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "fieldOption",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v22 /*: any*/ ,
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v23 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedSprintsConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                v25 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v26 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueFetchAndAppendQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraIssueFieldSetConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldSetsById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSet",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v27 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldSetId"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fields",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v15 /*: any*/ ,
                                                                                v16 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                },
                                                                                v28 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "serviceId"
                                                                                                                },
                                                                                                                v18 /*: any*/ ,
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraAffectedServicesField"
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "cascadingOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v30 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v30 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCascadingSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v32 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v33 /*: any*/ ,
                                                                                                                        v34 /*: any*/ ,
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                },
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        v37 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commentSummary",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canAddComment"
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCommentSummaryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "uri"
                                                                                                },
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraUrlField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": v39 /*: any*/ 
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v29 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": v41 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": v41 /*: any*/ 
                                                                                                        },
                                                                                                        v28 /*: any*/ ,
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v29 /*: any*/ ,
                                                                                                                        v21 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v29 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v15 /*: any*/ ,
                                                                                                                        v20 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v43 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "email"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraTeamView",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedTeam",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTeamViewField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "timeTrackingField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                v31 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraEstimate",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "originalEstimate",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "timeInSeconds"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingSettings",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "workingHoursPerDay"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "workingDaysPerWeek"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "defaultFormat"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "defaultUnit"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v16 /*: any*/ ,
                                                                                                                v18 /*: any*/ ,
                                                                                                                v27 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "label",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "value"
                                                                                                        },
                                                                                                        v28 /*: any*/ ,
                                                                                                        v33 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v32 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v33 /*: any*/ ,
                                                                                                                        v34 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "versionId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                },
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "args": v32 /*: any*/ ,
                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGoals",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v13 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                },
                                                                                                v31 /*: any*/ ,
                                                                                                v13 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraGoalsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v32 /*: any*/ ,
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "href"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                },
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "objectId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "label"
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "mediaClientConfig",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "clientId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "fileId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "url48"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "QueryError",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "errors",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "message"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraCMDBField"
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": "componentsOld",
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v44 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v36 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "date"
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v45 /*: any*/ ,
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDatePickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v35 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDateTimePickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraEpic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "epic",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v10 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "summary"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "color"
                                                                                                },
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraEpicLinkField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "renderedFieldHtml"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraFallbackField"
                                                                                },
                                                                                v37 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatusCategory",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "statusCategory",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v46 /*: any*/ ,
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusCategoryField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v47 /*: any*/ ,
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": v32 /*: any*/ ,
                                                                                            "concreteType": "JiraLabelConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedLabelsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraLabel",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v38 /*: any*/ 
                                                                                            ],
                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraLabelsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAvatar",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "avatar",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "small"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "parentIssue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v10 /*: any*/ ,
                                                                                                v48 /*: any*/ ,
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        v49 /*: any*/ ,
                                                                                                        v51 /*: any*/ ,
                                                                                                        v48 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        v49 /*: any*/ ,
                                                                                                        v51 /*: any*/ ,
                                                                                                        v48 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v52 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "ids",
                                                                                                                    "value": [
                                                                                                                        "summary",
                                                                                                                        "issuetype",
                                                                                                                        "status"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsById",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v15 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                        v36 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueType",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "issueTypeId"
                                                                                                                                                },
                                                                                                                                                v18 /*: any*/ ,
                                                                                                                                                v50 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "hierarchy",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "level"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                v28 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "status",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                v28 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraStatusField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v31 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraParentIssueField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraPriorityField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraProject",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "project",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v10 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraAvatar",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "avatar",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "large"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraResolution",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "resolution",
                                                                                            "plural": false,
                                                                                            "selections": v44 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraResolutionField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraSprintConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedSprintsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprint",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                v23 /*: any*/ ,
                                                                                                                v18 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "state"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "endDate"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSprintField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                v20 /*: any*/ ,
                                                                                                v42 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v43 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v45 /*: any*/ ,
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        {
                                                                                            "args": v32 /*: any*/ ,
                                                                                            "concreteType": "JiraVersionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedVersionsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": v44 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraRichText",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "richText",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraADF",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "adfValue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "condition": "isDensityFull",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "convertedPlainText",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "plainText"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "isDensityFull",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "json"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraRichTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "requestType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v50 /*: any*/ ,
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": v22 /*: any*/ ,
                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueLinkConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v38 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "args": [
                                                                                                                                {
                                                                                                                                    "kind": "Literal",
                                                                                                                                    "name": "ids",
                                                                                                                                    "value": [
                                                                                                                                        "statusCategory"
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldsById",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v15 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v47 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                },
                                                                                                                                                v28 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                        },
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "relationName"
                                                                                                                },
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueLinkField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isStoryPointField"
                                                                                        },
                                                                                        v24 /*: any*/ ,
                                                                                        v18 /*: any*/ ,
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                v24 /*: any*/ ,
                                                                                                v53 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                v24 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v31 /*: any*/ ,
                                                                                                v53 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraNumberField"
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraFlag",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "flag",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isFlagged"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFlagField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": v39 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ]
                                },
                                v28 /*: any*/ ,
                                {
                                    "condition": "shouldQueryFieldsByIdOrAlias",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v14 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "fieldsByIdOrAlias",
                                            "plural": true,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v28 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v28 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v20 /*: any*/ ,
                                                                v28 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "fieldOption",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v28 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v22 /*: any*/ ,
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v23 /*: any*/ ,
                                                                                v28 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedSprintsConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                v25 /*: any*/ ,
                                                v28 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v26 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3d7ae2f99294908c1c985e9e4da33ee3113ec9c6391c49f6eaa78a987c97ca8a",
            "metadata": {},
            "name": "issueFetchAndAppendQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$c95cd7ad294f5555$var$node.hash = "bdae245e29fd8cf9c816becb37ae7bae";
var $c95cd7ad294f5555$export$2e2bcd8739ae039 = $c95cd7ad294f5555$var$node;

});


parcelRegister("3c1eX", function(module, exports) {

$parcel$export(module.exports, "toIssueCreateInput", () => $b8c1bda33e09e92d$export$8430ab93380b81ae);

var $3dHKF = parcelRequire("3dHKF");

var $4R6GH = parcelRequire("4R6GH");

var $4N2h5 = parcelRequire("4N2h5");
const $b8c1bda33e09e92d$var$mapContextualFieldDataToInput = (payload)=>{
    let rank;
    if (payload.rankBeforeIssueId) rank = {
        beforeIssueId: payload.rankBeforeIssueId
    };
    else if (payload.rankAfterIssueId) rank = {
        afterIssueId: payload.rankAfterIssueId
    };
    return {
        rank: rank
    };
};
const $b8c1bda33e09e92d$export$8430ab93380b81ae = ({ project: project, issueType: issueType, summary: summary }, contextualFields, groupContextFieldInput, insertionArgs, isIssueRankingEnabled)=>{
    if (!summary.trim().length) return null;
    const input = {
        projectId: project.id,
        issueTypeId: issueType.id,
        fields: {
            singleLineTextFields: [
                {
                    fieldId: 'summary',
                    text: summary
                }
            ],
            ...contextualFields.parentIssueAri !== undefined && {
                parentField: {
                    issueId: contextualFields.parentIssueAri
                }
            },
            ...groupContextFieldInput && (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') && (0, $4N2h5.convertFieldToIssueCreateInput)(groupContextFieldInput)
        },
        rank: insertionArgs && isIssueRankingEnabled && (0, $4R6GH.fg)('jsc_list_reranking_gate_technical') ? {
            beforeIssueId: insertionArgs.insertAfter ? insertionArgs.insertNodeId : undefined,
            afterIssueId: insertionArgs.insertAfter ? undefined : insertionArgs.insertNodeId
        } : undefined
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3dHKF)))(input, $b8c1bda33e09e92d$var$mapContextualFieldDataToInput(contextualFields), (objValue, srcValue)=>{
        if (Array.isArray(objValue)) return objValue.concat(srcValue);
    });
};

});

parcelRegister("28vJk", function(module, exports) {

$parcel$export(module.exports, "toOptimisticResponse", () => $5fd459ca043dae72$export$79353fa5e28d43d8);

var $4R6GH = parcelRequire("4R6GH");

var $4N2h5 = parcelRequire("4N2h5");
const $5fd459ca043dae72$export$79353fa5e28d43d8 = ({ project: project, issueType: issueType, summary: summary }, optimisticId, isIssueHierarchyEnabled, groupContextFieldInput)=>{
    const issueId = optimisticId;
    const summaryEdge = summary ? $5fd459ca043dae72$var$toOptimisticSummary(issueId, summary) : null;
    const projectEdge = project ? $5fd459ca043dae72$var$toOptimisticProject(issueId, project) : null;
    const issueTypeEdge = issueType ? $5fd459ca043dae72$var$toOptimisticIssueType(issueId, issueType) : null;
    const edges = [
        summaryEdge,
        projectEdge,
        issueTypeEdge
    ];
    if (groupContextFieldInput && (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_')) {
        const groupContextFieldEdge = (0, $4N2h5.toOptimisticField)(issueId, groupContextFieldInput);
        edges.push(groupContextFieldEdge);
    }
    return {
        jira: {
            createIssue: {
                errors: null,
                issue: {
                    __typename: 'JiraIssue',
                    id: issueId,
                    issueId: issueId,
                    key: '',
                    fieldsByIdOrAlias: [],
                    fieldSetsById: {
                        edges: edges
                    },
                    matchesIssueSearch: undefined,
                    ...isIssueHierarchyEnabled ? {
                        issueTypeField: {
                            issueType: {
                                hierarchy: {
                                    level: issueType?.hierarchy?.level
                                },
                                id: issueType?.id
                            },
                            id: ''
                        },
                        canHaveChildIssues: false
                    } : {
                        issueTypeField: undefined,
                        canHaveChildIssues: undefined
                    }
                }
            }
        }
    };
};
const $5fd459ca043dae72$var$toOptimisticSummary = (issueId, summary)=>({
        node: {
            fieldSetId: 'summary',
            type: 'summary',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleLineTextField',
                            __isJiraIssueField: 'JiraSingleLineTextField',
                            fieldId: 'summary',
                            id: `${issueId}/summary`,
                            name: 'Summary',
                            text: summary,
                            type: 'summary',
                            lazyIsEditableInIssueView: undefined
                        }
                    }
                ]
            }
        }
    });
const $5fd459ca043dae72$var$toOptimisticIssueType = (issueId, issueType)=>({
        node: {
            fieldSetId: 'issuetype',
            type: 'issuetype',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraIssueTypeField',
                            __isJiraIssueField: 'JiraIssueTypeField',
                            fieldId: 'issuetype',
                            id: `${issueId}/issuetype`,
                            type: 'issuetype',
                            issueType: {
                                id: issueType.id,
                                name: issueType.name,
                                avatar: issueType.avatar
                            }
                        }
                    }
                ]
            }
        }
    });
const $5fd459ca043dae72$var$toOptimisticProject = (issueId, project)=>({
        node: {
            fieldSetId: 'project',
            type: 'project',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraProjectField',
                            __isJiraIssueField: 'JiraProjectField',
                            fieldId: 'project',
                            id: `${issueId}/project`,
                            type: 'project',
                            project: {
                                id: project.id,
                                key: project.key,
                                name: project.name,
                                avatar: project.avatar
                            }
                        }
                    }
                ]
            }
        }
    });

});

parcelRegister("2axqN", function(module, exports) {

$parcel$export(module.exports, "useOptimisticId", () => $2a9adb9218949f1d$export$753dc4430b354b6a);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");
const $2a9adb9218949f1d$export$753dc4430b354b6a = ()=>{
    const optimisticIDtoReal = (0, $5uXOq.useRef)(new Map());
    const generateOptimisticId = (0, $5uXOq.useCallback)(()=>{
        const id = (0, $7Jxgt.v4)();
        optimisticIDtoReal.current.set(id, undefined);
        return {
            id: id,
            saveRealId: (realId)=>{
                optimisticIDtoReal.current.set(id, realId);
            }
        };
    }, []);
    const getRealId = (0, $5uXOq.useCallback)((optimisticId)=>{
        return optimisticIDtoReal.current.get(optimisticId);
    }, []);
    return {
        generateOptimisticId: generateOptimisticId,
        getRealId: getRealId
    };
};

});



parcelRegister("ddMwE", function(module, exports) {

$parcel$export(module.exports, "PaginationControls", () => $22961ec39d7ab52d$export$ff17519edeb6015d);

var $02Jp6 = parcelRequire("02Jp6");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $xBgAj = parcelRequire("xBgAj");

var $3bDjY = parcelRequire("3bDjY");

var $jQtKF = parcelRequire("jQtKF");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9ttYE = parcelRequire("9ttYE");
const $22961ec39d7ab52d$var$getFirstPage = (data)=>{
    if (data?.pageCursors?.first) return data?.pageCursors.first.pageNumber;
    if (data?.pageCursors?.around?.length) return data?.pageCursors.around[0]?.pageNumber;
    return undefined;
};
const $22961ec39d7ab52d$var$getLastPage = (data)=>{
    if (data?.pageCursors?.last) return data?.pageCursors.last.pageNumber;
    if (data?.pageCursors?.around?.length) return data?.pageCursors.around[data?.pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $22961ec39d7ab52d$var$getPageCursor = (data, page)=>{
    const { first: first, last: last, around: around } = data?.pageCursors ?? {};
    if (page === first?.pageNumber) return first?.cursor ?? undefined;
    if (page === last?.pageNumber) return last?.cursor ?? undefined;
    return around?.find((pageCursor)=>page === pageCursor?.pageNumber)?.cursor ?? undefined;
};
const $22961ec39d7ab52d$export$ff17519edeb6015d = ({ issues: issues, onPageChange: onPageChange, isNewFooterOrderEnabled: isNewFooterOrderEnabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $02Jp6.default), issues);
    const [optimisticCurrentPage, setOptimisticCurrentPage] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        // Clear our optimistically set page number whenever fragment data changes.
        setOptimisticCurrentPage(null);
    }, [
        data
    ]);
    const pages = (0, $5uXOq.useMemo)(()=>{
        const firstPage = $22961ec39d7ab52d$var$getFirstPage(data) ?? 1;
        const lastPage = $22961ec39d7ab52d$var$getLastPage(data) ?? 1;
        return Array(lastPage - firstPage + 1).fill(undefined).map((_, i)=>firstPage + i);
    }, [
        data
    ]);
    const currentPage = optimisticCurrentPage ?? data?.pageCursors?.around?.find((pageCursor)=>pageCursor?.isCurrent)?.pageNumber ?? 1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onChange = (0, $5uXOq.useCallback)((_, page)=>{
        if (page === currentPage || optimisticCurrentPage !== null) return;
        const pageCursorToFetch = $22961ec39d7ab52d$var$getPageCursor(data, page);
        if (pageCursorToFetch != null) {
            setOptimisticCurrentPage(page);
            onPageChange(pageCursorToFetch);
            const attributes = {
                currentPage: currentPage,
                nextPage: page,
                randomAccess: Math.abs(page - currentPage) > 1,
                isLastPage: page === pages.length
            };
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'pageNumber'
            }), 'issueTablePagination', attributes);
        }
    }, [
        createAnalyticsEvent,
        currentPage,
        data,
        onPageChange,
        optimisticCurrentPage,
        pages.length
    ]); // Disable the pagination buttons while the selected page is optimistically rendered as we may not have page cursors
    // readily available for pages rendered on the UI.
    const OptimisticDisabledButtonRenderer = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ 'aria-label': ariaLabel, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": !ariaLabel && props.page ? formatMessage((0, $9ttYE.default).pageButtonPrefix, {
                page: props.page
            }) : ariaLabel,
            disabled: props.disabled || optimisticCurrentPage !== null
        }), [
        formatMessage,
        optimisticCurrentPage
    ]);
    const OptimisticDisabledButtonRendererWithTooltip = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ 'aria-label': ariaLabel, ...props }, ref)=>props.disabled && optimisticCurrentPage == null && data?.isCappingIssueSearchResult ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9ttYE.default).disabledButtonTooltipIssueTermRefresh : (0, $9ttYE.default).disabledButtonTooltip),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22961ec39d7ab52d$var$FullHeightDisabledButton, {
            tabIndex: 0,
            isDisabled: true,
            "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9ttYE.default).disabledButtonTooltipIssueTermRefresh : (0, $9ttYE.default).disabledButtonTooltip),
            "data-testid": "native-issue-table.ui.footer-renderer.pagination-controls.full-height-disabled-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": ariaLabel
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": ariaLabel,
            disabled: props.disabled || optimisticCurrentPage !== null
        }), [
        optimisticCurrentPage,
        data?.isCappingIssueSearchResult,
        formatMessage
    ]);
    const components = (0, $5uXOq.useMemo)(()=>{
        const OptimisticDisabledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(OptimisticDisabledButtonRenderer);
        const OptimisticDisabledButtonWithTooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)(OptimisticDisabledButtonRendererWithTooltip);
        return {
            Page: OptimisticDisabledButton,
            Previous: OptimisticDisabledButton,
            Next: OptimisticDisabledButtonWithTooltip
        };
    }, [
        OptimisticDisabledButtonRenderer,
        OptimisticDisabledButtonRendererWithTooltip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22961ec39d7ab52d$var$PaginationContainer, {
        isFlexCenter: isNewFooterOrderEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xBgAj.default), {
        testId: "native-issue-table.ui.footer-renderer.pagination-controls.pagination-controls",
        components: components,
        pages: pages,
        onChange: onChange,
        selectedIndex: currentPage - 1,
        max: 7,
        nextLabel: formatMessage((0, $9ttYE.default).nextButton),
        previousLabel: formatMessage((0, $9ttYE.default).prevButton)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $22961ec39d7ab52d$var$FullHeightDisabledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $jQtKF.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $22961ec39d7ab52d$var$PaginationContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexCenter: isFlexCenter, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o",
            __cmplp.isFlexCenter ? "_1bah1h6o" : "_1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("02Jp6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ec8926e2a2108d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3901018953637bca59dab12c8fc72e0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0ec8926e2a2108d$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "pageSize"
            }
        ],
        "kind": "Fragment",
        "name": "paginationControls_nativeIssueTable",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCappingIssueSearchResult"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    },
                    {
                        "kind": "Variable",
                        "name": "pageSize",
                        "variableName": "pageSize"
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "first",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$b0ec8926e2a2108d$var$node.hash = "f6c43af42ef3986e51936f79243f5544";
var $b0ec8926e2a2108d$export$2e2bcd8739ae039 = $b0ec8926e2a2108d$var$node;

});

parcelRegister("xBgAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaadfaafd170b3c$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $33etG = parcelRequire("33etG");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $5HBW9 = parcelRequire("5HBW9");

var $15F6T = parcelRequire("15F6T");

var $lmPue = parcelRequire("lmPue");

var $fc5SA = parcelRequire("fc5SA");

var $gRWrA = parcelRequire("gRWrA");
const $8aaadfaafd170b3c$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $8aaadfaafd170b3c$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))) : (0, (/*@__PURE__*/$parcel$interopDefault($6s76W)));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $8aaadfaafd170b3c$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        })
    });
}
function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, $fc5SA.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $fc5SA.emptyObject), max: max = 7, onChange: onChange = (0, $eGmKJ.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $lmPue.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $33etG.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$8aaadfaafd170b3c$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
            as: "li",
            xcss: $8aaadfaafd170b3c$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $15F6T.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $8aaadfaafd170b3c$var$styles.paginationMenu,
                    children: (0, $gRWrA.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $8aaadfaafd170b3c$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;

});
parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8f114aeec843a8c754b38083d324c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("ks8FD")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});
parcelRegister("ks8FD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee3d25fb52825f26$var$_react = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ee3d25fb52825f26$var$_baseNew = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ee3d25fb52825f26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee3d25fb52825f26$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $ee3d25fb52825f26$var$_react.default.createElement($ee3d25fb52825f26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$ee3d25fb52825f26$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $ee3d25fb52825f26$var$_default = module.exports.default = $ee3d25fb52825f26$var$ChevronLeftIcon;

});



parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("bpC55")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("5HBW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63acbbc2953d9b5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("15F6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $097dd42f19f41562$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("lmPue", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d144cd0d91a90ab$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $jldZL = parcelRequire("jldZL");
const $3d144cd0d91a90ab$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "li",
        testId: testId,
        xcss: $3d144cd0d91a90ab$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dS3PR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jldZL.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("fc5SA", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $cbef1c2cfb373aca$export$3f860eba1218f8d3);
const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};

});

parcelRegister("gRWrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fbac64848b775a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;

});


parcelRegister("jQtKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dbfcf6b8255255f$export$2e2bcd8739ae039);

var $47bDC = parcelRequire("47bDC");
/**
 * When the @atlaskit/button component is disabled it prevents mouse events being fired for the button, which prevents
 * tooltips showing https://atlassian.design/components/button/usage#disabled-buttons.
 * When you require a disabled button to show a tooltip on hover then the button should be wrapped in this element.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dbfcf6b8255255f$var$DisabledButtonWithTooltip = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "yhjexx-0"
})({
    display: 'inline-flex'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $47bDC.css)({
        cursor: 'not-allowed',
        // Disable pointer events for the button element which means 'event.preventDefault()' will not be
        // called from AK. This allows pointer events to bubble from our wrapping span element.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> button': {
            pointerEvents: 'none'
        }
    }) : '');
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$4dbfcf6b8255255f$export$2e2bcd8739ae039 = $4dbfcf6b8255255f$var$DisabledButtonWithTooltip;

});

parcelRegister("9ttYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $66b4bc75482a3c0f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $66b4bc75482a3c0f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    nextButton: {
        "id": "native-issue-table.footer-renderer.pagination-controls.next-button",
        "defaultMessage": "Next page"
    },
    prevButton: {
        "id": "native-issue-table.footer-renderer.pagination-controls.prev-button",
        "defaultMessage": "Previous page"
    },
    pageButtonPrefix: {
        "id": "native-issue-table.footer-renderer.pagination-controls.page-button-prefix",
        "defaultMessage": "Page {page}"
    },
    disabledButtonTooltip: {
        "id": "native-issue-table.footer-renderer.pagination-controls.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    },
    disabledButtonTooltipIssueTermRefresh: {
        "id": "native-issue-table.footer-renderer.pagination-controls.disabled-button-tooltip-issue-term-refresh",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more work."
    }
});

});



parcelRegister("hmiXQ", function(module, exports) {

$parcel$export(module.exports, "IssueFetchQueryVariables", () => $59ec760f602a4a06$export$2cef1066f7674208);

var $1JArL = parcelRequire("1JArL");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $67mCE = parcelRequire("67mCE");
const $59ec760f602a4a06$export$2cef1066f7674208 = ({ children: children, columns: columns })=>{
    const columnsData = (0, $8Uumt.useFragment)((0, $1JArL.default), columns);
    const fieldSetIds = (0, $5uXOq.useMemo)(()=>columnsData.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        columnsData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67mCE.IssueFetchQueryVariablesContainer), {
        fieldSetIds: fieldSetIds
    }, children);
};

});
parcelRegister("1JArL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2824f2fbde8704f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<20ba60668b078076c74952de9fab8952>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2824f2fbde8704f8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueFetchQueryVariables_nativeIssueTable",
    "selections": [
        {
            "concreteType": "JiraIssueSearchFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fieldSetId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$2824f2fbde8704f8$var$node.hash = "03290a1a84f19d99043c011485a36598";
var $2824f2fbde8704f8$export$2e2bcd8739ae039 = $2824f2fbde8704f8$var$node;

});


parcelRegister("9dYOM", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa6bfbccb1e9b3fa$export$2e2bcd8739ae039);

var $7ciLI = parcelRequire("7ciLI");

var $5of86 = parcelRequire("5of86");

var $k1JRo = parcelRequire("k1JRo");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $7mPT9 = parcelRequire("7mPT9");

var $fc4cz = parcelRequire("fc4cz");

var $czfFt = parcelRequire("czfFt");

var $hW5gq = parcelRequire("hW5gq");

var $2BpVt = parcelRequire("2BpVt");

var $e9M6d = parcelRequire("e9M6d");

var $lR6JR = parcelRequire("lR6JR");

var $5VaIm = parcelRequire("5VaIm");

var $3LBoo = parcelRequire("3LBoo");

var $hTC96 = parcelRequire("hTC96");

var $eT3Vu = parcelRequire("eT3Vu");

var $4nnug = parcelRequire("4nnug");

var $jWEOv = parcelRequire("jWEOv");

var $evoSk = parcelRequire("evoSk");

var $9uKCK = parcelRequire("9uKCK");
const $aa6bfbccb1e9b3fa$var$emptyArray = []; // We use rowsCount=50 by default to set the minimum table height until virtualizer reads it from DOM
const $aa6bfbccb1e9b3fa$var$getInitialTableHeight = (rowsCount = 50)=>(0, $czfFt.ROW_HEIGHT) * rowsCount + (0, $czfFt.HEADER_HEIGHT);
const $aa6bfbccb1e9b3fa$var$IssueTable = ({ columnPickerProps: columnPickerProps, columns: columns, NoIssues: NoIssues, canViewColumnConfiguration: canViewColumnConfiguration, canEditColumnConfiguration: canEditColumnConfiguration, issueResults: issueResults, groupResults: groupResults, project: project, loading: loading, NoColumns: NoColumns, onColumnsChange: onColumnsChange, onResizeColumn: onResizeColumn, tableInjectedProps: tableInjectedProps, tableRef: tableRef, isGroupingSupported: isGroupingSupported, isCompactColumnEnabled: isCompactColumnEnabled = false, onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld, onIssueFlatListUpdated: onIssueFlatListUpdated, tableBorderRadius: tableBorderRadius, ifcConfig: ifcConfig, columnsQueryRef: columnsQueryRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueResultsData = (0, $8Uumt.useFragment)((0, $k1JRo.default), issueResults);
    const groupResultsData = (0, $8Uumt.useFragment)((0, $5of86.default), groupResults);
    const projectData = (0, $8Uumt.useFragment)((0, $7ciLI.default), project);
    let flatList = $aa6bfbccb1e9b3fa$var$emptyArray;
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        flatList = (0, $fc4cz.useFlatList)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        const flatListIssueKeys = (0, $fc4cz.useFlatListIssueKeys)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        const flatListIssueIds = (0, $fc4cz.useIssueIds)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useEffect)(()=>{
            if (onIssueFlatListUpdated && (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false)) onIssueFlatListUpdated(flatListIssueKeys.filter(Boolean), flatListIssueIds);
            else if (onIssueFlatListUpdatedOld) onIssueFlatListUpdatedOld(flatListIssueKeys.filter(Boolean));
        }, [
            flatList,
            flatListIssueIds,
            flatListIssueKeys,
            onIssueFlatListUpdated,
            onIssueFlatListUpdatedOld
        ]);
    }
    const getItemKey = (0, $5uXOq.useCallback)((index)=>{
        if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) return flatList[index] ?? index;
        return issueResultsData?.edges?.at(index)?.node?.key ?? index;
    }, [
        flatList,
        issueResultsData?.edges
    ]);
    const totalSizeRef = (0, $5uXOq.useRef)($aa6bfbccb1e9b3fa$var$getInitialTableHeight(issueResultsData?.edges?.length));
    const isFixedTableLayoutEnabled = (0, $e9M6d.useIsFixedTableLayoutEnabled)();
    const showNoIssues = issueResultsData && !issueResultsData.edges?.length;
    const showNoGroupingIssues = isGroupingSupported && groupResultsData && !groupResultsData.edges?.length;
    let isMergedColumnVisible = false;
    if ((0, $4R6GH.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnVisible = (0, $e9M6d.useIsMergedColumnVisible)();
    let showNoColumns = (columns.length === 0 || columns.length === 1 && columns[0].id === (0, $czfFt.COLUMN_ID_MEATBALL_MENU)) && !isMergedColumnVisible;
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) showNoColumns = columns.filter((col)=>!(0, $czfFt.ACTION_COLUMNS).includes(col.id)).length === 0 && !isMergedColumnVisible;
    const isVirtualizationEnabled = (0, $e9M6d.useIsVirtualizationEnabled)();
    const { cellNavigationRef: cellNavigationRef, onBlur: onBlur, onFocus: onFocus, tabIndex: tabIndex, onKeyDown: onKeyDown } = (0, $4R6GH.fg)('jira_list_grid_pattern_keyboard_nav') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hW5gq.useTableGridNavigation)({
        rowCount: issueResultsData?.edges?.length ?? 0,
        colCount: columns.length
    }) : {
        cellNavigationRef: null,
        onBlur: undefined,
        onFocus: undefined,
        tabIndex: undefined,
        onKeyDown: undefined
    };
    const tableRefs = (0, $4R6GH.fg)('jira_list_grid_pattern_keyboard_nav') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7mPT9.default)(tableRef, cellNavigationRef) : tableRef;
    const tableHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5VaIm.IFCConfigContextProviderComponent), {
        ifcConfig: ifcConfig,
        columns: columns,
        onColumnsChange: columnPickerProps?.onChange,
        queryRef: issueResultsData ?? null,
        columnsQueryRef: columnsQueryRef ?? null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTC96.Header), {
        columnPickerProps: columnPickerProps,
        columns: columns,
        canViewColumnConfiguration: canViewColumnConfiguration,
        canEditColumnConfiguration: canEditColumnConfiguration,
        isCompactColumnEnabled: isCompactColumnEnabled,
        resizeHandleType: showNoIssues || showNoColumns ? (0, $czfFt.COLUMN_RESIZE_HANDLE_HEADER_ONLY) : (0, $czfFt.COLUMN_RESIZE_HANDLE_FULL_HEIGHT),
        onColumnsChange: onColumnsChange,
        onResizeColumn: onResizeColumn,
        tableRef: tableRef,
        tableBorderRadius: tableBorderRadius,
        showNoColumns: showNoColumns
    }));
    if (showNoIssues || showNoGroupingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aa6bfbccb1e9b3fa$export$36d41a08d3c6eb45, {
        isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
        "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eT3Vu.default).issuesTableLabelIssueTermRefresh : (0, $eT3Vu.default).issuesTableLabel),
        ref: tableRefs,
        onBlur: onBlur,
        onFocus: onFocus,
        tabIndex: tabIndex,
        onKeyDown: onKeyDown
    }, tableHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jWEOv.default), {
        NoIssues: NoIssues,
        isLoading: loading
    }));
    if (showNoColumns) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, canViewColumnConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aa6bfbccb1e9b3fa$export$36d41a08d3c6eb45, {
        isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
        "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eT3Vu.default).issuesTableLabelIssueTermRefresh : (0, $eT3Vu.default).issuesTableLabel),
        ref: tableRef
    }, tableHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4nnug.default), {
        NoColumns: NoColumns,
        hasColumnConfiguration: canViewColumnConfiguration,
        isLoading: loading
    }));
    const renderTableBody = ()=>{
        if (isGroupingSupported && groupResultsData && !issueResultsData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3LBoo.GroupTableBody), {
            groupResults: groupResultsData,
            columns: columns,
            tableInjectedProps: tableInjectedProps,
            project: projectData ?? null,
            loading: loading
        });
        if (issueResultsData == null) return null;
        const tableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $evoSk.default), {
            issueResults: issueResultsData,
            columns: columns,
            tableInjectedProps: tableInjectedProps,
            project: projectData ?? null,
            isGroupingSupported: isGroupingSupported
        });
        return tableBody;
    };
    const renderTable = (style)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aa6bfbccb1e9b3fa$export$36d41a08d3c6eb45, {
            ...style ? {
                style: style
            } : {},
            isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
            "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eT3Vu.default).issuesTableLabelIssueTermRefresh : (0, $eT3Vu.default).issuesTableLabel),
            ref: tableRefs,
            onBlur: onBlur,
            onFocus: onFocus,
            tabIndex: tabIndex,
            onKeyDown: onKeyDown,
            "data-vc": `issue-table${false ? '-ssr' : ''}`,
            ...false && (0, $4R6GH.fg)('additional_nin_ssr_placeholders') && {
                'data-ssr-placeholder': 'issue-table-placeholder'
            },
            ...!false && (0, $4R6GH.fg)('additional_nin_ssr_placeholders') && {
                'data-ssr-placeholder-replace': 'issue-table-placeholder'
            }
        }, tableHeader, renderTableBody(), loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aa6bfbccb1e9b3fa$var$TableFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("td", null, (0, $4R6GH.fg)('add_nin_press_interactions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2BpVt.Overlay), {
            interactionName: "issue-table-renderer-overlay"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2BpVt.OverlayOld), null)))) : null);
    };
    const rowsCount = flatList?.length > 0 && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? flatList?.length : issueResultsData?.edges?.length;
    if (isVirtualizationEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lR6JR.VirtualizationContainer), null, !(0, $4R6GH.fg)('empanada_nin_fix_extra_remount_in_virtualization') && renderTable({
        width: '100%',
        position: 'relative'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9uKCK.InitializeVirtualizer), {
        rows: rowsCount ?? 0,
        getItemKey: getItemKey,
        totalSizeRef: totalSizeRef
    }), (0, $4R6GH.fg)('empanada_nin_fix_extra_remount_in_virtualization') && renderTable({
        width: '100%',
        position: 'relative'
    }));
    return renderTable();
};
var $aa6bfbccb1e9b3fa$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $aa6bfbccb1e9b3fa$var$IssueTable;
const $aa6bfbccb1e9b3fa$export$36d41a08d3c6eb45 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedTableLayoutEnabled: isFixedTableLayoutEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3it94y _kqswh2mm _yq5h18uv _btyzidpf",
            __cmplp.isFixedTableLayoutEnabled && "_1kqm1n9t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
const $aa6bfbccb1e9b3fa$var$TableFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tfoot", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _p4liidpf _owipidpf _6autidpf _1pqwidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7ciLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $63b670bbbd5ecd52$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ad0f42d6a1044635396f00707db2d928>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $63b670bbbd5ecd52$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueTable_nativeIssueTable_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "groupTableBody_nativeIssueTable_project"
        },
        {
            "kind": "FragmentSpread",
            "name": "tableBody_nativeIssueTable_project"
        }
    ],
    "type": "JiraProject"
};
$63b670bbbd5ecd52$var$node.hash = "7c431cd8484564a62351c9a48932aff4";
var $63b670bbbd5ecd52$export$2e2bcd8739ae039 = $63b670bbbd5ecd52$var$node;

});

parcelRegister("5of86", function(module, exports) {

$parcel$export(module.exports, "default", () => $87901716819e2e7d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dcfdef2d11d1bc5918f35bb4e8d51e13>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $87901716819e2e7d$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isPaginating"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "issueTable_nativeIssueTable_groupResults",
    "selections": [
        {
            "concreteType": "JiraSpreadsheetGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraSpreadsheetGroup",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isPaginating",
                    "variableName": "isPaginating"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "groupTableBody_nativeIssueTable_groupResults"
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$87901716819e2e7d$var$node.hash = "84b3a4ebfe6ce0ad7c237c3fa721da76";
var $87901716819e2e7d$export$2e2bcd8739ae039 = $87901716819e2e7d$var$node;

});

parcelRegister("k1JRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ab6b5b943eb6e9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f50f8bf7506a49b1115431e1e287b23>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0ab6b5b943eb6e9e$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "issueTable_nativeIssueTable_issueResults",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "tableBody_nativeIssueTable_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "context_nativeIssueTable_IFCConfigContextProvider_queryRef"
        }
    ],
    "type": "JiraIssueConnection"
};
$0ab6b5b943eb6e9e$var$node.hash = "5dc77141c9ddf31877b86f76577d7aa0";
var $0ab6b5b943eb6e9e$export$2e2bcd8739ae039 = $0ab6b5b943eb6e9e$var$node;

});

parcelRegister("hW5gq", function(module, exports) {

$parcel$export(module.exports, "useTableGridNavigation", () => $a3de8431dbba068d$export$7092ebf4946dc68c);

var $5uXOq = parcelRequire("5uXOq");

var $gT660 = parcelRequire("gT660");
const $a3de8431dbba068d$var$TabbableSelector = `a[href],
	button,
	input:not([type="hidden"]),
	[tabindex]:not([tabindex="-1"])`;
const $a3de8431dbba068d$var$TableSiblingSelector = `a[href]:not(table a[href]), 
	button:not(table button), 
	input:not([type="hidden"]):not(table input:not([type="hidden"])), 
	[tabindex]:not([tabindex="-1"]):not(table [tabindex]:not([tabindex="-1"])), 
	table`;
const $a3de8431dbba068d$export$7092ebf4946dc68c = ({ rowCount: rowCount, colCount: colCount })=>{
    const isKeyboardNavOn = (0, $gT660.useIsKeyBoardNavOn)();
    const { setIsKeyboardNavOn: setIsKeyboardNavOn, moveColumnRight: moveColumnRight, moveRowUp: moveRowUp, moveColumnLeft: moveColumnLeft, moveRowDown: moveRowDown } = (0, $gT660.useCellNavigationActions)();
    const cellNavigationRef = (0, $5uXOq.useRef)(null);
    const disableTabbing = (0, $5uXOq.useCallback)(()=>{
        // disable clickable elements in the table when it gets focus
        const elements = cellNavigationRef.current?.querySelectorAll($a3de8431dbba068d$var$TabbableSelector);
        if (elements) elements.forEach((element)=>{
            element.setAttribute('tabindex', '-1');
        });
    }, []);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (isKeyboardNavOn) switch(e.key){
            case 'Tab':
                // if keyboard nav is on and user tabs into an element within the table,
                // hijack the tab event and send focus to header/footer element.
                // also disables all elements in the table
                if (e.target instanceof HTMLElement && cellNavigationRef.current?.contains(e.target)) {
                    e.preventDefault();
                    disableTabbing();
                    // we want to get the element before and after the table
                    // so we can redirect any Tabs pressed by the user when in table
                    const tableSiblingElements = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    document.querySelectorAll($a3de8431dbba068d$var$TableSiblingSelector);
                    const tableIndex = Array.from(tableSiblingElements).findIndex((el)=>cellNavigationRef.current === el);
                    if (tableIndex > -1) {
                        if (e.shiftKey) {
                            const beforeElement = tableSiblingElements[tableIndex - 1];
                            beforeElement instanceof HTMLElement && beforeElement.focus();
                        } else {
                            const afterElement = tableSiblingElements[tableIndex + 1];
                            afterElement instanceof HTMLElement && afterElement.focus();
                        }
                    }
                }
                break;
            case 'ArrowRight':
                moveColumnRight(1, colCount - 1);
                break;
            case 'ArrowLeft':
                moveColumnLeft(1, 0);
                break;
            case 'ArrowDown':
                moveRowDown(1, rowCount - 1);
                break;
            case 'ArrowUp':
                moveRowUp(1, 0);
                break;
            default:
        }
    }, [
        isKeyboardNavOn,
        moveColumnRight,
        colCount,
        moveColumnLeft,
        moveRowDown,
        rowCount,
        moveRowUp,
        disableTabbing
    ]);
    const onFocus = (0, $5uXOq.useCallback)((e)=>{
        // we are checking this to make sure that the focus event is triggered in the navigation wrapper and is not a focus that bubbled up
        // this means that the user has tabbed into the table so we should turn the grid nav on
        if (e.target === e.currentTarget) {
            if (cellNavigationRef.current != null) disableTabbing();
            setIsKeyboardNavOn(true);
        }
    }, [
        disableTabbing,
        setIsKeyboardNavOn
    ]);
    const onBlur = (0, $5uXOq.useCallback)((e)=>{
        if (e.relatedTarget instanceof Element && !cellNavigationRef.current?.contains(e.relatedTarget)) // if user has tabbed out of the table, turn keyboard nav off
        setIsKeyboardNavOn(false);
    }, [
        setIsKeyboardNavOn
    ]);
    const tabIndex = (0, $5uXOq.useMemo)(()=>isKeyboardNavOn ? -1 : 0, [
        isKeyboardNavOn
    ]);
    return {
        cellNavigationRef: cellNavigationRef,
        onFocus: onFocus,
        onBlur: onBlur,
        tabIndex: tabIndex,
        onKeyDown: onKeyDown
    };
};

});
parcelRegister("gT660", function(module, exports) {

$parcel$export(module.exports, "useIsKeyBoardNavOn", () => $122f23f098ab5383$export$1a3d6ba712a884e1);
$parcel$export(module.exports, "useCellNavigationActions", () => $122f23f098ab5383$export$ba35ece3d23f8641);
$parcel$export(module.exports, "useIsSelectedCell", () => $122f23f098ab5383$export$7eaf6b5b80c26bde);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $122f23f098ab5383$var$initialState = {
    // holds the current selected cell in the table [row, col]
    selectedCell: [
        0,
        0
    ],
    // if this is on, it means user has tabbed into the table and the arrow keys etc can be used to navigate the table
    isKeyboardNavOn: false
};
const $122f23f098ab5383$var$actions = {
    setIsKeyboardNavOn: (value)=>({ setState: setState })=>{
            setState({
                isKeyboardNavOn: value
            });
        },
    setSelectedCell: (row, col)=>({ setState: setState })=>{
            setState({
                selectedCell: [
                    row,
                    col
                ]
            });
        },
    moveRowDown: (by, max)=>({ setState: setState, getState: getState })=>{
            const { selectedCell: [row, col] } = getState();
            if (row < max) setState({
                selectedCell: [
                    row + by,
                    col
                ]
            });
        },
    moveRowUp: (by, max)=>({ setState: setState, getState: getState })=>{
            const { selectedCell: [row, col] } = getState();
            if (row > max) setState({
                selectedCell: [
                    row - by,
                    col
                ]
            });
        },
    moveColumnRight: (by, max)=>({ setState: setState, getState: getState })=>{
            const { selectedCell: [row, col] } = getState();
            if (col < max) setState({
                selectedCell: [
                    row,
                    col + by
                ]
            });
        },
    moveColumnLeft: (by, max)=>({ setState: setState, getState: getState })=>{
            const { selectedCell: [row, col] } = getState();
            if (col > max) setState({
                selectedCell: [
                    row,
                    col - by
                ]
            });
        }
};
const $122f23f098ab5383$var$Store = (0, $iXqE5.createStore)({
    initialState: $122f23f098ab5383$var$initialState,
    actions: $122f23f098ab5383$var$actions
});
const $122f23f098ab5383$export$1a3d6ba712a884e1 = (0, $3sQ5x.createStateHook)($122f23f098ab5383$var$Store, {
    selector: (state)=>state.isKeyboardNavOn
});
const $122f23f098ab5383$export$ba35ece3d23f8641 = (0, $3sQ5x.createActionsHook)($122f23f098ab5383$var$Store);
const $122f23f098ab5383$export$7eaf6b5b80c26bde = (0, $3sQ5x.createHook)($122f23f098ab5383$var$Store, {
    selector: ({ selectedCell: selectedCell, isKeyboardNavOn: isKeyboardNavOn }, [row, col])=>isKeyboardNavOn && selectedCell[0] === row && selectedCell[1] === col
});

});


parcelRegister("2BpVt", function(module, exports) {

$parcel$export(module.exports, "Overlay", () => $be12041917081354$export$c6fdb837b070b4ff);
$parcel$export(module.exports, "OverlayOld", () => $be12041917081354$export$3dff7b29487a2410);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fNobW = parcelRequire("fNobW");
const $be12041917081354$export$c6fdb837b070b4ff = ({ interactionName: interactionName })=>{
    return(// We are intentionally ignoring jira/ufo/valid-labels because we have a valid use case
    // for an encapsulated generic component, similar to generic AK components.
    // eslint-disable-next-line jira/ufo/valid-labels
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: interactionName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($be12041917081354$var$StyledOverlay, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $be12041917081354$var$StyledOverlay = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _bfhk166n _tzy4txnc _1sb2b3bt",
            __cmplp.className
        ])
    });
});
const $be12041917081354$export$3dff7b29487a2410 = $be12041917081354$var$StyledOverlay;

});

parcelRegister("lR6JR", function(module, exports) {

$parcel$export(module.exports, "VirtualizationContainer", () => $bcbdbafe942bee79$export$6f4d8b0593660d4a);
$parcel$export(module.exports, "useVirtualizationActions", () => $bcbdbafe942bee79$export$2d20df04c90a6b4d);
$parcel$export(module.exports, "useVirtualization", () => $bcbdbafe942bee79$export$8c88e6c844ce8aa0);
$parcel$export(module.exports, "useVirtualItemsMap", () => $bcbdbafe942bee79$export$48859eaeca922cb5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $bcbdbafe942bee79$var$initialState = {
    virtualizer: null,
    virtualItemsMap: {}
};
const $bcbdbafe942bee79$var$actions = {
    setVirtualizer: (virtualizer)=>({ setState: setState })=>{
            setState({
                virtualizer: virtualizer
            });
        },
    setVirtualItemsMap: (virtualItemsMap)=>({ setState: setState })=>{
            setState({
                virtualItemsMap: virtualItemsMap
            });
        }
};
const $bcbdbafe942bee79$export$6f4d8b0593660d4a = (0, $gg7kZ.createContainer)();
const $bcbdbafe942bee79$var$Store = (0, $iXqE5.createStore)({
    initialState: $bcbdbafe942bee79$var$initialState,
    actions: $bcbdbafe942bee79$var$actions,
    name: 'VirtualizerStore',
    containedBy: $bcbdbafe942bee79$export$6f4d8b0593660d4a
});
const $bcbdbafe942bee79$export$2d20df04c90a6b4d = (0, $3sQ5x.createActionsHook)($bcbdbafe942bee79$var$Store);
const $bcbdbafe942bee79$export$88d9b12c2ccec7b9 = (0, $3sQ5x.createHook)($bcbdbafe942bee79$var$Store);
const $bcbdbafe942bee79$var$getVirtualizerSelector = (state)=>state.virtualizer;
const $bcbdbafe942bee79$export$8c88e6c844ce8aa0 = (0, $3sQ5x.createStateHook)($bcbdbafe942bee79$var$Store, {
    selector: $bcbdbafe942bee79$var$getVirtualizerSelector
});
const $bcbdbafe942bee79$var$getVirtualItemsMapSelector = (state)=>state.virtualItemsMap;
const $bcbdbafe942bee79$export$48859eaeca922cb5 = (0, $3sQ5x.createStateHook)($bcbdbafe942bee79$var$Store, {
    selector: $bcbdbafe942bee79$var$getVirtualItemsMapSelector
});

});

parcelRegister("3LBoo", function(module, exports) {

$parcel$export(module.exports, "GroupTableBody", () => $c9399e4e2c92fc2a$export$aa181eb5196ac7ed);

var $1G64n = parcelRequire("1G64n");

var $gJcYx = parcelRequire("gJcYx");

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $52ESs = parcelRequire("52ESs");

var $1XJ20 = parcelRequire("1XJ20");

var $4R6GH = parcelRequire("4R6GH");

var $fc4cz = parcelRequire("fc4cz");

var $2q82p = parcelRequire("2q82p");

var $66i0J = parcelRequire("66i0J");

var $ft6vz = parcelRequire("ft6vz");

var $lFmEw = parcelRequire("lFmEw");

var $e9M6d = parcelRequire("e9M6d");

var $5DTiT = parcelRequire("5DTiT");

var $9JU2H = parcelRequire("9JU2H");

var $czfFt = parcelRequire("czfFt");

var $1v6c5 = parcelRequire("1v6c5");

var $9CFBJ = parcelRequire("9CFBJ");

var $4BEu7 = parcelRequire("4BEu7");

var $3I8L4 = parcelRequire("3I8L4");
const $c9399e4e2c92fc2a$export$aa181eb5196ac7ed = ({ groupResults: groupResults, project: project, columns: columns, loading: loading, ...tableBodyProps })=>{
    const groupsData = (0, $8Uumt.useFragment)((0, $gJcYx.default), groupResults);
    const projectData = (0, $8Uumt.useFragment)((0, $1G64n.default), project);
    const groupConnectionId = groupsData.__id;
    const { populateConnection: populateConnection } = (0, $fc4cz.useHierarchyActions)();
    const populateConnectionArgs = (0, $5uXOq.useMemo)(()=>({
            parentItemId: 'root',
            itemsConnectionId: groupConnectionId,
            parentConnectionId: groupConnectionId,
            list: groupsData?.edges?.map((edge)=>edge?.node && {
                    itemId: edge.node.id,
                    key: null,
                    groupId: edge.node.id
                }).filter(Boolean) ?? []
        }), [
        groupConnectionId,
        groupsData.edges
    ]);
    const prevPopulateConnectionArgs = (0, $1XJ20.usePrevious)(populateConnectionArgs);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(populateConnectionArgs, prevPopulateConnectionArgs)) populateConnection(populateConnectionArgs);
    /**
   * Passing those values down to ChildRowsLoader as props to avoid direct imports
   */ const jql = (0, $e9M6d.useJql)();
    const sortField = (0, $e9M6d.useSortField)();
    const sortDirection = (0, $e9M6d.useSortDirection)();
    const isReparentingEnabled = (0, $e9M6d.useIsReparentingEnabled)();
    const isTimelineEnabled = (0, $e9M6d.useIsTimelineEnabled)();
    const isHideDoneItemsEnabled = (0, $e9M6d.useIsHideDoneItemsEnabled)();
    const isFixedTableLayoutEnabled = (0, $e9M6d.useIsFixedTableLayoutEnabled)();
    const width = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>scrollState.width);
    const isIssueRankDescending = (0, $e9M6d.useIsIssueRankDescending)();
    let isIssueCreateEnabled;
    if ((0, $4R6GH.fg)('jira_list_check_issue_create_permissions')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isIssueCreateEnabled = (0, $e9M6d.useIsIssueCreateEnabled)();
    const renderDraggableWrapper = (0, $5uXOq.useCallback)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3I8L4.DraggableRowsContainer), {
            issueConnectionId: props.issueConnectionId,
            instanceId: props.instanceId
        }, props.children);
    }, []);
    const renderChildRows = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2q82p.ChildRows), {
            ...props,
            projectKey: projectData?.key,
            isGroupingSupported: true,
            childItemsExperience: (0, $czfFt.GROUPED_ITEMS_EXPERIENCE),
            childItemsLoadMoreExperience: (0, $czfFt.GROUPED_LOAD_MORE_EXPERIENCE),
            analyticsSource: (0, $czfFt.ANALYTICS_SOURCE),
            renderChildRowsLoader: (childRowsLoaderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $66i0J.ChildRowsLoader), {
                    ...childRowsLoaderProps,
                    jql: jql,
                    width: width,
                    sortField: sortField,
                    sortDirection: sortDirection,
                    columns: columns,
                    amountOfColumns: (0, $czfFt.MAX_COLUMNS),
                    actionColumns: (0, $czfFt.ACTION_COLUMNS),
                    pageSize: (0, $czfFt.CHILD_QUERY_PAGE_SIZE),
                    isReparentingEnabled: isReparentingEnabled,
                    isTimelineEnabled: isTimelineEnabled,
                    isIssueRankDescending: isIssueRankDescending,
                    isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                    isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
                    renderRows: (rowProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lFmEw.Rows), rowProps),
                    renderTableCell: (tableCellProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1v6c5.TableCell), tableCellProps),
                    renderCreateIssueController: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4BEu7.CreateIssueController), {
                            ...args,
                            groupContextFieldInput: props.groupContextField,
                            jql: jql
                        }),
                    ...(0, $4R6GH.fg)('jsc_list_reranking_gate_technical') && {
                        renderDraggableWrapper: renderDraggableWrapper
                    }
                })
        }), [
        isFixedTableLayoutEnabled,
        isHideDoneItemsEnabled,
        isIssueRankDescending,
        isReparentingEnabled,
        isTimelineEnabled,
        jql,
        projectData?.key,
        sortDirection,
        sortField,
        columns,
        width,
        renderDraggableWrapper
    ]);
    const FirstGroupRow = (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? (0, $ft6vz.FirstGroupRowWithMemo) : (0, $ft6vz.FirstGroupRow);
    const GroupRow = (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? (0, $ft6vz.GroupRowWithMemo) : (0, $ft6vz.GroupRow);
    const renderRows = (0, $5uXOq.useCallback)((rowProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lFmEw.Rows), rowProps), []);
    const renderCreateIssueController = (0, $5uXOq.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4BEu7.CreateIssueController), {
            ...args,
            jql: jql
        }), [
        jql
    ]);
    const numFirstGroupIssues = groupsData?.firstGroup?.issues?.edges?.length;
    const isFirstGroupEmpty = ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(numFirstGroupIssues) || numFirstGroupIssues === 0) && (0, $4R6GH.fg)('jira_list_skip_first_group_if_no_issues');
    const renderGroups = (0, $5uXOq.useCallback)((isItemVirtual)=>groupsData?.edges?.map((group, index)=>group?.node && // We need to render the first group separately because it requires initialization during the table rendering process.
            // Additionally, it bypasses the ChildRowLoader and directly uses ChildRowsPagination, as the data is already available in data.firstGroup.
            (groupsData?.firstGroup && group.node.id === groupsData.firstGroup.id && !isFirstGroupEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5DTiT.RowContextProvider), {
                key: groupsData.firstGroup.id,
                groupId: groupsData.firstGroup.id,
                groupConnectionId: (0, $4R6GH.fg)('jsc_list_hide_done_items') ? groupConnectionId : undefined,
                ...tableBodyProps,
                columns: columns,
                renderChildRows: (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? undefined : (props)=>renderChildRows({
                        ...props,
                        groupId: groupsData.firstGroup?.id
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FirstGroupRow, {
                firstGroupRow: groupsData.firstGroup,
                groupConnectionId: groupConnectionId,
                loading: loading,
                isVirtual: isItemVirtual?.((0, $52ESs.getFlatListKey)({
                    itemId: groupsData.firstGroup.id,
                    groupId: groupsData.firstGroup.id
                })) ?? true,
                isGroupAtTop: index === 0,
                projectKey: projectData?.key,
                isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                isIssueRankDescending: isIssueRankDescending,
                isTimelineEnabled: isTimelineEnabled,
                columns: columns,
                width: width,
                amountOfColumns: (0, $czfFt.MAX_COLUMNS),
                actionColumns: (0, $czfFt.ACTION_COLUMNS),
                pageSize: (0, $czfFt.CHILD_QUERY_PAGE_SIZE),
                childItemsExperience: (0, $czfFt.GROUPED_ITEMS_EXPERIENCE),
                childItemsLoadMoreExperience: (0, $czfFt.GROUPED_LOAD_MORE_EXPERIENCE),
                analyticsSource: (0, $czfFt.ANALYTICS_SOURCE),
                renderRows: renderRows,
                renderCreateIssueController: renderCreateIssueController,
                isIssueCreateEnabled: isIssueCreateEnabled,
                ...(0, $4R6GH.fg)('jsc_list_reranking_gate_technical') && {
                    renderDraggableWrapper: renderDraggableWrapper
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5DTiT.RowContextProvider), {
                key: group.node.id,
                groupId: group.node.id,
                groupConnectionId: (0, $4R6GH.fg)('jsc_list_hide_done_items') ? groupConnectionId : undefined,
                ...tableBodyProps,
                columns: columns,
                renderChildRows: (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? renderChildRows : (props)=>renderChildRows({
                        ...props,
                        groupId: group.node?.id
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GroupRow, {
                groupRow: group.node,
                groupConnectionId: groupConnectionId,
                isVirtual: isItemVirtual?.((0, $52ESs.getFlatListKey)({
                    itemId: group.node.id,
                    groupId: group.node.id
                })) ?? true,
                isGroupAtTop: index === 0,
                projectKey: projectData?.key,
                columns: columns,
                renderChildRows: (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? renderChildRows : (props)=>renderChildRows({
                        ...props,
                        groupId: group.node?.id
                    }),
                isIssueCreateEnabled: isIssueCreateEnabled
            })))), [
        FirstGroupRow,
        GroupRow,
        columns,
        groupConnectionId,
        groupsData?.edges,
        groupsData.firstGroup,
        isFirstGroupEmpty,
        tableBodyProps,
        loading,
        projectData?.key,
        isHideDoneItemsEnabled,
        isIssueRankDescending,
        isTimelineEnabled,
        width,
        renderRows,
        renderCreateIssueController,
        isIssueCreateEnabled,
        renderDraggableWrapper,
        renderChildRows
    ]);
    const isVirtualizationEnabled = (0, $e9M6d.useIsVirtualizationEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "tbody",
        xcss: $c9399e4e2c92fc2a$var$tableBodyStyles
    }, isVirtualizationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9JU2H.VirtualizedRows), {
        hasSpacers: true,
        columnsCount: columns.length
    }, renderGroups) : renderGroups());
};
const $c9399e4e2c92fc2a$var$tableBodyStyles = (0, $8CUq3.xcss)({
    borderBottom: 'none',
    overflowX: 'hidden'
});

});
parcelRegister("1G64n", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef2b0e4a5e3062b3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f4de0111b0006a82e527fc2add752569>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ef2b0e4a5e3062b3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "groupTableBody_nativeIssueTable_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraProject"
};
$ef2b0e4a5e3062b3$var$node.hash = "9172a5a0fde9cea9f3863762a614cb99";
var $ef2b0e4a5e3062b3$export$2e2bcd8739ae039 = $ef2b0e4a5e3062b3$var$node;

});

parcelRegister("gJcYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ea9456f5aaf9616$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b5ca8aa8da88e288a3f0b9eb8e29db93>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9ea9456f5aaf9616$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isPaginating"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "firstGroup",
                        "issues"
                    ]
                }
            ]
        },
        "name": "groupTableBody_nativeIssueTable_groupResults",
        "selections": [
            {
                "condition": "isPaginating",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "firstGroup",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "alias": "issues",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "fieldSetsInput",
                                        "variableName": "fieldSetsInput"
                                    }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "__firstGroupSection_nativeIssueTable__issues_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "isDensityFull",
                                        "variableName": "isDensityFull"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isInlineEditingEnabled",
                                        "variableName": "isInlineEditingEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isTimelineEnabled",
                                        "variableName": "isTimelineEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "projectKey",
                                        "variableName": "projectKey"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "projectKeys",
                                        "variableName": "projectKeys"
                                    }
                                ],
                                "kind": "FragmentSpread",
                                "name": "groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "JiraSpreadsheetGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "FragmentSpread",
                                "name": "groupRow_issueTableGrouping_groupRow"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetGroupConnection"
    };
}();
$9ea9456f5aaf9616$var$node.hash = "e233a7c1e14962f59bde2d6a5530679f";
var $9ea9456f5aaf9616$export$2e2bcd8739ae039 = $9ea9456f5aaf9616$var$node;

});

parcelRegister("2q82p", function(module, exports) {

$parcel$export(module.exports, "ChildRows", () => $e8a585fb9cc2215a$export$d1ec222e220e369e);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $fc4cz = parcelRequire("fc4cz");


var $fE64g = parcelRequire("fE64g");
const $e8a585fb9cc2215a$var$PACKAGE_LOCATION = 'jira-issue-table-hierarchy-child-rows';
const $e8a585fb9cc2215a$export$5881677fb314e6d9 = 'issue-table-child-rows-entrypoint-container';
const $e8a585fb9cc2215a$export$d1ec222e220e369e = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const [isExpanded] = (0, $fc4cz.useIsItemExpanded)({
        itemId: props.parentItemId,
        itemsConnectionId: props.itemsConnectionId,
        groupId: props.groupId
    });
    if (!isExpanded) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e8a585fb9cc2215a$var$ChildRowsInner, props);
});
const $e8a585fb9cc2215a$var$ChildRowsInner = (props)=>{
    const { parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, type: type, parentItemConnectionId: parentItemConnectionId, depth: depth, groupId: groupId, renderChildRowsLoader: renderChildRowsLoader } = props;
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experience: props.childItemsExperience,
        analyticsSource: props.analyticsSource
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: props.childItemsExperience,
        attributes: {}
    });
    (0, $5uXOq.useEffect)(()=>{
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    const { setIsItemExpanded: setIsItemExpanded } = (0, $fc4cz.useHierarchyActions)();
    const { showFlag: showFlag, hasFlag: hasFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleError = (0, $5uXOq.useCallback)((error)=>{
        setIsItemExpanded({
            itemId: parentItemId,
            itemsConnectionId: itemsConnectionId,
            groupId: groupId
        }, false);
        if (!hasFlag?.($e8a585fb9cc2215a$export$5881677fb314e6d9)) {
            const isGrouping = groupId && depth === 0;
            showFlag({
                id: $e8a585fb9cc2215a$export$5881677fb314e6d9,
                title: formatMessage(isGrouping ? (0, $fE64g.default).errorFlagGroupingTitle : (0, $fE64g.default).errorFlagTitle),
                description: formatMessage(isGrouping ? (0, $fE64g.default).errorFlagGroupingDescription : (0, $fE64g.default).errorFlagDescription),
                type: 'error',
                messageId: `issue-table-hierarchy.ui.child-rows.showFlag.${$e8a585fb9cc2215a$export$5881677fb314e6d9}`,
                messageType: 'transactional'
            });
        }
        (0, $jcw0u.default)({
            meta: {
                id: 'issue-table-child-rows-container',
                packageName: (0, $1878d7709231fe10$export$b8b9d90f9e5bd72b),
                teamName: (0, $1878d7709231fe10$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail($e8a585fb9cc2215a$var$PACKAGE_LOCATION, error);
        return null;
    }, [
        formatMessage,
        hasFlag,
        itemsConnectionId,
        onExperienceFail,
        parentItemId,
        setIsItemExpanded,
        showFlag,
        depth,
        groupId
    ]);
    const connectionMetadata = (0, $5uXOq.useMemo)(()=>{
        if (type === 'PARENT_CHILDREN' && parentItemConnectionId) return {
            type: type,
            parentRelayId: parentItemConnectionId,
            parentId: parentItemId
        };
        if (type === 'GROUP_CHILDREN' && groupId) return {
            type: type,
            fieldValue: props.groupFieldValue,
            groupId: groupId,
            jql: props.groupJql
        };
        return undefined;
    }, [
        type,
        parentItemConnectionId,
        groupId,
        props.groupFieldValue,
        props.groupJql,
        parentItemId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: $e8a585fb9cc2215a$var$PACKAGE_LOCATION,
        packageName: (0, $1878d7709231fe10$export$b8b9d90f9e5bd72b),
        teamName: (0, $1878d7709231fe10$export$d57b6b390e78d90f),
        onError: (_, error)=>handleError(error)
    }, renderChildRowsLoader({
        ...props,
        connectionMetadata: connectionMetadata
    }));
};

});
const $1878d7709231fe10$export$b8b9d90f9e5bd72b = 'jira-issue-table-hierarchy';
const $1878d7709231fe10$export$d57b6b390e78d90f = 'keystone';

parcelRegister("fE64g", function(module, exports) {

$parcel$export(module.exports, "default", () => $523efbaa9639763d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $523efbaa9639763d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "native-issue-table.rows.child-rows.error-flag-title",
        "defaultMessage": "We couldn't expand hierarchy"
    },
    errorFlagDescription: {
        "id": "native-issue-table.rows.child-rows.error-flag-description",
        "defaultMessage": "Someone may have deleted a task or changed access to the parent. Try again or contact an admin."
    },
    errorFlagGroupingTitle: {
        "id": "native-issue-table.rows.child-rows.error-flag-grouping-title",
        "defaultMessage": "We couldn't expand the group"
    },
    errorFlagGroupingDescription: {
        "id": "native-issue-table.rows.child-rows.error-flag-grouping-description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});


parcelRegister("66i0J", function(module, exports) {

$parcel$export(module.exports, "ChildRowsLoader", () => $c184019c33d25e18$export$148a4cf18f2e069b);

var $99Y6G = parcelRequire("99Y6G");

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Uumt = parcelRequire("8Uumt");

var $hYRTO = parcelRequire("hYRTO");

var $99Y6G = parcelRequire("99Y6G");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $w9XlC = parcelRequire("w9XlC");

var $gQNeS = parcelRequire("gQNeS");

var $6OGT1 = parcelRequire("6OGT1");
const $c184019c33d25e18$export$148a4cf18f2e069b = (props)=>{
    const [issueSearch, loadQuery, dispose] = (0, $8Uumt.useQueryLoader)((0, $99Y6G.default));
    const cloudId = (0, $koeKL.useCloudId)();
    const { sortField: sortField, sortDirection: sortDirection, jql: jql, columns: columns, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, isGroupingSupported: isGroupingSupported, pageSize: pageSize, amountOfColumns: amountOfColumns, actionColumns: actionColumns, isHideDoneItemsEnabled: isHideDoneItemsEnabled } = props;
    const variablesOld = (0, $5uXOq.useMemo)(()=>(0, $6OGT1.isGroupLoader)(props) ? (0, $w9XlC.getChildQueryVariablesForJql)({
            cloudId: cloudId,
            columns: columns,
            jql: props.groupJql,
            isReparentingEnabled: false,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled
        }) : (0, $w9XlC.getChildQueryVariablesForParentIssue)({
            cloudId: cloudId,
            columns: columns,
            parentIssueKey: props.issueKey,
            sortDirection: sortDirection,
            sortField: sortField,
            jql: jql,
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled
        }), [
        props,
        cloudId,
        columns,
        actionColumns,
        amountOfColumns,
        pageSize,
        isHideDoneItemsEnabled,
        sortDirection,
        sortField,
        jql,
        isReparentingEnabled,
        isTimelineEnabled
    ]);
    const variablesNew = (0, $5uXOq.useMemo)(()=>props.type === 'GROUP_CHILDREN' ? (0, $w9XlC.getChildQueryVariablesForJql)({
            cloudId: cloudId,
            columns: columns,
            jql: props.groupJql,
            isReparentingEnabled: false,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled
        }) : (0, $w9XlC.getChildQueryVariablesForParentIssue)({
            cloudId: cloudId,
            columns: columns,
            parentIssueKey: props.issueKey,
            sortDirection: sortDirection,
            sortField: sortField,
            jql: jql,
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled
        }), [
        props.type,
        props.groupJql,
        props.issueKey,
        cloudId,
        columns,
        actionColumns,
        amountOfColumns,
        pageSize,
        sortDirection,
        sortField,
        jql,
        isHideDoneItemsEnabled,
        isReparentingEnabled,
        isTimelineEnabled
    ]);
    const variables = (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? variablesNew : variablesOld;
    const prevIssueSearchInput = (0, $5uXOq.useRef)(variables.issueSearchInput);
    (0, $5uXOq.useEffect)(()=>{
        // This check prevents performing another network request for child items when the issue query changes
        // (which is unused as we re-fetch the issues when this happens). This is due to a race condition where
        // this component has not yet been unmounted when the issue query changes.
        if (props.isGroupingSupported && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(variables.issueSearchInput, prevIssueSearchInput.current)) return;
        loadQuery(variables);
        if (props.isGroupingSupported) prevIssueSearchInput.current = variables.issueSearchInput;
        return ()=>{
            dispose();
        };
    }, [
        variables,
        loadQuery,
        dispose,
        props.isGroupingSupported
    ]);
    if (!issueSearch) return null;
    const { groupId: groupId, depth: depth, parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentIssueAri: parentIssueAri, parentItemConnectionId: parentItemConnectionId, parentIssueRelayConnectionId: parentIssueRelayConnectionId, connectionMetadata: connectionMetadata, isFormVisible: isFormVisible, formProps: formProps, projectKey: projectKey, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, width: width, isIssueRankDescending: isIssueRankDescending, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "native-issue-table-child-rows-query",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gQNeS.default), {
            itemId: parentItemId,
            groupId: groupId,
            columnsCount: columns.length,
            isFixedTableLayoutEnabled: props.isFixedTableLayoutEnabled,
            renderTableCell: props.renderTableCell
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c184019c33d25e18$export$410977b2c408dd5d, {
        issueSearch: issueSearch,
        depth: depth,
        parentItemId: parentItemId,
        itemsConnectionId: itemsConnectionId,
        parentIssueAri: parentIssueAri,
        parentItemConnectionId: parentItemConnectionId,
        parentIssueRelayConnectionId: parentIssueRelayConnectionId,
        connectionMetadata: connectionMetadata,
        isFormVisible: isFormVisible,
        formProps: formProps,
        projectKey: projectKey,
        isGroupingSupported: isGroupingSupported,
        childItemsExperience: childItemsExperience,
        childItemsLoadMoreExperience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource,
        pageSize: pageSize,
        width: width,
        isIssueRankDescending: isIssueRankDescending,
        renderRows: renderRows,
        renderCreateIssueController: renderCreateIssueController,
        groupId: groupId,
        columns: columns,
        ...(0, $4R6GH.fg)('jsc_list_reranking_gate_technical') && {
            renderDraggableWrapper: renderDraggableWrapper
        }
    }));
};
const $c184019c33d25e18$export$410977b2c408dd5d = ({ issueSearch: issueSearch, ...rest })=>{
    const queryData = (0, $8Uumt.usePreloadedQuery)((0, $99Y6G.default), issueSearch);
    if (rest.isGroupingSupported && queryData?.jira?.issueSearch?.issueSearchError?.__typename) switch(queryData.jira.issueSearch.issueSearchError.__typename){
        case 'JiraInvalidJqlError':
            throw new Error(queryData.jira.issueSearch.issueSearchError.messages?.[0] ?? 'Invalid JQL');
        case 'JiraInvalidSyntaxError':
        case 'JiraServerError':
            throw new Error(queryData.jira.issueSearch.issueSearchError.message ?? 'Unknown Error');
        default:
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OGT1.ChildRowsPagination), {
        ...rest,
        query: queryData
    });
};

});
parcelRegister("99Y6G", function(module, exports) {

$parcel$export(module.exports, "default", () => $7363cdf67fe600e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ea6e9dc557fc767bac2b942b85c232ac>>
 * @relayHash a6f901f2ffefb7b67f60dfc3df0f1013
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7c6d137855573f13e263411e4c42c00a542036b943a104e40105269c0af7c230

var $5oQtH = parcelRequire("5oQtH");

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $7363cdf67fe600e0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isReparentingEnabled"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v21 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v22 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = [
        {
            "kind": "ScalarField",
            "name": "message"
        }
    ], v25 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v24 /*: any*/ ,
                "type": "JiraServerError"
            },
            {
                "kind": "InlineFragment",
                "selections": v24 /*: any*/ ,
                "type": "JiraInvalidSyntaxError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "id"
    }, v27 = {
        "kind": "ScalarField",
        "name": "key"
    }, v28 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v31 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            v29 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v26 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v33 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v35 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v36 = {
        "kind": "ScalarField",
        "name": "type"
    }, v37 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v38 = {
        "kind": "ScalarField",
        "name": "name"
    }, v39 = {
        "kind": "ScalarField",
        "name": "value"
    }, v40 = [
        v39 /*: any*/ ,
        v26 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v41 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v42 = {
        "kind": "ClientExtension",
        "selections": [
            v41 /*: any*/ 
        ]
    }, v43 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v44 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v45 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v46 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v47 = {
        "kind": "ScalarField",
        "name": "text"
    }, v48 = {
        "kind": "InlineFragment",
        "selections": [
            v47 /*: any*/ ,
            v38 /*: any*/ ,
            v42 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v49 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v50 = [
        v49 /*: any*/ 
    ], v51 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v26 /*: any*/ 
        ]
    }, v52 = [
        v51 /*: any*/ 
    ], v53 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v54 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v55 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v56 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v57 = {
        "kind": "ClientExtension",
        "selections": [
            v34 /*: any*/ 
        ]
    }, v58 = [
        v38 /*: any*/ ,
        v26 /*: any*/ 
    ], v59 = {
        "kind": "ScalarField",
        "name": "date"
    }, v60 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v61 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v62 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v63 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v47 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v64 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v51 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v65 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v66 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v65 /*: any*/ ,
                    v38 /*: any*/ ,
                    v26 /*: any*/ 
                ]
            },
            v26 /*: any*/ 
        ]
    }, v67 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v68 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v69 = {
        "kind": "ScalarField",
        "name": "number"
    }, v70 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v71 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v36 /*: any*/ ,
                        v37 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraIssueField"
                                                },
                                                v26 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAffectedServiceConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedAffectedServicesConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAffectedService",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "serviceId"
                                                                                },
                                                                                v38 /*: any*/ ,
                                                                                v26 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAffectedServicesField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraCascadingOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "cascadingOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "parentOptionValue",
                                                                            "plural": false,
                                                                            "selections": v40 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "childOptionValue",
                                                                            "plural": false,
                                                                            "selections": v40 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraCascadingSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "args": v43 /*: any*/ ,
                                                                    "concreteType": "JiraComponentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedComponentsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraComponent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v44 /*: any*/ ,
                                                                                        v45 /*: any*/ ,
                                                                                        v26 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraComponentsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v46 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraDateTimePickerField"
                                                        },
                                                        v48 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCommentSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "commentSummary",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canAddComment"
                                                                        },
                                                                        v49 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraCommentSummaryField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "uri"
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraUrlField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOptions",
                                                                    "plural": false,
                                                                    "selections": v50 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v39 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v52 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v52 /*: any*/ 
                                                                        },
                                                                        v26 /*: any*/ ,
                                                                        v53 /*: any*/ 
                                                                    ]
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v39 /*: any*/ ,
                                                                                        v53 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v39 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraCheckboxesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraUserConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedUsersConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraUserEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v23 /*: any*/ ,
                                                                                        v54 /*: any*/ ,
                                                                                        v38 /*: any*/ ,
                                                                                        v55 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v56 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "email"
                                                                                                }
                                                                                            ],
                                                                                            "type": "AtlassianAccountUser"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraTeamView",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedTeam",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraSuppliedId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraSuppliedName"
                                                                        }
                                                                    ]
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraTeamViewField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraTimeTrackingField",
                                                                            "kind": "LinkedField",
                                                                            "name": "timeTrackingField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v26 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraEstimate",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "originalEstimate",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "timeInSeconds"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "timeTrackingSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingHoursPerDay"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingDaysPerWeek"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultFormat"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultUnit"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v29 /*: any*/ ,
                                                                                v38 /*: any*/ ,
                                                                                v36 /*: any*/ ,
                                                                                v42 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraOriginalTimeEstimateField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": "label",
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        },
                                                                        v26 /*: any*/ ,
                                                                        v44 /*: any*/ 
                                                                    ]
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "args": v43 /*: any*/ ,
                                                                    "concreteType": "JiraVersionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedVersionsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraVersion",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v38 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        v45 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "versionId"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": v43 /*: any*/ ,
                                                                    "concreteType": "JiraGoalConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedGoals",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraGoalEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraGoal",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v27 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v57 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                },
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v34 /*: any*/ ,
                                                                        v41 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraGoalsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "args": v43 /*: any*/ ,
                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "confluenceRemoteIssueLinks",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "href"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v49 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraCmdbObjectConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedCmdbObjectsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraCmdbObject",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "objectId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "label"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatar",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "mediaClientConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "clientId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "fileId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaBaseUrl"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaJwtToken"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "url48"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "QueryError",
                                                                    "kind": "LinkedField",
                                                                    "name": "errors",
                                                                    "plural": true,
                                                                    "selections": v24 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraCMDBField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": "componentsOld",
                                                                    "concreteType": "JiraComponentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedComponentsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraComponent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v58 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraComponentsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v47 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v59 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        v60 /*: any*/ ,
                                                        v42 /*: any*/ 
                                                    ],
                                                    "type": "JiraDatePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v46 /*: any*/ 
                                                    ],
                                                    "type": "JiraDateTimePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraEpic",
                                                            "kind": "LinkedField",
                                                            "name": "epic",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                v61 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "color"
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraEpicLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "renderedFieldHtml"
                                                        }
                                                    ],
                                                    "type": "JiraFallbackField"
                                                },
                                                v48 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusCategory",
                                                            "kind": "LinkedField",
                                                            "name": "statusCategory",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusCategoryField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusId"
                                                                },
                                                                v31 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v43 /*: any*/ ,
                                                            "concreteType": "JiraLabelConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedLabelsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabelEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabel",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v49 /*: any*/ 
                                                            ],
                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                        },
                                                        v38 /*: any*/ ,
                                                        v42 /*: any*/ 
                                                    ],
                                                    "type": "JiraLabelsField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v62 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraIssueTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssue",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                v63 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v64 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v64 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v67 /*: any*/ ,
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "summary",
                                                                                        "issuetype",
                                                                                        "status"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v23 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v29 /*: any*/ ,
                                                                                                        v47 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v29 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "issueTypeId"
                                                                                                                },
                                                                                                                v38 /*: any*/ ,
                                                                                                                v65 /*: any*/ ,
                                                                                                                v33 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                v32 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                                        }
                                                                    ]
                                                                },
                                                                v38 /*: any*/ ,
                                                                v42 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraParentIssueField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        v38 /*: any*/ ,
                                                        v42 /*: any*/ 
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "large"
                                                                        }
                                                                    ]
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraProjectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraResolution",
                                                            "kind": "LinkedField",
                                                            "name": "resolution",
                                                            "plural": false,
                                                            "selections": v58 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraResolutionField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v26 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "sprintId"
                                                                                },
                                                                                v38 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "state"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "endDate"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v38 /*: any*/ ,
                                                        v42 /*: any*/ 
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                v54 /*: any*/ ,
                                                                v55 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v26 /*: any*/ ,
                                                                v56 /*: any*/ 
                                                            ]
                                                        },
                                                        v38 /*: any*/ ,
                                                        v60 /*: any*/ ,
                                                        v42 /*: any*/ 
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        {
                                                            "args": v43 /*: any*/ ,
                                                            "concreteType": "JiraVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedVersionsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v58 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                        }
                                                    ],
                                                    "type": "JiraMultipleVersionPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraRichText",
                                                            "kind": "LinkedField",
                                                            "name": "richText",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraADF",
                                                                    "kind": "LinkedField",
                                                                    "name": "adfValue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                            "kind": "LinkedField",
                                                                            "name": "convertedPlainText",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "plainText"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraRichTextField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraServiceManagementRequestType",
                                                            "kind": "LinkedField",
                                                            "name": "requestType",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                v65 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementRequestTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 1
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinkConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                v49 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v67 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "ids",
                                                                                                    "value": [
                                                                                                        "statusCategory"
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldsById",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v31 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                        },
                                                                                        v26 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v68 /*: any*/ ,
                                                                                v26 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinkConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraIssueLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isStoryPointField"
                                                        },
                                                        v69 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                v69 /*: any*/ ,
                                                                v70 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v69 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v70 /*: any*/ ,
                                                                v42 /*: any*/ 
                                                            ]
                                                        },
                                                        v42 /*: any*/ 
                                                    ],
                                                    "type": "JiraNumberField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraGroupConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedGroupsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraGroupEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraGroup",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v38 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "groupId"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleGroupPickerField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFlag",
                                                                    "kind": "LinkedField",
                                                                    "name": "flag",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isFlagged"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraFlagField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraWatch",
                                                                    "kind": "LinkedField",
                                                                    "name": "watch",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "count"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isWatching"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraWatchesField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v50 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v72 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v73 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v37 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v59 /*: any*/ 
                                                    ],
                                                    "type": "JiraDatePickerField"
                                                },
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "childRowsLoaderQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isReparentingEnabled",
                            "variableName": "isReparentingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isTimelineEnabled",
                            "variableName": "isTimelineEnabled"
                        },
                        v21 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "childRowsPagination_issueTableHierarchy_query"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v22 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v11 /*: any*/ ,
                v8 /*: any*/ ,
                v12 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v13 /*: any*/ ,
                v20 /*: any*/ ,
                v14 /*: any*/ ,
                v7 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v17 /*: any*/ ,
                v5 /*: any*/ ,
                v16 /*: any*/ ,
                v15 /*: any*/ ,
                v19 /*: any*/ ,
                v18 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "childRowsLoaderQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v22 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        },
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "status"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"status\"])"
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        v26 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v34 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "fieldSetIds",
                                                                            "variableName": "fieldSetIds"
                                                                        },
                                                                        v35 /*: any*/ 
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsById",
                                                                    "plural": false,
                                                                    "selections": v71 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "context",
                                                                            "variableName": "fieldSetsContext"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "filterId",
                                                                            "variableName": "filterId"
                                                                        },
                                                                        v35 /*: any*/ ,
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "namespace",
                                                                            "variableName": "namespace"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "viewId",
                                                                            "variableName": "viewId"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsForIssueSearchView",
                                                                    "plural": false,
                                                                    "selections": v71 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isReparentingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v61 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v62 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryHasChildren",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "filterByProjectKeys",
                                                            "variableName": "projectKeys"
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasChildren"
                                                },
                                                {
                                                    "args": [
                                                        v21 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "canHaveChildIssues"
                                                }
                                            ]
                                        },
                                        v57 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v72 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": v71 /*: any*/ ,
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startCursor"
                                        }
                                    ]
                                },
                                v25 /*: any*/ ,
                                {
                                    "condition": "isTimelineEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v72 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": v73 /*: any*/ ,
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 10
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinks",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "fieldSetIds",
                                                                                                    "value": [
                                                                                                        "Start date[Date]"
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldSetsById",
                                                                                            "plural": false,
                                                                                            "selections": v73 /*: any*/ ,
                                                                                            "storageKey": "fieldSetsById(fieldSetIds:[\"Start date[Date]\"])"
                                                                                        },
                                                                                        v28 /*: any*/ ,
                                                                                        v26 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v68 /*: any*/ ,
                                                                                v26 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinks(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v57 /*: any*/ 
                            ]
                        },
                        {
                            "args": v22 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options",
                                "fieldSetsInput",
                                "viewConfigInput"
                            ],
                            "handle": "connection",
                            "key": "hierarchy_nativeIssueTable__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7c6d137855573f13e263411e4c42c00a542036b943a104e40105269c0af7c230",
            "metadata": {},
            "name": "childRowsLoaderQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$7363cdf67fe600e0$var$node.hash = "c3699d41c1f2b48e7b65b6a252f0d094";
var $7363cdf67fe600e0$export$2e2bcd8739ae039 = $7363cdf67fe600e0$var$node;

});

parcelRegister("w9XlC", function(module, exports) {

$parcel$export(module.exports, "getChildQueryVariablesForJql", () => $2b632183a7f3afac$export$e5b06f7246d135e);
$parcel$export(module.exports, "getChildQueryVariablesForParentIssue", () => $2b632183a7f3afac$export$e350acffa980a984);

var $4R6GH = parcelRequire("4R6GH");

var $65VLO = parcelRequire("65VLO");
const $2b632183a7f3afac$var$getProjectKeyFromIssueKey = (issueKey)=>{
    return issueKey.split('-')[0];
};
const $2b632183a7f3afac$var$getChildQueryVariablesBase = ({ cloudId: cloudId, columns: columns, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, actionColumns: actionColumns, amountOfColumns: amountOfColumns, pageSize: pageSize })=>{
    let fieldSetIds = columns.filter((column)=>!!column.id && !actionColumns.includes(column.id)).map((column)=>column.id).sort();
    const mergedColumnsIds = (0, $4R6GH.fg)('jira_list_merged_column_gate') ? (columns.find((col)=>col?.id === (0, $65VLO.COLUMN_ID_MERGED_COLUMN))?.mergedColumns ?? []).map((col)=>col.id) : [];
    fieldSetIds = [
        ...mergedColumnsIds,
        ...fieldSetIds
    ];
    return {
        cloudId: cloudId,
        amountOfColumns: amountOfColumns,
        fieldSetsInput: {
            fieldSetIds: fieldSetIds
        },
        fieldSetIds: fieldSetIds,
        first: pageSize,
        namespace: '',
        shouldQueryFieldSetsById: true,
        filterId: null,
        viewId: null,
        isReparentingEnabled: isReparentingEnabled,
        isTimelineEnabled: isTimelineEnabled
    };
};
const $2b632183a7f3afac$export$e5b06f7246d135e = ({ cloudId: cloudId, columns: columns, jql: jql, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, actionColumns: actionColumns, amountOfColumns: amountOfColumns, pageSize: pageSize, isHideDoneItemsEnabled: isHideDoneItemsEnabled })=>{
    return {
        ...$2b632183a7f3afac$var$getChildQueryVariablesBase({
            cloudId: cloudId,
            columns: columns,
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize
        }),
        issueSearchInput: {
            jql: jql
        },
        shouldQueryHasChildren: false,
        ...isHideDoneItemsEnabled && (0, $4R6GH.fg)('jsc_list_hide_done_items') && {
            viewConfigInput: {
                staticViewInput: {
                    isHideDoneEnabled: true
                }
            }
        }
    };
};
const $2b632183a7f3afac$export$e350acffa980a984 = ({ cloudId: cloudId, columns: columns, parentIssueKey: parentIssueKey, jql: jql, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, isHideDoneItemsEnabled: isHideDoneItemsEnabled, actionColumns: actionColumns, amountOfColumns: amountOfColumns, pageSize: pageSize })=>{
    const projectKey = $2b632183a7f3afac$var$getProjectKeyFromIssueKey(parentIssueKey);
    return {
        ...$2b632183a7f3afac$var$getChildQueryVariablesBase({
            cloudId: cloudId,
            columns: columns,
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize
        }),
        issueSearchInput: {
            childIssuesInput: {
                parentIssueKey: parentIssueKey,
                filterByProjectKeys: [
                    projectKey
                ],
                ...jql ? {
                    jql: jql
                } : {},
                ...(0, $4R6GH.fg)('jsc_list_hide_done_items') && {
                    namespace: 'ISSUE_NAVIGATOR'
                }
            }
        },
        projectKeys: [
            projectKey
        ],
        projectKey: projectKey,
        viewConfigInput: {
            staticViewInput: {
                isHierarchyEnabled: true,
                isGroupingEnabled: false,
                ...(0, $4R6GH.fg)('jsc_list_hide_done_items') && {
                    isHideDoneEnabled: isHideDoneItemsEnabled
                }
            }
        },
        shouldQueryHasChildren: true
    };
};

});

parcelRegister("gQNeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4908284f036b3683$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $fc4cz = parcelRequire("fc4cz");
const $4908284f036b3683$var$LoadingIssueRow = ({ itemId: itemId, groupId: groupId, columnsCount: columnsCount, isFixedTableLayoutEnabled: isFixedTableLayoutEnabled, renderTableCell: renderTableCell })=>{
    const { setItemIsLoading: setItemIsLoading } = (0, $fc4cz.useHierarchyActions)();
    (0, $5uXOq.useEffect)(()=>{
        setItemIsLoading({
            itemId: itemId,
            groupId: groupId,
            isLoading: true
        });
        return ()=>{
            setItemIsLoading({
                itemId: itemId,
                groupId: groupId,
                isLoading: false
            });
        };
    }, [
        itemId,
        groupId,
        setItemIsLoading
    ]);
    const columns = Array.from({
        length: columnsCount
    });
    const colSpans = columns.map((_, index)=>{
        const isLastColumn = index === columns.length - 1;
        return 1 + (isLastColumn && isFixedTableLayoutEnabled ? 1 : 0);
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        as: "tr",
        xcss: $4908284f036b3683$var$wrapperStyles
    }, columns.map((_, i)=>renderTableCell({
            key: `${itemId}-${i}`,
            colSpan: colSpans[i],
            border: [
                $4908284f036b3683$var$cellBorderStyles,
                i === columnsCount - 1 && $4908284f036b3683$var$lastCellBorderStyles
            ],
            children: /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
                xcss: $4908284f036b3683$var$loadingCellStyles
            })
        })));
};
var $4908284f036b3683$export$2e2bcd8739ae039 = $4908284f036b3683$var$LoadingIssueRow;
const $4908284f036b3683$var$wrapperStyles = (0, $8CUq3.xcss)({
    height: '40px'
});
const $4908284f036b3683$var$cellBorderStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTopWidth: 'border.width',
    borderBottomWidth: '0',
    borderLeftWidth: '0',
    borderRightWidth: 'border.width'
});
const $4908284f036b3683$var$lastCellBorderStyles = (0, $8CUq3.xcss)({
    borderRightWidth: '0'
});
const $4908284f036b3683$var$loadingCellStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)",
    padding: 'space.150',
    width: '100%'
});

});

parcelRegister("6OGT1", function(module, exports) {

$parcel$export(module.exports, "isGroupLoader", () => $87963a737922547e$export$2ce2ba220d1f6f03);
$parcel$export(module.exports, "ChildRowsPagination", () => $87963a737922547e$export$74d2c2d9ae144c85);

var $6W1xX = parcelRequire("6W1xX");

var $cwC3G = parcelRequire("cwC3G");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $fc4cz = parcelRequire("fc4cz");

var $5FoyW = parcelRequire("5FoyW");

var $6387V = parcelRequire("6387V");

var $9E5tC = parcelRequire("9E5tC");
const $87963a737922547e$var$PACKAGE_LOCATION = 'jira-issue-table-hierarchy-child-rows-pagination';
const $87963a737922547e$export$2ce2ba220d1f6f03 = (props)=>'groupJql' in props && Boolean(props.groupJql);
const $87963a737922547e$export$74d2c2d9ae144c85 = ({ query: query, depth: depth, parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentIssueAri: parentIssueAri, parentItemConnectionId: parentItemConnectionId, parentIssueRelayConnectionId: parentIssueRelayConnectionId, isFormVisible: isFormVisible, formProps: formProps, connectionMetadata: connectionMetadata, projectKey: projectKey, pageSize: pageSize, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, isIssueRankDescending: isIssueRankDescending, groupId: groupId, width: width, columns: columns, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper })=>{
    const { data: queryData, loadNext: loadNext, isLoadingNext: isLoadingNext, hasNext: hasNext } = (0, $8Uumt.usePaginationFragment)((0, $cwC3G.default), query);
    const issueResultsData = (0, $8Uumt.useFragment)((0, $6W1xX.default), queryData?.jira?.issueSearch);
    const { type: type } = connectionMetadata || {};
    const isGroupChildren = type === 'GROUP_CHILDREN';
    const onCreateIssueRef = (0, $5uXOq.useRef)();
    const setOnCreateIssue = (0, $5uXOq.useCallback)((onCreateIssue)=>{
        onCreateIssueRef.current = onCreateIssue;
    }, []);
    // Set the issue count on the group record if needed
    (0, $6387V.useUpdateGroupIssueCountOnExpand)({
        groupId: groupId,
        isGroupChildren: isGroupChildren,
        totalIssueSearchResultCount: issueResultsData.totalIssueSearchResultCount || 0,
        isCappingIssueSearchResult: issueResultsData.isCappingIssueSearchResult ?? false
    });
    const onExperienceLoadMoreStart = (0, $kaHBi.useExperienceStart)({
        experience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource
    });
    const onExperienceLoadMoreFail = (0, $93jKl.useExperienceFail)({
        experience: childItemsLoadMoreExperience,
        attributes: {}
    });
    const onExperienceLoadMoreSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: childItemsLoadMoreExperience,
        attributes: {}
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: childItemsExperience,
        attributes: {}
    });
    (0, $5uXOq.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    const childConnectionId = issueResultsData.__id;
    const [isSelected] = (0, $fc4cz.useIsSelected)({
        itemsConnectionId: itemsConnectionId,
        groupId: groupId,
        itemId: parentItemId
    });
    const siblingIssueId = issueResultsData.edges?.[0]?.node?.id;
    const isChildIssueCreateRowVisible = isSelected && !!formProps && isFormVisible && ((0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') || !!parentIssueAri && !!parentItemConnectionId);
    if ((0, $6s1PB.expVal)('jira_list_realtime_updates_with_queue', 'isEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $6387V.useUpdateHierarchyHasChildrenOnExpand)({
        connectionMetadata: connectionMetadata,
        projectKey: projectKey,
        childCount: issueResultsData.edges?.length ?? 0
    });
    if ((0, $4R6GH.fg)('decouple_connection_register_hooks_from_realtime')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const connectionDetails = (0, $5uXOq.useMemo)(()=>{
            if (issueResultsData?.edges?.length === undefined || issueResultsData.edges.length === 0 && !isChildIssueCreateRowVisible || !connectionMetadata) return undefined;
            return {
                connectionId: childConnectionId,
                // This is the value the backend uses to fetch the issue list for realtime updates. It should be the connection length + 1
                // to ensure a potentially newly created issue is also fetched and included in the results.
                first: issueResultsData.edges.length + 1,
                ...connectionMetadata
            };
        }, [
            childConnectionId,
            connectionMetadata,
            isChildIssueCreateRowVisible,
            issueResultsData.edges?.length
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5FoyW.useRegisterConnection)(connectionDetails);
    }
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onCompleteLoadNextItems = (0, $5uXOq.useCallback)((error)=>{
        if (!error) onExperienceLoadMoreSuccess();
        else onExperienceLoadMoreFail($87963a737922547e$var$PACKAGE_LOCATION, error);
    }, [
        onExperienceLoadMoreFail,
        onExperienceLoadMoreSuccess
    ]);
    const loadNextItems = (0, $5uXOq.useCallback)(()=>{
        onExperienceLoadMoreStart();
        const actionSubjectId = isGroupChildren ? 'groupingLoadMore' : 'hierarchyLoadMore';
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', actionSubjectId);
        loadNext(pageSize, {
            onComplete: onCompleteLoadNextItems
        });
    }, [
        pageSize,
        onExperienceLoadMoreStart,
        isGroupChildren,
        createAnalyticsEvent,
        loadNext,
        onCompleteLoadNextItems
    ]);
    const renderChildIssueCreateRow = (0, $5uXOq.useCallback)(()=>isChildIssueCreateRowVisible && onCreateIssueRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9E5tC.ChildIssueCreateRow), {
            depth: depth,
            parentIssueAri: parentIssueAri,
            siblingIssueId: siblingIssueId,
            isFormVisible: isFormVisible ?? false,
            ...formProps,
            width: width,
            isIssueRankDescending: isIssueRankDescending,
            onCreateIssue: onCreateIssueRef.current,
            columns: columns
        }) : null, [
        isIssueRankDescending,
        depth,
        formProps,
        isChildIssueCreateRowVisible,
        isFormVisible,
        parentIssueAri,
        siblingIssueId,
        width,
        columns
    ]);
    const renderChildRowsBody = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderCreateIssueController({
            childConnectionId: issueResultsData.__id,
            parentItemConnectionId: parentItemConnectionId,
            setOnCreateIssue: setOnCreateIssue
        }), renderRows({
            issueResults: issueResultsData,
            depth: depth + 1,
            parentItemId: parentItemId,
            itemsConnectionId: itemsConnectionId,
            parentIssueAri: parentIssueAri,
            parentItemConnectionId: parentItemConnectionId,
            isLoadingNext: isLoadingNext,
            hasNext: hasNext,
            onLoadNextItems: loadNextItems,
            renderChildIssueCreateRow: renderChildIssueCreateRow,
            isChildIssueCreateRowVisible: isChildIssueCreateRowVisible,
            parentIssueRelayConnectionId: parentIssueRelayConnectionId,
            ...(0, $4R6GH.fg)('jsc_list_reparenting') ? {
                projectKey: projectKey
            } : {}
        }));
    }, [
        issueResultsData,
        parentItemConnectionId,
        setOnCreateIssue,
        depth,
        parentItemId,
        itemsConnectionId,
        parentIssueAri,
        isLoadingNext,
        hasNext,
        loadNextItems,
        renderChildIssueCreateRow,
        isChildIssueCreateRowVisible,
        parentIssueRelayConnectionId,
        projectKey,
        renderCreateIssueController,
        renderRows
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderDraggableWrapper && (0, $4R6GH.fg)('jsc_list_reranking_gate_technical') ? renderDraggableWrapper({
        instanceId: issueResultsData?.__id,
        issueConnectionId: childConnectionId,
        children: renderChildRowsBody()
    }) : renderChildRowsBody());
};

});
parcelRegister("6W1xX", function(module, exports) {

$parcel$export(module.exports, "default", () => $148063c0079f4010$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eeae3291fefd10dd69b9dc17a886c576>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $148063c0079f4010$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "childRowsPagination_issueTableHierarchy_queryData",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "rows_nativeIssueTable"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$148063c0079f4010$var$node.hash = "2619a4ac37ba6976cb043bc487a2810b";
var $148063c0079f4010$export$2e2bcd8739ae039 = $148063c0079f4010$var$node;

});

parcelRegister("cwC3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $217bcf913fbd49aa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a221ea4fa164417b5d80128a98aa762f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $jUiJS = parcelRequire("jUiJS");
const $217bcf913fbd49aa$var$node = function() {
    var v0 = [
        "jira",
        "issueSearch"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsContext"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $jUiJS.default)
            }
        },
        "name": "childRowsPagination_issueTableHierarchy_query",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "issueSearch",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "fieldSetsInput",
                                        "variableName": "fieldSetsInput"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "issueSearchInput",
                                        "variableName": "issueSearchInput"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "options",
                                        "variableName": "options"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "viewConfigInput",
                                        "variableName": "viewConfigInput"
                                    }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "__hierarchy_nativeIssueTable__issueSearch_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "isDensityFull",
                                                "variableName": "isDensityFull"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isInlineEditingEnabled",
                                                "variableName": "isInlineEditingEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isReparentingEnabled",
                                                "variableName": "isReparentingEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isTimelineEnabled",
                                                "variableName": "isTimelineEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "projectKey",
                                                "variableName": "projectKey"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "projectKeys",
                                                "variableName": "projectKeys"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "shouldQueryHasChildren",
                                                "variableName": "shouldQueryHasChildren"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "childRowsPagination_issueTableHierarchy_queryData"
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasPreviousPage"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "startCursor"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__id"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.issueSearch"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$217bcf913fbd49aa$var$node.hash = "cd11990db9bbf06820091bbc62203810";
var $217bcf913fbd49aa$export$2e2bcd8739ae039 = $217bcf913fbd49aa$var$node;

});
parcelRegister("jUiJS", function(module, exports) {

$parcel$export(module.exports, "default", () => $71e0d6c568ce58b6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bed31a6f5e5b17c2ab101c2ad91ae293>>
 * @relayHash 4c88807da0241b07342cd1c62268aab0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 000a46a7c0165518d8978fab82eb6a2afe51abe195e99c1f4b5e80f545dac426

var $5oQtH = parcelRequire("5oQtH");

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $71e0d6c568ce58b6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v10 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isReparentingEnabled"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v23 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v24 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v26 = {
        "kind": "ScalarField",
        "name": "id"
    }, v27 = {
        "kind": "ScalarField",
        "name": "key"
    }, v28 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v31 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            v29 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v26 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v33 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v35 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v36 = {
        "kind": "ScalarField",
        "name": "type"
    }, v37 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v38 = {
        "kind": "ScalarField",
        "name": "name"
    }, v39 = {
        "kind": "ScalarField",
        "name": "value"
    }, v40 = [
        v39 /*: any*/ ,
        v26 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v41 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v42 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v43 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v44 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v45 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v46 = {
        "kind": "ScalarField",
        "name": "text"
    }, v47 = {
        "kind": "InlineFragment",
        "selections": [
            v46 /*: any*/ ,
            v38 /*: any*/ ,
            v41 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v48 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v49 = [
        v48 /*: any*/ 
    ], v50 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v26 /*: any*/ 
        ]
    }, v51 = [
        v50 /*: any*/ 
    ], v52 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v53 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v54 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v55 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v56 = {
        "kind": "ClientExtension",
        "selections": [
            v34 /*: any*/ 
        ]
    }, v57 = [
        v38 /*: any*/ ,
        v26 /*: any*/ 
    ], v58 = {
        "kind": "ScalarField",
        "name": "date"
    }, v59 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v60 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v61 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v62 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v46 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v63 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v50 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v64 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v65 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v64 /*: any*/ ,
                    v38 /*: any*/ ,
                    v26 /*: any*/ 
                ]
            },
            v26 /*: any*/ 
        ]
    }, v66 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v67 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v68 = {
        "kind": "ScalarField",
        "name": "number"
    }, v69 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v70 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v36 /*: any*/ ,
                        v37 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v25 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraIssueField"
                                                },
                                                v26 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAffectedServiceConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedAffectedServicesConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAffectedService",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "serviceId"
                                                                                },
                                                                                v38 /*: any*/ ,
                                                                                v26 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAffectedServicesField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraCascadingOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "cascadingOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "parentOptionValue",
                                                                            "plural": false,
                                                                            "selections": v40 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "childOptionValue",
                                                                            "plural": false,
                                                                            "selections": v40 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "JiraCascadingSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "args": v42 /*: any*/ ,
                                                                    "concreteType": "JiraComponentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedComponentsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraComponent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v43 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        v26 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                },
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "JiraComponentsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "JiraDateTimePickerField"
                                                        },
                                                        v47 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCommentSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "commentSummary",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canAddComment"
                                                                        },
                                                                        v48 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraCommentSummaryField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "uri"
                                                                },
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "JiraUrlField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOptions",
                                                                    "plural": false,
                                                                    "selections": v49 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v39 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v51 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v51 /*: any*/ 
                                                                        },
                                                                        v26 /*: any*/ ,
                                                                        v52 /*: any*/ 
                                                                    ]
                                                                },
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v39 /*: any*/ ,
                                                                                        v52 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v39 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "JiraCheckboxesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraUserConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedUsersConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraUserEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v25 /*: any*/ ,
                                                                                        v53 /*: any*/ ,
                                                                                        v38 /*: any*/ ,
                                                                                        v54 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v55 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "email"
                                                                                                }
                                                                                            ],
                                                                                            "type": "AtlassianAccountUser"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraTeamView",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedTeam",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraSuppliedId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraSuppliedName"
                                                                        }
                                                                    ]
                                                                },
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "JiraTeamViewField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraTimeTrackingField",
                                                                            "kind": "LinkedField",
                                                                            "name": "timeTrackingField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v26 /*: any*/ ,
                                                                                v41 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraEstimate",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "originalEstimate",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "timeInSeconds"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "timeTrackingSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingHoursPerDay"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingDaysPerWeek"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultFormat"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultUnit"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v29 /*: any*/ ,
                                                                                v38 /*: any*/ ,
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraOriginalTimeEstimateField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": "label",
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        },
                                                                        v26 /*: any*/ ,
                                                                        v43 /*: any*/ 
                                                                    ]
                                                                },
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "args": v42 /*: any*/ ,
                                                                    "concreteType": "JiraVersionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedVersionsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraVersion",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v38 /*: any*/ ,
                                                                                        v43 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "versionId"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                },
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": v42 /*: any*/ ,
                                                                    "concreteType": "JiraGoalConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedGoals",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraGoalEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraGoal",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v27 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                },
                                                                v41 /*: any*/ ,
                                                                v56 /*: any*/ 
                                                            ],
                                                            "type": "JiraGoalsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "args": v42 /*: any*/ ,
                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "confluenceRemoteIssueLinks",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "href"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v48 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                },
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraCmdbObjectConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedCmdbObjectsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraCmdbObject",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "objectId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "label"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatar",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "mediaClientConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "clientId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "fileId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaBaseUrl"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaJwtToken"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "url48"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "QueryError",
                                                                    "kind": "LinkedField",
                                                                    "name": "errors",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "message"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraCMDBField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": "componentsOld",
                                                                    "concreteType": "JiraComponentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedComponentsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraComponent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v57 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraComponentsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v46 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v58 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        v59 /*: any*/ ,
                                                        v41 /*: any*/ 
                                                    ],
                                                    "type": "JiraDatePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ 
                                                    ],
                                                    "type": "JiraDateTimePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraEpic",
                                                            "kind": "LinkedField",
                                                            "name": "epic",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                v60 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "color"
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraEpicLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "renderedFieldHtml"
                                                        }
                                                    ],
                                                    "type": "JiraFallbackField"
                                                },
                                                v47 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusCategory",
                                                            "kind": "LinkedField",
                                                            "name": "statusCategory",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusCategoryField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusId"
                                                                },
                                                                v31 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v42 /*: any*/ ,
                                                            "concreteType": "JiraLabelConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedLabelsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabelEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabel",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v48 /*: any*/ 
                                                            ],
                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                        },
                                                        v38 /*: any*/ ,
                                                        v41 /*: any*/ 
                                                    ],
                                                    "type": "JiraLabelsField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v61 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraIssueTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssue",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                v62 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "summary",
                                                                                        "issuetype",
                                                                                        "status"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v25 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v29 /*: any*/ ,
                                                                                                        v46 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v29 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "issueTypeId"
                                                                                                                },
                                                                                                                v38 /*: any*/ ,
                                                                                                                v64 /*: any*/ ,
                                                                                                                v33 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                v32 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                                        }
                                                                    ]
                                                                },
                                                                v38 /*: any*/ ,
                                                                v41 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraParentIssueField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        v38 /*: any*/ ,
                                                        v41 /*: any*/ 
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "large"
                                                                        }
                                                                    ]
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraProjectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraResolution",
                                                            "kind": "LinkedField",
                                                            "name": "resolution",
                                                            "plural": false,
                                                            "selections": v57 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraResolutionField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v26 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "sprintId"
                                                                                },
                                                                                v38 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "state"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "endDate"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v38 /*: any*/ ,
                                                        v41 /*: any*/ 
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                v53 /*: any*/ ,
                                                                v54 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v26 /*: any*/ ,
                                                                v55 /*: any*/ 
                                                            ]
                                                        },
                                                        v38 /*: any*/ ,
                                                        v59 /*: any*/ ,
                                                        v41 /*: any*/ 
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        {
                                                            "args": v42 /*: any*/ ,
                                                            "concreteType": "JiraVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedVersionsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v57 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                        }
                                                    ],
                                                    "type": "JiraMultipleVersionPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraRichText",
                                                            "kind": "LinkedField",
                                                            "name": "richText",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraADF",
                                                                    "kind": "LinkedField",
                                                                    "name": "adfValue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "isDensityFull",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "convertedPlainText",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "plainText"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "isDensityFull",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "json"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraRichTextField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraServiceManagementRequestType",
                                                            "kind": "LinkedField",
                                                            "name": "requestType",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                v64 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementRequestTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 1
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinkConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                v48 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v66 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "ids",
                                                                                                    "value": [
                                                                                                        "statusCategory"
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldsById",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v31 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                        },
                                                                                        v26 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v67 /*: any*/ ,
                                                                                v26 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinkConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraIssueLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isStoryPointField"
                                                        },
                                                        v68 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                v68 /*: any*/ ,
                                                                v69 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v68 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v41 /*: any*/ ,
                                                                v69 /*: any*/ 
                                                            ]
                                                        },
                                                        v41 /*: any*/ 
                                                    ],
                                                    "type": "JiraNumberField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraGroupConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedGroupsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraGroupEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraGroup",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v38 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "groupId"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleGroupPickerField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFlag",
                                                                    "kind": "LinkedField",
                                                                    "name": "flag",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isFlagged"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraFlagField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraWatch",
                                                                    "kind": "LinkedField",
                                                                    "name": "watch",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "count"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isWatching"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraWatchesField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v49 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v71 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v72 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v37 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v25 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v58 /*: any*/ 
                                                    ],
                                                    "type": "JiraDatePickerField"
                                                },
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "tableBody_issueTableHierarchy_childIssuesPaginationQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDensityFull",
                            "variableName": "isDensityFull"
                        },
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isReparentingEnabled",
                            "variableName": "isReparentingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isTimelineEnabled",
                            "variableName": "isTimelineEnabled"
                        },
                        v23 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "childRowsPagination_issueTableHierarchy_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "tableBody_issueTableHierarchy_childIssuesPaginationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v24 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        },
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v25 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "status"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v25 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"status\"])"
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        v26 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v34 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "fieldSetIds",
                                                                            "variableName": "fieldSetIds"
                                                                        },
                                                                        v35 /*: any*/ 
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsById",
                                                                    "plural": false,
                                                                    "selections": v70 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "context",
                                                                            "variableName": "fieldSetsContext"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "filterId",
                                                                            "variableName": "filterId"
                                                                        },
                                                                        v35 /*: any*/ ,
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "namespace",
                                                                            "variableName": "namespace"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "viewId",
                                                                            "variableName": "viewId"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsForIssueSearchView",
                                                                    "plural": false,
                                                                    "selections": v70 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isDensityFull",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canBeExported"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isReparentingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v60 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v61 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryHasChildren",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "filterByProjectKeys",
                                                            "variableName": "projectKeys"
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasChildren"
                                                },
                                                {
                                                    "args": [
                                                        v23 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "canHaveChildIssues"
                                                }
                                            ]
                                        },
                                        v56 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v71 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": v70 /*: any*/ ,
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startCursor"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isTimelineEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v71 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": v72 /*: any*/ ,
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 10
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinks",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "fieldSetIds",
                                                                                                    "value": [
                                                                                                        "Start date[Date]"
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldSetsById",
                                                                                            "plural": false,
                                                                                            "selections": v72 /*: any*/ ,
                                                                                            "storageKey": "fieldSetsById(fieldSetIds:[\"Start date[Date]\"])"
                                                                                        },
                                                                                        v28 /*: any*/ ,
                                                                                        v26 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v67 /*: any*/ ,
                                                                                v26 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinks(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v56 /*: any*/ 
                            ]
                        },
                        {
                            "args": v24 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options",
                                "fieldSetsInput",
                                "viewConfigInput"
                            ],
                            "handle": "connection",
                            "key": "hierarchy_nativeIssueTable__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "000a46a7c0165518d8978fab82eb6a2afe51abe195e99c1f4b5e80f545dac426",
            "metadata": {},
            "name": "tableBody_issueTableHierarchy_childIssuesPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$71e0d6c568ce58b6$var$node.hash = "cd11990db9bbf06820091bbc62203810";
var $71e0d6c568ce58b6$export$2e2bcd8739ae039 = $71e0d6c568ce58b6$var$node;

});


parcelRegister("6387V", function(module, exports) {

$parcel$export(module.exports, "useUpdateHierarchyHasChildrenOnExpand", () => $7d6bdd94a0ec83ae$export$7ab3d5838740f061);
$parcel$export(module.exports, "useUpdateGroupIssueCountOnExpand", () => $7d6bdd94a0ec83ae$export$60baf22d0466329d);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $iJZ8l = parcelRequire("iJZ8l");
const $7d6bdd94a0ec83ae$export$7ab3d5838740f061 = ({ connectionMetadata: connectionMetadata, projectKey: projectKey, childCount: childCount })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    (0, $5uXOq.useEffect)(()=>{
        if (connectionMetadata?.type === 'PARENT_CHILDREN' && childCount === 0) (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            const parentIssueRecord = store.get(connectionMetadata.parentRelayId);
            const updateArgs = projectKey ? {
                filterByProjectKeys: [
                    projectKey
                ]
            } : undefined;
            if (parentIssueRecord && parentIssueRecord.getValue('hasChildren', updateArgs) === true) parentIssueRecord.setValue(false, 'hasChildren', updateArgs);
        });
    }, [
        childCount,
        connectionMetadata,
        environment,
        projectKey
    ]);
};
const $7d6bdd94a0ec83ae$export$60baf22d0466329d = ({ groupId: groupId, isGroupChildren: isGroupChildren, totalIssueSearchResultCount: totalIssueSearchResultCount, isCappingIssueSearchResult: isCappingIssueSearchResult })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    // we need to update the group only once when the component mounts which happens on first expand
    // Other changes to issue count will be handled by realtime connection updates
    // also, we don't need to update the "firstGroup" field in the group record as it's expanded on default and realtime event always updates it
    const hasIssueCountUpdated = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasIssueCountUpdated.current && groupId && isGroupChildren) (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            const relayId = (0, $iJZ8l.default)({
                id: groupId
            }, 'JiraSpreadsheetGroup');
            if (!relayId) return;
            const groupRecord = store.get(relayId);
            if (groupRecord?.getValue('issueCount') !== totalIssueSearchResultCount && !isCappingIssueSearchResult) groupRecord?.setValue(totalIssueSearchResultCount, 'issueCount');
        });
        hasIssueCountUpdated.current = true;
    }, [
        environment,
        groupId,
        isCappingIssueSearchResult,
        isGroupChildren,
        totalIssueSearchResultCount
    ]);
};

});

parcelRegister("9E5tC", function(module, exports) {

$parcel$export(module.exports, "ChildIssueCreateRow", () => $e95517d184fdeedb$export$3a3a78b432b7032f);

var $5uXOq = parcelRequire("5uXOq");

var $czV24 = parcelRequire("czV24");
const $e95517d184fdeedb$export$3a3a78b432b7032f = ({ isFormVisible: isFormVisible, ...props })=>{
    return isFormVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $czV24.IssueCreateCell), props));
};

});
parcelRegister("czV24", function(module, exports) {

$parcel$export(module.exports, "IssueCreateCell", () => $8386f9e1c76ee862$export$2337c3632571bf46);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8wqxH = parcelRequire("8wqxH");
const $8386f9e1c76ee862$export$2337c3632571bf46 = ({ parentIssueAri: parentIssueAri, siblingIssueId: siblingIssueId, depth: depth, isIssueRankDescending: isIssueRankDescending, width: width, onCreateIssue: onCreateIssue, ...props })=>{
    const formContextualFields = (0, $5uXOq.useMemo)(()=>isIssueRankDescending ? {
            rankAfterIssueId: siblingIssueId
        } : {
            rankBeforeIssueId: siblingIssueId
        }, [
        isIssueRankDescending,
        siblingIssueId
    ]);
    const handleIssueCreate = (0, $5uXOq.useCallback)((issueToCreate, contextualFields)=>{
        onCreateIssue(issueToCreate, {
            ...contextualFields,
            parentIssueAri: parentIssueAri
        }, {
            insertAfter: false,
            insertNodeId: siblingIssueId
        });
    }, [
        onCreateIssue,
        parentIssueAri,
        siblingIssueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "td",
        xcss: $8386f9e1c76ee862$var$cellStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8386f9e1c76ee862$var$boxStyles,
        style: {
            width: `${width}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wqxH.default), {
        contextualFields: formContextualFields,
        onCreateIssue: handleIssueCreate,
        depth: depth + 1,
        ...props
    })));
};
const $8386f9e1c76ee862$var$cellStyles = (0, $8CUq3.xcss)({
    height: '40px',
    left: 'space.0',
    position: 'sticky',
    zIndex: 'card'
});
const $8386f9e1c76ee862$var$boxStyles = (0, $8CUq3.xcss)({
    left: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});




parcelRegister("ft6vz", function(module, exports) {

$parcel$export(module.exports, "FirstGroupRow", () => $950c8ae27a0c8d48$export$ac1801bcb8e0f256);
$parcel$export(module.exports, "GroupRow", () => $950c8ae27a0c8d48$export$84aac6ac2cec7eed);
$parcel$export(module.exports, "GroupRowWithMemo", () => $950c8ae27a0c8d48$export$882de0673bc73466);
$parcel$export(module.exports, "FirstGroupRowWithMemo", () => $950c8ae27a0c8d48$export$85293ebb086fe36d);

var $3CMyU = parcelRequire("3CMyU");

var $lEhB5 = parcelRequire("lEhB5");

var $5uXOq = parcelRequire("5uXOq");

var $3NMrl = parcelRequire("3NMrl");

var $8Uumt = parcelRequire("8Uumt");

var $2S8IK = parcelRequire("2S8IK");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $fc4cz = parcelRequire("fc4cz");

var $w9XlC = parcelRequire("w9XlC");

var $6s1PB = parcelRequire("6s1PB");

var $5fc53 = parcelRequire("5fc53");

var $g6NP9 = parcelRequire("g6NP9");

var $3Q1xZ = parcelRequire("3Q1xZ");

var $jFCcB = parcelRequire("jFCcB");
const $950c8ae27a0c8d48$var$getGroupFieldValue = (fieldValue)=>{
    switch(fieldValue?.__typename){
        case 'JiraJqlPriorityFieldValue':
            return fieldValue?.priority?.priorityId ?? null;
        case 'JiraJqlUserFieldValue':
            return fieldValue?.user?.accountId ?? null;
        case 'JiraJqlStatusFieldValue':
            return fieldValue?.status?.id ?? null;
        case 'JiraJqlNumberFieldValue':
            return fieldValue?.number?.toString() ?? null;
        case 'JiraJqlOptionFieldValue':
            return fieldValue?.option?.optionId ?? null;
        case 'JiraJqlSprintFieldValue':
            return fieldValue?.sprint?.sprintId ?? null;
        case 'JiraJqlGoalsFieldValue':
            return fieldValue?.goal?.id ?? null;
        default:
            return null;
    }
};
const $950c8ae27a0c8d48$export$6afa27f3196791b2 = ({ fieldType: fieldType, fieldId: fieldId, fieldValue: fieldValue })=>{
    switch(fieldType){
        case 0, $5fc53.PRIORITY_TYPE:
            if (fieldValue?.__typename === 'JiraJqlPriorityFieldValue' && fieldValue?.priority) return {
                type: (0, $5fc53.PRIORITY_TYPE),
                priority: {
                    id: fieldValue.priority.priorityId,
                    name: fieldValue.priority.name,
                    iconUrl: fieldValue.priority.iconUrl
                }
            };
            break;
        case 0, $5fc53.ASSIGNEE_TYPE:
            return {
                type: (0, $5fc53.ASSIGNEE_TYPE),
                user: fieldValue?.__typename === 'JiraJqlUserFieldValue' && fieldValue?.user ? {
                    id: fieldValue.user.accountId,
                    accountId: fieldValue.user.accountId,
                    name: fieldValue.user.name,
                    picture: fieldValue.user.picture
                } : null
            };
        case 0, $5fc53.STATUS_TYPE:
            if (fieldValue?.__typename === 'JiraJqlStatusFieldValue' && fieldValue?.status && fieldValue?.status.statusCategory) return {
                type: (0, $5fc53.STATUS_TYPE),
                status: {
                    id: fieldValue.status.id,
                    name: fieldValue.status.name,
                    statusId: fieldValue.status.id,
                    statusCategory: {
                        statusCategoryId: fieldValue.status.statusCategory.statusCategoryId,
                        id: fieldValue.status.statusCategory.id
                    }
                }
            };
            break;
        case 0, $5fc53.CATEGORY_TYPE:
            return {
                type: (0, $5fc53.CATEGORY_TYPE),
                option: fieldValue?.__typename === 'JiraJqlOptionFieldValue' && fieldValue?.option ? {
                    id: fieldValue.option.optionId,
                    value: fieldValue.option.value,
                    optionId: fieldValue.option.optionId,
                    color: {
                        colorKey: fieldValue.option.color?.colorKey,
                        id: fieldValue.option.color?.id
                    }
                } : null
            };
        case 0, $5fc53.SPRINT_TYPE:
            return {
                type: (0, $5fc53.SPRINT_TYPE),
                sprint: fieldValue?.__typename === 'JiraJqlSprintFieldValue' && fieldValue?.sprint ? {
                    id: fieldValue.sprint.sprintId,
                    sprintId: fieldValue.sprint.sprintId,
                    name: fieldValue.sprint.name,
                    state: fieldValue.sprint.state,
                    endDate: fieldValue.sprint.endDate
                } : null
            };
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
            return {
                type: (0, $5fc53.NUMBER_CF_TYPE),
                value: fieldValue?.__typename === 'JiraJqlNumberFieldValue' ? fieldValue.number : null,
                fieldSetId: fieldId
            };
        case 0, $5fc53.NUMBER_CF_TYPE:
            return {
                type: (0, $5fc53.NUMBER_CF_TYPE),
                value: fieldValue?.__typename === 'JiraJqlNumberFieldValue' ? fieldValue.number : null,
                // TODO: As part of grouping by many fields, this will need to be dynamic
                fieldSetId: 'Story Points[Number]',
                isStoryPointField: true
            };
        default:
            return undefined;
    }
};
const $950c8ae27a0c8d48$export$ac1801bcb8e0f256 = ({ firstGroupRow: firstGroupRow, groupConnectionId: groupConnectionId, isVirtual: isVirtual, loading: loading, isGroupAtTop: isGroupAtTop, projectKey: projectKey = null, columns: columns, actionColumns: actionColumns, amountOfColumns: amountOfColumns, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isTimelineEnabled: isTimelineEnabled, pageSize: pageSize, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, width: width, isIssueRankDescending: isIssueRankDescending, isIssueCreateEnabled: isIssueCreateEnabled, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const firstGroupRowData = (0, $8Uumt.useFragment)((0, $lEhB5.default), firstGroupRow);
    const variables = (0, $5uXOq.useMemo)(()=>{
        return {
            ...(0, $w9XlC.getChildQueryVariablesForJql)({
                cloudId: cloudId,
                columns: columns,
                jql: firstGroupRowData.jql,
                isReparentingEnabled: false,
                isTimelineEnabled: isTimelineEnabled,
                actionColumns: actionColumns,
                amountOfColumns: amountOfColumns,
                pageSize: pageSize,
                isHideDoneItemsEnabled: isHideDoneItemsEnabled
            }),
            shouldQueryFieldSetsById: false,
            namespace: 'ISSUE_NAVIGATOR',
            shouldQueryHasChildren: false
        };
    }, [
        cloudId,
        columns,
        firstGroupRowData.jql,
        isTimelineEnabled,
        actionColumns,
        amountOfColumns,
        pageSize,
        isHideDoneItemsEnabled
    ]);
    const baseProps = [
        'cloudId',
        'issueSearchInput',
        'fieldSetsInput'
    ];
    const propsWithViewConfigInput = [
        ...baseProps,
        'viewConfigInput'
    ];
    const hasInitialised = (0, $3Q1xZ.useInitialiseFirstGroupIssues)({
        groupId: firstGroupRowData.id,
        groupConnectionId: groupConnectionId,
        firstGroupItemsConnectionId: firstGroupRowData.issues?.__id ?? null,
        issueSearchVariables: (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(variables, ...isHideDoneItemsEnabled ? propsWithViewConfigInput : baseProps),
        loading: loading
    });
    const [isExpanded] = (0, $fc4cz.useIsItemExpanded)({
        itemId: firstGroupRowData.id,
        groupId: firstGroupRowData.id,
        itemsConnectionId: groupConnectionId
    });
    let inlineCreateHandlers;
    let groupContextFieldInput;
    const groupFieldValue = $950c8ae27a0c8d48$var$getGroupFieldValue(firstGroupRowData.fieldValue);
    if ((0, $6s1PB.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        inlineCreateHandlers = (0, $2S8IK.useInlineCreateHandlers)({
            projectKey: projectKey,
            minHierarchyLevel: 0
        });
        const { fieldId: fieldId, fieldType: fieldType } = firstGroupRowData;
        groupContextFieldInput = fieldId && fieldType ? {
            fieldValue: groupFieldValue,
            fieldId: fieldId,
            fieldType: fieldType,
            groupId: firstGroupRowData.id,
            optimisticResponse: $950c8ae27a0c8d48$export$6afa27f3196791b2({
                fieldType: fieldType,
                fieldId: fieldId,
                fieldValue: firstGroupRowData.fieldValue
            })
        } : undefined;
    }
    const renderChildIssueControllerWithGroupContextField = (0, $5uXOq.useCallback)((args)=>{
        return renderCreateIssueController?.({
            ...args,
            groupContextFieldInput: groupContextFieldInput
        });
    }, [
        renderCreateIssueController,
        groupContextFieldInput
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jFCcB.GroupHeader), {
        groupHeader: firstGroupRowData,
        groupConnectionId: groupConnectionId,
        isGroupAtTop: isGroupAtTop,
        createChildTriggerProps: inlineCreateHandlers?.triggerProps,
        columnsCount: columns.length,
        groupId: firstGroupRowData.id,
        isIssueCreateEnabled: isIssueCreateEnabled
    }), hasInitialised && isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g6NP9.FirstGroupIssues), {
        variables: variables,
        groupId: firstGroupRowData.id,
        groupConnectionId: groupConnectionId,
        groupFieldValue: groupFieldValue,
        formProps: inlineCreateHandlers?.formProps,
        isFormVisible: inlineCreateHandlers?.isFormVisible,
        pageSize: pageSize,
        width: width,
        isIssueRankDescending: isIssueRankDescending,
        childItemsExperience: childItemsExperience,
        childItemsLoadMoreExperience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource,
        renderRows: renderRows,
        renderCreateIssueController: (0, $6s1PB.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false) ? renderChildIssueControllerWithGroupContextField : renderCreateIssueController,
        ...(0, $4R6GH.fg)('jsc_list_reranking_gate_technical') && {
            renderDraggableWrapper: renderDraggableWrapper
        }
    }));
};
const $950c8ae27a0c8d48$export$84aac6ac2cec7eed = ({ groupRow: groupRow, groupConnectionId: groupConnectionId, isVirtual: isVirtual, projectKey: projectKey = null, columns: columns, isIssueCreateEnabled: isIssueCreateEnabled, renderChildRows: renderChildRows })=>{
    const groupRowData = (0, $8Uumt.useFragment)((0, $3CMyU.default), groupRow);
    let inlineCreateHandlers;
    let groupContextField;
    const groupFieldValue = $950c8ae27a0c8d48$var$getGroupFieldValue(groupRowData.fieldValue);
    if ((0, $6s1PB.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        inlineCreateHandlers = (0, $2S8IK.useInlineCreateHandlers)({
            projectKey: projectKey,
            minHierarchyLevel: 0
        });
        const { fieldId: fieldId, fieldType: fieldType } = groupRowData;
        groupContextField = fieldId && fieldType ? {
            fieldValue: groupFieldValue,
            fieldId: fieldId,
            fieldType: fieldType,
            groupId: groupRowData.id,
            optimisticResponse: $950c8ae27a0c8d48$export$6afa27f3196791b2({
                fieldType: fieldType,
                fieldId: fieldId,
                fieldValue: groupRowData.fieldValue
            })
        } : undefined;
    }
    return groupRowData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jFCcB.GroupHeader), {
        groupHeader: groupRowData,
        groupConnectionId: groupConnectionId,
        createChildTriggerProps: inlineCreateHandlers?.triggerProps,
        columnsCount: columns.length,
        groupId: groupRowData.id,
        isIssueCreateEnabled: isIssueCreateEnabled
    }), renderChildRows?.({
        parentItemId: groupRowData.id,
        itemsConnectionId: groupConnectionId,
        depth: 0,
        type: 'GROUP_CHILDREN',
        groupFieldValue: groupFieldValue,
        groupJql: groupRowData.jql,
        formProps: inlineCreateHandlers?.formProps,
        isFormVisible: inlineCreateHandlers?.isFormVisible,
        groupId: (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_') ? groupRowData.id : undefined,
        groupContextField: groupContextField
    }));
};
const $950c8ae27a0c8d48$export$882de0673bc73466 = /*#__PURE__*/ (0, $5uXOq.memo)($950c8ae27a0c8d48$export$84aac6ac2cec7eed);
const $950c8ae27a0c8d48$export$85293ebb086fe36d = /*#__PURE__*/ (0, $5uXOq.memo)($950c8ae27a0c8d48$export$ac1801bcb8e0f256);

});
parcelRegister("3CMyU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f348c333c4c1f2d1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<83960a6e7771dee7e949f001e06a340e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f348c333c4c1f2d1$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "groupRow_issueTableGrouping_groupRow",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                "action": "THROW",
                "path": "jql"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "fieldType"
            },
            {
                "kind": "LinkedField",
                "name": "fieldValue",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "priorityId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlPriorityFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlUserFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "statusCategoryId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlStatusFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ],
                        "type": "JiraJqlNumberFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            },
                                            v0 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlOptionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlSprintFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlGoalsFieldValue"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "groupHeader_issueTableGrouping"
            }
        ],
        "type": "JiraSpreadsheetGroup"
    };
}();
$f348c333c4c1f2d1$var$node.hash = "59d6ca2176af6cfc4715541c7e23edd9";
var $f348c333c4c1f2d1$export$2e2bcd8739ae039 = $f348c333c4c1f2d1$var$node;

});

parcelRegister("lEhB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $893043dc3206bad2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b961c4dbbb4be68f0b4e744e896b0039>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $893043dc3206bad2$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "issues"
                    ]
                }
            ]
        },
        "name": "groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                "action": "THROW",
                "path": "jql"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "fieldType"
            },
            {
                "kind": "LinkedField",
                "name": "fieldValue",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "priorityId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlPriorityFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlUserFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "statusCategoryId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlStatusFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ],
                        "type": "JiraJqlNumberFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            },
                                            v0 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlOptionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlSprintFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlGoalsFieldValue"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "groupHeader_issueTableGrouping"
            },
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "fieldSetsInput",
                        "variableName": "fieldSetsInput"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__firstGroupSection_nativeIssueTable__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isDensityFull",
                                "variableName": "isDensityFull"
                            },
                            {
                                "kind": "Variable",
                                "name": "isInlineEditingEnabled",
                                "variableName": "isInlineEditingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isReparentingEnabled",
                                "variableName": "isReparentingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isTimelineEnabled",
                                "variableName": "isTimelineEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Literal",
                                "name": "shouldQueryHasChildren",
                                "value": false
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "childRowsPagination_issueTableHierarchy_queryData"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__id"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetGroup"
    };
}();
$893043dc3206bad2$var$node.hash = "a147ce5007463bba3fd632eb0f102e57";
var $893043dc3206bad2$export$2e2bcd8739ae039 = $893043dc3206bad2$var$node;

});

parcelRegister("g6NP9", function(module, exports) {

$parcel$export(module.exports, "FirstGroupIssues", () => $7da20961c6a3233e$export$e2f0ecb1fcdc2610);

var $hQlbT = parcelRequire("hQlbT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6OGT1 = parcelRequire("6OGT1");

var $4R6GH = parcelRequire("4R6GH");
const $7da20961c6a3233e$export$e2f0ecb1fcdc2610 = ({ variables: variables, groupId: groupId, groupConnectionId: groupConnectionId, groupFieldValue: groupFieldValue, isFormVisible: isFormVisible, formProps: formProps, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, pageSize: pageSize, width: width, isIssueRankDescending: isIssueRankDescending, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper })=>{
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $hQlbT.default), variables, {
        fetchPolicy: 'store-only'
    });
    const connectionMetadata = (0, $5uXOq.useMemo)(()=>variables.issueSearchInput.jql ? {
            type: 'GROUP_CHILDREN',
            fieldValue: groupFieldValue,
            groupId: groupId,
            jql: variables.issueSearchInput.jql
        } : undefined, [
        groupFieldValue,
        groupId,
        variables.issueSearchInput.jql
    ]);
    // Ensure relay cache is in correct state
    if (!data?.jira?.issueSearch?.edges) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OGT1.ChildRowsPagination), {
        query: data,
        depth: 0,
        parentItemId: groupId,
        groupId: groupId,
        itemsConnectionId: groupConnectionId,
        connectionMetadata: connectionMetadata,
        width: width,
        isIssueRankDescending: isIssueRankDescending,
        pageSize: pageSize,
        childItemsExperience: childItemsExperience,
        childItemsLoadMoreExperience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource,
        renderRows: renderRows,
        renderCreateIssueController: renderCreateIssueController,
        ...(0, $4R6GH.fg)('jsc_list_reranking_gate_technical') && {
            renderDraggableWrapper: renderDraggableWrapper
        },
        isFormVisible: isFormVisible,
        formProps: formProps
    });
};

});
parcelRegister("hQlbT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5395a267577284e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5ba62e5242f62ab491dad900f732a7b8>>
 * @relayHash f0e3596d4644c318742fc5fde325d0ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dcd805f27f7bd55e6cee262b84aef23ce5d12739e117baca4f90bb16d9e1935b

var $5oQtH = parcelRequire("5oQtH");

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $5395a267577284e0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v20 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v21 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v22 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v25 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            },
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v26 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v20 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        v21 /*: any*/ ,
        v22 /*: any*/ 
    ], v27 = {
        "kind": "ScalarField",
        "name": "id"
    }, v28 = {
        "kind": "ScalarField",
        "name": "key"
    }, v29 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v31 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v32 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v27 /*: any*/ 
        ]
    }, v33 = {
        "kind": "InlineFragment",
        "selections": [
            v30 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v32 /*: any*/ ,
                    v27 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v34 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v36 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v37 = {
        "kind": "ScalarField",
        "name": "type"
    }, v38 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v39 = {
        "kind": "ScalarField",
        "name": "name"
    }, v40 = {
        "kind": "ScalarField",
        "name": "value"
    }, v41 = [
        v40 /*: any*/ ,
        v27 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v42 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v43 = {
        "kind": "ClientExtension",
        "selections": [
            v42 /*: any*/ 
        ]
    }, v44 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v45 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v46 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v47 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v48 = {
        "kind": "ScalarField",
        "name": "text"
    }, v49 = {
        "kind": "InlineFragment",
        "selections": [
            v48 /*: any*/ ,
            v39 /*: any*/ ,
            v43 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v50 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v51 = [
        v50 /*: any*/ 
    ], v52 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v27 /*: any*/ 
        ]
    }, v53 = [
        v52 /*: any*/ 
    ], v54 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v55 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v56 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v57 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v58 = {
        "kind": "ClientExtension",
        "selections": [
            v35 /*: any*/ 
        ]
    }, v59 = [
        v39 /*: any*/ ,
        v27 /*: any*/ 
    ], v60 = {
        "kind": "ScalarField",
        "name": "date"
    }, v61 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v62 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v48 /*: any*/ ,
            v27 /*: any*/ 
        ]
    }, v63 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v52 /*: any*/ ,
            v27 /*: any*/ 
        ]
    }, v64 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v65 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v64 /*: any*/ ,
                    v39 /*: any*/ ,
                    v27 /*: any*/ 
                ]
            },
            v27 /*: any*/ 
        ]
    }, v66 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v67 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v68 = {
        "kind": "ScalarField",
        "name": "number"
    }, v69 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v70 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v37 /*: any*/ ,
                        v38 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraIssueField"
                                                },
                                                v27 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAffectedServiceConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedAffectedServicesConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAffectedService",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "serviceId"
                                                                                },
                                                                                v39 /*: any*/ ,
                                                                                v27 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAffectedServicesField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraCascadingOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "cascadingOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "parentOptionValue",
                                                                            "plural": false,
                                                                            "selections": v41 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "childOptionValue",
                                                                            "plural": false,
                                                                            "selections": v41 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraCascadingSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "args": v44 /*: any*/ ,
                                                                    "concreteType": "JiraComponentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedComponentsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraComponent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v45 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v27 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                },
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraComponentsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v47 /*: any*/ ,
                                                                v39 /*: any*/ ,
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraDateTimePickerField"
                                                        },
                                                        v49 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCommentSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "commentSummary",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canAddComment"
                                                                        },
                                                                        v50 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraCommentSummaryField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "uri"
                                                                },
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraUrlField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOptions",
                                                                    "plural": false,
                                                                    "selections": v51 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v40 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v53 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v53 /*: any*/ 
                                                                        },
                                                                        v27 /*: any*/ ,
                                                                        v54 /*: any*/ 
                                                                    ]
                                                                },
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v40 /*: any*/ ,
                                                                                        v54 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v40 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraCheckboxesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraUserConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedUsersConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraUserEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v23 /*: any*/ ,
                                                                                        v55 /*: any*/ ,
                                                                                        v39 /*: any*/ ,
                                                                                        v56 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        v57 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "email"
                                                                                                }
                                                                                            ],
                                                                                            "type": "AtlassianAccountUser"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraTeamView",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedTeam",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraSuppliedId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraSuppliedName"
                                                                        }
                                                                    ]
                                                                },
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraTeamViewField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraTimeTrackingField",
                                                                            "kind": "LinkedField",
                                                                            "name": "timeTrackingField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v27 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraEstimate",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "originalEstimate",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "timeInSeconds"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "timeTrackingSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingHoursPerDay"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingDaysPerWeek"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultFormat"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultUnit"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v30 /*: any*/ ,
                                                                                v39 /*: any*/ ,
                                                                                v37 /*: any*/ ,
                                                                                v43 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v27 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraOriginalTimeEstimateField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": "label",
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        },
                                                                        v27 /*: any*/ ,
                                                                        v45 /*: any*/ 
                                                                    ]
                                                                },
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "args": v44 /*: any*/ ,
                                                                    "concreteType": "JiraVersionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedVersionsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraVersion",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v39 /*: any*/ ,
                                                                                        v45 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "versionId"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                },
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": v44 /*: any*/ ,
                                                                    "concreteType": "JiraGoalConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedGoals",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraGoalEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraGoal",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v28 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v58 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                },
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v35 /*: any*/ ,
                                                                        v42 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraGoalsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "args": v44 /*: any*/ ,
                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "confluenceRemoteIssueLinks",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "href"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v50 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                },
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraCmdbObjectConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedCmdbObjectsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraCmdbObject",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "objectId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "label"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatar",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "mediaClientConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "clientId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "fileId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaBaseUrl"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaJwtToken"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "url48"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "QueryError",
                                                                    "kind": "LinkedField",
                                                                    "name": "errors",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "message"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraCMDBField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": "componentsOld",
                                                                    "concreteType": "JiraComponentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedComponentsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraComponent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v59 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraComponentsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v48 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v60 /*: any*/ ,
                                                        v39 /*: any*/ ,
                                                        v61 /*: any*/ ,
                                                        v43 /*: any*/ 
                                                    ],
                                                    "type": "JiraDatePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v47 /*: any*/ 
                                                    ],
                                                    "type": "JiraDateTimePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraEpic",
                                                            "kind": "LinkedField",
                                                            "name": "epic",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "summary"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "color"
                                                                },
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraEpicLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "renderedFieldHtml"
                                                        }
                                                    ],
                                                    "type": "JiraFallbackField"
                                                },
                                                v49 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusCategory",
                                                            "kind": "LinkedField",
                                                            "name": "statusCategory",
                                                            "plural": false,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusCategoryField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusId"
                                                                },
                                                                v32 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v44 /*: any*/ ,
                                                            "concreteType": "JiraLabelConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedLabelsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabelEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabel",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v39 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v50 /*: any*/ 
                                                            ],
                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                        },
                                                        v39 /*: any*/ ,
                                                        v43 /*: any*/ 
                                                    ],
                                                    "type": "JiraLabelsField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "small"
                                                                        }
                                                                    ]
                                                                },
                                                                v39 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraIssueTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssue",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v62 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v28 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v27 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v28 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v29 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "summary",
                                                                                        "issuetype",
                                                                                        "status"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v23 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        v48 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "issueTypeId"
                                                                                                                },
                                                                                                                v39 /*: any*/ ,
                                                                                                                v64 /*: any*/ ,
                                                                                                                v34 /*: any*/ ,
                                                                                                                v27 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                v33 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                                        }
                                                                    ]
                                                                },
                                                                v39 /*: any*/ ,
                                                                v43 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraParentIssueField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v27 /*: any*/ 
                                                            ]
                                                        },
                                                        v39 /*: any*/ ,
                                                        v43 /*: any*/ 
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "large"
                                                                        }
                                                                    ]
                                                                },
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraProjectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraResolution",
                                                            "kind": "LinkedField",
                                                            "name": "resolution",
                                                            "plural": false,
                                                            "selections": v59 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraResolutionField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v27 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "sprintId"
                                                                                },
                                                                                v39 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "state"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "endDate"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v39 /*: any*/ ,
                                                        v43 /*: any*/ 
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                v55 /*: any*/ ,
                                                                v56 /*: any*/ ,
                                                                v39 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v57 /*: any*/ 
                                                            ]
                                                        },
                                                        v39 /*: any*/ ,
                                                        v61 /*: any*/ ,
                                                        v43 /*: any*/ 
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        {
                                                            "args": v44 /*: any*/ ,
                                                            "concreteType": "JiraVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedVersionsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v59 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                        }
                                                    ],
                                                    "type": "JiraMultipleVersionPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraRichText",
                                                            "kind": "LinkedField",
                                                            "name": "richText",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraADF",
                                                                    "kind": "LinkedField",
                                                                    "name": "adfValue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                            "kind": "LinkedField",
                                                                            "name": "convertedPlainText",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "plainText"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraRichTextField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraServiceManagementRequestType",
                                                            "kind": "LinkedField",
                                                            "name": "requestType",
                                                            "plural": false,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                v64 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementRequestTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 1
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinkConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                v50 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v66 /*: any*/ ,
                                                                                        v28 /*: any*/ ,
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "ids",
                                                                                                    "value": [
                                                                                                        "statusCategory"
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldsById",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v32 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                },
                                                                                                                v27 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                        },
                                                                                        v27 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v67 /*: any*/ ,
                                                                                v27 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinkConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraIssueLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isStoryPointField"
                                                        },
                                                        v68 /*: any*/ ,
                                                        v39 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                v68 /*: any*/ ,
                                                                v69 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v68 /*: any*/ ,
                                                                v39 /*: any*/ ,
                                                                v69 /*: any*/ ,
                                                                v43 /*: any*/ 
                                                            ]
                                                        },
                                                        v43 /*: any*/ 
                                                    ],
                                                    "type": "JiraNumberField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraGroupConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedGroupsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraGroupEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraGroup",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v39 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "groupId"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v43 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleGroupPickerField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFlag",
                                                                    "kind": "LinkedField",
                                                                    "name": "flag",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isFlagged"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraFlagField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraWatch",
                                                                    "kind": "LinkedField",
                                                                    "name": "watch",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "count"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isWatching"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraWatchesField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v51 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v71 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v72 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v38 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v60 /*: any*/ 
                                                    ],
                                                    "type": "JiraDatePickerField"
                                                },
                                                v27 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "firstGroupIssues_issueTableGrouping_childIssuesQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isTimelineEnabled",
                            "variableName": "isTimelineEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "childRowsPagination_issueTableHierarchy_query"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "issueSearch",
                            "args": [
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "__hierarchy_nativeIssueTable__issueSearch_connection",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v10 /*: any*/ ,
                v8 /*: any*/ ,
                v11 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v12 /*: any*/ ,
                v17 /*: any*/ ,
                v13 /*: any*/ ,
                v7 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v14 /*: any*/ ,
                v5 /*: any*/ ,
                v16 /*: any*/ ,
                v15 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "firstGroupIssues_issueTableGrouping_childIssuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v26 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "status"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v27 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"status\"])"
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v34 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ]
                                                        },
                                                        v27 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v35 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "fieldSetIds",
                                                                            "variableName": "fieldSetIds"
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsById",
                                                                    "plural": false,
                                                                    "selections": v70 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "context",
                                                                            "variableName": "fieldSetsContext"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "filterId",
                                                                            "variableName": "filterId"
                                                                        },
                                                                        v36 /*: any*/ ,
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "namespace",
                                                                            "variableName": "namespace"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "viewId",
                                                                            "variableName": "viewId"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsForIssueSearchView",
                                                                    "plural": false,
                                                                    "selections": v70 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryHasChildren",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasChildren"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canHaveChildIssues"
                                                }
                                            ]
                                        },
                                        v58 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v71 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": v70 /*: any*/ ,
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                v25 /*: any*/ ,
                                {
                                    "condition": "isTimelineEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v71 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": v72 /*: any*/ ,
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 10
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinks",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "fieldSetIds",
                                                                                                    "value": [
                                                                                                        "Start date[Date]"
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldSetsById",
                                                                                            "plural": false,
                                                                                            "selections": v72 /*: any*/ ,
                                                                                            "storageKey": "fieldSetsById(fieldSetIds:[\"Start date[Date]\"])"
                                                                                        },
                                                                                        v29 /*: any*/ ,
                                                                                        v27 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v67 /*: any*/ ,
                                                                                v27 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinks(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v58 /*: any*/ 
                            ]
                        },
                        {
                            "args": v26 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options",
                                "fieldSetsInput",
                                "viewConfigInput"
                            ],
                            "handle": "connection",
                            "key": "hierarchy_nativeIssueTable__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dcd805f27f7bd55e6cee262b84aef23ce5d12739e117baca4f90bb16d9e1935b",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "bidirectional",
                        "path": [
                            "jira",
                            "issueSearch"
                        ]
                    }
                ]
            },
            "name": "firstGroupIssues_issueTableGrouping_childIssuesQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$5395a267577284e0$var$node.hash = "3eb85b224f1d181caeb0050dacb249d7";
var $5395a267577284e0$export$2e2bcd8739ae039 = $5395a267577284e0$var$node;

});


parcelRegister("3Q1xZ", function(module, exports) {

$parcel$export(module.exports, "useInitialiseFirstGroupIssues", () => $fc3ebec732fb2036$export$3e4eaea282025a37);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $fc4cz = parcelRequire("fc4cz");
const $fc3ebec732fb2036$var$JIRA = 'jira';
const $fc3ebec732fb2036$var$HIERARCHY_ISSUE_SEARCH_CONNECTION = 'hierarchy_nativeIssueTable__issueSearch';
const $fc3ebec732fb2036$var$JIRA_ISSUE_CONNECTION_TYPE = 'JiraIssueConnection';
const $fc3ebec732fb2036$var$CONNECTION = 'connection';
const $fc3ebec732fb2036$export$3e4eaea282025a37 = ({ groupId: groupId, groupConnectionId: groupConnectionId, firstGroupItemsConnectionId: firstGroupItemsConnectionId, issueSearchVariables: issueSearchVariables, loading: loading })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const hasInitialised = (0, $5uXOq.useRef)(false);
    const prevGroupConnectionId = (0, $5uXOq.useRef)(groupConnectionId);
    const prevFieldSetsInput = (0, $5uXOq.useRef)(issueSearchVariables.fieldSetsInput);
    const prevViewConfigInput = (0, $5uXOq.useRef)(issueSearchVariables.viewConfigInput);
    const prevLoading = (0, $5uXOq.useRef)(loading);
    const { setIsItemExpanded: setIsItemExpanded } = (0, $fc4cz.useHierarchyActions)();
    // When firstGroupItemsConnectionId is available, if the groupConnectionId changes, fieldSetsInput change or view has finished loading, trigger re-initialisation
    if (!!firstGroupItemsConnectionId && (!loading && prevLoading.current || prevGroupConnectionId.current !== groupConnectionId || !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevFieldSetsInput.current, issueSearchVariables.fieldSetsInput) || !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevViewConfigInput.current, issueSearchVariables.viewConfigInput))) {
        hasInitialised.current = false;
        prevGroupConnectionId.current = groupConnectionId;
        prevFieldSetsInput.current = issueSearchVariables.fieldSetsInput;
        prevViewConfigInput.current = issueSearchVariables.viewConfigInput;
        prevLoading.current = loading;
    }
    if (!hasInitialised.current) {
        setIsItemExpanded({
            itemId: groupId,
            groupId: groupId,
            itemsConnectionId: groupConnectionId
        }, true);
        (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const firstGroupIssuesConnection = store.get(firstGroupItemsConnectionId ?? '');
            const jiraRecord = store.getRoot().getLinkedRecord($fc3ebec732fb2036$var$JIRA);
            if (!firstGroupIssuesConnection || !jiraRecord) return;
            const connectionId = (0, $eiowN.ConnectionHandler).getConnectionID(jiraRecord.getDataID(), $fc3ebec732fb2036$var$HIERARCHY_ISSUE_SEARCH_CONNECTION, issueSearchVariables);
            // If connection already exists, update it with the latest data. This ensures the field sets are correct.
            let connection = store.get(connectionId);
            if (!connection) connection = store.create(connectionId, $fc3ebec732fb2036$var$JIRA_ISSUE_CONNECTION_TYPE);
            connection.copyFieldsFrom(firstGroupIssuesConnection);
            jiraRecord.setLinkedRecord(connection, (0, $eiowN.getRelayHandleKey)($fc3ebec732fb2036$var$CONNECTION, $fc3ebec732fb2036$var$HIERARCHY_ISSUE_SEARCH_CONNECTION), issueSearchVariables);
            hasInitialised.current = true;
        });
    }
    return hasInitialised.current;
};

});

parcelRegister("jFCcB", function(module, exports) {

$parcel$export(module.exports, "GroupHeader", () => $717bf766dd45d245$export$58d63a2875c58fc8);

var $ioG0Q = parcelRequire("ioG0Q");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $8Uumt = parcelRequire("8Uumt");

var $jZ4fr = parcelRequire("jZ4fr");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koVbs = parcelRequire("koVbs");

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $fc4cz = parcelRequire("fc4cz");

var $55mL9 = parcelRequire("55mL9");

var $6s1PB = parcelRequire("6s1PB");

var $kZoYS = parcelRequire("kZoYS");

var $4N2h5 = parcelRequire("4N2h5");

var $hfluP = parcelRequire("hfluP");

var $2t70i = parcelRequire("2t70i");

var $auqtM = parcelRequire("auqtM");

var $dtVUt = parcelRequire("dtVUt");

var $2jQNy = parcelRequire("2jQNy");

var $8tbem = parcelRequire("8tbem");

var $Z2VxN = parcelRequire("Z2VxN");

var $9KThJ = parcelRequire("9KThJ");
const $717bf766dd45d245$var$isCompletedSprintGroup = (data)=>data?.fieldValue?.__typename === 'JiraJqlSprintFieldValue' && data.fieldValue.sprint?.state === 'CLOSED';
const $717bf766dd45d245$var$ONBOARDING_TARGET_NAME = 'issue-navigator-create-issue-in-group';
const $717bf766dd45d245$export$58d63a2875c58fc8 = ({ groupHeader: groupHeader, groupConnectionId: groupConnectionId, createChildTriggerProps: createChildTriggerProps, isGroupAtTop: isGroupAtTop = false, columnsCount: columnsCount, groupId: groupId, isIssueCreateEnabled: isIssueCreateEnabled = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const tableRowRef = (0, $5uXOq.useRef)(null);
    const data = (0, $8Uumt.useFragment)((0, $ioG0Q.default), groupHeader);
    const itemDetails = (0, $5uXOq.useMemo)(()=>data ? {
            itemsConnectionId: groupConnectionId,
            itemId: data.id,
            groupId: groupId
        } : null, [
        data,
        groupConnectionId,
        groupId
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    const list = (0, $4R6GH.fg)('nin-grid-keyboard-navigation') ? (0, $fc4cz.useFlatList)() : [];
    const [isSelected, { setSelectedRow: setSelectedRow }] = (0, $fc4cz.useIsSelected)(itemDetails);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Scroll the table row into view (if needed - block: nearest) when it becomes selected
        if (isSelected) tableRowRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        isSelected
    ]);
    const focusCurrentRow = (0, $5uXOq.useCallback)(()=>{
        return setSelectedRow(itemDetails);
    }, [
        setSelectedRow,
        itemDetails
    ]);
    const groupHeaderView = (0, $5uXOq.useMemo)(()=>{
        switch(data.fieldType){
            case 0, $5fc53.PRIORITY_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dtVUt.PriorityGroupHeader), {
                    priorityGroupHeader: data.fieldValue ?? null
                });
            case 0, $5fc53.ASSIGNEE_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hfluP.AssigneeGroupHeader), {
                    assigneeGroupHeader: data.fieldValue ?? null
                });
            case 0, $5fc53.STATUS_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tbem.StatusGroupHeader), {
                    statusGroupHeader: data.fieldValue ?? null
                });
            case 0, $5fc53.NUMBER_CF_TYPE:
            case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Z2VxN.StoryPointsGroupHeader), {
                    storyPointsGroupHeader: data.fieldValue ?? null
                });
            case 0, $5fc53.GOALS_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9KThJ.GoalGroupHeader), {
                    goalGroupHeader: data.fieldValue ?? null
                });
            case 0, $5fc53.CATEGORY_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2t70i.CategoryGroupHeader), {
                    categoryGroupHeader: data.fieldValue ?? null
                });
            case 0, $5fc53.SPRINT_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2jQNy.SprintGroupHeader), {
                    sprintGroupHeader: data.fieldValue ?? null
                });
            default:
                // should never happen
                return null;
        }
    }, [
        data
    ]);
    const groupMetadata = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, groupHeaderView, !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(data?.issueCount) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            color: "color.text.subtlest"
        }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $auqtM.default).issuesIssueTermRefresh : (0, $auqtM.default).issues, {
            count: data.issueCount
        })));
    }, [
        data.issueCount,
        formatMessage,
        groupHeaderView
    ]);
    const [isExpanded, { toggleIsItemExpanded: toggleIsItemExpanded }] = (0, $fc4cz.useIsItemExpanded)(itemDetails);
    const [isLoading] = (0, $fc4cz.useIsItemLoading)(data?.id ?? null);
    const onCreateChildClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'groupCreateChildButton');
        if (!isExpanded) toggleIsItemExpanded(itemDetails, 0);
        createChildTriggerProps?.onClick();
    }, [
        createAnalyticsEvent,
        isExpanded,
        toggleIsItemExpanded,
        itemDetails,
        createChildTriggerProps
    ]);
    const headerContent = (0, $5uXOq.useMemo)(()=>{
        if ((0, $6s1PB.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, data.issueCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $55mL9.ExpandButton), {
            itemId: data.id,
            itemsConnectionId: groupConnectionId,
            depth: 0,
            isGroupButton: true,
            groupId: groupId
        }) : null, groupMetadata, isIssueCreateEnabled && (0, $4N2h5.isCreateIssueSupportedForFieldType)(data.fieldType) && !$717bf766dd45d245$var$isCompletedSprintGroup(data) && (isGroupAtTop ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: $717bf766dd45d245$var$ONBOARDING_TARGET_NAME
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_kqswh2mm _yt1xcs5v"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZoYS.default), {
            onClick: onCreateChildClick,
            ref: createChildTriggerProps?.ref,
            isCreateWorkItem: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
            engagementId: $717bf766dd45d245$var$ONBOARDING_TARGET_NAME
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_kqswh2mm _yt1xcs5v"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZoYS.default), {
            onClick: onCreateChildClick,
            ref: createChildTriggerProps?.ref,
            isCreateWorkItem: true
        }))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, data.issueCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $55mL9.ExpandButtonWithCreateChildButton), {
            isGroupButton: true,
            itemId: data.id,
            itemsConnectionId: groupConnectionId,
            depth: 0,
            groupId: groupId
        }) : null, groupMetadata);
    }, [
        data,
        groupConnectionId,
        groupId,
        groupMetadata,
        isIssueCreateEnabled,
        isGroupAtTop,
        onCreateChildClick,
        createChildTriggerProps?.ref
    ]);
    const rowIndex = itemDetails && (0, $4R6GH.fg)('nin-grid-keyboard-navigation') ? list.indexOf(`${itemDetails.itemId}::${itemDetails.itemId}`) + 1 : -1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", {
        role: "row",
        tabIndex: -1,
        ...rowIndex > 0 && (0, $4R6GH.fg)('nin-grid-keyboard-navigation') && {
            'aria-rowindex': rowIndex
        },
        onFocus: focusCurrentRow,
        "data-testid": "issue-table-grouping.ui.group-row.group-header.tr",
        "aria-selected": isSelected,
        ref: tableRowRef,
        className: (0, $bwpsq.default)([
            "_nt751r31 _49pcglyw _1hvw1o36 _irr3108i",
            isSelected && !(0, $4R6GH.fg)('nin-grid-keyboard-navigation') && "_bfhkfg4m _irr3i1yw",
            (0, $4R6GH.fg)('nin-grid-keyboard-navigation') && "_10j7fg4m _1p0pi1yw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "td" // Additional column for configure columns menu & issue actions
        ,
        colSpan: columnsCount + 1,
        xcss: [
            $717bf766dd45d245$var$borderStyles,
            isGroupAtTop && $717bf766dd45d245$var$removeTopBorder,
            (!isExpanded || isLoading || !data.issueCount || (0, $6s1PB.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) && $717bf766dd45d245$var$removeBottomBorder
        ],
        ...(0, $4R6GH.fg)('nin-grid-keyboard-navigation') && {
            tabIndex: -1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: [
            $717bf766dd45d245$var$inlineStyles,
            !data.issueCount && $717bf766dd45d245$var$placeholderStyles
        ],
        space: "space.100"
    }, headerContent)));
};
const $717bf766dd45d245$var$inlineStyles = (0, $8CUq3.xcss)({
    paddingInline: 'space.150',
    alignItems: 'center',
    gap: 'space.100'
});
const $717bf766dd45d245$var$placeholderStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.400'
});
const $717bf766dd45d245$var$borderStyles = (0, $8CUq3.xcss)({
    border: 0,
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTopWidth: 'border.width',
    borderBottomWidth: 'border.width'
});
const $717bf766dd45d245$var$removeTopBorder = (0, $8CUq3.xcss)({
    borderTopWidth: '0'
});
const $717bf766dd45d245$var$removeBottomBorder = (0, $8CUq3.xcss)({
    borderBottomWidth: '0'
});
const $717bf766dd45d245$var$headerRowStyles = null;
const $717bf766dd45d245$var$headerRowKeyboardNavigationStyles = null;
const $717bf766dd45d245$var$activeRowStyles = null;
const $717bf766dd45d245$var$raiseOnHoverStyles = null;

});
parcelRegister("ioG0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $1310f43bb325435b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bfbc98017c9523d82ec8f8463842b5b0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1310f43bb325435b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "groupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldType"
        },
        {
            "kind": "ScalarField",
            "name": "issueCount"
        },
        {
            "kind": "LinkedField",
            "name": "fieldValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "priorityGroupHeader_issueTableGrouping"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "assigneeGroupHeader_issueTableGrouping"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "statusGroupHeader_issueTableGrouping"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "categoryGroupHeader_issueTableGrouping"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "sprintGroupHeader_issueTableGrouping"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "storyPointsGroupHeader_issueTableGrouping"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "goalGroupHeader_issueTableGrouping"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "state"
                                }
                            ]
                        }
                    ],
                    "type": "JiraJqlSprintFieldValue"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroup"
};
$1310f43bb325435b$var$node.hash = "cdd40a4124f5cd97da3d222a219538c6";
var $1310f43bb325435b$export$2e2bcd8739ae039 = $1310f43bb325435b$var$node;

});

parcelRegister("55mL9", function(module, exports) {

$parcel$export(module.exports, "ExpandButton", () => $3ffb73e5a197054b$export$5663c8f5aeb8c1c4);
$parcel$export(module.exports, "CreateChildButtonWithExpandToggle", () => $3ffb73e5a197054b$export$86df7a8824b06d6e);
$parcel$export(module.exports, "ExpandButtonWithCreateChildButton", () => $3ffb73e5a197054b$export$b921667debd4e0cb);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $kZoYS = parcelRequire("kZoYS");

var $fc4cz = parcelRequire("fc4cz");

var $gUxW5 = parcelRequire("gUxW5");

var $fmAMq = parcelRequire("fmAMq");
const $3ffb73e5a197054b$var$ICON_WIDTH = 24;
const $3ffb73e5a197054b$var$EXTRA_PADDING_ROW_WITHOUT_EXPAND = 8;
const $3ffb73e5a197054b$export$5663c8f5aeb8c1c4 = ({ itemId: itemId, itemsConnectionId: itemsConnectionId, depth: depth, isGroupButton: isGroupButton, groupId: groupId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isExpanded, { toggleIsItemExpanded: toggleIsItemExpanded }] = (0, $fc4cz.useIsItemExpanded)({
        itemId: itemId,
        groupId: groupId,
        itemsConnectionId: itemsConnectionId
    });
    const onExpandClick = (0, $5uXOq.useCallback)(()=>{
        const actionSubjectId = isGroupButton ? 'groupExpandButton' : 'hierarchyExpandButton';
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', actionSubjectId);
        toggleIsItemExpanded({
            itemId: itemId,
            itemsConnectionId: itemsConnectionId,
            groupId: groupId
        }, depth);
    }, [
        createAnalyticsEvent,
        depth,
        itemId,
        itemsConnectionId,
        toggleIsItemExpanded,
        isGroupButton,
        groupId
    ]);
    const label = (0, $5uXOq.useMemo)(()=>{
        if (isGroupButton) return formatMessage(isExpanded ? (0, $gUxW5.default).collapseGroup : (0, $gUxW5.default).expandGroup);
        return formatMessage(isExpanded ? (0, $gUxW5.default).collapseIssue : (0, $gUxW5.default).expandIssue);
    }, [
        formatMessage,
        isExpanded,
        isGroupButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        spacing: "compact",
        appearance: "subtle",
        label: label,
        "aria-expanded": isExpanded,
        testId: "issue-table-hierarchy.ui.expand-button.expand-button",
        icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($hORKG))) : (0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))),
        onClick: onExpandClick,
        isTooltipDisabled: false
    });
};
const $3ffb73e5a197054b$export$86df7a8824b06d6e = ({ itemId: itemId, groupId: groupId, itemsConnectionId: itemsConnectionId, isCreateChildFormVisible: isCreateChildFormVisible, depth: depth, isGroupButton: isGroupButton, createChildTriggerProps: createChildTriggerProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isInlineCreateChildOpen, setIsInlineCreateChildOpen] = (0, $5uXOq.useState)(false);
    const [isExpanded, { toggleIsItemExpanded: toggleIsItemExpanded }] = (0, $fc4cz.useIsItemExpanded)({
        itemId: itemId,
        groupId: groupId,
        itemsConnectionId: itemsConnectionId
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!isCreateChildFormVisible) setIsInlineCreateChildOpen(false);
    }, [
        isCreateChildFormVisible
    ]);
    const onCreateChildClick = (0, $5uXOq.useCallback)(()=>{
        const actionSubjectId = isGroupButton ? 'groupCreateChildButton' : 'hierarchyCreateChildButton';
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', actionSubjectId);
        if (!isExpanded) toggleIsItemExpanded({
            itemId: itemId,
            itemsConnectionId: itemsConnectionId
        }, depth);
        if (!isCreateChildFormVisible) createChildTriggerProps?.onClick();
        setIsInlineCreateChildOpen(true);
    }, [
        createAnalyticsEvent,
        createChildTriggerProps,
        depth,
        isCreateChildFormVisible,
        isExpanded,
        itemId,
        itemsConnectionId,
        toggleIsItemExpanded,
        isGroupButton
    ]);
    return !isInlineCreateChildOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZoYS.default), {
        onClick: onCreateChildClick,
        ref: createChildTriggerProps?.ref
    });
};
const $3ffb73e5a197054b$export$b921667debd4e0cb = ({ itemId: itemId, itemsConnectionId: itemsConnectionId, depth: depth, hasChildren: hasChildren = true, isRowHoveredOrSelected: isRowHoveredOrSelected, showCreateChildButton: showCreateChildButton, createChildTriggerProps: createChildTriggerProps, isCreateChildFormVisible: isCreateChildFormVisible, isGroupButton: isGroupButton, groupId: groupId })=>{
    if (hasChildren) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        tabIndex: isRowHoveredOrSelected ? 0 : -1,
        xcss: [
            $3ffb73e5a197054b$var$cellStyle,
            !isGroupButton && $3ffb73e5a197054b$var$cellPaddingStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fmAMq.default), {
        depth: depth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3ffb73e5a197054b$var$cellWrapperStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            paddingLeft: `${$3ffb73e5a197054b$var$ICON_WIDTH * depth}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ffb73e5a197054b$export$5663c8f5aeb8c1c4, {
        itemId: itemId,
        itemsConnectionId: itemsConnectionId,
        depth: depth,
        isGroupButton: isGroupButton,
        groupId: groupId
    })), showCreateChildButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ffb73e5a197054b$export$86df7a8824b06d6e, {
        depth: depth,
        itemId: itemId,
        groupId: groupId,
        isGroupButton: isGroupButton,
        itemsConnectionId: itemsConnectionId,
        createChildTriggerProps: createChildTriggerProps,
        isCreateChildFormVisible: isCreateChildFormVisible
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        tabIndex: 0,
        xcss: $3ffb73e5a197054b$var$cellSizeStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fmAMq.default), {
        depth: depth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3ffb73e5a197054b$var$cellPaddingStyle,
        style: {
            paddingLeft: `${$3ffb73e5a197054b$var$ICON_WIDTH * depth + $3ffb73e5a197054b$var$ICON_WIDTH + $3ffb73e5a197054b$var$EXTRA_PADDING_ROW_WITHOUT_EXPAND}px`
        }
    }, showCreateChildButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ffb73e5a197054b$export$86df7a8824b06d6e, {
        depth: depth,
        itemId: itemId,
        groupId: groupId,
        isGroupButton: isGroupButton,
        itemsConnectionId: itemsConnectionId,
        createChildTriggerProps: createChildTriggerProps,
        isCreateChildFormVisible: isCreateChildFormVisible
    })));
};
const $3ffb73e5a197054b$var$cellWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $3ffb73e5a197054b$var$cellSizeStyle = (0, $8CUq3.xcss)({
    height: '100%'
});
const $3ffb73e5a197054b$var$cellStyle = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
});
const $3ffb73e5a197054b$var$cellPaddingStyle = (0, $8CUq3.xcss)({
    padding: 'space.100'
});

});
parcelRegister("kZoYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f707eb30973e997$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $dIWbq = parcelRequire("dIWbq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $jBc7J = parcelRequire("jBc7J");
const $0f707eb30973e997$var$getWorkItemMessage = ()=>(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $jBc7J.default).createWorkItem : (0, $jBc7J.default).createIssue;
const $0f707eb30973e997$var$CreateChildButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, isCreateWorkItem: isCreateWorkItem }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        spacing: "compact",
        appearance: "subtle",
        label: isCreateWorkItem ? formatMessage($0f707eb30973e997$var$getWorkItemMessage()) : formatMessage((0, $jBc7J.default).createChildItem),
        testId: "issue-table-hierarchy.ui.create-child-button.create",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dIWbq))),
        onClick: onClick,
        isTooltipDisabled: false,
        ref: ref
    });
});
var $0f707eb30973e997$export$2e2bcd8739ae039 = $0f707eb30973e997$var$CreateChildButton;

});
parcelRegister("jBc7J", function(module, exports) {

$parcel$export(module.exports, "default", () => $913d09f4d7e47083$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $913d09f4d7e47083$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createChildItem: {
        "id": "issue-table-hierarchy.ui.create-child-button.create-child-item",
        "defaultMessage": "Create child item"
    },
    createWorkItem: {
        "id": "issue-table-hierarchy.ui.create-child-button.create-work-item",
        "defaultMessage": "Create work item"
    },
    createIssue: {
        "id": "issue-table-hierarchy.ui.create-child-button.create-issue",
        "defaultMessage": "Create issue"
    }
});

});


parcelRegister("gUxW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1227c83067c36a0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b1227c83067c36a0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    expandIssue: {
        "id": "native-issue-table.expand-button.expand-issue-hierarchy",
        "defaultMessage": "Expand hierarchy"
    },
    collapseIssue: {
        "id": "native-issue-table.expand-button.collapse",
        "defaultMessage": "Collapse hierarchy"
    },
    expandGroup: {
        "id": "native-issue-table.expand-button.expand-group-issue-hierarchy",
        "defaultMessage": "Expand group"
    },
    collapseGroup: {
        "id": "native-issue-table.expand-button.collapse-group",
        "defaultMessage": "Collapse group"
    }
});

});

parcelRegister("fmAMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $89b24fb882c73184$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $89b24fb882c73184$var$ICON_WIDTH = 24;
const $89b24fb882c73184$var$INDENTED_PADDING = 8;
const $89b24fb882c73184$var$IndentedIcon = ({ depth: depth })=>{
    if (depth <= 0) return null;
    const left = depth > 1 ? (depth - 1) * $89b24fb882c73184$var$ICON_WIDTH + $89b24fb882c73184$var$INDENTED_PADDING : $89b24fb882c73184$var$INDENTED_PADDING;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            left: `${left}px`
        },
        xcss: $89b24fb882c73184$var$imgContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $89b24fb882c73184$var$imgStyles,
        testId: "issue-table-hierarchy.ui.expand-button.indented-icon.indented-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 0V9.5C1 10.3284 1.67157 11 2.5 11H12V12H2.5C1.11929 12 0 10.8807 0 9.5V0H1Z",
        fill: "var(--ds-border, #091E4224)"
    }))));
};
const $89b24fb882c73184$var$imgStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
});
const $89b24fb882c73184$var$imgContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    height: '100%'
});
var $89b24fb882c73184$export$2e2bcd8739ae039 = $89b24fb882c73184$var$IndentedIcon;

});


parcelRegister("hfluP", function(module, exports) {

$parcel$export(module.exports, "AssigneeGroupHeader", () => $a03c65567d2dbb5a$export$2822dce50d1b3806);

var $l339X = parcelRequire("l339X");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $ujWmd = parcelRequire("ujWmd");

var $cgL5K = parcelRequire("cgL5K");

var $bmZvc = parcelRequire("bmZvc");

var $koVbs = parcelRequire("koVbs");

var $108Ha = parcelRequire("108Ha");
const $a03c65567d2dbb5a$export$2822dce50d1b3806 = ({ assigneeGroupHeader: assigneeGroupHeader })=>{
    const data = (0, $8Uumt.useFragment)((0, $l339X.default), assigneeGroupHeader);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const displayName = data?.displayName ?? formatMessage((0, $108Ha.default).unassignedDisplayName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bmZvc.AvatarLite), {
        avatarUrl: data.user?.picture
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "circle",
        src: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, displayName));
};

});
parcelRegister("l339X", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4fb5e0a5232fcda$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9d531e106d2b6b2f46e946691c632cec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b4fb5e0a5232fcda$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "assigneeGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                }
            ]
        }
    ],
    "type": "JiraJqlUserFieldValue"
};
$b4fb5e0a5232fcda$var$node.hash = "b0c0b208c554355360ef1df28176610c";
var $b4fb5e0a5232fcda$export$2e2bcd8739ae039 = $b4fb5e0a5232fcda$var$node;

});

parcelRegister("bmZvc", function(module, exports) {

$parcel$export(module.exports, "AvatarLite", () => $0b2cc805665652bb$export$8b9560cc4e12c651);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $0b2cc805665652bb$var$AVATAR_SIZE = 24;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b2cc805665652bb$var$Avatar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { avatarUrl: avatarUrl, isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fzlxay": (0, $lD23V.default)(`url(${__cmplp.avatarUrl})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _12ji1r31 _1qu2glyw _12y3idpf _1itk1v7f _ouxl1ssb _12vemgnk _1lrw1dfr _bfhk18uv _vchh18uv _4t3i1tcg _1bsb1tcg _1ul91tcg _1tke1tcg _1e0c1o8l _kqswh2mm _80om1kw7 _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.isHighlighted ? "_16qsa9gh" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $0b2cc805665652bb$var$hasKeywords = (name)=>(keyword)=>name && keyword && name.toLowerCase().includes(keyword.toLowerCase());
const $0b2cc805665652bb$export$8b9560cc4e12c651 = /*#__PURE__*/ (0, $5uXOq.memo)(({ avatarUrl: avatarUrl, name: name = '', highlight: highlight, testId: testId })=>{
    const isHighlighted = highlight && highlight.some($0b2cc805665652bb$var$hasKeywords(name));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b2cc805665652bb$var$Avatar, {
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        avatarUrl: avatarUrl,
        title: name,
        // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
        isHighlighted: isHighlighted,
        "data-testid": testId
    });
});

});

parcelRegister("108Ha", function(module, exports) {

$parcel$export(module.exports, "default", () => $0303d0f506399d80$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0303d0f506399d80$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassignedDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.assignee-group-header.unassigned-display-name",
        "defaultMessage": "Unassigned"
    }
});

});


parcelRegister("2t70i", function(module, exports) {

$parcel$export(module.exports, "CategoryGroupHeader", () => $d81aa964a2ef89ac$export$fc0707d1ce99fe4d);

var $2WkH9 = parcelRequire("2WkH9");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cgL5K = parcelRequire("cgL5K");

var $DhnKp = parcelRequire("DhnKp");

var $koVbs = parcelRequire("koVbs");

var $3Qvj8 = parcelRequire("3Qvj8");
const $d81aa964a2ef89ac$export$fc0707d1ce99fe4d = ({ categoryGroupHeader: categoryGroupHeader })=>{
    const data = (0, $8Uumt.useFragment)((0, $2WkH9.default), categoryGroupHeader);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return data != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $DhnKp.default), {
        categoryColor: data?.option?.color?.colorKey ?? null,
        categoryName: data?.displayName,
        isInteractive: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $3Qvj8.default).noCategory));
};

});
parcelRegister("2WkH9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2afe4cf7558d8e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7e75d6021772df962ce23c83c556dffa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e2afe4cf7558d8e7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "categoryGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "option",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "colorKey"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraJqlOptionFieldValue"
};
$e2afe4cf7558d8e7$var$node.hash = "90b12dc5c3b223af53b5f45469a1b3f2";
var $e2afe4cf7558d8e7$export$2e2bcd8739ae039 = $e2afe4cf7558d8e7$var$node;

});

parcelRegister("DhnKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3fabf56d1291b24$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $gSwFG = parcelRequire("gSwFG");
const $f3fabf56d1291b24$var$CategoryTag = ({ categoryName: categoryName, categoryColor: categoryColor, isInteractive: isInteractive = true })=>{
    const { textColor: textColor, backgroundColor: tagColor } = (0, $gSwFG.getColorMetadata)(categoryColor);
    return /*#__PURE__*/ $5uXOq.createElement($f3fabf56d1291b24$var$CategoryTagWrapper, {
        isInteractive: isInteractive,
        textColor: (0, $dCm1o.isVisualRefreshEnabled)() ? "var(--ds-text, #172B4D)" : textColor,
        "aria-label": categoryName,
        "data-testid": "business-categories.ui.category-form.category-tag.category-tag-wrapper"
    }, /*#__PURE__*/ $5uXOq.createElement($f3fabf56d1291b24$var$StyledTag, {
        color: tagColor
    }, categoryName));
};
var $f3fabf56d1291b24$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f3fabf56d1291b24$var$CategoryTag);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f3fabf56d1291b24$var$CategoryTagWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textColor: textColor, isInteractive: isInteractive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlcdp": (0, $lD23V.default)(__cmplp.textColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564188d _1e0c116y _1bah1e5h _4cvr1h6o _p12f1osq _1ul9idpf _1tkeidpf _syazijt0",
            __cmplp.isInteractive ? "_d0altlke" : "_d0al73ad",
            __cmplp.className
        ])
    });
});
const $f3fabf56d1291b24$var$StyledTagOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _11c82smr _1reo15vq _18m915vq _bfhk1cj8 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $f3fabf56d1291b24$var$StyledTagNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $lD23V.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko5n0m _19it11we _11c82smr _1reo15vq _18m915vq _bfhk18uv _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $f3fabf56d1291b24$var$StyledTag = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $f3fabf56d1291b24$var$StyledTagNew, $f3fabf56d1291b24$var$StyledTagOld);

});
parcelRegister("gSwFG", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $371e0387ab2e6a89$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $371e0387ab2e6a89$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $371e0387ab2e6a89$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $371e0387ab2e6a89$export$49fce7fdcf55f26d);

var $3m7Ch = parcelRequire("3m7Ch");
const $371e0387ab2e6a89$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $3m7Ch.CATEGORY_THEMES).length);
    return (0, $3m7Ch.CATEGORY_THEMES)[randomIndex].name;
};
const $371e0387ab2e6a89$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $3m7Ch.CATEGORY_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $371e0387ab2e6a89$export$9eff62e8ee2aaa2c = (colorName)=>(0, $3m7Ch.CATEGORY_THEMES).find((item)=>item.name === colorName)?.backgroundColor ?? '';
const $371e0387ab2e6a89$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $3m7Ch.GREY_LIGHTEST_META;
    return (0, $3m7Ch.CATEGORY_THEMES).find((item)=>item.name === colorName) ?? (0, $3m7Ch.GREY_LIGHTEST_META);
};
const $371e0387ab2e6a89$export$4ef6b7574883e63d = ()=>(0, $3m7Ch.CATEGORY_THEMES).map((item)=>item.name);

});
parcelRegister("3m7Ch", function(module, exports) {

$parcel$export(module.exports, "GREY_LIGHTEST_META", () => $b019b47b4798283a$export$cb19a604bb399a88);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $b019b47b4798283a$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $b019b47b4798283a$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "CATEGORY_THEMES", () => $b019b47b4798283a$export$845e69f3af4133a6);

var $gAmq4 = parcelRequire("gAmq4");
const $b019b47b4798283a$export$cb19a604bb399a88 = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $gAmq4.default).greyLightest
};
const $b019b47b4798283a$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $gAmq4.default).greyLighter
};
const $b019b47b4798283a$var$GREY_META = {
    name: 'GREY',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $gAmq4.default).grey
};
const $b019b47b4798283a$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).greyDarker
};
const $b019b47b4798283a$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).greyDarkest
};
const $b019b47b4798283a$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $gAmq4.default).purpleLightest
};
const $b019b47b4798283a$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $gAmq4.default).purpleLighter
};
const $b019b47b4798283a$var$PURPLE_META = {
    name: 'PURPLE',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $gAmq4.default).purple
};
const $b019b47b4798283a$var$PURPLE_DARKER_META = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).purpleDarker
};
const $b019b47b4798283a$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).purpleDarkest
};
const $b019b47b4798283a$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $gAmq4.default).blueLightest
};
const $b019b47b4798283a$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $gAmq4.default).blueLighter
};
const $b019b47b4798283a$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $gAmq4.default).blue
};
const $b019b47b4798283a$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).blueDarker
};
const $b019b47b4798283a$var$BLUE_DARKEST_META = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).blueDarkest
};
const $b019b47b4798283a$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $gAmq4.default).tealLightest
};
const $b019b47b4798283a$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $gAmq4.default).tealLighter
};
const $b019b47b4798283a$var$TEAL_META = {
    name: 'TEAL',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $gAmq4.default).teal
};
const $b019b47b4798283a$var$TEAL_DARKER_META = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).tealDarker
};
const $b019b47b4798283a$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).tealDarkest
};
const $b019b47b4798283a$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $gAmq4.default).greenLightest
};
const $b019b47b4798283a$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $gAmq4.default).greenLighter
};
const $b019b47b4798283a$var$GREEN_META = {
    name: 'GREEN',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $gAmq4.default).green
};
const $b019b47b4798283a$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).greenDarker
};
const $b019b47b4798283a$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).greenDarkest
};
const $b019b47b4798283a$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $gAmq4.default).limeLightest
};
const $b019b47b4798283a$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $gAmq4.default).limeLighter
};
const $b019b47b4798283a$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $gAmq4.default).lime
};
const $b019b47b4798283a$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).limeDarker
};
const $b019b47b4798283a$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).limeDarkest
};
const $b019b47b4798283a$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $gAmq4.default).yellowLightest
};
const $b019b47b4798283a$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $gAmq4.default).yellowLighter
};
const $b019b47b4798283a$var$YELLOW_META = {
    name: 'YELLOW',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $gAmq4.default).yellow
};
const $b019b47b4798283a$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).yellowDarker
};
const $b019b47b4798283a$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).yellowDarkest
};
const $b019b47b4798283a$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $gAmq4.default).orangeLightest
};
const $b019b47b4798283a$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $gAmq4.default).orangeLighter
};
const $b019b47b4798283a$var$ORANGE_META = {
    name: 'ORANGE',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $gAmq4.default).orange
};
const $b019b47b4798283a$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).orangeDarker
};
const $b019b47b4798283a$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).orangeDarkest
};
const $b019b47b4798283a$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $gAmq4.default).redLightest
};
const $b019b47b4798283a$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $gAmq4.default).redLighter
};
const $b019b47b4798283a$var$RED_META = {
    name: 'RED',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $gAmq4.default).red
};
const $b019b47b4798283a$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).redDarker
};
const $b019b47b4798283a$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).redDarkest
};
const $b019b47b4798283a$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $gAmq4.default).magentaLightest
};
const $b019b47b4798283a$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $gAmq4.default).magentaLighter
};
const $b019b47b4798283a$var$MAGENTA_META = {
    name: 'MAGENTA',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $gAmq4.default).magenta
};
const $b019b47b4798283a$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).magentaDarker
};
const $b019b47b4798283a$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).magentaDarkest
};
const $b019b47b4798283a$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $b019b47b4798283a$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $b019b47b4798283a$export$845e69f3af4133a6 = [
    $b019b47b4798283a$export$cb19a604bb399a88,
    $b019b47b4798283a$var$PURPLE_LIGHTEST_META,
    $b019b47b4798283a$var$BLUE_LIGHTEST_META,
    $b019b47b4798283a$var$TEAL_LIGHTEST_META,
    $b019b47b4798283a$var$GREEN_LIGHTEST_META,
    $b019b47b4798283a$var$LIME_LIGHTEST_META,
    $b019b47b4798283a$var$YELLOW_LIGHTEST_META,
    $b019b47b4798283a$var$ORANGE_LIGHTEST_META,
    $b019b47b4798283a$var$RED_LIGHTEST_META,
    $b019b47b4798283a$var$MAGENTA_LIGHTEST_META,
    $b019b47b4798283a$var$GREY_LIGHTER_META,
    $b019b47b4798283a$var$PURPLE_LIGHTER_META,
    $b019b47b4798283a$var$BLUE_LIGHTER_META,
    $b019b47b4798283a$var$TEAL_LIGHTER_META,
    $b019b47b4798283a$var$GREEN_LIGHTER_META,
    $b019b47b4798283a$var$LIME_LIGHTER_META,
    $b019b47b4798283a$var$YELLOW_LIGHTER_META,
    $b019b47b4798283a$var$ORANGE_LIGHTER_META,
    $b019b47b4798283a$var$RED_LIGHTER_META,
    $b019b47b4798283a$var$MAGENTA_LIGHTER_META,
    $b019b47b4798283a$var$GREY_META,
    $b019b47b4798283a$var$PURPLE_META,
    $b019b47b4798283a$var$BLUE_META,
    $b019b47b4798283a$var$TEAL_META,
    $b019b47b4798283a$var$GREEN_META,
    $b019b47b4798283a$var$LIME_META,
    $b019b47b4798283a$var$YELLOW_META,
    $b019b47b4798283a$var$ORANGE_META,
    $b019b47b4798283a$var$RED_META,
    $b019b47b4798283a$var$MAGENTA_META,
    $b019b47b4798283a$var$GREY_DARKER_META,
    $b019b47b4798283a$var$PURPLE_DARKER_META,
    $b019b47b4798283a$var$BLUE_DARKER_META,
    $b019b47b4798283a$var$TEAL_DARKER_META,
    $b019b47b4798283a$var$GREEN_DARKER_META,
    $b019b47b4798283a$var$LIME_DARKER_META,
    $b019b47b4798283a$var$YELLOW_DARKER_META,
    $b019b47b4798283a$var$ORANGE_DARKER_META,
    $b019b47b4798283a$var$RED_DARKER_META,
    $b019b47b4798283a$var$MAGENTA_DARKER_META,
    $b019b47b4798283a$var$GREY_DARKEST_META,
    $b019b47b4798283a$var$PURPLE_DARKEST_META,
    $b019b47b4798283a$var$BLUE_DARKEST_META,
    $b019b47b4798283a$var$TEAL_DARKEST_META,
    $b019b47b4798283a$var$GREEN_DARKEST_META,
    $b019b47b4798283a$var$LIME_DARKEST_META,
    $b019b47b4798283a$var$YELLOW_DARKEST_META,
    $b019b47b4798283a$var$ORANGE_DARKEST_META,
    $b019b47b4798283a$var$RED_DARKEST_META,
    $b019b47b4798283a$var$MAGENTA_DARKEST_META
];

});
parcelRegister("gAmq4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d59c1f29a6afb9ec$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d59c1f29a6afb9ec$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    greyLightest: {
        "id": "business-categories.category-form.category-color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "business-categories.category-form.category-color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "business-categories.category-form.category-color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "business-categories.category-form.category-color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "business-categories.category-form.category-color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "business-categories.category-form.category-color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "business-categories.category-form.category-color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "business-categories.category-form.category-color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "business-categories.category-form.category-color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "business-categories.category-form.category-color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "business-categories.category-form.category-color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "business-categories.category-form.category-color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "business-categories.category-form.category-color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "business-categories.category-form.category-color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "business-categories.category-form.category-color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "business-categories.category-form.category-color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "business-categories.category-form.category-color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "business-categories.category-form.category-color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "business-categories.category-form.category-color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "business-categories.category-form.category-color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "business-categories.category-form.category-color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "business-categories.category-form.category-color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "business-categories.category-form.category-color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "business-categories.category-form.category-color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "business-categories.category-form.category-color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "business-categories.category-form.category-color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "business-categories.category-form.category-color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "business-categories.category-form.category-color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "business-categories.category-form.category-color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "business-categories.category-form.category-color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "business-categories.category-form.category-color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "business-categories.category-form.category-color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "business-categories.category-form.category-color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "business-categories.category-form.category-color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "business-categories.category-form.category-color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "business-categories.category-form.category-color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "business-categories.category-form.category-color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "business-categories.category-form.category-color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "business-categories.category-form.category-color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "business-categories.category-form.category-color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "business-categories.category-form.category-color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "business-categories.category-form.category-color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "business-categories.category-form.category-color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "business-categories.category-form.category-color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "business-categories.category-form.category-color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "business-categories.category-form.category-color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "business-categories.category-form.category-color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "business-categories.category-form.category-color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "business-categories.category-form.category-color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "business-categories.category-form.category-color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});




parcelRegister("3Qvj8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a15d0a8bf35daa6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8a15d0a8bf35daa6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noCategory: {
        "id": "issue-table-grouping.group-row.group-header.category-group-header.no-category",
        "defaultMessage": "Uncategorized"
    }
});

});


parcelRegister("auqtM", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd782d309bb83742$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dd782d309bb83742$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issues: {
        "id": "issue-table-grouping.group-row.group-header.issues",
        "defaultMessage": "{count, plural, one {# issue} other {# issues}}"
    },
    issuesIssueTermRefresh: {
        "id": "issue-table-grouping.group-row.group-header.issues-issue-term-refresh",
        "defaultMessage": "{count, plural, one {# work item} other {# work items}}"
    }
});

});

parcelRegister("dtVUt", function(module, exports) {

$parcel$export(module.exports, "PriorityGroupHeader", () => $a17ee02a1a9ce0f3$export$3d9fbda3fab02eba);

var $8L1xw = parcelRequire("8L1xw");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $1uIg8 = parcelRequire("1uIg8");
const $a17ee02a1a9ce0f3$export$3d9fbda3fab02eba = ({ priorityGroupHeader: priorityGroupHeader })=>{
    const data = (0, $8Uumt.useFragment)((0, $8L1xw.default), priorityGroupHeader);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, data?.priority.iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "img",
        src: data.priority.iconUrl,
        xcss: $a17ee02a1a9ce0f3$var$iconStyles,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, data?.displayName ?? formatMessage((0, $1uIg8.default).noPriority)));
};
const $a17ee02a1a9ce0f3$var$iconStyles = (0, $8CUq3.xcss)({
    width: "var(--ds-space-250, 20px)",
    height: "var(--ds-space-250, 20px)"
});

});
parcelRegister("8L1xw", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb2e92f427b3ca8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a47183f377827441d9c91b7504c70c7f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $beb2e92f427b3ca8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priorityGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        }
    ],
    "type": "JiraJqlPriorityFieldValue"
};
$beb2e92f427b3ca8$var$node.hash = "3dcfc9ec9cb74efd76e969db691aec34";
var $beb2e92f427b3ca8$export$2e2bcd8739ae039 = $beb2e92f427b3ca8$var$node;

});

parcelRegister("1uIg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa07e961036536be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aa07e961036536be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noPriority: {
        "id": "issue-table-grouping.group-row.group-header.priority-group-header.no-priority",
        "defaultMessage": "No priority"
    }
});

});


parcelRegister("2jQNy", function(module, exports) {

$parcel$export(module.exports, "SprintGroupHeader", () => $1cfe87a9ad7ea4e1$export$c4bf8cf8359b52ab);

var $6s8vB = parcelRequire("6s8vB");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $d9xxV = parcelRequire("d9xxV");

var $koVbs = parcelRequire("koVbs");

var $fXSZY = parcelRequire("fXSZY");
const $1cfe87a9ad7ea4e1$export$c4bf8cf8359b52ab = ({ sprintGroupHeader: sprintGroupHeader })=>{
    const data = (0, $8Uumt.useFragment)((0, $6s8vB.default), sprintGroupHeader);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let text;
    if (!data) text = formatMessage((0, $fXSZY.default).backlog);
    else if (data.sprint?.state === 'CLOSED') text = formatMessage((0, $fXSZY.default).completedSprint);
    else text = data.displayName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
        text: text
    });
};

});
parcelRegister("6s8vB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b01b5b5a51186b96$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6e460a26aee2693b751f2aede983be2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b01b5b5a51186b96$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sprintGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraSprint",
            "kind": "LinkedField",
            "name": "sprint",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "state"
                }
            ]
        }
    ],
    "type": "JiraJqlSprintFieldValue"
};
$b01b5b5a51186b96$var$node.hash = "8c878b1b3d9a4d86bbc1c264380dbce5";
var $b01b5b5a51186b96$export$2e2bcd8739ae039 = $b01b5b5a51186b96$var$node;

});

parcelRegister("d9xxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87927dab24395a15$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");
const $87927dab24395a15$var$SimpleTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5oSQr.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aXLIT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $87927dab24395a15$var$SimpleTag = /*#__PURE__*/ (0, $5uXOq.memo)($87927dab24395a15$var$SimpleTagComponent);
var $87927dab24395a15$export$2e2bcd8739ae039 = $87927dab24395a15$var$SimpleTag;

});
parcelRegister("5oSQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35d9df42c66ff0$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $2hnSR = parcelRequire("2hnSR");
const $db35d9df42c66ff0$var$borderColorCssVar = '--ds-bc';
const $db35d9df42c66ff0$var$focusRingCssVar = '--ds-cfr';
const $db35d9df42c66ff0$var$textLinkCssVar = '--ds-ctl';
const $db35d9df42c66ff0$var$textDefaultCssVar = '--ds-ct';
const $db35d9df42c66ff0$var$textHoverCssVar = '--ds-cth';
const $db35d9df42c66ff0$var$textActiveCssVar = '--ds-ctp';
const $db35d9df42c66ff0$var$backgroundDefaultCssVar = '--ds-cb';
const $db35d9df42c66ff0$var$backgroundHoverCssVar = '--ds-cbh';
const $db35d9df42c66ff0$var$backgroundActiveCssVar = '--ds-cba';
const $db35d9df42c66ff0$var$removeButtonDefaultCssVar = '--ds-rb';
const $db35d9df42c66ff0$var$removeButtonHoverCssVar = '--ds-rbh';
const $db35d9df42c66ff0$var$borderRadiusCssVar = '--ds-br';
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$baseStylesOld = null;
const $db35d9df42c66ff0$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$interactiveStylesOld = null;
const $db35d9df42c66ff0$var$interactiveStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$focusRingStylesOld = null;
const $db35d9df42c66ff0$var$focusRingStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$nonStandardLinkStyles = null;
const $db35d9df42c66ff0$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? (0, $2hnSR.textColors)['standardLink'] : (0, $2hnSR.textColors)[color];
    const backgroundHoverColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkHoverBackgroundColors)[color];
    const backgroundActiveColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkActiveBackgroundColors)[color];
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // NOTE: The vast majority of these styles have zero purpose to be runtime computed
            // This can all be migrated to statically distributed atomic CSS with Compiled in the future
            // The main reason for not touching this is there is to avoid excessive changes in the same PR on non-visual-refresh code
            /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ [$db35d9df42c66ff0$var$borderColorCssVar]: (0, $2hnSR.borderColors)[color],
            [$db35d9df42c66ff0$var$textDefaultCssVar]: (0, $2hnSR.textColors)[color],
            [$db35d9df42c66ff0$var$textHoverCssVar]: (0, $2hnSR.textHoverColors)[color],
            [$db35d9df42c66ff0$var$textActiveCssVar]: (0, $2hnSR.textActiveColors)[color],
            [$db35d9df42c66ff0$var$textLinkCssVar]: textLinkColors,
            [$db35d9df42c66ff0$var$backgroundDefaultCssVar]: (0, $2hnSR.backgroundColors)[color],
            [$db35d9df42c66ff0$var$backgroundHoverCssVar]: backgroundHoverColors,
            [$db35d9df42c66ff0$var$backgroundActiveCssVar]: backgroundActiveColors,
            [$db35d9df42c66ff0$var$focusRingCssVar]: (0, $2hnSR.focusRingColors),
            [$db35d9df42c66ff0$var$removeButtonDefaultCssVar]: (0, $2hnSR.removeButtonColors)[color],
            [$db35d9df42c66ff0$var$removeButtonHoverCssVar]: (0, $2hnSR.removeButtonHoverColors)[color],
            [$db35d9df42c66ff0$var$borderRadiusCssVar]: appearance === 'rounded' ? '10px' : '3px',
            /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_zulp1b66 _2rko1sit _1h6d2fso _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhk1w7a _syaz1fxt _80om73ad" : "_2rko1l5z _1mou1b66 _195g1b66 _1rjcze3t _18zrze3t _1e0c116y _1ul9idpf _4t3iv47k _kqswh2mm _bfhklsll _syaz148y _80om73ad",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e38ugt7 _7glxv77o" : "_1guj1r31 _pbhaglyw _11ow1o36 _1u6lnr64",
            isLink && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_irr3166n _1di61dty",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && "_9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isInteractive && "_irr31lyj _1di6oo20",
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;

});
parcelRegister("2hnSR", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $5b444d8505b9cc3c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $5b444d8505b9cc3c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $5b444d8505b9cc3c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $5b444d8505b9cc3c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $5b444d8505b9cc3c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $5b444d8505b9cc3c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $5b444d8505b9cc3c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $5b444d8505b9cc3c$export$2a31dbe82788f940);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $5b444d8505b9cc3c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $5b444d8505b9cc3c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $5b444d8505b9cc3c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $5b444d8505b9cc3c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $5b444d8505b9cc3c$export$b03fbc2a369c563e);
// Text colors
const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
    standard: "var(--ds-text, #253858)",
    standardLink: "var(--ds-link, #0052CC)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
    standard: "var(--ds-link, #0065FF)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$382469baad253eb7 = {
    standard: "var(--ds-link-pressed, #0065FF)",
    blue: "var(--ds-text-accent-blue, #172B4D)",
    red: "var(--ds-text-accent-red, #172B4D)",
    yellow: "var(--ds-text-accent-yellow, #172B4D)",
    green: "var(--ds-text-accent-green, #172B4D)",
    teal: "var(--ds-text-accent-teal, #172B4D)",
    purple: "var(--ds-text-accent-purple, #172B4D)",
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: "var(--ds-text-accent-gray, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue-bolder, #0747A6)",
    redLight: "var(--ds-text-accent-red-bolder, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow-bolder, #42526E)",
    greenLight: "var(--ds-text-accent-green-bolder, #006644)",
    tealLight: "var(--ds-text-accent-teal-bolder, #42526E)",
    purpleLight: "var(--ds-text-accent-purple-bolder, #403294)",
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: "var(--ds-text-accent-gray-bolder, #42526E)"
};
const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
    standard: "var(--ds-background-neutral, #F4F5F7)",
    blue: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    red: "var(--ds-background-accent-red-subtle, #FF8F73)",
    yellow: "var(--ds-background-accent-yellow-subtle, #FFC400)",
    green: "var(--ds-background-accent-green-subtle, #57D9A3)",
    teal: "var(--ds-background-accent-teal-subtle, #00C7E6)",
    purple: "var(--ds-background-accent-purple-subtle, #998DD9)",
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: "var(--ds-background-accent-gray-subtle, #42526E)",
    blueLight: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    redLight: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    yellowLight: "var(--ds-background-accent-yellow-subtler, #FFE380)",
    greenLight: "var(--ds-background-accent-green-subtler, #79F2C0)",
    tealLight: "var(--ds-background-accent-teal-subtler, #79E2F2)",
    purpleLight: "var(--ds-background-accent-purple-subtler, #C0B6F2)",
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: "var(--ds-background-accent-gray-subtler, #EBECF0)"
};
const $5b444d8505b9cc3c$export$4410079763249c74 = {
    standard: "var(--ds-background-neutral-hovered, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-hovered, #B3D4FF)",
    red: "var(--ds-background-accent-red-subtle-hovered, #FFBDAD)",
    yellow: "var(--ds-background-accent-yellow-subtle-hovered, #FFE380)",
    green: "var(--ds-background-accent-green-subtle-hovered, #79F2C0)",
    teal: "var(--ds-background-accent-teal-subtle-hovered, #79E2F2)",
    purple: "var(--ds-background-accent-purple-subtle-hovered, #C0B6F2)",
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: "var(--ds-background-accent-gray-subtle-hovered, #505F79)",
    blueLight: "var(--ds-background-accent-blue-subtler-hovered, #DEEBFF)",
    redLight: "var(--ds-background-accent-red-subtler-hovered, #FFEBE6)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-hovered, #FFF0B3)",
    greenLight: "var(--ds-background-accent-green-subtler-hovered, #ABF5D1)",
    tealLight: "var(--ds-background-accent-teal-subtler-hovered, #B3F5FF)",
    purpleLight: "var(--ds-background-accent-purple-subtler-hovered, #EAE6FF)",
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: "var(--ds-background-accent-gray-subtler-hovered, #DFE1E6)"
};
const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
    standard: "var(--ds-background-neutral-pressed, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-pressed, #DEEBFF)",
    red: "var(--ds-background-accent-red-subtle-pressed, #FFEBE6)",
    yellow: "var(--ds-background-accent-yellow-subtle-pressed, #FFF0B3)",
    green: "var(--ds-background-accent-green-subtle-pressed, #ABF5D1)",
    teal: "var(--ds-background-accent-teal-subtle-pressed, #B3F5FF)",
    purple: "var(--ds-background-accent-purple-subtle-pressed, #EAE6FF)",
    grey: "var(--ds-background-accent-gray-subtle-pressed, #5E6C84)",
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: "var(--ds-background-accent-blue-subtler-pressed, #4C9AFF)",
    redLight: "var(--ds-background-accent-red-subtler-pressed, #FF8F73)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-pressed, #FFC400)",
    greenLight: "var(--ds-background-accent-green-subtler-pressed, #57D9A3)",
    tealLight: "var(--ds-background-accent-teal-subtler-pressed, #00C7E6)",
    purpleLight: "var(--ds-background-accent-purple-subtler-pressed, #998DD9)",
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: "var(--ds-background-accent-gray-subtler-pressed, #C1C7D0)"
};
const $5b444d8505b9cc3c$export$2a31dbe82788f940 = "var(--ds-border-focused, #4C9AFF)";
const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = "var(--ds-background-danger, #FFEBE6)";
const $5b444d8505b9cc3c$export$62ace793ebb16bda = "var(--ds-background-danger-hovered, #FFEBE6)";
const $5b444d8505b9cc3c$export$17d206ccea111bbb = "var(--ds-text-danger, #BF2600)";
const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
    standard: "var(--ds-text, #42526E)",
    blue: "var(--ds-text-accent-blue-bolder, #42526E)",
    red: "var(--ds-text-accent-red-bolder, #42526E)",
    yellow: "var(--ds-text-accent-yellow-bolder, #42526E)",
    green: "var(--ds-text-accent-green-bolder, #42526E)",
    teal: "var(--ds-text-accent-teal-bolder, #42526E)",
    purple: "var(--ds-text-accent-purple-bolder, #42526E)",
    lime: "var(--ds-text-accent-lime-bolder, #42526E)",
    magenta: "var(--ds-text-accent-magenta-bolder, #42526E)",
    orange: "var(--ds-text-accent-orange-bolder, #42526E)",
    grey: "var(--ds-text-accent-gray-bolder, #42526E)",
    blueLight: "var(--ds-text-accent-blue, #42526E)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #42526E)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #42526E)",
    limeLight: "var(--ds-text-accent-lime, #42526E)",
    magentaLight: "var(--ds-text-accent-magenta, #42526E)",
    orangeLight: "var(--ds-text-accent-orange, #42526E)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
    standard: "var(--ds-text-danger, #253858)",
    standardLink: "var(--ds-text-danger, #0052CC)",
    blue: "var(--ds-text-danger, #172B4D)",
    red: "var(--ds-text-danger, #172B4D)",
    yellow: "var(--ds-text-danger, #172B4D)",
    green: "var(--ds-text-danger, #172B4D)",
    teal: "var(--ds-text-danger, #172B4D)",
    purple: "var(--ds-text-danger, #172B4D)",
    lime: "var(--ds-text-danger, #172B4D)",
    magenta: "var(--ds-text-danger, #172B4D)",
    orange: "var(--ds-text-danger, #172B4D)",
    grey: "var(--ds-text-danger, #FFFFFF)",
    blueLight: "var(--ds-text-danger, #0747A6)",
    redLight: "var(--ds-text-danger, #42526E)",
    yellowLight: "var(--ds-text-danger, #42526E)",
    greenLight: "var(--ds-text-danger, #006644)",
    tealLight: "var(--ds-text-danger, #42526E)",
    purpleLight: "var(--ds-text-danger, #403294)",
    limeLight: "var(--ds-text-danger, #403294)",
    magentaLight: "var(--ds-text-danger, #403294)",
    orangeLight: "var(--ds-text-danger, #403294)",
    greyLight: "var(--ds-text-danger, #42526E)"
};

});


parcelRegister("aXLIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b11e671062d0fc5$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $4b11e671062d0fc5$var$beforeElementStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $4b11e671062d0fc5$var$beforeElementStylesOld = null;
const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t" : "_2rko1l5z _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;

});

parcelRegister("eYXIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b06918fbe54e8$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$baseStylesOld = null;
const $c46b06918fbe54e8$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$linkStylesOld = null;
const $c46b06918fbe54e8$var$linkStyles = null;
const $c46b06918fbe54e8$var$hasAfterStylesOld = null;
const $c46b06918fbe54e8$var$hasAfterStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$hasBeforeStyles = null;
const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)(Link, {
        href: href,
        "data-color": color,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt" : "_4bfu18uv _1hmsglyw _ajmmnqa1 _syazs5nr _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l3117u _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;

});


parcelRegister("fXSZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $05d3d0a2a698fcfc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $05d3d0a2a698fcfc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    completedSprint: {
        "id": "issue-table-grouping.group-row.group-header.sprint-group-header.completed-sprint",
        "defaultMessage": "Completed sprint"
    },
    backlog: {
        "id": "issue-table-grouping.group-row.group-header.sprint-group-header.backlog",
        "defaultMessage": "Backlog"
    }
});

});


parcelRegister("8tbem", function(module, exports) {

$parcel$export(module.exports, "StatusGroupHeader", () => $011d203fec163038$export$47d603da63417bb);

var $7Z6H4 = parcelRequire("7Z6H4");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aYAc3 = parcelRequire("aYAc3");

var $gULOk = parcelRequire("gULOk");
const $011d203fec163038$var$appearanceMap = {
    [(0, $gULOk.UNDEFINED)]: 'default',
    [(0, $gULOk.TODO)]: 'default',
    [(0, $gULOk.DONE)]: 'success',
    [(0, $gULOk.IN_PROGRESS)]: 'inprogress'
};
const $011d203fec163038$export$47d603da63417bb = ({ statusGroupHeader: statusGroupHeader })=>{
    const data = (0, $8Uumt.useFragment)((0, $7Z6H4.default), statusGroupHeader);
    const appearance = data?.statusCategory.statusCategoryId != null ? $011d203fec163038$var$appearanceMap[(0, $gULOk.statusCategoryForId)(data?.statusCategory.statusCategoryId)] : $011d203fec163038$var$appearanceMap[0, $gULOk.UNDEFINED];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: appearance
    }, data?.displayName);
};

});
parcelRegister("7Z6H4", function(module, exports) {

$parcel$export(module.exports, "default", () => $370a83288e3e16ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ad111684f32cabb41a8564790f4ff647>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $370a83288e3e16ba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "statusGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCategoryId"
                }
            ]
        }
    ],
    "type": "JiraJqlStatusFieldValue"
};
$370a83288e3e16ba$var$node.hash = "4f2de6020bb90556ff180cce2814c51d";
var $370a83288e3e16ba$export$2e2bcd8739ae039 = $370a83288e3e16ba$var$node;

});

parcelRegister("gULOk", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e77315bf13f8b83b$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e77315bf13f8b83b$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e77315bf13f8b83b$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e77315bf13f8b83b$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e77315bf13f8b83b$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e77315bf13f8b83b$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e77315bf13f8b83b$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e77315bf13f8b83b$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e77315bf13f8b83b$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e77315bf13f8b83b$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e77315bf13f8b83b$export$d928f247c903643a);
const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
    $e77315bf13f8b83b$export$6db089fe7b26f5b6,
    $e77315bf13f8b83b$export$aa456a5030160740,
    $e77315bf13f8b83b$export$5a9ac66c2785cc13,
    $e77315bf13f8b83b$export$71efb3495f6084f2
];
const $e77315bf13f8b83b$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
    }
];
const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
};
const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("Z2VxN", function(module, exports) {

$parcel$export(module.exports, "StoryPointsGroupHeader", () => $957bad3d7bd8bb06$export$67c95e3a82fabe13);

var $3pV1e = parcelRequire("3pV1e");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $16T6Y = parcelRequire("16T6Y");

var $d9xxV = parcelRequire("d9xxV");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $jdpbd = parcelRequire("jdpbd");
const $957bad3d7bd8bb06$export$67c95e3a82fabe13 = ({ storyPointsGroupHeader: storyPointsGroupHeader })=>{
    const data = (0, $8Uumt.useFragment)((0, $3pV1e.default), storyPointsGroupHeader);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "default"
    }, typeof data?.number === 'number' ? formatMessage((0, $jdpbd.default).storyPoints, {
        points: data?.number
    }) : formatMessage((0, $jdpbd.default).noStoryPoints)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
        text: typeof data?.number === 'number' ? formatMessage((0, $jdpbd.default).storyPoints, {
            points: data?.number
        }) : formatMessage((0, $jdpbd.default).noStoryPoints)
    });
};

});
parcelRegister("3pV1e", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bb6de155e686261$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ce8ac842490f82e59f8a233d44e27fa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1bb6de155e686261$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "storyPointsGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraJqlNumberFieldValue"
};
$1bb6de155e686261$var$node.hash = "99ed4a1cc4e5ea4a4b3c5cb98de1c14f";
var $1bb6de155e686261$export$2e2bcd8739ae039 = $1bb6de155e686261$var$node;

});

parcelRegister("jdpbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cf3a1d59f505ba5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4cf3a1d59f505ba5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    storyPoints: {
        "id": "issue-table-grouping.group-row.group-header.story-points-group-header.story-points",
        "defaultMessage": "{points, plural, one {# point} other {# points}}"
    },
    noStoryPoints: {
        "id": "issue-table-grouping.group-row.group-header.story-points-group-header.no-story-points",
        "defaultMessage": "No points"
    }
});

});


parcelRegister("9KThJ", function(module, exports) {

$parcel$export(module.exports, "GoalGroupHeader", () => $2aefc58c4513aeb3$export$2fac2323394ec085);

var $gl7gs = parcelRequire("gl7gs");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $aYAc3 = parcelRequire("aYAc3");

var $koVbs = parcelRequire("koVbs");

var $en3kR = parcelRequire("en3kR");

var $en3kR = parcelRequire("en3kR");

var $4R6GH = parcelRequire("4R6GH");

var $hCQ8w = parcelRequire("hCQ8w");
const $2aefc58c4513aeb3$var$goalStatusToLabelMap = {
    ARCHIVED: (0, $hCQ8w.default).statusLabelArchived,
    PENDING: (0, $hCQ8w.default).statusLabelPending,
    IN_PROGRESS: (0, $hCQ8w.default).statusLabelInProgress,
    COMPLETED: (0, $hCQ8w.default).statusLabelCompleted,
    DONE: (0, $hCQ8w.default).statusLabelCompleted,
    ON_TRACK: (0, $hCQ8w.default).statusLabelOnTrack,
    PAUSED: (0, $hCQ8w.default).statusLabelPaused,
    AT_RISK: (0, $hCQ8w.default).statusLabelAtRisk,
    OFF_TRACK: (0, $hCQ8w.default).statusLabelOffTrack,
    CANCELLED: (0, $hCQ8w.default).statusLabelCancelled
};
const $2aefc58c4513aeb3$var$goalStatusToLozengeAppearanceMap = {
    ARCHIVED: 'default',
    PENDING: 'default',
    IN_PROGRESS: 'inprogress',
    COMPLETED: 'success',
    DONE: 'success',
    ON_TRACK: 'success',
    PAUSED: 'moved',
    AT_RISK: 'moved',
    OFF_TRACK: 'removed',
    CANCELLED: 'removed'
};
const $2aefc58c4513aeb3$export$2fac2323394ec085 = ({ goalGroupHeader: goalGroupHeader })=>{
    const data = (0, $8Uumt.useFragment)((0, $gl7gs.default), goalGroupHeader);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const displayName = data?.displayName ?? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $hCQ8w.default).noGoalsDisplayNameIssueTermRefresh : (0, $hCQ8w.default).noGoalsDisplayName);
    const status = formatMessage($2aefc58c4513aeb3$var$goalStatusToLabelMap[data?.goal?.status || 'PENDING']);
    const appearance = (0, $en3kR.normalizeGoalAppearance)(data?.goal?.status || 'PENDING');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, data?.goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $en3kR.GoalIcon), {
        size: "16",
        appearance: appearance,
        goalIconKey: "GOAL"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2aefc58c4513aeb3$var$goalTextStyles
    }, displayName), data?.goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: $2aefc58c4513aeb3$var$goalStatusToLozengeAppearanceMap[data.goal.status || 'PENDING']
    }, status, data.goal.score && ` - ${data.goal.score || ''}`));
};
const $2aefc58c4513aeb3$var$goalTextStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("gl7gs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9385f979ebc76306$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<01232dee66988142ad1378499d9b08c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9385f979ebc76306$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "goalGroupHeader_issueTableGrouping",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraGoal",
            "kind": "LinkedField",
            "name": "goal",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "kind": "ScalarField",
                    "name": "score"
                }
            ]
        }
    ],
    "type": "JiraJqlGoalsFieldValue"
};
$9385f979ebc76306$var$node.hash = "ff278af7d79d0614b5dc07558d4a411c";
var $9385f979ebc76306$export$2e2bcd8739ae039 = $9385f979ebc76306$var$node;

});

parcelRegister("en3kR", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $a6db28d963218554$export$134cbcd70c6693b8);
$parcel$export(module.exports, "normalizeGoalAppearance", () => $a6db28d963218554$export$f1b3ca93191ce5cc);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $cwmS5 = parcelRequire("cwmS5");

var $4iV1e = parcelRequire("4iV1e");

var $4DRId = parcelRequire("4DRId");

var $3pgsH = parcelRequire("3pgsH");

var $h7ddS = parcelRequire("h7ddS");

var $dOSG9 = parcelRequire("dOSG9");
const $a6db28d963218554$var$appearanceToColorMap = {
    DEFAULT: 'gray',
    MENU: 'gray',
    OFF_TRACK: 'red',
    AT_RISK: 'yellow',
    ON_TRACK: 'green'
};
const $a6db28d963218554$var$appearanceToNewColorMap = {
    MENU: "var(--ds-icon, #44546F)",
    DEFAULT: "var(--ds-icon-accent-gray, #758195)",
    OFF_TRACK: "var(--ds-icon-danger, #C9372C)",
    AT_RISK: "var(--ds-icon-warning, #E56910)",
    ON_TRACK: "var(--ds-icon-success, #22A06B)"
};
const $a6db28d963218554$var$keyToIconMap = {
    GOAL: (0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))),
    OBJECTIVE: (0, (/*@__PURE__*/$parcel$interopDefault($3pgsH))),
    KEY_RESULT: (0, (/*@__PURE__*/$parcel$interopDefault($4DRId)))
};
const $a6db28d963218554$var$getLabel = (intl, label, localizedLabel)=>{
    if (label) return label;
    if (localizedLabel && (0, $dOSG9.isMessageId)(localizedLabel?.messageId)) return intl.formatMessage((0, $dOSG9.messages)[localizedLabel.messageId]);
    return '';
};
const $a6db28d963218554$export$134cbcd70c6693b8 = ({ appearance: appearance, size: size, localizedLabel: localizedLabel, goalIconKey: goalIconKey = 'GOAL', isVisualRefresh: isVisualRefresh = false, visualRefreshSpacing: visualRefreshSpacing = 'none', label: label, shouldScale: shouldScale = false })=>{
    const intl = (0, $koVbs.default)();
    const iconLabel = $a6db28d963218554$var$getLabel(intl, label, localizedLabel);
    const Icon = $a6db28d963218554$var$keyToIconMap[goalIconKey] ?? $a6db28d963218554$var$keyToIconMap.GOAL;
    if (isVisualRefresh) {
        const ResizableIcon = Icon;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ResizableIcon, {
            shouldScale: shouldScale,
            color: $a6db28d963218554$var$appearanceToNewColorMap[appearance],
            label: iconLabel,
            spacing: visualRefreshSpacing
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        size: size,
        icon: Icon,
        label: iconLabel,
        appearance: $a6db28d963218554$var$appearanceToColorMap[appearance]
    });
};
const $a6db28d963218554$export$f1b3ca93191ce5cc = (statusValue)=>{
    const appearanceUppercase = statusValue.toLocaleUpperCase();
    return (0, $h7ddS.isGoalAppearance)(appearanceUppercase) ? appearanceUppercase : 'DEFAULT';
};

});
parcelRegister("cwmS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a921419639fe8f6f$export$2e2bcd8739ae039);
/* icon-tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $a921419639fe8f6f$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $a921419639fe8f6f$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $a921419639fe8f6f$var$shapeMap = {
    square: "_2rkoiti9",
    circle: "_2rko14q2"
};
const $a921419639fe8f6f$var$iconTileStyles = null;
function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $VSDnB.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $a921419639fe8f6f$var$appearanceMap[appearance],
            $a921419639fe8f6f$var$sizeMap[size],
            $a921419639fe8f6f$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});

parcelRegister("4DRId", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9ba563912d9cb57c78d7ea4485b79c7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3614780827b64603$var$_react = $3614780827b64603$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3614780827b64603$var$_baseNew = $3614780827b64603$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3614780827b64603$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "KeyResult".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing key results.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3614780827b64603$var$KeyResultIcon = (props)=>/*#__PURE__*/ $3614780827b64603$var$_react.default.createElement($3614780827b64603$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.435.001a.75.75 0 0 1 .547.194l3.023 2.75-1.01 1.11-2.437-2.217A10.2 10.2 0 0 0 7.527 7.25h3.163l1.28-1.28a.75.75 0 0 1 .53-.22h2.75a.75.75 0 0 1 .671 1.085L15.339 8l.582 1.165a.75.75 0 0 1-.67 1.085H12.5a.75.75 0 0 1-.531-.22l-1.28-1.28H7.528c.149 2.02.895 3.88 2.051 5.41l2.414-2.213 1.014 1.106-3 2.75a.75.75 0 0 1-1.07-.059A11.75 11.75 0 0 1 6.023 8.75H2.756l1.361 1.184-.984 1.132-2.875-2.5a.75.75 0 0 1 0-1.132l2.875-2.5.984 1.132L2.755 7.25h3.269A11.7 11.7 0 0 1 8.914.255a.75.75 0 0 1 .52-.254m2.626 8 .75.749h1.226l-.208-.414a.75.75 0 0 1 0-.671l.208-.415H12.81z" clip-rule="evenodd"/>`
    }, props));
$3614780827b64603$var$KeyResultIcon.displayName = 'KeyResultIcon';
var $3614780827b64603$var$_default = module.exports.default = $3614780827b64603$var$KeyResultIcon;

});

parcelRegister("3pgsH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6209776ef69c56f26af2970fd840a919>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27b079e3ef5ffb2f$var$_react = $27b079e3ef5ffb2f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $27b079e3ef5ffb2f$var$_baseNew = $27b079e3ef5ffb2f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $27b079e3ef5ffb2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Objective".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for objectives.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27b079e3ef5ffb2f$var$ObjectiveIcon = (props)=>/*#__PURE__*/ $27b079e3ef5ffb2f$var$_react.default.createElement($27b079e3ef5ffb2f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.422.02a.75.75 0 0 1 .54.493l.38 1.144 1.145.381a.75.75 0 0 1 .293 1.242l-2 2a.75.75 0 0 1-.53.22h-1.69L8.03 9.03 6.97 7.97l3.53-3.53V2.75a.75.75 0 0 1 .22-.53l2-2a.75.75 0 0 1 .702-.2M12 4h.94l.922-.922-.35-.116a.75.75 0 0 1-.473-.475l-.117-.349-.922.923zM8 1.5A6.5 6.5 0 1 0 14.5 8H16a8 8 0 1 1-8-8zM8 5a3 3 0 1 0 3 3h1.5A4.5 4.5 0 1 1 8 3.5z" clip-rule="evenodd"/>`
    }, props));
$27b079e3ef5ffb2f$var$ObjectiveIcon.displayName = 'ObjectiveIcon';
var $27b079e3ef5ffb2f$var$_default = module.exports.default = $27b079e3ef5ffb2f$var$ObjectiveIcon;

});

parcelRegister("h7ddS", function(module, exports) {

$parcel$export(module.exports, "isGoalAppearance", () => $926e58146ec2300b$export$86d2476abee3806b);
$parcel$export(module.exports, "isGoalIconKey", () => $926e58146ec2300b$export$51f87e2f4bd9e4bf);
const $926e58146ec2300b$export$d6870ac5e959c0f5 = [
    'DEFAULT',
    'ON_TRACK',
    'AT_RISK',
    'OFF_TRACK',
    'MENU'
];
const $926e58146ec2300b$export$86d2476abee3806b = (value)=>$926e58146ec2300b$export$d6870ac5e959c0f5.includes(value);
const $926e58146ec2300b$export$d7b4c6a971e28318 = [
    'ON_TRACK',
    'AT_RISK',
    'OFF_TRACK',
    'PENDING',
    'DONE',
    'CANCELLED',
    'PAUSED',
    'ARCHIVED'
];
const $926e58146ec2300b$export$a65140e49f013a96 = [
    'GOAL',
    'OBJECTIVE',
    'KEY_RESULT'
];
const $926e58146ec2300b$export$51f87e2f4bd9e4bf = (value)=>$926e58146ec2300b$export$a65140e49f013a96.includes(value);

});

parcelRegister("dOSG9", function(module, exports) {

$parcel$export(module.exports, "isMessageId", () => $a371d973bdb7f9d5$export$d28699f9b486207b);
$parcel$export(module.exports, "messages", () => $a371d973bdb7f9d5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a371d973bdb7f9d5$var$MESSAGE_IDS = [
    'townsquare.api.goal-state.on-track',
    'townsquare.api.goal-state.off-track',
    'townsquare.api.goal-state.at-risk',
    'townsquare.api.goal-state.pending',
    'townsquare.api.goal-state.completed',
    'townsquare.api.goal-state.cancelled',
    'townsquare.api.goal-state.paused'
];
const $a371d973bdb7f9d5$export$d28699f9b486207b = (value)=>$a371d973bdb7f9d5$var$MESSAGE_IDS.includes(value);
const $a371d973bdb7f9d5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    'townsquare.api.goal-state.on-track': {
        id: 'Goals.icon.label.on-track',
        defaultMessage: 'On track',
        description: 'The label for the "on track" goal status'
    },
    'townsquare.api.goal-state.off-track': {
        id: 'Goals.icon.label.off-track',
        defaultMessage: 'Off track',
        description: 'The label for the "off track" goal status'
    },
    'townsquare.api.goal-state.at-risk': {
        id: 'Goals.icon.label.at-risk',
        defaultMessage: 'At risk',
        description: 'The label for the "at risk" goal status'
    },
    'townsquare.api.goal-state.pending': {
        id: 'Goals.icon.label.pending',
        defaultMessage: 'Pending',
        description: 'The label for the "pending" goal status'
    },
    'townsquare.api.goal-state.completed': {
        id: 'Goals.icon.label.completed',
        defaultMessage: 'Completed',
        description: 'The label for the "completed" goal status'
    },
    'townsquare.api.goal-state.cancelled': {
        id: 'Goals.icon.label.cancelled',
        defaultMessage: 'Cancelled',
        description: 'The label for the "cancelled" goal status'
    },
    'townsquare.api.goal-state.paused': {
        id: 'Goals.icon.label.paused',
        defaultMessage: 'Paused',
        description: 'The label for the "paused" goal status'
    }
});

});


parcelRegister("hCQ8w", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f6b8ba66c684ab2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4f6b8ba66c684ab2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noGoalsDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.goal-group-header.no-goals-display-name",
        "defaultMessage": "Issues without goal"
    },
    noGoalsDisplayNameIssueTermRefresh: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.no-goals-display-name-issue-term-refresh",
        "defaultMessage": "Work items without goal"
    },
    statusLabelArchived: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-archived",
        "defaultMessage": "Archived"
    },
    statusLabelPending: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-pending",
        "defaultMessage": "Pending"
    },
    statusLabelInProgress: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-in-progress",
        "defaultMessage": "In progress"
    },
    statusLabelCompleted: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-completed",
        "defaultMessage": "Completed"
    },
    statusLabelOnTrack: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-on-track",
        "defaultMessage": "On track"
    },
    statusLabelPaused: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-paused",
        "defaultMessage": "Paused"
    },
    statusLabelAtRisk: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-at-risk",
        "defaultMessage": "At risk"
    },
    statusLabelOffTrack: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-off-track",
        "defaultMessage": "Off track"
    },
    statusLabelCancelled: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-cancelled",
        "defaultMessage": "Cancelled"
    }
});

});




parcelRegister("lFmEw", function(module, exports) {

$parcel$export(module.exports, "Rows", () => $a9cf22ec2b58158b$export$9ba739f4e3fc4d9);

var $i7hLy = parcelRequire("i7hLy");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $ajpes = parcelRequire("ajpes");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $2S8IK = parcelRequire("2S8IK");

var $iXVV6 = parcelRequire("iXVV6");

var $52ESs = parcelRequire("52ESs");

var $1XJ20 = parcelRequire("1XJ20");

var $fc4cz = parcelRequire("fc4cz");

var $loBb5 = parcelRequire("loBb5");

var $e9M6d = parcelRequire("e9M6d");

var $1CwmH = parcelRequire("1CwmH");

var $bGP8e = parcelRequire("bGP8e");

var $5DTiT = parcelRequire("5DTiT");

var $9JU2H = parcelRequire("9JU2H");

var $1D5Yb = parcelRequire("1D5Yb");
const $a9cf22ec2b58158b$var$HierarchyRow = /*#__PURE__*/ (0, $5uXOq.memo)(({ depth: depth, itemsConnectionId: itemsConnectionId, parentItemConnectionId: parentItemConnectionId, parentIssueAri: parentIssueAri, rowsData: rowsData, index: index, isVirtual: isVirtual, isIssueHierarchyEnabled: isIssueHierarchyEnabled, measureElement: measureElement, projectKey: projectKey })=>{
    const issueRow = rowsData?.edges?.[index];
    const hierarchyLevel = issueRow?.node?.issueTypeField?.issueType?.hierarchy?.level;
    const { renderChildRows: renderChildRows } = (0, $5DTiT.useRowContext)();
    const { isFormVisible: isFormVisible, formProps: formProps, triggerProps: triggerProps } = (0, $2S8IK.useInlineCreateHandlers)({
        projectKey: (0, $e9M6d.useProjectContext)(),
        ...hierarchyLevel != null && {
            minHierarchyLevel: hierarchyLevel - 1,
            maxHierarchyLevel: hierarchyLevel - 1
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            rowIndex: index,
            tableRowNumber: index
        }
    }, isVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1CwmH.default), {
        rowIndex: index,
        itemsConnectionId: rowsData.__id,
        issue: issueRow?.node ?? null,
        issueEdge: issueRow ?? null,
        fieldSets: issueRow?.fieldSets ?? null,
        depth: depth,
        parentIssueAri: parentIssueAri,
        parentItemConnectionId: parentItemConnectionId,
        parentIssueRelayConnectionId: itemsConnectionId,
        triggerProps: triggerProps,
        isFormVisible: isFormVisible,
        measureElement: measureElement,
        ...(0, $4R6GH.fg)('jsc_list_reparenting') ? {
            hierarchyLevel: hierarchyLevel,
            issueKey: issueRow?.node?.key,
            projectKey: projectKey
        } : {}
    }), issueRow?.node?.issueId && isIssueHierarchyEnabled && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') && renderChildRows?.({
        issueKey: issueRow?.node?.key,
        parentItemId: issueRow?.node?.issueId,
        itemsConnectionId: rowsData.__id,
        depth: depth,
        parentIssueAri: issueRow?.node?.id,
        parentItemConnectionId: issueRow?.__id,
        parentIssueRelayConnectionId: itemsConnectionId,
        type: 'PARENT_CHILDREN',
        isFormVisible: isFormVisible,
        formProps: formProps,
        hasChildren: issueRow?.hasChildren ?? false
    }));
});
const $a9cf22ec2b58158b$export$9ba739f4e3fc4d9 = ({ projectKey: projectKey, issueResults: issueResults, depth: depth = 0, parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentIssueAri: parentIssueAri, parentItemConnectionId: parentItemConnectionId, parentIssueRelayConnectionId: parentIssueRelayConnectionId, isLoadingNext: isLoadingNext, hasNext: hasNext, isChildIssueCreateRowVisible: isChildIssueCreateRowVisible, onLoadNextItems: onLoadNextItems, renderChildIssueCreateRow: renderChildIssueCreateRow })=>{
    const rowsData = (0, $8Uumt.useFragment)((0, $i7hLy.default), issueResults);
    let isIssueHierarchyEnabled = false;
    let populateConnection = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isIssueHierarchyEnabled = (0, $e9M6d.useIsIssueHierarchyEnabled)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ populateConnection: populateConnection } = (0, $fc4cz.useHierarchyActions)());
    }
    const { columns: columns, groupId: groupId } = (0, $5DTiT.useRowContext)();
    const populateConnectionArgs = (0, $5uXOq.useMemo)(()=>({
            parentItemId: parentItemId,
            itemsConnectionId: rowsData.__id,
            parentConnectionId: itemsConnectionId,
            list: rowsData?.edges?.map((edge)=>edge?.node && {
                    key: edge.node.key,
                    itemId: edge.node.issueId,
                    groupId: groupId
                }).filter(Boolean) ?? [],
            hasNext: hasNext,
            groupId: groupId,
            isChildIssueCreateRowVisible: isChildIssueCreateRowVisible
        }), [
        parentItemId,
        itemsConnectionId,
        rowsData.__id,
        rowsData?.edges,
        hasNext,
        groupId,
        isChildIssueCreateRowVisible
    ]);
    const prevPopulateConnectArgs = (0, $1XJ20.usePrevious)(populateConnectionArgs);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(populateConnectionArgs, prevPopulateConnectArgs) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) populateConnection(populateConnectionArgs);
    const renderRowItem = (0, $5uXOq.useCallback)((index, measureElement)=>{
        const issueRow = rowsData?.edges?.[index];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            key: issueRow?.node?.key || index,
            attributes: {
                rowIndex: index,
                tableRowNumber: index
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1CwmH.default), {
            rowIndex: index,
            itemsConnectionId: rowsData.__id,
            issue: issueRow?.node ?? null,
            issueEdge: issueRow ?? null,
            fieldSets: issueRow?.fieldSets ?? null,
            depth: depth,
            parentIssueAri: parentIssueAri,
            parentItemConnectionId: parentItemConnectionId,
            parentIssueRelayConnectionId: parentIssueRelayConnectionId,
            measureElement: measureElement,
            ...(0, $4R6GH.fg)('jsc_list_reparenting') ? {
                projectKey: projectKey,
                issueKey: issueRow?.node?.key
            } : {}
        }));
    }, [
        rowsData?.edges,
        rowsData.__id,
        depth,
        parentIssueAri,
        parentItemConnectionId,
        parentIssueRelayConnectionId,
        projectKey
    ]);
    const renderRows = (0, $5uXOq.useCallback)((isItemVirtual, measureElement)=>{
        if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) {
            const childIssueCreateItemId = (0, $52ESs.getFlatListKey)({
                itemId: (0, $fc4cz.getChildIssueCreateItemKey)(parentItemId),
                groupId: groupId
            });
            const isChildIssueCreateRowVirtual = isItemVirtual?.(childIssueCreateItemId) ?? true;
            const showMoreItemId = (0, $52ESs.getFlatListKey)({
                itemId: (0, $fc4cz.getShowMoreItemKey)(parentItemId),
                groupId: groupId
            });
            const isShowMoreItemVirtual = isItemVirtual?.(showMoreItemId) ?? true;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (isIssueHierarchyEnabled || (0, $4R6GH.fg)('jira_spreadsheet_issue_create_in_group_targeting_')) && isChildIssueCreateRowVirtual && renderChildIssueCreateRow?.(), rowsData?.edges?.map((edge, index)=>{
                const flatListIssueId = (0, $52ESs.getFlatListKey)({
                    itemId: edge?.node?.issueId ?? '',
                    groupId: groupId
                });
                const isVirtual = isItemVirtual?.(flatListIssueId) ?? true;
                return isIssueHierarchyEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9cf22ec2b58158b$var$HierarchyRow, {
                    key: flatListIssueId,
                    itemsConnectionId: itemsConnectionId,
                    isVirtual: isVirtual,
                    index: index,
                    rowsData: rowsData,
                    depth: depth,
                    parentItemConnectionId: parentItemConnectionId ?? '',
                    parentIssueAri: parentIssueAri ?? '',
                    isIssueHierarchyEnabled: isIssueHierarchyEnabled,
                    measureElement: measureElement,
                    projectKey: projectKey
                }) : isVirtual && renderRowItem(index, measureElement);
            }), hasNext && isShowMoreItemVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $loBb5.LoadMoreItemsRow), {
                isLoadingNext: isLoadingNext,
                columnsCount: columns.length,
                loadNext: onLoadNextItems ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
            }), (0, $4R6GH.fg)('jira_native_issue_table_extra_custom_components') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGP8e.RowsAdditionalContentRenderer), {
                depth: depth,
                groupId: groupId,
                issues: rowsData
            }));
        }
        return rowsData?.edges?.map((_, index)=>renderRowItem(index, measureElement) ?? null);
    }, [
        columns.length,
        depth,
        groupId,
        hasNext,
        isIssueHierarchyEnabled,
        isLoadingNext,
        itemsConnectionId,
        onLoadNextItems,
        parentIssueAri,
        parentItemConnectionId,
        parentItemId,
        projectKey,
        renderChildIssueCreateRow,
        renderRowItem,
        rowsData
    ]);
    const isVirtualizationEnabled = (0, $e9M6d.useIsVirtualizationEnabled)();
    if (isVirtualizationEnabled) {
        if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) {
            const isGrouping = Boolean(groupId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9JU2H.VirtualizedRows), {
                hasSpacers: depth === 0 && !isGrouping,
                columnsCount: columns.length
            }, renderRows);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1D5Yb.VirtualizedRows), {
            renderRow: renderRowItem
        }, renderRows);
    }
    return renderRows();
};

});
parcelRegister("i7hLy", function(module, exports) {

$parcel$export(module.exports, "default", () => $62f2119386e428fa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7e5c7da3700fe09919b4063b0a8826d8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $62f2119386e428fa$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "isDensityFull",
        "variableName": "isDensityFull"
    }, v1 = {
        "kind": "Variable",
        "name": "isInlineEditingEnabled",
        "variableName": "isInlineEditingEnabled"
    }, v2 = [
        v0 /*: any*/ ,
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "rows_nativeIssueTable",
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "args": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "isReparentingEnabled",
                                "variableName": "isReparentingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Variable",
                                "name": "shouldQueryHasChildren",
                                "variableName": "shouldQueryHasChildren"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "row_nativeIssueTable_issueEdge"
                    },
                    {
                        "condition": "shouldQueryHasChildren",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterByProjectKeys",
                                        "variableName": "projectKeys"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "hasChildren"
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "id"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "issueId"
                            },
                            {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueTypeHierarchyLevel",
                                                "kind": "LinkedField",
                                                "name": "hierarchy",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "level"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "row_nativeIssueTable_issue"
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 500
                                    }
                                ],
                                "concreteType": "JiraIssueFieldSetConnection",
                                "kind": "LinkedField",
                                "name": "fieldSets",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "row_nativeIssueTable_fieldSets"
                                    }
                                ],
                                "storageKey": "fieldSets(first:500)"
                            }
                        ]
                    },
                    v3 /*: any*/ 
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isTimelineEnabled",
                        "variableName": "isTimelineEnabled"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "rowsAdditionalContentRenderer_nativeIssueTable"
            },
            v3 /*: any*/ 
        ],
        "type": "JiraIssueConnection"
    };
}();
$62f2119386e428fa$var$node.hash = "e970da1e7f280b1886b6f0a965086ad1";
var $62f2119386e428fa$export$2e2bcd8739ae039 = $62f2119386e428fa$var$node;

});

parcelRegister("loBb5", function(module, exports) {

$parcel$export(module.exports, "LoadMoreItemsRow", () => $2abe2418dcc03d48$export$23063d416e023423);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $1v6c5 = parcelRequire("1v6c5");

var $dmE4j = parcelRequire("dmE4j");
const $2abe2418dcc03d48$var$ROW_HEIGHT = 40;
const $2abe2418dcc03d48$export$23063d416e023423 = ({ loadNext: loadNext, isLoadingNext: isLoadingNext = false, columnsCount: columnsCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "tr",
        xcss: $2abe2418dcc03d48$var$rowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1v6c5.TableCell), {
        border: $2abe2418dcc03d48$var$cellBorderStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1v6c5.TableCell), {
        border: $2abe2418dcc03d48$var$cellBorderStyles,
        colSpan: columnsCount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        spacing: "compact",
        isDisabled: isLoadingNext,
        onClick: loadNext
    }, isLoadingNext ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dmE4j.default).loadingMoreItemsIssueTermRefresh : (0, $dmE4j.default).loadingMoreItems) : formatMessage((0, $dmE4j.default).showMore))));
};
const $2abe2418dcc03d48$var$rowStyles = (0, $8CUq3.xcss)({
    height: `${$2abe2418dcc03d48$var$ROW_HEIGHT}px`,
    backgroundColor: 'elevation.surface'
});
const $2abe2418dcc03d48$var$cellBorderStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTopWidth: 'border.width',
    borderBottomWidth: '0',
    borderLeftWidth: '0',
    borderRightWidth: '0'
});

});
parcelRegister("1v6c5", function(module, exports) {

$parcel$export(module.exports, "TableCell", () => $28ce82260e13c14a$export$1e4baea7053fc0e3);

var $5uXOq = parcelRequire("5uXOq");

var $7hpBk = parcelRequire("7hpBk");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $79UpA = parcelRequire("79UpA");

var $lP0j5 = parcelRequire("lP0j5");

var $e9M6d = parcelRequire("e9M6d");
const $28ce82260e13c14a$export$1e4baea7053fc0e3 = (props)=>{
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    return isSingleLineRowHeightEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79UpA.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28ce82260e13c14a$var$TableCellInner, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28ce82260e13c14a$var$TableCellInner, props);
};
const $28ce82260e13c14a$var$TableCellInner = ({ children: children, border: border, spacing: spacing, row: row, column: column, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, ...htmlAttributes })=>{
    const spacingStyles = spacing !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($7hpBk)))(spacing) : [
        $28ce82260e13c14a$var$defaultSpacingStyles
    ];
    const borderStyles = border !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($7hpBk)))(border) : [];
    const { cellRef: cellRef } = (0, $4R6GH.fg)('jira_list_grid_pattern_keyboard_nav') ? (0, $lP0j5.useCellWrapper)({
        row: row == null ? 0 : row + 1,
        col: column == null ? 0 : column
    }) : {
        cellRef: null
    };
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    let singleLineRowHeightProps = {};
    if (isSingleLineRowHeightEnabled) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave } = (0, $79UpA.useCellHoverHandlers)();
        singleLineRowHeightProps = {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        };
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "td",
        ...(0, $4R6GH.fg)('issue_table_frozen_columns') && {
            style: {
                left: isColumnSticky ? stickyOffsets : undefined,
                zIndex: isColumnSticky ? 2 : undefined
            }
        },
        xcss: [
            $28ce82260e13c14a$var$baseStyles,
            ...spacingStyles,
            ...borderStyles,
            (0, $4R6GH.fg)('nin-grid-keyboard-navigation') && $28ce82260e13c14a$var$keyboardNavigationStyles,
            isColumnSticky && (0, $4R6GH.fg)('issue_table_frozen_columns') && $28ce82260e13c14a$var$stickyStyles
        ],
        ...(0, $4R6GH.fg)('jira_list_grid_pattern_keyboard_nav') && {
            ref: cellRef
        },
        ...htmlAttributes,
        ...singleLineRowHeightProps,
        ...(0, $4R6GH.fg)('nin-grid-keyboard-navigation') && {
            tabIndex: -1
        }
    }, children);
};
const $28ce82260e13c14a$var$baseStyles = (0, $8CUq3.xcss)({
    background: 'inherit',
    // Cross-browser CSS hack to allow inline editable fields to fill the entire space of their `td`. The
    // preferred long-term solution is to adopt a flexbox layout, but until then, please do extensive
    // cross-browser testing before you update this rule.
    height: '100%',
    position: 'relative'
});
const $28ce82260e13c14a$var$keyboardNavigationStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    ':focus': {
        outline: 'unset'
    },
    ':focus::before': {
        display: 'block',
        content: '" "',
        position: 'absolute',
        height: '100%',
        width: '100%',
        inset: '0px',
        borderColor: 'color.border.focused',
        borderWidth: '2px',
        borderStyle: 'solid',
        boxSizing: 'border-box'
    }
});
const $28ce82260e13c14a$var$defaultSpacingStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingLeft: 'space.100'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        paddingRight: 'space.100'
    }
});
const $28ce82260e13c14a$var$stickyStyles = (0, $8CUq3.xcss)({
    position: 'sticky'
});

});
parcelRegister("79UpA", function(module, exports) {

$parcel$export(module.exports, "useCellHoverCallbacks", () => $e9efda5efd0a7da8$export$793f17026bd5d1b4);
$parcel$export(module.exports, "CellHoverProvider", () => $e9efda5efd0a7da8$export$d427879c5002c548);
$parcel$export(module.exports, "useCellHoverHandlers", () => $e9efda5efd0a7da8$export$5ac0a932365e8caa);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iO5Z8 = parcelRequire("iO5Z8");
const $e9efda5efd0a7da8$export$7c2be23b3b8e5093 = 200;
const $e9efda5efd0a7da8$export$1e4bd5ddbd3e82e5 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $e9efda5efd0a7da8$var$onShowPopup = ({ contentRef: contentRef, onPopupToggle: onPopupToggle, shouldGetParentRef: shouldGetParentRef, analyticsEvent: analyticsEvent })=>{
    const elementWithTextContent = contentRef?.current ? (0, $iO5Z8.getClosestTextElement)(shouldGetParentRef ? contentRef?.current.parentElement : contentRef?.current) : undefined;
    const clientWidth = elementWithTextContent?.clientWidth || 0;
    const scrollWidth = elementWithTextContent?.scrollWidth || 0;
    const isClamped = (0, $iO5Z8.checkIsClamped)(elementWithTextContent);
    // If contentRef is not provided then the popover should always be visible on hover.
    if (!contentRef?.current || scrollWidth > clientWidth || isClamped) {
        if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'showHoverPopover');
        onPopupToggle(true);
    }
};
const $e9efda5efd0a7da8$export$793f17026bd5d1b4 = ({ contentRef: contentRef, onPreload: onPreload, onPopupToggle: onPopupToggle, onLoad: onLoad, shouldGetParentRef: shouldGetParentRef, onHoverOut: onHoverOut, onChangePopupState: onChangePopupState })=>{
    const handlers = (0, $5uXOq.useContext)($e9efda5efd0a7da8$export$1e4bd5ddbd3e82e5);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onHidePopup = (0, $5uXOq.useCallback)(()=>{
        onPopupToggle(false);
    }, [
        onPopupToggle
    ]);
    if (!handlers) return;
    if (handlers.onPreload) handlers.onPreload.current = onPreload || null;
    if (handlers.onLoad) handlers.onLoad.current = onLoad || null;
    if (handlers.onChangePopupState) handlers.onChangePopupState.current = onChangePopupState || null;
    handlers.onShowPopup.current = ()=>$e9efda5efd0a7da8$var$onShowPopup({
            contentRef: contentRef,
            onPopupToggle: onPopupToggle,
            shouldGetParentRef: shouldGetParentRef,
            analyticsEvent: createAnalyticsEvent({
                action: 'hover',
                actionSubject: 'table cell'
            })
        });
    handlers.onHidePopup.current = ()=>{
        onHidePopup();
        onHoverOut?.();
    };
};
const $e9efda5efd0a7da8$export$d427879c5002c548 = ({ children: children, delay: delay = $e9efda5efd0a7da8$export$7c2be23b3b8e5093 })=>{
    const hoverTimeoutRef = (0, $5uXOq.useRef)(null);
    const onPreloadRef = (0, $5uXOq.useRef)(null);
    const onLoadRef = (0, $5uXOq.useRef)(null);
    const onShowPopupRef = (0, $5uXOq.useRef)(null);
    const onHidePopupRef = (0, $5uXOq.useRef)(null);
    const onChangePopupStateRef = (0, $5uXOq.useRef)(null);
    const cleanUpTimeout = (0, $5uXOq.useCallback)(()=>{
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
    }, []);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        onPreloadRef.current?.();
        hoverTimeoutRef.current = setTimeout(()=>{
            onLoadRef.current?.();
            onShowPopupRef.current?.();
        }, delay);
    }, [
        delay
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        cleanUpTimeout();
        onHidePopupRef.current?.();
    }, [
        cleanUpTimeout
    ]);
    const handleToggle = (0, $5uXOq.useCallback)(()=>{
        onLoadRef.current?.();
        onChangePopupStateRef.current?.();
    }, []);
    const handers = (0, $5uXOq.useMemo)(()=>({
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            onPreload: onPreloadRef,
            onLoad: onLoadRef,
            onShowPopup: onShowPopupRef,
            onHidePopup: onHidePopupRef,
            handleToggle: handleToggle,
            onChangePopupState: onChangePopupStateRef
        }), [
        handleMouseEnter,
        handleMouseLeave,
        handleToggle
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return cleanUpTimeout;
    }, [
        cleanUpTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9efda5efd0a7da8$export$1e4bd5ddbd3e82e5.Provider, {
        value: handers
    }, children);
};
const $e9efda5efd0a7da8$export$5ac0a932365e8caa = ()=>{
    const handlers = (0, $5uXOq.useContext)($e9efda5efd0a7da8$export$1e4bd5ddbd3e82e5);
    if (handlers === null) throw new Error('useCellHoverHandlers must be used within a CellHoverProvider');
    return handlers;
};

});
parcelRegister("iO5Z8", function(module, exports) {

$parcel$export(module.exports, "getClosestTextElement", () => $6a3ea72a9b55286e$export$a4c1c84a8efc2153);
$parcel$export(module.exports, "checkIsClamped", () => $6a3ea72a9b55286e$export$63c32f0123c21b4d);
/**
 * Utility function to get the closest element that is truncated.
 * This is required since some components already have pre-existing refs set up or
 * do not allow refs to be set on those components.
 * If there is no element that is truncated, return the passed in element.
 * @param el
 * @returns
 */ const $6a3ea72a9b55286e$export$a4c1c84a8efc2153 = (el)=>{
    if (!el || !el.children || el.children.length === 0) return el;
    const elements = [
        el
    ];
    for (const e of elements){
        if (e.clientWidth !== e.scrollWidth) return e;
        for (const child of e.children)elements.push(child);
    }
    return el;
};
const $6a3ea72a9b55286e$export$63c32f0123c21b4d = (el)=>{
    if (!el) return false;
    if (!(el instanceof Element)) return false;
    const currentStyle = getComputedStyle(el);
    const lineClamp = parseInt(currentStyle.getPropertyValue('-webkit-line-clamp'), 10);
    if (lineClamp > 0 && currentStyle.getPropertyValue('overflow') === 'hidden') return el.scrollHeight > el.clientHeight;
    return false;
};

});


parcelRegister("lP0j5", function(module, exports) {

$parcel$export(module.exports, "useCellWrapper", () => $998e5de43f78cf72$export$1636c89afee55472);

var $5uXOq = parcelRequire("5uXOq");

var $gT660 = parcelRequire("gT660");
const $998e5de43f78cf72$var$TabbableSelector = `a[href],
	button,
	input:not([type="hidden"]),
	[tabindex]:not([tabindex="-1"])`;
const $998e5de43f78cf72$export$1636c89afee55472 = ({ row: row, col: col })=>{
    const cellRef = (0, $5uXOq.useRef)(null);
    const isCellNavEnabled = (0, $5uXOq.useRef)(false);
    const [isSelectedCell] = (0, $gT660.useIsSelectedCell)([
        row,
        col
    ]);
    const { setIsKeyboardNavOn: setIsKeyboardNavOn, setSelectedCell: setSelectedCell } = (0, $gT660.useCellNavigationActions)();
    const forEachTabbableElement = (0, $5uXOq.useCallback)((fn)=>{
        const elements = cellRef.current?.querySelectorAll($998e5de43f78cf72$var$TabbableSelector);
        if (elements) elements.forEach((element, index)=>{
            fn(element, index);
        });
    }, []);
    const enableTabbing = (0, $5uXOq.useCallback)(()=>forEachTabbableElement((element, index)=>{
            element.setAttribute('tabindex', '0');
            if (element instanceof HTMLElement && index === 0) element.focus();
        }), [
        forEachTabbableElement
    ]);
    const disableTabbing = (0, $5uXOq.useCallback)(()=>forEachTabbableElement((element)=>{
            element.setAttribute('tabindex', '-1');
        }), [
        forEachTabbableElement
    ]);
    const toggleCellNavigation = (0, $5uXOq.useCallback)((override)=>{
        if (typeof override === 'boolean') {
            isCellNavEnabled.current = override;
            setIsKeyboardNavOn(!override);
            override ? enableTabbing() : disableTabbing();
        } else if (isCellNavEnabled.current) {
            setIsKeyboardNavOn(true);
            isCellNavEnabled.current = false;
            disableTabbing();
        } else {
            setIsKeyboardNavOn(false);
            isCellNavEnabled.current = true;
            enableTabbing();
        }
    }, [
        disableTabbing,
        enableTabbing,
        setIsKeyboardNavOn
    ]);
    const moveSelectedCell = (0, $5uXOq.useCallback)((r, c)=>{
        if (isCellNavEnabled.current) {
            // we do not need to set focus because we are changing state
            setIsKeyboardNavOn(true);
            isCellNavEnabled.current = false;
            disableTabbing();
        }
        setSelectedCell(r, c);
    }, [
        disableTabbing,
        setIsKeyboardNavOn,
        setSelectedCell
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        switch(e.code){
            // Goes from grid to cell navigation
            case 'Enter':
                if (e.target === cellRef?.current) {
                    const elements = cellRef.current?.querySelectorAll($998e5de43f78cf72$var$TabbableSelector);
                    if (elements) {
                        // if this is readonly, pressing Enter does nothing
                        if (elements.length === 0) return;
                        e.preventDefault();
                        // if we have 1 tabbable link element, programmatically click that element
                        if (elements.length === 1 && elements[0] instanceof HTMLElement) {
                            elements[0].click();
                            // if the element has no popups, stay in grid navigation
                            if (elements[0].getAttribute('aria-haspopup') !== 'true') return;
                        }
                        toggleCellNavigation(true);
                    }
                }
                break;
            // Goes from cell to grid navigation
            case 'Escape':
                if (isCellNavEnabled.current) {
                    toggleCellNavigation(false);
                    cellRef.current?.focus();
                }
                // this cell could have moved row/cell, so we set selected cell to follow it
                setSelectedCell(row, col);
                break;
            // Trap tab keys in the cell
            case 'Tab':
                if (isCellNavEnabled.current && e.target instanceof Element && cellRef?.current?.contains(e.target)) {
                    const elements = cellRef.current?.querySelectorAll($998e5de43f78cf72$var$TabbableSelector);
                    const firstElement = elements[0];
                    const lastElement = elements[elements.length - 1];
                    let nextElement;
                    if (e.shiftKey && firstElement === e.target) nextElement = lastElement;
                    else if (!e.shiftKey && lastElement === e.target) nextElement = firstElement;
                    if (nextElement) {
                        e.preventDefault();
                        nextElement instanceof HTMLElement && nextElement.focus();
                    }
                }
                break;
            default:
        }
    }, [
        col,
        row,
        setSelectedCell,
        toggleCellNavigation
    ]);
    const onBlur = (0, $5uXOq.useCallback)((e)=>{
        if (e.relatedTarget == null) // if user has tabbed out of the page, disable tabs in cell again
        disableTabbing();
    }, [
        disableTabbing
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isCellNavEnabled.current) {
            setSelectedCell(row, col);
            const elements = cellRef.current?.querySelectorAll($998e5de43f78cf72$var$TabbableSelector);
            if (elements && elements.length > 0) {
                // handle when there is only 1 tabbable element in the cell and it has no pop-up, stay in grid nav
                if (elements.length === 1 && elements[0].getAttribute('aria-haspopup') !== 'true') return;
                toggleCellNavigation(true);
            }
        }
    }, [
        col,
        row,
        setSelectedCell,
        toggleCellNavigation
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // attach necessary event handlers here
        const cellRefCurrent = cellRef.current;
        cellRefCurrent?.addEventListener('keydown', onKeyDown);
        cellRefCurrent?.addEventListener('blur', onBlur);
        cellRefCurrent?.addEventListener('click', onClick);
        return ()=>{
            cellRefCurrent?.removeEventListener('keydown', onKeyDown);
            cellRefCurrent?.removeEventListener('blur', onBlur);
            cellRefCurrent?.removeEventListener('click', onClick);
        };
    }, [
        onBlur,
        onClick,
        onKeyDown
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isSelectedCell) {
            cellRef.current?.setAttribute('tabindex', '0');
            cellRef.current?.focus();
        } else cellRef.current?.setAttribute('tabindex', '-1');
    }, [
        isSelectedCell
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // programatically disabling tabbing in all tabbable elements of the cell
        disableTabbing();
    }, [
        disableTabbing
    ]);
    return {
        cellRef: cellRef,
        isSelected: isSelectedCell,
        disableTabbing: disableTabbing,
        toggleCellNavigation: toggleCellNavigation,
        setSelectedCell: setSelectedCell,
        moveSelectedCell: moveSelectedCell
    };
};

});


parcelRegister("dmE4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $f552c2d070c58af1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f552c2d070c58af1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showMore: {
        "id": "native-issue-table.common.load-more-items-row.show-more",
        "defaultMessage": "Show more"
    },
    loadingMoreItems: {
        "id": "native-issue-table.common.load-more-items-row.loading-more-items",
        "defaultMessage": "Loading more issues"
    },
    loadingMoreItemsIssueTermRefresh: {
        "id": "native-issue-table.common.load-more-items-row.loading-more-items-issue-term-refresh",
        "defaultMessage": "Loading more"
    }
});

});


parcelRegister("1CwmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $85233023a5e68cf6$export$2e2bcd8739ae039);

var $9Xwct = parcelRequire("9Xwct");

var $hgrWE = parcelRequire("hgrWE");

var $38ZNp = parcelRequire("38ZNp");

var $j01kn = parcelRequire("j01kn");

var $3OjGc = parcelRequire("3OjGc");

var $hyPxz = parcelRequire("hyPxz");

var $6sao6 = parcelRequire("6sao6");

var $bQfUQ = parcelRequire("bQfUQ");

var $2RSrC = parcelRequire("2RSrC");

var $dx3pf = parcelRequire("dx3pf");

var $lI1RI = parcelRequire("lI1RI");

var $cmsjV = parcelRequire("cmsjV");

var $iekGv = parcelRequire("iekGv");

var $bUYin = parcelRequire("bUYin");

var $1tnAA = parcelRequire("1tnAA");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $2S8IK = parcelRequire("2S8IK");

var $7mPT9 = parcelRequire("7mPT9");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $fc4cz = parcelRequire("fc4cz");

var $52ESs = parcelRequire("52ESs");

var $66CrF = parcelRequire("66CrF");

var $9CFBJ = parcelRequire("9CFBJ");

var $e9M6d = parcelRequire("e9M6d");

var $1JFgA = parcelRequire("1JFgA");

var $48rMm = parcelRequire("48rMm");

var $dSLRZ = parcelRequire("dSLRZ");

var $0147U = parcelRequire("0147U");

var $5DTiT = parcelRequire("5DTiT");

var $fiELF = parcelRequire("fiELF");

var $4kgUO = parcelRequire("4kgUO");

var $hBooe = parcelRequire("hBooe");

var $lMLWW = parcelRequire("lMLWW");
const $85233023a5e68cf6$var$RowWithSiblingCreate = (props)=>{
    const { itemsConnectionId: itemsConnectionId, rowIndex: rowIndex, parentIssueAri: parentIssueAri } = props;
    const issueRowDataOld = (0, $8Uumt.useFragment)((0, $1tnAA.default), props.issue);
    const issueRowEdgeData = (0, $8Uumt.useFragment)((0, $bUYin.default), props.issueEdge);
    const issueRowData = (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? issueRowEdgeData?.node : issueRowDataOld;
    const fieldSetsData = (0, $8Uumt.useFragment)((0, $iekGv.default), props.fieldSets);
    const { onMouseLeave: onMouseLeave, onMouseMove: onMouseMove } = (0, $dSLRZ.useSiblingIssueCreateHandler)(itemsConnectionId, rowIndex);
    const projectContext = (0, $e9M6d.useProjectContext)();
    const { isFormVisible: isFormVisible, formProps: formProps, triggerProps: triggerProps } = (0, $2S8IK.useInlineCreateHandlers)({
        projectKey: projectContext,
        minHierarchyLevel: 0
    });
    const issueCreateRowContext = (0, $5uXOq.useMemo)(()=>({
            isFormVisible: isFormVisible,
            triggerProps: triggerProps
        }), [
        isFormVisible,
        triggerProps
    ]);
    const issueCreateRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBooe.IssueCreateRow), {
        depth: 0,
        isFormVisible: isFormVisible,
        issuesConnectionId: itemsConnectionId,
        siblingIssueId: issueRowData?.id ?? '',
        parentIssueAri: parentIssueAri,
        ...formProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dSLRZ.SiblingIssueCreateRowContext).Provider, {
        value: issueCreateRowContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85233023a5e68cf6$var$MaybeRowWithDragAndDrop, {
        ...props,
        issue: issueRowDataOld ?? null,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        beforeRow: issueCreateRow
    }));
};
const $85233023a5e68cf6$var$RowWithDragAndDrop = (props)=>{
    const issueRowDataOld = (0, $8Uumt.useFragment)((0, $cmsjV.default), props.issue);
    const issueRowEdgeData = (0, $8Uumt.useFragment)((0, $lI1RI.default), props.issueEdge);
    const fieldSetsData = (0, $8Uumt.useFragment)((0, $dx3pf.default), props.fieldSets);
    const issueRowData = (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? issueRowEdgeData?.node : issueRowDataOld;
    const draggableRef = (0, $66CrF.useDraggableRow)({
        edgeIndex: props.rowIndex,
        issueId: issueRowData?.id ?? '',
        hierarchyLevel: props.hierarchyLevel,
        parentIssueAri: props.parentIssueAri,
        parentIssueEdgeRelayId: props.parentItemConnectionId,
        parentIssueConnectionId: props.parentIssueRelayConnectionId,
        issueEdgeRelayId: issueRowEdgeData?.__id,
        depth: props.depth,
        itemsConnectionId: props.itemsConnectionId,
        projectKey: props.projectKey,
        hasChildren: Boolean(issueRowEdgeData?.hasChildren)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85233023a5e68cf6$var$MaybeMemoRowInner, {
        ...props,
        issue: issueRowDataOld ?? null,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        ref: draggableRef
    });
};
const $85233023a5e68cf6$var$MaybeRowWithDragAndDrop = (props)=>{
    const isDragAndDropEnabled = (0, $e9M6d.useIsDragAndDropEnabled)();
    const issueRowDataOld = (0, $8Uumt.useFragment)((0, $2RSrC.default), props.issue);
    const issueRowEdgeData = (0, $8Uumt.useFragment)((0, $bQfUQ.default), props.issueEdge);
    const fieldSetsData = (0, $8Uumt.useFragment)((0, $6sao6.default), props.fieldSets);
    if (isDragAndDropEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85233023a5e68cf6$var$RowWithDragAndDrop, {
        ...props,
        issue: issueRowDataOld ?? null,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85233023a5e68cf6$var$MaybeMemoRowInner, {
        ...props,
        issue: issueRowDataOld ?? null,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null
    });
};
const $85233023a5e68cf6$var$RowInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
    const { rowIndex: rowIndex, issue: issue, issueEdge: issueEdge, fieldSets: fieldSets, itemsConnectionId: itemsConnectionId, depth: depth, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, beforeRow: beforeRow, triggerProps: triggerProps, isFormVisible: isFormVisible, parentIssueAri: parentIssueAri, parentIssueRelayConnectionId: parentIssueRelayConnectionId, measureElement: measureElement = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), hierarchyLevel: hierarchyLevel, issueKey: issueKey, projectKey: projectKey } = props;
    const tableRowRef = (0, $5uXOq.useRef)(null);
    const { groupId: groupId } = (0, $5DTiT.useRowContext)();
    const issueRowDataOld = (0, $8Uumt.useFragment)((0, $hyPxz.default), issue);
    const issueRowEdgeData = (0, $8Uumt.useFragment)((0, $3OjGc.default), issueEdge);
    const issueRowData = (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? issueRowEdgeData?.node : issueRowDataOld;
    const fieldSetsData = (0, $8Uumt.useFragment)((0, $j01kn.default), fieldSets);
    const itemDetails = (0, $5uXOq.useMemo)(()=>issueRowData ? {
            itemsConnectionId: itemsConnectionId,
            itemId: issueRowData.issueId,
            groupId: groupId
        } : null, [
        issueRowData,
        itemsConnectionId,
        groupId
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    const list = (0, $4R6GH.fg)('nin-grid-keyboard-navigation') ? (0, $fc4cz.useFlatList)() : [];
    const [isSelected, { setSelectedRow: setSelectedRow }] = (0, $1JFgA.useIsSelected)(itemDetails, {
        selectedRowIndex: rowIndex
    });
    const prevIsSelected = (0, $1XJ20.usePreviousWithInitial)(isSelected);
    const [isFocused, { resetFocus: resetFocus }] = (0, $1JFgA.useIsFocused)(itemDetails, {
        selectedRowIndex: rowIndex
    });
    const [isRowHovered, setIsRowHovered] = (0, $5uXOq.useState)(false);
    const isDragAndDropEnabled = (0, $e9M6d.useIsDragAndDropEnabled)();
    const isReParentingEnabled = (0, $e9M6d.useIsReparentingEnabled)();
    const [currentDraggingRow, setCurrentDraggingRow] = (0, $5uXOq.useState)(null);
    const isScrolling = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>scrollState.isScrolling);
    const isEntireRowDraggable = (0, $e9M6d.useIsEntireRowDraggable)();
    const isIssueSelected = (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $48rMm.useIsIssueSelected)(issueRowData?.issueId ?? '') : false;
    (0, $5uXOq.useEffect)(()=>{
        // Explicitly reset our internal state to track which row is focused. We do this to prevent the DOM element being re-focused unintentionally when the component is re-rendered.
        if (isFocused) resetFocus();
    }, [
        isFocused,
        resetFocus
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    let isIssueHierarchyEnabled = false;
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isIssueHierarchyEnabled = (0, $e9M6d.useIsIssueHierarchyEnabled)();
    const onMouseOverHandler = (0, $5uXOq.useCallback)(()=>{
        if (!isScrolling && (isIssueHierarchyEnabled && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') || isDragAndDropEnabled)) setIsRowHovered(true);
    }, [
        isDragAndDropEnabled,
        isIssueHierarchyEnabled,
        isScrolling,
        setIsRowHovered
    ]);
    const onMouseLeaveHandler = (0, $5uXOq.useCallback)((e)=>{
        onMouseLeave?.(e);
        if (isIssueHierarchyEnabled && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') || isDragAndDropEnabled) setIsRowHovered(false);
    }, [
        isDragAndDropEnabled,
        isIssueHierarchyEnabled,
        onMouseLeave,
        setIsRowHovered
    ]);
    const focusCurrentRow = (0, $5uXOq.useCallback)(()=>{
        return setSelectedRow(// The method below has a different signature compared to the old implementation which leads to this type error which is not trivial to solve
        // @ts-expect-error - TS2345: Argument of type '[number | { itemsConnectionId: string; itemId: string; }]' is not assignable to parameter of type '{ itemsConnectionId: string; itemId: string; } & number'
        (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? itemDetails : rowIndex);
    }, [
        setSelectedRow,
        itemDetails,
        rowIndex
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const clickAnalytics = createAnalyticsEvent({});
        const actionSubjectId = issueRowData ? 'issueRow' : 'blankRow';
        (0, $8zOmE.fireUIAnalytics)(clickAnalytics, 'rowItem clicked', actionSubjectId);
    }, [
        createAnalyticsEvent,
        issueRowData
    ]);
    const isColumnBordersEnabled = (0, $e9M6d.useIsColumnBordersEnabled)();
    const isGrouping = !!groupId && (0, $6s1PB.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false);
    const cellBorder = (0, $5uXOq.useMemo)(()=>[
            isColumnBordersEnabled ? $85233023a5e68cf6$var$cellBorderStyles : $85233023a5e68cf6$var$cellBorderStylesWithNoColumn,
            rowIndex === 0 && !parentIssueAri && !isGrouping && $85233023a5e68cf6$var$firstRowCellBorderStyles
        ], [
        parentIssueAri,
        rowIndex,
        isColumnBordersEnabled,
        isGrouping
    ]); // when cleaning up jsc_m2_hierarchy_fe_changes, replace issueRowDataOld with issueRowEdgeData, and ensure it is a required property
    const rowContent = issueRowDataOld ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lMLWW.IssueRow), {
        issue: issueRowDataOld,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        cellBorder: cellBorder,
        beforeFirstCell: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiELF.BeforeFirstCell), {
            edgeIndex: rowIndex,
            issueId: issueRowDataOld.id,
            itemsConnectionId: itemsConnectionId,
            hierarchyLevel: hierarchyLevel,
            parentIssueAri: parentIssueAri,
            parentIssueConnectionId: parentIssueRelayConnectionId,
            issueKey: issueKey,
            projectKey: projectKey,
            ...isDragAndDropEnabled ? {
                isRowHovered: isRowHovered
            } : {},
            ...isReParentingEnabled ? {
                issueRowData: issueRowEdgeData?.node || null,
                setCurrentDraggingRow: setCurrentDraggingRow
            } : {
                issueRowData: null
            }
        }),
        itemsConnectionId: itemsConnectionId,
        depth: depth,
        isRowHoveredOrSelected: isFocused || isSelected || isRowHovered,
        ...((0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) || (0, $4R6GH.fg)('jira_list_grid_pattern_keyboard_nav')) && {
            rowIndex: rowIndex
        },
        triggerProps: triggerProps,
        isFormVisible: isFormVisible
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4kgUO.default), {
        isSelected: isSelected,
        cellBorder: cellBorder
    }); /**
                                                                                                                                        * Only scroll table row into view when it's a _newly_ selected row.
                                                                                                                                        *
                                                                                                                                        * We keep track of the prev selected state to avoid jumping to the selected row on mount. This issue
                                                                                                                                        * was introduced when we enabled virtualization as part of the infinite scroll work.
                                                                                                                                        * @see https://getsupport.atlassian.com/browse/PCS-359806
                                                                                                                                        */ 
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (isSelected && isSelected !== prevIsSelected) tableRowRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        isSelected,
        prevIsSelected
    ]);
    const highlightFadeOut = (0, $5uXOq.useRef)(false);
    const onInterceptionItemRef = (0, $0147U.useObserveItem)(issueRowData?.id);
    let trRef = (0, $7mPT9.default)(onInterceptionItemRef, tableRowRef, forwardedRef);
    const isHighlighted = issueRowData?.isHighlightedIssueRow ?? false;
    const prevIsHighlighted = (0, $1XJ20.usePrevious)(isHighlighted); // Begin fade out animation when isHighlighted changes to false
    if (prevIsHighlighted && !isHighlighted) highlightFadeOut.current = true;
    trRef = (0, $7mPT9.default)(trRef, measureElement);
    let itemKey = null;
    if (itemsConnectionId && issueRowData?.id) itemKey = (0, $fc4cz.getItemKey)(itemsConnectionId, issueRowData.id);
    const overallRowIndex = itemDetails && (0, $4R6GH.fg)('nin-grid-keyboard-navigation') ? list.indexOf((0, $52ESs.getFlatListKey)(itemDetails)) + 1 : -1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, beforeRow, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "native-issue-table.ui.issue-row",
        "aria-selected": isSelected,
        ...overallRowIndex > 0 && (0, $4R6GH.fg)('nin-grid-keyboard-navigation') && {
            'aria-rowindex': overallRowIndex
        },
        role: "row",
        onAnimationEnd: ()=>{
            /*
      	Animation set using @compiled may be inadvertently started when the scripting engine applies
      	new styles (e.g. after a new issue row is appended). We need to set the animation duration
      	to 0s once the animation has completed to prevent the animation restarting.
      	See https://drafts.csswg.org/css-animations-1/#animations
      	 */ if (tableRowRef.current) tableRowRef.current.style.animationDuration = '0s';
        },
        onFocus: focusCurrentRow,
        onClick: onClick,
        onMouseOver: onMouseOverHandler,
        onMouseMove: onMouseMove,
        onMouseLeave: onMouseLeaveHandler,
        tabIndex: -1,
        'data-index': rowIndex,
        ref: trRef,
        "data-vc": `issue-row${false ? '-ssr' : ''}`,
        ...false && (0, $4R6GH.fg)('additional_nin_ssr_placeholders') && {
            'data-ssr-placeholder': 'issue-row-placeholder'
        },
        ...!false && (0, $4R6GH.fg)('additional_nin_ssr_placeholders') && {
            'data-ssr-placeholder-replace': 'issue-row-placeholder'
        },
        className: (0, $bwpsq.default)([
            "_4t3i1ylp _kqswh2mm _bfhkvuon _nt751r31 _49pcglyw _1hvw1o36 _7psyru3m _irr3108i",
            (0, $4R6GH.fg)('nin-grid-keyboard-navigation') && "_qj5iru3m _10j7fg4m _1p0pi1yw",
            highlightFadeOut.current && "",
            highlightFadeOut.current && "_j7hqwkqb _5sagymdr _1pgl6ui8",
            isSelected && !(0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) && "_5sagru3m _bfhkfg4m _irr3fg4m",
            (isSelected && !(0, $4R6GH.fg)('nin-grid-keyboard-navigation') || isIssueSelected) && (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) && "_5sagru3m _bfhkfg4m _irr3i1yw",
            isHighlighted && "_bfhkavxe",
            isEntireRowDraggable && "_80om1qgj _1qam5szm",
            currentDraggingRow !== null && currentDraggingRow === itemKey && (0, $4R6GH.fg)('jsc_list_reparenting') && "_tzy41ou4"
        ])
    }, rowContent));
});
const $85233023a5e68cf6$var$MaybeMemoRowInner = /*#__PURE__*/ (0, $5uXOq.memo)($85233023a5e68cf6$var$RowInner);
const $85233023a5e68cf6$var$Row = (props)=>{
    const issueRowData = (0, $8Uumt.useFragment)((0, $38ZNp.default), props.issue);
    const issueRowEdgeData = (0, $8Uumt.useFragment)((0, $hgrWE.default), props.issueEdge);
    const fieldSetsData = (0, $8Uumt.useFragment)((0, $9Xwct.default), props.fieldSets);
    const isSiblingIssueCreateEnabled = (0, $e9M6d.useIsSiblingIssueCreateEnabled)();
    if (isSiblingIssueCreateEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85233023a5e68cf6$var$RowWithSiblingCreate, {
        ...props,
        issue: issueRowData ?? null,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85233023a5e68cf6$var$MaybeRowWithDragAndDrop, {
        ...props,
        issue: issueRowData ?? null,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null
    });
};
var $85233023a5e68cf6$export$2e2bcd8739ae039 = $85233023a5e68cf6$var$Row;
const $85233023a5e68cf6$var$ROW_HEIGHT = 40;
const $85233023a5e68cf6$var$cellBorderStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTopWidth: 'border.width',
    borderBottomWidth: '0',
    borderLeftWidth: '0',
    borderRightWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderRightWidth: '0'
    }
});
const $85233023a5e68cf6$var$cellBorderStylesWithNoColumn = (0, $8CUq3.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTopWidth: 'border.width',
    borderBottomWidth: '0',
    borderLeftWidth: '0',
    borderRightWidth: '0'
});
const $85233023a5e68cf6$var$firstRowCellBorderStyles = (0, $8CUq3.xcss)({
    borderTopWidth: '0'
});
const $85233023a5e68cf6$var$fadeOut = null;
const $85233023a5e68cf6$var$rowStyles = null;
const $85233023a5e68cf6$var$rowStylesKeyborabNavigation = null;
const $85233023a5e68cf6$var$draggableRowStyles = null;
const $85233023a5e68cf6$var$activeRowStylesOld = null;
const $85233023a5e68cf6$var$activeRowStyles = null;
const $85233023a5e68cf6$var$highlightRowStyles = null;
const $85233023a5e68cf6$var$draggingRowStyles = null;
const $85233023a5e68cf6$var$highlightFadeOutStyles = null;

});
parcelRegister("9Xwct", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2166c8da065c184$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d4db416a19f6fb4f58d2279bfea0b91>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e2166c8da065c184$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_fieldSets",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowInner_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithSiblingCreate_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithDragAndDrop_fieldSets"
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$e2166c8da065c184$var$node.hash = "aeef3b235285f8ee145e31705e01ca9f";
var $e2166c8da065c184$export$2e2bcd8739ae039 = $e2166c8da065c184$var$node;

});

parcelRegister("hgrWE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec85f186db0208de$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00f946809db670ca340ae425df4e2590>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ec85f186db0208de$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isReparentingEnabled",
            "variableName": "isReparentingEnabled"
        },
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        },
        {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKeys"
        },
        {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_issueEdge",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowInner_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithSiblingCreate_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithDragAndDrop_issueEdge"
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    }
                ]
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$ec85f186db0208de$var$node.hash = "47429bdfc5af03f5d63ca636fbdd2557";
var $ec85f186db0208de$export$2e2bcd8739ae039 = $ec85f186db0208de$var$node;

});

parcelRegister("38ZNp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c75e447c25d153e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<73f64d6bbc7e03fab4a20dcf3e112eff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6c75e447c25d153e$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_issue",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowInner_issue"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithSiblingCreate_issue"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_issue"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithDragAndDrop_issue"
            }
        ],
        "type": "JiraIssue"
    };
}();
$6c75e447c25d153e$var$node.hash = "4859b1b0140c4d135bcce90e54a15277";
var $6c75e447c25d153e$export$2e2bcd8739ae039 = $6c75e447c25d153e$var$node;

});

parcelRegister("j01kn", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e11e4e4c54a7b72$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<296609b60b4a4daf51b5572d7c0ce9ff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6e11e4e4c54a7b72$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowInner_fieldSets",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$6e11e4e4c54a7b72$var$node.hash = "2d2a16ac06342f4e00560f32f837ce90";
var $6e11e4e4c54a7b72$export$2e2bcd8739ae039 = $6e11e4e4c54a7b72$var$node;

});

parcelRegister("3OjGc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3564504a05d69cd7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<50d1a3186385343e93273e55cabee208>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3564504a05d69cd7$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowInner_issueEdge",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_issueEdge"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isReparentingEnabled",
                            "variableName": "isReparentingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "beforeFirstCell_nativeIssueTable"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isHighlightedIssueRow"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$3564504a05d69cd7$var$node.hash = "4f79d837150c5a57231d1f7399de095b";
var $3564504a05d69cd7$export$2e2bcd8739ae039 = $3564504a05d69cd7$var$node;

});

parcelRegister("hyPxz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1807bfb81be1bfe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a44ca5ffb48c8562c2b3a2b60023329>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e1807bfb81be1bfe$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowInner_issue",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_issue"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "issueId"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isHighlightedIssueRow"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$e1807bfb81be1bfe$var$node.hash = "a1246f8e77527118a6cf551f87d4b343";
var $e1807bfb81be1bfe$export$2e2bcd8739ae039 = $e1807bfb81be1bfe$var$node;

});

parcelRegister("6sao6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fa6dbb7931212f7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2712d319b7cda0f164e33dcd4c6f421c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0fa6dbb7931212f7$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_fieldSets",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowInner_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithDragAndDrop_fieldSets"
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$0fa6dbb7931212f7$var$node.hash = "2df10ad608b4032fdba30e652192059f";
var $0fa6dbb7931212f7$export$2e2bcd8739ae039 = $0fa6dbb7931212f7$var$node;

});

parcelRegister("bQfUQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51b773168abf4ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f98fe0da0290d93372f146e646472b13>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a51b773168abf4ad$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isReparentingEnabled",
            "variableName": "isReparentingEnabled"
        },
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        },
        {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKeys"
        },
        {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_issueEdge",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowInner_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithDragAndDrop_issueEdge"
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    }
                ]
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$a51b773168abf4ad$var$node.hash = "b7bc74fbfe4cf047632031716ff96362";
var $a51b773168abf4ad$export$2e2bcd8739ae039 = $a51b773168abf4ad$var$node;

});

parcelRegister("2RSrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $35fd6a36b48c1638$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<10e81eed51f30b85a0177f0bea5a09b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $35fd6a36b48c1638$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_issue",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowInner_issue"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "row_nativeIssueTable_RowWithDragAndDrop_issue"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraIssue"
    };
}();
$35fd6a36b48c1638$var$node.hash = "f61ddf6ed119305422968d6c9b8a484c";
var $35fd6a36b48c1638$export$2e2bcd8739ae039 = $35fd6a36b48c1638$var$node;

});

parcelRegister("dx3pf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e6e3226b0ba2f3c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cf35f6bfca3e21a79e68e7f14b7d8f17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1e6e3226b0ba2f3c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithDragAndDrop_fieldSets",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_RowInner_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$1e6e3226b0ba2f3c$var$node.hash = "e4a29721eef57f256f5fd661e73e9d0c";
var $1e6e3226b0ba2f3c$export$2e2bcd8739ae039 = $1e6e3226b0ba2f3c$var$node;

});

parcelRegister("lI1RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2a5a407d33a898c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dba6d19744e011b82f79de29c5e14ecc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c2a5a407d33a898c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithDragAndDrop_issueEdge",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_RowInner_issueEdge"
        },
        {
            "condition": "shouldQueryHasChildren",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filterByProjectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "hasChildren"
                }
            ]
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$c2a5a407d33a898c$var$node.hash = "fbea99a7c3ea13c8ffa4931b74337e02";
var $c2a5a407d33a898c$export$2e2bcd8739ae039 = $c2a5a407d33a898c$var$node;

});

parcelRegister("cmsjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $969d6092dac1049d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b1bb6a63385f06f588dfb6b8ce56da0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $969d6092dac1049d$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithDragAndDrop_issue",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_RowInner_issue"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ],
    "type": "JiraIssue"
};
$969d6092dac1049d$var$node.hash = "759d5632678e2a4b7255397b832654e6";
var $969d6092dac1049d$export$2e2bcd8739ae039 = $969d6092dac1049d$var$node;

});

parcelRegister("iekGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1d07fe601dc74cb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<497ecb1b18092a8ed89fc8ca76ab5933>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c1d07fe601dc74cb$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithSiblingCreate_fieldSets",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$c1d07fe601dc74cb$var$node.hash = "87ffe72235de098d0c77b063161d05e1";
var $c1d07fe601dc74cb$export$2e2bcd8739ae039 = $c1d07fe601dc74cb$var$node;

});

parcelRegister("bUYin", function(module, exports) {

$parcel$export(module.exports, "default", () => $99802ba452b61d85$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b41c32994c435331b250ce449fc44634>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $99802ba452b61d85$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithSiblingCreate_issueEdge",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_issueEdge"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$99802ba452b61d85$var$node.hash = "0d2dd8ff9005b8953147938127c7b8d3";
var $99802ba452b61d85$export$2e2bcd8739ae039 = $99802ba452b61d85$var$node;

});

parcelRegister("1tnAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $505f9b3de4a7b349$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6dcc61bfdd5c42f253dda5a7711e84ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $505f9b3de4a7b349$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable_RowWithSiblingCreate_issue",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_issue"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ],
    "type": "JiraIssue"
};
$505f9b3de4a7b349$var$node.hash = "ba623de7122344bfc84f16b75828ccda";
var $505f9b3de4a7b349$export$2e2bcd8739ae039 = $505f9b3de4a7b349$var$node;

});

parcelRegister("66CrF", function(module, exports) {

$parcel$export(module.exports, "EXTRA_SPACE_PER_LEVEL", () => $4dfb30913fde1ed0$export$107c825dc66c95b7);
$parcel$export(module.exports, "useDraggableRows", () => $4dfb30913fde1ed0$export$1e4d2f7e506c2b7d);
$parcel$export(module.exports, "useDraggableRow", () => $4dfb30913fde1ed0$export$a878804271d34ba8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $biEfA = parcelRequire("biEfA");

var $4hDdm = parcelRequire("4hDdm");

var $f3lfW = parcelRequire("f3lfW");

var $9EGGH = parcelRequire("9EGGH");

var $7gWdR = parcelRequire("7gWdR");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");

var $jUlV7 = parcelRequire("jUlV7");
var $2RKeg = parcelRequire("2RKeg");

var $koeKL = parcelRequire("koeKL");

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $czfFt = parcelRequire("czfFt");

var $e9M6d = parcelRequire("e9M6d");

var $7bewW = parcelRequire("7bewW");

var $4pPXb = parcelRequire("4pPXb");

var $3I8L4 = parcelRequire("3I8L4");

var $4iDVJ = parcelRequire("4iDVJ");
const $4dfb30913fde1ed0$var$INDENT_PER_LEVEL = 42;
const $4dfb30913fde1ed0$export$107c825dc66c95b7 = 4;
const $4dfb30913fde1ed0$var$ATTACH_INSTRUCTION_MODE = 'standard';
const $4dfb30913fde1ed0$var$SUPPORTED_TYPES = new Set([
    (0, $czfFt.MAKE_CHILD),
    (0, $czfFt.REORDER_ABOVE),
    (0, $czfFt.REORDER_BELOW)
]);
const $4dfb30913fde1ed0$export$1e4d2f7e506c2b7d = (0, $3sQ5x.createHook)((0, $3I8L4.Store));
const $4dfb30913fde1ed0$var$isDraggableRowData = (data)=>data != null && typeof data === 'object' && 'operation' in data && data.operation === (0, $czfFt.ROW_OPERATION_REORDER);
const $4dfb30913fde1ed0$export$a878804271d34ba8 = (props)=>{
    const { edgeIndex: edgeIndex, issueId: issueId, hierarchyLevel: hierarchyLevel, parentIssueAri: parentIssueAri, parentIssueEdgeRelayId: parentIssueEdgeRelayId, parentIssueConnectionId: parentIssueConnectionId, issueEdgeRelayId: issueEdgeRelayId } = props;
    const isRowReorderingEnabled = (0, $e9M6d.useIsRowReorderingEnabled)();
    const isEntireRowDraggable = (0, $e9M6d.useIsEntireRowDraggable)();
    const isReParentingEnabled = (0, $e9M6d.useIsReparentingEnabled)();
    const isDragAndDropEnabled = (0, $e9M6d.useIsDragAndDropEnabled)();
    let isIssueRankingEnabled = false;
    let issueRank;
    let getBlockedInstructions = (0, $4iDVJ.getBlockedInstructionsOld);
    if ((0, $4R6GH.fg)('jsc_list_reranking_gate_technical')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isIssueRankingEnabled = (0, $e9M6d.useIsIssueRankingEnabled)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        issueRank = (0, $4pPXb.useIssuesRanker)();
    }
    if ((0, $4R6GH.fg)('jsc_list_reranking_gate')) getBlockedInstructions = (0, $4iDVJ.getBlockedInstructions);
    const [{ instanceId: instanceId, onRowReorder: onRowReorderHandler }, { registerItem: registerItem, setDropTarget: setDropTarget, unregisterItem: unregisterItem }] = $4dfb30913fde1ed0$export$1e4d2f7e506c2b7d();
    let reparent = null;
    if ((0, $4R6GH.fg)('jsc_list_reparenting')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ reparent: reparent } = (0, $7bewW.useUpdateParent)());
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // TODO: https://jbusiness.atlassian.net/browse/JSC-2065 - Unify the row reordering from CHIN with issue table
    const onRowReorder = isIssueRankingEnabled ? issueRank : onRowReorderHandler;
    const cleanupFnRef = (0, $5uXOq.useRef)(null);
    const attachDraggableElement = (0, $5uXOq.useCallback)((rowElement)=>isEntireRowDraggable ? (0, $7gWdR.draggable)({
            element: rowElement,
            getInitialData () {
                return {
                    operation: (0, $czfFt.ROW_OPERATION_REORDER),
                    instanceId: instanceId,
                    issueId: issueId,
                    hierarchyLevel: hierarchyLevel,
                    parentIssueAri: parentIssueAri,
                    parentIssueEdgeRelayId: parentIssueEdgeRelayId,
                    parentIssueConnectionId: parentIssueConnectionId,
                    issueEdgeRelayId: issueEdgeRelayId,
                    rowIndex: edgeIndex,
                    itemsConnectionId: props.itemsConnectionId
                };
            },
            onDragStart () {
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dragged',
                    actionSubject: 'useDraggableRow',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            },
            onDrop () {
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dropped',
                    actionSubject: 'useDraggableRow',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            }
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), [
        isEntireRowDraggable,
        instanceId,
        issueId,
        hierarchyLevel,
        parentIssueAri,
        parentIssueEdgeRelayId,
        parentIssueConnectionId,
        issueEdgeRelayId,
        edgeIndex,
        props.itemsConnectionId,
        createAnalyticsEvent
    ]);
    const attachDropTargetElement = (0, $5uXOq.useCallback)((rowElement)=>(0, $7gWdR.dropTargetForElements)({
            element: rowElement,
            canDrop ({ source: source }) {
                if ((0, $4R6GH.fg)('jsc_list_reranking_gate_technical')) return source.data.operation === (0, $czfFt.ROW_OPERATION_REORDER) && source.data.issueId !== issueId;
                return source.data.operation === (0, $czfFt.ROW_OPERATION_REORDER) && source.data.instanceId === instanceId && source.data.issueId !== issueId;
            },
            getData ({ input: input, element: element, source: source }) {
                const data = {
                    operation: (0, $czfFt.ROW_OPERATION_REORDER),
                    instanceId: instanceId,
                    issueId: issueId,
                    parentIssueAri: parentIssueAri,
                    parentIssueConnectionId: parentIssueConnectionId,
                    issueEdgeRelayId: issueEdgeRelayId,
                    parentIssueEdgeRelayId: parentIssueEdgeRelayId,
                    rowIndex: edgeIndex,
                    itemsConnectionId: props.itemsConnectionId,
                    hasChildren: Boolean(props.hasChildren)
                };
                if ((0, $4R6GH.fg)('jsc_list_reparenting')) {
                    const blockedInstructions = $4dfb30913fde1ed0$var$isDraggableRowData(source.data) ? getBlockedInstructions({
                        dropTarget: {
                            ...data,
                            ...props
                        },
                        draggedItem: source.data,
                        isRowReorderingEnabled: isRowReorderingEnabled,
                        isIssueRankingEnabled: isIssueRankingEnabled
                    }) : [
                        (0, $czfFt.MAKE_CHILD),
                        (0, $czfFt.REORDER_BELOW),
                        (0, $czfFt.REORDER_BELOW)
                    ];
                    return (0, $f3lfW.attachInstruction)(data, {
                        input: input,
                        element: element,
                        mode: $4dfb30913fde1ed0$var$ATTACH_INSTRUCTION_MODE,
                        indentPerLevel: // adjust the drop indicator position based on the depth of the item
                        !props.depth || props.depth < 2 ? $4dfb30913fde1ed0$var$INDENT_PER_LEVEL : $4dfb30913fde1ed0$var$INDENT_PER_LEVEL - props.depth * $4dfb30913fde1ed0$export$107c825dc66c95b7,
                        currentLevel: props.depth || 0,
                        block: blockedInstructions
                    });
                }
                return (0, $biEfA.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            onDrag ({ self: self, source: source }) {
                // Don't set drop edge if source target is the same as this row instance
                if (issueId === source.data.issueId) return;
                if ((0, $4R6GH.fg)('jsc_list_reparenting')) {
                    const extractedInstruction = (0, $f3lfW.extractInstruction)(self.data);
                    extractedInstruction && setDropTarget({
                        issueId: issueId,
                        dropInstruction: extractedInstruction
                    });
                    return;
                }
                const closestEdge = (0, $biEfA.extractClosestEdge)(self.data);
                closestEdge && setDropTarget({
                    issueId: issueId,
                    dropEdge: closestEdge
                });
            },
            onDragLeave () {
                setDropTarget(null);
            },
            onDrop ({ source: source, location: location }) {
                const [destination] = location.current.dropTargets;
                setDropTarget(null);
                if (!$4dfb30913fde1ed0$var$isDraggableRowData(source.data) || !$4dfb30913fde1ed0$var$isDraggableRowData(destination?.data)) return;
                let closestEdgeOfTarget;
                let extractedInstruction;
                if ((0, $4R6GH.fg)('jsc_list_reparenting')) {
                    extractedInstruction = (0, $f3lfW.extractInstruction)(destination.data);
                    closestEdgeOfTarget = extractedInstruction?.type === (0, $czfFt.REORDER_ABOVE) ? 'top' : 'bottom';
                } else closestEdgeOfTarget = (0, $biEfA.extractClosestEdge)(destination.data);
                const dragItemParent = source.data?.parentIssueAri;
                const dropTargetParent = props?.parentIssueAri;
                const isWithinSameParent = dragItemParent === dropTargetParent;
                // We are dropping at specific edge but not changing parent, meaning only reranking
                const isRerankingOnly = (extractedInstruction?.type === (0, $czfFt.REORDER_ABOVE) || extractedInstruction?.type === (0, $czfFt.REORDER_BELOW)) && isWithinSameParent;
                const shouldRerank = (0, $4R6GH.fg)('jsc_list_reranking_gate') ? isRerankingOnly && (isRowReorderingEnabled || isIssueRankingEnabled) : isRowReorderingEnabled;
                const shouldReparent = (0, $4R6GH.fg)('jsc_list_reranking_gate') ? !isRerankingOnly && isReParentingEnabled : isReParentingEnabled;
                if (shouldRerank) {
                    if (!closestEdgeOfTarget) return;
                    const startIndex = source.data.rowIndex;
                    const finishIndex = (0, $9EGGH.getReorderDestinationIndex)({
                        axis: 'vertical',
                        closestEdgeOfTarget: closestEdgeOfTarget,
                        startIndex: startIndex,
                        indexOfTarget: destination.data.rowIndex
                    });
                    if (startIndex === finishIndex) return;
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'updatedRanking',
                        actionSubject: 'dragActionsButton',
                        actionSubjectId: 'jscDraggableIssue'
                    }));
                    onRowReorder?.({
                        source: {
                            issueIds: [
                                source.data.issueId
                            ],
                            rowIndex: startIndex
                        },
                        destination: {
                            relativeToIssueId: destination.data.issueId,
                            rowIndex: finishIndex
                        },
                        edge: closestEdgeOfTarget
                    });
                }
                if (shouldReparent) {
                    if (extractedInstruction && $4dfb30913fde1ed0$var$SUPPORTED_TYPES.has(extractedInstruction.type)) {
                        const issueIdToReparent = (0, $jUlV7.JiraIssueAri).parse(source.data.issueId).issueId;
                        const issueFieldAriToReparent = (0, $2RKeg.JiraIssuefieldvalueAri).create({
                            siteId: cloudId,
                            issueId: issueIdToReparent,
                            fieldId: (0, $5fc53.PARENT_TYPE)
                        }).toString();
                        const oldParentId = source.data.parentIssueAri && (0, $jUlV7.JiraIssueAri).parse(source.data.parentIssueAri).issueId;
                        const newParentAri = extractedInstruction.type === (0, $czfFt.MAKE_CHILD) ? destination.data.issueId : destination.data.parentIssueAri;
                        const newParentId = newParentAri ? (0, $jUlV7.JiraIssueAri).parse(newParentAri).issueId : undefined;
                        const newParentEdgeId = extractedInstruction?.type === (0, $czfFt.MAKE_CHILD) ? destination.data.issueEdgeRelayId : destination.data.parentIssueEdgeRelayId;
                        let dropIndex = 0;
                        if (extractedInstruction?.type === (0, $czfFt.REORDER_ABOVE)) dropIndex = destination.data.rowIndex;
                        else if (extractedInstruction?.type === (0, $czfFt.REORDER_BELOW)) dropIndex = destination.data.rowIndex + 1;
                        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'field updated', {
                            isJscReparenting: true
                        });
                        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueParent updated', {
                            isJscReparenting: true
                        });
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                            action: 'updatedParent',
                            actionSubject: 'dragActionsButton',
                            actionSubjectId: 'jscDraggableIssue'
                        }), {
                            reparentingMethod: extractedInstruction.type,
                            isAddingParent: !oldParentId,
                            isUnparenting: !newParentAri,
                            droppedIssueHierarchyLevel: source.data.hierarchyLevel
                        });
                        reparent?.({
                            issueId: source.data.issueId,
                            issueAri: issueFieldAriToReparent,
                            oldParentId: oldParentId,
                            newParentId: newParentId,
                            newParentAri: newParentAri || null,
                            newParentEdgeId: newParentEdgeId,
                            index: dropIndex,
                            projectKey: props.projectKey
                        });
                    }
                }
            }
        }), [
        instanceId,
        issueId,
        parentIssueAri,
        parentIssueConnectionId,
        issueEdgeRelayId,
        parentIssueEdgeRelayId,
        edgeIndex,
        props,
        getBlockedInstructions,
        isRowReorderingEnabled,
        setDropTarget,
        isIssueRankingEnabled,
        isReParentingEnabled,
        createAnalyticsEvent,
        onRowReorder,
        cloudId,
        reparent
    ]);
    const registerDraggableRow = (0, $5uXOq.useCallback)(()=>{
        registerItem(edgeIndex, issueId);
    }, [
        edgeIndex,
        issueId,
        registerItem
    ]);
    const unregisterDraggableRow = (0, $5uXOq.useCallback)(()=>{
        unregisterItem(edgeIndex);
    }, [
        edgeIndex,
        unregisterItem
    ]);
    const attachDraggableRow = (0, $5uXOq.useCallback)((rowElement)=>{
        // If there's an existing ref, clean up before attaching
        cleanupFnRef.current?.();
        if (!rowElement) return;
        cleanupFnRef.current = (0, $4hDdm.combine)(attachDraggableElement(rowElement), attachDropTargetElement(rowElement), ()=>{
            // Reset the ref to null so that the cleanup function is not called again
            cleanupFnRef.current = null;
        });
    }, [
        attachDraggableElement,
        attachDropTargetElement
    ]);
    (0, $5uXOq.useEffect)(()=>()=>cleanupFnRef.current?.(), []);
    (0, $5uXOq.useEffect)(()=>{
        registerDraggableRow();
        return ()=>{
            unregisterDraggableRow();
        };
    }, [
        registerDraggableRow,
        unregisterDraggableRow
    ]);
    return isDragAndDropEnabled ? attachDraggableRow : null;
};

});
parcelRegister("biEfA", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $934cfe81468fb31a$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $934cfe81468fb31a$export$945a571f3b658bf);
const $934cfe81468fb31a$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $934cfe81468fb31a$var$uniqueKey = Symbol('closestEdge');
function $934cfe81468fb31a$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $934cfe81468fb31a$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$934cfe81468fb31a$var$uniqueKey]: addClosestEdge
    };
}
function $934cfe81468fb31a$export$945a571f3b658bf(userData) {
    return userData[$934cfe81468fb31a$var$uniqueKey] ?? null;
}

});

parcelRegister("f3lfW", function(module, exports) {

$parcel$export(module.exports, "attachInstruction", () => $8ac1160b89f36213$export$267ad49d812c2c7f);
$parcel$export(module.exports, "extractInstruction", () => $8ac1160b89f36213$export$c8ffecbe249dc8f8);

var $l0Z5B = parcelRequire("l0Z5B");
// using a symbol so we can guarantee a key with a unique value
const $8ac1160b89f36213$var$uniqueKey = Symbol('tree-item-instruction');
function $8ac1160b89f36213$var$getCenter(rect) {
    return {
        x: (rect.right + rect.left) / 2,
        y: (rect.bottom + rect.top) / 2
    };
}
function $8ac1160b89f36213$var$standardHitbox({ client: client, borderBox: borderBox }) {
    const quarterOfHeight = borderBox.height / 4;
    // In the top 1/4: reorder-above
    // On the line = in the top 1/4 to give this zone a bit more space
    if (client.y <= borderBox.top + quarterOfHeight) return 'reorder-above';
    // In the bottom 1/4: reorder-below
    // On the line = in the bottom 1/4 to give this zone a bit more space
    if (client.y >= borderBox.bottom - quarterOfHeight) return 'reorder-below';
    return 'make-child';
}
function $8ac1160b89f36213$var$getInstruction({ element: element, input: input, currentLevel: currentLevel, indentPerLevel: indentPerLevel, mode: mode }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    if (mode === 'standard') {
        const type = $8ac1160b89f36213$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            type: type,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    const center = $8ac1160b89f36213$var$getCenter(borderBox);
    if (mode === 'expanded') {
        // leveraging "standard" hitbox to ensure that the 'reorder-above' hit zone is
        // exactly the same for "standard" and "expanded" items
        const type = $8ac1160b89f36213$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            // Use the "standard" hitbox for "reorder above",
            // The rest of the item is "make-child"
            type: type === 'reorder-above' ? type : 'make-child',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // `mode` is "last-in-group"
    const visibleInset = indentPerLevel * currentLevel;
    // Before the left edge of the visible item
    if (client.x < borderBox.left + visibleInset) {
        // Above the center: `reorder-above`
        if (client.y < center.y) return {
            type: 'reorder-above',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
        // On or below the center: `reparent`
        // On the center = `reparent` as we are giving a slightly bigger hitbox to this
        // action as it is the only place a user can do it
        const rawLevel = (client.x - borderBox.left) / indentPerLevel;
        // We can get sub pixel negative numbers as getBoundingClientRect gives sub-pixel accuracy,
        // where as clientX is rounded to the nearest pixel.
        // Using Math.max() ensures we can never get a negative level
        const desiredLevel = Math.max(Math.floor(rawLevel), 0);
        return {
            type: 'reparent',
            desiredLevel: desiredLevel,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // On the visible item
    return {
        type: $8ac1160b89f36213$var$standardHitbox({
            borderBox: borderBox,
            client: client
        }),
        indentPerLevel: indentPerLevel,
        currentLevel: currentLevel
    };
}
function $8ac1160b89f36213$var$areInstructionsEqual(a, b) {
    // Shortcut
    if (a.type !== b.type) return false;
    if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') return $8ac1160b89f36213$var$areInstructionsEqual(a.desired, b.desired);
    return (0, $l0Z5B.isShallowEqual)(a, b);
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $8ac1160b89f36213$var$memoizeInstruction = (0, $l0Z5B.stable)($8ac1160b89f36213$var$areInstructionsEqual);
function $8ac1160b89f36213$var$applyInstructionBlock({ desired: desired, block: block }) {
    if (block?.includes(desired.type) && desired.type !== 'instruction-blocked') {
        const blocked = {
            type: 'instruction-blocked',
            desired: desired
        };
        return blocked;
    }
    return desired;
}
function $8ac1160b89f36213$export$267ad49d812c2c7f(userData, { block: block, ...rest }) {
    const desired = $8ac1160b89f36213$var$getInstruction(rest);
    const withBlock = $8ac1160b89f36213$var$applyInstructionBlock({
        desired: desired,
        block: block
    });
    const memoized = $8ac1160b89f36213$var$memoizeInstruction(withBlock);
    return {
        ...userData,
        [$8ac1160b89f36213$var$uniqueKey]: memoized
    };
}
function $8ac1160b89f36213$export$c8ffecbe249dc8f8(userData) {
    return userData[$8ac1160b89f36213$var$uniqueKey] ?? null;
}

});
parcelRegister("l0Z5B", function(module, exports) {

$parcel$export(module.exports, "isShallowEqual", () => $75d7ad3b386681e2$export$2225b4c39d37f8b3);
$parcel$export(module.exports, "stable", () => $75d7ad3b386681e2$export$3f55479a3469259f);
function $75d7ad3b386681e2$export$2225b4c39d37f8b3(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>Object.is(a[key], b[key]));
}
function $75d7ad3b386681e2$export$3f55479a3469259f(isEqual = $75d7ad3b386681e2$export$2225b4c39d37f8b3) {
    let cache = null;
    return (value)=>{
        if (cache && isEqual(cache.value, value)) return cache.value;
        cache = {
            value: value
        };
        return cache.value;
    };
}

});


parcelRegister("9EGGH", function(module, exports) {

$parcel$export(module.exports, "getReorderDestinationIndex", () => $178b6900979d74e0$export$846f792f51b92b6e);
function $178b6900979d74e0$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});

parcelRegister("7bewW", function(module, exports) {

$parcel$export(module.exports, "useUpdateParent", () => $fbc22896c442a4ba$export$d767b1cfe1a164d3);

var $aKHfW = parcelRequire("aKHfW");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $iJZ8l = parcelRequire("iJZ8l");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $kaHBi = parcelRequire("kaHBi");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $eCBf9 = parcelRequire("eCBf9");

var $czfFt = parcelRequire("czfFt");

var $debr5 = parcelRequire("debr5");

var $cAo1S = parcelRequire("cAo1S");
const $fbc22896c442a4ba$export$d767b1cfe1a164d3 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $debr5.REPARENTING_EXPERIENCE),
        analyticsSource: (0, $czfFt.ANALYTICS_SOURCE)
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $debr5.REPARENTING_EXPERIENCE)
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $debr5.REPARENTING_EXPERIENCE)
    });
    const [commitMutation, loading] = (0, $8Uumt.useMutation)((0, $aKHfW.default));
    const handleError = (0, $5uXOq.useCallback)((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'issueTableReparentMutation',
                packageName: (0, $czfFt.PACKAGE_NAME),
                teamName: (0, $czfFt.TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail((0, $czfFt.PACKAGE_NAME), error);
        showFlag((0, $debr5.UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG));
    }, [
        onExperienceFail,
        showFlag
    ]);
    const updater = (0, $cAo1S.useGetReparentUpdater)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const highlightIssue = (0, $5uXOq.useCallback)(({ issueId: issueId, store: store })=>{
        // Highlight the row
        const issueRelayID = (0, $iJZ8l.default)({
            id: issueId
        }, (0, $cAo1S.JIRA_ISSUE_TYPENAME));
        if (issueRelayID) {
            const node = store.get(issueRelayID);
            if (node) node?.setValue(true, 'isHighlightedIssueRow');
        }
    }, []);
    const reparent = (0, $5uXOq.useCallback)(({ issueId: issueId, issueAri: issueAri, oldParentId: oldParentId, newParentId: newParentId, newParentAri: newParentAri, newParentEdgeId: newParentEdgeId, index: index, projectKey: projectKey })=>{
        const input = {
            id: issueAri,
            operation: {
                operation: 'SET',
                id: newParentAri
            }
        };
        onExperienceStart();
        commitMutation({
            variables: {
                input: input
            },
            optimisticUpdater: (store)=>{
                updater({
                    store: store,
                    issueId: issueId,
                    oldParentId: oldParentId,
                    newParentId: newParentId,
                    newParentEdgeId: newParentEdgeId,
                    index: index,
                    projectKey: projectKey
                });
                // Highlight the row
                highlightIssue({
                    store: store,
                    issueId: issueId
                });
            },
            updater: (store, response)=>{
                if (response?.jira?.updateParentField?.success) {
                    updater({
                        store: store,
                        issueId: issueId,
                        oldParentId: oldParentId,
                        newParentId: newParentId,
                        newParentEdgeId: newParentEdgeId,
                        index: index,
                        projectKey: projectKey
                    });
                    highlightIssue({
                        store: store,
                        issueId: issueId
                    });
                    const issueRelayID = (0, $iJZ8l.default)({
                        id: issueId
                    }, (0, $cAo1S.JIRA_ISSUE_TYPENAME));
                    if (issueRelayID) setTimeout(()=>{
                        (0, $8Uumt.commitLocalUpdate)(environment, (currentStore)=>{
                            const node = currentStore.get(issueRelayID);
                            node?.setValue(false, 'isHighlightedIssueRow');
                        });
                    }, (0, $czfFt.HIGHLIGHT_LINGER_DURATION_MS));
                }
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.updateParentField ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    const clientSideErrorMessage = (0, $cAo1S.getFlagDetails)(statusCode);
                    if (clientSideErrorMessage) {
                        showFlag(clientSideErrorMessage);
                        onExperienceSuccess();
                        return;
                    }
                    handleError(error);
                    return;
                }
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue reparented', (0, $debr5.ACTION_SUBJECT_ID));
                onExperienceSuccess();
            },
            onError: (error)=>{
                const err = new (0, $eCBf9.MutationError)(error);
                handleError(err);
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        environment,
        handleError,
        highlightIssue,
        onExperienceStart,
        onExperienceSuccess,
        showFlag,
        updater
    ]);
    return {
        reparent: reparent,
        loading: loading
    };
};

});
parcelRegister("aKHfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0677e9fa9d6baa62$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a14b547dc80db979d18a2f6b7caad927>>
 * @relayHash 912b3665801859ed64b357f816488c18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5822dc5c39bb3263eb89e5efb2750a9fb42f5c4f74af60f422e877ecfaac2766
const $0677e9fa9d6baa62$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraParentIssueField",
        "kind": "LinkedField",
        "name": "field",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "reparentMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "reparentMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5822dc5c39bb3263eb89e5efb2750a9fb42f5c4f74af60f422e877ecfaac2766",
            "metadata": {},
            "name": "reparentMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0677e9fa9d6baa62$var$node.hash = "8010fe7d0e37915f076661fa947a0546";
var $0677e9fa9d6baa62$export$2e2bcd8739ae039 = $0677e9fa9d6baa62$var$node;

});

parcelRegister("debr5", function(module, exports) {

$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG", () => $29aa487c00a0f44f$export$e80b28191e1d3602);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG", () => $29aa487c00a0f44f$export$29d372313e7a3d7b);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM", () => $29aa487c00a0f44f$export$a75bfbb3fb2f437c);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG", () => $29aa487c00a0f44f$export$6a4ca5120f2baf63);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM", () => $29aa487c00a0f44f$export$4cba4bafd925e182);
$parcel$export(module.exports, "REPARENTING_EXPERIENCE", () => $29aa487c00a0f44f$export$4c7c3fa9c49bb0d7);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $29aa487c00a0f44f$export$9957974f8b4d8f74);

var $9R8ao = parcelRequire("9R8ao");
const $29aa487c00a0f44f$export$e80b28191e1d3602 = {
    type: 'error',
    title: (0, $9R8ao.default).updateIssueParentErrorTitle,
    description: (0, $9R8ao.default).updateIssueParentGenericErrorDescription,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic',
    messageType: 'transactional'
};
const $29aa487c00a0f44f$export$29d372313e7a3d7b = {
    type: 'error',
    title: (0, $9R8ao.default).updateIssueParentErrorTitle,
    description: (0, $9R8ao.default).updateIssueParent400ErrorDescription,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-400-flag.error.flag.update-issue-parent400error',
    messageType: 'transactional'
};
const $29aa487c00a0f44f$export$a75bfbb3fb2f437c = {
    type: 'error',
    title: (0, $9R8ao.default).updateIssueParentErrorTitle,
    description: (0, $9R8ao.default).updateIssueParent400ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term.error.flag.update-issue-parent400error-issue-term-refresh',
    messageType: 'transactional'
};
const $29aa487c00a0f44f$export$6a4ca5120f2baf63 = {
    type: 'error',
    title: (0, $9R8ao.default).updateIssueParentErrorTitle,
    description: (0, $9R8ao.default).updateIssueParent404ErrorDescription,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
    messageType: 'transactional'
};
const $29aa487c00a0f44f$export$4cba4bafd925e182 = {
    type: 'error',
    title: (0, $9R8ao.default).updateIssueParentErrorTitle,
    description: (0, $9R8ao.default).updateIssueParent404ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
    messageType: 'transactional'
};
const $29aa487c00a0f44f$export$4c7c3fa9c49bb0d7 = 'updateParent';
const $29aa487c00a0f44f$export$11823571c61d4d02 = 'SUCCEEDED';
const $29aa487c00a0f44f$export$d71930f7f5807a72 = 'FAILED';
const $29aa487c00a0f44f$export$f3390a0e172fee41 = 'useUpdateParent';
const $29aa487c00a0f44f$export$9957974f8b4d8f74 = 'issueTableUpdateIssueParent';

});
parcelRegister("9R8ao", function(module, exports) {

$parcel$export(module.exports, "default", () => $8687cbc9456584f0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8687cbc9456584f0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updateIssueParentErrorTitle: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-error-title",
        "defaultMessage": "Something's gone wrong"
    },
    updateIssueParentGenericErrorDescription: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-generic-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    updateIssueParent400ErrorDescription: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description",
        "defaultMessage": "You don\u2019t have permission to update this issue. Contact a project admin."
    },
    updateIssueParent404ErrorDescription: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-description",
        "defaultMessage": "We\u2019re having trouble updating this issue. To continue, refresh the page."
    },
    updateIssueParent400ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description-issue-term-refresh",
        "defaultMessage": "You don\u2019t have permission to update this work item. Contact a project admin."
    },
    updateIssueParent404ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-description-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble updating this work item. To continue, refresh the page."
    }
});

});


parcelRegister("cAo1S", function(module, exports) {

$parcel$export(module.exports, "getFlagDetails", () => $cffe992024741707$export$e0141c03826f0c2c);
$parcel$export(module.exports, "JIRA_ISSUE_TYPENAME", () => $cffe992024741707$export$8df31253ff7294c9);
$parcel$export(module.exports, "useGetReparentUpdater", () => $cffe992024741707$export$b3f12c98c1f443a);

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");

var $6s1PB = parcelRequire("6s1PB");

var $iJZ8l = parcelRequire("iJZ8l");

var $5FoyW = parcelRequire("5FoyW");

var $4R6GH = parcelRequire("4R6GH");

var $MMunf = parcelRequire("MMunf");

var $debr5 = parcelRequire("debr5");
const $cffe992024741707$export$e0141c03826f0c2c = (statusCode)=>{
    switch(statusCode){
        case 400:
            return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $debr5.UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM) : (0, $debr5.UPDATE_ITEM_PARENT_FAIL_400_FLAG);
        case 404:
            return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $debr5.UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM) : (0, $debr5.UPDATE_ITEM_PARENT_FAIL_404_FLAG);
        default:
            return null;
    }
};
const $cffe992024741707$export$8df31253ff7294c9 = 'JiraIssue';
const $cffe992024741707$export$b3f12c98c1f443a = ()=>{
    const { connections: connections } = (0, $5FoyW.useConnectionsList)();
    const updateConnectionDetails = (0, $MMunf.useUpdateConnectionDetails)();
    const getConection = (0, $5uXOq.useCallback)(({ issueId: issueId })=>Object.values(connections).find((connection)=>{
            if (issueId) return connection.type === 'PARENT_CHILDREN' && connection.parentId === issueId;
            return connection.type === 'ROOT_ISSUES';
        }), [
        connections
    ]);
    const updater = (0, $5uXOq.useCallback)(({ store: store, issueId: issueId, oldParentId: oldParentId, newParentId: newParentId, newParentEdgeId: newParentEdgeId, index: index = 0, projectKey: projectKey })=>{
        const relayId = (0, $iJZ8l.default)({
            id: issueId
        }, $cffe992024741707$export$8df31253ff7294c9);
        if (!relayId || !oldParentId && !(0, $4R6GH.fg)('jsc-fix-reparenting-items-with-no-parent')) return;
        const oldConnection = getConection({
            issueId: oldParentId
        });
        const newConnection = getConection({
            issueId: newParentId
        });
        if (!oldConnection) // Since the issue has to be visible to be repartented, this case should not occur
        return;
        const oldConnectionRecord = store.get(oldConnection.connectionId);
        if (!oldConnectionRecord) return;
        if (newParentEdgeId) (0, $MMunf.updateParentHasChildren)({
            store: store,
            parentIssueEdgeRecordId: newParentEdgeId,
            connectionId: newConnection?.connectionId,
            hasChildren: true,
            projectKey: projectKey
        });
        if (newConnection) {
            const newConnectionRecord = store.get(newConnection.connectionId);
            if (!newConnectionRecord) return;
            const existingEdge = oldConnectionRecord.getLinkedRecords('edges')?.find((edge)=>edge?.getLinkedRecord('node')?.getDataID() === relayId);
            // no before or after implies an empty conneciton, verify then create the edges list
            const { EDGES: EDGES } = (0, $eiowN.ConnectionInterface).get();
            const edges = newConnectionRecord.getLinkedRecords(EDGES);
            if (!edges || !existingEdge) return;
            const nextEdges = edges.slice(0, index).concat(existingEdge).concat(edges.slice(index));
            newConnectionRecord.setLinkedRecords(nextEdges, EDGES);
            updateConnectionDetails({
                store: store,
                connection: newConnection,
                netChangeInIssueCount: 1,
                remainingIssueCount: newConnectionRecord.getLinkedRecords('edges')?.length,
                projectKey: projectKey
            });
        }
        if (oldConnection) // remove the issue from the old connection
        {
            if (oldConnectionRecord.getLinkedRecords('edges')?.some((edge)=>edge?.getLinkedRecord('node')?.getDataID() === relayId)) {
                (0, $eiowN.ConnectionHandler).deleteNode(oldConnectionRecord, relayId);
                updateConnectionDetails({
                    store: store,
                    connection: oldConnection,
                    netChangeInIssueCount: -1,
                    remainingIssueCount: oldConnectionRecord.getLinkedRecords('edges')?.length,
                    projectKey: projectKey
                });
            }
        }
    }, [
        getConection,
        updateConnectionDetails
    ]);
    return updater;
};

});


parcelRegister("4pPXb", function(module, exports) {

$parcel$export(module.exports, "useIssuesRanker", () => $6c346a4432b15df7$export$40f5e450e8552c78);

var $aX2fz = parcelRequire("aX2fz");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");
parcelRequire("ii3zs");
var $a44uV = parcelRequire("a44uV");

var $kaHBi = parcelRequire("kaHBi");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $eCBf9 = parcelRequire("eCBf9");

var $czfFt = parcelRequire("czfFt");

var $3I8L4 = parcelRequire("3I8L4");

var $aGXrU = parcelRequire("aGXrU");

var $56yIl = parcelRequire("56yIl");

var $fIF0q = parcelRequire("fIF0q");
const $6c346a4432b15df7$var$getRankMutationEdge = (edge)=>{
    switch(edge){
        case 'top':
            return 'TOP';
        case 'bottom':
            return 'BOTTOM';
        default:
            // Unsupported edge
            return null;
    }
};
const $6c346a4432b15df7$export$40f5e450e8552c78 = ()=>{
    const [issueConnectionId] = (0, $3I8L4.useDraggableRowsConnectionId)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $aGXrU.RE_RANKING_EXPERIENCE),
        analyticsSource: (0, $czfFt.ANALYTICS_SOURCE)
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $aGXrU.RE_RANKING_EXPERIENCE)
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $aGXrU.RE_RANKING_EXPERIENCE)
    });
    const [rankIssuesMutation] = (0, $8Uumt.useMutation)((0, $aX2fz.default));
    const showErrorFlag = (0, $5uXOq.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $fIF0q.default).reorderErrorTitleIssueTermRefresh : (0, $fIF0q.default).reorderErrorTitle,
            description: (0, $fIF0q.default).reorderErrorDescription,
            isAutoDismiss: true,
            messageId: 'native-issue-table.services.rank-mutation.show-flag.error.use-issues-ranker.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    const reorderIssuesUpdater = (0, $5uXOq.useCallback)((store, startIndex, finishIndex)=>{
        const issueConnection = store.get(issueConnectionId);
        if (!issueConnection) return;
        const edges = issueConnection.getLinkedRecords('edges');
        if (!edges) return;
        const reorderedEdges = (0, $a44uV.reorder)({
            list: edges,
            startIndex: startIndex,
            finishIndex: finishIndex
        });
        issueConnection.setLinkedRecords(reorderedEdges, 'edges');
    }, [
        issueConnectionId
    ]);
    const handleError = (0, $5uXOq.useCallback)((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'commitRankIssuesMutationError',
                packageName: (0, $czfFt.PACKAGE_NAME),
                teamName: (0, $czfFt.TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail((0, $czfFt.PACKAGE_NAME), error);
        showErrorFlag();
    }, [
        onExperienceFail,
        showErrorFlag
    ]);
    const rankIssues = (0, $5uXOq.useCallback)((payload)=>{
        const { source: source, destination: destination, edge: edge } = payload;
        const rankMutationEdge = $6c346a4432b15df7$var$getRankMutationEdge(edge);
        onExperienceStart();
        if (rankMutationEdge == null) {
            showErrorFlag();
            (0, $jcw0u.default)({
                meta: {
                    id: 'commitRankIssuesError',
                    packageName: (0, $czfFt.PACKAGE_NAME),
                    teamName: (0, $czfFt.TEAM_NAME)
                },
                error: new Error(`Edge "${edge}" is unsupported in JiraMutation.rankIssues`),
                sendToPrivacyUnsafeSplunk: true
            });
            return;
        }
        rankIssuesMutation({
            variables: {
                rankInput: {
                    issues: source.issueIds,
                    relativeToIssue: destination.relativeToIssueId,
                    edge: rankMutationEdge
                }
            },
            optimisticUpdater (store) {
                reorderIssuesUpdater(store, source.rowIndex, destination.rowIndex);
            },
            updater (store, data) {
                // Rollback update if mutation fails
                if (!data?.jira?.rankIssues?.success) return;
                reorderIssuesUpdater(store, source.rowIndex, destination.rowIndex);
            },
            onCompleted (data) {
                const { errors: errors } = data?.jira?.rankIssues ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    const clientSideErrorMessage = (0, $56yIl.getFlagDetails)(statusCode);
                    if (clientSideErrorMessage) {
                        showFlag(clientSideErrorMessage);
                        onExperienceSuccess();
                        return;
                    }
                    handleError(error);
                    return;
                }
                if (!data.jira?.rankIssues?.success) {
                    const error = new Error(errors?.[0]?.message ?? 'Failed to reorder issues: Unknown Error occurred');
                    handleError(error);
                    return;
                }
                onExperienceSuccess();
            },
            onError (error) {
                handleError(error);
            }
        });
    }, [
        handleError,
        onExperienceStart,
        onExperienceSuccess,
        rankIssuesMutation,
        reorderIssuesUpdater,
        showErrorFlag,
        showFlag
    ]);
    return rankIssues;
};

});
parcelRegister("aX2fz", function(module, exports) {

$parcel$export(module.exports, "default", () => $59305e3d9ee9f1bb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a7b6192e241bff817293e89536fb54d7>>
 * @relayHash 5af65462c60885c21e1ab5b9e7fe7bcd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28980e6494a8955ea545f2049a61094e488898b5d096195ce03d5df5cd90873c
const $59305e3d9ee9f1bb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "rankInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "rankInput",
            "variableName": "rankInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "rankMutation_rankIssuesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRankMutationPayload",
                            "kind": "LinkedField",
                            "name": "rankIssues",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "rankMutation_rankIssuesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRankMutationPayload",
                            "kind": "LinkedField",
                            "name": "rankIssues",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "28980e6494a8955ea545f2049a61094e488898b5d096195ce03d5df5cd90873c",
            "metadata": {},
            "name": "rankMutation_rankIssuesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$59305e3d9ee9f1bb$var$node.hash = "4dde1357f9a06e5132a41d95c199765c";
var $59305e3d9ee9f1bb$export$2e2bcd8739ae039 = $59305e3d9ee9f1bb$var$node;

});

parcelRegister("ii3zs", function(module, exports) {

$parcel$export(module.exports, "reorder", () => (parcelRequire("a44uV")).reorder);

var $a44uV = parcelRequire("a44uV");

});
parcelRegister("a44uV", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $921c81942b5fc66a$export$fc77a6137e3f91c);
/**
 * A function that will reorder an array (`list`).
 * `reorder` returns a new array with reordered items and does not
 *  modify the original array. The items in the array are also not modified.
 */ function $921c81942b5fc66a$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) // Making this function consistently return a new array reference.
    // This is consistent with .toSorted() which always returns a new array
    // even when it does not do anything
    return Array.from(list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}

});


parcelRegister("aGXrU", function(module, exports) {

$parcel$export(module.exports, "REORDER_ITEM_FAIL_400_FLAG", () => $de6f52464d349937$export$c58c5fc634df2e30);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM", () => $de6f52464d349937$export$d37d45ebdf6e6be4);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_404_FLAG", () => $de6f52464d349937$export$d9fdb4939efc3fa9);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_404_FLAG_WITH_ISSUE_TERM", () => $de6f52464d349937$export$83a2ceb0732d655a);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_409_FLAG", () => $de6f52464d349937$export$3b5b9901de703a5a);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_409_FLAG_WITH_ISSUE_TERM", () => $de6f52464d349937$export$b57a01d3fd8405a5);
$parcel$export(module.exports, "RE_RANKING_EXPERIENCE", () => $de6f52464d349937$export$cb50c1de8dfcf0a5);

var $fIF0q = parcelRequire("fIF0q");
const $de6f52464d349937$export$9aa93234f179f11b = {
    type: 'error',
    title: (0, $fIF0q.default).reorderErrorTitle,
    description: (0, $fIF0q.default).reorderErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-generic-flag.error.update-item-parent-fail-generic-flag.error.reparent-mutation.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic',
    messageType: 'transactional'
};
const $de6f52464d349937$export$c58c5fc634df2e30 = {
    type: 'error',
    title: (0, $fIF0q.default).reorderErrorTitle,
    description: (0, $fIF0q.default).reorderIssue400ErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-400-flag.error.update-item-parent-fail-400-flag.error.reparent-mutation.update-item-parent-fail-400-flag.error.flag.update-issue-parent400error',
    messageType: 'transactional'
};
const $de6f52464d349937$export$d37d45ebdf6e6be4 = {
    type: 'error',
    title: (0, $fIF0q.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $fIF0q.default).reorderIssue400ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-400-flag-with-issue-term.error.update-item-parent-fail-400-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term.error.flag.update-issue-parent400error-issue-term-refresh',
    messageType: 'transactional'
};
const $de6f52464d349937$export$d9fdb4939efc3fa9 = {
    type: 'error',
    title: (0, $fIF0q.default).reorderErrorTitle,
    description: (0, $fIF0q.default).reorderIssue404ErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-404-flag.error.update-item-parent-fail-404-flag.error.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
    messageType: 'transactional'
};
const $de6f52464d349937$export$83a2ceb0732d655a = {
    type: 'error',
    title: (0, $fIF0q.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $fIF0q.default).reorderIssue404ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-404-flag-with-issue-term.error.update-item-parent-fail-404-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
    messageType: 'transactional'
};
const $de6f52464d349937$export$3b5b9901de703a5a = {
    type: 'error',
    title: (0, $fIF0q.default).reorderErrorTitle,
    description: (0, $fIF0q.default).reorderIssue409ErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-409-flag.error.reorder-item-fail-404-flag.error.update-item-parent-fail-404-flag.error.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
    messageType: 'transactional'
};
const $de6f52464d349937$export$b57a01d3fd8405a5 = {
    type: 'error',
    title: (0, $fIF0q.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $fIF0q.default).reorderIssue409ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-409-flag-with-issue-term.error.reorder-item-fail-404-flag-with-issue-term.error.update-item-parent-fail-404-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
    messageType: 'transactional'
};
const $de6f52464d349937$export$cb50c1de8dfcf0a5 = 'reRankIssue';

});
parcelRegister("fIF0q", function(module, exports) {

$parcel$export(module.exports, "default", () => $426fd16fa6ee43f5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $426fd16fa6ee43f5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    reorderErrorTitle: {
        "id": "native-issue-table.services.rank-mutation.reorder-error-title",
        "defaultMessage": "We couldn't reorder those issues"
    },
    reorderErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-error-description",
        "defaultMessage": "Wait a few moments, then give it another try."
    },
    reorderErrorTitleIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-error-title-issue-term-refresh",
        "defaultMessage": "We couldn't reorder those work items"
    },
    reorderIssue400ErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-400-error-description",
        "defaultMessage": "You don\u2019t have permission to reorder this issue. Contact a project admin."
    },
    reorderIssue404ErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-404-error-description",
        "defaultMessage": "We\u2019re having trouble reordering this issue. To continue, refresh the page."
    },
    reorderIssue409ErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-409-error-description",
        "defaultMessage": "There was a conflict reordering those issues. Please try again."
    },
    reorderIssue400ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-400-error-description-issue-term-refresh",
        "defaultMessage": "You don\u2019t have permission to reorder this work item. Contact a project admin."
    },
    reorderIssue404ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-404-error-description-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble reordering this work item. To continue, refresh the page."
    },
    reorderIssue409ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-409-error-description-issue-term-refresh",
        "defaultMessage": "There was a conflict reordering those work items. Please try again."
    }
});

});


parcelRegister("56yIl", function(module, exports) {

$parcel$export(module.exports, "getFlagDetails", () => $bc2685a27b92739b$export$e0141c03826f0c2c);

var $4R6GH = parcelRequire("4R6GH");

var $aGXrU = parcelRequire("aGXrU");
const $bc2685a27b92739b$export$e0141c03826f0c2c = (statusCode)=>{
    switch(statusCode){
        case 400:
            return (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $aGXrU.REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM) : (0, $aGXrU.REORDER_ITEM_FAIL_400_FLAG);
        case 404:
            return (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $aGXrU.REORDER_ITEM_FAIL_404_FLAG_WITH_ISSUE_TERM) : (0, $aGXrU.REORDER_ITEM_FAIL_404_FLAG);
        case 409:
            return (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $aGXrU.REORDER_ITEM_FAIL_409_FLAG_WITH_ISSUE_TERM) : (0, $aGXrU.REORDER_ITEM_FAIL_409_FLAG);
        default:
            return null;
    }
};

});


parcelRegister("4iDVJ", function(module, exports) {

$parcel$export(module.exports, "getBlockedInstructions", () => $773999e842652f14$export$44539271c2e3abc8);
$parcel$export(module.exports, "getBlockedInstructionsOld", () => $773999e842652f14$export$704f71e2437b55b4);

var $hUobS = parcelRequire("hUobS");

var $czfFt = parcelRequire("czfFt");
const $773999e842652f14$export$44539271c2e3abc8 = ({ dropTarget: dropTarget, draggedItem: draggedItem, isIssueRankingEnabled: isIssueRankingEnabled })=>{
    const draggedItemLevel = draggedItem?.hierarchyLevel;
    const dropTargetLevel = dropTarget?.hierarchyLevel;
    const dragItemHasParent = !!draggedItem?.parentIssueAri;
    const dropTargetHasParent = !!dropTarget?.parentIssueAri;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hUobS)))(dropTargetLevel) || !(0, (/*@__PURE__*/$parcel$interopDefault($hUobS)))(draggedItemLevel)) return [];
    const dragItemParentIsDropTarget = String(dropTarget?.issueId) === String(draggedItem?.parentIssueAri);
    const isSiblingOfDropTarget = String(dropTarget?.parentIssueAri) === String(draggedItem?.parentIssueAri);
    const droppingToSameParent = // Do not take into account when both drag item and drop target do not have parent, in which case
    // they have an equal parent value but is not reparenting to same parent
    draggedItem?.parentIssueAri !== '' && draggedItem?.parentIssueAri != null && (isSiblingOfDropTarget || dragItemParentIsDropTarget);
    if (droppingToSameParent) {
        if (isIssueRankingEnabled && isSiblingOfDropTarget) return [
            (0, $czfFt.MAKE_CHILD)
        ];
        if (dragItemParentIsDropTarget && draggedItemLevel > (0, $czfFt.SUBTASK_HIERARCHY_LEVEL)) return [
            (0, $czfFt.MAKE_CHILD)
        ];
        return [
            (0, $czfFt.MAKE_CHILD),
            (0, $czfFt.REORDER_BELOW),
            (0, $czfFt.REORDER_ABOVE)
        ];
    }
    // if the difference is not of one level up, we could be reparenting by dragging
    if (dropTargetLevel !== draggedItemLevel + 1) {
        // If drop target is of same level as drag item and drop target has parent,
        // do not block reorder as we are reordering to reparent
        if (dropTargetLevel === draggedItemLevel && dropTargetHasParent) return [
            (0, $czfFt.MAKE_CHILD)
        ];
        // If we are dropping to a top level issue (unparenting or reranking), we should not block reordering
        if (dropTarget?.depth === 0 && draggedItemLevel > (0, $czfFt.SUBTASK_HIERARCHY_LEVEL)) {
            if (dragItemHasParent || isIssueRankingEnabled) return [
                (0, $czfFt.MAKE_CHILD)
            ];
        }
        if (draggedItemLevel === (0, $czfFt.SUBTASK_HIERARCHY_LEVEL)) return [
            (0, $czfFt.MAKE_CHILD),
            (0, $czfFt.REORDER_BELOW),
            (0, $czfFt.REORDER_ABOVE)
        ];
        // Any other actions is an invalid drop onto an item
        return [
            (0, $czfFt.MAKE_CHILD),
            (0, $czfFt.REORDER_BELOW),
            (0, $czfFt.REORDER_ABOVE)
        ];
    }
    // we cannot unparent a subtask nor an item that already does not have a parent
    if (draggedItemLevel === (0, $czfFt.SUBTASK_HIERARCHY_LEVEL)) return [
        (0, $czfFt.REORDER_BELOW),
        (0, $czfFt.REORDER_ABOVE)
    ];
    // Unparenting any non-subtask issue type
    if (dropTarget?.depth === 0 && draggedItemLevel > (0, $czfFt.SUBTASK_HIERARCHY_LEVEL) && dragItemHasParent) return [];
    // we are dropping to a valid parent
    return [];
};
const $773999e842652f14$export$704f71e2437b55b4 = ({ dropTarget: dropTarget, draggedItem: draggedItem, isRowReorderingEnabled: isRowReorderingEnabled })=>{
    // We don't support reordering and reparenting
    if (isRowReorderingEnabled) return [
        (0, $czfFt.MAKE_CHILD)
    ];
    const draggedItemLevel = draggedItem?.hierarchyLevel;
    const dropTargetLevel = dropTarget?.hierarchyLevel;
    const dragItemHasParent = !!draggedItem?.parentIssueAri;
    const dropTargetHasParent = !!dropTarget?.parentIssueAri;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hUobS)))(dropTargetLevel) || !(0, (/*@__PURE__*/$parcel$interopDefault($hUobS)))(draggedItemLevel)) return [];
    const dragItemParentIsDropTarget = String(dropTarget?.issueId) === String(draggedItem?.parentIssueAri);
    const isSiblingOfDropTarget = String(dropTarget?.parentIssueAri) === String(draggedItem?.parentIssueAri);
    const droppingToSameParent = // Do not take into account when both drag item and drop target do not have parent, in which case
    // they have an equal parent value but is not reparenting to same parent
    draggedItem?.parentIssueAri !== '' && draggedItem?.parentIssueAri != null && (isSiblingOfDropTarget || dragItemParentIsDropTarget);
    if (droppingToSameParent) return [
        (0, $czfFt.MAKE_CHILD),
        (0, $czfFt.REORDER_BELOW),
        (0, $czfFt.REORDER_ABOVE)
    ];
    // if the difference is not of one level up, we could be reparenting by dragging
    if (dropTargetLevel !== draggedItemLevel + 1) {
        // If drop target is of same level as drag item and drop target has parent,
        // do not block reorder as we are reordering to reparent
        if (dropTargetLevel === draggedItemLevel && dropTargetHasParent) return [
            (0, $czfFt.MAKE_CHILD)
        ];
        // If we are dropping to a top level issue (unparenting), we should not block reordering
        if (dropTarget?.depth === 0 && draggedItemLevel > (0, $czfFt.SUBTASK_HIERARCHY_LEVEL) && dragItemHasParent) return [
            (0, $czfFt.MAKE_CHILD)
        ];
        // Any other actions are invalid
        return [
            (0, $czfFt.MAKE_CHILD),
            (0, $czfFt.REORDER_BELOW),
            (0, $czfFt.REORDER_ABOVE)
        ];
    }
    // we cannot unparent a subtask nor an item that already does not have a parent
    if (draggedItemLevel === (0, $czfFt.SUBTASK_HIERARCHY_LEVEL) || !dragItemHasParent) return [
        (0, $czfFt.REORDER_BELOW),
        (0, $czfFt.REORDER_ABOVE)
    ];
    // Unparenting any non-subtask issue type
    if (dropTarget?.depth === 0 && draggedItemLevel > (0, $czfFt.SUBTASK_HIERARCHY_LEVEL) && dragItemHasParent) return [];
    // we are dropping to a valid parent
    return [
        (0, $czfFt.REORDER_BELOW),
        (0, $czfFt.REORDER_ABOVE)
    ];
};

});
parcelRegister("hUobS", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $d09a6e5a442af90c$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $d09a6e5a442af90c$var$isNumber(value) {
    return typeof value == 'number' || $fC1Kz(value) && $beQoo(value) == $d09a6e5a442af90c$var$numberTag;
}
module.exports = $d09a6e5a442af90c$var$isNumber;

});



parcelRegister("1JFgA", function(module, exports) {

$parcel$export(module.exports, "useSelectedRow", () => $afb746f1e9a228af$export$11a86b67953bcc50);
$parcel$export(module.exports, "useIsSelected", () => $afb746f1e9a228af$export$fb40a80c530e5f2b);
$parcel$export(module.exports, "useIsFocused", () => $afb746f1e9a228af$export$a774b9356e1b793);

var $4R6GH = parcelRequire("4R6GH");

var $fc4cz = parcelRequire("fc4cz");

var $1wHMz = parcelRequire("1wHMz");
const $afb746f1e9a228af$export$11a86b67953bcc50 = ()=>{
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $fc4cz.useSelectedRow)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $1wHMz.useSelectedRow)();
};
const $afb746f1e9a228af$export$fb40a80c530e5f2b = (itemDetail, rowDetail)=>{
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $fc4cz.useIsSelected)(itemDetail);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $1wHMz.useIsSelected)(rowDetail);
};
const $afb746f1e9a228af$export$a774b9356e1b793 = (itemDetail, rowDetail)=>{
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $fc4cz.useIsFocused)(itemDetail);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $1wHMz.useIsFocused)(rowDetail);
};

});

parcelRegister("dSLRZ", function(module, exports) {

$parcel$export(module.exports, "SiblingIssueCreateRowContext", () => $375e39f1626badfa$export$93b3e64bc25dd687);
$parcel$export(module.exports, "useSiblingIssueCreateRow", () => $375e39f1626badfa$export$4d2a6b6549dc23e8);
$parcel$export(module.exports, "useSiblingIssueCreateHandler", () => $375e39f1626badfa$export$6dac168b5104cc);
$parcel$export(module.exports, "useSiblingIssueCreateOnScroll", () => $375e39f1626badfa$export$2dfe9712a7a20bc9);

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $e9M6d = parcelRequire("e9M6d");

var $fh5X0 = parcelRequire("fh5X0");

const $375e39f1626badfa$var$MOUSE_MOVE_THROTTLE = 16;
const $375e39f1626badfa$var$SIBLING_CREATE_HOVER_AREA = 12;
const $375e39f1626badfa$export$93b3e64bc25dd687 = /*#__PURE__*/ (0, $5uXOq.createContext)({});
const $375e39f1626badfa$export$4d2a6b6549dc23e8 = ()=>{
    const context = (0, $5uXOq.useContext)($375e39f1626badfa$export$93b3e64bc25dd687);
    const isSiblingIssueCreateEnabled = (0, $e9M6d.useIsSiblingIssueCreateEnabled)();
    return isSiblingIssueCreateEnabled ? context : {};
};
const $375e39f1626badfa$export$6dac168b5104cc = (connectionId, edgeIndex)=>{
    const isSiblingIssueCreateEnabled = (0, $e9M6d.useIsSiblingIssueCreateEnabled)();
    const { setIndex: setIndex, clearIndex: clearIndex, clearIndexAfterDelay: clearIndexAfterDelay } = (0, $fh5X0.useSiblingCreateActiveIndexActions)();
    const calculateRowIndex = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))((event)=>{
            const currentRow = event.currentTarget;
            if (!currentRow) return;
            // Calculate the y position of the mouse relative to the top of the current row.
            const currentRowRect = currentRow.getBoundingClientRect();
            // This calculation ranges from -1 to 39, instead of 0 to 40, potentially due to the row's border.
            // For this reason, we add 1 to ensure the value is correct.
            const currentRowMouseVerticalOffset = event.clientY - currentRowRect.top + 1;
            if (currentRowMouseVerticalOffset >= 0 && currentRowMouseVerticalOffset <= $375e39f1626badfa$var$SIBLING_CREATE_HOVER_AREA) // When hovering the top part of a row, the trigger should be rendered at the top of the current row.
            setIndex((0, $ba4a319520d566ae$export$76a449e52fa0e1e8), [
                connectionId,
                edgeIndex
            ]);
            else if (currentRowMouseVerticalOffset > currentRowRect.height - $375e39f1626badfa$var$SIBLING_CREATE_HOVER_AREA) // When hovering the bottom part of a row, the trigger should be rendered at the top of the next row.
            setIndex((0, $ba4a319520d566ae$export$76a449e52fa0e1e8), [
                connectionId,
                edgeIndex + 1
            ]);
            else // When hovering the middle part of a row, the trigger should not be rendered.
            clearIndex((0, $ba4a319520d566ae$export$76a449e52fa0e1e8));
        }, $375e39f1626badfa$var$MOUSE_MOVE_THROTTLE), [
        connectionId,
        edgeIndex,
        clearIndex,
        setIndex
    ]);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>{
        clearIndexAfterDelay((0, $ba4a319520d566ae$export$76a449e52fa0e1e8));
    }, [
        clearIndexAfterDelay
    ]);
    const onMouseMove = (0, $5uXOq.useCallback)((event)=>{
        calculateRowIndex(event);
    }, [
        calculateRowIndex
    ]);
    return isSiblingIssueCreateEnabled ? {
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove
    } : {};
};
const $375e39f1626badfa$export$2dfe9712a7a20bc9 = ()=>{
    const isSiblingIssueCreateEnabled = (0, $e9M6d.useIsSiblingIssueCreateEnabled)();
    const { clearIndex: clearIndex } = (0, $fh5X0.useSiblingCreateActiveIndexActions)();
    return (0, $5uXOq.useMemo)(()=>isSiblingIssueCreateEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(()=>{
            clearIndex((0, $ba4a319520d566ae$export$76a449e52fa0e1e8));
        }, $375e39f1626badfa$var$MOUSE_MOVE_THROTTLE) : undefined, [
        clearIndex,
        isSiblingIssueCreateEnabled
    ]);
};

});
const $ba4a319520d566ae$export$76a449e52fa0e1e8 = 'issue';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $ba4a319520d566ae$var$FIELD = 'field';


parcelRegister("5DTiT", function(module, exports) {

$parcel$export(module.exports, "useRowContext", () => $6e0d3eb2b3d97ce5$export$7a486b5630cc7522);
$parcel$export(module.exports, "RowContextProvider", () => $6e0d3eb2b3d97ce5$export$81ecc1ee96e0504e);

var $5uXOq = parcelRequire("5uXOq");
const $6e0d3eb2b3d97ce5$var$RowContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $6e0d3eb2b3d97ce5$export$7a486b5630cc7522 = ()=>{
    const context = (0, $5uXOq.useContext)($6e0d3eb2b3d97ce5$var$RowContext);
    if (!context) throw new Error('useRowContext must be used within RowContextProvider');
    return context;
};
const $6e0d3eb2b3d97ce5$export$81ecc1ee96e0504e = ({ children: children, columns: columns, tableInjectedProps: tableInjectedProps, renderChildRows: renderChildRows, groupId: groupId, groupConnectionId: groupConnectionId })=>{
    const props = (0, $5uXOq.useMemo)(()=>({
            columns: columns,
            tableInjectedProps: tableInjectedProps,
            renderChildRows: renderChildRows,
            groupId: groupId,
            groupConnectionId: groupConnectionId
        }), [
        columns,
        tableInjectedProps,
        renderChildRows,
        groupId,
        groupConnectionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6e0d3eb2b3d97ce5$var$RowContext.Provider, {
        value: props
    }, children);
};

});

parcelRegister("fiELF", function(module, exports) {

$parcel$export(module.exports, "BeforeFirstCell", () => $21d196b9ef151fec$export$bcb733e1e43aa5a8);

var $63Daq = parcelRequire("63Daq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $e9M6d = parcelRequire("e9M6d");

var $dSLRZ = parcelRequire("dSLRZ");

var $fiaaY = parcelRequire("fiaaY");

var $h9W1J = parcelRequire("h9W1J");
const $21d196b9ef151fec$export$bcb733e1e43aa5a8 = ({ edgeIndex: edgeIndex, issueId: issueId, itemsConnectionId: itemsConnectionId, hierarchyLevel: hierarchyLevel, parentIssueAri: parentIssueAri, parentIssueConnectionId: parentIssueConnectionId, issueKey: issueKey, projectKey: projectKey, isRowHovered: isRowHovered, issueRowData: issueRowData, setCurrentDraggingRow: setCurrentDraggingRow })=>{
    const { isFormVisible: isFormVisible } = (0, $dSLRZ.useSiblingIssueCreateRow)();
    const firstCellData = (0, $8Uumt.useFragment)((0, $63Daq.default), issueRowData);
    const isDragAndDropEnabled = (0, $e9M6d.useIsDragAndDropEnabled)();
    let isReparentingEnabled = false;
    if ((0, $4R6GH.fg)('jsc_list_reparenting')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isReparentingEnabled = (0, $e9M6d.useIsReparentingEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, // Check value instead of truthiness because it can be `undefined` if sibling issue create is disabled
    isFormVisible === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9W1J.SiblingIssueCreateButton), {
        edgeIndex: edgeIndex,
        issuesConnectionId: itemsConnectionId
    }), isDragAndDropEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiaaY.DragActionsButton), {
        edgeIndex: edgeIndex,
        issueId: issueId,
        isRowHovered: isRowHovered,
        parentIssueConnectionId: parentIssueConnectionId,
        ...isReparentingEnabled ? {
            hierarchyLevel: hierarchyLevel,
            parentIssueAri: parentIssueAri,
            issueKey: issueKey,
            projectKey: projectKey,
            firstCellData: firstCellData ?? null,
            itemsConnectionId: itemsConnectionId,
            setCurrentDraggingRow: setCurrentDraggingRow
        } : {
            firstCellData: null
        }
    }));
};

});
parcelRegister("63Daq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b3a82168c3cc4ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9abde640c438bf7b632fc8e21ea6b27b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7b3a82168c3cc4ab$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "beforeFirstCell_nativeIssueTable",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "dragActionsButton_nativeIssueTable"
        }
    ],
    "type": "JiraIssue"
};
$7b3a82168c3cc4ab$var$node.hash = "780f04e74d4c4e81616ebb05591db223";
var $7b3a82168c3cc4ab$export$2e2bcd8739ae039 = $7b3a82168c3cc4ab$var$node;

});

parcelRegister("fiaaY", function(module, exports) {

$parcel$export(module.exports, "DragActionsButton", () => $1b1539ba34a50494$export$d55b3c0033758134);

var $cBxS2 = parcelRequire("cBxS2");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $8Uumt = parcelRequire("8Uumt");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");
parcelRequire("2Uxmu");
var $hJNa8 = parcelRequire("hJNa8");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");

var $3JT92 = parcelRequire("3JT92");

var $57Zji = parcelRequire("57Zji");

var $7gWdR = parcelRequire("7gWdR");

var $jUlV7 = parcelRequire("jUlV7");

var $lXAdy = parcelRequire("lXAdy");

var $7mPT9 = parcelRequire("7mPT9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $fc4cz = parcelRequire("fc4cz");

var $e9M6d = parcelRequire("e9M6d");

var $czfFt = parcelRequire("czfFt");

var $kFnqi = parcelRequire("kFnqi");

var $hNxST = parcelRequire("hNxST");

var $66CrF = parcelRequire("66CrF");

var $jqcv8 = parcelRequire("jqcv8");

var $l1UlV = parcelRequire("l1UlV");

var $iANPM = parcelRequire("iANPM");

var $l2EkY = parcelRequire("l2EkY");

var $75jfh = parcelRequire("75jfh");
const $1b1539ba34a50494$var$styles = {
    button: "_1dqonqa1 _1h6dmuej _189ee4h9 _4t3i7vkz _1bsbdlk8 _16qs1cd0 _bfhkhp5a _syaz1fxt _80om1qgj _irr31a0f _1di6qctv _9h8h16c2 _1qam5szm"
}; // Negatively offset by 1px to account for the cell border
const $1b1539ba34a50494$var$offset = [
    (0, $czfFt.ROW_HEIGHT) / 2 - 1,
    -1
];
const $1b1539ba34a50494$var$BUTTON_SIZE = 16;
const $1b1539ba34a50494$var$IDLE_DRAGGABLE_STATE = 'idle';
const $1b1539ba34a50494$var$PREVIEW_DRAGGABLE_STATE = 'preview';
const $1b1539ba34a50494$var$DRAGGING_DRAGGABLE_STATE = 'dragging';
const $1b1539ba34a50494$var$isDropEdgeTarget = (dropTarget)=>'dropEdge' in dropTarget;
const $1b1539ba34a50494$export$d55b3c0033758134 = ({ edgeIndex: edgeIndex, issueId: issueId, hierarchyLevel: hierarchyLevel, parentIssueAri: parentIssueAri, parentIssueConnectionId: parentIssueConnectionId, issueKey: issueKey, projectKey: projectKey, isRowHovered: isRowHovered, firstCellData: firstCellData, itemsConnectionId: itemsConnectionId, setCurrentDraggingRow: setCurrentDraggingRow })=>{
    const dragPreviewData = (0, $8Uumt.useFragment)((0, $cBxS2.default), firstCellData);
    const buttonRef = (0, $5uXOq.useRef)(null);
    const [buttonState, setButtonState] = (0, $5uXOq.useState)($1b1539ba34a50494$var$IDLE_DRAGGABLE_STATE);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const [{ currentDropTarget: currentDropTarget, instanceId: instanceId, items: items }, { reorderRows: reorderRows }] = (0, $66CrF.useDraggableRows)();
    const isRowReorderingEnabled = (0, $e9M6d.useIsRowReorderingEnabled)();
    const isReparentingEnabled = (0, $e9M6d.useIsReparentingEnabled)();
    let isIssueRankingEnabled = false;
    if ((0, $4R6GH.fg)('jsc_list_reranking_gate_technical')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isIssueRankingEnabled = (0, $e9M6d.useIsIssueRankingEnabled)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isVisible = isDropdownOpen || isRowHovered || buttonState === $1b1539ba34a50494$var$DRAGGING_DRAGGABLE_STATE;
    const isDropTarget = currentDropTarget?.issueId === issueId;
    const [draggableState, setDraggableState] = (0, $5uXOq.useState)({
        type: $1b1539ba34a50494$var$IDLE_DRAGGABLE_STATE
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    (0, $5uXOq.useEffect)(()=>{
        if (!buttonRef.current) return;
        return (0, $7gWdR.draggable)({
            element: buttonRef.current,
            getInitialData () {
                return {
                    operation: (0, $czfFt.ROW_OPERATION_REORDER),
                    instanceId: instanceId,
                    issueId: issueId,
                    rowIndex: edgeIndex,
                    hierarchyLevel: hierarchyLevel,
                    parentIssueAri: parentIssueAri,
                    parentIssueConnectionId: parentIssueConnectionId,
                    itemsConnectionId: itemsConnectionId
                };
            },
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                // We need to make sure that the element not obfuscated by the sticky header
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $hJNa8.pointerOutsideOfPreview)({
                        x: "var(--ds-space-250, 20px)",
                        y: "var(--ds-space-250, 20px)"
                    }),
                    render ({ container: container }) {
                        setDraggableState({
                            type: $1b1539ba34a50494$var$PREVIEW_DRAGGABLE_STATE,
                            container: container
                        });
                        return ()=>setDraggableState({
                                type: $1b1539ba34a50494$var$IDLE_DRAGGABLE_STATE
                            });
                    }
                });
            },
            onDragStart () {
                if (isReparentingEnabled && itemsConnectionId && (0, $4R6GH.fg)('jsc_list_reparenting')) {
                    const itemKey = (0, $fc4cz.getItemKey)(itemsConnectionId, issueId);
                    setCurrentDraggingRow && setCurrentDraggingRow(itemKey);
                }
                setButtonState('dragging');
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dragged',
                    actionSubject: 'dragActionsButton',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            },
            onDrop () {
                if (isReparentingEnabled && (0, $4R6GH.fg)('jsc_list_reparenting')) setCurrentDraggingRow && setCurrentDraggingRow(null);
                buttonRef.current?.blur();
                setButtonState('idle');
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dropped',
                    actionSubject: 'dragActionsButton',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            }
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        issueId,
        hierarchyLevel,
        parentIssueAri,
        instanceId,
        itemsConnectionId,
        parentIssueConnectionId,
        setCurrentDraggingRow,
        isReparentingEnabled
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        if (parentIssueAri) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'changeParent');
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'addParent');
    }, [
        createAnalyticsEvent,
        parentIssueAri
    ]);
    const isFirstRow = edgeIndex === 0 && !parentIssueAri;
    const [isOnboardingVisible, setIsOnboardingVisible] = (0, $5uXOq.useState)(false);
    let handleSubmitReparenting;
    if ((0, $4R6GH.fg)('jsc_list_reparenting')) // eslint-disable-next-line react-hooks/rules-of-hooks
    handleSubmitReparenting = (0, $jqcv8.useReparentingFromModal)({
        projectKey: projectKey
    });
    const modalEntryPointProps = (0, $5uXOq.useMemo)(()=>({
            issueId: issueId,
            parentIssueAri: parentIssueAri,
            issueKey: issueKey,
            hierarchyLevel: hierarchyLevel,
            onSubmit: handleSubmitReparenting
        }), [
        handleSubmitReparenting,
        hierarchyLevel,
        issueId,
        issueKey,
        parentIssueAri
    ]);
    if (!issueKey && isReparentingEnabled && (0, $4R6GH.fg)('jsc_list_reparenting')) // if the issue key is empty, it indicates that it’s an optimistic row so we should not render the drag handler
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isOpen: isDropdownOpen,
        onOpenChange: (attrs)=>{
            setIsDropdownOpen(attrs.isOpen);
        },
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hNxST.RowPopupButton), {
                alignToYAxis: true,
                buttonSize: $1b1539ba34a50494$var$BUTTON_SIZE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($57Zji))), {
                    label: ""
                }),
                isVisible: isVisible || isOnboardingVisible,
                label: formatMessage((0, $75jfh.default).label),
                offset: $1b1539ba34a50494$var$offset,
                ref: (0, $7mPT9.mergeRefs)(triggerRef, buttonRef),
                xcss: (0, $3JT92.cx)($1b1539ba34a50494$var$styles.button),
                onClick: triggerProps.onClick
            }),
        testId: "native-issue-table.ui.row.before-first-cell.drag-actions-button.dropdown-menu"
    }, projectKey && (0, $4R6GH.fg)('jsc_list_reparenting') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXAdy.ModalEntryPointDropdownItemTrigger), {
        entryPoint: (0, $l1UlV.reparentModalEntryPoint),
        entryPointProps: modalEntryPointProps,
        entryPointParams: {
            cloudId: cloudId,
            projectKey: projectKey
        },
        interactionName: "open-reparent-issue-modal",
        useInternalModal: true,
        onClick: handleClick
    }, parentIssueAri ? formatMessage((0, $75jfh.default).changeParent) : formatMessage((0, $75jfh.default).addParent))), isRowReorderingEnabled && items.size > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        "data-testid": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reorder-menu-items"
    }, isIssueRankingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        isDisabled: edgeIndex === 0,
        onClick: ()=>{
            reorderRows(edgeIndex, 0);
        }
    }, formatMessage((0, $75jfh.default).moveToTop)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        isDisabled: edgeIndex === 0,
        onClick: ()=>{
            reorderRows(edgeIndex, edgeIndex - 1);
        }
    }, formatMessage((0, $75jfh.default).moveUp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        isDisabled: edgeIndex === items.size - 1,
        onClick: ()=>{
            reorderRows(edgeIndex, edgeIndex + 1);
        }
    }, formatMessage((0, $75jfh.default).moveDown)), isIssueRankingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        isDisabled: edgeIndex === items.size - 1,
        onClick: ()=>{
            reorderRows(edgeIndex, items.size - 1);
        }
    }, formatMessage((0, $75jfh.default).moveToBottom)))), isDropTarget && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kFnqi.RowDropIndicator), $1b1539ba34a50494$var$isDropEdgeTarget(currentDropTarget) ? {
        edge: currentDropTarget.dropEdge
    } : {
        instruction: currentDropTarget.dropInstruction
    }), draggableState.type === $1b1539ba34a50494$var$PREVIEW_DRAGGABLE_STATE && isReparentingEnabled && dragPreviewData && /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l2EkY.DragPreview), {
        issueId: (0, $jUlV7.JiraIssueAri).parse(issueId).issueId,
        itemsConnectionId: itemsConnectionId,
        summary: dragPreviewData.summary,
        issueTypeAvatarUrl: dragPreviewData.issueTypeField?.issueType?.avatar?.small
    }), draggableState.container), isFirstRow && isReparentingEnabled && buttonRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iANPM.ReparentingOnboarding), {
        buttonElement: buttonRef.current,
        setIsOnboardingVisible: setIsOnboardingVisible
    }));
};

});
parcelRegister("cBxS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d691cfab325c506$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<871b4d4d6f391f7645d8365104353e34>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0d691cfab325c506$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "dragActionsButton_nativeIssueTable",
    "selections": [
        {
            "condition": "isReparentingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "concreteType": "JiraIssueTypeField",
                    "kind": "LinkedField",
                    "name": "issueTypeField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "small"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$0d691cfab325c506$var$node.hash = "2c82d93dee43bfbb87413c0ffdd9f22b";
var $0d691cfab325c506$export$2e2bcd8739ae039 = $0d691cfab325c506$var$node;

});

parcelRegister("2Uxmu", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("hJNa8")).pointerOutsideOfPreview);

var $hJNa8 = parcelRequire("hJNa8");

});
parcelRegister("hJNa8", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => $4030604dbfde028c$export$427e20518819fabc);

var $6NnQH = parcelRequire("6NnQH");
function $4030604dbfde028c$export$427e20518819fabc(point) {
    return ({ container: container })=>{
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on iOS**
		 *
		 * On iOS, the browser will set the transparent border color to be black. We can provide a
		 * more polished experience not using the transparent border on iOS.
		 *
		 * While dragging, iOS will shift the drag preview under the center of the users pointer,
		 * so the "pushing away" of the preview is short lived on iOS anyway.
		 *
		 * Notes:
		 *
		 * - Tested on `iOS@18.4.1` on May 7th 2025
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a black border
		 * - The `<body>` text or background color does not change the black border color
		 */ if (!(0, $6NnQH.isSafariOnIOS)()) Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}

});
parcelRegister("6NnQH", function(module, exports) {

$parcel$export(module.exports, "isSafariOnIOS", () => $023dae56098ed162$export$52fc40c68fea4952);

var $jjNE9 = parcelRequire("jjNE9");

var $6aABs = parcelRequire("6aABs");
const $023dae56098ed162$export$52fc40c68fea4952 = (0, $jjNE9.once)(function isSafariOnIOS() {
    return (0, $6aABs.isSafari)() && 'ontouchend' in document;
});

});



parcelRegister("erBEN", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("kpXwZ")).setCustomNativeDragPreview);

var $kpXwZ = parcelRequire("kpXwZ");

});
parcelRegister("kpXwZ", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $39163240d699f88a$export$52d889c66db0f96e);

var $40DDD = parcelRequire("40DDD");

var $6aABs = parcelRequire("6aABs");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $39163240d699f88a$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $39163240d699f88a$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $39163240d699f88a$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $ff68169bc3de57ec$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $6aABs.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $40DDD.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $ff68169bc3de57ec$export$7d0a15ee70427305 = 2147483647;



parcelRegister("57Zji", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c021dd04da16bc130f1da0e63e621476>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bbd2a25619c0aa4$var$_react = $3bbd2a25619c0aa4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3bbd2a25619c0aa4$var$_baseNew = $3bbd2a25619c0aa4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3bbd2a25619c0aa4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bbd2a25619c0aa4$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $3bbd2a25619c0aa4$var$_react.default.createElement($3bbd2a25619c0aa4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5 2.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m4.5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M5 6a1.25 1.25 0 1 1-2.5 0A1.25 1.25 0 0 1 5 6m4.5 0A1.25 1.25 0 1 1 7 6a1.25 1.25 0 0 1 2.5 0M5 9.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m4.5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"/>`,
        type: 'utility'
    }, props));
$3bbd2a25619c0aa4$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $3bbd2a25619c0aa4$var$_default = module.exports.default = $3bbd2a25619c0aa4$var$DragHandleVerticalIcon;

});

parcelRegister("kFnqi", function(module, exports) {

$parcel$export(module.exports, "RowDropIndicator", () => $d5c9e16d7e5ffc89$export$fa88485e37d4f027);

var $5uXOq = parcelRequire("5uXOq");

var $5vhoG = parcelRequire("5vhoG");

var $5uJ9N = parcelRequire("5uJ9N");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $9CFBJ = parcelRequire("9CFBJ");

var $e9M6d = parcelRequire("e9M6d");

var $czfFt = parcelRequire("czfFt");

var $66CrF = parcelRequire("66CrF");
const $d5c9e16d7e5ffc89$export$feefd628b4f4feb5 = ({ instruction: instruction })=>{
    const width = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>scrollState.scrollWidth - (0, $66CrF.EXTRA_SPACE_PER_LEVEL));
    const isReParentingEnabled = (0, $e9M6d.useIsReparentingEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "native-issue-table.common.ui.row-drop-indicator.box",
        xcss: [
            $d5c9e16d7e5ffc89$var$boxStyles,
            $d5c9e16d7e5ffc89$var$dropIndicatorStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: `${width}px`
        },
        "data-row-drop-indicator": true
    }, isReParentingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5vhoG.DropIndicator), {
        instruction: instruction
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uJ9N.DropIndicator), {
        edge: instruction.type === (0, $czfFt.REORDER_ABOVE) ? 'top' : 'bottom'
    }));
};
const $d5c9e16d7e5ffc89$export$d508f4eb766c5ef8 = ({ edge: edge })=>{
    const width = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>scrollState.width);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "native-issue-table.common.ui.row-drop-indicator.box",
        xcss: [
            $d5c9e16d7e5ffc89$var$boxStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: `${width}px`
        },
        "data-row-drop-indicator": true
    }, edge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uJ9N.DropIndicator), {
        edge: edge
    }));
};
const $d5c9e16d7e5ffc89$export$fa88485e37d4f027 = /*#__PURE__*/ (0, $5uXOq.memo)(({ edge: edge, instruction: instruction })=>{
    if (instruction && (0, $4R6GH.fg)('jsc_list_reparenting')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d5c9e16d7e5ffc89$export$feefd628b4f4feb5, {
        instruction: instruction
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d5c9e16d7e5ffc89$export$d508f4eb766c5ef8, {
        edge: edge
    });
});
const $d5c9e16d7e5ffc89$var$boxStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.0',
    bottom: 'space.0',
    // Negatively offset by 1px to account for the cell border
    left: '-1px',
    pointerEvents: 'none'
});
const $d5c9e16d7e5ffc89$var$dropIndicatorStyles = (0, $8CUq3.xcss)({
    left: 'space.050',
    width: '100%',
    zIndex: 'tooltip'
});

});
parcelRegister("5vhoG", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $1176513858724da8$export$62ed72bc21f6b8a6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kOHxT = parcelRequire("kOHxT");

var $5uJ9N = parcelRequire("5uJ9N");
function $1176513858724da8$var$getElement({ instruction: instruction, isBlocked: isBlocked }) {
    const indent = `${instruction.currentLevel * instruction.indentPerLevel}px`;
    const appearance = isBlocked ? 'warning' : 'default';
    if (instruction.type === 'reorder-above') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uJ9N.DropIndicator), {
        edge: "top",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reorder-below') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uJ9N.DropIndicator), {
        edge: "bottom",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'make-child') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kOHxT.DropIndicator), {
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reparent') {
        const reparentIndent = `${instruction.desiredLevel * instruction.indentPerLevel}px`;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uJ9N.DropIndicator), {
            edge: "bottom",
            appearance: appearance,
            indent: reparentIndent
        });
    }
    return null;
}
function $1176513858724da8$export$62ed72bc21f6b8a6({ instruction: instruction }) {
    if (instruction.type === 'instruction-blocked') return $1176513858724da8$var$getElement({
        instruction: instruction.desired,
        isBlocked: true
    });
    return $1176513858724da8$var$getElement({
        instruction: instruction,
        isBlocked: false
    });
}

});
parcelRegister("kOHxT", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $4bfe81de297be269$export$62ed72bc21f6b8a6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $aUWFB = parcelRequire("aUWFB");

var $choBO = parcelRequire("choBO");
function $4bfe81de297be269$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', indent: indent }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aUWFB.Border), {
        strokeColor: (0, $choBO.presetStrokeColors)[appearance],
        indent: indent
    });
}
var // For React.lazy
$4bfe81de297be269$export$2e2bcd8739ae039 = $4bfe81de297be269$export$62ed72bc21f6b8a6;

});
parcelRegister("aUWFB", function(module, exports) {

$parcel$export(module.exports, "Border", () => $dabba09cdf2af051$export$d8e9c9d63e86d41e);
/* border.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $choBO = parcelRequire("choBO");
const $dabba09cdf2af051$var$styles = null;
function $dabba09cdf2af051$export$d8e9c9d63e86d41e({ strokeColor: strokeColor = (0, $choBO.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $choBO.presetStrokeWidth), borderRadius: borderRadius = '3px', indent: // TODO: update to border.radius (4px) token
indent = '0px' }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            '--border-radius': borderRadius,
            '--indent': indent
        },
        className: (0, $bwpsq.default)([
            "_19it1ebc _2rko1koq _kqswstnw _152tidpf _u7coidpf _rjxpidpf _1e02armj _lcxvglyw"
        ])
    });
}
var // For React.lazy
$dabba09cdf2af051$export$2e2bcd8739ae039 = $dabba09cdf2af051$export$d8e9c9d63e86d41e;

});
parcelRegister("choBO", function(module, exports) {

$parcel$export(module.exports, "presetStrokeColors", () => $9f99301ec58274c5$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $9f99301ec58274c5$export$45db03aa04b685e3);
const $9f99301ec58274c5$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #0C66E4)",
    warning: "var(--ds-border-warning, #E56910)"
};
const $9f99301ec58274c5$export$45db03aa04b685e3 = "var(--ds-border-width-outline, 2px)";

});



parcelRegister("5uJ9N", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $057503bea847bf4c$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $057503bea847bf4c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $40bhS = parcelRequire("40bhS");

var $choBO = parcelRequire("choBO");
function $057503bea847bf4c$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $40bhS.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $choBO.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$057503bea847bf4c$export$2e2bcd8739ae039 = $057503bea847bf4c$export$62ed72bc21f6b8a6;

});
parcelRegister("40bhS", function(module, exports) {

$parcel$export(module.exports, "Line", () => $5554523a258e458d$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $choBO = parcelRequire("choBO");
const $5554523a258e458d$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $5554523a258e458d$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $5554523a258e458d$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $5554523a258e458d$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $5554523a258e458d$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $5554523a258e458d$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $choBO.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $choBO.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $5554523a258e458d$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $5554523a258e458d$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $bwpsq.default)([
            $5554523a258e458d$var$baseStyles.root,
            $5554523a258e458d$var$orientationStyles[orientation],
            $5554523a258e458d$var$edgeStyles[edge]
        ])
    });
}
var // For React.lazy
$5554523a258e458d$export$2e2bcd8739ae039 = $5554523a258e458d$export$17d680238e50603e;

});




parcelRegister("hNxST", function(module, exports) {

$parcel$export(module.exports, "RowPopupButton", () => $d00f2ce169b16be8$export$960d0282617d39c3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $3JT92 = parcelRequire("3JT92");

var $gkD4s = parcelRequire("gkD4s");
var $1V7PR = parcelRequire("1V7PR");

var $dC5iT = parcelRequire("dC5iT");

var $3Lty3 = parcelRequire("3Lty3");

var $3bDjY = parcelRequire("3bDjY");

var $7mPT9 = parcelRequire("7mPT9");

var $7pDxf = parcelRequire("7pDxf");

var $4R6GH = parcelRequire("4R6GH");
const $d00f2ce169b16be8$var$styles = {
    reference: "_1ltvze3t _154ize3t",
    visuallyHidden: "_19itglyw _1reo15vq _18m915vq _1bsbt94y _4t3it94y _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _kqswstnw _mkrz1ly6 _o5721q9c"
};
const $d00f2ce169b16be8$var$buttonStyles = {
    root: "_1e0c1txw _1bah1h6o _4cvr1h6o _1pby1nn1",
    default: "_2rkoglpi _bfhk1bhr _80omtlke _irr316qz _1di6vq0a"
};
const $d00f2ce169b16be8$var$constantModifiers = [
    {
        name: 'flip',
        enabled: false
    }
];
// Height/width of the popup button
const $d00f2ce169b16be8$var$DEFAULT_BUTTON_SIZE = 24;
// Height/width of the reference element the popup button is anchored to
const $d00f2ce169b16be8$var$REFERENCE_SIZE = 1;
const $d00f2ce169b16be8$export$960d0282617d39c3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
    const { icon: icon, isVisible: isVisible, label: label, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, tooltipContent: tooltipContent, alignToYAxis: alignToYAxis = true, buttonSize: buttonSize = $d00f2ce169b16be8$var$DEFAULT_BUTTON_SIZE, offset: offset = [
        0,
        0
    ], xcss: xcss } = props;
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const updateRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Recompute popup position when the button is shown
        isVisible && updateRef.current?.();
    }, [
        isVisible
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Recompute popup position when the button is focused
        isFocused && updateRef.current?.();
    }, [
        isFocused
    ]);
    const [along, away] = offset;
    const finalOffset = (0, $5uXOq.useMemo)(()=>// Negatively offset the popup by the button + reference size to center the button on the secondary axis
        [
            along,
            away - (buttonSize + $d00f2ce169b16be8$var$REFERENCE_SIZE) / 2
        ], [
        along,
        away,
        buttonSize
    ]);
    const modifiers = (0, $5uXOq.useMemo)(()=>{
        // Adjust the overflow calculation for the primary axis so it is relative to the center of the button.
        const alongCenterOffset = -(buttonSize / 2);
        // Retain the provided offset for the secondary axis
        const padding = alignToYAxis ? {
            left: finalOffset[1],
            top: alongCenterOffset,
            bottom: alongCenterOffset
        } : {
            top: finalOffset[1],
            left: alongCenterOffset,
            right: alongCenterOffset
        };
        return [
            ...$d00f2ce169b16be8$var$constantModifiers,
            {
                name: 'preventOverflow',
                options: {
                    mainAxis: true,
                    altAxis: true,
                    padding: padding,
                    altBoundary: true,
                    rootBoundary: 'viewport',
                    tether: false
                }
            },
            {
                name: 'eventListeners',
                options: {
                    // Only recompute position on scroll/resize events while the button is visible to reduce CPU load
                    scroll: (0, $4R6GH.fg)('jsc-1389-fix-drag-handler-focus-changes') ? isVisible : isFocused,
                    resize: (0, $4R6GH.fg)('jsc-1389-fix-drag-handler-focus-changes') ? isVisible : isFocused
                }
            }
        ];
    }, [
        alignToYAxis,
        buttonSize,
        finalOffset,
        isFocused,
        isVisible
    ]);
    // Ensure a stable ref function is passed through to the trigger button
    const memoizedMergeRefs = (0, $5uXOq.useMemo)(()=>(0, $8QpSo.default)((0, $7mPT9.mergeRefs)), []);
    const isVisuallyHidden = !isVisible && !isFocused;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkD4s.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1V7PR.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: (0, $3JT92.cx)($d00f2ce169b16be8$var$styles.reference, $d00f2ce169b16be8$var$styles.visuallyHidden),
            ref: ref
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7pDxf.JiraPopper), {
        placement: alignToYAxis ? 'right' : 'bottom',
        modifiers: modifiers,
        offset: finalOffset,
        messageId: "native-issue-table.common.ui.row-popup-button.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: tooltipContent,
            canAppear: ()=>tooltipContent != null
        }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Lty3.default), {
                ...triggerProps,
                "aria-label": label,
                testId: `native-issue-table.common.ui.row-popup-button.pressable${isVisuallyHidden ? '-hidden' : ''}`,
                xcss: (0, $3JT92.cx)($d00f2ce169b16be8$var$buttonStyles.root, $d00f2ce169b16be8$var$buttonStyles.default, // See https://atlassian.design/components/css/overview#building-reusable-components
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                xcss, isVisuallyHidden && $d00f2ce169b16be8$var$styles.visuallyHidden),
                onClick: (e, analyticEvent)=>{
                    onClick?.(e, analyticEvent);
                    triggerProps.onClick(e);
                },
                onFocus: (e)=>{
                    setIsFocused(true);
                    triggerProps.onFocus(e);
                },
                onBlur: (e)=>{
                    setIsFocused(false);
                    triggerProps.onBlur(e);
                },
                onMouseMove: (e)=>{
                    // Stop propagation so the button isn't inadvertently hidden when hovering
                    e.stopPropagation();
                    triggerProps.onMouseMove?.(e);
                },
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                ref: memoizedMergeRefs(ref, triggerProps.ref, forwardedRef),
                // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
                style: style
            }, icon));
    }));
});

});
parcelRegister("7pDxf", function(module, exports) {

$parcel$export(module.exports, "JiraPopper", () => $5dfb0b72e9322fa3$export$23789575ac361b5d);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $4oNEb = parcelRequire("4oNEb");

var $10xFf = parcelRequire("10xFf");

var $jW2j1 = parcelRequire("jW2j1");
const $5dfb0b72e9322fa3$export$23789575ac361b5d = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jW2j1.ChoreographerPopper), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oNEb.Popper), rest);
};

});
parcelRegister("jW2j1", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopper", () => $577b12f0a509cc55$export$6077de4a190b560c);
// eslint-disable-next-line jira/restricted/react-component-props

var $4oNEb = parcelRequire("4oNEb");

var $cSWNW = parcelRequire("cSWNW");
const $577b12f0a509cc55$export$6077de4a190b560c = (0, $cSWNW.withChoreographedRender)((0, $4oNEb.Popper));

});



parcelRegister("jqcv8", function(module, exports) {

$parcel$export(module.exports, "useReparentingFromModal", () => $d0f463badae9806a$export$7ed8dfd115f70801);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $jUlV7 = parcelRequire("jUlV7");

var $koeKL = parcelRequire("koeKL");

var $pa9q9 = parcelRequire("pa9q9");

var $cAo1S = parcelRequire("cAo1S");

var $czfFt = parcelRequire("czfFt");

var $debr5 = parcelRequire("debr5");
const $d0f463badae9806a$export$7ed8dfd115f70801 = ({ projectKey: projectKey })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const updateParentConnections = (0, $cAo1S.useGetReparentUpdater)();
    return (0, $5uXOq.useCallback)((updatedIssues, newParentId, newIssueParent, requestPromise)=>{
        if (updatedIssues.length) {
            const upatedIssue = updatedIssues[0];
            if (upatedIssue.id) {
                const ariIssueId = (0, $jUlV7.JiraIssueAri).create({
                    issueId: upatedIssue.id,
                    siteId: cloudId
                }).toString();
                (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
                    updateParentConnections({
                        store: store,
                        issueId: ariIssueId,
                        oldParentId: upatedIssue.parentId,
                        newParentId: newParentId,
                        index: 0,
                        projectKey: projectKey
                    });
                });
                requestPromise.catch((error)=>{
                    // Rollback
                    (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
                        updateParentConnections({
                            store: store,
                            issueId: ariIssueId,
                            oldParentId: newParentId,
                            newParentId: upatedIssue.parentId,
                            index: 0,
                            projectKey: projectKey
                        });
                    });
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'issueTableReparentMutationFromModal',
                            packageName: (0, $czfFt.PACKAGE_NAME),
                            teamName: (0, $czfFt.TEAM_NAME)
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    showFlag((0, $debr5.UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG));
                });
            }
        }
    }, [
        cloudId,
        environment,
        projectKey,
        showFlag,
        updateParentConnections
    ]);
};

});

parcelRegister("l1UlV", function(module, exports) {

$parcel$export(module.exports, "reparentModalEntryPoint", () => $48650b7e258bdbf1$export$e5e5cbbac06953a1);

var $hBruS = parcelRequire("hBruS");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $48650b7e258bdbf1$export$e5e5cbbac06953a1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("fskez")), {
        moduleId: "a7705f96"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>({
            queries: {
                projectData: {
                    parameters: $hBruS.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("fskez", function(module, exports) {

let $b4092a9b58b85102$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4092a9b58b85102$var$load("eILt2").then(()=>parcelRequire('kiGd7'));

});


parcelRegister("iANPM", function(module, exports) {

$parcel$export(module.exports, "ReparentingOnboarding", () => $7a4c1c969ffae6e2$export$18bcadaeddef642);

var $5uXOq = parcelRequire("5uXOq");

var $kbqIt = parcelRequire("kbqIt");

var $1QiBP = parcelRequire("1QiBP");

var $dC5iT = parcelRequire("dC5iT");

var $hxoiH = parcelRequire("hxoiH");

var $ioD1B = parcelRequire("ioD1B");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $bhg9n = parcelRequire("bhg9n");

var $2CmuS = parcelRequire("2CmuS");

var $bWRre = parcelRequire("bWRre");
const $7a4c1c969ffae6e2$export$ae06398c30161061 = 'jira-list-nin-reparent-onboarding-stg';
const $7a4c1c969ffae6e2$export$c63f3f365035b47c = 'jira-list-nin-reparent-onboarding';
const $7a4c1c969ffae6e2$var$ENV_STAGING = 'staging';
const $7a4c1c969ffae6e2$var$STARGATE_URL = '/gateway/api';
const $7a4c1c969ffae6e2$export$18bcadaeddef642 = ({ buttonElement: buttonElement, setIsOnboardingVisible: setIsOnboardingVisible })=>{
    const ONBOARDING_ENGAGEMENT_ID = (0, $2tT7R.useEnvironment)() === $7a4c1c969ffae6e2$var$ENV_STAGING ? $7a4c1c969ffae6e2$export$ae06398c30161061 : $7a4c1c969ffae6e2$export$c63f3f365035b47c;
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const spotlight = colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($bWRre))) : (0, (/*@__PURE__*/$parcel$interopDefault($2CmuS)));
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(false);
    const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, $7a4c1c969ffae6e2$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $kbqIt.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $5uXOq.useEffect)(()=>{
        if (isEnrolled) {
            setIsOnboardingVisible(true);
            stopEnrolment(false);
            setTimeout(()=>{
                setIsSpotlightActive(true);
            }, 50);
        }
    }, [
        isEnrolled,
        setIsOnboardingVisible,
        stopEnrolment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isSpotlightActive && buttonElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onMouseOver: (event)=>{
            event.stopPropagation();
        },
        onMouseLeave: (event)=>{
            event.stopPropagation();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        image: spotlight,
        messageId: "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.jira-spotlight.expand-column-header",
        messageType: "engagement",
        actions: [
            {
                onClick: ()=>{
                    setIsSpotlightActive(false);
                    setIsOnboardingVisible(false);
                },
                text: formatMessage((0, $bhg9n.default).dismiss)
            }
        ],
        dialogWidth: 270,
        heading: formatMessage((0, $bhg9n.default).onboardingHeading),
        targetNode: buttonElement,
        targetRadius: 3,
        key: "reparenting-onboarding"
    }, formatMessage((0, $bhg9n.default).onboardingDescription)))));
};

});
parcelRegister("bhg9n", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf91a7ac9450825d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cf91a7ac9450825d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    onboardingHeading: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.onboarding-heading",
        "defaultMessage": "Re-parent work items"
    },
    onboardingDescription: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.onboarding-description",
        "defaultMessage": "Select and move a work item to add, or change, the parent."
    },
    dismiss: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});

parcelRegister("2CmuS", function(module, exports) {
module.exports = new URL("reparent-onboarding-light.f5faa58e.gif", import.meta.url).toString();

});

parcelRegister("bWRre", function(module, exports) {
module.exports = new URL("reparent-onboarding-dark.ad59f27a.gif", import.meta.url).toString();

});


parcelRegister("l2EkY", function(module, exports) {

$parcel$export(module.exports, "DragPreview", () => $ddb140b3fa393bd2$export$905ab40ac2179daa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $fc4cz = parcelRequire("fc4cz");
const $ddb140b3fa393bd2$var$MAX_ISSUE_COUNT = 99;
const $ddb140b3fa393bd2$export$905ab40ac2179daa = ({ summary: summary, issueTypeAvatarUrl: issueTypeAvatarUrl, issueId: issueId, itemsConnectionId: itemsConnectionId })=>{
    const [{ listMetadata: listMetadata, connectionMap: connectionMap, connectionItems: connectionItems }] = (0, $fc4cz.useHierarchyStore)();
    const [isExpanded] = (0, $fc4cz.useIsItemExpanded)({
        itemId: issueId,
        itemsConnectionId: itemsConnectionId || ''
    });
    const childCount = (0, $5uXOq.useMemo)(()=>{
        if (isExpanded) {
            const itemKey = listMetadata.find((element)=>element.itemId === issueId)?.key || '';
            const keyConnection = connectionMap[itemKey];
            const itemConnectionItems = keyConnection ? connectionItems[keyConnection] || [] : [];
            return itemConnectionItems.length ? (0, $fc4cz.filterNonIssueItems)(itemConnectionItems.map((item)=>item.itemId)).length || 0 : 0;
        }
        return 0;
    }, [
        connectionItems,
        connectionMap,
        isExpanded,
        issueId,
        listMetadata
    ]);
    const showChildIssues = childCount > 0;
    const hasMoreThanOneChild = childCount > 1;
    const countIncludingParent = childCount > 0 ? childCount + 1 : 0;
    const hasLessThanMaxIssueCount = countIncludingParent < $ddb140b3fa393bd2$var$MAX_ISSUE_COUNT;
    const roundedIssueCount = hasLessThanMaxIssueCount ? countIncludingParent : $ddb140b3fa393bd2$var$MAX_ISSUE_COUNT;
    return summary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ddb140b3fa393bd2$var$rootStyles
    }, showChildIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, hasMoreThanOneChild ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $ddb140b3fa393bd2$var$listItemStyles,
            $ddb140b3fa393bd2$var$child2Styles
        ]
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $ddb140b3fa393bd2$var$listItemStyles,
            $ddb140b3fa393bd2$var$child1Styles
        ]
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $ddb140b3fa393bd2$var$listItemStyles,
            $ddb140b3fa393bd2$var$primaryItemStyles
        ]
    }, showChildIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: hasLessThanMaxIssueCount ? $ddb140b3fa393bd2$var$badgeStyles : [
            $ddb140b3fa393bd2$var$badgeStyles,
            $ddb140b3fa393bd2$var$smallContentStyles
        ],
        alignItems: "center",
        justifyContent: "center"
    }, hasLessThanMaxIssueCount ? roundedIssueCount : `${roundedIssueCount}+`) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $ddb140b3fa393bd2$var$innerStyles,
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center"
    }, issueTypeAvatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: issueTypeAvatarUrl,
        alt: "",
        className: (0, $bwpsq.default)([
            "_4t3ipxbi _1bsbpxbi"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ddb140b3fa393bd2$var$textStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        maxLines: 1
    }, summary)))))) : null;
};
const $ddb140b3fa393bd2$var$MAX_WIDTH = 300;
const $ddb140b3fa393bd2$var$rootStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    width: `${$ddb140b3fa393bd2$var$MAX_WIDTH}px`
});
const $ddb140b3fa393bd2$var$listItemStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface',
    boxShadow: 'elevation.shadow.overlay',
    position: 'absolute',
    height: 'size.400',
    width: `${$ddb140b3fa393bd2$var$MAX_WIDTH}px`
});
const $ddb140b3fa393bd2$var$primaryItemStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.200',
    backgroundColor: 'color.background.input'
});
const $ddb140b3fa393bd2$var$innerStyles = (0, $8CUq3.xcss)({
    height: '100%'
});
const $ddb140b3fa393bd2$var$textStyle = (0, $8CUq3.xcss)({
    maxWidth: '220px'
});
const $ddb140b3fa393bd2$var$imageStyles = null;
const $ddb140b3fa393bd2$var$child1Styles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    left: 'space.075',
    top: 'space.075'
});
const $ddb140b3fa393bd2$var$child2Styles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    left: 'space.150',
    top: 'space.150'
});
const $ddb140b3fa393bd2$var$badgeStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.negative.150',
    right: 'space.negative.150',
    borderRadius: 'border.radius.circle',
    backgroundColor: 'color.background.accent.red.bolder',
    width: 'size.200',
    height: 'size.200',
    color: 'color.text.inverse'
});
const $ddb140b3fa393bd2$var$smallContentStyles = (0, $8CUq3.xcss)({
    font: 'font.body.small'
});

});

parcelRegister("75jfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a923522095be0c9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1a923522095be0c9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.label",
        "defaultMessage": "Actions"
    },
    addParent: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.add-parent",
        "defaultMessage": "Add parent"
    },
    changeParent: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.change-parent",
        "defaultMessage": "Change parent"
    },
    moveToTop: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-to-top",
        "defaultMessage": "Move to top"
    },
    moveUp: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-up",
        "defaultMessage": "Move up"
    },
    moveDown: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-down",
        "defaultMessage": "Move down"
    },
    moveToBottom: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-to-bottom",
        "defaultMessage": "Move to bottom"
    }
});

});


parcelRegister("h9W1J", function(module, exports) {

$parcel$export(module.exports, "SiblingIssueCreateButton", () => $be8b8c431d01b1a9$export$76f0c0887f3df38d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $99M5v = parcelRequire("99M5v");

var $koVbs = parcelRequire("koVbs");

var $kFnqi = parcelRequire("kFnqi");

var $hNxST = parcelRequire("hNxST");

var $fh5X0 = parcelRequire("fh5X0");


var $dSLRZ = parcelRequire("dSLRZ");

var $1vUhc = parcelRequire("1vUhc");
const $be8b8c431d01b1a9$var$styles = {
    button: "_1dqonqa1 _189ee4h9 _1h6dmuej _4t3i1tcg _1bsb1tcg _kqswh2mm _16qs1cd0"
};
const $be8b8c431d01b1a9$var$offset = [
    -1,
    -1
]; /**
                                            * Display a 'Create' popup button positioned relative to the nearest containing block that will appear when hovering
                                            * between issue rows.
                                            */ 
const $be8b8c431d01b1a9$export$76f0c0887f3df38d = ({ issuesConnectionId: issuesConnectionId, edgeIndex: edgeIndex })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isInlineIssueCreateActive, { lockIndex: lockIndex, clearIndexAfterDelay: clearIndexAfterDelay }] = (0, $fh5X0.useIsSiblingIssueCreateActive)([
        issuesConnectionId,
        edgeIndex
    ]);
    const [isMouseOverSiblingCreate, setIsMouseOverSiblingCreate] = (0, $5uXOq.useState)(false);
    const { triggerProps: triggerProps } = (0, $dSLRZ.useSiblingIssueCreateRow)();
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsMouseOverSiblingCreate(true);
        lockIndex((0, $ba4a319520d566ae$export$76a449e52fa0e1e8));
    }, [
        lockIndex
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsMouseOverSiblingCreate(false);
        clearIndexAfterDelay((0, $ba4a319520d566ae$export$76a449e52fa0e1e8));
    }, [
        clearIndexAfterDelay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hNxST.RowPopupButton), {
        alignToYAxis: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            label: "",
            LEGACY_size: "small"
        }),
        isVisible: isInlineIssueCreateActive,
        label: formatMessage((0, $1vUhc.default).createLabel),
        offset: $be8b8c431d01b1a9$var$offset,
        onClick: triggerProps?.onClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: triggerProps?.ref,
        tooltipContent: formatMessage((0, $1vUhc.default).createLabel),
        xcss: $be8b8c431d01b1a9$var$styles.button
    }), isMouseOverSiblingCreate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kFnqi.RowDropIndicator), {
        edge: "top"
    }));
};

});
parcelRegister("1vUhc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3930c90a57f5d05e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3930c90a57f5d05e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createLabel: {
        "id": "native-issue-table.ui.row.before-first-cell.sibling-issue-create-button.create-label",
        "defaultMessage": "Create"
    }
});

});



parcelRegister("4kgUO", function(module, exports) {

$parcel$export(module.exports, "default", () => $23a92e24a99ac5ff$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $1v6c5 = parcelRequire("1v6c5");

var $e9M6d = parcelRequire("e9M6d");

var $5DTiT = parcelRequire("5DTiT");

var $dMukY = parcelRequire("dMukY");
const $23a92e24a99ac5ff$var$BlankIssueRow = ({ isSelected: isSelected, cellBorder: cellBorder })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { columns: columns } = (0, $5DTiT.useRowContext)();
    const isFixedTableLayoutEnabled = (0, $e9M6d.useIsFixedTableLayoutEnabled)();
    // Extra column added to account for the blank spacer column added to the table
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1v6c5.TableCell), {
        colSpan: columns.length + (isFixedTableLayoutEnabled ? 1 : 0),
        border: cellBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23a92e24a99ac5ff$var$Text, {
        isSelected: isSelected
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dMukY.default).blankRowTextWithArchiveIssueIssueTermRefresh : (0, $dMukY.default).blankRowTextWithArchiveIssue)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "blankIssue"
    }));
};
var $23a92e24a99ac5ff$export$2e2bcd8739ae039 = $23a92e24a99ac5ff$var$BlankIssueRow;
const $23a92e24a99ac5ff$var$textColorActiveState = "var(--ds-text-selected, #0C66E4)";
const $23a92e24a99ac5ff$var$textColor = "var(--ds-text, #172B4D)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23a92e24a99ac5ff$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bv1b66 _80om73ad",
            __cmplp.isSelected ? "_syazaqb7" : "_syaz1fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dMukY", function(module, exports) {

$parcel$export(module.exports, "default", () => $46c5eade6703ecdb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $46c5eade6703ecdb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    blankRow: {
        "id": "native-issue-table.issue-row.blank-row.blank-row",
        "defaultMessage": "We can't display this issue"
    },
    blankRowText: {
        "id": "native-issue-table.row.blank-row.blank-row-text",
        "defaultMessage": "This issue cannot be opened because it may have been deleted or you do not have access to it"
    },
    blankRowTextWithArchiveIssue: {
        "id": "native-issue-table.row.blank-row.blank-row-text-with-archive-issue",
        "defaultMessage": "This issue can\u2019t be opened because it may have been archived or deleted, or you don\u2019t have access to it."
    },
    blankRowTextWithArchiveIssueIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.blank-row-text-with-archive-issue-issue-term-refresh",
        "defaultMessage": "This work item can\u2019t be opened because it may have been archived or deleted, or you don\u2019t have access to it."
    },
    tooltip: {
        "id": "native-issue-table.issue-row.blank-row.tooltip",
        "defaultMessage": "Either this issue has been deleted, or you don\u2019t have access to it."
    },
    blankRowIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.blank-row-issue-term-refresh",
        "defaultMessage": "We can't display this work item"
    },
    blankRowTextIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.blank-row-text-issue-term-refresh",
        "defaultMessage": "This work item cannot be opened because it may have been deleted or you do not have access to it."
    },
    tooltipIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.tooltip-issue-term-refresh",
        "defaultMessage": "Either this work item has been deleted, or you don\u2019t have access to it."
    }
});

});


parcelRegister("hBooe", function(module, exports) {

$parcel$export(module.exports, "IssueCreateRow", () => $5c59e482a8bf341d$export$a7c20b50f3f5d02c);

var $5uXOq = parcelRequire("5uXOq");

var $cG7gD = parcelRequire("cG7gD");
const $5c59e482a8bf341d$export$a7c20b50f3f5d02c = ({ isFormVisible: isFormVisible, ...props })=>{
    return isFormVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cG7gD.IssueCreateCell), props));
};

});
parcelRegister("cG7gD", function(module, exports) {

$parcel$export(module.exports, "IssueCreateCell", () => $6559177b4d0a3729$export$2337c3632571bf46);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8wqxH = parcelRequire("8wqxH");

var $6s1PB = parcelRequire("6s1PB");

var $e9M6d = parcelRequire("e9M6d");

var $9CFBJ = parcelRequire("9CFBJ");

var $4BEu7 = parcelRequire("4BEu7");
const $6559177b4d0a3729$export$2337c3632571bf46 = ({ issuesConnectionId: issuesConnectionId, siblingIssueId: siblingIssueId, parentIssueAri: parentIssueAri, ...props })=>{
    const width = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>scrollState.width);
    let jql;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    jql = (0, $e9M6d.useJql)();
    const isIssueRankDescending = (0, $e9M6d.useIsIssueRankDescending)();
    // JSC-169 Set rankFieldId into formContextualFields so correct rank is set for GIC fallback
    const formContextualFields = (0, $5uXOq.useMemo)(()=>isIssueRankDescending ? {
            rankAfterIssueId: siblingIssueId
        } : {
            rankBeforeIssueId: siblingIssueId
        }, [
        isIssueRankDescending,
        siblingIssueId
    ]);
    const onCreateIssue = (0, $4BEu7.useIssueCreateMutation)({
        issueConnectionId: issuesConnectionId,
        jql: jql
    });
    const handleIssueCreate = (0, $5uXOq.useCallback)((issueToCreate, contextualFields)=>{
        onCreateIssue(issueToCreate, {
            ...contextualFields,
            ...parentIssueAri && {
                parentIssueAri: parentIssueAri
            }
        }, {
            insertAfter: false,
            insertNodeId: siblingIssueId
        });
    }, [
        onCreateIssue,
        parentIssueAri,
        siblingIssueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "td",
        xcss: $6559177b4d0a3729$var$cellStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6559177b4d0a3729$var$boxStyles,
        style: {
            width: `${width}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wqxH.default), {
        contextualFields: formContextualFields,
        onCreateIssue: handleIssueCreate,
        ...props
    })));
};
const $6559177b4d0a3729$var$cellStyles = (0, $8CUq3.xcss)({
    height: '40px',
    left: 'space.0',
    position: 'sticky',
    zIndex: 'card'
});
const $6559177b4d0a3729$var$boxStyles = (0, $8CUq3.xcss)({
    left: 'space.0',
    position: 'absolute',
    top: 'space.0'
});

});


parcelRegister("lMLWW", function(module, exports) {

$parcel$export(module.exports, "IssueRow", () => $d6183e77fafb3f2f$export$29013dcb6d1b879d);

var $gxp46 = parcelRequire("gxp46");

var $7GNCS = parcelRequire("7GNCS");

var $ggp2a = parcelRequire("ggp2a");

var $jyDou = parcelRequire("jyDou");

var $5uXOq = parcelRequire("5uXOq");

var $7hpBk = parcelRequire("7hpBk");

var $8Rkzz = parcelRequire("8Rkzz");

var $gJBT6 = parcelRequire("gJBT6");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $g5X3G = parcelRequire("g5X3G");

var $65VLO = parcelRequire("65VLO");

var $jcw0u = parcelRequire("jcw0u");

var $2NMNM = parcelRequire("2NMNM");

var $czfFt = parcelRequire("czfFt");

var $4c7oE = parcelRequire("4c7oE");

var $14NPb = parcelRequire("14NPb");

var $3JOwB = parcelRequire("3JOwB");

var $bKdpc = parcelRequire("bKdpc");

var $1ujU3 = parcelRequire("1ujU3");

var $g3xK5 = parcelRequire("g3xK5");

var $fiheM = parcelRequire("fiheM");

var $fMqn0 = parcelRequire("fMqn0");

var $8mdOM = parcelRequire("8mdOM");

var $kzYGs = parcelRequire("kzYGs");

var $jc00M = parcelRequire("jc00M");

var $3ljzH = parcelRequire("3ljzH");

var $1Yk7g = parcelRequire("1Yk7g");

var $iMwsC = parcelRequire("iMwsC");

var $fRR6R = parcelRequire("fRR6R");

var $bRJBd = parcelRequire("bRJBd");

var $hxR1y = parcelRequire("hxR1y");

var $k2wrj = parcelRequire("k2wrj");

var $gzMyH = parcelRequire("gzMyH");

var $7zHDm = parcelRequire("7zHDm");

var $kNCQ8 = parcelRequire("kNCQ8");

var $lExf8 = parcelRequire("lExf8");

var $dM1CQ = parcelRequire("dM1CQ");

var $dCYi9 = parcelRequire("dCYi9");

var $8L8tK = parcelRequire("8L8tK");

var $jC6NH = parcelRequire("jC6NH");

var $cs56G = parcelRequire("cs56G");

var $4q4lw = parcelRequire("4q4lw");

var $9Xsfm = parcelRequire("9Xsfm");

var $jocEA = parcelRequire("jocEA");

var $9RbW4 = parcelRequire("9RbW4");

var $jDPUV = parcelRequire("jDPUV");

var $f1enQ = parcelRequire("f1enQ");

var $eMbHQ = parcelRequire("eMbHQ");

var $cNbPb = parcelRequire("cNbPb");

var $9uEyQ = parcelRequire("9uEyQ");

var $8nXhj = parcelRequire("8nXhj");

var $3mocF = parcelRequire("3mocF");

var $D17bC = parcelRequire("D17bC");

var $1v6c5 = parcelRequire("1v6c5");

var $aB7bN = parcelRequire("aB7bN");

var $e9M6d = parcelRequire("e9M6d");

var $5DTiT = parcelRequire("5DTiT");

var $8S46R = parcelRequire("8S46R");

var $6ArGj = parcelRequire("6ArGj");

var $8fUkx = parcelRequire("8fUkx");

var $dPslO = parcelRequire("dPslO");

var $4faBS = parcelRequire("4faBS");

var $7qJqb = parcelRequire("7qJqb");

var $doR3I = parcelRequire("doR3I");

var $cIEJu = parcelRequire("cIEJu");

var $lsEKV = parcelRequire("lsEKV");
const $d6183e77fafb3f2f$export$cc10a6916fdb60c = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((typename, createAnalyticsEvent)=>{
    (0, $jcw0u.default)({
        meta: {
            id: 'tableCellUnhandledGraphQLType',
            packageName: (0, $czfFt.PACKAGE_NAME),
            teamName: (0, $czfFt.TEAM_NAME)
        },
        error: new Error(`Unhandled GraphQL type ${typename} when trying to render issue field.`),
        event: createAnalyticsEvent({}),
        attributes: {
            typename: typename
        }
    });
});
const $d6183e77fafb3f2f$export$b1e360b45a7ed518 = ({ issue: issue, issueEdge: issueEdge, fieldSets: fieldSets, cellBorder: cellBorder, beforeFirstCell: beforeFirstCell, itemsConnectionId: itemsConnectionId, depth: depth, isRowHoveredOrSelected: isRowHoveredOrSelected, rowIndex: rowIndex, triggerProps: triggerProps, isFormVisible: isFormVisible })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const issueDataOld = (0, $8Uumt.useFragment)((0, $jyDou.default), issue);
    const issueEdgeData = (0, $8Uumt.useFragment)((0, $ggp2a.default), issueEdge);
    const issueData = (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? // Clean up issueDataOld on experiment cleanup, this will be safe as we the edge data will be made required
    issueEdgeData?.node ?? issueDataOld : issueDataOld;
    // Remove this old connection in a separate PR `jira_spreadsheet_component_m1` as it affects many many files
    /* eslint-disable @atlassian/relay/unused-fields */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const fieldSetConnectionOld = (0, $8Uumt.useFragment)((0, $7GNCS.default), null);
    /* eslint-enable @atlassian/relay/unused-fields */ const fieldSetsData = (0, $8Uumt.useFragment)((0, $gxp46.default), fieldSets);
    const isCreateSubTaskAllowed = issueData && issueData.issueTypeField?.issueType?.hierarchy?.level === 0;
    const { columns: columns, tableInjectedProps: tableInjectedProps, groupConnectionId: groupConnectionId, groupId: groupId } = (0, $5DTiT.useRowContext)();
    const columnConfigByIdMap = (0, $5uXOq.useMemo)(()=>{
        const result = new Map();
        columns.forEach((columnConfig)=>{
            result.set(columnConfig.id, columnConfig);
        });
        return result;
    }, [
        columns
    ]);
    const isSinglieLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    let isIssueHierarchyEnabled = false;
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isIssueHierarchyEnabled = (0, $e9M6d.useIsIssueHierarchyEnabled)();
    let handleStatusUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if ((0, $4R6GH.fg)('jsc_list_hide_done_items')) // eslint-disable-next-line react-hooks/rules-of-hooks
    handleStatusUpdate = (0, $dPslO.useHideDoneItems)({
        itemsConnectionId: itemsConnectionId,
        recordId: issueData.__id,
        projectKey: (0, $aB7bN.getProjectKeyFromIssueKey)(issueData.key),
        groupConnectionId: groupConnectionId
    });
    let isMergedColumnEnabled = false;
    if ((0, $4R6GH.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $e9M6d.useIsMergedColumnEnabled)();
    const handleUpdateCacheNew = (0, $5uXOq.useCallback)((issueKey, fieldName, field)=>{
        tableInjectedProps.onUpdateCache?.(issueKey, fieldName, field);
        handleStatusUpdate(field);
    }, [
        handleStatusUpdate,
        tableInjectedProps
    ]);
    const handleUpdateCache = (0, $4R6GH.fg)('jsc_list_hide_done_items') ? handleUpdateCacheNew : tableInjectedProps.onUpdateCache;
    const isIssueOperationMeatballMenuEnabled = (0, $e9M6d.useIsIssueOperationMeatballMenuEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    const fieldElementByIdMap = (0, $5uXOq.useMemo)(()=>{
        // Map all issue fields into their respective cell type keyed by fieldSetId. This will be used as a lookup when
        // mapping table columns in the row.
        const result = new Map();
        if (isIssueHierarchyEnabled && issueEdgeData && !(isMergedColumnEnabled && (0, $4R6GH.fg)('jira_list_merged_column_gate')) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cIEJu.default), {
                isRowHoveredOrSelected: Boolean(isRowHoveredOrSelected),
                itemsConnectionId: itemsConnectionId,
                depth: depth,
                issueRef: issueEdgeData,
                triggerProps: triggerProps,
                isFormVisible: isFormVisible
            });
            result.set((0, $czfFt.COLUMN_ID_EXPAND_BUTTON), {
                cellElement: element,
                spacing: $d6183e77fafb3f2f$var$noSpacingStyles
            });
        }
        if (issueEdgeData && isMergedColumnEnabled && (0, $4R6GH.fg)('jira_list_merged_column_gate')) {
            const nodes = fieldSetsData?.edges?.flatMap((edgeData)=>edgeData?.node?.fields?.edges?.map((edge)=>edge?.node) ?? []);
            const issueTypeField = nodes?.find((node)=>node?.__typename === 'JiraIssueTypeField');
            const issueKeyField = nodes?.find((node)=>node?.__typename === 'JiraSingleLineTextField' && node?.type === (0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_KEY);
            const summaryField = nodes?.find((node)=>node?.__typename === 'JiraSingleLineTextField' && node?.type === (0, $65VLO.KNOWN_COLUMN_TYPES).SUMMARY);
            const isHierarchyEnabled = isIssueHierarchyEnabled && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes');
            if (isHierarchyEnabled || issueTypeField || issueKeyField || summaryField) {
                const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lsEKV.MergedCell), {
                    key: (0, $65VLO.COLUMN_ID_MERGED_COLUMN),
                    itemsConnectionId: itemsConnectionId,
                    depth: depth,
                    issueRef: issueEdgeData,
                    isRowHoveredOrSelected: Boolean(isRowHoveredOrSelected),
                    isCreateChildFormVisible: isFormVisible,
                    createChildTriggerProps: triggerProps,
                    groupId: groupId,
                    isHierarchyEnabled: isHierarchyEnabled,
                    renderContent: ({ actionButtons: actionButtons })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, issueTypeField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                            xcss: isHierarchyEnabled ? $d6183e77fafb3f2f$var$typeCellStyles : $d6183e77fafb3f2f$var$typeCellNoHierarchyStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7zHDm.IssueTypeCell), {
                            fieldRef: issueTypeField
                        })), issueKeyField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMwsC.IssueKeyCell), {
                            fieldRef: issueKeyField,
                            issueRef: issueData,
                            onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                        }), !summaryField && actionButtons, summaryField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzMyH.IssueSummaryCell), {
                            fieldRef: summaryField,
                            issueRef: issueData,
                            onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                        }, actionButtons))
                });
                result.set((0, $65VLO.COLUMN_ID_MERGED_COLUMN), {
                    cellElement: element,
                    spacing: $d6183e77fafb3f2f$var$noSpacingStyles,
                    multipleFieldLayoutAdjustment: true
                });
            }
        }
        fieldSetsData?.edges?.map((edge)=>edge?.node).filter((0, $aB7bN.isNonNullish)).forEach((fieldSet)=>{
            // @ts-expect-error - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | null'.
            const columnConfig = columnConfigByIdMap.get(fieldSet.fieldSetId);
            if (!fieldSet.fieldSetId || !columnConfig) return;
            const projectKey = (0, $aB7bN.getProjectKeyFromIssueKey)(issueData.key);
            // Handle Collapsed Fields on a single issue (rare) by simply rendering a node for each field.
            const fieldElements = [];
            // Allow td spacing to be configured for the given field type
            let spacing;
            // Stop gap fix to wrap inline editable field elements in styled containers when there are multiple
            // fields within a single cell. This is necessary as inline editable fields have min-height: 100% by
            // default.
            // TODO JSC-1783 This approach will need to be revised as part of single row height once we gather data
            //  on prevalence of this edge case.
            let multipleFieldLayoutAdjustment;
            const totalCount = fieldSet.fields?.totalCount ?? 1;
            let currentCount = totalCount;
            fieldSet.fields?.edges?.forEach((fieldEdge)=>{
                // Only render the first field as editable
                const shouldBeReadOnly = isSinglieLineRowHeightEnabled && currentCount !== totalCount;
                switch(fieldEdge?.node?.__typename){
                    case 'JiraAffectedServicesField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4c7oE.AffectedServicesCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                        }));
                        break;
                    case 'JiraCascadingSelectField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiheM.CascadingSelectCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraCMDBField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ujU3.CmdbObjectsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                        }));
                        break;
                    case 'JiraCheckboxesField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKdpc.CheckboxSelectCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraComponentsField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3xK5.ComponentsInlineEditCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                                jqlTerm: columnConfig.jqlTerm,
                                projectKey: projectKey,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            multipleFieldLayoutAdjustment = true;
                        } else fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3xK5.ComponentsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm,
                            projectKey: projectKey
                        }));
                        break;
                    case 'JiraDatePickerField':
                        if (isInlineEditingExtendedFieldSupportEnabled) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fMqn0.DateInlineEditCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        } else {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fMqn0.DateCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node
                            }));
                            if (fieldEdge.node.fieldId === (0, $65VLO.KNOWN_COLUMN_TYPES).DUE_DATE) spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraDateTimePickerField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8mdOM.DateTimeCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        } else fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fMqn0.DateCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isRequired: fieldEdge.node.type === (0, $65VLO.KNOWN_COLUMN_TYPES).CREATED || fieldEdge.node.type === (0, $65VLO.KNOWN_COLUMN_TYPES).UPDATED
                        }));
                        break;
                    case 'JiraEpicLinkField':
                        // This field is deprecated; this field will show text "Replaced by Parent field" as content
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kzYGs.EpicLinkCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraFallbackField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jc00M.FallbackCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                        }));
                        spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                        break;
                    case 'JiraIssueTypeField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7zHDm.IssueTypeCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraLabelsField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kNCQ8.LabelsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm,
                            isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                        }));
                        if (fieldEdge.node.fieldId === (0, $65VLO.KNOWN_COLUMN_TYPES).LABELS || (0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraMultipleSelectField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lExf8.MultiSelectCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraMultipleSelectUserPickerField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            // This field is not treated with single line row height since the read view
                            // is using <AvatarGroup> component from @atlaskit/avatar-group. Until this component is modified,
                            // or rebuilt, right truncation will not be applied.
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM1CQ.MultiUserPickerCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraMultipleGroupPickerField':
                        if ((0, $4R6GH.fg)('nin_multi_group_picker_cell')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4faBS.MultiGroupPickerCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraNumberField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8L8tK.NumberCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                        }));
                        spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraParentIssueField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cs56G.ParentCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            fieldType: fieldEdge.node.type,
                            isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                        }));
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraPriorityField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Xsfm.PriorityCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                        }));
                        spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraProjectField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jocEA.ProjectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isRequired: fieldEdge.node.type === (0, $65VLO.KNOWN_COLUMN_TYPES).PROJECT,
                            isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                        }));
                        break;
                    case 'JiraResolutionField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f1enQ.ResolutionCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                        }));
                        break;
                    case 'JiraRichTextField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eMbHQ.RichTextCell), {
                            issueKey: issueData.key,
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueRef: issueData,
                            isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                        }));
                        spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                        break;
                    case 'JiraSingleLineTextField':
                        if (fieldEdge.node.type === (0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_KEY) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMwsC.IssueKeyCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                issueRef: issueData,
                                onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                        } else if (fieldEdge.node.type === (0, $65VLO.KNOWN_COLUMN_TYPES).SUMMARY) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzMyH.IssueSummaryCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                issueRef: issueData,
                                onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        } else {
                            if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                                fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4q4lw.PlainTextCell), {
                                    key: fieldEdge.node.fieldId,
                                    fieldRef: fieldEdge.node,
                                    isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                                }));
                                multipleFieldLayoutAdjustment = true;
                            } else fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4q4lw.PlainTextCellOld), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraSingleSelectUserPickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mocF.UserCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            projectKey: projectKey,
                            isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                        }));
                        if (fieldEdge.node.fieldId === 'assignee' || fieldEdge.node.fieldId === 'reporter' || (0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraSingleSelectField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNbPb.SingleSelectCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraSprintField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9uEyQ.SprintCell), {
                            key: fieldEdge.node.fieldId,
                            projectKey: (0, $g5X3G.toProjectKey)(projectKey),
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm
                        }));
                        spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraStatusCategoryField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hxR1y.IssueStatusCategoryCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraStatusField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2wrj.IssueStatusCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueKey: issueData.key,
                            issueId: issueData.issueId,
                            onUpdateCache: handleUpdateCache
                        }));
                        break;
                    case 'JiraServiceManagementRequestTypeField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDPUV.RequestTypeCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                        }));
                        break;
                    case 'JiraTeamViewField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nXhj.TeamCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraIssueLinkField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fRR6R.IssueLinksCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            issueKey: issueData.key,
                            isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                        }));
                        break;
                    case 'JiraCommentSummaryField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8S46R.CommentSummaryCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                issueKey: issueData.key,
                                onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraUrlField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ArGj.UrlCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraOriginalTimeEstimateField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jC6NH.OriginalEstimateCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraRadioSelectField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9RbW4.RadioSelectCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraMultipleVersionPickerField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fUkx.MultiVersionPickerCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        } else fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $D17bC.VersionsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm,
                            projectKey: projectKey
                        }));
                        break;
                    case 'JiraGoalsField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Yk7g.GoalsCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraConfluenceRemoteIssueLinksField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dCYi9.ConfluencePagesCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isReadOnlyWithoutHoverPopover: shouldBeReadOnly
                            }));
                            spacing = $d6183e77fafb3f2f$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraFlagField':
                        if ((0, $4R6GH.fg)('jsc_inline_editing_flag_fix')) fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3ljzH.FlagCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraWatchesField':
                        if ((0, $4R6GH.fg)('render_jirawatchesfield_nin')) fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7qJqb.WatchersCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    default:
                        if (fieldEdge?.node?.__typename && (0, $4R6GH.fg)('jsc_inline_editing_flag_fix')) $d6183e77fafb3f2f$export$cc10a6916fdb60c(fieldEdge?.node?.__typename, createAnalyticsEvent);
                        break;
                }
                currentCount--;
            });
            if (fieldElements.length) result.set(fieldSet.fieldSetId, {
                cellElement: fieldElements,
                spacing: spacing,
                multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment
            });
        });
        // Always include the Issue Operations meatball menu cell.
        // But show it empty if isIssueOperationMeatballMenuEnabled is false
        result.set((0, $czfFt.COLUMN_ID_MEATBALL_MENU), {
            cellElement: isIssueOperationMeatballMenuEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bRJBd.IssueOperations), {
                key: (0, $czfFt.COLUMN_ID_MEATBALL_MENU),
                issueId: Number(issueData.issueId),
                issueKey: issueData.key,
                onIssueRefetch: tableInjectedProps.onIssueRefetch,
                onIssueDelete: tableInjectedProps.onIssueDelete,
                isCreateSubTaskAllowed: isCreateSubTaskAllowed
            })
        });
        // TODO Remove rowIndex !== undefined when cleaning up bulk_operations_in_nin
        if (rowIndex !== undefined && (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false)) result.set((0, $czfFt.COLUMN_ID_CHECKBOX), {
            cellElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3JOwB.CheckboxCell), {
                issueId: issueData.issueId,
                rowIndex: rowIndex
            })
        });
        return result;
    }, [
        isIssueHierarchyEnabled,
        issueEdgeData,
        isMergedColumnEnabled,
        fieldSetsData?.edges,
        isIssueOperationMeatballMenuEnabled,
        issueData,
        tableInjectedProps.onIssueRefetch,
        tableInjectedProps.onIssueDelete,
        tableInjectedProps.onIssueLinkSelected,
        tableInjectedProps.issueSearchBaseUrl,
        isCreateSubTaskAllowed,
        rowIndex,
        isRowHoveredOrSelected,
        itemsConnectionId,
        depth,
        triggerProps,
        isFormVisible,
        groupId,
        columnConfigByIdMap,
        isSinglieLineRowHeightEnabled,
        isInlineEditingExtendedFieldSupportEnabled,
        handleUpdateCache,
        createAnalyticsEvent
    ]);
    const cellBorderWithNoInlineBordersStyles = (0, $5uXOq.useMemo)(()=>{
        if (cellBorder === undefined) return $d6183e77fafb3f2f$var$noInlineBordersStyles;
        return [
            ...(0, (/*@__PURE__*/$parcel$interopDefault($7hpBk)))(cellBorder),
            $d6183e77fafb3f2f$var$noInlineBordersStyles
        ];
    }, [
        cellBorder
    ]);
    const isFixedTableLayoutEnabled = (0, $e9M6d.useIsFixedTableLayoutEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, columns.map(({ id: id, type: type, isPlaceHolderField: isPlaceHolderField, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets }, index)=>{
        const field = fieldElementByIdMap.get(id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: id
        }, // TODO: EM-7165 – Update the extra filler cell logic when refactoring the column picker column
        // Empty cell to fill remainig space if configured columns are not wide enough to fill the table
        isFixedTableLayoutEnabled && id === (0, $czfFt.COLUMN_ID_MEATBALL_MENU) && !(0, $4R6GH.fg)('jira_list_grid_pattern_keyboard_nav') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1v6c5.TableCell), {
            border: cellBorderWithNoInlineBordersStyles,
            "aria-hidden": true
        }), // TODO: EM-7165 – Update the extra filler cell logic when refactoring the column picker column
        // Empty cell to fill remainig space if configured columns are not wide enough to fill the table
        isFixedTableLayoutEnabled && id === (0, $czfFt.COLUMN_ID_MEATBALL_MENU) && (0, $4R6GH.fg)('jira_list_grid_pattern_keyboard_nav') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "td",
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcss: cellBorderWithNoInlineBordersStyles,
            "aria-hidden": true
        }), isPlaceHolderField && (0, $4R6GH.fg)('jira_inline_field_config_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $14NPb.LoadingCell), {
            cellBorder: cellBorder
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $doR3I.default), {
            type: type,
            beforeElement: index === 0 ? beforeFirstCell : undefined,
            cellElement: field?.cellElement,
            spacing: field?.spacing,
            multipleFieldLayoutAdjustment: field?.multipleFieldLayoutAdjustment,
            border: cellBorder,
            ...(0, $4R6GH.fg)('jira_list_grid_pattern_keyboard_nav') && {
                row: rowIndex,
                column: index
            },
            ...(0, $4R6GH.fg)('issue_table_frozen_columns') && {
                isColumnSticky: isColumnSticky,
                stickyOffsets: stickyOffsets
            }
        }));
    }));
};
const $d6183e77fafb3f2f$var$noSpacingStyles = (0, $8CUq3.xcss)({
    padding: 'space.0'
});
const $d6183e77fafb3f2f$var$noInlineBordersStyles = (0, $8CUq3.xcss)({
    borderLeftWidth: '0',
    borderRightWidth: '0'
});
const $d6183e77fafb3f2f$var$typeCellStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.050'
});
const $d6183e77fafb3f2f$var$typeCellNoHierarchyStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100'
});
const $d6183e77fafb3f2f$export$29013dcb6d1b879d = /*#__PURE__*/ (0, $5uXOq.memo)($d6183e77fafb3f2f$export$b1e360b45a7ed518);

});
parcelRegister("gxp46", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dca7d3b94536ed4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4eb719a7226d5b86b3f45f5a01c1c003>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8dca7d3b94536ed4$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "type"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "fieldSetId"
                            },
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "totalCount"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "affectedServices_nativeIssueTable_AffectedServicesCell"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "cascadingSelect_nativeIssueTable_CascadingSelectCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "components_nativeIssueTable_ComponentsInlineEditCell_fieldRef"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "dateTime_nativeIssueTable_DateTimeCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "plainText_nativeIssueTable_PlainTextCell_fieldRef"
                                                            },
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "commentSummary_nativeIssueTable_CommentSummaryCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "url_nativeIssueTable_UrlCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "singleSelect_nativeIssueTable_SingleSelectCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "multiSelect_nativeIssueTable_MultiSelectCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "checkboxSelect_nativeIssueTable_CheckboxSelectCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "multiUserPicker_nativeIssueTable_MultiUserPickerCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "team_nativeIssueTable_TeamCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "originalEstimate_nativeIssueTable_OriginalEstimateCell_fieldRef"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "radioSelect_nativeIssueTable_RadioSelectCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "multiVersionPicker_nativeIssueTable_MultiVersionPickerCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "goals_nativeIssueTable_GoalsCell"
                                                            },
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "confluencePages_nativeIssueTable_ConfluencePagesCell"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "cmdbObjects_nativeIssueTable_CmdbObjectsCell"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "components_nativeIssueTable_ComponentsCell_fieldRef"
                                                            },
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "plainText_nativeIssueTable_PlainTextCellOld_fieldRef"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "date_nativeIssueTable_DateCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "date_nativeIssueTable_DateInlineEditCell_fieldRef"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "epicLink_nativeIssueTable_EpicLinkCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "fallback_nativeIssueTable_FallbackCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "issueKey_nativeIssueTable_IssueKeyCell_fieldRef"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "issueStatus_nativeIssueTable_IssueStatusCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "issueSummary_nativeIssueTable_IssueSummaryCell_fieldRef"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "labels_nativeIssueTable_LabelsCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "issueType_nativeIssueTable_IssueTypeCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "parent_nativeIssueTable_ParentCell_fieldRef"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "priority_nativeIssueTable_PriorityCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "project_nativeIssueTable_ProjectCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "resolution_nativeIssueTable_ResolutionCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "sprint_nativeIssueTable_SprintCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "user_nativeIssueTable_UserCell_fieldRef"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versions_nativeIssueTable_VersionsCell"
                                                    },
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "isDensityFull",
                                                                "variableName": "isDensityFull"
                                                            }
                                                        ],
                                                        "kind": "FragmentSpread",
                                                        "name": "richText_nativeIssueTable_RichTextCell_fieldRef"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "requestType_nativeIssueTable_RequestTypeCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "issueLinks_nativeIssueTable_IssueLinksCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "number_nativeIssueTable_NumberCell_fieldRef"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "args": v1 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "multiGroupPicker_nativeIssueTable_MultiGroupPickerCell"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "flag_nativeIssueTable_FlagCell"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "watches_nativeIssueTable_WatchersCell"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$8dca7d3b94536ed4$var$node.hash = "331d47cef88478362399e5d4f4e7f812";
var $8dca7d3b94536ed4$export$2e2bcd8739ae039 = $8dca7d3b94536ed4$var$node;

});

parcelRegister("7GNCS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cce377fc3436b13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c03f711f2100ccb4fcb240fc4071d6d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1cce377fc3436b13$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsContext"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetConnectionOld",
        "selections": [
            {
                "condition": "shouldQueryFieldSetsById",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetIds",
                                    "variableName": "fieldSetIds"
                                },
                                v0 /*: any*/ 
                            ],
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        "action": "THROW",
                        "path": "fieldSetsById"
                    }
                ]
            },
            {
                "condition": "shouldQueryFieldSetsById",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "fieldSetsContext"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "filterId",
                                    "variableName": "filterId"
                                },
                                v0 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "namespace",
                                    "variableName": "namespace"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewId",
                                    "variableName": "viewId"
                                }
                            ],
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsForIssueSearchView",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        "action": "THROW",
                        "path": "fieldSetsForIssueSearchView"
                    }
                ]
            }
        ],
        "type": "JiraIssue"
    };
}();
$1cce377fc3436b13$var$node.hash = "04b58e7d74acd8f7f93585698eb3d968";
var $1cce377fc3436b13$export$2e2bcd8739ae039 = $1cce377fc3436b13$var$node;

});

parcelRegister("ggp2a", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a16362c62c57ba4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<69630405a8c6aec693336714c4320b8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3a16362c62c57ba4$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v1 = {
        "kind": "Variable",
        "name": "projectKeys",
        "variableName": "projectKeys"
    }, v2 = {
        "kind": "Variable",
        "name": "shouldQueryHasChildren",
        "variableName": "shouldQueryHasChildren"
    }, v3 = {
        "kind": "Variable",
        "name": "isDensityFull",
        "variableName": "isDensityFull"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "issueRow_nativeIssueTable_IssueRowWithFragments_issueEdge",
        "selections": [
            {
                "args": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "firstColumnCell_nativeIssueTable"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isJscM2Enabled",
                                "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                            },
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ],
                        "kind": "FragmentSpread",
                        "name": "mergedCell_nativeIssueTable"
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                    "kind": "LinkedField",
                                                    "name": "hierarchy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "level"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "issueSummary_nativeIssueTable_IssueSummaryCell_issueRef"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "issueKey_nativeIssueTable_IssueKeyCell_fieldsByIdRef"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "isInlineEditingEnabled",
                                            "variableName": "isInlineEditingEnabled"
                                        }
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetConnectionOld"
                                }
                            ]
                        },
                        {
                            "args": [
                                v3 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "richText_nativeIssueTable_RichTextCell_issueRef"
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "node"
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$3a16362c62c57ba4$var$node.hash = "f66eaf93adba5ef593234058b1616cf5";
var $3a16362c62c57ba4$export$2e2bcd8739ae039 = $3a16362c62c57ba4$var$node;

});

parcelRegister("jyDou", function(module, exports) {

$parcel$export(module.exports, "default", () => $0869aa3d03d0b6fd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<274cfda653161f3f9e03eeb94b27648d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0869aa3d03d0b6fd$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "isDensityFull",
        "variableName": "isDensityFull"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "issueRow_nativeIssueTable_IssueRowWithFragments_issue",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "issueId"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueTypeHierarchyLevel",
                                        "kind": "LinkedField",
                                        "name": "hierarchy",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "level"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "issueSummary_nativeIssueTable_IssueSummaryCell_issueRef"
            },
            {
                "kind": "FragmentSpread",
                "name": "issueKey_nativeIssueTable_IssueKeyCell_fieldsByIdRef"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "isInlineEditingEnabled",
                                "variableName": "isInlineEditingEnabled"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetConnectionOld"
                    }
                ]
            },
            {
                "args": [
                    v0 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "richText_nativeIssueTable_RichTextCell_issueRef"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraIssue"
    };
}();
$0869aa3d03d0b6fd$var$node.hash = "75a77826cc5198af57c73c476716e592";
var $0869aa3d03d0b6fd$export$2e2bcd8739ae039 = $0869aa3d03d0b6fd$var$node;

});

parcelRegister("4c7oE", function(module, exports) {

$parcel$export(module.exports, "AffectedServicesCell", () => $640e76929a274e03$export$e6c0da3971931bb1);

var $fQzuK = parcelRequire("fQzuK");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $2bYmU = parcelRequire("2bYmU");

var $l8IoT = parcelRequire("l8IoT");

var $aB7bN = parcelRequire("aB7bN");

var $hKMVG = parcelRequire("hKMVG");

var $e9M6d = parcelRequire("e9M6d");

var $hVZ8e = parcelRequire("hVZ8e");
const $640e76929a274e03$export$e6c0da3971931bb1 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $fQzuK.default), fieldRef);
    const affectedServices = data.selectedAffectedServicesConnection?.edges;
    const filteredAffectedServices = affectedServices?.map((edge)=>edge?.node?.name != null ? {
            key: edge.node.serviceId,
            name: edge.node.name
        } : null).filter((0, $aB7bN.isNonNullish)) ?? [];
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    if (!affectedServices || affectedServices.length !== filteredAffectedServices.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "affectedServices",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bYmU.default), {
        items: filteredAffectedServices,
        ItemComponent: (0, $l8IoT.TagItem),
        PopupContentWrapper: (0, $l8IoT.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $hVZ8e.default).triggerButton),
        isHoverPopoverEnabled: isSingleLineRowHeightEnabled
    });
});

});
parcelRegister("fQzuK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2495d47abe39c6be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3588ea039c9febd14e0e88de5d01bbc2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2495d47abe39c6be$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "affectedServices_nativeIssueTable_AffectedServicesCell",
    "selections": [
        {
            "concreteType": "JiraAffectedServiceConnection",
            "kind": "LinkedField",
            "name": "selectedAffectedServicesConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAffectedServiceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraAffectedService",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "serviceId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraAffectedServicesField"
};
$2495d47abe39c6be$var$node.hash = "ce0f961052b6620f6333f7806e16524e";
var $2495d47abe39c6be$export$2e2bcd8739ae039 = $2495d47abe39c6be$var$node;

});

parcelRegister("2bYmU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d17bd6ff7b34ce3d$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $79UpA = parcelRequire("79UpA");

var $fOWsa = parcelRequire("fOWsa");
const $d17bd6ff7b34ce3d$var$ListWithPopup = ({ items: items, ItemComponent: ItemComponent, maxLimit: maxLimit, initialIsOpen: initialIsOpen, isHoverPopoverEnabled: isHoverPopoverEnabled, ...restProps })=>{
    const [firstItem, ...restItems] = items;
    const ShowMorePopupRenderer = (0, $5uXOq.useCallback)(()=>isHoverPopoverEnabled ? /*#__PURE__*/ $5uXOq.createElement((0, $79UpA.CellHoverProvider), null, /*#__PURE__*/ $5uXOq.createElement((0, $fOWsa.default), {
            items: restItems,
            maxLimit: maxLimit,
            ItemComponent: ItemComponent,
            initialIsOpen: initialIsOpen,
            isHoverPopoverEnabled: isHoverPopoverEnabled,
            ...restProps
        })) : /*#__PURE__*/ $5uXOq.createElement((0, $fOWsa.default), {
            items: restItems,
            maxLimit: maxLimit,
            ItemComponent: ItemComponent,
            initialIsOpen: initialIsOpen,
            isHoverPopoverEnabled: isHoverPopoverEnabled,
            ...restProps
        }), [
        ItemComponent,
        initialIsOpen,
        isHoverPopoverEnabled,
        maxLimit,
        restItems,
        restProps
    ]);
    if (items.length === 0) return null;
    return /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: !isHoverPopoverEnabled,
        xcss: isHoverPopoverEnabled && $d17bd6ff7b34ce3d$var$hoverPopoverStyles
    }, /*#__PURE__*/ $5uXOq.createElement(ItemComponent, {
        ...firstItem,
        isHoverPopoverEnabled: isHoverPopoverEnabled,
        className: (0, $bwpsq.default)([
            isHoverPopoverEnabled && "_1ul9ze3t"
        ])
    }), restItems.length >= 1 && ShowMorePopupRenderer());
};
const $d17bd6ff7b34ce3d$var$hoverPopoverStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.050',
    width: '100%'
});
const $d17bd6ff7b34ce3d$var$hoverPopoverItemStyles = null;
var $d17bd6ff7b34ce3d$export$2e2bcd8739ae039 = $d17bd6ff7b34ce3d$var$ListWithPopup;

});
parcelRegister("fOWsa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8185fb8c4a7dccd8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $9fuVs = parcelRequire("9fuVs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $dpHMc = parcelRequire("dpHMc");
const $8185fb8c4a7dccd8$var$ShowMorePopup = ({ showMoreTooltip: showMoreTooltip, items: items, ItemComponent: ItemComponent, PopupContentWrapper: PopupContentWrapper = (0, $5uXOq.Fragment), maxLimit: maxLimit = 99, OverrideContentComponent: OverrideContentComponent, initialIsOpen: initialIsOpen = false, isHoverPopoverEnabled: isHoverPopoverEnabled = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(initialIsOpen);
    const list = items.slice(0, maxLimit);
    const content = (0, $5uXOq.useCallback)(()=>list.map(({ key: key, ...item })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ItemComponent, item))), [
        ItemComponent,
        list
    ]);
    if (items.length === 0) return null;
    const onClickTrigger = ()=>{
        setIsOpen(!isOpen);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'listWithPopup');
    };
    const contentWithWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: [
                $8185fb8c4a7dccd8$var$ContainerDialogStyles,
                $8185fb8c4a7dccd8$var$ContainerDialogBorderStyles
            ]
        }, OverrideContentComponent === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PopupContentWrapper, null, content()) : OverrideContentComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null));
    if (isHoverPopoverEnabled) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const hoverPopoverContent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $8185fb8c4a7dccd8$var$HoverPopoverContainerDialogStyles
            }, OverrideContentComponent === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PopupContentWrapper, null, content()) : OverrideContentComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null)), [
            OverrideContentComponent,
            PopupContentWrapper,
            content
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
                content: hoverPopoverContent,
                isInteractive: true
            }, ({ ref: ref, ariaExpanded: ariaExpanded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    isSelected: isOpen,
                    spacing: "none",
                    testId: "list-with-popup.ui.show-more-popup.items-count",
                    "aria-expanded": ariaExpanded,
                    ref: ref,
                    ...props
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8185fb8c4a7dccd8$var$ItemsCount, null, "+", list.length))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom",
        content: contentWithWrapper,
        testId: "list-with-popup.ui.show-more-popup",
        messageId: "list-with-popup.ui.show-more-popup.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                key: "triggerLinksDialog",
                content: showMoreTooltip,
                tag: $8185fb8c4a7dccd8$var$TooltipContainer,
                ...(0, $4R6GH.fg)('jsc_inline_editing_field_refactor') && {
                    position: 'top'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: onClickTrigger,
                spacing: "none",
                testId: "list-with-popup.ui.show-more-popup.items-count"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8185fb8c4a7dccd8$var$ItemsCount, null, "+", list.length)))
    });
};
const $8185fb8c4a7dccd8$var$TooltipContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ...props,
        ref: ref,
        as: "span",
        xcss: $8185fb8c4a7dccd8$var$tooltipContainerStyles
    }));
const $8185fb8c4a7dccd8$var$ContainerDialogStyles = (0, $8CUq3.xcss)({
    width: '240px',
    maxHeight: '220px',
    overflow: 'auto',
    padding: 'space.100'
});
const $8185fb8c4a7dccd8$var$HoverPopoverContainerDialogStyles = (0, $8CUq3.xcss)({
    maxHeight: '220px',
    overflow: 'auto',
    padding: 'space.050'
});
const $8185fb8c4a7dccd8$var$ContainerDialogBorderStyles = (0, $8CUq3.xcss)({
    border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
});
const $8185fb8c4a7dccd8$var$tooltipContainerStyles = (0, $8CUq3.xcss)({
    maxWidth: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8185fb8c4a7dccd8$var$ItemsCount = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18zr1b66 _k48pi7a9 _vwz4v47k",
            __cmplp.className
        ])
    });
});
var $8185fb8c4a7dccd8$export$2e2bcd8739ae039 = $8185fb8c4a7dccd8$var$ShowMorePopup;

});
parcelRegister("dpHMc", function(module, exports) {

$parcel$export(module.exports, "HoverPopover", () => $c3b22dea78231293$export$cdce0887ee98d5c8);
$parcel$export(module.exports, "CellHoverRenderer", () => $c3b22dea78231293$export$15e55631babd0ec5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1I7E8 = parcelRequire("1I7E8");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");

var $79UpA = parcelRequire("79UpA");


var $4j2QQ = parcelRequire("4j2QQ");
const $c3b22dea78231293$var$HoverPopoverComponent = ({ content: content, children: children, contentRef: contentRef, entryPointActions: entryPointActions, isInteractive: isInteractive, shouldGetParentRef: shouldGetParentRef, isFixedWidth: isFixedWidth, onHoverOut: onHoverOut, hidePopover: hidePopover })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $5uXOq.useState)(false);
    const togglePopup = (0, $5uXOq.useCallback)(()=>{
        setIsPopupOpen(!isPopupOpen);
    }, [
        isPopupOpen
    ]);
    (0, $79UpA.useCellHoverCallbacks)({
        contentRef: contentRef,
        onPreload: entryPointActions?.preload,
        onLoad: entryPointActions?.load,
        onPopupToggle: setIsPopupOpen,
        shouldGetParentRef: shouldGetParentRef,
        onHoverOut: onHoverOut,
        onChangePopupState: togglePopup
    });
    if (content) return /*#__PURE__*/ $5uXOq.createElement((0, $l8ruj.default), {
        name: "jira-list-hover-popover",
        mode: "list"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jira-list-hover-popover",
        packageName: (0, $3d0efee74fd96834$export$b8b9d90f9e5bd72b),
        teamName: (0, $3d0efee74fd96834$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $1I7E8.Popup), {
        content: ({ update: update })=>/*#__PURE__*/ $5uXOq.createElement((0, $4j2QQ.PopupContent), {
                isInteractive: isInteractive,
                update: update
            }, content),
        popupComponent: /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: popupChildren, isReferenceHidden: isReferenceHidden, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, ...restProps }, ref)=>{
            if (isReferenceHidden && isPopupOpen) setIsPopupOpen(false);
            return /*#__PURE__*/ $5uXOq.createElement("div", {
                onMouseEnter: ()=>isInteractive && setIsPopupOpen(true),
                onMouseLeave: ()=>isInteractive && setIsPopupOpen(false),
                ...restProps,
                ref: ref,
                className: (0, $bwpsq.default)([
                    "_1mouu2gc _j7hq1ida _tzy4idpf _5sag1yx9 _1pgl1v42 _1o51q7pw _p12f1mjv _lcxvglyw",
                    isInteractive && "_1moux0bf _1rjcutpp _lcxv1wug",
                    isFixedWidth && "_1bsb1mjv"
                ])
            }, popupChildren);
        }),
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: false,
        isOpen: !hidePopover && isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        trigger: ({ ref: ref })=>children({
                ref: ref,
                ariaExpanded: isPopupOpen
            }),
        placement: "bottom-start"
    })));
    return typeof children === 'function' ? children({
        ref: null
    }) : children;
};
const $c3b22dea78231293$export$cdce0887ee98d5c8 = /*#__PURE__*/ (0, $5uXOq.memo)($c3b22dea78231293$var$HoverPopoverComponent);
const $c3b22dea78231293$export$15e55631babd0ec5 = ({ children: children })=>{
    const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, handleToggle: handleToggle } = (0, $79UpA.useCellHoverHandlers)();
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.code === 'Space') handleToggle();
    }, [
        handleToggle
    ]);
    return children({
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onKeyDown: handleKeyDown
    });
};
const $c3b22dea78231293$var$fadeIn = null;
const $c3b22dea78231293$var$interactiveStyles = null;
const $c3b22dea78231293$var$containerStyles = null;
const $c3b22dea78231293$var$fixedWidthStyles = null;

});
const $3d0efee74fd96834$export$d57b6b390e78d90f = 'jira-yurree';
const $3d0efee74fd96834$export$b8b9d90f9e5bd72b = '@atlassian/jira-hover-popover';

parcelRegister("4j2QQ", function(module, exports) {

$parcel$export(module.exports, "PopupContent", () => $174a01b18c9bd881$export$2a2c7ba12d3231e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2m0b6 = parcelRequire("2m0b6");

var $9fuVs = parcelRequire("9fuVs");
const $174a01b18c9bd881$var$PopupContentComponent = ({ children: children, update: update, isInteractive: isInteractive })=>{
    const componentRef = (0, $5uXOq.useRef)(null);
    (0, $2m0b6.useResizeObserver)({
        ref: componentRef,
        onResize: update
    });
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        ref: componentRef,
        "data-testid": "hover-popover.ui.popup-content.hover-popover-content",
        "aria-hidden": !isInteractive,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: isInteractive ? 0 : undefined,
        className: (0, $bwpsq.default)([
            "_2rkoglpi _1reo1wug _18m91wug _18zrutpp _1rjc12x7 _bfhk1bhr _16qs1cd0 _qv3h2smr _k48pi7a9 _1i4q1hna _c71l1mjv _1nmz1hna _y2mvugt7 _1bg4v77o"
        ])
    }, children, /*#__PURE__*/ $5uXOq.createElement((0, $9fuVs.default), null));
};
const $174a01b18c9bd881$export$2a2c7ba12d3231e3 = /*#__PURE__*/ (0, $5uXOq.memo)($174a01b18c9bd881$var$PopupContentComponent);
const $174a01b18c9bd881$var$popoverStyles = null;

});
parcelRegister("2m0b6", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $072291c9ed048772$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $072291c9ed048772$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $072291c9ed048772$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $072291c9ed048772$export$e58143dc89297272);

var $5uXOq = parcelRequire("5uXOq");

var $eUdQc = parcelRequire("eUdQc");
function $072291c9ed048772$export$87a9d3e287304ae4(params) {
    const group = new (0, $eUdQc.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $5uXOq.useRef)(onResize);
        (0, $5uXOq.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $5uXOq.useCallback)(()=>onResizeRef.current(), []);
        (0, $5uXOq.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $072291c9ed048772$export$683480f191c0e3ea, flushResizeObservers: $072291c9ed048772$export$a181ef2a6d0a1bb6 } = $072291c9ed048772$export$87a9d3e287304ae4();
function $072291c9ed048772$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $072291c9ed048772$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $5uXOq.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("eUdQc", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $52e6ab4254804b44$export$607798bbe2869c0);

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");
class $52e6ab4254804b44$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $7nsd3.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});






parcelRegister("l8IoT", function(module, exports) {

$parcel$export(module.exports, "TagItem", () => $d23071f9a11add84$export$32a09b7581f7fd80);
$parcel$export(module.exports, "TagItemPopupContentWrapper", () => $d23071f9a11add84$export$c9925310d93bfb2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $vIiRg = parcelRequire("vIiRg");
var $ujWmd = parcelRequire("ujWmd");
var $iDZjq = parcelRequire("iDZjq");

var $kOLg6 = parcelRequire("kOLg6");

var $d9xxV = parcelRequire("d9xxV");

var $exfTw = parcelRequire("exfTw");

var $79UpA = parcelRequire("79UpA");

var $dpHMc = parcelRequire("dpHMc");

var $7mPT9 = parcelRequire("7mPT9");

var $kFniW = parcelRequire("kFniW");
const $d23071f9a11add84$var$AVATAR_SIZE = 'xsmall';
const $d23071f9a11add84$var$AVATAR_APPEARANCE = 'square';
const $d23071f9a11add84$var$tagMarginFixStyles = null;
const $d23071f9a11add84$var$tagMarginInlineFixStyles = null;
const $d23071f9a11add84$var$strikethroughStyles = null;
const $d23071f9a11add84$var$TagItemAvatar = ({ src: src, testId: testId = 'list-with-popup.ui.tag-item.avatar' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: $d23071f9a11add84$var$AVATAR_APPEARANCE,
        size: $d23071f9a11add84$var$AVATAR_SIZE,
        src: src,
        borderColor: "transparent",
        testId: testId
    });
const $d23071f9a11add84$var$TagItemMediaImage = /*#__PURE__*/ (0, $5uXOq.memo)(({ mediaImage: mediaImage, fallbackSrc: fallbackSrc })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kOLg6.MediaImageWithErrorBoundary), {
        identifier: mediaImage.identifier,
        mediaClientConfig: mediaImage.mediaClientConfig,
        apiConfig: {
            ...mediaImage.apiConfig,
            width: (0, $vIiRg.AVATAR_SIZES)[$d23071f9a11add84$var$AVATAR_SIZE],
            height: (0, $vIiRg.AVATAR_SIZES)[$d23071f9a11add84$var$AVATAR_SIZE]
        }
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDZjq.default), {
            appearance: $d23071f9a11add84$var$AVATAR_APPEARANCE,
            size: $d23071f9a11add84$var$AVATAR_SIZE
        });
        if (error || !data?.src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d23071f9a11add84$var$TagItemAvatar, {
            src: fallbackSrc,
            testId: "list-with-popup.ui.tag-item.media-image-error"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d23071f9a11add84$var$TagItemAvatar, {
            src: data?.src,
            testId: "list-with-popup.ui.tag-item.media-image-avatar"
        });
    }));
const $d23071f9a11add84$var$TagItemIcon = ({ icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, icon.mediaImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d23071f9a11add84$var$TagItemMediaImage, {
        mediaImage: icon.mediaImage,
        fallbackSrc: icon.url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d23071f9a11add84$var$TagItemAvatar, {
        src: icon.url
    }));
const $d23071f9a11add84$export$32a09b7581f7fd80 = ({ name: name, href: href, icon: icon, shouldDisplayStrikethrough: shouldDisplayStrikethrough, isColored: isColored, isHoverPopoverEnabled: isHoverPopoverEnabled = false, isOnlyOneItem: isOnlyOneItem })=>{
    const tagRef = (0, $5uXOq.useRef)(null);
    if (isHoverPopoverEnabled) {
        const renderTagContent = (ref, props)=>{
            return isColored ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $exfTw.ColoredTag), {
                labelName: name,
                href: href,
                actionSubjectId: "listWithPopup",
                pressableXcss: $d23071f9a11add84$var$extraColoredTagStyles,
                contentXcss: $d23071f9a11add84$var$extraColoredTagTextStyles,
                ref: ref,
                ...props
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1ule _1ul9ze3t"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                "data-testid": "list-with-popup.ui.tag-item.tag-item",
                ...props,
                className: (0, $bwpsq.default)([
                    "_1e0c1o8l _19pkr5cr _otyrr5cr _p12f1osq _l9z01osq",
                    "_2hwxr5cr _18u0r5cr",
                    shouldDisplayStrikethrough && "_59381r81 _yha21cog _1nmzvv82"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
                elemBefore: icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d23071f9a11add84$var$TagItemIcon, {
                    icon: icon
                }) : undefined,
                text: name,
                href: href,
                linkComponent: (0, $kFniW.default),
                ref: ref
            })));
        };
        const hoverPopoverContent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
                contentRef: tagRef,
                content: name
            }, ({ ref: ref })=>renderTagContent((0, $7mPT9.mergeRefs)(tagRef, ref), props));
        if (isOnlyOneItem) return hoverPopoverContent();
        // If there are more then one tag, different popovers need to be rendered on the tag and the see more button.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79UpA.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.CellHoverRenderer), null, ({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>hoverPopoverContent({
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            })));
    }
    if (isColored) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $exfTw.ColoredTag), {
        labelName: name,
        href: href,
        actionSubjectId: "listWithPopup",
        pressableXcss: $d23071f9a11add84$var$extraColoredTagStyles,
        contentXcss: $d23071f9a11add84$var$extraColoredTagTextStyles
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": "list-with-popup.ui.tag-item.tag-item",
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _19pkr5cr _otyrr5cr _p12f1osq _l9z01osq",
            "_2hwxr5cr _18u0r5cr",
            shouldDisplayStrikethrough && "_59381r81 _yha21cog _1nmzvv82"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
        elemBefore: icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d23071f9a11add84$var$TagItemIcon, {
            icon: icon
        }) : undefined,
        text: name,
        href: href,
        linkComponent: (0, $kFniW.default)
    }));
};
const $d23071f9a11add84$export$c9925310d93bfb2 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        shouldWrap: true
    }, children);
const $d23071f9a11add84$var$extraColoredTagTextStyles = (0, $8CUq3.xcss)({
    maxWidth: '100%'
});
const $d23071f9a11add84$var$extraColoredTagStyles = (0, $8CUq3.xcss)({
    marginInline: 'space.0',
    minWidth: '0px'
});
const $d23071f9a11add84$var$hoverPopoverStyles = null;

});
parcelRegister("iDZjq", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b6b09c530db49a$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $31b6b09c530db49a$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $31b6b09c530db49a$var$styles = {
    root: "_2rko1q5u _189e1bk5 _1dqonqa1 _1h6d3acm _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    strongOpacity: "_tzy4clii"
};
const $31b6b09c530db49a$var$sizeStyles = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $31b6b09c530db49a$var$borderRadiusMap = {
    xsmall: "_2rkogqwt",
    small: "_2rkogqwt",
    medium: "_2rko1l7b",
    large: "_2rko1l7b",
    xlarge: "_2rkoi2wt",
    xxlarge: "_2rkob7nn"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $31b6b09c530db49a$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            [$31b6b09c530db49a$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $bwpsq.default)([
            $31b6b09c530db49a$var$styles.root,
            $31b6b09c530db49a$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' && $31b6b09c530db49a$var$borderRadiusMap[size ?? 'medium'],
            weight === 'strong' && $31b6b09c530db49a$var$styles.strongOpacity
        ])
    });
var $31b6b09c530db49a$export$2e2bcd8739ae039 = $31b6b09c530db49a$var$Skeleton;

});

parcelRegister("kOLg6", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $27dd12b02502711d$export$758a2fef95a29ad0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $eYKm8 = parcelRequire("eYKm8");
const $27dd12b02502711d$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: props.children({
                loading: false,
                error: true
            })
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eYKm8.MediaImageWithMediaClient), {
            ...props
        })
    });

});
parcelRegister("eYKm8", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithMediaClient", () => $eecef2c1b93fb3db$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iArlU = parcelRequire("iArlU");

var $10b0h = parcelRequire("10b0h");

var $VSDnB = parcelRequire("VSDnB");
const $eecef2c1b93fb3db$var$copyDivStyles = null;
const $eecef2c1b93fb3db$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $10b0h.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            children({
                loading: status === 'loading',
                error: status === 'error',
                data: status === 'succeeded' ? {
                    status: status,
                    src: preview?.dataURI
                } : undefined
            }),
            (0, $VSDnB.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: copyNodeRef,
                className: (0, $bwpsq.default)([
                    "_1e0cglyw"
                ])
            }),
            getSsrScriptProps && /*#__PURE__*/ (0, $2OMIu.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};
const $eecef2c1b93fb3db$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $5uXOq.useMemo)(()=>(0, $iArlU.withMediaClient)($eecef2c1b93fb3db$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(MediaImageComponent, {
        ...props
    });
};

});
parcelRegister("iArlU", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $104af301cec809a6$export$9f7977d4a2561bee);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");
const $104af301cec809a6$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        });

});
parcelRegister("cEHh7", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $2a03c62fd3cc05ea$export$5bff351c86f56d97);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $85xkt = parcelRequire("85xkt");
const $2a03c62fd3cc05ea$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $2a03c62fd3cc05ea$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $5uXOq.useMemo)(()=>(0, $85xkt.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2a03c62fd3cc05ea$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};

});


parcelRegister("10b0h", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $baceb2843b357d39$export$4eaebdef02112fe4);

var $5uXOq = parcelRequire("5uXOq");

var $1Pp1U = parcelRequire("1Pp1U");
var $gFZHi = parcelRequire("gFZHi");

var $93kaw = parcelRequire("93kaw");
var $24tOd = parcelRequire("24tOd");
var $dTQMj = parcelRequire("dTQMj");

var $8GKRF = parcelRequire("8GKRF");

var $kGpuq = parcelRequire("kGpuq");

var $01sWe = parcelRequire("01sWe");

var $3JWNV = parcelRequire("3JWNV");
var $4n1NZ = parcelRequire("4n1NZ");
var $7xRaJ = parcelRequire("7xRaJ");

var $3JZCV = parcelRequire("3JZCV");
var $jR4hE = parcelRequire("jR4hE");

var $8Kbwv = parcelRequire("8Kbwv");
const $baceb2843b357d39$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $dTQMj.useMediaClient)();
    const [status, setStatus] = (0, $5uXOq.useState)('loading');
    const [error, setError] = (0, $5uXOq.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $5uXOq.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $5uXOq.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $5uXOq.useState)('not-resolved');
    const ssrReliabilityRef = (0, $5uXOq.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $5uXOq.useMemo)(()=>dimensions ? (0, $8Kbwv.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $8Kbwv.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $jR4hE.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $3JWNV.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $kGpuq.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $5uXOq.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $24tOd.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $1Pp1U.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $5uXOq.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('metadata-fetch', (0, $gFZHi.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $8Kbwv.useCurrentValueRef)(()=>{
        return (0, $3JWNV.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $5uXOq.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $8Kbwv.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $8Kbwv.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $5uXOq.useEffect)(()=>{
        const cachedPreview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $8Kbwv.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $4n1NZ.isSupportedLocalPreview)(mediaType) && (0, $8GKRF.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $3JWNV.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $8Kbwv.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $3JWNV.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $01sWe.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $5uXOq.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $3JWNV.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $3JWNV.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $3JWNV.isLocalPreview)(failedPreview);
        const isRemote = (0, $3JWNV.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $01sWe.ImageLoadError)(failedPreview?.source);
            (0, $7xRaJ.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $5uXOq.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $3JWNV.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $3JWNV.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $3JZCV.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $93kaw.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("93kaw", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $d123d92fa0d5c1a9$export$46fd859414de9d62);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $VSDnB = parcelRequire("VSDnB");

var $dTQMj = parcelRequire("dTQMj");

var $7wsJE = parcelRequire("7wsJE");

var $eaxUQ = parcelRequire("eaxUQ");
function $d123d92fa0d5c1a9$var$useCurrentValueRef(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}
const $d123d92fa0d5c1a9$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $dTQMj.useMediaClient)();
    const innerRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const registerCopyIntentRef = $d123d92fa0d5c1a9$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $7wsJE.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $7wsJE.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $5uXOq.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $5uXOq.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) (0, $eaxUQ.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $eaxUQ.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("dTQMj", function(module, exports) {

$parcel$export(module.exports, "useMediaClient", () => $b143d4e1474eae5f$export$8b3e87ea56c3a345);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");

var $j9aMR = parcelRequire("j9aMR");
const $b143d4e1474eae5f$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $cEHh7.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $j9aMR.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("j9aMR", function(module, exports) {

$parcel$export(module.exports, "MediaContext", () => $67e1b660defdb678$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $67e1b660defdb678$export$57164260bc1f1218);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $85xkt = parcelRequire("85xkt");

var $6MEeI = parcelRequire("6MEeI");
const $67e1b660defdb678$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $67e1b660defdb678$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $5uXOq.useMemo)(()=>(0, $85xkt.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $6MEeI.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($67e1b660defdb678$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};

});
parcelRegister("6MEeI", function(module, exports) {

$parcel$export(module.exports, "useMediaParsedSettings", () => $8fe91b921518e593$export$d54af28440a5efc0);

var $5uXOq = parcelRequire("5uXOq");

var $g6aUe = parcelRequire("g6aUe");
const $8fe91b921518e593$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $5uXOq.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $g6aUe.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("g6aUe", function(module, exports) {

$parcel$export(module.exports, "defaultMediaUserPreferences", () => $216d5498643172f0$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $216d5498643172f0$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $216d5498643172f0$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($216d5498643172f0$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $216d5498643172f0$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $216d5498643172f0$export$2d23ed2854ac1650 = $216d5498643172f0$export$7e209e67b965bc63($216d5498643172f0$var$defaultUserPreferences);

});




parcelRegister("7wsJE", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $9a6af4835a9857e5$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $9a6af4835a9857e5$export$aacb463551da2e8f);

var $1As4I = parcelRequire("1As4I");
const $9a6af4835a9857e5$var$getRequestErrorDetails = (err)=>{
    if ((0, $1As4I.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $9a6af4835a9857e5$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $1As4I.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$9a6af4835a9857e5$var$getRequestErrorDetails(error)
        }
    };
};
const $9a6af4835a9857e5$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("eaxUQ", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $9ea95d3f3a6b1d04$export$f65ca476c09acec0);
const $9ea95d3f3a6b1d04$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("24tOd", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $768d10f5fd62ab89$export$90ff537b0999afb);

var $5uXOq = parcelRequire("5uXOq");

var $dTQMj = parcelRequire("dTQMj");

var $k4CmR = parcelRequire("k4CmR");
function $768d10f5fd62ab89$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $dTQMj.useMediaClient)();
    const fileState = (0, $k4CmR.useMediaStore)((state)=>state.files[id]);
    (0, $5uXOq.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("k4CmR", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $a907ffa2ecfaf54d$export$8a9cc8c330400af8);

var $6esDR = parcelRequire("6esDR");

var $dTQMj = parcelRequire("dTQMj");
const $a907ffa2ecfaf54d$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $6esDR.useStore)(store, selector, equals);
function $a907ffa2ecfaf54d$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $dTQMj.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $a907ffa2ecfaf54d$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("6esDR", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $489a4492a45245b1$export$6ccbb43953eebf8);

var $ee7sp = parcelRequire("ee7sp");

var $5uXOq = parcelRequire("5uXOq");

var $lNQti = parcelRequire("lNQti");
var $489a4492a45245b1$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $489a4492a45245b1$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)));
const { useSyncExternalStoreWithSelector: $489a4492a45245b1$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($lNQti)));
let $489a4492a45245b1$var$didWarnAboutEqualityFn = false;
const $489a4492a45245b1$var$identity = (arg)=>arg;
function $489a4492a45245b1$export$6ccbb43953eebf8(api, selector = $489a4492a45245b1$var$identity, equalityFn) {
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$489a4492a45245b1$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $489a4492a45245b1$var$didWarnAboutEqualityFn = true;
    }
    const slice = $489a4492a45245b1$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $489a4492a45245b1$var$useDebugValue(slice);
    return slice;
}
const $489a4492a45245b1$var$createImpl = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $ee7sp.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$489a4492a45245b1$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $489a4492a45245b1$export$185802fd694ee1f5 = (createState)=>createState ? $489a4492a45245b1$var$createImpl(createState) : $489a4492a45245b1$var$createImpl;
var $489a4492a45245b1$export$2e2bcd8739ae039 = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $489a4492a45245b1$export$185802fd694ee1f5(createState);
};

});
parcelRegister("lNQti", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hUiTL"));

});
parcelRegister("hUiTL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d096537a1780f6c5$export$bf730a2d8bf68b42, (v) => $d096537a1780f6c5$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d096537a1780f6c5$export$bf730a2d8bf68b42;
'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $goz36 = parcelRequire("goz36");
function $d096537a1780f6c5$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d096537a1780f6c5$var$q = "function" === typeof Object.is ? Object.is : $d096537a1780f6c5$var$p, $d096537a1780f6c5$var$r = $goz36.useSyncExternalStore, $d096537a1780f6c5$var$t = $5uXOq.useRef, $d096537a1780f6c5$var$u = $5uXOq.useEffect, $d096537a1780f6c5$var$v = $5uXOq.useMemo, $d096537a1780f6c5$var$w = $5uXOq.useDebugValue;
$d096537a1780f6c5$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $d096537a1780f6c5$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $d096537a1780f6c5$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($d096537a1780f6c5$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $d096537a1780f6c5$var$r(a, c[0], c[1]);
    $d096537a1780f6c5$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $d096537a1780f6c5$var$w(d);
    return d;
};

});
parcelRegister("goz36", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jcmQl"));

});
parcelRegister("jcmQl", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16, (v) => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dfa0db7ec3fca60b$export$306c0aa65ff9ec16;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $dfa0db7ec3fca60b$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $dfa0db7ec3fca60b$var$k = "function" === typeof Object.is ? Object.is : $dfa0db7ec3fca60b$var$h, $dfa0db7ec3fca60b$var$l = $5uXOq.useState, $dfa0db7ec3fca60b$var$m = $5uXOq.useEffect, $dfa0db7ec3fca60b$var$n = $5uXOq.useLayoutEffect, $dfa0db7ec3fca60b$var$p = $5uXOq.useDebugValue;
function $dfa0db7ec3fca60b$var$q(a, b) {
    var d = b(), f = $dfa0db7ec3fca60b$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $dfa0db7ec3fca60b$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $dfa0db7ec3fca60b$var$m(function() {
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $dfa0db7ec3fca60b$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $dfa0db7ec3fca60b$var$p(d);
    return d;
}
function $dfa0db7ec3fca60b$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$dfa0db7ec3fca60b$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $dfa0db7ec3fca60b$var$t(a, b) {
    return b();
}
var $dfa0db7ec3fca60b$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $dfa0db7ec3fca60b$var$t : $dfa0db7ec3fca60b$var$q;
$dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = void 0 !== $5uXOq.useSyncExternalStore ? $5uXOq.useSyncExternalStore : $dfa0db7ec3fca60b$var$u;

});







parcelRegister("kGpuq", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $d93d75d54376e990$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $d93d75d54376e990$export$768c370ed0dbaeb3);

var $gFZHi = parcelRequire("gFZHi");

var $01sWe = parcelRequire("01sWe");
const $d93d75d54376e990$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $d93d75d54376e990$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $d93d75d54376e990$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $d93d75d54376e990$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $d93d75d54376e990$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $d93d75d54376e990$export$4af9d71992e89714(error),
        error: $d93d75d54376e990$export$88c61dcad53762da(error),
        errorDetail: $d93d75d54376e990$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $d93d75d54376e990$export$29aa614726672b2e(error)
    };
};
const $d93d75d54376e990$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$d93d75d54376e990$export$74aaf4784c2edb2c(new (0, $01sWe.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("01sWe", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $fcceba16863dd854$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $fcceba16863dd854$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $fcceba16863dd854$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $fcceba16863dd854$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $fcceba16863dd854$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $fcceba16863dd854$export$7156ce7b78b49bd7);
class $fcceba16863dd854$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $fcceba16863dd854$export$2c035820a31723e extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$10ab445310d30114 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$18e89b7e50818288 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $fcceba16863dd854$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $fcceba16863dd854$export$d0a45ab59b4606b extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(source){
        super($fcceba16863dd854$var$getImageLoadPrimaryReason(source));
    }
}
function $fcceba16863dd854$export$553696a6e769784c(err) {
    return err instanceof $fcceba16863dd854$export$96e559194c287cf4;
}
const $fcceba16863dd854$export$b380593ba3516c6f = (err)=>err instanceof $fcceba16863dd854$export$2c035820a31723e;
const $fcceba16863dd854$export$e1d87830b3784f94 = (err)=>err instanceof $fcceba16863dd854$export$10ab445310d30114;
const $fcceba16863dd854$export$443aeb298d35d79d = (err)=>$fcceba16863dd854$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $fcceba16863dd854$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($fcceba16863dd854$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("3JWNV", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $609060e8f7210c63$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $609060e8f7210c63$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $609060e8f7210c63$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $609060e8f7210c63$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $609060e8f7210c63$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $609060e8f7210c63$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $609060e8f7210c63$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $609060e8f7210c63$export$98e935d981c884d);

var $9KG2L = parcelRequire("9KG2L");

var $01sWe = parcelRequire("01sWe");

var $7xRaJ = parcelRequire("7xRaJ");

var $4n1NZ = parcelRequire("4n1NZ");
const $609060e8f7210c63$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $7xRaJ.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $609060e8f7210c63$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $01sWe.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $609060e8f7210c63$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $609060e8f7210c63$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $609060e8f7210c63$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $609060e8f7210c63$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $609060e8f7210c63$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $609060e8f7210c63$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $4n1NZ.getRemotePreview)(mediaClient, id, params, traceContext);
    return $609060e8f7210c63$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $609060e8f7210c63$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $4n1NZ.getLocalPreview)(filePreview);
    return $609060e8f7210c63$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("9KG2L", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $3193ea5c2295e37f$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $3193ea5c2295e37f$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $3193ea5c2295e37f$export$e51a8146182600b8);
const $3193ea5c2295e37f$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $3193ea5c2295e37f$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$3193ea5c2295e37f$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $3193ea5c2295e37f$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $3193ea5c2295e37f$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $3193ea5c2295e37f$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $3193ea5c2295e37f$var$getStringFromParams(params, 'collection'),
        alt: $3193ea5c2295e37f$var$getStringFromParams(params, 'alt'),
        height: $3193ea5c2295e37f$var$getNumberFromParams(params, 'height'),
        width: $3193ea5c2295e37f$var$getNumberFromParams(params, 'width'),
        size: $3193ea5c2295e37f$var$getNumberFromParams(params, 'size'),
        name: $3193ea5c2295e37f$var$getStringFromParams(params, 'name'),
        mimeType: $3193ea5c2295e37f$var$getStringFromParams(params, 'mimeType')
    };
};
const $3193ea5c2295e37f$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $3193ea5c2295e37f$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$3193ea5c2295e37f$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $3193ea5c2295e37f$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("7xRaJ", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $abbc266dbfedc514$export$b7e8ee3f7a41459);

var $aAIop = parcelRequire("aAIop");
const $abbc266dbfedc514$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $abbc266dbfedc514$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $abbc266dbfedc514$export$b7e8ee3f7a41459 = new $abbc266dbfedc514$export$7b50526c091bb915((0, $aAIop.createObjectURLCache)());

});
parcelRegister("aAIop", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $0cfc22aea6c15367$export$ba71be67d5c32535);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $0cfc22aea6c15367$export$36d0f9859761643d = 50;
class $0cfc22aea6c15367$var$ExtendedLRUCache extends (0, $iwKVT.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $0cfc22aea6c15367$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $0cfc22aea6c15367$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $0cfc22aea6c15367$export$ba71be67d5c32535 = ()=>new $0cfc22aea6c15367$export$75d1c8c9ba1d0773($0cfc22aea6c15367$export$36d0f9859761643d);

});


parcelRegister("4n1NZ", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3b75ec6170865ae7$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3b75ec6170865ae7$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3b75ec6170865ae7$export$bfe20bd01db02b3);

var $jzW7G = parcelRequire("jzW7G");

var $48aIR = parcelRequire("48aIR");

var $01sWe = parcelRequire("01sWe");

var $Nl5sY = parcelRequire("Nl5sY");
const $3b75ec6170865ae7$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3b75ec6170865ae7$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $48aIR.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $Nl5sY.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $jzW7G.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3b75ec6170865ae7$var$getImageLocalPreview(value);
            case 'video':
                return $3b75ec6170865ae7$var$getVideoLocalPreview(value);
            default:
                throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
};
const $3b75ec6170865ae7$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $01sWe.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("48aIR", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $93f6c931eebc2be3$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $93f6c931eebc2be3$export$67689507e8404821);

var $k9Ch0 = parcelRequire("k9Ch0");

var $5m9mt = parcelRequire("5m9mt");

var $1xbJn = parcelRequire("1xbJn");

var $hNjKA = parcelRequire("hNjKA");
const { Orientation: $93f6c931eebc2be3$var$Orientation, XResolution: $93f6c931eebc2be3$var$XResolution } = (0, $k9Ch0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $93f6c931eebc2be3$var$DPI_WEB_BASELINE = 72;
async function $93f6c931eebc2be3$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $93f6c931eebc2be3$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $93f6c931eebc2be3$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $93f6c931eebc2be3$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
        else return $93f6c931eebc2be3$export$268f92356524130b(tags, $93f6c931eebc2be3$var$XResolution, $93f6c931eebc2be3$var$DPI_WEB_BASELINE) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $93f6c931eebc2be3$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$93f6c931eebc2be3$var$Orientation]) {
        const tagValue = tags[$93f6c931eebc2be3$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $k9Ch0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $93f6c931eebc2be3$export$67689507e8404821(file) {
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    return $93f6c931eebc2be3$var$getOrientationFromTags(tags);
}
function $93f6c931eebc2be3$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $93f6c931eebc2be3$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $1xbJn.loadImage)(src);
        const { width: width, height: height } = (0, $1xbJn.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("k9Ch0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $8ba626f637ae3df3$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $8ba626f637ae3df3$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $8ba626f637ae3df3$export$f6ea0c89fd7d156);
var $8ba626f637ae3df3$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $8ba626f637ae3df3$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $8ba626f637ae3df3$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("5m9mt", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $6da5c9a89db4de84$export$41982b5c7acb23c4);

var $k9Ch0 = parcelRequire("k9Ch0");

var $jkveD = parcelRequire("jkveD");

var $kINoG = parcelRequire("kINoG");

var $2edT6 = parcelRequire("2edT6");
async function $6da5c9a89db4de84$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $k9Ch0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $kINoG.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $2edT6.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $k9Ch0.ImageType).JPEG) return await (0, $jkveD.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("jkveD", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $537aa8dc852a8555$export$556b2ccec62d7f2a);

var $k9Ch0 = parcelRequire("k9Ch0");
const { XResolution: $537aa8dc852a8555$var$XResolution, YResolution: $537aa8dc852a8555$var$YResolution } = (0, $k9Ch0.SupportedImageMetaTag);
let $537aa8dc852a8555$var$loadImage;

function $537aa8dc852a8555$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$537aa8dc852a8555$var$loadImage) {
            const module = await (parcelRequire("iErjn"));
            $537aa8dc852a8555$var$loadImage = module.default || module;
        }
        $537aa8dc852a8555$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $537aa8dc852a8555$var$XResolution || key === $537aa8dc852a8555$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("iErjn", function(module, exports) {

let $d94125e60802a764$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d94125e60802a764$var$load("i57oW").then(()=>parcelRequire('8aLn9'));

});


parcelRegister("kINoG", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $013315ab2d0cc3cf$export$5fb37736440fca6f);

var $1xbJn = parcelRequire("1xbJn");
let $013315ab2d0cc3cf$var$pngChunksExtract;

async function $013315ab2d0cc3cf$export$5fb37736440fca6f(file) {
    if (!$013315ab2d0cc3cf$var$pngChunksExtract) {
        const module = await (parcelRequire("jegge"));
        $013315ab2d0cc3cf$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $1xbJn.fileToArrayBuffer)(file);
    const chunks = $013315ab2d0cc3cf$var$pngChunksExtract(buffer);
    return await $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks);
}
async function $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("1xbJn", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $3c9a3ebb8ee397f0$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $3c9a3ebb8ee397f0$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $3c9a3ebb8ee397f0$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $3c9a3ebb8ee397f0$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $3c9a3ebb8ee397f0$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $3c9a3ebb8ee397f0$export$61a1de0822e2820);

var $2tm8x = parcelRequire("2tm8x");

var $RiK2l = parcelRequire("RiK2l");

var $cHwqN = parcelRequire("cHwqN");

var $2sfBf = parcelRequire("2sfBf");

var $iABw2 = parcelRequire("iABw2");

var $7hpMa = parcelRequire("7hpMa");

var $dGYEZ = parcelRequire("dGYEZ");

var $iBOon = parcelRequire("iBOon");

var $jdlqN = parcelRequire("jdlqN");

var $c70Lr = parcelRequire("c70Lr");

var $2osAJ = parcelRequire("2osAJ");

var $7zjHG = parcelRequire("7zjHG");

var $8SPcB = parcelRequire("8SPcB");

var $es8mD = parcelRequire("es8mD");

var $gYsK7 = parcelRequire("gYsK7");

var $8RqHP = parcelRequire("8RqHP");
function $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $3c9a3ebb8ee397f0$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $3c9a3ebb8ee397f0$export$849633012686f7ee(file)
    };
}
async function $3c9a3ebb8ee397f0$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $3c9a3ebb8ee397f0$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $3c9a3ebb8ee397f0$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $3c9a3ebb8ee397f0$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $3c9a3ebb8ee397f0$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2tm8x)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2osAJ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c70Lr)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBOon)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2sfBf)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($es8mD)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHwqN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($RiK2l)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8SPcB)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7zjHG)))
    }
];
function $3c9a3ebb8ee397f0$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $3c9a3ebb8ee397f0$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $8RqHP.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gYsK7)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iABw2)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7hpMa)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dGYEZ)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("2tm8x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ccf7616b127308b$var$_react = $1ccf7616b127308b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1ccf7616b127308b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ccf7616b127308b$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $1ccf7616b127308b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1ccf7616b127308b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $1ccf7616b127308b$var$_default = module.exports.default = $1ccf7616b127308b$var$PdfDocument24Icon;

});

parcelRegister("RiK2l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0a037d07967bfa4f$var$_react = $0a037d07967bfa4f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $0a037d07967bfa4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0a037d07967bfa4f$var$Gif24Icon = (props)=>/*#__PURE__*/ $0a037d07967bfa4f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$0a037d07967bfa4f$var$Gif24Icon.displayName = 'Gif24Icon';
var $0a037d07967bfa4f$var$_default = module.exports.default = $0a037d07967bfa4f$var$Gif24Icon;

});

parcelRegister("cHwqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $93f2a85309224bbe$var$_react = $93f2a85309224bbe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $93f2a85309224bbe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93f2a85309224bbe$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $93f2a85309224bbe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$93f2a85309224bbe$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $93f2a85309224bbe$var$_default = module.exports.default = $93f2a85309224bbe$var$PowerpointPresentation24Icon;

});

parcelRegister("2sfBf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c9a4c12d2fc4227$var$_react = $1c9a4c12d2fc4227$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1c9a4c12d2fc4227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1c9a4c12d2fc4227$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $1c9a4c12d2fc4227$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c9a4c12d2fc4227$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $1c9a4c12d2fc4227$var$_default = module.exports.default = $1c9a4c12d2fc4227$var$WordDocument24Icon;

});

parcelRegister("iABw2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d888b0a1557aa645$var$_react = $d888b0a1557aa645$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d888b0a1557aa645$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d888b0a1557aa645$var$Sketch24Icon = (props)=>/*#__PURE__*/ $d888b0a1557aa645$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d888b0a1557aa645$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $d888b0a1557aa645$var$_default = module.exports.default = $d888b0a1557aa645$var$Sketch24Icon;

});

parcelRegister("7hpMa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $54ce1d7bd56eb231$var$_react = $54ce1d7bd56eb231$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $54ce1d7bd56eb231$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $54ce1d7bd56eb231$var$Figma24Icon = (props)=>/*#__PURE__*/ $54ce1d7bd56eb231$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$54ce1d7bd56eb231$var$Figma24Icon.displayName = 'Figma24Icon';
var $54ce1d7bd56eb231$var$_default = module.exports.default = $54ce1d7bd56eb231$var$Figma24Icon;

});

parcelRegister("dGYEZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9f7e406d5bea49df$var$_react = $9f7e406d5bea49df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9f7e406d5bea49df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f7e406d5bea49df$var$Executable24Icon = (props)=>/*#__PURE__*/ $9f7e406d5bea49df$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9f7e406d5bea49df$var$Executable24Icon.displayName = 'Executable24Icon';
var $9f7e406d5bea49df$var$_default = module.exports.default = $9f7e406d5bea49df$var$Executable24Icon;

});

parcelRegister("iBOon", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d8c2c58dddf5fcc0$var$_react = $d8c2c58dddf5fcc0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d8c2c58dddf5fcc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d8c2c58dddf5fcc0$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d8c2c58dddf5fcc0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d8c2c58dddf5fcc0$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d8c2c58dddf5fcc0$var$_default = module.exports.default = $d8c2c58dddf5fcc0$var$GoogleDoc24Icon;

});

parcelRegister("jdlqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $dfcfdb061c664b77$var$_react = $dfcfdb061c664b77$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $dfcfdb061c664b77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfcfdb061c664b77$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $dfcfdb061c664b77$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$dfcfdb061c664b77$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $dfcfdb061c664b77$var$_default = module.exports.default = $dfcfdb061c664b77$var$GoogleForm24Icon;

});

parcelRegister("c70Lr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8d16bb363c31083e$var$_react = $8d16bb363c31083e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $8d16bb363c31083e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d16bb363c31083e$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $8d16bb363c31083e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8d16bb363c31083e$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $8d16bb363c31083e$var$_default = module.exports.default = $8d16bb363c31083e$var$GoogleSheet24Icon;

});

parcelRegister("2osAJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1be4005185ae78d9$var$_react = $1be4005185ae78d9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1be4005185ae78d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1be4005185ae78d9$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $1be4005185ae78d9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1be4005185ae78d9$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $1be4005185ae78d9$var$_default = module.exports.default = $1be4005185ae78d9$var$GoogleSlide24Icon;

});

parcelRegister("7zjHG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $582b1603b710ea90$var$_react = $582b1603b710ea90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $582b1603b710ea90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $582b1603b710ea90$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $582b1603b710ea90$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$582b1603b710ea90$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $582b1603b710ea90$var$_default = module.exports.default = $582b1603b710ea90$var$ExcelSpreadsheet24Icon;

});

parcelRegister("8SPcB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $677b15938c7d624c$var$_react = $677b15938c7d624c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $677b15938c7d624c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $677b15938c7d624c$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $677b15938c7d624c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$677b15938c7d624c$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $677b15938c7d624c$var$_default = module.exports.default = $677b15938c7d624c$var$Spreadsheet24Icon;

});

parcelRegister("es8mD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a85a2b23143ceb75$var$_react = $a85a2b23143ceb75$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a85a2b23143ceb75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a85a2b23143ceb75$var$Presentation24Icon = (props)=>/*#__PURE__*/ $a85a2b23143ceb75$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a85a2b23143ceb75$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $a85a2b23143ceb75$var$_default = module.exports.default = $a85a2b23143ceb75$var$Presentation24Icon;

});

parcelRegister("gYsK7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c5b88baa981b1084$var$_react = $c5b88baa981b1084$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $c5b88baa981b1084$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c5b88baa981b1084$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $c5b88baa981b1084$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c5b88baa981b1084$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $c5b88baa981b1084$var$_default = module.exports.default = $c5b88baa981b1084$var$SourceCode24Icon;

});

parcelRegister("8RqHP", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $60b93921782d6d1e$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $60b93921782d6d1e$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $60b93921782d6d1e$export$ba4368c844580f9e);
function $60b93921782d6d1e$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $60b93921782d6d1e$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $60b93921782d6d1e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $60b93921782d6d1e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $60b93921782d6d1e$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("jegge", function(module, exports) {

let $dffbf02b1eb2951b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dffbf02b1eb2951b$var$load("4tH5n").then(()=>parcelRequire('eYIux'));

});


parcelRegister("2edT6", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $1cac606283e05089$export$55c3bc9841b19de2);
function $1cac606283e05089$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("hNjKA", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $81d3fceca65be0fc$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $81d3fceca65be0fc$export$43142f95b8de7a91);
const $81d3fceca65be0fc$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $81d3fceca65be0fc$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $81d3fceca65be0fc$export$43142f95b8de7a91 = (orientation)=>{
    return $81d3fceca65be0fc$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("Nl5sY", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $33ec34d1173165de$export$4269d30173168e5c);
const $33ec34d1173165de$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("3JZCV", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $293d53ca8ea6912a$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $293d53ca8ea6912a$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $293d53ca8ea6912a$export$de7c49925e44d75d);

var $1QRxp = parcelRequire("1QRxp");
const $293d53ca8ea6912a$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $293d53ca8ea6912a$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $293d53ca8ea6912a$var$dashed = (param)=>param ? `-${param}` : '';
const $293d53ca8ea6912a$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$293d53ca8ea6912a$var$dashed(collectionName)}${$293d53ca8ea6912a$var$dashed(occurrenceKey)}`;
const $293d53ca8ea6912a$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $293d53ca8ea6912a$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $1QRxp.printFunctionCall)($293d53ca8ea6912a$export$4310981e0aa4ce67, $293d53ca8ea6912a$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $1QRxp.printScript)([
        $293d53ca8ea6912a$export$ede93d4564eaa8da.toString(),
        $293d53ca8ea6912a$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $293d53ca8ea6912a$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $293d53ca8ea6912a$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("1QRxp", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $56ce1649d25a132b$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $56ce1649d25a132b$export$8b902fb69a2f17c1);

var $VSDnB = parcelRequire("VSDnB");
const $56ce1649d25a132b$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $56ce1649d25a132b$var$printParams = (args)=>args.map((arg)=>$56ce1649d25a132b$var$printParam(arg)).join(',');
const $56ce1649d25a132b$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$56ce1649d25a132b$var$printParams(args)});`;
const $56ce1649d25a132b$export$8b902fb69a2f17c1 = (statements)=>(0, $VSDnB.fg)('platform_remove_media_script_after_execution') ? `(function(){
 			 ${statements.join(';')}
  			document.currentScript.remove();
		})();
		` : `(function(){
   			${statements.join(';')}
 		})();`;

});


parcelRegister("jR4hE", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $815e3e27cebcb154$export$d3a890b0f7844b6f);

var $3JZCV = parcelRequire("3JZCV");
const $815e3e27cebcb154$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $3JZCV.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $3JZCV.getKey)(identifier)];
};

});

parcelRegister("8Kbwv", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $7b6d905fc3b6f0e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $7b6d905fc3b6f0e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db);

var $5uXOq = parcelRequire("5uXOq");
const $7b6d905fc3b6f0e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $7b6d905fc3b6f0e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $7b6d905fc3b6f0e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $7b6d905fc3b6f0e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}

});




parcelRegister("exfTw", function(module, exports) {

$parcel$export(module.exports, "ColoredTag", () => $eb002c47e3970036$export$526384205b143b58);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ek97b = parcelRequire("ek97b");

var $7ldcY = parcelRequire("7ldcY");
const $eb002c47e3970036$export$526384205b143b58 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ labelName: labelName, href: href, actionSubjectId: actionSubjectId, pressableXcss: pressableXcss, contentXcss: contentXcss, ...restProps }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { backgroundColor: color } = (0, $ek97b.getColorMetadata)((0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(labelName));
    const onHandleClick = (0, $5uXOq.useCallback)(()=>{
        if (href) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.href = href;
        if (actionSubjectId) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), actionSubjectId);
    }, [
        actionSubjectId,
        createAnalyticsEvent,
        href
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        ref: ref,
        xcss: [
            $eb002c47e3970036$var$tagStyles,
            ...pressableXcss ? [
                pressableXcss
            ] : []
        ],
        onClick: onHandleClick,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: color
        },
        ...restProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $eb002c47e3970036$var$tagTextStyles,
            ...contentXcss ? [
                contentXcss
            ] : []
        ]
    }, labelName));
});
const $eb002c47e3970036$var$tagStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    backgroundColor: 'color.background.neutral.subtle',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    paddingInline: 'space.050',
    paddingBlock: '0',
    font: 'font.body',
    marginBlock: 'space.050',
    marginInline: 'space.050',
    height: '20px',
    alignItems: 'center',
    maxWidth: '100%',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered',
        textDecoration: 'underline'
    }
});
const $eb002c47e3970036$var$tagTextStyles = (0, $8CUq3.xcss)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '180px'
});

});
parcelRegister("ek97b", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $c5f14892c9125c93$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $c5f14892c9125c93$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $c5f14892c9125c93$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $c5f14892c9125c93$export$49fce7fdcf55f26d);

var $1L3S5 = parcelRequire("1L3S5");
const $c5f14892c9125c93$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length);
    return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
};
const $c5f14892c9125c93$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $1L3S5.OPTION_COLOR_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $c5f14892c9125c93$export$9eff62e8ee2aaa2c = (colorName)=>(0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName]?.backgroundColor ?? '';
const $c5f14892c9125c93$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $1L3S5.GREY_META;
    return (0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName] ?? (0, $1L3S5.GREY_META);
};
const $c5f14892c9125c93$export$4ef6b7574883e63d = ()=>(0, $1L3S5.OPTION_COLOR_THEMES).map((item)=>item.name);

});
parcelRegister("1L3S5", function(module, exports) {

$parcel$export(module.exports, "GREY_META", () => $0d4a83e59182b411$export$11b75436f568ab00);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $0d4a83e59182b411$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $0d4a83e59182b411$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "OPTION_COLOR_THEMES", () => $0d4a83e59182b411$export$7f42563469df7e01);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT", () => $0d4a83e59182b411$export$2c649adf8351b065);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_MAP", () => $0d4a83e59182b411$export$7c14120abebd4749);

var $9GtPC = parcelRequire("9GtPC");
const $0d4a83e59182b411$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).greyLightest
};
const $0d4a83e59182b411$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).greyLighter
};
const $0d4a83e59182b411$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).grey
};
const $0d4a83e59182b411$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greyDarker
};
const $0d4a83e59182b411$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greyDarkest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLightest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLighter
};
const $0d4a83e59182b411$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purple
};
const $0d4a83e59182b411$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).purpleDarker
};
const $0d4a83e59182b411$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).purpleDarkest
};
const $0d4a83e59182b411$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLightest
};
const $0d4a83e59182b411$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLighter
};
const $0d4a83e59182b411$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blue
};
const $0d4a83e59182b411$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).blueDarker
};
const $0d4a83e59182b411$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).blueDarkest
};
const $0d4a83e59182b411$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLightest
};
const $0d4a83e59182b411$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLighter
};
const $0d4a83e59182b411$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).teal
};
const $0d4a83e59182b411$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).tealDarker
};
const $0d4a83e59182b411$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).tealDarkest
};
const $0d4a83e59182b411$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLightest
};
const $0d4a83e59182b411$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLighter
};
const $0d4a83e59182b411$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).green
};
const $0d4a83e59182b411$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greenDarker
};
const $0d4a83e59182b411$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greenDarkest
};
const $0d4a83e59182b411$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLightest
};
const $0d4a83e59182b411$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLighter
};
const $0d4a83e59182b411$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).lime
};
const $0d4a83e59182b411$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).limeDarker
};
const $0d4a83e59182b411$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).limeDarkest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLightest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLighter
};
const $0d4a83e59182b411$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellow
};
const $0d4a83e59182b411$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).yellowDarker
};
const $0d4a83e59182b411$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).yellowDarkest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLightest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLighter
};
const $0d4a83e59182b411$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orange
};
const $0d4a83e59182b411$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).orangeDarker
};
const $0d4a83e59182b411$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).orangeDarkest
};
const $0d4a83e59182b411$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLightest
};
const $0d4a83e59182b411$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLighter
};
const $0d4a83e59182b411$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).red
};
const $0d4a83e59182b411$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).redDarker
};
const $0d4a83e59182b411$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).redDarkest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magentaLightest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magentaLighter
};
const $0d4a83e59182b411$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magenta
};
const $0d4a83e59182b411$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).magentaDarker
};
const $0d4a83e59182b411$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).magentaDarkest
};
const $0d4a83e59182b411$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $0d4a83e59182b411$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $0d4a83e59182b411$export$7f42563469df7e01 = [
    $0d4a83e59182b411$var$GREY_LIGHTEST_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTEST_META,
    $0d4a83e59182b411$var$BLUE_LIGHTEST_META,
    $0d4a83e59182b411$var$TEAL_LIGHTEST_META,
    $0d4a83e59182b411$var$GREEN_LIGHTEST_META,
    $0d4a83e59182b411$var$LIME_LIGHTEST_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTEST_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTEST_META,
    $0d4a83e59182b411$var$RED_LIGHTEST_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META,
    $0d4a83e59182b411$var$GREY_LIGHTER_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTER_META,
    $0d4a83e59182b411$var$BLUE_LIGHTER_META,
    $0d4a83e59182b411$var$TEAL_LIGHTER_META,
    $0d4a83e59182b411$var$GREEN_LIGHTER_META,
    $0d4a83e59182b411$var$LIME_LIGHTER_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTER_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTER_META,
    $0d4a83e59182b411$var$RED_LIGHTER_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTER_META,
    $0d4a83e59182b411$export$11b75436f568ab00,
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$BLUE_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$LIME_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$7c314e2461a7241b,
    $0d4a83e59182b411$var$BLUE_DARKER_META,
    $0d4a83e59182b411$export$6daaa1cc3f46f41,
    $0d4a83e59182b411$var$GREEN_DARKER_META,
    $0d4a83e59182b411$var$LIME_DARKER_META,
    $0d4a83e59182b411$var$YELLOW_DARKER_META,
    $0d4a83e59182b411$var$ORANGE_DARKER_META,
    $0d4a83e59182b411$var$RED_DARKER_META,
    $0d4a83e59182b411$var$MAGENTA_DARKER_META,
    $0d4a83e59182b411$var$GREY_DARKEST_META,
    $0d4a83e59182b411$var$PURPLE_DARKEST_META,
    $0d4a83e59182b411$export$69c4eac71b813fba,
    $0d4a83e59182b411$var$TEAL_DARKEST_META,
    $0d4a83e59182b411$var$GREEN_DARKEST_META,
    $0d4a83e59182b411$var$LIME_DARKEST_META,
    $0d4a83e59182b411$var$YELLOW_DARKEST_META,
    $0d4a83e59182b411$var$ORANGE_DARKEST_META,
    $0d4a83e59182b411$var$RED_DARKEST_META,
    $0d4a83e59182b411$var$MAGENTA_DARKEST_META
];
const $0d4a83e59182b411$export$2c649adf8351b065 = [
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$11b75436f568ab00
];
const $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$0d4a83e59182b411$export$2c649adf8351b065.forEach((option)=>{
    $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $0d4a83e59182b411$export$7c14120abebd4749 = {};
$0d4a83e59182b411$export$7f42563469df7e01.forEach((option)=>{
    $0d4a83e59182b411$export$7c14120abebd4749[option.name] = option;
});

});
parcelRegister("9GtPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8610941b4777e2f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8610941b4777e2f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    greyLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});



parcelRegister("7ldcY", function(module, exports) {

$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabels", () => $7fa3a87d53177c9e$export$8100203285e9ab92);
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabelsTag", () => $7fa3a87d53177c9e$export$a80529ae8ec44f02);

var $gJBT6 = parcelRequire("gJBT6");

var $1L3S5 = parcelRequire("1L3S5");

var $fzY6y = parcelRequire("fzY6y");

var $96pcJ = parcelRequire("96pcJ");
const $7fa3a87d53177c9e$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $1L3S5.GREY_META).name;
};
const $7fa3a87d53177c9e$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $1L3S5.GREY_META).tagColor;
};
const $7fa3a87d53177c9e$export$8100203285e9ab92 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$97056d4b28203ee9);
const $7fa3a87d53177c9e$export$a80529ae8ec44f02 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$a3f5334e7a13e57a);

});
parcelRegister("fzY6y", function(module, exports) {

$parcel$export(module.exports, "getHashValueForText", () => $899e3507d4080274$export$e352defce701b36e);

const $899e3507d4080274$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $37d3405989cb4520$export$d15e38bcd75fda7c) + text.charCodeAt(i)) % (0, $37d3405989cb4520$export$e143f4b09221a374);
    return hashValue;
};

});
/*
 * This is used to calculate the hash value of the provided text,
 * allowing us to generate random hash values for the options in the Labels field.
 * As a result, we enhance the randomization of color assignments to Labels.
 */ const $37d3405989cb4520$export$d15e38bcd75fda7c = 256;
const $37d3405989cb4520$export$e143f4b09221a374 = 1000000007;


parcelRegister("96pcJ", function(module, exports) {

$parcel$export(module.exports, "getRandomIndex", () => $9ffc042ff38af51a$export$cb0dffe2d2ae675a);

var $1L3S5 = parcelRequire("1L3S5");
const $9ffc042ff38af51a$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};

});



parcelRegister("kFniW", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f16a4690143373$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hjSul = parcelRequire("hjSul");

var $4R6GH = parcelRequire("4R6GH");

var $2e4p8 = parcelRequire("2e4p8");
const $43f16a4690143373$var$Link = ({ onClick: onClick, wordBreak: wordBreak = true, shouldDisplayStrikethrough: shouldDisplayStrikethrough = false, ...rest })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isEmbedMode = (0, $4R6GH.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2e4p8.useIsEmbedMode)() : false;
    const onClickWithAnalytics = (0, $5uXOq.useCallback)((e)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'listWithPopup');
        onClick && onClick(e);
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($43f16a4690143373$var$StyledLink, {
        wordBreak: wordBreak,
        shouldDisplayStrikethrough: shouldDisplayStrikethrough,
        ...rest,
        onClick: onClickWithAnalytics,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    });
};
// Fix for Compiled bug where invalid props are passed on to the underlying DOM element when using inheritance.
const $43f16a4690143373$var$PropFilteredLink = ({ wordBreak: wordBreak, shouldDisplayStrikethrough: shouldDisplayStrikethrough, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), rest);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $43f16a4690143373$var$StyledLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $43f16a4690143373$var$PropFilteredLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.wordBreak && "_1nmz1hna",
            __cmplp.shouldDisplayStrikethrough && "_4bfu1r81 _1hms1cog _ajmmvv82",
            __cmplp.className
        ])
    });
});
var $43f16a4690143373$export$2e2bcd8739ae039 = $43f16a4690143373$var$Link;

});


parcelRegister("hKMVG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2a12d0d4da4e2c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $bU3PY = parcelRequire("bU3PY");

var $3bDjY = parcelRequire("3bDjY");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $dpHMc = parcelRequire("dpHMc");

var $czfFt = parcelRequire("czfFt");

var $e9M6d = parcelRequire("e9M6d");

var $izbCX = parcelRequire("izbCX");
const $6b2a12d0d4da4e2c$var$ErrorCell = ({ cellType: cellType, reason: reason, errorInfo: errorInfo })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovered(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovered(false), []);
    const iconColor = isHovered ? "var(--ds-icon, #44546F)" : "var(--ds-icon-subtle, #626F86)";
    const message = formatMessage((0, $izbCX.default).tooltip);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    (0, $5uXOq.useEffect)(()=>{
        const sendAnalytics = ()=>{
            const error = new Error(`Failed to render cell data for the ${cellType} cell type. Reason: ${reason}`);
            (0, $jcw0u.default)({
                meta: {
                    id: 'errorCell',
                    packageName: (0, $czfFt.PACKAGE_NAME),
                    teamName: (0, $czfFt.TEAM_NAME)
                },
                error: error,
                errorInfo: errorInfo,
                event: createAnalyticsEvent({}),
                attributes: {
                    cellType: cellType
                },
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const sendAnalyticsDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(sendAnalytics);
        sendAnalyticsDebounced();
        // Cancel any debounced events on unmount. This prevents sending an error event when the cell was mounted
        // due to an intermediary render. We've observed this when new columns are committed to the Relay store
        // in a separate render before issue field sets are aligned.
        return ()=>{
            sendAnalyticsDebounced.cancel();
        };
    // Only fire on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const cellContent = (ref = null)=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "native-issue-table.common.error-cell.tooltip-target",
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            color: iconColor,
            label: message,
            spacing: "spacious"
        }));
    if (isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: message
    }, ({ ref: ref })=>cellContent(ref));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message,
        position: "bottom-start"
    }, cellContent());
};
var $6b2a12d0d4da4e2c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($6b2a12d0d4da4e2c$var$ErrorCell);

});
parcelRegister("izbCX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d78808ca6282d09$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0d78808ca6282d09$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "native-issue-table.common.error-cell.tooltip",
        "defaultMessage": "We couldn\u2019t load this field\u2019s details. Refresh and try again."
    }
});

});


parcelRegister("hVZ8e", function(module, exports) {

$parcel$export(module.exports, "default", () => $03882a9250f9b8e6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $03882a9250f9b8e6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.affected-services.trigger-button",
        "defaultMessage": "See more affected services"
    }
});

});


parcelRegister("14NPb", function(module, exports) {

$parcel$export(module.exports, "LoadingCell", () => $1312fd4d73799d6d$export$5191481abee8295e);

var $5uXOq = parcelRequire("5uXOq");

var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");

var $1v6c5 = parcelRequire("1v6c5");
const $1312fd4d73799d6d$export$5191481abee8295e = ({ cellBorder: cellBorder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1v6c5.TableCell), {
        border: cellBorder ?? $1312fd4d73799d6d$var$cellBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        testId: "native-issue-table.common.ui.issue-cells.loading-cell",
        height: "16px",
        width: "100%",
        borderRadius: "3px"
    }));
};
const $1312fd4d73799d6d$var$cellBorderStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTopWidth: '0',
    borderBottomWidth: 'border.width',
    borderLeftWidth: '0',
    borderRightWidth: 'border.width'
});

});

parcelRegister("bKdpc", function(module, exports) {

$parcel$export(module.exports, "CheckboxSelectCell", () => $e20d6ddd65627d3a$export$1fd5a9db1fedc6bb);

var $kg8MW = parcelRequire("kg8MW");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1z0GS = parcelRequire("1z0GS");

var $jFYC8 = parcelRequire("jFYC8");

var $Br57E = parcelRequire("Br57E");

var $e9M6d = parcelRequire("e9M6d");
const $e20d6ddd65627d3a$export$1fd5a9db1fedc6bb = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $kg8MW.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1z0GS.CheckboxSelectInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: true,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
};

});
parcelRegister("kg8MW", function(module, exports) {

$parcel$export(module.exports, "default", () => $93c83fc6c181ed01$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b92cc8d61690b086c94cc5bd1949b44b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $93c83fc6c181ed01$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "checkboxSelect_nativeIssueTable_CheckboxSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraCheckboxesField"
};
$93c83fc6c181ed01$var$node.hash = "2c20809123ea14dfdd133e575ffd4309";
var $93c83fc6c181ed01$export$2e2bcd8739ae039 = $93c83fc6c181ed01$var$node;

});

parcelRegister("1z0GS", function(module, exports) {

$parcel$export(module.exports, "CheckboxSelectInlineEditViewWithIsEditable", () => $484756d133ac810d$export$1b3be05b9a6273f2);

var $a4i8S = parcelRequire("a4i8S");

var $aswMc = parcelRequire("aswMc");

var $8LBj9 = parcelRequire("8LBj9");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $1CKDg = parcelRequire("1CKDg");

var $kQfA4 = parcelRequire("kQfA4");

var $jrRyX = parcelRequire("jrRyX");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $484756d133ac810d$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.value));
    return b.every((option)=>aIdSet.has(option.value));
};
const $484756d133ac810d$export$1b3be05b9a6273f2 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled })=>{
    const data = (0, $8Uumt.useFragment)((0, $8LBj9.default), fragmentRef);
    const [commit] = (0, $8Uumt.useMutation)((0, $aswMc.default));
    const { id: uniqueFieldId, name: name, selectedOptions: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $5uXOq.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                value: edge?.node?.id ?? '',
                label: edge?.node?.value ?? ''
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $5uXOq.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.value) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateCheckboxesField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateCheckboxesField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedOptions: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.value ?? '',
                                            value: edge.label ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $484756d133ac810d$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'checkboxSelect'
    });
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kQfA4.CheckboxSelectReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isHoverPopoverEnabled: isSingleLineRowHeightEnabled
        }), [
        data,
        isTruncated,
        isSingleLineRowHeightEnabled
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            fetchSuggestionsOnMount: true,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $1CKDg.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
};
const $484756d133ac810d$export$110d4fbf3ef97d6 = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $8Uumt.useFragment)((0, $a4i8S.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($484756d133ac810d$export$1b3be05b9a6273f2, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("a4i8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8ca297040baf27$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<865dcb3c94a5735613636474e65b5c54>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0e8ca297040baf27$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraCheckboxesField"
};
$0e8ca297040baf27$var$node.hash = "578907f93847166d177912bba783cc44";
var $0e8ca297040baf27$export$2e2bcd8739ae039 = $0e8ca297040baf27$var$node;

});

parcelRegister("aswMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cd5293e18006da5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a674bc11003d5a4f6042bd041448c62>>
 * @relayHash 2f2935fb2f2e43d33d4c8ed1e1b2cd67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8540386bf8ddcde1b4f569318aad611087a8b356d205fa2274ec5675ba438f8e
const $6cd5293e18006da5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "checkboxSelect_issueFieldCheckboxSelect_CheckboxSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCheckboxesFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCheckboxesField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCheckboxesField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "checkboxSelect_issueFieldCheckboxSelect_CheckboxSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCheckboxesFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCheckboxesField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCheckboxesField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8540386bf8ddcde1b4f569318aad611087a8b356d205fa2274ec5675ba438f8e",
            "metadata": {},
            "name": "checkboxSelect_issueFieldCheckboxSelect_CheckboxSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$6cd5293e18006da5$var$node.hash = "8471c6b898ae5a82094ee733778542d4";
var $6cd5293e18006da5$export$2e2bcd8739ae039 = $6cd5293e18006da5$var$node;

});

parcelRegister("8LBj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $60cf2c11d2356008$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e85c1b6294972f8a4727536d560cd70>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $60cf2c11d2356008$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "checkboxSelect_issueFieldCheckboxSelectReadviewFull_CheckboxSelectReadView"
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCheckboxesField"
    };
}();
$60cf2c11d2356008$var$node.hash = "949a32b9c93f1898a846b4634eca9e93";
var $60cf2c11d2356008$export$2e2bcd8739ae039 = $60cf2c11d2356008$var$node;

});

parcelRegister("7F8HM", function(module, exports) {

$parcel$export(module.exports, "useFieldInlineEditActions", () => $66d60cf6484b11a4$export$ad535fb3592a66ff);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $ctrpc = parcelRequire("ctrpc");

var $adLrP = parcelRequire("adLrP");

var $7Gz0U = parcelRequire("7Gz0U");

var $dSSeS = parcelRequire("dSSeS");

var $cIZbf = parcelRequire("cIZbf");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hGyAY = parcelRequire("hGyAY");

var $jv5ZP = parcelRequire("jv5ZP");

var $bgqP5 = parcelRequire("bgqP5");

var $d2Afy = parcelRequire("d2Afy");

var $9AfTz = parcelRequire("9AfTz");
const $66d60cf6484b11a4$var$defaultIsEquals = (a, b)=>a === b;
const $66d60cf6484b11a4$export$ad535fb3592a66ff = ({ attributes: attributes, fieldId: fieldId, fieldName: fieldName, fieldType: fieldType, initialValue: initialValue, isValueEqual: isValueEqual = $66d60cf6484b11a4$var$defaultIsEquals, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, onUpdateValue: onUpdateValue, startWithEditViewOpen: startWithEditViewOpen = false, updatedValue: updatedValue, validator: validator, setAnalyticsAttributes: setAnalyticsAttributes, analyticsFieldType: analyticsFieldType, clipboardComponentType: clipboardComponentType })=>{
    const [isEditing, setIsEditing] = (0, $adLrP.useOptionallyControlledEditingState)(startWithEditViewOpen, fieldId, {
        // Ensure our updatedValue is re-initialised if editing is enabled via an external store update
        onSharedChange: (sharedIsEditing)=>sharedIsEditing && onUpdateValue(initialValue, true)
    });
    const [{ isRealTimeCommentUpdated: isRealTimeCommentUpdated }] = (0, $9AfTz.useRealTimeComments)();
    const [invalidMessage, { validateChange: validateChange, validateSubmit: validateSubmit, clearValidation: clearValidation }] = (0, $7Gz0U.useClientValidationHandler)(validator);
    const [hasServerValidationError, { handleSubmitFailed: handleSubmitFailed, clearServerValidation: clearServerValidation }] = (0, $dSSeS.useServerValidationHandler)(fieldName, setIsEditing, onSubmitFailed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    /** Clear any validation errors and transition to read view. */ const onStopEditing = (0, $5uXOq.useCallback)(()=>{
        clearValidation();
        clearServerValidation();
        setIsEditing(false);
    }, [
        clearServerValidation,
        clearValidation,
        setIsEditing
    ]);
    /** Handler to validate and submit the updated value for a field. */ const handleSubmit = (0, $5uXOq.useCallback)((value, analyticsEvent)=>{
        // Early exit if a validation error is present
        if (validateSubmit(value) === 'error') return;
        onStopEditing();
        // Skip mutation if value is unchanged
        if (isValueEqual(initialValue, value)) return;
        onSubmit(value, {
            onSuccess: ()=>{
                // Field updated event is a core action used to track MCU as defined in https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'field updated', {
                    ...attributes,
                    fieldKey: fieldId,
                    fieldType: fieldType,
                    ...(0, $4R6GH.fg)('thor_send_realtime_attribute') ? {
                        isRealTimeCommentUpdated: !!isRealTimeCommentUpdated
                    } : {}
                });
                onSubmitSucceeded?.(value);
            },
            onFail: (error, message)=>{
                handleSubmitFailed(error, message);
                if (!(0, $4R6GH.fg)('relay-migration-issue-fields-assignee-fg')) onSubmitFailed?.(); // we don't need this since it's called in handleSubmitFailed
            }
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    }, [
        attributes,
        createAnalyticsEvent,
        fieldId,
        fieldType,
        handleSubmitFailed,
        initialValue,
        isValueEqual,
        onStopEditing,
        onSubmit,
        onSubmitFailed,
        onSubmitSucceeded,
        validateSubmit,
        isRealTimeCommentUpdated
    ]);
    /** Exits `editView` and switches back to `readView`. This is called when the cancel action button (x) is clicked. */ const handleCancel = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        onStopEditing();
        onCancel?.();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    }, [
        onCancel,
        onStopEditing
    ]);
    /** Handler called when readView is clicked. */ const handleEdit = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        // Re-initialise the edit view value unless there is a server error, in which case we want to preserve the
        // previous dirty value.
        if (!hasServerValidationError) onUpdateValue(initialValue, true);
        setIsEditing(true);
        onEdit?.();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
            const fieldIdWithoutAri = (0, $cIZbf.getFieldIdFromAri)(fieldId);
            const fieldTypeAttribute = analyticsFieldType ?? fieldType;
            if (fieldIdWithoutAri && fieldTypeAttribute) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart(fieldIdWithoutAri, {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: fieldTypeAttribute
                }
            });
        }
    }, [
        hasServerValidationError,
        setIsEditing,
        onEdit,
        fieldId,
        fieldType,
        onUpdateValue,
        initialValue,
        createAnalyticsEvent,
        analyticsFieldType
    ]);
    /** Saves and confirms the value entered into the field. It exits `editView` and returns to `readView`. */ const handleConfirm = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        handleSubmit(updatedValue, analyticsEvent);
    }, [
        handleSubmit,
        updatedValue
    ]);
    /**
	 * Handler called when the `editView` is updated by the user. This will validate the input and call
	 * `onUpdateValue` to update the value in state.
	 */ const handleChange = (0, $5uXOq.useCallback)((value)=>{
        validateChange(value);
        onUpdateValue(value, false);
        (0, $4R6GH.fg)('one_event_rules_them_all_fg') && setAnalyticsAttributes?.(value);
    }, [
        onUpdateValue,
        setAnalyticsAttributes,
        validateChange
    ]);
    /**
	 * Handler called when the `editView` is updated by the user which will immediately confirm the value and return to
	 * `readView`.
	 *
	 * Note that this **will not** run any `change` validator functions. Consumers should instead define a `submit`
	 * validator function if required.
	 */ const handleChangeAndConfirm = (0, $5uXOq.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: 'inlineEdit'
        });
        onUpdateValue(value, false);
        handleSubmit(value, analyticsEvent);
        (0, $4R6GH.fg)('one_event_rules_them_all_fg') && setAnalyticsAttributes?.(value);
    }, [
        createAnalyticsEvent,
        handleSubmit,
        onUpdateValue,
        setAnalyticsAttributes
    ]);
    const reportClipboardError = (0, $bgqP5.useClipboardErrorReporting)(fieldName, fieldType);
    /**
	 * Attempt to submit changes to a field in the background (i.e. while remaining in `readView`). If the updated
	 * value fails `change` or `submit` validation then we forcibly switch to `editView` to allow users to correct
	 * their changes.
	 */ const handleBackgroundSubmit = (0, $5uXOq.useCallback)((value)=>{
        if (validateChange(value) === 'error' || validateSubmit(value) === 'error') {
            onUpdateValue(value, false);
            setIsEditing(true);
        } else handleChangeAndConfirm(value);
    }, [
        handleChangeAndConfirm,
        setIsEditing,
        onUpdateValue,
        validateChange,
        validateSubmit
    ]);
    const copyToClipboard = (0, $5uXOq.useMemo)(()=>{
        if (!(0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) return undefined;
        return clipboardComponentType !== undefined ? (0, $hGyAY.getOnCopyHandler)(clipboardComponentType, /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        initialValue) : undefined;
    }, [
        clipboardComponentType,
        initialValue
    ]);
    const handleCopy = (0, $5uXOq.useMemo)(()=>{
        if (!(0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) return undefined;
        return ()=>{
            if (copyToClipboard) {
                copyToClipboard();
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clipboardCopy',
                    actionSubject: 'inlineEdit'
                }));
                // Signal the copy event has been explicitly handled
                return true;
            }
            reportClipboardError((0, $jv5ZP.ClipboardValidationError).copyOperationUnsupported());
            return false;
        };
    }, [
        copyToClipboard,
        createAnalyticsEvent,
        reportClipboardError
    ]);
    const handleCut = (0, $5uXOq.useMemo)(()=>{
        if (!(0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) return undefined;
        return ()=>{
            if (clipboardComponentType !== undefined && copyToClipboard) {
                copyToClipboard();
                if ((0, $d2Afy.isNullableComponentType)(clipboardComponentType)) /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handleBackgroundSubmit(null);
                else if ((0, $d2Afy.isStringComponentType)(clipboardComponentType)) /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handleBackgroundSubmit('');
                else if ((0, $d2Afy.isArrayComponentType)(clipboardComponentType)) /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handleBackgroundSubmit([]);
                else reportClipboardError((0, $jv5ZP.ClipboardValidationError).cutNonEditableError(clipboardComponentType));
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clipboardCut',
                    actionSubject: 'inlineEdit'
                }));
                // Signal the copy event has been explicitly handled
                return true;
            }
            reportClipboardError((0, $jv5ZP.ClipboardValidationError).cutOperationUnsupported());
            return false;
        };
    }, [
        clipboardComponentType,
        copyToClipboard,
        createAnalyticsEvent,
        handleBackgroundSubmit,
        reportClipboardError
    ]);
    const handlePaste = (0, $5uXOq.useMemo)(()=>{
        if (!(0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) return undefined;
        if (clipboardComponentType !== undefined) {
            const onPaste = (0, $hGyAY.getOnPasteHandler)(clipboardComponentType);
            return (e)=>{
                try {
                    const value = onPaste(e);
                    if (value !== undefined) {
                        /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
						 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        handleBackgroundSubmit(value);
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                            action: 'clipboardPaste',
                            actionSubject: 'inlineEdit'
                        }));
                        // Signal the paste event has been explicitly handled
                        return true;
                    }
                } catch (error) {
                    reportClipboardError(error instanceof Error ? error : undefined);
                }
                return false;
            };
        }
        return ()=>{
            reportClipboardError((0, $jv5ZP.ClipboardValidationError).pasteOperationUnsupported());
            return false;
        };
    }, [
        clipboardComponentType,
        createAnalyticsEvent,
        handleBackgroundSubmit,
        reportClipboardError
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            handleCancel: handleCancel,
            handleEdit: handleEdit,
            handleConfirm: handleConfirm,
            handleChange: handleChange,
            handleChangeAndConfirm: handleChangeAndConfirm,
            hasServerValidationError: hasServerValidationError,
            handleCopy: handleCopy,
            handleCut: handleCut,
            handlePaste: handlePaste,
            invalidMessage: invalidMessage,
            isEditing: isEditing
        }), [
        handleCancel,
        handleChange,
        handleChangeAndConfirm,
        handleConfirm,
        handleEdit,
        handleCopy,
        handleCut,
        handlePaste,
        hasServerValidationError,
        invalidMessage,
        isEditing
    ]);
};

});
parcelRegister("adLrP", function(module, exports) {

$parcel$export(module.exports, "IssueContext", () => $77202c44007377c1$export$c436e295255cfd98);
$parcel$export(module.exports, "IssueFieldEditingContextProvider", () => $77202c44007377c1$export$4bdcf555c5e0921f);
$parcel$export(module.exports, "useOptionallyControlledEditingState", () => $77202c44007377c1$export$db1e18c2e86e1a50);

var $5uXOq = parcelRequire("5uXOq");

var $7XMcV = parcelRequire("7XMcV");
const $77202c44007377c1$export$c436e295255cfd98 = /*#__PURE__*/ (0, $5uXOq.createContext)('localStateMode');
const $77202c44007377c1$export$4bdcf555c5e0921f = ({ children: children, scope: scope })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($77202c44007377c1$export$c436e295255cfd98.Provider, {
        value: "sharedStateMode"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XMcV.FieldEditingContainer), {
        scope: scope
    }, children));
const $77202c44007377c1$export$db1e18c2e86e1a50 = (initialState, fieldId, onChangeMethods)=>{
    const editingContext = (0, $5uXOq.useContext)($77202c44007377c1$export$c436e295255cfd98);
    const isLocalStateMode = editingContext !== 'sharedStateMode';
    const [sharedState, { setFieldEditingState: setFieldEditingState }] = (0, $7XMcV.useFieldIsEditing)(fieldId);
    const [localState, setLocalState] = (0, $5uXOq.useState)(isLocalStateMode ? initialState : sharedState);
    const unifiedOnChange = (0, $5uXOq.useCallback)((newValue)=>{
        onChangeMethods?.onLocalChange?.(newValue, localState);
        onChangeMethods?.onChange?.(newValue, localState);
        setLocalState(newValue);
        if (!isLocalStateMode) setFieldEditingState(fieldId, newValue);
    }, [
        fieldId,
        isLocalStateMode,
        onChangeMethods,
        setFieldEditingState,
        localState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // If sharedState updates to a value that is different from localState, it's a shared state update.
        // Otherwise, it's just the shared state following a locally triggered state update
        if (!isLocalStateMode && sharedState !== localState) {
            onChangeMethods?.onSharedChange?.(sharedState, !sharedState);
            onChangeMethods?.onChange?.(sharedState, !sharedState);
            setLocalState(sharedState);
        }
    // We want to ensure this useEffect is only called when the sharedState changes, not when any other dependencies change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sharedState
    ]);
    const resultState = isLocalStateMode ? localState : sharedState;
    return [
        resultState,
        unifiedOnChange
    ];
};

});
parcelRegister("7XMcV", function(module, exports) {

$parcel$export(module.exports, "useFieldIsEditing", () => $d64f2f6e0dff1a32$export$3734a1b20e979e6e);
$parcel$export(module.exports, "useFieldIsEditingActions", () => $d64f2f6e0dff1a32$export$a4850d650526df2e);
$parcel$export(module.exports, "FieldEditingContainer", () => $d64f2f6e0dff1a32$export$4301025b8d3e0255);

var $dPSWJ = parcelRequire("dPSWJ");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $d64f2f6e0dff1a32$var$Store = (0, $iXqE5.createStore)({
    initialState: {},
    actions: {
        setFieldEditingState: (fieldId, isEditing)=>({ setState: setState })=>{
                setState({
                    [fieldId]: isEditing
                });
            },
        toggleFieldEditingState: (fieldId)=>({ setState: setState, getState: getState })=>{
                if (getState()[fieldId] == null) return undefined;
                const toggledValue = !getState()[fieldId];
                setState({
                    [fieldId]: toggledValue
                });
                return toggledValue;
            },
        getFieldEditingState: (fieldId)=>({ getState: getState })=>getState()[fieldId],
        resetFieldEditingStateStore: ()=>({ setState: setState, getState: getState })=>{
                setState((0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(getState(), ()=>false));
            }
    },
    name: 'FieldEditingState'
});
const $d64f2f6e0dff1a32$export$3734a1b20e979e6e = (0, $3sQ5x.createHook)($d64f2f6e0dff1a32$var$Store, {
    selector: (state, arg)=>state[arg] != null ? state[arg] : false
});
const $d64f2f6e0dff1a32$export$a4850d650526df2e = (0, $3sQ5x.createActionsHook)($d64f2f6e0dff1a32$var$Store);
const $d64f2f6e0dff1a32$export$4301025b8d3e0255 = (0, $gg7kZ.createContainer)($d64f2f6e0dff1a32$var$Store);

});


parcelRegister("7Gz0U", function(module, exports) {

$parcel$export(module.exports, "useClientValidationHandler", () => $835dbd9dc1252371$export$f57c10638969fb77);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
/** Return an `ValidationStatus` for a given validation message. */ const $835dbd9dc1252371$var$getValidationStatus = (message)=>message ? message.type : 'success';
// Priority order for ValidationStatus. Higher value = higher priority.
const $835dbd9dc1252371$var$invalidStatusPriority = {
    success: 0,
    warning: 1,
    error: 2
};
/**
 * Return the higher priority message of `messageA` and `messageB`. If the priority is equal then `messageA` will be
 * returned.
 */ const $835dbd9dc1252371$var$getHigherPriorityMessage = (messageA, messageB)=>{
    const statusA = $835dbd9dc1252371$var$getValidationStatus(messageA);
    const statusB = $835dbd9dc1252371$var$getValidationStatus(messageB);
    return $835dbd9dc1252371$var$invalidStatusPriority[statusA] >= $835dbd9dc1252371$var$invalidStatusPriority[statusB] ? messageA : messageB;
};
const $835dbd9dc1252371$export$f57c10638969fb77 = (validator)=>{
    const [invalidMessage, setInvalidMessage] = (0, $5uXOq.useState)(null);
    const [invalidEvent, setInvalidEvent] = (0, $5uXOq.useState)(null);
    const { change: change, submit: submit } = validator ?? {};
    const validateChange = (0, $5uXOq.useCallback)((value)=>{
        // If no change validator is defined then the value is considered valid
        const message = change ? change(value) : null;
        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) setInvalidEvent(message ? {
            action: 'change',
            state: message
        } : null);
        else setInvalidMessage(message);
        return $835dbd9dc1252371$var$getValidationStatus(message);
    }, [
        change
    ]);
    const validateSubmit = (0, $5uXOq.useCallback)((value)=>{
        // If no submit validator is defined then the value is considered valid
        const message = submit ? submit(value) : null;
        let higherPriorityMessage;
        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
            const changeInvalidMessage = invalidEvent?.action === 'change' ? invalidEvent.state : null;
            // Only update the change event invalid state if a higher priority message is returned
            higherPriorityMessage = $835dbd9dc1252371$var$getHigherPriorityMessage(message, changeInvalidMessage);
            setInvalidEvent(higherPriorityMessage ? {
                action: 'submit',
                state: higherPriorityMessage
            } : null);
        } else {
            // Only update the existing invalid state if a higher priority message is returned
            higherPriorityMessage = $835dbd9dc1252371$var$getHigherPriorityMessage(message, invalidMessage);
            setInvalidMessage(higherPriorityMessage);
        }
        return $835dbd9dc1252371$var$getValidationStatus(higherPriorityMessage);
    }, [
        invalidEvent,
        invalidMessage,
        submit
    ]);
    const clearValidation = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) setInvalidEvent(null);
        else setInvalidMessage(null);
    }, []);
    const actions = (0, $5uXOq.useMemo)(()=>({
            validateChange: validateChange,
            validateSubmit: validateSubmit,
            clearValidation: clearValidation
        }), [
        clearValidation,
        validateChange,
        validateSubmit
    ]);
    if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) return [
        invalidEvent?.state ?? null,
        actions
    ];
    return [
        invalidMessage,
        actions
    ];
};

});

parcelRegister("dSSeS", function(module, exports) {

$parcel$export(module.exports, "useServerValidationHandler", () => $0fca836bbd518c54$export$1bf5fbbc94f09320);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $sIi2V = parcelRequire("sIi2V");
const $0fca836bbd518c54$export$1bf5fbbc94f09320 = (fieldName, setIsEditing, onSubmitFailed)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { dismissFlag: dismissFlag, showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [hasServerValidationError, setHasServerValidationError] = (0, $5uXOq.useState)(false);
    const handleSubmitFailed = (0, $5uXOq.useCallback)((error, message)=>{
        setHasServerValidationError(true);
        const flagId = showFlag({
            type: 'error',
            title: formatMessage((0, $4R6GH.fg)('relay-migration-issue-fields-number') ? (0, $sIi2V.default).submitFailedTitle : (0, $sIi2V.default).submitFailedTitleOld, {
                fieldName: fieldName
            }),
            description: message ?? formatMessage((0, $sIi2V.default).submitFailedDescription),
            testId: (0, $4R6GH.fg)('relay-migration-issue-fields-assignee-fg') ? 'issue-field-validation-handler.controllers.server-validation-handler.submit-failed-flag' : undefined,
            messageId: 'issue-field-validation-handler.controllers.server-validation-handler.show-flag.error.submit-failed',
            messageType: 'transactional',
            onDismissed: ()=>{
                (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') && setHasServerValidationError(false);
            },
            // eslint-disable-next-line no-nested-ternary
            actions: (0, $4R6GH.fg)('relay-migration-issue-header-and-parent') ? setIsEditing ? [
                {
                    content: (0, $sIi2V.default).submitFailedTryAgain,
                    onClick: ()=>{
                        setIsEditing(true);
                        flagId && dismissFlag(flagId);
                    }
                }
            ] : undefined : [
                {
                    content: (0, $sIi2V.default).submitFailedTryAgain,
                    onClick: ()=>{
                        setIsEditing?.(true);
                        flagId && dismissFlag(flagId);
                    }
                }
            ]
        });
        (0, $jcw0u.default)({
            meta: {
                id: 'serverValidationHandler',
                packageName: 'jiraIssueFieldValidationHandler',
                teamName: 'empanada'
            },
            event: createAnalyticsEvent({}),
            error: error,
            attributes: {
                fieldName: fieldName
            },
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true
        });
        if ((0, $4R6GH.fg)('relay-migration-issue-fields-assignee-fg')) onSubmitFailed?.(error);
        else onSubmitFailed?.();
    }, [
        dismissFlag,
        fieldName,
        formatMessage,
        onSubmitFailed,
        setIsEditing,
        showFlag,
        createAnalyticsEvent
    ]);
    const clearServerValidation = (0, $5uXOq.useCallback)(()=>setHasServerValidationError(false), []);
    return (0, $5uXOq.useMemo)(()=>[
            hasServerValidationError,
            {
                handleSubmitFailed: handleSubmitFailed,
                clearServerValidation: clearServerValidation
            }
        ], [
        hasServerValidationError,
        handleSubmitFailed,
        clearServerValidation
    ]);
};

});
parcelRegister("sIi2V", function(module, exports) {

$parcel$export(module.exports, "default", () => $86df3ee768f71b97$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var // Keep up to date with jira/src/packages/issue/keyboard-shortcuts/src/services/assign-to-me-or-unassign/messages.tsx
$86df3ee768f71b97$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    submitFailedTitleOld: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-title",
        "defaultMessage": "We couldn\u2019t update {fieldName}"
    },
    submitFailedTitle: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-title-new",
        "defaultMessage": "We couldn\u2019t update the {fieldName} value"
    },
    submitFailedDescription: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-description",
        "defaultMessage": "You can try again in a few minutes, or refresh the page."
    },
    submitFailedTryAgain: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-try-again",
        "defaultMessage": "Try editing the field again"
    }
});

});


parcelRegister("cIZbf", function(module, exports) {

$parcel$export(module.exports, "getFieldIdFromAri", () => $9b276216fa1bf039$export$4ae913a052c0d582);
$parcel$export(module.exports, "getPriorityIdFromAri", () => $9b276216fa1bf039$export$d3f3dc1a70aa9a8);
$parcel$export(module.exports, "getUserIdFromAri", () => $9b276216fa1bf039$export$364d97890ac491af);
const $9b276216fa1bf039$var$FIELD_ID_ARI_REGEX = /ari:cloud:jira:.*?:issuefieldvalue\/.*?\/(.*)/;
const $9b276216fa1bf039$var$PRIORITY_ID_ARI_REGEX = /ari:cloud:jira:.*?:priority\/activation\/.*?\/(.*)/;
const $9b276216fa1bf039$var$USER_ID_ARI_REGEX = /ari:cloud:identity::user\/(.*)/;
const $9b276216fa1bf039$export$4ae913a052c0d582 = (fieldIdOrAri)=>{
    const match = fieldIdOrAri?.match($9b276216fa1bf039$var$FIELD_ID_ARI_REGEX);
    return match ? match[1] : fieldIdOrAri;
};
const $9b276216fa1bf039$export$d3f3dc1a70aa9a8 = (priorityIdOrAri)=>{
    const match = priorityIdOrAri?.match($9b276216fa1bf039$var$PRIORITY_ID_ARI_REGEX);
    return match ? match[1] : priorityIdOrAri;
};
const $9b276216fa1bf039$export$364d97890ac491af = (userIdOrAri)=>{
    const match = userIdOrAri?.match($9b276216fa1bf039$var$USER_ID_ARI_REGEX);
    return match ? match[1] : userIdOrAri;
};

});

parcelRegister("hGyAY", function(module, exports) {

$parcel$export(module.exports, "getOnCopyHandler", () => $f5c8c91d68a7f27b$export$ce96a952c1e6691a);
$parcel$export(module.exports, "getOnPasteHandler", () => $f5c8c91d68a7f27b$export$66ac6a407d63bc45);

var $8lGKS = parcelRequire("8lGKS");

var $hwJtl = parcelRequire("hwJtl");

var $8rdhd = parcelRequire("8rdhd");

var $jv5ZP = parcelRequire("jv5ZP");
/** Returns a sanitised HTML string with the provided `componentType` and `value` set as HTML attributes. */ const $f5c8c91d68a7f27b$var$safelyAddRichValueToHtml = (componentType, value)=>{
    try {
        const html = `<div data-type="table-cell" data-component-type="${componentType}" />`;
        const DOM = new DOMParser().parseFromString(html, 'text/html');
        DOM.body?.querySelector('div')?.setAttribute('data-field-value', JSON.stringify(value));
        return DOM.body?.innerHTML || '';
    } catch (e) {
        return null;
    }
};
function $f5c8c91d68a7f27b$export$89af511f3acca517(componentType, value, textSerialiser) {
    const clipboardItems = {
        'text/plain': new globalThis.window.Blob([
            textSerialiser(value)
        ], {
            type: 'text/plain'
        })
    };
    const html = $f5c8c91d68a7f27b$var$safelyAddRichValueToHtml(componentType, value);
    if (html) clipboardItems['text/html'] = new globalThis.window.Blob([
        html
    ], {
        type: 'text/html'
    });
    const clipboardItem = new globalThis.window.ClipboardItem(clipboardItems);
    globalThis.navigator.clipboard.write([
        clipboardItem
    ]);
}
const $f5c8c91d68a7f27b$export$29418a91c5daf3d9 = (e)=>{
    const html = e.clipboardData?.getData('text/html');
    if (!html) return null;
    try {
        const clipboardDocument = new DOMParser().parseFromString(html, 'text/html');
        const data = clipboardDocument.body?.querySelector('div')?.dataset;
        if (!data || !data.componentType || !data.fieldValue) return null;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            componentType: data.componentType,
            value: JSON.parse(data.fieldValue)
        };
    } catch (error) {
        return null;
    }
};
const $f5c8c91d68a7f27b$export$ce96a952c1e6691a = (componentType, value)=>{
    const textSerialiser = (0, $8lGKS.getDefaultClipboardTextSerialiser)();
    return ()=>$f5c8c91d68a7f27b$export$89af511f3acca517(componentType, value, textSerialiser);
};
const $f5c8c91d68a7f27b$export$66ac6a407d63bc45 = (componentType)=>{
    const parser = (0, $hwJtl.getDefaultClipboardParser)(componentType);
    return (e)=>{
        let caughtError;
        const metadata = $f5c8c91d68a7f27b$export$29418a91c5daf3d9(e);
        if (metadata) try {
            return parser(metadata);
        } catch (error) {
            // Silently ignore and fallthrough
            caughtError = error;
        }
        const plainText = e.clipboardData?.getData('text/plain');
        if (plainText) try {
            if (componentType === 'text') return (0, $8rdhd.stringClipboardTextParser)(plainText);
            return (0, $8rdhd.defaultClipboardTextParser)(plainText);
        } catch (error) {
            // Silently ignore and fallthrough
            caughtError = caughtError ?? error;
        }
        if (caughtError instanceof (0, $jv5ZP.ClipboardValidationError)) throw caughtError;
    };
};

});
parcelRegister("8lGKS", function(module, exports) {

$parcel$export(module.exports, "getDefaultClipboardTextSerialiser", () => $79e2fe90bc97bf2d$export$2bbd2e5056252b1d);
const $79e2fe90bc97bf2d$export$2bbd2e5056252b1d = ()=>{
    return (value)=>{
        switch(typeof value){
            case 'string':
            case 'number':
            case 'boolean':
                return String(value);
            default:
                return '';
        }
    };
};

});

parcelRegister("hwJtl", function(module, exports) {

$parcel$export(module.exports, "getDefaultClipboardParser", () => $6d789358d183d273$export$b221956cf03526aa);

var $jv5ZP = parcelRequire("jv5ZP");
const $6d789358d183d273$var$isComponentType = (meta, type)=>meta.componentType === type;
const $6d789358d183d273$export$b221956cf03526aa = (expectedComponentType)=>{
    return (meta)=>{
        if ($6d789358d183d273$var$isComponentType(meta, expectedComponentType)) return meta.value;
        throw (0, $jv5ZP.ClipboardValidationError).pasteUnexpectedComponentType(meta.componentType, expectedComponentType);
    };
};

});
parcelRegister("jv5ZP", function(module, exports) {

$parcel$export(module.exports, "ClipboardValidationError", () => $110508e145caff0c$export$41262351255fc0fe);
class $110508e145caff0c$export$41262351255fc0fe extends Error {
    constructor(type, message){
        super(message);
        this.name = 'ClipboardValidationError';
        this.type = type;
    }
    static copyOperationUnsupported() {
        return new $110508e145caff0c$export$41262351255fc0fe('copyOperationUnsupported', 'Copy operation not supported.');
    }
    static cutOperationUnsupported() {
        return new $110508e145caff0c$export$41262351255fc0fe('cutOperationUnsupported', 'Cut operation not supported.');
    }
    static cutNonEditableError(actual) {
        return new $110508e145caff0c$export$41262351255fc0fe('cutNonEditableError', `Received component type '${actual}' cannot be cut.`);
    }
    static pasteOperationUnsupported() {
        return new $110508e145caff0c$export$41262351255fc0fe('pasteOperationUnsupported', 'Paste operation not supported.');
    }
    static pasteUnexpectedComponentType(actual, expected) {
        return new $110508e145caff0c$export$41262351255fc0fe('pasteUnexpectedComponentType', `Received component type '${actual}' when '${expected}' was expected.`);
    }
    static pasteUnsupportedFormat(format) {
        return new $110508e145caff0c$export$41262351255fc0fe('pasteUnsupportedFormat', `Unsupported data transfer format '${format}'.`);
    }
}

});


parcelRegister("8rdhd", function(module, exports) {

$parcel$export(module.exports, "defaultClipboardTextParser", () => $55db8c83d29ca82e$export$eaf687a0cd453100);
$parcel$export(module.exports, "stringClipboardTextParser", () => $55db8c83d29ca82e$export$95f020f7a1102e64);

var $jv5ZP = parcelRequire("jv5ZP");
const $55db8c83d29ca82e$export$eaf687a0cd453100 = ()=>{
    throw (0, $jv5ZP.ClipboardValidationError).pasteUnsupportedFormat('text/plain');
};
const $55db8c83d29ca82e$export$95f020f7a1102e64 = (plainText)=>plainText;

});


parcelRegister("bgqP5", function(module, exports) {

$parcel$export(module.exports, "useClipboardErrorReporting", () => $98938c44bea03048$export$a3594035e6545378);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dU2AG = parcelRequire("dU2AG");

var $jv5ZP = parcelRequire("jv5ZP");
const $98938c44bea03048$var$uniqueFlagId = (0, $7HGHK.toFlagId)('JSC_COPY_PASTE_FLAG');
const $98938c44bea03048$export$f2525c1d596f8d46 = (_)=>{
    throw new Error('Unreachable code reached');
};
const $98938c44bea03048$var$useGetErrorFlag = (fieldName)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (0, $5uXOq.useCallback)((errorType)=>{
        switch(errorType){
            case 'copyOperationUnsupported':
                return {
                    type: 'error',
                    title: formatMessage((0, $dU2AG.default).copyErrorTitle),
                    description: formatMessage((0, $dU2AG.default).copyValidationError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.copy-validation-error',
                    messageType: 'transactional'
                };
            case 'cutOperationUnsupported':
                return {
                    type: 'error',
                    title: formatMessage((0, $dU2AG.default).cutErrorTitle),
                    description: formatMessage((0, $dU2AG.default).cutValidationError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.cut-validation-error',
                    messageType: 'transactional'
                };
            case 'cutNonEditableError':
                return {
                    type: 'error',
                    title: formatMessage((0, $dU2AG.default).cutErrorTitle),
                    description: formatMessage((0, $dU2AG.default).cutNonEditableError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.cut-non-editable-error',
                    messageType: 'transactional'
                };
            case 'pasteOperationUnsupported':
            case 'pasteUnexpectedComponentType':
            case 'pasteUnsupportedFormat':
                return {
                    type: 'error',
                    title: formatMessage((0, $dU2AG.default).pasteErrorTitle),
                    description: formatMessage((0, $dU2AG.default).pasteUnsupportedError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.paste-unsupported-error',
                    messageType: 'transactional'
                };
            default:
                return $98938c44bea03048$export$f2525c1d596f8d46(errorType);
        }
    }, [
        fieldName,
        formatMessage
    ]);
};
const $98938c44bea03048$export$a3594035e6545378 = (fieldName, fieldType)=>{
    const { dismissFlag: dismissFlag, showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const getErrorFlag = $98938c44bea03048$var$useGetErrorFlag(fieldName);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((error)=>{
        if (error instanceof (0, $jv5ZP.ClipboardValidationError)) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'inlineEdit clipboardValidationError', {
                clipboardValidationErrorType: error.type,
                fieldType: fieldType
            });
            dismissFlag($98938c44bea03048$var$uniqueFlagId);
            showFlag({
                ...getErrorFlag(error.type),
                id: $98938c44bea03048$var$uniqueFlagId
            });
        } else {
            const ugcSafeMessage = `Failed to perform clipboard operation for field of type ${fieldType}`;
            (0, $jcw0u.default)({
                meta: {
                    id: 'clipboardOperationError',
                    packageName: 'jiraIssueFieldCopyPaste',
                    teamName: 'empanada'
                },
                attributes: {
                    message: ugcSafeMessage,
                    fieldType: fieldType
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        dismissFlag,
        fieldType,
        getErrorFlag,
        showFlag
    ]);
};

});
parcelRegister("dU2AG", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf0cee044fa71f48$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cf0cee044fa71f48$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copyErrorTitle: {
        "id": "issue-field-copy-paste.controller.copy-error-title",
        "defaultMessage": "Unable to copy"
    },
    copyValidationError: {
        "id": "issue-field-copy-paste.controller.copy-validation-error",
        "defaultMessage": "{name} can't be copied."
    },
    cutErrorTitle: {
        "id": "issue-field-cut-paste.controller.cut-error-title",
        "defaultMessage": "Unable to cut"
    },
    cutValidationError: {
        "id": "issue-field-cut-paste.controller.cut-validation-error",
        "defaultMessage": "{name} can't be cut."
    },
    cutNonEditableError: {
        "id": "business-list.controllers.clipboard.cut-non-editable-error",
        "defaultMessage": "{name} is copied to your clipboard instead."
    },
    pasteErrorTitle: {
        "id": "issue-field-copy-paste.controller.paste-error-title",
        "defaultMessage": "Unable to paste"
    },
    pasteUnsupportedError: {
        "id": "issue-field-copy-paste.controller.paste-unsupported-error",
        "defaultMessage": "This can't be pasted on {name}."
    }
});

});


parcelRegister("d2Afy", function(module, exports) {

$parcel$export(module.exports, "isNullableComponentType", () => $a81473d8e0e81082$export$caeca7da2724234c);
$parcel$export(module.exports, "isStringComponentType", () => $a81473d8e0e81082$export$6e42f8250885ab5b);
$parcel$export(module.exports, "isArrayComponentType", () => $a81473d8e0e81082$export$1c384554b943e9d8);
/**
 * Exhaustive assertion that will throw for all component types that do not support a `null` value. If a new
 * `ClipboardComponentType` is defined that **does not** support `null` values then it must be added to the below switch
 * case.
 */ const $a81473d8e0e81082$var$assertIsNullableComponentType = (type)=>{
    switch(type){
        case 'number':
        case 'boolean':
        case 'text':
        case 'priority':
        case 'labels':
        case 'originalEstimate':
            throw new Error(`Type '${type}' does not support null values`);
        default:
            return type;
    }
};
const $a81473d8e0e81082$export$caeca7da2724234c = (type)=>{
    try {
        $a81473d8e0e81082$var$assertIsNullableComponentType(type);
        return true;
    } catch  {
        return false;
    }
};
/**
 * Exhaustive assertion that will throw for all component types that do not support a `string` value. If a new
 * `ClipboardComponentType` is defined that **does not** support `string` values then it must be added to the below
 * switch case.
 */ const $a81473d8e0e81082$var$assertIsStringComponentType = (type)=>{
    switch(type){
        case 'number':
        case 'boolean':
        case 'checkboxSelect':
        case 'numberNullable':
        case 'priority':
        case 'sprint':
        case 'singleUser':
        case 'labels':
        case 'singleSelect':
        case 'multiUserPicker':
        case 'multiSelect':
        case 'multiGroupPicker':
        case 'cascadingSelect':
        case 'radioSelect':
        case 'components':
        case 'team':
        case 'multiVersionSelect':
        case 'parent':
            throw new Error(`Type '${type}' does not support string values`);
        default:
            return type;
    }
};
const $a81473d8e0e81082$export$6e42f8250885ab5b = (type)=>{
    try {
        $a81473d8e0e81082$var$assertIsStringComponentType(type);
        return true;
    } catch  {
        return false;
    }
};
/**
 * Exhaustive assertion that will throw for all component types that do not support an `array` value. If a new
 * `ClipboardComponentType` is defined that **does not** support `array` values then it must be added to the below
 * switch case.
 */ const $a81473d8e0e81082$var$assertIsArrayComponentType = (type)=>{
    switch(type){
        case 'date':
        case 'dateTime':
        case 'text':
        case 'number':
        case 'numberNullable':
        case 'boolean':
        case 'sprint':
        case 'originalEstimate':
        case 'singleUser':
        case 'singleSelect':
        case 'url':
        case 'priority':
        case 'cascadingSelect':
        case 'radioSelect':
        case 'team':
        case 'parent':
            throw new Error(`Type '${type}' does not support array values`);
        default:
            return type;
    }
};
const $a81473d8e0e81082$export$1c384554b943e9d8 = (type)=>{
    try {
        $a81473d8e0e81082$var$assertIsArrayComponentType(type);
        return true;
    } catch  {
        return false;
    }
};

});

parcelRegister("9AfTz", function(module, exports) {

$parcel$export(module.exports, "useRealTimeComments", () => $fe818fde6225ba11$export$77846b359c3804dd);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $fe818fde6225ba11$var$initialState = {
    isRealTimeCommentUpdated: false
};
const $fe818fde6225ba11$var$actions = {
    setRealTimeCommentUpdated: (isRealTimeCommentUpdated)=>({ setState: setState })=>{
            setState({
                isRealTimeCommentUpdated: isRealTimeCommentUpdated
            });
        }
};
const $fe818fde6225ba11$var$store = (0, $iXqE5.createStore)({
    name: 'issue-view.controllers.realtime-comments',
    initialState: $fe818fde6225ba11$var$initialState,
    actions: $fe818fde6225ba11$var$actions
});
const $fe818fde6225ba11$export$77846b359c3804dd = (0, $3sQ5x.createHook)($fe818fde6225ba11$var$store);

});


parcelRegister("lXLX3", function(module, exports) {

$parcel$export(module.exports, "FieldInlineEditLiteWithEntryPoint", () => $669235cd789e519d$export$d14ba912eb773f8d);

var $5uXOq = parcelRequire("5uXOq");

var $kMSay = parcelRequire("kMSay");

var $4R6GH = parcelRequire("4R6GH");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jXcyJ = parcelRequire("jXcyJ");

var $hOlfS = parcelRequire("hOlfS");

const $669235cd789e519d$export$d14ba912eb773f8d = ({ editViewEntryPoint: editViewEntryPoint, editViewEntryPointParams: editViewEntryPointParams, getEditViewProps: getEditViewProps, ...props })=>{
    const { hideEditButton: hideEditButton, isEditable: isEditable, isEditing: isEditing, readView: readView, readViewFitContainerHeight: readViewFitContainerHeight, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled } = props;
    const pressTrace = (0, $kMSay.default)('issue.field.inline-edit-lite');
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)(editViewEntryPoint, editViewEntryPointParams);
    const entryPointEventMap = (0, $5uXOq.useMemo)(()=>{
        const actions = (0, $47gW9.getDefaultEntrypointActionEventMap)(entryPointActions);
        if ((0, $4R6GH.fg)('jiv-20205-more-ufo-tracing')) {
            const { click: click } = actions;
            actions.click = (e)=>{
                pressTrace();
                click(e);
            };
        }
        return actions;
    }, [
        entryPointActions,
        pressTrace
    ]);
    const readViewTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, true, entryPointEventMap);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        // This component can be mounted in an editing state or toggled externally, so we need to ensure the entrypoint
        // is always explicitly loaded when entering edit view.
        if (isEditing) entryPointActions.load();
    }, [
        isEditing,
        entryPointActions
    ]);
    const renderEditView = (fieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "editView",
            packageName: "jiraIssueFieldInlineEditLite",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOlfS.ReadViewNonEditable), {
                hideEditButton: hideEditButton,
                isLoading: true,
                readViewFitContainerHeight: readViewFitContainerHeight
            }, readView()),
            runtimeProps: getEditViewProps(fieldProps)
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jXcyJ.default), {
        ...props,
        readViewContainerRef: isEditable ? readViewTrigger : undefined,
        editView: renderEditView,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled
    });
};

});
parcelRegister("jXcyJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f0a9d17b9c14380$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7vSIf = parcelRequire("7vSIf");

var $koVbs = parcelRequire("koVbs");

var $l1FyB = parcelRequire("l1FyB");

var $lOM5D = parcelRequire("lOM5D");

var $8KtCv = parcelRequire("8KtCv");

var $aSXFv = parcelRequire("aSXFv");

// Fallback placements to be used for the validation popover if it overflows its clipping parent
const $2f0a9d17b9c14380$var$fallbackPlacements = [
    'left',
    'top-start',
    'auto'
];
/**
 * Component leveraging `@atlassian/jira-inline-edit-lite` to provide consistent spacing and validation UX for issue
 * fields.
 */ const $2f0a9d17b9c14380$var$FieldInlineEditLite = ({ editView: editView, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupMinWidth: editViewPopupMinWidth, editViewPopupTarget: editViewPopupTarget, fieldName: fieldName, hasUnsubmittedChanges: hasUnsubmittedChanges, hideActionButtons: hideActionButtons, hideEditButton: hideEditButton, invalidMessage: invalidMessage, isEditable: isEditable, isEditing: isEditing, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, onCopy: onCopy, onCut: onCut, onPaste: onPaste, readViewFitContainerHeight: readViewFitContainerHeight, readViewContainerRef: readViewContainerRef, readView: readView, confirmButtonLabel: confirmButtonLabelProp, cancelButtonLabel: cancelButtonLabelProp, editButtonLabel: editButtonLabelProp, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { context: context, refs: refs } = (0, $7vSIf.useInlineEdit)({
        isEditing: isEditing,
        onCancel: onCancel,
        onConfirm: onConfirm,
        onEdit: onEdit
    });
    const confirmButtonLabel = confirmButtonLabelProp ?? formatMessage((0, $8KtCv.default).confirmButtonLabel, {
        fieldName: fieldName
    });
    const cancelButtonLabel = cancelButtonLabelProp ?? formatMessage((0, $8KtCv.default).cancelButtonLabel, {
        fieldName: fieldName
    });
    const editButtonLabel = editButtonLabelProp ?? formatMessage((0, $8KtCv.default).editButtonLabel, {
        fieldName: fieldName
    });
    if (isEditing && isEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lOM5D.EditView), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: editViewPopupMinWidth,
        editViewPopupTarget: editViewPopupTarget,
        hideActionButtons: hideActionButtons,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1FyB.default), {
        message: invalidMessage,
        trigger: (triggerProps)=>editView(triggerProps),
        placement: "right",
        fallbackPlacements: $2f0a9d17b9c14380$var$fallbackPlacements
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aSXFv.ReadView), {
        context: context,
        editButtonLabel: editButtonLabel,
        editButtonRef: refs.editButton,
        hideEditButton: hideEditButton,
        isEditInteractionEnabled: isEditable,
        isInvalid: hasUnsubmittedChanges,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readViewContainerRef: readViewContainerRef,
        onCopy: onCopy,
        onCut: onCut,
        onPaste: onPaste,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled
    }, readView());
};
var $2f0a9d17b9c14380$export$2e2bcd8739ae039 = $2f0a9d17b9c14380$var$FieldInlineEditLite;

});
parcelRegister("7vSIf", function(module, exports) {

$parcel$export(module.exports, "useInlineEdit", () => $9b253d0845aaa9c6$export$4059f16ba5dcb4e1);

var $5uXOq = parcelRequire("5uXOq");

var $1XJ20 = parcelRequire("1XJ20");

var $2NMNM = parcelRequire("2NMNM");
const $9b253d0845aaa9c6$var$actionSubject = 'inlineEdit';
const $9b253d0845aaa9c6$export$4059f16ba5dcb4e1 = ({ isEditing: isEditing, onCancel: onCancelOption, onConfirm: onConfirmOption, onEdit: onEditOption })=>{
    const editButtonRef = (0, $5uXOq.useRef)(null);
    const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const prevIsEditing = (0, $1XJ20.usePrevious)(isEditing);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !isEditing) {
            if (preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else editButtonRef.current?.focus();
        }
    }, [
        prevIsEditing,
        isEditing
    ]);
    const onCancel = (0, $5uXOq.useCallback)((preventFocusReturn = true)=>{
        preventFocusOnEditButtonRef.current = preventFocusReturn;
        const analyticsEvent = createAnalyticsEvent({
            action: 'canceled',
            actionSubject: $9b253d0845aaa9c6$var$actionSubject
        });
        onCancelOption(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onCancelOption
    ]);
    const onConfirm = (0, $5uXOq.useCallback)((preventFocusReturn = true)=>{
        preventFocusOnEditButtonRef.current = preventFocusReturn;
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: $9b253d0845aaa9c6$var$actionSubject
        });
        onConfirmOption(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onConfirmOption
    ]);
    const onEdit = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: $9b253d0845aaa9c6$var$actionSubject
        });
        onEditOption(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onEditOption
    ]);
    const context = (0, $5uXOq.useMemo)(()=>({
            onCancel: onCancel,
            onConfirm: onConfirm,
            onEdit: onEdit
        }), [
        onCancel,
        onConfirm,
        onEdit
    ]);
    const refs = (0, $5uXOq.useMemo)(()=>({
            editButton: editButtonRef
        }), []);
    return (0, $5uXOq.useMemo)(()=>({
            context: context,
            refs: refs
        }), [
        context,
        refs
    ]);
};

});

parcelRegister("l1FyB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5ec22cc6e76b75e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $ePxPW = parcelRequire("ePxPW");
/**
 * Popup component to display a validation message for inline editable fields. The message will be displayed when the
 * user focuses the trigger attached to this component (which should be an interactive form field), and hidden when the
 * trigger is blurred.
 *
 * Why do we have a custom popup instead of using an existing `@atlaskit` component? There are a couple of caveats from
 * the existing components which makes them unsuitable for our use case:
 * 1. `@atlaskit/popup` - Creates a focus lock within the popup preventing the user from tab navigating to and from the
 * popup content.
 * 2. `@atlaskit/inline-dialog` - Deprecated in favour of `@atlaskit/popup`.
 * 3. `@atlaskit/tooltip` - Does not allow visibility to be controlled via a prop and attaches to mouseover events,
 * which is undesired.
 */ const $f5ec22cc6e76b75e$var$ValidationPopup = ({ message: message, placement: placement, fallbackPlacements: fallbackPlacements, trigger: trigger })=>{
    const [isVisuallyHidden, setIsVisuallyHidden] = (0, $5uXOq.useState)(true);
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const triggerRef = (0, $5uXOq.useRef)();
    const onFocus = ()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
        setIsVisuallyHidden(false);
    };
    const onBlur = ()=>{
        wasFocusReceivedSinceLastBlurRef.current = false;
        setTimeout(()=>{
            if (!wasFocusReceivedSinceLastBlurRef.current) setIsVisuallyHidden(true);
        }, 0);
    };
    const popupContentId = (0, $5uXOq.useMemo)(()=>`${(0, $7Jxgt.v4)()}-validation-popup`, []);
    const fieldProps = {
        ref: triggerRef,
        onFocus: onFocus,
        onBlur: onBlur,
        'aria-describedby': isVisuallyHidden ? undefined : popupContentId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, trigger(fieldProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePxPW.default), {
        id: popupContentId,
        isVisuallyHidden: isVisuallyHidden,
        message: message,
        onFocus: onFocus,
        onBlur: onBlur,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        referenceElement: triggerRef?.current
    }));
};
var $f5ec22cc6e76b75e$export$2e2bcd8739ae039 = $f5ec22cc6e76b75e$var$ValidationPopup;

});
parcelRegister("ePxPW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8247420c4d94a5cf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");
var $4uxPN = parcelRequire("4uxPN");

var $k5uoT = parcelRequire("k5uoT");

var $dqoiX = parcelRequire("dqoiX");

var $7pDxf = parcelRequire("7pDxf");

var $20hde = parcelRequire("20hde");
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $8247420c4d94a5cf$var$getDirectionFromPlacement = (placement)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    placement.split('-')[0];
// Inverts motion direction
const $8247420c4d94a5cf$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $8247420c4d94a5cf$var$ValidationPopper = ({ id: id, isVisuallyHidden: isVisuallyHidden, message: message, onFocus: onFocus, onBlur: onBlur, placement: placement, fallbackPlacements: fallbackPlacements, referenceElement: referenceElement })=>{
    const updateRef = (0, $5uXOq.useRef)();
    const modifiers = (0, $5uXOq.useMemo)(()=>[
            {
                name: 'flip',
                options: {
                    fallbackPlacements: fallbackPlacements
                }
            }
        ], [
        fallbackPlacements
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Since we are applying visually hidden styles instead of unmounting the popup for accessibility reasons,
        // there will be cases where the popup placement is calculated while it's visually hidden (e.g. when a
        // validation occurs on blur). While visually hidden, popup size is 1px x 1px, and this can make Popper
        // think that the popup fits in a placement where it doesn't actually fit, and end up overflowing the
        // viewport. To prevent this from happening, we ask Popper to recompute popup position when it becomes visible.
        !isVisuallyHidden && updateRef.current?.();
    }, [
        isVisuallyHidden
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $35XSW.default), {
        appear: true
    }, message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7pDxf.JiraPopper), {
        placement: placement,
        referenceElement: referenceElement,
        strategy: "absolute",
        modifiers: modifiers,
        messageId: "issue-field-validation-popup.ui.validation-popper.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, placement: finalPlacement, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uxPN.default), {
            entranceDirection: $8247420c4d94a5cf$var$invertedDirection[$8247420c4d94a5cf$var$getDirectionFromPlacement(finalPlacement)]
        }, ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line jira/react/no-style-attribute
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ...style,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    ...isVisuallyHidden && (0, $dqoiX.visuallyHiddenStyles),
                    zIndex: (0, $k5uoT.layers).layer()
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $20hde.default), {
                ...message,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                id: id,
                onFocus: onFocus,
                onBlur: onBlur,
                "data-testid": "issue-field-validation-popup.ui.validation-popper.popup-content",
                testId: `issue-field-validation-popup.ui.validation-popper.popup-content${isVisuallyHidden ? '-hidden' : ''}`
            })));
    }));
};
var $8247420c4d94a5cf$export$2e2bcd8739ae039 = $8247420c4d94a5cf$var$ValidationPopper;

});
parcelRegister("20hde", function(module, exports) {

$parcel$export(module.exports, "default", () => $13e3a78ea1c23349$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dD7Zc = parcelRequire("dD7Zc");

var $bU3PY = parcelRequire("bU3PY");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $7tRcI = parcelRequire("7tRcI");
const $13e3a78ea1c23349$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
const $13e3a78ea1c23349$var$useIcon = (type)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    switch(type){
        case 'error':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                spacing: "spacious",
                label: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? formatMessage((0, $7tRcI.default).errorLabel) : '',
                color: "var(--ds-icon-danger, #C9372C)"
            });
        case 'warning':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
                spacing: "spacious",
                label: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? formatMessage((0, $7tRcI.default).warningLabel) : '',
                color: "var(--ds-icon-warning, #E56910)"
            });
        default:
            $13e3a78ea1c23349$var$assertUnreachable(type);
    }
};
const $13e3a78ea1c23349$var$PopupContent = ({ className: className, id: id, message: message, onFocus: onFocus, onBlur: onBlur, testId: testId, title: title, type: type })=>{
    const icon = $13e3a78ea1c23349$var$useIcon(type);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13e3a78ea1c23349$var$Content // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        role: "alert",
        id: id,
        hasTitle: !!title,
        onFocus: onFocus,
        onBlur: onBlur,
        "data-testid": testId
    }, icon, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: "space.075",
        xcss: $13e3a78ea1c23349$var$titleStyles
    }, title), message) : message);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $13e3a78ea1c23349$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasTitle: hasTitle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1e0c1txw _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _vchhusvi _p12f1feq _bfhk1bhr _16qs1cd0 _1bsb1ns9",
            __cmplp.hasTitle ? "_zulppxbi" : "_zulp12x7 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $13e3a78ea1c23349$var$titleStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle',
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px'
});
var $13e3a78ea1c23349$export$2e2bcd8739ae039 = $13e3a78ea1c23349$var$PopupContent;

});
parcelRegister("7tRcI", function(module, exports) {

$parcel$export(module.exports, "default", () => $76e92152844e7cc0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $76e92152844e7cc0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorLabel: {
        "id": "issue-field-validation-popup.validation-popper.popup-content.error-label",
        "defaultMessage": "Error"
    },
    warningLabel: {
        "id": "issue-field-validation-popup.validation-popper.popup-content.warning-label",
        "defaultMessage": "Warning"
    }
});

});




parcelRegister("lOM5D", function(module, exports) {

$parcel$export(module.exports, "EditView", () => $5647bbeb786c1d1b$export$280eb2fbab4e5389);

var $5uXOq = parcelRequire("5uXOq");

var $84Z9v = parcelRequire("84Z9v");

var $fevyg = parcelRequire("fevyg");
const $5647bbeb786c1d1b$export$280eb2fbab4e5389 = ({ cancelButtonLabel: cancelButtonLabel, children: children, confirmButtonLabel: confirmButtonLabel, context: context, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupMinWidth: editViewPopupMinWidth, editViewPopupTarget: editViewPopupTarget, hideActionButtons: hideActionButtons, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur })=>{
    const form = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $84Z9v.Form), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        hideActionButtons: hideActionButtons,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur
    }, children);
    if (editViewPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fevyg.EditViewPopup), {
        alignBlock: editViewPopupAlignBlock,
        minWidth: editViewPopupMinWidth,
        target: editViewPopupTarget
    }, form);
    return form;
};

});
parcelRegister("84Z9v", function(module, exports) {

$parcel$export(module.exports, "Form", () => $2013618434e71d2e$export$a7fed597f4b8afd8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gFHzB = parcelRequire("gFHzB");
const $2013618434e71d2e$export$a7fed597f4b8afd8 = ({ cancelButtonLabel: cancelButtonLabel, children: children, confirmButtonLabel: confirmButtonLabel, context: context, hideActionButtons: hideActionButtons, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur })=>{
    const { onCancel: onCancel, onConfirm: onConfirm } = context;
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const formRef = (0, $5uXOq.useRef)(null);
    /** If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save)
   */ const onBlur = (0, $5uXOq.useCallback)(()=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            setTimeout(()=>{
                // Check the form hasn't unmounted before attempting to auto-submit
                !wasFocusReceivedSinceLastBlurRef.current && formRef.current && onConfirm(true);
            }, 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        onConfirm
    ]);
    /** Gets called when focus is transferred to the editView, or action buttons
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field
   */ const onFocus = (0, $5uXOq.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const onSubmit = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onConfirm(false);
    }, [
        onConfirm
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) onSubmit(event);
        if (event.key === 'Esc' || event.key === 'Escape') onCancel(false);
    }, [
        onCancel,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2013618434e71d2e$var$StyledForm, {
        ref: formRef,
        role: "presentation",
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onSubmit: onSubmit
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFHzB.FormControls), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        hideActionButtons: hideActionButtons
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2013618434e71d2e$var$StyledForm = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gFHzB", function(module, exports) {

$parcel$export(module.exports, "FormControls", () => $f0a6c88ac1a8ee43$export$9b13823dba16e7d1);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $3QtoI = parcelRequire("3QtoI");

var $4bh3r = parcelRequire("4bh3r");
const $f0a6c88ac1a8ee43$export$9b13823dba16e7d1 = ({ cancelButtonLabel: cancelButtonLabel, confirmButtonLabel: confirmButtonLabel, context: { onCancel: onCancel }, hideActionButtons: hideActionButtons })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return !hideActionButtons ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bh3r.default), {
        cancelButtonLabel: cancelButtonLabel ?? formatMessage((0, $3QtoI.default).cancelButtonLabel),
        confirmButtonLabel: confirmButtonLabel ?? formatMessage((0, $3QtoI.default).confirmButtonLabel),
        onCancelClick: ()=>onCancel(false)
    }) : /** This is to allow Ctrl + Enter to submit without action buttons */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
        hidden: true,
        type: "submit",
        "aria-label": formatMessage((0, $3QtoI.default).submitButtonLabel)
    });
};

});
parcelRegister("3QtoI", function(module, exports) {

$parcel$export(module.exports, "default", () => $642f24ebaaa5440a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $642f24ebaaa5440a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editButtonLabel: {
        "id": "inline-edit-lite.read-view.edit-button-label",
        "defaultMessage": "Edit"
    },
    confirmButtonLabel: {
        "id": "inline-edit-lite.edit-view.confirm-button-label",
        "defaultMessage": "Confirm"
    },
    cancelButtonLabel: {
        "id": "inline-edit-lite.edit-view.cancel-button-label",
        "defaultMessage": "Cancel"
    },
    submitButtonLabel: {
        "id": "inline-edit-lite.edit-view.submit-button-label",
        "defaultMessage": "Submit"
    }
});

});

parcelRegister("4bh3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd4cb4b703da218f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $ky7e4 = parcelRequire("ky7e4");

var $84THj = parcelRequire("84THj");
const $bd4cb4b703da218f$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd4cb4b703da218f$var$ButtonsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd4cb4b703da218f$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": confirmButtonLabel,
        type: "submit",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
            label: confirmButtonLabel,
            LEGACY_size: "small"
        }),
        shouldFitContainer: true,
        onMouseDown: onMouseDown
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd4cb4b703da218f$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": cancelButtonLabel,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            label: cancelButtonLabel,
            LEGACY_size: "small"
        }),
        onClick: onCancelClick,
        shouldFitContainer: true,
        onMouseDown: onMouseDown
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd4cb4b703da218f$var$ButtonsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1pfh12x7 _kqswstnw _152t1osq _rjxpidpf _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $bd4cb4b703da218f$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1cd0 _1mpy1b66 _1nlx1bhr _l2uv16qz _7mfvvq0a _szlb1fxt",
            __cmplp.className
        ])
    });
});
var $bd4cb4b703da218f$export$2e2bcd8739ae039 = $bd4cb4b703da218f$var$Buttons;

});
parcelRegister("ky7e4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef5c96854bbf6178$var$_react = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ef5c96854bbf6178$var$_checkMark = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ef5c96854bbf6178$var$_check = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("kbxJz")));
function $ef5c96854bbf6178$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef5c96854bbf6178$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ef5c96854bbf6178$var$_react.default.createElement($ef5c96854bbf6178$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ef5c96854bbf6178$var$_check.default
    }, props));
$ef5c96854bbf6178$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ef5c96854bbf6178$var$_default = module.exports.default = $ef5c96854bbf6178$var$CheckMarkIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("kbxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb1f0098e5a023eb$var$CheckIcon = (props)=>/*#__PURE__*/ $eb1f0098e5a023eb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $eb1f0098e5a023eb$var$_checkMark.default
    }));
$eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;

});





parcelRegister("fevyg", function(module, exports) {

$parcel$export(module.exports, "EditViewPopup", () => $202714b4b925b765$export$3ce17fd683f703eb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8QpSo = parcelRequire("8QpSo");

var $gkD4s = parcelRequire("gkD4s");
var $1V7PR = parcelRequire("1V7PR");

var $7mPT9 = parcelRequire("7mPT9");

var $7pDxf = parcelRequire("7pDxf");

var $4R6GH = parcelRequire("4R6GH");
const $202714b4b925b765$var$getModifiers = (alignBlock)=>[
        {
            name: 'offset',
            enabled: alignBlock === 'center',
            options: {
                // Use negative offset of half the popper height to vertically center the content
                offset: ({ popper: popper })=>[
                        0,
                        -popper.height / 2
                    ]
            }
        },
        {
            name: 'flip',
            enabled: false
        },
        {
            name: 'computeStyles',
            options: {
                // Prevent use of 3D transforms to avoid creating a new stacking context for fixed position children
                gpuAcceleration: false
            }
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 0,
                rootBoundary: 'viewport',
                // Allow the popup to remain within the clipping parent when overflowing the Y axis
                altAxis: true
            }
        }
    ];
/** Map the provided alignment to the appropriate popper placement. */ const $202714b4b925b765$var$toPopperPlacement = (alignBlock)=>{
    switch(alignBlock){
        case 'end':
            return 'top-start';
        default:
            return 'bottom-start';
    }
};
/** Map the provided min width breakpoint to a pixel value. */ const $202714b4b925b765$var$toMinWidth = (minWidth)=>{
    switch(minWidth){
        case 'large':
            return '400px';
        case 'medium':
            return '200px';
        default:
            return '140px';
    }
};
const $202714b4b925b765$export$3ce17fd683f703eb = ({ alignBlock: alignBlock = 'start', minWidth: minWidth = 'medium', target: target, children: children })=>{
    const updateRef = (0, $5uXOq.useRef)();
    const resizeObserver = (0, $5uXOq.useRef)();
    // Cleanup the resize observer when the component is unmounted
    (0, $5uXOq.useEffect)(()=>()=>resizeObserver.current?.disconnect(), []);
    const resizeRef = (0, $5uXOq.useCallback)((el)=>{
        if (el) {
            // Update popup positioning whenever content is resized
            resizeObserver.current = new ResizeObserver(()=>updateRef.current?.());
            resizeObserver.current.observe(el);
        }
    }, []);
    const Target = (0, $5uXOq.useMemo)(()=>target != null && (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? target : $202714b4b925b765$var$DefaultTarget, [
        target
    ]);
    // Ensure a stable ref function is passed through to the popup content
    const memoizedMergeRefs = (0, $5uXOq.useMemo)(()=>(0, $8QpSo.default)((0, $7mPT9.mergeRefs)), []);
    const modifiers = (0, $5uXOq.useMemo)(()=>$202714b4b925b765$var$getModifiers(alignBlock), [
        alignBlock
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkD4s.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1V7PR.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Target, {
            ref: ref
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7pDxf.JiraPopper), {
        placement: $202714b4b925b765$var$toPopperPlacement(alignBlock),
        strategy: "absolute",
        modifiers: modifiers,
        messageId: "issue-field-inline-edit-lite.ui.field-inline-edit-lite.edit-view.edit-view-popup.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($202714b4b925b765$var$Content, {
            ref: memoizedMergeRefs(ref, resizeRef),
            minWidth: minWidth,
            /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style
        }, children);
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $202714b4b925b765$var$DefaultTarget = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbidpf",
            __cmplp.className
        ])
    });
});
const $202714b4b925b765$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_11xim2q": (0, $lD23V.default)(`max(100%, ${$202714b4b925b765$var$toMinWidth(__cmplp.minWidth)})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul91hi4 _1bsb1ris _p12fkbql _1pby16oo",
            __cmplp.className
        ])
    });
});

});


parcelRegister("8KtCv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d993c04ef711ba27$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d993c04ef711ba27$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    confirmButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    }
});

});

parcelRegister("aSXFv", function(module, exports) {

$parcel$export(module.exports, "ReadView", () => $966dc4be1fcc7c7c$export$a4b5824ec1e018e1);

var $5uXOq = parcelRequire("5uXOq");

var $ewVRN = parcelRequire("ewVRN");

var $iHavf = parcelRequire("iHavf");

var $4R6GH = parcelRequire("4R6GH");

var $6MvyO = parcelRequire("6MvyO");
const $966dc4be1fcc7c7c$export$a4b5824ec1e018e1 = ({ children: children, context: context, editButtonLabel: editButtonLabel, editButtonRef: editButtonRef, hideEditButton: hideEditButton, isEditInteractionEnabled: isEditInteractionEnabled, isInvalid: isInvalid, isLoading: isLoading, readViewContainerRef: readViewContainerRef, readViewFitContainerHeight: readViewFitContainerHeight, onCopy: onCopy, onCut: onCut, onPaste: onPaste, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled })=>{
    const { isEditButtonFocused: isEditButtonFocused, onClick: onClick, onMouseDown: onMouseDown, onEditButtonBlur: onEditButtonBlur, onEditButtonFocus: onEditButtonFocus } = (0, $ewVRN.useInlineEditReadViewContainer)(context, isEditInteractionEnabled);
    let handleEditButtonBlur = onEditButtonBlur;
    let handleEditButtonFocus = onEditButtonFocus;
    let isCopied = false;
    if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { onFocus: onFocus, onBlur: onBlur, lastCopiedTarget: lastCopiedTarget } = (0, $6MvyO.useCopyPasteTarget)({
            onCopy: onCopy,
            onCut: onCut,
            // Don't allow paste interaction for non-editable fields
            onPaste: isEditInteractionEnabled ? onPaste : undefined
        });
        isCopied = lastCopiedTarget;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        handleEditButtonBlur = (0, $5uXOq.useCallback)((e)=>{
            onEditButtonBlur(e);
            onBlur(e);
        }, [
            onEditButtonBlur,
            onBlur
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        handleEditButtonFocus = (0, $5uXOq.useCallback)((e)=>{
            onEditButtonFocus(e);
            onFocus(e);
        }, [
            onEditButtonFocus,
            onFocus
        ]);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iHavf.default), {
        context: context,
        editButtonLabel: editButtonLabel,
        editButtonRef: editButtonRef,
        hideEditButton: hideEditButton,
        isEditInteractionEnabled: isEditInteractionEnabled,
        isEditButtonFocused: isEditButtonFocused,
        isCopied: isCopied,
        // Highlight the field as invalid to notify the user if there was an error attempting to submit changes.
        isInvalid: isInvalid,
        isLoading: isLoading,
        onClick: onClick,
        onMouseDown: onMouseDown,
        onEditButtonBlur: handleEditButtonBlur,
        onEditButtonFocus: handleEditButtonFocus,
        readViewFitContainerHeight: readViewFitContainerHeight,
        ref: readViewContainerRef,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled
    }, children);
};

});
parcelRegister("ewVRN", function(module, exports) {

$parcel$export(module.exports, "useInlineEditReadViewContainer", () => $9716c2460c9f5736$export$49374f374d70ab51);

var $5uXOq = parcelRequire("5uXOq");
const $9716c2460c9f5736$var$DRAG_THRESHOLD = 5;
const $9716c2460c9f5736$var$isLinkOrButton = (element)=>element.closest('a') != null || element.closest('button') != null;
const $9716c2460c9f5736$export$49374f374d70ab51 = ({ onEdit: onEdit }, isEditInteractionEnabled = true)=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startY = (0, $5uXOq.useRef)(0);
    const [isEditButtonFocused, setEditButtonFocused] = (0, $5uXOq.useState)(false);
    const mouseHasMovedAfterMouseDown = (0, $5uXOq.useCallback)((event)=>Math.abs(startX.current - event.clientX) >= $9716c2460c9f5736$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $9716c2460c9f5736$var$DRAG_THRESHOLD, []);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        const element = event.target;
        /** If a link or button is clicked in the read view, default action should be taken */ if (element instanceof HTMLElement && !$9716c2460c9f5736$var$isLinkOrButton(element) && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEdit();
        }
    }, [
        mouseHasMovedAfterMouseDown,
        onEdit
    ]);
    const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
        startX.current = event.clientX;
        startY.current = event.clientY;
    }, []);
    const onEditButtonBlur = (0, $5uXOq.useCallback)(()=>setEditButtonFocused(false), []);
    const onEditButtonFocus = (0, $5uXOq.useCallback)(()=>setEditButtonFocused(true), []);
    return {
        isEditButtonFocused: isEditButtonFocused,
        onClick: isEditInteractionEnabled ? onClick : undefined,
        onMouseDown: isEditInteractionEnabled ? onMouseDown : undefined,
        onEditButtonBlur: onEditButtonBlur,
        onEditButtonFocus: onEditButtonFocus
    };
};

});

parcelRegister("iHavf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a352247ae0a338f6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $4R6GH = parcelRequire("4R6GH");

var $8mtOu = parcelRequire("8mtOu");

var $3i0C1 = parcelRequire("3i0C1");

var $HXUQY = parcelRequire("HXUQY");
const $a352247ae0a338f6$var$borderStyles = {
    focused: "_1h6d1p6i",
    invalid: "_1h6d1bqt",
    copied: "_1h6d1p6i _1dqogq9o",
    none: "_1h6d3acm"
};
const $a352247ae0a338f6$var$getBorderStyle = ({ isFocusRingVisible: isFocusRingVisible, isInvalid: isInvalid, isCopied: isCopied })=>{
    if (isFocusRingVisible) return 'focused';
    if (isInvalid) return 'invalid';
    if (isCopied) return 'copied';
    return 'none';
};
/**
 * This component is designed to be rendered within the `readView` of a `FieldInlineEditLite` component. This can be
 * rendered in a 'read-only' layout by omitting the `context` prop which is provided by `useInlineEdit` in
 * `@atlassian/jira-inline-edit-lite`. This ensures consistent spacing for consumers when a field is conditionally
 * editable.
 */ const $a352247ae0a338f6$var$InlineEditReadViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, context: context, editButtonLabel: editButtonLabel, editButtonRef: editButtonRef, hideEditButton: hideEditButton = true, isCopied: isCopied = false, isEditButtonFocused: isEditButtonFocused = false, isEditInteractionEnabled: isEditInteractionEnabled = true, isLoading: isLoading = false, isInvalid: isInvalid = false, onClick: onClick, onMouseDown: onMouseDown, onEditButtonBlur: onEditButtonBlur, onEditButtonFocus: onEditButtonFocus, readViewFitContainerHeight: readViewFitContainerHeight = false, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled = false }, ref)=>{
    const isHiddenButtonFocused = hideEditButton && isEditButtonFocused;
    const isFocusRingVisible = isHiddenButtonFocused || isLoading;
    const isEditable = Boolean(context) && isEditInteractionEnabled;
    const borderStyle = (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? $a352247ae0a338f6$var$getBorderStyle({
        isFocusRingVisible: isFocusRingVisible,
        isInvalid: isInvalid,
        isCopied: isCopied
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a352247ae0a338f6$var$Container, {
        "data-testid": "issue-field-inline-edit-read-view-container.ui.container",
        "data-vc": "issue-field-inline-edit-read-view-container",
        readViewFitContainerHeight: readViewFitContainerHeight,
        isEditable: isEditable,
        isFocusRingVisible: isFocusRingVisible,
        isInvalid: isInvalid,
        onClick: onClick,
        onMouseDown: onMouseDown,
        role: "presentation",
        ref: ref,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        // Consumers may currently update non-visual styles dynamically based off isEditable prop.
        // Here we allow consumers to exclude the attachment of edit styles from VC calculation.
        // Learn more about why this has been introduced https://jplat.atlassian.net/browse/EM-9211
        "data-vc-nvs": (0, $4R6GH.fg)('ignore_inline_edit_cell'),
        className: (0, $bwpsq.default)([
            borderStyle && $a352247ae0a338f6$var$borderStyles[borderStyle]
        ])
    }, hideEditButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3i0C1.EditButtonHidden), {
        ref: editButtonRef,
        context: context ?? (0, $8mtOu.EMPTY_INLINE_EDIT_CONTEXT),
        isDisabled: !isEditable,
        label: editButtonLabel,
        onBlur: onEditButtonBlur,
        onFocus: onEditButtonFocus
    }), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a352247ae0a338f6$var$LoadingOverlay, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a352247ae0a338f6$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null))) : children, !hideEditButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $HXUQY.EditButton), {
        ref: editButtonRef,
        context: context ?? (0, $8mtOu.EMPTY_INLINE_EDIT_CONTEXT),
        isDisabled: !isEditable,
        label: editButtonLabel,
        onBlur: onEditButtonBlur,
        onFocus: onEditButtonFocus,
        // In future providing CSS variables *may* be something that makes its way into the design system, but
        // for now this is an acceptable override to prevent managing additional state with JS.
        // More context here https://atlassian.slack.com/archives/C060GTVV988/p1703214250865779?thread_ts=1703212675.166419&cid=C060GTVV988
        /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766, */ style: $a352247ae0a338f6$var$editButtonStyles
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a352247ae0a338f6$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { readViewFitContainerHeight: readViewFitContainerHeight, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, isEditable: isEditable, isFocusRingVisible: isFocusRingVisible, isInvalid: isInvalid, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _zulpu2gc _189eyh40 _1dqonqa1 _ca0qidpf _u5f312x7 _n3tdidpf _19bv12x7 _1e0c1txw _4cvr1h6o _vchhusvi _p12f1osq _kqswh2mm",
            __cmplp.readViewFitContainerHeight ? "_1tke1osq" : "_1tkezwfg",
            __cmplp.hasReadViewTruncateDisabled ? "_1reoewfl _18m9ewfl" : "_1reo15vq _18m915vq",
            __cmplp.hasReadViewTruncateDisabled ? "_1bton7od" : "_1bto1l2s",
            __cmplp.isEditable && "_v56412tl _yyosidpf _irr3166n _37uft94y _1rr4t94y",
            __cmplp.isFocusRingVisible && !(0, $4R6GH.fg)('jsc_inline_editing_field_refactor') && "_1h6d1p6i",
            __cmplp.isInvalid && !__cmplp.isFocusRingVisible && !(0, $4R6GH.fg)('jsc_inline_editing_field_refactor') && "_1h6d1bqt",
            !__cmplp.isInvalid && !__cmplp.isFocusRingVisible && !(0, $4R6GH.fg)('jsc_inline_editing_field_refactor') && "_1h6d3acm",
            ((0, $4R6GH.fg)('jsc_summary_link_button') || (0, $4R6GH.fg)('jira_list_merged_column_gate')) && "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $a352247ae0a338f6$var$editButtonStyles = {
    flexShrink: 0,
    marginLeft: 'auto',
    opacity: 'var(--edit-button-opacity, 0)'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a352247ae0a338f6$var$LoadingOverlay = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lcxvglyw _tzy4n2vs",
            __cmplp.className
        ])
    });
});
const $a352247ae0a338f6$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1ltv1ssb _154i1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
var $a352247ae0a338f6$export$2e2bcd8739ae039 = $a352247ae0a338f6$var$InlineEditReadViewContainer;

});
parcelRegister("8mtOu", function(module, exports) {

$parcel$export(module.exports, "EMPTY_INLINE_EDIT_CONTEXT", () => $22efb5973d9a3eb7$export$817cfe3c303a8a15);

var $8Rkzz = parcelRequire("8Rkzz");
const $22efb5973d9a3eb7$export$817cfe3c303a8a15 = {
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onEdit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};

});

parcelRegister("3i0C1", function(module, exports) {

$parcel$export(module.exports, "EditButtonHidden", () => $f6975eb6f5ceef4d$export$c2bd955fafbef8bc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $3QtoI = parcelRequire("3QtoI");
const $f6975eb6f5ceef4d$export$c2bd955fafbef8bc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ context: { onEdit: onEdit }, isDisabled: isDisabled, label: label, onBlur: onBlur, onFocus: onFocus }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const finalEditButtonLabel = label ?? formatMessage((0, $3QtoI.default).editButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f6975eb6f5ceef4d$var$HiddenButton, {
        "aria-label": finalEditButtonLabel,
        disabled: isDisabled,
        "aria-hidden": isDisabled,
        onBlur: onBlur,
        onFocus: onFocus,
        onClick: onEdit,
        ref: ref,
        type: "button"
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/no-html-button -- Ignored via go/DSP-18766
const $f6975eb6f5ceef4d$var$HiddenButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});

parcelRegister("HXUQY", function(module, exports) {

$parcel$export(module.exports, "EditButton", () => $fd9aa49e5dd93289$export$a8d3280cb45e38b8);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $5gR1R = parcelRequire("5gR1R");

var $koVbs = parcelRequire("koVbs");

var $3QtoI = parcelRequire("3QtoI");
const $fd9aa49e5dd93289$export$a8d3280cb45e38b8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ context: { onEdit: onEdit }, isDisabled: isDisabled, label: label, onBlur: onBlur, onFocus: onFocus, style: style }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const finalEditButtonLabel = label ?? formatMessage((0, $3QtoI.default).editButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "data-vc": "inline-edit-lite-edit-button",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5gR1R))), {
            spacing: "spacious",
            label: finalEditButtonLabel,
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: isDisabled,
        "aria-hidden": isDisabled,
        onClick: onEdit,
        onBlur: onBlur,
        onFocus: onFocus,
        ref: ref,
        spacing: "none",
        // In future providing CSS variables *may* be something that makes its way into the design system, but
        // for now this is an acceptable override to prevent managing additional state with JS.
        // More context here https://atlassian.slack.com/archives/C060GTVV988/p1703214250865779?thread_ts=1703212675.166419&cid=C060GTVV988
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, jira/react/no-style-attribute -- Ignored via go/DSP-18766
        style: style
    });
});

});
parcelRegister("5gR1R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a01e1f60e987af0a2e95a320523abf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d6794d2f296ea70$var$_react = $3d6794d2f296ea70$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3d6794d2f296ea70$var$_edit = $3d6794d2f296ea70$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $3d6794d2f296ea70$var$_edit2 = $3d6794d2f296ea70$var$_interopRequireDefault((parcelRequire("gjM4I")));
function $3d6794d2f296ea70$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditorEditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d6794d2f296ea70$var$EditIcon = (props)=>/*#__PURE__*/ $3d6794d2f296ea70$var$_react.default.createElement($3d6794d2f296ea70$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $3d6794d2f296ea70$var$_edit2.default
    }, props));
$3d6794d2f296ea70$var$EditIcon.Name = 'EditIconMigration';
var $3d6794d2f296ea70$var$_default = module.exports.default = $3d6794d2f296ea70$var$EditIcon;

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("gjM4I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be13b660d6f77686$var$_react = $be13b660d6f77686$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $be13b660d6f77686$var$_edit = $be13b660d6f77686$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $be13b660d6f77686$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $be13b660d6f77686$var$EditorEditIcon = (props)=>/*#__PURE__*/ $be13b660d6f77686$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M15.148 6.852a.5.5 0 0 1 .708.004l2.288 2.288a.5.5 0 0 1 .004.708L11 17l-3-3zM7 15l3 3-3.51.877c-.27.068-.436-.092-.367-.367z"/></svg>`
    }, props, {
        newIcon: $be13b660d6f77686$var$_edit.default
    }));
$be13b660d6f77686$var$EditorEditIcon.displayName = 'EditorEditIcon';
var $be13b660d6f77686$var$_default = module.exports.default = $be13b660d6f77686$var$EditorEditIcon;

});




parcelRegister("6MvyO", function(module, exports) {

$parcel$export(module.exports, "CopyPasteContextProvider", () => $b77bf0e00bba006f$export$1afe5f1aa41cba74);
$parcel$export(module.exports, "useCopyPasteTarget", () => $b77bf0e00bba006f$export$6bdcb2980d85cb0f);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
const $b77bf0e00bba006f$var$CopyPasteContext = /*#__PURE__*/ (0, $5uXOq.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
const $b77bf0e00bba006f$export$1afe5f1aa41cba74 = ({ children: children })=>{
    const copyPasteTarget = (0, $5uXOq.useRef)(null);
    const lastCopiedTarget = (0, $5uXOq.useRef)(null);
    const updateCopyPasteTarget = (0, $5uXOq.useCallback)((handlers)=>{
        copyPasteTarget.current = handlers;
    }, []);
    /** Update the last copied target if the copy event is explicitly handled. */ const updateLastCopiedTargetWhenHandled = (0, $5uXOq.useCallback)((handled, nextTarget)=>{
        if (!handled) return;
        // Clear previously copied target
        lastCopiedTarget.current?.onLastCopiedTarget(false);
        // Set next copied target
        nextTarget?.onLastCopiedTarget(true);
        lastCopiedTarget.current = nextTarget;
    }, []);
    const onCopy = (0, $5uXOq.useCallback)((event)=>{
        updateLastCopiedTargetWhenHandled(copyPasteTarget.current?.onCopy(event) ?? false, copyPasteTarget.current);
    }, [
        updateLastCopiedTargetWhenHandled
    ]);
    const onCut = (0, $5uXOq.useCallback)((event)=>{
        updateLastCopiedTargetWhenHandled(copyPasteTarget.current?.onCut(event) ?? false, copyPasteTarget.current);
    }, [
        updateLastCopiedTargetWhenHandled
    ]);
    const onPaste = (0, $5uXOq.useCallback)((event)=>{
        updateLastCopiedTargetWhenHandled(copyPasteTarget.current?.onPaste(event) ?? false, null);
    }, [
        updateLastCopiedTargetWhenHandled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        globalThis.document.addEventListener('copy', onCopy);
        globalThis.document.addEventListener('cut', onCut);
        globalThis.document.addEventListener('paste', onPaste, true);
        return ()=>{
            globalThis.document.removeEventListener('copy', onCopy);
            globalThis.document.removeEventListener('cut', onCut);
            globalThis.document.removeEventListener('paste', onPaste, true);
        };
    }, [
        onCopy,
        onCut,
        onPaste
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b77bf0e00bba006f$var$CopyPasteContext.Provider, {
        value: updateCopyPasteTarget
    }, children);
};
const $b77bf0e00bba006f$export$6bdcb2980d85cb0f = ({ onCopy: onCopy, onCut: onCut, onPaste: onPaste })=>{
    const updateCopyPasteTarget = (0, $5uXOq.useContext)($b77bf0e00bba006f$var$CopyPasteContext);
    const [lastCopiedTarget, setLastCopiedTarget] = (0, $5uXOq.useState)(false);
    // Track callbacks as refs so they can be invoked using a stable function reference
    const onCopyRef = (0, $5uXOq.useRef)(onCopy);
    onCopyRef.current = onCopy;
    const onCutRef = (0, $5uXOq.useRef)(onCut);
    onCutRef.current = onCut;
    const onPasteRef = (0, $5uXOq.useRef)(onPaste);
    onPasteRef.current = onPaste;
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        // Ensure stable function reference is provided as the callback functions are only bound to the document once
        const stableCopy = (event)=>onCopyRef.current?.(event) ?? false;
        const stableCut = (event)=>onCutRef.current?.(event) ?? false;
        const stablePaste = (event)=>onPasteRef.current?.(event) ?? false;
        /* Queue as a microtask to ensure the blur callback is emitted before calling updateCopyPasteTarget when
		 * navigating between targets. */ queueMicrotask(()=>{
            updateCopyPasteTarget({
                onCopy: stableCopy,
                onCut: stableCut,
                onPaste: stablePaste,
                onLastCopiedTarget: setLastCopiedTarget
            });
        });
    }, [
        updateCopyPasteTarget
    ]);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        updateCopyPasteTarget(null);
    }, [
        updateCopyPasteTarget
    ]);
    return {
        lastCopiedTarget: lastCopiedTarget,
        onFocus: onFocus,
        onBlur: onBlur
    };
};

});



parcelRegister("hOlfS", function(module, exports) {

$parcel$export(module.exports, "ReadViewNonEditable", () => $4b8d6134ee093d56$export$4efb4956550fac52);

var $5uXOq = parcelRequire("5uXOq");

var $iHavf = parcelRequire("iHavf");
const $4b8d6134ee093d56$export$4efb4956550fac52 = ({ children: children, hideEditButton: hideEditButton, isLoading: isLoading, readViewFitContainerHeight: readViewFitContainerHeight, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iHavf.default), {
        hideEditButton: hideEditButton,
        isLoading: isLoading,
        readViewFitContainerHeight: readViewFitContainerHeight,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled
    }, children);

});


parcelRegister("1CKDg", function(module, exports) {

$parcel$export(module.exports, "default", () => $83628fdb19b073cc$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $83628fdb19b073cc$var$CheckboxSelectEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("gdLPQ")), {
        moduleId: "6225fccd"
    }),
    getPreloadProps: ()=>({})
});
var $83628fdb19b073cc$export$2e2bcd8739ae039 = $83628fdb19b073cc$var$CheckboxSelectEditViewEntryPoint;

});
parcelRegister("gdLPQ", function(module, exports) {

let $bcf2f74b6aaabedb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bcf2f74b6aaabedb$var$load("gFjqZ").then(()=>parcelRequire('48Ka6'));

});


parcelRegister("kQfA4", function(module, exports) {

$parcel$export(module.exports, "CheckboxSelectReadView", () => $59d27ef8d1f98c3a$export$9aaea694d3042383);

var $f9DWh = parcelRequire("f9DWh");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $d9xxV = parcelRequire("d9xxV");

var $koVbs = parcelRequire("koVbs");

var $eZibI = parcelRequire("eZibI");

var $2bYmU = parcelRequire("2bYmU");

var $l8IoT = parcelRequire("l8IoT");

var $e3oxY = parcelRequire("e3oxY");
const $59d27ef8d1f98c3a$export$9aaea694d3042383 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const data = (0, $8Uumt.useFragment)((0, $f9DWh.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectedOptions = data?.selectedOptions?.edges?.filter((edge)=>Boolean(edge?.node?.value)).map((edge)=>({
            name: edge?.node?.value || '',
            key: edge?.node?.id || ''
        })) || [];
    if (!selectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.050",
        xcss: isHoverPopoverEnabled && $59d27ef8d1f98c3a$var$widthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bYmU.default), {
        items: selectedOptions,
        ItemComponent: (0, $l8IoT.TagItem),
        PopupContentWrapper: (0, $l8IoT.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $e3oxY.default).showMoreTooltip),
        isHoverPopoverEnabled: isHoverPopoverEnabled
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $59d27ef8d1f98c3a$var$containerWithNegativeMarginOffset
    }, selectedOptions.map((value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
            key: value.key,
            text: value.name
        })));
};
const $59d27ef8d1f98c3a$var$containerWithNegativeMarginOffset = (0, $8CUq3.xcss)({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    // Tag has a built-in margin of 4px, so we use a negative side margin to allow tags to align with their parent.
    marginTop: 'space.0',
    marginRight: 'space.negative.050',
    marginBottom: 'space.0',
    marginLeft: 'space.negative.050'
});
const $59d27ef8d1f98c3a$var$widthStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});
parcelRegister("f9DWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8ec28f23f15ef43$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e66798db69b7174dc3e67181cb94bce4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f8ec28f23f15ef43$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "checkboxSelect_issueFieldCheckboxSelectReadviewFull_CheckboxSelectReadView",
    "selections": [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraCheckboxesField"
};
$f8ec28f23f15ef43$var$node.hash = "d4b0ebe1c72d70b5bd1191947a37e196";
var $f8ec28f23f15ef43$export$2e2bcd8739ae039 = $f8ec28f23f15ef43$var$node;

});

parcelRegister("eZibI", function(module, exports) {

$parcel$export(module.exports, "EmptyFieldText", () => $0e4914e960fc7f36$export$f6d716da5f11cd01);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $gSPPL = parcelRequire("gSPPL");
const $0e4914e960fc7f36$export$f6d716da5f11cd01 = ({ emptyText: emptyText })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e4914e960fc7f36$var$EmptyValueStyleWrapper, null, emptyText ?? formatMessage((0, $gSPPL.default).emptyFieldText));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $0e4914e960fc7f36$var$EmptyValueStyleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _syaz131l _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gSPPL", function(module, exports) {

$parcel$export(module.exports, "default", () => $59e08f941baa8969$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $59e08f941baa8969$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyFieldText: {
        "id": "issue-empty-field-text.empty-field-text",
        "defaultMessage": "None"
    }
});

});


parcelRegister("e3oxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea04ee41f5256749$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ea04ee41f5256749$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-checkbox-select-readview-full.checkbox-select.truncated.show-more-tooltip",
        "defaultMessage": "See more items"
    }
});

});


parcelRegister("jrRyX", function(module, exports) {

$parcel$export(module.exports, "InlineEditFieldInjectionsContext", () => $311a24c867bfddef$export$5b3426c89ef7f7de);
$parcel$export(module.exports, "useInlineEditFieldInjections", () => $311a24c867bfddef$export$23de4844126025dd);

var $5uXOq = parcelRequire("5uXOq");

var $lHfia = parcelRequire("lHfia");
const $311a24c867bfddef$export$f36c9b20522c59e3 = {
    overriding: {
        overrideLabel: (0, $lHfia.identity),
        overrideDescription: (0, $lHfia.identity),
        overrideIsEditable: (0, $lHfia.identity),
        overrideFieldOptionsFilter: (0, $lHfia.identity)
    }
};
const $311a24c867bfddef$export$5b3426c89ef7f7de = /*#__PURE__*/ (0, $5uXOq.createContext)($311a24c867bfddef$export$f36c9b20522c59e3);
const $311a24c867bfddef$export$23de4844126025dd = ()=>(0, $5uXOq.useContext)($311a24c867bfddef$export$5b3426c89ef7f7de);

});
parcelRegister("lHfia", function(module, exports) {

$parcel$export(module.exports, "identity", () => $517b82c525a70787$export$f0954fd7d5368655);
$parcel$export(module.exports, "FieldInjectionsContext", () => $517b82c525a70787$export$a6ff76841695c6c0);

var $5uXOq = parcelRequire("5uXOq");
const $517b82c525a70787$export$8793edee2d425525 = ()=>{};
const $517b82c525a70787$export$f0954fd7d5368655 = (x)=>x;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $517b82c525a70787$var$initialValue = {
    capturing: {
        captureAllowedValues: $517b82c525a70787$export$8793edee2d425525,
        captureDescription: $517b82c525a70787$export$8793edee2d425525,
        captureFieldId: $517b82c525a70787$export$8793edee2d425525,
        captureFieldType: $517b82c525a70787$export$8793edee2d425525,
        captureIsDisabled: $517b82c525a70787$export$8793edee2d425525,
        captureIsRequired: $517b82c525a70787$export$8793edee2d425525,
        captureLabel: $517b82c525a70787$export$8793edee2d425525,
        captureRenderer: $517b82c525a70787$export$8793edee2d425525
    },
    overriding: {
        overrideLabel: $517b82c525a70787$export$f0954fd7d5368655,
        overrideElementAfterLabel: $517b82c525a70787$export$f0954fd7d5368655,
        overrideIsRequired: $517b82c525a70787$export$f0954fd7d5368655,
        overrideIsDisabled: $517b82c525a70787$export$f0954fd7d5368655,
        overrideAllowedValues: $517b82c525a70787$export$f0954fd7d5368655,
        overrideFieldOptionsFilter: $517b82c525a70787$export$f0954fd7d5368655,
        overrideOnChange: $517b82c525a70787$export$f0954fd7d5368655,
        overrideOnBlur: $517b82c525a70787$export$f0954fd7d5368655,
        overrideDescription: $517b82c525a70787$export$f0954fd7d5368655
    }
};
const $517b82c525a70787$export$a6ff76841695c6c0 = /*#__PURE__*/ (0, $5uXOq.createContext)($517b82c525a70787$var$initialValue);

});



parcelRegister("jFYC8", function(module, exports) {

$parcel$export(module.exports, "INLINE_EDIT_ANALYTICS_ATTRIBUTES", () => $d0e4349c9e2fbabc$export$a659dfe9528cfc57);
// Attributes for inline editing track events
const $d0e4349c9e2fbabc$export$a659dfe9528cfc57 = {
    // If the update was made inline (and not via the issue view)
    isInlineEditing: true
};

});


parcelRegister("1ujU3", function(module, exports) {

$parcel$export(module.exports, "CmdbObjectsCell", () => $27b4916dbbf0b803$export$eebc6db46b17b7b3);

var $6joRz = parcelRequire("6joRz");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2bYmU = parcelRequire("2bYmU");

var $l8IoT = parcelRequire("l8IoT");

var $blEB6 = parcelRequire("blEB6");

var $aB7bN = parcelRequire("aB7bN");

var $hKMVG = parcelRequire("hKMVG");

var $e9M6d = parcelRequire("e9M6d");

var $ijfem = parcelRequire("ijfem");

var $tlGuq = parcelRequire("tlGuq");
const $27b4916dbbf0b803$var$CELL_TYPE = 'cmdbObjects';
const $27b4916dbbf0b803$export$eebc6db46b17b7b3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $6joRz.default), fieldRef);
    const errors = data?.selectedCmdbObjectsConnection?.errors?.map((error)=>error?.message);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    if (errors?.length) // At time of writing, these errors are not wired up on the issue backend. However we will maintain this
    // logging so that it is present if/when it is wired up so we can get error information immediately.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: $27b4916dbbf0b803$var$CELL_TYPE,
        reason: `Errors present: ${errors.length} - ${errors.join(', ')}; Edges present: ${data?.selectedCmdbObjectsConnection?.edges?.length}`
    });
    const objects = data?.selectedCmdbObjectsConnection?.edges;
    const filteredObjectsWithMedia = objects?.map((edge)=>{
        if (!edge?.node?.label) return null;
        let mediaImage;
        const iconUrl = edge.node.avatar?.url48 ?? undefined;
        if (edge.node.avatar?.mediaClientConfig?.clientId && edge.node.avatar?.mediaClientConfig?.fileId && edge.node.avatar?.mediaClientConfig?.mediaBaseUrl && edge.node.avatar?.mediaClientConfig?.mediaJwtToken) {
            const identifier = {
                id: edge.node.avatar.mediaClientConfig.fileId,
                mediaItemType: 'file'
            };
            const clientBasedAuth = {
                clientId: edge.node.avatar.mediaClientConfig.clientId,
                token: edge.node.avatar.mediaClientConfig.mediaJwtToken,
                // eslint-disable-next-line jira/deprecations/no-base-url
                baseUrl: edge.node.avatar.mediaClientConfig.mediaBaseUrl
            };
            const mediaClientConfig = {
                authProvider: ()=>Promise.resolve(clientBasedAuth)
            };
            mediaImage = {
                identifier: identifier,
                mediaClientConfig: mediaClientConfig
            };
        }
        return {
            key: edge.node.objectId || 'missingId',
            name: edge.node.label,
            href: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $blEB6.createObjectDetailUrl)(edge.node.objectId || '') : (0, $ijfem.createObjectDetailUrl)(edge.node.objectId || ''),
            icon: {
                url: !mediaImage ? iconUrl : undefined,
                mediaImage: mediaImage
            }
        };
    }).filter((0, $aB7bN.isNonNullish)) ?? [];
    if (!objects || objects.length !== filteredObjectsWithMedia.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: $27b4916dbbf0b803$var$CELL_TYPE,
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bYmU.default), {
        items: filteredObjectsWithMedia,
        ItemComponent: (0, $l8IoT.TagItem),
        PopupContentWrapper: (0, $l8IoT.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $tlGuq.default).triggerButton),
        isHoverPopoverEnabled: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
});

});
parcelRegister("6joRz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cff3a6a9808a0697$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d0ec6f9a42c69561a21d355d7d95393a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cff3a6a9808a0697$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cmdbObjects_nativeIssueTable_CmdbObjectsCell",
    "selections": [
        {
            "concreteType": "JiraCmdbObjectConnection",
            "kind": "LinkedField",
            "name": "selectedCmdbObjectsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraCmdbObjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraCmdbObject",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "objectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "label"
                                },
                                {
                                    "concreteType": "JiraCmdbAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCmdbMediaClientConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaClientConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "clientId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fileId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaBaseUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaJwtToken"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url48"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraCMDBField"
};
$cff3a6a9808a0697$var$node.hash = "b737019714db01f1a69458d583f66ece";
var $cff3a6a9808a0697$export$2e2bcd8739ae039 = $cff3a6a9808a0697$var$node;

});

parcelRegister("ijfem", function(module, exports) {

$parcel$export(module.exports, "createObjectDetailUrl", () => $64858d758f44ae35$export$51e4229f2c7d3866);
// Hardcoded values from @atlassian/jira-servicedesk-insight-urls
const $64858d758f44ae35$var$ASSETS_ROUTE_PREFIX = '/jira/servicedesk/assets';
const $64858d758f44ae35$export$51e4229f2c7d3866 = (objectId)=>`${$64858d758f44ae35$var$ASSETS_ROUTE_PREFIX}/object/${objectId}`;

});

parcelRegister("tlGuq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb9d56a9ae5d84fb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fb9d56a9ae5d84fb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.cmdb-objects.trigger-button",
        "defaultMessage": "See more assets"
    }
});

});


parcelRegister("g3xK5", function(module, exports) {

$parcel$export(module.exports, "ComponentsCell", () => $f128912fb43e4955$export$fafea088ac1dbc41);
$parcel$export(module.exports, "ComponentsInlineEditCell", () => $f128912fb43e4955$export$b3c67e48ecea06e4);

var $9s64Y = parcelRequire("9s64Y");

var $81cp9 = parcelRequire("81cp9");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $iEIQF = parcelRequire("iEIQF");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");

var $koVbs = parcelRequire("koVbs");

var $2bYmU = parcelRequire("2bYmU");

var $l8IoT = parcelRequire("l8IoT");

var $5hByW = parcelRequire("5hByW");

var $aB7bN = parcelRequire("aB7bN");

var $hKMVG = parcelRequire("hKMVG");

var $jFYC8 = parcelRequire("jFYC8");

var $Br57E = parcelRequire("Br57E");

var $e9M6d = parcelRequire("e9M6d");

var $imEz9 = parcelRequire("imEz9");
/**
 * Expected JQL Output: `project = ${projectKey} AND ${jqlTerm} = ${name}`
 */ const $f128912fb43e4955$var$getLinkJql = (projectKey, jqlTerm, name)=>{
    const jast = (0, $iEIQF.default).jast((0, $iEIQF.default).query((0, $iEIQF.default).compoundClause((0, $iEIQF.default).compoundOperator((0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97)), [
        (0, $iEIQF.default).terminalClause((0, $iEIQF.default).field('project'), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS)), (0, $iEIQF.default).valueOperand(projectKey)),
        (0, $iEIQF.default).terminalClause((0, $iEIQF.default).field((0, $aB7bN.escapeBackslashes)(jqlTerm)), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS)), (0, $iEIQF.default).valueOperand((0, $aB7bN.escapeBackslashes)(name)))
    ])));
    return (0, $l0V05.print)(jast, {
        operatorCase: 'upper'
    });
};
const $f128912fb43e4955$export$fafea088ac1dbc41 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { componentsOld: selectedComponentsConnection } = (0, $8Uumt.useFragment)((0, $81cp9.default), fieldRef);
    const components = selectedComponentsConnection?.edges;
    const filteredComponents = (0, $5uXOq.useMemo)(()=>components?.map((edge)=>edge?.node?.name != null ? {
                key: edge.node.name,
                name: edge.node.name,
                href: `${issueSearchBaseUrl}?jql=${encodeURIComponent($f128912fb43e4955$var$getLinkJql(projectKey, jqlTerm, edge.node.name))}`
            } : null).filter((0, $aB7bN.isNonNullish)) ?? [], [
        components,
        issueSearchBaseUrl,
        projectKey,
        jqlTerm
    ]);
    if (!components || components.length !== filteredComponents.length || !projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "components",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bYmU.default), {
        items: filteredComponents,
        ItemComponent: (0, $l8IoT.TagItem),
        PopupContentWrapper: (0, $l8IoT.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $imEz9.default).triggerButton)
    });
});
const $f128912fb43e4955$export$b3c67e48ecea06e4 = ({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, projectKey: projectKey, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $9s64Y.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const formatComponentJql = (0, $5uXOq.useCallback)((componentName)=>$f128912fb43e4955$var$getLinkJql(projectKey, jqlTerm, componentName), [
        jqlTerm,
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5hByW.ComponentsInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        baseSearchUrl: issueSearchBaseUrl,
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        formatComponentJql: formatComponentJql,
        fragmentRef: data,
        isTruncated: true,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};

});
parcelRegister("9s64Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $218ff115033e1293$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47106549cd6ea23d9e005ca430b256b6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $218ff115033e1293$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "components_nativeIssueTable_ComponentsInlineEditCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraComponentsField"
};
$218ff115033e1293$var$node.hash = "464cf035608be826c9250669fd7b79b4";
var $218ff115033e1293$export$2e2bcd8739ae039 = $218ff115033e1293$var$node;

});

parcelRegister("81cp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5af8d6e795f2dca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<373e632fc369142429d535218f0816a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d5af8d6e795f2dca$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_nativeIssueTable_ComponentsCell_fieldRef",
    "selections": [
        {
            "alias": "componentsOld",
            "concreteType": "JiraComponentConnection",
            "kind": "LinkedField",
            "name": "selectedComponentsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraComponentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraComponent",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraComponentsField"
};
$d5af8d6e795f2dca$var$node.hash = "0c7ed7763b84f4a5f5fdf18a8ff99f37";
var $d5af8d6e795f2dca$export$2e2bcd8739ae039 = $d5af8d6e795f2dca$var$node;

});

const $3cef51f82b2cbe1d$export$6d6d48d210d3ca97 = 'and';
const $3cef51f82b2cbe1d$export$7b8f0a728d79a753 = 'or';

parcelRegister("5hByW", function(module, exports) {

$parcel$export(module.exports, "ComponentsInlineEditViewWithIsEditable", () => $06940e99c7931c18$export$32ccb5f0cb497709);

var $6pkht = parcelRequire("6pkht");

var $fvFRE = parcelRequire("fvFRE");

var $btBMK = parcelRequire("btBMK");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $9B2fw = parcelRequire("9B2fw");

var $6PGpn = parcelRequire("6PGpn");

var $jrRyX = parcelRequire("jrRyX");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $06940e99c7931c18$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.value));
    return b.every((option)=>aIdSet.has(option.value));
};
const $06940e99c7931c18$export$32ccb5f0cb497709 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, baseSearchUrl: baseSearchUrl, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncatedWithHoverPopover: isTruncatedWithHoverPopover, formatComponentJql: formatComponentJql })=>{
    const data = (0, $8Uumt.useFragment)((0, $btBMK.default), fragmentRef);
    const [commit] = (0, $8Uumt.useMutation)((0, $fvFRE.default));
    const { id: uniqueFieldId, name: name, selectedComponentsConnection: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $5uXOq.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                value: edge?.node?.value ?? '',
                label: edge?.node?.label ?? ''
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $5uXOq.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.value) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateComponentsField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateComponentsField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedComponentsConnection: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.value ?? '',
                                            label: edge.label ?? '',
                                            value: edge.value ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $06940e99c7931c18$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'components'
    });
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PGpn.ComponentsReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            baseSearchUrl: baseSearchUrl,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover,
            formatComponentJql: formatComponentJql
        }), [
        data,
        baseSearchUrl,
        isTruncated,
        isTruncatedWithHoverPopover,
        formatComponentJql
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    (values, actionMeta)=>{
        const mutableOptions = values?.map((i)=>({
                label: i.label,
                value: i.value || ''
            })) || null;
        handleChange(mutableOptions);
    }, [
        handleChange
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleOnChange,
            fetchSuggestionsOnMount: true,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $9B2fw.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $06940e99c7931c18$export$bbb45a0e0da9bd53 = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $8Uumt.useFragment)((0, $6pkht.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06940e99c7931c18$export$32ccb5f0cb497709, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("6pkht", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a9c524353c39373$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d752273960d62c97543fd5c98cc9b483>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5a9c524353c39373$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraComponentsField"
};
$5a9c524353c39373$var$node.hash = "616223369097ff7023289b730e24e390";
var $5a9c524353c39373$export$2e2bcd8739ae039 = $5a9c524353c39373$var$node;

});

parcelRegister("fvFRE", function(module, exports) {

$parcel$export(module.exports, "default", () => $64cf67d1a4efa9b5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a287f8603250d4bcfa340f08a133c0c>>
 * @relayHash 7fdc4a8b53b49ddfa954865ceb36f19e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 37d268d7e189244c2485e7f63d82c6610aa4201a00aec643ec30383b07b411b3
const $64cf67d1a4efa9b5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "components_issueFieldComponents_ComponentsField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraComponentsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateComponentsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraComponentsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "components_issueFieldComponents_ComponentsField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraComponentsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateComponentsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraComponentsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraComponentConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedComponentsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraComponentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraComponent",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": "value",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "37d268d7e189244c2485e7f63d82c6610aa4201a00aec643ec30383b07b411b3",
            "metadata": {},
            "name": "components_issueFieldComponents_ComponentsField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$64cf67d1a4efa9b5$var$node.hash = "55d6de75b11bbe1bea570947ba244198";
var $64cf67d1a4efa9b5$export$2e2bcd8739ae039 = $64cf67d1a4efa9b5$var$node;

});

parcelRegister("btBMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $298b7144db1ff512$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<176cf950f3063d94accb5a37ad63e7ce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $298b7144db1ff512$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "components_issueFieldComponentsReadviewFull_ComponentsReadView"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "value",
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "alias": "label",
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            "action": "THROW",
            "path": "selectedComponentsConnection"
        }
    ],
    "type": "JiraComponentsField"
};
$298b7144db1ff512$var$node.hash = "7d58e8d795b9134c31920723b434efe7";
var $298b7144db1ff512$export$2e2bcd8739ae039 = $298b7144db1ff512$var$node;

});

parcelRegister("9B2fw", function(module, exports) {

$parcel$export(module.exports, "default", () => $87dc86f30447ca76$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $87dc86f30447ca76$var$ComponentsEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("jsLfq")), {
        moduleId: "09bac631"
    }),
    getPreloadProps: ()=>({})
});
var $87dc86f30447ca76$export$2e2bcd8739ae039 = $87dc86f30447ca76$var$ComponentsEditViewEntryPoint;

});
parcelRegister("jsLfq", function(module, exports) {

let $e2b548444a397b20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e2b548444a397b20$var$load("7ZZSU").then(()=>parcelRequire('dIr09'));

});


parcelRegister("6PGpn", function(module, exports) {

$parcel$export(module.exports, "ComponentsReadView", () => $fa77465098c2ad76$export$1841519927c4fa28);

var $3jchu = parcelRequire("3jchu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $9laXL = parcelRequire("9laXL");

var $koVbs = parcelRequire("koVbs");

var $eZibI = parcelRequire("eZibI");

var $2bYmU = parcelRequire("2bYmU");

var $l8IoT = parcelRequire("l8IoT");

var $cIy4l = parcelRequire("cIy4l");

var $4R6GH = parcelRequire("4R6GH");

var $eC8Vs = parcelRequire("eC8Vs");
const $fa77465098c2ad76$export$b1992ee206a63570 = (value, baseSearchUrl = '/issues/')=>{
    const jqlEncodedValue = encodeURIComponent(`components = ${(0, $cIy4l.toQuotedString)(value)}`);
    return `${baseSearchUrl}?jql=${jqlEncodedValue}`;
};
const $fa77465098c2ad76$export$e2150facc9f107aa = (componentName)=>`component = ${(0, $cIy4l.toQuotedString)(componentName)}`;
const $fa77465098c2ad76$export$12458b8497b0a890 = (componentJql, baseSearchUrl = '/issues/')=>`${baseSearchUrl}?jql=${encodeURIComponent(componentJql)}`;
const $fa77465098c2ad76$export$1841519927c4fa28 = ({ baseSearchUrl: baseSearchUrl, fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover, formatComponentJql: formatComponentJql = $fa77465098c2ad76$export$e2150facc9f107aa })=>{
    const data = (0, $8Uumt.useFragment)((0, $3jchu.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectedComponents = data?.selectedComponentsConnection?.edges?.filter((edge)=>Boolean(edge?.node?.label)).map((item)=>{
        let href;
        if ((0, $4R6GH.fg)('jsc_inline_editing_component_jql_fix')) href = item?.node?.label ? $fa77465098c2ad76$export$12458b8497b0a890(formatComponentJql(item?.node?.label), baseSearchUrl) : undefined;
        else href = item?.node?.label ? $fa77465098c2ad76$export$b1992ee206a63570(item?.node?.label, baseSearchUrl) : undefined;
        return {
            name: item?.node?.label || '',
            key: item?.node?.value || '',
            href: href
        };
    }) || [];
    if (!selectedComponents?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.050",
        xcss: isTruncatedWithHoverPopover && $fa77465098c2ad76$var$widthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bYmU.default), {
        items: selectedComponents,
        ItemComponent: (0, $l8IoT.TagItem),
        PopupContentWrapper: (0, $l8IoT.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $eC8Vs.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $fa77465098c2ad76$var$containerWithNegativeMarginOffset
    }, selectedComponents.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9laXL.default), {
            key: item.key,
            isRemovable: false,
            text: item.name,
            href: item.href
        })));
};
const $fa77465098c2ad76$var$containerWithNegativeMarginOffset = (0, $8CUq3.xcss)({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    // Tag has a built-in margin of 4px, so we use a negative side margin to allow tags to align with their parent.
    marginTop: 'space.0',
    marginRight: 'space.negative.050',
    marginBottom: 'space.0',
    marginLeft: 'space.negative.050'
});
const $fa77465098c2ad76$var$widthStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});
parcelRegister("3jchu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6ecedd58faedb99$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<309f4d62bd850a58613b75bc1e5b17ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f6ecedd58faedb99$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_issueFieldComponentsReadviewFull_ComponentsReadView",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "value",
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "alias": "label",
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            "action": "THROW",
            "path": "selectedComponentsConnection"
        }
    ],
    "type": "JiraComponentsField"
};
$f6ecedd58faedb99$var$node.hash = "35b9643b76a914d7422dfb3f74901db8";
var $f6ecedd58faedb99$export$2e2bcd8739ae039 = $f6ecedd58faedb99$var$node;

});

parcelRegister("9laXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d63a49f20b6f0a05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c543i = parcelRequire("c543i");

var $5JjdN = parcelRequire("5JjdN");

var $eGmKJ = parcelRequire("eGmKJ");

var $35XSW = parcelRequire("35XSW");
var $lM16U = parcelRequire("lM16U");

var $VSDnB = parcelRequire("VSDnB");

var $2hnSR = parcelRequire("2hnSR");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");

var $frUcV = parcelRequire("frUcV");
const $d63a49f20b6f0a05$var$textLinkCssVar = '--ds-ctl';
const $d63a49f20b6f0a05$var$textDefaultCssVar = '--ds-ct';
const $d63a49f20b6f0a05$var$textActiveCssVar = '--ds-ctp';
const $d63a49f20b6f0a05$var$backgroundHoverCssVar = '--ds-cbh';
const $d63a49f20b6f0a05$var$backgroundActiveCssVar = '--ds-cba';
var $d63a49f20b6f0a05$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($d63a49f20b6f0a05$var$TagStatus || {});
const $d63a49f20b6f0a05$var$packageName = "platform-pkg";
const $d63a49f20b6f0a05$var$packageVersion = "0.0.0-use.local";
const $d63a49f20b6f0a05$var$defaultBeforeRemoveAction = ()=>true; /**
                                               * These hide the focus ring for the tag when its remove button is focused,
                                               * preventing a double focus ring.
                                               */ 
const $d63a49f20b6f0a05$var$removingStyles = null;
const $d63a49f20b6f0a05$var$RemovableTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $d63a49f20b6f0a05$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $eGmKJ.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $5uXOq.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $5uXOq.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $c543i.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $d63a49f20b6f0a05$var$packageName,
            packageVersion: $d63a49f20b6f0a05$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $5uXOq.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $5uXOq.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $5uXOq.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $5uXOq.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $5uXOq.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $5uXOq.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $frUcV.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle, #00000000)" : undefined,
        // Tag background color on hover
        [$d63a49f20b6f0a05$var$backgroundHoverCssVar]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalHoverBackgroundColors),
        // Tag background color on press
        [$d63a49f20b6f0a05$var$backgroundActiveCssVar]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalActiveBackgroundColors),
        // The tag text on hover of remove button
        [$d63a49f20b6f0a05$var$textDefaultCssVar]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalTextColors),
        // 'elemBefore' text on press of remove button
        [$d63a49f20b6f0a05$var$textActiveCssVar]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalTextColors),
        // The tag link text on hover of remove button
        [$d63a49f20b6f0a05$var$textLinkCssVar]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalTextColors)
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lM16U.default), {
            children: (motion)=>{
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5oSQr.default), {
                    ref: (0, $5JjdN.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aXLIT.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, $bwpsq.default)([
                        status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqht1nip"
                    ])
                });
            }
        })
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $d63a49f20b6f0a05$var$RemovableTag = /*#__PURE__*/ (0, $5uXOq.memo)($d63a49f20b6f0a05$var$RemovableTagComponent);
var $d63a49f20b6f0a05$export$2e2bcd8739ae039 = $d63a49f20b6f0a05$var$RemovableTag;

});
parcelRegister("lM16U", function(module, exports) {

$parcel$export(module.exports, "default", () => $c624c149830103aa$export$2e2bcd8739ae039);

var $lObw7 = parcelRequire("lObw7");

var $bh8Xz = parcelRequire("bh8Xz");

var $3GP8X = parcelRequire("3GP8X");

var $fsENI = parcelRequire("fsENI");

var $35XSW = parcelRequire("35XSW");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $c624c149830103aa$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $3GP8X.useElementRef)();
    const exiting = (0, $35XSW.useExitingPersistence)();
    const requestAnimationFrame = (0, $bh8Xz.useRequestAnimationFrame)();
    const setTimeout = (0, $bh8Xz.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $fsENI.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $lObw7.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $lObw7.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $c624c149830103aa$export$2e2bcd8739ae039 = $c624c149830103aa$var$ShrinkOut;

});
parcelRegister("3GP8X", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $19cc13cbd0e78f53$export$ff879f35a69d56b7);

var $5uXOq = parcelRequire("5uXOq");
const $19cc13cbd0e78f53$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $5uXOq.useRef)(null);
    const setRef = (0, $5uXOq.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("frUcV", function(module, exports) {

$parcel$export(module.exports, "default", () => $625906158e0f3c21$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $3Lty3 = parcelRequire("3Lty3");
const $625906158e0f3c21$var$removeButtonStyles = {
    root: "_19itglyw _2rkogqwt _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _1bsb7vkz _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syaz1fxt _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah31i6y _irr3166n _1di61dty"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $625906158e0f3c21$var$removeButtonStylesOld = {
    root: "_19itglyw _2rko1l5z _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _ahbqze3t _12l2ze3t _1pfhze3t _6rthze3t _kqswstnw _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syaz1bah _80omtlke _lcxv1wug _1ah3ze3t _30l31eu2"
};
const $625906158e0f3c21$var$removeButtonStylesOldIcon = {
    root: "_rjxpze3t"
};
const $625906158e0f3c21$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
const $625906158e0f3c21$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        xcss: (0, $3JT92.cx)(// TODO: When cleaning up all these feature gates, they should just be converged into a single `styles` object.
        (0, $VSDnB.fg)('platform-component-visual-refresh') && $625906158e0f3c21$var$removeButtonStyles.root, !(0, $VSDnB.fg)('platform-component-visual-refresh') && $625906158e0f3c21$var$removeButtonStylesOld.root, $625906158e0f3c21$var$removeButtonStylesOldIcon.root, (0, $VSDnB.fg)('platform-visual-refresh-icons') && $625906158e0f3c21$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "small"
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$625906158e0f3c21$export$2e2bcd8739ae039 = $625906158e0f3c21$var$RemoveButton;

});


parcelRegister("cIy4l", function(module, exports) {

$parcel$export(module.exports, "toQuotedString", () => $ae91325110cc96a6$export$dbeab020a4aa404);
$parcel$export(module.exports, "createIssuesUrl", () => $ae91325110cc96a6$export$c623a4b2d8c439ab);
const $ae91325110cc96a6$var$ENCODE_MAP = {
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '"': '\\"',
    "'": "\\'",
    '\\': '\\\\'
};
const $ae91325110cc96a6$export$946fe289c25510be = (character, ignoredCharacter)=>{
    if (character === ignoredCharacter) return character;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
    return $ae91325110cc96a6$var$ENCODE_MAP[character] || character;
};
const $ae91325110cc96a6$export$dbeab020a4aa404 = (parameter)=>{
    let escaped = '';
    for(let position = 0; position < parameter.length; position += 1)escaped += $ae91325110cc96a6$export$946fe289c25510be(parameter[position], "'");
    return `"${escaped}"`;
};
const $ae91325110cc96a6$export$c623a4b2d8c439ab = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;

});

parcelRegister("eC8Vs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4879a2ee32d6df1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e4879a2ee32d6df1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-components-readview-full.components.truncated.show-more-tooltip",
        "defaultMessage": "See more items"
    }
});

});



parcelRegister("imEz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6e6f9b13ed82579$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d6e6f9b13ed82579$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.components.trigger-button",
        "defaultMessage": "See more components"
    }
});

});


parcelRegister("fiheM", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectCell", () => $378a100b5b861c28$export$4f505fdc26f544f5);

var $iWTla = parcelRequire("iWTla");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $52q83 = parcelRequire("52q83");

var $e9M6d = parcelRequire("e9M6d");

var $Br57E = parcelRequire("Br57E");

var $jFYC8 = parcelRequire("jFYC8");
const $378a100b5b861c28$export$4f505fdc26f544f5 = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $iWTla.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const shouldRenderHoverPopover = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $52q83.CascadingSelectInlineEditViewIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupTarget: $378a100b5b861c28$var$CustomTarget,
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        readViewFitContainerHeight: true,
        menuPosition: "fixed",
        isTruncated: true,
        shouldRenderHoverPopover: shouldRenderHoverPopover && !isReadOnlyWithoutHoverPopover
    });
};
const $378a100b5b861c28$var$CustomTarget = /*#__PURE__*/ (0, $5uXOq.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $378a100b5b861c28$var$customTargetStyles,
        ref: ref
    });
});
const $378a100b5b861c28$var$customTargetStyles = (0, $8CUq3.xcss)({
    width: '0',
    position: 'absolute',
    top: 'space.0'
});

});
parcelRegister("iWTla", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fb130f026e3cdc9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a170f6032ed9d52606dab07b6826eca7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7fb130f026e3cdc9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "cascadingSelect_nativeIssueTable_CascadingSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraCascadingSelectField"
};
$7fb130f026e3cdc9$var$node.hash = "c0952c4997585ebce9f9a5e25b71750e";
var $7fb130f026e3cdc9$export$2e2bcd8739ae039 = $7fb130f026e3cdc9$var$node;

});

parcelRegister("52q83", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectInlineEditViewIsEditable", () => $45b9d3f67587609d$export$d3164c915fdde2ef);
$parcel$export(module.exports, "CascadingSelectInlineEditView", () => $45b9d3f67587609d$export$c72b86275efea41a);

var $kSwPL = parcelRequire("kSwPL");

var $jGDXG = parcelRequire("jGDXG");

var $8AxSE = parcelRequire("8AxSE");

var $iJcNv = parcelRequire("iJcNv");

var $efQiU = parcelRequire("efQiU");

var $hkFNW = parcelRequire("hkFNW");

var $ekSUz = parcelRequire("ekSUz");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $qfj8c = parcelRequire("qfj8c");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zxCp = parcelRequire("8zxCp");

var $b6bFZ = parcelRequire("b6bFZ");

var $lXLX3 = parcelRequire("lXLX3");

var $es3zY = parcelRequire("es3zY");

var $cYlTx = parcelRequire("cYlTx");

var $jrRyX = parcelRequire("jrRyX");

var $gGpyR = parcelRequire("gGpyR");

var $adLrP = parcelRequire("adLrP");

var $4x0ty = parcelRequire("4x0ty");

var $7F8HM = parcelRequire("7F8HM");

var $iv6X1 = parcelRequire("iv6X1");

var $g0MwR = parcelRequire("g0MwR");
const $45b9d3f67587609d$var$isCascadingOptionExist = (value)=>value !== undefined; /** Check if the new selected value is equal to the old value */ 
const $45b9d3f67587609d$var$isEqualSelection = (a, b)=>a?.parentOptionValue?.value === b?.parentOptionValue?.value && a?.childOptionValue?.value === b?.childOptionValue?.value;
const $45b9d3f67587609d$var$EditViewWrapper = ({ children: children })=>{
    // This needs to be fixed by DST: go/DSP-22083
    // Dropdown z-index is 1, action bar is 200
    // Bento fixes this by wrapping dropdown into a new 300 stack context
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $45b9d3f67587609d$var$wrapperStyles
    }, children);
}; /**
    * Inline edit will handle the switching behaviour between the 'readView' and 'editView' components.
    *
    * @param props [CascadingSelectInlineEditViewProps](./types.tsx)
    */ 
const $45b9d3f67587609d$export$d3164c915fdde2ef = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, readViewFitContainerHeight: readViewFitContainerHeight, hideActionButtons: hideActionButtons = false, menuPosition: menuPosition, fragmentRef: fragmentRef, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, spacing: spacing = 'default', isTruncated: isTruncated = false, isEditable: isEditable = false, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)(); // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $ekSUz.default), fragmentRef);
    const [commit] = (0, $8Uumt.useMutation)((0, $hkFNW.default));
    const { id: uniqueFieldId, cascadingOption: cascadingOption, name: name, fieldId: fieldId, type: fieldType } = data; // #endregion
    // #region State
    const initialValue = (0, $5uXOq.useMemo)(()=>({
            parentOptionValue: cascadingOption?.parentOptionValue ? {
                id: cascadingOption?.parentOptionValue?.id ?? '',
                value: cascadingOption?.parentOptionValue?.value ?? '',
                isDisabled: cascadingOption?.parentOptionValue?.isDisabled
            } : null,
            childOptionValue: cascadingOption?.childOptionValue ? {
                id: cascadingOption?.childOptionValue?.id ?? '',
                value: cascadingOption?.childOptionValue?.value ?? '',
                isDisabled: cascadingOption?.childOptionValue?.isDisabled
            } : null
        }), [
        cascadingOption?.childOptionValue,
        cascadingOption?.parentOptionValue
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $5uXOq.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]); // #endregion
    // #region Action
    const handleSubmit = (0, $5uXOq.useCallback)((newOption, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newOption); // note: If these objects happen to include more than what is expected, Relay will complain.
        const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = newOption || {};
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        parentOption: parentOptionValue?.id || null,
                        childOption: childOptionValue?.id || null
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateCascadingSelectField?.success) onSuccess();
                else onFail();
            },
            onError: (error)=>onFail(error, error.message),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            optimisticResponse: {
                jira: {
                    updateCascadingSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            cascadingOption: newOption
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const actions = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        isValueEqual: $45b9d3f67587609d$var$isEqualSelection,
        clipboardComponentType: 'cascadingSelect'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChange: handleChange, invalidMessage: invalidMessage, isEditing: isEditing } = actions; // #endregion Action
    // #region View
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $es3zY.CascadingSelectReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        }), [
        data,
        isTruncated,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            wrapper: $45b9d3f67587609d$var$EditViewWrapper,
            fieldId: uniqueFieldId,
            autoFocus: true,
            parentOptionValue: updatedValue?.parentOptionValue,
            childOptionValue: updatedValue?.childOptionValue,
            menuPosition: menuPosition,
            onChange: handleChange,
            spacing: spacing,
            ...isExperimentEnabled && {
                value: !updatedValue || !updatedValue.parentOptionValue?.id ? null : updatedValue
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $b6bFZ.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: hideActionButtons,
        hasReadViewTruncateDisabled: shouldRenderHoverPopover
    }); // #endregion Action
};
const $45b9d3f67587609d$export$61f585e318ddf3af = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $efQiU.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($45b9d3f67587609d$export$d3164c915fdde2ef, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
}; /**
    * Inline edit will handle the switching behaviour between the 'readView' and 'editView' components.
    *
    * @param props [CascadingSelectInlineEditViewProps](./types.tsx)
    */ 
const $45b9d3f67587609d$export$a010415846add744 = ({ fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, readViewFitContainerWidth: readViewFitContainerWidth = true, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, spacing: spacing = 'default' })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $iJcNv.default), fragmentRef);
    const { id: uniqueFieldId, name: fieldName, fieldConfig: fieldConfig } = data;
    const cascadingOption = (0, $5uXOq.useMemo)(()=>({
            parentOptionValue: data.cascadingOption?.parentOptionValue ? {
                id: data.cascadingOption?.parentOptionValue?.id ?? '',
                value: data.cascadingOption?.parentOptionValue?.value ?? '',
                isDisabled: data.cascadingOption?.parentOptionValue?.isDisabled
            } : null,
            childOptionValue: data.cascadingOption?.childOptionValue ? {
                id: data.cascadingOption?.childOptionValue?.id ?? '',
                value: data.cascadingOption?.childOptionValue?.value ?? '',
                isDisabled: data.cascadingOption?.childOptionValue?.isDisabled
            } : null
        }), [
        data.cascadingOption?.childOptionValue,
        data.cascadingOption?.parentOptionValue
    ]);
    const [commit] = (0, $8Uumt.useMutation)((0, $8AxSE.default)); // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const [isEditing, setIsEditing] = (0, $adLrP.useOptionallyControlledEditingState)(startWithEditViewOpen, uniqueFieldId);
    const [newValue, setNewValue] = (0, $5uXOq.useState)(cascadingOption);
    const [errors, setErrors] = (0, $5uXOq.useState)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isEditable = fieldConfig?.isEditable || false;
    const isFieldEditable = overriding.overrideIsEditable(isEditable); // #endregion
    // #region Handle new value
    (0, $5uXOq.useEffect)(()=>{
        if ($45b9d3f67587609d$var$isCascadingOptionExist(cascadingOption)) setNewValue(cascadingOption);
    }, [
        cascadingOption
    ]);
    const onCancelRequest = (0, $5uXOq.useCallback)(()=>{
        setErrors(null);
        setIsEditing(false); // clear the user's state so it reflects the last server state
        setNewValue({
            parentOptionValue: cascadingOption?.parentOptionValue ?? null,
            childOptionValue: cascadingOption?.childOptionValue ?? null
        });
    }, [
        cascadingOption?.childOptionValue,
        cascadingOption?.parentOptionValue,
        setIsEditing
    ]);
    const onEditRequest = (0, $5uXOq.useCallback)(()=>{
        setErrors(null);
        setIsEditing(true);
    }, [
        setIsEditing
    ]);
    const onCommitError = (0, $5uXOq.useCallback)((responseErrors)=>{
        setErrors(responseErrors);
        setIsEditing(true);
        onSubmitFailed?.();
    }, [
        onSubmitFailed,
        setIsEditing
    ]);
    const onCommitCompleted = (0, $5uXOq.useCallback)((response, newOption)=>{
        if (!response.jira?.updateCascadingSelectField) {
            onCommitError([]);
            return;
        }
        const { success: success, errors: responseErrors } = response.jira.updateCascadingSelectField;
        if (!success) {
            onCommitError(responseErrors);
            return;
        }
        setNewValue(newOption ?? null);
        onSubmitSucceeded?.(newOption);
    }, [
        onSubmitSucceeded,
        onCommitError
    ]);
    const handleNewValue = (0, $5uXOq.useCallback)((newOption)=>{
        // Clear errors and exit editing mode
        setErrors(null);
        setIsEditing(false); // note: If these objects happen to include more than what is expected, Relay will complain.
        const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = newOption || {};
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        parentOption: parentOptionValue?.id || null,
                        childOption: childOptionValue?.id || null
                    }
                }
            },
            onCompleted (res) {
                onCommitCompleted(res, newOption);
            },
            onError (error) {
                onCommitError([
                    error
                ]);
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            optimisticResponse: {
                jira: {
                    updateCascadingSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            cascadingOption: {
                                parentOptionValue: parentOptionValue,
                                childOptionValue: childOptionValue
                            },
                            fieldConfig: {
                                isEditable: true
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldName,
        onCommitCompleted,
        onCommitError,
        setIsEditing,
        uniqueFieldId
    ]); // #endregion
    // #region Common callbacks
    const onConfirmRequest = (0, $5uXOq.useCallback)(()=>{
        handleNewValue(newValue);
        onSubmit?.(newValue);
    }, [
        newValue,
        handleNewValue,
        onSubmit
    ]); // #endregion
    // #region Read view
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($45b9d3f67587609d$var$ReadViewContainer, {
            "data-testid": "issue-field-cascading-select-inline-edit-full.ui.cascading-select.read-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $es3zY.CascadingSelectReadView), {
            fragmentRef: data
        })), [
        data
    ]); // #endregion
    // #region Edit view
    const renderEditView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, errors && errors.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, errors[0].message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($45b9d3f67587609d$var$EditViewContainer, {
            "data-testid": "issue-field-cascading-select-inline-edit-full.ui.cascading-select.edit-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zxCp.CascadingSelectEditView), {
            autoFocus: true,
            fieldId: uniqueFieldId,
            ariaLabel: fieldName,
            parentOptionValue: newValue?.parentOptionValue,
            childOptionValue: newValue?.childOptionValue,
            onChange: setNewValue,
            spacing: spacing
        }))), [
        errors,
        fieldName,
        newValue?.childOptionValue,
        newValue?.parentOptionValue,
        spacing,
        uniqueFieldId
    ]); // #endregion
    const [, prefetchOptions, abortPrefetchOptions] = (0, $4x0ty.useQueryLoaderOnIntent)((0, $jGDXG.default));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($45b9d3f67587609d$var$InlineEditContainer, {
        isEditable: isFieldEditable,
        onPointerEnter: ()=>prefetchOptions((0, $8zxCp.getCascadingSelectEditViewSuggestionsVariables)({
                id: uniqueFieldId,
                selectedParentId: newValue?.parentOptionValue?.id,
                queryString: '',
                filterParentOptionsById: null,
                filterChildOptionsById: null,
                first: (0, $cYlTx.FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST)
            })),
        onPointerLeave: (e)=>e.pointerType === 'mouse' && abortPrefetchOptions()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gGpyR.FieldInlineEditStateLess), {
        editView: renderEditView,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        isLabelHidden: true,
        label: fieldName,
        readView: renderReadView,
        readViewFitContainerWidth: readViewFitContainerWidth,
        testId: "issue-field-cascading-select-inline-edit-full.ui.cascading-select.field-inline-edit-state-less",
        fieldId: (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? uniqueFieldId : undefined,
        hideActionButtons: false,
        cancelButtonLabel: formatMessage((0, $g0MwR.default).cancelButtonLabel, {
            fieldName: fieldName
        }),
        confirmButtonLabel: formatMessage((0, $g0MwR.default).confirmButtonLabel, {
            fieldName: fieldName
        }),
        editButtonLabel: formatMessage((0, $g0MwR.default).editButtonLabel, {
            fieldName: fieldName
        }),
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequest
    }));
};
const $45b9d3f67587609d$export$c72b86275efea41a = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $kSwPL.default), fragmentRef);
    if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($45b9d3f67587609d$export$61f585e318ddf3af, {
        ...props,
        fragmentRef: data
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($45b9d3f67587609d$export$a010415846add744, {
        ...props,
        fragmentRef: data
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45b9d3f67587609d$var$EditViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbyowjs _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45b9d3f67587609d$var$ReadViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _1nmz1hna _kqswh2mm _vwz4gktf",
            __cmplp.className
        ])
    });
});
const $45b9d3f67587609d$var$nonEditableStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45b9d3f67587609d$var$InlineEditContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _19pkx0bf _18u0x0bf _1gzc1txw _auuz1h6o _6vgs1osq _1rjezwfg _osjgidpf _alyvidpf _pa3x12x7 _2g9b12x7",
            !__cmplp.isEditable && "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _1nmz1hna _kqswh2mm _vwz4gktf _19bv12x7",
            __cmplp.className
        ])
    });
});
const $45b9d3f67587609d$var$wrapperStyles = (0, $8CUq3.xcss)({
    zIndex: 'modal',
    position: 'relative'
});

});
parcelRegister("kSwPL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5429da1a00e7636$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4927cfd579260e6c6befc74834b7eb74>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e5429da1a00e7636$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewNew_fragmentRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewOld_fragmentRef"
        }
    ],
    "type": "JiraCascadingSelectField"
};
$e5429da1a00e7636$var$node.hash = "b309285458f0ab8d823f851bf8dce495";
var $e5429da1a00e7636$export$2e2bcd8739ae039 = $e5429da1a00e7636$var$node;

});

parcelRegister("jGDXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e544f0787eb1c7c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<84e3f24e5b158506253748cb82c9036b>>
 * @relayHash 7881910e51a829d77ee52c81fed56f55
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 32369970bb9fcc9b3b84ccefcf25e7559cb4fc2c03b05a059baa4b375dbc8738
const $8e544f0787eb1c7c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "childOptionsFilterById"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSelectedParentIdSet"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchBy"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "selectedParentIdFilter"
    }, v7 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v8 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v9 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v10 = {
        "kind": "Variable",
        "name": "searchBy",
        "variableName": "searchBy"
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = [
        v7 /*: any*/ ,
        v8 /*: any*/ ,
        v10 /*: any*/ 
    ], v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = {
        "kind": "ScalarField",
        "name": "value"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isDisabled"
    }, v16 = {
        "args": [
            {
                "kind": "Variable",
                "name": "filterById",
                "variableName": "childOptionsFilterById"
            }
        ],
        "concreteType": "JiraOptionConnection",
        "kind": "LinkedField",
        "name": "childOptions",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "cascadingSelect_issueFieldCascadingSelect_PrefetchQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "childOptionsFilterById",
                            "variableName": "childOptionsFilterById"
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "isSelectedParentIdSet",
                            "variableName": "isSelectedParentIdSet"
                        },
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "selectedParentIdFilter",
                            "variableName": "selectedParentIdFilter"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "cascadingSelect_issueFieldCascadingSelect_PrefetchQuery",
            "selections": [
                {
                    "args": [
                        v9 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraParentOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "parentOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraParentOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraParentOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v12 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "cascadingSelect_issueFieldCascadingSelectEditviewFull_parentOptions",
                                    "kind": "LinkedHandle",
                                    "name": "parentOptions"
                                },
                                {
                                    "condition": "isSelectedParentIdSet",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "selectedParentOptions",
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "filterById",
                                                    "variableName": "selectedParentIdFilter"
                                                }
                                            ],
                                            "concreteType": "JiraParentOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "parentOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraParentOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraParentOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v16 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraCascadingSelectField"
                        },
                        v13 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "32369970bb9fcc9b3b84ccefcf25e7559cb4fc2c03b05a059baa4b375dbc8738",
            "metadata": {},
            "name": "cascadingSelect_issueFieldCascadingSelect_PrefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8e544f0787eb1c7c$var$node.hash = "d6b5aeb02fb02f4bd87412a0a561fb87";
var $8e544f0787eb1c7c$export$2e2bcd8739ae039 = $8e544f0787eb1c7c$var$node;

});

parcelRegister("8AxSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $754b2361eafd7304$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8fc054c14d6bddea696dededf37d80ed>>
 * @relayHash f4c7db359db24a283c738bcd80ff62d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0881cf501af0bbe13bb67be56841a880890dc42b5d656d4e5b524a7a8606f76f
const $754b2361eafd7304$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewOld_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "concreteType": "JiraCascadingOption",
                                            "kind": "LinkedField",
                                            "name": "cascadingOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "parentOptionValue",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "childOptionValue",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0881cf501af0bbe13bb67be56841a880890dc42b5d656d4e5b524a7a8606f76f",
            "metadata": {},
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$754b2361eafd7304$var$node.hash = "d2aa8009e389257d3576f281dee876bf";
var $754b2361eafd7304$export$2e2bcd8739ae039 = $754b2361eafd7304$var$node;

});

parcelRegister("iJcNv", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f3e522377bf687$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<05ff16598aaed1a371df86cb608e27a5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $43f3e522377bf687$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewOld_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "FragmentSpread",
                "name": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView"
            },
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
}();
$43f3e522377bf687$var$node.hash = "5bb28472de24371a143da3ea82f76473";
var $43f3e522377bf687$export$2e2bcd8739ae039 = $43f3e522377bf687$var$node;

});

parcelRegister("efQiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $25c76a8dd4727f62$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30e7bff7501ed85c1ada0a9e7a961b83>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $25c76a8dd4727f62$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewNew_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraCascadingSelectField"
};
$25c76a8dd4727f62$var$node.hash = "e7ecd450fd47d2261ef09c2802d1bf69";
var $25c76a8dd4727f62$export$2e2bcd8739ae039 = $25c76a8dd4727f62$var$node;

});

parcelRegister("hkFNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6c424046c2b6a83$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5af5a0e1aadbd43170434c736b972392>>
 * @relayHash 7d22f5050c538c3158a691b3e905083c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 997d0833657ad9a1d712284af57a44a81eafd9d35f375dda9a2e4f7adbfc26e9
const $a6c424046c2b6a83$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraCascadingOption",
                                            "kind": "LinkedField",
                                            "name": "cascadingOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "parentOptionValue",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "childOptionValue",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "997d0833657ad9a1d712284af57a44a81eafd9d35f375dda9a2e4f7adbfc26e9",
            "metadata": {},
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a6c424046c2b6a83$var$node.hash = "792c8e7af6ed535746e17a76dc52564b";
var $a6c424046c2b6a83$export$2e2bcd8739ae039 = $a6c424046c2b6a83$var$node;

});

parcelRegister("ekSUz", function(module, exports) {

$parcel$export(module.exports, "default", () => $703aac2f74f59865$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ae6d5401514d5954c10b2c3baa89186>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $703aac2f74f59865$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView"
            },
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
}();
$703aac2f74f59865$var$node.hash = "afadb43a696a96b327cd8181443d429b";
var $703aac2f74f59865$export$2e2bcd8739ae039 = $703aac2f74f59865$var$node;

});

parcelRegister("8zxCp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getCascadingSelectEditViewSuggestionsVariables", () => $a1c11e11f5d9fb02$export$31c772f673cde49);
$parcel$export(module.exports, "CascadingSelectEditViewWithFieldOptionsFragment", () => $a1c11e11f5d9fb02$export$bd936cd33aa90610);
$parcel$export(module.exports, "CascadingSelectEditView", () => $a1c11e11f5d9fb02$export$dcf968b265cd57c5);
$parcel$export(module.exports, "default", () => $a1c11e11f5d9fb02$export$2e2bcd8739ae039);

var $hOkD8 = parcelRequire("hOkD8");

var $1JKdV = parcelRequire("1JKdV");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5JAlL = parcelRequire("5JAlL");
var $7K5PP = parcelRequire("7K5PP");

var $koVbs = parcelRequire("koVbs");

var $cYlTx = parcelRequire("cYlTx");

var $1othz = parcelRequire("1othz");

var $jDrwg = parcelRequire("jDrwg");

var $cuIZp = parcelRequire("cuIZp");

var $4R6GH = parcelRequire("4R6GH");

var $9T3OL = parcelRequire("9T3OL");
const $a1c11e11f5d9fb02$var$aggToAtlaskitOption = (item)=>item ? {
        label: item.value || '',
        value: item.id,
        isDisabled: Boolean(item.isDisabled)
    } : null;
const $a1c11e11f5d9fb02$var$atlaskitOptionToAgg = (item)=>item ? {
        value: item.label,
        id: String(item.value),
        isDisabled: Boolean(item.isDisabled)
    } : null;
const $a1c11e11f5d9fb02$var$filterOption = (0, $5JAlL.createFilter)({
    stringify: (option)=>option.label
});
const $a1c11e11f5d9fb02$export$31c772f673cde49 = ({ id: id, selectedParentId: selectedParentId, first: first, queryString: queryString, filterParentOptionsById: filterParentOptionsById, filterChildOptionsById: filterChildOptionsById })=>({
        id: id,
        first: first,
        selectedParentIdFilter: {
            optionIds: [
                selectedParentId || ''
            ],
            operation: 'ALLOW'
        },
        isSelectedParentIdSet: !!selectedParentId,
        searchBy: queryString || '',
        filterById: filterParentOptionsById || null,
        childOptionsFilterById: filterChildOptionsById || null
    }); /**
     * CascadingSelectEditViewWithFieldOptionsFragment is a version of the edit view that allows
     * the passing of a fragment for experiences like GIC that might want to group fetch data on mount
     * instead of having a separate network request for it
     *
     * @param props [CascadingSelectEditViewWithFieldOptionsFragmentProps](./types.tsx)
     */ 
const $a1c11e11f5d9fb02$export$bd936cd33aa90610 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ autoFocus: autoFocus = true, areOptionsOnSameRow: areOptionsOnSameRow = false, fieldId: fieldId, fieldOptionsFragmentRef: fieldOptionsFragmentRef, onChange: onChange, parentOptionValue: parentOptionValue, childOptionValue: childOptionValue, filterParentOptionsById: filterParentOptionsById = null, filterChildOptionsById: filterChildOptionsById = null, isDisabled: isDisabled = false, isInvalid: isInvalid = false, fetchSuggestionsOnMount: fetchSuggestionsOnMount = false, spacing: spacing = 'default', menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, ariaLabel: ariaLabel = 'Cascading Select', ariaLabelledBy: ariaLabelledBy = '', wrapper: Wrapper }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const loadingMessage = (0, $5uXOq.useCallback)(()=>formatMessage((0, $9T3OL.default).loading), [
        formatMessage
    ]);
    const noOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage((0, $9T3OL.default).empty), [
        formatMessage
    ]);
    const placeholderMessage = (0, $5uXOq.useMemo)(()=>formatMessage((0, $9T3OL.default).noOptionsSelected), [
        formatMessage
    ]);
    const childRef = (0, $5uXOq.useRef)(null); /** Whether the end-user interacted with the parent selector or not.
                                  * The child selector should never be auto-focussed on the first render.
                                  * However, if the parent option is changed and child options are available, that's fine.
                                  */ 
    const [userChosenParentOption, setUserChosenParentOption] = (0, $5uXOq.useState)(null);
    const [searchByString, setSearchByString] = (0, $5uXOq.useState)('');
    const firstUpdate = (0, $5uXOq.useRef)(true); // #region Relay
    // suggestions fragment with pagination and refetch
    const { data: fieldOptionsSearchData, refetch: refetchSuggestions, loadNext: loadNext, hasNext: hasNext, isLoadingNext: isLoadingNext } = (0, $8Uumt.usePaginationFragment)((0, $1JKdV.default), fieldOptionsFragmentRef);
    const { parentOptions: parentOptions, selectedParentOptions: selectedParentOptions } = fieldOptionsSearchData.node || {};
    const { edges: fieldOptionsData } = parentOptions || {};
    const selectedParentData = selectedParentOptions?.edges?.[0]?.node; // #endregion
    // #region Debounced suspensless refetch helpers
    const [searchSuspenselessRefetch, isLoading, lastFetchError] = (0, $1othz.useSuspenselessRefetch)((0, $cuIZp.default), refetchSuggestions);
    const [debouncedSuggestionsRefetcher] = (0, $jDrwg.default)(searchSuspenselessRefetch, (0, $cYlTx.SEARCH_DEBOUNCE_TIMEOUT));
    const [searchLeadingEdgeSuspenselessRefetch] = (0, $jDrwg.default)(searchSuspenselessRefetch, (0, $cYlTx.SEARCH_DEBOUNCE_TIMEOUT), {
        leading: true
    }); // #endregion
    // #region Common callbacks for the selector
    const onFocusParent = (0, $5uXOq.useCallback)(()=>{
        searchLeadingEdgeSuspenselessRefetch($a1c11e11f5d9fb02$export$31c772f673cde49({
            id: fieldId,
            selectedParentId: parentOptionValue?.id,
            queryString: searchByString,
            filterParentOptionsById: filterParentOptionsById,
            filterChildOptionsById: filterChildOptionsById,
            first: (0, $cYlTx.FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST)
        }));
    }, [
        fieldId,
        filterChildOptionsById,
        filterParentOptionsById,
        parentOptionValue?.id,
        searchByString,
        searchLeadingEdgeSuspenselessRefetch
    ]);
    const onSearchByStringChangeFunction = (0, $5uXOq.useCallback)((newSearchByString)=>{
        setSearchByString(newSearchByString);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        debouncedSuggestionsRefetcher($a1c11e11f5d9fb02$export$31c772f673cde49({
            id: fieldId,
            selectedParentId: parentOptionValue?.id,
            queryString: searchByString,
            filterParentOptionsById: filterParentOptionsById,
            filterChildOptionsById: filterChildOptionsById,
            first: (0, $cYlTx.FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST)
        }));
    }, [
        debouncedSuggestionsRefetcher,
        fieldId,
        filterChildOptionsById,
        filterParentOptionsById,
        parentOptionValue?.id,
        searchByString,
        searchLeadingEdgeSuspenselessRefetch
    ]);
    const onMenuScrollToBottom = ()=>{
        if (hasNext) loadNext((0, $cYlTx.SELECTABLE_FIELD_PAGE_OPTIONS));
    };
    const onChangeChild = (0, $5uXOq.useCallback)((selectedChildOption)=>{
        const newValue = {
            parentOptionValue: parentOptionValue ?? null,
            childOptionValue: $a1c11e11f5d9fb02$var$atlaskitOptionToAgg(selectedChildOption)
        };
        onChange && onChange(newValue);
    }, [
        onChange,
        parentOptionValue
    ]);
    const onChangeParent = (0, $5uXOq.useCallback)((selectedParentOption)=>{
        const newValue = {
            parentOptionValue: $a1c11e11f5d9fb02$var$atlaskitOptionToAgg(selectedParentOption),
            childOptionValue: null
        }; // Manage whether the child selector should be focussed.
        // @ts-expect-error Atlaskit's select does not have a typed `focus` prototype member, though it exists in practice.
        childRef && childRef.current && childRef.current.focus(); // once a user has selected a parent, it's fine to auto-focus the child when it disappeared then re-appeared.
        setUserChosenParentOption(newValue.parentOptionValue?.id || null);
        onChange && onChange(newValue);
    }, [
        onChange
    ]); // #endregion
    // #region Transform options data from relay to AK Select
    const defaultFailedOption = (0, $5uXOq.useMemo)(()=>({
            label: formatMessage((0, $9T3OL.default).failedFetch),
            value: '',
            isDisabled: true
        }), [
        formatMessage
    ]);
    const withErrorOption = (0, $5uXOq.useCallback)((options)=>{
        const arr = options || [];
        if (lastFetchError) arr.push(defaultFailedOption);
        return arr;
    }, [
        lastFetchError,
        defaultFailedOption
    ]);
    const cascadingOptionResults = (0, $5uXOq.useMemo)(()=>fieldOptionsData?.map((edge)=>edge?.node).filter(Boolean) ?? [], [
        fieldOptionsData
    ]); // Add selected parent data and child options to the main options
    // This serves two purposes:
    // 1. Always ensures that the selected parent option is an option in the drop down (i.e. if it's out of the first 100 fetched options)
    // 2. Ensures, that after search of parent options and selecting the option, the child options data remain available in the cashe
    //    For example, when you search for Option101 (that is outside of the first 100 options fetched), the data for Option101 will be fetched
    //    But, upon selection, the search is cleared which resets the fetch to first 100 options, and the 101st option would be removed from cascadingOptionResults,
    //    That means the child options for the selected Option101 are gone and child option can not be selected.
    (0, $5uXOq.useMemo)(()=>{
        if (selectedParentData?.id && cascadingOptionResults.findIndex((parentOption)=>selectedParentData?.id === parentOption?.id) === -1) cascadingOptionResults.push({
            id: selectedParentData.id ?? '',
            value: selectedParentData.value ?? undefined,
            isDisabled: selectedParentData.isDisabled ?? undefined,
            childOptions: selectedParentData.childOptions ?? undefined
        });
    }, [
        cascadingOptionResults,
        selectedParentData?.childOptions,
        selectedParentData?.id,
        selectedParentData?.isDisabled,
        selectedParentData?.value
    ]); // Extract list of allowed parent values. It's just the full list of what we've found for now.
    const parentOptionResults = (0, $5uXOq.useMemo)(()=>withErrorOption(cascadingOptionResults.map((result)=>$a1c11e11f5d9fb02$var$aggToAtlaskitOption(result)).filter(Boolean)), [
        withErrorOption,
        cascadingOptionResults
    ]); // Extract list of allowed child values. Only do so if a parent value exists and has a valid optionId, otherwise
    // there's no way we could select a child option.
    const childOptionResults = (0, $5uXOq.useMemo)(()=>withErrorOption(parentOptionValue?.id && cascadingOptionResults.find((result)=>parentOptionValue.id === result?.id)?.childOptions?.edges?.map((edge)=>$a1c11e11f5d9fb02$var$aggToAtlaskitOption(edge?.node)).filter(Boolean) || []), [
        withErrorOption,
        cascadingOptionResults,
        parentOptionValue
    ]); // #endregion
    // #region state control between parent and child UI components
    const showChildOptionSelector = (0, $5uXOq.useMemo)(()=>parentOptionValue?.value && (childOptionValue?.value || childOptionResults.length > 0), [
        childOptionResults.length,
        childOptionValue?.value,
        parentOptionValue?.value
    ]); // #endregion
    (0, $5uXOq.useEffect)(()=>{
        if (fetchSuggestionsOnMount) searchLeadingEdgeSuspenselessRefetch($a1c11e11f5d9fb02$export$31c772f673cde49({
            id: fieldId,
            selectedParentId: parentOptionValue?.id,
            queryString: searchByString,
            filterParentOptionsById: filterParentOptionsById,
            filterChildOptionsById: filterChildOptionsById,
            first: (0, $cYlTx.FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST)
        }));
    }, [
        fieldId,
        searchLeadingEdgeSuspenselessRefetch,
        fetchSuggestionsOnMount,
        filterChildOptionsById,
        filterParentOptionsById,
        parentOptionValue?.id,
        searchByString
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1c11e11f5d9fb02$var$Container, {
        areOptionsOnSameRow: areOptionsOnSameRow,
        "data-testid": "issue-field-cascading-select-editview-full.ui.cascading-select.container",
        ref: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? ref : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        ...(0, $4R6GH.fg)('cascading_select_edit_field_no_blur_on_select') ? {
            blurInputOnSelect: false
        } : {},
        openMenuOnFocus: true,
        closeMenuOnSelect: true,
        isClearable: true,
        isLoading: isLoading || isLoadingNext,
        loadingMessage: loadingMessage,
        noOptionsMessage: noOptionsMessage,
        options: parentOptionResults,
        onInputChange: onSearchByStringChangeFunction,
        onMenuScrollToBottom: onMenuScrollToBottom,
        filterOption: $a1c11e11f5d9fb02$var$filterOption,
        value: $a1c11e11f5d9fb02$var$aggToAtlaskitOption(parentOptionValue),
        placeholder: formatMessage((0, $9T3OL.default).noOptionsSelected),
        onChange: onChangeParent,
        onFocus: onFocusParent,
        spacing: spacing,
        menuPosition: menuPosition,
        menuPortalTarget: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? menuPortalTarget : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    }), showChildOptionSelector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        ...(0, $4R6GH.fg)('cascading_select_edit_field_no_blur_on_select') ? {
            blurInputOnSelect: false
        } : {},
        ref: childRef,
        autoFocus: !!userChosenParentOption,
        openMenuOnFocus: true,
        closeMenuOnSelect: true,
        isClearable: true,
        isLoading: isLoading || isLoadingNext,
        loadingMessage: loadingMessage,
        noOptionsMessage: noOptionsMessage,
        options: childOptionResults,
        filterOption: $a1c11e11f5d9fb02$var$filterOption,
        value: $a1c11e11f5d9fb02$var$aggToAtlaskitOption(childOptionValue),
        placeholder: placeholderMessage,
        onChange: onChangeChild,
        spacing: spacing,
        menuPosition: menuPosition,
        menuPortalTarget: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? menuPortalTarget : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    }));
    if (Wrapper != null && (0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, content);
    return content;
});
const $a1c11e11f5d9fb02$export$dcf968b265cd57c5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const suggestionsData = (0, $8Uumt.useLazyLoadQuery)((0, $hOkD8.default), $a1c11e11f5d9fb02$export$31c772f673cde49({
        id: props.fieldId,
        selectedParentId: props.parentOptionValue?.id,
        queryString: '',
        filterParentOptionsById: null,
        filterChildOptionsById: null,
        first: (0, $cYlTx.FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST)
    }), {
        fetchPolicy: 'store-only'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1c11e11f5d9fb02$export$bd936cd33aa90610, {
        ...props,
        ref: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? ref : undefined,
        fieldOptionsFragmentRef: suggestionsData
    });
});
const $a1c11e11f5d9fb02$var$CascadingSelectEditViewEntryPoint = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1c11e11f5d9fb02$export$dcf968b265cd57c5, props);
var $a1c11e11f5d9fb02$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a1c11e11f5d9fb02$var$CascadingSelectEditViewEntryPoint;
const $a1c11e11f5d9fb02$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { areOptionsOnSameRow: areOptionsOnSameRow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _osiyidpf _12apkb7n",
            __cmplp.areOptionsOnSameRow ? "_2lx2vrvc" : "_2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hOkD8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbe4817b7fd512a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a2de74fca5929f174d19e6bfd15def54>>
 * @relayHash 3b95b5271696095cc201498de4795a65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fc32d13891b5313c58de44fd31a04121b4bdee1858f6b5caddd10cdd7a6d1426
const $bbe4817b7fd512a9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSelectedParentIdSet"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "selectedParentIdFilter"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "value"
    }, v8 = {
        "kind": "ScalarField",
        "name": "isDisabled"
    }, v9 = {
        "concreteType": "JiraOptionConnection",
        "kind": "LinkedField",
        "name": "childOptions",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v6 /*: any*/ ,
                            v7 /*: any*/ ,
                            v8 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "cascadingSelect_cascadingSelectSearchQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "isSelectedParentIdSet",
                            "variableName": "isSelectedParentIdSet"
                        },
                        {
                            "kind": "Variable",
                            "name": "selectedParentIdFilter",
                            "variableName": "selectedParentIdFilter"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "cascadingSelect_cascadingSelectSearchQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraParentOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "parentOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraParentOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraParentOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "parentOptions(first:50,searchBy:\"\")"
                                },
                                {
                                    "args": v5 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "cascadingSelect_issueFieldCascadingSelectEditviewFull_parentOptions",
                                    "kind": "LinkedHandle",
                                    "name": "parentOptions"
                                },
                                {
                                    "condition": "isSelectedParentIdSet",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "selectedParentOptions",
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "filterById",
                                                    "variableName": "selectedParentIdFilter"
                                                }
                                            ],
                                            "concreteType": "JiraParentOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "parentOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraParentOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraParentOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraCascadingSelectField"
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "fc32d13891b5313c58de44fd31a04121b4bdee1858f6b5caddd10cdd7a6d1426",
            "metadata": {},
            "name": "cascadingSelect_cascadingSelectSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bbe4817b7fd512a9$var$node.hash = "54b471f864071ab7d141ec6c1c7ce09c";
var $bbe4817b7fd512a9$export$2e2bcd8739ae039 = $bbe4817b7fd512a9$var$node;

});

parcelRegister("1JKdV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecc362369ccca936$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a5859f2e8aff0abc870aef405a820df7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $cuIZp = parcelRequire("cuIZp");
const $ecc362369ccca936$var$node = function() {
    var v0 = [
        "node",
        "parentOptions"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "value"
    }, v3 = {
        "kind": "ScalarField",
        "name": "isDisabled"
    }, v4 = {
        "args": [
            {
                "kind": "Variable",
                "name": "filterById",
                "variableName": "childOptionsFilterById"
            }
        ],
        "concreteType": "JiraOptionConnection",
        "kind": "LinkedField",
        "name": "childOptions",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "childOptionsFilterById"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filterById"
            },
            {
                "defaultValue": 50,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "id"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isSelectedParentIdSet"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "searchBy"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "selectedParentIdFilter"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $cuIZp.default)
            }
        },
        "name": "cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "id"
                    }
                ],
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": "parentOptions",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterById",
                                        "variableName": "filterById"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "searchBy",
                                        "variableName": "searchBy"
                                    }
                                ],
                                "concreteType": "JiraParentOptionConnection",
                                "kind": "LinkedField",
                                "name": "__cascadingSelect_issueFieldCascadingSelectEditviewFull_parentOptions_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraParentOptionEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraParentOption",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    v2 /*: any*/ ,
                                                    v3 /*: any*/ ,
                                                    v4 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "isSelectedParentIdSet",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "selectedParentOptions",
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "filterById",
                                                "variableName": "selectedParentIdFilter"
                                            }
                                        ],
                                        "concreteType": "JiraParentOptionConnection",
                                        "kind": "LinkedField",
                                        "name": "parentOptions",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraParentOptionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraParentOption",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v1 /*: any*/ ,
                                                            v2 /*: any*/ ,
                                                            v3 /*: any*/ ,
                                                            v4 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraCascadingSelectField"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$ecc362369ccca936$var$node.hash = "ebe1d9e6c6846d6dbd53863d27c091d5";
var $ecc362369ccca936$export$2e2bcd8739ae039 = $ecc362369ccca936$var$node;

});
parcelRegister("cuIZp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed53e87ee824ca5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<690874b6a9fca2395123b6a71188adc2>>
 * @relayHash e7a4a99cb82001356da65cbddf7e914e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 944c95479d0d443af0aedbd81e0ca0b65e312b8c27c70afedf578f251ebaca13
const $3ed53e87ee824ca5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "childOptionsFilterById"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        },
        {
            "defaultValue": 50,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSelectedParentIdSet"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "searchBy"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "selectedParentIdFilter"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v5 = {
        "kind": "Variable",
        "name": "searchBy",
        "variableName": "searchBy"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "value"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isDisabled"
    }, v11 = {
        "args": [
            {
                "kind": "Variable",
                "name": "filterById",
                "variableName": "childOptionsFilterById"
            }
        ],
        "concreteType": "JiraOptionConnection",
        "kind": "LinkedField",
        "name": "childOptions",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v8 /*: any*/ ,
                            v9 /*: any*/ ,
                            v10 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cascadingSelect_cascadingSelectSearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "childOptionsFilterById",
                            "variableName": "childOptionsFilterById"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "isSelectedParentIdSet",
                            "variableName": "isSelectedParentIdSet"
                        },
                        v5 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "selectedParentIdFilter",
                            "variableName": "selectedParentIdFilter"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cascadingSelect_cascadingSelectSearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraParentOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "parentOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraParentOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraParentOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "cascadingSelect_issueFieldCascadingSelectEditviewFull_parentOptions",
                                    "kind": "LinkedHandle",
                                    "name": "parentOptions"
                                },
                                {
                                    "condition": "isSelectedParentIdSet",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "selectedParentOptions",
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "filterById",
                                                    "variableName": "selectedParentIdFilter"
                                                }
                                            ],
                                            "concreteType": "JiraParentOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "parentOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraParentOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraParentOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                v11 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraCascadingSelectField"
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "944c95479d0d443af0aedbd81e0ca0b65e312b8c27c70afedf578f251ebaca13",
            "metadata": {},
            "name": "cascadingSelect_cascadingSelectSearchRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3ed53e87ee824ca5$var$node.hash = "ebe1d9e6c6846d6dbd53863d27c091d5";
var $3ed53e87ee824ca5$export$2e2bcd8739ae039 = $3ed53e87ee824ca5$var$node;

});


parcelRegister("9T3OL", function(module, exports) {

$parcel$export(module.exports, "default", () => $43b28e6650f47fe2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $43b28e6650f47fe2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    empty: {
        "id": "issue-field-cascading-select-editview-full.cascading-select.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-cascading-select-editview-full.cascading-select.failed-fetch",
        "defaultMessage": "Search failed."
    },
    loading: {
        "id": "issue-field-cascading-select-editview-full.cascading-select.loading",
        "defaultMessage": "Searching..."
    },
    noOptionsSelected: {
        "id": "issue-field-cascading-select-editview-full.cascading-select.no-options-selected",
        "defaultMessage": "None"
    },
    queryError: {
        "id": "issue-field-cascading-select-editview-full.cascading-select.query-error",
        "defaultMessage": "Search failed."
    }
});

});


parcelRegister("b6bFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd77d51937f2e027$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $dd77d51937f2e027$var$CascadingEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("8zxCp"))), {
        moduleId: "d23a4651"
    }),
    getPreloadProps: ()=>({})
});
var $dd77d51937f2e027$export$2e2bcd8739ae039 = $dd77d51937f2e027$var$CascadingEditViewEntryPoint;

});

parcelRegister("es3zY", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectReadView", () => $3e93a7f41fb3ca8b$export$4b0478fdeeb1c69);

var $jcWyB = parcelRequire("jcWyB");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eZibI = parcelRequire("eZibI");

var $4R6GH = parcelRequire("4R6GH");

var $dpHMc = parcelRequire("dpHMc");

var $7mPT9 = parcelRequire("7mPT9");

var $6xt8h = parcelRequire("6xt8h");
const $3e93a7f41fb3ca8b$var$getFieldValueAsText = (cascadingOption)=>{
    if (!cascadingOption || !cascadingOption?.parentOptionValue) return null;
    if (!cascadingOption?.childOptionValue) return cascadingOption.parentOptionValue.value;
    return `${cascadingOption.parentOptionValue.value} - ${cascadingOption.childOptionValue.value}`;
};
const $3e93a7f41fb3ca8b$export$4b0478fdeeb1c69 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated = false, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { cascadingOption: cascadingOption } = (0, $8Uumt.useFragment)((0, $jcWyB.default), fragmentRef);
    const fieldValueAsText = $3e93a7f41fb3ca8b$var$getFieldValueAsText(cascadingOption);
    const contentRef = (0, $5uXOq.useRef)(null);
    if (!fieldValueAsText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    if (isTruncated && (0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
        if (shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
            content: fieldValueAsText,
            contentRef: contentRef
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6xt8h.CascadingSelectOptionTruncated), {
                value: fieldValueAsText,
                ref: (0, $7mPT9.default)(ref, contentRef)
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6xt8h.CascadingSelectOptionTruncated), {
            value: fieldValueAsText
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fieldValueAsText);
};

});
parcelRegister("jcWyB", function(module, exports) {

$parcel$export(module.exports, "default", () => $260c5bd6ac6907fc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e3e7eaf85051bb2d23ffb70d08f4080d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $260c5bd6ac6907fc$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView",
        "selections": [
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
}();
$260c5bd6ac6907fc$var$node.hash = "3327b7b284e2098b00737ec46c5db99a";
var $260c5bd6ac6907fc$export$2e2bcd8739ae039 = $260c5bd6ac6907fc$var$node;

});

parcelRegister("6xt8h", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectOptionTruncated", () => $445c646ff06370f8$export$8691872cfdb45f29);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $445c646ff06370f8$export$8691872cfdb45f29 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ value: value }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $445c646ff06370f8$var$cascadingValueStylesTruncated,
        ref: ref
    }, value);
});
const $445c646ff06370f8$var$cascadingValueStylesTruncated = (0, $8CUq3.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    width: '100%'
});

});


parcelRegister("gGpyR", function(module, exports) {

$parcel$export(module.exports, "FieldInlineEditStateLess", () => $cca53fa1018295ba$export$9a29c614a3f4aae1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bopR4 = parcelRequire("bopR4");

var $kMSay = parcelRequire("kMSay");

var $i0vxP = parcelRequire("i0vxP");

var $4R6GH = parcelRequire("4R6GH");

var $ctrpc = parcelRequire("ctrpc");

var $2gCtH = parcelRequire("2gCtH");

var $iv6X1 = parcelRequire("iv6X1");

var $54wEF = parcelRequire("54wEF");

var $69oHP = parcelRequire("69oHP");

var $cIZbf = parcelRequire("cIZbf");

var $2OMDV = parcelRequire("2OMDV");
var $2NMNM = parcelRequire("2NMNM");

var $Fn2Vl = parcelRequire("Fn2Vl");
const $cca53fa1018295ba$export$5af7124b5599afd0 = (0, $2OMDV.AnalyticsEventToProps)('EnterEscapeHandler', {
    onEnter: 'entered',
    onEscape: 'escaped'
})((0, $i0vxP.default));
const $cca53fa1018295ba$export$41b20ce1a1b4f6f1 = (0, $2OMDV.AnalyticsEventToProps)('EscapeHandler', {
    onEscape: 'escaped'
})((0, $i0vxP.default));
const $cca53fa1018295ba$export$bfbc426ae4e1403d = (0, $2OMDV.AnalyticsEventToProps)('EnterHandler', {
    onEnter: 'entered'
})((0, $i0vxP.default));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cca53fa1018295ba$var$FieldContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12jb1r31 _1gjeglyw _qrzw1o36",
            __cmplp.className
        ])
    });
});
const $cca53fa1018295ba$var$NonEditableMargin = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s81uch",
            __cmplp.className
        ])
    });
});
const $cca53fa1018295ba$var$useCallbackWithAnalyticsEvent = (callback, payload)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)(()=>{
        if (typeof callback === 'function') callback(createAnalyticsEvent(payload));
    }, [
        callback,
        createAnalyticsEvent,
        payload
    ]);
};
const $cca53fa1018295ba$var$useCallbackWithAnalyticsEventForEdit = (callback, payload)=>{
    const { fieldId: fieldId, fieldType: fieldTypeFromProps, isInlineEditing: isInlineEditing = false } = payload;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const pressTrace = (0, $kMSay.default)('issue.field.inline-edit');
    const fieldIdWithoutAri = (0, $cIZbf.getFieldIdFromAri)(fieldId);
    const [fieldConfig] = (0, $54wEF.useFieldConfig)(issueKey || '', fieldIdWithoutAri || '');
    const fieldType = fieldTypeFromProps || (0, $69oHP.getFieldType)(fieldConfig?.value);
    return (0, $5uXOq.useCallback)(()=>{
        (0, $4R6GH.fg)('jiv-20205-more-ufo-tracing') && pressTrace();
        if (fieldIdWithoutAri && fieldType) {
            const event = createAnalyticsEvent({});
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart(fieldIdWithoutAri, {
                analytics: event,
                attributes: {
                    fieldType: fieldType,
                    isInlineEditing: isInlineEditing
                }
            });
        }
        if (typeof callback === 'function') callback(createAnalyticsEvent(payload));
    }, [
        callback,
        createAnalyticsEvent,
        fieldIdWithoutAri,
        fieldType,
        payload,
        isInlineEditing,
        pressTrace
    ]);
};
function $cca53fa1018295ba$var$FieldInlineEditStateLessInner(props) {
    const { actionSubject: actionSubject = 'fieldInlineEdit', editView: editView, isEditable: isEditable = false, isEditing: isEditing = false, isLabelHidden: isLabelHidden = true, readView: readView, testId: testId, fieldId: fieldId, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, onEditRequested: onEditRequested, onEnter: onEnter, onEscape: onEscape } = props;
    const [isMouseOver, setIsMouseOver] = (0, $5uXOq.useState)(false);
    const { isVisibleOnHover: isVisibleOnHover } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    const handleEnter = $cca53fa1018295ba$var$useCallbackWithAnalyticsEvent(onEnter, {
        action: 'entered',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleEscape = $cca53fa1018295ba$var$useCallbackWithAnalyticsEvent(onEscape, {
        action: 'escaped',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleEdit = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $cca53fa1018295ba$var$useCallbackWithAnalyticsEventForEdit(onEditRequested || onEdit, {
        action: 'focused',
        actionSubject: actionSubject,
        fieldId: fieldId,
        ...props.componentAnalyticsData
    }) // eslint-disable-next-line react-hooks/rules-of-hooks
     : $cca53fa1018295ba$var$useCallbackWithAnalyticsEvent(onEditRequested || onEdit, {
        action: 'focused',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleCancel = $cca53fa1018295ba$var$useCallbackWithAnalyticsEvent(onCancel, {
        action: 'canceled',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleConfirm = (0, $5uXOq.useCallback)((_, event)=>{
        if (typeof onConfirm === 'function') onConfirm(event.update({
            action: 'confirmed',
            actionSubject: actionSubject,
            ...props.componentAnalyticsData
        }));
    }, [
        actionSubject,
        onConfirm,
        props.componentAnalyticsData
    ]);
    const renderReadView = typeof readView === 'function' ? readView : ()=>readView;
    const renderEditView = (0, $5uXOq.useMemo)(()=>{
        if (typeof editView === 'function') return editView;
        return ()=>editView;
    }, [
        editView
    ]);
    const renderEditViewWithHandlers = (0, $5uXOq.useCallback)((editProps, ref)=>{
        if (editView === null) return null;
        if (onEnter && onEscape) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cca53fa1018295ba$export$5af7124b5599afd0, {
            onEnter: handleEnter,
            onEscape: handleEscape
        }, renderEditView(editProps, ref));
        if (onEnter) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cca53fa1018295ba$export$bfbc426ae4e1403d, {
            onEnter: handleEnter
        }, renderEditView(editProps, ref));
        if (onEscape) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cca53fa1018295ba$export$41b20ce1a1b4f6f1, {
            onEscape: handleEscape
        }, renderEditView(editProps, ref));
        return renderEditView(editProps, ref);
    }, [
        editView,
        onEnter,
        onEscape,
        handleEnter,
        handleEscape,
        renderEditView
    ]);
    const inlineEditProps = {
        defaultValue: 'defaultValue' in props ? props.defaultValue : props.value,
        onConfirm: handleConfirm,
        readView: ()=>!isVisibleOnHover || props.value || props.defaultValue || isMouseOver ? renderReadView() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, $bwpsq.default)([
                    "_3um015vq"
                ])
            }, renderReadView()),
        editView: renderEditViewWithHandlers,
        isEditing: isEditing,
        onCancel: handleCancel,
        onEdit: handleEdit,
        isRequired: props.isRequired,
        analyticsContext: props.analyticsContext,
        cancelButtonLabel: props.cancelButtonLabel,
        confirmButtonLabel: props.confirmButtonLabel,
        editButtonLabel: props.editButtonLabel,
        hideActionButtons: 'hideActionButtons' in props ? props.hideActionButtons : props.areActionButtonsHidden,
        keepEditViewOpenOnBlur: 'keepEditViewOpenOnBlur' in props ? props.keepEditViewOpenOnBlur : props.isConfirmOnBlurDisabled,
        label: isLabelHidden === true ? undefined : props.label,
        readViewFitContainerWidth: 'readViewFitContainerWidth' in props ? props.readViewFitContainerWidth : props.isFitContainerWidthReadView,
        startWithEditViewOpen: props.startWithEditViewOpen,
        validate: props.validate
    };
    return isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cca53fa1018295ba$var$FieldContainer, {
        "data-testid": testId != null ? `${testId}--container` : undefined,
        onFocus: ()=>setIsMouseOver(true),
        onBlur: ()=>setIsMouseOver(false),
        onMouseEnter: ()=>setIsMouseOver(true),
        onMouseLeave: ()=>setIsMouseOver(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), inlineEditProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cca53fa1018295ba$var$NonEditableMargin, {
        "data-component-selector": (0, $Fn2Vl.readOnlyViewContainerSelectorName),
        "data-testid": testId != null ? `${testId}--read-only-container` : undefined
    }, renderReadView());
}
const $cca53fa1018295ba$var$readViewHiddenUntilHoverStyle = null;
const $cca53fa1018295ba$export$9a29c614a3f4aae1 = /*#__PURE__*/ (0, $5uXOq.memo)($cca53fa1018295ba$var$FieldInlineEditStateLessInner);
var $cca53fa1018295ba$export$2e2bcd8739ae039 = $cca53fa1018295ba$export$9a29c614a3f4aae1;

});
parcelRegister("bopR4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb3572edb783a8f$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $7O4UO = parcelRequire("7O4UO");

var $efXp3 = parcelRequire("efXp3");

var $VSDnB = parcelRequire("VSDnB");

var $3Lty3 = parcelRequire("3Lty3");

var $jldZL = parcelRequire("jldZL");

var $1PDuf = parcelRequire("1PDuf");

var $pZGLJ = parcelRequire("pZGLJ");

var $6LLMl = parcelRequire("6LLMl");
const $9fb3572edb783a8f$var$fieldStyles = null;
const $9fb3572edb783a8f$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $9fb3572edb783a8f$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
    const timerRef = (0, $5uXOq.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $pZGLJ.default)(isEditing, isEditingState);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$9fb3572edb783a8f$var$analyticsAttributes
    });
    const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6LLMl.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $efXp3.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $2OMIu.jsx)("form", {
                /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                // This is because due to some default focus being applied to the form element, the inline edit component
                // was being focused automatically and causing scroll issues in issue view
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $VSDnB.fg)('platform_design_system_inline_edit_dont_focus') ? 'dont-default-focus' : undefined,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $bwpsq.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PDuf.default), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view" // used for reset to default value
                ) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view" // used for reset to default value
                )
            })
    });
};
const $9fb3572edb783a8f$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9fb3572edb783a8f$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9fb3572edb783a8f$export$2e2bcd8739ae039 = $9fb3572edb783a8f$var$InlineEdit;

});
parcelRegister("1PDuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d92d54fb10d87e$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $i28qQ = parcelRequire("i28qQ");

var $ky7e4 = parcelRequire("ky7e4");

var $lLLkM = parcelRequire("lLLkM");
const $55d92d54fb10d87e$var$buttonsContainerStyles = null;
const $55d92d54fb10d87e$var$buttonWrapperBaseStyles = null;
const $55d92d54fb10d87e$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lLLkM))),
                            size: "small"
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$55d92d54fb10d87e$export$2e2bcd8739ae039 = $55d92d54fb10d87e$var$Buttons;

});

parcelRegister("pZGLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5aa752dd00081f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $d5aa752dd00081f6$var$usePrevious = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $d5aa752dd00081f6$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $5uXOq.useRef)(null);
    const editViewRef = (0, $5uXOq.useRef)();
    const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $d5aa752dd00081f6$var$usePrevious(shouldBeEditing);
    (0, $5uXOq.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $d5aa752dd00081f6$export$2e2bcd8739ae039 = $d5aa752dd00081f6$var$useButtonFocusHook;

});

parcelRegister("6LLMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba9adf9a6463766$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3Lty3 = parcelRequire("3Lty3");
const $1ba9adf9a6463766$var$readViewContainerStyles = null;
const $1ba9adf9a6463766$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189e1grb _1dqoglyw _1h6d3acm _1e0c1ule _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14ly1bk5 _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $1ba9adf9a6463766$var$readViewWrapperStyles = null;
const $1ba9adf9a6463766$var$readViewFitContainerWidthStyles = null;
const $1ba9adf9a6463766$var$DRAG_THRESHOLD = 5;
const $1ba9adf9a6463766$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startY = (0, $5uXOq.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                xcss: $1ba9adf9a6463766$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _v564thzt _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
                    readViewFitContainerWidth && "_1bsb1osq"
                ]),
                children: readView()
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1ba9adf9a6463766$export$2e2bcd8739ae039 = $1ba9adf9a6463766$var$ReadView;

});


parcelRegister("iv6X1", function(module, exports) {

$parcel$export(module.exports, "useBespokeEmptyFieldTextExperiment", () => $79e1a209ff1442cd$export$5a7b1bb3c8ba459f);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $2gCtH = parcelRequire("2gCtH");

var $93Yeu = parcelRequire("93Yeu");

var $2vSU6 = parcelRequire("2vSU6");
const $79e1a209ff1442cd$var$useIsExperimentEligible = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    /* Some URL patterns where Issue view is rendered either in a modal or full page or in a sidebar
	The common pattern is presence of issue key in the URL pathname or search params
	1. /browse/TEST-1
	2. /issues/TEST-1
	3. /jira/software/c/projects/TEST/issues/TEST-1
	4. /jira/software/c/projects/TEST/boards/1?selectedIssue=TEST-1
	5. /jira/software/c/projects/TEST/boards/1/backlog?selectedIssue=TEST-1
	6. /jira/software/c/projects/TEST/list?selectedIssue=TEST-1
	*/ const ISSUE_KEY_REGEX = /[A-Z][A-Z0-9]+-\d+/;
    let isFieldRenderedInIssueView = false;
    try {
        isFieldRenderedInIssueView = // eslint-disable-next-line no-restricted-globals
        ISSUE_KEY_REGEX.test(location.search) || ISSUE_KEY_REGEX.test(location.pathname);
    } catch (error) {
        // If regex test fails for some reason, default to false
        isFieldRenderedInIssueView = false;
    }
    return projectType === (0, $2vSU6.SOFTWARE_PROJECT) && isFieldRenderedInIssueView && (0, $4R6GH.fg)('bespoke_empty_field_text_gate');
};
const $79e1a209ff1442cd$export$5a7b1bb3c8ba459f = ()=>{
    const isExperimentEligible = $79e1a209ff1442cd$var$useIsExperimentEligible();
    const isVisibleAlways = isExperimentEligible && (0, $6s1PB.expValEquals)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'always', 'never');
    const isVisibleOnHover = isExperimentEligible && (0, $6s1PB.expValEquals)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'hover', 'never');
    return {
        isExperimentEnabled: isVisibleAlways || isVisibleOnHover,
        isVisibleAlways: isVisibleAlways,
        isVisibleOnHover: isVisibleOnHover
    };
};

});

parcelRegister("54wEF", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $a5085d8f4019d625$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $a5085d8f4019d625$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $a5085d8f4019d625$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $a5085d8f4019d625$export$28a22fd0dedf31b7);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $iZIvy = parcelRequire("iZIvy");

var $eDXka = parcelRequire("eDXka");

var $gXz4p = parcelRequire("gXz4p");

var $biQrn = parcelRequire("biQrn");

var $2N3tQ = parcelRequire("2N3tQ");
const $a5085d8f4019d625$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION,
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: 'Issue View Field Configuration Query',
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
    (0, $gXz4p.sendExperienceAnalytics)($a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error?.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $jJZqs.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {}
    }));
};
const $a5085d8f4019d625$var$fetchData = async (issueKey)=>{
    try {
        const response = await (0, $eusud.performPostRequest)((0, $iZIvy.getGraphQlUrl)('', (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response?.data?.issue?.fields) {
            const fieldConfigData = response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
            (result, field)=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...result,
                    [field.key]: {
                        autoCompleteUrl: field.autoCompleteUrl,
                        allowedValues: field.allowedValues,
                        isEditable: field.editable,
                        isRequired: field.required,
                        schema: field.schema,
                        title: field.title,
                        ...field.description ? {
                            description: field.description
                        } : {}
                    }
                }), {});
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: true
            });
            return fieldConfigData;
        }
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: new Error('Unexpected field configuration response')
        });
        return null;
    } catch (error) {
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: error instanceof (0, $jJZqs.default) ? error : undefined
        });
        return null;
    }
};
const $a5085d8f4019d625$var$requestSet = new Set();
const $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $a5085d8f4019d625$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $biQrn.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $5uXOq.useState)(()=>!skipRefresh && value === undefined && !$a5085d8f4019d625$var$requestSet.has(issueKey));
    const getData = (0, $5uXOq.useCallback)(async ()=>{
        setLoading(true);
        $a5085d8f4019d625$var$requestSet.add(issueKey);
        const result = await $a5085d8f4019d625$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $a5085d8f4019d625$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const shouldGetData = (0, $4R6GH.fg)('jiv-19312-fix-fieldconfigurationquery-refetch') ? !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined && issueKey !== '' : !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $2N3tQ.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $2N3tQ.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $2N3tQ.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $a5085d8f4019d625$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("iZIvy", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $ef2130f553e5234b$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $ef2130f553e5234b$export$f2fec0cacdfabaaf);

var $96nmc = parcelRequire("96nmc");

var $chLKn = parcelRequire("chLKn");

const $ef2130f553e5234b$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
const $ef2130f553e5234b$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $chLKn.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("96nmc", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $8119dcf59ebfcad5$export$69694c3add0f6058);
const $8119dcf59ebfcad5$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("chLKn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7dcb170a6dfaf0$export$2e2bcd8739ae039);
const $2c7dcb170a6dfaf0$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $2c7dcb170a6dfaf0$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $2c7dcb170a6dfaf0$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $2c7dcb170a6dfaf0$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$2c7dcb170a6dfaf0$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2c7dcb170a6dfaf0$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2c7dcb170a6dfaf0$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery()}
            ${$2c7dcb170a6dfaf0$var$getAgileQuery()}
        }
        ${$2c7dcb170a6dfaf0$var$getProjectQuery(projectKey)}
    }`;

});


parcelRegister("eDXka", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $9f0f96bc04f1e77a$export$b38f30d67f730bc4);
const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("gXz4p", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $b28eb6b892a8c2f7$export$4a95ada1b8228562);

var $1UikQ = parcelRequire("1UikQ");

var $gSA3s = parcelRequire("gSA3s");

var $hh0bW = parcelRequire("hh0bW");

var $j8DrX = parcelRequire("j8DrX");

var $4R6GH = parcelRequire("4R6GH");
const $b28eb6b892a8c2f7$var$isSynthetic = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
const $b28eb6b892a8c2f7$var$shouldAddConnectivityAttribute = (experienceDescription)=>{
    // Return false if feature flag is off
    if (!(0, $4R6GH.fg)('thor_refine_taskfail_offline_failed_events')) return false;
    // Return false if not a taskFail action
    if (experienceDescription.wasExperienceSuccesful) return false;
    const isKnownExperience = [
        'transitionIssue',
        'getTransitions',
        'startWatching',
        'stopWatching'
    ].includes(experienceDescription.experience);
    // Return false if not a known experience
    if (!isKnownExperience) return false;
    const hasStatusCode = !!experienceDescription.additionalAttributes?.statusCode;
    // Return false if status code is present
    return !hasStatusCode;
};
function $b28eb6b892a8c2f7$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    const shard = (0, $j8DrX.default)('ajs-shard');
    const region = (0, $j8DrX.default)('ajs-region');
    Object.assign(additionalContext, {
        shard: shard,
        region: region
    });
    const enabledFeatureFlags = Object.fromEntries([
        ...(0, $gSA3s.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    Object.assign(additionalContext, {
        enabledFeatureFlags: enabledFeatureFlags
    });
    if ($b28eb6b892a8c2f7$var$shouldAddConnectivityAttribute(experienceDescription)) {
        const isOnline = typeof globalThis.window !== 'undefined' && globalThis.window?.navigator?.onLine;
        Object.assign(additionalContext, {
            isOnline: isOnline
        });
    }
    const synthetics = {
        additionalAttributes: {
            synthetic: $b28eb6b892a8c2f7$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(experienceDescription, synthetics);
    (0, $hh0bW.default)(experienceDescription);
}

});

parcelRegister("2N3tQ", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $0471f3f4df57179c$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $0471f3f4df57179c$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $0471f3f4df57179c$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $0471f3f4df57179c$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $0471f3f4df57179c$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $0471f3f4df57179c$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $0471f3f4df57179c$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $0471f3f4df57179c$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $0471f3f4df57179c$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $dGvGJ = parcelRequire("dGvGJ");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $0471f3f4df57179c$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $0471f3f4df57179c$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $0471f3f4df57179c$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $0471f3f4df57179c$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $0471f3f4df57179c$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $0471f3f4df57179c$var$actions = {
    setIssueConfig: $0471f3f4df57179c$var$setIssueConfig,
    setIssuesConfig: $0471f3f4df57179c$var$setIssuesConfig,
    mergeIssueConfig: $0471f3f4df57179c$var$mergeIssueConfig,
    mergeIssuesConfig: $0471f3f4df57179c$var$mergeIssuesConfig,
    setFieldConfigValue: $0471f3f4df57179c$var$setFieldConfigValue
};
// this is a global state
const $0471f3f4df57179c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $0471f3f4df57179c$var$actions
});
const $0471f3f4df57179c$var$getIssueFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $0471f3f4df57179c$export$52f51db4e2b3da57 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$var$getFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $0471f3f4df57179c$var$getFieldConfigWithLabel = (0, $dGvGJ.createSelector)($0471f3f4df57179c$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $0471f3f4df57179c$var$getFieldOptionsOverrides = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $0471f3f4df57179c$export$f9beb98c7488fd61 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$314199caf05d245 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: null
});
const $0471f3f4df57179c$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $0471f3f4df57179c$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $0471f3f4df57179c$var$overridesActions = {
    setFieldConfigOverridesValue: $0471f3f4df57179c$var$setOverrides,
    resetOverridesStore: $0471f3f4df57179c$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $0471f3f4df57179c$var$overridesStore = (0, $iXqE5.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $0471f3f4df57179c$var$overridesActions
});
const $0471f3f4df57179c$export$ff357cf5a96ec0c6 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$export$6e41e9c34587d557 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$e704d739927bd1d6 = (0, $3sQ5x.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfigWithLabel
});
const $0471f3f4df57179c$export$d94ae842140da412 = (0, $3sQ5x.createActionsHook)($0471f3f4df57179c$var$overridesStore);
const $0471f3f4df57179c$export$bfea9bb9bad7bc8f = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldOptionsOverrides
});
const $0471f3f4df57179c$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $0471f3f4df57179c$export$982ff1008c2e2780 = (0, $3sQ5x.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIsFieldBusySelector
});

});


parcelRegister("69oHP", function(module, exports) {

$parcel$export(module.exports, "getFieldType", () => $53d3f894a8bd7ffe$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isRichTextSupported", () => $53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1);


var $fOGZN = parcelRequire("fOGZN");

var $5fc53 = parcelRequire("5fc53");
const $53d3f894a8bd7ffe$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $fOGZN.specialFields)();
    return [
        ...(0, $fOGZN.customFieldsToDisplay)().filter((cf)=>!(0, $fOGZN.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $5fc53.FLAGGED_CF_TYPE)
    ];
};
const $53d3f894a8bd7ffe$export$f521834fc2bfcd81 = (custom)=>$53d3f894a8bd7ffe$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $53d3f894a8bd7ffe$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $53d3f894a8bd7ffe$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
const $53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1 = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? fieldSchema.type === (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $650578330a102f55$export$89b8c5d86c10a68c) || $53d3f894a8bd7ffe$export$b9089a6e41ed43aa(field) === (0, $5fc53.DESCRIPTION_TYPE) : false;
};

});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("fOGZN", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $1df76d38eb6e3f90$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $1df76d38eb6e3f90$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $1df76d38eb6e3f90$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $1df76d38eb6e3f90$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $1df76d38eb6e3f90$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $1df76d38eb6e3f90$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $1df76d38eb6e3f90$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $1df76d38eb6e3f90$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $1df76d38eb6e3f90$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $1df76d38eb6e3f90$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $1df76d38eb6e3f90$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $1df76d38eb6e3f90$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $1df76d38eb6e3f90$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $1df76d38eb6e3f90$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $1df76d38eb6e3f90$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $1df76d38eb6e3f90$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $1df76d38eb6e3f90$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $1df76d38eb6e3f90$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $1df76d38eb6e3f90$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $1df76d38eb6e3f90$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $1df76d38eb6e3f90$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $1df76d38eb6e3f90$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $1df76d38eb6e3f90$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $1df76d38eb6e3f90$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $1df76d38eb6e3f90$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $1df76d38eb6e3f90$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $1df76d38eb6e3f90$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $1df76d38eb6e3f90$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $1df76d38eb6e3f90$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $1df76d38eb6e3f90$export$aba22e09a66f6826);
$parcel$export(module.exports, "SELECT_CUSTOM_FIELD_TYPE", () => $1df76d38eb6e3f90$export$826d657005bbe54c);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $1df76d38eb6e3f90$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $1df76d38eb6e3f90$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $1df76d38eb6e3f90$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $1df76d38eb6e3f90$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $1df76d38eb6e3f90$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $1df76d38eb6e3f90$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $1df76d38eb6e3f90$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $1df76d38eb6e3f90$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $1df76d38eb6e3f90$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $1df76d38eb6e3f90$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $1df76d38eb6e3f90$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $1df76d38eb6e3f90$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $1df76d38eb6e3f90$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $1df76d38eb6e3f90$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $1df76d38eb6e3f90$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");

var $5fc53 = parcelRequire("5fc53");
const $1df76d38eb6e3f90$export$ebb48b08205007c5 = 'issuetype';
const $1df76d38eb6e3f90$export$a464614f8f5fe986 = 'summary';
const $1df76d38eb6e3f90$export$a311a3c9b207604e = 'parent';
const $1df76d38eb6e3f90$export$2a4f270075a033de = 'parent-issue';
const $1df76d38eb6e3f90$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $1df76d38eb6e3f90$export$289917d9a7031e1d = 'watches';
const $1df76d38eb6e3f90$export$81614f6dc3be5b00 = 'votes';
const $1df76d38eb6e3f90$export$72a5630aa398d6b4 = 'security';
const $1df76d38eb6e3f90$export$caf1ff54fbdf44bf = 'issuerestriction';
const $1df76d38eb6e3f90$export$f8f7545d2bb78afb = 'assignee';
const $1df76d38eb6e3f90$export$6d7021166edc895c = 'reporter';
const $1df76d38eb6e3f90$export$cf7e173386d30cdd = 'duedate';
const $1df76d38eb6e3f90$export$bb34f3538ba26c7e = 'priority';
const $1df76d38eb6e3f90$export$79b91d4669dcadcb = 'labels';
const $1df76d38eb6e3f90$export$cbedbfe2cd0caec7 = 'components';
const $1df76d38eb6e3f90$export$950d47e775e208ee = 'devSummary';
const $1df76d38eb6e3f90$export$f91d2bb4cc99fa5e = 'releases';
const $1df76d38eb6e3f90$export$a316570a0dbfd2b0 = 'sprint';
const $1df76d38eb6e3f90$export$405b6d72f2d243a9 = 'storyPointsField';
const $1df76d38eb6e3f90$export$3cb4a99a332e4186 = 'epic';
const $1df76d38eb6e3f90$export$d7e18f5730074533 = 'fixVersions';
const $1df76d38eb6e3f90$export$c435f0000304e508 = 'versions';
const $1df76d38eb6e3f90$export$ee99ef6ee562a446 = 'timetracking';
const $1df76d38eb6e3f90$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $1df76d38eb6e3f90$export$e50006273435e7d4 = 'status';
const $1df76d38eb6e3f90$export$f1a6ce22cbb7eb32 = 'resolution';
const $1df76d38eb6e3f90$export$ff39ebd4bb12b718 = 'created';
const $1df76d38eb6e3f90$export$cd8e68094cb5c3cb = 'updated';
const $1df76d38eb6e3f90$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $1df76d38eb6e3f90$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $1df76d38eb6e3f90$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $1df76d38eb6e3f90$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $1df76d38eb6e3f90$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $1df76d38eb6e3f90$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $1df76d38eb6e3f90$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $1df76d38eb6e3f90$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $1df76d38eb6e3f90$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $1df76d38eb6e3f90$export$913055729e1380b2 = 'summary';
const $1df76d38eb6e3f90$export$d44826c816b5619b = 'description';
const $1df76d38eb6e3f90$export$a29989082612d0d9 = 'comment';
const $1df76d38eb6e3f90$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $1df76d38eb6e3f90$export$3b3d0889022c85b3 = 'children-issues';
const $1df76d38eb6e3f90$export$be46596bc6608f3b = 'environment';
const $1df76d38eb6e3f90$export$f528fadbfdb3c25e = 'subtasks';
const $1df76d38eb6e3f90$export$f10e53e8928b61bd = 'dataclassification';
const $1df76d38eb6e3f90$export$e0dfb65d1047c53c = (0, $5fc53.PARENT_CF_TYPE);
const $1df76d38eb6e3f90$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $1df76d38eb6e3f90$export$826d657005bbe54c = (0, $5fc53.SELECT_CF_TYPE);
const $1df76d38eb6e3f90$export$cdbd1eb3b05729e0 = 'flagActions';
const $1df76d38eb6e3f90$export$c161a774ec2e7e56 = 'cardCoverActions';
const $1df76d38eb6e3f90$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$1df76d38eb6e3f90$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$1df76d38eb6e3f90$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$1df76d38eb6e3f90$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $5fc53.TEAM_CF_TYPE)]: (0, $5fc53.TEAM_CF_TYPE),
        [(0, $5fc53.PARENT_CF_TYPE)]: (0, $5fc53.PARENT_CF_TYPE),
        [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $5fc53.BASELINE_START_CF_TYPE),
        [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $5fc53.BASELINE_END_CF_TYPE),
        [(0, $5fc53.COLOR_CF_TYPE)]: (0, $5fc53.COLOR_CF_TYPE),
        [(0, $5fc53.EPIC_COLOR_TYPE)]: (0, $5fc53.EPIC_COLOR_TYPE),
        [(0, $5fc53.EPIC_NAME_TYPE)]: (0, $5fc53.EPIC_NAME_TYPE)
    };
    return fields;
};
const $1df76d38eb6e3f90$export$87934b3672715c91 = [
    (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $1df76d38eb6e3f90$var$serviceDeskCustomFields = [
    (0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $5fc53.ORGANIZATIONS_CF_TYPE),
    (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
    (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
    (0, $5fc53.APPROVALS_CF_TYPE),
    (0, $5fc53.APPROVERS_LIST_CF_TYPE),
    (0, $5fc53.REQUEST_TYPE_CF_TYPE),
    (0, $5fc53.CMDB_OBJECT_CF_TYPE),
    (0, $5fc53.RESPONDERS_CF_TYPE),
    (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
    (0, $5fc53.ENTITLEMENT_CF_TYPE),
    (0, $5fc53.SENTIMENT_CF_TYPE),
    (0, $5fc53.ORGANIZATION_CF_TYPE)
];
const $1df76d38eb6e3f90$export$efd443bccc4c01ed = ()=>[
        (0, $5fc53.LABELS_CF_TYPE),
        (0, $5fc53.TEXT_CF_TYPE),
        (0, $5fc53.MULTI_USER_CF_TYPE),
        (0, $5fc53.PARTICIPANTS_CF_TYPE),
        (0, $5fc53.URL_CF_TYPE),
        (0, $5fc53.NUMBER_CF_TYPE),
        (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $5fc53.SELECT_CF_TYPE),
        (0, $5fc53.MULTI_SELECT_CF_TYPE),
        (0, $5fc53.VERSION_CF_TYPE),
        (0, $5fc53.TEXT_AREA_CF_TYPE),
        (0, $5fc53.MULTI_VERSION_CF_TYPE),
        (0, $5fc53.DATE_CF_TYPE),
        (0, $5fc53.GROUP_CF_TYPE),
        (0, $5fc53.MULTI_GROUP_CF_TYPE),
        (0, $5fc53.USER_CF_TYPE),
        (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
        (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
        (0, $5fc53.DATETIME_CF_TYPE),
        (0, $5fc53.ASSETS_CF_TYPE),
        (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
        (0, $5fc53.PEOPLE_CF_TYPE),
        (0, $5fc53.CASCADING_SELECT_CF_TYPE),
        (0, $5fc53.PROJECT_PICKER_CF_TYPE),
        (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
        (0, $5fc53.READ_ONLY_CF_TYPE),
        (0, $5fc53.EPIC_STATUS_TYPE),
        (0, $5fc53.MESSAGE_VIEW_CF_TYPE),
        (0, $5fc53.MESSAGE_EDIT_CF_TYPE),
        (0, $5fc53.CATEGORY_TYPE),
        (0, $5fc53.GOALS_CF_TYPE),
        ...$1df76d38eb6e3f90$export$87934b3672715c91,
        ...$1df76d38eb6e3f90$var$serviceDeskCustomFields
    ];
const $1df76d38eb6e3f90$export$a18b3a656ee9c709 = {
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $2vSU6.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $1df76d38eb6e3f90$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $1df76d38eb6e3f90$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0,
            $1df76d38eb6e3f90$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $65mz3.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $1df76d38eb6e3f90$export$aebf676dfa727a1c();
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $1df76d38eb6e3f90$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $1df76d38eb6e3f90$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
    }
    return $1df76d38eb6e3f90$export$27e0678365e5dcff();
};

});


parcelRegister("Fn2Vl", function(module, exports) {

$parcel$export(module.exports, "InlineEditContainer", () => $2060312c94028fa8$export$9f16bbb9a44c7bf6);
$parcel$export(module.exports, "InlineEditContainerExperiment", () => $2060312c94028fa8$export$409c96a6d46b6d0);
$parcel$export(module.exports, "ReadViewContainer", () => $2060312c94028fa8$export$ebb3489b83262b26);
$parcel$export(module.exports, "readOnlyViewContainerSelectorName", () => $2060312c94028fa8$export$dafe48f89a07868a);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $gwIPs = parcelRequire("gwIPs");
/*
 Using calc as this margin negates 2 things:
 - Left displacement which ensures there's more space for the input element that becomes visible on focus.
 - The focus outline offset for the badge (implemented as a 2px border) which is in PX everywhere currently.
 The REM is affected by browser font size settings while PX isn't. So, this ensures the spacing behaves in a consistent manner.
 */ const $2060312c94028fa8$var$MARGIN_LEFT = `calc(${"var(--ds-space-negative-075, -6px)"} - 2px)`;
const $2060312c94028fa8$export$9f16bbb9a44c7bf6 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "q52d93-0"
})`margin-left:${$2060312c94028fa8$var$MARGIN_LEFT};margin-top:${"var(--ds-space-negative-100, -8px)"};padding-right:${"var(--ds-space-100, 8px)"};& div[data-read-view-fit-container-width]{width:100%;min-height:${(0, $gwIPs.gridSize) * 4}px;${({ hasValue: hasValue })=>hasValue ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $47bDC.css)`padding:0;` : // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $47bDC.css)`padding:${"var(--ds-space-100, 8px)"} 0;`}}`;
const $2060312c94028fa8$export$409c96a6d46b6d0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasValue: hasValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0x0bf _19pkx0bf _u5f3u2gc _6vgs1osq _1rjezwfg",
            __cmplp.hasValue ? "_osjgidpf _2g9bidpf _alyvidpf _pa3xidpf" : "_osjg1v6z _2g9bidpf _alyv1v6z _pa3xidpf",
            __cmplp.className
        ])
    });
});
const $2060312c94028fa8$export$ebb3489b83262b26 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "q52d93-1"
})({
    wordBreak: 'break-word',
    position: 'relative',
    left: "var(--ds-space-075, 6px)"
});
const $2060312c94028fa8$var$readViewContainerSelectorName = 'jira-issue-field-inline-edit-read-view-container';
const $2060312c94028fa8$export$dafe48f89a07868a = 'jira-issue-field-inline-edit-readonly-view-container';
const $2060312c94028fa8$export$5c18970ef161f5b6 = `[data-component-selector="${$2060312c94028fa8$var$readViewContainerSelectorName}"]`;
const $2060312c94028fa8$export$eab846169c2a4f66 = `[data-component-selector="${$2060312c94028fa8$export$dafe48f89a07868a}"]`;
$2060312c94028fa8$export$ebb3489b83262b26.defaultProps = {
    'data-component-selector': $2060312c94028fa8$var$readViewContainerSelectorName
};
const $2060312c94028fa8$export$646e0a1b0db8be98 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1nmz1hna _kqswh2mm _1ltv12x7",
            __cmplp.className
        ])
    });
});
const $2060312c94028fa8$export$3b079ed2709f4949 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4x0ty", function(module, exports) {

$parcel$export(module.exports, "useQueryLoaderOnIntent", () => $fd0b1d391c253772$export$2e6e7bf10cfd4543);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $bxYf9 = parcelRequire("bxYf9");

var $8Uumt = parcelRequire("8Uumt");
const $fd0b1d391c253772$var$defaultTimeout = 250;
function $fd0b1d391c253772$export$2e6e7bf10cfd4543(request, timeout = $fd0b1d391c253772$var$defaultTimeout) {
    const [ref, fetch] = (0, $8Uumt.useQueryLoader)(request);
    const trigger = (0, $5uXOq.useMemo)(()=>{
        const onceFetch = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(fetch);
        return (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(onceFetch, timeout, {
            trailing: true
        });
    }, [
        fetch,
        timeout
    ]);
    const abort = (0, $5uXOq.useCallback)(()=>trigger.cancel(), [
        trigger
    ]);
    // cancel the fetch if the component is unmounted before debounce is triggered
    (0, $5uXOq.useEffect)(()=>()=>trigger.cancel(), [
        trigger
    ]);
    return [
        ref,
        trigger,
        abort
    ];
}

});

parcelRegister("g0MwR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d055ee95e63a7a64$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d055ee95e63a7a64$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    confirmButtonLabel: {
        "id": "issue-field-cascading-select-inline-edit-full.cascading-select.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "issue-field-cascading-select-inline-edit-full.cascading-select.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "issue-field-cascading-select-inline-edit-full.cascading-select.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    }
});

});



parcelRegister("fMqn0", function(module, exports) {

$parcel$export(module.exports, "DateCell", () => $a5ba01011e140c80$export$64a69967f353bb7c);
$parcel$export(module.exports, "DateInlineEditCell", () => $a5ba01011e140c80$export$976ea8051f04575);

var $fW0lx = parcelRequire("fW0lx");

var $j8bBR = parcelRequire("j8bBR");

var $5uXOq = parcelRequire("5uXOq");

var $eZDAP = parcelRequire("eZDAP");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7VHMR = parcelRequire("7VHMR");

var $3ikQj = parcelRequire("3ikQj");

var $65VLO = parcelRequire("65VLO");

var $Br57E = parcelRequire("Br57E");

var $hKMVG = parcelRequire("hKMVG");

var $jFYC8 = parcelRequire("jFYC8");

var $e9M6d = parcelRequire("e9M6d");
const $a5ba01011e140c80$var$parseDate = (dateString)=>{
    if (dateString !== null && dateString !== '') {
        const date = (0, $eZDAP.default)(dateString);
        if (date.toString() !== 'Invalid Date') return date;
    }
    return null;
};
const $a5ba01011e140c80$var$formattedDate = (dateString)=>{
    const date = $a5ba01011e140c80$var$parseDate(dateString);
    if (!date) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VHMR.FormattedDate), {
        value: date,
        year: "numeric",
        month: "short",
        day: "numeric"
    });
};
const $a5ba01011e140c80$export$64a69967f353bb7c = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, isRequired: isRequired })=>{
    const data = (0, $8Uumt.useFragment)(/* eslint-disable @atlassian/relay/graphql-naming */ (0, $j8bBR.default), fieldRef);
    if (data.__typename === 'JiraDatePickerField' && data.fieldId === (0, $65VLO.KNOWN_COLUMN_TYPES).DUE_DATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5ba01011e140c80$export$976ea8051f04575, {
        fieldRef: data
    });
    let date = null;
    if (data.__typename === 'JiraDatePickerField') date = data.date ?? null;
    else if (data.__typename === 'JiraDateTimePickerField') date = data.dateTime ?? null;
    if (isRequired && date == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "date",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a5ba01011e140c80$var$wrapperStyles
    }, $a5ba01011e140c80$var$formattedDate(date));
});
const $a5ba01011e140c80$export$976ea8051f04575 = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $fW0lx.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3ikQj.DateInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        readViewFitContainerHeight: true,
        shouldShowHoverPopover: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
};
const $a5ba01011e140c80$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("fW0lx", function(module, exports) {

$parcel$export(module.exports, "default", () => $47618bb60ed923a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5348679d88409840cbc084cca6cb2abb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $47618bb60ed923a9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "date_nativeIssueTable_DateInlineEditCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraDatePickerField"
};
$47618bb60ed923a9$var$node.hash = "d355ad73c106c22099e54f46482d082c";
var $47618bb60ed923a9$export$2e2bcd8739ae039 = $47618bb60ed923a9$var$node;

});

parcelRegister("j8bBR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10a05d864eb46a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4f7957eb15e09b3ca778fbe5b6cecfb8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c10a05d864eb46a5$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "date_nativeIssueTable_DateCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "date"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "date_nativeIssueTable_DateInlineEditCell_fieldRef"
                }
            ],
            "type": "JiraDatePickerField"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "dateTime"
                }
            ],
            "type": "JiraDateTimePickerField"
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$c10a05d864eb46a5$var$node.hash = "7b89423f51f8c1066484f850cdda0694";
var $c10a05d864eb46a5$export$2e2bcd8739ae039 = $c10a05d864eb46a5$var$node;

});

parcelRegister("3ikQj", function(module, exports) {

$parcel$export(module.exports, "DateInlineEditViewWithIsEditable", () => $d829cea42af34348$export$af387cb7b19f78a3);
$parcel$export(module.exports, "DateInlineEditView", () => $d829cea42af34348$export$d1623660a0dc5b59);

var $9o4fH = parcelRequire("9o4fH");

var $f5PcL = parcelRequire("f5PcL");

var $02tKg = parcelRequire("02tKg");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $1xSBy = parcelRequire("1xSBy");

var $imgL2 = parcelRequire("imgL2");

var $jrRyX = parcelRequire("jrRyX");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $6s1PB = parcelRequire("6s1PB");

var $fOGZN = parcelRequire("fOGZN");

var $1eyaH = parcelRequire("1eyaH");

var $2gCtH = parcelRequire("2gCtH");

var $93Yeu = parcelRequire("93Yeu");

var $2vSU6 = parcelRequire("2vSU6");

var $2NMNM = parcelRequire("2NMNM");

var $kbVcX = parcelRequire("kbVcX");
const $d829cea42af34348$var$RecurWorkItemContainerEmpty = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $d829cea42af34348$export$af387cb7b19f78a3 = (props)=>{
    const { attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, isEditing: isEditingProp = false, isEditable: isEditable, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, fragmentRef: fragmentRef, readViewFitContainerHeight: readViewFitContainerHeight, includeUrgencyTreatment: includeUrgencyTreatment, context: context, shouldShowHoverPopover: shouldShowHoverPopover } = props;
    const data = (0, $8Uumt.useFragment)((0, $02tKg.default), fragmentRef);
    const [commit] = (0, $8Uumt.useMutation)((0, $f5PcL.default));
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, fieldConfig: fieldConfig } = data;
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const fieldName = overriding.overrideLabel(name);
    const isFieldEditable = overriding.overrideIsEditable(isEditable);
    const isFieldRequired = fieldConfig?.isRequired ?? false;
    const validator = (0, $kbVcX.useDateValidator)(fieldName, isFieldRequired);
    const initialValue = data.date ?? null;
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const handleSubmit = (0, $5uXOq.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        date: value,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateDateField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateDateField: {
                        success: true,
                        errors: null,
                        field: {
                            date: value,
                            id: uniqueFieldId
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const handleSubmitSucceeded = (0, $5uXOq.useCallback)((value)=>{
        onSubmitSucceeded?.(value);
    }, [
        onSubmitSucceeded
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: isEditingProp,
        updatedValue: updatedValue,
        validator: validator,
        clipboardComponentType: 'date'
    });
    const isRecurWorkItemEnabled = (projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && context === 'ISSUE_DETAIL' && fieldId === (0, $fOGZN.DUE_DATE) && (0, $6s1PB.expVal)('jira-recur-single-work-item-on-sched-due-date-exp', 'showRecurringWorkPopup', false);
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imgL2.DateReadView), {
            fragmentRef: data,
            includeUrgencyTreatment: includeUrgencyTreatment,
            ...(0, $4R6GH.fg)('issue_view_due_date_colored_field_targeting_gate') ? {
                fieldId: fieldId
            } : {},
            shouldShowRecurWorkIcon: isRecurWorkItemEnabled && (0, $6s1PB.expVal)('jira-recur-single-work-item-on-sched-due-date-exp', 'showRecurWorkIconInDueDate', false),
            shouldShowHoverPopover: shouldShowHoverPopover
        }), [
        data,
        fieldId,
        includeUrgencyTreatment,
        isRecurWorkItemEnabled,
        shouldShowHoverPopover
    ]);
    const RecurWorkItemContainer = isRecurWorkItemEnabled ? (0, $1eyaH.RecurWorkItemContainer) : $d829cea42af34348$var$RecurWorkItemContainerEmpty;
    // copied from @atlassian/jira-inline-edit-lite/src/ui/use-inline-edit/index.tsx
    const handleCancelWithEvent = (0, $5uXOq.useCallback)(()=>handleCancel(createAnalyticsEvent({
            action: 'canceled',
            actionSubject: 'inlineEdit'
        })), [
        handleCancel,
        createAnalyticsEvent
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            value: updatedValue,
            onChange: handleChange,
            isInvalid: !!invalidMessage,
            autoFocus: true,
            label: fieldName,
            ...isRecurWorkItemEnabled && {
                issueKey: issueKey,
                isRecurWorkItemEnabled: isRecurWorkItemEnabled,
                onCancel: handleCancelWithEvent
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RecurWorkItemContainer, {
        issueKey: issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $1xSBy.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        invalidMessage: invalidMessage,
        hideActionButtons: true
    }));
};
const $d829cea42af34348$export$d1623660a0dc5b59 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $9o4fH.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d829cea42af34348$export$af387cb7b19f78a3, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("9o4fH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f099f5bf27e0d11$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c7e4c91cc0608cf472bd3e81527b427>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f099f5bf27e0d11$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateInlineEditFull_DateInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraDatePickerField"
};
$6f099f5bf27e0d11$var$node.hash = "0548aa5d7a0a6ecdbe8581123c90487f";
var $6f099f5bf27e0d11$export$2e2bcd8739ae039 = $6f099f5bf27e0d11$var$node;

});

parcelRegister("f5PcL", function(module, exports) {

$parcel$export(module.exports, "default", () => $af0678dee6048cd3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3544f4fde4e58c3db63548472c851999>>
 * @relayHash 3f73c046ded86edefc83912b3cd5e2d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4e94696fd29cf731c3234b50dbf74d91aa220d3c9064bbb1beb198ce6b790f4
const $af0678dee6048cd3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "date"
    }, v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "date_issueFieldDate_DateField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDatePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "date_issueFieldDate_DateField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDatePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                },
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f4e94696fd29cf731c3234b50dbf74d91aa220d3c9064bbb1beb198ce6b790f4",
            "metadata": {},
            "name": "date_issueFieldDate_DateField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$af0678dee6048cd3$var$node.hash = "3265ff9f0b11e3ed4bac45dff405280d";
var $af0678dee6048cd3$export$2e2bcd8739ae039 = $af0678dee6048cd3$var$node;

});

parcelRegister("02tKg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cabf1c7029a43b6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e77458cde4889443c861d0d7069e28b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8cabf1c7029a43b6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateReadviewFull_DateReadView"
        },
        {
            "kind": "ScalarField",
            "name": "date"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        }
    ],
    "type": "JiraDatePickerField"
};
$8cabf1c7029a43b6$var$node.hash = "2d11e23373a2a9517c8a8ac5a6bfe366";
var $8cabf1c7029a43b6$export$2e2bcd8739ae039 = $8cabf1c7029a43b6$var$node;

});

parcelRegister("1xSBy", function(module, exports) {

$parcel$export(module.exports, "default", () => $07beed780e685ad9$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $07beed780e685ad9$var$DateEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("jqcIN")), {
        moduleId: "652b5c22"
    }),
    getPreloadProps: ()=>({})
});
var $07beed780e685ad9$export$2e2bcd8739ae039 = $07beed780e685ad9$var$DateEditViewEntryPoint;

});
parcelRegister("jqcIN", function(module, exports) {

let $e23a504547a98ab2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e23a504547a98ab2$var$load("4rGYh").then(()=>parcelRequire('89Wlf'));

});


parcelRegister("imgL2", function(module, exports) {

$parcel$export(module.exports, "DateReadView", () => $dd62e7a12458098b$export$c663acc1a0b7c5a9);

var $gU9cN = parcelRequire("gU9cN");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $jpopi = parcelRequire("jpopi");

var $f1akg = parcelRequire("f1akg");

var $cNoIA = parcelRequire("cNoIA");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $eZibI = parcelRequire("eZibI");

var $iv6X1 = parcelRequire("iv6X1");

var $8tRRd = parcelRequire("8tRRd");

var $fOGZN = parcelRequire("fOGZN");

var $1eyaH = parcelRequire("1eyaH");

var $cpjnU = parcelRequire("cpjnU");

var $3MR3Z = parcelRequire("3MR3Z");

var $dpHMc = parcelRequire("dpHMc");

var $7mPT9 = parcelRequire("7mPT9");

var $JqOmc = parcelRequire("JqOmc");
const $dd62e7a12458098b$var$RecurringWorkItemIcon = ({ useUrgentColour: useUrgentColour })=>{
    const { issueProperties: issueProperties, isUpdatingRule: isUpdatingRule } = (0, $1eyaH.useRecurWorkItemState)();
    if (!issueProperties && !isUpdatingRule || (0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jpopi))), {
        label: "",
        testId: "issue-field-date-readview-full.ui.date.recur-work-icon",
        ...useUrgentColour ? {
            color: "var(--ds-icon-danger, #C9372C)"
        } : {}
    });
};
const $dd62e7a12458098b$var$EmptyContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $dd62e7a12458098b$export$c663acc1a0b7c5a9 = ({ fragmentRef: fragmentRef, fieldId: fieldId, includeUrgencyTreatment: includeUrgencyTreatment, shouldShowRecurWorkIcon: shouldShowRecurWorkIcon = false, shouldShowHoverPopover: shouldShowHoverPopover })=>{
    const { formatDateOnly: formatDateOnly } = (0, $8tRRd.useDateTimeFormatter)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    const noValueTextExperiment = formatMessage(fieldId === (0, $fOGZN.DUE_DATE) ? (0, $JqOmc.default).noValueTextExperimentDueDate : (0, $JqOmc.default).noValueTextExperiment);
    const data = (0, $8Uumt.useFragment)((0, $gU9cN.default), fragmentRef);
    const { date: date } = data || {};
    const contentRef = (0, $5uXOq.useRef)(null);
    if (!date) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    });
    const daysSinceDate = (0, $3MR3Z.getNoOfDaysSinceUTCDateString)(date);
    const isDatePast = daysSinceDate != null && daysSinceDate > 0;
    const isDueToday = daysSinceDate === 0;
    const renderColoredDueDate = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f1akg.ColoredDueDate), {
            dateString: date,
            pastDue: isDatePast && Boolean(includeUrgencyTreatment) && fieldId === (0, $fOGZN.DUE_DATE),
            dueToday: isDueToday && Boolean(includeUrgencyTreatment) && fieldId === (0, $fOGZN.DUE_DATE),
            warningIconTestId: "date-field.warning-icon",
            clockIconTestId: "date-field.clock-icon",
            calendarIconTestId: "date-field.calendar-icon",
            maybeShowRecurIcon: shouldShowRecurWorkIcon,
            recurIconTestId: "date-field.recur-icon"
        });
    const renderedValue = includeUrgencyTreatment && fieldId === (0, $fOGZN.DUE_DATE) && (0, $6s1PB.expVal)('due_date_colured_field', 'showUrgencyIndicator', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNoIA.DateWithUrgencyIndicator), {
        value: date
    }) : formatDateOnly(date);
    const Container = shouldShowRecurWorkIcon ? (0, $f5TWP.default) : $dd62e7a12458098b$var$EmptyContainer;
    /**
   * Hover popover is only enabled on NIN, GNIN, and CHIN and hence the conditional rendering of
   * other formatted dates is ignroed
   */ if (shouldShowHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        contentRef: contentRef,
        content: formatDateOnly(date)
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Container, {
            space: "space.075",
            alignBlock: "center",
            testId: "issue-field-date-readview-full.ui.date.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span",
            xcss: [
                $dd62e7a12458098b$var$dateReadViewStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            maxLines: 1,
            ref: (0, $7mPT9.default)(ref, contentRef)
        }, formatDateOnly(date)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Container, {
        space: "space.075",
        alignBlock: "center",
        testId: "issue-field-date-readview-full.ui.date.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: [
            $dd62e7a12458098b$var$dateReadViewStyles,
            !(includeUrgencyTreatment && fieldId === (0, $fOGZN.DUE_DATE) && (0, $6s1PB.expVal)('color_due_date_all_views', 'showColoredDueDate', false)) && $dd62e7a12458098b$var$clampStyles
        ]
    }, includeUrgencyTreatment && fieldId === (0, $fOGZN.DUE_DATE) && (0, $6s1PB.expVal)('color_due_date_all_views', 'showColoredDueDate', false) ? renderColoredDueDate() : renderedValue), !(0, $6s1PB.expVal)('color_due_date_all_views', 'showColoredDueDate', false) && shouldShowRecurWorkIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd62e7a12458098b$var$RecurringWorkItemIcon, {
        useUrgentColour: (isDatePast || isDueToday) && !!includeUrgencyTreatment && (0, $6s1PB.expVal)('due_date_colured_field', 'showUrgencyIndicator', false)
    }));
};
const $dd62e7a12458098b$var$dateReadViewStyles = (0, $8CUq3.xcss)({
    display: '-webkit-box',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $dd62e7a12458098b$var$clampStyles = (0, $8CUq3.xcss)({
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2
});

});
parcelRegister("gU9cN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a389af066840a2ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<95b885d98116415e04b7330ebc0d66c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a389af066840a2ae$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateReadviewFull_DateReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "date"
        }
    ],
    "type": "JiraDatePickerField"
};
$a389af066840a2ae$var$node.hash = "d7db56777519dc6f4756e8e006032b0d";
var $a389af066840a2ae$export$2e2bcd8739ae039 = $a389af066840a2ae$var$node;

});

parcelRegister("jpopi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a88758e67a65d8683bdcd5e828d8b686>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e21348dd48989821$var$_react = $e21348dd48989821$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e21348dd48989821$var$_baseNew = $e21348dd48989821$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e21348dd48989821$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Repeat".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for setting objects to recur (eg Work items, Forms)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e21348dd48989821$var$RepeatIcon = (props)=>/*#__PURE__*/ $e21348dd48989821$var$_react.default.createElement($e21348dd48989821$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m8.78 3.72-3-3-1.06 1.06L6.44 3.5H4.5a4.5 4.5 0 0 0 0 9h1V11h-1a3 3 0 0 1 0-6h1.94L4.72 6.72l1.06 1.06 3-3a.75.75 0 0 0 0-1.06M11.5 5a3 3 0 1 1 0 6H9.56l1.72-1.72-1.06-1.06-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72h1.94a4.5 4.5 0 1 0 0-9h-1V5z" clip-rule="evenodd"/>`
    }, props));
$e21348dd48989821$var$RepeatIcon.displayName = 'RepeatIcon';
var $e21348dd48989821$var$_default = module.exports.default = $e21348dd48989821$var$RepeatIcon;

});

parcelRegister("f1akg", function(module, exports) {

$parcel$export(module.exports, "ColoredDueDate", () => $3f739dd1d004c9d2$export$63c54814247cca36);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jpopi = parcelRequire("jpopi");

var $acknU = parcelRequire("acknU");

var $hyKRO = parcelRequire("hyKRO");

var $jCESp = parcelRequire("jCESp");

var $3bDjY = parcelRequire("3bDjY");

var $DVljb = parcelRequire("DVljb");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $1eyaH = parcelRequire("1eyaH");

var $cpjnU = parcelRequire("cpjnU");

var $CKlOf = parcelRequire("CKlOf");
const $3f739dd1d004c9d2$var$RecurringWorkItemIcon = ({ testId: testId })=>{
    const { issueProperties: issueProperties, isUpdatingRule: isUpdatingRule } = (0, $1eyaH.useRecurWorkItemState)();
    if (!issueProperties && !isUpdatingRule || (0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jpopi))), {
        label: "",
        testId: testId
    });
};
const $3f739dd1d004c9d2$export$63c54814247cca36 = ({ dateString: dateString, pastDue: pastDue, dueToday: dueToday, warningIconTestId: warningIconTestId, clockIconTestId: clockIconTestId, calendarIconTestId: calendarIconTestId, tooltipTestId: tooltipTestId, isShortFormat: isShortFormat = false, maybeShowRecurIcon: maybeShowRecurIcon = false, recurIconTestId: recurIconTestId })=>{
    const locale = (0, $DVljb.useLocale)();
    const localeString = locale.replace('_', '-');
    const formatter = new Intl.DateTimeFormat(localeString, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC'
    });
    const parts = formatter.formatToParts(new Date(dateString));
    const formatDateParts = ({ dateParts: dateParts, includeYear: includeYear = true })=>{
        let result = '';
        dateParts.forEach((part, index)=>{
            const isYearLiteralInShortFormat = part.type === 'literal' && (dateParts[index + 1]?.type === 'year' || dateParts[index - 1]?.type === 'year') && !includeYear;
            if (part.type === 'year' && includeYear || part.type !== 'year' && !isYearLiteralInShortFormat) result += part.value;
        });
        return result;
    };
    const displayDate = isShortFormat ? formatDateParts({
        dateParts: parts,
        includeYear: false
    }) : formatDateParts({
        dateParts: parts
    });
    const tooltipDate = formatDateParts({
        dateParts: parts,
        includeYear: true
    });
    const dueMessage = pastDue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $CKlOf.messages).overdue,
        values: {
            date: tooltipDate
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $CKlOf.messages).due,
        values: {
            date: tooltipDate
        }
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const iconLabel = pastDue ? formatMessage((0, $CKlOf.messages).overdue, {
        date: tooltipDate
    }) : formatMessage((0, $CKlOf.messages).due, {
        date: tooltipDate
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: dueMessage,
        position: "top",
        testId: tooltipTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $3f739dd1d004c9d2$var$styles.dateTag,
            $3f739dd1d004c9d2$var$styles.flexContainer,
            pastDue ? $3f739dd1d004c9d2$var$styles.overdue : undefined,
            dueToday ? $3f739dd1d004c9d2$var$styles.dueToday : undefined,
            !pastDue && !dueToday ? $3f739dd1d004c9d2$var$styles.normalDate : undefined
        ],
        testId: "coloured-due-date.ui.colored-due-date-container",
        tabIndex: 0,
        role: "button",
        "aria-label": iconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3f739dd1d004c9d2$var$styles.dueDateIcon,
        testId: "coloured-due-date.ui.tooltip-container"
    }, pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jCESp))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-danger, #AE2E24)",
        testId: warningIconTestId
    }), dueToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-warning, #A54800)",
        testId: clockIconTestId
    }), !dueToday && !pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
        label: iconLabel,
        color: "var(--ds-text, #172B4D)",
        LEGACY_size: "medium",
        testId: calendarIconTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "aria-hidden": "true"
    }, displayDate), maybeShowRecurIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f739dd1d004c9d2$var$RecurringWorkItemIcon, {
        testId: recurIconTestId
    })));
};
const $3f739dd1d004c9d2$var$styles = {
    dateTag: (0, $8CUq3.xcss)({
        paddingLeft: 'space.075',
        paddingRight: 'space.075',
        borderStyle: 'solid',
        borderRadius: 'border.radius.100',
        borderWidth: 'border.width',
        color: 'color.text',
        cursor: 'pointer'
    }),
    flexContainer: (0, $8CUq3.xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050'
    }),
    overdue: (0, $8CUq3.xcss)({
        color: 'color.text.danger',
        borderColor: 'color.border.danger'
    }),
    dueToday: (0, $8CUq3.xcss)({
        color: 'color.text.warning',
        borderColor: 'color.border.warning'
    }),
    normalDate: (0, $8CUq3.xcss)({
        color: 'color.text',
        borderColor: 'color.border'
    }),
    dueDateIcon: (0, $8CUq3.xcss)({
        display: 'flex',
        alignItems: 'center'
    })
};

});
parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});


parcelRegister("jCESp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::22f154a5d93289d4bcc4dadb1207abea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e49146301a0d3a89$var$_react = $e49146301a0d3a89$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e49146301a0d3a89$var$_baseNew = $e49146301a0d3a89$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e49146301a0d3a89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e49146301a0d3a89$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $e49146301a0d3a89$var$_react.default.createElement($e49146301a0d3a89$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.384c.996-1.816 3.605-1.818 4.602-.003l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972 0l-5.336 9.73c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$e49146301a0d3a89$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $e49146301a0d3a89$var$_default = module.exports.default = $e49146301a0d3a89$var$WarningOutlineIcon;

});

parcelRegister("1eyaH", function(module, exports) {

$parcel$export(module.exports, "RecurWorkItemContainer", () => $299cd71373520f02$export$32458a51e0870d6c);
$parcel$export(module.exports, "useRecurWorkItemState", () => $299cd71373520f02$export$5730c874dfb9803f);
$parcel$export(module.exports, "useRecurWorkItemActions", () => $299cd71373520f02$export$eb9ad4e1e739768e);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $93Yeu = parcelRequire("93Yeu");

var $cYlk7 = parcelRequire("cYlk7");

var $2YZCu = parcelRequire("2YZCu");

var $hVn1P = parcelRequire("hVn1P");

var $lQupu = parcelRequire("lQupu");
const $299cd71373520f02$var$RecurWorkItemStoreContainer = (0, $gg7kZ.createContainer)();
const $299cd71373520f02$export$32458a51e0870d6c = ({ children: children, issueKey: issueKey })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const { data: currentUser } = (0, $cYlk7.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (!projectId) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-recur-work-item.src.controllers.RecurWorkItemContainer', 'Error initialising RecurWorkItemContainer, could not retrieve projectId');
        return children;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($299cd71373520f02$var$RecurWorkItemStoreContainer, {
        scope: `recur-${issueKey}`,
        issueKey: issueKey,
        environment: environment,
        cloudId: cloudId,
        currentUserAccountId: currentUser.user.accountId,
        projectId: projectId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $299cd71373520f02$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'RecurWorkItemStore',
    initialState: (0, $lQupu.INITIAL_STATE),
    actions: $hVn1P.actions,
    containedBy: $299cd71373520f02$var$RecurWorkItemStoreContainer,
    handlers: {
        onInit: ()=>async ({ dispatch: dispatch })=>{
                await dispatch((0, $hVn1P.actions).fetch());
            }
    }
});
const $299cd71373520f02$export$6630e454597fb59c = (0, $3sQ5x.createHook)($299cd71373520f02$export$390f32400eaf98c9);
const $299cd71373520f02$export$5730c874dfb9803f = (0, $3sQ5x.createStateHook)($299cd71373520f02$export$390f32400eaf98c9);
const $299cd71373520f02$export$eb9ad4e1e739768e = (0, $3sQ5x.createActionsHook)($299cd71373520f02$export$390f32400eaf98c9);

});
parcelRegister("hVn1P", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a7f343d49f172fdb$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7Sl82 = parcelRequire("7Sl82");

var $l9xxv = parcelRequire("l9xxv");

var $bvhsR = parcelRequire("bvhsR");

var $c8g0F = parcelRequire("c8g0F");
const $a7f343d49f172fdb$export$5153917efea4a83d = (issueProperties)=>({ setState: setState })=>{
        setState({
            issueProperties: issueProperties
        });
    };
const $a7f343d49f172fdb$export$e324594224ef24da = {
    fetch: $7Sl82.fetch,
    setIssueProperties: $a7f343d49f172fdb$export$5153917efea4a83d,
    setAsNonRecurringIssue: $l9xxv.setAsNonRecurringIssue,
    setAsRecurringIssue: $bvhsR.setAsRecurringIssue,
    updateRule: $c8g0F.updateRule
};

});
parcelRegister("7Sl82", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $88fd35b220315252$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $m8SHd = parcelRequire("m8SHd");

var $ahBjy = parcelRequire("ahBjy");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");

var $cpjnU = parcelRequire("cpjnU");
const $88fd35b220315252$export$e7aa7bc5c1b3cfb3 = ()=>async ({ setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId, currentUserAccountId: currentUserAccountId })=>{
        setState({
            isFetching: true,
            errors: null
        });
        try {
            // First fetch issue-properties
            const { value: issueProperties } = await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $m8SHd.fetchIssueProperties)(issueKey), 'fetchIssueProperties');
            let ruleSummary;
            // Only fetch rule summary if a rule exists in issue-properties and not a grandfathered recur-on-complete rule
            if (issueProperties?.automationRuleUuid) {
                ruleSummary = await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $m8SHd.fetchRuleSummary)(environment, cloudId, projectId, issueProperties.automationRuleUuid), 'fetchRuleSummary');
                // If rule doesn't exist or is disabled, delete issue-properties
                if (!ruleSummary || ruleSummary?.ruleState === (0, $ahBjy.RuleState).DISABLED) {
                    await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $fAJ3G.deleteIssueProperties)({
                        issueKey: issueKey
                    }), 'deleteIssueProperties');
                    setState({
                        isFetching: false,
                        hasFetched: true,
                        issueProperties: null
                    });
                    return;
                }
            }
            let isRuleOwner;
            if ((0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties)) isRuleOwner = true;
            else if (ruleSummary) isRuleOwner = ruleSummary.authorAccountId === currentUserAccountId;
            else isRuleOwner = null;
            setState({
                isFetching: false,
                hasFetched: true,
                issueProperties: issueProperties,
                isRuleOwner: isRuleOwner,
                ...(0, $4R6GH.fg)('jira-recur-single-work-item-on-sched-due-date-gate') && {
                    hasBootstrapError: false
                }
            });
        } catch (error) {
            setState({
                isFetching: false,
                hasFetched: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    error
                ],
                hasBootstrapError: true
            });
        }
    };

});
parcelRegister("m8SHd", function(module, exports) {

$parcel$export(module.exports, "fetchIssueProperties", () => $85e12c64cfd21e7a$export$efa35964e975bd30);
$parcel$export(module.exports, "fetchRuleSummary", () => $85e12c64cfd21e7a$export$3cada9835f092161);

var $c5wox = parcelRequire("c5wox");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $85e12c64cfd21e7a$export$efa35964e975bd30 = async (issueKey)=>{
    const recurrenceConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    try {
        return await (0, $eusud.performGetRequest)(recurrenceConfigEndpoint);
    } catch (error) {
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return Promise.resolve({
            value: null
        });
        throw error;
    }
};
const $85e12c64cfd21e7a$export$3cada9835f092161 = async (environment, cloudId, projectId, ruleUuid)=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const summaryEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/summary`;
    try {
        return await (0, $eusud.performGetRequest)(summaryEndpoint);
    } catch (error) {
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return null;
        throw error;
    }
};

});
parcelRegister("c5wox", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $8833cfad9f41bd36$export$6123178d3f5fb24d);
$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $8833cfad9f41bd36$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $8833cfad9f41bd36$export$8e479e490e1e69bc);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $8833cfad9f41bd36$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('automation-menu');
const $8833cfad9f41bd36$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $8833cfad9f41bd36$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $4R6GH.fg)('automation-platform-pre-prod-instance')) {
            const stack = await $8833cfad9f41bd36$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $8833cfad9f41bd36$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $8833cfad9f41bd36$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $8833cfad9f41bd36$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $8833cfad9f41bd36$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $8833cfad9f41bd36$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if ((0, $4R6GH.fg)('jcs_project_type_m3')) switch(projectType){
        case 'customer_service':
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});


parcelRegister("ahBjy", function(module, exports) {

$parcel$export(module.exports, "RuleState", () => $50cbc517c5c98dcf$export$c22ef3527b5f5563);
$parcel$export(module.exports, "CONDITION", () => $50cbc517c5c98dcf$export$1cfe08df32bc8f76);
$parcel$export(module.exports, "FORM_TITLE_ID", () => $50cbc517c5c98dcf$export$66f4c6e4b9206abf);
$parcel$export(module.exports, "SOFTWARE_END_USER_TEMPLATE_2", () => $50cbc517c5c98dcf$export$c07ca23c166d6344);
const $50cbc517c5c98dcf$export$c22ef3527b5f5563 = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    MISSING_PERMS: 'MISSING_PERMS'
};
const $50cbc517c5c98dcf$export$1cfe08df32bc8f76 = {
    SCHEDULE: 'SCHEDULE',
    SCHEDULE_IF_COMPLETE: 'SCHEDULE_IF_COMPLETE'
};
const $50cbc517c5c98dcf$export$f7109619a5e9e0d6 = 'recurWorkItemForm';
const $50cbc517c5c98dcf$export$66f4c6e4b9206abf = 'recur-work-item-form-title';
const $50cbc517c5c98dcf$export$c07ca23c166d6344 = 'software_end_user_template_2';

});

parcelRegister("fAJ3G", function(module, exports) {

$parcel$export(module.exports, "deleteRule", () => $dcc2b085f6f8ace7$export$988cba38e738f27d);
$parcel$export(module.exports, "deleteIssueProperties", () => $dcc2b085f6f8ace7$export$3906c12f20991cd1);
$parcel$export(module.exports, "disableRule", () => $dcc2b085f6f8ace7$export$44bd9fdb7edbb04a);

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");
const $dcc2b085f6f8ace7$export$988cba38e738f27d = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const DELETE_RULE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}`;
    return (0, $eusud.performDeleteRequest)(DELETE_RULE_URL);
};
const $dcc2b085f6f8ace7$export$3906c12f20991cd1 = async ({ issueKey: issueKey })=>{
    const ruleConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    return (0, $eusud.performDeleteRequest)(ruleConfigEndpoint);
};
const $dcc2b085f6f8ace7$export$44bd9fdb7edbb04a = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const disableRuleEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/disable`;
    return (0, $eusud.performPatchRequest)(disableRuleEndpoint);
};

});

parcelRegister("519t2", function(module, exports) {

$parcel$export(module.exports, "callServiceWithAnalytics", () => $ad2a8aebaff4128f$export$7ad2acdaf7d8c23c);

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
const $ad2a8aebaff4128f$var$getErrorAttributes = (error)=>{
    if (error instanceof Error) return {
        errorMessage: error.message,
        ...error instanceof (0, $jJZqs.default) && {
            statusCode: error.statusCode
        }
    };
    return {};
};
const $ad2a8aebaff4128f$export$7ad2acdaf7d8c23c = async (analyticsEvent, requestPromise, requestName, attributes = {})=>{
    try {
        const response = await requestPromise;
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} succeeded`, {
            ...attributes
        });
        return response;
    } catch (err) {
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} failed`, {
            ...attributes,
            ...$ad2a8aebaff4128f$var$getErrorAttributes(err)
        });
        throw err;
    }
};

});

parcelRegister("cpjnU", function(module, exports) {

$parcel$export(module.exports, "mapFrequencyToRRule", () => $c35d2016d68e7b8d$export$e01411a3db8dd3d7);
$parcel$export(module.exports, "mapFrequencyToSmartOffsetValue", () => $c35d2016d68e7b8d$export$777fffdd861d4f20);
$parcel$export(module.exports, "getFrequencyFromRRule", () => $c35d2016d68e7b8d$export$71b17ee07540e13b);
$parcel$export(module.exports, "getRecurMenuItemLabel", () => $c35d2016d68e7b8d$export$c7198a7e75d4478b);
$parcel$export(module.exports, "getSuccessFlagContent", () => $c35d2016d68e7b8d$export$8eef89c3d24cb712);
$parcel$export(module.exports, "isRecurOnCompleteToggleRule", () => $c35d2016d68e7b8d$export$b57843f38b80b500);
$parcel$export(module.exports, "hasRuleChanged", () => $c35d2016d68e7b8d$export$8dc77b9e863f46b);
$parcel$export(module.exports, "applyUserTimezone", () => $c35d2016d68e7b8d$export$555109634e8a63b6);

var $ajpes = parcelRequire("ajpes");

var $1GF3c = parcelRequire("1GF3c");

var $gwejS = parcelRequire("gwejS");

var $7jns1 = parcelRequire("7jns1");

var $bbVsP = parcelRequire("bbVsP");
var $jpR5P = parcelRequire("jpR5P");

var $9eJ96 = parcelRequire("9eJ96");

var $5D9Ji = parcelRequire("5D9Ji");
const $c35d2016d68e7b8d$export$e01411a3db8dd3d7 = (timeframe, recurWeeklyConfig)=>{
    switch(timeframe){
        case 'DAILY':
            return {
                frequency: (0, $9eJ96.Frequencies).DAILY,
                interval: 1
            };
        case 'WEEKDAY':
            return {
                frequency: (0, $9eJ96.Frequencies).DAILY,
                byDay: [
                    (0, $9eJ96.Days).MO,
                    (0, $9eJ96.Days).TU,
                    (0, $9eJ96.Days).WE,
                    (0, $9eJ96.Days).TH,
                    (0, $9eJ96.Days).FR
                ],
                interval: 1
            };
        case 'WEEKLY':
            return {
                frequency: (0, $9eJ96.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 1
            };
        case 'FORTNIGHTLY':
            // There is no native FORTNIGHTLY frequency for ical, so we need to combine WEEKLY with interval 2
            return {
                frequency: (0, $9eJ96.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 2
            };
        default:
            throw new Error(`Unknown timeframe: ${timeframe}`);
    }
};
const $c35d2016d68e7b8d$export$777fffdd861d4f20 = (timeframe)=>{
    switch(timeframe){
        case 'DAILY':
            return '{{now.plusDays(1)}}';
        case 'WEEKDAY':
            return '{{now.plusBusinessDays(1)}}';
        case 'WEEKLY':
            return '{{now.plusWeeks(1)}}';
        case 'FORTNIGHTLY':
            return '{{now.plusWeeks(2)}}';
        default:
            throw new Error(`Could not calculate due date smart offset value: ${timeframe}`);
    }
};
const $c35d2016d68e7b8d$export$71b17ee07540e13b = (rrule)=>{
    if (rrule.frequency === (0, $9eJ96.Frequencies).DAILY) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(rrule.byDay, [
            (0, $9eJ96.Days).MO,
            (0, $9eJ96.Days).TU,
            (0, $9eJ96.Days).WE,
            (0, $9eJ96.Days).TH,
            (0, $9eJ96.Days).FR
        ])) return 'WEEKDAY';
        return 'DAILY';
    }
    if (rrule.frequency === (0, $9eJ96.Frequencies).WEEKLY) {
        if (rrule.interval === 2) return 'FORTNIGHTLY';
        return 'WEEKLY';
    }
};
const $c35d2016d68e7b8d$export$c7198a7e75d4478b = (rrule, isRecurOnComplete = false)=>{
    if (isRecurOnComplete) return (0, $5D9Ji.default).recursOnComplete;
    const frequency = $c35d2016d68e7b8d$export$71b17ee07540e13b(rrule);
    // Every business day (Monday to Friday)
    if (frequency === 'WEEKDAY') return (0, $5D9Ji.default).recursEveryWeekday;
    // Daily
    if (frequency === 'DAILY') return (0, $5D9Ji.default).recursDaily;
    // Fortnightly
    if (frequency === 'FORTNIGHTLY') return (0, $5D9Ji.default).recursEveryTwoWeeks;
    // Weekly
    if (frequency === 'WEEKLY') return (0, $5D9Ji.default).recursWeekly;
    return (0, $5D9Ji.default).setToRecur;
};
const $c35d2016d68e7b8d$var$byDayOptions = Object.values((0, $9eJ96.Days));
const $c35d2016d68e7b8d$var$getWeekDayNameFromByDay = (byDayValue, intl)=>{
    const dayIndex = $c35d2016d68e7b8d$var$byDayOptions.indexOf(byDayValue);
    if (dayIndex < 0) throw new Error(`Invalid ByDay value provided: ${byDayValue}. Valid options: ${$c35d2016d68e7b8d$var$byDayOptions}`);
    const firstDayOfWeek = (0, $1GF3c.default)(new Date(), {
        weekStartsOn: 1
    });
    const day = (0, $gwejS.default)(firstDayOfWeek, dayIndex);
    return intl.formatDate(day, {
        weekday: 'long'
    });
};
const $c35d2016d68e7b8d$export$5c6d45150d1588c0 = ({ byDayValues: byDayValues, intl: intl, standardizedLocale: standardizedLocale })=>new Intl.ListFormat(standardizedLocale, {
        style: 'long',
        type: 'conjunction'
    }).format(Array.from(byDayValues, (byDayValue)=>$c35d2016d68e7b8d$var$getWeekDayNameFromByDay(byDayValue, intl)));
const $c35d2016d68e7b8d$export$8eef89c3d24cb712 = ({ frequency: frequency, recurCondition: recurCondition, recurWeeklyConfig: recurWeeklyConfig, intl: intl, standardizedLocale: standardizedLocale, issueKey: issueKey, issueType: issueType })=>{
    const issueTypeLowercase = issueType.toLocaleLowerCase(standardizedLocale);
    switch(recurCondition){
        case 'SCHEDULE_IF_COMPLETE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteDaily, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteDaily, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteWeekday, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekday, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteWeekly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteFortnightly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteFortnightly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        case 'SCHEDULE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleDaily, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleWeekday, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleWeekly, {
                            issueKey: issueKey,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleFortnightly, {
                            issueKey: issueKey,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        default:
            throw new Error(`Unknown recur condition: ${recurCondition}`);
    }
};
const $c35d2016d68e7b8d$export$b57843f38b80b500 = (issueProperties)=>{
    return !!issueProperties && !!issueProperties.token && (issueProperties.recurOnScheduleConfig === null || issueProperties.recurOnScheduleConfig === undefined);
};
const $c35d2016d68e7b8d$var$areByDaysEqual = ({ byDays: byDays, anotherByDays: anotherByDays })=>{
    // assumes lists have a consistent order
    if (byDays === undefined) return anotherByDays === undefined;
    if (anotherByDays === undefined) return false;
    if (byDays.length !== anotherByDays.length) return false;
    return byDays.every((byDay, index)=>byDay === anotherByDays[index]);
};
const $c35d2016d68e7b8d$var$areDatesEqual = (date1, date2)=>{
    if (date1 === undefined || date2 === undefined) return date1 === date2;
    // We only care about checking the date equality, not the time
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
const $c35d2016d68e7b8d$export$8dc77b9e863f46b = ({ formInput: formInput, formOutput: formOutput })=>{
    // comparing 2 recur-on-schedule rules
    if (formInput.frequency !== formOutput.frequency || formInput.condition !== formOutput.condition || !$c35d2016d68e7b8d$var$areDatesEqual(formInput.endsOn, formOutput.endsOn)) return true;
    if (formInput.frequency === 'WEEKLY' || formInput.frequency === 'FORTNIGHTLY') return !$c35d2016d68e7b8d$var$areByDaysEqual({
        byDays: formInput.byDay,
        anotherByDays: formOutput.byDay
    });
    return false;
};
const $c35d2016d68e7b8d$export$555109634e8a63b6 = (date, browserTimezone, userTimezone)=>{
    const browserTimezoneOffsetMs = (0, $7jns1.default)(browserTimezone);
    const userTimezoneOffsetMs = (0, $7jns1.default)(userTimezone);
    return (0, $bbVsP.default)((0, $jpR5P.default)(date, browserTimezoneOffsetMs), userTimezoneOffsetMs);
};

});
parcelRegister("9eJ96", function(module, exports) {

$parcel$export(module.exports, "NEWLINE_REGEX", () => $1079d16957e265b2$export$665ca7211e0c33c);
$parcel$export(module.exports, "FOLD_LINES_REGEX", () => $1079d16957e265b2$export$4b7f22f32fbb5949);
$parcel$export(module.exports, "LF", () => $1079d16957e265b2$export$606cfc2a8896c91f);
$parcel$export(module.exports, "NewlineCharacters", () => $1079d16957e265b2$export$ccae594c20078277);
$parcel$export(module.exports, "NewlineCharacterValues", () => $1079d16957e265b2$export$c3edd2b21ac02f88);
$parcel$export(module.exports, "Frequencies", () => $1079d16957e265b2$export$895ee510b2e84ade);
$parcel$export(module.exports, "Days", () => $1079d16957e265b2$export$d3134eff2123aadb);
$parcel$export(module.exports, "BEGIN_VEVENT", () => $1079d16957e265b2$export$67de00e87412dc6f);
$parcel$export(module.exports, "END_VEVENT", () => $1079d16957e265b2$export$987d86d2e891c4cb);
$parcel$export(module.exports, "DTSTART", () => $1079d16957e265b2$export$fd1a0e011a586e26);
$parcel$export(module.exports, "RRULE", () => $1079d16957e265b2$export$d86ed937a45b0291);
$parcel$export(module.exports, "ICalSpecificationFields", () => $1079d16957e265b2$export$98eba4d8ff00c139);
$parcel$export(module.exports, "ICalSupportedFields", () => $1079d16957e265b2$export$38b1323f325ffd22);
$parcel$export(module.exports, "TZID", () => $1079d16957e265b2$export$5b9a78912028c06d);
$parcel$export(module.exports, "DTStartProperties", () => $1079d16957e265b2$export$20184b745430719e);
$parcel$export(module.exports, "FREQ", () => $1079d16957e265b2$export$fb124b4fa837b262);
$parcel$export(module.exports, "UNTIL", () => $1079d16957e265b2$export$4cc4f35131ed029c);
$parcel$export(module.exports, "INTERVAL", () => $1079d16957e265b2$export$7dea0e6e08f87a8a);
$parcel$export(module.exports, "BYHOUR", () => $1079d16957e265b2$export$a764ed9c4884f76d);
$parcel$export(module.exports, "BYMINUTE", () => $1079d16957e265b2$export$7a96578de7a037b6);
$parcel$export(module.exports, "BYSECOND", () => $1079d16957e265b2$export$55bcca3bd8d3041f);
$parcel$export(module.exports, "BYDAY", () => $1079d16957e265b2$export$f512ea3e90612d03);
$parcel$export(module.exports, "BYMONTH", () => $1079d16957e265b2$export$b3203f635d74ce88);
$parcel$export(module.exports, "BYMONTHDAY", () => $1079d16957e265b2$export$15623ad945e92c4c);
$parcel$export(module.exports, "RRuleProperties", () => $1079d16957e265b2$export$7898bd020dba0a27);
$parcel$export(module.exports, "MISSING", () => $1079d16957e265b2$export$64c81710c321f252);
$parcel$export(module.exports, "EMPTY", () => $1079d16957e265b2$export$ccb33e29d92c9a58);
$parcel$export(module.exports, "INVALID", () => $1079d16957e265b2$export$9a105a556e65c2c0);
$parcel$export(module.exports, "VALID", () => $1079d16957e265b2$export$f3abe3d006c81602);
const $1079d16957e265b2$export$665ca7211e0c33c = /\r?\n/;
const $1079d16957e265b2$export$4b7f22f32fbb5949 = /\r?\n[ \t]/g; // match line breaks followed by a whitespace character (space or tab)
const $1079d16957e265b2$export$ae9ea0d00d3d8982 = 'CRLF';
const $1079d16957e265b2$export$a1f3f1ef020bdc3a = '\r\n';
const $1079d16957e265b2$export$606cfc2a8896c91f = 'LF';
const $1079d16957e265b2$export$477fea8aa280bb1e = '\n';
const $1079d16957e265b2$export$ccae594c20078277 = {
    CRLF: $1079d16957e265b2$export$ae9ea0d00d3d8982,
    LF: $1079d16957e265b2$export$606cfc2a8896c91f
};
const $1079d16957e265b2$export$c3edd2b21ac02f88 = {
    [$1079d16957e265b2$export$ae9ea0d00d3d8982]: $1079d16957e265b2$export$a1f3f1ef020bdc3a,
    [$1079d16957e265b2$export$606cfc2a8896c91f]: $1079d16957e265b2$export$477fea8aa280bb1e
};
const $1079d16957e265b2$export$895ee510b2e84ade = {
    SECONDLY: 'SECONDLY',
    MINUTELY: 'MINUTELY',
    HOURLY: 'HOURLY',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const $1079d16957e265b2$export$d3134eff2123aadb = {
    MO: 'MO',
    TU: 'TU',
    WE: 'WE',
    TH: 'TH',
    FR: 'FR',
    SA: 'SA',
    SU: 'SU'
};
const $1079d16957e265b2$export$f62540a8bebc4ed3 = 'BEGIN';
const $1079d16957e265b2$export$32239d68d9c6cb49 = 'END';
const $1079d16957e265b2$export$67de00e87412dc6f = 'BEGIN:VEVENT';
const $1079d16957e265b2$export$987d86d2e891c4cb = 'END:VEVENT';
const $1079d16957e265b2$export$fd1a0e011a586e26 = 'DTSTART';
const $1079d16957e265b2$export$d86ed937a45b0291 = 'RRULE';
const $1079d16957e265b2$export$913055729e1380b2 = 'SUMMARY';
const $1079d16957e265b2$export$87d0ca22edb7493a = 'LOCATION';
const $1079d16957e265b2$export$d44826c816b5619b = 'DESCRIPTION';
const $1079d16957e265b2$export$c8b4a4d253b84ce0 = 'UID';
const $1079d16957e265b2$export$34694f8d8b23ee2a = 'SEQUENCE';
const $1079d16957e265b2$export$e50006273435e7d4 = 'STATUS';
const $1079d16957e265b2$export$36034111438e3f25 = 'TRANSP';
const $1079d16957e265b2$export$bb34f3538ba26c7e = 'PRIORITY';
const $1079d16957e265b2$export$30dbcad954808285 = 'DTEND';
const $1079d16957e265b2$export$bacc88974c736870 = 'DURATION';
const $1079d16957e265b2$export$da3a32b38cbf59ba = 'ATTACH';
const $1079d16957e265b2$export$5e0bdf8bba8d5088 = 'ATTENDEE';
const $1079d16957e265b2$export$a513ea61a7bee91c = 'CATEGORIES';
const $1079d16957e265b2$export$a29989082612d0d9 = 'COMMENT';
const $1079d16957e265b2$export$11038cc09fdccb91 = 'CONTACT';
const $1079d16957e265b2$export$133ffe3c8efbf133 = 'EXDATE';
const $1079d16957e265b2$export$7e27a94778a9d7d7 = 'EXRULE';
const $1079d16957e265b2$export$3d166b1dacd2503a = 'RDATE';
const $1079d16957e265b2$export$47a1d4cd38dddc05 = 'RELATED-TO';
const $1079d16957e265b2$export$4e841128923ef26 = 'RESOURCES';
const $1079d16957e265b2$export$1c0dd28c42f2741e = 'RECURRENCE-ID';
const $1079d16957e265b2$export$61abde59b50deb8e = 'URL';
const $1079d16957e265b2$export$ff39ebd4bb12b718 = 'CREATED';
const $1079d16957e265b2$export$2ebcefe61501d5fe = 'DTSTAMP';
const $1079d16957e265b2$export$90812500f628da64 = 'LAST-MODIFIED';
const $1079d16957e265b2$export$5409f4c14bda7ac = 'ORGANIZER';
const $1079d16957e265b2$export$9fe99b3b71be9378 = 'REQUEST-STATUS';
const $1079d16957e265b2$export$98eba4d8ff00c139 = {
    BEGIN: $1079d16957e265b2$export$f62540a8bebc4ed3,
    END: $1079d16957e265b2$export$32239d68d9c6cb49,
    BEGIN_VEVENT: $1079d16957e265b2$export$67de00e87412dc6f,
    END_VEVENT: $1079d16957e265b2$export$987d86d2e891c4cb,
    SUMMARY: $1079d16957e265b2$export$913055729e1380b2,
    LOCATION: $1079d16957e265b2$export$87d0ca22edb7493a,
    DESCRIPTION: $1079d16957e265b2$export$d44826c816b5619b,
    UID: $1079d16957e265b2$export$c8b4a4d253b84ce0,
    SEQUENCE: $1079d16957e265b2$export$34694f8d8b23ee2a,
    STATUS: $1079d16957e265b2$export$e50006273435e7d4,
    TRANSP: $1079d16957e265b2$export$36034111438e3f25,
    PRIORITY: $1079d16957e265b2$export$bb34f3538ba26c7e,
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    RRULE: $1079d16957e265b2$export$d86ed937a45b0291,
    DTEND: $1079d16957e265b2$export$30dbcad954808285,
    DURATION: $1079d16957e265b2$export$bacc88974c736870,
    ATTACH: $1079d16957e265b2$export$da3a32b38cbf59ba,
    ATTENDEE: $1079d16957e265b2$export$5e0bdf8bba8d5088,
    CATEGORIES: $1079d16957e265b2$export$a513ea61a7bee91c,
    COMMENT: $1079d16957e265b2$export$a29989082612d0d9,
    CONTACT: $1079d16957e265b2$export$11038cc09fdccb91,
    EXDATE: $1079d16957e265b2$export$133ffe3c8efbf133,
    EXRULE: $1079d16957e265b2$export$7e27a94778a9d7d7,
    RDATE: $1079d16957e265b2$export$3d166b1dacd2503a,
    RELATED_TO: $1079d16957e265b2$export$47a1d4cd38dddc05,
    RESOURCES: $1079d16957e265b2$export$4e841128923ef26,
    RECURRENCE_ID: $1079d16957e265b2$export$1c0dd28c42f2741e,
    URL: $1079d16957e265b2$export$61abde59b50deb8e,
    CREATED: $1079d16957e265b2$export$ff39ebd4bb12b718,
    DTSTAMP: $1079d16957e265b2$export$2ebcefe61501d5fe,
    LAST_MODIFIED: $1079d16957e265b2$export$90812500f628da64,
    ORGANIZER: $1079d16957e265b2$export$5409f4c14bda7ac,
    REQUEST_STATUS: $1079d16957e265b2$export$9fe99b3b71be9378
};
const $1079d16957e265b2$export$38b1323f325ffd22 = {
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    RRULE: $1079d16957e265b2$export$d86ed937a45b0291
};
const $1079d16957e265b2$export$5b9a78912028c06d = 'TZID';
const $1079d16957e265b2$export$20184b745430719e = {
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    TZID: $1079d16957e265b2$export$5b9a78912028c06d
};
const $1079d16957e265b2$export$fb124b4fa837b262 = 'FREQ';
const $1079d16957e265b2$export$4cc4f35131ed029c = 'UNTIL';
const $1079d16957e265b2$export$7dea0e6e08f87a8a = 'INTERVAL';
const $1079d16957e265b2$export$a764ed9c4884f76d = 'BYHOUR';
const $1079d16957e265b2$export$7a96578de7a037b6 = 'BYMINUTE';
const $1079d16957e265b2$export$55bcca3bd8d3041f = 'BYSECOND';
const $1079d16957e265b2$export$f512ea3e90612d03 = 'BYDAY';
const $1079d16957e265b2$export$b3203f635d74ce88 = 'BYMONTH';
const $1079d16957e265b2$export$15623ad945e92c4c = 'BYMONTHDAY';
const $1079d16957e265b2$export$7898bd020dba0a27 = {
    FREQ: $1079d16957e265b2$export$fb124b4fa837b262,
    UNTIL: $1079d16957e265b2$export$4cc4f35131ed029c,
    INTERVAL: $1079d16957e265b2$export$7dea0e6e08f87a8a,
    BYHOUR: $1079d16957e265b2$export$a764ed9c4884f76d,
    BYMINUTE: $1079d16957e265b2$export$7a96578de7a037b6,
    BYSECOND: $1079d16957e265b2$export$55bcca3bd8d3041f,
    BYDAY: $1079d16957e265b2$export$f512ea3e90612d03,
    BYMONTH: $1079d16957e265b2$export$b3203f635d74ce88,
    BYMONTHDAY: $1079d16957e265b2$export$15623ad945e92c4c
};
const $1079d16957e265b2$export$64c81710c321f252 = 'MISSING';
const $1079d16957e265b2$export$ccb33e29d92c9a58 = 'EMPTY';
const $1079d16957e265b2$export$9a105a556e65c2c0 = 'INVALID';
const $1079d16957e265b2$export$f3abe3d006c81602 = 'VALID';

});

parcelRegister("5D9Ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $f056e68da25dd6c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f056e68da25dd6c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    formTitle: {
        "id": "recur-work-item.form-title",
        "defaultMessage": "Set to recur"
    },
    saveButtonText: {
        "id": "recur-work-item.save-button-text",
        "defaultMessage": "Save"
    },
    cancelButtonText: {
        "id": "recur-work-item.cancel-button-text",
        "defaultMessage": "Cancel"
    },
    deleteButtonText: {
        "id": "recur-work-item.delete-button-text",
        "defaultMessage": "Delete"
    },
    recurFieldsLabel: {
        "id": "recur-work-item.recur-fields-label",
        "defaultMessage": "Recur"
    },
    setToRecur: {
        "id": "recur-work-item.set-to-recur",
        "defaultMessage": "Set to recur"
    },
    recursDaily: {
        "id": "recur-work-item.recurs-daily",
        "defaultMessage": "Recurs daily"
    },
    recursEveryWeekday: {
        "id": "recur-work-item.recurs-every-weekday",
        "defaultMessage": "Every weekday (Monday to Friday)"
    },
    recursWeekly: {
        "id": "recur-work-item.recurs-weekly",
        "defaultMessage": "Recurs weekly"
    },
    recursEveryTwoWeeks: {
        "id": "recur-work-item.recurs-every-two-weeks",
        "defaultMessage": "Recurs every 2 weeks"
    },
    recursOnComplete: {
        "id": "recur-work-item.recurs-on-complete",
        "defaultMessage": "Recurs when completed"
    },
    successFlagTitleRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "{issueKey} recurs every week"
    },
    successFlagTitleRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-daily",
        "defaultMessage": "This {issueType} recurs daily when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "This {issueType} recurs every weekday when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "This {issueType} recurs weekly on {weekDayNames} when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "This {issueType} recurs every 2 weeks on {weekDayNames} when completed"
    },
    successFlagTitleRecurOnScheduleDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekly",
        "defaultMessage": "{issueKey} recurs every week on {weekDayNames}"
    },
    successFlagTitleRecurOnScheduleFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks on {weekDayNames}"
    },
    goBackLabel: {
        "id": "recur-work-item.go-back-label",
        "defaultMessage": "Go back"
    },
    errorFlagReloadPageButton: {
        "id": "recur-work-item.error-flag-reload-page-button",
        "defaultMessage": "Reload page"
    },
    errorFlagDescription: {
        "id": "recur-work-item.error-flag-description",
        "defaultMessage": "If this keeps happening, share this information with your admin, who should <link>contact support</link>."
    },
    errorFlagTitle: {
        "id": "recur-work-item.error-flag-title",
        "defaultMessage": "Something went wrong on our end"
    }
});

});



parcelRegister("l9xxv", function(module, exports) {

$parcel$export(module.exports, "setAsNonRecurringIssue", () => $867e9b1c0261db63$export$7b76980c59e9a391);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8zOmE = parcelRequire("8zOmE");

var $lQupu = parcelRequire("lQupu");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");
const $867e9b1c0261db63$export$7b76980c59e9a391 = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, skipDeletingIssueProperties: skipDeletingIssueProperties = false })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { issueProperties: issueProperties, errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        // this can't be !automationRuleUuid because recur-on-complete rules won't have an
        // automationRuleUuid, but they will have issueProperties
        if (!issueProperties) {
            const error = new Error('User is trying to delete a rule before the rule data has been stored.');
            setState({
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (!isSiteAdmin && !isProjectAdmin && !isRuleOwner) {
            const error = new Error('User does not have permission to set issue as non-recurring.');
            setState({
                // TODO: decide if we want to be appending to this list or overwriting it
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId, recurOnScheduleConfig: recurOnScheduleConfig } = issueProperties;
        if (skipDeletingIssueProperties && !ruleUuid) // nothing to do
        return;
        setState({
            isDeletingRule: true
        });
        const analyticsEvent = createAnalyticsEvent({});
        // delete or disable the rule if we know the rule UUID
        if (ruleUuid) try {
            if (isRuleOwner || isSiteAdmin) {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.deleteRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'deleteRule');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule deleted', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            } else {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.disableRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'disableRule');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule disabled', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            }
        } catch (error) {
            // abort if the rule cannot be deleted/disabled
            setState({
                isDeletingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (skipDeletingIssueProperties) {
            // we only get here if we've successfully deleted/disabled a recur-on-schedule rule.
            // it's not possible to re-enable disabled rules, so we can assume that the rule will
            // no longer generate future work items. this means that the issue's issue properties
            // are no longer important to store.
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE)
            });
            return;
        }
        try {
            await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.deleteIssueProperties)({
                issueKey: issueKey
            }), 'deleteIssueProperties');
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE)
            });
        } catch (error) {
            if (!ruleUuid) {
                // in this case, we haven't deleted or disabled the rule, so the rule can still generate
                // future work items. we leave the rule stored in state unchanged and rethrow the error.
                setState({
                    isDeletingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
                throw error;
            }
            // don't rethrow because from the user's perspective, the work item is no longer recurring.
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
        }
    };

});
parcelRegister("lQupu", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $6bdecc95b0135cf9$export$36d128238e6b60f5);
$parcel$export(module.exports, "NO_RULE_PARTIAL_STATE", () => $6bdecc95b0135cf9$export$a1b15f9b9ceb0f70);
const $6bdecc95b0135cf9$export$36d128238e6b60f5 = {
    hasFetched: false,
    isFetching: false,
    isCreatingRule: false,
    isDeletingRule: false,
    isUpdatingRule: false,
    errors: null,
    hasBootstrapError: false,
    isRuleOwner: null,
    issueProperties: null
};
const $6bdecc95b0135cf9$export$a1b15f9b9ceb0f70 = {
    isRuleOwner: null,
    issueProperties: null
};

});


parcelRegister("bvhsR", function(module, exports) {

$parcel$export(module.exports, "setAsRecurringIssue", () => $fe7808073e642503$export$5d9cc8e9f9314f21);

var $7Jxgt = parcelRequire("7Jxgt");

var $8zOmE = parcelRequire("8zOmE");

var $cS75I = parcelRequire("cS75I");

var $ahBjy = parcelRequire("ahBjy");

var $519t2 = parcelRequire("519t2");
const $fe7808073e642503$export$5d9cc8e9f9314f21 = ({ recurOnScheduleConfig: { rRule: rRule, recurCondition: recurCondition, dueDateOffsetSmartValue: dueDateOffsetSmartValue } })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        setState({
            isCreatingRule: true
        });
        const recurrenceToken = (0, $7Jxgt.v4)();
        const templateId = (0, $ahBjy.SOFTWARE_END_USER_TEMPLATE_2);
        const analyticsEvent = createAnalyticsEvent({});
        try {
            const createTemplateResponse = await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $cS75I.createTemplate)({
                environment: environment,
                cloudId: cloudId,
                projectId: projectId,
                recurrenceToken: recurrenceToken,
                recurCondition: recurCondition,
                rRule: rRule,
                dueDateOffsetSmartValue: dueDateOffsetSmartValue
            }), 'createTemplate');
            if (createTemplateResponse?.ruleUuid) {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $cS75I.setIssueProperties)({
                    issueKey: issueKey,
                    recurrenceToken: recurrenceToken,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    recurCondition: recurCondition,
                    rRule: rRule,
                    templateId: templateId,
                    dueDateOffsetSmartValue: dueDateOffsetSmartValue
                }), 'setIssueProperties');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule created', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    templateId: templateId,
                    recurCondition: recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
                const issueProperties = {
                    automationRuleUuid: createTemplateResponse.ruleUuid,
                    token: recurrenceToken,
                    templateId: templateId,
                    recurOnScheduleConfig: {
                        rRule: rRule,
                        dueDateOffsetSmartValue: dueDateOffsetSmartValue,
                        recurCondition: recurCondition
                    }
                };
                setState({
                    isCreatingRule: false,
                    issueProperties: issueProperties,
                    isRuleOwner: true
                });
            } else throw new Error('New rule failed to be created.');
        } catch (error) {
            setState({
                isCreatingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
    };

});
parcelRegister("cS75I", function(module, exports) {

$parcel$export(module.exports, "createTemplate", () => $d425ed86c31f35f6$export$7b7ae612b60e1630);
$parcel$export(module.exports, "setIssueProperties", () => $d425ed86c31f35f6$export$5153917efea4a83d);

var $kV9ss = parcelRequire("kV9ss");

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");

var $ahBjy = parcelRequire("ahBjy");
const $d425ed86c31f35f6$export$7b7ae612b60e1630 = async ({ environment: environment, cloudId: cloudId, projectId: projectId, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const CREATE_TEMPLATE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/public/rest/v1/template/create`;
    const ruleHomeARI = (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    });
    const payload = {
        ruleHome: ruleHomeARI,
        templateId: (0, $ahBjy.SOFTWARE_END_USER_TEMPLATE_2),
        parameters: {
            recurrenceToken: {
                value: recurrenceToken,
                type: 'TEXT'
            },
            rRule: {
                value: rRule,
                type: 'TEXT'
            },
            dueDateOffsetSmartValue: {
                value: dueDateOffsetSmartValue,
                type: 'TEXT'
            },
            recurCondition: {
                value: recurCondition,
                type: 'TEXT'
            }
        }
    };
    return (0, $eusud.performPostRequest)(CREATE_TEMPLATE_URL, {
        body: JSON.stringify(payload)
    });
};
const $d425ed86c31f35f6$export$5153917efea4a83d = async ({ issueKey: issueKey, ruleUuid: ruleUuid, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, templateId: templateId, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const issuePropertiesEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    const requestBody = {
        automationRuleUuid: ruleUuid,
        token: recurrenceToken,
        templateId: templateId,
        recurOnScheduleConfig: {
            rRule: rRule,
            dueDateOffsetSmartValue: dueDateOffsetSmartValue,
            recurCondition: recurCondition
        }
    };
    return (0, $eusud.performPutRequest)(issuePropertiesEndpoint, {
        body: JSON.stringify(requestBody)
    });
};

});


parcelRegister("c8g0F", function(module, exports) {

$parcel$export(module.exports, "updateRule", () => $257e932348ccd8c0$export$b2ebf395d72c5a4c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8zOmE = parcelRequire("8zOmE");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");

var $bvhsR = parcelRequire("bvhsR");

var $l9xxv = parcelRequire("l9xxv");
const $257e932348ccd8c0$export$b2ebf395d72c5a4c = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, recurOnScheduleConfig: recurOnScheduleConfig })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey })=>{
        const { issueProperties: issueProperties, errors: errors } = getState();
        if (!issueProperties) {
            // if there is no existing rule, then create a new rule and update issue properties
            await dispatch((0, $bvhsR.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            return;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId } = issueProperties;
        setState({
            isUpdatingRule: true
        });
        try {
            await dispatch((0, $l9xxv.setAsNonRecurringIssue)({
                isProjectAdmin: isProjectAdmin,
                isRuleOwner: isRuleOwner,
                isSiteAdmin: isSiteAdmin,
                // we'll update issue properties later
                skipDeletingIssueProperties: true
            }));
        } catch (error) {
            // don't need to save the error to state because setAsNonRecurringIssue should already do this
            setState({
                isUpdatingRule: false
            });
            throw error;
        }
        // create the new rule
        try {
            await dispatch((0, $bvhsR.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'recurringRule updated', {
                issueKey: // TODO: add ruleId attribute
                issueKey,
                ruleUuid: ruleUuid,
                templateId: templateId,
                recurCondition: recurOnScheduleConfig?.recurCondition,
                isUpdateForExistingRule: true
            });
            setState({
                isUpdatingRule: false
            });
        } catch (error) {
            // if we fail to create the rule and update issue properties, then we need to go back and remove the
            // original recurring rule config from issue properties
            try {
                setState({
                    isDeletingRule: true
                });
                await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $fAJ3G.deleteIssueProperties)({
                    issueKey: issueKey
                }), 'deleteIssueProperties');
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    issueProperties: null,
                    isRuleOwner: null,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
            } catch (anotherError) {
                // we've made no changes to the rule config since we called `setAsNonRecurringIssue` above,
                // so we don't need to update ruleSummary or issueProperties.
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error,
                        anotherError
                    ]
                });
                throw anotherError;
            }
            // we've just successfully deleted the existing rule; we haven't actually created a new one.
            throw error;
        }
    };

});



parcelRegister("CKlOf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d9e9728e1365538b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d9e9728e1365538b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    overdue: {
        "id": "business.list.ui.list-view.date-cell.overdue",
        "defaultMessage": "Overdue since {date}"
    },
    due: {
        "id": "business.list.ui.list-view.date-cell.due",
        "defaultMessage": "Due on {date}"
    }
});

});


parcelRegister("cNoIA", function(module, exports) {

$parcel$export(module.exports, "DateWithUrgencyIndicator", () => $2daf46ef768149e4$export$31bba0fc7d099434);

var $5uXOq = parcelRequire("5uXOq");

var $hyKRO = parcelRequire("hyKRO");

var $34Rrn = parcelRequire("34Rrn");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8tRRd = parcelRequire("8tRRd");

var $3MR3Z = parcelRequire("3MR3Z");

var $dCm1o = parcelRequire("dCm1o");

var $cSD7y = parcelRequire("cSD7y");

var $kVPfJ = parcelRequire("kVPfJ");
const $2daf46ef768149e4$var$DateWithUrgencyIndicatorOld = ({ value: value, formattedDateString: formattedDateString })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { formatDateOnly: formatDateOnly } = (0, $8tRRd.useDateTimeFormatter)();
    const [daysBetweenTodayAndValue, setDaysBetweenTodayAndValue] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        setDaysBetweenTodayAndValue((0, $3MR3Z.getNoOfDaysSinceUTCDateString)(value));
    }, [
        value
    ]);
    const formattedDate = formattedDateString || formatDateOnly(value);
    const dueMessage = daysBetweenTodayAndValue === 0 ? formatMessage((0, $kVPfJ.default).dueToday) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $kVPfJ.default).dueIn,
        values: {
            daysBetween: daysBetweenTodayAndValue
        }
    });
    const isDatePast = daysBetweenTodayAndValue != null && daysBetweenTodayAndValue >= 0;
    const Icon = daysBetweenTodayAndValue === 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))) : (0, (/*@__PURE__*/$parcel$interopDefault($34Rrn)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        testId: "date-with-urgency-indicator.container",
        gap: "space.075"
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $2daf46ef768149e4$var$baseStyles,
            isDatePast ? $2daf46ef768149e4$var$redBackgroundStyle : false
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: isDatePast ? 'color.text.accent.red' : 'color.text.accent.gray.bolder'
    }, formattedDate)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $2daf46ef768149e4$var$baseStyles,
            isDatePast ? $2daf46ef768149e4$var$redBackgroundStyle : $2daf46ef768149e4$var$greyBackgroundStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: isDatePast ? 'color.text.accent.red' : 'color.text.accent.gray.bolder'
    }, formattedDate)), isDatePast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: dueMessage,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        LEGACY_size: "medium",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: "date-with-urgency-indicator.warning-icon"
    })));
};
const $2daf46ef768149e4$var$DateWithUrgencyIndicatorNew = ({ value: value, formattedDateString: formattedDateString })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { formatDateOnly: formatDateOnly } = (0, $8tRRd.useDateTimeFormatter)();
    const daysBetweenTodayAndValue = (0, $5uXOq.useMemo)(()=>(0, $3MR3Z.getNoOfDaysSinceUTCDateString)(value), [
        value
    ]);
    const formattedDate = (0, $5uXOq.useMemo)(()=>formattedDateString || formatDateOnly(value), [
        formattedDateString,
        formatDateOnly,
        value
    ]);
    const dueMessage = daysBetweenTodayAndValue === 0 ? formatMessage((0, $kVPfJ.default).dueToday) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $kVPfJ.default).dueIn,
        values: {
            daysBetween: daysBetweenTodayAndValue
        }
    });
    const isDatePast = daysBetweenTodayAndValue != null && daysBetweenTodayAndValue >= 0;
    const Icon = daysBetweenTodayAndValue === 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))) : (0, (/*@__PURE__*/$parcel$interopDefault($34Rrn)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        testId: "date-with-urgency-indicator.container",
        gap: "space.075"
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $2daf46ef768149e4$var$baseStyles,
            isDatePast ? $2daf46ef768149e4$var$redBackgroundStyle : false
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: isDatePast ? 'color.text.accent.red' : 'color.text.accent.gray.bolder'
    }, formattedDate)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $2daf46ef768149e4$var$baseStyles,
            isDatePast ? $2daf46ef768149e4$var$redBackgroundStyle : $2daf46ef768149e4$var$greyBackgroundStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: isDatePast ? 'color.text.accent.red' : 'color.text.accent.gray.bolder'
    }, formattedDate)), isDatePast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: dueMessage,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        LEGACY_size: "medium",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: "date-with-urgency-indicator.warning-icon"
    })));
};
const $2daf46ef768149e4$export$31bba0fc7d099434 = (0, $cSD7y.componentWithFG)('fix_date_field_rerenders_iv_llc_fields', $2daf46ef768149e4$var$DateWithUrgencyIndicatorNew, $2daf46ef768149e4$var$DateWithUrgencyIndicatorOld);
const $2daf46ef768149e4$var$baseStyles = (0, $8CUq3.xcss)({
    padding: 'space.025',
    borderRadius: '3px'
});
const $2daf46ef768149e4$var$redBackgroundStyle = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.red.subtlest',
    ':hover': {
        backgroundColor: 'color.background.accent.red.subtlest.hovered'
    },
    minWidth: '92px'
});
const $2daf46ef768149e4$var$greyBackgroundStyle = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    ':hover': {
        backgroundColor: 'color.background.accent.gray.subtlest.hovered'
    },
    minWidth: '92px'
});

});
parcelRegister("8tRRd", function(module, exports) {

$parcel$export(module.exports, "useDateTimeFormatter", () => $e6616d5994c4d841$export$163f492669f74d5b);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $cYlk7 = parcelRequire("cYlk7");

var $DVljb = parcelRequire("DVljb");

var $1YbNB = parcelRequire("1YbNB");

var $6yeNV = parcelRequire("6yeNV");
const $e6616d5994c4d841$export$163f492669f74d5b = (overrideTimeZone)=>{
    (0, $gKZoD.di)(Intl);
    const { data: { // @ts-expect-error - TS2339 - Property 'timeZone' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    user: { timeZone: timeZonePreference } } } = (0, $cYlk7.useCurrentUser)();
    const timeZone = overrideTimeZone ?? timeZonePreference;
    const jiraLocal = (0, $DVljb.useLocale)();
    const standardizedLocale = (0, $6yeNV.standardizeLocale)(jiraLocal);
    const verifiedTimeZone = (0, $6yeNV.verifyTimeZone)(timeZone);
    const dateTimeFormatter = (0, $5uXOq.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $1YbNB.longDateTimeFormat),
            timeZone: verifiedTimeZone
        }), [
        standardizedLocale,
        verifiedTimeZone
    ]);
    const dateOnlyFormatter = (0, $5uXOq.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $1YbNB.longDateOnlyFormat),
            timeZone: 'UTC'
        }), [
        standardizedLocale
    ]);
    const formatDateTime = (0, $5uXOq.useCallback)((date)=>{
        const rawValue = typeof date === 'string' ? new Date(date) : date;
        return dateTimeFormatter.format(rawValue);
    }, [
        dateTimeFormatter
    ]);
    const formatDateOnly = (0, $5uXOq.useCallback)((date)=>dateOnlyFormatter.format(new Date(date)), [
        dateOnlyFormatter
    ]);
    return {
        formatDateTime: /**
		 * Returns the long form of a date value with respect to the user's locale and timezone preferences
		 *
		 * @param {string|number|date} date Value as either an [ISO8601 string](https://www.w3.org/TR/NOTE-datetime) (eg `"1997-07-16T19:20:30.45+01:00"`), epoch number (eg `1615431020`), or vanilla `Date` object
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021, 1:11 PM
		 * formatDateTime(1611281490857) // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日 午後1:11
		 * formatDateTime(1611281490857) // where user locale is "ja-JP"
		 * ```
		 */ formatDateTime,
        formatDateOnly: /**
		 * Returns the long form of a date without time value with respect to the user's locale. Timezones do not apply to these dates.
		 *
		 * @param {string} date Value as a 'YYYY-MM-DD' string (eg `"1997-07-16"`)
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021
		 * formatDateOnly('2021-01-22') // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日
		 * formatDateOnly('2021-01-22') // where user locale is "ja-JP"
		 * ```
		 */ formatDateOnly
    };
};

});
parcelRegister("1YbNB", function(module, exports) {

$parcel$export(module.exports, "longDateTimeFormat", () => $71114821d9cd9835$export$f2f390060309965);
$parcel$export(module.exports, "longDateOnlyFormat", () => $71114821d9cd9835$export$51f819d50bcd4ae1);
/**
 * If this file gets changed, please update platform/packages/proforma/proforma-common-core/src/form-system/components/questions/common/defaultDateTimeFormats.tsx or let the owners know via #jsm-request-intake.
 *
 * Proforma wants to stay consistent with Jira date and time format options.
 *
 * Later on Proforma will introduce React Context to pass config props, and this will be removed.
 */ /**
 * Long format of a date time, eg "Jun 16, 1971, 2:34 AM" with 12h/24h formatting resolved from locale
 */ const $71114821d9cd9835$export$f2f390060309965 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $71114821d9cd9835$export$51f819d50bcd4ae1 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
};

});

parcelRegister("6yeNV", function(module, exports) {

$parcel$export(module.exports, "standardizeLocale", () => $e3b19be89da6c3f8$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $e3b19be89da6c3f8$export$93ff13646da25bd);

var $lzeFL = parcelRequire("lzeFL");

var $2YZCu = parcelRequire("2YZCu");
const $e3b19be89da6c3f8$export$95b7602913551865 = 'en-US';
const $e3b19be89da6c3f8$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$e3b19be89da6c3f8$export$95b7602913551865}.`);
        return $e3b19be89da6c3f8$export$95b7602913551865;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $lzeFL.default).includes(jiraLocale)) (0, $2YZCu.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $e3b19be89da6c3f8$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($e3b19be89da6c3f8$export$95b7602913551865, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});


parcelRegister("3MR3Z", function(module, exports) {

$parcel$export(module.exports, "getIsUTCDatePastOrDueSoon", () => $bf96c076ca2cb35f$export$3d094644d6bd82b9);
$parcel$export(module.exports, "getNoOfDaysSinceUTCDateString", () => $bf96c076ca2cb35f$export$7f4e2d0c87567b43);

var $4kK95 = parcelRequire("4kK95");
/**
 * Normalizes a given date by removing the time component.
 *
 * @param {Date} date - The date to be normalized.
 * @returns {Date} - The normalized date without the time component.
 */ const $bf96c076ca2cb35f$var$normalizeDate = (date)=>new Date(date.getFullYear(), date.getMonth(), date.getDate());
/**
 * Adds a specified number of days to a given date.
 *
 * @param date - The date to which the days should be added.
 * @param days - The number of days to add.
 * @returns The new date after adding the specified number of days.
 */ const $bf96c076ca2cb35f$var$datePlusXDays = (date, days)=>$bf96c076ca2cb35f$var$normalizeDate(new Date(date.getTime() + days * 86400000));
const $bf96c076ca2cb35f$export$9417a5d0968b488e = (dateString, dueDaysOffset = 7)=>{
    if (!dateString) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    const date = $bf96c076ca2cb35f$var$normalizeDate(new Date(dateString));
    if (Number.isNaN(date.getTime())) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    const TODAY = $bf96c076ca2cb35f$var$normalizeDate(new Date());
    const TODAY_PLUS_DUE_DAYS_OFFSET = $bf96c076ca2cb35f$var$datePlusXDays(TODAY, dueDaysOffset);
    const isDueDatePast = date.getTime() === TODAY.getTime() || date < TODAY;
    const isDueSoon = !isDueDatePast && date < TODAY_PLUS_DUE_DAYS_OFFSET;
    return {
        isDueDatePast: isDueDatePast,
        isDueSoon: isDueSoon
    };
};
const $bf96c076ca2cb35f$export$3d094644d6bd82b9 = (dateString, dueDaysOffset = 7)=>{
    if (!dateString) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    let inputDateInISO;
    try {
        inputDateInISO = (0, $4kK95.DateOnly).fromISODateString(dateString).toLocalDate();
    } catch (e) {
        return {
            isDueDatePast: false,
            isDueSoon: false
        };
    }
    const TODAY = (0, $4kK95.DateOnly).fromDateAccordingToLocalTime(new Date()).toLocalDate();
    const TODAY_PLUS_DUE_DAYS_OFFSET = $bf96c076ca2cb35f$var$datePlusXDays(TODAY, dueDaysOffset);
    const isDueDatePast = inputDateInISO.getTime() === TODAY.getTime() || inputDateInISO < TODAY;
    const isDueSoon = !isDueDatePast && inputDateInISO < TODAY_PLUS_DUE_DAYS_OFFSET;
    return {
        isDueDatePast: isDueDatePast,
        isDueSoon: isDueSoon
    };
};
const $bf96c076ca2cb35f$export$7f4e2d0c87567b43 = (dateString)=>{
    if (!dateString) return null;
    let inputDateInISO;
    try {
        inputDateInISO = (0, $4kK95.DateOnly).fromISODateString(dateString).toLocalDate();
    } catch (e) {
        return null;
    }
    const TODAY = (0, $4kK95.DateOnly).fromDateAccordingToLocalTime(new Date()).toLocalDate();
    const daysBetween = Math.floor((TODAY.getTime() - inputDateInISO.getTime()) / 86400000);
    return daysBetween;
};

});
parcelRegister("4kK95", function(module, exports) {

$parcel$export(module.exports, "DateOnly", () => $a1048e23edd181e2$export$988b361b394263b6);
$parcel$export(module.exports, "toDateOnly", () => $a1048e23edd181e2$export$b0961ad8aee63b8b);
const $a1048e23edd181e2$export$9cda9b56d134780f = 'Invalid date or date format';
const $a1048e23edd181e2$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
const $a1048e23edd181e2$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
const $a1048e23edd181e2$var$daysInMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
/**
 Returns a boolean to indicate that the date specified is valid.

 Note: Dates before Year zero are treated to be invalid.
 */ const $a1048e23edd181e2$var$isDateValid = (year, month, day)=>{
    if ([
        year,
        month,
        day
    ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
    if (year < 0) return false;
    if (month < 1 || month > 12) return false;
    if (day < 1) return false;
    if (day > (month === 2 && $a1048e23edd181e2$var$isLeapYear(year) ? 29 : $a1048e23edd181e2$var$daysInMonth[month - 1])) return false;
    return true;
};
const $a1048e23edd181e2$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
class $a1048e23edd181e2$export$988b361b394263b6 {
    /**
	 * Return true if the string is a valid ISO date string in the format 'YYYY-MM-DD'.
	 * @param dateString
	 * @returns {boolean}
	 */ static isISODateString(dateString) {
        try {
            $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(dateString);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e?.message === $a1048e23edd181e2$export$9cda9b56d134780f) return false;
            throw e;
        }
        return true;
    }
    /**
	 * Create a DateOnly object from a string in the format 'YYYY-MM-DD'.
	 */ // go/jfe-eslint
    static fromISODateString(dateString) {
        const matches = $a1048e23edd181e2$var$dateFormatRegExp.exec(dateString);
        if (matches === null) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
        const [, year, month, day] = matches;
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        return new $a1048e23edd181e2$export$988b361b394263b6(...[
            year,
            month,
            day
        ].map((s)=>Number.parseInt(s, 10)));
    }
    /**
	 * DISCLAIMER:
	 * Date() does NOT store timezone information.
	 *
	 * Date.prototype.toString() leverages the system's timezone to serialize it into a string according to local time.
	 * Methods getDate(), getMonth(), getFullYear() behave the same and also return values according to local time.
	 *
	 * Methods toUTCString(), getUTCDate(), getUTCMonth(), getUTCFullYear() return values according to universal time.
	 *
	 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
	 */ /**
	 * Create a DateOnly object that reflects the local year, month & day for the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToLocalTime(date) {
        return new $a1048e23edd181e2$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    /**
	 * Create a DateOnly object that reflects the UTC year, month & day of the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToUTC(date) {
        return new $a1048e23edd181e2$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
    }
    /**
	 * Compare 2 DateOnly objects.
	 *
	 * (Similar to the TC39 proposal Temporal.PlainDate.compare).
	 *
	 * If a comes before b, return -1.
	 * If a is equal to b, return 0.
	 * If a is greater than b, return 1.
	 */ static compare(a, b) {
        if (a.year === b.year) {
            if (a.month === b.month) {
                if (a.day === b.day) return 0;
                return a.day < b.day ? -1 : 1;
            }
            return a.month < b.month ? -1 : 1;
        }
        return a.year < b.year ? -1 : 1;
    }
    /**
	 * Create a DateOnly object which represents a day. It does not have a time component.
	 * @param year - A year, ranging between 0 and 9999 inclusive.
	 * @param month - A month, ranging between 1 and 12 inclusive.
	 * @param day - A day of the month, ranging between 1 and 31 inclusive.
	 */ constructor(year, month, day){
        if (!$a1048e23edd181e2$var$isDateValid(year, month, day)) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    getYear() {
        return this.year;
    }
    getMonth() {
        return this.month;
    }
    getDay() {
        return this.day;
    }
    toISOString() {
        return $a1048e23edd181e2$var$toISOString(this.year, this.month, this.day);
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 which corresponds to the UTC timezone.
	 */ toUTCDate() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day));
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 for the local timezone.
	 */ toLocalDate() {
        // take the current date (e.g. 1.06.2020)
        const localDate = new Date();
        // store current month in a const to compare below
        const currentMonth = localDate.getMonth();
        // set the year
        localDate.setFullYear(this.year);
        localDate.setHours(0);
        localDate.setMinutes(0);
        localDate.setSeconds(0);
        localDate.setMilliseconds(0);
        localDate.setDate(this.day);
        // if this.day doesn't exist in the current month (e.g. 31 doesn't exist in June ),
        // it will set the month to July instead. We need to make sure setDate doesn't change the month
        if (localDate.getMonth() !== currentMonth) {
            localDate.setMonth(this.month - 1);
            // reset the date after updating the month
            localDate.setDate(this.day);
        } else localDate.setMonth(this.month - 1);
        return localDate;
    }
    equals(dateOnly) {
        return $a1048e23edd181e2$export$988b361b394263b6.compare(this, dateOnly) === 0;
    }
}
const $a1048e23edd181e2$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;

});


parcelRegister("kVPfJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $caed967898a0f524$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $caed967898a0f524$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dueToday: {
        "id": "date-with-urgency-indicator.due-today",
        "defaultMessage": "Due today"
    },
    dueIn: {
        "id": "date-with-urgency-indicator.due-in",
        "defaultMessage": "{daysBetween} {daysBetween, plural, one {day} other {days}} overdue"
    }
});

});


parcelRegister("JqOmc", function(module, exports) {

$parcel$export(module.exports, "default", () => $930175ddb53b5937$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $930175ddb53b5937$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-date-readview-full.date.no-value-text-experiment",
        "defaultMessage": "Add date"
    },
    noValueTextExperimentDueDate: {
        "id": "issue-field-date-readview-full.date.no-value-text-experiment-due-date",
        "defaultMessage": "Add due date"
    }
});

});


parcelRegister("kbVcX", function(module, exports) {

$parcel$export(module.exports, "useDateValidator", () => $7a93120a08242883$export$bb028423d75e7237);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $es0kv = parcelRequire("es0kv");
const $7a93120a08242883$export$bb028423d75e7237 = (fieldName, isRequired)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const submit = (0, $5uXOq.useCallback)((value)=>{
        if (isRequired && (!value || value.trim().length === 0)) return {
            type: 'error',
            message: formatMessage((0, $es0kv.messages).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("es0kv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $df904c31386a3e98$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $df904c31386a3e98$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-field-date-inline-edit-full.date.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});

});




parcelRegister("8mdOM", function(module, exports) {

$parcel$export(module.exports, "DateTimeCell", () => $df6ef226a27c264f$export$372b87ceae2922a4);

var $fFHHz = parcelRequire("fFHHz");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $katAh = parcelRequire("katAh");

var $65VLO = parcelRequire("65VLO");

var $Br57E = parcelRequire("Br57E");

var $jFYC8 = parcelRequire("jFYC8");

var $e9M6d = parcelRequire("e9M6d");
const $df6ef226a27c264f$export$372b87ceae2922a4 = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $fFHHz.default), fieldRef);
    const isCreatedOrUpdated = data.type === (0, $65VLO.KNOWN_COLUMN_TYPES).CREATED || data.type === (0, $65VLO.KNOWN_COLUMN_TYPES).UPDATED;
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isInlineEditingSupported = !isCreatedOrUpdated && isInlineEditingExtendedFieldSupportEnabled;
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    // We can also disable editability of the created/updated fields as they are never editable.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingSupported ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $katAh.DateTimeInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        readViewFitContainerHeight: true,
        isAutoFocusFixEnabled: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
};

});
parcelRegister("fFHHz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d632e90bb034e724$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f40040f20e49a676e75cea1191e3dde3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d632e90bb034e724$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "dateTime_nativeIssueTable_DateTimeCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$d632e90bb034e724$var$node.hash = "b976a3c6a5f97459d63599a3152d13cd";
var $d632e90bb034e724$export$2e2bcd8739ae039 = $d632e90bb034e724$var$node;

});

parcelRegister("katAh", function(module, exports) {

$parcel$export(module.exports, "DateTimeInlineEditViewWithIsEditable", () => $6403ba36308225bd$export$40278230a655efcf);
$parcel$export(module.exports, "DateTimeInlineEditView", () => $6403ba36308225bd$export$2044e876297ff5d7);

var $gcxLJ = parcelRequire("gcxLJ");

var $Pz9tH = parcelRequire("Pz9tH");

var $grcZz = parcelRequire("grcZz");

var $4Rdfm = parcelRequire("4Rdfm");

var $1WNVu = parcelRequire("1WNVu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $k7m40 = parcelRequire("k7m40");

var $1SrMX = parcelRequire("1SrMX");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $i0vxP = parcelRequire("i0vxP");

var $b71gk = parcelRequire("b71gk");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $8tf7c = parcelRequire("8tf7c");

var $4M7GZ = parcelRequire("4M7GZ");

var $36gqy = parcelRequire("36gqy");

var $j0FAD = parcelRequire("j0FAD");

var $jrRyX = parcelRequire("jrRyX");

var $DVljb = parcelRequire("DVljb");

var $6yeNV = parcelRequire("6yeNV");

var $Fn2Vl = parcelRequire("Fn2Vl");

var $gGpyR = parcelRequire("gGpyR");

var $adLrP = parcelRequire("adLrP");

var $dCm1o = parcelRequire("dCm1o");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $cSD7y = parcelRequire("cSD7y");

var $jcw0u = parcelRequire("jcw0u");

var $8CBGY = parcelRequire("8CBGY");

var $5Rur0 = parcelRequire("5Rur0");
const $6403ba36308225bd$export$7525482b5931e326 = 'dateTimeFieldInlineEdit'; /**
                                                          * DateTimeInlineEditView Component will handle the switching behaviour between the 'readView' and 'editView' components
                                                          * @param props {@link DateTimeInlineEditView}
                                                          *
                                                          * we also want to finalise if we need areActionButtonsHidden here or not
                                                          * */ 
const $6403ba36308225bd$var$DateTimeInlineEditViewOld = ({ fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, timeZone: timeZone })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $1WNVu.default), fragmentRef);
    const { id: uniqueFieldId, fieldConfig: fieldConfig, dateTime: dateTime } = data;
    const [commit] = (0, $8Uumt.useMutation)((0, $4Rdfm.default)); // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isEditing, setIsEditing] = (0, $adLrP.useOptionallyControlledEditingState)(startWithEditViewOpen, uniqueFieldId);
    const [newValue, setNewValue] = (0, $5uXOq.useState)(dateTime ?? null);
    const [newTimeValue, setNewTimeValue] = (0, $5uXOq.useState)(null);
    const [newDateValue, setNewDateValue] = (0, $5uXOq.useState)(null);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const locale = (0, $DVljb.useLocale)();
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overriding.overrideIsEditable(fieldConfig?.isEditable || false), [
        fieldConfig?.isEditable,
        overriding
    ]); // #endregion
    // #region Handle new value
    const onEditRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        setError(null);
        setIsEditing(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    }, [
        setError,
        setIsEditing
    ]);
    const handleErrors = (0, $5uXOq.useCallback)((incomingError)=>{
        setError(incomingError);
        setIsEditing(true);
        setNewValue(dateTime ?? null);
    }, [
        setError,
        setIsEditing,
        setNewValue,
        dateTime
    ]);
    const onCancelRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        if (analyticsEvent && analyticsEvent instanceof KeyboardEvent && 'stopPropagation' in analyticsEvent && (0, $6s1PB.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true)) {
            analyticsEvent.stopPropagation();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'canceled',
                actionSubject: 'dateTimeFieldInlineEdit'
            }));
        } else if ((0, $1SrMX.isUIAnalyticsEvent)(analyticsEvent)) (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        setError(null);
        setIsEditing(false);
    }, [
        setError,
        setIsEditing,
        createAnalyticsEvent
    ]);
    const handleNewValue = (0, $5uXOq.useCallback)((newDateTime)=>{
        onSubmit?.(newDateTime);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        datetime: newDateTime ?? null,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateDateTimeField) {
                    const { success: success, errors: responseErrors } = mutationData.jira?.updateDateTimeField;
                    if (success) {
                        onSubmitSucceeded?.(newDateTime);
                        return;
                    }
                    onSubmitFailed?.();
                    if (responseErrors != null && responseErrors.length > 0) handleErrors(new Error(responseErrors[0].message != null ? responseErrors[0].message : undefined));
                }
            },
            onError (incomingError) {
                handleErrors(incomingError);
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            optimisticResponse: {
                jira: {
                    updateDateTimeField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            dateTime: newDateTime
                        }
                    }
                }
            }
        });
        setIsEditing(false);
    }, [
        commit,
        handleErrors,
        onSubmit,
        onSubmitFailed,
        onSubmitSucceeded,
        setIsEditing,
        uniqueFieldId
    ]);
    const onConfirm = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        if ((0, $6s1PB.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true)) {
            if (!newValue && (newDateValue || newTimeValue)) {
                const constructedValue = (0, $8CBGY.constructDateTimeFromPartialData)(newDateValue, newTimeValue);
                setNewValue(constructedValue);
                const date = new Date(constructedValue);
                setNewDateValue((0, $k7m40.default)(date, 'yyyy-MM-dd'));
                setNewTimeValue((0, $k7m40.default)(date, 'HH:mm'));
                handleNewValue(constructedValue);
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
            } else {
                handleNewValue(newValue);
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
            }
        } else {
            handleNewValue(newValue);
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        }
    }, [
        newValue,
        newDateValue,
        newTimeValue,
        handleNewValue
    ]);
    const onChange = (0, $5uXOq.useCallback)((value)=>{
        if ((0, $6s1PB.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true)) {
            if (!value) {
                handleNewValue(value);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'confirmed',
                    actionSubject: 'dateTimeFieldInlineEdit'
                }));
            }
        }
        setError(null);
        setNewValue(value);
    }, [
        setNewValue,
        handleNewValue,
        createAnalyticsEvent
    ]);
    const onDateChange = (newDate)=>{
        setNewDateValue(newDate);
    };
    const onTimeChange = (newTime)=>{
        setNewTimeValue(newTime);
    };
    const timePlaceholder = (0, $5uXOq.useMemo)(()=>{
        const standardizedLocale = (0, $6yeNV.standardizeLocale)(locale);
        return (0, $8CBGY.getNext30MinuteInterval)(undefined, standardizedLocale);
    }, [
        locale
    ]);
    const datePlaceholder = (0, $5uXOq.useMemo)(()=>{
        let formattedDate = '';
        try {
            formattedDate = (0, $8CBGY.getFormattedDate)(locale);
        } catch (dateFormatError) {
            (0, $jcw0u.default)({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: dateFormatError,
                meta: {
                    packageName: 'dateTimeFieldInlineEdit',
                    id: 'formatDateError'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return formattedDate;
    }, [
        locale
    ]); // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Fn2Vl.ReadViewContainer), {
            "data-testid": "issue-field-date-time-inline-edit-full.ui.date-time.read-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j0FAD.DateTimeReadView), {
            fragmentRef: data,
            timeZone: timeZone
        })); // #endregion
    // #region Edit view
    const renderEditView = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6403ba36308225bd$var$EditViewContainer, {
            "data-testid": "issue-field-date-time-inline-edit-full.ui.date-time.edit-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4M7GZ.DateTimeEditView), {
            ...(0, $6s1PB.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true) ? {
                autoFocus: true,
                defaultIsOpen: true,
                spacing: 'compact',
                datePlaceholder: datePlaceholder,
                timePlaceholder: timePlaceholder,
                onDateChange: onDateChange,
                onTimeChange: onTimeChange
            } : {},
            value: newValue,
            onChange: onChange,
            timeZone: timeZone
        })));
    }; // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "Field(DateTime)",
        prefixOverride: "issue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
        onEscape: onCancelRequest
    }, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tf7c.ErrorFlag), {
        description: (0, $5Rur0.default).errorMessage,
        error: error,
        title: (0, $5Rur0.default).errorTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Fn2Vl.InlineEditContainer), {
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gGpyR.FieldInlineEditStateLess), {
        testId: "issue-field-date-time-inline-edit-full.ui.date-time.field-date-time",
        fieldId: (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? uniqueFieldId : undefined,
        isEditing: isEditing,
        areActionButtonsHidden: true,
        actionSubject: $6403ba36308225bd$export$7525482b5931e326,
        isEditable: isFieldEditable,
        readView: renderReadView,
        editView: renderEditView,
        onCancel: onCancelRequest,
        onConfirm: onConfirm,
        onEdit: onEditRequest,
        defaultValue: null
    }))));
};
const $6403ba36308225bd$export$40278230a655efcf = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, timeZone: timeZone, isAutoFocusFixEnabled: isAutoFocusFixEnabled, readViewDateOnlyFormat: readViewDateOnlyFormat, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $grcZz.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, name: fieldName, type: type, dateTime: dateTime } = data;
    const [commit] = (0, $8Uumt.useMutation)((0, $Pz9tH.default)); // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const locale = (0, $DVljb.useLocale)();
    const initialValue = dateTime ?? null;
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overriding.overrideIsEditable(isEditable), [
        isEditable,
        overriding
    ]); // #endregion
    // #region Handle new value
    const handleSubmit = (0, $5uXOq.useCallback)((newDateTime, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newDateTime);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        datetime: newDateTime ?? null,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateDateTimeField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateDateTimeField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            dateTime: newDateTime
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        clipboardComponentType: 'dateTime'
    }); // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j0FAD.DateTimeReadView), {
            fragmentRef: data,
            timeZone: timeZone,
            isDateOnlyFormat: readViewDateOnlyFormat,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        }); // #endregion
    // #region Edit view
    const timePlaceholder = (0, $5uXOq.useMemo)(()=>{
        const standardizedLocale = (0, $6yeNV.standardizeLocale)(locale);
        return (0, $8CBGY.getNext30MinuteInterval)(undefined, standardizedLocale);
    }, [
        locale
    ]);
    const datePlaceholder = (0, $5uXOq.useMemo)(()=>{
        let formattedDate = '';
        try {
            formattedDate = (0, $8CBGY.getFormattedDate)(locale);
        } catch (dateFormatError) {
            (0, $jcw0u.default)({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: dateFormatError,
                meta: {
                    packageName: 'dateTimeFieldInlineEdit',
                    id: 'formatDateError'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return formattedDate;
    }, [
        locale
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: isAutoFocusFixEnabled,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            timeZone: timeZone,
            ...(0, $6s1PB.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true) ? {
                autoFocus: true,
                spacing: spacing,
                datePlaceholder: datePlaceholder,
                timePlaceholder: timePlaceholder
            } : {}
        }); // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $36gqy.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $6403ba36308225bd$export$3babe8d01dc38aca = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $gcxLJ.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6403ba36308225bd$export$40278230a655efcf, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};
const $6403ba36308225bd$export$2044e876297ff5d7 = (0, $cSD7y.componentWithFG)('jsc_inline_editing_field_refactor', $6403ba36308225bd$export$3babe8d01dc38aca, $6403ba36308225bd$var$DateTimeInlineEditViewOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6403ba36308225bd$var$EditViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1pby1kze" : "_1pbyowjs",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gcxLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b88a7092c1f5fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ff168d0c48feb770d902c19b185aa605>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $09b88a7092c1f5fe$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewNew_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraDateTimePickerField"
};
$09b88a7092c1f5fe$var$node.hash = "eeb23ad7c37c54cf808653965b7bf769";
var $09b88a7092c1f5fe$export$2e2bcd8739ae039 = $09b88a7092c1f5fe$var$node;

});

parcelRegister("Pz9tH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e1556388970f604$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<35b0d1b8dda4ba883b598557010413d2>>
 * @relayHash b962bde817ae9133f076383673744639
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52b99b4d5da7ae41fc7cea0050d5a473435a64cac29f4d8502862f446fbffbc0
const $4e1556388970f604$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "dateTime"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateTimeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateTimeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraDateTimePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateTimeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateTimeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraDateTimePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "52b99b4d5da7ae41fc7cea0050d5a473435a64cac29f4d8502862f446fbffbc0",
            "metadata": {},
            "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$4e1556388970f604$var$node.hash = "e0c0e1ca810b79fb98a05142a47ace9e";
var $4e1556388970f604$export$2e2bcd8739ae039 = $4e1556388970f604$var$node;

});

parcelRegister("grcZz", function(module, exports) {

$parcel$export(module.exports, "default", () => $529de4d037950a1a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf046c3fc1d1cb9d3c8a8b0339c689f5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $529de4d037950a1a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$529de4d037950a1a$var$node.hash = "e7911508d34079b211453d8cdb4bbc3d";
var $529de4d037950a1a$export$2e2bcd8739ae039 = $529de4d037950a1a$var$node;

});

parcelRegister("4Rdfm", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd233c2818a2290c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf44c1d99ad8ee8656c194a9a3f356f4>>
 * @relayHash 1b42d3ae71d08906518143d93b5393d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2c4a5297dcf7456a85d37e509ecffb6458d390684805ae3fdc6ac19dec04468f
const $dd233c2818a2290c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "dateTime"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dateTime_issueFieldDateTime_DateTimeFieldOld_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateTimeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateTimeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraDateTimePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dateTime_issueFieldDateTime_DateTimeFieldOld_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateTimeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateTimeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraDateTimePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2c4a5297dcf7456a85d37e509ecffb6458d390684805ae3fdc6ac19dec04468f",
            "metadata": {},
            "name": "dateTime_issueFieldDateTime_DateTimeFieldOld_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$dd233c2818a2290c$var$node.hash = "7520fca6dd1c12ddc4a3f71f7cea7484";
var $dd233c2818a2290c$export$2e2bcd8739ae039 = $dd233c2818a2290c$var$node;

});

parcelRegister("1WNVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d59b2a8f88dc8ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3c9fa4cc29432746d5c47ff473bcc9f9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2d59b2a8f88dc8ad$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewOld_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "dateTime"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraDateTimePickerField"
};
$2d59b2a8f88dc8ad$var$node.hash = "524086c2c1d813c84e1e36bbc0676a40";
var $2d59b2a8f88dc8ad$export$2e2bcd8739ae039 = $2d59b2a8f88dc8ad$var$node;

});

parcelRegister("8tf7c", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $b20ca95c735c7779$export$518ba8e0e60f145f);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $LJaTB = parcelRequire("LJaTB");
const $b20ca95c735c7779$export$518ba8e0e60f145f = ({ error: error, title: title, description: description })=>{
    if (!error) return null;
    if (error instanceof (0, $jJZqs.ValidationError)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorMessage = error.message || error.errors && error.errors[0] && error.errors[0].error || description;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LJaTB.FlagRenderer), {
            flag: {
                messageId: 'issue-error-flag.flag.warning.issue.fields.components.error-flag.flag.warning',
                messageType: 'transactional',
                type: 'warning',
                title: title,
                description: errorMessage,
                testId: (0, $4R6GH.fg)('relay-migration-issue-fields-number') ? 'issue-error-flag.error-flag.warning' : undefined
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LJaTB.FlagRenderer), {
        flag: {
            messageId: 'issue-error-flag.flag.error.issue.fields.components.error-flag.flag.error',
            messageType: 'transactional',
            type: 'error',
            title: title,
            description: description,
            testId: (0, $4R6GH.fg)('relay-migration-issue-fields-number') ? 'issue-error-flag.error-flag.error' : undefined
        }
    });
};

});
parcelRegister("LJaTB", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $2de6889b93863972$export$7c38ebd1f7ca6a5a);

var $hkhmi = parcelRequire("hkhmi");

var $34Vv8 = parcelRequire("34Vv8");
const $2de6889b93863972$export$7c38ebd1f7ca6a5a = (0, $34Vv8.default)((0, $hkhmi.default));

});
parcelRegister("hkhmi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2971dd786c0add8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fHfPB = parcelRequire("fHfPB");
class $e2971dd786c0add8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $fHfPB.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});



parcelRegister("4M7GZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "DEFAULT_WEEK_START_DAY", () => $653af4b64f524cf8$export$845e1054649a85c2);
$parcel$export(module.exports, "DateTimeEditView", () => $653af4b64f524cf8$export$22b93d77c10368c8);
$parcel$export(module.exports, "default", () => $653af4b64f524cf8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $21Uac = parcelRequire("21Uac");

var $htnpT = parcelRequire("htnpT");

var $8C78M = parcelRequire("8C78M");

var $7SL2i = parcelRequire("7SL2i");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $6yeNV = parcelRequire("6yeNV");

var $cYlk7 = parcelRequire("cYlk7");

var $1p96B = parcelRequire("1p96B");

var $DVljb = parcelRequire("DVljb");

var $8yIsJ = parcelRequire("8yIsJ");
const $653af4b64f524cf8$export$845e1054649a85c2 = 0; // Sunday
const $653af4b64f524cf8$export$22b93d77c10368c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ autoFocus: autoFocus, isDisabled: isDisabled, isInvalid: isInvalid, timeZone: timeZone, value: value, onChange: onChange, datePlaceholder: datePlaceholder, timePlaceholder: timePlaceholder, onDatePickerKeyDown: onDatePickerKeyDown, defaultIsOpen: defaultIsOpen, spacing: spacing, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onDateChange: onDateChange, onTimeChange: onTimeChange }, ref)=>{
    const locale = (0, $DVljb.useLocale)();
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    const currentUserTimeZone = 'timeZone' in user ? user.timeZone || null : null;
    const timeZoneToUse = timeZone !== undefined ? timeZone : currentUserTimeZone;
    const handleOnChange = (0, $5uXOq.useCallback)((isoDateTimeValue)=>{
        const convertedIso = (0, $7SL2i.convertISODateFormat)(isoDateTimeValue ?? '');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($21Uac)))(Date.parse(convertedIso))) onChange?.(null);
        else onChange?.(convertedIso);
    }, [
        onChange
    ]);
    const parseValue = (0, $5uXOq.useCallback)((dateTimeValue, fallbackDate, fallbackTime, fallbackTimeZone)=>(0, $8yIsJ.parseDateTimeValue)(dateTimeValue, fallbackDate, fallbackTime, timeZoneToUse ?? fallbackTimeZone), [
        timeZoneToUse
    ]);
    const baseSelectProps = (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? {
        blurInputOnSelect: false,
        menuPosition: menuPosition,
        menuPortalTarget: menuPortalTarget
    } : {};
    const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
        switch(e.code){
            case 'ArrowLeft':
            case 'ArrowRight':
            case 'ArrowUp':
            case 'ArrowDown':
                // Stop propagation of arrow keys used for keyboard navigation in the date picker control so it
                // doesn't clash with consumer shortcut keys, i.e. issue view.
                if (e.defaultPrevented) e.stopPropagation();
                break;
            default:
                break;
        }
    }, []);
    const standardizedLocale = (0, $6yeNV.standardizeLocale)(locale);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htnpT.default), {
        testId: "issue-field-date-time-editview-full.ui.date-time.date-time-picker",
        locale: standardizedLocale,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        value: value || '',
        onChange: handleOnChange,
        parseValue: timeZoneToUse != null ? parseValue : undefined,
        spacing: spacing,
        timePickerProps: {
            placeholder: timePlaceholder,
            times: (0, $8C78M.default),
            timeIsEditable: true,
            onChange: onTimeChange,
            selectProps: {
                ...baseSelectProps,
                formatCreateLabel: (val)=>val,
                // Want to show the dropdown option if the user input
                // matches the value (22:30) or the label (10:30pm)
                filterOption: (option, val)=>!val || option.value === val || option.label === val
            }
        },
        // Use of non-standardized locale is intentional, getLocale map accounts for this.
        datePickerProps: {
            placeholder: datePlaceholder || '',
            defaultIsOpen: (0, $6s1PB.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true) ? defaultIsOpen : false,
            weekStartDay: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $1p96B.getLocale)(locale), 'options.weekStartsOn', $653af4b64f524cf8$export$845e1054649a85c2),
            selectProps: {
                ...baseSelectProps,
                ...onDatePickerKeyDown ? {
                    onKeyDown: onDatePickerKeyDown
                } : {}
            },
            onChange: onDateChange
        }
    });
    return (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') || (0, $6s1PB.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "presentation",
        ref: ref,
        onKeyDown: (0, $6s1PB.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true) ? handleKeyDown : undefined
    }, content) : content;
});
const $653af4b64f524cf8$var$DateTimeEditViewEntryPoint = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($653af4b64f524cf8$export$22b93d77c10368c8, props);
var $653af4b64f524cf8$export$2e2bcd8739ae039 = $653af4b64f524cf8$var$DateTimeEditViewEntryPoint;

});
parcelRegister("21Uac", function(module, exports) {

var $hUobS = parcelRequire("hUobS");
/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $17a73daff2076455$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $hUobS(value) && value != +value;
}
module.exports = $17a73daff2076455$var$isNaN;

});

parcelRegister("htnpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa2698ee0cdd579e$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cKsfY = parcelRequire("cKsfY");

var $9Lqvx = parcelRequire("9Lqvx");

var $hB1kl = parcelRequire("hB1kl");
const $fa2698ee0cdd579e$var$DateTimePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-time-picker-use-functional-component'), (0, $hB1kl.default), (0, $9Lqvx.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fa2698ee0cdd579e$export$2e2bcd8739ae039 = $fa2698ee0cdd579e$var$DateTimePicker;

});
parcelRegister("cKsfY", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $8f027f90da2b6bac$export$6e8ea24b15199873);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("9Lqvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $597f1543018f8252$export$2e2bcd8739ae039);
/* date-time-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $ip0rq = parcelRequire("ip0rq");

var $VSDnB = parcelRequire("VSDnB");

var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $8JNJx = parcelRequire("8JNJx");

var $cKsfY = parcelRequire("cKsfY");

var $2ucUe = parcelRequire("2ucUe");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");

var $jdTq6 = parcelRequire("jdTq6");
const $597f1543018f8252$var$DatePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
const $597f1543018f8252$var$packageName = "platform-pkg";
const $597f1543018f8252$var$packageVersion = "0.0.0-use.local";
const $597f1543018f8252$var$compiledStyles = {
    datePickerContainerStyles: "_i0dl1ssb _16jlkb7n _1o9zidpf",
    timePickerContainerStyles: "_i0dl1ssb _16jlkb7n",
    iconContainerStyles: "_19itglyw _v564vrg3 _1e0c1txw _4cvr1h6o _i0dl1kw7 _bfhk1kw7 _syaz131l _6rthe4h9 _1pfhe4h9 _12l2e4h9 _ahbqe4h9 _85i512x7 _1q5112x7 _y4tiu2gc _bozg1b66 _30l31gjq"
}; // react-select overrides (via @atlaskit/select).
const $597f1543018f8252$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $597f1543018f8252$var$dateTimePickerDefaultProps = {
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $597f1543018f8252$export$3b559a1219cb3c27 = 'Date';
const $597f1543018f8252$export$d82cc7e53d68a428 = 'Time'; // eslint-disable-next-line @repo/internal/react/no-class-components
class $597f1543018f8252$export$732a1726f0a3523b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = $597f1543018f8252$var$dateTimePickerDefaultProps;
    }
    parseValue(value, dateValue, timeValue, zoneValue) {
        if (this.props.parseValue) {
            const parsedFromFn = this.props.parseValue(value, dateValue, timeValue, zoneValue); // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: dateValue,
                timeValue: timeValue,
                zoneValue: zoneValue
            };
        }
        const parsed = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(parsed) ? {
            dateValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('HH:mm')),
            zoneValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }
    onValueChange({ dateValue: dateValue, timeValue: timeValue, zoneValue: zoneValue }) {
        this.setState({
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        });
        if (dateValue && timeValue) {
            const value = (0, $jHBnA.formatDateTimeZoneIntoIso)(dateValue, timeValue, zoneValue);
            const { zoneValue: parsedZone } = this.parseValue(value, dateValue, timeValue, zoneValue);
            const valueWithValidZone = (0, $jHBnA.formatDateTimeZoneIntoIso)(dateValue, timeValue, parsedZone);
            this.setState({
                value: valueWithValidZone
            });
            this.props.onChange?.(valueWithValidZone); // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (this.getValue()) {
            this.setState({
                value: ''
            });
            this.props.onChange?.('');
        }
    }
    render() {
        const { 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerProps = {}, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, locale: locale = 'en-US', name: name = '', spacing: spacing = 'default', testId: testId, timePickerProps: timePickerProps = {} } = this.props;
        const value = this.getValue();
        const { isFocused: isFocused } = this.state;
        const parsedValues = this.getParsedValues();
        const dateValue = parsedValues?.dateValue;
        const timeValue = parsedValues?.timeValue;
        const datePickerSelectProps = datePickerProps?.selectProps;
        const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
        const datePickerLabel = datePickerProps.label || $597f1543018f8252$export$3b559a1219cb3c27;
        const mergedDatePickerSelectProps = {
            ...datePickerSelectProps,
            styles: (0, $7VXAu.mergeStyles)($597f1543018f8252$var$styles, datePickerSelectProps?.styles)
        };
        const timePickerSelectProps = timePickerProps?.selectProps;
        const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
        const timePickerLabel = timePickerProps.label || $597f1543018f8252$export$d82cc7e53d68a428;
        const mergedTimePickerSelectProps = {
            ...timePickerSelectProps,
            styles: (0, $7VXAu.mergeStyles)($597f1543018f8252$var$styles, timePickerSelectProps?.styles)
        }; // Render DateTimePicker's IconContainer when a value has been filled
        // Don't use Date or TimePicker's because they can't be customised
        const isClearable = Boolean(dateValue || timeValue);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8JNJx.DateTimePickerContainer), {
            appearance: appearance,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isInvalid: isInvalid,
            testId: testId,
            innerProps: innerProps,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $597f1543018f8252$var$compiledStyles.datePickerContainerStyles
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($597f1543018f8252$var$DatePicker, {
                        appearance: appearance,
                        "aria-describedby": datePickerAriaDescribedBy,
                        autoFocus: datePickerProps.autoFocus || autoFocus,
                        dateFormat: datePickerProps.dateFormat,
                        defaultIsOpen: datePickerProps.defaultIsOpen,
                        defaultValue: datePickerProps.defaultValue,
                        disabled: datePickerProps.disabled,
                        disabledDateFilter: datePickerProps.disabledDateFilter,
                        formatDisplayLabel: datePickerProps.formatDisplayLabel,
                        hideIcon: datePickerProps.hideIcon || true,
                        icon: datePickerProps.icon,
                        id: datePickerProps.id || id,
                        innerProps: datePickerProps.innerProps,
                        isDisabled: datePickerProps.isDisabled || isDisabled,
                        isInvalid: datePickerProps.isInvalid || isInvalid,
                        isRequired: datePickerProps.isRequired || isRequired,
                        isOpen: datePickerProps.isOpen,
                        label: datePickerLabel,
                        locale: datePickerProps.locale || locale,
                        maxDate: datePickerProps.maxDate,
                        minDate: datePickerProps.minDate,
                        name: datePickerProps.name,
                        nextMonthLabel: datePickerProps.nextMonthLabel,
                        onBlur: this.onDateBlur,
                        onChange: this.onDateChange,
                        onFocus: this.onDateFocus,
                        parseInputValue: datePickerProps.parseInputValue,
                        placeholder: datePickerProps.placeholder,
                        previousMonthLabel: datePickerProps.previousMonthLabel,
                        selectProps: mergedDatePickerSelectProps,
                        shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
                        spacing: datePickerProps.spacing || spacing,
                        testId: testId && `${testId}--datepicker` || datePickerProps.testId,
                        value: dateValue,
                        weekStartDay: datePickerProps.weekStartDay
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $597f1543018f8252$var$compiledStyles.timePickerContainerStyles
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdTq6.default), {
                        appearance: timePickerProps.appearance || appearance,
                        "aria-describedby": timePickerAriaDescribedBy,
                        autoFocus: timePickerProps.autoFocus,
                        defaultIsOpen: timePickerProps.defaultIsOpen,
                        defaultValue: timePickerProps.defaultValue,
                        formatDisplayLabel: timePickerProps.formatDisplayLabel,
                        hideIcon: timePickerProps.hideIcon || true,
                        id: timePickerProps.id,
                        innerProps: timePickerProps.innerProps,
                        isDisabled: timePickerProps.isDisabled || isDisabled,
                        isInvalid: timePickerProps.isInvalid || isInvalid,
                        isOpen: timePickerProps.isOpen,
                        isRequired: timePickerProps.isRequired || isRequired,
                        label: timePickerLabel,
                        locale: timePickerProps.locale || locale,
                        name: timePickerProps.name,
                        onBlur: this.onTimeBlur,
                        onChange: this.onTimeChange,
                        onFocus: this.onTimeFocus,
                        parseInputValue: timePickerProps.parseInputValue,
                        placeholder: timePickerProps.placeholder,
                        selectProps: mergedTimePickerSelectProps,
                        spacing: timePickerProps.spacing || spacing,
                        testId: timePickerProps.testId || testId && `${testId}--timepicker`,
                        timeFormat: timePickerProps.timeFormat,
                        timeIsEditable: timePickerProps.timeIsEditable,
                        times: timePickerProps.times,
                        value: timeValue
                    })
                }),
                isClearable && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsxs)("button", {
                    onClick: this.onClear,
                    "data-testid": testId && `${testId}--icon--container`,
                    tabIndex: -1,
                    type: "button",
                    className: (0, $bwpsq.default)([
                        $597f1543018f8252$var$compiledStyles.iconContainerStyles
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ip0rq))), {
                            LEGACY_size: "small",
                            color: "currentColor",
                            label: clearControlLabel,
                            size: "small"
                        }),
                        ' '
                    ]
                }) : null
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            dateValue: this.props.datePickerProps?.defaultValue || '',
            isFocused: false,
            timeValue: this.props.timePickerProps?.defaultValue || '',
            value: this.props.defaultValue || '',
            zoneValue: ''
        } // All state needs to be accessed via this function so that the state is mapped from props
        , // correctly to allow controlled/uncontrolled usage.
        this.getParsedValues = ()=>this.parseValue(this.getValue(), this.state.dateValue, this.state.timeValue, this.state.zoneValue), this.getValue = ()=>this.props.value ?? this.state.value, this.onDateBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.datePickerProps?.onBlur) this.props.datePickerProps.onBlur(event);
        }, this.onTimeBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.timePickerProps?.onBlur) this.props.timePickerProps.onBlur(event);
        }, this.onDateFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.datePickerProps?.onFocus) this.props.datePickerProps.onFocus(event);
        }, this.onTimeFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.timePickerProps?.onFocus) this.props.timePickerProps.onFocus(event);
        }, this.onDateChange = (dateValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: dateValue,
                timeValue: parsedValues.timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange(dateValue);
        }, this.onTimeChange = (timeValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: parsedValues.dateValue,
                timeValue: timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange(timeValue);
        }, this.onClear = ()=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: '',
                timeValue: '',
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange('');
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange('');
        };
    }
}
const $597f1543018f8252$var$DateTimePicker = (0, $994MI.default)({
    componentName: 'dateTimePicker',
    packageName: $597f1543018f8252$var$packageName,
    packageVersion: $597f1543018f8252$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'changed',
        actionSubject: 'dateTimePicker',
        attributes: {
            componentName: 'dateTimePicker',
            packageName: $597f1543018f8252$var$packageName,
            packageVersion: $597f1543018f8252$var$packageVersion
        }
    })
})($597f1543018f8252$export$732a1726f0a3523b));
var $597f1543018f8252$export$2e2bcd8739ae039 = $597f1543018f8252$var$DateTimePicker;

});
parcelRegister("ip0rq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32d605899e0518e58ac6527dead74482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d65ae76e92cae981$var$_react = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d65ae76e92cae981$var$_crossCircle = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("hI6SY")));

var $d65ae76e92cae981$var$_selectClear = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("673MF")));
function $d65ae76e92cae981$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d65ae76e92cae981$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $d65ae76e92cae981$var$_react.default.createElement($d65ae76e92cae981$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $d65ae76e92cae981$var$_selectClear.default
    }, props));
$d65ae76e92cae981$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $d65ae76e92cae981$var$_default = module.exports.default = $d65ae76e92cae981$var$CrossCircleIcon;

});

parcelRegister("jHBnA", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $91948b176ea23188$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $91948b176ea23188$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $91948b176ea23188$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $91948b176ea23188$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $91948b176ea23188$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $91948b176ea23188$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $91948b176ea23188$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $91948b176ea23188$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("8JNJx", function(module, exports) {

$parcel$export(module.exports, "DateTimePickerContainer", () => $346cb403038f00ec$export$83034b1f07ab0b20);
/* date-time-picker-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $346cb403038f00ec$var$isInvalidBorderStyles = null;
const $346cb403038f00ec$var$isFocusedBorderStyles = null;
const $346cb403038f00ec$var$isFocusedStyles = null;
const $346cb403038f00ec$var$subtleBgStyles = null;
const $346cb403038f00ec$var$subtleFocusedBgStyles = null;
const $346cb403038f00ec$var$noBgStyles = null;
const $346cb403038f00ec$var$hoverStyles = null;
const $346cb403038f00ec$var$isInvalidHoverStyles = null;
const $346cb403038f00ec$var$isDisabledStyles = null;
const $346cb403038f00ec$var$newBorderStyles = null;
const $346cb403038f00ec$var$baseContainerStyles = null;
const $346cb403038f00ec$export$83034b1f07ab0b20 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId }, ref)=>{
    const notFocusedOrIsDisabled = !(isFocused || isDisabled);
    // we cannot use Box or Flex primitives because these do not allow ...innerProps to be passed
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_2rkoglpi _v564r5cv _1e0c1txw _bfhk1j9a _d0altlke",
            "_19it1k9g",
            isDisabled && "_1h6d13gt _bfhksyzs _d0al73ad",
            isFocused && "_bfhkr01l",
            appearance === 'subtle' && isFocused && "_1h6d3acm _bfhkxbh0",
            appearance === 'subtle' && !isFocused && "_1h6d3acm _bfhk18uv",
            isFocused && "_1h6d1p6i _16qsq049",
            isInvalid && "_1h6d1bqt",
            notFocusedOrIsDisabled && isInvalid && "_4cvx1bqt _irr31d5g",
            notFocusedOrIsDisabled && !isInvalid && "_4cvx1elr _irr31d5g",
            appearance === 'none' && "_1h6d3acm _bfhk18uv _4cvx3acm _irr318uv"
        ]),
        children: children
    });
});

});

parcelRegister("2ucUe", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca6f20a476eda5dc$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca6f20a476eda5dc$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});

parcelRegister("2TI0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $19201d0a1f7d7d54$export$2e2bcd8739ae039);
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $42CjB = parcelRequire("42CjB");

var $3JT92 = parcelRequire("3JT92");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $19201d0a1f7d7d54$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $5RLF6.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $5RLF6.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $6AqCE.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        } // This event handler is triggered from both keydown and click. It's weird.
        , this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        } // `unknown` is used because `value` is unused so it does not matter.
        , this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date()),
            l10n: (0, $7qZ1x.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $7qZ1x.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $19201d0a1f7d7d54$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $dBs4v.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iaQLg.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gtijU.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $jHBnA.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $5RLF6.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $bwpsq.default)([
                $19201d0a1f7d7d54$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                    appearance: this.props.appearance,
                    "aria-describedby": ariaDescribedBy,
                    label: label || undefined,
                    autoFocus: autoFocus,
                    clearControlLabel: clearControlLabel,
                    closeMenuOnSelect: true,
                    enableAnimation: false,
                    inputId: id,
                    inputValue: actualSelectInputValue,
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    menuIsOpen: menuIsOpen,
                    onBlur: this.onSelectBlur,
                    onChange: this.onSelectChange,
                    onFocus: this.onSelectFocus,
                    onInputChange: this.handleSelectInputChange,
                    placeholder: (0, $5RLF6.getPlaceholder)({
                        placeholder: this.props.placeholder,
                        l10n: this.state.l10n
                    }),
                    styles: mergedStyles,
                    value: initialValue,
                    ...selectProps,
                    // up when you alter some of the properties in the `selectComponents`
                    // object. These errors are still present, and I suspect have always
                    // been present, without changing the unrelated code. Ignoring as the
                    // component still works as expected despite this error. And also
                    // because the select refresh team may solve it later.
                    components: selectComponents,
                    // selectProps or not and what wil be overwritten
                    isClearable: true,
                    isInvalid: isInvalid,
                    spacing: spacing,
                    testId: testId,
                    // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                    calendarContainerRef: calendarProps.calendarContainerRef,
                    calendarDisabled: calendarProps.calendarDisabled,
                    calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                    calendarLocale: calendarProps.calendarLocale,
                    calendarMaxDate: calendarProps.calendarMaxDate,
                    calendarMinDate: calendarProps.calendarMinDate,
                    calendarRef: calendarProps.calendarRef,
                    calendarValue: calendarProps.calendarValue,
                    calendarView: calendarProps.calendarView,
                    calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                    nextMonthLabel: nextMonthLabel,
                    onCalendarChange: calendarProps.onCalendarChange,
                    onCalendarSelect: calendarProps.onCalendarSelect,
                    previousMonthLabel: previousMonthLabel,
                    shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                    menuInnerWrapper: calendarProps.menuInnerWrapper
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9KnKW.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: (0, $3JT92.cx)($19201d0a1f7d7d54$var$styles.iconContainerStyles, value && !hideIcon ? $19201d0a1f7d7d54$var$styles.iconSpacingWithClearButtonStyles : $19201d0a1f7d7d54$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #44546F)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
}
const $19201d0a1f7d7d54$var$DatePicker = (0, $994MI.default)({
    componentName: 'datePicker',
    packageName: $19201d0a1f7d7d54$var$packageName,
    packageVersion: $19201d0a1f7d7d54$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $19201d0a1f7d7d54$var$packageName,
            packageVersion: $19201d0a1f7d7d54$var$packageVersion
        }
    })
})($19201d0a1f7d7d54$export$df43d21f5faca9f7));
var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;

});
parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $is0Fy.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $lCAti = parcelRequire("lCAti");

var $3wYKB = parcelRequire("3wYKB");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("5RLF6", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $e0db4b6edb7dbfac$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $e0db4b6edb7dbfac$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $e0db4b6edb7dbfac$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $e0db4b6edb7dbfac$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $k7m40 = parcelRequire("k7m40");
var $5I2ju = parcelRequire("5I2ju");
var $eZDAP = parcelRequire("eZDAP");

var $2ucUe = parcelRequire("2ucUe");

var $jHBnA = parcelRequire("jHBnA");
const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $5I2ju.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(parsedDate)}`;
    return newIso;
};
const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $jHBnA.defaultDateFormat));
    return l10n.parseDate(date);
};
const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $jHBnA.defaultDateFormat));
    const date = (0, $eZDAP.default)(value);
    return dateFormat ? (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $jHBnA.placeholderDatetime));
};

});

parcelRegister("iaQLg", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $d73476b891de3e0c$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");
const $d73476b891de3e0c$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            showClearIndicator ? $d73476b891de3e0c$var$styles.calendarButtonInclusionStyles : $d73476b891de3e0c$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).IndicatorsContainer, {
            ...rest
        })
    });

});

parcelRegister("gtijU", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $e800a879ee1613fc$export$d9b273488cd8ce6f);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $1f0Hs = parcelRequire("1f0Hs");

var $9MHPe = parcelRequire("9MHPe");

var $avHVh = parcelRequire("avHVh");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $e800a879ee1613fc$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $eZDAP.default)(iso);
        return (0, $jovBr.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $e800a879ee1613fc$var$menuStyles = null;
const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9MHPe.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $avHVh.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $bwpsq.default)([
                    "_2rkoglpi _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs1cd0"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1f0Hs.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};

});
parcelRegister("1f0Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $16abbcd9b9109722$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");

var $ePz3p = parcelRequire("ePz3p");

var $lJWdi = parcelRequire("lJWdi");

var $avO9B = parcelRequire("avO9B");

var $iioJV = parcelRequire("iioJV");

var $jihAA = parcelRequire("jihAA");

var $bbnGB = parcelRequire("bbnGB");

var $hbcve = parcelRequire("hbcve");

var $2TGJ3 = parcelRequire("2TGJ3");

var $f9D1v = parcelRequire("f9D1v");

var $9efze = parcelRequire("9efze");
const $16abbcd9b9109722$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $16abbcd9b9109722$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $16abbcd9b9109722$var$InnerCalendar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $iioJV.blankStringArray), defaultSelected: defaultSelected = (0, $iioJV.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $eGmKJ.default), onChange: onChange = (0, $eGmKJ.default), onFocus: onFocus = (0, $eGmKJ.default), onSelect: onSelect = (0, $eGmKJ.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $jihAA.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2TGJ3.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $f9D1v.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $bbnGB.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $9efze.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $hbcve.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $9KnKW.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $16abbcd9b9109722$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ePz3p.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $avO9B.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJWdi.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    }));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $16abbcd9b9109722$var$Calendar = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($16abbcd9b9109722$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;

});
parcelRegister("ePz3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $995afee12cb828f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $l1N8i = parcelRequire("l1N8i");

var $gqS53 = parcelRequire("gqS53");

var $1a4Mo = parcelRequire("1a4Mo");

var $ks8FD = parcelRequire("ks8FD");

var $bpC55 = parcelRequire("bpC55");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
const $995afee12cb828f6$var$Header = /*#__PURE__*/ (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $9KnKW.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $5uXOq.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gqS53))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ks8FD))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bpC55))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1a4Mo))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$995afee12cb828f6$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;

});
parcelRegister("gqS53", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89a5ee1ee34f6c51127fc5be19fb8c41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf69065665122720$var$_react = $bf69065665122720$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bf69065665122720$var$_baseNew = $bf69065665122720$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $bf69065665122720$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bf69065665122720$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $bf69065665122720$var$_react.default.createElement($bf69065665122720$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$bf69065665122720$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $bf69065665122720$var$_default = module.exports.default = $bf69065665122720$var$ChevronDoubleLeftIcon;

});

parcelRegister("1a4Mo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a70faad39a1700c3cb50a44f6bcc1a4e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d8a6ebd9b94ee9b$var$_react = $0d8a6ebd9b94ee9b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0d8a6ebd9b94ee9b$var$_baseNew = $0d8a6ebd9b94ee9b$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0d8a6ebd9b94ee9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0d8a6ebd9b94ee9b$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $0d8a6ebd9b94ee9b$var$_react.default.createElement($0d8a6ebd9b94ee9b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$0d8a6ebd9b94ee9b$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $0d8a6ebd9b94ee9b$var$_default = module.exports.default = $0d8a6ebd9b94ee9b$var$ChevronDoubleRightIcon;

});


parcelRegister("lJWdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f22a52ec309eeb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $1q4y8 = parcelRequire("1q4y8");

var $h581D = parcelRequire("h581D");
const $43f22a52ec309eeb$var$WeekDays = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1q4y8.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;

});
parcelRegister("1q4y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b02566a310b79$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");

var $joKkQ = parcelRequire("joKkQ");
const $d70b02566a310b79$var$dateCellSiblingStyle = null;
const $d70b02566a310b79$var$dateCellTodayStyle = null;
const $d70b02566a310b79$var$dateCellPrevSelectedStyle = null;
const $d70b02566a310b79$var$dateCellSelectedStyle = null;
const $d70b02566a310b79$var$dateCellDisabledStyle = null;
const $d70b02566a310b79$var$dateCellStyles = null;
const $d70b02566a310b79$var$Date = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $eGmKJ.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $5uXOq.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $bwpsq.default)([
                "_kkk2n7od _2rko1l7b _11c82smr _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$d70b02566a310b79$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;

});
parcelRegister("joKkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a473d4552aaa0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $975a473d4552aaa0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $975a473d4552aaa0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $975a473d4552aaa0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $975a473d4552aaa0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $975a473d4552aaa0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $975a473d4552aaa0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $975a473d4552aaa0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $975a473d4552aaa0$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $bwpsq.default)([
            $975a473d4552aaa0$var$baseStyles.root,
            gap && $975a473d4552aaa0$var$columnGapMap[gap],
            columnGap && $975a473d4552aaa0$var$columnGapMap[columnGap],
            gap && $975a473d4552aaa0$var$rowGapMap[gap],
            rowGap && $975a473d4552aaa0$var$rowGapMap[rowGap],
            alignItems && $975a473d4552aaa0$var$alignItemsMap[alignItems],
            alignContent && $975a473d4552aaa0$var$alignContentMap[alignContent],
            justifyContent && $975a473d4552aaa0$var$justifyContentMap[justifyContent],
            autoFlow && $975a473d4552aaa0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$975a473d4552aaa0$var$Grid.displayName = 'Grid';
var $975a473d4552aaa0$export$2e2bcd8739ae039 = $975a473d4552aaa0$var$Grid;

});


parcelRegister("h581D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c8aba25f4ae00ff$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $joKkQ = parcelRequire("joKkQ");
const $5c8aba25f4ae00ff$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        testId: testId,
        xcss: $5c8aba25f4ae00ff$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;

});


parcelRegister("avO9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29b1b1295ce3a84$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $h581D = parcelRequire("h581D");
const $f29b1b1295ce3a84$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $f29b1b1295ce3a84$var$WeekHeader = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                padding: "space.100",
                xcss: $f29b1b1295ce3a84$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;

});

parcelRegister("iioJV", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $85c2ac8e9452c4bf$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $85c2ac8e9452c4bf$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];

});

parcelRegister("jihAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $654a69afe715a212$export$2e2bcd8739ae039);

var $33etG = parcelRequire("33etG");

var $f8qry = parcelRequire("f8qry");

var $3EtUb = parcelRequire("3EtUb");
function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $f8qry.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $33etG.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $33etG.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $33etG.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $33etG.default)(today, ()=>today || `${thisYear}-${(0, $3EtUb.default)(thisMonth)}-${(0, $3EtUb.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $33etG.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $33etG.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("3EtUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd804e1790f6d755$export$2e2bcd8739ae039);
function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("bbnGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccb38b64bb63461$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("hbcve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe53b5f3382c02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZDAP = parcelRequire("eZDAP");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $5wbTt = parcelRequire("5wbTt");
function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $5uXOq.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $iioJV.daysPerWeek) : 0;
            return (0, $5wbTt.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $iioJV.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $5uXOq.useMemo)(()=>(0, $5wbTt.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $eZDAP.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $eZDAP.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $5uXOq.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $6ASl9.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $eZDAP.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("6ASl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ae62fd51c4538f$export$2e2bcd8739ae039);

var $3EtUb = parcelRequire("3EtUb");
function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $3EtUb.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $3EtUb.default)(date.day)}`;
}

});

parcelRegister("5wbTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dff1ed1384abe91$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $iioJV = parcelRequire("iioJV");

var $9Zmg7 = parcelRequire("9Zmg7");
function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $iioJV.daysPerWeek) - weekStartDay + firstDay) % (0, $iioJV.daysPerWeek));
    const lastDate = (0, $9Zmg7.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $iioJV.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $9Zmg7.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $iioJV.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $iioJV.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $iioJV.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $iioJV.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $iioJV.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("9Zmg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $878800070b837d93$export$2e2bcd8739ae039);
function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("2TGJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caae4eff24f6e8d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $9Zmg7 = parcelRequire("9Zmg7");
const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $iioJV.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $iioJV.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $5uXOq.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $iioJV.daysPerWeek);
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $iioJV.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("f9D1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ec54640e7b9de4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");
function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $iioJV.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("9efze", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd6f430b06675a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7qZ1x = parcelRequire("7qZ1x");
function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $5uXOq.useMemo)(()=>(0, $7qZ1x.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("avHVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac07968b7cb494a9$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $5owSH = parcelRequire("5owSH");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");
const $ac07968b7cb494a9$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $5owSH.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gkD4s.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1V7PR.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $eGmKJ.default);
    }
}

});
parcelRegister("5owSH", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $7ad0abb26ad673d7$export$c647cb0ee6e282fe);
const $7ad0abb26ad673d7$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $7ad0abb26ad673d7$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $7ad0abb26ad673d7$export$62ad7b0c781000e9 = {
    small: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("6AqCE", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $caee16c105163c22$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $caee16c105163c22$export$ff525416014fb67d);

var $k7m40 = parcelRequire("k7m40");

var $2ucUe = parcelRequire("2ucUe");
function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
    return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)('YYYY-MM-DD'));
}
function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("dBs4v", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $9661917c82165ad2$export$6e30bf8cb1347b56);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("jcbUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f5b21daaca02ab$export$2e2bcd8739ae039);
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $3JT92 = parcelRequire("3JT92");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
const $48f5b21daaca02ab$var$packageName = "platform-pkg";
const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
const $48f5b21daaca02ab$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $48f5b21daaca02ab$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $48f5b21daaca02ab$var$packageName,
    packageVersion: $48f5b21daaca02ab$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $48f5b21daaca02ab$var$DatePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const calendarRef = (0, $5uXOq.useRef)(null);
    const calendarButtonRef = (0, $5uXOq.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $5uXOq.useState)((0, $7qZ1x.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$48f5b21daaca02ab$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $7qZ1x.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $5uXOq.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $5RLF6.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $5RLF6.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $6AqCE.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen(!isOpen);
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $48f5b21daaca02ab$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iaQLg.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gtijU.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $5RLF6.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $9KnKW.useId)()}`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $bwpsq.default)([
            $48f5b21daaca02ab$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $5RLF6.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // @ts-ignore -- Type 'OptionType' is not assignable to type '{ label: string; value: string; }'
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: (0, $3JT92.cx)($48f5b21daaca02ab$var$styles.iconContainerStyles, value && !hideIcon ? $48f5b21daaca02ab$var$styles.iconSpacingWithClearButtonStyles : $48f5b21daaca02ab$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                            ...iconProps,
                            color: "var(--ds-icon, #44546F)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;

});

parcelRegister("jdTq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $420c0ce16dc216b4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $7qZ1x = parcelRequire("7qZ1x");

var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $imOgG = parcelRequire("imOgG");

var $j537G = parcelRequire("j537G");

var $2ucUe = parcelRequire("2ucUe");

var $dBs4v = parcelRequire("dBs4v");
const $420c0ce16dc216b4$var$packageName = "platform-pkg";
const $420c0ce16dc216b4$var$packageVersion = "0.0.0-use.local";
const $420c0ce16dc216b4$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $420c0ce16dc216b4$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $420c0ce16dc216b4$var$packageName,
    packageVersion: $420c0ce16dc216b4$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $420c0ce16dc216b4$var$TimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $eGmKJ.default), onChange: providedOnChange = (0, $eGmKJ.default), onFocus: providedOnFocus = (0, $eGmKJ.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $j537G.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $jHBnA.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $5uXOq.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$420c0ce16dc216b4$var$analyticsAttributes
    });
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $jHBnA.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $k7m40.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $7qZ1x.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $iOwNT.default) : (0, $7K5PP.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $jHBnA.defaultTimeFormat));
        const date = (0, $j537G.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $jovBr.default)(date)) return time;
        if (timeFormat) return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $jHBnA.EmptyComponent),
        Menu: (0, $imOgG.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$420c0ce16dc216b4$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $jHBnA.placeholderDatetime)),
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $420c0ce16dc216b4$export$2e2bcd8739ae039 = $420c0ce16dc216b4$var$TimePicker;

});
parcelRegister("imOgG", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $cf860f703ecf4b3d$export$982ad994195b4356);
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $avHVh = parcelRequire("avHVh");
const $cf860f703ecf4b3d$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $avHVh.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});

parcelRegister("j537G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e493719c30ce57$export$2e2bcd8739ae039);
const $b5e493719c30ce57$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $b5e493719c30ce57$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $b5e493719c30ce57$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $b5e493719c30ce57$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $b5e493719c30ce57$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $b5e493719c30ce57$var$map24[hour];
    return hour;
}
function $b5e493719c30ce57$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $b5e493719c30ce57$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $b5e493719c30ce57$var$formatSemi24(timeArray[0].trim());
    const hour = $b5e493719c30ce57$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $b5e493719c30ce57$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $b5e493719c30ce57$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $b5e493719c30ce57$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $b5e493719c30ce57$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$b5e493719c30ce57$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $b5e493719c30ce57$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $b5e493719c30ce57$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $b5e493719c30ce57$var$assignToDate(time2);
}

});



parcelRegister("hB1kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d24b25c52c40a49$export$2e2bcd8739ae039);
/* date-time-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $ip0rq = parcelRequire("ip0rq");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $8JNJx = parcelRequire("8JNJx");

var $cKsfY = parcelRequire("cKsfY");

var $2ucUe = parcelRequire("2ucUe");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");

var $jdTq6 = parcelRequire("jdTq6");
const $9d24b25c52c40a49$var$DatePicker = (0, $cKsfY.componentWithCondition)(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
const $9d24b25c52c40a49$var$packageName = "platform-pkg";
const $9d24b25c52c40a49$var$packageVersion = "0.0.0-use.local";
const $9d24b25c52c40a49$var$analyticsAttributes = {
    componentName: 'dateTimePicker',
    packageName: $9d24b25c52c40a49$var$packageName,
    packageVersion: $9d24b25c52c40a49$var$packageVersion
};
const $9d24b25c52c40a49$var$compiledStyles = {
    datePickerContainerStyles: "_i0dl1ssb _16jlkb7n _1o9zidpf",
    timePickerContainerStyles: "_i0dl1ssb _16jlkb7n",
    iconContainerStyles: "_1e0c1txw _4cvr1h6o _i0dl1kw7"
}; // react-select overrides (via @atlaskit/select).
const $9d24b25c52c40a49$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $9d24b25c52c40a49$export$3b559a1219cb3c27 = 'Date';
const $9d24b25c52c40a49$export$d82cc7e53d68a428 = 'Time'; /**
                                                   * __Date time picker__
                                                   *
                                                   * A date time picker allows the user to select an associated date and time.
                                                   *
                                                   * - [Examples](https://atlassian.design/components/datetime-picker/examples)
                                                   * - [Code](https://atlassian.design/components/datetime-picker/code)
                                                   * - [Usage](https://atlassian.design/components/datetime-picker/usage)
                                                   */ 
const $9d24b25c52c40a49$var$DateTimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerPropsWithSelectProps = {}, defaultValue: defaultValue = '', id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, name: name = '', onBlur: // These disables are here for proper typing when used as defaults. They
// should *not* use the `noop` function.
/* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, /* eslint-enable @repo/internal/react/use-noop */ parseValue: providedParseValue, spacing: spacing = 'default', locale: locale = 'en-US', testId: testId, timePickerProps: timePickerPropsWithSelectProps = {}, value: providedValue }, ref)=>{
    const [dateValue, setDateValue] = (0, $5uXOq.useState)(datePickerPropsWithSelectProps?.defaultValue || '');
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [timeValue, setTimeValue] = (0, $5uXOq.useState)(timePickerPropsWithSelectProps?.defaultValue || '');
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue || '');
    const [zoneValue, setZoneValue] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    const parseValue = (0, $5uXOq.useCallback)((value, providedDateValue, providedTimeValue, providedZoneValue)=>{
        if (providedParseValue) {
            const parsedFromFn = providedParseValue(value, providedDateValue, providedTimeValue, providedZoneValue); // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: providedDateValue,
                timeValue: providedTimeValue,
                zoneValue: providedZoneValue
            };
        }
        const parsed = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(parsed) ? {
            dateValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('HH:mm')),
            zoneValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }, [
        providedParseValue,
        dateValue,
        timeValue,
        zoneValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        setDateValue(parsedValues.dateValue);
        setTimeValue(parsedValues.timeValue);
        setZoneValue(parsedValues.zoneValue);
    }, [
        value,
        dateValue,
        timeValue,
        zoneValue,
        parseValue
    ]);
    const onDateBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (datePickerPropsWithSelectProps?.onBlur) datePickerPropsWithSelectProps.onBlur(event);
    };
    const onTimeBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (timePickerPropsWithSelectProps?.onBlur) timePickerPropsWithSelectProps.onBlur(event);
    };
    const onDateFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (datePickerPropsWithSelectProps?.onFocus) datePickerPropsWithSelectProps.onFocus(event);
    };
    const onTimeFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (timePickerPropsWithSelectProps?.onFocus) timePickerPropsWithSelectProps.onFocus(event);
    };
    const onDateChange = (dateValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: dateValue,
            providedTimeValue: parsedValues.timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange(dateValue);
    };
    const onTimeChange = (timeValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: parsedValues.dateValue,
            providedTimeValue: timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange(timeValue);
    };
    const onClear = ()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: '',
            providedTimeValue: '',
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange('');
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange('');
    };
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$9d24b25c52c40a49$var$analyticsAttributes
    });
    const onValueChange = ({ providedDateValue: providedDateValue, providedTimeValue: providedTimeValue, providedZoneValue: providedZoneValue })=>{
        setDateValue(providedDateValue);
        setTimeValue(providedTimeValue);
        setZoneValue(providedZoneValue);
        if (providedDateValue && providedTimeValue) {
            const value = (0, $jHBnA.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, providedZoneValue);
            const { zoneValue: parsedZone } = parseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
            const valueWithValidZone = (0, $jHBnA.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, parsedZone);
            setValue(valueWithValidZone);
            onChangePropWithAnalytics(valueWithValidZone); // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (value) {
            setValue('');
            onChangePropWithAnalytics('');
        }
    };
    const { selectProps: datePickerSelectProps, ...datePickerProps } = datePickerPropsWithSelectProps;
    const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
    const datePickerLabel = datePickerProps.label || $9d24b25c52c40a49$export$3b559a1219cb3c27;
    const mergedDatePickerSelectProps = {
        ...datePickerSelectProps,
        styles: (0, $7VXAu.mergeStyles)($9d24b25c52c40a49$var$styles, datePickerSelectProps?.styles)
    };
    const { selectProps: timePickerSelectProps, ...timePickerProps } = timePickerPropsWithSelectProps;
    const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
    const timePickerLabel = timePickerProps.label || $9d24b25c52c40a49$export$d82cc7e53d68a428;
    const mergedTimePickerSelectProps = {
        ...timePickerSelectProps,
        styles: (0, $7VXAu.mergeStyles)($9d24b25c52c40a49$var$styles, timePickerSelectProps?.styles)
    }; // Render DateTimePicker's IconContainer when a value has been filled
    // Don't use Date or TimePicker's because they can't be customised
    const isClearable = Boolean(dateValue || timeValue);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8JNJx.DateTimePickerContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isInvalid: isInvalid,
        testId: testId,
        innerProps: innerProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $9d24b25c52c40a49$var$compiledStyles.datePickerContainerStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($9d24b25c52c40a49$var$DatePicker, {
                    appearance: appearance,
                    "aria-describedby": datePickerAriaDescribedBy,
                    autoFocus: datePickerProps.autoFocus || autoFocus,
                    dateFormat: datePickerProps.dateFormat,
                    defaultIsOpen: datePickerProps.defaultIsOpen,
                    defaultValue: datePickerProps.defaultValue,
                    disabled: datePickerProps.disabled,
                    disabledDateFilter: datePickerProps.disabledDateFilter,
                    formatDisplayLabel: datePickerProps.formatDisplayLabel,
                    hideIcon: datePickerProps.hideIcon || true,
                    icon: datePickerProps.icon,
                    id: datePickerProps.id || id,
                    innerProps: datePickerProps.innerProps,
                    inputLabel: datePickerProps.inputLabel,
                    inputLabelId: datePickerProps.inputLabelId,
                    isDisabled: datePickerProps.isDisabled || isDisabled,
                    isInvalid: datePickerProps.isInvalid || isInvalid,
                    isOpen: datePickerProps.isOpen,
                    isRequired: datePickerProps.isRequired || isRequired,
                    label: datePickerLabel,
                    locale: datePickerProps.locale || locale,
                    maxDate: datePickerProps.maxDate,
                    minDate: datePickerProps.minDate,
                    name: datePickerProps.name,
                    nextMonthLabel: datePickerProps.nextMonthLabel,
                    onBlur: onDateBlur,
                    onChange: onDateChange,
                    onFocus: onDateFocus,
                    openCalendarLabel: datePickerProps.openCalendarLabel,
                    parseInputValue: datePickerProps.parseInputValue,
                    placeholder: datePickerProps.placeholder,
                    previousMonthLabel: datePickerProps.previousMonthLabel,
                    selectProps: mergedDatePickerSelectProps,
                    shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
                    spacing: datePickerProps.spacing || spacing,
                    testId: testId && `${testId}--datepicker` || datePickerProps.testId,
                    value: dateValue,
                    weekStartDay: datePickerProps.weekStartDay
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $9d24b25c52c40a49$var$compiledStyles.timePickerContainerStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdTq6.default), {
                    appearance: timePickerProps.appearance || appearance,
                    "aria-describedby": timePickerAriaDescribedBy,
                    autoFocus: timePickerProps.autoFocus,
                    defaultIsOpen: timePickerProps.defaultIsOpen,
                    defaultValue: timePickerProps.defaultValue,
                    formatDisplayLabel: timePickerProps.formatDisplayLabel,
                    hideIcon: timePickerProps.hideIcon || true,
                    id: timePickerProps.id,
                    innerProps: timePickerProps.innerProps,
                    isDisabled: timePickerProps.isDisabled || isDisabled,
                    isInvalid: timePickerProps.isInvalid || isInvalid,
                    isOpen: timePickerProps.isOpen,
                    isRequired: timePickerProps.isRequired || isRequired,
                    label: timePickerLabel,
                    locale: timePickerProps.locale || locale,
                    name: timePickerProps.name,
                    onBlur: onTimeBlur,
                    onChange: onTimeChange,
                    onFocus: onTimeFocus,
                    parseInputValue: timePickerProps.parseInputValue,
                    placeholder: timePickerProps.placeholder,
                    selectProps: mergedTimePickerSelectProps,
                    spacing: timePickerProps.spacing || spacing,
                    testId: timePickerProps.testId || testId && `${testId}--timepicker`,
                    timeFormat: timePickerProps.timeFormat,
                    timeIsEditable: timePickerProps.timeIsEditable,
                    times: timePickerProps.times,
                    value: timeValue
                })
            }),
            isClearable && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                xcss: $9d24b25c52c40a49$var$compiledStyles.iconContainerStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    appearance: "subtle",
                    label: clearControlLabel,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ip0rq))), {
                            ...iconProps,
                            color: "var(--ds-text-subtlest, #626F86)",
                            LEGACY_size: "small",
                            size: "small"
                        }),
                    onClick: onClear,
                    testId: testId && `${testId}--icon--container`,
                    tabIndex: -1
                })
            }) : null
        ]
    });
});
var $9d24b25c52c40a49$export$2e2bcd8739ae039 = $9d24b25c52c40a49$var$DateTimePicker;

});


parcelRegister("8C78M", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8375c0a150abd1f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $f8375c0a150abd1f$export$2e2bcd8739ae039 = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];

});

parcelRegister("7SL2i", function(module, exports) {

$parcel$export(module.exports, "convertISODateFormat", () => $8566de3960c30a15$export$6ac2be7021dd8e44);
// Safari and Internet Explorer cannot parse dates (invalid date error) of a specific type of
// ISO formatting (RFC 822) that does no have timezone part (HHmm) separated by a colon (:)
// not working example: new Date('2018-02-06T20:00:00+1100')
// working example:     new Date('2018-02-06T20:00:00+11:00')
const $8566de3960c30a15$export$6ac2be7021dd8e44 = (date)=>date.replace(/([+-][0-9]{2})([0-9]{2})$/, '$1:$2');

});

parcelRegister("8yIsJ", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeValue", () => $dacfe32de6588585$export$30dbc3f5fc81f24a);

var $dwDIK = parcelRequire("dwDIK");
var $7CMcV = parcelRequire("7CMcV");

var $jovBr = parcelRequire("jovBr");
const $dacfe32de6588585$export$30dbc3f5fc81f24a = (dateTimeValue, fallbackDate, fallbackTime, timeZone)=>{
    const parsed = dateTimeValue !== null && (0, $jovBr.default)(new Date(dateTimeValue)) ? (0, $7CMcV.default)(new Date(dateTimeValue), timeZone) : null;
    return parsed !== null && (0, $jovBr.default)(parsed) ? {
        dateValue: (0, $dwDIK.default)(parsed, 'yyyy-MM-dd', {
            timeZone: timeZone
        }),
        timeValue: (0, $dwDIK.default)(parsed, 'HH:mm', {
            timeZone: timeZone
        }),
        zoneValue: (0, $dwDIK.default)(parsed, 'XX', {
            timeZone: timeZone
        })
    } : {
        dateValue: fallbackDate,
        timeValue: fallbackTime,
        zoneValue: (0, $dwDIK.default)(new Date(), 'XX', {
            timeZone: timeZone
        })
    };
};

});


parcelRegister("36gqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $176a9230c01f97d0$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $176a9230c01f97d0$var$DateTimeEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("4M7GZ"))), {
        moduleId: "60a5161a"
    }),
    getPreloadProps: ()=>({})
});
var $176a9230c01f97d0$export$2e2bcd8739ae039 = $176a9230c01f97d0$var$DateTimeEditViewEntryPoint;

});

parcelRegister("j0FAD", function(module, exports) {

$parcel$export(module.exports, "DateTimeReadView", () => $30df85553be0b81c$export$962e920a3f993096);

var $e2EGR = parcelRequire("e2EGR");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cgL5K = parcelRequire("cgL5K");

var $eZibI = parcelRequire("eZibI");

var $8tRRd = parcelRequire("8tRRd");

var $dpHMc = parcelRequire("dpHMc");

var $7mPT9 = parcelRequire("7mPT9");
const $30df85553be0b81c$export$962e920a3f993096 = (props)=>{
    const { fragmentRef: fragmentRef, timeZone: overrideTimeZone, isDateOnlyFormat: isDateOnlyFormat = false, shouldRenderHoverPopover: shouldRenderHoverPopover = false } = props;
    const date = (0, $8Uumt.useFragment)((0, $e2EGR.default), fragmentRef);
    const { dateTime: dateTime } = date || {};
    const { formatDateTime: formatDateTime, formatDateOnly: formatDateOnly } = (0, $8tRRd.useDateTimeFormatter)(overrideTimeZone);
    const contentRef = (0, $5uXOq.useRef)(null);
    if (!dateTime) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    let content;
    try {
        content = isDateOnlyFormat ? formatDateOnly(dateTime) : formatDateTime(dateTime);
    } catch (err) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    }
    if (shouldRenderHoverPopover && dateTime) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        contentRef: contentRef,
        content: content
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            maxLines: 1,
            ref: (0, $7mPT9.default)(ref, contentRef)
        }, content));
    return content;
};

});
parcelRegister("e2EGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b65dd0e17b82b61$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d7d9c9b2f7afb2aadfdb8d3e90d98a18>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5b65dd0e17b82b61$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$5b65dd0e17b82b61$var$node.hash = "20472898e50d717a420a278e6770282c";
var $5b65dd0e17b82b61$export$2e2bcd8739ae039 = $5b65dd0e17b82b61$var$node;

});


parcelRegister("8CBGY", function(module, exports) {

$parcel$export(module.exports, "getNext30MinuteInterval", () => $4c3dc4eae9291533$export$84c10da5aad3dff1);
$parcel$export(module.exports, "getFormattedDate", () => $4c3dc4eae9291533$export$92521769c5df59ad);
$parcel$export(module.exports, "constructDateTimeFromPartialData", () => $4c3dc4eae9291533$export$9fea7babeb5d6905);

var $k7m40 = parcelRequire("k7m40");
var $79nXx = parcelRequire("79nXx");
var $2753q = parcelRequire("2753q");

var $8C78M = parcelRequire("8C78M");

var $1p96B = parcelRequire("1p96B");
function $4c3dc4eae9291533$var$getLocalisedTimeString(intervalTime, intervalString, userLocale) {
    if (userLocale) {
        const normalizedLocale = userLocale.replace(/_/g, '-');
        return new Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(intervalTime);
    }
    return intervalString;
}
function $4c3dc4eae9291533$export$84c10da5aad3dff1(date, userLocale) {
    // Get the current date and time
    const now = date ?? new Date();
    // Format current time to 'HH:mm'
    const currentTime = (0, $k7m40.default)(now, 'HH:mm');
    // Find the next interval
    for (const interval of (0, $8C78M.default)){
        // Parse the interval time to a Date object
        const intervalTime = (0, $2753q.default)(interval, 'HH:mm', now);
        // Check if the interval is after the current time
        if ((0, $79nXx.default)(intervalTime, now) || interval === currentTime) return $4c3dc4eae9291533$var$getLocalisedTimeString(intervalTime, interval, userLocale);
    }
    const intervalTime = (0, $2753q.default)((0, $8C78M.default)[0], 'HH:mm', now);
    // If no interval is found that is after the current time, return the first interval of the next day
    return $4c3dc4eae9291533$var$getLocalisedTimeString(intervalTime, (0, $8C78M.default)[0], userLocale);
}
const $4c3dc4eae9291533$export$92521769c5df59ad = (userLocale)=>{
    return (0, $1p96B.formatWithLocale)(new Date(), 'P', userLocale);
};
const $4c3dc4eae9291533$export$9fea7babeb5d6905 = (date, time)=>{
    if (!date && !time) return '';
    const referenceDate = new Date();
    let resultDate;
    if (date && !time) {
        resultDate = (0, $2753q.default)(date, 'yyyy-MM-dd', referenceDate);
        const nextInterval = $4c3dc4eae9291533$export$84c10da5aad3dff1();
        const parsedTime = (0, $2753q.default)(nextInterval, 'HH:mm', referenceDate);
        resultDate.setHours(parsedTime.getHours(), parsedTime.getMinutes());
    } else if (time && !date) {
        resultDate = (0, $2753q.default)(time, 'HH:mm', referenceDate);
        resultDate.setFullYear(referenceDate.getFullYear(), referenceDate.getMonth(), referenceDate.getDate());
    }
    return resultDate ? resultDate.toISOString() : '';
};

});

parcelRegister("5Rur0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2e540745471157e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c2e540745471157e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "issue-field-date-time-inline-edit-full.date-time.error-title",
        "defaultMessage": "We couldn't set the date"
    },
    errorMessage: {
        "id": "issue-field-date-time-inline-edit-full.date-time.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});



parcelRegister("kzYGs", function(module, exports) {

$parcel$export(module.exports, "EpicLinkCell", () => $a4b55b4804532ec9$export$6c1071448075813f);

var $bVjp2 = parcelRequire("bVjp2");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $cgL5K = parcelRequire("cgL5K");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $heWHN = parcelRequire("heWHN");

var $iHPnC = parcelRequire("iHPnC");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hKMVG = parcelRequire("hKMVG");

var $e9M6d = parcelRequire("e9M6d");

var $3oRMm = parcelRequire("3oRMm");
const $a4b55b4804532ec9$var$getLozengeThemes = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $a4b55b4804532ec9$var$getLozengeThemeByColor = (color = (0, $heWHN.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $a4b55b4804532ec9$var$getLozengeThemes[color] ?? $a4b55b4804532ec9$var$getLozengeThemes[0, $heWHN.DEFAULT_EPIC_COLOR]; // type assertion is fine as the record key is of type Color
const $a4b55b4804532ec9$var$findColor = (color)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys((0, $heWHN.MAP_COLOR_TO_AK_COLOR)).find((key)=>(0, $heWHN.MAP_COLOR_TO_AK_COLOR)[key] === color);
const $a4b55b4804532ec9$export$6c1071448075813f = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { epic: epic } = (0, $8Uumt.useFragment)((0, $bVjp2.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)(); /**
                                                                           * As part of the initiative to remove "Epic Link" and "Parent Link" fields from Jira,
                                                                           * we're rendering a "Replaced by Parent field" deprecation message in the "Epic Link" cell.
                                                                           * At the time of writing this comment, "Epic Link" is still used in ~6% of issue tables, and
                                                                           * we hope this message will help these users migrate and use the "Parent" field from now on.
                                                                           */ 
    if ((0, $4R6GH.fg)('replace-epic-parent-link-by-depreca-message-in-nin')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: "color.text.subtlest",
        maxLines: isSingleLineRowHeightEnabled ? 1 : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $3oRMm.default).replacedByParentField,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, chunks)
        }
    }));
    if (!epic) return null;
    if (epic.key == null || epic.summary == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "epicLink",
        reason: "Missing required fields"
    });
    const epicColor = (0, $iHPnC.asColor)(epic.color);
    const tagColor = (0, $heWHN.MAP_COLOR_TO_AK_COLOR)[epicColor];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4b55b4804532ec9$var$TagWrapper, {
        href: `/browse/${epic.key}`,
        "aria-label": `${formatMessage((0, $3oRMm.default).epicTitle)} ${epic.summary}`,
        style: $a4b55b4804532ec9$var$getLozengeThemeByColor($a4b55b4804532ec9$var$findColor(tagColor)),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'tableIssueLink');
        }
    }, epic.summary);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a4b55b4804532ec9$var$TagWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1reo15vq _18m915vq _2rko1l7b _1e0c1o8l _s7n4nkob _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq _vchhusvi _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bVjp2", function(module, exports) {

$parcel$export(module.exports, "default", () => $094f5cec7265e386$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cbbefe241979b3de7277fee2ab84498c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $094f5cec7265e386$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "epicLink_nativeIssueTable_EpicLinkCell",
    "selections": [
        {
            "concreteType": "JiraEpic",
            "kind": "LinkedField",
            "name": "epic",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                }
            ]
        }
    ],
    "type": "JiraEpicLinkField"
};
$094f5cec7265e386$var$node.hash = "0d48d484eeec312fafb57f96f453cf0f";
var $094f5cec7265e386$export$2e2bcd8739ae039 = $094f5cec7265e386$var$node;

});

parcelRegister("heWHN", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3a4ee6f2b0ce40ab$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);

var $ggSx2 = parcelRequire("ggSx2");


var $7SCny = parcelRequire("7SCny");
const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
    [(0, $7SCny.PURPLE)]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $7SCny.BLUE)]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $7SCny.GREEN)]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $7SCny.TEAL)]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $7SCny.YELLOW)]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $7SCny.ORANGE)]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $7SCny.GREY)]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $7SCny.DARK_PURPLE)]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $7SCny.DARK_BLUE)]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $7SCny.DARK_GREEN)]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $7SCny.DARK_TEAL)]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $7SCny.DARK_YELLOW)]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $7SCny.DARK_ORANGE)]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $7SCny.DARK_GREY)]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
    [(0, $829f609a65d26a98$exports).P200]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $829f609a65d26a98$exports).B200]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $829f609a65d26a98$exports).G200]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $829f609a65d26a98$exports).T200]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $829f609a65d26a98$exports).Y200]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $829f609a65d26a98$exports).R200]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $829f609a65d26a98$exports).N200]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $829f609a65d26a98$exports).P400]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $829f609a65d26a98$exports).B400]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $829f609a65d26a98$exports).G400]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $829f609a65d26a98$exports).T400]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $829f609a65d26a98$exports).Y400]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $829f609a65d26a98$exports).R400]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $829f609a65d26a98$exports).N700]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
    [(0, $7SCny.SERVER_PURPLE)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.SERVER_DARK_PURPLE)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.SERVER_BLUE)]: (0, $7SCny.BLUE),
    [(0, $7SCny.SERVER_DARK_BLUE)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.SERVER_GREEN)]: (0, $7SCny.GREEN),
    [(0, $7SCny.SERVER_DARK_GREEN)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.SERVER_TEAL)]: (0, $7SCny.TEAL),
    [(0, $7SCny.SERVER_DARK_TEAL)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.SERVER_YELLOW)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.SERVER_DARK_YELLOW)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.SERVER_ORANGE)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.SERVER_DARK_ORANGE)]: (0, $7SCny.DARK_ORANGE),
    [(0, $7SCny.SERVER_GREY)]: (0, $7SCny.GREY),
    [(0, $7SCny.SERVER_DARK_GREY)]: (0, $7SCny.DARK_GREY)
};
const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
    [(0, $7SCny.GHX_LABEL_1)]: (0, $7SCny.DARK_GREY),
    [(0, $7SCny.GHX_LABEL_2)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.GHX_LABEL_3)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.GHX_LABEL_4)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.GHX_LABEL_5)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.GHX_LABEL_6)]: (0, $7SCny.GREEN),
    [(0, $7SCny.GHX_LABEL_7)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.GHX_LABEL_8)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.GHX_LABEL_9)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.GHX_LABEL_10)]: (0, $7SCny.BLUE),
    [(0, $7SCny.GHX_LABEL_11)]: (0, $7SCny.TEAL),
    [(0, $7SCny.GHX_LABEL_12)]: (0, $7SCny.GREY),
    [(0, $7SCny.GHX_LABEL_13)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.GHX_LABEL_14)]: (0, $7SCny.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
    [(0, $7SCny.AGILE_COLOR_1)]: (0, $7SCny.DARK_GREY),
    [(0, $7SCny.AGILE_COLOR_2)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.AGILE_COLOR_3)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.AGILE_COLOR_4)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.AGILE_COLOR_5)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.AGILE_COLOR_6)]: (0, $7SCny.GREEN),
    [(0, $7SCny.AGILE_COLOR_7)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.AGILE_COLOR_8)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.AGILE_COLOR_9)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.AGILE_COLOR_10)]: (0, $7SCny.BLUE),
    [(0, $7SCny.AGILE_COLOR_11)]: (0, $7SCny.TEAL),
    [(0, $7SCny.AGILE_COLOR_12)]: (0, $7SCny.GREY),
    [(0, $7SCny.AGILE_COLOR_13)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.AGILE_COLOR_14)]: (0, $7SCny.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
    [(0, $7SCny.GHX_LABEL_1)]: (0, $7SCny.AGILE_COLOR_1),
    [(0, $7SCny.GHX_LABEL_2)]: (0, $7SCny.AGILE_COLOR_2),
    [(0, $7SCny.GHX_LABEL_3)]: (0, $7SCny.AGILE_COLOR_3),
    [(0, $7SCny.GHX_LABEL_4)]: (0, $7SCny.AGILE_COLOR_4),
    [(0, $7SCny.GHX_LABEL_5)]: (0, $7SCny.AGILE_COLOR_5),
    [(0, $7SCny.GHX_LABEL_6)]: (0, $7SCny.AGILE_COLOR_6),
    [(0, $7SCny.GHX_LABEL_7)]: (0, $7SCny.AGILE_COLOR_7),
    [(0, $7SCny.GHX_LABEL_8)]: (0, $7SCny.AGILE_COLOR_8),
    [(0, $7SCny.GHX_LABEL_9)]: (0, $7SCny.AGILE_COLOR_9),
    [(0, $7SCny.GHX_LABEL_10)]: (0, $7SCny.AGILE_COLOR_10),
    [(0, $7SCny.GHX_LABEL_11)]: (0, $7SCny.AGILE_COLOR_11),
    [(0, $7SCny.GHX_LABEL_12)]: (0, $7SCny.AGILE_COLOR_12),
    [(0, $7SCny.GHX_LABEL_13)]: (0, $7SCny.AGILE_COLOR_13),
    [(0, $7SCny.GHX_LABEL_14)]: (0, $7SCny.AGILE_COLOR_14)
};
const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
    [(0, $7SCny.DARK_GREY)]: 'grey',
    [(0, $7SCny.DARK_YELLOW)]: 'yellow',
    [(0, $7SCny.YELLOW)]: 'yellowLight',
    [(0, $7SCny.DARK_BLUE)]: 'blue',
    [(0, $7SCny.DARK_TEAL)]: 'teal',
    [(0, $7SCny.GREEN)]: 'greenLight',
    [(0, $7SCny.PURPLE)]: 'purpleLight',
    [(0, $7SCny.DARK_PURPLE)]: 'purple',
    [(0, $7SCny.ORANGE)]: 'redLight',
    [(0, $7SCny.BLUE)]: 'blueLight',
    [(0, $7SCny.TEAL)]: 'tealLight',
    [(0, $7SCny.GREY)]: 'greyLight',
    [(0, $7SCny.DARK_GREEN)]: 'green',
    [(0, $7SCny.DARK_ORANGE)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
    [(0, $7SCny.AGILE_COLOR_1)]: 'grey',
    [(0, $7SCny.AGILE_COLOR_2)]: 'yellow',
    [(0, $7SCny.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $7SCny.AGILE_COLOR_4)]: 'blue',
    [(0, $7SCny.AGILE_COLOR_5)]: 'teal',
    [(0, $7SCny.AGILE_COLOR_6)]: 'greenLight',
    [(0, $7SCny.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $7SCny.AGILE_COLOR_8)]: 'purple',
    [(0, $7SCny.AGILE_COLOR_9)]: 'redLight',
    [(0, $7SCny.AGILE_COLOR_10)]: 'blueLight',
    [(0, $7SCny.AGILE_COLOR_11)]: 'tealLight',
    [(0, $7SCny.AGILE_COLOR_12)]: 'greyLight',
    [(0, $7SCny.AGILE_COLOR_13)]: 'green',
    [(0, $7SCny.AGILE_COLOR_14)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
    [(0, $7SCny.PURPLE)]: {
        primary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        secondary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        text: "var(--ds-text-accent-purple, #5E4DB2)",
        textBackground: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.BLUE)]: {
        primary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        secondary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        text: "var(--ds-text-accent-blue, #0055CC)",
        textBackground: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.GREEN)]: {
        primary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        secondary: "var(--ds-background-accent-green-bolder, #1F845A)",
        text: "var(--ds-text-accent-green, #216E4E)",
        textBackground: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.TEAL)]: {
        primary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        secondary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        text: "var(--ds-text-accent-teal, #206A83)",
        textBackground: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.YELLOW)]: {
        primary: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
        secondary: "var(--ds-background-accent-yellow-bolder, #946F00)",
        text: "var(--ds-text-accent-yellow, #7F5F01)",
        textBackground: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        border: "var(--ds-border-accent-yellow, #B38600)",
        line: "var(--ds-border-accent-yellow, #B38600)",
        primaryGradient: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.ORANGE)]: {
        primary: "var(--ds-background-accent-red-subtle, #F87168)",
        secondary: "var(--ds-background-accent-red-bolder, #C9372C)",
        text: "var(--ds-text-accent-red, #AE2E24)",
        textBackground: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        border: "var(--ds-border-accent-red, #E2483D)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.GREY)]: {
        primary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        secondary: "var(--ds-background-accent-gray-bolder, #626F86)",
        text: "var(--ds-text-accent-gray, #44546F)",
        textBackground: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        border: "var(--ds-border-accent-gray, #758195)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.DARK_PURPLE)]: {
        primary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        secondary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_BLUE)]: {
        primary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        secondary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtle, #579DFF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_GREEN)]: {
        primary: "var(--ds-background-accent-green-bolder, #1F845A)",
        secondary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtle, #4BCE97)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_TEAL)]: {
        primary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        secondary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-teal-bolder, #227D9B)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_YELLOW)]: {
        primary: "var(--ds-background-accent-orange-bolder, #C25100)",
        secondary: "var(--ds-background-accent-orange-subtle, #FEA362)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-orange-bolder, #C25100)",
        border: "var(--ds-background-accent-orange-subtle, #FEA362)",
        line: "var(--ds-border-accent-orange, #E56910)",
        primaryGradient: "var(--ds-background-accent-orange-subtle, #FEA362)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_ORANGE)]: {
        primary: "var(--ds-background-accent-red-bolder, #C9372C)",
        secondary: "var(--ds-background-accent-red-subtle, #F87168)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-red-bolder, #C9372C)",
        border: "var(--ds-background-accent-red-subtle, #F87168)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtle, #F87168)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_GREY)]: {
        primary: "var(--ds-background-accent-gray-bolder, #626F86)",
        secondary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-gray-bolder, #626F86)",
        border: "var(--ds-background-accent-gray-subtle, #8590A2)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtle, #8590A2)",
        hasContrastSecondaryGradient: false
    }
};

});
parcelRegister("ggSx2", function(module, exports) {

var $cxSdl = parcelRequire("cxSdl");

var $fxKlj = parcelRequire("fxKlj");

var $etyzk = parcelRequire("etyzk");
/** Used for built-in method references. */ var $bd8870e21c3833a0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bd8870e21c3833a0$var$nativeObjectToString = $bd8870e21c3833a0$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $bd8870e21c3833a0$var$invert = $fxKlj(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $bd8870e21c3833a0$var$nativeObjectToString.call(value);
    result[value] = key;
}, $cxSdl($etyzk));
module.exports = $bd8870e21c3833a0$var$invert;

});
parcelRegister("fxKlj", function(module, exports) {

var $d1nCg = parcelRequire("d1nCg");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $b50de2cb57eb155c$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $d1nCg(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $b50de2cb57eb155c$var$createInverter;

});
parcelRegister("d1nCg", function(module, exports) {

var $hDnyx = parcelRequire("hDnyx");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $97adb007e27dc709$var$baseInverter(object, setter, iteratee, accumulator) {
    $hDnyx(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $97adb007e27dc709$var$baseInverter;

});



var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("7SCny", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $8e4230f608d6b965$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $8e4230f608d6b965$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $8e4230f608d6b965$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $8e4230f608d6b965$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $8e4230f608d6b965$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $8e4230f608d6b965$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $8e4230f608d6b965$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $8e4230f608d6b965$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $8e4230f608d6b965$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $8e4230f608d6b965$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $8e4230f608d6b965$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $8e4230f608d6b965$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $8e4230f608d6b965$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $8e4230f608d6b965$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $8e4230f608d6b965$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $8e4230f608d6b965$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $8e4230f608d6b965$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $8e4230f608d6b965$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $8e4230f608d6b965$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $8e4230f608d6b965$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $8e4230f608d6b965$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $8e4230f608d6b965$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $8e4230f608d6b965$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $8e4230f608d6b965$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $8e4230f608d6b965$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $8e4230f608d6b965$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $8e4230f608d6b965$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $8e4230f608d6b965$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $8e4230f608d6b965$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $8e4230f608d6b965$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $8e4230f608d6b965$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $8e4230f608d6b965$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $8e4230f608d6b965$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $8e4230f608d6b965$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $8e4230f608d6b965$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $8e4230f608d6b965$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $8e4230f608d6b965$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $8e4230f608d6b965$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $8e4230f608d6b965$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $8e4230f608d6b965$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $8e4230f608d6b965$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $8e4230f608d6b965$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $8e4230f608d6b965$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $8e4230f608d6b965$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $8e4230f608d6b965$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $8e4230f608d6b965$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $8e4230f608d6b965$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $8e4230f608d6b965$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $8e4230f608d6b965$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $8e4230f608d6b965$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $8e4230f608d6b965$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $8e4230f608d6b965$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $8e4230f608d6b965$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $8e4230f608d6b965$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $8e4230f608d6b965$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $8e4230f608d6b965$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $8e4230f608d6b965$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $8e4230f608d6b965$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $8e4230f608d6b965$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $8e4230f608d6b965$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $8e4230f608d6b965$export$4b7407b8700035bd);
/**
 * @fileoverview This file was moved from `@atlassian/jira-issue-epic-color-types`
 * so that these types do not require atlaskit dependencies.
 *
 * Color constants
 */ const $8e4230f608d6b965$export$7ffdeca4b2f927a2 = 'PURPLE';
const $8e4230f608d6b965$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $8e4230f608d6b965$export$738c3b9a44c87ecc = 'BLUE';
const $8e4230f608d6b965$export$1225f83626261b80 = 'DARK_BLUE';
const $8e4230f608d6b965$export$48d4b2cd5bc0e88b = 'GREEN';
const $8e4230f608d6b965$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $8e4230f608d6b965$export$d0446fe88325854e = 'TEAL';
const $8e4230f608d6b965$export$bb848c92687e69dc = 'DARK_TEAL';
const $8e4230f608d6b965$export$aab610c505c06a8f = 'YELLOW';
const $8e4230f608d6b965$export$466af87757d343a2 = 'DARK_YELLOW';
const $8e4230f608d6b965$export$3de5e29ed1757f9b = 'ORANGE';
const $8e4230f608d6b965$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $8e4230f608d6b965$export$7d278ca694634874 = 'GREY';
const $8e4230f608d6b965$export$26453300bfc61cb8 = 'DARK_GREY';
const $8e4230f608d6b965$export$56d196d2844d1ca1 = [
    $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    $8e4230f608d6b965$export$c815fe495e8174a0,
    $8e4230f608d6b965$export$738c3b9a44c87ecc,
    $8e4230f608d6b965$export$1225f83626261b80,
    $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    $8e4230f608d6b965$export$d0446fe88325854e,
    $8e4230f608d6b965$export$bb848c92687e69dc,
    $8e4230f608d6b965$export$aab610c505c06a8f,
    $8e4230f608d6b965$export$466af87757d343a2,
    $8e4230f608d6b965$export$3de5e29ed1757f9b,
    $8e4230f608d6b965$export$da02e4820b6ab753,
    $8e4230f608d6b965$export$7d278ca694634874,
    $8e4230f608d6b965$export$26453300bfc61cb8
];
const $8e4230f608d6b965$export$792af22a0198af8d = 'purple';
const $8e4230f608d6b965$export$588af712afdcb006 = 'dark_purple';
const $8e4230f608d6b965$export$84c4918645391802 = 'blue';
const $8e4230f608d6b965$export$b8f1f5838352a33a = 'dark_blue';
const $8e4230f608d6b965$export$9384b7e350ee6542 = 'green';
const $8e4230f608d6b965$export$87d3fb8d8656d38b = 'dark_green';
const $8e4230f608d6b965$export$b0b4ce3e99e66aae = 'teal';
const $8e4230f608d6b965$export$a89b77a449bd223e = 'dark_teal';
const $8e4230f608d6b965$export$9a33b5e3cde94885 = 'yellow';
const $8e4230f608d6b965$export$33253d7862bceb8a = 'dark_yellow';
const $8e4230f608d6b965$export$6609c2b23fc42f39 = 'orange';
const $8e4230f608d6b965$export$cd994662b5911917 = 'dark_orange';
const $8e4230f608d6b965$export$1793d43e13e078c5 = 'grey';
const $8e4230f608d6b965$export$487a6e9145526564 = 'dark_grey';
const $8e4230f608d6b965$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $8e4230f608d6b965$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $8e4230f608d6b965$export$94ac87c81ed074a7 = 'ghx-label-3';
const $8e4230f608d6b965$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $8e4230f608d6b965$export$610a2c132b6fcf96 = 'ghx-label-5';
const $8e4230f608d6b965$export$8e4997dba71f1c40 = 'ghx-label-6';
const $8e4230f608d6b965$export$18a545b4e69b27b4 = 'ghx-label-7';
const $8e4230f608d6b965$export$27fff1a0d295292a = 'ghx-label-8';
const $8e4230f608d6b965$export$e57aa662a56724e1 = 'ghx-label-9';
const $8e4230f608d6b965$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $8e4230f608d6b965$export$457ecb9560f2bf83 = 'ghx-label-11';
const $8e4230f608d6b965$export$a866db37165a696c = 'ghx-label-12';
const $8e4230f608d6b965$export$9b18447c1168a1b6 = 'ghx-label-13';
const $8e4230f608d6b965$export$93b9ad4020e271b7 = 'ghx-label-14';
const $8e4230f608d6b965$export$5cd2af17b34de3e3 = 'color_1';
const $8e4230f608d6b965$export$987671fa69482a7b = 'color_2';
const $8e4230f608d6b965$export$70ba8a5b1f4c7446 = 'color_3';
const $8e4230f608d6b965$export$fcd1c42d8d3ebd36 = 'color_4';
const $8e4230f608d6b965$export$f80a5bd2fa0ba256 = 'color_5';
const $8e4230f608d6b965$export$37ad5ce8d2aeaf78 = 'color_6';
const $8e4230f608d6b965$export$9dc62d5d151cb355 = 'color_7';
const $8e4230f608d6b965$export$1ed15b30f5663f92 = 'color_8';
const $8e4230f608d6b965$export$5d23a84d55ac1644 = 'color_9';
const $8e4230f608d6b965$export$bf08c9a6ed42e349 = 'color_10';
const $8e4230f608d6b965$export$66c5d8f0b5ff279c = 'color_11';
const $8e4230f608d6b965$export$da30755a37c3a597 = 'color_12';
const $8e4230f608d6b965$export$721cf84faff6bf19 = 'color_13';
const $8e4230f608d6b965$export$4b8f8666bd7b61dd = 'color_14';
const $8e4230f608d6b965$export$c537fa0d021d010b = {
    PURPLE: $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $8e4230f608d6b965$export$c815fe495e8174a0,
    BLUE: $8e4230f608d6b965$export$738c3b9a44c87ecc,
    DARK_BLUE: $8e4230f608d6b965$export$1225f83626261b80,
    GREEN: $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    TEAL: $8e4230f608d6b965$export$d0446fe88325854e,
    DARK_TEAL: $8e4230f608d6b965$export$bb848c92687e69dc,
    YELLOW: $8e4230f608d6b965$export$aab610c505c06a8f,
    DARK_YELLOW: $8e4230f608d6b965$export$466af87757d343a2,
    ORANGE: $8e4230f608d6b965$export$3de5e29ed1757f9b,
    DARK_ORANGE: $8e4230f608d6b965$export$da02e4820b6ab753,
    GREY: $8e4230f608d6b965$export$7d278ca694634874,
    DARK_GREY: $8e4230f608d6b965$export$26453300bfc61cb8
};
const $8e4230f608d6b965$export$d33d39828a18210a = {
    SERVER_PURPLE: $8e4230f608d6b965$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $8e4230f608d6b965$export$588af712afdcb006,
    SERVER_BLUE: $8e4230f608d6b965$export$84c4918645391802,
    SERVER_DARK_BLUE: $8e4230f608d6b965$export$b8f1f5838352a33a,
    SERVER_GREEN: $8e4230f608d6b965$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $8e4230f608d6b965$export$87d3fb8d8656d38b,
    SERVER_TEAL: $8e4230f608d6b965$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $8e4230f608d6b965$export$a89b77a449bd223e,
    SERVER_YELLOW: $8e4230f608d6b965$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $8e4230f608d6b965$export$33253d7862bceb8a,
    SERVER_ORANGE: $8e4230f608d6b965$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $8e4230f608d6b965$export$cd994662b5911917,
    SERVER_GREY: $8e4230f608d6b965$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $8e4230f608d6b965$export$487a6e9145526564
};
const $8e4230f608d6b965$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $8e4230f608d6b965$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $8e4230f608d6b965$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $8e4230f608d6b965$export$94ac87c81ed074a7,
    GHX_LABEL_4: $8e4230f608d6b965$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $8e4230f608d6b965$export$610a2c132b6fcf96,
    GHX_LABEL_6: $8e4230f608d6b965$export$8e4997dba71f1c40,
    GHX_LABEL_7: $8e4230f608d6b965$export$18a545b4e69b27b4,
    GHX_LABEL_8: $8e4230f608d6b965$export$27fff1a0d295292a,
    GHX_LABEL_9: $8e4230f608d6b965$export$e57aa662a56724e1,
    GHX_LABEL_10: $8e4230f608d6b965$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $8e4230f608d6b965$export$457ecb9560f2bf83,
    GHX_LABEL_12: $8e4230f608d6b965$export$a866db37165a696c,
    GHX_LABEL_13: $8e4230f608d6b965$export$9b18447c1168a1b6,
    GHX_LABEL_14: $8e4230f608d6b965$export$93b9ad4020e271b7
};
const $8e4230f608d6b965$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $8e4230f608d6b965$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $8e4230f608d6b965$export$987671fa69482a7b,
    AGILE_COLOR_3: $8e4230f608d6b965$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $8e4230f608d6b965$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $8e4230f608d6b965$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $8e4230f608d6b965$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $8e4230f608d6b965$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $8e4230f608d6b965$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $8e4230f608d6b965$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $8e4230f608d6b965$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $8e4230f608d6b965$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $8e4230f608d6b965$export$da30755a37c3a597,
    AGILE_COLOR_13: $8e4230f608d6b965$export$721cf84faff6bf19,
    AGILE_COLOR_14: $8e4230f608d6b965$export$4b8f8666bd7b61dd
};

});


parcelRegister("iHPnC", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $e626bf77f0e696c5$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $e626bf77f0e696c5$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $e626bf77f0e696c5$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $e626bf77f0e696c5$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $e626bf77f0e696c5$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $e626bf77f0e696c5$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $e626bf77f0e696c5$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $e626bf77f0e696c5$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $e626bf77f0e696c5$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $e626bf77f0e696c5$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $e626bf77f0e696c5$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $e626bf77f0e696c5$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $e626bf77f0e696c5$export$e4369cabd7e84cd9);

var $ggSx2 = parcelRequire("ggSx2");

var $7SCny = parcelRequire("7SCny");

var $heWHN = parcelRequire("heWHN");

var $ehxiD = parcelRequire("ehxiD");
const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $7SCny.Colors).PURPLE;
    if (color in (0, $7SCny.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $7SCny.Colors).PURPLE;
};
const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $7SCny.ServerColors).SERVER_PURPLE;
    if (color in (0, $7SCny.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $7SCny.ServerColors).SERVER_PURPLE;
};
const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $7SCny.Colors).PURPLE];
    if (color in (0, $7SCny.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $7SCny.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $7SCny.Colors).PURPLE];
    if (color in (0, $7SCny.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $7SCny.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $heWHN.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $7SCny.Colors)));
    return extendedColors.reduce((obj, color)=>Object.assign(obj, {
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, $heWHN.MAP_COLORS_TO_VALUE)[color] || (0, $heWHN.MAP_COLORS_TO_VALUE)[0, $7SCny.PURPLE];
const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $heWHN.MAP_COLORS_TO_VALUE))[value] || (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $ehxiD.default).purpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).blueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).tealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).yellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).orangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).GREY]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkPurpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkBlueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkTealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkYellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkOrangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_GREY]
        }
    ];
const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, $heWHN.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, $heWHN.DEFAULT_EPIC_COLOR];
const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $7SCny.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("ehxiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b7e3d933c7b9f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});


parcelRegister("3oRMm", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ef7c79d1bfddee1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8ef7c79d1bfddee1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    epicTitle: {
        "id": "native-issue-table.common.issue-cells.epic-link.epic-title",
        "defaultMessage": "Click to visit"
    },
    replacedByParentField: {
        "id": "issue-create-commons.common.fields.epic-link-parent-link-disabled.replaced-by-parent-field",
        "defaultMessage": "Replaced by <strong>Parent</strong> field"
    }
});

});


parcelRegister("jc00M", function(module, exports) {

$parcel$export(module.exports, "FallbackCell", () => $1ebd5775cccd7bf4$export$de9d519be820a473);

var $eKXRN = parcelRequire("eKXRN");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dpHMc = parcelRequire("dpHMc");

var $7mPT9 = parcelRequire("7mPT9");

var $hKMVG = parcelRequire("hKMVG");

var $e9M6d = parcelRequire("e9M6d");
const $1ebd5775cccd7bf4$var$TYPES_TO_REMOVE_TITLE = new Set([
    'lastViewed'
]);
const $1ebd5775cccd7bf4$export$de9d519be820a473 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { renderedFieldHtml: renderedFieldHtml, type: type } = (0, $8Uumt.useFragment)((0, $eKXRN.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const contentRef = (0, $5uXOq.useRef)(null);
    const removeTitleAttributeRef = (0, $5uXOq.useCallback)((el)=>{
        if (!$1ebd5775cccd7bf4$var$TYPES_TO_REMOVE_TITLE.has(type)) return;
        el?.querySelectorAll('[title]').forEach((node)=>{
            node.removeAttribute('title');
        });
    }, [
        type
    ]);
    if (renderedFieldHtml == null) return /*#__PURE__*/ $5uXOq.createElement((0, $hKMVG.default), {
        cellType: "fallback",
        reason: "Missing required fields"
    });
    if (!renderedFieldHtml.trim().length) return null;
    switch(type){
        case 'thumbnail':
            return isSingleLineRowHeightEnabled ? /*#__PURE__*/ $5uXOq.createElement((0, $dpHMc.HoverPopover), {
                content: /*#__PURE__*/ $5uXOq.createElement("div" // eslint-disable-next-line react/no-danger
                , {
                    dangerouslySetInnerHTML: {
                        __html: renderedFieldHtml
                    },
                    className: (0, $bwpsq.default)([
                        "_1jpx1f51 _rtys1osq _19l31osq"
                    ])
                })
            }, ({ ref: ref })=>/*#__PURE__*/ $5uXOq.createElement($1ebd5775cccd7bf4$var$AttachmentFallbackContainer, {
                    "data-testid": "native-issue-table.common.ui.issue-cells.fallback.attachment-fallback-container",
                    dangerouslySetInnerHTML: {
                        __html: renderedFieldHtml
                    },
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                    ref: ref
                })) : /*#__PURE__*/ $5uXOq.createElement($1ebd5775cccd7bf4$var$AttachmentFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.attachment-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                },
                isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
            });
        case 'progress':
        case 'aggregateprogress':
            // No need for hover popover for progress as contents (graphic) is responsive to cell width
            return /*#__PURE__*/ $5uXOq.createElement($1ebd5775cccd7bf4$var$ProgressFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.progress-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        case 'com.atlassian.servicedesk:sd-request-feedback':
            return isSingleLineRowHeightEnabled ? /*#__PURE__*/ $5uXOq.createElement((0, $dpHMc.HoverPopover), {
                contentRef: contentRef,
                content: /*#__PURE__*/ $5uXOq.createElement("div" // eslint-disable-next-line react/no-danger
                , {
                    dangerouslySetInnerHTML: {
                        __html: renderedFieldHtml
                    }
                })
            }, ({ ref: ref })=>/*#__PURE__*/ $5uXOq.createElement($1ebd5775cccd7bf4$var$SatisfactionFallbackContainer, {
                    ref: (0, $7mPT9.mergeRefs)(contentRef, ref),
                    "data-testid": "native-issue-table.common.ui.issue-cells.fallback.satisfaction-fallback-container",
                    dangerouslySetInnerHTML: {
                        __html: renderedFieldHtml
                    },
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                })) : /*#__PURE__*/ $5uXOq.createElement($1ebd5775cccd7bf4$var$SatisfactionFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.satisfaction-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        case 'com.atlassian.servicedesk:sd-sla-field':
            return isSingleLineRowHeightEnabled ? /*#__PURE__*/ $5uXOq.createElement((0, $dpHMc.HoverPopover), {
                contentRef: contentRef,
                content: /*#__PURE__*/ $5uXOq.createElement("div" // eslint-disable-next-line react/no-danger
                , {
                    dangerouslySetInnerHTML: {
                        __html: renderedFieldHtml
                    }
                })
            }, ({ ref: ref })=>/*#__PURE__*/ $5uXOq.createElement($1ebd5775cccd7bf4$var$SlaFallbackContainer, {
                    ref: (0, $7mPT9.mergeRefs)(contentRef, ref),
                    "data-testid": "native-issue-table.common.ui.issue-cells.fallback.sla-fallback-container",
                    dangerouslySetInnerHTML: {
                        __html: renderedFieldHtml
                    },
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                })) : /*#__PURE__*/ $5uXOq.createElement($1ebd5775cccd7bf4$var$SlaFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.sla-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        default:
            return isSingleLineRowHeightEnabled ? /*#__PURE__*/ $5uXOq.createElement((0, $dpHMc.HoverPopover), {
                contentRef: contentRef,
                content: /*#__PURE__*/ $5uXOq.createElement("div" // eslint-disable-next-line react/no-danger
                , {
                    dangerouslySetInnerHTML: {
                        __html: renderedFieldHtml
                    }
                })
            }, ({ ref: ref })=>/*#__PURE__*/ $5uXOq.createElement($1ebd5775cccd7bf4$var$FallbackContainer, {
                    ref: (0, $7mPT9.mergeRefs)(contentRef, ref, removeTitleAttributeRef),
                    "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div",
                    dangerouslySetInnerHTML: {
                        __html: renderedFieldHtml
                    },
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                })) : /*#__PURE__*/ $5uXOq.createElement($1ebd5775cccd7bf4$var$FallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
    }
});
/**
 * Disabling selector eslint rules because we must provide the fallback style overrides this way due
 * to the markup and base styles coming from the monolith.
 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ebd5775cccd7bf4$var$FallbackContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1rjc1b66 _18zru2gc _p12f1osq _1bto1l2s _bna71wug _rtys1osq",
            __cmplp && "_o5721q9c _wmb415vq _12ev15vq _5c4l1l2s _1e4iglyw",
            __cmplp.className
        ])
    });
});
const $1ebd5775cccd7bf4$var$attachmentPopoverStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ebd5775cccd7bf4$var$AttachmentFallbackContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $1ebd5775cccd7bf4$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bna71wug _19l3uuw1 _mezj1wug _rtys1osq",
            __cmplp && "_1rjcv77o _1e0c1txw _1bah1h6o _4cvr1h6o _19l31ul9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ebd5775cccd7bf4$var$ProgressFallbackContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $1ebd5775cccd7bf4$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4idpf _1lms18uv _xu7xt94y _19jqt94y _iv7lt94y _18m0t94y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ebd5775cccd7bf4$var$SatisfactionFallbackContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $1ebd5775cccd7bf4$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nmi71oqg _17go131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ebd5775cccd7bf4$var$SlaFallbackContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $1ebd5775cccd7bf4$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1xngu2gc _1kss1txw _1v441h6o _1fecusic _1op7t9kd _i95c17hp _c4xnnbxb _1mf8wdcn _10ku8uof _m1tonbxb _g3h87r97",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eKXRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b563049ed02b6b73$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04fe6cbd7f86be0b3c73e9e2564fcb5e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b563049ed02b6b73$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "fallback_nativeIssueTable_FallbackCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "renderedFieldHtml"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        }
    ],
    "type": "JiraFallbackField"
};
$b563049ed02b6b73$var$node.hash = "ae1cf9566abe8a4e7439b5ee75c25916";
var $b563049ed02b6b73$export$2e2bcd8739ae039 = $b563049ed02b6b73$var$node;

});


parcelRegister("3ljzH", function(module, exports) {

$parcel$export(module.exports, "FlagCell", () => $70549110da97a152$export$be4c47c19457cd1e);

var $1JspW = parcelRequire("1JspW");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $8JJIk = parcelRequire("8JJIk");
const $70549110da97a152$export$be4c47c19457cd1e = ({ fieldRef: fieldRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $1JspW.default), fieldRef);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return data.flag?.isFlagged && formatMessage((0, $8JJIk.default).flagged);
};

});
parcelRegister("1JspW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4965d17ab878198a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<03ad9db22088fdd1e457a5121db18df3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4965d17ab878198a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "flag_nativeIssueTable_FlagCell",
    "selections": [
        {
            "concreteType": "JiraFlag",
            "kind": "LinkedField",
            "name": "flag",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFlagged"
                }
            ]
        }
    ],
    "type": "JiraFlagField"
};
$4965d17ab878198a$var$node.hash = "31300af4f47b42a3abf7e459bcad4233";
var $4965d17ab878198a$export$2e2bcd8739ae039 = $4965d17ab878198a$var$node;

});

parcelRegister("8JJIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa67e05ec42c9446$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fa67e05ec42c9446$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagged: {
        "id": "native-issue-table.common.issue-cells.flag.flagged",
        "defaultMessage": "Impediment"
    }
});

});


parcelRegister("1Yk7g", function(module, exports) {

$parcel$export(module.exports, "GoalsCell", () => $da9b89a027e685da$export$aea87ff07be8100d);

var $aWz4e = parcelRequire("aWz4e");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $4froE = parcelRequire("4froE");

var $e9M6d = parcelRequire("e9M6d");

var $Br57E = parcelRequire("Br57E");

var $jFYC8 = parcelRequire("jFYC8");
const $da9b89a027e685da$export$aea87ff07be8100d = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $aWz4e.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled && (0, $4R6GH.fg)('jsc_goals_inline_edit') ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const shouldTruncate = (0, $e9M6d.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4froE.GoalsInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: shouldTruncate
    });
};

});
parcelRegister("aWz4e", function(module, exports) {

$parcel$export(module.exports, "default", () => $521053acc9bbd0c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<138238bf08ff12610c67c9c231c87b2f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $521053acc9bbd0c5$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "goals_nativeIssueTable_GoalsCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraGoalsField"
};
$521053acc9bbd0c5$var$node.hash = "c06d2cf0d8aec11ffdbf49b380c6dd10";
var $521053acc9bbd0c5$export$2e2bcd8739ae039 = $521053acc9bbd0c5$var$node;

});

parcelRegister("4froE", function(module, exports) {

$parcel$export(module.exports, "GoalsInlineEditViewWithIsEditable", () => $54622b58ee81f5d4$export$16ba9f62f4ede1d3);

var $f5xKG = parcelRequire("f5xKG");

var $kRFcH = parcelRequire("kRFcH");

var $b28DR = parcelRequire("b28DR");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $iJZ8l = parcelRequire("iJZ8l");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $a1oMe = parcelRequire("a1oMe");

var $koeKL = parcelRequire("koeKL");

var $4SN5P = parcelRequire("4SN5P");

var $jrRyX = parcelRequire("jrRyX");

var $a3olt = parcelRequire("a3olt");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $54622b58ee81f5d4$var$isEqualOption = (a, b)=>{
    if (a.length !== b.length) return false;
    const aUrlSet = new Set(a.map((option)=>option.url));
    return b.every((option)=>aUrlSet.has(option.url));
};
const $54622b58ee81f5d4$var$JIRA_GOAL_TYPENAME = 'JiraGoal';
const $54622b58ee81f5d4$var$JIRA_GOAL_EDGE_TYPENAME = 'JiraGoalEdge';
const $54622b58ee81f5d4$export$16ba9f62f4ede1d3 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncated: isTruncated })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $b28DR.default), fragmentRef);
    // for the mutation, only need to worry about the deletion / removal
    // don't worry about insertion as that's handled by the townsquare goal picker
    const [commit] = (0, $8Uumt.useMutation)((0, $kRFcH.default));
    // #endregion Relay
    // #region State
    const constructGoalUrl = (0, $4SN5P.useGoalUrlConstructor)();
    const { __id: __id, id: uniqueFieldId, name: name, type: fieldType, selectedGoals: selectedGoals, issue: issue } = data;
    const selectedGoalsConnectionId = selectedGoals?.__id;
    const initialValue = (0, $5uXOq.useMemo)(()=>{
        const nodes = selectedGoals?.edges?.map((edge)=>edge?.node)?.filter((node)=>Boolean(node?.key)) ?? [];
        return nodes.map((node)=>({
                id: node.id,
                url: constructGoalUrl(node.key)
            }));
    }, [
        constructGoalUrl,
        selectedGoals?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $5uXOq.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #region Action
    const updater = (0, $5uXOq.useCallback)((store, value)=>{
        const connection = selectedGoalsConnectionId ? store.get(selectedGoalsConnectionId) : null;
        if (!connection) return;
        const { EDGES: EDGES, NODE: NODE } = (0, $eiowN.ConnectionInterface).get();
        const edges = connection.getLinkedRecords(EDGES) ?? [];
        const edgesByNodeId = {};
        edges.forEach((edge)=>{
            const nodeId = edge.getLinkedRecord(NODE)?.getValue('id');
            if (typeof nodeId === 'string') edgesByNodeId[nodeId] = edge;
        });
        const nextEdges = [];
        value.forEach(({ id: id, url: url })=>{
            if (id && id in edgesByNodeId) nextEdges.push(edgesByNodeId[id]);
            else {
                const nodeRelayDataId = (0, $iJZ8l.default)({
                    id: id
                }, $54622b58ee81f5d4$var$JIRA_GOAL_TYPENAME);
                const key = (0, $4SN5P.getGoalKeyFromUrl)(url);
                if (nodeRelayDataId) {
                    let node = store.get(nodeRelayDataId);
                    if (!node) {
                        node = store.create(nodeRelayDataId, $54622b58ee81f5d4$var$JIRA_GOAL_TYPENAME);
                        node.setValue(nodeRelayDataId, 'id');
                    }
                    if (key) node.setValue(key, 'key');
                    const edge = (0, $8Uumt.ConnectionHandler).createEdge(store, connection, node, $54622b58ee81f5d4$var$JIRA_GOAL_EDGE_TYPENAME);
                    nextEdges.push(edge);
                }
            }
        });
        connection.setLinkedRecords(nextEdges, EDGES);
    }, [
        selectedGoalsConnectionId
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        const initialIds = initialValue.map(({ id: id })=>id).filter(Boolean);
        const initialIdSet = new Set(initialIds);
        const updatedIds = value.map(({ id: id })=>id).filter(Boolean);
        const updatedIdSet = new Set(updatedIds);
        const deletedRelationships = initialIds.filter((id)=>!updatedIdSet.has(id)).map((id)=>({
                from: issue.id,
                to: id
            }));
        const createdRelationships = updatedIds.filter((id)=>!initialIdSet.has(id)).map((id)=>({
                from: issue.id,
                to: id
            }));
        commit({
            variables: {
                createInput: {
                    relationships: createdRelationships
                },
                deleteInput: {
                    relationships: deletedRelationships
                }
            },
            updater: (store)=>updater(store, value),
            optimisticUpdater: (store)=>updater(store, value),
            onCompleted (mutationData) {
                if (mutationData.townsquare?.createRelationships?.success && mutationData.townsquare?.deleteRelationships?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                townsquare: {
                    createRelationships: {
                        success: true,
                        relationships: createdRelationships
                    },
                    deleteRelationships: {
                        success: true,
                        relationships: deletedRelationships
                    }
                }
            }
        });
    }, [
        onSubmit,
        initialValue,
        commit,
        issue.id,
        updater
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $54622b58ee81f5d4$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue
    });
    // #endregion Action
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a3olt.GoalsReadView), {
            fragmentRef: data,
            isTruncated: isTruncated
        });
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            issueAri: issue.id,
            initialIsOpen: true,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            spacing: spacing
        });
    const cloudId = (0, $koeKL.useCloudId)();
    const editViewEntryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            issueAri: issue.id
        }), [
        cloudId,
        issue.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $a1oMe.default),
        editViewEntryPointParams: editViewEntryPointParams,
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
// #endregion Edit View
};
const $54622b58ee81f5d4$export$fc2645c54795e7e6 = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $f5xKG.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($54622b58ee81f5d4$export$16ba9f62f4ede1d3, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("f5xKG", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c0ec68207d6252$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7542446408a11d8dcd6f34ea8741757a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03c0ec68207d6252$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraGoalsField"
};
$03c0ec68207d6252$var$node.hash = "d698a934047d8a1aef53370ee1f7570c";
var $03c0ec68207d6252$export$2e2bcd8739ae039 = $03c0ec68207d6252$var$node;

});

parcelRegister("kRFcH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c209f5a39c14458$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<57d11f4e2332b19d87c403e7d64ec868>>
 * @relayHash f896f939a1918da6870fd74a26e67107
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8dbb1de2807924cc75847f0e6cb98eddad0909f975f61d85473712a94f60740f
const $9c209f5a39c14458$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deleteInput"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "success"
        },
        {
            "concreteType": "TownsquareRelationship",
            "kind": "LinkedField",
            "name": "relationships",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "from"
                },
                {
                    "kind": "ScalarField",
                    "name": "to"
                }
            ]
        }
    ], v2 = [
        {
            "concreteType": "TownsquareMutationApi",
            "kind": "LinkedField",
            "name": "townsquare",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "createInput"
                        }
                    ],
                    "concreteType": "TownsquareCreateRelationshipsPayload",
                    "kind": "LinkedField",
                    "name": "createRelationships",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "deleteInput"
                        }
                    ],
                    "concreteType": "TownsquareDeleteRelationshipsPayload",
                    "kind": "LinkedField",
                    "name": "deleteRelationships",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "8dbb1de2807924cc75847f0e6cb98eddad0909f975f61d85473712a94f60740f",
            "metadata": {},
            "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9c209f5a39c14458$var$node.hash = "d5d407c381c2f478408ef64adaf27177";
var $9c209f5a39c14458$export$2e2bcd8739ae039 = $9c209f5a39c14458$var$node;

});

parcelRegister("b28DR", function(module, exports) {

$parcel$export(module.exports, "default", () => $468c43a633aca57e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b806e0d4bbf68b8eb5cca1fbda58643>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $468c43a633aca57e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                        v0 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issue"
            },
            {
                "kind": "FragmentSpread",
                "name": "goals_issueFieldGoalsReadviewFull_GoalsReadView"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    }
                                ]
                            }
                        ]
                    },
                    v1 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            v1 /*: any*/ 
        ],
        "type": "JiraGoalsField"
    };
}();
$468c43a633aca57e$var$node.hash = "46c4ce64c1ccf9c7ee8dc2090f374288";
var $468c43a633aca57e$export$2e2bcd8739ae039 = $468c43a633aca57e$var$node;

});

parcelRegister("a1oMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3be109d8eee8802d$export$2e2bcd8739ae039);

var $jcI49 = parcelRequire("jcI49");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $3be109d8eee8802d$var$GoalsEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9VbAm")), {
        moduleId: "8bcf8112"
    }),
    getPreloadProps: ({ cloudId: cloudId, issueAri: issueAri })=>({
            queries: {
                mainGoalsPopupContentQuery: {
                    parameters: (0, $jcI49.default),
                    variables: {
                        cloudId: cloudId,
                        issueAri: issueAri
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});
var $3be109d8eee8802d$export$2e2bcd8739ae039 = $3be109d8eee8802d$var$GoalsEditViewEntryPoint;

});
parcelRegister("jcI49", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a552aaf657035b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc863f7c0959b2e25deb284199453eea>>
 * @relayHash c13167dac448e4f5c0b631b60ba23ded
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bb7cccd795fc3a3a7749d89cb300deef1b787136f6c16ee2e1ebb17697a40cdd
const $56a552aaf657035b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "concreteType": "TownsquareUnshardedUserCapabilities",
        "kind": "LinkedField",
        "name": "userCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareUnshardedCapability",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "capability"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "capabilityContainer"
                    }
                ]
            }
        ]
    }, v5 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "issueAri"
    }, v6 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        v5 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "InlineFragment",
        "selections": v9 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v11 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v12 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v13 = [
        "id"
    ], v14 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainGoalsPopupContentQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueGoals_AtlassianGoalPicker"
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
                    "kind": "LinkedField",
                    "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareUnshardedWorkspaceSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainGoalsPopupContentQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                            "kind": "LinkedField",
                            "name": "jiraEpicContributesToAtlasGoal",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        },
                                                        {
                                                            "concreteType": "TownsquareStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareLocalizationField",
                                                                    "kind": "LinkedField",
                                                                    "name": "localizedLabel",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "messageId"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalIcon",
                                                            "kind": "LinkedField",
                                                            "name": "icon",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appearance"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareGoal"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ 
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "filters": v13 /*: any*/ ,
                            "handle": "connection",
                            "key": "LinkedGoals_jiraEpicContributesToAtlasGoal",
                            "kind": "LinkedHandle",
                            "name": "jiraEpicContributesToAtlasGoal"
                        },
                        {
                            "alias": "issueGoalPicker",
                            "args": v14 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                            "kind": "LinkedField",
                            "name": "jiraEpicContributesToAtlasGoal",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "TownsquareGoal"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "issueGoalPicker",
                            "args": v14 /*: any*/ ,
                            "filters": v13 /*: any*/ ,
                            "handle": "connection",
                            "key": "Goals_issueGoalPicker",
                            "kind": "LinkedHandle",
                            "name": "jiraEpicContributesToAtlasGoal"
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
                    "kind": "LinkedField",
                    "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareUnshardedWorkspaceSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bb7cccd795fc3a3a7749d89cb300deef1b787136f6c16ee2e1ebb17697a40cdd",
            "metadata": {},
            "name": "mainGoalsPopupContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$56a552aaf657035b$var$node.hash = "46961c295be31891ee43ef13cc35d017";
var $56a552aaf657035b$export$2e2bcd8739ae039 = $56a552aaf657035b$var$node;

});

parcelRegister("9VbAm", function(module, exports) {

let $73926c93ac372b3d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $73926c93ac372b3d$var$load("ffQaD"),
    $73926c93ac372b3d$var$load("kvRbA"),
    $73926c93ac372b3d$var$load("bs8Gf")
]).then(()=>parcelRequire('1t0Dz'));

});


parcelRegister("4SN5P", function(module, exports) {

$parcel$export(module.exports, "useGoalUrlConstructor", () => $df5bd6a864d9d384$export$141a926c45c15603);
$parcel$export(module.exports, "getGoalKeyFromUrl", () => $df5bd6a864d9d384$export$9bf22e4fb9891a0d);

var $5uXOq = parcelRequire("5uXOq");

var $14XJw = parcelRequire("14XJw");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

const $df5bd6a864d9d384$export$141a926c45c15603 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const isStagingOrDevOrLocal = (0, $2tT7R.useIsStagingOrDevOrLocal)();
    return (0, $5uXOq.useCallback)((goalKey)=>{
        const atlassianHomeUrl = isStagingOrDevOrLocal ? (0, $f656b0ab912d71fd$export$46b5a4e5fbe6e304) : (0, $f656b0ab912d71fd$export$732915c664dff395);
        return `${atlassianHomeUrl}/o/${orgId}/s/${cloudId}/goal/${goalKey}`;
    }, [
        cloudId,
        isStagingOrDevOrLocal,
        orgId
    ]);
};
const $df5bd6a864d9d384$export$9bf22e4fb9891a0d = (url)=>url.split('/').pop();

});
const $f656b0ab912d71fd$export$732915c664dff395 = 'https://home.atlassian.com';
const $f656b0ab912d71fd$export$46b5a4e5fbe6e304 = 'https://home.stg.atlassian.com';


parcelRegister("a3olt", function(module, exports) {

$parcel$export(module.exports, "GoalsReadView", () => $6f3997a41ef2374a$export$7f51e00c35102426);

var $hbfVo = parcelRequire("hbfVo");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4SN5P = parcelRequire("4SN5P");

var $3Dy3s = parcelRequire("3Dy3s");

var $8qImc = parcelRequire("8qImc");

var $eZibI = parcelRequire("eZibI");

var $koVbs = parcelRequire("koVbs");

var $eNMpo = parcelRequire("eNMpo");

var $92x2t = parcelRequire("92x2t");
const $6f3997a41ef2374a$export$7f51e00c35102426 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const constructGoalUrl = (0, $4SN5P.useGoalUrlConstructor)();
    const { selectedGoals: selectedGoals } = (0, $8Uumt.useFragment)((0, $hbfVo.default), fragmentRef);
    const { firstGoal: firstGoal, totalGoalsCount: totalGoalsCount } = (0, $5uXOq.useMemo)(()=>{
        const nodes = selectedGoals?.edges?.map((edge)=>edge?.node)?.filter((node)=>Boolean(node?.key)) ?? [];
        const transformedNodes = nodes.map((node)=>({
                ...node,
                key: node.id,
                url: constructGoalUrl(node.key)
            }));
        return {
            firstGoal: transformedNodes[0],
            totalGoalsCount: transformedNodes.length
        };
    }, [
        constructGoalUrl,
        selectedGoals?.edges
    ]);
    if (totalGoalsCount === 0 || !selectedGoals) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Dy3s.ItemWithEntryPointPopup), {
        ItemComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8qImc.SimpleInlineSmartLink), {
            anchorTarget: "_blank",
            url: firstGoal.url
        }),
        totalItems: totalGoalsCount,
        isTruncated: isTruncated,
        entryPoint: (0, $eNMpo.goalsPopupContentEntryPoint),
        entryPointParams: {},
        entryPointRuntimeProps: {
            fragmentRef: selectedGoals
        },
        showMoreTooltip: formatMessage((0, $92x2t.default).showMoreTooltip),
        actionSubjectIdPrefix: "goals"
    });
};

});
parcelRegister("hbfVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e5c987459c67a03$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc3ad8e62c65a9e808cd72ccc0efee71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5e5c987459c67a03$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "goals_issueFieldGoalsReadviewFull_GoalsReadView",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraGoalConnection",
            "kind": "LinkedField",
            "name": "selectedGoals",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "popupContent_issueFieldGoalsReadviewFull"
                },
                {
                    "concreteType": "JiraGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraGoal",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedGoals(first:1000)"
        }
    ],
    "type": "JiraGoalsField"
};
$5e5c987459c67a03$var$node.hash = "13eae32e673f8f11067837df02577e03";
var $5e5c987459c67a03$export$2e2bcd8739ae039 = $5e5c987459c67a03$var$node;

});

parcelRegister("3Dy3s", function(module, exports) {

$parcel$export(module.exports, "ItemWithEntryPointPopup", () => $99964dae7502f88c$export$15750a4e92a11aeb);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $eZJjh = parcelRequire("eZJjh");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $8wiEe = parcelRequire("8wiEe");

var $gZqkW = parcelRequire("gZqkW");
const $99964dae7502f88c$export$15750a4e92a11aeb = ({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointRuntimeProps: entryPointRuntimeProps, ...props })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)(entryPoint, entryPointParams);
    const [retryKey, setRetryKey] = (0, $5uXOq.useState)(0);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wiEe.default), {
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        triggerRefCallback: triggerRef,
        entryPointActions: entryPointActions,
        PopupComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            key: retryKey,
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "popup-content",
            packageName: "jiraItemWithPopup",
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZqkW.ErrorFallback), {
                    onClick: ()=>setRetryKey((prev)=>prev + 1)
                }),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                padding: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "medium"
            })),
            runtimeProps: entryPointRuntimeProps
        }),
        ...props
    });
};

});
parcelRegister("8wiEe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea7929992b811d71$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");

var $4R6GH = parcelRequire("4R6GH");

var $79UpA = parcelRequire("79UpA");

var $bLc87 = parcelRequire("bLc87");
const $ea7929992b811d71$var$ItemWithPopup = ({ ItemComponent: ItemComponent, showMoreTooltip: showMoreTooltip, totalItems: totalItems, PopupComponent: PopupComponent, isOpen: isOpen, onSetIsOpen: onSetIsOpen, triggerRefCallback: triggerRefCallback, actionSubjectIdPrefix: actionSubjectIdPrefix, isTruncated: isTruncated = false, entryPointActions: entryPointActions })=>{
    if (ItemComponent === undefined) return null;
    const shouldTruncated = isTruncated && (0, $4R6GH.fg)('jsc_inline_editing_field_refactor');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: !shouldTruncated
    }, ItemComponent, totalItems > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79UpA.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bLc87.default), {
        showMoreTooltip: showMoreTooltip,
        totalItems: totalItems - 1,
        PopupComponent: PopupComponent,
        isOpen: isOpen,
        onSetIsOpen: onSetIsOpen,
        triggerRefCallback: triggerRefCallback,
        actionSubjectIdPrefix: actionSubjectIdPrefix,
        isTruncated: isTruncated,
        entryPointActions: entryPointActions
    })));
};
var $ea7929992b811d71$export$2e2bcd8739ae039 = $ea7929992b811d71$var$ItemWithPopup;

});
parcelRegister("bLc87", function(module, exports) {

$parcel$export(module.exports, "default", () => $278fbb7f351a6662$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $9fuVs = parcelRequire("9fuVs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dpHMc = parcelRequire("dpHMc");
const $278fbb7f351a6662$var$ShowMorePopup = ({ showMoreTooltip: showMoreTooltip, totalItems: totalItems, PopupComponent: PopupComponent, isOpen: isOpen, onSetIsOpen: onSetIsOpen, triggerRefCallback: triggerRefCallback, actionSubjectIdPrefix: actionSubjectIdPrefix, isTruncated: isTruncated, entryPointActions: entryPointActions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (totalItems === 0) return null;
    const onClickTrigger = ()=>{
        onSetIsOpen(!isOpen);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), `${actionSubjectIdPrefix}ItemWithPopup`);
    };
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $278fbb7f351a6662$var$ContainerDialogStyles
        }, PopupComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null));
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.CellHoverRenderer), null, (hoverProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
            content: PopupComponent,
            entryPointActions: entryPointActions,
            isInteractive: true
        }, ({ ref: ref, ariaExpanded: ariaExpanded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                "aria-label": `${showMoreTooltip} +${totalItems}`,
                isSelected: isOpen,
                spacing: "none",
                "aria-expanded": ariaExpanded,
                testId: "item-with-popup.ui.item-with-popup.show-more-popup.button",
                ref: ref,
                ...hoverProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                as: "span",
                xcss: $278fbb7f351a6662$var$itemsCountStyles,
                paddingInline: "space.050"
            }, "+", totalItems)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>onSetIsOpen(false),
        placement: "bottom",
        content: content,
        testId: "item-with-popup.ui.item-with-popup.show-more-popup.show-more-popup",
        messageId: "item-with-popup.ui.item-with-popup.show-more-popup.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                key: "triggerLinksDialog",
                content: showMoreTooltip,
                tag: $278fbb7f351a6662$var$TooltipContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                "aria-label": `${showMoreTooltip} +${totalItems}`,
                isSelected: isOpen,
                onClick: onClickTrigger,
                spacing: "none",
                ref: (element)=>{
                    triggerRefCallback && triggerRefCallback(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                as: "span",
                xcss: $278fbb7f351a6662$var$itemsCountStyles,
                paddingInline: "space.050"
            }, "+", totalItems)))
    });
};
const $278fbb7f351a6662$var$TooltipContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ...props,
        ref: ref,
        as: "span",
        xcss: $278fbb7f351a6662$var$tooltipContainerStyles
    }));
const $278fbb7f351a6662$var$ContainerDialogStyles = (0, $8CUq3.xcss)({
    width: '240px',
    maxHeight: '220px',
    overflow: 'auto',
    padding: 'space.100',
    border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
    borderRadius: 'border.radius'
});
const $278fbb7f351a6662$var$tooltipContainerStyles = (0, $8CUq3.xcss)({
    maxWidth: '100%'
});
const $278fbb7f351a6662$var$itemsCountStyles = (0, $8CUq3.xcss)({
    fontWeight: "var(--ds-font-weight-regular, 400)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-250, 20px)"
});
var $278fbb7f351a6662$export$2e2bcd8739ae039 = $278fbb7f351a6662$var$ShowMorePopup;

});


parcelRegister("gZqkW", function(module, exports) {

$parcel$export(module.exports, "ErrorFallback", () => $1341304fc7f28080$export$8a7ad05c3ee0c78a);

var $5uXOq = parcelRequire("5uXOq");

var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $hMVoD = parcelRequire("hMVoD");

var $eCeGD = parcelRequire("eCeGD");

var $koVbs = parcelRequire("koVbs");

var $cDi7Q = parcelRequire("cDi7Q");
const $1341304fc7f28080$export$8a7ad05c3ee0c78a = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong"
    }, formatMessage((0, $cDi7Q.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        onClick: onClick,
        spacing: "compact"
    }, formatMessage((0, $cDi7Q.default).retryMessage)));
};

});
parcelRegister("cDi7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a53cdfd6cf39214$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1a53cdfd6cf39214$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retryMessage: {
        "id": "item-with-popup.ui.item-with-entrypoint-popup.error-fallback.retry-message",
        "defaultMessage": "Click to retry"
    },
    errorMessage: {
        "id": "item-with-popup.ui.item-with-entrypoint-popup.error-fallback.error-message",
        "defaultMessage": "Failed to load content"
    }
});

});



parcelRegister("8qImc", function(module, exports) {

$parcel$export(module.exports, "SimpleInlineSmartLink", () => $79653708edbaa6cd$export$e918b96127f4d56b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dn5wJ = parcelRequire("dn5wJ");
var $8dVIb = parcelRequire("8dVIb");
var $buvhv = parcelRequire("buvhv");

var $0Tx5e = parcelRequire("0Tx5e");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4WT1d = parcelRequire("4WT1d");
const $79653708edbaa6cd$var$uiOptions = {
    clickableContainer: true,
    hideBackground: true,
    hideElevation: true,
    hidePadding: true,
    size: (0, $8dVIb.SmartLinkSize).Medium
};
const $79653708edbaa6cd$var$actionOptions = {
    hide: false,
    exclude: [
        (0, $dn5wJ.CardAction).ChangeStatusAction
    ]
};
const $79653708edbaa6cd$export$e918b96127f4d56b = ({ onRemove: onRemove, url: url, anchorTarget: anchorTarget, showHoverPreview: showHoverPreview = true, text: text, anchorRef: anchorRef, onError: onError })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.025",
        paddingInline: "space.050",
        xcss: $79653708edbaa6cd$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0Tx5e.CardSSR), {
        appearance: "inline",
        url: url,
        ui: $79653708edbaa6cd$var$uiOptions,
        actionOptions: $79653708edbaa6cd$var$actionOptions,
        showHoverPreview: showHoverPreview,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buvhv.default), {
        hideTitleTooltip: true,
        maxLines: 1,
        metadata: [
            {
                name: (0, $8dVIb.ElementName).State
            }
        ],
        anchorTarget: anchorTarget ?? '_self',
        text: text,
        anchorRef: anchorRef,
        className: (0, $bwpsq.default)([
            "_zulp1b66"
        ])
    })), onRemove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4WT1d.RemoveButton), {
        onClick: onRemove
    }));
};
const $79653708edbaa6cd$var$inlineStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.raised',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRadius: 'border.radius',
    display: 'inline-flex',
    gap: 'space.050'
});
const $79653708edbaa6cd$var$titleBlockStyles = null;

});
parcelRegister("dn5wJ", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $b402a0f22139e437$export$f40b7e0b762b928b);
var $b402a0f22139e437$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});

parcelRegister("8dVIb", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $ad6fd5c2f706e309$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $ad6fd5c2f706e309$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $ad6fd5c2f706e309$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $ad6fd5c2f706e309$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $ad6fd5c2f706e309$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $ad6fd5c2f706e309$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $ad6fd5c2f706e309$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $ad6fd5c2f706e309$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $ad6fd5c2f706e309$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $ad6fd5c2f706e309$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $ad6fd5c2f706e309$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $ad6fd5c2f706e309$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $ad6fd5c2f706e309$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $ad6fd5c2f706e309$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $ad6fd5c2f706e309$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $ad6fd5c2f706e309$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $ad6fd5c2f706e309$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $ad6fd5c2f706e309$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804);
const $ad6fd5c2f706e309$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $ad6fd5c2f706e309$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $ad6fd5c2f706e309$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $ad6fd5c2f706e309$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $ad6fd5c2f706e309$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $ad6fd5c2f706e309$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $ad6fd5c2f706e309$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $ad6fd5c2f706e309$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $ad6fd5c2f706e309$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $ad6fd5c2f706e309$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $ad6fd5c2f706e309$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $ad6fd5c2f706e309$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $ad6fd5c2f706e309$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $ad6fd5c2f706e309$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $ad6fd5c2f706e309$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $ad6fd5c2f706e309$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $ad6fd5c2f706e309$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $ad6fd5c2f706e309$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("buvhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b66054384f48ec$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $fkxMX = parcelRequire("fkxMX");

var $bXy5i = parcelRequire("bXy5i");

var $jHa2h = parcelRequire("jHa2h");
const $93b66054384f48ec$var$actionStyles = null;
const $93b66054384f48ec$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Pending:
        case (0, $8dVIb.SmartLinkStatus).Resolving:
            return 0, $jHa2h.default;
        case (0, $8dVIb.SmartLinkStatus).Resolved:
            return 0, $bXy5i.default;
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).NotFound:
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            return 0, $fkxMX.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $93b66054384f48ec$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, status: statusProp = (0, $8dVIb.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, ...props })=>{
    const cardContext = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $Nh1XU.useFlexibleCardContext)() : undefined;
    const { status: status = (0, $8dVIb.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    if (!(0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action')) {
        if (hideRetry && props.retry) delete props.retry;
    }
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $5uXOq.useState)(false);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
            onClick: onClick
        },
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? ui?.theme : theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $93b66054384f48ec$var$getTitleBlockViewComponent((0, $VSDnB.fg)('platform-linking-flexible-card-context') ? status : statusProp);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? {
            hideRetry: hideRetry
        } : undefined,
        icon: icon,
        size: (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? props.size ?? ui?.size : props?.size,
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
            theme: theme
        },
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};
var $93b66054384f48ec$export$2e2bcd8739ae039 = $93b66054384f48ec$var$TitleBlock;

});
parcelRegister("4URMI", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $0d5ea96be37e2b5d$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $0d5ea96be37e2b5d$export$df67f318ded0283c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $g2eZ6 = parcelRequire("g2eZ6");
var $0d5ea96be37e2b5d$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
    return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
};

});
parcelRegister("g2eZ6", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $473b45d487f9fd1b$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $473b45d487f9fd1b$export$263352d59c0c5966);

var $5uXOq = parcelRequire("5uXOq");

var $b6uPu = parcelRequire("b6uPu");

var $4URMI = parcelRequire("4URMI");

var $fzJZi = parcelRequire("fzJZi");
const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $b6uPu.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $473b45d487f9fd1b$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4URMI.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4URMI.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("b6uPu", function(module, exports) {

$parcel$export(module.exports, "browser", () => $7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
const $7f7209ce5c1e8d08$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
    return $7f7209ce5c1e8d08$var$result;
}

});

parcelRegister("fzJZi", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3b4d25437cc28513$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3b4d25437cc28513$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3b4d25437cc28513$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3b4d25437cc28513$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3b4d25437cc28513$export$b91e0203b928470c);
const $3b4d25437cc28513$export$85183a312807388d = 'media';
const $3b4d25437cc28513$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3b4d25437cc28513$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3b4d25437cc28513$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3b4d25437cc28513$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3b4d25437cc28513$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
};

});



parcelRegister("Nh1XU", function(module, exports) {

$parcel$export(module.exports, "FlexibleCardContext", () => $79a38154bf117346$export$13dde4423ab71d62);
$parcel$export(module.exports, "useFlexibleCardContext", () => $79a38154bf117346$export$a8c4167e4e9f26ab);
$parcel$export(module.exports, "FlexibleUiContext", () => $79a38154bf117346$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $79a38154bf117346$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $79a38154bf117346$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $79a38154bf117346$export$e6b5ad18b56e8f51);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $79a38154bf117346$export$13dde4423ab71d62 = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$a8c4167e4e9f26ab = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$13dde4423ab71d62);
const $79a38154bf117346$export$ca70b164b615de47 = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$61d7957a243df7aa = ()=>(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? $79a38154bf117346$export$a8c4167e4e9f26ab()?.data : (0, $5uXOq.useContext)($79a38154bf117346$export$ca70b164b615de47);
const $79a38154bf117346$export$f7433dbd6c50e26a = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$e6b5ad18b56e8f51 = ()=>(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? $79a38154bf117346$export$a8c4167e4e9f26ab()?.ui : (0, $5uXOq.useContext)($79a38154bf117346$export$f7433dbd6c50e26a);

});

parcelRegister("eqoQu", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $ec376f2b71614cc0$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $ec376f2b71614cc0$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $ec376f2b71614cc0$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $ec376f2b71614cc0$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $ec376f2b71614cc0$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $ec376f2b71614cc0$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $ec376f2b71614cc0$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $ec376f2b71614cc0$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $ec376f2b71614cc0$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $ec376f2b71614cc0$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $ec376f2b71614cc0$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $ec376f2b71614cc0$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $ec376f2b71614cc0$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $ec376f2b71614cc0$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $ec376f2b71614cc0$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $ec376f2b71614cc0$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $ec376f2b71614cc0$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $ec376f2b71614cc0$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $ec376f2b71614cc0$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $ec376f2b71614cc0$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $ec376f2b71614cc0$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $ec376f2b71614cc0$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $ec376f2b71614cc0$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $ec376f2b71614cc0$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $ec376f2b71614cc0$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $ec376f2b71614cc0$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $ec376f2b71614cc0$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $ec376f2b71614cc0$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $ec376f2b71614cc0$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $ec376f2b71614cc0$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $ec376f2b71614cc0$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $ec376f2b71614cc0$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("4gwhW")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("kp8aU")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("iG1Aw")).default);

var $8dVIb = parcelRequire("8dVIb");

var $eCsaJ = parcelRequire("eCsaJ");

var $4gwhW = parcelRequire("4gwhW");

var $kp8aU = parcelRequire("kp8aU");

var $iG1Aw = parcelRequire("iG1Aw");
const $ec376f2b71614cc0$export$d3af56c23f9e459b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedTo);
const $ec376f2b71614cc0$export$fbd18f11bf3a3444 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedToGroup);
const $ec376f2b71614cc0$export$3bc3c9693a40aa = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AttachmentCount);
const $ec376f2b71614cc0$export$2ae2af4435dd6144 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AuthorGroup);
const $ec376f2b71614cc0$export$5742b38fd5cfe410 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ChecklistProgress);
const $ec376f2b71614cc0$export$a1e647014985ddb9 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CollaboratorGroup);
const $ec376f2b71614cc0$export$f4c1466e6fdd07b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CommentCount);
const $ec376f2b71614cc0$export$53ced9403d373871 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedOn);
const $ec376f2b71614cc0$export$db468caedefbb630 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedBy);
const $ec376f2b71614cc0$export$fea59459cfa1625b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).DueOn);
const $ec376f2b71614cc0$export$2aa8c58ab6c8ae64 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LatestCommit);
const $ec376f2b71614cc0$export$69387b41dfc808f7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LinkIcon);
const $ec376f2b71614cc0$export$18a2be9195644f38 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Location);
const $ec376f2b71614cc0$export$ebbbdcc68d717b7b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedBy);
const $ec376f2b71614cc0$export$a6db3f4240728b58 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedOn);
const $ec376f2b71614cc0$export$fa04b1f8d953704f = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedBy);
const $ec376f2b71614cc0$export$90e81c873cca1e90 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedByGroup);
const $ec376f2b71614cc0$export$300334f671c43555 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Priority);
const $ec376f2b71614cc0$export$7904b5485bf997ea = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ProgrammingLanguage);
const $ec376f2b71614cc0$export$2881499e37b75b9a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Provider);
const $ec376f2b71614cc0$export$f69df2decd5f729e = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReactCount);
const $ec376f2b71614cc0$export$77dedcd16f070a20 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReadTime);
const $ec376f2b71614cc0$export$897b145a1ed39fe5 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SentOn);
const $ec376f2b71614cc0$export$387c3264a8f67d61 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SourceBranch);
const $ec376f2b71614cc0$export$7254cc27399e90bd = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).State);
const $ec376f2b71614cc0$export$cfafe90bba8a54db = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubscriberCount);
const $ec376f2b71614cc0$export$d441f34e4c8dd9e7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubTasksProgress);
const $ec376f2b71614cc0$export$634eef04d1a9a575 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).StoryPoints);
const $ec376f2b71614cc0$export$b5e4199e062b8f44 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).TargetBranch);
const $ec376f2b71614cc0$export$f99233281efd08a0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Title);
const $ec376f2b71614cc0$export$ae2d8be089b6cfe0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ViewCount);
const $ec376f2b71614cc0$export$b080bef6ed7fa75a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).VoteCount);

});
parcelRegister("eCsaJ", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $3c92d860530d8c8b$export$c8a8987d4410bf2d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iG1Aw = parcelRequire("iG1Aw");

var $4Xgub = parcelRequire("4Xgub");

var $gzmfH = parcelRequire("gzmfH");

var $iyiGe = parcelRequire("iyiGe");

var $aV6Md = parcelRequire("aV6Md");

var $lwU5V = parcelRequire("lwU5V");

var $jmLta = parcelRequire("jmLta");

var $4yhoW = parcelRequire("4yhoW");

var $eiceF = parcelRequire("eiceF");
var $8JkyP = parcelRequire("8JkyP");
var $hg3n9 = parcelRequire("hg3n9");
var $hMRm5 = parcelRequire("hMRm5");
var $9TvvC = parcelRequire("9TvvC");
var $f8hXJ = parcelRequire("f8hXJ");
var $Rf8nG = parcelRequire("Rf8nG");
var $eL5Me = parcelRequire("eL5Me");

var $fZ5Rc = parcelRequire("fZ5Rc");

var $2Lk0M = parcelRequire("2Lk0M");

var $6WvJP = parcelRequire("6WvJP");

var $3fl0H = parcelRequire("3fl0H");

var $3PUOW = parcelRequire("3PUOW");

var $jWYXR = parcelRequire("jWYXR");

var $h2tJr = parcelRequire("h2tJr");

var $fGb2i = parcelRequire("fGb2i");

var $2V8HO = parcelRequire("2V8HO");

var $8m6ON = parcelRequire("8m6ON");

var $jZqBQ = parcelRequire("jZqBQ");

var $4gwhW = parcelRequire("4gwhW");

var $kwJiq = parcelRequire("kwJiq");

var $f9GCy = parcelRequire("f9GCy");

var $hRhDt = parcelRequire("hRhDt");

var $9WaRz = parcelRequire("9WaRz");

var $bUqCh = parcelRequire("bUqCh");

var $f6mgE = parcelRequire("f6mgE");

var $eEGHy = parcelRequire("eEGHy");

var $c6O1q = parcelRequire("c6O1q");

var $enxie = parcelRequire("enxie");

var $7iJoh = parcelRequire("7iJoh");

var $ab13D = parcelRequire("ab13D");

var $jJwLC = parcelRequire("jJwLC");

var $ivaGo = parcelRequire("ivaGo");

var $hp8Xw = parcelRequire("hp8Xw");

var $cG2jR = parcelRequire("cG2jR");
/**
 * @deprecated remove on FG clean up platform-linking-flexible-card-elements-refactor
 */ const $3c92d860530d8c8b$var$elementMappings = {
    [(0, $8dVIb.ElementName).AppliedToComponentsCount]: {
        component: (0, $iG1Aw.default),
        props: {
            icon: (0, $8dVIb.IconType).Component
        }
    },
    [(0, $8dVIb.ElementName).AttachmentCount]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).Attachment
        },
        newComponent: (0, $iyiGe.default)
    },
    [(0, $8dVIb.ElementName).AuthorGroup]: {
        component: (0, $8JkyP.default),
        newComponent: (0, $aV6Md.default)
    },
    [(0, $8dVIb.ElementName).ChecklistProgress]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).CheckItem
        },
        newComponent: (0, $lwU5V.default)
    },
    [(0, $8dVIb.ElementName).CollaboratorGroup]: {
        component: (0, $8JkyP.default),
        newComponent: (0, $jmLta.default)
    },
    [(0, $8dVIb.ElementName).CommentCount]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).Comment
        },
        newComponent: (0, $4yhoW.default)
    },
    [(0, $8dVIb.ElementName).ViewCount]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).View
        },
        newComponent: (0, $hp8Xw.default)
    },
    [(0, $8dVIb.ElementName).ReactCount]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).React
        },
        newComponent: (0, $9WaRz.default)
    },
    [(0, $8dVIb.ElementName).VoteCount]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).Vote
        },
        newComponent: (0, $cG2jR.default)
    },
    [(0, $8dVIb.ElementName).CreatedBy]: {
        component: (0, $eL5Me.default),
        newComponent: (0, $fZ5Rc.default)
    },
    [(0, $8dVIb.ElementName).OwnedBy]: {
        component: (0, $eL5Me.default),
        newComponent: (0, $8m6ON.default)
    },
    [(0, $8dVIb.ElementName).AssignedTo]: {
        component: (0, $eL5Me.default),
        newComponent: (0, $4Xgub.default)
    },
    [(0, $8dVIb.ElementName).AssignedToGroup]: {
        component: (0, $8JkyP.default),
        newComponent: (0, $gzmfH.default)
    },
    [(0, $8dVIb.ElementName).OwnedByGroup]: {
        component: (0, $8JkyP.default),
        newComponent: (0, $jZqBQ.default)
    },
    [(0, $8dVIb.ElementName).CreatedOn]: {
        component: (0, $hMRm5.default),
        newComponent: (0, $2Lk0M.default)
    },
    [(0, $8dVIb.ElementName).DueOn]: {
        component: (0, $Rf8nG.default),
        newComponent: (0, $6WvJP.default)
    },
    [(0, $8dVIb.ElementName).LatestCommit]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).Commit
        },
        newComponent: (0, $3fl0H.default)
    },
    [(0, $8dVIb.ElementName).LinkIcon]: {
        component: (0, $9TvvC.default),
        newComponent: (0, $3PUOW.default)
    },
    [(0, $8dVIb.ElementName).ModifiedBy]: {
        component: (0, $eL5Me.default),
        newComponent: (0, $fGb2i.default)
    },
    [(0, $8dVIb.ElementName).ModifiedOn]: {
        component: (0, $hMRm5.default),
        newComponent: (0, $2V8HO.default)
    },
    [(0, $8dVIb.ElementName).Preview]: {
        component: (0, $h2tJr.default),
        newComponent: (0, $4gwhW.default)
    },
    [(0, $8dVIb.ElementName).Priority]: {
        component: (0, $hg3n9.default),
        newComponent: (0, $kwJiq.default)
    },
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).ProgrammingLanguage
        },
        newComponent: (0, $f9GCy.default)
    },
    [(0, $8dVIb.ElementName).Provider]: {
        component: (0, $hg3n9.default),
        newComponent: (0, $hRhDt.default)
    },
    [(0, $8dVIb.ElementName).ReadTime]: {
        component: (0, $eL5Me.default),
        newComponent: (0, $bUqCh.default)
    },
    [(0, $8dVIb.ElementName).SentOn]: {
        component: (0, $hMRm5.default),
        newComponent: (0, $f6mgE.default)
    },
    [(0, $8dVIb.ElementName).SourceBranch]: {
        component: (0, $eL5Me.default),
        newComponent: (0, $eEGHy.default)
    },
    [(0, $8dVIb.ElementName).State]: {
        component: (0, $Rf8nG.default),
        newComponent: (0, $c6O1q.default)
    },
    [(0, $8dVIb.ElementName).SubscriberCount]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).Subscriber
        },
        newComponent: (0, $ab13D.default)
    },
    [(0, $8dVIb.ElementName).SubTasksProgress]: {
        component: (0, $hg3n9.default),
        props: {
            icon: (0, $8dVIb.IconType).SubTasksProgress
        },
        newComponent: (0, $7iJoh.default)
    },
    [(0, $8dVIb.ElementName).StoryPoints]: {
        component: (0, $eiceF.default),
        newComponent: (0, $enxie.default)
    },
    [(0, $8dVIb.ElementName).TargetBranch]: {
        component: (0, $eL5Me.default),
        newComponent: (0, $jJwLC.default)
    },
    [(0, $8dVIb.ElementName).Title]: {
        component: (0, $f8hXJ.default),
        newComponent: (0, $ivaGo.default)
    },
    [(0, $8dVIb.ElementName).Location]: {
        component: (0, $f8hXJ.default),
        props: {
            theme: (0, $8dVIb.SmartLinkInternalTheme).Grey
        },
        newComponent: (0, $jWYXR.default)
    }
};
/**
 * @deprecated remove on FG clean up platform-linking-flexible-card-elements-refactor
 */ const $3c92d860530d8c8b$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
/**
 * @deprecated remove on FG clean up platform-linking-flexible-card-elements-refactor
 */ const $3c92d860530d8c8b$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
        case (0, $8dVIb.ElementName).AuthorGroup:
        case (0, $8dVIb.ElementName).CollaboratorGroup:
        case (0, $8dVIb.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $8dVIb.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return (0, $8JkyP.toAvatarGroupProps)(data, showFallbackAvatar);
        case (0, $8dVIb.ElementName).AppliedToComponentsCount:
        case (0, $8dVIb.ElementName).AttachmentCount:
        case (0, $8dVIb.ElementName).ChecklistProgress:
        case (0, $8dVIb.ElementName).CommentCount:
        case (0, $8dVIb.ElementName).ViewCount:
        case (0, $8dVIb.ElementName).ReactCount:
        case (0, $8dVIb.ElementName).VoteCount:
        case (0, $8dVIb.ElementName).ProgrammingLanguage:
        case (0, $8dVIb.ElementName).SubscriberCount:
        case (0, $8dVIb.ElementName).LatestCommit:
        case (0, $8dVIb.ElementName).SubTasksProgress:
            return (0, $hg3n9.toBadgeProps)(data);
        case (0, $8dVIb.ElementName).StoryPoints:
            return (0, $eiceF.toAtlaskitBadgeProps)(data);
        case (0, $8dVIb.ElementName).CreatedBy:
            return (0, $eL5Me.toFormattedTextProps)((0, $7zaVw.messages).created_by, context.createdBy);
        case (0, $8dVIb.ElementName).AssignedTo:
            return (0, $eL5Me.toFormattedTextProps)((0, $7zaVw.messages).assigned_to, context.assignedTo);
        case (0, $8dVIb.ElementName).OwnedBy:
            return (0, $eL5Me.toFormattedTextProps)((0, $7zaVw.messages).owned_by, context.ownedBy);
        case (0, $8dVIb.ElementName).CreatedOn:
            return (0, $hMRm5.toDateTimeProps)('created', context.createdOn);
        case (0, $8dVIb.ElementName).DueOn:
            return (0, $Rf8nG.toDateLozengeProps)(context.dueOn);
        case (0, $8dVIb.ElementName).ModifiedBy:
            return (0, $eL5Me.toFormattedTextProps)((0, $7zaVw.messages).modified_by, context.modifiedBy);
        case (0, $8dVIb.ElementName).ModifiedOn:
            return (0, $hMRm5.toDateTimeProps)('modified', context.modifiedOn);
        case (0, $8dVIb.ElementName).SentOn:
            return (0, $hMRm5.toDateTimeProps)('sent', context.sentOn);
        case (0, $8dVIb.ElementName).ReadTime:
            return (0, $eL5Me.toFormattedTextProps)((0, $7zaVw.messages).read_time, data);
        case (0, $8dVIb.ElementName).SourceBranch:
        case (0, $8dVIb.ElementName).TargetBranch:
            return (0, $eL5Me.toTextProps)(data);
        case (0, $8dVIb.ElementName).Title:
            if ((0, $VSDnB.fg)('platform-linking-flexible-card-context')) return context.linkTitle;
            return (0, $f8hXJ.toLinkProps)(context.title, context.url);
        case (0, $8dVIb.ElementName).LinkIcon:
            if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v2')) return (0, $9TvvC.toLinkIconProps)(data, context.type);
            return typeof data === 'object' ? data : undefined;
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $3c92d860530d8c8b$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props, newComponent: newComponent } = $3c92d860530d8c8b$var$elementMappings[name] || {};
    if (newComponent && (0, $VSDnB.fg)('platform-linking-flexible-card-elements-refactor')) return newComponent;
    const contextKey = $3c92d860530d8c8b$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $Nh1XU.useFlexibleUiContext)() : (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
        const data = $3c92d860530d8c8b$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, $2OMIu.jsx)(BaseElement, {
            ...props,
            ...data,
            ...overrides,
            name: name
        }) : null;
    };
};

});
parcelRegister("7zaVw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a298b78183f16654$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a298b78183f16654$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    /**
	 * @deprecated remove when cleaning up FG platform_bandicoots-smart-card-disable-aria
	 */ more_information_about_this_work_item: {
        id: 'fabric.linking.more_information_about_this_work_item',
        defaultMessage: 'More information about this work item',
        description: 'Allows the users to see more about the work item'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_modal_title_v2: {
        id: 'fabric.linking.related_links_modal_title_v2',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_found_in_v2: {
        id: 'fabric.linking.related_links_found_in_v2',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_includes_links_to_v2: {
        id: 'fabric.linking.related_links_includes_links_to_v2',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    }
});

});

parcelRegister("iG1Aw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e7eab4f33cc1929$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $4e7eab4f33cc1929$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $7zaVw.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        icon: (0, $8dVIb.IconType).Component,
        label: label,
        ...props
    });
};
var $4e7eab4f33cc1929$export$2e2bcd8739ae039 = $4e7eab4f33cc1929$var$AppliedToComponentsCountElement;

});
parcelRegister("hg3n9", function(module, exports) {

$parcel$export(module.exports, "default", () => $13d6ce54266be73c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toBadgeProps", () => $13d6ce54266be73c$export$a2fb457791942ba4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $h5UrH = parcelRequire("h5UrH");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $3dubP = parcelRequire("3dubP");

var $fpDmE = parcelRequire("fpDmE");
const $13d6ce54266be73c$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $13d6ce54266be73c$var$colorMap = {
    subtle: "_syaz131l",
    default: "_syaz1gjq"
};
const $13d6ce54266be73c$var$badgeStyles = null;
const $13d6ce54266be73c$var$iconStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $13d6ce54266be73c$var$labelStylesOld = null;
const $13d6ce54266be73c$var$messageMapper = {
    [(0, $8dVIb.IconType).PriorityBlocker]: (0, $7zaVw.messages).priority_blocker,
    [(0, $8dVIb.IconType).PriorityCritical]: (0, $7zaVw.messages).priority_critical,
    [(0, $8dVIb.IconType).PriorityHigh]: (0, $7zaVw.messages).priority_high,
    [(0, $8dVIb.IconType).PriorityHighest]: (0, $7zaVw.messages).priority_highest,
    [(0, $8dVIb.IconType).PriorityLow]: (0, $7zaVw.messages).priority_low,
    [(0, $8dVIb.IconType).PriorityLowest]: (0, $7zaVw.messages).priority_lowest,
    [(0, $8dVIb.IconType).PriorityMajor]: (0, $7zaVw.messages).priority_major,
    [(0, $8dVIb.IconType).PriorityMedium]: (0, $7zaVw.messages).priority_medium,
    [(0, $8dVIb.IconType).PriorityMinor]: (0, $7zaVw.messages).priority_minor,
    [(0, $8dVIb.IconType).PriorityTrivial]: (0, $7zaVw.messages).priority_trivial,
    [(0, $8dVIb.IconType).PriorityUndefined]: (0, $7zaVw.messages).priority_undefined
};
const $13d6ce54266be73c$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $13d6ce54266be73c$var$messageMapper[icon];
        if (descriptor) return (0, $fpDmE.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $13d6ce54266be73c$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Hdrc.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $13d6ce54266be73c$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BaseBadgeElementProps} BaseBadgeElementProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $13d6ce54266be73c$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color }, ref)=>{
    const formattedMessageOrLabel = $13d6ce54266be73c$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $13d6ce54266be73c$var$renderAtlaskitIcon(icon, testId) || $13d6ce54266be73c$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color && (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props') ? color : undefined
        },
        className: (0, $bwpsq.default)([
            $13d6ce54266be73c$var$styles.container,
            $13d6ce54266be73c$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                xcss: $13d6ce54266be73c$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $13d6ce54266be73c$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(BaseBadgeElement);
const $13d6ce54266be73c$var$BaseBadgeElementRefreshNewWithOverrideCss = (0, $3dubP.withOverrideCss)($13d6ce54266be73c$var$BaseBadgeRefreshNew);
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $13d6ce54266be73c$var$BaseBadgeElementCompiledNew = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, className: className, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $13d6ce54266be73c$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $13d6ce54266be73c$var$renderAtlaskitIcon(icon, testId) || $13d6ce54266be73c$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_16jlidpf _1o9zidpf _i0dl1wug _syaz1oju _vwz4idpf _s7n4nkob _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v _1jtnidpf _13t3idpf _rm9uidpf _rtqbnkob _e4kmnkob _z239nkob"
                ]),
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": `${testId}-label`,
                className: (0, $bwpsq.default)([
                    "_11c8dcr7 _syaz131l _19bv1xvx _s7n4nkob"
                ]),
                children: formattedMessageOrLabel
            })
        ]
    });
};
var $13d6ce54266be73c$export$2e2bcd8739ae039 = (0, $h5UrH.withFeatureFlaggedComponent)($13d6ce54266be73c$var$BaseBadgeElementCompiledNew, $13d6ce54266be73c$var$BaseBadgeElementRefreshNewWithOverrideCss, ()=>(0, $VSDnB.fg)('platform-linking-visual-refresh-v1'));
const $13d6ce54266be73c$export$a2fb457791942ba4 = (label)=>{
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-elements-refactor')) // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
    return label ? {
        label: label
    } : undefined;
};

});
parcelRegister("h5UrH", function(module, exports) {

$parcel$export(module.exports, "withFeatureFlaggedComponent", () => $080bc03d046ff7bd$export$55dba0d8ccf3da86);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $080bc03d046ff7bd$export$55dba0d8ccf3da86 = (ComponentOld, ComponentNext, featureFlagFn)=>{
    return (props)=>{
        // copied from packages/editor/editor-common/src/utils/withFeatureFlaggedComponent.tsx
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return featureFlagFn() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentNext, {
            ...props
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentOld, {
            ...props
        });
    };
};

});

parcelRegister("9Hdrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1647af7fe5459c6c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $letJZ = parcelRequire("letJZ");

var $dVpJZ = parcelRequire("dVpJZ");

var $e1vlu = parcelRequire("e1vlu");

var $94rku = parcelRequire("94rku");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");
const $1647af7fe5459c6c$var$getIconImportFn = (icon, size)=>{
    const item = (0, $kxcRq.getLazyIcons)()[icon];
    if ((0, $kxcRq.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $1647af7fe5459c6c$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $1647af7fe5459c6c$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $8dVIb.SmartLinkSize).Medium })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $8dVIb.IconType).Document:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $94rku.default), {
                label: label ?? 'document',
                testId: testId,
                size: size
            });
        case (0, $8dVIb.IconType).Blog:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dVpJZ.default), {
                label: label ?? 'blog',
                testId: testId,
                size: size
            });
        case (0, $8dVIb.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e1vlu.default), {
                label: label ?? 'live-doc',
                testId: testId,
                size: size
            });
    }
    const importFn = $1647af7fe5459c6c$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $1647af7fe5459c6c$var$importIcon(importFn);
    switch(icon){
        case (0, $8dVIb.IconType).Confluence:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $8dVIb.IconType).Jira:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.JiraIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $8dVIb.IconType).Error:
        case (0, $8dVIb.IconType).Forbidden:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'medium' : 'small',
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'medium' : 'small',
                size: size
            });
    }
};
var $1647af7fe5459c6c$export$2e2bcd8739ae039 = $1647af7fe5459c6c$var$AtlaskitIcon;

});
parcelRegister("dVpJZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5e665de7fe478f98$export$2e2bcd8739ae039);

var $iRZQl = parcelRequire("iRZQl");

var $7oCpB = parcelRequire("7oCpB");

var $50H21 = parcelRequire("50H21");
const $5e665de7fe478f98$var$BlogIconWithColor = (0, $50H21.renderIconPerSize)((0, $iRZQl.default), (0, $7oCpB.default));
$5e665de7fe478f98$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $5e665de7fe478f98$export$2e2bcd8739ae039 = $5e665de7fe478f98$var$BlogIconWithColor;

});
parcelRegister("iRZQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $24299d4e22463111$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::845767e81b63ae055da0ba81295847f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $hZgcq = parcelRequire("hZgcq");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $24299d4e22463111$var$Blog16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
        label: label,
        testId: testId
    });
};
$24299d4e22463111$var$Blog16Icon.displayName = 'Blog16Icon';
var $24299d4e22463111$export$2e2bcd8739ae039 = $24299d4e22463111$var$Blog16Icon;

});
parcelRegister("2UiHO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::295e96fa490818737b2d2c8ee4291bb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21df524c58bafc58$var$_react = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21df524c58bafc58$var$_baseNew = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $21df524c58bafc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21df524c58bafc58$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $21df524c58bafc58$var$_react.default.createElement($21df524c58bafc58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$21df524c58bafc58$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $21df524c58bafc58$var$_default = module.exports.default = $21df524c58bafc58$var$QuotationMarkIcon;

});

parcelRegister("hZgcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $47749dc4aba4294e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::387cb99b24103ef6908201cae0580f7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $47749dc4aba4294e$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$47749dc4aba4294e$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$47749dc4aba4294e$export$2e2bcd8739ae039 = $47749dc4aba4294e$var$Blog16Icon;

});


parcelRegister("7oCpB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8806751d7f7ea905$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bba35c7457f1c82d9d31626969c259a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $asoCt = parcelRequire("asoCt");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $8806751d7f7ea905$var$Blog24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $asoCt.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $asoCt.default), {
        label: label,
        testId: testId
    });
};
$8806751d7f7ea905$var$Blog24Icon.displayName = 'Blog24Icon';
var $8806751d7f7ea905$export$2e2bcd8739ae039 = $8806751d7f7ea905$var$Blog24Icon;

});
parcelRegister("asoCt", function(module, exports) {

$parcel$export(module.exports, "default", () => $158d85a5273c8dbb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7682b4d34bd2a783038ec83f3b47a94>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $158d85a5273c8dbb$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$158d85a5273c8dbb$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$158d85a5273c8dbb$export$2e2bcd8739ae039 = $158d85a5273c8dbb$var$Blog24Icon;

});


parcelRegister("50H21", function(module, exports) {

$parcel$export(module.exports, "renderIconPerSize", () => $399bb260cc38f0bb$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $399bb260cc38f0bb$export$87c3646d0e299cfe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");
const $399bb260cc38f0bb$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $399bb260cc38f0bb$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $kxcRq.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $2OMIu.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(IconSmall, {
            ...props
        });
    };
};
const $399bb260cc38f0bb$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
            appearance: appearance,
            icon: Icon,
            size: $399bb260cc38f0bb$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $2OMIu.jsx)(LegacyIcon, {
                ...props,
                size: size
            })
        });
    };
};

});
parcelRegister("kxcRq", function(module, exports) {

$parcel$export(module.exports, "isSpecialEvent", () => $c53851cced73411d$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $c53851cced73411d$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $c53851cced73411d$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $c53851cced73411d$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $c53851cced73411d$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $c53851cced73411d$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $c53851cced73411d$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $c53851cced73411d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $c53851cced73411d$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $c53851cced73411d$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $c53851cced73411d$export$d2b8fb9e780e17e7);
$parcel$export(module.exports, "isProfileType", () => $c53851cced73411d$export$6a4545d6b336c401);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $imVhc = parcelRequire("imVhc");

var $8dVIb = parcelRequire("8dVIb");

var $liAf6 = parcelRequire("liAf6");
const $c53851cced73411d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($c53851cced73411d$export$e6c5ffa684aac4d7() || $c53851cced73411d$export$d8de0cd37d316fdf(evt) || $c53851cced73411d$export$5b1771037ab7c451(evt));
const $c53851cced73411d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $c53851cced73411d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $VSDnB.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $c53851cced73411d$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $c53851cced73411d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $c53851cced73411d$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label] = icon;
    return label;
};


























































































const $c53851cced73411d$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $8dVIb.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("94rku")))
        },
        [(0, $8dVIb.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("dVpJZ")))
        },
        [(0, $8dVIb.IconType).Audio]: {
            default: ()=>(parcelRequire("jP3VI"))
        },
        [(0, $8dVIb.IconType).Code]: {
            default: ()=>(parcelRequire("2zelF"))
        },
        [(0, $8dVIb.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("3vtQf")))
        },
        [(0, $8dVIb.IconType).Folder]: {
            default: ()=>(parcelRequire("hIRd2"))
        },
        [(0, $8dVIb.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("3vtQf")))
        },
        [(0, $8dVIb.IconType).Image]: {
            default: ()=>(parcelRequire("kcbfF"))
        },
        [(0, $8dVIb.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("gVXQp")))
        },
        [(0, $8dVIb.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("9bx9i")))
        },
        [(0, $8dVIb.IconType).Video]: {
            default: ()=>(parcelRequire("aO5d7"))
        },
        [(0, $8dVIb.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("ckyDP")))
        },
        [(0, $8dVIb.IconType).Template]: {
            default: ()=>Promise.resolve((parcelRequire("5mR3i")))
        },
        [(0, $8dVIb.IconType).Forbidden]: {
            default: ()=>(parcelRequire("k8THN"))
        },
        [(0, $8dVIb.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("jOyH3")))
        },
        [(0, $8dVIb.IconType).Archive]: {
            default: ()=>(parcelRequire("fBf2G")),
            large: ()=>(parcelRequire("kee99"))
        },
        [(0, $8dVIb.IconType).Executable]: {
            default: ()=>(parcelRequire("lslfp")),
            large: ()=>Promise.resolve((parcelRequire("dGYEZ")))
        },
        [(0, $8dVIb.IconType).GIF]: {
            default: ()=>(parcelRequire("4nfzo")),
            large: ()=>Promise.resolve((parcelRequire("RiK2l")))
        },
        [(0, $8dVIb.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("lyNGw")),
            large: ()=>Promise.resolve((parcelRequire("iBOon")))
        },
        [(0, $8dVIb.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("bnA29")),
            large: ()=>Promise.resolve((parcelRequire("jdlqN")))
        },
        [(0, $8dVIb.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("kwONT")),
            large: ()=>Promise.resolve((parcelRequire("c70Lr")))
        },
        [(0, $8dVIb.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("9Auxh")),
            large: ()=>Promise.resolve((parcelRequire("2osAJ")))
        },
        [(0, $8dVIb.IconType).MSExcel]: {
            default: ()=>(parcelRequire("hpac9")),
            large: ()=>Promise.resolve((parcelRequire("7zjHG")))
        },
        [(0, $8dVIb.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("5nTq3")),
            large: ()=>Promise.resolve((parcelRequire("cHwqN")))
        },
        [(0, $8dVIb.IconType).MSWord]: {
            default: ()=>(parcelRequire("818b0")),
            large: ()=>Promise.resolve((parcelRequire("2sfBf")))
        },
        [(0, $8dVIb.IconType).PDF]: {
            default: ()=>(parcelRequire("lnlq4")),
            large: ()=>Promise.resolve((parcelRequire("2tm8x")))
        },
        [(0, $8dVIb.IconType).Sketch]: {
            default: ()=>(parcelRequire("hSsH1")),
            large: ()=>Promise.resolve((parcelRequire("iABw2")))
        },
        // Bitbucket icons
        [(0, $8dVIb.IconType).Branch]: {
            default: ()=>Promise.resolve((parcelRequire("4sBeG"))),
            large: ()=>(parcelRequire("faNHh"))
        },
        [(0, $8dVIb.IconType).Commit]: {
            default: ()=>Promise.resolve((parcelRequire("bPjbr"))),
            large: ()=>(parcelRequire("7Cfy8"))
        },
        [(0, $8dVIb.IconType).PullRequest]: {
            default: ()=>Promise.resolve((parcelRequire("6qWjs"))),
            large: ()=>(parcelRequire("lhK2t"))
        },
        [(0, $8dVIb.IconType).Repo]: {
            default: ()=>Promise.resolve((parcelRequire("ezu4w"))),
            large: ()=>(parcelRequire("Zl279"))
        },
        // Jira icons
        [(0, $8dVIb.IconType).Bug]: {
            default: ()=>Promise.resolve((parcelRequire("iAkpb"))),
            large: ()=>(parcelRequire("jfHd4"))
        },
        [(0, $8dVIb.IconType).Change]: {
            default: ()=>Promise.resolve((parcelRequire("jnURg"))),
            large: ()=>(parcelRequire("h6mSM"))
        },
        [(0, $8dVIb.IconType).Epic]: {
            default: ()=>Promise.resolve((parcelRequire("gAdQO"))),
            large: ()=>(parcelRequire("2Nnnn"))
        },
        [(0, $8dVIb.IconType).Incident]: {
            default: ()=>Promise.resolve((parcelRequire("6ClRv"))),
            large: ()=>(parcelRequire("af9Ay"))
        },
        [(0, $8dVIb.IconType).Problem]: {
            default: ()=>Promise.resolve((parcelRequire("1ni2E"))),
            large: ()=>(parcelRequire("JuWWj"))
        },
        [(0, $8dVIb.IconType).ServiceRequest]: {
            default: ()=>Promise.resolve((parcelRequire("kQSMP"))),
            large: ()=>(parcelRequire("3Umjx"))
        },
        [(0, $8dVIb.IconType).Story]: {
            default: ()=>Promise.resolve((parcelRequire("kvhCa"))),
            large: ()=>(parcelRequire("bpMfi"))
        },
        [(0, $8dVIb.IconType).SubTask]: {
            default: ()=>Promise.resolve((parcelRequire("dvo9I"))),
            large: ()=>(parcelRequire("3unVm"))
        },
        [(0, $8dVIb.IconType).Task]: {
            default: ()=>Promise.resolve((parcelRequire("ercGv"))),
            large: ()=>(parcelRequire("kEBpI"))
        },
        // Confluence icons
        [(0, $8dVIb.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("4Atwu"))),
            large: ()=>Promise.resolve((parcelRequire("8lQ8Y")))
        },
        // Provider icons
        [(0, $8dVIb.IconType).Confluence]: {
            default: ()=>(parcelRequire("7JUWV")).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $8dVIb.IconType).Jira]: {
            default: ()=>(parcelRequire("7001k")).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $8dVIb.IconType).Attachment]: {
            default: ()=>(parcelRequire("b2QJV"))
        },
        [(0, $8dVIb.IconType).CheckItem]: {
            default: ()=>(parcelRequire("hTMzv"))
        },
        [(0, $8dVIb.IconType).Component]: {
            default: ()=>(parcelRequire("i5LI7"))
        },
        [(0, $8dVIb.IconType).Comment]: {
            default: ()=>(parcelRequire("28C0M"))
        },
        [(0, $8dVIb.IconType).View]: {
            default: ()=>(parcelRequire("5ewzx"))
        },
        [(0, $8dVIb.IconType).React]: {
            default: ()=>(parcelRequire("8NR13"))
        },
        [(0, $8dVIb.IconType).Vote]: {
            default: ()=>(parcelRequire("acQVl"))
        },
        [(0, $8dVIb.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("eXA0t"))
        },
        [(0, $8dVIb.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("9kf9T"))
        },
        [(0, $8dVIb.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("jiNtU"))
        },
        [(0, $8dVIb.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("eL0Ys"))
        },
        [(0, $8dVIb.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("aX5mo"))
        },
        [(0, $8dVIb.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("fIUai"))
        },
        [(0, $8dVIb.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("9EtBf"))
        },
        [(0, $8dVIb.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("1t6AM"))
        },
        [(0, $8dVIb.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("d3Riz"))
        },
        [(0, $8dVIb.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("34KmU"))
        },
        [(0, $8dVIb.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("99TdN"))
        },
        [(0, $8dVIb.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("lWPoA"))
        },
        [(0, $8dVIb.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("4hqZ5")))
        },
        [(0, $8dVIb.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("89ySK"))
        }
    };
};
const $c53851cced73411d$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $liAf6.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $c53851cced73411d$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $c53851cced73411d$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $c53851cced73411d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $c53851cced73411d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $c53851cced73411d$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $c53851cced73411d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $c53851cced73411d$export$e772c8ff12451969(interval);
            return $c53851cced73411d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $c53851cced73411d$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $c53851cced73411d$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $c53851cced73411d$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $imVhc.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $c53851cced73411d$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $8dVIb.SmartLinkSize).Large,
        (0, $8dVIb.SmartLinkSize).XLarge
    ].includes(size);
const $c53851cced73411d$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));

});
parcelRegister("liAf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d67e22f2f57cb4a6$export$2e2bcd8739ae039);

var $8dVIb = parcelRequire("8dVIb");
const $d67e22f2f57cb4a6$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $8dVIb.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $8dVIb.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $8dVIb.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $8dVIb.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $8dVIb.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $8dVIb.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $8dVIb.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $8dVIb.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $8dVIb.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $8dVIb.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $8dVIb.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $8dVIb.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $8dVIb.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $8dVIb.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $8dVIb.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $8dVIb.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $8dVIb.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $8dVIb.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $8dVIb.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $8dVIb.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $d67e22f2f57cb4a6$export$2e2bcd8739ae039 = $d67e22f2f57cb4a6$var$extractFileFormatIcon;

});

parcelRegister("94rku", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $56fb369bc3845a35$export$2e2bcd8739ae039);

var $duwKf = parcelRequire("duwKf");

var $lwV66 = parcelRequire("lwV66");

var $kdfZa = parcelRequire("kdfZa");

var $50H21 = parcelRequire("50H21");
const $56fb369bc3845a35$var$PageIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))), 'blueBold', (0, $50H21.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($duwKf))), (0, (/*@__PURE__*/$parcel$interopDefault($lwV66)))));
$56fb369bc3845a35$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $56fb369bc3845a35$export$2e2bcd8739ae039 = $56fb369bc3845a35$var$PageIconWithColor;

});
parcelRegister("duwKf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9d277a30a5a98acd$var$_react = $9d277a30a5a98acd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9d277a30a5a98acd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d277a30a5a98acd$var$Document16Icon = (props)=>/*#__PURE__*/ $9d277a30a5a98acd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$9d277a30a5a98acd$var$Document16Icon.displayName = 'Document16Icon';
var $9d277a30a5a98acd$var$_default = module.exports.default = $9d277a30a5a98acd$var$Document16Icon;

});

parcelRegister("lwV66", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $040b7f7dd846f7fd$var$_react = $040b7f7dd846f7fd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $040b7f7dd846f7fd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $040b7f7dd846f7fd$var$Document24Icon = (props)=>/*#__PURE__*/ $040b7f7dd846f7fd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$040b7f7dd846f7fd$var$Document24Icon.displayName = 'Document24Icon';
var $040b7f7dd846f7fd$var$_default = module.exports.default = $040b7f7dd846f7fd$var$Document24Icon;

});


parcelRegister("jP3VI", function(module, exports) {

let $e6e5d427a0d38fe7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e6e5d427a0d38fe7$var$load("aQTX9").then(()=>parcelRequire('aQnRv'));

});

parcelRegister("2zelF", function(module, exports) {

let $1de9faf58c0c87e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1de9faf58c0c87e3$var$load("3T2eQ").then(()=>parcelRequire('3WUNe'));

});

parcelRegister("hIRd2", function(module, exports) {

let $ce6fd2014e57e430$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ce6fd2014e57e430$var$load("ffQaD"),
    $ce6fd2014e57e430$var$load("kvRbA"),
    $ce6fd2014e57e430$var$load("ldrEN")
]).then(()=>parcelRequire('ikced'));

});

parcelRegister("kcbfF", function(module, exports) {

let $eb3da7fce14b245c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb3da7fce14b245c$var$load("jZklo").then(()=>parcelRequire('aRGuz'));

});

parcelRegister("aO5d7", function(module, exports) {

let $7de29da141eece0c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7de29da141eece0c$var$load("bHxrz").then(()=>parcelRequire('T5PvZ'));

});

parcelRegister("k8THN", function(module, exports) {

let $ea9fc3e9dd344518$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea9fc3e9dd344518$var$load("46xqb").then(()=>parcelRequire('a8hd9'));

});

parcelRegister("jOyH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6cd993777d46e1b$var$LinkIcon = (props)=>/*#__PURE__*/ $e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
    }, props));
$e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});


parcelRegister("fBf2G", function(module, exports) {

let $b5b5fad0121b0aed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b5b5fad0121b0aed$var$load("kRL9H").then(()=>parcelRequire('8njZH'));

});

parcelRegister("kee99", function(module, exports) {

let $eba016aa82a444ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eba016aa82a444ac$var$load("5soZa").then(()=>parcelRequire('9CRO6'));

});

parcelRegister("lslfp", function(module, exports) {

let $f9ecb1cf63d607e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f9ecb1cf63d607e6$var$load("ece3U").then(()=>parcelRequire('lp0fk'));

});

parcelRegister("4nfzo", function(module, exports) {

let $32f5634727f32f4e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32f5634727f32f4e$var$load("2xhmB").then(()=>parcelRequire('96Idm'));

});

parcelRegister("lyNGw", function(module, exports) {

let $fb235055aa698154$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fb235055aa698154$var$load("4Hcjo").then(()=>parcelRequire('3KifV'));

});

parcelRegister("bnA29", function(module, exports) {

let $848dcb3f06f2141b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $848dcb3f06f2141b$var$load("gyqsg").then(()=>parcelRequire('j8IiS'));

});

parcelRegister("kwONT", function(module, exports) {

let $ef1e345b5057ffb4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ef1e345b5057ffb4$var$load("lbzkh").then(()=>parcelRequire('iByEQ'));

});

parcelRegister("9Auxh", function(module, exports) {

let $6faf29a3253d3b39$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6faf29a3253d3b39$var$load("5yV3B").then(()=>parcelRequire('F35X1'));

});

parcelRegister("hpac9", function(module, exports) {

let $cabcadf6ae2e1f42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cabcadf6ae2e1f42$var$load("7cJNA").then(()=>parcelRequire('eABwY'));

});

parcelRegister("5nTq3", function(module, exports) {

let $3eba16db4c5c1d72$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3eba16db4c5c1d72$var$load("53hH3").then(()=>parcelRequire('kKp2J'));

});

parcelRegister("818b0", function(module, exports) {

let $5d64c263665334a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5d64c263665334a2$var$load("jCvJI").then(()=>parcelRequire('im5Hg'));

});

parcelRegister("lnlq4", function(module, exports) {

let $f8fc5c6b4e705851$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f8fc5c6b4e705851$var$load("hu0uQ").then(()=>parcelRequire('5m93C'));

});

parcelRegister("hSsH1", function(module, exports) {

let $d03dbc9f90006243$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d03dbc9f90006243$var$load("b1qY8").then(()=>parcelRequire('lE6mu'));

});

parcelRegister("faNHh", function(module, exports) {

let $b0be56fcbb908172$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b0be56fcbb908172$var$load("cdi9t").then(()=>parcelRequire('l04jD'));

});

parcelRegister("7Cfy8", function(module, exports) {

let $58b824d1a2ea9c13$var$load = (parcelRequire("28QjX"))(4);
module.exports = $58b824d1a2ea9c13$var$load("fsbZm").then(()=>parcelRequire('52A0r'));

});

parcelRegister("lhK2t", function(module, exports) {

let $f7eee5dccd5a384d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f7eee5dccd5a384d$var$load("jDEKQ").then(()=>parcelRequire('c9Fqq'));

});

parcelRegister("Zl279", function(module, exports) {

let $0b86035afefa8641$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0b86035afefa8641$var$load("exonR").then(()=>parcelRequire('6OpPE'));

});

parcelRegister("jfHd4", function(module, exports) {

let $e040ef9611e0e60c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e040ef9611e0e60c$var$load("gDjNE").then(()=>parcelRequire('41M8N'));

});

parcelRegister("h6mSM", function(module, exports) {

let $c734bf2e0d63df94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c734bf2e0d63df94$var$load("ljL6x").then(()=>parcelRequire('4MX1d'));

});

parcelRegister("2Nnnn", function(module, exports) {

let $20924a5914a94fa0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $20924a5914a94fa0$var$load("dJFy4").then(()=>parcelRequire('eHc1t'));

});

parcelRegister("af9Ay", function(module, exports) {

let $7752be2f3d740436$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7752be2f3d740436$var$load("4f6Qg").then(()=>parcelRequire('529Ow'));

});

parcelRegister("JuWWj", function(module, exports) {

let $088c3609920e6766$var$load = (parcelRequire("28QjX"))(4);
module.exports = $088c3609920e6766$var$load("5b7z5").then(()=>parcelRequire('gaBfD'));

});

parcelRegister("3Umjx", function(module, exports) {

let $2d87e92c7a44ae09$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2d87e92c7a44ae09$var$load("75rqy").then(()=>parcelRequire('36Q2c'));

});

parcelRegister("bpMfi", function(module, exports) {

let $84f77414cd4cb748$var$load = (parcelRequire("28QjX"))(4);
module.exports = $84f77414cd4cb748$var$load("jxvAw").then(()=>parcelRequire('21nCU'));

});

parcelRegister("3unVm", function(module, exports) {

let $28a6bb471d98579f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $28a6bb471d98579f$var$load("3L0Vc").then(()=>parcelRequire('93zHH'));

});

parcelRegister("kEBpI", function(module, exports) {

let $f09490ac2941d78c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f09490ac2941d78c$var$load("koGHi").then(()=>parcelRequire('eFWxr'));

});

parcelRegister("4Atwu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $67f5211f96bd858e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1228c9bdd9840505938b56c7ed44212>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2OgES = parcelRequire("2OgES");

var $VSDnB = parcelRequire("VSDnB");

var $i0wCi = parcelRequire("i0wCi");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67f5211f96bd858e$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2OgES))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
        label: label,
        testId: testId
    });
};
$67f5211f96bd858e$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $67f5211f96bd858e$export$2e2bcd8739ae039 = $67f5211f96bd858e$var$PageLiveDoc16Icon;

});
parcelRegister("2OgES", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::692b62fec4c56cd82ae8d8d02e2d3f2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20bd2c4c7f421719$var$_react = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $20bd2c4c7f421719$var$_baseNew = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $20bd2c4c7f421719$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $20bd2c4c7f421719$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $20bd2c4c7f421719$var$_react.default.createElement($20bd2c4c7f421719$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$20bd2c4c7f421719$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $20bd2c4c7f421719$var$_default = module.exports.default = $20bd2c4c7f421719$var$PageLiveDocIcon;

});

parcelRegister("i0wCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e01b6db3f29618ed$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbb561a99c36d24f949f1ade9ed1fa72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $e01b6db3f29618ed$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$e01b6db3f29618ed$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e01b6db3f29618ed$export$2e2bcd8739ae039 = $e01b6db3f29618ed$var$PageLiveDoc16Icon;

});


parcelRegister("8lQ8Y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $40d9c5b900864dd9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::724c9bd5f0d44d16613664f162286445>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2OgES = parcelRequire("2OgES");

var $VSDnB = parcelRequire("VSDnB");

var $25dv3 = parcelRequire("25dv3");
/**
 * __24px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $40d9c5b900864dd9$var$PageLiveDoc24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2OgES))),
        appearance: "magentaBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $25dv3.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $25dv3.default), {
        label: label,
        testId: testId
    });
};
$40d9c5b900864dd9$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var $40d9c5b900864dd9$export$2e2bcd8739ae039 = $40d9c5b900864dd9$var$PageLiveDoc24Icon;

});
parcelRegister("25dv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b5ea63b1e20da2$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5906433494daa938e0cf018edb0a9fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $23b5ea63b1e20da2$var$PageLiveDoc24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3zM4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m10.555-6.832a1 1 0 0 0-1.545.973l1 7a1 1 0 0 0 1.884.306L17.118 17H20a1 1 0 0 0 .555-1.832z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "medium"
    });
$23b5ea63b1e20da2$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$23b5ea63b1e20da2$export$2e2bcd8739ae039 = $23b5ea63b1e20da2$var$PageLiveDoc24Icon;

});


parcelRegister("7JUWV", function(module, exports) {

let $5a28e95396b915ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a28e95396b915ce$var$load("dznrv").then(()=>parcelRequire('ipPwQ'));

});

parcelRegister("7001k", function(module, exports) {

let $51888c926a462d79$var$load = (parcelRequire("28QjX"))(4);
module.exports = $51888c926a462d79$var$load("2hamX").then(()=>parcelRequire('kz0bU'));

});

parcelRegister("b2QJV", function(module, exports) {

let $80a8ca9d9079b9ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $80a8ca9d9079b9ba$var$load("bHtk9").then(()=>parcelRequire('eZ9Cp'));

});

parcelRegister("hTMzv", function(module, exports) {

let $d07d400d364d97f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d07d400d364d97f5$var$load("10YFK").then(()=>parcelRequire('f5h6d'));

});

parcelRegister("i5LI7", function(module, exports) {

let $d2bdb3fa3cba1265$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d2bdb3fa3cba1265$var$load("eHHfh").then(()=>parcelRequire('biU84'));

});

parcelRegister("28C0M", function(module, exports) {

let $18e9d06c8bb828e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $18e9d06c8bb828e0$var$load("aA0tq").then(()=>parcelRequire('729P0'));

});

parcelRegister("5ewzx", function(module, exports) {

let $3cf786b2f3106989$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3cf786b2f3106989$var$load("f0D0P").then(()=>parcelRequire('6N55R'));

});

parcelRegister("8NR13", function(module, exports) {

let $668c0634cfa76a7f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $668c0634cfa76a7f$var$load("fTI2h").then(()=>parcelRequire('3xPiH'));

});

parcelRegister("acQVl", function(module, exports) {

let $76e413f697d051f0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $76e413f697d051f0$var$load("b6xhe").then(()=>parcelRequire('9j532'));

});

parcelRegister("eXA0t", function(module, exports) {

let $ae42818d45a34fe6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ae42818d45a34fe6$var$load("4b20x").then(()=>parcelRequire('jJL9z'));

});

parcelRegister("9kf9T", function(module, exports) {

let $6ca1bd775537e485$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6ca1bd775537e485$var$load("bhhPH").then(()=>parcelRequire('3pKEh'));

});

parcelRegister("jiNtU", function(module, exports) {

let $e0d614c1b037b486$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0d614c1b037b486$var$load("jTNTf").then(()=>parcelRequire('k7gBp'));

});

parcelRegister("eL0Ys", function(module, exports) {

let $abe635e95dbbcf20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $abe635e95dbbcf20$var$load("1bW9w").then(()=>parcelRequire('Le10t'));

});

parcelRegister("aX5mo", function(module, exports) {

let $7f93927a0d8f10f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7f93927a0d8f10f8$var$load("dqho9").then(()=>parcelRequire('kc1MS'));

});

parcelRegister("fIUai", function(module, exports) {

let $b726884848bc31ae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b726884848bc31ae$var$load("j82pJ").then(()=>parcelRequire('hfn9j'));

});

parcelRegister("9EtBf", function(module, exports) {

let $706ecf612af6f4c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $706ecf612af6f4c0$var$load("a0E5q").then(()=>parcelRequire('4zl0K'));

});

parcelRegister("1t6AM", function(module, exports) {

let $111d9cf2449fdb30$var$load = (parcelRequire("28QjX"))(4);
module.exports = $111d9cf2449fdb30$var$load("4E7mO").then(()=>parcelRequire('cfbO3'));

});

parcelRegister("d3Riz", function(module, exports) {

let $9824e629a9213344$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9824e629a9213344$var$load("kel8g").then(()=>parcelRequire('jyFo7'));

});

parcelRegister("34KmU", function(module, exports) {

let $23d5b6a342ab0291$var$load = (parcelRequire("28QjX"))(4);
module.exports = $23d5b6a342ab0291$var$load("98SE2").then(()=>parcelRequire('eJNZM'));

});

parcelRegister("99TdN", function(module, exports) {

let $6aafca294ba4066d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6aafca294ba4066d$var$load("ffQaD"),
    $6aafca294ba4066d$var$load("kvRbA"),
    $6aafca294ba4066d$var$load("lMeFU")
]).then(()=>parcelRequire('2CRmv'));

});

parcelRegister("lWPoA", function(module, exports) {

let $ffa6e1d54a154aa3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ffa6e1d54a154aa3$var$load("1AaKL").then(()=>parcelRequire('2ciBJ'));

});

parcelRegister("89ySK", function(module, exports) {

let $5efa38d08ffa18a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5efa38d08ffa18a2$var$load("6wTPq").then(()=>parcelRequire('2lRM4'));

});




parcelRegister("e1vlu", function(module, exports) {

$parcel$export(module.exports, "default", () => $df3c19aa4679ee0a$export$2e2bcd8739ae039);

var $4Atwu = parcelRequire("4Atwu");

var $8lQ8Y = parcelRequire("8lQ8Y");

var $50H21 = parcelRequire("50H21");
const $df3c19aa4679ee0a$var$LiveDocumentIconWithColor = (0, $50H21.renderIconPerSize)((0, $4Atwu.default), (0, $8lQ8Y.default));
$df3c19aa4679ee0a$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $df3c19aa4679ee0a$export$2e2bcd8739ae039 = $df3c19aa4679ee0a$var$LiveDocumentIconWithColor;

});


parcelRegister("l5Xsv", function(module, exports) {

$parcel$export(module.exports, "default", () => $951590e808a48e01$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bmnhy = parcelRequire("bmnhy");

var $VSDnB = parcelRequire("VSDnB");

var $gU02S = parcelRequire("gU02S");
const $951590e808a48e01$var$styles = {
    roundImg: "_2rko14q2"
};
const $951590e808a48e01$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
        src: url,
        loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: "",
            style: {
                width: width,
                height: height
            },
            className: (0, $bwpsq.default)([
                appearance === 'round' && (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && $951590e808a48e01$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $951590e808a48e01$export$2e2bcd8739ae039 = $951590e808a48e01$var$ImageIcon;

});
parcelRegister("bmnhy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8453cf1ee7ef4644$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");
var $8453cf1ee7ef4644$var$React = $8453cf1ee7ef4644$var$_interopRequireWildcard($5uXOq);
function $8453cf1ee7ef4644$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $8453cf1ee7ef4644$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8453cf1ee7ef4644$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8453cf1ee7ef4644$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8453cf1ee7ef4644$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $8453cf1ee7ef4644$var$loaded() {
    return {
        isLoaded: true
    };
}
function $8453cf1ee7ef4644$var$errored() {
    return {
        isErrored: true
    };
}
function $8453cf1ee7ef4644$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $8453cf1ee7ef4644$var$ImageRenderer = function(_React$Component) {
    $8453cf1ee7ef4644$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $8453cf1ee7ef4644$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $8453cf1ee7ef4644$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $8453cf1ee7ef4644$var$_possibleConstructorReturn(_this, _ret);
    }
    $8453cf1ee7ef4644$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(this.props, nextProps)) this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($8453cf1ee7ef4644$var$React.Component);
module.exports.default = $8453cf1ee7ef4644$var$ImageRenderer;

});

parcelRegister("gU02S", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $880176eb12ae8419$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $880176eb12ae8419$var$animationNameStyles = null;
const $880176eb12ae8419$var$loadingSkeletonStyle = null;
const $880176eb12ae8419$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("3dubP", function(module, exports) {

$parcel$export(module.exports, "withOverrideCss", () => $9f9aac8ddfd1f0ad$export$e0bdcacb944f1da6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $9f9aac8ddfd1f0ad$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});

parcelRegister("fpDmE", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $3ebf94f205ad0182$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $3ebf94f205ad0182$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $3ebf94f205ad0182$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidth", () => $3ebf94f205ad0182$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $3ebf94f205ad0182$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $3ebf94f205ad0182$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $3ebf94f205ad0182$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $3ebf94f205ad0182$export$619e376a425cb759);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4qBtX = parcelRequire("4qBtX");

var $8dVIb = parcelRequire("8dVIb");
const $3ebf94f205ad0182$export$9d642f65a919fb93 = {
    [(0, $8dVIb.SmartLinkSize).Small]: 'none',
    [(0, $8dVIb.SmartLinkSize).Medium]: 'compact',
    [(0, $8dVIb.SmartLinkSize).Large]: 'compact',
    [(0, $8dVIb.SmartLinkSize).XLarge]: 'default'
};
const $3ebf94f205ad0182$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descriptor,
            values: values
        });
    }
};
const $3ebf94f205ad0182$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $3ebf94f205ad0182$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $3ebf94f205ad0182$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $3ebf94f205ad0182$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1.75;
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $3ebf94f205ad0182$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $3ebf94f205ad0182$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $8dVIb.SmartLinkSize).Large:
            return 'space.200';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $3ebf94f205ad0182$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("4Xgub", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bf87c18c5ab03d1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $eL5Me = parcelRequire("eL5Me");
const $6bf87c18c5ab03d1$var$AssignedToElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $eL5Me.toFormattedTextProps)((0, $7zaVw.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eL5Me.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).AssignedTo
    }) : null;
};
var $6bf87c18c5ab03d1$export$2e2bcd8739ae039 = $6bf87c18c5ab03d1$var$AssignedToElement;

});
parcelRegister("eL5Me", function(module, exports) {

$parcel$export(module.exports, "default", () => $0077ab6b3bad1a53$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toFormattedTextProps", () => $0077ab6b3bad1a53$export$b9738bf28fb14829);
$parcel$export(module.exports, "toTextProps", () => $0077ab6b3bad1a53$export$f12aecc78be3c7bb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $VSDnB = parcelRequire("VSDnB");

var $fpDmE = parcelRequire("fpDmE");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $0077ab6b3bad1a53$var$baseStyleOld = null;
const $0077ab6b3bad1a53$var$baseStyle = null;
const $0077ab6b3bad1a53$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const newContent = hideFormat && content ? content : (0, $fpDmE.getFormattedMessage)(message) || content;
    const oldContent = (0, $fpDmE.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color && (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props') ? color : undefined,
            "--_1erfju8": (0, $lD23V.default)(maxLines)
        },
        children: (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props') ? newContent : oldContent
    });
};
var $0077ab6b3bad1a53$export$2e2bcd8739ae039 = $0077ab6b3bad1a53$export$79422073c7118b5b;
const $0077ab6b3bad1a53$export$b9738bf28fb14829 = (descriptor, context)=>{
    if ((0, $VSDnB.fg)('platform-linking-additional-flexible-element-props')) return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $0077ab6b3bad1a53$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};

});


parcelRegister("gzmfH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e9a9eba851a9bf$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $8JkyP = parcelRequire("8JkyP");
const $a5e9a9eba851a9bf$var$AssignedToGroupElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $8JkyP.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8JkyP.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).AssignedToGroup
    }) : null;
};
var $a5e9a9eba851a9bf$export$2e2bcd8739ae039 = $a5e9a9eba851a9bf$var$AssignedToGroupElement;

});
parcelRegister("8JkyP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e642c27a7b9b549$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAvatarGroupProps", () => $6e642c27a7b9b549$export$91ba8651475968bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $jnhNB = parcelRequire("jnhNB");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $fpDmE = parcelRequire("fpDmE");
const $6e642c27a7b9b549$var$styles = null;
const $6e642c27a7b9b549$var$stylesMap = {
    xlarge: "_1e0c116y _1kvxu2gc _102oidpf",
    large: "_1e0c116y _1kvxu2gc _102oidpf",
    medium: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92",
    small: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92"
};
const $6e642c27a7b9b549$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).assigned_to, personName);
        case (0, $8dVIb.ElementName).OwnedByGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).owned_by, personName);
        case (0, $8dVIb.ElementName).AuthorGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {BaseAvatarGroupElementProps} BaseAvatarGroupElementProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $6e642c27a7b9b549$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $koVbs.default)();
    const data = (0, $5uXOq.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $8dVIb.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $6e642c27a7b9b549$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $6e642c27a7b9b549$var$stylesMap[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnhNB.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $6e642c27a7b9b549$export$2e2bcd8739ae039 = $6e642c27a7b9b549$var$BaseAvatarGroup;
const $6e642c27a7b9b549$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};

});


parcelRegister("iyiGe", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd356ef3eabec4ef$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $cd356ef3eabec4ef$var$AttachmentCountElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $hg3n9.toBadgeProps)(context.attachmentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        icon: (0, $8dVIb.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).AttachmentCount
    }) : null;
};
var $cd356ef3eabec4ef$export$2e2bcd8739ae039 = $cd356ef3eabec4ef$var$AttachmentCountElement;

});

parcelRegister("aV6Md", function(module, exports) {

$parcel$export(module.exports, "default", () => $c379fdcce5db58cc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $8JkyP = parcelRequire("8JkyP");
const $c379fdcce5db58cc$var$AuthorGroupElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $8JkyP.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8JkyP.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).AuthorGroup
    }) : null;
};
var $c379fdcce5db58cc$export$2e2bcd8739ae039 = $c379fdcce5db58cc$var$AuthorGroupElement;

});

parcelRegister("lwU5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b2bb19e23bc7b5b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $3b2bb19e23bc7b5b$var$ChecklistProgressElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $hg3n9.toBadgeProps)(context.checklistProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        icon: (0, $8dVIb.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).ChecklistProgress
    }) : null;
};
var $3b2bb19e23bc7b5b$export$2e2bcd8739ae039 = $3b2bb19e23bc7b5b$var$ChecklistProgressElement;

});

parcelRegister("jmLta", function(module, exports) {

$parcel$export(module.exports, "default", () => $e97a0609a0e06cc6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $8JkyP = parcelRequire("8JkyP");
const $e97a0609a0e06cc6$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $8JkyP.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8JkyP.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).CollaboratorGroup
    }) : null;
};
var $e97a0609a0e06cc6$export$2e2bcd8739ae039 = $e97a0609a0e06cc6$var$CollaboratorGroupElement;

});

parcelRegister("4yhoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9a539df8caaf64c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $d9a539df8caaf64c$var$CommentCountElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $hg3n9.toBadgeProps)(context.commentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        icon: (0, $8dVIb.IconType).Comment,
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).CommentCount
    }) : null;
};
var $d9a539df8caaf64c$export$2e2bcd8739ae039 = $d9a539df8caaf64c$var$CommentCountElement;

});

parcelRegister("eiceF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7bcad4b94b14567$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAtlaskitBadgeProps", () => $e7bcad4b94b14567$export$731812b93bd90554);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $VSDnB = parcelRequire("VSDnB");
const $e7bcad4b94b14567$var$badgeStylesOld = null;
const $e7bcad4b94b14567$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $e7bcad4b94b14567$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $16T6Y.default), {
            children: value
        })
    });
};
var $e7bcad4b94b14567$export$2e2bcd8739ae039 = $e7bcad4b94b14567$var$BaseAtlaskitElementBadge;
const $e7bcad4b94b14567$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};

});

parcelRegister("hMRm5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ff906df4a1f5956$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateTimeProps", () => $4ff906df4a1f5956$export$2d4384e6b150cbe3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7anB = parcelRequire("j7anB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $4ff906df4a1f5956$var$stylesOld = null;
const $4ff906df4a1f5956$var$styles = null;
const $4ff906df4a1f5956$var$typeToDescriptorMap = {
    created: {
        relative: (0, $7zaVw.messages).created_on_relative,
        absolute: (0, $7zaVw.messages).created_on_absolute
    },
    modified: {
        relative: (0, $7zaVw.messages).modified_on_relative,
        absolute: (0, $7zaVw.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $7zaVw.messages).sent_on_relative,
        absolute: (0, $7zaVw.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {BaseDateTimeElementProps} BaseDateTimeElementProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $4ff906df4a1f5956$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $koVbs.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $j7anB.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix && (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props')) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...$4ff906df4a1f5956$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            color: color && (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props') ? color : undefined
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k1j6v",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            className
        ]),
        children: content
    });
};
var $4ff906df4a1f5956$export$2e2bcd8739ae039 = $4ff906df4a1f5956$var$BaseDateTimeElement;
const $4ff906df4a1f5956$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};

});

parcelRegister("9TvvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f521aba426c040b2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toLinkIconProps", () => $f521aba426c040b2$export$6d33abd591a3f700);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $fpDmE = parcelRequire("fpDmE");
const $f521aba426c040b2$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $f521aba426c040b2$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $f521aba426c040b2$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym"
};
const $f521aba426c040b2$var$renderAtlaskitIcon = (icon, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Hdrc.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        size: size
    });
};
const $f521aba426c040b2$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $f521aba426c040b2$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $8dVIb.SmartLinkSize).Medium, appearance)=>{
    const width = size === (0, $8dVIb.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
            appearance: appearance
        }
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param props - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $f521aba426c040b2$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $8dVIb.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square' })=>{
    const element = (0, $5uXOq.useMemo)(()=>{
        const defaultIcon = $f521aba426c040b2$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $f521aba426c040b2$var$renderImageIcon(defaultIcon, url, testId, size, (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? appearance : undefined) || $f521aba426c040b2$var$renderAtlaskitIcon(icon, testId, size) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        icon
    ]);
    const width = (0, $fpDmE.getIconWidth)(size);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $f521aba426c040b2$var$styles.container,
            $f521aba426c040b2$var$positionStyleMap[position],
            render && $f521aba426c040b2$var$customRenderStyleMap[size],
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $f521aba426c040b2$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        })
    });
};
var $f521aba426c040b2$export$2e2bcd8739ae039 = $f521aba426c040b2$var$IconElement;
const $f521aba426c040b2$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $kxcRq.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};

});

parcelRegister("f8hXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f4293f1156eec10$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toLinkProps", () => $2f4293f1156eec10$export$d58e465a9e5297f4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $fpDmE = parcelRequire("fpDmE");
const $2f4293f1156eec10$var$DEFAULT_MAX_LINES = 2;
const $2f4293f1156eec10$var$MAXIMUM_MAX_LINES = 2;
const $2f4293f1156eec10$var$MINIMUM_MAX_LINES = 1;
const $2f4293f1156eec10$var$containerStyles = null;
const $2f4293f1156eec10$var$getMaxLines = (maxLines)=>{
    if (maxLines > $2f4293f1156eec10$var$MAXIMUM_MAX_LINES) return $2f4293f1156eec10$var$DEFAULT_MAX_LINES;
    if (maxLines < $2f4293f1156eec10$var$MINIMUM_MAX_LINES) return $2f4293f1156eec10$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $2f4293f1156eec10$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $2f4293f1156eec10$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $2f4293f1156eec10$var$baseAnchorStyle = null;
const $2f4293f1156eec10$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $2f4293f1156eec10$var$anchorConstantsStyles = null;
const $2f4293f1156eec10$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $2f4293f1156eec10$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $2f4293f1156eec10$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $2f4293f1156eec10$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {BaseLinkElementProps} BaseLinkElementProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $2f4293f1156eec10$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $2f4293f1156eec10$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $8dVIb.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const hasSpace = (0, $5uXOq.useMemo)(()=>text ? (0, $fpDmE.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $2f4293f1156eec10$var$linkStyleSizeMap[size],
            $2f4293f1156eec10$var$anchorLineClampMap[$2f4293f1156eec10$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $2f4293f1156eec10$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $2f4293f1156eec10$var$getMaxLines(maxLines) === 1 && $2f4293f1156eec10$var$anchorLinkLineHeight1Map[size],
            $2f4293f1156eec10$var$getMaxLines(maxLines) === 2 && $2f4293f1156eec10$var$anchorLinkLineHeight2Map[size],
            $2f4293f1156eec10$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef,
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $2f4293f1156eec10$var$withTooltip(anchor, text, testId)
    });
};
var $2f4293f1156eec10$export$2e2bcd8739ae039 = $2f4293f1156eec10$var$BaseLinkElement;
const $2f4293f1156eec10$export$d58e465a9e5297f4 = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};

});

parcelRegister("Rf8nG", function(module, exports) {

$parcel$export(module.exports, "default", () => $07a7759432a651e8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateLozengeProps", () => $07a7759432a651e8$export$8f9f58f7bac50fbe);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7VHMR = parcelRequire("7VHMR");

var $aYAc3 = parcelRequire("aYAc3");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $k3gQe = parcelRequire("k3gQe");
const $07a7759432a651e8$var$stylesOld = null;
const $07a7759432a651e8$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $07a7759432a651e8$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k3gQe.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aYAc3.default), {
        appearance: appearance,
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41kw7",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $07a7759432a651e8$export$2e2bcd8739ae039 = $07a7759432a651e8$var$BaseLozengeElement;
const $07a7759432a651e8$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VHMR.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};

});
parcelRegister("k3gQe", function(module, exports) {

$parcel$export(module.exports, "default", () => $89d832514be004f9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $dlJZx = parcelRequire("dlJZx");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $gDUps = parcelRequire("gDUps");

var $fzJZi = parcelRequire("fzJZi");

var $i7KLg = parcelRequire("i7KLg");

var $k2WzX = parcelRequire("k2WzX");

var $eDeTc = parcelRequire("eDeTc");

var $2Qn0O = parcelRequire("2Qn0O");

var $aizlC = parcelRequire("aizlC");

var $fgopX = parcelRequire("fgopX");
const $89d832514be004f9$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $89d832514be004f9$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $5uXOq.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [items, setItems] = (0, $5uXOq.useState)();
    const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)();
    const reload = (0, $f22ja.default)();
    const invoke = (0, $3q2sI.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $5uXOq.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $dlJZx.default));
                const validItems = typeof text === 'string' ? $89d832514be004f9$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $k2WzX.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? (0, $2Qn0O.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $2Qn0O.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $2Qn0O.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $k2WzX.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fgopX.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $5uXOq.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $gDUps.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $euMlu.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $k2WzX.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $2Qn0O.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $k2WzX.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $5uXOq.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eDeTc.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aizlC.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $89d832514be004f9$export$2e2bcd8739ae039 = (0, $i7KLg.default)($89d832514be004f9$var$LozengeAction);

});
parcelRegister("a1vqi", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $91130a451fd4887d$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::1f3587129789e7883af37adad3817cd2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");


var $1PQcU = parcelRequire("1PQcU");
const $91130a451fd4887d$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $1PQcU.default)(...params));
        event.fire((0, $37b399a913bad22b$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $37b399a913bad22b$export$3f072f06b90c3985 = 'media';

parcelRegister("1PQcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $539e70e97f68df84$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::eb8cd1263459fb798341024dc0c461ea>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $539e70e97f68df84$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $539e70e97f68df84$export$2e2bcd8739ae039 = $539e70e97f68df84$var$createEventPayload;

});


parcelRegister("dlJZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eaacaffc693a3ec$export$2e2bcd8739ae039);
const $6eaacaffc693a3ec$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $6eaacaffc693a3ec$export$2e2bcd8739ae039 = $6eaacaffc693a3ec$var$extractLozengeActionItems;

});

parcelRegister("3q2sI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a60e7c58b54588$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iiAnG = parcelRequire("iiAnG");

var $051X7 = parcelRequire("051X7");
const $f5a60e7c58b54588$var$useInvoke = ()=>{
    const { connections: connections } = (0, $051X7.useSmartLinkContext)();
    const clientExt = (0, $iiAnG.useSmartLinkClientExtension)(connections.client);
    return (0, $5uXOq.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $f5a60e7c58b54588$export$2e2bcd8739ae039 = $f5a60e7c58b54588$var$useInvoke;

});
parcelRegister("iiAnG", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $ffb669da1b6b71e8$export$303ede4eed148855);

var $5uXOq = parcelRequire("5uXOq");

var $dV0Jy = parcelRequire("dV0Jy");

var $T540Y = parcelRequire("T540Y");

var $3b94d = parcelRequire("3b94d");
const $ffb669da1b6b71e8$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $3b94d.useResolverUrl)(cardClient);
    const invoke = (0, $5uXOq.useCallback)(async (data)=>{
        try {
            return await (0, $dV0Jy.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $T540Y.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("T540Y", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $171ae91e706973ef$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $171ae91e706973ef$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $171ae91e706973ef$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $171ae91e706973ef$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("3b94d", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $eebf021c5f687360$export$d08617a365fbe694);

var $5uXOq = parcelRequire("5uXOq");

var $itO4f = parcelRequire("itO4f");
const $eebf021c5f687360$export$d08617a365fbe694 = (cardClient)=>(0, $5uXOq.useMemo)(()=>(0, $itO4f.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});



parcelRegister("euMlu", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $0ad6fedaface02c5$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $0ad6fedaface02c5$export$1694272377fa07d8);

var $fzJZi = parcelRequire("fzJZi");
const $0ad6fedaface02c5$export$65b3f792dff0bd60 = (err)=>{
    if (!$0ad6fedaface02c5$export$1694272377fa07d8(err)) return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $fzJZi.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    }
};
const $0ad6fedaface02c5$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("f22ja", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48b36e6e5cada34$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kYwnb = parcelRequire("kYwnb");

var $051X7 = parcelRequire("051X7");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $nb8r1 = parcelRequire("nb8r1");
const $f48b36e6e5cada34$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $nb8r1.default)();
    return (0, $5uXOq.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = (0, $VSDnB.fg)('smart_links_noun_support') ? !!(details && details.data || (0, $kYwnb.isEntityPresent)(details)) : !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $1VPdD.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $f48b36e6e5cada34$export$2e2bcd8739ae039 = $f48b36e6e5cada34$var$useResolve;

});
parcelRegister("1VPdD", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $2308e6f5aae12b86$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $2308e6f5aae12b86$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $2308e6f5aae12b86$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $2308e6f5aae12b86$export$4084c0df4a03a6af);

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
const $2308e6f5aae12b86$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
};
const $2308e6f5aae12b86$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$ufoExperiences = {
    'smart-link-rendered': new (0, $cBycP.ConcurrentExperience)('smart-link-rendered', $2308e6f5aae12b86$var$renderExperience),
    'smart-link-authenticated': new (0, $cBycP.ConcurrentExperience)('smart-link-authenticated', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-action-invocation': new (0, $cBycP.ConcurrentExperience)('smart-link-action-invocation', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-ai-summary': new (0, $cBycP.ConcurrentExperience)('smart-link-ai-summary', $2308e6f5aae12b86$var$aiExperience)
};
const $2308e6f5aae12b86$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $2308e6f5aae12b86$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("nb8r1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09545a48e55da9e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $051X7 = parcelRequire("051X7");

var $2yPrN = parcelRequire("2yPrN");
var $kDZ6Z = parcelRequire("kDZ6Z");
var $fiKQs = parcelRequire("fiKQs");

var $8dVIb = parcelRequire("8dVIb");

var $aOsut = parcelRequire("aOsut");

const $09545a48e55da9e9$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $5uXOq.useCallback)((url, metadataStatus)=>{
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $5uXOq.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: url
        }, (0, $aOsut.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $fiKQs.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fallback', hostname, (0, $cc6a74b99a201fc4$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fatal', hostname, (0, $cc6a74b99a201fc4$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('error', hostname, (0, $cc6a74b99a201fc4$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $7nsd3.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $09545a48e55da9e9$export$2e2bcd8739ae039 = $09545a48e55da9e9$var$useResponse;

});
parcelRegister("aOsut", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $5dc57cbabb8840da$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $5dc57cbabb8840da$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $5dc57cbabb8840da$export$e32193033a594efb);
const $5dc57cbabb8840da$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $5dc57cbabb8840da$export$2796a804c6e44f63 = ()=>$5dc57cbabb8840da$var$emptyData;
const $5dc57cbabb8840da$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });
const $5dc57cbabb8840da$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });

});

const $cc6a74b99a201fc4$export$297c39c8b9bfca0 = 'resolving';
const $cc6a74b99a201fc4$export$b64a888338c24e0e = 'errored';
const $cc6a74b99a201fc4$export$677b6edfa0002c70 = 'fallback';
const $cc6a74b99a201fc4$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $cc6a74b99a201fc4$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $cc6a74b99a201fc4$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("gDUps", function(module, exports) {

$parcel$export(module.exports, "default", () => $66cd4b0a305f86bf$export$2e2bcd8739ae039);
const $66cd4b0a305f86bf$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $66cd4b0a305f86bf$export$2e2bcd8739ae039 = $66cd4b0a305f86bf$var$createStatusUpdateRequest;

});

parcelRegister("i7KLg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c1a5dbe8fe9dd0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $aYAc3 = parcelRequire("aYAc3");

var $VSDnB = parcelRequire("VSDnB");
const $c0c1a5dbe8fe9dd0$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $aYAc3.default), {
                appearance: props?.appearance,
                ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            })
        });
    };
var $c0c1a5dbe8fe9dd0$export$2e2bcd8739ae039 = $c0c1a5dbe8fe9dd0$var$withErrorBoundary;

});

parcelRegister("k2WzX", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $9f7317929809ab5b$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $9f7317929809ab5b$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $9f7317929809ab5b$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $9f7317929809ab5b$export$618660b8f2aa87e2);
const $9f7317929809ab5b$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $9f7317929809ab5b$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $9f7317929809ab5b$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $9f7317929809ab5b$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("eDeTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed6f8e41f2a6640$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ousew = parcelRequire("ousew");

var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $dD7Zc = parcelRequire("dD7Zc");

var $VSDnB = parcelRequire("VSDnB");


var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $iPVbQ = parcelRequire("iPVbQ");

var $fpDmE = parcelRequire("fpDmE");
const $7ed6f8e41f2a6640$var$MAX_LINE_NUMBER = 8;
const $7ed6f8e41f2a6640$var$contentStyles = null;
const $7ed6f8e41f2a6640$var$linkStyles = null;
const $7ed6f8e41f2a6640$var$textStylesBase = null;
const $7ed6f8e41f2a6640$var$dropdownItemGroupStyles = null;
const $7ed6f8e41f2a6640$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $7ed6f8e41f2a6640$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const invoke = (0, $iPVbQ.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $5uXOq.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
                            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $bwpsq.default)([
                                "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $lD23V.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $fpDmE.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                        target: "_blank",
                        "data-testid": `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        children: (0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $bwpsq.default)([
            "_14hp1wdt _6pup1kw7 _1eo073ad"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $7ed6f8e41f2a6640$export$2e2bcd8739ae039 = $7ed6f8e41f2a6640$var$LozengeActionError;

});
parcelRegister("iPVbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a560b45251b869c0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $a1vqi = parcelRequire("a1vqi");

var $5vDFA = parcelRequire("5vDFA");

var $1VPdD = parcelRequire("1VPdD");
const $a560b45251b869c0$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $a560b45251b869c0$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $5uXOq.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $5vDFA.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $1VPdD.startUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $5vDFA.mark(markName, 'resolved');
            (0, $1VPdD.succeedUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $5vDFA.mark(markName, 'errored');
            (0, $1VPdD.failUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $a560b45251b869c0$export$2e2bcd8739ae039 = $a560b45251b869c0$var$useInvokeClientAction;

});
parcelRegister("5vDFA", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $483ef2a5b4b04745$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $483ef2a5b4b04745$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $483ef2a5b4b04745$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $483ef2a5b4b04745$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $483ef2a5b4b04745$export$185802fd694ee1f5);
const $483ef2a5b4b04745$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $483ef2a5b4b04745$var$hasPerformanceAPIAvailable = $483ef2a5b4b04745$var$isPerformanceAPIAvailable();
const $483ef2a5b4b04745$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $483ef2a5b4b04745$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $483ef2a5b4b04745$export$1a717feb4df1a945 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $483ef2a5b4b04745$export$de42547d395c8271 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $483ef2a5b4b04745$var$getMark = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $483ef2a5b4b04745$export$185802fd694ee1f5 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measure = $483ef2a5b4b04745$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $483ef2a5b4b04745$var$getMark(id, 'pending');
            const endMark = $483ef2a5b4b04745$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});



parcelRegister("2Qn0O", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $94674035efe67a9d$export$4f2e371a667ad688);

var $7zaVw = parcelRequire("7zaVw");
const $94674035efe67a9d$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $7zaVw.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $7zaVw.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $7zaVw.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $7zaVw.messages)['status_change_update_error']
    }
};

});

parcelRegister("aizlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0de089d76c0ce596$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aRoVz = parcelRequire("aRoVz");

var $3QMlO = parcelRequire("3QMlO");
const $0de089d76c0ce596$var$dropdownItemGroupStyles = null;
const $0de089d76c0ce596$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $bwpsq.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $5uXOq.createElement)((0, $3QMlO.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $0de089d76c0ce596$export$2e2bcd8739ae039 = $0de089d76c0ce596$var$LozengeActionItemsGroup;

});
parcelRegister("3QMlO", function(module, exports) {

$parcel$export(module.exports, "default", () => $21bfe154deafa121$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $aYAc3 = parcelRequire("aYAc3");

var $VSDnB = parcelRequire("VSDnB");
const $21bfe154deafa121$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aYAc3.default), {
                appearance: appearance,
                ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    }));
};
var $21bfe154deafa121$export$2e2bcd8739ae039 = $21bfe154deafa121$var$LozengeActionItem;

});


parcelRegister("fgopX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec70f521c081a340$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $c8Oei = parcelRequire("c8Oei");

var $h5UrH = parcelRequire("h5UrH");

var $aYAc3 = parcelRequire("aYAc3");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ec70f521c081a340$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rkoiti9 _1dqonqa1 _189ee4h9 _1h6d3acm _bfhk18uv _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1p6i"
};
const $ec70f521c081a340$var$triggerLozengeStyles = null;
const $ec70f521c081a340$var$triggerButtonStyles = null;
const $ec70f521c081a340$var$LozengeActionTriggerOld = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $5uXOq.useState)(false);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $aYAc3.default), {
            appearance: appearance,
            isBold: (0, $VSDnB.fg)('platform-component-visual-refresh') ? true : isBold,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
                className: (0, $bwpsq.default)([
                    "_4cvr1h6o _1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        as: "span",
                        xcss: $ec70f521c081a340$var$styles.chevronDown,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                            color: "currentColor",
                            label: "options",
                            LEGACY_size: "medium",
                            LEGACY_margin: "-4px -8px -4px -7px"
                        })
                    })
                ]
            })
        }), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
const $ec70f521c081a340$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isHovering, setIsHovering] = (0, $5uXOq.useState)(false);
    const [isPressing, setIsPressing] = (0, $5uXOq.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $5uXOq.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $5uXOq.useState)(undefined);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovering(false), []);
    const onMouseOrKeyDown = (0, $5uXOq.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $5uXOq.useCallback)(()=>setIsPressing(false), []);
    (0, $5uXOq.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #85B8FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else if (isOpen) {
            if (isHovering) setLozengeBackgroundColor("var(--ds-background-selected-hovered, #CCE0FF)");
            else setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen,
        isHovering
    ]);
    const lozenge = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $DEWI6.cx)($ec70f521c081a340$var$styles.lozengeContainer, (isOpen || isPressing) && $ec70f521c081a340$var$styles.lozengeContainerSelected),
            as: "span",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aYAc3.default), {
                appearance: appearance,
                isBold: (0, $VSDnB.fg)('platform-component-visual-refresh') ? true : isHovering,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    backgroundColor: lozengeBackgroundColor,
                    color: lozengeForegroundColor
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
                    className: (0, $bwpsq.default)([
                        "_4cvr1h6o _1e0c1txw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            children: text
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            as: "span",
                            xcss: $ec70f521c081a340$var$styles.chevronDown,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                                color: "currentColor",
                                label: "options",
                                LEGACY_size: "medium",
                                LEGACY_margin: "-4px -8px -4px -7px"
                            })
                        })
                    ]
                })
            })
        });
    }, [
        appearance,
        isHovering,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $ec70f521c081a340$export$2e2bcd8739ae039 = (0, $h5UrH.withFeatureFlaggedComponent)($ec70f521c081a340$var$LozengeActionTriggerOld, $ec70f521c081a340$var$LozengeActionTrigger, ()=>(0, $VSDnB.fg)('platform-linking-visual-refresh-v2'));

});



parcelRegister("fZ5Rc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f95e7e4c4fea1359$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $eL5Me = parcelRequire("eL5Me");
const $f95e7e4c4fea1359$var$CreatedByElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $eL5Me.toFormattedTextProps)((0, $7zaVw.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eL5Me.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).CreatedBy
    }) : null;
};
var $f95e7e4c4fea1359$export$2e2bcd8739ae039 = $f95e7e4c4fea1359$var$CreatedByElement;

});

parcelRegister("2Lk0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2e7e15f4da236d4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hMRm5 = parcelRequire("hMRm5");
const $c2e7e15f4da236d4$var$CreatedOnElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $hMRm5.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hMRm5.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).CreatedOn
    }) : null;
};
var $c2e7e15f4da236d4$export$2e2bcd8739ae039 = $c2e7e15f4da236d4$var$CreatedOnElement;

});

parcelRegister("6WvJP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1faea79a2b81fbe8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $Rf8nG = parcelRequire("Rf8nG");
const $1faea79a2b81fbe8$var$DueOnElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $Rf8nG.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Rf8nG.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).DueOn
    }) : null;
};
var $1faea79a2b81fbe8$export$2e2bcd8739ae039 = $1faea79a2b81fbe8$var$DueOnElement;

});

parcelRegister("3fl0H", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a5c74a72e49e62$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $68a5c74a72e49e62$var$LatestCommitElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $hg3n9.toBadgeProps)(context.latestCommit?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        icon: (0, $8dVIb.IconType).Commit,
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).LatestCommit
    }) : null;
};
var $68a5c74a72e49e62$export$2e2bcd8739ae039 = $68a5c74a72e49e62$var$LatestCommitElement;

});

parcelRegister("3PUOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $268707299b2ebc77$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $9TvvC = parcelRequire("9TvvC");
const $268707299b2ebc77$var$LinkIconElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    if (!context) return null;
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v2')) {
        const data = (0, $9TvvC.toLinkIconProps)(context?.linkIcon, context.type);
        return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9TvvC.default), {
            ...data,
            ...props,
            name: (0, $8dVIb.ElementName).LinkIcon
        }) : null;
    }
    const data = typeof context?.linkIcon === 'object' ? context?.linkIcon : undefined;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9TvvC.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).LinkIcon
    }) : null;
};
var $268707299b2ebc77$export$2e2bcd8739ae039 = $268707299b2ebc77$var$LinkIconElement;

});

parcelRegister("jWYXR", function(module, exports) {

$parcel$export(module.exports, "default", () => $83d1e8d9da2e7618$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $f8hXJ = parcelRequire("f8hXJ");
const $83d1e8d9da2e7618$var$LocationElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context?.location ?? null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8hXJ.default), {
        theme: (0, $8dVIb.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).Location
    }) : null;
};
var $83d1e8d9da2e7618$export$2e2bcd8739ae039 = $83d1e8d9da2e7618$var$LocationElement;

});

parcelRegister("h2tJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $eecdcb70dc9f547d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l5Xsv = parcelRequire("l5Xsv");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $eecdcb70dc9f547d$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param props - The props necessary for the Media element.
 */ const $eecdcb70dc9f547d$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $eecdcb70dc9f547d$export$2e2bcd8739ae039 = $eecdcb70dc9f547d$var$MediaElement;

});

parcelRegister("fGb2i", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55aea4954ee0203$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $eL5Me = parcelRequire("eL5Me");
const $d55aea4954ee0203$var$ModifiedByElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $eL5Me.toFormattedTextProps)((0, $7zaVw.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eL5Me.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).ModifiedBy
    }) : null;
};
var $d55aea4954ee0203$export$2e2bcd8739ae039 = $d55aea4954ee0203$var$ModifiedByElement;

});

parcelRegister("2V8HO", function(module, exports) {

$parcel$export(module.exports, "default", () => $221a925d247ee7c3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hMRm5 = parcelRequire("hMRm5");
const $221a925d247ee7c3$var$ModifiedOnElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $hMRm5.toDateTimeProps)('modified', context.modifiedOn) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hMRm5.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).ModifiedOn
    }) : null;
};
var $221a925d247ee7c3$export$2e2bcd8739ae039 = $221a925d247ee7c3$var$ModifiedOnElement;

});

parcelRegister("8m6ON", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f1670c61632c1c3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $eL5Me = parcelRequire("eL5Me");
const $2f1670c61632c1c3$var$OwnedByElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $eL5Me.toFormattedTextProps)((0, $7zaVw.messages).owned_by, context.ownedBy) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eL5Me.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).OwnedBy
    }) : null;
};
var $2f1670c61632c1c3$export$2e2bcd8739ae039 = $2f1670c61632c1c3$var$OwnedByElement;

});

parcelRegister("jZqBQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f772633cd878b7c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $8JkyP = parcelRequire("8JkyP");
const $1f772633cd878b7c$var$OwnedByGroupElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $8JkyP.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8JkyP.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).OwnedByGroup
    }) : null;
};
var $1f772633cd878b7c$export$2e2bcd8739ae039 = $1f772633cd878b7c$var$OwnedByGroupElement;

});

parcelRegister("4gwhW", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf6cfae5130c42ed$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $h2tJr = parcelRequire("h2tJr");
const $cf6cfae5130c42ed$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $8dVIb.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h2tJr.default), {
        ...rest,
        ...data
    });
};
var $cf6cfae5130c42ed$export$2e2bcd8739ae039 = $cf6cfae5130c42ed$var$PreviewElement;

});

parcelRegister("kwJiq", function(module, exports) {

$parcel$export(module.exports, "default", () => $88709694e7b968c9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $88709694e7b968c9$var$PriorityElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).Priority
    }) : null;
};
var $88709694e7b968c9$export$2e2bcd8739ae039 = $88709694e7b968c9$var$PriorityElement;

});

parcelRegister("f9GCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c652eb19359a8101$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $c652eb19359a8101$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $hg3n9.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        icon: (0, $8dVIb.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).ProgrammingLanguage
    }) : null;
};
var $c652eb19359a8101$export$2e2bcd8739ae039 = $c652eb19359a8101$var$ProgrammingLanguageElement;

});

parcelRegister("hRhDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $91835b0879d4d845$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $91835b0879d4d845$var$ProviderElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).Provider
    }) : null;
};
var $91835b0879d4d845$export$2e2bcd8739ae039 = $91835b0879d4d845$var$ProviderElement;

});

parcelRegister("9WaRz", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd325ca281352e46$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $dd325ca281352e46$var$ReactCountElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $hg3n9.toBadgeProps)(context.reactCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        icon: (0, $8dVIb.IconType).React,
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).ReactCount
    }) : null;
};
var $dd325ca281352e46$export$2e2bcd8739ae039 = $dd325ca281352e46$var$ReactCountElement;

});

parcelRegister("bUqCh", function(module, exports) {

$parcel$export(module.exports, "default", () => $790b0c4207f92caf$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $eL5Me = parcelRequire("eL5Me");
const $790b0c4207f92caf$var$ReadTimeElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $eL5Me.toFormattedTextProps)((0, $7zaVw.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eL5Me.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).ReadTime
    }) : null;
};
var $790b0c4207f92caf$export$2e2bcd8739ae039 = $790b0c4207f92caf$var$ReadTimeElement;

});

parcelRegister("f6mgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6ddecea4a1f7bdc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hMRm5 = parcelRequire("hMRm5");
const $a6ddecea4a1f7bdc$var$SentOnElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $hMRm5.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hMRm5.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).SentOn
    }) : null;
};
var $a6ddecea4a1f7bdc$export$2e2bcd8739ae039 = $a6ddecea4a1f7bdc$var$SentOnElement;

});

parcelRegister("eEGHy", function(module, exports) {

$parcel$export(module.exports, "default", () => $1521c4614e8b21f4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eL5Me = parcelRequire("eL5Me");
const $1521c4614e8b21f4$var$SourceBranchElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $eL5Me.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eL5Me.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).SourceBranch
    }) : null;
};
var $1521c4614e8b21f4$export$2e2bcd8739ae039 = $1521c4614e8b21f4$var$SourceBranchElement;

});

parcelRegister("c6O1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $6597b39595b7aa09$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $Rf8nG = parcelRequire("Rf8nG");
const $6597b39595b7aa09$var$StateElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context?.state ?? null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Rf8nG.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).State
    }) : null;
};
var $6597b39595b7aa09$export$2e2bcd8739ae039 = $6597b39595b7aa09$var$StateElement;

});

parcelRegister("enxie", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c81ff8c6b131186$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eiceF = parcelRequire("eiceF");
const $8c81ff8c6b131186$var$StoryPointsElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $eiceF.toAtlaskitBadgeProps)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eiceF.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).StoryPoints
    }) : null;
};
var $8c81ff8c6b131186$export$2e2bcd8739ae039 = $8c81ff8c6b131186$var$StoryPointsElement;

});

parcelRegister("7iJoh", function(module, exports) {

$parcel$export(module.exports, "default", () => $5147fb36ed8249c9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $5147fb36ed8249c9$var$SubTasksProgressElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $hg3n9.toBadgeProps)(context.subTasksProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        icon: (0, $8dVIb.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).SubTasksProgress
    }) : null;
};
var $5147fb36ed8249c9$export$2e2bcd8739ae039 = $5147fb36ed8249c9$var$SubTasksProgressElement;

});

parcelRegister("ab13D", function(module, exports) {

$parcel$export(module.exports, "default", () => $affe3dc68bab2bfe$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $affe3dc68bab2bfe$var$SubscriberCountElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $hg3n9.toBadgeProps)(context.subscriberCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        icon: (0, $8dVIb.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).SubscriberCount
    }) : null;
};
var $affe3dc68bab2bfe$export$2e2bcd8739ae039 = $affe3dc68bab2bfe$var$SubscriberCountElement;

});

parcelRegister("jJwLC", function(module, exports) {

$parcel$export(module.exports, "default", () => $eab88e343da53b06$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eL5Me = parcelRequire("eL5Me");
const $eab88e343da53b06$var$TargetBranchElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $eL5Me.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eL5Me.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).TargetBranch
    }) : null;
};
var $eab88e343da53b06$export$2e2bcd8739ae039 = $eab88e343da53b06$var$TargetBranchElement;

});

parcelRegister("ivaGo", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c6e12f7efa101e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $f8hXJ = parcelRequire("f8hXJ");
const $15c6e12f7efa101e$var$TitleElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? context?.linkTitle : (0, $f8hXJ.toLinkProps)(context.title, context.url) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8hXJ.default), {
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).Title
    }) : null;
};
var $15c6e12f7efa101e$export$2e2bcd8739ae039 = $15c6e12f7efa101e$var$TitleElement;

});

parcelRegister("hp8Xw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a469b84c6f356bcf$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $a469b84c6f356bcf$var$ViewCountElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $hg3n9.toBadgeProps)(context.viewCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        icon: (0, $8dVIb.IconType).View,
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).ViewCount
    }) : null;
};
var $a469b84c6f356bcf$export$2e2bcd8739ae039 = $a469b84c6f356bcf$var$ViewCountElement;

});

parcelRegister("cG2jR", function(module, exports) {

$parcel$export(module.exports, "default", () => $41d1d3baaf8f84dd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $hg3n9 = parcelRequire("hg3n9");
const $41d1d3baaf8f84dd$var$VoteCountElement = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context ? (0, $hg3n9.toBadgeProps)(context.voteCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hg3n9.default), {
        icon: (0, $8dVIb.IconType).Vote,
        ...data,
        ...props,
        name: (0, $8dVIb.ElementName).VoteCount
    }) : null;
};
var $41d1d3baaf8f84dd$export$2e2bcd8739ae039 = $41d1d3baaf8f84dd$var$VoteCountElement;

});


parcelRegister("kp8aU", function(module, exports) {

$parcel$export(module.exports, "default", () => $673e9555bded0d05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $eL5Me = parcelRequire("eL5Me");
const $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES = 3;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $673e9555bded0d05$var$snippetBaseStyleOld = null;
const $673e9555bded0d05$var$snippetBaseStyle = null;
const $673e9555bded0d05$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eL5Me.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $673e9555bded0d05$export$2e2bcd8739ae039 = $673e9555bded0d05$var$SnippetElement;

});


parcelRegister("bubxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $66554651c27d9387$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $ldJSL = parcelRequire("ldJSL");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $bJeNF = parcelRequire("bJeNF");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $akF1x = parcelRequire("akF1x");

var $3Zm9O = parcelRequire("3Zm9O");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $66554651c27d9387$var$stylesOld = null;
const $66554651c27d9387$var$styles = null;
const $66554651c27d9387$var$renderActionItems = (items = [], size = (0, $8dVIb.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Zm9O.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $66554651c27d9387$var$ActionGroup = ({ items: items = [], size: size = (0, $8dVIb.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gKZoD.di)((0, $BLPHT.default));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const renderableActionItems = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fpDmE.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).more_actions
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41j6v _dzc21h6o _1ilq1i6y",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ldJSL.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $66554651c27d9387$export$2e2bcd8739ae039 = $66554651c27d9387$var$ActionGroup;

});
parcelRegister("akF1x", function(module, exports) {

$parcel$export(module.exports, "filterActionItems", () => $8ba323b39584fd77$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $8ba323b39584fd77$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $8ba323b39584fd77$export$9678d3ca18bd7526);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $91tw3 = parcelRequire("91tw3");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $1BfaB = parcelRequire("1BfaB");
const $8ba323b39584fd77$export$f942619ce67b1a41 = {
    [(0, $8dVIb.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Location]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Preview]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).Priority]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Provider]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Snippet]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).State]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Title]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).VoteCount]: [
        'inline'
    ]
};
const $8ba323b39584fd77$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1;
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 0.5;
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $8ba323b39584fd77$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $bubxq.default);
const $8ba323b39584fd77$var$isElementDisplayValid = (name, display)=>{
    return $8ba323b39584fd77$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $8ba323b39584fd77$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $8ba323b39584fd77$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && ((0, $91tw3.isFlexibleUiElement)(node) || node.type === (0, $1BfaB.default));
const $8ba323b39584fd77$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $8dVIb.ActionName).DeleteAction:
            case (0, $8dVIb.ActionName).EditAction:
            case (0, $8dVIb.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $8dVIb.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $8ba323b39584fd77$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if ($8ba323b39584fd77$var$isElementOrElementGroup(child) || $8ba323b39584fd77$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $8ba323b39584fd77$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $eqoQu[name];
        const typedProps = props;
        if (Element && $8ba323b39584fd77$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $2OMIu.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$8ba323b39584fd77$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("91tw3", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $f30ba994fabdf720$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $f30ba994fabdf720$export$df0092b19156b140);
$parcel$export(module.exports, "isStyleCacheProvider", () => $f30ba994fabdf720$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $f30ba994fabdf720$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $f30ba994fabdf720$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $f30ba994fabdf720$export$c0547b4405cae584);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $66ZRy = parcelRequire("66ZRy");
var $buvhv = parcelRequire("buvhv");
var $hYQw7 = parcelRequire("hYQw7");
var $ietxm = parcelRequire("ietxm");

var $eqoQu = parcelRequire("eqoQu");
const $f30ba994fabdf720$export$3c94e0f4719f5c2a = (children, ui)=>{
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-openness')) {
        if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)?.length > 0 ? true : false;
    }
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).some((child)=>$f30ba994fabdf720$export$df0092b19156b140(child))) return true;
    return false;
};
const $f30ba994fabdf720$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $f30ba994fabdf720$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($66ZRy).some((type)=>type === node.type)) return true;
    return false;
};
const $f30ba994fabdf720$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (Object.values($eqoQu).some((type)=>type === node.type)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $buvhv.default)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $hYQw7.default)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $ietxm.default);

});
parcelRegister("66ZRy", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("ietxm")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("gg6Qm")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("hYQw7")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("1JaZ4")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("buvhv")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("dghu0")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("5HrTg")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("1qDIM")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("85ffk")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("fh9qw")).default);

var $ietxm = parcelRequire("ietxm");

var $gg6Qm = parcelRequire("gg6Qm");

var $hYQw7 = parcelRequire("hYQw7");

var $1JaZ4 = parcelRequire("1JaZ4");

var $buvhv = parcelRequire("buvhv");

var $dghu0 = parcelRequire("dghu0");

var $5HrTg = parcelRequire("5HrTg");

var $1qDIM = parcelRequire("1qDIM");

var $85ffk = parcelRequire("85ffk");

var $fh9qw = parcelRequire("fh9qw");

});
parcelRegister("ietxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fcebb5ad9978d90$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $5HrTg = parcelRequire("5HrTg");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $3fcebb5ad9978d90$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    const cardContext = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $Nh1XU.useFlexibleCardContext)() : undefined;
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-context')) {
        if (cardContext?.status !== (0, $8dVIb.SmartLinkStatus).Resolved && !alwaysShow) return null;
    } else {
        if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !alwaysShow) return null;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HrTg.default), {
        ...props,
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? {
            size: props.size ?? cardContext?.ui?.size
        } : undefined,
        testId: testId
    });
};
var $3fcebb5ad9978d90$export$2e2bcd8739ae039 = $3fcebb5ad9978d90$var$FooterBlock;

});
parcelRegister("5HrTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8eaafd3e75b73f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b6uPu = parcelRequire("b6uPu");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $b8eaafd3e75b73f4$var$actionGroupStylesOld = null;
const $b8eaafd3e75b73f4$var$actionGroupStyles = null;
const $b8eaafd3e75b73f4$var$safariStyles = null;
const $b8eaafd3e75b73f4$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $8dVIb.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const hasActions = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const { safari: safari = false } = (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>(0, $b6uPu.browser)(), []) : {};
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Provider), {
                ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                testId: "smart-element-group-actions",
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                className: (0, $bwpsq.default)([
                    size === (0, $8dVIb.SmartLinkSize).XLarge && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_c71lxy5q",
                    size === (0, $8dVIb.SmartLinkSize).XLarge && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_c71lviql",
                    safari && "_4t3i1osq"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $b8eaafd3e75b73f4$export$2e2bcd8739ae039 = $b8eaafd3e75b73f4$var$FooterBlockResolvedView;

});
parcelRegister("dghu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a6d91fb5d77548$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $96a6d91fb5d77548$var$BaseBlockStylesOld = null;
const $96a6d91fb5d77548$var$baseBlockStyles = null;
const $96a6d91fb5d77548$var$highlightRemoveStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $96a6d91fb5d77548$var$gapsStylesOld = {
    xlarge: "_zulp1k92 _1ljq1k92",
    large: "_zulp1j6v _1ljq1j6v",
    medium: "_zulp1kwk _1ljq1kwk",
    small: "_zulp6mu8 _1ljq6mu8"
};
const $96a6d91fb5d77548$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $96a6d91fb5d77548$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $96a6d91fb5d77548$var$Block = ({ children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $5uXOq.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    const ssrPlacholderProps = (0, $VSDnB.fg)('cc_shortcut_ssr_placeholder') ? {
        'data-ssr-placeholder': placeholderId,
        'data-ssr-placeholder-replace': placeholderId
    } : {};
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _vwz41j6v _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1ouwidpf _f6ju1ns9 _1uzp1mp2 _ytq1bjq5 _a7e8uxlv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bxmuej _e4i5bjq5 _1gu21oju _5b7tuxlv _17ae1oju",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $96a6d91fb5d77548$var$directionStyles[direction],
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $96a6d91fb5d77548$var$gapsStylesOld[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $96a6d91fb5d77548$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        ...ssrPlacholderProps,
        children: (0, $akF1x.renderChildren)(children, size)
    });
};
var $96a6d91fb5d77548$export$2e2bcd8739ae039 = $96a6d91fb5d77548$var$Block;

});

parcelRegister("1BfaB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed56962f49dee3a8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");
const $ed56962f49dee3a8$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $ed56962f49dee3a8$var$baseStyleBySizeOld = {
    xlarge: "_zulp147b _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    large: "_zulp1e9d _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    medium: "_zulpcxkx _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    small: "_zulppdf9 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v"
};
const $ed56962f49dee3a8$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $ed56962f49dee3a8$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $ed56962f49dee3a8$var$baseStyleOld = null;
const $ed56962f49dee3a8$var$baseStyles = null;
const $ed56962f49dee3a8$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $ed56962f49dee3a8$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $ed56962f49dee3a8$var$horizontalStyleBase = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $ed56962f49dee3a8$var$horizontalStyleByHeightOld = {
    xlarge: "_1e0ccj1k _102k1m1q",
    large: "_1e0ccj1k _102k1m1q",
    medium: "_1e0ccj1k _102k1k8s",
    small: "_1e0ccj1k _102k1k8s"
};
const $ed56962f49dee3a8$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $ed56962f49dee3a8$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $ed56962f49dee3a8$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $ed56962f49dee3a8$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $ed56962f49dee3a8$var$ElementGroup = ({ align: align = (0, $8dVIb.SmartLinkAlignment).Left, children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $8dVIb.SmartLinkWidth).FitToContent, position: position = (0, $8dVIb.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $8dVIb.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$baseStyleBySizeOld[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$baseStyleBySize[size],
            $ed56962f49dee3a8$var$baseStyleByDirection[direction],
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw _1ouwidpf _f6ju1ns9",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw",
            $ed56962f49dee3a8$var$alignmentStyleMap[align],
            "_1ul99by0",
            $ed56962f49dee3a8$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$horizontalStyleByHeightOld[size],
            isHorizontal && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $8dVIb.SmartLinkAlignment).Left && $ed56962f49dee3a8$var$gapStylesLeft[size],
            isHorizontal && align === (0, $8dVIb.SmartLinkAlignment).Right && $ed56962f49dee3a8$var$gapStylesRight[size],
            $ed56962f49dee3a8$var$positionStyle[position],
            className
        ]),
        children: (0, $akF1x.renderChildren)(children, size)
    });
};
var $ed56962f49dee3a8$export$2e2bcd8739ae039 = $ed56962f49dee3a8$var$ElementGroup;

});



parcelRegister("gg6Qm", function(module, exports) {

$parcel$export(module.exports, "default", () => $61dcf60a0013442f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $61dcf60a0013442f$var$DEFAULT_MAX_LINES = 2;
const $61dcf60a0013442f$var$MAXIMUM_MAX_LINES = 2;
const $61dcf60a0013442f$var$MINIMUM_MAX_LINES = 1;
const $61dcf60a0013442f$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $61dcf60a0013442f$var$sizeStylesOld = {
    xlarge: "_vwz41m1q _102k1k7u",
    large: "_vwz41m1q _102k1k7u",
    medium: "_vwz41k8s _102k1wto",
    small: "_vwz41k8s _102k1wto"
};
const $61dcf60a0013442f$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $61dcf60a0013442f$var$getMaxLines = (maxLines)=>{
    if (maxLines > $61dcf60a0013442f$var$MAXIMUM_MAX_LINES) return $61dcf60a0013442f$var$DEFAULT_MAX_LINES;
    if (maxLines < $61dcf60a0013442f$var$MINIMUM_MAX_LINES) return $61dcf60a0013442f$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $61dcf60a0013442f$var$ElementItemRenderer = ({ align: align = (0, $8dVIb.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $8dVIb.SmartLinkSize).Medium, maxLines: maxLines = $61dcf60a0013442f$var$DEFAULT_MAX_LINES })=>{
    const elements = (0, $akF1x.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
        align: align,
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
        width: (0, $8dVIb.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $bwpsq.default)([
            $61dcf60a0013442f$var$truncateStyles[maxLines],
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStylesOld[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStyles[size]
        ]),
        children: elements
    });
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $61dcf60a0013442f$var$MetadataBlock = ({ maxLines: maxLines = $61dcf60a0013442f$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    const cardContext = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $Nh1XU.useFlexibleCardContext)() : undefined;
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-context')) {
        if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    } else {
        if (primary.length === 0 && secondary.length === 0 || status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    }
    const { size: sizeProp = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const size = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? blockProps?.size ?? cardContext?.ui?.size ?? (0, $8dVIb.SmartLinkSize).Medium : sizeProp;
    const maxLinesTotal = $61dcf60a0013442f$var$getMaxLines(maxLines);
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-context')) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($61dcf60a0013442f$var$ElementItemRenderer, {
                items: primary,
                size: size,
                maxLines: maxLinesTotal
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($61dcf60a0013442f$var$ElementItemRenderer, {
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                items: secondary,
                size: size,
                maxLines: maxLinesTotal
            })
        ]
    });
    const primaryElements = (0, $akF1x.renderElementItems)(primary);
    const secondaryElements = (0, $akF1x.renderElementItems)(secondary);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            primaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Left,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStylesOld[size],
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStyles[size]
                ]),
                children: primaryElements
            }),
            secondaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStylesOld[size],
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStyles[size]
                ]),
                children: secondaryElements
            })
        ]
    });
};
var $61dcf60a0013442f$export$2e2bcd8739ae039 = $61dcf60a0013442f$var$MetadataBlock;

});

parcelRegister("hYQw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $61b44b31e2da1312$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $cElbi = parcelRequire("cElbi");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $61b44b31e2da1312$var$PreviewBlock = ({ status: // eslint-disable-next-line @typescript-eslint/no-unused-vars
status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $Nh1XU.useFlexibleUiOptionContext)() : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cElbi.default), {
        ...blockProps,
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? {
            size: blockProps.size ?? ui?.size
        } : undefined,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $61b44b31e2da1312$export$2e2bcd8739ae039 = $61b44b31e2da1312$var$PreviewBlock;

});
parcelRegister("cElbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $64981f7edc74268b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $4gwhW = parcelRequire("4gwhW");

var $dghu0 = parcelRequire("dghu0");
const $64981f7edc74268b$var$previewBlockStyleCommon = null;
const $64981f7edc74268b$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $64981f7edc74268b$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $5uXOq.useState)(style ?? {});
    const updateStyles = (0, $5uXOq.useCallback)(()=>{
        if (placement === (0, $8dVIb.MediaPlacement).Left || placement === (0, $8dVIb.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? '0px' : '0rem' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $8dVIb.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $8dVIb.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $5uXOq.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $5uXOq.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4gwhW.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $64981f7edc74268b$export$2e2bcd8739ae039 = $64981f7edc74268b$var$PreviewBlockResolvedView;

});


parcelRegister("1JaZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c880264dd5ccb40b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $khbkQ = parcelRequire("khbkQ");

var $kp8aU = parcelRequire("kp8aU");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
const $c880264dd5ccb40b$var$DEFAULT_MAX_LINES = 3;
const $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES = 6;
const $c880264dd5ccb40b$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $c880264dd5ccb40b$var$SnippetBlock = ({ maxLines: maxLines = $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, ...blockProps })=>{
    const context = (0, $VSDnB.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $Nh1XU.useFlexibleUiContext)() : undefined;
    const renderers = (0, $VSDnB.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $khbkQ.useSmartLinkRenderers)() : undefined;
    const enableSnippetRenderer = (0, $VSDnB.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $Nh1XU.useFlexibleUiOptionContext)()?.enableSnippetRenderer : undefined;
    const cardContext = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $Nh1XU.useFlexibleCardContext)() : undefined;
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-context')) {
        if (cardContext?.status !== (0, $8dVIb.SmartLinkStatus).Resolved && !text) return null;
    } else {
        if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !text) return null;
    }
    const snippetMaxLines = (0, $fpDmE.getMaxLines)(maxLines, $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES, $c880264dd5ccb40b$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kp8aU.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!(0, $VSDnB.fg)('cc-ai-linking-platform-snippet-renderer') || !enableSnippetRenderer) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? {
            size: blockProps.size ?? cardContext?.ui?.size
        } : undefined,
        testId: `${testId}-${statusTestId}-view`,
        children: snippet
    });
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? {
            size: blockProps.size ?? cardContext?.ui?.size
        } : undefined,
        testId: `${testId}-${statusTestId}-view`,
        children: SnippetReplacement ? /*#__PURE__*/ (0, $2OMIu.jsx)(SnippetReplacement, {
            fallbackText: (text || context?.snippet) ?? '',
            fallbackComponent: snippet,
            contentId: context?.meta?.objectId ?? '',
            contentType: context?.meta?.resourceType ?? '',
            cloudId: context?.meta?.tenantId ?? '',
            maxLines: snippetMaxLines,
            isHidden: isHidden
        }) : snippet
    });
};
var $c880264dd5ccb40b$export$2e2bcd8739ae039 = $c880264dd5ccb40b$var$SnippetBlock;

});
parcelRegister("khbkQ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkRenderers", () => $53b108afa53560ee$export$c3514c024fefef57);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $53b108afa53560ee$export$c3514c024fefef57 = ()=>{
    const context = (0, $051X7.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $5uXOq.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});


parcelRegister("1qDIM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dff75b4d7cc06d3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $4tgi5 = parcelRequire("4tgi5");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $5dff75b4d7cc06d3$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const cardContext = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $Nh1XU.useFlexibleCardContext)() : undefined;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-context')) {
        if (cardContext?.status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    } else {
        if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    }
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4tgi5.default), {
        ...props,
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? {
            size: props.size ?? cardContext?.ui?.size
        } : undefined,
        testId: testId,
        url: actionData.url
    });
};
var $5dff75b4d7cc06d3$export$2e2bcd8739ae039 = $5dff75b4d7cc06d3$var$AISummaryBlock;

});
parcelRegister("4tgi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $413bb2fab5c71807$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $8dVIb = parcelRequire("8dVIb");

var $1MeuC = parcelRequire("1MeuC");

var $bHeMs = parcelRequire("bHeMs");

var $aBTst = parcelRequire("aBTst");

var $dghu0 = parcelRequire("dghu0");

var $adeuB = parcelRequire("adeuB");
const $413bb2fab5c71807$var$styles = null;
const $413bb2fab5c71807$var$AISummaryBlockResolvedView = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default), (0, $bHeMs.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $1MeuC.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $5uXOq.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        direction: (0, $8dVIb.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adeuB.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bHeMs.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $413bb2fab5c71807$export$2e2bcd8739ae039 = $413bb2fab5c71807$var$AISummaryBlockResolvedView;

});
parcelRegister("1MeuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $27e30e18347ce2a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hWyvy = parcelRequire("hWyvy");
var $8UXrm = parcelRequire("8UXrm");

var $a1vqi = parcelRequire("a1vqi");

var $1VPdD = parcelRequire("1VPdD");

var $hjhAz = parcelRequire("hjhAz");

var $kR87P = parcelRequire("kR87P");

var $anB5s = parcelRequire("anB5s");
const $27e30e18347ce2a0$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $27e30e18347ce2a0$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $anB5s.useAISummaryConfig)();
    const cardState = (0, $hjhAz.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $hWyvy.extractAri)(data);
    const dataUrl = data && (0, $8UXrm.extractLink)(data) || '';
    const onStart = (0, $5uXOq.useCallback)((id)=>{
        (0, $1VPdD.startUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $5uXOq.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $1VPdD.succeedUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $5uXOq.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $1VPdD.failUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $kR87P.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $27e30e18347ce2a0$export$2e2bcd8739ae039 = $27e30e18347ce2a0$var$useAISummaryAction;

});
parcelRegister("hjhAz", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $7fb324870ee27912$export$b0444d00ba7313c6);

var $bDWQ3 = parcelRequire("bDWQ3");

var $051X7 = parcelRequire("051X7");
const $7fb324870ee27912$var$PENDING_STATE = {
    status: 'pending'
};
function $7fb324870ee27912$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const cardState = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $7fb324870ee27912$var$PENDING_STATE;
}

});

parcelRegister("kR87P", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $c5395471ca862cc2$export$becd8f2eba1bbd96);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $SrCME = parcelRequire("SrCME");

var $561ku = parcelRequire("561ku");
const $c5395471ca862cc2$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $5uXOq.useState)((0, $561ku.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $561ku.AISummariesStore).get(url)) (0, $561ku.AISummariesStore).set(url, new (0, $SrCME.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $561ku.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $561ku.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("SrCME", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $ad05438f1e08870b$export$73e4b807d5bd74b6);

var $7Jxgt = parcelRequire("7Jxgt");

var $itO4f = parcelRequire("itO4f");

var $9AA7J = parcelRequire("9AA7J");

var $c0Zwh = parcelRequire("c0Zwh");

var $ghXNq = parcelRequire("ghXNq");
class $ad05438f1e08870b$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $itO4f.getBaseUrl)(envKey);
                return (0, $ghXNq.addPath)(baseUrl, path);
            }
            return (0, $ghXNq.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $9AA7J.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $ghXNq.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $c0Zwh.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $c0Zwh.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("9AA7J", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $27dc203987154036$export$e45226161c660403);

var $ghXNq = parcelRequire("ghXNq");
async function* $27dc203987154036$export$e45226161c660403(response) {
    const reader = (0, $ghXNq.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("ghXNq", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $6c9c387ba5dd9d5b$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $6c9c387ba5dd9d5b$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $6c9c387ba5dd9d5b$export$ff2962de2b2c930f);
const $6c9c387ba5dd9d5b$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $6c9c387ba5dd9d5b$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $6c9c387ba5dd9d5b$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $6c9c387ba5dd9d5b$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $6c9c387ba5dd9d5b$export$ff2962de2b2c930f = (product)=>{
    if ($6c9c387ba5dd9d5b$var$isJiraProduct(product)) return $6c9c387ba5dd9d5b$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("c0Zwh", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $0e5f8d5a8019ed33$export$fcec967a4b7ebd84);
class $0e5f8d5a8019ed33$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $0e5f8d5a8019ed33$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("561ku", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $cc472589618fd980$export$6979339b6d41707e);

var $iwKVT = parcelRequire("iwKVT");
const $cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE = 100;
const $cc472589618fd980$export$6979339b6d41707e = new (0, $iwKVT.LRUMap)($cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("anB5s", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $cd0a62b074a064ce$export$4480af2c00aa7ebe);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $cd0a62b074a064ce$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $051X7.useSmartLinkContext)();
    return (0, $5uXOq.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("bHeMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea67ef8b17402f34$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $flpap = parcelRequire("flpap");

var $VSDnB = parcelRequire("VSDnB");

var $aRS1S = parcelRequire("aRS1S");
const $ea67ef8b17402f34$var$AISummaryCSSStyles = null;
const $ea67ef8b17402f34$var$baseStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $ea67ef8b17402f34$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $flpap.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _syaz1gjq _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $aRS1S.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $ea67ef8b17402f34$export$2e2bcd8739ae039 = $ea67ef8b17402f34$var$AISummary;

});
parcelRegister("flpap", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2bc56c6c0b4e02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b2bc56c6c0b4e02e$var$t() {
    return $b2bc56c6c0b4e02e$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $b2bc56c6c0b4e02e$var$t.apply(this, arguments);
}
const $b2bc56c6c0b4e02e$var$n = [
    "children",
    "options"
], $b2bc56c6c0b4e02e$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $b2bc56c6c0b4e02e$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($b2bc56c6c0b4e02e$var$i || ($b2bc56c6c0b4e02e$var$i = {}));
const $b2bc56c6c0b4e02e$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $b2bc56c6c0b4e02e$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $b2bc56c6c0b4e02e$var$o = [
    "style",
    "script"
], $b2bc56c6c0b4e02e$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $b2bc56c6c0b4e02e$var$s = /mailto:/i, $b2bc56c6c0b4e02e$var$d = /\n{2,}$/, $b2bc56c6c0b4e02e$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $b2bc56c6c0b4e02e$var$u = /^ *> ?/gm, $b2bc56c6c0b4e02e$var$f = /^ {2,}\n/, $b2bc56c6c0b4e02e$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $b2bc56c6c0b4e02e$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $b2bc56c6c0b4e02e$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $b2bc56c6c0b4e02e$var$k = /^(?:\n *)*\n/, $b2bc56c6c0b4e02e$var$x = /\r\n?/g, $b2bc56c6c0b4e02e$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $b2bc56c6c0b4e02e$var$v = /^\[\^([^\]]+)]/, $b2bc56c6c0b4e02e$var$S = /\f/g, $b2bc56c6c0b4e02e$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $b2bc56c6c0b4e02e$var$C = /^\s*?\[(x|\s)\]/, $b2bc56c6c0b4e02e$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $b2bc56c6c0b4e02e$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $b2bc56c6c0b4e02e$var$T = /^<!--[\s\S]*?(?:-->)/, $b2bc56c6c0b4e02e$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $b2bc56c6c0b4e02e$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $b2bc56c6c0b4e02e$var$M = /^\{.*\}$/, $b2bc56c6c0b4e02e$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $b2bc56c6c0b4e02e$var$I = /^<([^ >]+@[^ >]+)>/, $b2bc56c6c0b4e02e$var$U = /^<([^ >]+:\/[^ >]+)>/, $b2bc56c6c0b4e02e$var$D = /-([a-z])?/gi, $b2bc56c6c0b4e02e$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $b2bc56c6c0b4e02e$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $b2bc56c6c0b4e02e$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $b2bc56c6c0b4e02e$var$_ = /\t/g, $b2bc56c6c0b4e02e$var$G = /(^ *\||\| *$)/g, $b2bc56c6c0b4e02e$var$W = /^ *:-+: *$/, $b2bc56c6c0b4e02e$var$Z = /^ *:-+ *$/, $b2bc56c6c0b4e02e$var$q = /^ *-+: *$/, $b2bc56c6c0b4e02e$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $b2bc56c6c0b4e02e$var$V = new RegExp(`^([*_])\\1${$b2bc56c6c0b4e02e$var$Q}\\1\\1(?!\\1)`), $b2bc56c6c0b4e02e$var$X = new RegExp(`^([*_])${$b2bc56c6c0b4e02e$var$Q}\\1(?!\\1|\\w)`), $b2bc56c6c0b4e02e$var$J = new RegExp(`^==${$b2bc56c6c0b4e02e$var$Q}==`), $b2bc56c6c0b4e02e$var$K = new RegExp(`^~~${$b2bc56c6c0b4e02e$var$Q}~~`), $b2bc56c6c0b4e02e$var$Y = /^\\([^0-9A-Za-z\s])/, $b2bc56c6c0b4e02e$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $b2bc56c6c0b4e02e$var$te = /^\n+/, $b2bc56c6c0b4e02e$var$ne = /^([ \t]*)/, $b2bc56c6c0b4e02e$var$re = /\\([^\\])/g, $b2bc56c6c0b4e02e$var$ie = / *\n+$/, $b2bc56c6c0b4e02e$var$le = /(?:^|\n)( *)$/, $b2bc56c6c0b4e02e$var$ae = "(?:\\d+\\.)", $b2bc56c6c0b4e02e$var$oe = "(?:[*+-])";
function $b2bc56c6c0b4e02e$var$ce(e) {
    return "( *)(" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + ") +";
}
const $b2bc56c6c0b4e02e$var$se = $b2bc56c6c0b4e02e$var$ce(1), $b2bc56c6c0b4e02e$var$de = $b2bc56c6c0b4e02e$var$ce(2);
function $b2bc56c6c0b4e02e$var$pe(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de));
}
const $b2bc56c6c0b4e02e$var$ue = $b2bc56c6c0b4e02e$var$pe(1), $b2bc56c6c0b4e02e$var$fe = $b2bc56c6c0b4e02e$var$pe(2);
function $b2bc56c6c0b4e02e$var$he(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $b2bc56c6c0b4e02e$var$me = $b2bc56c6c0b4e02e$var$he(1), $b2bc56c6c0b4e02e$var$ge = $b2bc56c6c0b4e02e$var$he(2);
function $b2bc56c6c0b4e02e$var$ye(e) {
    const t = 1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $b2bc56c6c0b4e02e$var$ke = $b2bc56c6c0b4e02e$var$ye(1), $b2bc56c6c0b4e02e$var$xe = $b2bc56c6c0b4e02e$var$ye(2);
function $b2bc56c6c0b4e02e$var$be(e, t) {
    const n = 1 === t, i = n ? $b2bc56c6c0b4e02e$var$ke : $b2bc56c6c0b4e02e$var$xe, l = n ? $b2bc56c6c0b4e02e$var$me : $b2bc56c6c0b4e02e$var$ge, a = n ? $b2bc56c6c0b4e02e$var$ue : $b2bc56c6c0b4e02e$var$fe;
    return {
        match (e, t) {
            const n = $b2bc56c6c0b4e02e$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($b2bc56c6c0b4e02e$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($b2bc56c6c0b4e02e$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($b2bc56c6c0b4e02e$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $b2bc56c6c0b4e02e$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $b2bc56c6c0b4e02e$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $b2bc56c6c0b4e02e$var$Ee = [
    $b2bc56c6c0b4e02e$var$p,
    $b2bc56c6c0b4e02e$var$m,
    $b2bc56c6c0b4e02e$var$g,
    $b2bc56c6c0b4e02e$var$$,
    $b2bc56c6c0b4e02e$var$z,
    $b2bc56c6c0b4e02e$var$w,
    $b2bc56c6c0b4e02e$var$T,
    $b2bc56c6c0b4e02e$var$j,
    $b2bc56c6c0b4e02e$var$me,
    $b2bc56c6c0b4e02e$var$ke,
    $b2bc56c6c0b4e02e$var$ge,
    $b2bc56c6c0b4e02e$var$xe
], $b2bc56c6c0b4e02e$var$Ce = [
    ...$b2bc56c6c0b4e02e$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $b2bc56c6c0b4e02e$var$L,
    $b2bc56c6c0b4e02e$var$B
];
function $b2bc56c6c0b4e02e$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $b2bc56c6c0b4e02e$var$we(e) {
    return $b2bc56c6c0b4e02e$var$q.test(e) ? "right" : $b2bc56c6c0b4e02e$var$W.test(e) ? "center" : $b2bc56c6c0b4e02e$var$Z.test(e) ? "left" : null;
}
function $b2bc56c6c0b4e02e$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $b2bc56c6c0b4e02e$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($b2bc56c6c0b4e02e$var$G, "").split("|").map($b2bc56c6c0b4e02e$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $b2bc56c6c0b4e02e$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $b2bc56c6c0b4e02e$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph
    };
}
function $b2bc56c6c0b4e02e$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $b2bc56c6c0b4e02e$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$b2bc56c6c0b4e02e$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $b2bc56c6c0b4e02e$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $b2bc56c6c0b4e02e$var$Ue(e) {
    return e.replace($b2bc56c6c0b4e02e$var$re, "$1");
}
function $b2bc56c6c0b4e02e$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $b2bc56c6c0b4e02e$var$He = (e, t, n)=>({
        children: $b2bc56c6c0b4e02e$var$De(t, e[1], n)
    });
function $b2bc56c6c0b4e02e$var$Fe() {
    return {};
}
function $b2bc56c6c0b4e02e$var$Pe() {
    return null;
}
function $b2bc56c6c0b4e02e$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $b2bc56c6c0b4e02e$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $b2bc56c6c0b4e02e$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $b2bc56c6c0b4e02e$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $b2bc56c6c0b4e02e$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $b2bc56c6c0b4e02e$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $b2bc56c6c0b4e02e$var$t({}, n, l, {
            className: $b2bc56c6c0b4e02e$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($b2bc56c6c0b4e02e$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $b2bc56c6c0b4e02e$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($b2bc56c6c0b4e02e$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $5uXOq.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($b2bc56c6c0b4e02e$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($b2bc56c6c0b4e02e$var$O) && (e = e.replace($b2bc56c6c0b4e02e$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $b2bc56c6c0b4e02e$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($b2bc56c6c0b4e02e$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($b2bc56c6c0b4e02e$var$L.test(p) || $b2bc56c6c0b4e02e$var$B.test(p)) && (n[d] = $5uXOq.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$b2bc56c6c0b4e02e$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $b2bc56c6c0b4e02e$export$3e2338ea76b578c9, i.slugify = i.slugify || $b2bc56c6c0b4e02e$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $b2bc56c6c0b4e02e$var$t({}, $b2bc56c6c0b4e02e$var$a, i.namedCodesToUnicode) : $b2bc56c6c0b4e02e$var$a, i.createElement = i.createElement || $5uXOq.createElement;
    const Z = [], q = {}, Q = {
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.blockQuote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($b2bc56c6c0b4e02e$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakLine]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$f),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakThematic]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$h),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeFenced]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeInline]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnoteReference]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $b2bc56c6c0b4e02e$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.gfmTask]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading]: {
            match: $b2bc56c6c0b4e02e$var$Be(i.enforceAtxHeadings ? $b2bc56c6c0b4e02e$var$w : $b2bc56c6c0b4e02e$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[2], n),
                    id: i.slugify(e[2], $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.headingSetext]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($b2bc56c6c0b4e02e$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $b2bc56c6c0b4e02e$var$Ce.some((e)=>e.test(c)) ? $b2bc56c6c0b4e02e$var$Ne : $b2bc56c6c0b4e02e$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $b2bc56c6c0b4e02e$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlComment]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$T),
            order: 1,
            parse: ()=>({}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.image]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$je(t, e[1], n),
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $b2bc56c6c0b4e02e$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                };
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList]: $b2bc56c6c0b4e02e$var$be(d, 1),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.unorderedList]: $b2bc56c6c0b4e02e$var$be(d, 2),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$k),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: ()=>"\n"
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph]: {
            match: $b2bc56c6c0b4e02e$var$Re,
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.ref]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refImage]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refLink]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$j),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($b2bc56c6c0b4e02e$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textBolded]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEmphasized]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEscaped]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textMarked]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$J),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$K),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock], delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($b2bc56c6c0b4e02e$var$x, "\n").replace($b2bc56c6c0b4e02e$var$S, "").replace($b2bc56c6c0b4e02e$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $b2bc56c6c0b4e02e$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $b2bc56c6c0b4e02e$var$n);
    return $5uXOq.cloneElement($b2bc56c6c0b4e02e$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("aRS1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $270fc2c4bbd80c91$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $270fc2c4bbd80c91$var$listStyles = null;
const $270fc2c4bbd80c91$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        ...props,
        className: (0, $bwpsq.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $270fc2c4bbd80c91$export$2e2bcd8739ae039 = $270fc2c4bbd80c91$var$UList;

});


parcelRegister("aBTst", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8d8f80d50d9d1e4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $a8d8f80d50d9d1e4$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $5uXOq.useState)(0);
    const ref = (0, $5uXOq.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $5uXOq.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $a8d8f80d50d9d1e4$export$2e2bcd8739ae039 = $a8d8f80d50d9d1e4$export$6118ed0013927eb2;

});

parcelRegister("adeuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $749bb6d43c83bff0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $749bb6d43c83bff0$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $749bb6d43c83bff0$export$2e2bcd8739ae039 = $749bb6d43c83bff0$var$AIEventSummaryViewed;

});



parcelRegister("85ffk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5cb2203e6787402$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $obtkX = parcelRequire("obtkX");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $d5cb2203e6787402$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    const cardContext = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $Nh1XU.useFlexibleCardContext)() : undefined;
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-context')) {
        if (cardContext?.status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    } else {
        if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $obtkX.default), {
        ...props,
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? {
            size: props.size ?? cardContext?.ui?.size
        } : undefined,
        testId: testId
    });
};
var $d5cb2203e6787402$export$2e2bcd8739ae039 = $d5cb2203e6787402$var$AIFooterBlock;

});
parcelRegister("obtkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6b56bbc6d143050$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $kBKwT = parcelRequire("kBKwT");
const $f6b56bbc6d143050$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Provider), {
                ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kBKwT.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $f6b56bbc6d143050$export$2e2bcd8739ae039 = $f6b56bbc6d143050$var$AIFooterBlockResolvedView;

});
parcelRegister("kBKwT", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $84dc366e320e5880$export$175228cc2c92b3b6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $jps85 = parcelRequire("jps85");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $3bDjY = parcelRequire("3bDjY");

var $7zaVw = parcelRequire("7zaVw");

var $1MeuC = parcelRequire("1MeuC");

var $8z1HA = parcelRequire("8z1HA");

var $c8Sqt = parcelRequire("c8Sqt");
const $84dc366e320e5880$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { state: { status: status } } = (0, $1MeuC.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c8Sqt.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $8z1HA.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});
parcelRegister("jps85", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2162c0618e136c6$var$_react = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e2162c0618e136c6$var$_baseNew = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e2162c0618e136c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2162c0618e136c6$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $e2162c0618e136c6$var$_react.default.createElement($e2162c0618e136c6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$e2162c0618e136c6$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $e2162c0618e136c6$var$_default = module.exports.default = $e2162c0618e136c6$var$AtlassianIntelligenceIcon;

});

parcelRegister("8z1HA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8c2f1acb4b6b88$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $7f8c2f1acb4b6b88$var$AiIcon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $7f8c2f1acb4b6b88$export$2e2bcd8739ae039 = $7f8c2f1acb4b6b88$var$AiIcon;

});

parcelRegister("c8Sqt", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $a035773c38c242b5$export$2957fc44b3d2481);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2Yv61 = parcelRequire("2Yv61");

var $lqBg9 = parcelRequire("lqBg9");
const $a035773c38c242b5$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $lqBg9.default),
        ...props
    });

});
parcelRegister("lqBg9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f1ed3211c768fe6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $4f1ed3211c768fe6$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $4f1ed3211c768fe6$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $4f1ed3211c768fe6$var$InfoIconGlyph
    });
var $4f1ed3211c768fe6$export$2e2bcd8739ae039 = $4f1ed3211c768fe6$var$InfoIcon;

});





parcelRegister("fh9qw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b695424587865b74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $jRHKj = parcelRequire("jRHKj");

var $s2ak7 = parcelRequire("s2ak7");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b695424587865b74$var$ignoreContainerPaddingStylesOld = null;
const $b695424587865b74$var$ignoreContainerPaddingStyles = null;
const $b695424587865b74$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $b695424587865b74$var$sort = (a, b)=>{
    let idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $b695424587865b74$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $b695424587865b74$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $gKZoD.di)((0, $s2ak7.ActionFooter));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const onLoadingChange = (0, $5uXOq.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $b695424587865b74$export$1af10e3728e3a644(ui?.size || (0, $8dVIb.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $5uXOq.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $5uXOq.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($b695424587865b74$var$sort);
        return arr.map((name)=>{
            const Action = name in $jRHKj ? $jRHKj[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? size || ui?.size : size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/no-unsafe-design-token-usage
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui?.size,
        padding,
        isLoading,
        onClick
    ]);
    return actions ? /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g" : "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb1osq _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $s2ak7.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $b695424587865b74$export$2e2bcd8739ae039 = $b695424587865b74$var$ActionBlock;

});
parcelRegister("jRHKj", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("23vM5")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("96Kdz")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("fEhHT")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("g9G65")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("b6Mes")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("9mTP8")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("jep3X")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("erAKX")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("ziZLe")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("5OUwn")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("faTeC")).default);

var $23vM5 = parcelRequire("23vM5");

var $96Kdz = parcelRequire("96Kdz");

var $fEhHT = parcelRequire("fEhHT");

var $g9G65 = parcelRequire("g9G65");

var $b6Mes = parcelRequire("b6Mes");

var $9mTP8 = parcelRequire("9mTP8");

var $jep3X = parcelRequire("jep3X");

var $erAKX = parcelRequire("erAKX");

var $ziZLe = parcelRequire("ziZLe");

var $5OUwn = parcelRequire("5OUwn");

var $faTeC = parcelRequire("faTeC");

});
parcelRegister("23vM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf7d27623ce3bf9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $f6kZQ = parcelRequire("f6kZQ");

var $kuVc8 = parcelRequire("kuVc8");

var $bhB72 = parcelRequire("bhB72");

var $1wpdl = parcelRequire("1wpdl");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $1bf7d27623ce3bf9$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhB72.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1wpdl.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kuVc8.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f6kZQ.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $1bf7d27623ce3bf9$export$2e2bcd8739ae039 = $1bf7d27623ce3bf9$var$Action;

});
parcelRegister("f6kZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ee32ab04698fad$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $3dubP = parcelRequire("3dubP");

var $fpDmE = parcelRequire("fpDmE");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$IconOnlyLarge = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmall = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmallIconOnly = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmallNotIconOnly = null;
const $b3ee32ab04698fad$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $b3ee32ab04698fad$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $b3ee32ab04698fad$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $b3ee32ab04698fad$var$ActionButtonRefreshNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $5uXOq.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $krXdA.default), {
                appearance: $b3ee32ab04698fad$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $b3ee32ab04698fad$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                appearance: $b3ee32ab04698fad$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $b3ee32ab04698fad$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                appearance: $b3ee32ab04698fad$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                appearance: $b3ee32ab04698fad$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(ActionButton);
const $b3ee32ab04698fad$var$ActionButtonRefreshNewWithOverrideCss = (0, $3dubP.withOverrideCss)($b3ee32ab04698fad$var$ActionButtonRefreshNew);
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            size === (0, $8dVIb.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $8dVIb.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $8dVIb.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $8dVIb.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2rqOp.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $fpDmE.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $b3ee32ab04698fad$var$ActionButtonHideLegacyButton = (props)=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction && (0, $VSDnB.fg)('platform-linking-flexible-card-openness')) return /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonRefreshNewWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonNew, {
        ...props
    });
};
const $b3ee32ab04698fad$var$ActionButton = (props)=>{
    return (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonHideLegacyButton, {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonNew, {
        ...props
    });
};
var $b3ee32ab04698fad$export$2e2bcd8739ae039 = $b3ee32ab04698fad$var$ActionButton;

});

parcelRegister("kuVc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e656bda53d041540$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $kxcRq = parcelRequire("kxcRq");
const $e656bda53d041540$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $kxcRq.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $e656bda53d041540$export$2e2bcd8739ae039 = $e656bda53d041540$var$ActionDropdownItem;

});

parcelRegister("bhB72", function(module, exports) {

$parcel$export(module.exports, "default", () => $345d01659b23eb38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");
const $345d01659b23eb38$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $345d01659b23eb38$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $345d01659b23eb38$var$stackItemIconStylesOld = null;
const $345d01659b23eb38$var$stackItemIconStylesCompiled = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $345d01659b23eb38$var$iconStyleMap = {
    true: "_syaz2oi6",
    false: "_syazwdcn"
};
const $345d01659b23eb38$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap[$345d01659b23eb38$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $345d01659b23eb38$export$2e2bcd8739ae039 = $345d01659b23eb38$var$ActionIcon;

});

parcelRegister("1wpdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $5PILj = parcelRequire("5PILj");
const $c6ef8f3a6ac7d3ff$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5PILj.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5PILj.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039 = $c6ef8f3a6ac7d3ff$var$ActionStackItem;

});
parcelRegister("5PILj", function(module, exports) {

$parcel$export(module.exports, "default", () => $222d00bebc6cbf68$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $3Lty3 = parcelRequire("3Lty3");

var $eZJjh = parcelRequire("eZJjh");

var $fpDmE = parcelRequire("fpDmE");

var $bhB72 = parcelRequire("bhB72");
const $222d00bebc6cbf68$var$stylesOld = {
    button: "_kkk2n7od _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _irr3166n _1di61dty",
    content: "_11c8dcr7 _syaz1fxt"
};
const $222d00bebc6cbf68$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr3166n _1di61dty",
    content: "_11c81o8v _syaz1fxt"
};
const $222d00bebc6cbf68$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $fpDmE.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhB72.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        xcss: (0, $3JT92.cx)(!(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$stylesOld.button, (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: (0, $3JT92.cx)(!(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$stylesOld.content, (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $222d00bebc6cbf68$export$2e2bcd8739ae039 = $222d00bebc6cbf68$var$ActionButton;

});



parcelRegister("96Kdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddac835e19e975e0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $84THj = parcelRequire("84THj");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $ddac835e19e975e0$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).delete
        }),
        ...props
    });
var $ddac835e19e975e0$export$2e2bcd8739ae039 = $ddac835e19e975e0$var$DeleteAction;

});

parcelRegister("fEhHT", function(module, exports) {

$parcel$export(module.exports, "default", () => $23e1c92ea69f35be$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4ChK1 = parcelRequire("4ChK1");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $23e1c92ea69f35be$var$EditAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ChK1))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).edit
        }),
        ...props
    });
var $23e1c92ea69f35be$export$2e2bcd8739ae039 = $23e1c92ea69f35be$var$EditAction;

});
parcelRegister("4ChK1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
function $35c87913ec905242$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35c87913ec905242$var$EditIcon = (props)=>/*#__PURE__*/ $35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
    }, props));
$35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;

});
parcelRegister("gsEeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfbe7921991bc4cb$var$EditIcon = (props)=>/*#__PURE__*/ $bfbe7921991bc4cb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $bfbe7921991bc4cb$var$_edit.default
    }));
$bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;

});



parcelRegister("g9G65", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fb79986052b65c1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $d4dv2 = parcelRequire("d4dv2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $4fb79986052b65c1$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).DownloadAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $7zaVw.messages).download_file : (0, $7zaVw.messages).download;
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).download_description : (0, $7zaVw.messages).download;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d4dv2))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $4fb79986052b65c1$export$2e2bcd8739ae039 = $4fb79986052b65c1$var$DownloadAction;

});
parcelRegister("d4dv2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::647640fe09afef5813e2888b2ce1f074>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98361ed174bfbb2b$var$_react = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $98361ed174bfbb2b$var$_download = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("EOGIN")));

var $98361ed174bfbb2b$var$_download2 = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5krT5")));
function $98361ed174bfbb2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98361ed174bfbb2b$var$DownloadIcon = (props)=>/*#__PURE__*/ $98361ed174bfbb2b$var$_react.default.createElement($98361ed174bfbb2b$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $98361ed174bfbb2b$var$_download2.default
    }, props));
$98361ed174bfbb2b$var$DownloadIcon.Name = 'DownloadIconMigration';
var $98361ed174bfbb2b$var$_default = module.exports.default = $98361ed174bfbb2b$var$DownloadIcon;

});
parcelRegister("EOGIN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3903aba4213e0f68da56229d9d15d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07ab0e2228a1635e$var$_react = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $07ab0e2228a1635e$var$_baseNew = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $07ab0e2228a1635e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07ab0e2228a1635e$var$DownloadIcon = (props)=>/*#__PURE__*/ $07ab0e2228a1635e$var$_react.default.createElement($07ab0e2228a1635e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$07ab0e2228a1635e$var$DownloadIcon.displayName = 'DownloadIcon';
var $07ab0e2228a1635e$var$_default = module.exports.default = $07ab0e2228a1635e$var$DownloadIcon;

});

parcelRegister("5krT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e1473e49ea22b68$var$_react = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3e1473e49ea22b68$var$_download = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("EOGIN")));
function $3e1473e49ea22b68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e1473e49ea22b68$var$DownloadIcon = (props)=>/*#__PURE__*/ $3e1473e49ea22b68$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $3e1473e49ea22b68$var$_download.default
    }));
$3e1473e49ea22b68$var$DownloadIcon.displayName = 'DownloadIcon';
var $3e1473e49ea22b68$var$_default = module.exports.default = $3e1473e49ea22b68$var$DownloadIcon;

});



parcelRegister("b6Mes", function(module, exports) {

$parcel$export(module.exports, "default", () => $879133cabfb6e190$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $3xnBw = parcelRequire("3xnBw");

var $itef5 = parcelRequire("itef5");


const $879133cabfb6e190$var$importIconMapper = {
    goal: ()=>(parcelRequire("lyOhH")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("kQ6Ua")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $879133cabfb6e190$var$getIcon = (stackIconType)=>{
    const importFn = $879133cabfb6e190$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $fpDmE.importIcon)(importFn);
};
const $879133cabfb6e190$var$FollowAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $7zaVw.messages).follow : (0, $7zaVw.messages).unfollow;
    const projectMessage = value ? (0, $7zaVw.messages).follow_project : (0, $7zaVw.messages).unfollow_project;
    const goalMessage = value ? (0, $7zaVw.messages).follow_goal : (0, $7zaVw.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $7zaVw.messages).follow_project_description : (0, $7zaVw.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $7zaVw.messages).follow_goal_description : (0, $7zaVw.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $879133cabfb6e190$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $itef5.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3xnBw.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $879133cabfb6e190$export$2e2bcd8739ae039 = $879133cabfb6e190$var$FollowAction;

});
parcelRegister("3xnBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $35d557ed1ef6412d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $69hr0 = parcelRequire("69hr0");

var $23vM5 = parcelRequire("23vM5");
const $35d557ed1ef6412d$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const invoke = (0, $3q2sI.default)();
    const reload = (0, $f22ja.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $69hr0.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $euMlu.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $35d557ed1ef6412d$export$2e2bcd8739ae039 = $35d557ed1ef6412d$var$ServerAction;

});
parcelRegister("69hr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d791805237a266$export$2e2bcd8739ae039);
const $22d791805237a266$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $22d791805237a266$export$2e2bcd8739ae039 = $22d791805237a266$var$createInvokeRequest;

});


parcelRegister("itef5", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $d31a392ae92ce299$export$49248678d3914625);

var $7zaVw = parcelRequire("7zaVw");
const $d31a392ae92ce299$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $7zaVw.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $7zaVw.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $7zaVw.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $7zaVw.messages).unfollow_goal_error;
    return (0, $7zaVw.messages).generic_error_message;
};

});

parcelRegister("lyOhH", function(module, exports) {

let $fb23c76bc86d7ec6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fb23c76bc86d7ec6$var$load("ffQaD"),
    $fb23c76bc86d7ec6$var$load("kvRbA"),
    $fb23c76bc86d7ec6$var$load("3SzZM")
]).then(()=>parcelRequire('5UxRR'));

});

parcelRegister("kQ6Ua", function(module, exports) {

let $f2be052be792008d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f2be052be792008d$var$load("ffQaD"),
    $f2be052be792008d$var$load("kvRbA"),
    $f2be052be792008d$var$load("jZ50W")
]).then(()=>parcelRequire('gsEJ1'));

});


parcelRegister("9mTP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ea9170f77974c10$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $5JpK2 = parcelRequire("5JpK2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $3ea9170f77974c10$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).PreviewAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).preview_description : (0, $7zaVw.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).preview_improved
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $3ea9170f77974c10$export$2e2bcd8739ae039 = $3ea9170f77974c10$var$PreviewAction;

});
parcelRegister("5JpK2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));

var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
    }, props));
$42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;

});


parcelRegister("jep3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1e0763b6a84021$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jOyH3 = parcelRequire("jOyH3");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $0d1e0763b6a84021$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_url_to_clipboard);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $7zaVw.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $0d1e0763b6a84021$export$2e2bcd8739ae039 = $0d1e0763b6a84021$var$CopyLinkAction;

});

parcelRegister("erAKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $12a9f0a1fef78487$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");
const $12a9f0a1fef78487$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $12a9f0a1fef78487$var$UnresolvedAction = ({ testId: testId = 'unresolved-action' })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $8dVIb.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $12a9f0a1fef78487$var$styles.message,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descriptor,
            values: values
        })
    });
    return hasAction ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $12a9f0a1fef78487$var$styles.button,
        children: message
    }) : message;
};
var $12a9f0a1fef78487$export$2e2bcd8739ae039 = $12a9f0a1fef78487$var$UnresolvedAction;

});

parcelRegister("ziZLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b53b1e1aa704061$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $dgRei = parcelRequire("dgRei");
const $8b53b1e1aa704061$var$AISummaryAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dgRei.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $8b53b1e1aa704061$export$2e2bcd8739ae039 = $8b53b1e1aa704061$var$AISummaryAction;

});
parcelRegister("dgRei", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $a6e4dbdfe418b2c1$export$8eed96bc6d982595);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $1MeuC = parcelRequire("1MeuC");

var $8UCLX = parcelRequire("8UCLX");

var $jdA9V = parcelRequire("jdA9V");
const $a6e4dbdfe418b2c1$export$8eed96bc6d982595 = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $1MeuC.default)(url);
    (0, $5uXOq.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdA9V.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8UCLX.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("8UCLX", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $a2971ac1720627ee$export$75a19de44af58722);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jps85 = parcelRequire("jps85");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $8z1HA = parcelRequire("8z1HA");

var $23vM5 = parcelRequire("23vM5");

var $blyr7 = parcelRequire("blyr7");
function $a2971ac1720627ee$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onCompleted = (0, $5uXOq.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $blyr7.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $8z1HA.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("blyr7", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $2b1346f84062e88d$export$82f46aa4e6535a45);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $cnaAy = parcelRequire("cnaAy");

var $RbANO = parcelRequire("RbANO");

var $1r4gF = parcelRequire("1r4gF");
const $2b1346f84062e88d$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $cnaAy.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RbANO.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1r4gF.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("cnaAy", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $3339f41fc1b0dac1$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $3339f41fc1b0dac1$export$cd2e891d7f87074d);

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $3339f41fc1b0dac1$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $3339f41fc1b0dac1$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $8dVIb.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $7zaVw.messages).ai_summary_error_generic,
                url: (0, $8dVIb.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("RbANO", function(module, exports) {

$parcel$export(module.exports, "default", () => $402c39c7523f0dd1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $402c39c7523f0dd1$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $402c39c7523f0dd1$export$2e2bcd8739ae039 = $402c39c7523f0dd1$var$AIEventErrorViewed;

});

parcelRegister("1r4gF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8f369a3b340dfb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");
const $ff8f369a3b340dfb$var$AILearnMoreAnchor = ({ children: children, ...props })=>(0, $VSDnB.fg)('platform-linking-fix-a11y-in-smart-card') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
        href: (0, $8dVIb.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: (0, $8dVIb.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $ff8f369a3b340dfb$export$2e2bcd8739ae039 = $ff8f369a3b340dfb$var$AILearnMoreAnchor;

});



parcelRegister("jdA9V", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $2e1357a85e616794$export$cfa1d3eed9a61059);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $3Fq5M = parcelRequire("3Fq5M");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
function $2e1357a85e616794$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $5uXOq.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $7zaVw.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_summary_action_description),
        ...props
    });
}

});
parcelRegister("3Fq5M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746afd86dff7a846534476462b8fe4e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));

var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
function $2ab970d264bef26f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ab970d264bef26f$var$CopyIcon = (props)=>/*#__PURE__*/ $2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
    }, props));
$2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;

});
parcelRegister("8w53e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $63353af41c1756be$var$_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $63353af41c1756be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63353af41c1756be$var$CopyIcon = (props)=>/*#__PURE__*/ $63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;

});

parcelRegister("eE13R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aa959fe1f5a86e24$var$CopyIcon = (props)=>/*#__PURE__*/ $aa959fe1f5a86e24$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $aa959fe1f5a86e24$var$_copy.default
    }));
$aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;

});





parcelRegister("5OUwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd2a7343c5a2622$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $4ldhu = parcelRequire("4ldhu");

var $dS3PR = parcelRequire("dS3PR");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $e5vwM = parcelRequire("e5vwM");

var $3Lbo8 = parcelRequire("3Lbo8");

const $9fd2a7343c5a2622$var$AutomationModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("9O9YP")));
const $9fd2a7343c5a2622$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $8dVIb.ActionName).AutomationAction];
    const automationActionOnClick = (0, $5uXOq.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $3Lbo8.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($9fd2a7343c5a2622$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $7zaVw.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $e5vwM.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $9fd2a7343c5a2622$export$2e2bcd8739ae039 = $9fd2a7343c5a2622$var$AutomationAction;

});
parcelRegister("4ldhu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32936cf628dec798$var$_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $32936cf628dec798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32936cf628dec798$var$AutomationIcon = (props)=>/*#__PURE__*/ $32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;

});

parcelRegister("7HAq8", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $bc735e1cde43eb76$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $lnPiq = parcelRequire("lnPiq");
const $bc735e1cde43eb76$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $bc735e1cde43eb76$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($bc735e1cde43eb76$var$FALLBACK_API);
const $bc735e1cde43eb76$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    const api = (0, $5uXOq.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lnPiq.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $5uXOq.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $5uXOq.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8 = ()=>(0, $5uXOq.useContext)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c);

});
parcelRegister("lnPiq", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $a203465a8c9e0684$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $a203465a8c9e0684$var$styles = null;
const $a203465a8c9e0684$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onClick: onClick,
        className: (0, $bwpsq.default)([
            "_c71lidpf _p12fidpf _kqswstnw"
        ]),
        children: children
    });
};

});


parcelRegister("e5vwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $23884530c116b98b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $23884530c116b98b$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $23884530c116b98b$export$2e2bcd8739ae039 = $23884530c116b98b$var$AutomationManualTriggersGlyph;

});

parcelRegister("3Lbo8", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $6b74a4060fa13021$export$93e707b363eaf5c8);

var $7zaVw = parcelRequire("7zaVw");
const $6b74a4060fa13021$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $7zaVw.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $7zaVw.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("9O9YP", function(module, exports) {

let $72408668de532ebc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $72408668de532ebc$var$load("kNFvF"),
    $72408668de532ebc$var$load("ffQaD"),
    $72408668de532ebc$var$load("kvRbA"),
    $72408668de532ebc$var$load("47Kh6")
]).then(()=>parcelRequire('1Rjyb'));

});


parcelRegister("faTeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b95acafe5e8a7ba5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $k98Kd = parcelRequire("k98Kd");

const $b95acafe5e8a7ba5$var$RelatedLinksModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("3ivMk")));
const $b95acafe5e8a7ba5$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($b95acafe5e8a7ba5$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? (0, $7zaVw.messages).related_links_view_related_links : (0, $7zaVw.messages).related_links_view_related_urls
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k98Kd.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $b95acafe5e8a7ba5$export$2e2bcd8739ae039 = $b95acafe5e8a7ba5$var$ViewRelatedLinksAction;

});
parcelRegister("k98Kd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9aac1bc71ae3e1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hyKRO = parcelRequire("hyKRO");

var $ehOs2 = parcelRequire("ehOs2");

var $VSDnB = parcelRequire("VSDnB");
const $7c9aac1bc71ae3e1$var$rotateSvg = null;
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon = ()=>(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_t9ec1sub _1e0c1o8l"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ehOs2))), {
            color: "currentColor",
            spacing: "spacious",
            label: "View recent links..."
        })
    });
var $7c9aac1bc71ae3e1$export$2e2bcd8739ae039 = $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon;

});
parcelRegister("ehOs2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89cbd658a789691c2dfd917ec82d5504>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a669c9c7dda1a2bd$var$_react = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a669c9c7dda1a2bd$var$_childIssues = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("a5U1O")));

var $a669c9c7dda1a2bd$var$_childIssues2 = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("hxodJ")));
function $a669c9c7dda1a2bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChildIssuesIcon.
 * This component is ChildIssuesIcon, with `UNSAFE_fallbackIcon` set to "ChildIssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for child work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a669c9c7dda1a2bd$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $a669c9c7dda1a2bd$var$_react.default.createElement($a669c9c7dda1a2bd$var$_childIssues.default, Object.assign({
        LEGACY_fallbackIcon: $a669c9c7dda1a2bd$var$_childIssues2.default
    }, props));
$a669c9c7dda1a2bd$var$ChildIssuesIcon.Name = 'ChildIssuesIconMigration';
var $a669c9c7dda1a2bd$var$_default = module.exports.default = $a669c9c7dda1a2bd$var$ChildIssuesIcon;

});
parcelRegister("a5U1O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a33c20b0e9684239e470bd9fc395b3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7595d510a7cf11ee$var$_react = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7595d510a7cf11ee$var$_baseNew = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7595d510a7cf11ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for child work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7595d510a7cf11ee$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $7595d510a7cf11ee$var$_react.default.createElement($7595d510a7cf11ee$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 4.5V1H1v10a2 2 0 0 0 2 2h4v.75c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-5.5c-.69 0-1.25.56-1.25 1.25v.75H3a.5.5 0 0 1-.5-.5V6H7v.75C7 7.44 7.56 8 8.25 8h5.5C14.44 8 15 7.44 15 6.75v-3c0-.69-.56-1.25-1.25-1.25h-5.5C7.56 2.5 7 3.06 7 3.75v.75zm6-.5v2.5h5V4zm0 7v2.5h5V11z" clip-rule="evenodd"/>`
    }, props));
$7595d510a7cf11ee$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $7595d510a7cf11ee$var$_default = module.exports.default = $7595d510a7cf11ee$var$ChildIssuesIcon;

});

parcelRegister("hxodJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc484e6d94653edf$var$_react = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cc484e6d94653edf$var$_childIssues = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("a5U1O")));
function $cc484e6d94653edf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cc484e6d94653edf$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $cc484e6d94653edf$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $cc484e6d94653edf$var$_childIssues.default
    }));
$cc484e6d94653edf$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $cc484e6d94653edf$var$_default = module.exports.default = $cc484e6d94653edf$var$ChildIssuesIcon;

});



parcelRegister("3ivMk", function(module, exports) {

let $266bb40faa8f7fb6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $266bb40faa8f7fb6$var$load("hHAog").then(()=>parcelRequire('14MtF'));

});



parcelRegister("s2ak7", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $e384e6334b5a98a7$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $059q9 = parcelRequire("059q9");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $aBTst = parcelRequire("aBTst");
const $e384e6334b5a98a7$var$containerStyles = null;
const $e384e6334b5a98a7$var$errorStyles = null;
const $e384e6334b5a98a7$var$styles = {
    containerStyles: "_kkk2n7od _2rkoglpi _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syaz1gjq"
};
const $e384e6334b5a98a7$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`
            });
        default:
            return null;
    }
};
const $e384e6334b5a98a7$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $e384e6334b5a98a7$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $e384e6334b5a98a7$var$styles.errorContentStyles,
                children: [
                    message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $e384e6334b5a98a7$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testId": `${testId}-footer`,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _2rkoglpi _1yt412x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _vwz4gktf _1bsb1osq _fiawglyw",
            message.appearance === 'error' && "_bfhk1gly"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $e384e6334b5a98a7$var$styles.errorContentStyles,
                children: [
                    message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $e384e6334b5a98a7$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});
parcelRegister("059q9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98606756a92a07f2e7585c76d3cbd084>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));

var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>/*#__PURE__*/ $00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
    }, props));
$00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;

});
parcelRegister("hAZqC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d97879d6b889ef4621929c7dd705b0ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ccf572dfbabebdf7$var$_react = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ccf572dfbabebdf7$var$_baseNew = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ccf572dfbabebdf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ccf572dfbabebdf7$var$ErrorIcon = (props)=>/*#__PURE__*/ $ccf572dfbabebdf7$var$_react.default.createElement($ccf572dfbabebdf7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$ccf572dfbabebdf7$var$ErrorIcon.displayName = 'ErrorIcon';
var $ccf572dfbabebdf7$var$_default = module.exports.default = $ccf572dfbabebdf7$var$ErrorIcon;

});







parcelRegister("3Zm9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $70338cdeec0a99e7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jRHKj = parcelRequire("jRHKj");
const $70338cdeec0a99e7$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $jRHKj ? $jRHKj[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $70338cdeec0a99e7$export$2e2bcd8739ae039 = $70338cdeec0a99e7$var$ActionGroupItem;

});


parcelRegister("fkxMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcbea6814ca213c7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $erAKX = parcelRequire("erAKX");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $dcbea6814ca213c7$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const hasAction = onClick !== undefined;
    const context = (0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? (0, $Nh1XU.useFlexibleUiContext)() : {};
    const showRetry = (0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? !hideRetry && Boolean(context?.actions?.[(0, $8dVIb.InternalActionName).UnresolvedAction]) : false;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {
                overrideIcon: icon,
                position: position
            }),
            title,
            showRetry && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $erAKX.default), {
                    testId: testId
                })
            }),
            !(0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') && descriptor && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    onClick: onClick,
                    testId: `${testId}-errored-view-message`,
                    tabIndex: hasAction ? 0 : -1,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...descriptor,
                        values: values
                    })
                })
            }),
            actionGroup
        ]
    });
};
var $dcbea6814ca213c7$export$2e2bcd8739ae039 = $dcbea6814ca213c7$var$TitleBlockErroredView;

});

parcelRegister("bXy5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2967317da51f9f7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $e2967317da51f9f7$var$style = null;
const $e2967317da51f9f7$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $e2967317da51f9f7$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $akF1x.renderElementItems)(metadata);
    const subtitleElements = (0, $akF1x.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {
                overrideIcon: icon,
                position: position,
                size: size
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Vertical,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $bwpsq.default)([
                    "_zulp1b66"
                ]),
                children: [
                    CompetitorPrompt && url && (0, $VSDnB.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                        xcss: $e2967317da51f9f7$var$styles.titleBox,
                        children: [
                            title,
                            /*#__PURE__*/ (0, $2OMIu.jsx)(CompetitorPrompt, {
                                sourceUrl: url,
                                linkType: 'card'
                            })
                        ]
                    }) : title,
                    subtitleElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $8dVIb.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $e2967317da51f9f7$export$2e2bcd8739ae039 = $e2967317da51f9f7$var$TitleBlockResolvedView;

});

parcelRegister("jHa2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $045d1b1e49cae759$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $gU02S = parcelRequire("gU02S");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $045d1b1e49cae759$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $fpDmE.getIconWidth)(size);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                style: {
                    width: iconWidth,
                    height: iconWidth
                },
                "data-testid": `${testId}-icon`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
                    width: iconWidth,
                    height: iconWidth,
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $045d1b1e49cae759$export$2e2bcd8739ae039 = $045d1b1e49cae759$var$TitleBlockResolvingView;

});


parcelRegister("0Tx5e", function(module, exports) {

$parcel$export(module.exports, "CardSSR", () => $e2bd3eca15e522b1$export$7b5e1b7f9a325b6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $daJ0i = parcelRequire("daJ0i");

var $fzJZi = parcelRequire("fzJZi");

var $hBQOn = parcelRequire("hBQOn");

var $i41Ob = parcelRequire("i41Ob");
const $e2bd3eca15e522b1$export$7b5e1b7f9a325b6 = (props)=>{
    const [id] = (0, $5uXOq.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
    const cardProps = {
        ...props,
        id: id
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: (0, $fzJZi.context),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
            FallbackComponent: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $i41Ob.LoadingCardLink), {
                    ...cardProps
                }),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hBQOn.CardWithUrlContent), {
                ...cardProps
            })
        })
    });
};

});
parcelRegister("hBQOn", function(module, exports) {

$parcel$export(module.exports, "CardWithUrlContent", () => $ad2753aa52acbfd4$export$7598f5d7c597dd32);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $lGoTE = parcelRequire("lGoTE");

var $1VPdD = parcelRequire("1VPdD");

var $fgpl1 = parcelRequire("fgpl1");

var $7HAq8 = parcelRequire("7HAq8");

var $kxcRq = parcelRequire("kxcRq");

var $jCOVt = parcelRequire("jCOVt");

var $g2eZ6 = parcelRequire("g2eZ6");

var $5igsJ = parcelRequire("5igsJ");

var $91tw3 = parcelRequire("91tw3");

var $5vDFA = parcelRequire("5vDFA");

var $8Buf6 = parcelRequire("8Buf6");

var $7RcXv = parcelRequire("7RcXv");

var $9fYWd = parcelRequire("9fYWd");

var $7oGL1 = parcelRequire("7oGL1");
function $ad2753aa52acbfd4$var$Component({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    // Get state, actions for this card.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isGlancePanelAvailable: isGlancePanelAvailable, openGlancePanel: openGlancePanel } = (0, $lGoTE.useSmartLink)(id, url);
    const ari = (0, $VSDnB.fg)('fun-1765_wire_up_glance_panel_to_smart_cards') ? (0, $fgpl1.getObjectAri)(state.details) : undefined;
    const definitionId = (0, $fgpl1.getDefinitionId)(state.details);
    const extensionKey = (0, $fgpl1.getExtensionKey)(state.details);
    const resourceType = (0, $fgpl1.getResourceType)(state.details);
    const services = (0, $fgpl1.getServices)(state.details);
    let isFlexibleUi = (0, $5uXOq.useMemo)(()=>(0, $91tw3.isFlexibleUiCard)(children, (0, $VSDnB.fg)('platform-linking-flexible-card-openness') ? ui : undefined), [
        children,
        ui
    ]);
    const actionOptions = (0, $jCOVt.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    // Setup UI handlers.
    const handleClickWrapper = (0, $5uXOq.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $kxcRq.isSpecialEvent)(event);
        // Ctrl+left click on mac typically doesn't trigger onClick
        // The event could have potentially had `e.preventDefault()` called on it by now
        // event by smart card internally
        // If it has been called then only then can `isModifierKeyPressed` be true.
        const target = isModifierKeyPressed ? '_blank' : '_self';
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $8dVIb.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        // If glance panel is available and the user clicked on the link,
        // delegate the click to the glance panel handler
        if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
        (0, $VSDnB.fg)('fun-1765_wire_up_glance_panel_to_smart_cards') && target !== '_blank' && ari && isGlancePanelAvailable?.({
            ari: ari
        }) && openGlancePanel) {
            openGlancePanel({
                url: url,
                ari: ari,
                name: (0, $fgpl1.getObjectName)(state.details),
                iconUrl: (0, $fgpl1.getObjectIconUrl)(state.details)
            });
            (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: 'glancePanel'
                }
            });
        } else if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $fgpl1.getClickUrl)(url, state.details);
            window.open(clickUrl, target);
            (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        onClick,
        url,
        state.details,
        ari,
        isGlancePanelAvailable,
        openGlancePanel,
        createAnalyticsEvent
    ]);
    const handleAuthorize = (0, $5uXOq.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $5uXOq.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $5uXOq.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $5uXOq.useEffect)(()=>{
        $5vDFA.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $5vDFA.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $5vDFA.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $fgpl1.isFinalState)(state.status)) {
            (0, $1VPdD.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $1VPdD.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        state.status
    ]);
    const onIframeDwell = (0, $5uXOq.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9fYWd.default), {
            id: id,
            cardState: cardState,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError,
            children: children
        });
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7oGL1.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            });
        case 'block':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Buf6.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt
            });
        case 'embed':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7RcXv.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus
            });
    }
}
const $ad2753aa52acbfd4$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $91tw3.isFlexibleUiCard)(props.children, (0, $VSDnB.fg)('platform-linking-flexible-card-openness') ? props?.ui : undefined) ? (0, $8dVIb.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7HAq8.SmartLinkModalProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5igsJ.SmartLinkAnalyticsContext), {
            url: props.url,
            id: props.id,
            display: display,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($ad2753aa52acbfd4$var$Component, {
                ...props
            })
        })
    });
};

});
parcelRegister("lGoTE", function(module, exports) {

$parcel$export(module.exports, "useSmartLink", () => $7e143fdfadf9b6c5$export$9f4e486b1dc3e700);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");

var $3CATS = parcelRequire("3CATS");

var $eYswX = parcelRequire("eYswX");

var $khbkQ = parcelRequire("khbkQ");

var $hjhAz = parcelRequire("hjhAz");
function $7e143fdfadf9b6c5$export$9f4e486b1dc3e700(id, url) {
    const state = (0, $hjhAz.useSmartCardState)(url);
    const { store: store, isGlancePanelAvailable: isGlancePanelAvailable, openGlancePanel: openGlancePanel } = (0, $051X7.useSmartLinkContext)();
    const actions = (0, $3CATS.useSmartCardActions)(id, url);
    const config = (0, $eYswX.useSmartLinkConfig)();
    const renderers = (0, $khbkQ.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $5uXOq.useState)(null);
    // Register the current card.
    const register = ()=>{
        actions.register().catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isGlancePanelAvailable: isGlancePanelAvailable,
        openGlancePanel: openGlancePanel
    };
}

});
parcelRegister("3CATS", function(module, exports) {

$parcel$export(module.exports, "useSmartCardActions", () => $36916caf65c178ae$export$f7c340395f31e832);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");

var $2yPrN = parcelRequire("2yPrN");

var $fmdet = parcelRequire("fmdet");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $fgpl1 = parcelRequire("fgpl1");

var $iPVbQ = parcelRequire("iPVbQ");

var $f22ja = parcelRequire("f22ja");
const $36916caf65c178ae$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $f22ja.default)();
    const invokeClientAction = (0, $iPVbQ.default)({});
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $5uXOq.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $8dVIb.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $5uXOq.useCallback)((metadataStatus)=>{
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $5uXOq.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $5uXOq.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $5uXOq.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $fgpl1.getDefinitionId)(details);
        if (definitionId) (0, $fgpl1.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $5uXOq.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $5uXOq.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $fgpl1.getDefinitionId)(details);
        const extensionKey = (0, $fgpl1.getExtensionKey)(details);
        const services = (0, $fgpl1.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $fmdet.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $1VPdD.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $1VPdD.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $5uXOq.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("fmdet", function(module, exports) {

$parcel$export(module.exports, "auth", () => $5f3c60ac520535bf$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("fHui9")).AuthError);

var $fHui9 = parcelRequire("fHui9");

var $2sGCH = parcelRequire("2sGCH");
function $5f3c60ac520535bf$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $2sGCH.isOfTypeAuthError)(errorType)) reject(new (0, $fHui9.AuthError)(data.message, errorType));
                    else reject(new (0, $fHui9.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $fHui9.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("fHui9", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $39436ca0ebc2906b$export$145273558d58e0ac);
class $39436ca0ebc2906b$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("2sGCH", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", () => $4689bea2fc57183c$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $4689bea2fc57183c$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("fgpl1", function(module, exports) {

$parcel$export(module.exports, "getByDefinitionId", () => $8cbc55b0be5f7abb$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $8cbc55b0be5f7abb$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $8cbc55b0be5f7abb$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $8cbc55b0be5f7abb$export$218d96312e385949);
$parcel$export(module.exports, "getObjectAri", () => $8cbc55b0be5f7abb$export$81164c1570bcd038);
$parcel$export(module.exports, "getObjectName", () => $8cbc55b0be5f7abb$export$5615361d76a8be5);
$parcel$export(module.exports, "getObjectIconUrl", () => $8cbc55b0be5f7abb$export$bcf275804417edda);
$parcel$export(module.exports, "getResourceType", () => $8cbc55b0be5f7abb$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $8cbc55b0be5f7abb$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $8cbc55b0be5f7abb$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $8cbc55b0be5f7abb$export$3f9446bb21b945a0);

var $iCv9y = parcelRequire("iCv9y");
const $8cbc55b0be5f7abb$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $8cbc55b0be5f7abb$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $iCv9y.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $8cbc55b0be5f7abb$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $8cbc55b0be5f7abb$export$218d96312e385949 = (details)=>details?.meta?.key;
const $8cbc55b0be5f7abb$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $8cbc55b0be5f7abb$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $8cbc55b0be5f7abb$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $8cbc55b0be5f7abb$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $8cbc55b0be5f7abb$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $8cbc55b0be5f7abb$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $8cbc55b0be5f7abb$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $8cbc55b0be5f7abb$export$ac5d414b1ebfab5a = (details)=>details && $8cbc55b0be5f7abb$export$cd41ae544cfc2a65(details) && $8cbc55b0be5f7abb$export$795910f5f15a9633(details);
const $8cbc55b0be5f7abb$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $8cbc55b0be5f7abb$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $8cbc55b0be5f7abb$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $8cbc55b0be5f7abb$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $8cbc55b0be5f7abb$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $8cbc55b0be5f7abb$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $8cbc55b0be5f7abb$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $8cbc55b0be5f7abb$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;

});
parcelRegister("iCv9y", function(module, exports) {

$parcel$export(module.exports, "extractVisitUrl", () => $28ad1893a5a5e6d3$export$c81497d3681f24f4);
const $28ad1893a5a5e6d3$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});



parcelRegister("eYswX", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkConfig", () => $2387d938a9c268b4$export$5d10838c1e539409);

var $051X7 = parcelRequire("051X7");
const $2387d938a9c268b4$export$5d10838c1e539409 = ()=>{
    const context = (0, $051X7.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});


parcelRegister("jCOVt", function(module, exports) {

$parcel$export(module.exports, "combineActionOptions", () => $aaa9fcf770cffa90$export$2ae4cf79c720146a);
const $aaa9fcf770cffa90$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};

});

parcelRegister("5igsJ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$eaff10f7ec59c455);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $ffYTp = parcelRequire("ffYTp");

var $051X7 = parcelRequire("051X7");

var $cCcdH = parcelRequire("cCcdH");

var $VSDnB = parcelRequire("VSDnB");

var $hjhAz = parcelRequire("hjhAz");

var $fzJZi = parcelRequire("fzJZi");
const $31931ec4ffeaf53a$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $ffYTp.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $31931ec4ffeaf53a$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $fzJZi.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $31931ec4ffeaf53a$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const state = store ? (0, $cCcdH.getUrl)(store, url) : undefined;
    return (0, $5uXOq.useMemo)(()=>{
        return $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $31931ec4ffeaf53a$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $hjhAz.useSmartCardState)(url);
    const data = $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $VSDnB.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("ffYTp", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $842bbc6d3f3b5d59$export$7243431f5325a7b);

var $fiKQs = parcelRequire("fiKQs");

var $iHcpV = parcelRequire("iHcpV");

var $VSDnB = parcelRequire("VSDnB");
const $842bbc6d3f3b5d59$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $fiKQs.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $iHcpV.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $VSDnB.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("iHcpV", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $1a9daeca9ad503b7$export$28ddbae335bd80b5);
const $1a9daeca9ad503b7$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});



parcelRegister("8Buf6", function(module, exports) {

$parcel$export(module.exports, "BlockCard", () => $4d626c57887b3576$export$d18ccd25c0d2c6b0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $6TU5j = parcelRequire("6TU5j");

var $7xFN9 = parcelRequire("7xFN9");

var $gfnFT = parcelRequire("gfnFT");

var $bMldO = parcelRequire("bMldO");

var $1ENCM = parcelRequire("1ENCM");

var $kQeqP = parcelRequire("kQeqP");

var $7wrOH = parcelRequire("7wrOH");

var $kc7yu = parcelRequire("kc7yu");

var $1PV7p = parcelRequire("1PV7p");
const $4d626c57887b3576$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $gfnFT.handleClickCommon)(event, handleFrameClick),
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $6TU5j.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc7yu.default), {
                ...blockCardProps,
                testId: "smart-block-resolving-view"
            });
        case 'resolved':
            if ((0, $VSDnB.fg)('platform_smart_links_controlled_dsp_export_view')) {
                if ((0, $7xFN9.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PV7p.default), {
                    ...blockCardProps,
                    onAuthorize: handleAuthorize
                });
            }
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc7yu.default), {
                ...blockCardProps
            });
        case 'unauthorized':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PV7p.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQeqP.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7wrOH.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMldO.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1ENCM.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

});
parcelRegister("6TU5j", function(module, exports) {

$parcel$export(module.exports, "useControlDataExportConfig", () => $f8634558e6ab3b89$export$f93c47f1b2b3f55b);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $f8634558e6ab3b89$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $051X7.useSmartLinkContext)();
    return (0, $5uXOq.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};

});

parcelRegister("7xFN9", function(module, exports) {

$parcel$export(module.exports, "getIsDataExportEnabled", () => $6c86d4fba49dfc79$export$a019611f39785186);
const $6c86d4fba49dfc79$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));

});

parcelRegister("gfnFT", function(module, exports) {

$parcel$export(module.exports, "handleClickCommon", () => $616acbd6c6da9a6a$export$9759a67e215c4598);
const $616acbd6c6da9a6a$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});

parcelRegister("bMldO", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $d0b446175f31475d$export$ce508304ed2dd145);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kkxZO = parcelRequire("kkxZO");
class $d0b446175f31475d$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkxZO.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("kkxZO", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $2ed7f4f9fecd197d$export$b89a827e9254211a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4URMI = parcelRequire("4URMI");

var $8RHvB = parcelRequire("8RHvB");
const $2ed7f4f9fecd197d$export$b89a827e9254211a = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $4URMI.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $8RHvB.WrapperAnchor) : (0, $8RHvB.WrapperSpan);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        children: children
    });
});

});
parcelRegister("8RHvB", function(module, exports) {

$parcel$export(module.exports, "WrapperSpan", () => $7f29852863f1f016$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $7f29852863f1f016$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $7f29852863f1f016$var$lineHeight = 22;
const $7f29852863f1f016$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $7f29852863f1f016$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ]),
        children: props.children
    });
});
const $7f29852863f1f016$var$baseWrapperStylesNew = null;
const $7f29852863f1f016$var$baseWrapperStylesOld = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $7f29852863f1f016$var$interactiveStyles = null;
const $7f29852863f1f016$var$hoveredStyles = null;
const $7f29852863f1f016$var$hoveredWithBackgroundStyles = null;
const $7f29852863f1f016$var$withoutBackgroundStyles = null;
const $7f29852863f1f016$var$withBackgroundStyles = null;
const $7f29852863f1f016$var$truncateStylesNew = null;
const $7f29852863f1f016$var$truncateStylesOld = null;
const $7f29852863f1f016$var$notSelectedStyle = null;
const $7f29852863f1f016$var$selectedStyles = null;

});



parcelRegister("1ENCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e31a40ad40a157$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bU3PY = parcelRequire("bU3PY");

var $7zaVw = parcelRequire("7zaVw");

var $eL5Me = parcelRequire("eL5Me");

var $bd45l = parcelRequire("bd45l");

var $3Mvli = parcelRequire("3Mvli");

var $1dEUF = parcelRequire("1dEUF");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $c5e31a40ad40a157$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $5uXOq.useMemo)(()=>props.onAuthorize ? [
            (0, $bd45l.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Mvli.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
                label: "errored-warning-icon",
                color: "var(--ds-icon-warning, #E56910)",
                LEGACY_size: "small",
                testId: `${testId}-warning-icon`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eL5Me.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $7zaVw.messages).could_not_load_link
                }
            })
        ]
    });
};
var $c5e31a40ad40a157$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($c5e31a40ad40a157$var$ErroredView);

});
parcelRegister("bd45l", function(module, exports) {

$parcel$export(module.exports, "RetryAction", () => $93e1b738cef17b2e$export$c527d977b53f7537);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $93e1b738cef17b2e$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $8dVIb.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).try_again
        }),
        testId: 'smart-action-try-again'
    });

});

parcelRegister("3Mvli", function(module, exports) {

$parcel$export(module.exports, "default", () => $d25c51e88598659e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b6uPu = parcelRequire("b6uPu");

var $VSDnB = parcelRequire("VSDnB");

var $9fYWd = parcelRequire("9fYWd");

var $dghu0 = parcelRequire("dghu0");
var $5HrTg = parcelRequire("5HrTg");
var $hYQw7 = parcelRequire("hYQw7");
var $buvhv = parcelRequire("buvhv");

var $82kHN = parcelRequire("82kHN");
const $d25c51e88598659e$var$customBlockStylesOld = null;
const $d25c51e88598659e$var$customBlockStyles = null;
const $d25c51e88598659e$var$titleBlockCssOld = null;
const $d25c51e88598659e$var$titleBlockCss = null;
const $d25c51e88598659e$var$footerBlockCssOld = null;
const $d25c51e88598659e$var$footerBlockCss = null;
const $d25c51e88598659e$var$footerBlockSafariStyles = null;
const $d25c51e88598659e$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url })=>{
    const { safari: safari = false } = (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>(0, $b6uPu.browser)(), []) : {};
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $82kHN.FlexibleCardUiOptions) : (0, $82kHN.FlexibleCardUiOptionsOld),
        url: url,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $buvhv.default), {
                ...(0, $82kHN.titleBlockOptions),
                hideIcon: !!title,
                text: title,
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: cardState.status
                },
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _13mh1pd9 _2yhz14q2" : "_zulp1f3t _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: cardState.status
                },
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc01fxt" : "_4cvr1y6m"
                ]),
                children: children
            }),
            showPreview && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
                ...(0, $82kHN.PreviewBlockOptions),
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: cardState.status
                }
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HrTg.default), {
                actions: actions,
                testId: "smart-block-card-footer",
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: cardState.status
                },
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb" : "_4t3i1k8s _g0eioxwj _1qryoxwj _sxbroxwj _1gyioxwj",
                    safari && (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $d25c51e88598659e$export$2e2bcd8739ae039 = $d25c51e88598659e$var$UnresolvedView;

});
parcelRegister("9fYWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $063c59fdd9d80513$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $anB5s = parcelRequire("anB5s");

var $f22ja = parcelRequire("f22ja");

var $lJP2b = parcelRequire("lJP2b");

var $1Vuck = parcelRequire("1Vuck");
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $063c59fdd9d80513$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $anB5s.useAISummaryConfig)();
    const resolve = (0, $f22ja.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const context = (0, $5uXOq.useMemo)(()=>(0, $1Vuck.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: status,
            url: url
        }), [
        aiSummaryConfig,
        appearance,
        fireEvent,
        details,
        id,
        onAuthorize,
        onClick,
        origin,
        renderers,
        resolve,
        actionOptions,
        status,
        url
    ]);
    const flexibleCardContext = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $5uXOq.useMemo)(()=>({
            data: context,
            status: status,
            ui: ui
        }), [
        context,
        status,
        ui
    ]) : undefined;
    const retry = (0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? undefined : (0, $1Vuck.getRetryOptions)(url, status, details, onAuthorize);
    const { linkTitle: linkTitle, title: titleOld } = context || {};
    const title = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? linkTitle?.text : titleOld;
    (0, $5uXOq.useEffect)(()=>{
        switch(status){
            case (0, $8dVIb.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url
                });
                break;
            case (0, $8dVIb.SmartLinkStatus).Errored:
            case (0, $8dVIb.SmartLinkStatus).Fallback:
            case (0, $8dVIb.SmartLinkStatus).Forbidden:
            case (0, $8dVIb.SmartLinkStatus).NotFound:
            case (0, $8dVIb.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url
    ]);
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-context')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Nh1XU.FlexibleCardContext).Provider, {
        value: flexibleCardContext,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJP2b.default), {
            testId: testId,
            ...ui,
            onClick: onClick,
            retry: retry,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            status: status,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Nh1XU.FlexibleUiOptionContext).Provider, {
        value: ui,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Nh1XU.FlexibleUiContext).Provider, {
            value: context,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJP2b.default), {
                testId: testId,
                ...ui,
                onClick: onClick,
                retry: retry,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                status: status,
                children: children
            })
        })
    });
};
var $063c59fdd9d80513$export$2e2bcd8739ae039 = $063c59fdd9d80513$var$FlexibleCard;

});
parcelRegister("lJP2b", function(module, exports) {

$parcel$export(module.exports, "default", () => $399db9c8fe523a70$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $7ZRiH = parcelRequire("7ZRiH");

var $91tw3 = parcelRequire("91tw3");

var $buvhv = parcelRequire("buvhv");

var $jwrXN = parcelRequire("jwrXN");

var $4mRkk = parcelRequire("4mRkk");
const $399db9c8fe523a70$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $7ZRiH.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
            if ((0, $91tw3.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $8dVIb.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $8dVIb.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $399db9c8fe523a70$var$filterChildren = (children, removeBlockRestriction)=>{
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-openness')) {
        if (removeBlockRestriction) return children;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) && (0, $91tw3.isFlexibleUiBlock)(child) ? child : undefined);
};
const $399db9c8fe523a70$var$renderChildren = (children, containerSize, containerTheme, status, retry, onClick, removeBlockRestriction)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) && (0, $91tw3.isFlexibleUiBlock)(child)) {
            if ((0, $91tw3.isFlexibleUiTitleBlock)(child)) {
                if ((0, $91tw3.isStyleCacheProvider)(child)) return $399db9c8fe523a70$var$updateChildrenTitleBlock(child, {
                    onClick: onClick,
                    retry: retry,
                    containerSize: containerSize,
                    status: status,
                    theme: containerTheme
                });
                else {
                    const { size: blockSize } = child.props;
                    const size = blockSize || containerSize;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                        onClick: // @ts-expect-error
                        onClick,
                        size: size,
                        status: status,
                        theme: containerTheme,
                        ...(0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? undefined : {
                            retry: retry
                        }
                    });
                }
            }
            const { size: blockSize } = child.props;
            const size = blockSize || containerSize;
            if ((0, $91tw3.isStyleCacheProvider)(child)) return $399db9c8fe523a70$var$updateChildrenBlock(child, size, status);
            // @ts-expect-error
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                size: size,
                status: status
            });
        }
        if ((0, $VSDnB.fg)('platform-linking-flexible-card-openness')) {
            if (removeBlockRestriction) return child;
        }
    });
};
const $399db9c8fe523a70$var$updateChildrenBlock = (node, size, status)=>{
    const updatedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) && (0, $91tw3.isFlexibleUiBlock)(child)) // @ts-expect-error
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            size: size,
            status: status
        });
        return child;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
        children: updatedChildren
    });
};
const $399db9c8fe523a70$var$updateChildrenTitleBlock = (node, { containerSize: containerSize, ...props })=>{
    const updatedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) && (0, $91tw3.isFlexibleUiTitleBlock)(child)) {
            const { size: blockSize } = child.props;
            const size = blockSize || containerSize;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                ...props,
                size: size
            });
        } else return child;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
        children: updatedChildren
    });
};
const $399db9c8fe523a70$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return undefined;
    if (node.type === (0, $buvhv.default)) return node;
    if ((0, $91tw3.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $399db9c8fe523a70$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $399db9c8fe523a70$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>$399db9c8fe523a70$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(block)) return block.props;
};
const $399db9c8fe523a70$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { title: title, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $399db9c8fe523a70$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4mRkk.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || title,
        url: url
    });
};
const $399db9c8fe523a70$var$baseStyleCommon = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$backgroundStyleOld = null;
const $399db9c8fe523a70$var$backgroundStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$elevationStylesOld = null;
const $399db9c8fe523a70$var$elevationStyles = null;
const $399db9c8fe523a70$var$clickableContainerStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$gapStyleMapOld = {
    xlarge: "_zulp1jvo",
    large: "_zulph3jc",
    medium: "_zulp1qos",
    small: "_zulpfzsm"
};
const $399db9c8fe523a70$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $399db9c8fe523a70$var$getPadding = (size)=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.25rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return '1rem';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '.5rem';
    }
};
const $399db9c8fe523a70$var$getGap = (size)=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return '1.25rem';
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return '.5rem';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '.25rem';
    }
};
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$previewOnLeftStyleMapOld = {
    xlarge: "_19bv15sf _y5vk1k92",
    large: "_19bvf557 _y5vk1j6v",
    medium: "_19bvqox2 _y5vk1kwk",
    small: "_19bv1ltm _y5vk6mu8"
};
const $399db9c8fe523a70$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$previewOnRightStyleMapOld = {
    xlarge: "_u5f315sf _1yob1k92",
    large: "_u5f3f557 _1yob1j6v",
    medium: "_u5f3qox2 _1yob1kwk",
    small: "_u5f31ltm _1yob6mu8"
};
const $399db9c8fe523a70$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $399db9c8fe523a70$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $8dVIb.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container', theme: theme = (0, $8dVIb.SmartLinkTheme).Link })=>{
    (0, $gKZoD.di)((0, $jwrXN.default));
    const padding = hidePadding ? (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? '0px' : '0rem' : $399db9c8fe523a70$var$getPadding(size);
    const gap = $399db9c8fe523a70$var$getGap(size);
    const context = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $Nh1XU.useFlexibleUiContext)() : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $399db9c8fe523a70$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved';
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const containerPaddingStyles = null;
    const container = (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $399db9c8fe523a70$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $399db9c8fe523a70$var$previewOnLeftStyleMap[size],
            previewOnRight && $399db9c8fe523a70$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itzgxb _2rkob7nn _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $lD23V.default)(padding),
            "--_73mooq": (0, $lD23V.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $lD23V.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $399db9c8fe523a70$var$getLayeredLink(testId, context, children, onClick) : null,
            (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? $399db9c8fe523a70$var$filterChildren(children, removeBlockRestriction) : $399db9c8fe523a70$var$renderChildren(children, size, theme, status, retry, onClick, removeBlockRestriction)
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $399db9c8fe523a70$var$gapStyleMapOld[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $399db9c8fe523a70$var$previewOnLeftStyleMapOld[size],
            previewOnRight && $399db9c8fe523a70$var$previewOnRightStyleMapOld[size],
            !hideElevation && "_19ith6cr _2rkopd34 _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $lD23V.default)(padding),
            "--_73mooq": (0, $lD23V.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $lD23V.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $399db9c8fe523a70$var$getLayeredLink(testId, context, children, onClick) : null,
            (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? $399db9c8fe523a70$var$filterChildren(children, removeBlockRestriction) : $399db9c8fe523a70$var$renderChildren(children, size, theme, status, retry, onClick, removeBlockRestriction)
        ]
    });
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jwrXN.default), {
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: container
    });
    return container;
};
var $399db9c8fe523a70$export$2e2bcd8739ae039 = $399db9c8fe523a70$var$Container;

});
parcelRegister("7ZRiH", function(module, exports) {

$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $767677c9fc81205d$export$783c1bf8fee63f80);
const $767677c9fc81205d$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("jwrXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $93868de8e0c8126a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $hHEfn = parcelRequire("hHEfn");
const $93868de8e0c8126a$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $93868de8e0c8126a$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $93868de8e0c8126a$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $5uXOq.useState)(true);
    const mouseStopTimer = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $5uXOq.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $8dVIb.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            "data-testid": `${testId}-hover-card-wrapper`,
            children: children
        })
    });
};
var $93868de8e0c8126a$export$2e2bcd8739ae039 = $93868de8e0c8126a$var$HoverCardControl;

});
parcelRegister("hHEfn", function(module, exports) {

$parcel$export(module.exports, "HoverCard", () => $2eeb1383fcc12911$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $2eeb1383fcc12911$export$f1f63acbe6ed8fb0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $gKZoD = parcelRequire("gKZoD");

var $cb25w = parcelRequire("cb25w");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $7HAq8 = parcelRequire("7HAq8");

var $5igsJ = parcelRequire("5igsJ");

var $kySOC = parcelRequire("kySOC");
const $2eeb1383fcc12911$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $gKZoD.di)((0, $kySOC.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $5igsJ.useSmartLinkAnalyticsContext)({
        display: (0, $8dVIb.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $kySOC.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $5uXOq.useCallback)((error, info)=>{
        (0, $1VPdD.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1VPdD.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1VPdD.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $8dVIb.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        fallback: children,
        onError: onError,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7HAq8.SmartLinkModalProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kySOC.HoverCardComponent), {
                ...props,
                children: children
            })
        })
    });
};
const $2eeb1383fcc12911$var$HoverCardWithoutAnalyticsContext = (0, $cb25w.default)()($2eeb1383fcc12911$var$HoverCardWithErrorBoundary);
const $2eeb1383fcc12911$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2eeb1383fcc12911$var$HoverCardWithoutAnalyticsContext, {
        ...props
    });
};
const $2eeb1383fcc12911$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($2eeb1383fcc12911$export$57a077cc9fbe653e, {
        ...props
    });

});
parcelRegister("kySOC", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $3e0a0fbe111efeba$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $3e0a0fbe111efeba$export$e2173dafa6a751bb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $3CATS = parcelRequire("3CATS");

var $khbkQ = parcelRequire("khbkQ");

var $hjhAz = parcelRequire("hjhAz");

var $5igsJ = parcelRequire("5igsJ");

var $jpjv9 = parcelRequire("jpjv9");

var $fqj3r = parcelRequire("fqj3r");

var $hZqF4 = parcelRequire("hZqF4");
const $3e0a0fbe111efeba$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $3e0a0fbe111efeba$var$FADE_IN_DELAY = 500;
const $3e0a0fbe111efeba$var$FADE_OUT_DELAY = 300;
const $3e0a0fbe111efeba$var$RESOLVE_DELAY = 100;
const $3e0a0fbe111efeba$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $hZqF4.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, label: label, titleId: titleId, showLabel: showLabel = true })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $3e0a0fbe111efeba$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    const fadeOutTimeoutId = (0, $5uXOq.useRef)();
    const fadeInTimeoutId = (0, $5uXOq.useRef)();
    const resolveTimeOutId = (0, $5uXOq.useRef)();
    const mousePos = (0, $5uXOq.useRef)();
    const popupOffset = (0, $5uXOq.useRef)();
    const parentSpan = (0, $5uXOq.useRef)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderers = (0, $khbkQ.useSmartLinkRenderers)();
    const linkState = (0, $hjhAz.useSmartCardState)(url);
    const { loadMetadata: loadMetadata } = (0, $3CATS.useSmartCardActions)(id, url);
    const setMousePosition = (0, $5uXOq.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $hZqF4.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $hZqF4.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const initHideCard = (0, $5uXOq.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $3e0a0fbe111efeba$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $5uXOq.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $3e0a0fbe111efeba$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $5uXOq.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) setIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay
    ]);
    const onActionClick = (0, $5uXOq.useCallback)((actionId)=>{
        if (actionId === (0, $8dVIb.ActionName).PreviewAction || actionId === (0, $8dVIb.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $5uXOq.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $5uXOq.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $5uXOq.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $5uXOq.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5igsJ.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $8dVIb.CardDisplay).HoverCardPreview,
            id: id,
            source: $3e0a0fbe111efeba$export$421dbc3834daf261,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqj3r.default), {
                ...hoverCardContentProps
            })
        });
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $5uXOq.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            ref: parentSpan,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                ...triggerProps,
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseOver: initShowCard,
                onMouseLeave: initHideCard,
                onMouseMove: setMousePosition,
                onClick: onChildClick,
                onContextMenu: onContextMenuClick,
                "data-testid": "hover-card-trigger-wrapper",
                ...!(0, $VSDnB.fg)('platform_bandicoots-smart-card-disable-aria') ? {
                    'aria-label': showLabel ? formatMessage((0, $7zaVw.messages).more_information_about_this_work_item) : undefined
                } : {},
                ...(0, $VSDnB.fg)('fix_a11y_violation_in_hover_card_trigger') ? {
                    role: 'button'
                } : {},
                children: children
            })
        }), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition,
        formatMessage,
        showLabel
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: (0, $jpjv9.default)
    });
};

});
parcelRegister("jpjv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f3866955ba7de81$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $0f3866955ba7de81$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...props,
        ref: ref,
        children: children
    }));
var $0f3866955ba7de81$export$2e2bcd8739ae039 = $0f3866955ba7de81$var$CustomPopupContainer;

});

parcelRegister("fqj3r", function(module, exports) {

$parcel$export(module.exports, "hoverCardClassName", () => $d84d865bf5e6c05a$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $d84d865bf5e6c05a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $051X7 = parcelRequire("051X7");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $fgpl1 = parcelRequire("fgpl1");

var $hjhAz = parcelRequire("hjhAz");

var $kxcRq = parcelRequire("kxcRq");

var $cnaAy = parcelRequire("cnaAy");

var $g2eZ6 = parcelRequire("g2eZ6");

var $hZqF4 = parcelRequire("hZqF4");

var $8RJLv = parcelRequire("8RJLv");

var $fF5L8 = parcelRequire("fF5L8");

var $KTqu4 = parcelRequire("KTqu4");

var $6klQO = parcelRequire("6klQO");

var $g3aqq = parcelRequire("g3aqq");

var $f6jZ5 = parcelRequire("f6jZ5");
const $d84d865bf5e6c05a$export$34883cbaea18402d = 'smart-links-hover-preview';
const $d84d865bf5e6c05a$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const extensionKey = (0, $5uXOq.useMemo)(()=>(0, $fgpl1.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $hjhAz.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $5uXOq.useMemo)(()=>(0, $fgpl1.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $051X7.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $cnaAy.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $fgpl1.getServices)(linkState.details);
    const statusRef = (0, $5uXOq.useRef)(linkStatus);
    const fireEventRef = (0, $5uXOq.useRef)(fireEvent);
    const definitionIdRef = (0, $5uXOq.useRef)(definitionId);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $kxcRq.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $8dVIb.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $8RJLv.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $8dVIb.SmartLinkSize).Large,
        position: (0, $8dVIb.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const uiOptions = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $hZqF4.flexibleUiOptions) : (0, $hZqF4.flexibleUiOptionsOld);
    if ((0, $VSDnB.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $8dVIb.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $5uXOq.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g3aqq.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f6jZ5.default), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $KTqu4.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6klQO.default), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fF5L8.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url,
        children: cardView
    }) : null;
};
var $d84d865bf5e6c05a$export$2e2bcd8739ae039 = $d84d865bf5e6c05a$var$HoverCardContent;

});
parcelRegister("hZqF4", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $c1c4917a58eea345$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptionsOld", () => $c1c4917a58eea345$export$c973be2d9b924c51);
$parcel$export(module.exports, "flexibleUiOptions", () => $c1c4917a58eea345$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $c1c4917a58eea345$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $c1c4917a58eea345$export$e7cae8c75d768024);

var $k5uoT = parcelRequire("k5uoT");

var $8dVIb = parcelRequire("8dVIb");
const $c1c4917a58eea345$export$8245b0eaabf3440c = (0, $k5uoT.layers).modal();
const $c1c4917a58eea345$export$c973be2d9b924c51 = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    size: (0, $8dVIb.SmartLinkSize).Medium,
    zIndex: $c1c4917a58eea345$export$8245b0eaabf3440c + 1
};
const $c1c4917a58eea345$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $8dVIb.SmartLinkSize).Medium,
    zIndex: $c1c4917a58eea345$export$8245b0eaabf3440c + 1
};
const $c1c4917a58eea345$export$a0a37c997fbcd678 = 24;
const $c1c4917a58eea345$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("8RJLv", function(module, exports) {

$parcel$export(module.exports, "getMetadata", () => $575ef03a4633fd6f$export$8548546c0aa631e6);

var $FcDCF = parcelRequire("FcDCF");

var $8dVIb = parcelRequire("8dVIb");

var $6N2TY = parcelRequire("6N2TY");
const $575ef03a4633fd6f$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $FcDCF.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $8dVIb.ElementName).AuthorGroup,
            (0, $8dVIb.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn,
                    (0, $8dVIb.ElementName).SubscriberCount,
                    (0, $8dVIb.ElementName).State
                ],
                subtitle: [
                    (0, $8dVIb.ElementName).SourceBranch,
                    (0, $8dVIb.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $8dVIb.ElementName).LatestCommit,
                    (0, $8dVIb.ElementName).CollaboratorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $6N2TY.extractOwnedBy)(data) ? (0, $8dVIb.ElementName).OwnedByGroup : (0, $8dVIb.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $8dVIb.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $8dVIb.ElementName).ReactCount,
                    (0, $8dVIb.ElementName).CommentCount,
                    (0, $8dVIb.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $8dVIb.ElementName).AssignedToGroup,
                        (0, $8dVIb.ElementName).State,
                        (0, $8dVIb.ElementName).StoryPoints,
                        (0, $8dVIb.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $8dVIb.ElementName).CollaboratorGroup,
                    (0, $8dVIb.ElementName).State,
                    (0, $8dVIb.ElementName).DueOn
                ],
                secondary: [
                    (0, $8dVIb.ElementName).ReactCount,
                    (0, $8dVIb.ElementName).CommentCount,
                    (0, $8dVIb.ElementName).AttachmentCount,
                    (0, $8dVIb.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $8dVIb.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn,
                    (0, $8dVIb.ElementName).State,
                    (0, $8dVIb.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).State,
                    (0, $8dVIb.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).SentOn
                ],
                tertiary: [
                    (0, $8dVIb.ElementName).ReactCount,
                    (0, $8dVIb.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $575ef03a4633fd6f$var$AvatarGroupsWithNamePrefix = [
    (0, $8dVIb.ElementName).AssignedToGroup,
    (0, $8dVIb.ElementName).OwnedByGroup,
    (0, $8dVIb.ElementName).AuthorGroup
];
const $575ef03a4633fd6f$var$toElementItem = (name)=>{
    const showNamePrefix = $575ef03a4633fd6f$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $575ef03a4633fd6f$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $8dVIb.ElementName)).map($575ef03a4633fd6f$var$toElementItem);
};
const $575ef03a4633fd6f$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $575ef03a4633fd6f$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $575ef03a4633fd6f$var$toElementItems(metadata.subtitle),
        primary: $575ef03a4633fd6f$var$toElementItems(primary),
        secondary: $575ef03a4633fd6f$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("6N2TY", function(module, exports) {

$parcel$export(module.exports, "extractCommentCount", () => $e8afc48bfc3821d9$export$b68822b76d5d51d5);
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $e8afc48bfc3821d9$export$4356c594f5c138d6);
$parcel$export(module.exports, "extractDueOn", () => $e8afc48bfc3821d9$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $e8afc48bfc3821d9$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractReactCount", () => $e8afc48bfc3821d9$export$44130aa92252501);
$parcel$export(module.exports, "extractVoteCount", () => $e8afc48bfc3821d9$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $e8afc48bfc3821d9$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $e8afc48bfc3821d9$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $e8afc48bfc3821d9$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractCreatedBy", () => $e8afc48bfc3821d9$export$69b10d653f96288b);
$parcel$export(module.exports, "extractModifiedBy", () => $e8afc48bfc3821d9$export$bcb193c84c865ec9);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $e8afc48bfc3821d9$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $e8afc48bfc3821d9$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $e8afc48bfc3821d9$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractAttachmentCount", () => $e8afc48bfc3821d9$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $e8afc48bfc3821d9$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $e8afc48bfc3821d9$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $e8afc48bfc3821d9$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $e8afc48bfc3821d9$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractReadTime", () => $e8afc48bfc3821d9$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSentOn", () => $e8afc48bfc3821d9$export$b592ddecae70b61d);
$parcel$export(module.exports, "extractStoryPoints", () => $e8afc48bfc3821d9$export$bdcea84d1550eb9d);
$parcel$export(module.exports, "extractMetaObjectId", () => $e8afc48bfc3821d9$export$bec1443e3e33b166);
$parcel$export(module.exports, "extractMetaResourceType", () => $e8afc48bfc3821d9$export$11d1314ebbee594e);
$parcel$export(module.exports, "extractMetaTenantId", () => $e8afc48bfc3821d9$export$92037aea7f27bf7f);

var $lnY7t = parcelRequire("lnY7t");
var $4MmCl = parcelRequire("4MmCl");
var $eV8m9 = parcelRequire("eV8m9");
var $g9Blp = parcelRequire("g9Blp");
const $e8afc48bfc3821d9$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $e8afc48bfc3821d9$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $e8afc48bfc3821d9$export$b68822b76d5d51d5 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'schema:commentCount');
const $e8afc48bfc3821d9$export$4356c594f5c138d6 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $e8afc48bfc3821d9$export$ac56bd7a37249b48 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'endTime');
const $e8afc48bfc3821d9$export$e57334ce4738e29d = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:viewCount');
const $e8afc48bfc3821d9$export$44130aa92252501 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:reactCount');
const $e8afc48bfc3821d9$export$c8bef3d5e550a3a = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:voteCount');
const $e8afc48bfc3821d9$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $eV8m9.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $e8afc48bfc3821d9$export$5546969a505305 = (data)=>{
    const person = (0, $lnY7t.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $e8afc48bfc3821d9$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $lnY7t.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $e8afc48bfc3821d9$export$69b10d653f96288b = (data)=>{
    const persons = (0, $4MmCl.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $e8afc48bfc3821d9$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $g9Blp.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $e8afc48bfc3821d9$export$43e54589935a1ff = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'schema:programmingLanguage');
const $e8afc48bfc3821d9$export$949ac6a8325b3fdb = (data)=>$e8afc48bfc3821d9$var$extractLinkName(data['atlassian:mergeSource']);
const $e8afc48bfc3821d9$export$8bd03a7beb5badf1 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:subscriberCount');
const $e8afc48bfc3821d9$export$65362ff78a97fd8 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:attachmentCount');
const $e8afc48bfc3821d9$export$29b0ac5d2f9890cf = (data)=>$e8afc48bfc3821d9$var$extractLinkName(data['atlassian:mergeDestination']);
const $e8afc48bfc3821d9$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $e8afc48bfc3821d9$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $e8afc48bfc3821d9$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $e8afc48bfc3821d9$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $e8afc48bfc3821d9$export$cc4028b2878d0675 = (data)=>{
    return $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $e8afc48bfc3821d9$export$b592ddecae70b61d = (data)=>{
    return $e8afc48bfc3821d9$var$extractValue(data, 'dateSent');
};
const $e8afc48bfc3821d9$export$bdcea84d1550eb9d = (data)=>{
    return $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:storyPoints');
};
const $e8afc48bfc3821d9$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $e8afc48bfc3821d9$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $e8afc48bfc3821d9$export$92037aea7f27bf7f = (meta)=>meta.tenantId;

});
parcelRegister("lnY7t", function(module, exports) {

$parcel$export(module.exports, "extractPersonAssignedTo", () => $0ac42ccaa7f6f983$export$38a0979ebf273662);

var $aj6Xc = parcelRequire("aj6Xc");
const $0ac42ccaa7f6f983$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $aj6Xc.extractPersonFromJsonLd)(assignedTo);
};

});

parcelRegister("eV8m9", function(module, exports) {

$parcel$export(module.exports, "extractPersonOwnedBy", () => $2d658438ec8722e8$export$19ee667f3f7a6ec3);

var $aj6Xc = parcelRequire("aj6Xc");
const $2d658438ec8722e8$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $aj6Xc.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $aj6Xc.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});



parcelRegister("fF5L8", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ba3ed6dc9291b3$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $1MeuC = parcelRequire("1MeuC");

var $67sXJ = parcelRequire("67sXJ");

var $fqj3r = parcelRequire("fqj3r");
const $35ba3ed6dc9291b3$var$NEW_CARD_WIDTH_REM = 25;
const $35ba3ed6dc9291b3$var$HoverCardContainerStyle = null;
const $35ba3ed6dc9291b3$var$popupContainerStyles = null;
const $35ba3ed6dc9291b3$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $gKZoD.di)((0, $1MeuC.default), (0, $67sXJ.default));
    const { state: { status: status } } = (0, $1MeuC.default)(url);
    const [showPrism, setShowPrism] = (0, $5uXOq.useState)(status === 'loading');
    (0, $5uXOq.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rkopd34 _bfhk1bhr _16qs1e6u",
            (0, $fqj3r.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props,
        children: children
    });
    return isAIEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $67sXJ.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`,
        children: container
    }) : container;
};
const $35ba3ed6dc9291b3$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)($35ba3ed6dc9291b3$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props,
        children: children
    });
var $35ba3ed6dc9291b3$export$2e2bcd8739ae039 = $35ba3ed6dc9291b3$var$ContentContainer;

});
parcelRegister("67sXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c1d831891587499$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hxoiH = parcelRequire("hxoiH");

var $c1bPW = parcelRequire("c1bPW");

var $DuPPR = parcelRequire("DuPPR");
const $8c1d831891587499$var$contentStyles = null;
const $8c1d831891587499$var$contentStylesPrismVisible = null;
const $8c1d831891587499$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $8c1d831891587499$var$popupContainerStyles = null;
const $8c1d831891587499$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c1bPW.default), {
        palette: (0, $DuPPR.AI_BORDER_PALETTE)[colorMode] ?? (0, $DuPPR.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $bwpsq.default)([
            $8c1d831891587499$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_2rkopd34 _bfhk1bhr _16qs1e6u",
                "_v5649spz",
                isVisible && "_16qs1sqb"
            ]),
            children: children
        })
    });
};
var $8c1d831891587499$export$2e2bcd8739ae039 = $8c1d831891587499$var$AIPrism;

});
parcelRegister("c1bPW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1652d4d52e4f5cc8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iI2az = parcelRequire("iI2az");
const $1652d4d52e4f5cc8$var$borderContainerStyles = null;
const $1652d4d52e4f5cc8$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $1652d4d52e4f5cc8$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iI2az.default), {
                palette: palette,
                isMoving: isMoving,
                className: className
            }),
            isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iI2az.default), {
                palette: palette,
                isMoving: isMoving,
                isGlowing: true,
                className: className
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    "_2rkoftgi _16jlkb7n _1pbykb7n"
                ]),
                children: [
                    children,
                    " "
                ]
            })
        ]
    });
var $1652d4d52e4f5cc8$export$2e2bcd8739ae039 = $1652d4d52e4f5cc8$var$AIGlowingBorder;

});
parcelRegister("iI2az", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2f1273dcfb74565$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
let $e2f1273dcfb74565$var$namespaceUUID = 0;
const $e2f1273dcfb74565$var$svgStyles = null;
const $e2f1273dcfb74565$var$blurredStyles = null;
const $e2f1273dcfb74565$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $e2f1273dcfb74565$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $5uXOq.useRef)(null);
    const namespaceId = (0, $5uXOq.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $e2f1273dcfb74565$var$namespaceUUID;
        $e2f1273dcfb74565$var$namespaceUUID += 1;
    }
    (0, $5uXOq.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg1`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0%",
                        y1: "0",
                        x2: "400%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "0%",
                                to: "400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "400%",
                                to: "800%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg2`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "-100%",
                        x2: "0",
                        y2: "300%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "-100%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "300%",
                                to: "700%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg3`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "300%",
                        y1: "0",
                        x2: "700%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "300%",
                                to: "-100%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "700%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg4`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "400%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "0%",
                                to: "-400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "400%",
                                to: "0%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                strokeWidth: "8",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg1)`,
                        d: "M0 0h24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg2)`,
                        d: "M24 0v24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg3)`,
                        d: "M24 24H0",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg4)`,
                        d: "M0 24V0",
                        vectorEffect: "non-scaling-stroke"
                    })
                ]
            })
        ]
    });
};
var $e2f1273dcfb74565$export$2e2bcd8739ae039 = $e2f1273dcfb74565$var$AnimatedSvgContainer;

});


parcelRegister("DuPPR", function(module, exports) {

$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $82894915d9bf39bf$export$23b7b83c7063ccfe);
const $82894915d9bf39bf$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $82894915d9bf39bf$export$23b7b83c7063ccfe = {
    dark: {
        blue: $82894915d9bf39bf$export$3088ed82e2905d1e.blue800,
        teal: $82894915d9bf39bf$export$3088ed82e2905d1e.teal500,
        yellow: $82894915d9bf39bf$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $82894915d9bf39bf$export$3088ed82e2905d1e.blue600,
        teal: $82894915d9bf39bf$export$3088ed82e2905d1e.teal300,
        yellow: $82894915d9bf39bf$export$3088ed82e2905d1e.yellow200
    }
};

});



parcelRegister("KTqu4", function(module, exports) {

$parcel$export(module.exports, "default", () => $73fc988205a4fd73$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $8PVtF = parcelRequire("8PVtF");

var $eCNt3 = parcelRequire("eCNt3");

var $7zaVw = parcelRequire("7zaVw");

var $9fYWd = parcelRequire("9fYWd");

var $dghu0 = parcelRequire("dghu0");
var $hYQw7 = parcelRequire("hYQw7");
const $73fc988205a4fd73$var$titleBlockStylesOld = null;
const $73fc988205a4fd73$var$titleBlockStyles = null;
const $73fc988205a4fd73$var$mainTextStylesOld = null;
const $73fc988205a4fd73$var$mainTextStyles = null;
const $73fc988205a4fd73$var$connectButtonStylesOld = null;
const $73fc988205a4fd73$var$connectButtonStyles = null;
const $73fc988205a4fd73$var$basePreviewStylesOld = null;
const $73fc988205a4fd73$var$basePreviewStyles = null;
const $73fc988205a4fd73$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const data = cardState.details?.data;
    const meta = cardState.details?.meta;
    const product = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(cardState.details)?.text ?? '' : (0, $f24gj.extractProvider)(data)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
        children: (0, $eCNt3.default)(url)
    });
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $8PVtF.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    const ButtonComponent = (0, $VSDnB.fg)('platform-smart-card-remove-legacy-button') ? (0, $eCeGD.default) : (0, $fVnbM.default);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
                ignoreContainerPadding: true,
                testId: testId,
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $8dVIb.SmartLinkStatus).Forbidden
                },
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_13lipd34 _qrwqpd34 _otyru2gc" : "_13lipd34 _qrwqpd34 _otyrcxkx"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                testId: `${testId}-title`,
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $8dVIb.SmartLinkStatus).Forbidden
                },
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1bah1h6o _k48p1pd9 _19pku2gc" : "_1bah1h6o _k48p1pd9 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages)[titleMessageKey],
                    values: {
                        product: product
                    }
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                testId: `${testId}-content`,
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $8dVIb.SmartLinkStatus).Forbidden
                },
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o" : "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages)[descriptiveMessageKey],
                    values: {
                        product: product,
                        hostname: hostname
                    }
                })
            }),
            action && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $8dVIb.SmartLinkStatus).Forbidden
                },
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1bah1h6o _19pku2gc" : "_1bah1h6o _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(ButtonComponent, {
                    testId: `${testId}-button`,
                    onClick: action?.promise,
                    appearance: "primary",
                    isDisabled: buttonDisabled,
                    children: action?.text
                })
            })
        ]
    });
};
var $73fc988205a4fd73$export$2e2bcd8739ae039 = $73fc988205a4fd73$var$HoverCardForbiddenView;

});
parcelRegister("8PVtF", function(module, exports) {

$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $be4c51ebaefcf3e8$export$846c1540a86749e6);

var $7zaVw = parcelRequire("7zaVw");

var $fzJZi = parcelRequire("fzJZi");

var $fKHgZ = parcelRequire("fKHgZ");

var $eCNt3 = parcelRequire("eCNt3");
const $be4c51ebaefcf3e8$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $eCNt3.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $fKHgZ.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $7zaVw.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $fKHgZ.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $7zaVw.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $fKHgZ.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $7zaVw.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $fKHgZ.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $7zaVw.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("fKHgZ", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $d51c8d84b1e7f98f$export$59f8830fb5467e35);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7zaVw = parcelRequire("7zaVw");
const $d51c8d84b1e7f98f$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $7zaVw.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("eCNt3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aafc83cfd7b46ae$export$2e2bcd8739ae039);
const $4aafc83cfd7b46ae$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $4aafc83cfd7b46ae$export$2e2bcd8739ae039 = $4aafc83cfd7b46ae$var$extractHostname;

});



parcelRegister("6klQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $338ebad02f36b2c8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $9fYWd = parcelRequire("9fYWd");

var $fh9qw = parcelRequire("fh9qw");
var $85ffk = parcelRequire("85ffk");
var $1qDIM = parcelRequire("1qDIM");
var $gg6Qm = parcelRequire("gg6Qm");
var $1JaZ4 = parcelRequire("1JaZ4");
var $buvhv = parcelRequire("buvhv");

var $8RJLv = parcelRequire("8RJLv");

var $k9g4I = parcelRequire("k9g4I");
const $338ebad02f36b2c8$var$hiddenSnippetStyles = null;
const $338ebad02f36b2c8$var$metadataBlockCssOld = null;
/**
 * Moved from HoverCardContent.tsx due to CompiledCSS migration.
 */ const $338ebad02f36b2c8$var$titleBlockStyleOld = null;
const $338ebad02f36b2c8$var$titleBlockStyles = null;
const $338ebad02f36b2c8$var$snippetBlockCss = null;
const $338ebad02f36b2c8$var$actionBlockCss = null;
const $338ebad02f36b2c8$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $1VPdD.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $8dVIb.CardDisplay).HoverCardPreview
        });
        // UFO will disregard this if authentication experience has not yet been started
        (0, $1VPdD.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $8dVIb.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $8dVIb.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $5uXOq.useMemo)(()=>{
        return (0, $8RJLv.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(0);
    const snippetBlockRef = (0, $5uXOq.useRef)(null);
    const onSnippetRender = (0, $5uXOq.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $k9g4I.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1JaZ4.default), {
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
            status: (0, $8dVIb.SmartLinkStatus).Resolved
        },
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        ...flexibleCardProps,
        children: [
            imagePreview,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $buvhv.default), {
                ...titleBlockProps,
                metadataPosition: (0, $8dVIb.SmartLinkPosition).Top,
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $8dVIb.SmartLinkStatus).Resolved
                },
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9" : "_zulpu2gc _quenui7n _oebj1txw _x7z0u2gc _1ljqu2gc _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gg6Qm.default), {
                primary: primary,
                secondary: secondary,
                maxLines: 1,
                size: (0, $8dVIb.SmartLinkSize).Medium,
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $8dVIb.SmartLinkStatus).Resolved
                },
                className: (0, $bwpsq.default)([
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_zulpidpf _2aco1o8v _fmt31ohn _yklxcxkx _w3mucxkx _ia0l11wp _3tmpcxkx"
                ])
            }),
            isAISummaryEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1qDIM.default), {
                aiSummaryMinHeight: aiSummaryMinHeight,
                placeholder: snippet,
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $8dVIb.SmartLinkStatus).Resolved
                }
            }) : snippet,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1JaZ4.default), {
                testId: "hidden-snippet",
                onRender: onSnippetRender,
                blockRef: snippetBlockRef,
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $8dVIb.SmartLinkStatus).Resolved
                },
                isHidden: true,
                className: (0, $bwpsq.default)([
                    "_3um015vq _kqswstnw"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fh9qw.default), {
                onClick: onActionClick,
                spaceInline: "space.100",
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_n3td1b66"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $85ffk.default), {})
        ]
    });
};
var $338ebad02f36b2c8$export$2e2bcd8739ae039 = $338ebad02f36b2c8$var$HoverCardResolvedView;

});
parcelRegister("k9g4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb0493145b01898e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $jELGn = parcelRequire("jELGn");

var $hYQw7 = parcelRequire("hYQw7");
const $eb0493145b01898e$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $5uXOq.useRef)(false);
    const previewBlockRef = (0, $5uXOq.useRef)(null);
    const [showPreview, setShowPreview] = (0, $5uXOq.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $5uXOq.useState)({});
    const data = response?.data;
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $5uXOq.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
                borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
                marginBottom: (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "var(--ds-space-100, 8px)" : '0.5rem',
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $5uXOq.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $5uXOq.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    if ((0, $VSDnB.fg)('smart_links_noun_support')) return showPreview && (0, $jELGn.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
    return showPreview && data && (0, $jELGn.default)(data) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $eb0493145b01898e$export$2e2bcd8739ae039 = $eb0493145b01898e$var$ImagePreview;

});
parcelRegister("jELGn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3b57ea7b1c4bc68$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extractSmartLinkPreviewImage", () => $c3b57ea7b1c4bc68$export$a79836076066b8b6);

var $kYwnb = parcelRequire("kYwnb");
var $5nDnb = parcelRequire("5nDnb");

var $8dVIb = parcelRequire("8dVIb");
const $c3b57ea7b1c4bc68$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $5nDnb.extractImage)(data);
    return url ? {
        type: (0, $8dVIb.MediaType).Image,
        url: url
    } : undefined;
};
var $c3b57ea7b1c4bc68$export$2e2bcd8739ae039 = $c3b57ea7b1c4bc68$var$extractPreview;
const $c3b57ea7b1c4bc68$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $kYwnb.isEntityPresent)(response)) {
        const entity = (0, $kYwnb.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        if (!url) {
            const provider = (0, $kYwnb.extractEntityProvider)(response);
            url = provider?.image;
        }
        return url ? {
            type: (0, $8dVIb.MediaType).Image,
            url: url
        } : undefined;
    }
    return $c3b57ea7b1c4bc68$var$extractPreview(response.data);
};

});
parcelRegister("5nDnb", function(module, exports) {

$parcel$export(module.exports, "extractImage", () => $bf7a10bb5159fbbd$export$4c753a1297cb9805);

var $7OmtM = parcelRequire("7OmtM");
const $bf7a10bb5159fbbd$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $7OmtM.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $7OmtM.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});




parcelRegister("g3aqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9278993db7419c13$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dghu0 = parcelRequire("dghu0");

var $bubxq = parcelRequire("bubxq");

var $gU02S = parcelRequire("gU02S");

var $9TvvC = parcelRequire("9TvvC");

var $hZqF4 = parcelRequire("hZqF4");
const $9278993db7419c13$var$loadingViewContainer = null;
const $9278993db7419c13$var$skeletonContainer = null;
const $9278993db7419c13$var$titleStyle = null;
const $9278993db7419c13$var$titleBlockStyles = null;
const $9278993db7419c13$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $hZqF4.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1e9d _u5f31e9d _n3td1e9d _19bv1e9d"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            className: (0, $bwpsq.default)([
                "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
                    ...titleBlockProps,
                    testId: `${testId}-title-block`,
                    className: (0, $bwpsq.default)([
                        "_zulpcxkx _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9TvvC.default), {
                            render: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {}),
                            size: size
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testid": `${testId}-title`,
                            className: (0, $bwpsq.default)([
                                "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
                                height: `${lineHeightRem}rem`
                            })
                        }),
                        actionGroup
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem * 3}rem`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        })
                    ]
                })
            ]
        })
    });
};
var $9278993db7419c13$export$2e2bcd8739ae039 = $9278993db7419c13$var$HoverCardLoadingView;

});

parcelRegister("f6jZ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7ebd359d5a8e698$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $3CATS = parcelRequire("3CATS");

var $fgpl1 = parcelRequire("fgpl1");

var $3PAn6 = parcelRequire("3PAn6");

var $9fYWd = parcelRequire("9fYWd");

var $dghu0 = parcelRequire("dghu0");

var $bubxq = parcelRequire("bubxq");

var $eqoQu = parcelRequire("eqoQu");
const $e7ebd359d5a8e698$var$connectButtonStylesOld = null;
const $e7ebd359d5a8e698$var$connectButtonStyles = null;
const $e7ebd359d5a8e698$var$titleBlockStylesOld = null;
const $e7ebd359d5a8e698$var$titleBlockStyles = null;
const $e7ebd359d5a8e698$var$mainTextStylesOld = null;
const $e7ebd359d5a8e698$var$mainTextStyles = null;
const $e7ebd359d5a8e698$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const data = cardState.details?.data;
    const providerName = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(cardState.details)?.text : (0, $f24gj.extractProvider)(data)?.text;
    const isProductIntegrationSupported = (0, $fgpl1.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $3CATS.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleAuthorize = (0, $5uXOq.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $8dVIb.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>[
            {
                name: (0, $8dVIb.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
                testId: `${testId}-title`,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _13mh1pd9" : "_zulp5l1i _bpsp1wq8"
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $7zaVw.messages).connect_link_account_card_name,
                        values: {
                            context: providerName
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                testId: `${testId}-content`,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_11c8dcr7 _19pku2gc" : "_11c8dcr7 _19pkcxkx"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3PAn6.default), {
                        providerName: providerName,
                        isProductIntegrationSupported: isProductIntegrationSupported
                    })
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                testId: `${testId}-button`,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1bahesu3 _19pku2gc" : "_1bahesu3 _19pkcxkx"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
                    items: actions,
                    appearance: "primary"
                })
            })
        ]
    });
};
var $e7ebd359d5a8e698$export$2e2bcd8739ae039 = $e7ebd359d5a8e698$var$HoverCardUnauthorisedView;

});
parcelRegister("3PAn6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8897e3cb423b2de$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $5McnS = parcelRequire("5McnS");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $a8897e3cb423b2de$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $7zaVw.messages).learn_more_about_connecting_account : (0, $7zaVw.messages).learn_more_about_smart_links;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            providerName ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).connect_unauthorised_account_description,
                values: {
                    context: providerName
                }
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).connect_unauthorised_account_description_no_provider
            }),
            ' ',
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
                href: isProductIntegrationSupported ? (0, $8dVIb.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $8dVIb.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                testId: `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...learnMoreMessage
                })
            }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                href: isProductIntegrationSupported ? (0, $8dVIb.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $8dVIb.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                "data-testid": `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    textDecoration: 'underline'
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...learnMoreMessage
                })
            })
        ]
    });
};
var $a8897e3cb423b2de$export$2e2bcd8739ae039 = $a8897e3cb423b2de$var$UnauthorisedViewContent;

});






parcelRegister("4mRkk", function(module, exports) {

$parcel$export(module.exports, "default", () => $22aaf352da1fa338$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4URMI = parcelRequire("4URMI");
const $22aaf352da1fa338$var$styles = null;
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $22aaf352da1fa338$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1,
        children: text
    });
};
var $22aaf352da1fa338$export$2e2bcd8739ae039 = $22aaf352da1fa338$var$LayeredLink;

});


parcelRegister("1Vuck", function(module, exports) {

$parcel$export(module.exports, "getContextByStatus", () => $567a4b851e4bc65e$export$e68aec76e359e401);
$parcel$export(module.exports, "getRetryOptions", () => $567a4b851e4bc65e$export$f3d3482baaff4bf6);

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $8PVtF = parcelRequire("8PVtF");

var $2zcFi = parcelRequire("2zcFi");

var $7t0R3 = parcelRequire("7t0R3");

var $jELGn = parcelRequire("jELGn");

var $dybmx = parcelRequire("dybmx");

var $jq5Nf = parcelRequire("jq5Nf");

var $7zaVw = parcelRequire("7zaVw");

var $kxcRq = parcelRequire("kxcRq");

var $aOsut = parcelRequire("aOsut");
const $567a4b851e4bc65e$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Pending:
        case (0, $8dVIb.SmartLinkStatus).Resolving:
            return (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? {
                linkTitle: (0, $7t0R3.default)(status, url, response, onClick),
                url: url
            } : {
                title: url,
                url: url
            };
        case (0, $8dVIb.SmartLinkStatus).Resolved:
            return (0, $2zcFi.default)(params);
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).NotFound:
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                title: (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : url,
                linkIcon: (0, $dybmx.extractErrorIcon)(response, status),
                linkTitle: (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $7t0R3.default)(status, url, response, onClick) : undefined,
                preview: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $jELGn.extractSmartLinkPreviewImage)(response) : (0, $jELGn.default)(response?.data),
                provider: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $jq5Nf.extractSmartLinkProviderIcon)(response) : (0, $jq5Nf.default)(response?.data),
                actions: (0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? {
                    [(0, $8dVIb.InternalActionName).UnresolvedAction]: $567a4b851e4bc65e$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                } : undefined
            };
    }
};
const $567a4b851e4bc65e$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $567a4b851e4bc65e$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const data = response && response.data || (0, $aOsut.getEmptyJsonLd)();
    const provider = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(response) : (0, $f24gj.extractProvider)(data);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $aOsut.getForbiddenJsonLd)().meta;
            const access = (0, $8PVtF.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $567a4b851e4bc65e$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $7zaVw.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $kxcRq.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $7zaVw.messages).connect_link_account_card_name,
                onClick: (0, $kxcRq.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $8dVIb.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $7zaVw.messages).cannot_find_link
            };
    }
};

});
parcelRegister("2zcFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $da041debbb7991f6$export$2e2bcd8739ae039);

var $hWyvy = parcelRequire("hWyvy");
var $8Tcl1 = parcelRequire("8Tcl1");
var $ccpJ1 = parcelRequire("ccpJ1");
var $8UXrm = parcelRequire("8UXrm");
var $4MmCl = parcelRequire("4MmCl");
var $eV8m9 = parcelRequire("eV8m9");
var $dhQ1x = parcelRequire("dhQ1x");
var $iPUv2 = parcelRequire("iPUv2");
var $FcDCF = parcelRequire("FcDCF");

var $VSDnB = parcelRequire("VSDnB");

var $jnrSW = parcelRequire("jnrSW");

var $d4sEp = parcelRequire("d4sEp");

var $9LwFA = parcelRequire("9LwFA");

var $7t0R3 = parcelRequire("7t0R3");

var $jELGn = parcelRequire("jELGn");

var $bWsp1 = parcelRequire("bWsp1");

var $djFaY = parcelRequire("djFaY");

var $dybmx = parcelRequire("dybmx");

var $jq5Nf = parcelRequire("jq5Nf");

var $iGAv4 = parcelRequire("iGAv4");

var $6N2TY = parcelRequire("6N2TY");
const $da041debbb7991f6$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, origin: origin, renderers: renderers, resolve: resolve, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkUrl)(response) : (0, $8UXrm.extractLink)(data);
    return {
        actions: (0, $d4sEp.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url
        }),
        appliedToComponentsCount: (0, $6N2TY.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $6N2TY.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $6N2TY.extractAttachmentCount)(data),
        authorGroup: (0, $4MmCl.extractPersonCreatedBy)(data),
        ownedByGroup: (0, $eV8m9.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $9LwFA.extractPersonsUpdatedBy)(data),
        commentCount: (0, $6N2TY.extractCommentCount)(data),
        viewCount: (0, $6N2TY.extractViewCount)(data),
        reactCount: (0, $6N2TY.extractReactCount)(data),
        voteCount: (0, $6N2TY.extractVoteCount)(data),
        checklistProgress: (0, $6N2TY.extractChecklistProgress)(data),
        createdBy: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkCreatedBy)(response) : (0, $6N2TY.extractCreatedBy)(data),
        ownedBy: (0, $6N2TY.extractOwnedBy)(data),
        assignedTo: (0, $6N2TY.extractAssignedTo)(data),
        createdOn: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkCreatedOn)(response) : (0, $8Tcl1.extractDateCreated)(data),
        dueOn: (0, $6N2TY.extractDueOn)(data),
        latestCommit: (0, $iGAv4.extractLatestCommit)(data),
        linkIcon: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dybmx.extractSmartLinkIcon)(response) : (0, $dybmx.extractLinkIcon)(response, renderers),
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') && {
            linkTitle: (0, $7t0R3.default)(status, props.url, response, onClick)
        },
        location: (0, $6N2TY.extractLocation)(data),
        modifiedBy: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkModifiedBy)(response) : (0, $6N2TY.extractModifiedBy)(data),
        modifiedOn: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkModifiedOn)(response) : (0, $ccpJ1.extractDateUpdated)(data),
        preview: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $jELGn.extractSmartLinkPreviewImage)(response) : (0, $jELGn.default)(data),
        priority: (0, $bWsp1.default)(data),
        provider: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $jq5Nf.extractSmartLinkProviderIcon)(response) : (0, $jq5Nf.default)(data),
        programmingLanguage: (0, $6N2TY.extractProgrammingLanguage)(data),
        readTime: (0, $6N2TY.extractReadTime)(data),
        sentOn: (0, $6N2TY.extractSentOn)(data),
        snippet: (0, $jnrSW.extractSummary)(data) || undefined,
        sourceBranch: (0, $6N2TY.extractSourceBranch)(data),
        state: (0, $djFaY.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve),
        subscriberCount: (0, $6N2TY.extractSubscriberCount)(data),
        subTasksProgress: (0, $6N2TY.extractSubTasksProgress)(data),
        storyPoints: (0, $6N2TY.extractStoryPoints)(data),
        targetBranch: (0, $6N2TY.extractTargetBranch)(data),
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
            title: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkTitle)(response) || url : (0, $iPUv2.extractTitle)(data) || url
        },
        url: url,
        ari: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkAri)(response) : (0, $hWyvy.extractAri)(data),
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $FcDCF.extractType)(data)
        },
        ...(0, $VSDnB.fg)('cc-ai-linking-platform-snippet-renderer') && {
            meta: {
                objectId: (0, $6N2TY.extractMetaObjectId)(meta),
                resourceType: (0, $6N2TY.extractMetaResourceType)(meta),
                tenantId: (0, $6N2TY.extractMetaTenantId)(meta)
            }
        }
    };
};
var $da041debbb7991f6$export$2e2bcd8739ae039 = $da041debbb7991f6$var$extractFlexibleUiContext;

});
parcelRegister("jnrSW", function(module, exports) {

$parcel$export(module.exports, "extractSummary", () => $82a2487542e3dcba$export$db5a8500f6b6286e);
const $82a2487542e3dcba$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};

});

parcelRegister("d4sEp", function(module, exports) {

$parcel$export(module.exports, "extractFlexibleCardActions", () => $c3cafd9d828d6c09$export$abe8d0ca1daa1755);

var $8dVIb = parcelRequire("8dVIb");

var $4ma4m = parcelRequire("4ma4m");

var $f5eJz = parcelRequire("f5eJz");

var $kh3Vl = parcelRequire("kh3Vl");

var $gIJxe = parcelRequire("gIJxe");

var $4DFf8 = parcelRequire("4DFf8");

var $joFPX = parcelRequire("joFPX");

var $ljBcB = parcelRequire("ljBcB");
const $c3cafd9d828d6c09$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url })=>{
    const action = {
        [(0, $8dVIb.ActionName).CopyLinkAction]: (0, $kh3Vl.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $8dVIb.ActionName).DownloadAction]: (0, $gIJxe.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $8dVIb.ActionName).FollowAction]: (0, $4DFf8.default)(response, actionOptions, id),
        [(0, $8dVIb.ActionName).PreviewAction]: (0, $joFPX.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response
        }),
        [(0, $8dVIb.ActionName).AutomationAction]: (0, $f5eJz.extractAutomationAction)(response),
        [(0, $8dVIb.InternalActionName).AISummaryAction]: (0, $4ma4m.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $8dVIb.InternalActionName).ViewRelatedLinksAction]: (0, $ljBcB.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("4ma4m", function(module, exports) {

$parcel$export(module.exports, "extractAISummaryAction", () => $8cdc7ca64eb62313$export$e7f7a50a8b8932df);

var $evnkj = parcelRequire("evnkj");

var $cnaAy = parcelRequire("cnaAy");

var $dn5wJ = parcelRequire("dn5wJ");
const $8cdc7ca64eb62313$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).AISummaryAction, actionOptions) || !(0, $cnaAy.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});
parcelRegister("evnkj", function(module, exports) {

$parcel$export(module.exports, "canShowAction", () => $6626d2f2bee6ec27$export$2487b058456cca75);
const $6626d2f2bee6ec27$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});


parcelRegister("f5eJz", function(module, exports) {

$parcel$export(module.exports, "extractAutomationAction", () => $ca59c43d6a564063$export$f913cc6abf3ec084);

var $8dVIb = parcelRequire("8dVIb");
const $ca59c43d6a564063$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $8dVIb.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("kh3Vl", function(module, exports) {

$parcel$export(module.exports, "extractCopyLinkClientAction", () => $156b119eb968da41$export$31ddd5c40039ce53);

var $ewRjE = parcelRequire("ewRjE");
const $156b119eb968da41$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $ewRjE.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("ewRjE", function(module, exports) {

$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $f95950db90c61c64$export$5ec86886067a062d);

var $8UXrm = parcelRequire("8UXrm");

var $8dVIb = parcelRequire("8dVIb");
var $dn5wJ = parcelRequire("dn5wJ");

var $fgpl1 = parcelRequire("fgpl1");

var $evnkj = parcelRequire("evnkj");
const $f95950db90c61c64$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).CopyLinkAction, actionOptions)) return;
    const data = response.data;
    const url = (0, $8UXrm.extractLink)(data);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $8dVIb.ActionName).CopyLinkAction,
        definitionId: (0, $fgpl1.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $fgpl1.getExtensionKey)(response),
        id: id,
        resourceType: (0, $fgpl1.getResourceType)(response)
    };
};

});


parcelRegister("gIJxe", function(module, exports) {

$parcel$export(module.exports, "extractDownloadClientAction", () => $02d459bef4b0b3b6$export$f6c386869a352b1f);

var $gOP67 = parcelRequire("gOP67");
const $02d459bef4b0b3b6$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $gOP67.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("gOP67", function(module, exports) {

$parcel$export(module.exports, "extractInvokeDownloadAction", () => $8cd6513c4477faeb$export$ea97cd34c2ca86de);

var $8dVIb = parcelRequire("8dVIb");
var $dn5wJ = parcelRequire("dn5wJ");

var $fgpl1 = parcelRequire("fgpl1");

var $kxcRq = parcelRequire("kxcRq");

var $evnkj = parcelRequire("evnkj");

var $5U430 = parcelRequire("5U430");

var $e2ZVS = parcelRequire("e2ZVS");
const $8cd6513c4477faeb$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $5U430.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $e2ZVS.extractDownloadUrl)(data);
        return {
            actionFn: async ()=>(0, $kxcRq.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $8dVIb.ActionName).DownloadAction,
            definitionId: (0, $fgpl1.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $fgpl1.getExtensionKey)(response),
            id: id,
            resourceType: (0, $fgpl1.getResourceType)(response)
        };
    }
};

});
parcelRegister("5U430", function(module, exports) {

$parcel$export(module.exports, "getActionsFromJsonLd", () => $76a260c3f7e7678d$export$8f031784a3a03b23);
const $76a260c3f7e7678d$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});

parcelRegister("e2ZVS", function(module, exports) {

$parcel$export(module.exports, "extractDownloadUrl", () => $ef91c3db80f281ff$export$9682e3ac9d184e95);
const $ef91c3db80f281ff$export$9682e3ac9d184e95 = (jsonLd)=>{
    if (jsonLd['atlassian:downloadUrl']) return jsonLd['atlassian:downloadUrl'];
};

});



parcelRegister("4DFf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a99662467a25c4e$export$2e2bcd8739ae039);

var $8UXrm = parcelRequire("8UXrm");
var $FcDCF = parcelRequire("FcDCF");

var $T540Y = parcelRequire("T540Y");

var $fgpl1 = parcelRequire("fgpl1");

var $evnkj = parcelRequire("evnkj");

var $dn5wJ = parcelRequire("dn5wJ");

var $j4IjY = parcelRequire("j4IjY");
const $5a99662467a25c4e$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $fgpl1.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $j4IjY.default)(data);
    const type = (0, $FcDCF.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $T540Y.SmartLinkActionType).FollowEntityAction || actionName === (0, $T540Y.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $8UXrm.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $T540Y.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $5a99662467a25c4e$export$2e2bcd8739ae039 = $5a99662467a25c4e$var$extractFollowAction;

});
parcelRegister("j4IjY", function(module, exports) {

$parcel$export(module.exports, "default", () => $491a605bed171307$export$2e2bcd8739ae039);
const $491a605bed171307$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $491a605bed171307$export$2e2bcd8739ae039 = $491a605bed171307$var$extractServerAction;

});


parcelRegister("joFPX", function(module, exports) {

$parcel$export(module.exports, "extractPreviewClientAction", () => $67a9503b149a9ddf$export$9f0d9100b079448);

var $k1bRY = parcelRequire("k1bRY");
const $67a9503b149a9ddf$export$9f0d9100b079448 = (param)=>{
    const invokeAction = (0, $k1bRY.extractInvokePreviewAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("k1bRY", function(module, exports) {

$parcel$export(module.exports, "extractInvokePreviewAction", () => $ae749ffcba0ba676$export$caf83f49e52ac0bb);

var $8UXrm = parcelRequire("8UXrm");
var $k9B19 = parcelRequire("k9B19");
var $f24gj = parcelRequire("f24gj");
var $iPUv2 = parcelRequire("iPUv2");

var $8dVIb = parcelRequire("8dVIb");
var $dn5wJ = parcelRequire("dn5wJ");

var $fgpl1 = parcelRequire("fgpl1");

var $evnkj = parcelRequire("evnkj");

var $2Fcti = parcelRequire("2Fcti");

var $hYF5d = parcelRequire("hYF5d");

var $V4gq9 = parcelRequire("V4gq9");

var $dybmx = parcelRequire("dybmx");

var $gOP67 = parcelRequire("gOP67");

var $eBrh9 = parcelRequire("eBrh9");
const $ae749ffcba0ba676$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response } = param;
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).PreviewAction, actionOptions)) return;
    const data = response.data;
    const meta = response.meta;
    const src = (0, $k9B19.extractPreview)(data, 'web')?.src;
    if (src) {
        const url = (0, $8UXrm.extractLink)(data);
        const extensionKey = (0, $fgpl1.getExtensionKey)(response);
        return {
            actionFn: async ()=>(0, $2Fcti.openEmbedModal)({
                    fireEvent: fireEvent,
                    extensionKey: extensionKey,
                    id: id,
                    invokeDownloadAction: (0, $gOP67.extractInvokeDownloadAction)(param),
                    invokeViewAction: (0, $eBrh9.extractInvokeViewAction)(param, true),
                    isSupportTheming: (0, $hYF5d.extractIsSupportTheming)(meta),
                    isTrusted: (0, $V4gq9.extractIsTrusted)(meta),
                    linkIcon: (0, $dybmx.extractLinkIcon)(response),
                    providerName: (0, $f24gj.extractProvider)(data)?.text,
                    onClose: onClose,
                    origin: origin,
                    src: src,
                    title: (0, $iPUv2.extractTitle)(data),
                    url: url
                }),
            actionSubjectId: 'invokePreviewScreen',
            actionType: (0, $8dVIb.ActionName).PreviewAction,
            display: display,
            extensionKey: extensionKey,
            id: id
        };
    }
};

});
parcelRegister("2Fcti", function(module, exports) {

$parcel$export(module.exports, "openEmbedModal", () => $2555d47e7922f4ad$export$7859f96cd8cff034);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $i5FdW = parcelRequire("i5FdW");
const $2555d47e7922f4ad$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $2555d47e7922f4ad$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("9RmOY"));
    (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).render(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Modal.default, {
            ...props,
            iframeName: $2555d47e7922f4ad$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })
    }), popupMountPoint);
}

});
parcelRegister("9RmOY", function(module, exports) {

let $72dac41cf87d8065$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $72dac41cf87d8065$var$load("ffQaD"),
    $72dac41cf87d8065$var$load("kvRbA"),
    $72dac41cf87d8065$var$load("lJvDT")
]).then(()=>parcelRequire('amcti'));

});


parcelRegister("hYF5d", function(module, exports) {

$parcel$export(module.exports, "extractIsSupportTheming", () => $693566d688a51b19$export$38d755f52cdf4acb);

var $dvNbb = parcelRequire("dvNbb");
const $693566d688a51b19$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $dvNbb.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("dvNbb", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $9b14bed6babdc545$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $9b14bed6babdc545$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $9b14bed6babdc545$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $9b14bed6babdc545$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $9b14bed6babdc545$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $9b14bed6babdc545$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $9b14bed6babdc545$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $9b14bed6babdc545$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $9b14bed6babdc545$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $9b14bed6babdc545$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $9b14bed6babdc545$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $9b14bed6babdc545$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $9b14bed6babdc545$export$fe44ce30fd8d131b);
const $9b14bed6babdc545$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $9b14bed6babdc545$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $9b14bed6babdc545$export$84a73a0383f58180 = 'JiraTask';
const $9b14bed6babdc545$export$c6c83963a9378a67 = 'JiraSubTask';
const $9b14bed6babdc545$export$58af3c426c111a6d = 'JiraStory';
const $9b14bed6babdc545$export$ac9898a63417219e = 'JiraBug';
const $9b14bed6babdc545$export$54db5e3fb12e39cd = 'JiraEpic';
const $9b14bed6babdc545$export$2f54a5a217202c85 = 'JiraIncident';
const $9b14bed6babdc545$export$d097371052bfc411 = 'JiraServiceRequest';
const $9b14bed6babdc545$export$efd9452ad16c6676 = 'JiraChange';
const $9b14bed6babdc545$export$2e7e70abb5d81f67 = 'JiraProblem';
const $9b14bed6babdc545$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $9b14bed6babdc545$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider'
];

});


parcelRegister("V4gq9", function(module, exports) {

$parcel$export(module.exports, "extractIsTrusted", () => $635b28bc2d55c0b7$export$4f3ffbb500daac5a);
const $635b28bc2d55c0b7$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("dybmx", function(module, exports) {

$parcel$export(module.exports, "extractLinkIcon", () => $d7af83be96aed150$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $d7af83be96aed150$export$bdd29be9b0395931);
$parcel$export(module.exports, "extractSmartLinkIcon", () => $d7af83be96aed150$export$35040aed9264b11c);

var $kYwnb = parcelRequire("kYwnb");

var $8dVIb = parcelRequire("8dVIb");

var $9fbCf = parcelRequire("9fbCf");

var $5ZCMp = parcelRequire("5ZCMp");

var $jq5Nf = parcelRequire("jq5Nf");
const $d7af83be96aed150$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $9fbCf.default)(data, renderers);
    return {
        ...(0, $5ZCMp.default)(data),
        render: render
    };
};
const $d7af83be96aed150$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $jq5Nf.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $8dVIb.IconType).Forbidden
            };
        case (0, $8dVIb.SmartLinkStatus).NotFound:
            return {
                icon: (0, $8dVIb.IconType).Error
            };
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $8dVIb.IconType).Default
            };
    }
};
const $d7af83be96aed150$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntityIcon)(response);
    return $d7af83be96aed150$export$43612bed147eae48(response, renderers);
};

});
parcelRegister("9fbCf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cc79bd445a96437$export$2e2bcd8739ae039);
const $3cc79bd445a96437$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $3cc79bd445a96437$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $3cc79bd445a96437$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $3cc79bd445a96437$export$2e2bcd8739ae039 = $3cc79bd445a96437$var$extractIconRenderer;

});

parcelRegister("5ZCMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f6ae1c2ef653082$export$2e2bcd8739ae039);

var $iPUv2 = parcelRequire("iPUv2");

var $8dVIb = parcelRequire("8dVIb");

var $3TBiE = parcelRequire("3TBiE");

var $4DoyP = parcelRequire("4DoyP");

var $a4RsY = parcelRequire("a4RsY");

var $dvNbb = parcelRequire("dvNbb");

var $1gwFB = parcelRequire("1gwFB");

var $liAf6 = parcelRequire("liAf6");

var $cKwAC = parcelRequire("cKwAC");

var $jq5Nf = parcelRequire("jq5Nf");

var $iWNKM = parcelRequire("iWNKM");
const $4f6ae1c2ef653082$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $a4RsY.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $4f6ae1c2ef653082$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $4DoyP.extractorPriorityMap)[b] - (0, $4DoyP.extractorPriorityMap)[a])[0] : type;
};
const $4f6ae1c2ef653082$var$isJiraProvider = (provider)=>provider === (0, $dvNbb.JIRA_GENERATOR_ID);
function $4f6ae1c2ef653082$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $liAf6.default)(fileFormat);
    const documentTypeIcon = $4f6ae1c2ef653082$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $1gwFB.default)(type, label, providerId);
    return (0, $3TBiE.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $4f6ae1c2ef653082$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $8dVIb.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $8dVIb.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $8dVIb.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $8dVIb.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $8dVIb.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $8dVIb.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $8dVIb.IconType).Task,
                label: taskLabel
            };
            if ($4f6ae1c2ef653082$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $4f6ae1c2ef653082$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $cKwAC.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $4f6ae1c2ef653082$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $iPUv2.extractTitle)(data);
    const type = $4f6ae1c2ef653082$var$extractType(data);
    const urlIcon = (0, $iWNKM.default)(data.icon, label);
    const providerIcon = (0, $jq5Nf.default)(data);
    return $4f6ae1c2ef653082$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $4f6ae1c2ef653082$export$2e2bcd8739ae039 = $4f6ae1c2ef653082$var$extractJsonldDataIcon;

});
parcelRegister("3TBiE", function(module, exports) {

$parcel$export(module.exports, "prioritiseIcon", () => $99be71cd5a3b0274$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $99be71cd5a3b0274$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("4DoyP", function(module, exports) {

$parcel$export(module.exports, "extractorPriorityMap", () => $bf343580a3de2dcf$export$e0deaeb4a2dfe2b4);
const $bf343580a3de2dcf$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("a4RsY", function(module, exports) {

$parcel$export(module.exports, "extractTaskType", () => $81dd8ddf907a1532$export$ed3fd59180514d27);

var $cuw1y = parcelRequire("cuw1y");
const $81dd8ddf907a1532$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("1gwFB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f8e24b11256d3ae$export$2e2bcd8739ae039);

var $f24gj = parcelRequire("f24gj");

var $8dVIb = parcelRequire("8dVIb");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $2f8e24b11256d3ae$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $8dVIb.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $f24gj.isConfluenceGenerator)(providerId)) return {
                icon: (0, $8dVIb.IconType).LiveDocument,
                label: label || 'Live Document'
            };
            else return {
                icon: (0, $8dVIb.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $8dVIb.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $8dVIb.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $8dVIb.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $8dVIb.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $8dVIb.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $2f8e24b11256d3ae$export$2e2bcd8739ae039 = $2f8e24b11256d3ae$var$extractDocumentTypeIcon;

});

parcelRegister("cKwAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $97a727b28b60947e$export$2e2bcd8739ae039);

var $8dVIb = parcelRequire("8dVIb");
const $97a727b28b60947e$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $8dVIb.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $8dVIb.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $8dVIb.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $8dVIb.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $8dVIb.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $8dVIb.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $8dVIb.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $8dVIb.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $8dVIb.IconType).Task,
                label: label
            };
    }
};
var $97a727b28b60947e$export$2e2bcd8739ae039 = $97a727b28b60947e$var$extractJiraTaskIcon;

});

parcelRegister("jq5Nf", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e0775b3750bf70$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extractSmartLinkProviderIcon", () => $87e0775b3750bf70$export$5def189f04eea025);

var $kYwnb = parcelRequire("kYwnb");
var $iPUv2 = parcelRequire("iPUv2");

var $8dVIb = parcelRequire("8dVIb");

var $dvNbb = parcelRequire("dvNbb");

var $iWNKM = parcelRequire("iWNKM");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $87e0775b3750bf70$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $iPUv2.extractTitle)(data);
    if (provider === (0, $dvNbb.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $8dVIb.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $dvNbb.JIRA_GENERATOR_ID)) return {
        icon: (0, $8dVIb.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $iWNKM.default)(icon, label);
};
var $87e0775b3750bf70$export$2e2bcd8739ae039 = $87e0775b3750bf70$var$extractProviderIcon;
const $87e0775b3750bf70$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $kYwnb.isEntityPresent)(response)) {
        const provider = (0, $kYwnb.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $dvNbb.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $8dVIb.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $dvNbb.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $8dVIb.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $kYwnb.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $87e0775b3750bf70$var$extractProviderIcon(response.data);
};

});
parcelRegister("iWNKM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8418e6f5863288f0$export$2e2bcd8739ae039);

var $cuw1y = parcelRequire("cuw1y");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $8418e6f5863288f0$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $cuw1y.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $8418e6f5863288f0$export$2e2bcd8739ae039 = $8418e6f5863288f0$var$extractUrlIcon;

});




parcelRegister("eBrh9", function(module, exports) {

$parcel$export(module.exports, "extractInvokeViewAction", () => $d2874e5e099b8c6e$export$88c5813cfbbe4e4c);

var $8UXrm = parcelRequire("8UXrm");

var $dn5wJ = parcelRequire("dn5wJ");

var $fgpl1 = parcelRequire("fgpl1");

var $kxcRq = parcelRequire("kxcRq");

var $evnkj = parcelRequire("evnkj");

var $5U430 = parcelRequire("5U430");
const $d2874e5e099b8c6e$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $8UXrm.extractLink)(data);
    const viewActionExists = (0, $5U430.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $kxcRq.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $fgpl1.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $fgpl1.getExtensionKey)(response),
        id: id,
        resourceType: (0, $fgpl1.getResourceType)(response)
    };
};

});



parcelRegister("ljBcB", function(module, exports) {

$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $a600a657ec97b3e1$export$debae7424a0231b9);

var $hWyvy = parcelRequire("hWyvy");
const $a600a657ec97b3e1$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $hWyvy.extractAri)(response.data);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("9LwFA", function(module, exports) {

$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $4c9ea88664552b6e$export$216e4f6aa7c169b8);

var $o6TQ1 = parcelRequire("o6TQ1");
var $aj6Xc = parcelRequire("aj6Xc");
const $4c9ea88664552b6e$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $o6TQ1.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $aj6Xc.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("o6TQ1", function(module, exports) {

$parcel$export(module.exports, "extractMembers", () => $e9d0787cbe8b8bff$export$6281d080d62a0719);

var $aj6Xc = parcelRequire("aj6Xc");
const $e9d0787cbe8b8bff$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $aj6Xc.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $aj6Xc.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});


parcelRegister("7t0R3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4ce26ac9ccc277a$export$2e2bcd8739ae039);

var $8UXrm = parcelRequire("8UXrm");
var $dhQ1x = parcelRequire("dhQ1x");
var $iPUv2 = parcelRequire("iPUv2");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");
const $d4ce26ac9ccc277a$var$extractLinkTitle = (status, propUrl, response, onClick)=>{
    const data = response?.data;
    const responseUrl = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkUrl)(response) : (0, $8UXrm.extractLink)(data);
    const url = status === (0, $8dVIb.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkTitle)(response) : (0, $iPUv2.extractTitle)(data);
    const text = status === (0, $8dVIb.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        text: text,
        url: url
    };
};
var $d4ce26ac9ccc277a$export$2e2bcd8739ae039 = $d4ce26ac9ccc277a$var$extractLinkTitle;

});

parcelRegister("bWsp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $92024e0264c50850$export$2e2bcd8739ae039);

var $cuw1y = parcelRequire("cuw1y");

var $8dVIb = parcelRequire("8dVIb");
const $92024e0264c50850$var$priorityMapper = {
    blocker: (0, $8dVIb.IconType).PriorityBlocker,
    critical: (0, $8dVIb.IconType).PriorityCritical,
    high: (0, $8dVIb.IconType).PriorityHigh,
    highest: (0, $8dVIb.IconType).PriorityHighest,
    low: (0, $8dVIb.IconType).PriorityLow,
    lowest: (0, $8dVIb.IconType).PriorityLowest,
    major: (0, $8dVIb.IconType).PriorityMajor,
    medium: (0, $8dVIb.IconType).PriorityMedium,
    minor: (0, $8dVIb.IconType).PriorityMinor,
    trivial: (0, $8dVIb.IconType).PriorityTrivial,
    undefined: (0, $8dVIb.IconType).PriorityUndefined
};
const $92024e0264c50850$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $92024e0264c50850$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $92024e0264c50850$export$2e2bcd8739ae039 = $92024e0264c50850$var$extractPriority;

});

parcelRegister("djFaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c680025bc04d725$export$2e2bcd8739ae039);

var $8UXrm = parcelRequire("8UXrm");

var $fgpl1 = parcelRequire("fgpl1");

var $evnkj = parcelRequire("evnkj");

var $dn5wJ = parcelRequire("dn5wJ");

var $k1bRY = parcelRequire("k1bRY");

var $eL1Oa = parcelRequire("eL1Oa");

var $j4IjY = parcelRequire("j4IjY");
const $9c680025bc04d725$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $9c680025bc04d725$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve)=>{
    const extensionKey = (0, $fgpl1.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $j4IjY.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $9c680025bc04d725$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $8UXrm.extractLink)(data);
    const invokePreviewAction = response ? (0, $k1bRY.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response
    }) : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $9c680025bc04d725$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $9c680025bc04d725$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $eL1Oa.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $9c680025bc04d725$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve);
    return {
        ...lozenge,
        action: action
    };
};
var $9c680025bc04d725$export$2e2bcd8739ae039 = $9c680025bc04d725$var$extractState;

});
parcelRegister("eL1Oa", function(module, exports) {

$parcel$export(module.exports, "extractLozenge", () => $00b49e71ec2a1469$export$e5da155556a77bca);

var $FcDCF = parcelRequire("FcDCF");

var $hJJo2 = parcelRequire("hJJo2");

var $8KYrd = parcelRequire("8KYrd");

var $1fxuS = parcelRequire("1fxuS");

var $a4RsY = parcelRequire("a4RsY");
const $00b49e71ec2a1469$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $FcDCF.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $8KYrd.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $1fxuS.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $00b49e71ec2a1469$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $hJJo2.extractState)(jsonLd);
    }
};
const $00b49e71ec2a1469$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $a4RsY.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("hJJo2", function(module, exports) {

$parcel$export(module.exports, "extractState", () => $23353713d30390cb$export$5e4074cbce6574c7);

var $5Sb4A = parcelRequire("5Sb4A");
// Maps accent color short names to their corresponding background and text colors
const $23353713d30390cb$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $23353713d30390cb$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $5Sb4A.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $5Sb4A.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $23353713d30390cb$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("5Sb4A", function(module, exports) {

$parcel$export(module.exports, "isValidAppearance", () => $0823e05e6f9f26fe$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $0823e05e6f9f26fe$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $0823e05e6f9f26fe$export$772610da74ddbc07);
const $0823e05e6f9f26fe$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $0823e05e6f9f26fe$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $0823e05e6f9f26fe$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $0823e05e6f9f26fe$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $0823e05e6f9f26fe$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("8KYrd", function(module, exports) {

$parcel$export(module.exports, "extractTag", () => $6e0524caff97ae26$export$962a8da34cf78a4f);

var $5Sb4A = parcelRequire("5Sb4A");
const $6e0524caff97ae26$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($6e0524caff97ae26$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $6e0524caff97ae26$var$extractTagItem(tag);
    }
};
const $6e0524caff97ae26$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $5Sb4A.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("1fxuS", function(module, exports) {

$parcel$export(module.exports, "extractTaskStatus", () => $4b88cdff9f070a4a$export$7698df1946deda72);
const $4b88cdff9f070a4a$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("iGAv4", function(module, exports) {

$parcel$export(module.exports, "extractLatestCommit", () => $0e72a17e0fb58d4d$export$f222392162cff0d8);
const $0e72a17e0fb58d4d$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});




parcelRegister("82kHN", function(module, exports) {

$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $315bbe8c3c3dac23$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptionsOld", () => $315bbe8c3c3dac23$export$bffdde2c5e3e604e);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $315bbe8c3c3dac23$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $315bbe8c3c3dac23$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $315bbe8c3c3dac23$export$9671929f11bd4ad8);

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $6N2TY = parcelRequire("6N2TY");

var $fgpl1 = parcelRequire("fgpl1");
const $315bbe8c3c3dac23$var$baseTopMetadata = [
    {
        name: (0, $8dVIb.ElementName).ModifiedOn
    },
    {
        name: (0, $8dVIb.ElementName).AttachmentCount
    },
    {
        name: (0, $8dVIb.ElementName).SubscriberCount
    },
    {
        name: (0, $8dVIb.ElementName).VoteCount
    },
    {
        name: (0, $8dVIb.ElementName).DueOn
    },
    {
        name: (0, $8dVIb.ElementName).ReadTime
    }
];
const $315bbe8c3c3dac23$var$baseBottomMetaData = [
    {
        name: (0, $8dVIb.ElementName).ReactCount
    },
    {
        name: (0, $8dVIb.ElementName).CommentCount
    },
    {
        name: (0, $8dVIb.ElementName).ViewCount
    },
    {
        name: (0, $8dVIb.ElementName).Priority
    },
    {
        name: (0, $8dVIb.ElementName).SubTasksProgress
    },
    {
        name: (0, $8dVIb.ElementName).ChecklistProgress
    }
];
const $315bbe8c3c3dac23$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $fgpl1.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $8dVIb.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $8dVIb.ElementName).AuthorGroup
        },
        {
            name: (0, $8dVIb.ElementName).CreatedBy
        },
        ...$315bbe8c3c3dac23$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $315bbe8c3c3dac23$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $8dVIb.ElementName).LatestCommit
                    },
                    {
                        name: (0, $8dVIb.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $8dVIb.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            if ((0, $VSDnB.fg)('expandable_smart_links_for_scorecards_v2')) return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $6N2TY.extractOwnedBy)(data) ? [
                    {
                        name: (0, $8dVIb.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $8dVIb.ElementName).OwnedBy
                    },
                    ...$315bbe8c3c3dac23$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).AppliedToComponentsCount
                    },
                    ...$315bbe8c3c3dac23$var$baseBottomMetaData
                ]
            };
            else return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $6N2TY.extractOwnedBy)(data) ? [
                    {
                        name: (0, $8dVIb.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $8dVIb.ElementName).OwnedBy
                    },
                    ...$315bbe8c3c3dac23$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = !!data['atlassian:ownedBy'] ?? false;
            let topMetadata = [
                {
                    name: (0, $8dVIb.ElementName).AuthorGroup
                },
                {
                    name: (0, $8dVIb.ElementName).CreatedBy
                },
                {
                    name: (0, $8dVIb.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $8dVIb.ElementName).AssignedToGroup
                },
                {
                    name: (0, $8dVIb.ElementName).AssignedTo
                },
                {
                    name: (0, $8dVIb.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan && (0, $VSDnB.fg)('smart_links_for_plans_platform')) topMetadata = [
                {
                    name: (0, $8dVIb.ElementName).OwnedByGroup
                },
                {
                    name: (0, $8dVIb.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).StoryPoints
                    },
                    {
                        name: (0, $8dVIb.ElementName).Priority
                    },
                    {
                        name: (0, $8dVIb.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $8dVIb.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).ReactCount
                    },
                    {
                        name: (0, $8dVIb.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).CollaboratorGroup
                    },
                    ...$315bbe8c3c3dac23$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $315bbe8c3c3dac23$export$bffdde2c5e3e604e = {
    hideElevation: true,
    hideLegacyButton: true
};
const $315bbe8c3c3dac23$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $315bbe8c3c3dac23$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $8dVIb.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $8dVIb.SmartLinkSize).Large
};
const $315bbe8c3c3dac23$export$9671929f11bd4ad8 = {
    placement: (0, $8dVIb.MediaPlacement).Right,
    ignoreContainerPadding: true
};

});


parcelRegister("1dEUF", function(module, exports) {

$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $f3e0678ba71181d8$export$36ce1a3a446661ab);
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $f3e0678ba71181d8$var$flexibleBlockCardStyle = null;
const $f3e0678ba71181d8$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_1g96pd34 _1qo3h6cr"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(FlexibleBlockCardView, {
                ...props
            })
        });
    };

});


parcelRegister("kQeqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3ee13c9f8fe006$export$2e2bcd8739ae039);
/* ForbiddenView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $bwyQI = parcelRequire("bwyQI");

var $3G2gB = parcelRequire("3G2gB");

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $8PVtF = parcelRequire("8PVtF");

var $eCNt3 = parcelRequire("eCNt3");

var $7zaVw = parcelRequire("7zaVw");

var $cL21r = parcelRequire("cL21r");

var $aOsut = parcelRequire("aOsut");

var $eL5Me = parcelRequire("eL5Me");

var $jgxl3 = parcelRequire("jgxl3");

var $3Mvli = parcelRequire("3Mvli");

var $1dEUF = parcelRequire("1dEUF");
const $9b3ee13c9f8fe006$var$textStyles = null;
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $9b3ee13c9f8fe006$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const intl = (0, $koVbs.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $aOsut.getForbiddenJsonLd)().meta;
    const provider = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(details) : (0, $f24gj.extractProvider)(details?.data);
    const providerName = provider?.text || '';
    const messageContext = (0, $5uXOq.useMemo)(()=>{
        const hostname = /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
            children: (0, $eCNt3.default)(url)
        });
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $5uXOq.useMemo)(()=>{
        return (0, $8PVtF.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $5uXOq.useMemo)(()=>{
        const descriptor = (0, $cL21r.toMessage)((0, $7zaVw.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $jgxl3.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $jgxl3.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Mvli.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
                label: "forbidden-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3G2gB))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eL5Me.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $cL21r.toMessage)((0, $7zaVw.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
                    values: messageContext
                },
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt"
                ])
            })
        ]
    });
};
var $9b3ee13c9f8fe006$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($9b3ee13c9f8fe006$var$ForbiddenView);

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("3G2gB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad70d7fd26028c0$var$_react = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2ad70d7fd26028c0$var$_lockLocked = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $2ad70d7fd26028c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ad70d7fd26028c0$var$LockIcon = (props)=>/*#__PURE__*/ $2ad70d7fd26028c0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $2ad70d7fd26028c0$var$_lockLocked.default
    }));
$2ad70d7fd26028c0$var$LockIcon.displayName = 'LockIcon';
var $2ad70d7fd26028c0$var$_default = module.exports.default = $2ad70d7fd26028c0$var$LockIcon;

});

parcelRegister("cL21r", function(module, exports) {

$parcel$export(module.exports, "toMessage", () => $4b469267e6199ae7$export$d14c2a6dee946f52);

var $7zaVw = parcelRequire("7zaVw");
const $4b469267e6199ae7$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $7zaVw.messages)) return (0, $7zaVw.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("jgxl3", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $4f0bf32284a5caf2$export$59f8830fb5467e35);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $4f0bf32284a5caf2$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $8dVIb.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("7wrOH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d316574b181170a3$export$2e2bcd8739ae039);
/* NotFoundView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $bwyQI = parcelRequire("bwyQI");

var $3G2gB = parcelRequire("3G2gB");

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");

var $eL5Me = parcelRequire("eL5Me");

var $3Mvli = parcelRequire("3Mvli");

var $1dEUF = parcelRequire("1dEUF");
const $d316574b181170a3$var$textStyles = null;
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $d316574b181170a3$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $koVbs.default)();
    const { cardState: { details: details } } = props;
    const product = (0, $5uXOq.useMemo)(()=>{
        const provider = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(details) : (0, $f24gj.extractProvider)(details?.data);
        return provider?.text ?? '';
    }, [
        details
    ]);
    const title = (0, $5uXOq.useMemo)(()=>intl.formatMessage((0, $7zaVw.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $5uXOq.useMemo)(()=>({
            descriptor: (0, $7zaVw.messages).not_found_description
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Mvli.default), {
        ...props,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
                label: "not-found-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3G2gB))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eL5Me.default), {
                message: description,
                testId: `${testId}-message`,
                maxLines: 3,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt"
                ])
            })
        ]
    });
};
var $d316574b181170a3$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($d316574b181170a3$var$NotFoundView);

});

parcelRegister("kc7yu", function(module, exports) {

$parcel$export(module.exports, "default", () => $49b1742d0d340851$export$2e2bcd8739ae039);
/* ResolvedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b6uPu = parcelRequire("b6uPu");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $9fYWd = parcelRequire("9fYWd");

var $ietxm = parcelRequire("ietxm");
var $gg6Qm = parcelRequire("gg6Qm");
var $hYQw7 = parcelRequire("hYQw7");
var $1JaZ4 = parcelRequire("1JaZ4");
var $buvhv = parcelRequire("buvhv");

var $82kHN = parcelRequire("82kHN");

var $1dEUF = parcelRequire("1dEUF");
const $49b1742d0d340851$var$titleBlockCssOld = null;
const $49b1742d0d340851$var$titleBlockCss = null;
const $49b1742d0d340851$var$footerBlockCssOld = null;
const $49b1742d0d340851$var$footerBlockCss = null;
const $49b1742d0d340851$var$footerBlockSafariStyles = null;
const $49b1742d0d340851$var$metadataBlockCssOld = null;
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $49b1742d0d340851$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $5uXOq.useState)(false);
    const { safari: safari = false } = (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>(0, $b6uPu.browser)(), []) : {};
    (0, $5uXOq.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $82kHN.getSimulatedBetterMetadata)(cardState.details);
    const footerActions = (0, $5uXOq.useMemo)(()=>[
            {
                name: (0, $8dVIb.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $8dVIb.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $8dVIb.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const status = cardState.status;
    const uiOptions = (0, $VSDnB.fg)('platform-linking-flexible-card-context') ? (0, $82kHN.FlexibleCardUiOptions) : (0, $82kHN.FlexibleCardUiOptionsOld);
    if ((0, $VSDnB.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $buvhv.default), {
                ...(0, $82kHN.titleBlockOptions),
                metadata: titleMetadata,
                subtitle: [
                    {
                        name: (0, $8dVIb.ElementName).Location
                    }
                ],
                metadataPosition: (0, $8dVIb.SmartLinkPosition).Top,
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: status
                },
                CompetitorPrompt: CompetitorPrompt,
                url: url,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _13mh1pd9 _2yhz14q2" : "_zulpcxkx _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gg6Qm.default), {
                primary: topMetadata,
                maxLines: 1,
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $8dVIb.SmartLinkStatus).Resolved
                },
                className: (0, $bwpsq.default)([
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_wwyvidpf _1sxbcxkx _i8d01j6v"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1JaZ4.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gg6Qm.default), {
                primary: bottomMetadata,
                maxLines: 1,
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $8dVIb.SmartLinkStatus).Resolved
                },
                className: (0, $bwpsq.default)([
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_wwyvidpf _1sxbcxkx _i8d01j6v"
                ])
            }),
            !isPreviewBlockErrored ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
                ...(0, $82kHN.PreviewBlockOptions),
                onError: ()=>{
                    setIsPreviewBlockErrored(true);
                },
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $8dVIb.SmartLinkStatus).Resolved
                }
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ietxm.default), {
                actions: footerActions,
                ...(0, $VSDnB.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $8dVIb.SmartLinkStatus).Resolved
                },
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb" : "_4t3i1k8s _g0eioxwj _1qryoxwj _sxbroxwj _1gyioxwj",
                    safari && (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $49b1742d0d340851$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($49b1742d0d340851$var$ResolvedView);

});

parcelRegister("1PV7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $163450cca1677688$export$2e2bcd8739ae039);
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $fgpl1 = parcelRequire("fgpl1");

var $3PAn6 = parcelRequire("3PAn6");

var $1CwNu = parcelRequire("1CwNu");

var $3Mvli = parcelRequire("3Mvli");

var $1dEUF = parcelRequire("1dEUF");
const $163450cca1677688$var$contentStylesOld = null;
const $163450cca1677688$var$contentStyles = null;
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $163450cca1677688$var$UnauthorisedView = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const data = cardState.details?.data;
    const providerName = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(cardState.details)?.text : (0, $f24gj.extractProvider)(data)?.text;
    const isProductIntegrationSupported = (0, $fgpl1.hasAuthScopeOverrides)(cardState.details);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleAuthorize = (0, $5uXOq.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $5uXOq.useMemo)(()=>onAuthorize ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3PAn6.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>onAuthorize ? [
            (0, $1CwNu.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Mvli.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": `${testId}-content`,
            className: (0, $bwpsq.default)([
                (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_11c8dcr7 _syaz1fxt _19pku2gc" : "_11c8dcr7 _syaz131l _19pkcxkx"
            ]),
            children: content
        })
    });
};
var $163450cca1677688$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($163450cca1677688$var$UnauthorisedView);

});
parcelRegister("1CwNu", function(module, exports) {

$parcel$export(module.exports, "AuthorizeAction", () => $712c9d89e4ab58d6$export$34cef2b72294bd84);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $712c9d89e4ab58d6$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $8dVIb.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).connect_link_account_card
        }),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});



parcelRegister("7RcXv", function(module, exports) {

$parcel$export(module.exports, "EmbedCard", () => $ab3d9e42a13cc11c$export$6789d7ecdc77631b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $VSDnB = parcelRequire("VSDnB");

var $8PVtF = parcelRequire("8PVtF");

var $lNtMX = parcelRequire("lNtMX");

var $ctwhA = parcelRequire("ctwhA");

var $fgpl1 = parcelRequire("fgpl1");

var $6TU5j = parcelRequire("6TU5j");

var $aOsut = parcelRequire("aOsut");

var $7xFN9 = parcelRequire("7xFN9");

var $kc7yu = parcelRequire("kc7yu");

var $ir8YW = parcelRequire("ir8YW");

var $iJqW5 = parcelRequire("iJqW5");

var $39ESV = parcelRequire("39ESV");

var $5VvNe = parcelRequire("5VvNe");

var $d0weD = parcelRequire("d0weD");

var $4WY3L = parcelRequire("4WY3L");
const $ab3d9e42a13cc11c$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $fgpl1.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $fgpl1.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $6TU5j.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc7yu.default), {
                url: url,
                cardState: cardState,
                onClick: handleFrameClick,
                onError: onError,
                onResolve: onResolve,
                renderers: renderers,
                actionOptions: actionOptions,
                testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
            });
        case 'resolved':
            const resolvedViewProps = (0, $lNtMX.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio
            });
            if ((0, $VSDnB.fg)('platform_smart_links_controlled_dsp_export_view')) {
                if ((0, $7xFN9.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                    const unauthViewProps = (0, $lNtMX.extractEmbedProps)(details, platform);
                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4WY3L.default), {
                        context: unauthViewProps.context,
                        extensionKey: extensionKey,
                        frameStyle: frameStyle,
                        isProductIntegrationSupported: isProductIntegrationSupported,
                        inheritDimensions: inheritDimensions,
                        isSelected: isSelected,
                        onAuthorize: handleAuthorize,
                        onClick: handleFrameClick,
                        testId: testId,
                        url: unauthViewProps.link
                    });
                }
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d0weD.EmbedCardResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                testId: testId
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $ctwhA.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ir8YW.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc7yu.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $lNtMX.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4WY3L.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $lNtMX.extractEmbedProps)(details, platform);
            const cardMetadata = details?.meta ?? (0, $aOsut.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d0weD.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef
            });
            const forbiddenAccessContext = (0, $8PVtF.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $39ESV.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $lNtMX.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $8PVtF.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5VvNe.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iJqW5.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("lNtMX", function(module, exports) {

$parcel$export(module.exports, "extractEmbedProps", () => $0b9efe0d16e320ac$export$d6cf81ca6e68bcc3);

var $8UXrm = parcelRequire("8UXrm");
var $k9B19 = parcelRequire("k9B19");
var $dhQ1x = parcelRequire("dhQ1x");
var $iPUv2 = parcelRequire("iPUv2");
var $FcDCF = parcelRequire("FcDCF");

var $VSDnB = parcelRequire("VSDnB");

var $aOsut = parcelRequire("aOsut");

var $ejTRu = parcelRequire("ejTRu");

var $hYF5d = parcelRequire("hYF5d");

var $V4gq9 = parcelRequire("V4gq9");
const $0b9efe0d16e320ac$var$extractEmbedPreview = (jsonLd, platform, iframeUrlType)=>{
    const preview = (0, $k9B19.extractPreview)(jsonLd, platform, iframeUrlType);
    if (preview && preview.src) return {
        ...preview,
        src: preview.src
    };
};
const $0b9efe0d16e320ac$export$d6cf81ca6e68bcc3 = (response, platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $aOsut.getEmptyJsonLd)();
    if ((0, $VSDnB.fg)('smart_links_noun_support')) return {
        link: (0, $dhQ1x.extractSmartLinkUrl)(response) || '',
        title: (0, $dhQ1x.extractSmartLinkTitle)(response),
        context: (0, $ejTRu.extractSmartLinkContext)(response),
        preview: (0, $dhQ1x.extractSmartLinkEmbed)(response, iframeUrlType),
        isTrusted: (0, $V4gq9.extractIsTrusted)(meta),
        isSupportTheming: (0, $hYF5d.extractIsSupportTheming)(meta),
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $FcDCF.extractType)(jsonLd)
        }
    };
    return {
        link: (0, $8UXrm.extractLink)(jsonLd) || '',
        title: (0, $iPUv2.extractTitle)(jsonLd),
        context: (0, $ejTRu.generateContext)(jsonLd),
        preview: $0b9efe0d16e320ac$var$extractEmbedPreview(jsonLd, platform, iframeUrlType),
        isTrusted: (0, $V4gq9.extractIsTrusted)(meta),
        isSupportTheming: (0, $hYF5d.extractIsSupportTheming)(meta),
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $FcDCF.extractType)(jsonLd)
        }
    };
};

});
parcelRegister("ejTRu", function(module, exports) {

$parcel$export(module.exports, "generateContext", () => $a8e47739da07a172$export$8dcb07487061d3c1);
$parcel$export(module.exports, "extractSmartLinkContext", () => $a8e47739da07a172$export$6ec4b6b24dec9156);

var $kYwnb = parcelRequire("kYwnb");
var $f24gj = parcelRequire("f24gj");
var $cuw1y = parcelRequire("cuw1y");

var $3TBiE = parcelRequire("3TBiE");

var $8PVtF = parcelRequire("8PVtF");
function $a8e47739da07a172$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $f24gj.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $3TBiE.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $cuw1y.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $f24gj.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
function $a8e47739da07a172$export$6ec4b6b24dec9156(response) {
    if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntityProvider)(response);
    return $a8e47739da07a172$export$8dcb07487061d3c1(response?.data);
}

});


parcelRegister("ctwhA", function(module, exports) {

$parcel$export(module.exports, "extractInlineProps", () => $240edc2fd862d8a6$export$68e1703c529dc7e0);

var $kYwnb = parcelRequire("kYwnb");
var $8UXrm = parcelRequire("8UXrm");
var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");
var $iPUv2 = parcelRequire("iPUv2");
var $FcDCF = parcelRequire("FcDCF");

var $VSDnB = parcelRequire("VSDnB");

var $2Gj5n = parcelRequire("2Gj5n");

var $eL1Oa = parcelRequire("eL1Oa");

var $8Kv84 = parcelRequire("8Kv84");

var $6tk3N = parcelRequire("6tk3N");

var $dvNbb = parcelRequire("dvNbb");
const $240edc2fd862d8a6$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $f24gj.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $dvNbb.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $dvNbb.JIRA_GENERATOR_ID)) return (0, $2Gj5n.extractIcon)(jsonLd, 'type', showIconLabel);
    }
    return (0, $2Gj5n.extractIcon)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $240edc2fd862d8a6$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $kYwnb.isEntityPresent)(response)) {
        const provider = (0, $kYwnb.extractEntityProvider)(response);
        if (provider) return provider.icon;
    // We don't need this for design entities,
    // but we can add it back when we support more entities
    // it requires extractInlineIcon to be moved to the smart link extractor package.
    // see: https://product-fabric.atlassian.net/browse/EDM-12375
    // return extractSmartLinkIcon(response);
    }
    return $240edc2fd862d8a6$var$extractInlineIcon(response?.data, showLabel);
};
const $240edc2fd862d8a6$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data;
    if ((0, $VSDnB.fg)('smart_links_noun_support')) return {
        link: (0, $dhQ1x.extractSmartLinkUrl)(response),
        title: (0, $dhQ1x.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: $240edc2fd862d8a6$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $eL1Oa.extractLozenge)(jsonLd),
        titleTextColor: (0, $8Kv84.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $6tk3N.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $FcDCF.extractType)(jsonLd)
        }
    };
    return {
        link: (0, $8UXrm.extractLink)(jsonLd),
        title: (0, $iPUv2.extractTitle)(jsonLd, removeTextHighlightingFromTitle),
        lozenge: (0, $eL1Oa.extractLozenge)(jsonLd),
        icon: $240edc2fd862d8a6$var$extractInlineIcon(jsonLd, showLabel),
        titleTextColor: (0, $8Kv84.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $6tk3N.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $FcDCF.extractType)(jsonLd)
        }
    };
};

});
parcelRegister("2Gj5n", function(module, exports) {

$parcel$export(module.exports, "extractIcon", () => $b9f947e5dca4cb3d$export$64bdf1f5e49e8626);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4sBeG = parcelRequire("4sBeG");

var $ezu4w = parcelRequire("ezu4w");

var $bPjbr = parcelRequire("bPjbr");

var $6qWjs = parcelRequire("6qWjs");

var $ercGv = parcelRequire("ercGv");

var $ckyDP = parcelRequire("ckyDP");

var $f24gj = parcelRequire("f24gj");
var $iPUv2 = parcelRequire("iPUv2");
var $cuw1y = parcelRequire("cuw1y");

var $kxcRq = parcelRequire("kxcRq");

var $a4RsY = parcelRequire("a4RsY");

var $6mmu7 = parcelRequire("6mmu7");

var $eeWf5 = parcelRequire("eeWf5");

var $i6XYa = parcelRequire("i6XYa");

var $3TBiE = parcelRequire("3TBiE");

var $4DoyP = parcelRequire("4DoyP");
const $b9f947e5dca4cb3d$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $iPUv2.extractTitle)(jsonLd),
        provider: (0, $f24gj.extractProvider)(jsonLd),
        fileFormat: (0, $6mmu7.extractFileFormat)(jsonLd),
        taskType: (0, $a4RsY.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $4DoyP.extractorPriorityMap)[b] - (0, $4DoyP.extractorPriorityMap)[a])[0];
        return $b9f947e5dca4cb3d$var$extractIconByType(highestPriorityType, opts);
    } else return $b9f947e5dca4cb3d$var$extractIconByType(type, opts);
};
function $b9f947e5dca4cb3d$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bPjbr.default), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ckyDP))), {
                label: opts.title || 'project',
                LEGACY_size: "small",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6qWjs.default), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4sBeG.default), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ezu4w.default), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ercGv.default), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $i6XYa.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $b9f947e5dca4cb3d$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $b9f947e5dca4cb3d$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $kxcRq.getIconForFileType)(opts.fileFormat) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $3TBiE.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $b9f947e5dca4cb3d$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $eeWf5.extractIconFromDocument)(type, opts);
        default:
            return $b9f947e5dca4cb3d$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("4sBeG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6b6e63637c1c2754$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd5a8d264ca7a1e79e3d50d476094729>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $4iPF3 = parcelRequire("4iPF3");

var $VSDnB = parcelRequire("VSDnB");

var $9ORcR = parcelRequire("9ORcR");
/**
 * __16px `branch` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $6b6e63637c1c2754$var$Branch16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4iPF3))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9ORcR.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9ORcR.default), {
        label: label,
        testId: testId
    });
};
$6b6e63637c1c2754$var$Branch16Icon.displayName = 'Branch16Icon';
var $6b6e63637c1c2754$export$2e2bcd8739ae039 = $6b6e63637c1c2754$var$Branch16Icon;

});
parcelRegister("4iPF3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3220eab15e59539d$var$_react = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3220eab15e59539d$var$_baseNew = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3220eab15e59539d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3220eab15e59539d$var$BranchIcon = (props)=>/*#__PURE__*/ $3220eab15e59539d$var$_react.default.createElement($3220eab15e59539d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$3220eab15e59539d$var$BranchIcon.displayName = 'BranchIcon';
var $3220eab15e59539d$var$_default = module.exports.default = $3220eab15e59539d$var$BranchIcon;

});

parcelRegister("9ORcR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1801d86c423f8469$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::371b0d35eca629b3ebb5e933140aedc3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $1801d86c423f8469$var$Branch16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 0 1 8.002 11l-.004 2A3.995 3.995 0 0 0 12 9.007v-.274a2 2 0 1 0-2 0m-4-3a2 2 0 1 0-2 0v4.536a2 2 0 1 0 2 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$1801d86c423f8469$var$Branch16Icon.displayName = 'Branch16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1801d86c423f8469$export$2e2bcd8739ae039 = $1801d86c423f8469$var$Branch16Icon;

});


parcelRegister("ezu4w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f0dda3514063910b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2e0cf5105bbbaa2e318211c53ac326e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $jSlaY = parcelRequire("jSlaY");

var $VSDnB = parcelRequire("VSDnB");

var $RsLsu = parcelRequire("RsLsu");
/**
 * __16px `code` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $f0dda3514063910b$var$Code16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jSlaY))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RsLsu.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RsLsu.default), {
        label: label,
        testId: testId
    });
};
$f0dda3514063910b$var$Code16Icon.displayName = 'Code16Icon';
var $f0dda3514063910b$export$2e2bcd8739ae039 = $f0dda3514063910b$var$Code16Icon;

});
parcelRegister("jSlaY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7837c8d7e1becd0$var$_react = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e7837c8d7e1becd0$var$_baseNew = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e7837c8d7e1becd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7837c8d7e1becd0$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $e7837c8d7e1becd0$var$_react.default.createElement($e7837c8d7e1becd0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$e7837c8d7e1becd0$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $e7837c8d7e1becd0$var$_default = module.exports.default = $e7837c8d7e1becd0$var$AngleBracketsIcon;

});

parcelRegister("RsLsu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffae1b83b5704dc$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a17b0b5d454f4262ba3195f959601cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $7ffae1b83b5704dc$var$Code16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L4.46 8.006l1.873-1.871A1 1 0 1 0 4.92 4.72m4.792 0a1 1 0 0 0 0 1.415l1.874 1.87-1.873 1.87a1 1 0 1 0 1.414 1.416l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292 1 1 0 0 0-.708.293"/></svg>`,
        ...props,
        size: "small"
    });
$7ffae1b83b5704dc$var$Code16Icon.displayName = 'Code16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7ffae1b83b5704dc$export$2e2bcd8739ae039 = $7ffae1b83b5704dc$var$Code16Icon;

});


parcelRegister("bPjbr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f3351ecfbe1e828a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e96efea4cb290db7d8f614246fd62e43>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $bFklq = parcelRequire("bFklq");

var $VSDnB = parcelRequire("VSDnB");

var $a0LEu = parcelRequire("a0LEu");
/**
 * __16px `commit` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $f3351ecfbe1e828a$var$Commit16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bFklq))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a0LEu.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a0LEu.default), {
        label: label,
        testId: testId
    });
};
$f3351ecfbe1e828a$var$Commit16Icon.displayName = 'Commit16Icon';
var $f3351ecfbe1e828a$export$2e2bcd8739ae039 = $f3351ecfbe1e828a$var$Commit16Icon;

});
parcelRegister("bFklq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06952e599791aaa8e8e82dba5053d210>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e34e0db8f20450$var$_react = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e34e0db8f20450$var$_baseNew = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e34e0db8f20450$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e34e0db8f20450$var$CommitIcon = (props)=>/*#__PURE__*/ $87e34e0db8f20450$var$_react.default.createElement($87e34e0db8f20450$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$87e34e0db8f20450$var$CommitIcon.displayName = 'CommitIcon';
var $87e34e0db8f20450$var$_default = module.exports.default = $87e34e0db8f20450$var$CommitIcon;

});

parcelRegister("a0LEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $87782212607829d3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::50d5a3bab2c708a6de1c7dc72e3a297a>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $87782212607829d3$var$Commit16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.986 1.834a3.001 3.001 0 0 1 0-5.668A1 1 0 0 1 7 5V3a1 1 0 1 1 2 0v2q0 .085-.014.166a3.001 3.001 0 0 1 0 5.668Q9 10.915 9 11v2a1 1 0 0 1-2 0v-2q0-.085.014-.166"/></svg>`,
        ...props,
        size: "small"
    });
$87782212607829d3$var$Commit16Icon.displayName = 'Commit16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$87782212607829d3$export$2e2bcd8739ae039 = $87782212607829d3$var$Commit16Icon;

});


parcelRegister("6qWjs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1636b9971be53c9b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::499dedcb1e659dc62cb0d811acc9f742>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $hXgVM = parcelRequire("hXgVM");

var $VSDnB = parcelRequire("VSDnB");

var $9VouT = parcelRequire("9VouT");
/**
 * __16px `pull-request` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $1636b9971be53c9b$var$PullRequest16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hXgVM))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9VouT.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9VouT.default), {
        label: label,
        testId: testId
    });
};
$1636b9971be53c9b$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $1636b9971be53c9b$export$2e2bcd8739ae039 = $1636b9971be53c9b$var$PullRequest16Icon;

});
parcelRegister("hXgVM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a083285ccf5836110a489694f045affe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1251477351c10fe$var$_react = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d1251477351c10fe$var$_baseNew = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d1251477351c10fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1251477351c10fe$var$PullRequestIcon = (props)=>/*#__PURE__*/ $d1251477351c10fe$var$_react.default.createElement($d1251477351c10fe$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$d1251477351c10fe$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $d1251477351c10fe$var$_default = module.exports.default = $d1251477351c10fe$var$PullRequestIcon;

});

parcelRegister("9VouT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a0bea366084931a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f46cc1f5eba58da93be626b062afbd6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $1a0bea366084931a$var$PullRequest16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M6.417 6H9a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V7a3 3 0 0 0-3-3H6.415l.294-.295a1 1 0 1 0-1.413-1.414l-2.003 2a1 1 0 0 0 .001 1.415l2.002 2.001a1 1 0 0 0 1.414-.002 1 1 0 0 0-.001-1.413zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`,
        ...props,
        size: "small"
    });
$1a0bea366084931a$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1a0bea366084931a$export$2e2bcd8739ae039 = $1a0bea366084931a$var$PullRequest16Icon;

});


parcelRegister("ercGv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $95e8963209f4e129$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5cb120ef54d45ebd04018c195938778f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $4xPlE = parcelRequire("4xPlE");

var $VSDnB = parcelRequire("VSDnB");

var $2BNVE = parcelRequire("2BNVE");
/**
 * __16px `task` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $95e8963209f4e129$var$Task16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4xPlE))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2BNVE.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2BNVE.default), {
        label: label,
        testId: testId
    });
};
$95e8963209f4e129$var$Task16Icon.displayName = 'Task16Icon';
var $95e8963209f4e129$export$2e2bcd8739ae039 = $95e8963209f4e129$var$Task16Icon;

});
parcelRegister("4xPlE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1fa22b134d342ddb8339c9dc89d7524>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34f2132ab88342e6$var$_react = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $34f2132ab88342e6$var$_baseNew = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $34f2132ab88342e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34f2132ab88342e6$var$TaskIcon = (props)=>/*#__PURE__*/ $34f2132ab88342e6$var$_react.default.createElement($34f2132ab88342e6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$34f2132ab88342e6$var$TaskIcon.displayName = 'TaskIcon';
var $34f2132ab88342e6$var$_default = module.exports.default = $34f2132ab88342e6$var$TaskIcon;

});

parcelRegister("2BNVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $95ed5bdbe4530df8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73d9ff981bcfc769f66de456322c40e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $95ed5bdbe4530df8$var$Task16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`,
        ...props,
        size: "small"
    });
$95ed5bdbe4530df8$var$Task16Icon.displayName = 'Task16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$95ed5bdbe4530df8$export$2e2bcd8739ae039 = $95ed5bdbe4530df8$var$Task16Icon;

});


parcelRegister("6mmu7", function(module, exports) {

$parcel$export(module.exports, "extractFileFormat", () => $086b33d374843724$export$f2d65f02f6888b60);
const $086b33d374843724$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("eeWf5", function(module, exports) {

$parcel$export(module.exports, "extractIconFromDocument", () => $43bc73545f7cdfda$export$25c24c7f577936d3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5mR3i = parcelRequire("5mR3i");

var $f24gj = parcelRequire("f24gj");

var $dVpJZ = parcelRequire("dVpJZ");

var $gVXQp = parcelRequire("gVXQp");

var $3vtQf = parcelRequire("3vtQf");

var $9bx9i = parcelRequire("9bx9i");

var $e1vlu = parcelRequire("e1vlu");

var $94rku = parcelRequire("94rku");

var $kxcRq = parcelRequire("kxcRq");

var $3TBiE = parcelRequire("3TBiE");
const $43bc73545f7cdfda$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $43bc73545f7cdfda$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $43bc73545f7cdfda$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $3TBiE.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $43bc73545f7cdfda$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $kxcRq.getIconForFileType)(opts.fileFormat);
};
const $43bc73545f7cdfda$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dVpJZ.default), {
                label: opts.showIconLabel ? opts.title || 'blog' : '',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return $43bc73545f7cdfda$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $94rku.default), {
                label: opts.showIconLabel ? opts.title || 'document' : '',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gVXQp.default), {
                label: opts.showIconLabel ? opts.title || 'presentation' : '',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9bx9i.default), {
                label: opts.showIconLabel ? opts.title || 'spreadsheet' : '',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5mR3i))), {
                color: "currentColor",
                label: opts.showIconLabel ? opts.title || 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $94rku.default), {
                label: opts.showIconLabel ? opts.title || 'undefinedLink' : '',
                testId: "document-icon"
            });
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $43bc73545f7cdfda$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $f24gj.isConfluenceGenerator)(opts.provider.id)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e1vlu.default), {
        label: "live-doc",
        testId: "live-doc-icon"
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3vtQf.default), {
        label: opts.showIconLabel ? opts.title || 'file' : '',
        testId: "file-icon"
    });
};

});
parcelRegister("5mR3i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c20e147606d139fd2bd9c488f6dfb0c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e8828e45bde362b$var$_react = $3e8828e45bde362b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3e8828e45bde362b$var$_file = $3e8828e45bde362b$var$_interopRequireDefault((parcelRequire("1NlXW")));

var $3e8828e45bde362b$var$_documentFilled = $3e8828e45bde362b$var$_interopRequireDefault((parcelRequire("53J27")));
function $3e8828e45bde362b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e8828e45bde362b$var$FileIcon = (props)=>/*#__PURE__*/ $3e8828e45bde362b$var$_react.default.createElement($3e8828e45bde362b$var$_file.default, Object.assign({
        LEGACY_fallbackIcon: $3e8828e45bde362b$var$_documentFilled.default
    }, props));
$3e8828e45bde362b$var$FileIcon.Name = 'FileIconMigration';
var $3e8828e45bde362b$var$_default = module.exports.default = $3e8828e45bde362b$var$FileIcon;

});
parcelRegister("1NlXW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14eb6801df53e470$var$_react = $14eb6801df53e470$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $14eb6801df53e470$var$_baseNew = $14eb6801df53e470$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $14eb6801df53e470$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14eb6801df53e470$var$FileIcon = (props)=>/*#__PURE__*/ $14eb6801df53e470$var$_react.default.createElement($14eb6801df53e470$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$14eb6801df53e470$var$FileIcon.displayName = 'FileIcon';
var $14eb6801df53e470$var$_default = module.exports.default = $14eb6801df53e470$var$FileIcon;

});

parcelRegister("53J27", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3af02a3bc9667b59$var$_react = $3af02a3bc9667b59$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3af02a3bc9667b59$var$_file = $3af02a3bc9667b59$var$_interopRequireDefault((parcelRequire("1NlXW")));
function $3af02a3bc9667b59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3af02a3bc9667b59$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $3af02a3bc9667b59$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props, {
        newIcon: $3af02a3bc9667b59$var$_file.default
    }));
$3af02a3bc9667b59$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $3af02a3bc9667b59$var$_default = module.exports.default = $3af02a3bc9667b59$var$DocumentFilledIcon;

});


parcelRegister("gVXQp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a29a66c0c086b650$export$2e2bcd8739ae039);

var $h7zk4 = parcelRequire("h7zk4");

var $es8mD = parcelRequire("es8mD");

var $fDskX = parcelRequire("fDskX");

var $50H21 = parcelRequire("50H21");
const $a29a66c0c086b650$var$ChartBarIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($fDskX))), 'purpleBold', (0, $50H21.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($h7zk4))), (0, (/*@__PURE__*/$parcel$interopDefault($es8mD)))));
$a29a66c0c086b650$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $a29a66c0c086b650$export$2e2bcd8739ae039 = $a29a66c0c086b650$var$ChartBarIconWithColor;

});
parcelRegister("h7zk4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c76e7d7523f812d3$var$_react = $c76e7d7523f812d3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $c76e7d7523f812d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c76e7d7523f812d3$var$Presentation16Icon = (props)=>/*#__PURE__*/ $c76e7d7523f812d3$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$c76e7d7523f812d3$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $c76e7d7523f812d3$var$_default = module.exports.default = $c76e7d7523f812d3$var$Presentation16Icon;

});

parcelRegister("fDskX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::938052aeb81071adc088ccde54cc9808>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6207aa8debd29f4$var$_react = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b6207aa8debd29f4$var$_baseNew = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b6207aa8debd29f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6207aa8debd29f4$var$ChartBarIcon = (props)=>/*#__PURE__*/ $b6207aa8debd29f4$var$_react.default.createElement($b6207aa8debd29f4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.333 1.75a.75.75 0 0 1 .75-.75h4.167a.75.75 0 0 1 .75.75V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9.75A.75.75 0 0 1 1.75 9h3.417V5.75a.75.75 0 0 1 .75-.75h3.416zm0 4.75H6.667v7h2.666zm1.5 7H13a.5.5 0 0 0 .5-.5V2.5h-2.667zm-5.666 0v-3H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$b6207aa8debd29f4$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $b6207aa8debd29f4$var$_default = module.exports.default = $b6207aa8debd29f4$var$ChartBarIcon;

});


parcelRegister("3vtQf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cb5c4b8517518bd8$export$2e2bcd8739ae039);

var $7BHMh = parcelRequire("7BHMh");

var $jGmM2 = parcelRequire("jGmM2");

var $1NlXW = parcelRequire("1NlXW");

var $50H21 = parcelRequire("50H21");
const $cb5c4b8517518bd8$var$FileIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($1NlXW))), 'grayBold', (0, $50H21.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($7BHMh))), (0, (/*@__PURE__*/$parcel$interopDefault($jGmM2)))));
$cb5c4b8517518bd8$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $cb5c4b8517518bd8$export$2e2bcd8739ae039 = $cb5c4b8517518bd8$var$FileIconWithColor;

});
parcelRegister("7BHMh", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $589df26f9969902f$var$_react = $589df26f9969902f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $589df26f9969902f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $589df26f9969902f$var$Generic16Icon = (props)=>/*#__PURE__*/ $589df26f9969902f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$589df26f9969902f$var$Generic16Icon.displayName = 'Generic16Icon';
var $589df26f9969902f$var$_default = module.exports.default = $589df26f9969902f$var$Generic16Icon;

});

parcelRegister("jGmM2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e5439afabf017b97$var$_react = $e5439afabf017b97$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $e5439afabf017b97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e5439afabf017b97$var$Generic24Icon = (props)=>/*#__PURE__*/ $e5439afabf017b97$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e5439afabf017b97$var$Generic24Icon.displayName = 'Generic24Icon';
var $e5439afabf017b97$var$_default = module.exports.default = $e5439afabf017b97$var$Generic24Icon;

});


parcelRegister("9bx9i", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $dad84149a00c7077$export$2e2bcd8739ae039);

var $2Bgv8 = parcelRequire("2Bgv8");

var $8SPcB = parcelRequire("8SPcB");

var $bEjt9 = parcelRequire("bEjt9");

var $50H21 = parcelRequire("50H21");
const $dad84149a00c7077$var$ListBulletedIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($bEjt9))), 'greenBold', (0, $50H21.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($2Bgv8))), (0, (/*@__PURE__*/$parcel$interopDefault($8SPcB)))));
$dad84149a00c7077$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $dad84149a00c7077$export$2e2bcd8739ae039 = $dad84149a00c7077$var$ListBulletedIconWithColor;

});
parcelRegister("2Bgv8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1e4bd645869fad1d$var$_react = $1e4bd645869fad1d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1e4bd645869fad1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e4bd645869fad1d$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $1e4bd645869fad1d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$1e4bd645869fad1d$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $1e4bd645869fad1d$var$_default = module.exports.default = $1e4bd645869fad1d$var$Spreadsheet16Icon;

});



parcelRegister("i6XYa", function(module, exports) {

$parcel$export(module.exports, "extractIconFromTask", () => $4a76bae5211e39a4$export$321256ed044e3100);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iAkpb = parcelRequire("iAkpb");

var $jnURg = parcelRequire("jnURg");

var $gAdQO = parcelRequire("gAdQO");

var $6ClRv = parcelRequire("6ClRv");

var $kQSMP = parcelRequire("kQSMP");

var $1ni2E = parcelRequire("1ni2E");

var $kvhCa = parcelRequire("kvhCa");

var $dvo9I = parcelRequire("dvo9I");

var $ercGv = parcelRequire("ercGv");

var $dvNbb = parcelRequire("dvNbb");
const $4a76bae5211e39a4$var$TaskIcon = (0, $ercGv.default);
const $4a76bae5211e39a4$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    const defaultIcon = /*#__PURE__*/ (0, $2OMIu.jsx)($4a76bae5211e39a4$var$TaskIcon, {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $dvNbb.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $dvNbb.JIRA_TASK:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ercGv.default), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $dvNbb.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dvo9I.default), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $dvNbb.JIRA_STORY:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kvhCa.default), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $dvNbb.JIRA_BUG:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iAkpb.default), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $dvNbb.JIRA_EPIC:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gAdQO.default), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $dvNbb.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ClRv.default), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $dvNbb.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQSMP.default), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $dvNbb.JIRA_CHANGE:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnURg.default), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $dvNbb.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1ni2E.default), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $dvNbb.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("iAkpb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $95722ca43be940d9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f047f6f7bd48e9a2ba7394ee23b095>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $i6z47 = parcelRequire("i6z47");

var $VSDnB = parcelRequire("VSDnB");

var $dTB4u = parcelRequire("dTB4u");
/**
 * __16px `bug` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $95722ca43be940d9$var$Bug16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i6z47))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTB4u.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTB4u.default), {
        label: label,
        testId: testId
    });
};
$95722ca43be940d9$var$Bug16Icon.displayName = 'Bug16Icon';
var $95722ca43be940d9$export$2e2bcd8739ae039 = $95722ca43be940d9$var$Bug16Icon;

});
parcelRegister("i6z47", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2e3fcca8ec2d82f$var$_react = $d2e3fcca8ec2d82f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d2e3fcca8ec2d82f$var$_baseNew = $d2e3fcca8ec2d82f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d2e3fcca8ec2d82f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2e3fcca8ec2d82f$var$BugIcon = (props)=>/*#__PURE__*/ $d2e3fcca8ec2d82f$var$_react.default.createElement($d2e3fcca8ec2d82f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$d2e3fcca8ec2d82f$var$BugIcon.displayName = 'BugIcon';
var $d2e3fcca8ec2d82f$var$_default = module.exports.default = $d2e3fcca8ec2d82f$var$BugIcon;

});

parcelRegister("dTB4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35369c9d3f28a25$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508e97af907f08dc14fc66e28b081e3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $d35369c9d3f28a25$var$Bug16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`,
        ...props,
        size: "small"
    });
$d35369c9d3f28a25$var$Bug16Icon.displayName = 'Bug16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d35369c9d3f28a25$export$2e2bcd8739ae039 = $d35369c9d3f28a25$var$Bug16Icon;

});


parcelRegister("jnURg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3bbc99392e8686bf$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ee9d05b0e18fef4787b81f1748fa21a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $3Vx3e = parcelRequire("3Vx3e");

var $VSDnB = parcelRequire("VSDnB");

var $8vXv7 = parcelRequire("8vXv7");
/**
 * __16px `changes` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $3bbc99392e8686bf$var$Changes16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Vx3e))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8vXv7.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8vXv7.default), {
        label: label,
        testId: testId
    });
};
$3bbc99392e8686bf$var$Changes16Icon.displayName = 'Changes16Icon';
var $3bbc99392e8686bf$export$2e2bcd8739ae039 = $3bbc99392e8686bf$var$Changes16Icon;

});
parcelRegister("3Vx3e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2dc055420c806e0d$var$_react = $2dc055420c806e0d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2dc055420c806e0d$var$_baseNew = $2dc055420c806e0d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2dc055420c806e0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2dc055420c806e0d$var$ChangesIcon = (props)=>/*#__PURE__*/ $2dc055420c806e0d$var$_react.default.createElement($2dc055420c806e0d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$2dc055420c806e0d$var$ChangesIcon.displayName = 'ChangesIcon';
var $2dc055420c806e0d$var$_default = module.exports.default = $2dc055420c806e0d$var$ChangesIcon;

});

parcelRegister("8vXv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $057d039125c231f1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::281636a4b7ecb1d97df53dcc5763d1a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $057d039125c231f1$var$Changes16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 1 0 4.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L5.456 9h5.134l-.877.876a1 1 0 1 0 1.414 1.415l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292.999.999 0 0 0-.707 1.707zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$057d039125c231f1$var$Changes16Icon.displayName = 'Changes16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$057d039125c231f1$export$2e2bcd8739ae039 = $057d039125c231f1$var$Changes16Icon;

});


parcelRegister("gAdQO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $45d4358dfe9bfcd5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fec5072b15ea4111438ac6700ce61b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $5AZiN = parcelRequire("5AZiN");

var $VSDnB = parcelRequire("VSDnB");

var $37F19 = parcelRequire("37F19");
/**
 * __16px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $45d4358dfe9bfcd5$var$Epic16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5AZiN))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $37F19.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $37F19.default), {
        label: label,
        testId: testId
    });
};
$45d4358dfe9bfcd5$var$Epic16Icon.displayName = 'Epic16Icon';
var $45d4358dfe9bfcd5$export$2e2bcd8739ae039 = $45d4358dfe9bfcd5$var$Epic16Icon;

});
parcelRegister("5AZiN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69c5703d29cce34dd1176fbc8fceb659>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $412fddddb485461d$var$_react = $412fddddb485461d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $412fddddb485461d$var$_baseNew = $412fddddb485461d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $412fddddb485461d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $412fddddb485461d$var$EpicIcon = (props)=>/*#__PURE__*/ $412fddddb485461d$var$_react.default.createElement($412fddddb485461d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$412fddddb485461d$var$EpicIcon.displayName = 'EpicIcon';
var $412fddddb485461d$var$_default = module.exports.default = $412fddddb485461d$var$EpicIcon;

});

parcelRegister("37F19", function(module, exports) {

$parcel$export(module.exports, "default", () => $43bfed8f132140c5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cb559f656356bdb13b54acac6c1eee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $43bfed8f132140c5$var$Epic16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9.912 7.767A.5.5 0 0 0 12 7.5a.5.5 0 0 0-.5-.5H9V3.5a.495.495 0 0 0-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.5.5 0 0 0 4 8.5a.5.5 0 0 0 .5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 0 0 .5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033z"/></svg>`,
        ...props,
        size: "small"
    });
$43bfed8f132140c5$var$Epic16Icon.displayName = 'Epic16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43bfed8f132140c5$export$2e2bcd8739ae039 = $43bfed8f132140c5$var$Epic16Icon;

});


parcelRegister("6ClRv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $03a4ac4c743fc34a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9beea2179909206f90938b1cce486fe2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $fNZB4 = parcelRequire("fNZB4");

var $VSDnB = parcelRequire("VSDnB");

var $l66Lz = parcelRequire("l66Lz");
/**
 * __16px `incident` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $03a4ac4c743fc34a$var$Incident16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fNZB4))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l66Lz.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l66Lz.default), {
        label: label,
        testId: testId
    });
};
$03a4ac4c743fc34a$var$Incident16Icon.displayName = 'Incident16Icon';
var $03a4ac4c743fc34a$export$2e2bcd8739ae039 = $03a4ac4c743fc34a$var$Incident16Icon;

});
parcelRegister("fNZB4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b81b36817ee75239$var$_react = $b81b36817ee75239$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b81b36817ee75239$var$_baseNew = $b81b36817ee75239$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b81b36817ee75239$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b81b36817ee75239$var$IncidentIcon = (props)=>/*#__PURE__*/ $b81b36817ee75239$var$_react.default.createElement($b81b36817ee75239$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$b81b36817ee75239$var$IncidentIcon.displayName = 'IncidentIcon';
var $b81b36817ee75239$var$_default = module.exports.default = $b81b36817ee75239$var$IncidentIcon;

});

parcelRegister("l66Lz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b197eb4db6e194a4$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dce0ac1582dc2507da5f80cdb2ca3ec0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $b197eb4db6e194a4$var$Incident16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499zM4 11a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1zm1.856-4h4.288L8.942 3.632a1 1 0 0 0-1.884 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$b197eb4db6e194a4$var$Incident16Icon.displayName = 'Incident16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b197eb4db6e194a4$export$2e2bcd8739ae039 = $b197eb4db6e194a4$var$Incident16Icon;

});


parcelRegister("kQSMP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7ed36b810abfd088$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6546d4aeab39dc918bda403f727c61ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $lhPtH = parcelRequire("lhPtH");

var $VSDnB = parcelRequire("VSDnB");

var $8oSh9 = parcelRequire("8oSh9");
/**
 * __16px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $7ed36b810abfd088$var$Issue16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lhPtH))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8oSh9.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8oSh9.default), {
        label: label,
        testId: testId
    });
};
$7ed36b810abfd088$var$Issue16Icon.displayName = 'Issue16Icon';
var $7ed36b810abfd088$export$2e2bcd8739ae039 = $7ed36b810abfd088$var$Issue16Icon;

});
parcelRegister("lhPtH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16b1a013266ea85d8875a6b5e1d2412a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7f31df16698d05e$var$_react = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7f31df16698d05e$var$_baseNew = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f7f31df16698d05e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7f31df16698d05e$var$WorkItemIcon = (props)=>/*#__PURE__*/ $f7f31df16698d05e$var$_react.default.createElement($f7f31df16698d05e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$f7f31df16698d05e$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $f7f31df16698d05e$var$_default = module.exports.default = $f7f31df16698d05e$var$WorkItemIcon;

});

parcelRegister("8oSh9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0610242619823e8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a9a249fb572b3dfc8cacf8f2a204c85>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $d0610242619823e8$var$Issue16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`,
        ...props,
        size: "small"
    });
$d0610242619823e8$var$Issue16Icon.displayName = 'Issue16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d0610242619823e8$export$2e2bcd8739ae039 = $d0610242619823e8$var$Issue16Icon;

});


parcelRegister("1ni2E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0df6901e91a4c816$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b69e4602c3c1878109c2ce1bcc3a020>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $v8u7G = parcelRequire("v8u7G");

var $VSDnB = parcelRequire("VSDnB");

var $c6n91 = parcelRequire("c6n91");
/**
 * __16px `problem` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $0df6901e91a4c816$var$Problem16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($v8u7G))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c6n91.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c6n91.default), {
        label: label,
        testId: testId
    });
};
$0df6901e91a4c816$var$Problem16Icon.displayName = 'Problem16Icon';
var $0df6901e91a4c816$export$2e2bcd8739ae039 = $0df6901e91a4c816$var$Problem16Icon;

});
parcelRegister("v8u7G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ad59de50cbf2d9cd9f6ad629f1ce9da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05d97a47b15d3c35$var$_react = $05d97a47b15d3c35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $05d97a47b15d3c35$var$_baseNew = $05d97a47b15d3c35$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $05d97a47b15d3c35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05d97a47b15d3c35$var$ProblemIcon = (props)=>/*#__PURE__*/ $05d97a47b15d3c35$var$_react.default.createElement($05d97a47b15d3c35$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343a8 8 0 1 1 11.314 11.315A8 8 0 0 1 2.343 2.343m.561 1.622a6.5 6.5 0 0 0 9.13 9.13zm9.693-.562a6.5 6.5 0 0 0-8.632-.499l9.13 9.13a6.5 6.5 0 0 0-.498-8.63"/>`
    }, props));
$05d97a47b15d3c35$var$ProblemIcon.displayName = 'ProblemIcon';
var $05d97a47b15d3c35$var$_default = module.exports.default = $05d97a47b15d3c35$var$ProblemIcon;

});

parcelRegister("c6n91", function(module, exports) {

$parcel$export(module.exports, "default", () => $9beef7a5821119de$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03a2258325f093d634d77334f2165e7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $9beef7a5821119de$var$Problem16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="m5.968 11.446 5.478-5.478a4 4 0 0 1-5.478 5.478m-1.414-1.414a4 4 0 0 1 5.478-5.478zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/></svg>`,
        ...props,
        size: "small"
    });
$9beef7a5821119de$var$Problem16Icon.displayName = 'Problem16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9beef7a5821119de$export$2e2bcd8739ae039 = $9beef7a5821119de$var$Problem16Icon;

});


parcelRegister("kvhCa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $58497e342f0afaee$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7dc9560f1e0ba735793d18700483c5f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $7Fct1 = parcelRequire("7Fct1");

var $VSDnB = parcelRequire("VSDnB");

var $fjoZ1 = parcelRequire("fjoZ1");
/**
 * __16px `story` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $58497e342f0afaee$var$Story16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Fct1))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fjoZ1.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fjoZ1.default), {
        label: label,
        testId: testId
    });
};
$58497e342f0afaee$var$Story16Icon.displayName = 'Story16Icon';
var $58497e342f0afaee$export$2e2bcd8739ae039 = $58497e342f0afaee$var$Story16Icon;

});
parcelRegister("7Fct1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57b828e09f9287500323fc5bcdd6b33d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $594608750eb4424e$var$_react = $594608750eb4424e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $594608750eb4424e$var$_baseNew = $594608750eb4424e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $594608750eb4424e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $594608750eb4424e$var$StoryIcon = (props)=>/*#__PURE__*/ $594608750eb4424e$var$_react.default.createElement($594608750eb4424e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$594608750eb4424e$var$StoryIcon.displayName = 'StoryIcon';
var $594608750eb4424e$var$_default = module.exports.default = $594608750eb4424e$var$StoryIcon;

});

parcelRegister("fjoZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d38a9d1e30071735$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fd8d8228b7585fa76e9cb13da3baf72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $d38a9d1e30071735$var$Story16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`,
        ...props,
        size: "small"
    });
$d38a9d1e30071735$var$Story16Icon.displayName = 'Story16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d38a9d1e30071735$export$2e2bcd8739ae039 = $d38a9d1e30071735$var$Story16Icon;

});


parcelRegister("dvo9I", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $158d2140cdc19c0f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::169a13a2ae270c089103a5ea3de6fc67>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $iRvAI = parcelRequire("iRvAI");

var $VSDnB = parcelRequire("VSDnB");

var $5WrPu = parcelRequire("5WrPu");
/**
 * __16px `subtask` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $158d2140cdc19c0f$var$Subtask16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRvAI))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5WrPu.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5WrPu.default), {
        label: label,
        testId: testId
    });
};
$158d2140cdc19c0f$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $158d2140cdc19c0f$export$2e2bcd8739ae039 = $158d2140cdc19c0f$var$Subtask16Icon;

});
parcelRegister("iRvAI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb1eed99abd44e812ae4cb98f136c93f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbb5ae8ec700c853$var$_react = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dbb5ae8ec700c853$var$_baseNew = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $dbb5ae8ec700c853$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbb5ae8ec700c853$var$SubtasksIcon = (props)=>/*#__PURE__*/ $dbb5ae8ec700c853$var$_react.default.createElement($dbb5ae8ec700c853$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$dbb5ae8ec700c853$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $dbb5ae8ec700c853$var$_default = module.exports.default = $dbb5ae8ec700c853$var$SubtasksIcon;

});

parcelRegister("5WrPu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0252c73d4b8f4e03$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cad22e1176a9874a0c269f62ca4a13d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $0252c73d4b8f4e03$var$Subtask16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M9 7V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM9 9h2v2H9zM5 5h2v2H5z"/></svg>`,
        ...props,
        size: "small"
    });
$0252c73d4b8f4e03$var$Subtask16Icon.displayName = 'Subtask16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0252c73d4b8f4e03$export$2e2bcd8739ae039 = $0252c73d4b8f4e03$var$Subtask16Icon;

});




parcelRegister("8Kv84", function(module, exports) {

$parcel$export(module.exports, "extractTitleTextColor", () => $ae5231d890ad8c03$export$a2afc198e9dada1);


var $4DoyP = parcelRequire("4DoyP");
const $ae5231d890ad8c03$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $4DoyP.extractorPriorityMap)[b] - (0, $4DoyP.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $829f609a65d26a98$export$2837b5a1a71d5c02})`;
            default:
                return undefined;
        }
    }
};

});

parcelRegister("6tk3N", function(module, exports) {

$parcel$export(module.exports, "extractTitlePrefix", () => $c60268a167a69ea9$export$58d9bc37318dfb32);
const $c60268a167a69ea9$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $c60268a167a69ea9$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $c60268a167a69ea9$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});


parcelRegister("ir8YW", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvedView", () => $e6bd8b33974efcaa$export$6d5912cb4b56390e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $VSDnB = parcelRequire("VSDnB");

var $hHEfn = parcelRequire("hHEfn");

var $6x7n6 = parcelRequire("6x7n6");

var $kkxZO = parcelRequire("kkxZO");

var $6oaVw = parcelRequire("6oaVw");
class $e6bd8b33974efcaa$export$6d5912cb4b56390e extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge) return null;
        const appearance = lozenge.appearance || 'default';
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-inline-lozenge')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6x7n6.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge?.style?.backgroundColor,
                color: lozenge?.style?.color
            },
            isBold: (0, $VSDnB.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
            children: lozenge.text
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.LozengeWrapper), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aYAc3.default), {
                testId: "inline-card-resolved-view-lozenge",
                appearance: appearance,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: lozenge.style,
                isBold: (0, $VSDnB.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
                children: lozenge.text
            })
        });
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            truncateInline: truncateInline,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                    emoji: titlePrefix,
                    icon: icon,
                    title: title,
                    titleTextColor: titleTextColor,
                    ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
                        type: type
                    }
                }),
                this.renderLozenge()
            ]
        });
        if (showHoverPreview && link) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions,
            ...!(0, $VSDnB.fg)('platform_bandicoots-smart-card-disable-aria') ? {
                showLabel: false
            } : {},
            children: inlineCardResolvedView
        });
        return inlineCardResolvedView;
    }
}

});
parcelRegister("6x7n6", function(module, exports) {

$parcel$export(module.exports, "default", () => $af25c54e4444d79c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aYAc3 = parcelRequire("aYAc3");
const $af25c54e4444d79c$var$wrapperStyles = null;
const $af25c54e4444d79c$var$InlineLozenge = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aYAc3.default), {
            ...props
        })
    });
var $af25c54e4444d79c$export$2e2bcd8739ae039 = $af25c54e4444d79c$var$InlineLozenge;

});

parcelRegister("6oaVw", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $fce424d2cf27c0bc$export$d34be4d513116847);
$parcel$export(module.exports, "IconTitleWrapper", () => $fce424d2cf27c0bc$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $fce424d2cf27c0bc$export$75180efdd3f4d9c2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $bmnhy = parcelRequire("bmnhy");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $kxcRq = parcelRequire("kxcRq");

var $6P7yN = parcelRequire("6P7yN");

var $1Fo58 = parcelRequire("1Fo58");
const $fce424d2cf27c0bc$var$iconWrapperStyle = null;
const $fce424d2cf27c0bc$var$iconImageStyle = null;
const $fce424d2cf27c0bc$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkogqwt",
    noLinkAppearanceStyle: "_syaz131l _18u01b66",
    roundImageStyle: "_2rko14q2"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $fce424d2cf27c0bc$var$NoLinkAppearanceOldVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1wmz _18u01b66",
            __cmplp.className
        ])
    });
});
const $fce424d2cf27c0bc$var$LinkAppearance = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1y58 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $fce424d2cf27c0bc$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type })=>{
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        if (emoji) {
            if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return emoji;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.EmojiWrapperOldVisualRefresh), {
                children: emoji
            });
        }
        if (!icon || typeof icon === 'string') return null;
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return icon;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconWrapperOldVisualRefresh), {
            children: icon
        });
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? (0, $kxcRq.isProfileType)(type) : false;
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((errored, testId)=>{
        (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))));
        if (!icon || typeof icon !== 'string') return null;
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
            src: icon,
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                className: (0, $bwpsq.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $fce424d2cf27c0bc$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6P7yN.Shimmer), {
                testId: `${testId}-loading`
            })
        });
        const removedProps = !(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? {
            className: 'smart-link-icon'
        } : {};
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
            src: icon,
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6P7yN.Icon), {
                ...removedProps,
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                className: (0, $bwpsq.default)([
                    profileType && $fce424d2cf27c0bc$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6P7yN.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }, [
        icon,
        profileType
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((testId)=>{
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return defaultIcon || /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`,
            color: "currentColor"
        });
        if (defaultIcon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconWrapperOldVisualRefresh), {
            children: defaultIcon
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconWrapperOldVisualRefresh), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
                label: "link",
                LEGACY_size: "small",
                testId: `${testId}-default`,
                color: "currentColor"
            })
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                // EDM-12119: This is set here to help with the positioning of the icon to be in the middle of inline display.
                // We cannot set the fix font because inline is taking the parent container font size into account.
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                style: {
                    lineHeight: `1`
                },
                xcss: $fce424d2cf27c0bc$var$styles.iconOuterWrapperStyle,
                testId: "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            as: "span",
                            xcss: $fce424d2cf27c0bc$var$styles.iconEmptyStyle,
                            testId: "icon-empty-wrapper"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testId": "icon-wrapper",
                            className: (0, $bwpsq.default)([
                                "_11c81o8v _2rkoyh40 _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
                            ]),
                            children: renderIcon(testId)
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconPositionWrapperOldVisualRefresh), {
                "data-testid": "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconEmptyWrapperOldVisualRefresh), {
                            "data-testid": "icon-empty-wrapper"
                        }),
                        renderIcon(testId)
                    ]
                })
            }),
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                style: {
                    color: titleTextColor
                },
                children: title
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                style: {
                    color: titleTextColor
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $1Fo58.TitleWrapperClassNameOldVisualRefresh),
                children: title
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsxs)($fce424d2cf27c0bc$export$c73a53738ef9e3f, {
            style: {
                color: titleColor
            },
            testId: testId,
            children: [
                link ? /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    className: (0, $bwpsq.default)([
                        $fce424d2cf27c0bc$var$styles.linkStyle
                    ]),
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    as: "span",
                    xcss: $fce424d2cf27c0bc$var$styles.noLinkAppearanceStyle,
                    children: rightSide
                }) : null
            ]
        }) : /*#__PURE__*/ (0, $2OMIu.jsxs)($fce424d2cf27c0bc$var$IconTitleWrapperOldVisualRefresh, {
            style: {
                color: titleColor
            },
            "data-testid": testId,
            children: [
                link ? /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$NoLinkAppearanceOldVisualRefresh, {
                    children: rightSide
                }) : null
            ]
        })
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $fce424d2cf27c0bc$var$IconTitleWrapperOldVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});
const $fce424d2cf27c0bc$export$c73a53738ef9e3f = (props)=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $fce424d2cf27c0bc$var$styles.iconTitleWrapperStyle,
        ...props
    });
    // note: This is just to get the types to work due to compiled css weirdness.
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$IconTitleWrapperOldVisualRefresh, {
        ...props
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $fce424d2cf27c0bc$var$LozengeWrapperOldVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o",
            __cmplp.className
        ])
    });
});
const $fce424d2cf27c0bc$export$75180efdd3f4d9c2 = (props)=>{
    // note: This is just to get the types to work due to compiled css weirdness.
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$LozengeWrapperOldVisualRefresh, {
        ...props
    });
};

});
parcelRegister("6P7yN", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $1cc6345298e1009b$export$f04a61298a47a40f);
$parcel$export(module.exports, "Shimmer", () => $1cc6345298e1009b$export$809644b82cfe94b1);
/* Icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3oVhZ = parcelRequire("3oVhZ");
const $1cc6345298e1009b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $1cc6345298e1009b$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3oVhZ.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: 2,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("3oVhZ", function(module, exports) {

$parcel$export(module.exports, "SpanSkeleton", () => $d9c8a8c862f581db$export$85d5658002cae6ce);
$parcel$export(module.exports, "Skeleton", () => $d9c8a8c862f581db$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $d9c8a8c862f581db$var$placeholderShimmer = null;
const $d9c8a8c862f581db$var$appearanceValues = {
    darkGray: {
        animation: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$export$c2e91cbeada39b8b)})`
    },
    gray: {
        animation: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #cce0ff)"
    }
};
const $d9c8a8c862f581db$var$spanSkeletonStyles = null;
const $d9c8a8c862f581db$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhk1cs6",
    blue: "_bfhk1hdx",
    darkGray: "_bfhk1gk7"
};
const $d9c8a8c862f581db$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$d9c8a8c862f581db$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $bwpsq.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $d9c8a8c862f581db$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $d9c8a8c862f581db$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$d9c8a8c862f581db$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $bwpsq.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $d9c8a8c862f581db$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $d9c8a8c862f581db$export$2e2bcd8739ae039 = $d9c8a8c862f581db$export$8f31e4c4a37b8e9c;

});


parcelRegister("1Fo58", function(module, exports) {

$parcel$export(module.exports, "IconWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$abdbe8c4b7f7dbc0);
$parcel$export(module.exports, "EmojiWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$d1387355dd734414);
$parcel$export(module.exports, "IconTitleWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$c635ccf8b1286a3a);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $13bc30456c869fbe$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$989c0529a97b612a);
$parcel$export(module.exports, "IconEmptyWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$87c6f228b0cd0750);
$parcel$export(module.exports, "TitleWrapperClassNameOldVisualRefresh", () => $13bc30456c869fbe$export$65af995e438d6ba4);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // Wraps all icons represented in Inline Links. Icons have three sources/types:
// - JSON-LD: from the generator.icon property coming back from ORS.
// - @atlaskit/icon: for lock icons, unauthorized, etc.
// - @atlaskit/icon-object: for object icons, e.g. repository, branch, etc.
// NB: the first set of overrides style icons imported from @atlaskit/icon-object correctly.
// NB: the second set of overrides style icons imported from @atlaskit/icon correctly.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $13bc30456c869fbe$var$IconObjectOverrides = `
  & > span {
    height: 16px;
    width: 16px;
    position: absolute;
    top: 3px;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
// TODO: remove this override behaviour for @atlaskit/icon
const $13bc30456c869fbe$var$IconOverrides = `
  & > * > span {
    height: 16px;
    width: 16px;
    position: absolute;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $13bc30456c869fbe$export$abdbe8c4b7f7dbc0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_uiztglyw _17047vkz _iibf7vkz _lacastnw _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe _1f027vkz _nbgx7vkz _4d7tstnw _o5fv1l7b _3g5ridpf _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$d1387355dd734414 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _2hwxv77o _uiztglyw _17047vkz _iibf7vkz _lacastnw _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe _1f027vkz _nbgx7vkz _4d7tstnw _o5fv1l7b _3g5ridpf _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$c635ccf8b1286a3a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$8228f3d531b6be20 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$91b164375b8037b5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$989c0529a97b612a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwx1b66 _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$87c6f228b0cd0750 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$65af995e438d6ba4 = 'smart-link-title-wrapper';
const $13bc30456c869fbe$export$3bc08b0c31e5f53e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.className
        ])
    });
});

});



parcelRegister("iJqW5", function(module, exports) {

$parcel$export(module.exports, "EmbedCardErroredView", () => $223c5d6a864b7795$export$6819d845957344e);
/* ErroredView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $dD7Zc = parcelRequire("dD7Zc");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");


var $7zaVw = parcelRequire("7zaVw");

var $7TGH2 = parcelRequire("7TGH2");
const $223c5d6a864b7795$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $223c5d6a864b7795$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7TGH2.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                LEGACY_size: "small",
                color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
                label: "error-icon"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $223c5d6a864b7795$var$styles.boxStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $7zaVw.messages).could_not_load_link
                    })
                })
            }),
            (0, $VSDnB.fg)('platform-smart-card-remove-legacy-button') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                testId: "err-view-retry",
                spacing: "compact",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).try_again
                })
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                testId: "err-view-retry",
                appearance: "link",
                spacing: "none",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).try_again
                })
            })
        ]
    });

});
parcelRegister("7TGH2", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $07a1a38b3dfd1707$export$b89a827e9254211a);
/* ErrorFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $07a1a38b3dfd1707$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, $2OMIu.jsx)($07a1a38b3dfd1707$export$f862a410248f4f00, {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($07a1a38b3dfd1707$export$7b360cd785b6c366, {
        ...props
    });
const $07a1a38b3dfd1707$var$sharedBaseFrameStyles = null;
const $07a1a38b3dfd1707$var$sharedFrameStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameHoverStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameFluidHeightTrueStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameFluidHeightFalseStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameSelectedStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameNotSelectedStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameStyles = null;
const $07a1a38b3dfd1707$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3k6hx _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rko1l7b _1h6d1can _1dqonqa1 _189eyh40" : "_2rko1lya _1h6d3acm _1dqonqa1 _189eyh40",
            "_1reo15vq _18m915vq _1bah1yb4 _16qs1os1",
            className
        ]),
        "data-trello-do-not-use-override": testId,
        children: children
    });
};
const $07a1a38b3dfd1707$var$compactFrameHoverStyles = null;
const $07a1a38b3dfd1707$var$compactFrameInheritDimensionsTrueStyles = null;
const $07a1a38b3dfd1707$var$compactFrameInheritDimensionsFalseStyles = null;
const $07a1a38b3dfd1707$var$compactFrameAlignStyles = null;
const $07a1a38b3dfd1707$var$compactFrameStyles = null;
const $07a1a38b3dfd1707$var$compactFrameNotSelectedStyles = null;
const $07a1a38b3dfd1707$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3yw9d",
            isSelected && "_2rko1l7b _1h6d1can _1dqonqa1 _189eyh40",
            !isSelected && "_2rko1lya",
            "_1bah1h6o _4cvr1h6o _bfhkiw92",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ]),
        children: children
    });
};

});


parcelRegister("39ESV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87a1f0d324217dd9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");

var $cL21r = parcelRequire("cL21r");

var $8m9FN = parcelRequire("8m9FN");

var $4ec1m = parcelRequire("4ec1m");
const $87a1f0d324217dd9$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $5uXOq.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                children: hostname
            })
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
	 * if there is a request access context, but no action to perform, do not show any button.
	 * By default, a "Try another account" button shows, but with request access context, we don't
	 * want to encourage users to try another account, if their request is already pending, etc.
	 */ const button = (0, $5uXOq.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        const ButtonComponent = (0, $VSDnB.fg)('platform-smart-card-remove-legacy-button') ? (0, $eCeGD.default) : (0, $fVnbM.default);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ButtonComponent, {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $cL21r.toMessage)((0, $7zaVw.messages).try_another_account, callToActionMessageKey),
                values: values
            })
        });
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8m9FN.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ec1m.ForbiddenSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $cL21r.toMessage)((0, $7zaVw.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $cL21r.toMessage)((0, $7zaVw.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $87a1f0d324217dd9$export$2e2bcd8739ae039 = $87a1f0d324217dd9$var$ForbiddenView;

});
parcelRegister("8m9FN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be3576ed5cf1944$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $jOyH3 = parcelRequire("jOyH3");

var $HEA7j = parcelRequire("HEA7j");

var $ckWLp = parcelRequire("ckWLp");
const $6be3576ed5cf1944$var$containerStyles = null;
const $6be3576ed5cf1944$var$contentStyles = null;
const $6be3576ed5cf1944$var$descriptionStyles = null;
const $6be3576ed5cf1944$var$imageStyles = null;
const $6be3576ed5cf1944$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $5uXOq.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckWLp.ImageIcon), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
                label: "icon",
                LEGACY_size: "small",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $5uXOq.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $bwpsq.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": imageTestId,
            className: (0, $bwpsq.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ]),
            children: imageUrlOrElement
        });
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $HEA7j.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": `${testId}-unresolved-container`,
            className: (0, $bwpsq.default)([
                "_1e0c11p5 _4t3i1kw7"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
                ]),
                children: [
                    image,
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "large",
                        testId: `${testId}-unresolved-title`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        "data-testid": `${testId}-unresolved-description`,
                        className: (0, $bwpsq.default)([
                            "_11c82smr _y3gn1h6o"
                        ]),
                        children: description
                    }),
                    button
                ]
            })
        })
    });
};
var $6be3576ed5cf1944$export$2e2bcd8739ae039 = $6be3576ed5cf1944$var$UnresolvedView;

});
parcelRegister("HEA7j", function(module, exports) {

$parcel$export(module.exports, "ExpandedFrame", () => $4aba9fa58e630365$export$7b360cd785b6c366);
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $4URMI = parcelRequire("4URMI");

var $gfnFT = parcelRequire("gfnFT");

var $f8JAn = parcelRequire("f8JAn");
const $4aba9fa58e630365$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $gfnFT.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $4URMI.useMouseDownEvent)();
    const renderHeader = ()=>{
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return frameStyle !== 'hide' && /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            className: (0, $bwpsq.default)([
                $4aba9fa58e630365$var$styles.header,
                "embed-header"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $4aba9fa58e630365$var$styles.headerIcon
                    ]),
                    children: icon
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $4aba9fa58e630365$var$styles.tooltipWrapper
                    ]),
                    children: !isPlaceholder && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: text,
                        hideTooltipOnMouseDown: true,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                            href: href,
                            onClick: handleClick,
                            onMouseDown: handleMouseDown,
                            className: (0, $bwpsq.default)([
                                $4aba9fa58e630365$var$styles.headerAnchor
                            ]),
                            children: text
                        })
                    })
                })
            ]
        });
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f8JAn.HeaderOldVisualRefresh), {
            className: "embed-header",
            frameStyle: frameStyle,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.IconWrapperOldVisualRefresh), {
                    isPlaceholder: isPlaceholder,
                    children: !isPlaceholder && icon
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.TooltipWrapperOldVisualRefresh), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: text,
                        hideTooltipOnMouseDown: true,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.TextWrapperOldVisualRefresh), {
                            isPlaceholder: isPlaceholder,
                            children: !isPlaceholder && // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                            /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                                href: href,
                                onClick: handleClick,
                                onMouseDown: handleMouseDown,
                                children: text
                            })
                        })
                    })
                })
            ]
        }));
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            className: (0, $bwpsq.default)([
                $4aba9fa58e630365$var$styles.contentStyle,
                setOverflow && allowScrollBar && $4aba9fa58e630365$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $4aba9fa58e630365$var$styles.contentInteractiveActiveBorder
            ]),
            children: children
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.ContentOldVisualRefresh), {
            "data-testid": "embed-content-wrapper",
            allowScrollBar: allowScrollBar,
            removeOverflow: !setOverflow,
            isInteractive: isInteractive(),
            frameStyle: frameStyle,
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: 'false',
            suppressContentEditableWarning: true,
            children: children
        });
    };
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $4aba9fa58e630365$var$styles.linkWrapper,
            inheritDimensions && $4aba9fa58e630365$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $4aba9fa58e630365$var$styles.linkWrapperSelected,
            showBackgroundAlways && $4aba9fa58e630365$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $4aba9fa58e630365$var$styles.linkWrapperInteractiveNotHidden,
            (0, $f8JAn.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        },
        children: [
            renderHeader(),
            renderContent()
        ]
    });
    if (!isPlaceholder && href) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f8JAn.LinkWrapperOldVisualRefresh), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $f8JAn.className),
        isInteractive: isInteractive(),
        isSelected: isSelected,
        frameStyle: frameStyle,
        minWidth: minWidth,
        maxWidth: maxWidth,
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        inheritDimensions: inheritDimensions,
        children: [
            renderHeader(),
            renderContent()
        ]
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f8JAn.WrapperOldVisualRefresh), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $f8JAn.className),
        isInteractive: isInteractive(),
        isSelected: isSelected,
        minWidth: minWidth,
        frameStyle: frameStyle,
        maxWidth: maxWidth,
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        "data-is-selected": isSelected,
        "data-wrapper-type": "default",
        "data-is-interactive": isInteractive(),
        children: [
            renderHeader(),
            renderContent()
        ]
    });
};
const $4aba9fa58e630365$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mj1crf _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk18uv _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u92p9",
    linkWrapperBorderAndBackground: "_1tqzzgxb _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgvzgxb _4tpuhp5a _x148kb7n",
    header: "_11c8140y _zulp1b66 _1e0c1txw _4cvr1h6o _4t3igktf _1pbykb7n",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c8140y _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik18uv _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c8140y _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19it1pvm _2rko1y44 _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1ips",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};

});
parcelRegister("f8JAn", function(module, exports) {

$parcel$export(module.exports, "className", () => $f426c5b6b9ce91fc$export$2913c0c0b5623090);
$parcel$export(module.exports, "embedHeaderHeight", () => $f426c5b6b9ce91fc$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "LinkWrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$2a480844028e4ec0);
$parcel$export(module.exports, "WrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$3261c38179e5e529);
$parcel$export(module.exports, "HeaderOldVisualRefresh", () => $f426c5b6b9ce91fc$export$b23fd71055f45d1c);
$parcel$export(module.exports, "IconWrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$abdbe8c4b7f7dbc0);
$parcel$export(module.exports, "TextWrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$6c22c892e48a7e6d);
$parcel$export(module.exports, "TooltipWrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$63387b6a2966b8a1);
$parcel$export(module.exports, "ContentOldVisualRefresh", () => $f426c5b6b9ce91fc$export$ddc04b8b166e58de);
$parcel$export(module.exports, "Image", () => $f426c5b6b9ce91fc$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $f426c5b6b9ce91fc$export$2913c0c0b5623090 = 'media-card-frame';
const $f426c5b6b9ce91fc$export$8f5a73ba0d077b01 = 32;
const $f426c5b6b9ce91fc$export$2a480844028e4ec0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, frameStyle: frameStyle, minWidth: minWidth, maxWidth: maxWidth, isInteractive: isInteractive, inheritDimensions: inheritDimensions, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10q0298": (0, $lD23V.default)(__cmplp.minWidth, "px"),
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _v5641y8x _1e0c116y _2lx21bp4 _vchhusvi _ect41gqc _1bsb1osq _uiztglyw _vwz44jg8 _kqswh2mm _qc5o94zs _14mjpd34 _aetrb3bt _18postnw _1qdg1rgy _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.isSelected && __cmplp.frameStyle === 'hide' ? "_2rkoiti9" : "_2rkopd34",
            __cmplp.minWidth && "_1ul91pd6",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_1u3rh6cr",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_4tpuhp5a",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' ? "_x148kb7n" : "_x148idpf",
            __cmplp.isInteractive && "_1di629zg",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1ifikb7n" : "_1ifiidpf",
            __cmplp.inheritDimensions ? "_4t3i1osq" : "_4t3ik5xz",
            __cmplp.frameStyle === 'show' && "_631ousvi",
            __cmplp.frameStyle === 'show' ? "_z0ai1osq" : "_z0aie9lw",
            __cmplp.frameStyle !== 'show' ? "_19dox0bf" : __cmplp.isSelected ? "_19doidpf" : "_19do1kw7",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_eq43h6cr" : "_eq431kw7",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1hfkhp5a" : "_1hfk1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_6syztlke" : "_6syz1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_8x3umqxb" : "_8x3u1kw7",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$3261c38179e5e529 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, frameStyle: frameStyle, minWidth: minWidth, maxWidth: maxWidth, isInteractive: isInteractive, inheritDimensions: inheritDimensions, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10q0298": (0, $lD23V.default)(__cmplp.minWidth, "px"),
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _v5641y8x _1e0c116y _2lx21bp4 _vchhusvi _ect41gqc _1bsb1osq _uiztglyw _vwz44jg8 _kqswh2mm _19pk19bv _qc5o94zs _14mjpd34 _aetrb3bt _18postnw _1qdg1rgy",
            __cmplp.isSelected && __cmplp.frameStyle === 'hide' ? "_2rkoiti9" : "_2rkopd34",
            __cmplp.minWidth && "_1ul91pd6",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_1u3rh6cr",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_4tpuhp5a",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' ? "_x148kb7n" : "_x148idpf",
            __cmplp.isInteractive && "_1di629zg",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1ifikb7n" : "_1ifiidpf",
            __cmplp.inheritDimensions ? "_4t3i1osq" : "_4t3ik5xz",
            __cmplp.frameStyle === 'show' && "_631ousvi",
            __cmplp.frameStyle === 'show' ? "_z0ai1osq" : "_z0aie9lw",
            __cmplp.frameStyle !== 'show' ? "_19dox0bf" : __cmplp.isSelected ? "_19doidpf" : "_19do1kw7",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_eq43h6cr" : "_eq431kw7",
            __cmplp.frameStyle === 'show' ? "_1hfkhp5a" : "_1hfk1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_6syztlke" : "_6syz1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_8x3umqxb" : "_8x3u1kw7",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$b23fd71055f45d1c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { frameStyle: frameStyle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564ojwh _4t3izwfg _kqswstnw _1pbykb7n _1bsb1osq _1e0c1txw _4cvr1h6o _syazqjbk _tzy4idpf",
            __cmplp.frameStyle === 'show' && "_vchhusvi",
            __cmplp.frameStyle === 'show' && "_1yt4h8dc",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$abdbe8c4b7f7dbc0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPlaceholder: isPlaceholder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1bsb7vkz _4t3i7vkz _2hwx1b66",
            __cmplp.isPlaceholder && "_bfhkqrzy",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$6c22c892e48a7e6d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPlaceholder: isPlaceholder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1reo15vq _18m915vq _syaz1rc1 _1bto1l2s _o5721q9c",
            __cmplp.isPlaceholder && "_2rko1sit",
            __cmplp.isPlaceholder && "_1bsb176v",
            __cmplp.isPlaceholder && "_4t3i1crf",
            __cmplp.isPlaceholder && "_bfhkqrzy",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$63387b6a2966b8a1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$ddc04b8b166e58de = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { removeOverflow: removeOverflow, allowScrollBar: allowScrollBar, frameStyle: frameStyle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _19ith6cr _v56414ba _bfhkhp5a _kqswstnw _1pbykb7n _hlq8idpf _rd9b1wug _1g4jidpf _jk3p1wug",
            !__cmplp.removeOverflow && (__cmplp.allowScrollBar ? "_1reo1wug _18m91wug" : "_1reo15vq _18m915vq"),
            __cmplp.frameStyle === 'show' ? "_1bsbwgg2" : "_1bsb1osq",
            __cmplp.frameStyle === 'show' && "_18s81xf9",
            __cmplp.frameStyle === 'hide' ? "_4t3i1osq" : "_4t3i1j2a",
            __cmplp.frameStyle !== 'hide' && "_154ixy5q",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
};
const $f426c5b6b9ce91fc$export$3e431a229df88919 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $lD23V.default)($f426c5b6b9ce91fc$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $lD23V.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkqrzy _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ckWLp", function(module, exports) {

$parcel$export(module.exports, "ImageIcon", () => $e061611f1f328974$export$4a122bafaa48b23d);
/* ImageIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $bmnhy = parcelRequire("bmnhy");

var $VSDnB = parcelRequire("VSDnB");

var $f8JAn = parcelRequire("f8JAn");
const $e061611f1f328974$var$styles = {
    roundedImage: "_2rko14q2"
};
const $e061611f1f328974$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square' })=>{
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    const LoadedImageComponent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.Image), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            appearance === 'round' && (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && $e061611f1f328974$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};

});


parcelRegister("4ec1m", function(module, exports) {

$parcel$export(module.exports, "ForbiddenSVG", () => $35d20558628c8f8e$export$f51768a4e7ff128);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $35d20558628c8f8e$export$f51768a4e7ff128 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "49.4199",
                x2: "122.662",
                y1: "59.7673",
                y2: "59.7673",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                        offset: "0",
                        stopColor: "#0065ff"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                        offset: ".2188",
                        stopColor: "#0b6cff"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                        offset: ".5999",
                        stopColor: "#2780ff"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                        offset: "1",
                        stopColor: "#4c9aff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
                fill: "#ff7452"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
                fill: "#344563"
            })
        ]
    });

});


parcelRegister("5VvNe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f15eaaa942c697a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7zaVw = parcelRequire("7zaVw");

var $cL21r = parcelRequire("cL21r");

var $8m9FN = parcelRequire("8m9FN");

var $hEH3t = parcelRequire("hEH3t");
const $7f15eaaa942c697a$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $5uXOq.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8m9FN.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hEH3t.NotFoundSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $cL21r.toMessage)((0, $7zaVw.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $cL21r.toMessage)((0, $7zaVw.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $7f15eaaa942c697a$export$2e2bcd8739ae039 = $7f15eaaa942c697a$var$NotFoundView;

});
parcelRegister("hEH3t", function(module, exports) {

$parcel$export(module.exports, "NotFoundSVG", () => $23c56cd588a55ebd$export$80542c1714a314c8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $23c56cd588a55ebd$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "1316.98",
                        y1: "230.66",
                        x2: "1396.36",
                        y2: "230.66",
                        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6c798f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "170.3",
                        y1: "897.49",
                        x2: "365.15",
                        y2: "897.49",
                        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.69",
                                stopColor: "#fff",
                                stopOpacity: "0.1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("title", {
                children: "Search error"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    id: "Objects",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#cfd4db",
                            d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            id: "_Path_",
                            "data-name": "<Path>",
                            fill: "url(#linear-gradient)",
                            d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#091e42",
                            opacity: 0.1,
                            d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#344563",
                            d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            id: "_Clipping_Path_",
                            "data-name": "<Clipping Path>",
                            fill: "#deebff",
                            d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            id: "_Path_2",
                            "data-name": "<Path>",
                            fill: "#b2d4ff",
                            d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#cce0ff",
                            d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "url(#linear-gradient-2)",
                            d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("polygon", {
                            id: "_Path_3",
                            "data-name": "<Path>",
                            fill: "#5e6c84",
                            points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#ffc400",
                            d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#ffc400",
                            d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#344563",
                            d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
                        })
                    ]
                })
            })
        ]
    });

});


parcelRegister("d0weD", function(module, exports) {

$parcel$export(module.exports, "EmbedCardResolvedView", () => $6626ad9154fcc56d$export$30f3c6c32b384a8b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $hxoiH = parcelRequire("hxoiH");

var $kxcRq = parcelRequire("kxcRq");

var $HEA7j = parcelRequire("HEA7j");

var $5yako = parcelRequire("5yako");

var $ckWLp = parcelRequire("ckWLp");
const $6626ad9154fcc56d$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ link: link, context: context, onClick: onClick, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, isSupportTheming: isSupportTheming, type: type }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            label: "icon",
            LEGACY_size: "small",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    const profileType = (0, $kxcRq.isProfileType)(type) && (0, $VSDnB.fg)('platform-linking-visual-refresh-v2');
    let icon = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckWLp.ImageIcon), {
            src: src,
            default: linkGlyph,
            ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
                appearance: profileType ? 'round' : 'square'
            }
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        profileType
    ]);
    const themeState = (0, $hxoiH.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $kxcRq.getPreviewUrlWithTheme)(previewUrl, themeState);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $HEA7j.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5yako.Frame), {
            url: previewUrl,
            isTrusted: isTrusted,
            testId: testId,
            ref: embedIframeRef,
            onIframeDwell: onIframeDwell,
            onIframeFocus: onIframeFocus,
            title: text
        })
    });
});

});
parcelRegister("5yako", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $6ecba5ca7578a7ab$export$b89a827e9254211a);
/* Frame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $kxcRq = parcelRequire("kxcRq");

var $6WbQT = parcelRequire("6WbQT");

var $fcrey = parcelRequire("fcrey");
function $6ecba5ca7578a7ab$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $6ecba5ca7578a7ab$var$iframeStyles = null;
const $6ecba5ca7578a7ab$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, title: title }, iframeRef)=>{
    (0, $gKZoD.di)((0, $6WbQT.IFrame));
    const [isIframeLoaded, setIframeLoaded] = (0, $5uXOq.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $5uXOq.useState)(false);
    const [isWindowFocused, setWindowFocused] = (0, $5uXOq.useState)(true);
    const ref = (0, $5uXOq.useRef)();
    const mergedRef = $6ecba5ca7578a7ab$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $5uXOq.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $5uXOq.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const onBlur = ()=>{
            setWindowFocused(false);
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fcrey.IframeDwellTracker), {
                isIframeLoaded: isIframeLoaded,
                isMouseOver: isMouseOver,
                isWindowFocused: isWindowFocused,
                iframePercentVisible: percentVisible,
                onIframeDwell: onIframeDwell
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6WbQT.IFrame), {
                childRef: mergedRef,
                src: url,
                "data-testid": `${testId}-frame`,
                "data-iframe-loaded": isIframeLoaded,
                onMouseEnter: ()=>setMouseOver(true),
                onMouseLeave: ()=>setMouseOver(false),
                allowFullScreen: true,
                scrolling: "yes",
                allow: "autoplay; encrypted-media; clipboard-write",
                onLoad: ()=>{
                    setIframeLoaded(true);
                },
                sandbox: (0, $kxcRq.getIframeSandboxAttribute)(isTrusted),
                title: title,
                className: (0, $bwpsq.default)([
                    "_19itidpf _1reo15vq _18m915vq _2rko1l7b _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
                ])
            })
        ]
    });
});

});
parcelRegister("6WbQT", function(module, exports) {

$parcel$export(module.exports, "IFrame", () => $aafa8e6c37921cc3$export$b32b5f1ee4493319);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $aafa8e6c37921cc3$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, ...props })=>{
    // eslint-disable-next-line jsx-a11y/iframe-has-title,@atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $2OMIu.jsx)("iframe", {
        className: className,
        ...props,
        ref: childRef
    });
};

});

parcelRegister("fcrey", function(module, exports) {

$parcel$export(module.exports, "IframeDwellTracker", () => $891ad2d7961cc85f$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $891ad2d7961cc85f$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $891ad2d7961cc85f$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, isWindowFocused: isWindowFocused, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $5uXOq.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $5uXOq.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $5uXOq.useEffect)(()=>{
        if (dwell.time > 0 && $891ad2d7961cc85f$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $5uXOq.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        if (isIframeLoaded && isMouseOver && isWindowFocused && iframePercentVisible > 0.75) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isWindowFocused,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});



parcelRegister("4WY3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd12e79c2283e2b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $3PAn6 = parcelRequire("3PAn6");

var $8m9FN = parcelRequire("8m9FN");

var $hrgWV = parcelRequire("hrgWV");
const $cbd12e79c2283e2b$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $5uXOq.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $5uXOq.useMemo)(()=>{
        const ButtonComponent = (0, $VSDnB.fg)('platform-smart-card-remove-legacy-button') ? (0, $eCeGD.default) : (0, $fVnbM.default);
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3PAn6.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, $2OMIu.jsx)(ButtonComponent, {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $7zaVw.messages).connect_unauthorised_account_action,
                        values: values
                    })
                })
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).unauthorised_account_name_no_provider
            }),
            description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).unauthorised_account_description_no_provider
            })
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8m9FN.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrgWV.UnauthorizedSVG), {}),
        testId: testId,
        text: context?.text
    });
};
var $cbd12e79c2283e2b$export$2e2bcd8739ae039 = $cbd12e79c2283e2b$var$UnauthorizedView;

});
parcelRegister("hrgWV", function(module, exports) {

$parcel$export(module.exports, "UnauthorizedSVG", () => $629e05cc9b210214$export$6526edaac83a8c90);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $629e05cc9b210214$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0_1375_267)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "563.88",
                        height: "265.81",
                        transform: "translate(0.870117 0.509766)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
                        stroke: "url(#paint0_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
                        fill: "#403294"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.25",
                        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
                        fill: "url(#paint1_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.25",
                        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
                        fill: "url(#paint2_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
                        stroke: "url(#paint3_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.38",
                        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
                        fill: "url(#paint4_radial_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
                        fill: "url(#paint5_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
                        fill: "url(#paint6_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
                        fill: "url(#paint7_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
                        fill: "url(#paint8_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
                        fill: "url(#paint9_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
                        fill: "url(#paint10_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
                        fill: "url(#paint11_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
                        fill: "url(#paint12_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
                        fill: "#172B4D"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
                        fill: "url(#paint13_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
                        fill: "url(#paint14_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
                        fill: "url(#paint15_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
                        fill: "url(#paint16_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
                        fill: "#6554C0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
                        fill: "url(#paint17_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
                        fill: "#5243AA"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
                        fill: "url(#paint18_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
                        fill: "#B3BAC5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint0_linear_1375_267",
                        x1: "141.994",
                        y1: "181.192",
                        x2: "0.870117",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C1C7D0",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint1_linear_1375_267",
                        x1: "208.292",
                        y1: "264.428",
                        x2: "0.870117",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint2_linear_1375_267",
                        x1: "357.327",
                        y1: "264.428",
                        x2: "564.748",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint3_linear_1375_267",
                        x1: "423.624",
                        y1: "181.192",
                        x2: "564.748",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.1724",
                                stopColor: "#076AFF",
                                stopOpacity: "0.8007"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.4145",
                                stopColor: "#1976FF",
                                stopOpacity: "0.5208"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.6966",
                                stopColor: "#378BFF",
                                stopOpacity: "0.1947"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8651",
                                stopColor: "#4C9AFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint4_radial_1375_267",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(285 99.0229) scale(96.5182)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.1584",
                                stopColor: "#FFE587",
                                stopOpacity: "0.8416"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.3589",
                                stopColor: "#FFDA57",
                                stopOpacity: "0.6411"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5498",
                                stopColor: "#FFD031",
                                stopOpacity: "0.4502"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.7256",
                                stopColor: "#FFC916",
                                stopOpacity: "0.2744"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8811",
                                stopColor: "#FFC506",
                                stopOpacity: "0.1189"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint5_linear_1375_267",
                        x1: "346.074",
                        y1: "98.8386",
                        x2: "423.624",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint6_linear_1375_267",
                        x1: "237.087",
                        y1: "120.044",
                        x2: "276.412",
                        y2: "120.044",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint7_linear_1375_267",
                        x1: "237.087",
                        y1: "75.0106",
                        x2: "276.412",
                        y2: "75.0106",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint8_linear_1375_267",
                        x1: "335.969",
                        y1: "146.593",
                        x2: "335.969",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B2D4FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint9_linear_1375_267",
                        x1: "219.544",
                        y1: "98.8386",
                        x2: "141.994",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint10_linear_1375_267",
                        x1: "229.65",
                        y1: "146.593",
                        x2: "229.65",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F4F5F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint11_linear_1375_267",
                        x1: "402.858",
                        y1: "216.64",
                        x2: "421.684",
                        y2: "223.492",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#4C9AFF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8134",
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8713",
                                stopColor: "#0065FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint12_linear_1375_267",
                        x1: "376.968",
                        y1: "157.139",
                        x2: "433.936",
                        y2: "157.139",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#B2D4FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint13_linear_1375_267",
                        x1: "289.638",
                        y1: "45.0027",
                        x2: "289.638",
                        y2: "0.510323",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint14_linear_1375_267",
                        x1: "262.238",
                        y1: "36.2259",
                        x2: "272.592",
                        y2: "36.2259",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint15_linear_1375_267",
                        x1: "259.6",
                        y1: "180.859",
                        x2: "259.6",
                        y2: "141.017",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint16_linear_1375_267",
                        x1: "284.971",
                        y1: "171.613",
                        x2: "284.971",
                        y2: "149.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint17_linear_1375_267",
                        x1: "157.982",
                        y1: "221.995",
                        x2: "188.627",
                        y2: "221.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.3435",
                                stopColor: "#6554C0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#998DD9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint18_linear_1375_267",
                        x1: "163.185",
                        y1: "155.517",
                        x2: "213.758",
                        y2: "155.517",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#5243AA"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8777D9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_1375_267",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "563.88",
                            height: "265.81",
                            fill: "white",
                            transform: "translate(0.870117 0.509766)"
                        })
                    })
                ]
            })
        ]
    });

});



parcelRegister("7oGL1", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $d266b2c60f505e83$export$aff6291803939b05);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $8PVtF = parcelRequire("8PVtF");

var $ctwhA = parcelRequire("ctwhA");

var $fgpl1 = parcelRequire("fgpl1");

var $aOsut = parcelRequire("aOsut");

var $bMldO = parcelRequire("bMldO");

var $anNwF = parcelRequire("anNwF");

var $4ULLF = parcelRequire("4ULLF");

var $ir8YW = parcelRequire("ir8YW");

var $eVTgG = parcelRequire("eVTgG");

var $2bexk = parcelRequire("2bexk");
const $d266b2c60f505e83$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const cardDetails = details && details.data || (0, $aOsut.getEmptyJsonLd)();
    const extensionKey = (0, $fgpl1.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $8dVIb.SmartLinkStatus).Resolved ? (0, $ctwhA.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $5uXOq.useEffect)(()=>{
        switch(status){
            case (0, $8dVIb.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title
                });
                break;
            case (0, $8dVIb.SmartLinkStatus).Errored:
            case (0, $8dVIb.SmartLinkStatus).Fallback:
            case (0, $8dVIb.SmartLinkStatus).Forbidden:
            case (0, $8dVIb.SmartLinkStatus).NotFound:
            case (0, $8dVIb.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eVTgG.InlineCardResolvingView), {
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                inlinePreloaderStyle: inlinePreloaderStyle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            });
        case 'resolved':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ir8YW.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                truncateInline: truncateInline
            });
        case 'unauthorized':
            const provider = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(details) : (0, $f24gj.extractProvider)(cardDetails);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2bexk.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(details) : (0, $f24gj.extractProvider)(cardDetails);
            const cardMetadata = details?.meta ?? (0, $aOsut.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $8PVtF.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ULLF.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(details) : (0, $f24gj.extractProvider)(cardDetails);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $anNwF.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMldO.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline
            });
    }
};

});
parcelRegister("anNwF", function(module, exports) {

$parcel$export(module.exports, "InlineCardErroredView", () => $d7fe9dbae4fd2cf4$export$8ae570c871cdb179);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $dD7Zc = parcelRequire("dD7Zc");

var $059q9 = parcelRequire("059q9");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7zaVw = parcelRequire("7zaVw");

var $hHEfn = parcelRequire("hHEfn");

var $7hUjd = parcelRequire("7hUjd");

var $kkxZO = parcelRequire("kkxZO");

var $6oaVw = parcelRequire("6oaVw");

var $1czVu = parcelRequire("1czVu");

var $EvUeI = parcelRequire("EvUeI");
const $d7fe9dbae4fd2cf4$var$styles = {
    iconWrapper: "_2hwx1i6y"
};
const $d7fe9dbae4fd2cf4$var$fallbackIcon = ()=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_size: "small",
        testId: "errored-view-default-icon"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $d7fe9dbae4fd2cf4$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: "error",
            LEGACY_size: "small",
            testId: "errored-view-default-icon"
        })
    });
};
const $d7fe9dbae4fd2cf4$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        const Button = (0, $EvUeI.default)((0, $fVnbM.default), frameRef);
        return onRetry && ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7hUjd.ActionButton), {
            onClick: handleRetry,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).try_again
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
            spacing: "none",
            component: (0, $1czVu.IconStyledButtonOldVisualRefresh),
            onClick: handleRetry,
            role: "button",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).try_again
            })
        }));
    }, [
        handleRetry,
        onRetry
    ]);
    const content = (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                icon: icon || $d7fe9dbae4fd2cf4$var$fallbackIcon(),
                link: hashAction ? url : undefined,
                title: url,
                onClick: hashAction ? onClick : undefined,
                rightSide: message
            }),
            renderActionButton()
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                icon: icon || $d7fe9dbae4fd2cf4$var$fallbackIcon(),
                link: url,
                title: url,
                onClick: onClick,
                rightSide: message
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("7hUjd", function(module, exports) {

$parcel$export(module.exports, "ActionButton", () => $d9315bd317cf09de$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3Lty3 = parcelRequire("3Lty3");
const $d9315bd317cf09de$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syaz1fxt _80omtlke _bfhkm7j4 _irr315ej _1di6ip91",
    disabled: "_syaz1lh4 _80om13gf _bfhksyzs"
};
const $d9315bd317cf09de$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $d9315bd317cf09de$var$styles.button,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            tabIndex: isDisabled ? undefined : 0,
            className: (0, $bwpsq.default)([
                $d9315bd317cf09de$var$styles.innerContainer,
                isDisabled ? $d9315bd317cf09de$var$styles.disabled : $d9315bd317cf09de$var$styles.enabled
            ]),
            children: children
        })
    });
});

});

parcelRegister("1czVu", function(module, exports) {

$parcel$export(module.exports, "IconStyledButtonOldVisualRefresh", () => $b39da9ce412dd56b$export$c7df70607ac721c3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // By default buttons will hide overflow and ellipsis content instead of wrapping.
// This basically turns the button back into inline content
// TODO Delete when cleaning platform-linking-visual-refresh-v1
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $b39da9ce412dd56b$export$c7df70607ac721c3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_i3j7iti9 _uqpc18uv _1ilx1nu9 _18v918uv _1t1midpf _jinwidpf _1695v77o _1pns12x7 _vktqv77o _1byq12x7 _k1fv1u8q _5x9bqvcn _ju3g18uv _mt1t18uv _12rl18uv _1wge18uv _1nr3zryt _1a8r4jg8 _1xdi1nu9 _1t21zryt _1jjh4jg8",
            __cmplp.className
        ])
    });
});

});

parcelRegister("EvUeI", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd6c302e9fb2d38d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var /**
 * This HOC serves as a temporary workaround for controlling the style of a parent component.
 * We do not want the Frame to have a hover state when hovering over the action button.
 * TODO: When Firefox begins supporting the :has()pseudo-selector (e.g "frame:has(button:hover){...}"),
 * it should be used instead and the code should be cleaned up.
 */ $dd6c302e9fb2d38d$export$2e2bcd8739ae039 = (Button, frameRef)=>(props)=>{
        const setBorderStyle = ()=>{
            const frameNode = frameRef.current;
            if (frameNode) frameNode.style.borderColor = `${`var(--ds-border, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`}`;
        };
        const removeBorderStyle = ()=>{
            const frameNode = frameRef.current;
            if (frameNode) frameNode.removeAttribute('style');
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
            ...props,
            onMouseEnter: setBorderStyle,
            onMouseLeave: removeBorderStyle
        });
    };

});


parcelRegister("4ULLF", function(module, exports) {

$parcel$export(module.exports, "InlineCardForbiddenView", () => $afe1b9ba417d1ecc$export$ebd227d2573ed3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $bwyQI = parcelRequire("bwyQI");

var $gs7PQ = parcelRequire("gs7PQ");

var $aYAc3 = parcelRequire("aYAc3");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");


var $7zaVw = parcelRequire("7zaVw");

var $hHEfn = parcelRequire("hHEfn");

var $7hUjd = parcelRequire("7hUjd");

var $6x7n6 = parcelRequire("6x7n6");

var $kkxZO = parcelRequire("kkxZO");

var $6oaVw = parcelRequire("6oaVw");

var $1czVu = parcelRequire("1czVu");

var $EvUeI = parcelRequire("EvUeI");
const $afe1b9ba417d1ecc$var$styles = {
    iconWrapper: "_2hwx1i6y _1e0cbu77",
    actionButtonLozengeStyleOld: "_2rkogqwt _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    actionButtonLozengeStyleNew: "_2rkogqwt _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _p12f1osq"
};
const $afe1b9ba417d1ecc$var$fallbackForbiddenIcon = ()=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))),
        LEGACY_size: "small",
        testId: "forbidden-view-fallback-icon"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $afe1b9ba417d1ecc$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
            label: "error",
            color: "var(--ds-icon-danger, #C9372C)",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))),
            LEGACY_size: "small",
            testId: "forbidden-view-fallback-icon"
        })
    });
};
const $afe1b9ba417d1ecc$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).invalid_permissions,
            children: (formattedMessage)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                    children: formattedMessage
                })
        });
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        const Button = (0, $EvUeI.default)((0, $fVnbM.default), frameRef);
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) {
                const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7hUjd.ActionButton), {
                    isDisabled: isDisabled,
                    onClick: handleRetry,
                    testId: "button-connect-other-account",
                    children: renderForbiddenAccessMessage()
                });
            }
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
                spacing: "none",
                onClick: handleRetry,
                component: (0, $1czVu.IconStyledButtonOldVisualRefresh),
                testId: "button-connect-other-account",
                role: "button",
                isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
                children: renderForbiddenAccessMessage()
            });
        }
        if (onAuthorise) {
            if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) {
                if ((0, $VSDnB.fg)('platform-linking-visual-refresh-inline-lozenge')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                    xcss: $afe1b9ba417d1ecc$var$styles.actionButtonLozengeStyleNew,
                    onClick: handleRetry,
                    style: {
                        font: `inherit`
                    },
                    testId: "button-connect-other-account",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6x7n6.default), {
                        appearance: "moved",
                        ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                            isBold: true
                        } : undefined,
                        children: renderForbiddenAccessMessage()
                    })
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.LozengeWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                        xcss: $afe1b9ba417d1ecc$var$styles.actionButtonLozengeStyleOld,
                        onClick: handleRetry,
                        testId: "button-connect-other-account",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aYAc3.default), {
                            appearance: "moved",
                            ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                                isBold: true
                            } : undefined,
                            children: renderForbiddenAccessMessage()
                        })
                    })
                });
            }
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
                spacing: "none",
                onClick: handleRetry,
                appearance: "subtle-link",
                testId: "button-connect-other-account",
                role: "button",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.LozengeWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aYAc3.default), {
                        appearance: 'moved',
                        ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                            isBold: true
                        } : undefined,
                        children: renderForbiddenAccessMessage()
                    })
                })
            });
        }
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                icon: icon ? icon : $afe1b9ba417d1ecc$var$fallbackForbiddenIcon(),
                link: url,
                title: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("gs7PQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfa556ca72f8a34c$var$_react = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfa556ca72f8a34c$var$_lockLocked = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $bfa556ca72f8a34c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfa556ca72f8a34c$var$LockFilledIcon = (props)=>/*#__PURE__*/ $bfa556ca72f8a34c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $bfa556ca72f8a34c$var$_lockLocked.default
    }));
$bfa556ca72f8a34c$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $bfa556ca72f8a34c$var$_default = module.exports.default = $bfa556ca72f8a34c$var$LockFilledIcon;

});


parcelRegister("eVTgG", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvingView", () => $0760a9bf886910dc$export$98531adac42f053e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $eZJjh = parcelRequire("eZJjh");

var $kkxZO = parcelRequire("kkxZO");

var $6oaVw = parcelRequire("6oaVw");

var $1Fo58 = parcelRequire("1Fo58");

var $bIwoX = parcelRequire("bIwoX");
const $0760a9bf886910dc$var$styles = {
    spinnerWrapper: "_11c81o8v _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $0760a9bf886910dc$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            as: "span",
            xcss: $0760a9bf886910dc$var$styles.spinnerWrapper,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                size: 14
            })
        }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bIwoX.SpinnerWrapperOldVisualRefresh), {
            className: "inline-resolving-spinner",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                size: 14
            })
        }), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkxZO.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6oaVw.IconTitleWrapper), {
            children: [
                url,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.RightIconPositionWrapper), {
                    children: renderSpinner()
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkxZO.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
            icon: (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? renderSpinner() : undefined,
            title: resolvingPlaceholder ?? url,
            titleTextColor: titleTextColor,
            children: (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? undefined : renderSpinner()
        })
    });
};

});
parcelRegister("bIwoX", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapperOldVisualRefresh", () => $0c4a685457e69a72$export$cfcf9ebf54d3fb5c);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1Fo58 = parcelRequire("1Fo58");
const $0c4a685457e69a72$export$cfcf9ebf54d3fb5c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1Fo58.IconTitleWrapperOldVisualRefresh), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _s7n41ndm",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2bexk", function(module, exports) {

$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $9c6f4165ad8dd9bb$export$ece47728c0503997);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $bwyQI = parcelRequire("bwyQI");

var $gs7PQ = parcelRequire("gs7PQ");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $hHEfn = parcelRequire("hHEfn");

var $7hUjd = parcelRequire("7hUjd");

var $kkxZO = parcelRequire("kkxZO");

var $6oaVw = parcelRequire("6oaVw");

var $1czVu = parcelRequire("1czVu");

var $EvUeI = parcelRequire("EvUeI");
const $9c6f4165ad8dd9bb$var$styles = {
    iconWrapper: "_2hwx1i6y"
};
const $9c6f4165ad8dd9bb$var$fallbackUnauthorizedIcon = ()=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))),
        LEGACY_size: "small"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $9c6f4165ad8dd9bb$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: "error",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))),
            LEGACY_size: "small"
        })
    });
};
const $9c6f4165ad8dd9bb$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        const Button = (0, $EvUeI.default)((0, $fVnbM.default), frameRef);
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7hUjd.ActionButton), {
            onClick: handleConnectAccount,
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        });
        return onAuthorise ? /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
            spacing: "none",
            component: (0, $1czVu.IconStyledButtonOldVisualRefresh),
            onClick: handleConnectAccount,
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        }) : undefined;
    }, [
        handleConnectAccount,
        onAuthorise,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                icon: icon ? icon : $9c6f4165ad8dd9bb$var$fallbackUnauthorizedIcon(),
                title: url,
                link: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
        url: url,
        id: id,
        children: inlineCardUnauthenticatedView
    });
    return inlineCardUnauthenticatedView;
};

});



parcelRegister("i41Ob", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $b4c0875f37c33ad9$export$1ca0544321134ad6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bMldO = parcelRequire("bMldO");

const $b4c0875f37c33ad9$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMldO.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $b18b5009ce608fe8$export$4b2b7d155f69aed4),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
const $b18b5009ce608fe8$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';



parcelRegister("4WT1d", function(module, exports) {

$parcel$export(module.exports, "RemoveButton", () => $5272b4d3c861c357$export$4e9d5ce1e6c22a94);

var $5uXOq = parcelRequire("5uXOq");

var $i28qQ = parcelRequire("i28qQ");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $jl6lF = parcelRequire("jl6lF");
const $5272b4d3c861c357$export$4e9d5ce1e6c22a94 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        e.stopPropagation();
        onClick();
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $jl6lF.default).removeTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            ...tooltipProps,
            "aria-label": formatMessage((0, $jl6lF.default).removeTooltip),
            onClick: handleClick,
            padding: "space.0",
            xcss: $5272b4d3c861c357$var$pressableStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
            color: "var(--ds-icon, #44546F)",
            spacing: "compact",
            label: "",
            size: "small"
        })));
};
const $5272b4d3c861c357$var$pressableStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'border.radius',
    display: 'flex',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});

});
parcelRegister("jl6lF", function(module, exports) {

$parcel$export(module.exports, "default", () => $50823fb608df5d83$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50823fb608df5d83$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    removeTooltip: {
        "id": "issue-smart-links-popup-edit-view.smart-link-options-trigger.remove-button.remove-all-tooltip",
        "defaultMessage": "Remove"
    }
});

});



parcelRegister("eNMpo", function(module, exports) {

$parcel$export(module.exports, "goalsPopupContentEntryPoint", () => $a0b28a2b51b69f70$export$dc38dd29dc6b8559);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $a0b28a2b51b69f70$export$dc38dd29dc6b8559 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3EcTt")), {
        moduleId: "e7e5e5c1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3EcTt", function(module, exports) {

let $2a7f1bf88c4a7921$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2a7f1bf88c4a7921$var$load("fgtjT").then(()=>parcelRequire('d7RpF'));

});


parcelRegister("92x2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $d227166a39c09182$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d227166a39c09182$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-goals-readview-full.goals.show-more-tooltip",
        "defaultMessage": "See more selected goals"
    }
});

});




parcelRegister("iMwsC", function(module, exports) {

$parcel$export(module.exports, "IssueKeyCell", () => $9f7b28ebe825d75b$export$a6c835c7dffd9abf);

var $2fkY3 = parcelRequire("2fkY3");

var $14mpR = parcelRequire("14mpR");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $7mPT9 = parcelRequire("7mPT9");

var $gULOk = parcelRequire("gULOk");

var $koVbs = parcelRequire("koVbs");

var $ku7XM = parcelRequire("ku7XM");

var $dCm1o = parcelRequire("dCm1o");

var $dpHMc = parcelRequire("dpHMc");

var $4R6GH = parcelRequire("4R6GH");

var $2e4p8 = parcelRequire("2e4p8");

var $e9M6d = parcelRequire("e9M6d");

var $hKMVG = parcelRequire("hKMVG");

var $eCw3H = parcelRequire("eCw3H");

var $4M8IX = parcelRequire("4M8IX");
const $9f7b28ebe825d75b$export$a6c835c7dffd9abf = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, issueRef: issueRef, onIssueLinkSelected: onIssueLinkSelected })=>{
    const intl = (0, $koVbs.default)();
    const { text: issueKey } = (0, $8Uumt.useFragment)((0, $14mpR.default), fieldRef);
    const fieldsByIdFragment = (0, $8Uumt.useFragment)((0, $2fkY3.default), issueRef || null);
    const isDensityFull = (0, $e9M6d.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    const tableCellLinkRef = (0, $5uXOq.useRef)(null);
    let isMergedColumnVisible = false;
    if ((0, $4R6GH.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnVisible = (0, $e9M6d.useIsMergedColumnVisible)();
    const isEmbedMode = (0, $4R6GH.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2e4p8.useIsEmbedMode)() : false;
    const onClick = (0, $5uXOq.useCallback)((e)=>{
        // Use default browser event handling when a modifier key is pressed during the click event
        const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
        const handled = !isEmbedMode && !isModifierKeyUsed && onIssueLinkSelected !== undefined && issueKey && onIssueLinkSelected(issueKey);
        if (handled) e.preventDefault();
    }, [
        isEmbedMode,
        issueKey,
        onIssueLinkSelected
    ]);
    if (!issueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "issueKey",
        reason: "Missing required fields"
    });
    const issueStrikeThroughProps = {};
    const statusEdge = fieldsByIdFragment?.fieldsById?.edges?.find((edge)=>edge?.node?.fieldId === 'status');
    const statusCategoryId = statusEdge?.node?.status?.statusCategory?.statusCategoryId;
    const isResolved = fieldsByIdFragment?.isResolved ?? undefined;
    const isIssueResolved = (0, $ku7XM.shouldDisplayStrikethrough)(isResolved, (0, $gULOk.statusCategoryForId)(statusCategoryId));
    issueStrikeThroughProps.shouldDisplayStrikethrough = isIssueResolved;
    issueStrikeThroughProps['aria-label'] = intl.formatMessage((0, $4M8IX.default).issueKeyWithResolution, {
        issueKey: issueKey,
        isResolved: isIssueResolved
    });
    const getWrapperStyles = ()=>{
        if (isDensityFull) return (0, $dCm1o.isVisualRefreshEnabled)() ? $9f7b28ebe825d75b$var$wrapperStylesFull : $9f7b28ebe825d75b$var$wrapperStylesFullOld;
        return (0, $dCm1o.isVisualRefreshEnabled)() ? $9f7b28ebe825d75b$var$wrapperStylesCompact : $9f7b28ebe825d75b$var$wrapperStylesCompactOld;
    };
    if (isInlineEditingExtendedFieldSupportEnabled && (0, $4R6GH.fg)('jsc_summary_link_button')) {
        const issueKeyLink = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCw3H.TableCellLink), {
                ...issueStrikeThroughProps,
                href: `/browse/${issueKey}`,
                isTruncated: !isDensityFull || isSingleLineRowHeightEnabled,
                onClick: onClick,
                ref: (0, $7mPT9.mergeRefs)(tableCellLinkRef, ref),
                testId: "native-issue-table.common.ui.issue-cells.issue-key.issue-key-cell"
            }, issueKey);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingBlock: "space.050",
            paddingInline: isMergedColumnVisible ? 'space.050' : 'space.100',
            "data-vc": "native-issue-table-ui-issue-key-cell"
        }, isSingleLineRowHeightEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
            content: issueKey,
            contentRef: tableCellLinkRef
        }, ({ ref: ref })=>issueKeyLink(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: issueKey
        }, issueKeyLink()));
    }
    const issueKeyLink = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCw3H.TableCellDiscreteLink), {
            href: `/browse/${issueKey}`,
            "data-testid": "native-issue-table.common.ui.issue-cells.issue-key.issue-key-cell",
            ...issueStrikeThroughProps,
            isSubtle: true,
            ref: (0, $7mPT9.mergeRefs)(tableCellLinkRef, ref),
            onClick: onClick
        }, issueKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.050",
        paddingInline: isMergedColumnVisible ? 'space.050' : 'space.100',
        xcss: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            getWrapperStyles(),
            isSingleLineRowHeightEnabled && $9f7b28ebe825d75b$var$singleLineRowHeightStyles,
            isMergedColumnVisible && $9f7b28ebe825d75b$var$overflowVisibleStyles
        ],
        "data-vc": "native-issue-table-ui-issue-key-cell"
    }, isSingleLineRowHeightEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: issueKey,
        contentRef: tableCellLinkRef
    }, ({ ref: ref })=>issueKeyLink(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: issueKey
    }, issueKeyLink()));
});
const $9f7b28ebe825d75b$var$singleLineRowHeightStyles = (0, $8CUq3.xcss)({
    textOverflow: 'ellipsis'
});
const $9f7b28ebe825d75b$var$wrapperStylesCompactOld = (0, $8CUq3.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $9f7b28ebe825d75b$var$wrapperStylesCompact = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $9f7b28ebe825d75b$var$wrapperStylesFullOld = (0, $8CUq3.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%'
});
const $9f7b28ebe825d75b$var$wrapperStylesFull = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%'
});
const $9f7b28ebe825d75b$var$overflowVisibleStyles = (0, $8CUq3.xcss)({
    overflow: 'visible'
});

});
parcelRegister("2fkY3", function(module, exports) {

$parcel$export(module.exports, "default", () => $16846b7312cdc0e4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<84e38266018a2d0ee5fecb7a6ccbbea1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $16846b7312cdc0e4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueKey_nativeIssueTable_IssueKeyCell_fieldsByIdRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isResolved"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "ids",
                    "value": [
                        "status"
                    ]
                }
            ],
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fieldsById",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "concreteType": "JiraStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraStatusCategory",
                                                    "kind": "LinkedField",
                                                    "name": "statusCategory",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCategoryId"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraStatusField"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "fieldsById(ids:[\"status\"])"
        }
    ],
    "type": "JiraIssue"
};
$16846b7312cdc0e4$var$node.hash = "3f8a2e871d3d14cf9fc0af5923a7fcf4";
var $16846b7312cdc0e4$export$2e2bcd8739ae039 = $16846b7312cdc0e4$var$node;

});

parcelRegister("14mpR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a8ab7499b179cca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab4cedce41cbb321f6ef8976f1af3dc3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3a8ab7499b179cca$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueKey_nativeIssueTable_IssueKeyCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$3a8ab7499b179cca$var$node.hash = "79f6c1453d4dd585ed1c4eab8fbd7fc1";
var $3a8ab7499b179cca$export$2e2bcd8739ae039 = $3a8ab7499b179cca$var$node;

});

parcelRegister("ku7XM", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayStrikethrough", () => $5e2ee485e17261c7$export$1e1e848245d3a6f7);

var $gULOk = parcelRequire("gULOk");
const { DONE: $5e2ee485e17261c7$var$DONE } = (0, $gULOk);
const $5e2ee485e17261c7$export$1e1e848245d3a6f7 = (isResolved, statusCategory)=>{
    if (isResolved !== undefined) return isResolved;
    // In JSW, the strikethrough must now only depend on resolution. However we have to keep
    // this logic because there is a consumer of issue-line-card in JSM that displays
    // the strikethrough based on status src/packages/servicedesk/post-incident-review/src/ui/primary-incident/index.tsx
    return statusCategory === $5e2ee485e17261c7$var$DONE;
};

});

parcelRegister("eCw3H", function(module, exports) {

$parcel$export(module.exports, "TableCellDiscreteLink", () => $d8fa778f378b54db$export$4e03936e0e9409e2);
$parcel$export(module.exports, "TableCellLink", () => $d8fa778f378b54db$export$fce640eb3bd348ea);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $jhmo0 = parcelRequire("jhmo0");
var $8CUq3 = parcelRequire("8CUq3");

var $7XYc4 = parcelRequire("7XYc4");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $hjSul = parcelRequire("hjSul");

var $4R6GH = parcelRequire("4R6GH");

var $2e4p8 = parcelRequire("2e4p8");

var $e9M6d = parcelRequire("e9M6d");
const $d8fa778f378b54db$export$4e03936e0e9409e2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    const onClickWithAnalytics = (0, $5uXOq.useCallback)((e)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'tableIssueLink');
        onClick && onClick(e);
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const isEmbedMode = (0, $4R6GH.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2e4p8.useIsEmbedMode)() : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8fa778f378b54db$var$StyledLink, {
        ...rest,
        onClick: onClickWithAnalytics,
        ref: ref,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    });
});
const $d8fa778f378b54db$export$fce640eb3bd348ea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-label': ariaLabel, children: children, href: href, isTruncated: isTruncated, onClick: onClick, shouldDisplayStrikethrough: shouldDisplayStrikethrough, testId: testId }, ref)=>{
    const onClickWithAnalytics = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
        onClick && onClick(e);
    }, [
        onClick
    ]);
    const isEmbedMode = (0, $4R6GH.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2e4p8.useIsEmbedMode)() : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        "aria-label": ariaLabel,
        href: href,
        onClick: onClickWithAnalytics,
        ref: ref,
        testId: testId,
        xcss: [
            $d8fa778f378b54db$var$linkDefaultStyles,
            isTruncated && $d8fa778f378b54db$var$linkTruncatedStyles,
            shouldDisplayStrikethrough && $d8fa778f378b54db$var$linkStrikethroughStyles
        ],
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
});
// Fix for Compiled bug where invalid props are passed on to the underlying DOM element when using inheritance.
const $d8fa778f378b54db$var$PropFilteredLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ innerFocusOutline: innerFocusOutline, shouldDisplayStrikethrough: shouldDisplayStrikethrough, isSubtle: isSubtle, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        ...rest,
        ref: ref
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d8fa778f378b54db$var$StyledLinkOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $d8fa778f378b54db$var$PropFilteredLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1nmz1hna",
            __cmplp.innerFocusOutline && "_1ah31i6y",
            __cmplp.shouldDisplayStrikethrough && "_4bfu18uv _1hms1911 _ajmmnqa1",
            __cmplp.isSingleLineRowHeightEnabled && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1e0c1ule",
            __cmplp.className
        ])
    });
});
const $d8fa778f378b54db$var$StyledLinkNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $d8fa778f378b54db$var$PropFilteredLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1nmz1hna",
            __cmplp.isSubtle ? "_syaz1gjq" : "_syaz1fxt",
            __cmplp.innerFocusOutline && "_1ah31i6y",
            __cmplp.shouldDisplayStrikethrough && "_4bfu18uv _1hms1911 _ajmmnqa1",
            __cmplp.isSingleLineRowHeightEnabled && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1e0c1ule",
            __cmplp.className
        ])
    });
});
const $d8fa778f378b54db$var$linkDefaultStyles = (0, $8CUq3.xcss)({
    cursor: 'pointer',
    display: 'block',
    font: 'font.body',
    overflow: 'hidden',
    textDecoration: 'underline',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});
const $d8fa778f378b54db$var$linkTruncatedStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap'
});
const $d8fa778f378b54db$var$linkStrikethroughStyles = (0, $8CUq3.xcss)({
    textDecoration: 'line-through',
    ':hover': {
        textDecoration: 'line-through'
    }
});
const $d8fa778f378b54db$var$StyledLink = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $d8fa778f378b54db$var$StyledLinkNew, $d8fa778f378b54db$var$StyledLinkOld);

});

parcelRegister("4M8IX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4b15410c08dffa3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f4b15410c08dffa3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueKeyWithResolution: {
        "id": "native-issue-table.common.issue-cells.issue-key.issue-key-with-resolution",
        "defaultMessage": "{issueKey} is {isResolved, select, \n            true {resolved}\n            false {not resolved}\n            other {}\n        }"
    }
});

});


parcelRegister("fRR6R", function(module, exports) {

$parcel$export(module.exports, "IssueLinksCell", () => $b5dc149ee1dfe143$export$75aa2ccc20dd7954);

var $4kFMt = parcelRequire("4kFMt");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $dD7Zc = parcelRequire("dD7Zc");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $eZJjh = parcelRequire("eZJjh");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8wiEe = parcelRequire("8wiEe");

var $3Dy3s = parcelRequire("3Dy3s");

var $l8IoT = parcelRequire("l8IoT");

var $koeKL = parcelRequire("koeKL");

var $czfFt = parcelRequire("czfFt");

var $hKMVG = parcelRequire("hKMVG");

var $e9M6d = parcelRequire("e9M6d");

var $fPkZ0 = parcelRequire("fPkZ0");

var $9QgmA = parcelRequire("9QgmA");
const $b5dc149ee1dfe143$export$f48224de87d33a65 = (initialIsOpen)=>(0, $5uXOq.useState)(initialIsOpen);
const $b5dc149ee1dfe143$export$75aa2ccc20dd7954 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, issueKey: issueKey, accordionInitialIsOpen: accordionInitialIsOpen = false, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const [isOpen, setIsOpen] = $b5dc149ee1dfe143$export$f48224de87d33a65(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $4kFMt.default), fieldRef);
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        issueKey,
        cloudId
    ]);
    const issueLinks = data?.issueLinkConnection?.edges;
    const totalCount = data?.issueLinkConnection?.totalCount;
    const filteredIssueLinks = (0, $5uXOq.useMemo)(()=>issueLinks?.map((edge)=>edge?.node?.issue?.key != null ? {
                key: edge.node.issue?.key || 'missingId',
                name: edge.node.issue?.key,
                href: edge.node.issue?.webUrl || '',
                relationName: edge.node.relationName,
                shouldDisplayStrikethrough: edge.node.issue?.fieldsById?.edges?.[0]?.node?.statusCategory?.statusCategoryId === '3' || false
            } : null).filter(Boolean) ?? [], [
        issueLinks
    ]);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                issueKey: issueKey,
                issueSearchBaseUrl: issueSearchBaseUrl,
                accordionInitialIsOpen: accordionInitialIsOpen
            }), [
            issueKey,
            issueSearchBaseUrl,
            accordionInitialIsOpen
        ]);
        if (!issueLinks) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
            cellType: "issueLinks",
            reason: "Missing issue links field"
        });
        if (issueLinks.length !== filteredIssueLinks.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
            cellType: "issueLinks",
            reason: "Missing fields on issue links"
        });
        if (totalCount === undefined || totalCount === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
            cellType: "issueLinks",
            reason: "Missing total count"
        });
        if (totalCount < 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
            cellType: "issueLinks",
            reason: "Invalid total count"
        });
        if (totalCount > 0 && filteredIssueLinks.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
            cellType: "issueLinks",
            reason: "Total count valid but no issue links given"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Dy3s.ItemWithEntryPointPopup), {
            entryPoint: (0, $fPkZ0.issueLinksPopUpContentEntryPoint),
            entryPointParams: entryPointParams,
            entryPointRuntimeProps: runtimeProps,
            totalItems: Math.min(totalCount, 1000),
            ItemComponent: totalCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8IoT.TagItem), {
                name: filteredIssueLinks[0].name,
                href: filteredIssueLinks[0].href,
                shouldDisplayStrikethrough: filteredIssueLinks[0].shouldDisplayStrikethrough,
                key: filteredIssueLinks[0].key,
                isHoverPopoverEnabled: isSingleLineRowHeightEnabled,
                isOnlyOneItem: totalCount === 1
            }) : undefined,
            showMoreTooltip: formatMessage((0, $9QgmA.default).triggerButton),
            actionSubjectIdPrefix: "issueLinks",
            isTruncated: isSingleLineRowHeightEnabled
        }));
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $fPkZ0.issueLinksPopUpContentEntryPoint), entryPointParams);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [retryKey, setRetryKey] = (0, $5uXOq.useState)(0);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    if (!issueLinks) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "issueLinks",
        reason: "Missing issue links field"
    });
    if (issueLinks.length !== filteredIssueLinks.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "issueLinks",
        reason: "Missing fields on issue links"
    });
    if (totalCount === undefined || totalCount === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "issueLinks",
        reason: "Missing total count"
    });
    if (totalCount < 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "issueLinks",
        reason: "Invalid total count"
    });
    if (totalCount > 0 && filteredIssueLinks.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "issueLinks",
        reason: "Total count valid but no issue links given"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wiEe.default), {
        totalItems: Math.min(totalCount, 1000),
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        triggerRefCallback: triggerRef,
        ItemComponent: totalCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8IoT.TagItem), {
            name: filteredIssueLinks[0].name,
            href: filteredIssueLinks[0].href,
            shouldDisplayStrikethrough: filteredIssueLinks[0].shouldDisplayStrikethrough,
            key: filteredIssueLinks[0].key,
            isHoverPopoverEnabled: isSingleLineRowHeightEnabled
        }) : undefined,
        showMoreTooltip: formatMessage((0, $9QgmA.default).triggerButton),
        PopupComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            key: retryKey,
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "issue-links-popup-content",
            packageName: (0, $czfFt.PACKAGE_NAME),
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5dc149ee1dfe143$export$7981ca72a47ca202, {
                    onClick: ()=>setRetryKey((prev)=>prev + 1)
                }),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                padding: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "medium"
            })),
            runtimeProps: {
                issueKey: issueKey,
                issueSearchBaseUrl: issueSearchBaseUrl,
                accordionInitialIsOpen: accordionInitialIsOpen
            }
        }),
        actionSubjectIdPrefix: "issueLinks",
        isTruncated: isSingleLineRowHeightEnabled
    }));
});
const $b5dc149ee1dfe143$export$7981ca72a47ca202 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9QgmA.default).errorMessageIssueTermRefresh : (0, $9QgmA.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClick,
        appearance: "link",
        spacing: "compact",
        testId: "native-issue-table.common.ui.issue-cells.issue-links.button"
    }, formatMessage((0, $9QgmA.default).retryMessage)));
};

});
parcelRegister("4kFMt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5217486898f69550$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9cb685025347abb0a5b07424eaaf6a04>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5217486898f69550$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueLinks_nativeIssueTable_IssueLinksCell",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "JiraIssueLinkConnection",
            "kind": "LinkedField",
            "name": "issueLinkConnection",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                {
                    "concreteType": "JiraIssueLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueLink",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webUrl"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "ids",
                                                    "value": [
                                                        "statusCategory"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraStatusCategoryField"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "relationName"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "issueLinkConnection(first:1)"
        }
    ],
    "type": "JiraIssueLinkField"
};
$5217486898f69550$var$node.hash = "1e9888fcf84cc8f53dcabd49810063d2";
var $5217486898f69550$export$2e2bcd8739ae039 = $5217486898f69550$var$node;

});

parcelRegister("fPkZ0", function(module, exports) {

$parcel$export(module.exports, "issueLinksPopUpContentEntryPoint", () => $aef35eb695e475ad$export$94cbcdadb553c314);

var $9UxKM = parcelRequire("9UxKM");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $aef35eb695e475ad$export$94cbcdadb553c314 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("1wl7x")), {
        moduleId: "95d98593"
    }),
    getPreloadProps: ({ issueKey: issueKey, cloudId: cloudId })=>({
            queries: {
                links: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $9UxKM.default,
                    variables: {
                        issueKey: issueKey,
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("9UxKM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c12c1fdc178f449$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b1958999ab18d9f57257e6116583fd83>>
 * @relayHash 5c17b8fbf5a1e69531b46c6e762bc127
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46a6916f10ae38e187e874e829f804706892021354f2ba5bad26efc50947a5ee
const $4c12c1fdc178f449$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "46a6916f10ae38e187e874e829f804706892021354f2ba5bad26efc50947a5ee",
        "metadata": {},
        "name": "ui_IssueLinksPopUpContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4c12c1fdc178f449$export$2e2bcd8739ae039 = $4c12c1fdc178f449$var$node;

});

parcelRegister("1wl7x", function(module, exports) {

let $11b929b6350b920b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $11b929b6350b920b$var$load("hXzQe").then(()=>parcelRequire('QSCqM'));

});


parcelRegister("9QgmA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9d0383c926739f2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d9d0383c926739f2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.issue-links.trigger-button",
        "defaultMessage": "See more"
    },
    showMoreLink: {
        "id": "native-issue-table.common.issue-cells.issue-links.show-more-link",
        "defaultMessage": "Go to all linked issues"
    },
    showMoreLinkIssueTermRefresh: {
        "id": "native-issue-table.common.issue-cells.issue-links.show-more-link-issue-term-refresh",
        "defaultMessage": "Go to all linked work items"
    },
    retryMessage: {
        "id": "native-issue-table.common.issue-cells.issue-links.retry-message",
        "defaultMessage": "Click to retry"
    },
    errorMessage: {
        "id": "native-issue-table.common.issue-cells.issue-links.error-message",
        "defaultMessage": "Failed to load issue links"
    },
    errorMessageIssueTermRefresh: {
        "id": "native-issue-table.common.issue-cells.issue-links.error-message-issue-term-refresh",
        "defaultMessage": "Failed to load linked work items"
    }
});

});


parcelRegister("bRJBd", function(module, exports) {

$parcel$export(module.exports, "IssueOperations", () => $009c2afc2f2fdcbc$export$125bc3f55de1b4bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hPMhn = parcelRequire("hPMhn");
const $009c2afc2f2fdcbc$export$125bc3f55de1b4bd = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueKey: issueKey, issueId: issueId, onIssueRefetch: onIssueRefetch, onIssueDelete: onIssueDelete, isCreateSubTaskAllowed: isCreateSubTaskAllowed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($009c2afc2f2fdcbc$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPMhn.default), {
        issueId: issueId,
        issueKey: issueKey,
        isCreateSubTaskAllowed: isCreateSubTaskAllowed,
        onIssueRefetch: onIssueRefetch,
        onIssueDelete: onIssueDelete
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $009c2afc2f2fdcbc$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _bfhk1w7a _1bsb1ns9 _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hPMhn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b05769e44307cf2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $bJeNF = parcelRequire("bJeNF");

var $4R6GH = parcelRequire("4R6GH");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $24s6O = parcelRequire("24s6O");

var $3KrVF = parcelRequire("3KrVF");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b05769e44307cf2$var$MeatballMenu = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("avR5B")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/issue-operations/meatball-menu/src/ui/index.tsx"
});
const $3b05769e44307cf2$var$Fallback = ({ onRetry: onRetry })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, ...props })=>{
            const iconColor = isSelected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)";
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    label: "",
                    LEGACY_size: "medium",
                    color: iconColor,
                    LEGACY_primaryColor: iconColor,
                    spacing: "spacious"
                }),
                ref: triggerRef,
                isSelected: isSelected
            });
        },
        placement: "bottom-end",
        shouldRenderToParent: (0, $4R6GH.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $24s6O.ErrorState), {
        onRetry: onRetry
    }));
const $3b05769e44307cf2$var$AsyncMeatballMenu = (props)=>{
    const [resetCaughtError, setResetCaughtError] = (0, $5uXOq.useState)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorIssueOperations",
        id: "async-meatball-menu",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b05769e44307cf2$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error)
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            id: `async-meatball-menu-button-fallback-${props.issueId}`,
            "aria-label": formatMessage((0, $3KrVF.default).disabledMenuButtonLabel, {
                issueKey: props.issueKey
            }),
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "",
                LEGACY_size: "medium",
                color: "currentColor",
                spacing: "spacious"
            }),
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b05769e44307cf2$var$MeatballMenu, props)));
};
var $3b05769e44307cf2$export$2e2bcd8739ae039 = $3b05769e44307cf2$var$AsyncMeatballMenu;

});
parcelRegister("24s6O", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $552b57436875579d$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fVnbM = parcelRequire("fVnbM");

var $dD7Zc = parcelRequire("dD7Zc");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $7tt2k = parcelRequire("7tt2k");

var $6NkNz = parcelRequire("6NkNz");
const $552b57436875579d$export$c1ed4f415b9e7023 = ({ onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($552b57436875579d$var$DropdownItemsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($552b57436875579d$var$StyledBox, {
        height: (0, $gwIPs.gridSize) * 9,
        iconSize: (0, $gwIPs.gridSize) * 9
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        testId: "issue-navigator-issue-operations.common.ui.error-state.error-icon",
        color: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6NkNz.StyledText), null, formatMessage((0, $7tt2k.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onRetry,
        appearance: "link"
    }, formatMessage((0, $7tt2k.default).retryMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $552b57436875579d$var$DropdownItemsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1tket9kd _1ul9p3fh _p12fp3fh _c71leo28 _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $552b57436875579d$var$StyledBox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`),
            "--_1kpj8xj": (0, $lD23V.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i2nrh _1bah1h6o",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7tt2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b85d564d7311184$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7b85d564d7311184$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.retry-message",
        "defaultMessage": "Click to retry"
    }
});

});

parcelRegister("6NkNz", function(module, exports) {

$parcel$export(module.exports, "StyledText", () => $b697b271cff58776$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b697b271cff58776$var$StyledTextComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $b697b271cff58776$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b697b271cff58776$var$StyledTextComponent, props));

});


parcelRegister("3KrVF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b63515124e0ccb7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5b63515124e0ccb7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    menuButton: {
        "id": "issue-navigator-issue-operations.menu-button",
        "defaultMessage": "Issue operations menu"
    },
    menuButtonLabel: {
        "id": "issue-navigator-issue-operations.menu-button-label",
        "defaultMessage": "More actions for {issueKey}"
    },
    disabledMenuButtonLabel: {
        "id": "issue-navigator-issue-operations.disabled-menu-button-label",
        "defaultMessage": "Disabled more actions button for {issueKey}"
    },
    menuButtonIssueTerminologyRefreshM4: {
        "id": "issue-navigator-issue-operations.menu-button-issue-terminology-refresh-m4",
        "defaultMessage": "Work item operations menu"
    }
});

});

parcelRegister("avR5B", function(module, exports) {

let $7a75fb0f0f5b10de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7a75fb0f0f5b10de$var$load("ie65J").then(()=>parcelRequire('jTcWd'));

});



parcelRegister("hxR1y", function(module, exports) {

$parcel$export(module.exports, "IssueStatusCategoryCell", () => $0187ecf3d6ba0b52$export$663286ccb241374c);

var $3Twi3 = parcelRequire("3Twi3");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $fQeLt = parcelRequire("fQeLt");

var $dpHMc = parcelRequire("dpHMc");

var $7mPT9 = parcelRequire("7mPT9");

var $hKMVG = parcelRequire("hKMVG");

var $e9M6d = parcelRequire("e9M6d");
const $0187ecf3d6ba0b52$export$663286ccb241374c = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef })=>{
    const { statusCategory: statusCategory } = (0, $8Uumt.useFragment)((0, $3Twi3.default), fieldRef);
    const { name: name } = statusCategory;
    const statusCategoryId = parseInt(statusCategory.statusCategoryId, 10);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    const contentRef = (0, $5uXOq.useRef)(null);
    if (Number.isNaN(statusCategoryId) || statusCategoryId === -1 || !name?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "statusCategory",
        reason: "Missing required fields"
    });
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0187ecf3d6ba0b52$var$alignmentFixStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozenge), {
        value: {
            id: '',
            name: name,
            statusCategory: {
                id: statusCategoryId
            }
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: statusCategory.name,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $0187ecf3d6ba0b52$var$alignmentFixStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozenge), {
            value: {
                id: '',
                name: name,
                statusCategory: {
                    id: statusCategoryId
                }
            },
            contentRef: (0, $7mPT9.default)(contentRef, ref)
        })));
});
// Status lozenges have a 2px invisible border around them to keep them in the same place if they enter an "error" state (where a border colour is added).
// Refer to: src/packages/issue/fields/status/src/common/ui/status-lozenge/main.tsx
const $0187ecf3d6ba0b52$var$alignmentFixStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.025'
});

});
parcelRegister("3Twi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $33321105b85fcf01$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ea56737eacf62204e5cc47ea8a38de4e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $33321105b85fcf01$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell",
    "selections": [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusCategoryId"
                }
            ]
        }
    ],
    "type": "JiraStatusCategoryField"
};
$33321105b85fcf01$var$node.hash = "01c5fef6394b4cc6d50a5e2f02db1620";
var $33321105b85fcf01$export$2e2bcd8739ae039 = $33321105b85fcf01$var$node;

});

parcelRegister("fQeLt", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $e065d549cea5a7d0$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $e065d549cea5a7d0$export$9f5070a985b0679b);

var $5uXOq = parcelRequire("5uXOq");

var $17mYr = parcelRequire("17mYr");
const $e065d549cea5a7d0$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        contentRef: props.contentRef
    });
};
const $e065d549cea5a7d0$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});
parcelRegister("17mYr", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $390c5e7bc7d9c77b$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $390c5e7bc7d9c77b$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $9yOBd = parcelRequire("9yOBd");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $aQhlk = parcelRequire("aQhlk");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $5Ax7l = parcelRequire("5Ax7l");

var $4YeLF = parcelRequire("4YeLF");
const $390c5e7bc7d9c77b$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $390c5e7bc7d9c77b$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $390c5e7bc7d9c77b$var$StatusLozengeNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`,
        ref: ref
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, name)), hasHoverState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $390c5e7bc7d9c77b$var$hoverOverlayStyles
    })));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, contentRef: contentRef, triggerProps: triggerProps = {}, ...others } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: $390c5e7bc7d9c77b$var$pressableStyles,
        ref: targetRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeNew, {
        ...others,
        isEditable: isEditable,
        ref: contentRef
    }));
};
const $390c5e7bc7d9c77b$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    })));
const $390c5e7bc7d9c77b$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, name)));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, triggerProps: triggerProps = {}, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? "var(--ds-border-danger, #E2483D)" : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? "var(--ds-border-focused, #388BFF)" : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeOld, {
        ...other,
        isEditable: isEditable
    }));
};
const $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$StatusLozengeNew, $390c5e7bc7d9c77b$var$StatusLozengeOld);
const $390c5e7bc7d9c77b$export$69ea4907eefa8e7b = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew, $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozenge = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>// eslint-disable-next-line no-nested-ternary
    props.isDisabled ? (0, $aQhlk.disabledColor).text : !(0, $dCm1o.isVisualRefreshEnabled)() ? (0, $aQhlk.textColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]] : (0, $aQhlk.textColorOld)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $aQhlk.disabledColor).text : (0, $aQhlk.textHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $47bDC.css)({
        pointerEvents: 'none'
    })}}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1bgi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StatusContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $390c5e7bc7d9c77b$var$pressableStyles = (0, $8CUq3.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: '3px',
    background: 'transparent',
    position: 'relative',
    maxWidth: '100%',
    marginLeft: 'space.025'
});
const $390c5e7bc7d9c77b$var$hoverOverlayStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    inset: '0',
    borderRadius: '3px',
    marginRight: 'space.025',
    ':hover': {
        opacity: 0.3,
        backgroundColor: 'color.background.inverse.subtle'
    }
});

});
parcelRegister("aQhlk", function(module, exports) {

$parcel$export(module.exports, "statusCategoryToThemeMap", () => $58bc751e3aa4b554$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $58bc751e3aa4b554$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $58bc751e3aa4b554$export$32f78bffcd82ff28);
$parcel$export(module.exports, "textColorOld", () => $58bc751e3aa4b554$export$26ac04004fa4ead4);
$parcel$export(module.exports, "bgHoverColor", () => $58bc751e3aa4b554$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $58bc751e3aa4b554$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $58bc751e3aa4b554$export$b70f10fc4a6ba453);
const $58bc751e3aa4b554$export$61137dce61763ec3 = 'default';
const $58bc751e3aa4b554$export$132676d06d92ad48 = 'success';
const $58bc751e3aa4b554$export$5c1f3b72419aa125 = 'inprogress';
const $58bc751e3aa4b554$export$d9e35f42afe1e488 = {
    '1': $58bc751e3aa4b554$export$61137dce61763ec3,
    '2': $58bc751e3aa4b554$export$61137dce61763ec3,
    '3': $58bc751e3aa4b554$export$132676d06d92ad48,
    '4': $58bc751e3aa4b554$export$5c1f3b72419aa125
};
const $58bc751e3aa4b554$export$7dcbec377a25efc6 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-background-neutral, #091E420F)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-background-success, #DCFFF1)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-background-information, #E9F2FF)"
};
const $58bc751e3aa4b554$export$32f78bffcd82ff28 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text-subtle, #44546F)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$26ac04004fa4ead4 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$69fdf3ba928b4c77 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-background-neutral-hovered, #091E4224)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-background-success-hovered, #BAF3DB)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-background-information-hovered, #CCE0FF)"
};
const $58bc751e3aa4b554$export$99ec0cf2cf1b2082 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$b70f10fc4a6ba453 = {
    bg: "var(--ds-background-neutral, #091E420F)",
    text: "var(--ds-text-disabled, #091E424F)"
};

});

parcelRegister("5Ax7l", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $bcba81c28add5d02$export$a31cbe1bf5463979);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $aQhlk = parcelRequire("aQhlk");

const $bcba81c28add5d02$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        appearance: (0, $aQhlk.statusCategoryToThemeMap)[statusCategoryId],
        isBold: true,
        ...isDisabled ? {
            style: {
                color: (0, $aQhlk.disabledColor).text,
                backgroundColor: (0, $aQhlk.disabledColor).bg
            }
        } : {}
    }, children);

});

parcelRegister("4YeLF", function(module, exports) {

$parcel$export(module.exports, "LozengeOld", () => $bbacf745a667099a$export$26089816624d22fc);
// TODO - delete this file when cleaning up visual-refresh

var $5uXOq = parcelRequire("5uXOq");
const $bbacf745a667099a$var$containerStyles = {
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $bbacf745a667099a$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $bbacf745a667099a$export$26089816624d22fc = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$contentStyles
    }, children));
$bbacf745a667099a$export$26089816624d22fc.displayName = 'Lozenge';

});




parcelRegister("k2wrj", function(module, exports) {

$parcel$export(module.exports, "IssueStatusCell", () => $a301f7b3e7d0d020$export$58e0df5bb69dbb83);

var $gJWhR = parcelRequire("gJWhR");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $9fZKh = parcelRequire("9fZKh");

var $fQeLt = parcelRequire("fQeLt");

var $8zOmE = parcelRequire("8zOmE");

var $g5X3G = parcelRequire("g5X3G");

var $dpHMc = parcelRequire("dpHMc");

var $hKMVG = parcelRequire("hKMVG");

var $e9M6d = parcelRequire("e9M6d");

var $1uLry = parcelRequire("1uLry");
const $a301f7b3e7d0d020$export$58e0df5bb69dbb83 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, issueKey: issueKey, onUpdateCache: onUpdateCache, issueId: issueId })=>{
    const data = (0, $8Uumt.useFragment)((0, $gJWhR.default), fieldRef);
    const { status: status } = data;
    const [value, setValue] = (0, $5uXOq.useState)(status);
    const [isEditing, setIsEditing] = (0, $5uXOq.useState)(false);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    const contentRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        setValue(status);
    }, [
        status
    ]);
    const onSubmit = (0, $5uXOq.useCallback)((oldValue, newValue, meta, event)=>{
        // Mirrors the updated event fired from the issue view (with the addition of `isInlineEditing: true`) to
        // be used for core action tracking as defined in https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition
        (0, $8zOmE.fireTrackAnalytics)(event, 'issueStatus updated', {
            oldValId: oldValue.id,
            oldStatusCategoryId: oldValue.statusCategory.id,
            newValId: newValue.id,
            newStatusCategoryId: newValue.statusCategory.id,
            hasScreen: meta.transition.hasScreen,
            isConditional: meta.transition.isConditional,
            isInlineEditing: true
        });
    }, []);
    if (value?.statusCategory?.statusCategoryId === undefined || !value?.name?.length || !value?.statusId?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "status",
        reason: "Missing required fields"
    });
    const onSuccess = (newStatus)=>{
        const transformedStatus = (0, $1uLry.toJiraStatusField)(newStatus);
        setValue(transformedStatus);
        onUpdateCache && onUpdateCache(issueKey, 'status', transformedStatus);
    };
    // If the property does not exist in fragment data then we know it has been conditionally excluded because
    // inline editing is disabled. In future this should follow the same design/deferred loading strategy of
    // other inline editable fields, however this would require a larger effort to decompose the status field.
    const isEditable = data && typeof data.id === 'string';
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a301f7b3e7d0d020$var$alignmentFixStyles,
        "data-vc": "native-issue-table-ui-issue-status-box"
    }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fZKh.AsyncIssueStatusField), {
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        issueId: issueId && (0, $g5X3G.toIssueId)(issueId),
        appearance: "lozenge",
        value: (0, $1uLry.toStatusValue)(value),
        onSubmit: onSubmit,
        onSuccess: onSuccess
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozenge), {
        value: (0, $1uLry.toStatusValue)(value)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: (0, $1uLry.toStatusValue)(value).name,
        contentRef: contentRef,
        hidePopover: isEditing
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $a301f7b3e7d0d020$var$alignmentFixStyles,
            "data-vc": "native-issue-table-ui-issue-status-box",
            ref: ref
        }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fZKh.AsyncIssueStatusField), {
            issueKey: (0, $g5X3G.toIssueKey)(issueKey),
            issueId: issueId && (0, $g5X3G.toIssueId)(issueId),
            appearance: "lozenge",
            value: (0, $1uLry.toStatusValue)(value),
            onSubmit: onSubmit,
            onSuccess: onSuccess,
            statusButtonRef: contentRef,
            onEditStart: ()=>setIsEditing(true),
            onEditCancel: ()=>setIsEditing(false)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozenge), {
            value: (0, $1uLry.toStatusValue)(value)
        })));
});
// Status lozenges have a 2px invisible border around them to keep them in the same place if they enter an "error" state (where a border colour is added).
// Refer to: src/packages/issue/fields/status/src/common/ui/status-lozenge/main.tsx
const $a301f7b3e7d0d020$var$alignmentFixStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.025'
});

});
parcelRegister("gJWhR", function(module, exports) {

$parcel$export(module.exports, "default", () => $24d542ca8fcb8c10$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c0f79ce5044190fc6da94cb6bd50afa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $24d542ca8fcb8c10$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "issueStatus_nativeIssueTable_IssueStatusCell",
    "selections": [
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "concreteType": "JiraStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusId"
                },
                {
                    "concreteType": "JiraStatusCategory",
                    "kind": "LinkedField",
                    "name": "statusCategory",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCategoryId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraStatusField"
};
$24d542ca8fcb8c10$var$node.hash = "90e3d56baf9c61aa74ebf80af89d841c";
var $24d542ca8fcb8c10$export$2e2bcd8739ae039 = $24d542ca8fcb8c10$var$node;

});

parcelRegister("9fZKh", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueStatusField", () => $0cd8b9cfe3ba1e4a$export$ddd324b06f34200);
$parcel$export(module.exports, "IssueStatusFieldBoundary", () => $0cd8b9cfe3ba1e4a$export$dba9e9c892560f60);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $fQeLt = parcelRequire("fQeLt");

const $0cd8b9cfe3ba1e4a$export$6dbb1a485af348f = (0, $kxZPA.lazy)(()=>(parcelRequire("4NgFR")), {
    moduleId: "./src/packages/issue/fields/status/src/ui/main.tsx"
});
const $0cd8b9cfe3ba1e4a$export$ddd324b06f34200 = (props)=>{
    const { initialValue: initialValue, value: value } = props;
    const errorProps = {
        initialValue: initialValue,
        value: value
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-field-status",
        packageName: "jira-issue-field-status",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-status-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd8b9cfe3ba1e4a$export$6dbb1a485af348f, props)));
};
const $0cd8b9cfe3ba1e4a$export$dba9e9c892560f60 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-status-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-status-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("4NgFR", function(module, exports) {

let $37d8ac25b7f13bad$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $37d8ac25b7f13bad$var$load("7mIf9"),
    $37d8ac25b7f13bad$var$load("jXweD"),
    $37d8ac25b7f13bad$var$load("76n7a"),
    $37d8ac25b7f13bad$var$load("l253H"),
    $37d8ac25b7f13bad$var$load("ffQaD"),
    $37d8ac25b7f13bad$var$load("kvRbA"),
    $37d8ac25b7f13bad$var$load("gp6Ye")
]).then(()=>parcelRequire('2azQI'));

});


parcelRegister("1uLry", function(module, exports) {

$parcel$export(module.exports, "toJiraStatusField", () => $d6aaee7df7111033$export$54bbdde829b87b5c);
$parcel$export(module.exports, "toStatusValue", () => $d6aaee7df7111033$export$2950d85c450ec19d);
const $d6aaee7df7111033$export$54bbdde829b87b5c = (statusValue)=>({
        statusId: statusValue.id,
        name: statusValue.name,
        statusCategory: {
            statusCategoryId: `${statusValue.statusCategory.id}`
        }
    });
const $d6aaee7df7111033$export$2950d85c450ec19d = (jiraStatusField)=>({
        id: jiraStatusField.statusId,
        name: jiraStatusField.name ?? '',
        statusCategory: {
            id: parseInt(jiraStatusField.statusCategory?.statusCategoryId ?? '', 10)
        }
    });

});


parcelRegister("gzMyH", function(module, exports) {

$parcel$export(module.exports, "IssueSummaryCell", () => $1412def66c41bfc9$export$4da280f2973efc5c);

var $7KGcy = parcelRequire("7KGcy");

var $1JoiT = parcelRequire("1JoiT");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $9YRSH = parcelRequire("9YRSH");

var $4R6GH = parcelRequire("4R6GH");

var $dpHMc = parcelRequire("dpHMc");

var $7mPT9 = parcelRequire("7mPT9");

var $g5X3G = parcelRequire("g5X3G");

var $2e4p8 = parcelRequire("2e4p8");

var $e9M6d = parcelRequire("e9M6d");

var $Br57E = parcelRequire("Br57E");

var $hKMVG = parcelRequire("hKMVG");

var $eCw3H = parcelRequire("eCw3H");

var $jFYC8 = parcelRequire("jFYC8");

var $czfFt = parcelRequire("czfFt");

var $66QHb = parcelRequire("66QHb");

var $lhMQE = parcelRequire("lhMQE");

var $f0sme = parcelRequire("f0sme");
const $1412def66c41bfc9$export$4da280f2973efc5c = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, issueRef: issueRef, children: children, onIssueLinkSelected: onIssueLinkSelected })=>{
    const isEmbedMode = (0, $4R6GH.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2e4p8.useIsEmbedMode)() : false;
    const data = (0, $8Uumt.useFragment)((0, $1JoiT.default), fieldRef);
    const issueData = (0, $8Uumt.useFragment)((0, $7KGcy.default), issueRef);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const updateIssueSummary = (0, $4R6GH.fg)('jsc_list_reparenting') ? (0, $66QHb.useUpdateIssueSummary)() : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    const onSubmitSucceeded = (0, $5uXOq.useCallback)((value)=>{
        if (issueData?.__id && (0, $4R6GH.fg)('jsc_list_reparenting')) updateIssueSummary(issueData.__id, value);
    }, [
        issueData?.__id,
        updateIssueSummary
    ]);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const isDensityCompact = !(0, $e9M6d.useIsDensityFull)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    const contentRef = (0, $5uXOq.useRef)(null);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    const onLinkClick = (0, $5uXOq.useCallback)((e)=>{
        // Use default browser event handling when a modifier key is pressed during the click event
        const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
        const handled = !isEmbedMode && !isModifierKeyUsed && onIssueLinkSelected !== undefined && onIssueLinkSelected(issueData.key);
        if (handled) e.preventDefault();
    }, [
        isEmbedMode,
        issueData.key,
        onIssueLinkSelected
    ]);
    const renderCustomReadView = (0, $5uXOq.useCallback)((text)=>{
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
            cellType: "summary",
            reason: "Missing required fields"
        });
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCw3H.TableCellDiscreteLink), {
            innerFocusOutline: true,
            href: `/browse/${issueData.key}`,
            isSubtle: false,
            onClick: onLinkClick,
            "data-testid": "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
            ...isEmbedMode && {
                target: '_blank',
                rel: 'noopener'
            }
        }, text);
        if (isInlineEditingExtendedFieldSupportEnabled && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
            content: text,
            contentRef: contentRef
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                ref: (0, $7mPT9.default)(contentRef, ref),
                testId: "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
                maxLines: (0, $czfFt.MAX_LINE_WRAP_NEW)
            }, text)), (0, $4R6GH.fg)('jsc_summary_link_button') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0sme.OpenIssueLink), {
            issueKey: (0, $g5X3G.toIssueKey)(issueData.key),
            onClick: onLinkClick
        }), (0, $4R6GH.fg)('jira_list_merged_column_gate') && children);
        if (isInlineEditingExtendedFieldSupportEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            testId: "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
            maxLines: isDensityCompact ? 2 : undefined
        }, text), (0, $4R6GH.fg)('jsc_summary_link_button') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0sme.OpenIssueLink), {
            issueKey: (0, $g5X3G.toIssueKey)(issueData.key),
            onClick: onLinkClick
        }), (0, $4R6GH.fg)('jira_list_merged_column_gate') && children);
        // Span is necessary here to ensure only link text is clickable for multiline summaries, rather than the
        // entire content box.
        return isDensityCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span",
            xcss: $1412def66c41bfc9$var$textOverflowStyles
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, content);
    }, [
        children,
        isDensityCompact,
        isEmbedMode,
        isInlineEditingExtendedFieldSupportEnabled,
        isSingleLineRowHeightEnabled,
        issueData.key,
        onLinkClick
    ]);
    const node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YRSH.SingleLineTextInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        editViewPopupTarget: (0, $4R6GH.fg)('jsc_summary_link_button') ? $1412def66c41bfc9$var$EditViewPopupTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        isRequired: true,
        maxLength: 255,
        readViewFitContainerHeight: true,
        renderCustomReadView: renderCustomReadView,
        hideEditButton: isInlineEditingExtendedFieldSupportEnabled,
        onSubmitSucceeded: (0, $4R6GH.fg)('jsc_list_reparenting') ? onSubmitSucceeded : undefined,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
    if (isInlineEditingExtendedFieldSupportEnabled && (0, $4R6GH.fg)('jsc_summary_link_button')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lhMQE.ActionContainer), null, node);
    return node;
});
const $1412def66c41bfc9$var$EditViewPopupTarget = /*#__PURE__*/ (0, $5uXOq.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1412def66c41bfc9$var$customTargetStyles,
        ref: ref
    });
});
// We have an extra flex container around our inline edit component so we can show the open issue link button. We need
// to explicitly center align the edit view popup target to ensure consistent alignment in the table cell.
const $1412def66c41bfc9$var$customTargetStyles = (0, $8CUq3.xcss)({
    alignSelf: 'center',
    width: '0'
});
const $1412def66c41bfc9$var$textOverflowStyles = (0, $8CUq3.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});

});
parcelRegister("7KGcy", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b5a2b865e5ac00$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8218f47ddc91c3359aa0c4b7cefdd7c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $18b5a2b865e5ac00$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueSummary_nativeIssueTable_IssueSummaryCell_issueRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$18b5a2b865e5ac00$var$node.hash = "dcb0d0c1f8d780927dbe796b45e5676f";
var $18b5a2b865e5ac00$export$2e2bcd8739ae039 = $18b5a2b865e5ac00$var$node;

});

parcelRegister("1JoiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $370e75a4786ce04a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c4ac5609d74626566ce1666b4ad9a7bc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $370e75a4786ce04a$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "issueSummary_nativeIssueTable_IssueSummaryCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$370e75a4786ce04a$var$node.hash = "beddff3ed27f18187b31aea14d38514c";
var $370e75a4786ce04a$export$2e2bcd8739ae039 = $370e75a4786ce04a$var$node;

});

parcelRegister("9YRSH", function(module, exports) {

$parcel$export(module.exports, "SingleLineTextInlineEditViewWithIsEditable", () => $b2511b78f86a8bef$export$f267c8aeb8112733);
$parcel$export(module.exports, "SingleLineTextInlineEditView", () => $b2511b78f86a8bef$export$ad603a514b680587);

var $5aYgL = parcelRequire("5aYgL");

var $93TkX = parcelRequire("93TkX");

var $lWrc6 = parcelRequire("lWrc6");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jrRyX = parcelRequire("jrRyX");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $eRz50 = parcelRequire("eRz50");

var $617vt = parcelRequire("617vt");

var $cA85v = parcelRequire("cA85v");
const $b2511b78f86a8bef$export$f267c8aeb8112733 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen, isRequired: isRequired = false, hideEditButton: hideEditButton, maxLength: maxLength, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, renderCustomReadView: renderCustomReadView, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled = false })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $lWrc6.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, type: type, text: text, name: name } = data;
    const [commit] = (0, $8Uumt.useMutation)((0, $93TkX.default));
    // #endregion
    // #region Common state
    const initialValue = text ?? '';
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    // #endregion
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overriding ? overriding.overrideIsEditable(isEditable) : isEditable, [
        isEditable,
        overriding
    ]);
    const fieldName = (0, $5uXOq.useMemo)(()=>overriding ? overriding.overrideLabel(name) : name, [
        name,
        overriding
    ]);
    const validator = (0, $cA85v.useSingleLineTextValidator)(fieldName, isRequired, maxLength);
    /**
   * This will execute the GraphQL mutation.
   */ const handleSubmit = (0, $5uXOq.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        text: value,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateSingleLineTextField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateSingleLineTextField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            text: value
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        initialValue: initialValue,
        updatedValue: updatedValue,
        validator: validator,
        clipboardComponentType: 'text'
    });
    const onChange = (0, $5uXOq.useCallback)((event)=>{
        handleChange(event.target.value);
    }, [
        handleChange
    ]);
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $617vt.SingleLineTextReadView), {
            fragmentRef: data,
            renderCustomReadView: renderCustomReadView
        });
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            value: updatedValue,
            onChange: onChange,
            isInvalid: !!invalidMessage,
            autoFocus: true,
            ariaLabel: fieldName
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "large",
        editViewPopupTarget: editViewPopupTarget,
        editViewEntryPoint: (0, $eRz50.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        hideEditButton: hideEditButton,
        invalidMessage: invalidMessage ?? undefined,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled
    });
};
const $b2511b78f86a8bef$export$ad603a514b680587 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $5aYgL.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b2511b78f86a8bef$export$f267c8aeb8112733, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("5aYgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e50edd3a21bf4468$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5603fda12586c734accd519f63ebd761>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e50edd3a21bf4468$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleLineTextField"
};
$e50edd3a21bf4468$var$node.hash = "834bf98c01966c210bc0a4f6e9f0f4a7";
var $e50edd3a21bf4468$export$2e2bcd8739ae039 = $e50edd3a21bf4468$var$node;

});

parcelRegister("93TkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $46188b7f9b03f68b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f87bbae0df7928fcb860f8d696c8c51>>
 * @relayHash 029277561796d9f13acaef1dbb085ee8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6baebfa2f37e676d26595f29fc232725ad41353c9fcd04168be34a6b616f152
const $46188b7f9b03f68b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSingleLineTextFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateSingleLineTextField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraSingleLineTextField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "text"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a6baebfa2f37e676d26595f29fc232725ad41353c9fcd04168be34a6b616f152",
            "metadata": {},
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$46188b7f9b03f68b$var$node.hash = "7910ed923271af0f6fe2fd325e2358de";
var $46188b7f9b03f68b$export$2e2bcd8739ae039 = $46188b7f9b03f68b$var$node;

});

parcelRegister("lWrc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd84a6e43c511b1c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ebc67ee0e5b1d19577ad84dec6dd3022>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cd84a6e43c511b1c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextReadviewFull_SingleLineTextReadView"
        },
        {
            "kind": "ScalarField",
            "name": "text"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$cd84a6e43c511b1c$var$node.hash = "fa64e21466cd3e14f917674796ea3359";
var $cd84a6e43c511b1c$export$2e2bcd8739ae039 = $cd84a6e43c511b1c$var$node;

});

parcelRegister("eRz50", function(module, exports) {

$parcel$export(module.exports, "default", () => $20692c8d9647b92b$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $20692c8d9647b92b$var$SingleLineTextEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("4BImu"))), {
        moduleId: "c6bbf997"
    }),
    getPreloadProps: ()=>({})
});
var $20692c8d9647b92b$export$2e2bcd8739ae039 = $20692c8d9647b92b$var$SingleLineTextEditViewEntryPoint;

});

parcelRegister("617vt", function(module, exports) {

$parcel$export(module.exports, "SingleLineTextReadView", () => $3bd4d89e00a90c2d$export$5a145b2225896aea);

var $112k7 = parcelRequire("112k7");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $8xYPa = parcelRequire("8xYPa");

var $6s1PB = parcelRequire("6s1PB");

var $eZibI = parcelRequire("eZibI");

var $kYkHV = parcelRequire("kYkHV");

var $4R6GH = parcelRequire("4R6GH");
const $3bd4d89e00a90c2d$export$5a145b2225896aea = ({ fragmentRef: fragmentRef, renderFieldContentWrapper: FieldContentWrapper, renderCustomReadView: renderCustomReadView })=>{
    const { text: text = null, fieldId: fieldId } = (0, $8Uumt.useFragment)((0, $112k7.default), fragmentRef);
    const getReadView = (0, $5uXOq.useCallback)(()=>{
        if (renderCustomReadView) return renderCustomReadView(text);
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
        const testId = `issue.views.field.single-line-text.read-view.${fieldId}`;
        if ((0, $8xYPa.default)(text, true) && (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'issue-view', true)) {
            if ((0, $4R6GH.fg)('enable_redaction_support_in_jira_issue_view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                name: `redaction-marker-${fieldId}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3bd4d89e00a90c2d$var$ReadViewContainer, {
                "data-testid": testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kYkHV.LazySmartLink), {
                appearance: "inline",
                url: text
            })));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3bd4d89e00a90c2d$var$ReadViewContainer, {
                "data-testid": testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kYkHV.LazySmartLink), {
                appearance: "inline",
                url: text
            }));
        }
        if ((0, $4R6GH.fg)('enable_redaction_support_in_jira_issue_view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: `redaction-marker-${fieldId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3bd4d89e00a90c2d$var$ReadViewContainer, {
            "data-testid": testId
        }, text));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3bd4d89e00a90c2d$var$ReadViewContainer, {
            "data-testid": testId
        }, text);
    }, [
        renderCustomReadView,
        fieldId,
        text
    ]);
    if (FieldContentWrapper) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldContentWrapper, null, getReadView());
    return getReadView();
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bd4d89e00a90c2d$var$ReadViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _vwz4gktf _1nmz1hna _kqswh2mm _1bsb1osq _1eog1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("112k7", function(module, exports) {

$parcel$export(module.exports, "default", () => $78b79d6ad99afdf7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28cc3f1e512619502f58cc6e1fc159db>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $78b79d6ad99afdf7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextReadviewFull_SingleLineTextReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "text"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$78b79d6ad99afdf7$var$node.hash = "5f51bd1526b02ac7cd91c57eec827a2f";
var $78b79d6ad99afdf7$export$2e2bcd8739ae039 = $78b79d6ad99afdf7$var$node;

});

parcelRegister("8xYPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f301d52fd5328fb7$export$2e2bcd8739ae039);
/**
 * The URL standard regex for spec.: RFC 3986
 * https://tools.ietf.org/html/rfc3986#page-51
 */ const $f301d52fd5328fb7$var$URLStandardRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?');
/**
 * Full Domain name limits as per RFC is 256 characters
 * TLD limit as per RFC 1035 is 63 characters. Although, TLDs can contain numbers, since none of the existing popular TLDs are numbers, we are not allowing numbers in TLD.
 * Any characters allowed in protocol and query string. Domain name needs to be alphanumeric with hyphens allowed.
 */ const $f301d52fd5328fb7$var$stricterURLRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?[-a-zA-Z0-9@:.]{2,256}.[a-z]{2,63}\\b([-a-zA-Z0-9@:%_+.~#?&//=]*)');
const $f301d52fd5328fb7$var$protocolRegex = new RegExp('^(http|https|ftp)://.*|^//[^/]*?');
function $f301d52fd5328fb7$export$bef94a5618bf18bf(string, strict = false) {
    // Have to be string
    if (!string || typeof string !== 'string') return false;
    // Exit early if there is a space, no need to regex that
    if (string.indexOf(' ') >= 0 || string.length === 0) return false;
    // Localhost is bit different, doesn't need a dot but others likely should
    if (string.indexOf('localhost') === -1 && string.indexOf('.') === -1) return false;
    if (strict === true) return $f301d52fd5328fb7$var$stricterURLRegex.test(string) || $f301d52fd5328fb7$var$protocolRegex.test(string);
    return $f301d52fd5328fb7$var$URLStandardRegex.test(string);
}
var $f301d52fd5328fb7$export$2e2bcd8739ae039 = $f301d52fd5328fb7$export$bef94a5618bf18bf;

});

parcelRegister("kYkHV", function(module, exports) {

$parcel$export(module.exports, "LazySmartLink", () => $8487950172f5ea4b$export$fe7f8e391b2babff);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kRaSu = parcelRequire("kRaSu");
const $8487950172f5ea4b$var$entryPointParams = {};
const $8487950172f5ea4b$export$fe7f8e391b2babff = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kRaSu.SmartLinkEntryPoint), $8487950172f5ea4b$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.issue-field.smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("kRaSu", function(module, exports) {

$parcel$export(module.exports, "SmartLinkEntryPoint", () => $7afbb235d3dc2c80$export$29454edb61a1a57e);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $7afbb235d3dc2c80$export$29454edb61a1a57e = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3b4f2")).then((module)=>module.SmartLink), {
        moduleId: "3da73bc4"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3b4f2", function(module, exports) {

let $2505b076d1a8e666$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2505b076d1a8e666$var$load("fliVL"),
    $2505b076d1a8e666$var$load("4d8vq")
]).then(()=>parcelRequire('7jsM3'));

});




parcelRegister("cA85v", function(module, exports) {

$parcel$export(module.exports, "useSingleLineTextValidator", () => $025718172ff0a56c$export$6955d95abfe9109c);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bwChB = parcelRequire("bwChB");
const $025718172ff0a56c$export$6955d95abfe9109c = (fieldName, isRequired, maxLength)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const change = (0, $5uXOq.useCallback)((value)=>{
        if (maxLength && maxLength > 0 && value.length > maxLength) return {
            type: 'error',
            message: formatMessage((0, $bwChB.default).maxLengthErrorMessage, {
                maxLength: maxLength
            })
        };
        return null;
    }, [
        formatMessage,
        maxLength
    ]);
    const submit = (0, $5uXOq.useCallback)((value)=>{
        if (isRequired && value.trim().length === 0) return {
            type: 'error',
            message: formatMessage((0, $bwChB.default).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        change: change,
        submit: submit
    };
};

});
parcelRegister("bwChB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bcd33450fcfbedb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0bcd33450fcfbedb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    maxLengthErrorMessage: {
        "id": "issue-field-single-line-text-inline-edit-full.single-line-text.max-length-error-message",
        "defaultMessage": "{maxLength} character limit"
    },
    requiredErrorMessage: {
        "id": "issue-field-single-line-text-inline-edit-full.single-line-text.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});

});



parcelRegister("66QHb", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssueSummary", () => $2d173e51fcb1863e$export$8664a69d14346ead);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");
const $2d173e51fcb1863e$export$8664a69d14346ead = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)((issueRelayId, summary)=>{
        (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const issueEntry = store.get(issueRelayId);
            if (issueEntry) issueEntry.setValue(summary, 'summary');
        });
    }, [
        environment
    ]);
};

});

parcelRegister("lhMQE", function(module, exports) {

$parcel$export(module.exports, "ActionContainer", () => $5ffd8a4cbe36a017$export$37ab3bdebc286ca);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $5ffd8a4cbe36a017$export$37ab3bdebc286ca = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n _1tke1osq _155eidpf _nouyt94y _12nht94y"
        ])
    }, children);
};
const $5ffd8a4cbe36a017$var$containerStyles = null;

});

parcelRegister("f0sme", function(module, exports) {

$parcel$export(module.exports, "OpenIssueLink", () => $80f0adcdbe5af0e8$export$8f0bae95f8140072);

var $5uXOq = parcelRequire("5uXOq");

var $jhmo0 = parcelRequire("jhmo0");
var $8CUq3 = parcelRequire("8CUq3");

var $3sGLB = parcelRequire("3sGLB");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $2e4p8 = parcelRequire("2e4p8");

var $4R6GH = parcelRequire("4R6GH");

var $4iq4Z = parcelRequire("4iq4Z");
const $80f0adcdbe5af0e8$export$8f0bae95f8140072 = ({ issueKey: issueKey, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isEmbedMode = (0, $4R6GH.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2e4p8.useIsEmbedMode)() : false;
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
        onClick?.(e);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $4iq4Z.default).openTooltip)
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
            ...triggerProps,
            "aria-label": formatMessage((0, $4iq4Z.default).openLabel, {
                issueKey: issueKey
            }),
            href: `/browse/${issueKey}`,
            onClick: handleClick,
            xcss: $80f0adcdbe5af0e8$var$buttonStyles,
            // Cannot provide CSS variable as a compile time value due to various type constraints between
            // primitives + compiled.
            // eslint-disable-next-line jira/react/no-style-attribute,@atlaskit/ui-styling-standard/enforce-style-prop
            style: $80f0adcdbe5af0e8$var$buttonOpacityVariableStyle,
            ...isEmbedMode && {
                target: '_blank',
                rel: 'noopener'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sGLB))), {
            label: ""
        })));
};
const $80f0adcdbe5af0e8$var$buttonOpacityVariableStyle = {
    opacity: 'var(--open-button-opacity, 0)'
};
const $80f0adcdbe5af0e8$var$buttonStyles = (0, $8CUq3.xcss)({
    alignItems: 'center',
    borderRadius: 'border.radius',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderWidth: 'border.width',
    color: 'color.text',
    display: 'inline-flex',
    height: '24px',
    justifyContent: 'center',
    marginLeft: 'auto',
    paddingTop: 'space.050',
    paddingRight: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.050',
    width: '24px',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text'
    },
    ':focus': {
        color: 'color.text'
    },
    ':active': {
        color: 'color.text'
    }
});

});
parcelRegister("4iq4Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc807cf04512a5eb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bc807cf04512a5eb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openTooltip: {
        "id": "native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-tooltip",
        "defaultMessage": "Select work item"
    },
    openLabel: {
        "id": "native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-label",
        "defaultMessage": "Select work item {issueKey}"
    }
});

});



parcelRegister("7zHDm", function(module, exports) {

$parcel$export(module.exports, "IssueTypeCell", () => $b045c3367c9ddd8f$export$75b44b408924c851);

var $4Fhci = parcelRequire("4Fhci");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fZF1Q = parcelRequire("fZF1Q");
const $b045c3367c9ddd8f$export$75b44b408924c851 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef })=>{
    const { issueType: issueType } = (0, $8Uumt.useFragment)((0, $4Fhci.default), fieldRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fZF1Q.IconCell), {
        iconUrl: issueType?.avatar?.small,
        name: issueType?.name,
        showErrorIconWhenEmpty: true
    });
});

});
parcelRegister("4Fhci", function(module, exports) {

$parcel$export(module.exports, "default", () => $f456b4c17c1803b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7bfcee0dfb23a2020dec682786ec47f8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f456b4c17c1803b2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueType_nativeIssueTable_IssueTypeCell",
    "selections": [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "small"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraIssueTypeField"
};
$f456b4c17c1803b2$var$node.hash = "e81709c5f121dd64c1bf41498bda4ae0";
var $f456b4c17c1803b2$export$2e2bcd8739ae039 = $f456b4c17c1803b2$var$node;

});

parcelRegister("fZF1Q", function(module, exports) {

$parcel$export(module.exports, "IconCell", () => $bbc44c8ad1588ca6$export$5ffd26a2d6f7e2d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $dpHMc = parcelRequire("dpHMc");

var $4R6GH = parcelRequire("4R6GH");

var $hKMVG = parcelRequire("hKMVG");

var $e9M6d = parcelRequire("e9M6d");
const $bbc44c8ad1588ca6$export$5ffd26a2d6f7e2d = /*#__PURE__*/ (0, $5uXOq.memo)(({ name: name, iconUrl: iconUrl, showErrorIconWhenEmpty: showErrorIconWhenEmpty })=>{
    const isSingleLineRowHeightFeatureEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    let isMergedColumnVisible = false;
    if ((0, $4R6GH.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnVisible = (0, $e9M6d.useIsMergedColumnVisible)();
    const isSingleLineRowHeightEnabled = isSingleLineRowHeightFeatureEnabled && !isMergedColumnVisible;
    if (!name?.length || !iconUrl?.length) return showErrorIconWhenEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "icon",
        reason: "Missing required fields"
    }) : null; // aka an empty cell
    const imgComponent = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
            height: "16",
            width: "16",
            src: iconUrl,
            alt: name,
            "data-vc": "native-issue-table-ui-icon-cell-img",
            ref: ref,
            className: (0, $bwpsq.default)([
                isSingleLineRowHeightEnabled && "_1e0c1ule"
            ])
        });
    if (isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: name
    }, ({ ref: ref })=>imgComponent(ref));
    return(// @ts-expect-error Incompatible ref type in tooltip (AK needs "HTMLElement", Compiled provides "HTMLDivElement" somehow these are not compatible in Typescript)
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: name,
        tag: $bbc44c8ad1588ca6$var$AlignmentFix
    }, imgComponent()));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bbc44c8ad1588ca6$var$AlignmentFix = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $bbc44c8ad1588ca6$var$imgStyles = null;

});


parcelRegister("kNCQ8", function(module, exports) {

$parcel$export(module.exports, "LabelsCell", () => $75aacf1fb9c58432$export$b1db1ca9063ebfb8);

var $k9Izt = parcelRequire("k9Izt");

var $8rcLm = parcelRequire("8rcLm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $iEIQF = parcelRequire("iEIQF");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");

var $f5TWP = parcelRequire("f5TWP");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $f0heR = parcelRequire("f0heR");

var $2bYmU = parcelRequire("2bYmU");

var $l8IoT = parcelRequire("l8IoT");

var $65VLO = parcelRequire("65VLO");

var $6s1PB = parcelRequire("6s1PB");

var $e9M6d = parcelRequire("e9M6d");

var $Br57E = parcelRequire("Br57E");

var $aB7bN = parcelRequire("aB7bN");

var $hKMVG = parcelRequire("hKMVG");

var $jFYC8 = parcelRequire("jFYC8");

var $5GnJJ = parcelRequire("5GnJJ");
/**
 * Expected JQL Output: `${jqlTerm} = ${name}`
 */ const $75aacf1fb9c58432$var$getLinkJql = (jqlTerm, name)=>{
    const jast = (0, $iEIQF.default).jast((0, $iEIQF.default).query((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field((0, $aB7bN.escapeBackslashes)(jqlTerm)), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS)), (0, $iEIQF.default).valueOperand((0, $aB7bN.escapeBackslashes)(name)))));
    return (0, $l0V05.print)(jast, {
        operatorCase: 'upper'
    });
};
const $75aacf1fb9c58432$export$b1db1ca9063ebfb8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    /* eslint-disable @atlassian/relay/graphql-naming */ const data = (0, $8Uumt.useFragment)((0, $8rcLm.default), fieldRef);
    /* eslint-enable @atlassian/relay/graphql-naming */ const isDensityFull = (0, $e9M6d.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    const isLabelsSystemField = data.fieldId === (0, $65VLO.KNOWN_COLUMN_TYPES).LABELS;
    const labels = data.selectedLabelsConnection?.edges;
    const filteredLabels = (0, $5uXOq.useMemo)(()=>isLabelsSystemField ? [] : labels?.map((edge)=>edge?.node?.name != null ? {
                key: edge.node.name,
                name: edge.node.name,
                href: `${issueSearchBaseUrl}?jql=${encodeURIComponent($75aacf1fb9c58432$var$getLinkJql(jqlTerm, edge.node.name))}`,
                ...(0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) ? {
                    isColored: true
                } : {}
            } : null).filter((0, $aB7bN.isNonNullish)) ?? [], [
        isLabelsSystemField,
        labels,
        issueSearchBaseUrl,
        jqlTerm
    ]);
    if (isLabelsSystemField || (0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($75aacf1fb9c58432$export$194e7ceec6d29085, {
        fieldRef: data,
        issueSearchBaseUrl: issueSearchBaseUrl,
        isTruncated: !isDensityFull,
        isHoverPopoverEnabled: isSingleLineRowHeightEnabled,
        isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover
    });
    if (!labels || labels.length !== filteredLabels.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "labels",
        reason: "Missing required fields"
    });
    if (isDensityFull) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: true
    }, filteredLabels.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8IoT.TagItem), {
            key: label.key,
            name: label.name,
            href: label.href,
            ...label.isColored ? {
                isColored: label.isColored
            } : {}
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bYmU.default), {
        items: filteredLabels,
        ItemComponent: (0, $l8IoT.TagItem),
        PopupContentWrapper: (0, $l8IoT.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $5GnJJ.default).triggerButton)
    });
});
const $75aacf1fb9c58432$export$194e7ceec6d29085 = ({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, isTruncated: isTruncated, menuPortalTarget: menuPortalTarget, isHoverPopoverEnabled: isHoverPopoverEnabled, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $k9Izt.default), fieldRef);
    const isLabelsSystemField = data.fieldId === (0, $65VLO.KNOWN_COLUMN_TYPES).LABELS;
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isInlineEditingSupported = isLabelsSystemField || isInlineEditingExtendedFieldSupportEnabled;
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingSupported ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0heR.LabelsInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        baseSearchUrl: issueSearchBaseUrl,
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isTruncated: isTruncated,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        menuPortalTarget: menuPortalTarget,
        readViewFitContainerHeight: true,
        isHoverPopoverEnabled: isHoverPopoverEnabled && !isReadOnlyWithoutHoverPopover
    });
};

});
parcelRegister("k9Izt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a5b4ac32ab66132$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<62e3116c435d80a798da8c375c0bf69d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9a5b4ac32ab66132$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "labels_nativeIssueTable_LabelsInlineEditCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraLabelsField"
};
$9a5b4ac32ab66132$var$node.hash = "f76e2dc26627b6d7258218de93f192ad";
var $9a5b4ac32ab66132$export$2e2bcd8739ae039 = $9a5b4ac32ab66132$var$node;

});

parcelRegister("8rcLm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c655c6d6185fbb3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<14a01d21f77762b8bf6dc1773a908d06>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5c655c6d6185fbb3$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "labels_nativeIssueTable_LabelsCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraLabelConnection",
            "kind": "LinkedField",
            "name": "selectedLabelsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraLabelEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraLabel",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedLabelsConnection(first:1000)"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "labels_nativeIssueTable_LabelsInlineEditCell_fieldRef"
        }
    ],
    "type": "JiraLabelsField"
};
$5c655c6d6185fbb3$var$node.hash = "4d3abd4e5894c74a98fcfca725bffcab";
var $5c655c6d6185fbb3$export$2e2bcd8739ae039 = $5c655c6d6185fbb3$var$node;

});

parcelRegister("f0heR", function(module, exports) {

$parcel$export(module.exports, "LabelsInlineEditViewWithIsEditable", () => $fcc6937e9a821897$export$f00c136eadca5f4b);
$parcel$export(module.exports, "LabelsInlineEditView", () => $fcc6937e9a821897$export$f066b3edf0d7cd25);

var $8tXFa = parcelRequire("8tXFa");

var $lzd6v = parcelRequire("lzd6v");

var $cT2aD = parcelRequire("cT2aD");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7Jxgt = parcelRequire("7Jxgt");

var $2YZCu = parcelRequire("2YZCu");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $jrRyX = parcelRequire("jrRyX");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $7hmM3 = parcelRequire("7hmM3");

var $hTCPY = parcelRequire("hTCPY");

var $fP5Bh = parcelRequire("fP5Bh");

var $1iOCQ = parcelRequire("1iOCQ");

var $2NMNM = parcelRequire("2NMNM");

var $2gCtH = parcelRequire("2gCtH");

var $6zbnz = parcelRequire("6zbnz");

var $gG69f = parcelRequire("gG69f");
const $fcc6937e9a821897$var$FIELD_KEY = 'labels';
const $fcc6937e9a821897$var$FIELD_TYPE = 'labels';
const $fcc6937e9a821897$export$865a98c44e795d94 = 'field updated';
const $fcc6937e9a821897$export$1b05898090f57b12 = 'issue-field.save-value';
const $fcc6937e9a821897$export$3f27bc10068ef877 = `Failed to update field ${$fcc6937e9a821897$var$FIELD_KEY} of type ${$fcc6937e9a821897$var$FIELD_TYPE}`;
const $fcc6937e9a821897$var$transformAggToAtlaskitOption = (connection)=>{
    const labelValues = connection?.edges?.map((edge)=>edge?.node ?? null).filter(Boolean).filter((label)=>label && label.name != null) || [];
    const labelOptions = labelValues.map((label)=>({
            label: label.name || '',
            value: label.name || ''
        }));
    return labelOptions;
};
const $fcc6937e9a821897$var$transformAtlaskitOptionToAgg = (value)=>({
        totalCount: value.length,
        edges: value.map((label)=>({
                node: {
                    name: label.value
                }
            }))
    });
const $fcc6937e9a821897$var$transformLabelsOptionsToLabelNames = (value)=>value?.map((labelOption)=>labelOption.value) ?? [];
const $fcc6937e9a821897$var$transformOptionsOperationsIntoAggOperationInput = (operations)=>operations.map(({ operation: operation, value: value })=>({
            operation: operation,
            labels: $fcc6937e9a821897$var$transformLabelsOptionsToLabelNames(value)
        }));
const $fcc6937e9a821897$var$isEqualLabels = (a, b)=>a.length === b.length && a.every((option, index)=>option.label === b[index].label && option.value === b[index].value);
const $fcc6937e9a821897$export$f00c136eadca5f4b = ({ attributes: attributes, spacing: spacing = 'compact', baseSearchUrl: baseSearchUrl, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, isTruncated: isTruncated, isEditable: isEditable, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldScrollIntoView: menuShouldScrollIntoView, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceededProp, onSubmitFailed: onSubmitFailedProp, fragmentRef: fragmentRef, readViewFitContainerHeight: readViewFitContainerHeight, shouldShowProjectScopedCheckbox: shouldShowProjectScopedCheckbox, shouldPrefetchSuggestions: shouldPrefetchSuggestions = false, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const [{ dirtyValue: dirtyValue, operations: operations }, { onChange: onChange, initializeDirtyValue: initializeDirtyValue }] = (0, $1iOCQ.useMultiSelectFieldDirtyValueOperations)();
    const sessionId = (0, $5uXOq.useRef)((0, $7Jxgt.v4)());
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const [currentProjectOnly, setCurrentProjectOnly] = (0, $5uXOq.useState)((0, $gG69f.getProjectScopeLabelCheckboxValueFromLocalStorage));
    (0, $5uXOq.useEffect)(()=>{
        (0, $4R6GH.fg)('labels_restricted_to_project_experiment') && (0, $gG69f.setProjectScopeLabelCheckboxValueFromLocalStorage)(currentProjectOnly);
    }, [
        currentProjectOnly
    ]);
    const data = (0, $8Uumt.useFragment)((0, $cT2aD.default), fragmentRef);
    const { id: uniqueFieldId, name: fieldNameNoOverrides, fieldId: fieldId, type: type } = data;
    const isFieldEditable = overriding.overrideIsEditable(isEditable);
    const fieldName = overriding.overrideLabel(fieldNameNoOverrides);
    const initialValue = (0, $5uXOq.useMemo)(()=>$fcc6937e9a821897$var$transformAggToAtlaskitOption(data?.selectedLabelsConnection), [
        data?.selectedLabelsConnection
    ]);
    const [newValue, setNewValue] = (0, $5uXOq.useState)(initialValue);
    const [cachedLabels, { addToCache: addToCache }] = (0, $fP5Bh.useLabelsCache)(fieldId);
    const isAiEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isAiFieldSuggestionEnabled = isAiEnabled && (0, $4R6GH.fg)('jira-ai-field-suggestion-m1-label-field');
    const { data: aiSuggestedLabels, fetchAiLabelSuggestions: fetchAiLabelSuggestions, loading: isFetchingAiLabelSuggestions, completed: fetchingAiLabelSuggestionsCompleted, error: _aiSuggestedLabelsError } = // Conditionally rendering this hook behind the FG as a switch if the hook call causes any issues
    (0, $4R6GH.fg)('jira-ai-field-suggestion-m1-label-field') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $6zbnz.useFetchAiSuggestedLabels)() : {
        data: undefined,
        loading: false,
        completed: false,
        error: undefined,
        fetchAiLabelSuggestions: ()=>undefined
    };
    (0, $5uXOq.useEffect)(()=>{
        if (isAiFieldSuggestionEnabled && !isFetchingAiLabelSuggestions && !fetchingAiLabelSuggestionsCompleted && // We only want to call the API call if the user has updated labels in the last 7 days
        (0, $4R6GH.fg)('label_field_suggestions_user_last_updated_7_days')) // The API is only called if both feature gates
        // [jira-ai-field-suggestion-m1-label-field, label_field_suggestions_user_last_updated_7_days] are enabled
        fetchAiLabelSuggestions();
    }, [
        fetchAiLabelSuggestions,
        fetchingAiLabelSuggestionsCompleted,
        isAiFieldSuggestionEnabled,
        isFetchingAiLabelSuggestions
    ]);
    const [commit] = (0, $8Uumt.useMutation)((0, $lzd6v.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const validator = (0, $gG69f.useLabelsValidator)();
    const isValueEqual = (0, $5uXOq.useCallback)((a, b)=>!(0, $4R6GH.fg)('jsc_inline_editing_field_refactor') && operations.length === 0 || $fcc6937e9a821897$var$isEqualLabels(a, b), [
        operations.length
    ]);
    const onUpdateValue = (0, $5uXOq.useCallback)((value, isInitRequest)=>{
        isInitRequest ? initializeDirtyValue(value) : onChange(value);
    }, [
        initializeDirtyValue,
        onChange
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        const updatedValue = $fcc6937e9a821897$var$transformLabelsOptionsToLabelNames(value);
        addToCache(updatedValue);
        onSubmit?.(updatedValue);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? [
                        {
                            operation: 'SET',
                            labels: updatedValue
                        }
                    ] : $fcc6937e9a821897$var$transformOptionsOperationsIntoAggOperationInput(operations)
                }
            },
            optimisticResponse: {
                jira: {
                    updateLabelsField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            type: type,
                            fieldId: fieldId,
                            selectedLabelsConnection: $fcc6937e9a821897$var$transformAtlaskitOptionToAgg((0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? value : dirtyValue)
                        }
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData?.jira?.updateLabelsField?.success) onSuccess();
                else {
                    const errorMessage = mutationData?.jira?.updateLabelsField?.errors?.[0]?.message ?? undefined;
                    onFail(undefined, errorMessage);
                    (0, $2YZCu.default).safeErrorWithoutCustomerData($fcc6937e9a821897$export$1b05898090f57b12, `Failed to update field ${fieldId} of type ${$fcc6937e9a821897$var$FIELD_TYPE}`);
                }
            },
            onError (error) {
                onFail(error, error.message);
                (0, $2YZCu.default).safeErrorWithoutCustomerData($fcc6937e9a821897$export$1b05898090f57b12, `Failed to update field ${fieldId} of type ${$fcc6937e9a821897$var$FIELD_TYPE}`);
            }
        });
    }, // PLEASE CONFIRM THESE DEPENDENCIES ARE CORRECT
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        addToCache,
        onSubmit,
        commit,
        uniqueFieldId,
        operations,
        fieldName,
        type,
        fieldId,
        dirtyValue,
        createAnalyticsEvent
    ]);
    const handleSubmitSucceeded = (value)=>{
        // onSubmitSucceededProp expects a list of strings so we must map our updated value accordingly.
        onSubmitSucceededProp?.($fcc6937e9a821897$var$transformLabelsOptionsToLabelNames(value));
    };
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('labels_restricted_to_project');
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: {
            ...attributes,
            ...(0, $4R6GH.fg)('labels_restricted_to_project_experiment') ? {
                hasProjectScopedLabels: config.get('showProjectFilter', false),
                currentProjectOnly: currentProjectOnly
            } : {}
        },
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: isValueEqual,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: handleSubmitSucceeded,
        onSubmitFailed: onSubmitFailedProp,
        onUpdateValue: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? setNewValue : onUpdateValue,
        updatedValue: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? newValue : dirtyValue,
        validator: validator,
        clipboardComponentType: 'labels'
    });
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTCPY.LabelsReadView), {
            baseSearchUrl: baseSearchUrl,
            fragmentRef: data,
            isTruncated: isTruncated,
            isHoverPopoverEnabled: isHoverPopoverEnabled
        }), [
        baseSearchUrl,
        data,
        isTruncated,
        isHoverPopoverEnabled
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            ariaLabel: fieldName,
            spacing: spacing,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            onChange: handleChange,
            value: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? newValue : dirtyValue,
            cachedOptions: cachedLabels,
            nodeIdFragment: data,
            isInvalid: !!invalidMessage,
            sessionId: sessionId.current,
            testId: 'issue-field-labels-inline-edit-view-full.ui.labels.edit-view',
            shouldShowProjectScopedCheckbox: shouldShowProjectScopedCheckbox,
            ...(0, $4R6GH.fg)('labels_restricted_to_project_experiment') ? {
                currentProjectOnly: currentProjectOnly,
                setCurrentProjectOnly: setCurrentProjectOnly
            } : {},
            ...isAiFieldSuggestionEnabled ? {
                aiSuggestedLabels: aiSuggestedLabels
            } : {}
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $7hmM3.default),
        editViewEntryPointParams: shouldPrefetchSuggestions ? {
            id: uniqueFieldId
        } : {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        invalidMessage: invalidMessage,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        hasReadViewTruncateDisabled: isHoverPopoverEnabled,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        hasUnsubmittedChanges: hasServerValidationError
    });
};
const $fcc6937e9a821897$export$f066b3edf0d7cd25 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)(/* eslint-disable @atlassian/relay/graphql-naming */ (0, $8tXFa.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcc6937e9a821897$export$f00c136eadca5f4b, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("8tXFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9244d75bb96c02c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a5d785db9d94536cfc54c642b914993>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9244d75bb96c02c3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditView",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraLabelsField"
};
$9244d75bb96c02c3$var$node.hash = "83c0a65ee08db15e69b7b1d990bb3c2d";
var $9244d75bb96c02c3$export$2e2bcd8739ae039 = $9244d75bb96c02c3$var$node;

});

parcelRegister("lzd6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b8fceaf4b58dd2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<10fb72dff888a3fae7cdca3a19771315>>
 * @relayHash 91be5c344ee0d815b9488120a6e3d2ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fef917a924aab25e1dca4f0b0d78551cf23b3fe8146d59589fa4d1d10810b787
const $c7b8fceaf4b58dd2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraLabelConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedLabelsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                },
                                                {
                                                    "concreteType": "JiraLabelEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraLabel",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fef917a924aab25e1dca4f0b0d78551cf23b3fe8146d59589fa4d1d10810b787",
            "metadata": {},
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c7b8fceaf4b58dd2$var$node.hash = "b7c0af684826341f4d5d5b319e095b51";
var $c7b8fceaf4b58dd2$export$2e2bcd8739ae039 = $c7b8fceaf4b58dd2$var$node;

});

parcelRegister("cT2aD", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a2cb14406a90357$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<50aa70a6efbfeaaecd5b7acc02d927c1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1a2cb14406a90357$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "labels_issueFieldLabelsReadviewFull_LabelsReadView"
            },
            {
                "kind": "FragmentSpread",
                "name": "labels_issueFieldLabelsEditviewFull_LabelsEditView_nodeIdFragment"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1000
                        }
                    ],
                    "concreteType": "JiraLabelConnection",
                    "kind": "LinkedField",
                    "name": "selectedLabelsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "concreteType": "JiraLabelEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraLabel",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v0 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "selectedLabelsConnection(first:1000)"
                },
                "action": "THROW",
                "path": "selectedLabelsConnection"
            }
        ],
        "type": "JiraLabelsField"
    };
}();
$1a2cb14406a90357$var$node.hash = "eb1d78891ab7e5335abb92a0453c8f02";
var $1a2cb14406a90357$export$2e2bcd8739ae039 = $1a2cb14406a90357$var$node;

});

parcelRegister("7hmM3", function(module, exports) {

$parcel$export(module.exports, "default", () => $beabad75c5377c32$export$2e2bcd8739ae039);

var $exGVl = parcelRequire("exGVl");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $beabad75c5377c32$var$LabelsEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("lDG6B")), {
        moduleId: "f49080b6"
    }),
    getPreloadProps: ({ id: id })=>id ? {
            queries: {
                labelsSuggestionsData: {
                    parameters: $exGVl.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    variables: {
                        id: id
                    }
                }
            }
        } : {}
});
var $beabad75c5377c32$export$2e2bcd8739ae039 = $beabad75c5377c32$var$LabelsEditViewEntryPoint;

});
parcelRegister("exGVl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f019132ca82e91c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1812ef87b1f80def77b88faa395f28a5>>
 * @relayHash cf60cab627fd5a4526b86847467cc927
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 16a655da0b16a10ad930e84f8f7bfc022914d3262cbdef1fd962c0f5bc00523e
const $9f019132ca82e91c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        },
        {
            "kind": "Literal",
            "name": "suggested",
            "value": true
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewWithSuggestionsFragment_suggestionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraLabelConnection",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraLabelEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraLabel",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "color",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "colorKey"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "labels(first:50,searchBy:\"\",suggested:true)"
                                },
                                {
                                    "args": v3 /*: any*/ ,
                                    "filters": [
                                        "suggested",
                                        "searchBy",
                                        "currentProjectOnly"
                                    ],
                                    "handle": "connection",
                                    "key": "labels_issueFieldLabelsEditviewFull_LabelsEditViewWithSuggestionsFragmentSearch__labels",
                                    "kind": "LinkedHandle",
                                    "name": "labels"
                                }
                            ],
                            "type": "JiraLabelsField"
                        },
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "16a655da0b16a10ad930e84f8f7bfc022914d3262cbdef1fd962c0f5bc00523e",
            "metadata": {},
            "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9f019132ca82e91c$var$node.hash = "f7c0efbc6f8dee59af5c37b02898ac3e";
var $9f019132ca82e91c$export$2e2bcd8739ae039 = $9f019132ca82e91c$var$node;

});

parcelRegister("lDG6B", function(module, exports) {

let $fc0de6c97fab624d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc0de6c97fab624d$var$load("iaEBn").then(()=>parcelRequire('eV9zo'));

});


parcelRegister("hTCPY", function(module, exports) {

$parcel$export(module.exports, "LabelsReadView", () => $055c508282b8acd3$export$79e9d2357368ec9e);

var $5R2Lj = parcelRequire("5R2Lj");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $9laXL = parcelRequire("9laXL");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $eZibI = parcelRequire("eZibI");

var $iv6X1 = parcelRequire("iv6X1");

var $exfTw = parcelRequire("exfTw");

var $7ldcY = parcelRequire("7ldcY");

var $dCm1o = parcelRequire("dCm1o");

var $aGYuX = parcelRequire("aGYuX");

var $5Crtp = parcelRequire("5Crtp");

var $59LMX = parcelRequire("59LMX");
const $055c508282b8acd3$export$79e9d2357368ec9e = ({ baseSearchUrl: baseSearchUrl, fragmentRef: fragmentRef, isTruncated: isTruncated, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const noValueTextExperiment = formatMessage((0, $59LMX.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    const data = (0, $8Uumt.useFragment)((0, $5R2Lj.default), fragmentRef);
    const { selectedLabelsConnection: labels, fieldId: fieldId } = data;
    if (labels.totalCount !== 0) {
        const labelValues = labels?.edges?.filter(Boolean).map((edge)=>edge.node).filter((label)=>label != null && label.name != null) || [];
        if (labelValues.length !== 0) {
            if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Crtp.LabelsTruncatedReadView), {
                baseSearchUrl: baseSearchUrl,
                fieldId: fieldId,
                labelValues: labelValues,
                isHoverPopoverEnabled: isHoverPopoverEnabled
            });
            if (!(0, $dCm1o.isVisualRefreshEnabled)() && (0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($055c508282b8acd3$var$GroupWithNegativeMarginOffset, null, labelValues.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $exfTw.ColoredTag), {
                    key: label.name,
                    labelName: label.name,
                    href: (0, $aGYuX.getLabelHref)(fieldId, label.name, baseSearchUrl)
                })));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($055c508282b8acd3$var$GroupWithNegativeMarginOffset, null, labelValues.map((label)=>// @ts-expect-error - ts2322 - Type 'string' is not assignable to type 'TagColor'.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9laXL.default), {
                    key: label.name,
                    isRemovable: false,
                    text: label.name,
                    href: (0, $aGYuX.getLabelHref)(fieldId, label.name, baseSearchUrl),
                    ...(0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) ? {
                        color: (0, $7ldcY.memoizeGetAutoGeneratedColorForLabelsTag)(label.name)
                    } : {}
                })));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $055c508282b8acd3$var$GroupWithNegativeMarginOffset = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _1n261g80 _1bah1y6m _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5R2Lj", function(module, exports) {

$parcel$export(module.exports, "default", () => $14698e186094ff48$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f68c112c4e06b3f7e1cea409cbd5cac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $14698e186094ff48$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "labels_issueFieldLabelsReadviewFull_LabelsReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            "action": "THROW",
            "path": "selectedLabelsConnection"
        }
    ],
    "type": "JiraLabelsField"
};
$14698e186094ff48$var$node.hash = "7dbf871989626785f282568d738052ba";
var $14698e186094ff48$export$2e2bcd8739ae039 = $14698e186094ff48$var$node;

});

parcelRegister("aGYuX", function(module, exports) {

$parcel$export(module.exports, "getLabelHref", () => $4935af7f8d378b07$export$a1200807f331a4bd);

var $cIy4l = parcelRequire("cIy4l");
const $4935af7f8d378b07$var$CUSTOM_FIELD_PREFIX = 'customfield_';
const $4935af7f8d378b07$export$faff4881e53b3cb6 = (fieldId)=>{
    if (fieldId.startsWith($4935af7f8d378b07$var$CUSTOM_FIELD_PREFIX)) {
        const customId = fieldId.substring($4935af7f8d378b07$var$CUSTOM_FIELD_PREFIX.length, fieldId.length);
        return `cf[${customId}]`;
    }
    return fieldId;
};
const $4935af7f8d378b07$export$a1200807f331a4bd = (fieldId, label, baseSearchUrl = '/issues/')=>{
    const jqlEncodedValue = encodeURIComponent(`${$4935af7f8d378b07$export$faff4881e53b3cb6(fieldId)} = ${(0, $cIy4l.toQuotedString)(label)}`);
    return `${baseSearchUrl}?jql=${jqlEncodedValue}`;
};

});

parcelRegister("5Crtp", function(module, exports) {

$parcel$export(module.exports, "LabelsTruncatedReadView", () => $8a73c0119c4772aa$export$95d698e57184b56c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $eZibI = parcelRequire("eZibI");

var $iv6X1 = parcelRequire("iv6X1");

var $2bYmU = parcelRequire("2bYmU");

var $l8IoT = parcelRequire("l8IoT");

var $aGYuX = parcelRequire("aGYuX");

var $59LMX = parcelRequire("59LMX");
const $8a73c0119c4772aa$export$95d698e57184b56c = ({ baseSearchUrl: baseSearchUrl, fieldId: fieldId, labelValues: labelValues, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const noValueTextExperiment = formatMessage((0, $59LMX.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    if (labelValues.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    });
    const items = labelValues.map(({ name: name })=>{
        if ((0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) return {
            name: name,
            key: name,
            href: (0, $aGYuX.getLabelHref)(fieldId, name, baseSearchUrl),
            isColored: true
        };
        return {
            name: name,
            key: name,
            href: (0, $aGYuX.getLabelHref)(fieldId, name, baseSearchUrl)
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.050",
        xcss: $8a73c0119c4772aa$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bYmU.default), {
        items: items,
        ItemComponent: (0, $l8IoT.TagItem),
        PopupContentWrapper: (0, $l8IoT.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $59LMX.default).showMoreTooltip),
        isHoverPopoverEnabled: isHoverPopoverEnabled
    }));
};
const $8a73c0119c4772aa$var$containerStyles = (0, $8CUq3.xcss)({
    maxWidth: '100%'
});

});
parcelRegister("59LMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd883121b47956d1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bd883121b47956d1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-labels-readview-full.labels.compact.show-more-tooltip",
        "defaultMessage": "See more labels"
    },
    noValueTextExperiment: {
        "id": "issue-field-labels-readview-full.labels.compact.no-value-text-experiment",
        "defaultMessage": "Add labels"
    }
});

});



parcelRegister("fP5Bh", function(module, exports) {

$parcel$export(module.exports, "useLabelsCache", () => $60f4133cc76a7730$export$18b2bd971a089d24);

var $5uXOq = parcelRequire("5uXOq");

var $445JK = parcelRequire("445JK");

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cLccA = parcelRequire("cLccA");
const $60f4133cc76a7730$var$useRerenderTrigger = ()=>{
    const [token, setSymbol] = (0, $5uXOq.useState)(Symbol('useRerenderTrigger_initial'));
    const refreshToken = (0, $5uXOq.useCallback)(()=>setSymbol(Symbol('useRerenderTrigger_rerender')), []);
    return [
        token,
        refreshToken
    ];
};
const $60f4133cc76a7730$export$18b2bd971a089d24 = (fieldId)=>{
    const labelsCache = (0, $445JK.getLabelsCache)(fieldId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [cachedLabels, setCachedLabels] = (0, $5uXOq.useState)([]);
    const [cacheRefreshToken, refreshCache] = $60f4133cc76a7730$var$useRerenderTrigger();
    const addToCache = (0, $5uXOq.useCallback)((labels)=>{
        Promise.all(labels.map(async (label)=>{
            try {
                const cachedOption = await labelsCache.get(label);
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'labelPickerCache set', {
                    isFromCache: Boolean(cachedOption?.label)
                });
                return label && labelsCache.set(`${label}`, {
                    label: label
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-view.labels.cache.set', error.message);
            }
            return undefined;
        })).then(()=>{
            refreshCache(); // trigger an update of the returned cached labels value
        });
    }, [
        createAnalyticsEvent,
        labelsCache,
        refreshCache
    ]);
    const removeFromCache = (0, $5uXOq.useCallback)((labels)=>{
        Promise.all(labels.map(async (label)=>{
            try {
                const cachedOption = await labelsCache.get(label);
                if (cachedOption) {
                    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'labelPickerCache removed');
                    return cachedOption && labelsCache.remove(`${cachedOption.label}`);
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-view.labels.cache.remove', error.message);
            }
            return undefined;
        })).then(()=>{
            refreshCache(); // trigger an update of the returned cached labels value
        });
    }, [
        createAnalyticsEvent,
        labelsCache,
        refreshCache
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const getCachedLabels = async ()=>{
            const cachedItems = await labelsCache.getAll();
            const transformedCachedItems = (0, $cLccA.transformCacheEntries)(cachedItems);
            const labelOptions = (0, $cLccA.mapCachedItemsToLabelOptions)(transformedCachedItems);
            setCachedLabels(labelOptions);
        };
        getCachedLabels();
    // Having cacheRefreshToken in the deps array allows us to retrigger a loading of the cached values whenever refreshCache is called
    }, [
        cacheRefreshToken,
        labelsCache
    ]);
    return [
        cachedLabels,
        {
            addToCache: addToCache,
            removeFromCache: removeFromCache
        }
    ];
};

});
parcelRegister("445JK", function(module, exports) {

$parcel$export(module.exports, "getLabelsCache", () => $708c3ea0a805ef79$export$f7e90ae127ed72ef);

var $c3jsi = parcelRequire("c3jsi");

var $4mjZO = parcelRequire("4mjZO");
const $708c3ea0a805ef79$var$labelsCaches = {};
const $708c3ea0a805ef79$export$f7e90ae127ed72ef = (labelsFieldId)=>{
    const cacheKey = labelsFieldId || (0, $4mjZO.props).cacheKey;
    if (!$708c3ea0a805ef79$var$labelsCaches[cacheKey]) $708c3ea0a805ef79$var$labelsCaches[cacheKey] = (0, $c3jsi.default)({
        ...(0, $4mjZO.props),
        cacheKey: cacheKey
    });
    return $708c3ea0a805ef79$var$labelsCaches[cacheKey];
};

});
parcelRegister("c3jsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdca2a0bd8756d7$export$2e2bcd8739ae039);

var $8Op28 = parcelRequire("8Op28");
const $ccdca2a0bd8756d7$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ccdca2a0bd8756d7$export$2e2bcd8739ae039 = (config)=>{
    if (!false) {
        const Cache = (0, $8Op28.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $ccdca2a0bd8756d7$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $ccdca2a0bd8756d7$var$pNothing,
        update: $ccdca2a0bd8756d7$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $ccdca2a0bd8756d7$var$pNothing
    };
};

});
parcelRegister("8Op28", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $3e46065a4b1d2500$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $3e46065a4b1d2500$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");

var $2YZCu = parcelRequire("2YZCu");


var $1NZBJ = parcelRequire("1NZBJ");
const $3e46065a4b1d2500$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $3e46065a4b1d2500$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $1NZBJ.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $3e46065a4b1d2500$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $3e46065a4b1d2500$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)) storage = (0, $bSSG7.createLocalStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        else storage = (0, $eNf8a.createSessionStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $43a74598c9c16cf3$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $43a74598c9c16cf3$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $2YZCu.default).safeWarnWithoutCustomerData((0, $43a74598c9c16cf3$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $43a74598c9c16cf3$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $43a74598c9c16cf3$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $1NZBJ.default).scopes.current !== (0, $1NZBJ.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3e46065a4b1d2500$var$cacheMap = {};
const $3e46065a4b1d2500$var$getCache = async (props)=>{
    await (0, $1NZBJ.scopeGuard)().catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $3e46065a4b1d2500$var$cacheMap[cacheKey] = $3e46065a4b1d2500$var$cacheMap[cacheKey] || new $3e46065a4b1d2500$export$94affb487e701bf2(props);
    return $3e46065a4b1d2500$var$cacheMap[cacheKey];
};
const $3e46065a4b1d2500$export$710d301bf26d9700 = ()=>{
    Object.values($3e46065a4b1d2500$var$cacheMap).forEach((cache)=>cache.clear());
};
var $3e46065a4b1d2500$export$2e2bcd8739ae039 = $3e46065a4b1d2500$var$getCache;

});
const $43a74598c9c16cf3$export$7271276960377470 = 'common-cache';
const $43a74598c9c16cf3$export$a61768fefd33fcb1 = 'capacity exceeded';
const $43a74598c9c16cf3$export$6c4d37c7f376a1de = 'clear';
const $43a74598c9c16cf3$export$e271b26eefe41db8 = 'update';
const $43a74598c9c16cf3$export$4bd2facc4a3e6aa1 = 'delete';
const $43a74598c9c16cf3$export$26d12233004a7a60 = 'delete stale entry';
const $43a74598c9c16cf3$export$1bb358554aac31c1 = 'get';
const $43a74598c9c16cf3$export$61f74127e2b53cbe = 'hydrate';
const $43a74598c9c16cf3$export$5e8f180ef0142226 = 'set';
const $43a74598c9c16cf3$export$9eb68924983e00fb = 'get entries';
const $43a74598c9c16cf3$export$bf340b99118a1511 = 'memory';
const $43a74598c9c16cf3$export$2670cb7d5d4f7184 = 'local';
const $43a74598c9c16cf3$export$b796061ff0c82e1a = 'session';



parcelRegister("4mjZO", function(module, exports) {

$parcel$export(module.exports, "props", () => $e503e4d3735092a5$export$8128bb6492cf3de7);

const $e503e4d3735092a5$var$MAX_RESULTS = 10;
const $e503e4d3735092a5$var$CACHE_SIZE = $e503e4d3735092a5$var$MAX_RESULTS * 2;
const $e503e4d3735092a5$var$LABELS_CACHE_KEY = 'labels';
const $e503e4d3735092a5$export$8128bb6492cf3de7 = {
    size: $e503e4d3735092a5$var$CACHE_SIZE,
    cacheKey: $e503e4d3735092a5$var$LABELS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)
};

});


parcelRegister("cLccA", function(module, exports) {

$parcel$export(module.exports, "mapCachedItemsToLabelOptions", () => $bfc7f8f714de3d09$export$9ba85e25262c8a32);
$parcel$export(module.exports, "transformCacheEntries", () => $bfc7f8f714de3d09$export$64c1e7aa265973f8);

const $bfc7f8f714de3d09$export$9ba85e25262c8a32 = (items)=>items.map(({ label: label })=>({
            label: label,
            value: label
        }));
const $bfc7f8f714de3d09$export$64c1e7aa265973f8 = (items)=>items.slice(-1 * (0, $bb1ef66fa8511981$export$f6b2881bc1090cea)).reverse();

});
const $bb1ef66fa8511981$export$ffb1c0893bcc2c13 = 'customfield_';
const $bb1ef66fa8511981$export$f6b2881bc1090cea = 5;



parcelRegister("1iOCQ", function(module, exports) {

$parcel$export(module.exports, "useMultiSelectFieldDirtyValueOperations", () => $b744ba70074fe546$export$484e5e1fabcb3ce2);

var $5uXOq = parcelRequire("5uXOq");
const $b744ba70074fe546$export$484e5e1fabcb3ce2 = ()=>{
    const [dirtyValue, setDirtyValue] = (0, $5uXOq.useState)([]);
    const [operations, setOperations] = (0, $5uXOq.useState)([]);
    const initializeDirtyValue = (0, $5uXOq.useCallback)((currentValue)=>{
        setDirtyValue(currentValue);
        setOperations([]);
    }, []);
    const onChange = (0, $5uXOq.useCallback)((newValue)=>{
        // todo JIV-13917: compare the new values to previous state. convert in to a discrete combination of add, remove, and set operations.
        // Eg: User adds item A and removes item B -> results in -> [{operation: 'REMOVE', value: ['B']}, {operation: 'ADD', value: ['A']}]
        // Eg: User swaps the order of items A and B to [B,A] -> results in -> [{operation: 'REMOVE', value: ['A', 'B']}, {operation: 'ADD', value: ['B', 'A']}]
        // Eg: User clears the value of the field (using x button) then adds item A -> results in -> [{operation: 'SET', value: []}, {operation: 'ADD', value: ['A']}]
        // Rules:
        // If the user clears the field value, first operation must be SET to []
        // Any permutation of any number of single-value-add events, single-value-remove events or re-ordering events can be simplified down to a single `ADD` and `REMOVE` operation
        //
        // This will end up a fair bit more complex than it is now, but it will allow us to avoid bugs where we accidentally chop off values past the initial page
        setOperations([
            {
                operation: 'SET',
                value: newValue
            }
        ]);
        setDirtyValue(newValue);
    }, []);
    return [
        {
            dirtyValue: dirtyValue,
            operations: operations
        },
        {
            onChange: onChange,
            initializeDirtyValue: initializeDirtyValue
        }
    ];
};

});

parcelRegister("6zbnz", function(module, exports) {

$parcel$export(module.exports, "useFetchAiSuggestedLabels", () => $c44a1e732b7edb12$export$4a76de6874153152);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $2gCtH = parcelRequire("2gCtH");

var $3fAi8 = parcelRequire("3fAi8");

var $93Yeu = parcelRequire("93Yeu");

var $6s1PB = parcelRequire("6s1PB");


var $j7AWE = parcelRequire("j7AWE");

var $koiRX = parcelRequire("koiRX");
const $c44a1e732b7edb12$var$FIELD_SUGGESTION_API = '/gateway/api/assist/ai/v2/ai-feature/jira/issue/source-type/work-item/suggestions';
const $c44a1e732b7edb12$var$DEFAULT_MAX_SUGGESTIONS = 5;
const $c44a1e732b7edb12$var$DEFAULT_ISSUE_TYPE_NAME = 'Task';
const $c44a1e732b7edb12$var$DEFAULT_LOCALE = 'en-US';
const $c44a1e732b7edb12$var$DEFAULT_SOURCE = 'JIRA';
const $c44a1e732b7edb12$var$DEFAULT_MAX_ISSUES = 1;
const $c44a1e732b7edb12$export$e71bc55d397b0c22 = (response)=>{
    const labels = response?.ai_feature_output?.suggested_issues?.[0]?.field_values?.Labels || [];
    return labels.map((label, index)=>({
            id: index,
            label: label,
            value: label
        }));
};
const $c44a1e732b7edb12$export$f2d994132e9efc6d = (summary, issueType, projectId, description, issueKey, issueId)=>({
        ai_feature_input: {
            source: $c44a1e732b7edb12$var$DEFAULT_SOURCE,
            locale: $c44a1e732b7edb12$var$DEFAULT_LOCALE,
            context: {
                summary: summary,
                ...projectId && {
                    project_id: projectId
                },
                ...issueKey && {
                    issue_key: issueKey
                },
                ...issueId && {
                    issue_id: issueId
                },
                ...description && {
                    description: (0, $j7AWE.convertAdfToText)(description)
                },
                use_similar_issues: (0, $6s1PB.expVal)('jira_ai_label_field_suggestions', 'useSimilarIssues', false)
            },
            suggested_issues_config: {
                max_issues: $c44a1e732b7edb12$var$DEFAULT_MAX_ISSUES,
                suggested_issue_field_types: [
                    {
                        issue_type: issueType,
                        fields: [
                            {
                                field_name: 'Labels',
                                field_type: 'Short-Text-List',
                                max_field_suggestions: $c44a1e732b7edb12$var$DEFAULT_MAX_SUGGESTIONS
                            }
                        ]
                    }
                ]
            }
        }
    });
const $c44a1e732b7edb12$export$4a76de6874153152 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const issueId = (0, $2gCtH.useIssueId)();
    const [issueTypeName = $c44a1e732b7edb12$var$DEFAULT_ISSUE_TYPE_NAME] = (0, $koiRX.useIssueTypeName)();
    const [descriptionValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$d5bc879e3b748593)
    });
    const [summaryValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$e7cf1830fe735d1f)
    });
    const [state, setState] = (0, $5uXOq.useState)({
        data: undefined,
        error: undefined,
        loading: false,
        completed: false
    });
    const fetchAiLabelSuggestions = (0, $5uXOq.useCallback)(async ()=>{
        const payload = $c44a1e732b7edb12$export$f2d994132e9efc6d(summaryValue, issueTypeName, projectId, descriptionValue, issueKey, issueId);
        setState({
            error: undefined,
            data: undefined,
            loading: true,
            completed: false
        });
        try {
            const result = await (0, $eusud.performPostRequest)($c44a1e732b7edb12$var$FIELD_SUGGESTION_API, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Product': 'jira',
                    'X-Experience-Id': 'jira-field-suggestions',
                    'X-Channel-Id': 'jira-field-suggestions'
                },
                body: JSON.stringify(payload)
            });
            setState({
                data: $c44a1e732b7edb12$export$e71bc55d397b0c22(result),
                error: undefined,
                loading: false,
                completed: true
            });
            return result;
        } catch (error) {
            setState({
                data: undefined,
                error: error,
                loading: false,
                completed: true
            });
            return undefined;
        }
    }, [
        descriptionValue,
        issueKey,
        issueId,
        projectId,
        summaryValue,
        issueTypeName
    ]);
    return {
        ...state,
        fetchAiLabelSuggestions: fetchAiLabelSuggestions
    };
};

});
parcelRegister("3fAi8", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $ddbc380ab4ee430c$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $ddbc380ab4ee430c$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $ddbc380ab4ee430c$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $ddbc380ab4ee430c$export$612d9bcb0c9d8976);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
        });
    };
const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $ddbc380ab4ee430c$var$actions = {
    setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
    getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
    setIssue: $ddbc380ab4ee430c$var$setIssue,
    mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
    setIssues: $ddbc380ab4ee430c$var$setIssues,
    mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
};
// this is a global store
const $ddbc380ab4ee430c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $ddbc380ab4ee430c$var$actions
});
const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getAllFields
});
const $ddbc380ab4ee430c$export$ac289b84121829df = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, $51nlc.createSubscriber)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: null
});
const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

const $e9be48d6d2c01760$export$e18419056f3d184a = 'assignee';
const $e9be48d6d2c01760$export$45cafdfd629c3ca1 = 'reporter';
const $e9be48d6d2c01760$export$d5bc879e3b748593 = 'description';
const $e9be48d6d2c01760$export$a68dbc90211df1a8 = 'fixVersions';
const $e9be48d6d2c01760$export$93605f2a09aa8d26 = 'labels';
const $e9be48d6d2c01760$export$4420b7468f889692 = 'status';
const $e9be48d6d2c01760$export$e7cf1830fe735d1f = 'summary';
const $e9be48d6d2c01760$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $e9be48d6d2c01760$export$a5fc282ab2bf9b89 = 'issuelinks';
const $e9be48d6d2c01760$export$b52547457d714bc0 = 'epic-issues';
const $e9be48d6d2c01760$export$3cca6e37a5823d5a = 'children-issues';
const $e9be48d6d2c01760$export$98a935eb30de54ab = 'components';
const $e9be48d6d2c01760$export$f7a17147527dd688 = 'flag';

parcelRegister("j7AWE", function(module, exports) {

$parcel$export(module.exports, "convertAdfToText", () => $42fff3b8cd03387d$export$f36d973840b7febc);

var $kOFhM = parcelRequire("kOFhM");

var $12yAL = parcelRequire("12yAL");

var $fLTqo = parcelRequire("fLTqo");
const $42fff3b8cd03387d$var$serializer = (0, $fLTqo.default).fromSchema((0, $kOFhM.defaultSchema));
const $42fff3b8cd03387d$export$f36d973840b7febc = (doc)=>{
    if (!doc) return '';
    if (doc?.content?.length < 1) // renderer has a bug where empty adf returns null instead of empty string
    return '';
    const outputText = (0, $12yAL.renderDocument)(doc, $42fff3b8cd03387d$var$serializer, (0, $kOFhM.defaultSchema)).result;
    return outputText;
};

});
parcelRegister("kOFhM", function(module, exports) {

$parcel$export(module.exports, "defaultSchemaConfig", () => $f27880a8173018db$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $f27880a8173018db$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $f27880a8173018db$export$1db618b7b2275ea1);

var $8QpSo = parcelRequire("8QpSo");

var $7kC9H = parcelRequire("7kC9H");
var $47jug = parcelRequire("47jug");
var $gZoER = parcelRequire("gZoER");
var $2FIVU = parcelRequire("2FIVU");
var $9UDEr = parcelRequire("9UDEr");

var $kBho7 = parcelRequire("kBho7");
const $f27880a8173018db$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $f27880a8173018db$export$e4e3ac1fa64862db = $f27880a8173018db$var$getDefaultSchemaConfig();
const $f27880a8173018db$export$fd147e7d448dea03 = (0, $8QpSo.default)((stage = 'final')=>{
    const defaultSchemaConfig = $f27880a8173018db$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $gZoER.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $47jug.multiBodiedExtension),
        extensionFrame: (0, $47jug.extensionFrame),
        expand: (0, $7kC9H.expandWithNestedExpand),
        listItem: (0, $2FIVU.listItemWithDecisionStage0),
        table: (0, $9UDEr.tableWithNestedTable),
        tableRow: (0, $9UDEr.tableRowWithNestedTable),
        tableCell: (0, $9UDEr.tableCellWithNestedTable),
        tableHeader: (0, $9UDEr.tableHeaderWithNestedTable)
    };
    return (0, $kBho7.createSchema)(defaultSchemaConfig);
});
const $f27880a8173018db$export$1db618b7b2275ea1 = $f27880a8173018db$export$fd147e7d448dea03();

});
parcelRegister("7kC9H", function(module, exports) {

$parcel$export(module.exports, "expand", () => $5567ff8f3f52f7a8$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithNestedExpand", () => $5567ff8f3f52f7a8$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "toJSON", () => $5567ff8f3f52f7a8$export$54fd2c36b5cc6731);

var $gthjq = parcelRequire("gthjq");
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $5567ff8f3f52f7a8$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $5567ff8f3f52f7a8$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $5567ff8f3f52f7a8$export$9f77e0932fb78f72 = (0, $gthjq.expandWithoutNestedExpand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
const $5567ff8f3f52f7a8$export$7b80cba28d10b2c1 = (0, $gthjq.expand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
const $5567ff8f3f52f7a8$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});
parcelRegister("gthjq", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $bfdcc8a4590754dc$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $bfdcc8a4590754dc$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $bfdcc8a4590754dc$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", () => $bfdcc8a4590754dc$export$a91509d1c739c16f);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$32b1dde15f5fe85b);
$parcel$export(module.exports, "bodiedExtension", () => $bfdcc8a4590754dc$export$27903d543b563e39);
$parcel$export(module.exports, "bulletList", () => $bfdcc8a4590754dc$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $bfdcc8a4590754dc$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $bfdcc8a4590754dc$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $bfdcc8a4590754dc$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $bfdcc8a4590754dc$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $bfdcc8a4590754dc$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $bfdcc8a4590754dc$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $bfdcc8a4590754dc$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $bfdcc8a4590754dc$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $bfdcc8a4590754dc$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $bfdcc8a4590754dc$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $bfdcc8a4590754dc$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithoutNestedExpand", () => $bfdcc8a4590754dc$export$63c0f3992661097b);
$parcel$export(module.exports, "extension", () => $bfdcc8a4590754dc$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $bfdcc8a4590754dc$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $bfdcc8a4590754dc$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $bfdcc8a4590754dc$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $bfdcc8a4590754dc$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $bfdcc8a4590754dc$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $bfdcc8a4590754dc$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $bfdcc8a4590754dc$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $bfdcc8a4590754dc$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $bfdcc8a4590754dc$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $bfdcc8a4590754dc$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $bfdcc8a4590754dc$export$df876f0305235056);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$171e9ff2be159af7);
$parcel$export(module.exports, "media", () => $bfdcc8a4590754dc$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $bfdcc8a4590754dc$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $bfdcc8a4590754dc$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $bfdcc8a4590754dc$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $bfdcc8a4590754dc$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $bfdcc8a4590754dc$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $bfdcc8a4590754dc$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $bfdcc8a4590754dc$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $bfdcc8a4590754dc$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $bfdcc8a4590754dc$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$15ebf236772fa336);
$parcel$export(module.exports, "orderedList", () => $bfdcc8a4590754dc$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $bfdcc8a4590754dc$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => $bfdcc8a4590754dc$export$220c665c23b9541b);
$parcel$export(module.exports, "paragraph", () => $bfdcc8a4590754dc$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $bfdcc8a4590754dc$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $bfdcc8a4590754dc$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "table", () => $bfdcc8a4590754dc$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $bfdcc8a4590754dc$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $bfdcc8a4590754dc$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $bfdcc8a4590754dc$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $bfdcc8a4590754dc$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $bfdcc8a4590754dc$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $bfdcc8a4590754dc$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $bfdcc8a4590754dc$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $bfdcc8a4590754dc$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $bfdcc8a4590754dc$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $bfdcc8a4590754dc$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $bfdcc8a4590754dc$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $bfdcc8a4590754dc$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $f0ccE = parcelRequire("f0ccE");
const $bfdcc8a4590754dc$export$c4c2f833baaebdb8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$67dc04e652a298ca = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$199922e5af8e9a6 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$a91509d1c739c16f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$32b1dde15f5fe85b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$27903d543b563e39 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$e7320d153c538837 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a140c94e5ea26bee = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
const $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$7bb0d5c671655cc4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$e4f1c66d84049f8b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$daf889beb5092f95 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$e6e4878f43c27cab = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$3e6d667072febc87 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$324d90190a8b822a = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$47988d68fe575725 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$6959e16eeff859b4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $bfdcc8a4590754dc$export$62d45a65fb43d95e = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2a111da947c407d2 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
const $bfdcc8a4590754dc$export$be4283d9a1cb1ff6 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a19185d1233fc4b2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$f5574b5d45fc2112 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9f77e0932fb78f72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$7e3788972005cc72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$63c0f3992661097b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$1b45514b112dd749 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a8baf338431a691 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b555be60c7703afb = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$371da9dd35aba193 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $bfdcc8a4590754dc$export$46e4a324ac90507f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$1b0c1557b234fa00 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$85461f751c457cc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2b380a0f7e250af1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$5c452ff88e35e47d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $bfdcc8a4590754dc$export$cbf8224b64e0d942 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$2f4e72b9459914ad = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$16b353b2649bd8d9 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b3b1e36c2105006d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$ab76e7c03cd6f650 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$cdae19acb0a520fd = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$206007566ca0aca5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        }
    },
    isolating: true
});
const $bfdcc8a4590754dc$export$76c7e83ecc9cdf05 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$df876f0305235056 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$171e9ff2be159af7 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$987d49ffe1b0900f = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$2855e964765eac9 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $bfdcc8a4590754dc$export$38bab695e3f720f1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$969fe3781ca15058 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $bfdcc8a4590754dc$export$8d067f22dc2d1254 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$7e767666f2ce108a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$4bd9a38995f6bf50 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$db83999c14438df4 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$46f790bd65f760d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$750e45819f66d9d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $bfdcc8a4590754dc$export$63cadbf5f4296627 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$f03786aa6312d1e4 = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$15ebf236772fa336 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a5dc81035676e7a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$21f42ab9b6679f44 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$220c665c23b9541b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9c206ddddb32a9b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$4f98472e6dc14293 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$ea332b61641b0588 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$a1f41dc4901771f8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$c7187bbd1a7a9244 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block'
});
const $bfdcc8a4590754dc$export$471f7ae5c4103ae1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b6ce52be8d7a261 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9852986a3ec5f6a0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$ce086a560a1d05f5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$e1e720e5f4603e6a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$abf39ca178940ff3 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$48884d2a5190dc73 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$2a5a518232fa1a97 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$ce666bf02318c957 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$7d657479499397 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$6d8b0ef52e2e6390 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$375b6afcc5f4d291 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$6f093cfa640b7166 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$5ea06bc686c59dc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$93256a4c17b33a82 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$a12828d0f14a2762 = (0, $f0ccE.createPMNodeSpecFactory)({});
const $bfdcc8a4590754dc$export$44b79b0979d0f0f7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$310ebe0d80122e9b = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("f0ccE", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", () => $aec0525c0df12bb9$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $aec0525c0df12bb9$export$cf5823ed4e9f4c6f);
/**
 * Factory method to attach custom parseDOM and/or toDOM for nodeSpec
 *
 * @example
 * createPMNodeSpecFactory<SomeNode>(node)({parseDOM: {}, toDOM: (node) => {} });
 *
 * @param nodeSpec - NodeSpec without toDom and parseDom
 * @returns A function for a node which allows the consumer to define toDom and parseDom
 */ const $aec0525c0df12bb9$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $aec0525c0df12bb9$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("47jug", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $2ff6ee9baaedd4b6$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $2ff6ee9baaedd4b6$export$c3c04d555a8b9013);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $2ff6ee9baaedd4b6$export$4fdcae991fd743e7 = (0, $gthjq.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $2ff6ee9baaedd4b6$export$c3c04d555a8b9013 = (0, $gthjq.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("CWpyq", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $0750dbf71b86cced$export$1765e2758fc47004);
const $0750dbf71b86cced$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $0750dbf71b86cced$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $0750dbf71b86cced$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("gZoER", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $c5e57867b1f8b9c7$export$4f9d8f623ff17117);

var $gthjq = parcelRequire("gthjq");
const $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be = (0, $gthjq.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c5e57867b1f8b9c7$export$cdae19acb0a520fd = (0, $gthjq.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c5e57867b1f8b9c7$export$4f9d8f623ff17117 = (0, $gthjq.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("2FIVU", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $1f2243de0d109562$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithTask", () => $1f2243de0d109562$export$58dca2f0678302a4);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => $1f2243de0d109562$export$b2cd54d5ce935ddb);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => $1f2243de0d109562$export$171e9ff2be159af7);

var $gthjq = parcelRequire("gthjq");
const $1f2243de0d109562$export$76c7e83ecc9cdf05 = (0, $gthjq.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $1f2243de0d109562$export$58dca2f0678302a4 = $1f2243de0d109562$export$76c7e83ecc9cdf05;
const $1f2243de0d109562$export$b2cd54d5ce935ddb = (0, $gthjq.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $1f2243de0d109562$export$171e9ff2be159af7 = (0, $gthjq.listItemWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});

});

parcelRegister("9UDEr", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", () => $737819f27951a815$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $737819f27951a815$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $737819f27951a815$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $737819f27951a815$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $737819f27951a815$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $737819f27951a815$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $737819f27951a815$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $737819f27951a815$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $737819f27951a815$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $737819f27951a815$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $737819f27951a815$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $737819f27951a815$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $737819f27951a815$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $737819f27951a815$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $737819f27951a815$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $737819f27951a815$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $737819f27951a815$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $737819f27951a815$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $737819f27951a815$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $737819f27951a815$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $737819f27951a815$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $737819f27951a815$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $737819f27951a815$export$2a5a518232fa1a97);

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $9IGaJ = parcelRequire("9IGaJ");

var $87j2U = parcelRequire("87j2U");

var $gthjq = parcelRequire("gthjq");
const $737819f27951a815$export$9cfceb893b24742a = 'pm-table';
const $737819f27951a815$export$69cb4c3f80383763 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-content-wrap`;
const $737819f27951a815$export$7b07d37d879c957f = `${$737819f27951a815$export$9cfceb893b24742a}-header-content-wrap`;
const $737819f27951a815$export$8dd42a84cd52da07 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $737819f27951a815$export$5e26a5c19f0865d8 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $51H8P.N20).toLocaleLowerCase();
const $737819f27951a815$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $51H8P.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $51H8P.isRgb)(backgroundColor)) {
        const result = (0, $51H8P.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
let $737819f27951a815$var$testGlobalTheme;
const $737819f27951a815$export$fd7e0dd2b74807f7 = (theme)=>{
    $737819f27951a815$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $737819f27951a815$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($737819f27951a815$var$testGlobalTheme) return {
        colorMode: $737819f27951a815$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $737819f27951a815$var$cssVariablePattern = /^var\(--.*\)$/;
const $737819f27951a815$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $51H8P.isRgb)(background) && (0, $51H8P.rgbToHex)(background) ? (0, $51H8P.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $daes7.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $737819f27951a815$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($737819f27951a815$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $87j2U.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $737819f27951a815$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $737819f27951a815$export$7b07d37d879c957f;
    else attrs.class = $737819f27951a815$export$69cb4c3f80383763;
    return attrs;
};
const $737819f27951a815$export$219b7f492ad209f8 = new Map();
const $737819f27951a815$export$95e9c925fbf01d1c = (0, $51H8P.hexToRgba)((0, $51H8P.N800), 0.12) || (0, $51H8P.N0);
const $737819f27951a815$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $51H8P.N0),
        'White'
    ],
    [
        (0, $51H8P.B50),
        'Light blue'
    ],
    [
        (0, $51H8P.T50),
        'Light teal'
    ],
    [
        (0, $51H8P.G50),
        'Light green'
    ],
    [
        (0, $51H8P.Y50),
        'Light yellow'
    ],
    [
        (0, $51H8P.R50),
        'Light red'
    ],
    [
        (0, $51H8P.P50),
        'Light purple'
    ],
    [
        (0, $51H8P.N20),
        'Light gray'
    ],
    [
        (0, $51H8P.B75),
        'Blue'
    ],
    [
        (0, $51H8P.T75),
        'Teal'
    ],
    [
        (0, $51H8P.G75),
        'Green'
    ],
    [
        (0, $51H8P.Y75),
        'Yellow'
    ],
    [
        (0, $51H8P.R75),
        'Red'
    ],
    [
        (0, $51H8P.P75),
        'Purple'
    ],
    [
        (0, $51H8P.N60),
        'Gray'
    ],
    [
        (0, $51H8P.B100),
        'Dark blue'
    ],
    [
        (0, $51H8P.T100),
        'Dark teal'
    ],
    [
        (0, $51H8P.G200),
        'Dark green'
    ],
    [
        (0, $51H8P.Y200),
        'Dark yellow'
    ],
    [
        (0, $51H8P.R100),
        'Dark red'
    ],
    [
        (0, $51H8P.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $737819f27951a815$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $737819f27951a815$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
const $737819f27951a815$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $9IGaJ.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
const $737819f27951a815$var$createTableSpec = ()=>(0, $gthjq.table)($737819f27951a815$var$tableNodeSpecOptions);
const $737819f27951a815$export$9852986a3ec5f6a0 = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$export$90e634fbace1f0c4 = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$export$3862de5c8c9098cf = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $737819f27951a815$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$737819f27951a815$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $737819f27951a815$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $737819f27951a815$export$ce666bf02318c957 = (0, $gthjq.tableRow)($737819f27951a815$var$tableRowNodeSpecOptions);
const $737819f27951a815$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
const $737819f27951a815$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $737819f27951a815$export$363c8dda799bfe9c(node),
            0
        ]
};
const $737819f27951a815$export$e1e720e5f4603e6a = (0, $gthjq.tableCell)($737819f27951a815$var$tableCellNodeSpecOptions);
const $737819f27951a815$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($737819f27951a815$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $737819f27951a815$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom, {
                    background: $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $737819f27951a815$export$363c8dda799bfe9c(node),
            0
        ]
};
const $737819f27951a815$export$48884d2a5190dc73 = (0, $gthjq.tableHeader)($737819f27951a815$var$tableHeaderNodeSpecOptions);
const $737819f27951a815$export$2af48797a1010bb1 = $737819f27951a815$export$2ac34c099660f1a8;
const $737819f27951a815$export$ce086a560a1d05f5 = (0, $gthjq.tableWithNestedTable)($737819f27951a815$var$tableNodeSpecOptions);
const $737819f27951a815$export$7d657479499397 = (0, $gthjq.tableRowWithNestedTable)($737819f27951a815$var$tableRowNodeSpecOptions);
const $737819f27951a815$export$abf39ca178940ff3 = (0, $gthjq.tableCellWithNestedTable)($737819f27951a815$var$tableCellNodeSpecOptions);
const $737819f27951a815$export$2a5a518232fa1a97 = (0, $gthjq.tableHeaderWithNestedTable)($737819f27951a815$var$tableHeaderNodeSpecOptions);

});
parcelRegister("daes7", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $99576b847e5fbb17$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $99576b847e5fbb17$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $99576b847e5fbb17$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $99576b847e5fbb17$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $99576b847e5fbb17$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $99576b847e5fbb17$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $99576b847e5fbb17$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $99576b847e5fbb17$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? $99576b847e5fbb17$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $99576b847e5fbb17$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("51H8P", function(module, exports) {

$parcel$export(module.exports, "R50", () => $3a8e82bcbd673dd1$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $3a8e82bcbd673dd1$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $3a8e82bcbd673dd1$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $3a8e82bcbd673dd1$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $3a8e82bcbd673dd1$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $3a8e82bcbd673dd1$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $3a8e82bcbd673dd1$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $3a8e82bcbd673dd1$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $3a8e82bcbd673dd1$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $3a8e82bcbd673dd1$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $3a8e82bcbd673dd1$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $3a8e82bcbd673dd1$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $3a8e82bcbd673dd1$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $3a8e82bcbd673dd1$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $3a8e82bcbd673dd1$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $3a8e82bcbd673dd1$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $3a8e82bcbd673dd1$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $3a8e82bcbd673dd1$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $3a8e82bcbd673dd1$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $3a8e82bcbd673dd1$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $3a8e82bcbd673dd1$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $3a8e82bcbd673dd1$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $3a8e82bcbd673dd1$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $3a8e82bcbd673dd1$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $3a8e82bcbd673dd1$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $3a8e82bcbd673dd1$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $3a8e82bcbd673dd1$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $3a8e82bcbd673dd1$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $3a8e82bcbd673dd1$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $3a8e82bcbd673dd1$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $3a8e82bcbd673dd1$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $3a8e82bcbd673dd1$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $3a8e82bcbd673dd1$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $3a8e82bcbd673dd1$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $3a8e82bcbd673dd1$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $3a8e82bcbd673dd1$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $3a8e82bcbd673dd1$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $3a8e82bcbd673dd1$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $3a8e82bcbd673dd1$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $3a8e82bcbd673dd1$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $3a8e82bcbd673dd1$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $3a8e82bcbd673dd1$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $3a8e82bcbd673dd1$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $3a8e82bcbd673dd1$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $3a8e82bcbd673dd1$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $3a8e82bcbd673dd1$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $3a8e82bcbd673dd1$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $3a8e82bcbd673dd1$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $3a8e82bcbd673dd1$export$9665a07d9187b414);

var $3nnJa = parcelRequire("3nnJa");
const $3a8e82bcbd673dd1$export$4b84fd0e2c617bd = '#FFEBE6';
const $3a8e82bcbd673dd1$export$b34b069eff244586 = '#FFBDAD';
const $3a8e82bcbd673dd1$export$be802dd0d8b57f35 = '#FF8F73';
const $3a8e82bcbd673dd1$export$4a7404f376229999 = '#FF5630';
const $3a8e82bcbd673dd1$export$2010d0fb4295b346 = '#DE350B';
const $3a8e82bcbd673dd1$export$2837b5a1a71d5c02 = '#BF2600';
const $3a8e82bcbd673dd1$export$8d9596b529bbb9cf = '#FFFAE6';
const $3a8e82bcbd673dd1$export$41060a744ab0b7ae = '#FFF0B3';
const $3a8e82bcbd673dd1$export$5aae31392d72caaa = '#FFC400';
const $3a8e82bcbd673dd1$export$59619663aa6500fb = '#FF991F';
const $3a8e82bcbd673dd1$export$874739ea9e379ab6 = '#FF8B00';
const $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $3a8e82bcbd673dd1$export$69a3bf21b9686c2b = '#ABF5D1';
const $3a8e82bcbd673dd1$export$747d86715d4175de = '#57D9A3';
const $3a8e82bcbd673dd1$export$940e1f69e873f202 = '#36B37E';
const $3a8e82bcbd673dd1$export$a49394138f7b8e85 = '#00875A';
const $3a8e82bcbd673dd1$export$6fa04827ac68a4fb = '#006644';
const $3a8e82bcbd673dd1$export$226de0355ed012f8 = '#DEEBFF';
const $3a8e82bcbd673dd1$export$8c13c2ee36917869 = '#B3D4FF';
const $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $3a8e82bcbd673dd1$export$b3de0ae08da2ce64 = '#0052CC';
const $3a8e82bcbd673dd1$export$a6ee3d71bc067634 = '#0747A6';
const $3a8e82bcbd673dd1$export$f72948ef771f6f15 = '#D3F1A7';
const $3a8e82bcbd673dd1$export$29a4f05edc054374 = '#FFFFFF';
const $3a8e82bcbd673dd1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $3a8e82bcbd673dd1$export$3e51e8f1440314ba = '#EBECF0';
const $3a8e82bcbd673dd1$export$1ce2d1575d444ceb = '#DFE1E6';
const $3a8e82bcbd673dd1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $3a8e82bcbd673dd1$export$c2e91cbeada39b8b = '#B3BAC5';
const $3a8e82bcbd673dd1$export$eaa8c8a70ac22806 = '#97A0AF';
const $3a8e82bcbd673dd1$export$7c87d337fb91a97d = '#8993A4';
const $3a8e82bcbd673dd1$export$f563ee71e9ee74cd = '#6B778C';
const $3a8e82bcbd673dd1$export$e2ef2124cf4024b1 = '#5E6C84';
const $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $3a8e82bcbd673dd1$export$13609db0e6812ab8 = '#091E4224';
const $3a8e82bcbd673dd1$export$c39c0fe0f26207ae = '#42526E';
const $3a8e82bcbd673dd1$export$7090862dc3038a9f = '#758195';
const $3a8e82bcbd673dd1$export$7d61b15e0da132af = '#172B4D';
const $3a8e82bcbd673dd1$export$f78789c8b01753cd = '#172B4D';
const $3a8e82bcbd673dd1$export$a19f0c33186f7767 = '#FDD0EC';
const $3a8e82bcbd673dd1$export$51716a84e62e022c = '#FEDEC8';
const $3a8e82bcbd673dd1$export$363e4475840015bb = '#EAE6FF';
const $3a8e82bcbd673dd1$export$4b0a4417ed59760f = '#C0B6F2';
const $3a8e82bcbd673dd1$export$6011520a64d9a187 = '#998DD9';
const $3a8e82bcbd673dd1$export$a7175d4e9206bc80 = '#DFD8FD';
const $3a8e82bcbd673dd1$export$b48405b95304b5a1 = '#6554C0';
const $3a8e82bcbd673dd1$export$c71e4279dd54a18d = '#5243AA';
const $3a8e82bcbd673dd1$export$147899de772240ec = '#403294';
const $3a8e82bcbd673dd1$export$2cf711fe14c66f06 = '#E6FCFF';
const $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $3a8e82bcbd673dd1$export$776c9c497ef08533 = '#79E2F2';
const $3a8e82bcbd673dd1$export$69cb3ca10c1e330e = '#C6EDFB';
const $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b = '#00B8D9';
const $3a8e82bcbd673dd1$export$6036577f95c3877e = '#008DA6';
function $3a8e82bcbd673dd1$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($3a8e82bcbd673dd1$export$e698776ec826343(color)) return $3a8e82bcbd673dd1$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($3nnJa.default && $3nnJa.default[color]) color = $3nnJa.default[color];
        else if ($3nnJa && $3nnJa[color]) color = $3nnJa[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5(color) {
    if (!$3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $3a8e82bcbd673dd1$export$9665a07d9187b414(rawColor, alpha) {
    const color = $3a8e82bcbd673dd1$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $3a8e82bcbd673dd1$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $3a8e82bcbd673dd1$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("3nnJa", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("9IGaJ", function(module, exports) {

$parcel$export(module.exports, "generateUuid", () => $7138efa2a0163ee8$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $7138efa2a0163ee8$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $7138efa2a0163ee8$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $7138efa2a0163ee8$var$staticValue = false;
const $7138efa2a0163ee8$export$31b40729666a4ae0 = {
    setStatic (value) {
        $7138efa2a0163ee8$var$staticValue = value;
    },
    generate () {
        return $7138efa2a0163ee8$var$staticValue || $7138efa2a0163ee8$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("87j2U", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $5e8dc04ff4ab4f7d$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $5e8dc04ff4ab4f7d$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $5e8dc04ff4ab4f7d$var$rgbFromHex = (input)=>{
    const fullHex = $5e8dc04ff4ab4f7d$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $5e8dc04ff4ab4f7d$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $5e8dc04ff4ab4f7d$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $5e8dc04ff4ab4f7d$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $5e8dc04ff4ab4f7d$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $5e8dc04ff4ab4f7d$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $5e8dc04ff4ab4f7d$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $5e8dc04ff4ab4f7d$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $5e8dc04ff4ab4f7d$var$rgbToLch = (rgb)=>$5e8dc04ff4ab4f7d$var$labToLch($5e8dc04ff4ab4f7d$var$xyzToLab($5e8dc04ff4ab4f7d$var$rgbToXyz(rgb)));
const $5e8dc04ff4ab4f7d$var$lchToRgb = (lch)=>$5e8dc04ff4ab4f7d$var$xyzToRgb($5e8dc04ff4ab4f7d$var$labToXyz($5e8dc04ff4ab4f7d$var$lchToLab(lch)));
const $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
    lch.l = $5e8dc04ff4ab4f7d$var$clamp(newPercent, 0, 100);
    return $5e8dc04ff4ab4f7d$var$rgbToHex($5e8dc04ff4ab4f7d$var$lchToRgb(lch));
};
const $5e8dc04ff4ab4f7d$var$getLightness = (color)=>{
    const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
    return lch.l;
};
const $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $5e8dc04ff4ab4f7d$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("kBho7", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $eff4c0443be4d23b$export$5f4ce795563f4211);

var $kCV8T = parcelRequire("kCV8T");


var $7P7H6 = parcelRequire("7P7H6");

var $aeGrH = parcelRequire("aeGrH");
var $88i6h = parcelRequire("88i6h");
var $8jJss = parcelRequire("8jJss");
var $14Vqw = parcelRequire("14Vqw");
var $zceQE = parcelRequire("zceQE");
var $lcXoV = parcelRequire("lcXoV");
var $71k4W = parcelRequire("71k4W");
var $cUwVZ = parcelRequire("cUwVZ");
var $l3Tmi = parcelRequire("l3Tmi");
var $29Vii = parcelRequire("29Vii");
var $fK6mK = parcelRequire("fK6mK");
var $8XeG6 = parcelRequire("8XeG6");
var $aUhe2 = parcelRequire("aUhe2");
var $hhtT8 = parcelRequire("hhtT8");
var $4NwJJ = parcelRequire("4NwJJ");
var $c9aa1 = parcelRequire("c9aa1");
var $dtyqo = parcelRequire("dtyqo");
var $8EAPB = parcelRequire("8EAPB");
var $jxVez = parcelRequire("jxVez");
var $lVmBd = parcelRequire("lVmBd");

var $21PS7 = parcelRequire("21PS7");
var $5AxYU = parcelRequire("5AxYU");
var $kjhhp = parcelRequire("kjhhp");
var $5JeV5 = parcelRequire("5JeV5");
var $8vlrc = parcelRequire("8vlrc");
var $6bbHe = parcelRequire("6bbHe");
var $5y0tR = parcelRequire("5y0tR");
var $bd7A9 = parcelRequire("bd7A9");
var $b2VmY = parcelRequire("b2VmY");
var $Khvpb = parcelRequire("Khvpb");
var $8gSD8 = parcelRequire("8gSD8");
var $xjCuM = parcelRequire("xjCuM");
var $kshOv = parcelRequire("kshOv");
var $7DoMR = parcelRequire("7DoMR");
var $7kC9H = parcelRequire("7kC9H");
var $aXBFx = parcelRequire("aXBFx");
var $bFtEE = parcelRequire("bFtEE");
var $hhN5g = parcelRequire("hhN5g");
var $47jug = parcelRequire("47jug");
var $jnMM2 = parcelRequire("jnMM2");
var $lRTZM = parcelRequire("lRTZM");
var $7lRBh = parcelRequire("7lRBh");
var $cCBEe = parcelRequire("cCBEe");
var $5BOuQ = parcelRequire("5BOuQ");
var $4EbxI = parcelRequire("4EbxI");
var $gZoER = parcelRequire("gZoER");
var $2FIVU = parcelRequire("2FIVU");
var $7agO8 = parcelRequire("7agO8");
var $92lix = parcelRequire("92lix");
var $7Xgp3 = parcelRequire("7Xgp3");
var $bIGZ7 = parcelRequire("bIGZ7");
var $g7Cky = parcelRequire("g7Cky");
var $dx5eC = parcelRequire("dx5eC");
var $dwptW = parcelRequire("dwptW");
var $abme3 = parcelRequire("abme3");
var $dgJoa = parcelRequire("dgJoa");
var $M4hHz = parcelRequire("M4hHz");
var $18bvk = parcelRequire("18bvk");
var $9UDEr = parcelRequire("9UDEr");
var $iThOL = parcelRequire("iThOL");
var $43mJF = parcelRequire("43mJF");
var $3DR6L = parcelRequire("3DR6L");
var $9X587 = parcelRequire("9X587");
var $d1d6m = parcelRequire("d1d6m");
var $6kr5W = parcelRequire("6kr5W");
function $eff4c0443be4d23b$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $eff4c0443be4d23b$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $eff4c0443be4d23b$var$markGroupDeclarations = [
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$9b982809044276a6)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$4498a6080fed604c)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$b395009ca7f092c7))
];
const $eff4c0443be4d23b$var$markGroupDeclarationsNames = $eff4c0443be4d23b$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $eff4c0443be4d23b$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $xjCuM.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $abme3.paragraph)
    },
    {
        name: 'text',
        spec: (0, $3DR6L.text)
    },
    {
        name: 'bulletList',
        spec: (0, $kjhhp.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $dwptW.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $2FIVU.listItemWithTask)
    },
    {
        name: 'heading',
        spec: (0, $lRTZM.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $aXBFx.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $8vlrc.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $bFtEE.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $M4hHz.rule)
    },
    {
        name: 'image',
        spec: (0, $7lRBh.image)
    },
    {
        name: 'mention',
        spec: (0, $g7Cky.mention)
    },
    {
        name: 'caption',
        spec: (0, $5JeV5.caption)
    },
    {
        name: 'media',
        spec: (0, $7agO8.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $92lix.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $bIGZ7.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $7Xgp3.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $dgJoa.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $gZoER.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $4EbxI.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $jnMM2.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $7DoMR.emoji)
    },
    {
        name: 'table',
        spec: (0, $9UDEr.table)
    },
    {
        name: 'tableCell',
        spec: (0, $9UDEr.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $9UDEr.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $9UDEr.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $6bbHe.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $bd7A9.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $5y0tR.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $8gSD8.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $Khvpb.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $43mJF.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $iThOL.taskItem)
    },
    {
        name: 'date',
        spec: (0, $b2VmY.date)
    },
    {
        name: 'status',
        spec: (0, $18bvk.status)
    },
    {
        name: 'expand',
        spec: (0, $7kC9H.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $dx5eC.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $hhN5g.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $5BOuQ.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $5AxYU.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $47jug.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $47jug.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $cCBEe.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $21PS7.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $kshOv.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $9X587.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $d1d6m.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $6kr5W.unsupportedInline)
    }
];
const $eff4c0443be4d23b$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $8XeG6.link)
    },
    {
        name: 'em',
        spec: (0, $l3Tmi.em)
    },
    {
        name: 'strong',
        spec: (0, $hhtT8.strong)
    },
    {
        name: 'textColor',
        spec: (0, $c9aa1.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $8jJss.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $aUhe2.strike)
    },
    {
        name: 'subsup',
        spec: (0, $4NwJJ.subsup)
    },
    {
        name: 'underline',
        spec: (0, $8EAPB.underline)
    },
    {
        name: 'code',
        spec: (0, $lcXoV.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $dtyqo.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $aeGrH.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $88i6h.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $71k4W.confluenceInlineComment)
    },
    ...$eff4c0443be4d23b$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $zceQE.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $cUwVZ.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $29Vii.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $fK6mK.indentation)
    },
    {
        name: 'border',
        spec: (0, $14Vqw.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $jxVez.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $lVmBd.unsupportedNodeAttribute)
    }
];
function $eff4c0443be4d23b$export$2d0c32a809131488() {
    const nodes = $eff4c0443be4d23b$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $eff4c0443be4d23b$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $eff4c0443be4d23b$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($eff4c0443be4d23b$var$markGroupDeclarationsNames);
    let nodes = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $7P7H6.sanitizeNodes)(nodes, marks);
    return new (0, $kCV8T.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $eff4c0443be4d23b$export$c77b6d30da5276a1 = true;

});
parcelRegister("kCV8T", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $f043ae92c0a873f0$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $f043ae92c0a873f0$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $f043ae92c0a873f0$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $f043ae92c0a873f0$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $f043ae92c0a873f0$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $f043ae92c0a873f0$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $f043ae92c0a873f0$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $f043ae92c0a873f0$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $f043ae92c0a873f0$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $f043ae92c0a873f0$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $f043ae92c0a873f0$export$3476b78f8f5a8b72);

var $dHeNB = parcelRequire("dHeNB");
function $f043ae92c0a873f0$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $f043ae92c0a873f0$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $f043ae92c0a873f0$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $f043ae92c0a873f0$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $f043ae92c0a873f0$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $f043ae92c0a873f0$var$retIndex(0, pos);
        if (pos == this.size) return $f043ae92c0a873f0$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $f043ae92c0a873f0$var$retIndex(i + 1, end);
                return $f043ae92c0a873f0$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (nodes instanceof $f043ae92c0a873f0$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $f043ae92c0a873f0$export$ffb0004e005737fa.empty = new $f043ae92c0a873f0$export$ffb0004e005737fa([], 0);
const $f043ae92c0a873f0$var$found = {
    index: 0,
    offset: 0
};
function $f043ae92c0a873f0$var$retIndex(index, offset) {
    $f043ae92c0a873f0$var$found.index = index;
    $f043ae92c0a873f0$var$found.offset = offset;
    return $f043ae92c0a873f0$var$found;
}
function $f043ae92c0a873f0$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$f043ae92c0a873f0$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$f043ae92c0a873f0$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $f043ae92c0a873f0$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $f043ae92c0a873f0$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        if (marks instanceof $f043ae92c0a873f0$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $f043ae92c0a873f0$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $f043ae92c0a873f0$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $f043ae92c0a873f0$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $f043ae92c0a873f0$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty = new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.empty, 0, 0);
function $f043ae92c0a873f0$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($f043ae92c0a873f0$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $f043ae92c0a873f0$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $f043ae92c0a873f0$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $f043ae92c0a873f0$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inconsistent open depths");
    return $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, 0);
}
function $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $f043ae92c0a873f0$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $from);
        return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $f043ae92c0a873f0$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $f043ae92c0a873f0$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $f043ae92c0a873f0$var$checkJoin(node, $after.node(depth));
    return node;
}
function $f043ae92c0a873f0$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $f043ae92c0a873f0$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $f043ae92c0a873f0$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$f043ae92c0a873f0$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $f043ae92c0a873f0$var$addNode($end.nodeBefore, target);
}
function $f043ae92c0a873f0$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $f043ae92c0a873f0$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $f043ae92c0a873f0$var$joinable($end, $to, depth + 1);
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $f043ae92c0a873f0$var$checkJoin(openStart, openEnd);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceTwoWay($from, $start, depth + 1)), content);
        $f043ae92c0a873f0$var$addRange($start, $end, depth, content);
        if (openEnd) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openEnd, $f043ae92c0a873f0$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $f043ae92c0a873f0$var$joinable($from, $to, depth + 1);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(type, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $f043ae92c0a873f0$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $f043ae92c0a873f0$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $f043ae92c0a873f0$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $f043ae92c0a873f0$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $f043ae92c0a873f0$var$resolveCache.set(doc, cache = new $f043ae92c0a873f0$var$ResolveCache);
        let result = cache.elts[cache.i] = $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $f043ae92c0a873f0$var$resolveCacheSize;
        return result;
    }
}
class $f043ae92c0a873f0$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $f043ae92c0a873f0$var$resolveCacheSize = 12, $f043ae92c0a873f0$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $f043ae92c0a873f0$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $f043ae92c0a873f0$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $f043ae92c0a873f0$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $f043ae92c0a873f0$var$emptyAttrs) && $f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $f043ae92c0a873f0$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $f043ae92c0a873f0$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $f043ae92c0a873f0$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$f043ae92c0a873f0$export$85c928794f8d04d4.prototype.text = undefined;
class $f043ae92c0a873f0$var$TextNode extends $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $f043ae92c0a873f0$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $f043ae92c0a873f0$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $f043ae92c0a873f0$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $f043ae92c0a873f0$var$dfa($f043ae92c0a873f0$var$nfa(expr));
        $f043ae92c0a873f0$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $f043ae92c0a873f0$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $f043ae92c0a873f0$export$364ed450558d7ec4.empty = new $f043ae92c0a873f0$export$364ed450558d7ec4(true);
class $f043ae92c0a873f0$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $f043ae92c0a873f0$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSubscript(stream) {
    let expr = $f043ae92c0a873f0$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $f043ae92c0a873f0$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $f043ae92c0a873f0$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $f043ae92c0a873f0$var$parseExprRange(stream, expr) {
    let min = $f043ae92c0a873f0$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $f043ae92c0a873f0$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $f043ae92c0a873f0$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $f043ae92c0a873f0$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $f043ae92c0a873f0$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $f043ae92c0a873f0$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $f043ae92c0a873f0$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $f043ae92c0a873f0$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($f043ae92c0a873f0$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $f043ae92c0a873f0$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($f043ae92c0a873f0$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $f043ae92c0a873f0$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $f043ae92c0a873f0$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($f043ae92c0a873f0$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $f043ae92c0a873f0$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $f043ae92c0a873f0$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $f043ae92c0a873f0$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $f043ae92c0a873f0$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $f043ae92c0a873f0$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $f043ae92c0a873f0$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $f043ae92c0a873f0$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $f043ae92c0a873f0$export$ffb0004e005737fa.from(content), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, attrs, content.append(after), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $f043ae92c0a873f0$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $f043ae92c0a873f0$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $f043ae92c0a873f0$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $f043ae92c0a873f0$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $f043ae92c0a873f0$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $dHeNB.default).from(spec.nodes), instanceSpec.marks = (0, $dHeNB.default).from(spec.marks || {}), this.nodes = $f043ae92c0a873f0$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $f043ae92c0a873f0$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $f043ae92c0a873f0$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $f043ae92c0a873f0$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $f043ae92c0a873f0$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $f043ae92c0a873f0$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $f043ae92c0a873f0$var$TextNode(type, type.defaultAttrs, text, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $f043ae92c0a873f0$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $f043ae92c0a873f0$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $f043ae92c0a873f0$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $f043ae92c0a873f0$var$isTagRule(rule) {
    return rule.tag != null;
}
function $f043ae92c0a873f0$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $f043ae92c0a873f0$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($f043ae92c0a873f0$var$isTagRule(rule)) this.tags.push(rule);
            else if ($f043ae92c0a873f0$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, false);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, true);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($f043ae92c0a873f0$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $f043ae92c0a873f0$export$1059c6e7d2ce5669(schema, $f043ae92c0a873f0$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $f043ae92c0a873f0$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $f043ae92c0a873f0$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $f043ae92c0a873f0$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $f043ae92c0a873f0$var$OPT_PRESERVE_WS = 1, $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL = 2, $f043ae92c0a873f0$var$OPT_OPEN_LEFT = 4;
function $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS | $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : base & ~$f043ae92c0a873f0$var$OPT_OPEN_LEFT;
}
class $f043ae92c0a873f0$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$f043ae92c0a873f0$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $f043ae92c0a873f0$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $f043ae92c0a873f0$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $f043ae92c0a873f0$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $f043ae92c0a873f0$var$NodeContext(topNode.type, topNode.attrs, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $f043ae92c0a873f0$var$NodeContext(null, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $f043ae92c0a873f0$var$NodeContext(parser.schema.topNodeType, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $f043ae92c0a873f0$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $f043ae92c0a873f0$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($f043ae92c0a873f0$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $f043ae92c0a873f0$var$OPT_OPEN_LEFT;
        let applyMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $f043ae92c0a873f0$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $f043ae92c0a873f0$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $f043ae92c0a873f0$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $f043ae92c0a873f0$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $f043ae92c0a873f0$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $f043ae92c0a873f0$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $f043ae92c0a873f0$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $f043ae92c0a873f0$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $f043ae92c0a873f0$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $f043ae92c0a873f0$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $f043ae92c0a873f0$var$gatherToDOM(schema.marks);
    }
}
function $f043ae92c0a873f0$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $f043ae92c0a873f0$var$doc(options) {
    return options.document || window.document;
}
const $f043ae92c0a873f0$var$suspiciousAttributeCache = new WeakMap();
function $f043ae92c0a873f0$var$suspiciousAttributes(attrs) {
    let value = $f043ae92c0a873f0$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $f043ae92c0a873f0$var$suspiciousAttributeCache.set(attrs, value = $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs));
    return value;
}
function $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $f043ae92c0a873f0$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $f043ae92c0a873f0$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("dHeNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f8ac547b0b2e1f8$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $9f8ac547b0b2e1f8$var$OrderedMap(content) {
    this.content = content;
}
$9f8ac547b0b2e1f8$var$OrderedMap.prototype = {
    constructor: $9f8ac547b0b2e1f8$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $9f8ac547b0b2e1f8$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$9f8ac547b0b2e1f8$var$OrderedMap.from = function(value) {
    if (value instanceof $9f8ac547b0b2e1f8$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
};
var $9f8ac547b0b2e1f8$export$2e2bcd8739ae039 = $9f8ac547b0b2e1f8$var$OrderedMap;

});


// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $72fd39d34ca5bb7c$export$4498a6080fed604c = 'fontStyle';
const $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725 = 'searchQuery';
const $72fd39d34ca5bb7c$export$b395009ca7f092c7 = 'link';
const $72fd39d34ca5bb7c$export$9b982809044276a6 = 'color';
const $72fd39d34ca5bb7c$export$470d0905851e47a1 = 'alignment';
const $72fd39d34ca5bb7c$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("7P7H6", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodes", () => $5b2343b4eb27461c$export$daf54fed04c8fb77);
function $5b2343b4eb27461c$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$5b2343b4eb27461c$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$5b2343b4eb27461c$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $5b2343b4eb27461c$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $5b2343b4eb27461c$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("aeGrH", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", () => $773c2309706a915e$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $773c2309706a915e$export$8e53000a4ec837);

var $2fTAU = parcelRequire("2fTAU");
const $773c2309706a915e$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $773c2309706a915e$export$8e53000a4ec837 = (0, $2fTAU.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("2fTAU", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $1a481b607696d815$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $1a481b607696d815$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $1a481b607696d815$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $1a481b607696d815$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $1a481b607696d815$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $1a481b607696d815$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $1a481b607696d815$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $1a481b607696d815$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $1a481b607696d815$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $1a481b607696d815$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $1a481b607696d815$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $1a481b607696d815$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $1a481b607696d815$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $1a481b607696d815$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $1a481b607696d815$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $1a481b607696d815$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $1a481b607696d815$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $1a481b607696d815$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $1a481b607696d815$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $1a481b607696d815$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $f0ccE = parcelRequire("f0ccE");
const $1a481b607696d815$export$8e53000a4ec837 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $1a481b607696d815$export$8512c9afa7b24c3b = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $1a481b607696d815$export$8c5a050822fd698c = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $1a481b607696d815$export$1edee58a52776cd9 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $1a481b607696d815$export$89015c65f1c75e3f = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $1a481b607696d815$export$6565f9f03506010b = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $1a481b607696d815$export$f3b72f8fc4684ecd = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $1a481b607696d815$export$3024f02c495408d6 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $1a481b607696d815$export$c63c6f932822f543 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$f00aeb236b6f05af = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $1a481b607696d815$export$480c699bd4ec0d86 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $1a481b607696d815$export$9c30223ca0a664fb = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $1a481b607696d815$export$4899a95d70ec5056 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$59ae2c325a998f89 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$b3401ee80eb31041 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$32f78bffcd82ff28 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $1a481b607696d815$export$20af3dabbb5538df = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $1a481b607696d815$export$425327af25286e5e = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$30d78d5eb6719bb8 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $1a481b607696d815$export$a316dc07ff5182a2 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("88i6h", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", () => $5ebd1c6c912098fc$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $5ebd1c6c912098fc$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $5ebd1c6c912098fc$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $5ebd1c6c912098fc$export$8512c9afa7b24c3b);

var $2fTAU = parcelRequire("2fTAU");
let $5ebd1c6c912098fc$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $5ebd1c6c912098fc$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $5ebd1c6c912098fc$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $5ebd1c6c912098fc$export$8512c9afa7b24c3b = (0, $2fTAU.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$5ebd1c6c912098fc$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("8jJss", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", () => $60e35c16db44f137$export$8c5a050822fd698c);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $c9aa1 = parcelRequire("c9aa1");

var $87j2U = parcelRequire("87j2U");
/**
 * @name backgroundColor_mark
 */ const $60e35c16db44f137$var$colorArrayPalette = [
    [
        (0, $51H8P.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $51H8P.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $51H8P.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $51H8P.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $51H8P.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $51H8P.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $60e35c16db44f137$export$14ec3f21a268e497 = new Map();
$60e35c16db44f137$var$colorArrayPalette.forEach(([color, label])=>$60e35c16db44f137$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $60e35c16db44f137$export$8c5a050822fd698c = (0, $2fTAU.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51H8P.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $daes7.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $c9aa1.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("c9aa1", function(module, exports) {

$parcel$export(module.exports, "colorPalette", () => $8d7e34fd69d04bb8$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $8d7e34fd69d04bb8$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $8d7e34fd69d04bb8$export$32f78bffcd82ff28);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $87j2U = parcelRequire("87j2U");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $8d7e34fd69d04bb8$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $51H8P.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $51H8P.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $51H8P.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $51H8P.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $51H8P.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $51H8P.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $51H8P.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $51H8P.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $51H8P.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $51H8P.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $51H8P.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $51H8P.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $51H8P.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $51H8P.N0),
        'White'
    ],
    [
        (0, $51H8P.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $51H8P.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $51H8P.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $51H8P.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $51H8P.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $51H8P.P50),
        'Light purple'
    ] // Lavender secret
];
const $8d7e34fd69d04bb8$export$569885e57444f84a = new Map();
const $8d7e34fd69d04bb8$export$81e5ed9e84fe2e28 = $8d7e34fd69d04bb8$export$569885e57444f84a;
$8d7e34fd69d04bb8$var$colorArrayPalette.forEach(([color, label])=>$8d7e34fd69d04bb8$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $8d7e34fd69d04bb8$var$testGlobalTheme;
const $8d7e34fd69d04bb8$export$fd7e0dd2b74807f7 = (theme)=>{
    $8d7e34fd69d04bb8$var$testGlobalTheme = theme;
};
const $8d7e34fd69d04bb8$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($8d7e34fd69d04bb8$var$testGlobalTheme) return {
        colorMode: $8d7e34fd69d04bb8$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $8d7e34fd69d04bb8$export$32f78bffcd82ff28 = (0, $2fTAU.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51H8P.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $daes7.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($8d7e34fd69d04bb8$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});


parcelRegister("14Vqw", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", () => $0c92b5eb9dbe9377$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $0c92b5eb9dbe9377$export$1edee58a52776cd9);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $0c92b5eb9dbe9377$var$borderColorArrayPalette = [
    [
        (0, $51H8P.N300A),
        'Subtle gray'
    ],
    [
        (0, $51H8P.N600),
        'Gray'
    ],
    [
        (0, $51H8P.N1000),
        'Bold gray'
    ]
];
const $0c92b5eb9dbe9377$export$e4e044c989c86ca7 = new Map();
$0c92b5eb9dbe9377$var$borderColorArrayPalette.forEach(([color, label])=>$0c92b5eb9dbe9377$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $0c92b5eb9dbe9377$export$1edee58a52776cd9 = (0, $2fTAU.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $0c92b5eb9dbe9377$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $daes7.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("zceQE", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $069cc34ec2ef025e$export$89015c65f1c75e3f);

var $2fTAU = parcelRequire("2fTAU");
const $069cc34ec2ef025e$var$allowedTypes = [
    'wide',
    'full-width'
];
const $069cc34ec2ef025e$export$89015c65f1c75e3f = (0, $2fTAU.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                const width = dom.getAttribute('data-width');
                return {
                    mode: $069cc34ec2ef025e$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("lcXoV", function(module, exports) {

$parcel$export(module.exports, "code", () => $f708cbc93f02b120$export$6565f9f03506010b);

var $2fTAU = parcelRequire("2fTAU");
const $f708cbc93f02b120$export$6565f9f03506010b = (0, $2fTAU.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("71k4W", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $51c833981031ae17$export$f3b72f8fc4684ecd);

var $2fTAU = parcelRequire("2fTAU");
const $51c833981031ae17$export$f3b72f8fc4684ecd = (0, $2fTAU.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("cUwVZ", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $966443126bdc8969$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $966443126bdc8969$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $6VXbJ = parcelRequire("6VXbJ");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $966443126bdc8969$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $6VXbJ.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $966443126bdc8969$export$3024f02c495408d6 = (0, $2fTAU.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$966443126bdc8969$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $966443126bdc8969$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("6VXbJ", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $50c5fa8010b73128$export$c296e2d4365c37a5);
const $50c5fa8010b73128$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("l3Tmi", function(module, exports) {

$parcel$export(module.exports, "em", () => $f554d1dac524ac83$export$c63c6f932822f543);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name em_mark
 */ const $f554d1dac524ac83$var$emDOM = [
    'em'
];
const $f554d1dac524ac83$export$c63c6f932822f543 = (0, $2fTAU.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $f554d1dac524ac83$var$emDOM;
    }
});

});

parcelRegister("29Vii", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $1928dd6d160b68a9$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $1928dd6d160b68a9$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $6VXbJ = parcelRequire("6VXbJ");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $1928dd6d160b68a9$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $6VXbJ.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $1928dd6d160b68a9$export$f00aeb236b6f05af = (0, $2fTAU.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$1928dd6d160b68a9$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $1928dd6d160b68a9$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("fK6mK", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $b760170dcfe13435$export$480c699bd4ec0d86);

var $2fTAU = parcelRequire("2fTAU");
const $b760170dcfe13435$export$480c699bd4ec0d86 = (0, $2fTAU.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("8XeG6", function(module, exports) {

$parcel$export(module.exports, "link", () => $684f383282dda449$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $684f383282dda449$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $iZOJ9 = parcelRequire("iZOJ9");
const $684f383282dda449$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $iZOJ9.isSafeUrl)(href)) return false;
        if ((0, $iZOJ9.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $iZOJ9.normalizeUrl)(href);
        return attrs;
    };
const $684f383282dda449$export$9c30223ca0a664fb = (0, $2fTAU.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $684f383282dda449$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $684f383282dda449$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $iZOJ9.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $684f383282dda449$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $684f383282dda449$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($684f383282dda449$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("iZOJ9", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $dd4545da25e52dce$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $dd4545da25e52dce$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $dd4545da25e52dce$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $dd4545da25e52dce$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $dd4545da25e52dce$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $dd4545da25e52dce$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $i6xkD = parcelRequire("i6xkD");
const $dd4545da25e52dce$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($i6xkD)))();
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
    if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
    if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
    const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("i6xkD", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d2e2a485107d561a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d2e2a485107d561a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d2e2a485107d561a$var$isString(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object String]';
}
function $d2e2a485107d561a$var$isObject(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
}
function $d2e2a485107d561a$var$isRegExp(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
}
function $d2e2a485107d561a$var$isFunction(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
}
function $d2e2a485107d561a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d2e2a485107d561a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d2e2a485107d561a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d2e2a485107d561a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d2e2a485107d561a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d2e2a485107d561a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d2e2a485107d561a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d2e2a485107d561a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d2e2a485107d561a$var$isObject(val)) {
            if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
            else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d2e2a485107d561a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d2e2a485107d561a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d2e2a485107d561a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d2e2a485107d561a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d2e2a485107d561a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d2e2a485107d561a$var$createMatch(self, shift) {
    var match = new $d2e2a485107d561a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d2e2a485107d561a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d2e2a485107d561a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d2e2a485107d561a$var$LinkifyIt;

});
parcelRegister("9mKTr", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("b9ep3", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("23ErL", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("oRY4m", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("9bBmm", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("aUhe2", function(module, exports) {

$parcel$export(module.exports, "strike", () => $7f0c7ef7d4ef76e7$export$4899a95d70ec5056);

var $2fTAU = parcelRequire("2fTAU");
const $7f0c7ef7d4ef76e7$export$4899a95d70ec5056 = (0, $2fTAU.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("hhtT8", function(module, exports) {

$parcel$export(module.exports, "strong", () => $c94b3560d4129743$export$59ae2c325a998f89);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name strong_mark
 */ const $c94b3560d4129743$var$strongDOM = [
    'strong'
];
const $c94b3560d4129743$export$59ae2c325a998f89 = (0, $2fTAU.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $c94b3560d4129743$var$strongDOM;
    }
});

});

parcelRegister("4NwJJ", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $37e521d9accf6615$export$b3401ee80eb31041);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name subsup_mark
 */ function $37e521d9accf6615$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $37e521d9accf6615$export$b3401ee80eb31041 = (0, $2fTAU.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("dtyqo", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $9cf8afcff83743a0$export$20af3dabbb5538df);

var $2fTAU = parcelRequire("2fTAU");

var $51H8P = parcelRequire("51H8P");
const $9cf8afcff83743a0$export$20af3dabbb5538df = (0, $2fTAU.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $51H8P.B400)}`
            }
        ];
    }
});

});

parcelRegister("8EAPB", function(module, exports) {

$parcel$export(module.exports, "underline", () => $64cea1116bb0e8f8$export$425327af25286e5e);

var $2fTAU = parcelRequire("2fTAU");
const $64cea1116bb0e8f8$export$425327af25286e5e = (0, $2fTAU.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("jxVez", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $e3ad7edb6364f3b2$export$30d78d5eb6719bb8);

var $2fTAU = parcelRequire("2fTAU");
const $e3ad7edb6364f3b2$export$30d78d5eb6719bb8 = (0, $2fTAU.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("lVmBd", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $ff60739479aa7be3$export$a316dc07ff5182a2);

var $2fTAU = parcelRequire("2fTAU");
const $ff60739479aa7be3$export$a316dc07ff5182a2 = (0, $2fTAU.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("21PS7", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $17a3e9738ed289c7$export$c4c2f833baaebdb8);

var $gthjq = parcelRequire("gthjq");
/**
 * @name blockCard_node
 */ const $17a3e9738ed289c7$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $17a3e9738ed289c7$export$c4c2f833baaebdb8 = (0, $gthjq.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});

});

parcelRegister("5AxYU", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $411aac89e34c8741$export$27903d543b563e39);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $411aac89e34c8741$export$27903d543b563e39 = (0, $gthjq.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("kjhhp", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", () => $ec92fc66e86ee824$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $ec92fc66e86ee824$export$a140c94e5ea26bee);

var $gthjq = parcelRequire("gthjq");
const $ec92fc66e86ee824$export$5f25a39efab3b58b = '.ak-ul';
const $ec92fc66e86ee824$export$a140c94e5ea26bee = (0, $gthjq.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $ec92fc66e86ee824$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5JeV5", function(module, exports) {

$parcel$export(module.exports, "caption", () => $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d);

var $gthjq = parcelRequire("gthjq");
const $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d = (0, $gthjq.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8vlrc", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $6311d90c8f0b12c7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $6311d90c8f0b12c7$export$54fd2c36b5cc6731);

var $kCV8T = parcelRequire("kCV8T");

var $gthjq = parcelRequire("gthjq");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ const $6311d90c8f0b12c7$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $6311d90c8f0b12c7$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $6311d90c8f0b12c7$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $6311d90c8f0b12c7$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $6311d90c8f0b12c7$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $6311d90c8f0b12c7$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $6311d90c8f0b12c7$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $6311d90c8f0b12c7$export$7bb0d5c671655cc4 = (0, $gthjq.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromEditorStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $6311d90c8f0b12c7$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $6311d90c8f0b12c7$var$parseCodeFromHtml(domNode);
                return code ? (0, $kCV8T.Fragment).from(schema.text(code)) : (0, $kCV8T.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $6311d90c8f0b12c7$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });

});

parcelRegister("6bbHe", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $47fcd7cf328a46ad$export$daf889beb5092f95);

var $gthjq = parcelRequire("gthjq");
const $47fcd7cf328a46ad$var$name = 'confluenceJiraIssue';
const $47fcd7cf328a46ad$export$daf889beb5092f95 = (0, $gthjq.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$47fcd7cf328a46ad$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $47fcd7cf328a46ad$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("5y0tR", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $40a0802970c8dfd0$export$e6e4878f43c27cab);

var $gthjq = parcelRequire("gthjq");
const $40a0802970c8dfd0$var$name = 'confluenceUnsupportedBlock';
const $40a0802970c8dfd0$export$e6e4878f43c27cab = (0, $gthjq.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $40a0802970c8dfd0$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$40a0802970c8dfd0$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("bd7A9", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $8296ca40a4ed2ee7$export$3e6d667072febc87);

var $gthjq = parcelRequire("gthjq");
const $8296ca40a4ed2ee7$var$name = 'confluenceUnsupportedInline';
const $8296ca40a4ed2ee7$export$3e6d667072febc87 = (0, $gthjq.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $8296ca40a4ed2ee7$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$8296ca40a4ed2ee7$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("b2VmY", function(module, exports) {

$parcel$export(module.exports, "date", () => $80ac620012a63cc1$export$324d90190a8b822a);

var $gthjq = parcelRequire("gthjq");
const $80ac620012a63cc1$export$324d90190a8b822a = (0, $gthjq.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("Khvpb", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $08b1e03a19cbdc24$export$6959e16eeff859b4);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $08b1e03a19cbdc24$export$6959e16eeff859b4 = (0, $gthjq.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9IGaJ.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8gSD8", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", () => $605a31c9af2a8977$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $605a31c9af2a8977$export$62d45a65fb43d95e);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
/**
 * @name decisionList_node
 */ const $605a31c9af2a8977$var$name = 'decisionList';
const $605a31c9af2a8977$export$a5393ce68c2ff601 = `[data-node-type="${$605a31c9af2a8977$var$name}"]`;
const $605a31c9af2a8977$export$62d45a65fb43d95e = (0, $gthjq.decisionList)({
    parseDOM: [
        {
            tag: `ol${$605a31c9af2a8977$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9IGaJ.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $605a31c9af2a8977$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("xjCuM", function(module, exports) {

$parcel$export(module.exports, "doc", () => $06424d48e92613a9$export$2a111da947c407d2);

var $gthjq = parcelRequire("gthjq");
const $06424d48e92613a9$export$2a111da947c407d2 = (0, $gthjq.doc)({});

});

parcelRegister("kshOv", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $ee443d93678dbe0b$export$be4283d9a1cb1ff6);

var $gthjq = parcelRequire("gthjq");
const $ee443d93678dbe0b$export$be4283d9a1cb1ff6 = (0, $gthjq.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("7DoMR", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $58ef6723e99e5604$export$a19185d1233fc4b2);

var $4pzsz = parcelRequire("4pzsz");

var $gthjq = parcelRequire("gthjq");
const $58ef6723e99e5604$export$a19185d1233fc4b2 = (0, $gthjq.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $4pzsz.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $4pzsz.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("4pzsz", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $336500cbd1ca0f10$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $336500cbd1ca0f10$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $336500cbd1ca0f10$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $336500cbd1ca0f10$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $336500cbd1ca0f10$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $336500cbd1ca0f10$export$f61e93bda2a8b420(acName) {
    const emojiData = $336500cbd1ca0f10$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $336500cbd1ca0f10$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$336500cbd1ca0f10$var$acNameToEmojiMap[acName] ? $336500cbd1ca0f10$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($336500cbd1ca0f10$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $336500cbd1ca0f10$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$336500cbd1ca0f10$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $336500cbd1ca0f10$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $336500cbd1ca0f10$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($336500cbd1ca0f10$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $336500cbd1ca0f10$var$getAcNameFromShortName(shortName);
        if (possibleName in $336500cbd1ca0f10$var$acNameToEmojiMap) return possibleName;
    }
    return $336500cbd1ca0f10$export$bc94e44ec0e7bd82(id) || $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("aXBFx", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $7faca2534e4894a0$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => $7faca2534e4894a0$export$c4d50234112df933);
$parcel$export(module.exports, "extendedBlockquote", () => $7faca2534e4894a0$export$70a64939da3e8455);
$parcel$export(module.exports, "blockquoteWithList", () => $7faca2534e4894a0$export$9b4686c4b9672643);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => $7faca2534e4894a0$export$32b1dde15f5fe85b);

var $gthjq = parcelRequire("gthjq");
/**
 * @name blockquote_node
 */ const $7faca2534e4894a0$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $7faca2534e4894a0$export$67dc04e652a298ca = (0, $gthjq.blockquoteLegacy)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$c4d50234112df933 = (0, $gthjq.blockquoteWithoutNonBodiedMacros)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$70a64939da3e8455 = (0, $gthjq.blockquote)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$9b4686c4b9672643 = (0, $gthjq.blockquoteWithoutNestedCodeblockOrMedia)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});
const $7faca2534e4894a0$export$32b1dde15f5fe85b = (0, $gthjq.blockquoteWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});

});

parcelRegister("bFtEE", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $87ea86de426496d8$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $87ea86de426496d8$export$ce20b13564211141);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => $87ea86de426496d8$export$220c665c23b9541b);

var $gthjq = parcelRequire("gthjq");
let $87ea86de426496d8$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $87ea86de426496d8$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $87ea86de426496d8$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $87ea86de426496d8$export$969277cf61e5a7aa.CUSTOM ? $87ea86de426496d8$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $87ea86de426496d8$var$createPanelNodeSpecOptions = (allowCustomPanel)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
const $87ea86de426496d8$export$ce20b13564211141 = (allowCustomPanel)=>(0, $gthjq.panel)($87ea86de426496d8$var$createPanelNodeSpecOptions(allowCustomPanel));
const $87ea86de426496d8$export$220c665c23b9541b = (allowCustomPanel)=>(0, $gthjq.panelWithoutNestedNonBodiedMacros)($87ea86de426496d8$var$createPanelNodeSpecOptions(allowCustomPanel));

});

parcelRegister("hhN5g", function(module, exports) {

$parcel$export(module.exports, "extension", () => $c95a1940f4fa6aee$export$1b45514b112dd749);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $c95a1940f4fa6aee$export$1b45514b112dd749 = (0, $gthjq.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("jnMM2", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $e1c5ffc4cc369fdc$export$371da9dd35aba193);

var $gthjq = parcelRequire("gthjq");
const $e1c5ffc4cc369fdc$export$371da9dd35aba193 = (0, $gthjq.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("lRTZM", function(module, exports) {

$parcel$export(module.exports, "heading", () => $feb9fbb7aabe0cc7$export$46e4a324ac90507f);

var $gthjq = parcelRequire("gthjq");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $feb9fbb7aabe0cc7$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $feb9fbb7aabe0cc7$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $feb9fbb7aabe0cc7$export$46e4a324ac90507f = (0, $gthjq.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("7lRBh", function(module, exports) {

$parcel$export(module.exports, "image", () => $55a4127c569d3934$export$5c452ff88e35e47d);

var $gthjq = parcelRequire("gthjq");
const $55a4127c569d3934$export$5c452ff88e35e47d = (0, $gthjq.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("cCBEe", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $93063cb7956d3766$export$cbf8224b64e0d942);

var $gthjq = parcelRequire("gthjq");
const $93063cb7956d3766$export$cbf8224b64e0d942 = (0, $gthjq.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("5BOuQ", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $4157940155363fee$export$16b353b2649bd8d9);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $4157940155363fee$export$16b353b2649bd8d9 = (0, $gthjq.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("4EbxI", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $3623d9fd8951cfd2$export$ab76e7c03cd6f650);

var $gthjq = parcelRequire("gthjq");
const $3623d9fd8951cfd2$export$ab76e7c03cd6f650 = (0, $gthjq.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("7agO8", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", () => $5376813d9b4ea07d$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $5376813d9b4ea07d$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $5376813d9b4ea07d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $5376813d9b4ea07d$export$54fd2c36b5cc6731);

var $51H8P = parcelRequire("51H8P");

var $gthjq = parcelRequire("gthjq");
const $5376813d9b4ea07d$export$bb3fe706be61f640 = (0, $gthjq.media)({}).attrs;
const $5376813d9b4ea07d$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $5376813d9b4ea07d$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $51H8P.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $5376813d9b4ea07d$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$5376813d9b4ea07d$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $gthjq.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $gthjq.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    return {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                }
            }
        ],
        toDOM: toDOM
    });
};
const $5376813d9b4ea07d$export$987d49ffe1b0900f = $5376813d9b4ea07d$export$35bdbf5bc8caa677($5376813d9b4ea07d$export$bb3fe706be61f640, false);
const $5376813d9b4ea07d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $5376813d9b4ea07d$export$111130fa8968d741 = (from, to, map)=>{
    if ($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs) Object.keys($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $5376813d9b4ea07d$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
const $5376813d9b4ea07d$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
const $5376813d9b4ea07d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $5376813d9b4ea07d$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($5376813d9b4ea07d$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("92lix", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $6944d24b2c8b0dd9$export$2855e964765eac9);

var $gthjq = parcelRequire("gthjq");
const $6944d24b2c8b0dd9$export$2855e964765eac9 = (0, $gthjq.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("7Xgp3", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $5caac46433adf3f0$export$38bab695e3f720f1);

var $7agO8 = parcelRequire("7agO8");

var $gthjq = parcelRequire("gthjq");
const $5caac46433adf3f0$export$38bab695e3f720f1 = (0, $7agO8.createMediaSpec)((0, $gthjq.mediaInline)({}).attrs, true);

});

parcelRegister("bIGZ7", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", () => $888525ada96954d1$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $888525ada96954d1$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $888525ada96954d1$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $888525ada96954d1$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $888525ada96954d1$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $888525ada96954d1$export$54fd2c36b5cc6731);

var $ITAJ1 = parcelRequire("ITAJ1");

var $6VXbJ = parcelRequire("6VXbJ");

var $gthjq = parcelRequire("gthjq");
const $888525ada96954d1$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $888525ada96954d1$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $6VXbJ.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $ITAJ1.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $ITAJ1.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $gthjq.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $gthjq.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $gthjq.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $gthjq.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $888525ada96954d1$export$969fe3781ca15058 = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $888525ada96954d1$export$d35e6c006d4abdfb = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $888525ada96954d1$export$9c58e19811ce4cf5 = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $888525ada96954d1$export$7e767666f2ce108a = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $888525ada96954d1$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("ITAJ1", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $086f3b754fef02e1$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $086f3b754fef02e1$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("g7Cky", function(module, exports) {

$parcel$export(module.exports, "mention", () => $bbcb0873d657d42d$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $bbcb0873d657d42d$export$54fd2c36b5cc6731);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
let $bbcb0873d657d42d$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $bbcb0873d657d42d$export$db83999c14438df4 = (0, $gthjq.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $bbcb0873d657d42d$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $9IGaJ.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($bbcb0873d657d42d$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $bbcb0873d657d42d$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $bbcb0873d657d42d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($bbcb0873d657d42d$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("dx5eC", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $9da26af350402964$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => $9da26af350402964$export$15ebf236772fa336);

var $gthjq = parcelRequire("gthjq");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $9da26af350402964$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $9da26af350402964$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $9da26af350402964$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $9da26af350402964$export$63cadbf5f4296627 = (0, $gthjq.nestedExpand)($9da26af350402964$var$nestedExpandFactoryOptions);
const $9da26af350402964$export$15ebf236772fa336 = (0, $gthjq.nestedExpandWithoutNonBodiedMacros)($9da26af350402964$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions);

});

parcelRegister("dwptW", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", () => $9d8207b1e6c47527$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $9d8207b1e6c47527$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithOrder", () => $9d8207b1e6c47527$export$b9ab759e8298198f);

var $gthjq = parcelRequire("gthjq");
const $9d8207b1e6c47527$export$4e7125c7ff595be5 = '.ak-ol';
const $9d8207b1e6c47527$export$a5dc81035676e7a = (0, $gthjq.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $9d8207b1e6c47527$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $9d8207b1e6c47527$export$b9ab759e8298198f = (0, $gthjq.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $9d8207b1e6c47527$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const start = $9d8207b1e6c47527$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("abme3", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $769c2c0b195d79f6$export$9c206ddddb32a9b);

var $gthjq = parcelRequire("gthjq");
const $769c2c0b195d79f6$export$9c206ddddb32a9b = (0, $gthjq.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $769c2c0b195d79f6$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("dgJoa", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244);

var $gthjq = parcelRequire("gthjq");
const $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244 = (0, $gthjq.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("M4hHz", function(module, exports) {

$parcel$export(module.exports, "rule", () => $0907ce9fea0294ca$export$fbeb3a3956e8a3c7);

var $gthjq = parcelRequire("gthjq");
/**
 * @name rule_node
 */ const $0907ce9fea0294ca$var$hrDOM = [
    'hr'
];
const $0907ce9fea0294ca$export$fbeb3a3956e8a3c7 = (0, $gthjq.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $0907ce9fea0294ca$var$hrDOM;
    }
});

});

parcelRegister("18bvk", function(module, exports) {

$parcel$export(module.exports, "status", () => $0d2f764e7fea7c00$export$471f7ae5c4103ae1);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $0d2f764e7fea7c00$export$471f7ae5c4103ae1 = (0, $gthjq.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $9IGaJ.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("iThOL", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390 = (0, $gthjq.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9IGaJ.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("43mJF", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", () => $2f3914100d01687b$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $2f3914100d01687b$export$375b6afcc5f4d291);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
/**
 * @name taskList_node
 */ const $2f3914100d01687b$var$name = 'actionList';
const $2f3914100d01687b$export$c0ec71adb7a18fb2 = `[data-node-type="${$2f3914100d01687b$var$name}"]`;
const $2f3914100d01687b$export$375b6afcc5f4d291 = (0, $gthjq.taskList)({
    parseDOM: [
        {
            tag: `div${$2f3914100d01687b$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9IGaJ.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $2f3914100d01687b$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("3DR6L", function(module, exports) {

$parcel$export(module.exports, "text", () => $2a6e35cab1a01b8e$export$6f093cfa640b7166);

var $gthjq = parcelRequire("gthjq");
const $2a6e35cab1a01b8e$export$6f093cfa640b7166 = (0, $gthjq.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("9X587", function(module, exports) {

$parcel$export(module.exports, "default", () => $01deabc8204e5493$export$2e2bcd8739ae039);
const $01deabc8204e5493$var$name = 'unknownBlock';
var $01deabc8204e5493$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $01deabc8204e5493$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$01deabc8204e5493$var$name}"]`
        }
    ]
};

});

parcelRegister("d1d6m", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $97a5880db351ce36$export$44b79b0979d0f0f7);

var $gthjq = parcelRequire("gthjq");
const $97a5880db351ce36$export$44b79b0979d0f0f7 = (0, $gthjq.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("6kr5W", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b);

var $gthjq = parcelRequire("gthjq");
const $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b = (0, $gthjq.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("12yAL", function(module, exports) {

$parcel$export(module.exports, "renderDocument", () => $af6d4930d9141440$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $4FBRr = parcelRequire("4FBRr");
var $aSk3Q = parcelRequire("aSk3Q");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
var $4IuOY = parcelRequire("4IuOY");

var $eQNWQ = parcelRequire("eQNWQ");

var $VSDnB = parcelRequire("VSDnB");

var $8QpSo = parcelRequire("8QpSo");

var $knXBU = parcelRequire("knXBU");

var $1cjf7 = parcelRequire("1cjf7");

var $kgV4b = parcelRequire("kgV4b");
const $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $af6d4930d9141440$var$withStopwatch = (cb)=>{
    const startTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $af6d4930d9141440$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $4FBRr.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $4IuOY.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $eQNWQ.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    if ((0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $aSk3Q.transformNestedTablesIncomingDocument)(result, {
            environment: 'renderer',
            disableNestedRendererTreatment: (0, $VSDnB.fg)('platform_editor_nested_table_extension_comment_fix')
        });
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $gkwXh.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    return result;
};
const $af6d4930d9141440$var$memoValidation = (0, $8QpSo.default)($af6d4930d9141440$var$_validation, (newArgs, lastArgs)=>{
    let result = false;
    if ((0, $VSDnB.fg)('cc_complexit_fe_memoValidation_redundant_calls')) {
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        newSkipValidation, newValidationOverrides] = newArgs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        oldSkipValidation, oldValidationOverrides] = lastArgs;
        result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
    } else {
        // This path has a bug and it will wrongfully assign dispatchAnalyticsEvent to skipValidation/oldSkipValidation
        // instead of ignoring it as it does not skip it when unpacking the array.
        // This results the function returning false when it should return true
        // and causing extra re-renders. see https://hello.jira.atlassian.cloud/browse/COMPLEXIT-161.
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, , skipValidation, newValidationOverrides] = newArgs;
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , oldSkipValidation, oldValidationOverrides] = lastArgs;
        result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && skipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
    }
    return result;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $af6d4930d9141440$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $af6d4930d9141440$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $af6d4930d9141440$var$memoSerializeFragment = (0, $8QpSo.default)($af6d4930d9141440$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $af6d4930d9141440$var$memoCreateNodeAndCheck = (0, $8QpSo.default)($af6d4930d9141440$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $kOFhM.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    const { output: validDoc, time: sanitizeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $d54NZ.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $1cjf7.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $kgV4b.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("4FBRr", function(module, exports) {

$parcel$export(module.exports, "transformMediaLinkMarks", () => $75bd921bb3a8c47e$export$6528700f3fa2fe2a);

var $l1C1k = parcelRequire("l1C1k");
const $75bd921bb3a8c47e$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("l1C1k", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $b903aab814d8ed47$export$df3f009e3d155b20);
function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
    if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $b903aab814d8ed47$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("aSk3Q", function(module, exports) {

$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $2dd8f1bba9a54435$export$18544d0b5f43e4a1);
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $2dd8f1bba9a54435$export$8a334a7d9fe120ec);

var $l1C1k = parcelRequire("l1C1k");

var $gxbjN = parcelRequire("gxbjN");

var $8YCkv = parcelRequire("8YCkv");
const $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $2dd8f1bba9a54435$export$f45e7335ec874bfe = (extensionNode)=>extensionNode.attrs?.extensionType === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY;
const $2dd8f1bba9a54435$var$transformNestedTableExtension = (nestedTableExtension)=>{
    // No content - drop the extension node
    if (!nestedTableExtension.attrs?.parameters?.adf) return false;
    try {
        const adf = JSON.parse(nestedTableExtension.attrs?.parameters?.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $8YCkv.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
// TODO: EDITOR-806 - Remove when cleaning feature gate platform_editor_nested_table_extension_comment_fix
function $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent) {
    if (parent.node === undefined) return false;
    if (parent.node.type === 'bodiedExtension') return true;
    if (parent?.parent?.node) return $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent.parent);
    return false;
}
const $2dd8f1bba9a54435$export$18544d0b5f43e4a1 = (adf, // TODO: EDITOR-806 - Remove options when cleaning feature gate platform_editor_nested_table_extension_comment_fix as no longer needed
options = {})=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        extension: (node, parent)=>{
            if ($2dd8f1bba9a54435$export$f45e7335ec874bfe(node)) {
                // TODO: EDITOR-806 - Remove this block when cleaning feature gate platform_editor_nested_table_extension_comment_fix
                // Bodied extensions in renderer use their own nested renderer to render the content.
                // This results in the document being validated/transformed twice, once with untransformed content and again with transformed content.
                // Since the untransformed content is valid ADF (table as extension in table) but the transformed content is not valid ADF, (table in table)
                // we need to skip transforming nested tables inside bodied extensions in renderer on the first pass or else it will fail validation and render an unsupported block.
                if (options.environment === 'renderer' && $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent) && !options.disableNestedRendererTreatment) return undefined;
                isTransformed = true;
                return $2dd8f1bba9a54435$var$transformNestedTableExtension(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $2dd8f1bba9a54435$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $gxbjN.extension)({
                    extensionType: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $8YCkv.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("gxbjN", function(module, exports) {

$parcel$export(module.exports, "extension", () => $ec4576859225619a$export$1b45514b112dd749);
const $ec4576859225619a$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("8YCkv", function(module, exports) {

$parcel$export(module.exports, "NodeNestingTransformError", () => $b0271efedae2a0b7$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $b0271efedae2a0b7$export$3d8e8d2182f13924 extends Error {
    /**
	 * @param message - Error message - Do not use any UGC in this message
	 */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});


parcelRegister("gkwXh", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $97c56ca7515fdb59$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $97c56ca7515fdb59$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $97c56ca7515fdb59$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $97c56ca7515fdb59$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $97c56ca7515fdb59$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $97c56ca7515fdb59$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $97c56ca7515fdb59$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $97c56ca7515fdb59$export$9f0b2adf3cfd71b7);
var $97c56ca7515fdb59$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $97c56ca7515fdb59$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
	 * @private
	 * @deprecated
	 *
	 * This is no longer used and can be removed at a later date
	 */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["RESIZED"] = "resized";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    /**
	 * used in Editor AI inline suggestion for a track event when a suggestion is inserted
	 * previously tracked events being used by Editor AI proactive suggestion
	 *
	 */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    return ACTION;
}({});
var $97c56ca7515fdb59$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["META_CLICK"] = "metaClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    return INPUT_METHOD;
}({});
var $97c56ca7515fdb59$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $97c56ca7515fdb59$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $97c56ca7515fdb59$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    return ACTION_SUBJECT;
}({});
var $97c56ca7515fdb59$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    return ACTION_SUBJECT_ID;
}({});
var $97c56ca7515fdb59$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $97c56ca7515fdb59$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("d54NZ", function(module, exports) {

$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $850930d0b79c2a61$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $850930d0b79c2a61$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $850930d0b79c2a61$export$3a34598135e7219b);

var $gkwXh = parcelRequire("gkwXh");
const $850930d0b79c2a61$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $850930d0b79c2a61$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $850930d0b79c2a61$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $850930d0b79c2a61$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$850930d0b79c2a61$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $gkwXh.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $850930d0b79c2a61$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$850930d0b79c2a61$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $850930d0b79c2a61$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $850930d0b79c2a61$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $850930d0b79c2a61$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $850930d0b79c2a61$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor((0, $gkwXh.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("4IuOY", function(module, exports) {

$parcel$export(module.exports, "validateADFEntity", () => $2c0bbb60cfee2804$export$884cfad20dece33e);

var $905ey = parcelRequire("905ey");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
const $2c0bbb60cfee2804$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $2c0bbb60cfee2804$var$errorCallbackFor = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $2c0bbb60cfee2804$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides?.allowNestedTables
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $2c0bbb60cfee2804$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $2c0bbb60cfee2804$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $2c0bbb60cfee2804$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta?.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta?.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    if (options.allowUnsupportedBlock) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : validate(child, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $d54NZ.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $2c0bbb60cfee2804$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $905ey.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};
function $2c0bbb60cfee2804$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("905ey", function(module, exports) {

$parcel$export(module.exports, "validator", () => $e861220f24467804$export$956325f45c5d174a);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $gsiq1 = parcelRequire("gsiq1");

var $iiazc = parcelRequire("iiazc");

var $1H4Aw = parcelRequire("1H4Aw");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e861220f24467804$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported from './specs'.
 * We denormalised the spec to save bundle size.
 */ function $e861220f24467804$var$createSpec(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($gsiq1).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const spec = {
            ...$gsiq1[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $iiazc.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $gsiq1[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $iiazc.isString)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($gsiq1[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $gsiq1[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($gsiq1[subItem]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $gsiq1[subItem] : (0, $iiazc.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $e861220f24467804$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $e861220f24467804$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $e861220f24467804$export$66c739158ef99a42(spec, value) {
    if (!(0, $iiazc.isDefined)(value)) return !!spec.optional;
    if ($e861220f24467804$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $e861220f24467804$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $e861220f24467804$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $iiazc.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $iiazc.isBoolean)(value);
        case 'number':
            return (0, $iiazc.isNumber)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $iiazc.isInteger)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $iiazc.isDefined)((0, $1H4Aw.validatorFnMap)[rule]) && (0, $1H4Aw.validatorFnMap)[rule](value);
            return (0, $iiazc.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $iiazc.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $iiazc.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $iiazc.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$e861220f24467804$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$e861220f24467804$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $iiazc.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $e861220f24467804$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $e861220f24467804$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $e861220f24467804$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $e861220f24467804$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message,
        meta: {
            parentType: parentSpec?.props?.type?.values[0]
        }
    }, $e861220f24467804$var$getUnsupportedOptions(parentSpec));
};
const $e861220f24467804$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $e861220f24467804$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $e861220f24467804$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $e861220f24467804$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $e861220f24467804$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $e861220f24467804$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $e861220f24467804$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $e861220f24467804$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $e861220f24467804$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $iiazc.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $iiazc.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$e861220f24467804$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $iiazc.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $iiazc.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $iiazc.makeArray)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $e861220f24467804$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $e861220f24467804$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $e861220f24467804$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $e861220f24467804$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $e861220f24467804$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $e861220f24467804$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $iiazc.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $iiazc.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $e861220f24467804$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $iiazc.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $e861220f24467804$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $iiazc.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $iiazc.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("gsiq1", function(module, exports) {

$parcel$export(module.exports, "alignment", () => (parcelRequire("5fjVx")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("5fjVx")).annotation);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("5fjVx")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("5fjVx")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("5fjVx")).block_content);
$parcel$export(module.exports, "blockRootOnly", () => (parcelRequire("5fjVx")).blockRootOnly);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("5fjVx")).blockquote);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5fjVx")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("5fjVx")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("5fjVx")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("5fjVx")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("5fjVx")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("5fjVx")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("5fjVx")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("5fjVx")).codeBlock);
$parcel$export(module.exports, "codeBlock_root_only", () => (parcelRequire("5fjVx")).codeBlock_root_only);
$parcel$export(module.exports, "text_with_no_marks", () => (parcelRequire("5fjVx")).text_with_no_marks);
$parcel$export(module.exports, "confluenceInlineComment", () => (parcelRequire("5fjVx")).confluenceInlineComment);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("5fjVx")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("5fjVx")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("5fjVx")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("5fjVx")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("5fjVx")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("5fjVx")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("5fjVx")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("5fjVx")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("5fjVx")).expand);
$parcel$export(module.exports, "expand_root_only", () => (parcelRequire("5fjVx")).expand_root_only);
$parcel$export(module.exports, "extension", () => (parcelRequire("5fjVx")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("5fjVx")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("5fjVx")).extension_with_marks);
$parcel$export(module.exports, "fragment", () => (parcelRequire("5fjVx")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("5fjVx")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("5fjVx")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("5fjVx")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("5fjVx")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("5fjVx")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("5fjVx")).indentation);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("5fjVx")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5fjVx")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("5fjVx")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_content", () => (parcelRequire("5fjVx")).inline_content);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("5fjVx")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("5fjVx")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("5fjVx")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("5fjVx")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("5fjVx")).link);
$parcel$export(module.exports, "listItem", () => (parcelRequire("5fjVx")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("5fjVx")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("5fjVx")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("5fjVx")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("5fjVx")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("5fjVx")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("5fjVx")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("5fjVx")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("5fjVx")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("5fjVx")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("5fjVx")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("5fjVx")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("5fjVx")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("5fjVx")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("5fjVx")).panel);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("5fjVx")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("5fjVx")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("5fjVx")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("5fjVx")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("5fjVx")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("5fjVx")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("5fjVx")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("5fjVx")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("5fjVx")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("5fjVx")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("5fjVx")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("5fjVx")).tableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("5fjVx")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("5fjVx")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("5fjVx")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("5fjVx")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("5fjVx")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("5fjVx")).textColor);
$parcel$export(module.exports, "text_code_inline", () => (parcelRequire("5fjVx")).text_code_inline);
$parcel$export(module.exports, "text_formatted", () => (parcelRequire("5fjVx")).text_formatted);
$parcel$export(module.exports, "text_link_inline", () => (parcelRequire("5fjVx")).text_link_inline);
$parcel$export(module.exports, "underline", () => (parcelRequire("5fjVx")).underline);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5fjVx = parcelRequire("5fjVx");

});
parcelRegister("5fjVx", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $3d1dcf8b9eccd1a7$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $3d1dcf8b9eccd1a7$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $3d1dcf8b9eccd1a7$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $3d1dcf8b9eccd1a7$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23);
$parcel$export(module.exports, "bodiedExtension", () => $3d1dcf8b9eccd1a7$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83);
$parcel$export(module.exports, "border", () => $3d1dcf8b9eccd1a7$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $3d1dcf8b9eccd1a7$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $3d1dcf8b9eccd1a7$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $3d1dcf8b9eccd1a7$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $3d1dcf8b9eccd1a7$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $3d1dcf8b9eccd1a7$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $3d1dcf8b9eccd1a7$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $3d1dcf8b9eccd1a7$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $3d1dcf8b9eccd1a7$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fragment", () => $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $3d1dcf8b9eccd1a7$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $3d1dcf8b9eccd1a7$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $3d1dcf8b9eccd1a7$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $3d1dcf8b9eccd1a7$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $3d1dcf8b9eccd1a7$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $3d1dcf8b9eccd1a7$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $3d1dcf8b9eccd1a7$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $3d1dcf8b9eccd1a7$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $3d1dcf8b9eccd1a7$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $3d1dcf8b9eccd1a7$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $3d1dcf8b9eccd1a7$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $3d1dcf8b9eccd1a7$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $3d1dcf8b9eccd1a7$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013);
$parcel$export(module.exports, "nestedExpand", () => $3d1dcf8b9eccd1a7$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $3d1dcf8b9eccd1a7$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $3d1dcf8b9eccd1a7$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $3d1dcf8b9eccd1a7$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $3d1dcf8b9eccd1a7$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $3d1dcf8b9eccd1a7$export$b3401ee80eb31041);
$parcel$export(module.exports, "table", () => $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $3d1dcf8b9eccd1a7$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $3d1dcf8b9eccd1a7$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $3d1dcf8b9eccd1a7$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $3d1dcf8b9eccd1a7$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $3d1dcf8b9eccd1a7$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $3d1dcf8b9eccd1a7$export$425327af25286e5e);
const $3d1dcf8b9eccd1a7$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $3d1dcf8b9eccd1a7$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});


parcelRegister("iiazc", function(module, exports) {

$parcel$export(module.exports, "isDefined", () => $2c8456da404b8e3f$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $2c8456da404b8e3f$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $2c8456da404b8e3f$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $2c8456da404b8e3f$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $2c8456da404b8e3f$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $2c8456da404b8e3f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $2c8456da404b8e3f$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $2c8456da404b8e3f$export$7b85fd78dd236198);
const $2c8456da404b8e3f$export$4e62c701997796c1 = (x)=>x != null;
const $2c8456da404b8e3f$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $2c8456da404b8e3f$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $2c8456da404b8e3f$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $2c8456da404b8e3f$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $2c8456da404b8e3f$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $2c8456da404b8e3f$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $2c8456da404b8e3f$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("1H4Aw", function(module, exports) {

$parcel$export(module.exports, "validatorFnMap", () => $608e35270d0ca1e8$export$d1b377ca77ac267d);

var $iZOJ9 = parcelRequire("iZOJ9");
const $608e35270d0ca1e8$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $iZOJ9.isSafeUrl)
};

});



parcelRegister("eQNWQ", function(module, exports) {

$parcel$export(module.exports, "getMarksByOrder", () => $7bbfc2d34b0938dd$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $7bbfc2d34b0938dd$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $7bbfc2d34b0938dd$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $7bbfc2d34b0938dd$export$81b20b6c83a56bd);

var $9IGaJ = parcelRequire("9IGaJ");
var $kc0v7 = parcelRequire("kc0v7");
var $iZOJ9 = parcelRequire("iZOJ9");
var $bFtEE = parcelRequire("bFtEE");

var $kOFhM = parcelRequire("kOFhM");

var $VSDnB = parcelRequire("VSDnB");
const $7bbfc2d34b0938dd$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $7bbfc2d34b0938dd$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $7bbfc2d34b0938dd$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(a.type.name) - $7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $7bbfc2d34b0938dd$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $7bbfc2d34b0938dd$export$fb80336a7e408cb3 = (doc, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const node = $7bbfc2d34b0938dd$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $7bbfc2d34b0938dd$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $7bbfc2d34b0938dd$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $kc0v7.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $7bbfc2d34b0938dd$export$fafd4f799ee68da0 = (content, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$7bbfc2d34b0938dd$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$ANCHOR_LINK = /^#/;
const $7bbfc2d34b0938dd$var$flattenUnknownBlockTree = (node, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($7bbfc2d34b0938dd$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$7bbfc2d34b0938dd$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $7bbfc2d34b0938dd$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $iZOJ9.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $7bbfc2d34b0938dd$var$flattenUnknownBlockTree(node)
    };
};
const $7bbfc2d34b0938dd$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $7bbfc2d34b0938dd$export$81b20b6c83a56bd = (originalNode, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $7bbfc2d34b0938dd$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $bFtEE.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $9IGaJ.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
    }
    return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
};
const $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$7bbfc2d34b0938dd$var$RELATIVE_LINK.test(linkHref) && !$7bbfc2d34b0938dd$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $iZOJ9.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("kc0v7", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $eb355120b38723aa$export$b1f729c6af6f2a6e);

var $ctVrM = parcelRequire("ctVrM");
const $eb355120b38723aa$var$typedNodes = $ctVrM;
const $eb355120b38723aa$export$b1f729c6af6f2a6e = new Set(Object.keys($eb355120b38723aa$var$typedNodes).filter((key)=>$eb355120b38723aa$var$typedNodes[key] && $eb355120b38723aa$var$typedNodes[key].group === 'inline'));

});
parcelRegister("ctVrM", function(module, exports) {

$parcel$export(module.exports, "expand", () => (parcelRequire("7kC9H")).expand);
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("7kC9H")).expandWithNestedExpand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("7kC9H")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("6bbHe")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("5y0tR")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("bd7A9")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("xjCuM")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("aXBFx")).blockquote);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => (parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia);
$parcel$export(module.exports, "extendedBlockquote", () => (parcelRequire("aXBFx")).extendedBlockquote);
$parcel$export(module.exports, "blockquoteWithList", () => (parcelRequire("aXBFx")).blockquoteWithList);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => (parcelRequire("aXBFx")).blockquoteWithoutNonBodiedMacros);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("kjhhp")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("kjhhp")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("8vlrc")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("8vlrc")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("jnMM2")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("lRTZM")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("M4hHz")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("dwptW")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("dwptW")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("dwptW")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("abme3")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("7DoMR")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("7lRBh")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("g7Cky")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("g7Cky")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("2FIVU")).listItem);
$parcel$export(module.exports, "listItemWithTask", () => (parcelRequire("2FIVU")).listItemWithTask);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => (parcelRequire("2FIVU")).listItemWithDecisionStage0);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => (parcelRequire("2FIVU")).listItemWithoutNonBodiedMacros);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("bFtEE")).extendedPanel);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => (parcelRequire("bFtEE")).panelWithoutNestedNonBodiedMacros);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("bFtEE")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("3DR6L")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("9X587")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("5JeV5")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("7agO8")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("7agO8")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("7agO8")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("92lix")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("7Xgp3")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("bIGZ7")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("bIGZ7")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("bIGZ7")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("bIGZ7")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("bIGZ7")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("bIGZ7")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("9UDEr")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("9UDEr")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("9UDEr")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("9UDEr")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("9UDEr")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("9UDEr")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("9UDEr")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("9UDEr")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("9UDEr")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("9UDEr")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("9UDEr")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("9UDEr")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("9UDEr")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("9UDEr")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("9UDEr")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("9UDEr")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("9UDEr")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("9UDEr")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("9UDEr")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("9UDEr")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("9UDEr")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("9UDEr")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("9UDEr")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("8gSD8")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("8gSD8")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("Khvpb")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("43mJF")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("43mJF")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("iThOL")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("b2VmY")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("dgJoa")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("gZoER")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("gZoER")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("4EbxI")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("cCBEe")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("21PS7")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("d1d6m")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("6kr5W")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("18bvk")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("dx5eC")).nestedExpand);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => (parcelRequire("dx5eC")).nestedExpandWithoutNonBodiedMacros);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("kshOv")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("hhN5g")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5BOuQ")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5AxYU")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("47jug")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("47jug")).multiBodiedExtension);

var $7kC9H = parcelRequire("7kC9H");

var $6bbHe = parcelRequire("6bbHe");

var $5y0tR = parcelRequire("5y0tR");

var $bd7A9 = parcelRequire("bd7A9");

var $xjCuM = parcelRequire("xjCuM");

var $aXBFx = parcelRequire("aXBFx");

var $kjhhp = parcelRequire("kjhhp");

var $8vlrc = parcelRequire("8vlrc");

var $jnMM2 = parcelRequire("jnMM2");

var $lRTZM = parcelRequire("lRTZM");

var $M4hHz = parcelRequire("M4hHz");

var $dwptW = parcelRequire("dwptW");

var $abme3 = parcelRequire("abme3");

var $7DoMR = parcelRequire("7DoMR");

var $7lRBh = parcelRequire("7lRBh");

var $g7Cky = parcelRequire("g7Cky");

var $2FIVU = parcelRequire("2FIVU");

var $bFtEE = parcelRequire("bFtEE");

var $3DR6L = parcelRequire("3DR6L");

var $9X587 = parcelRequire("9X587");

var $5JeV5 = parcelRequire("5JeV5");

var $7agO8 = parcelRequire("7agO8");

var $92lix = parcelRequire("92lix");

var $7Xgp3 = parcelRequire("7Xgp3");

var $bIGZ7 = parcelRequire("bIGZ7");

var $9UDEr = parcelRequire("9UDEr");

var $8gSD8 = parcelRequire("8gSD8");

var $Khvpb = parcelRequire("Khvpb");

var $43mJF = parcelRequire("43mJF");

var $iThOL = parcelRequire("iThOL");

var $b2VmY = parcelRequire("b2VmY");

var $dgJoa = parcelRequire("dgJoa");

var $gZoER = parcelRequire("gZoER");

var $4EbxI = parcelRequire("4EbxI");

var $cCBEe = parcelRequire("cCBEe");

var $21PS7 = parcelRequire("21PS7");

var $d1d6m = parcelRequire("d1d6m");

var $6kr5W = parcelRequire("6kr5W");

var $18bvk = parcelRequire("18bvk");

var $dx5eC = parcelRequire("dx5eC");

var $kshOv = parcelRequire("kshOv");

var $hhN5g = parcelRequire("hhN5g");

var $5BOuQ = parcelRequire("5BOuQ");

var $5AxYU = parcelRequire("5AxYU");

var $47jug = parcelRequire("47jug");

});



parcelRegister("knXBU", function(module, exports) {

$parcel$export(module.exports, "PLATFORM", () => $11894d4d5d86b4b1$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $11894d4d5d86b4b1$export$e48589d9e4824227);
var $11894d4d5d86b4b1$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $11894d4d5d86b4b1$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $11894d4d5d86b4b1$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($11894d4d5d86b4b1$var$RESOLVE_METHOD || {});

});

parcelRegister("1cjf7", function(module, exports) {

$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $dad344c5873159ce$export$a43de96edd8d0a0);

var $4NUlu = parcelRequire("4NUlu");
var $2KwKW = parcelRequire("2KwKW");

var $gkwXh = parcelRequire("gkwXh");

var $knXBU = parcelRequire("knXBU");
const $dad344c5873159ce$var$rendersMap = {};
const $dad344c5873159ce$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $2KwKW.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $4NUlu.getAnalyticsAppearance)(item.appearance),
                platform: (0, $knXBU.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $dad344c5873159ce$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE = 100;
const $dad344c5873159ce$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$dad344c5873159ce$var$rendersMap[appearance]) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $dad344c5873159ce$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $dad344c5873159ce$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($dad344c5873159ce$var$rendersMap[appearance].size === 1) $dad344c5873159ce$var$schedule(()=>$dad344c5873159ce$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($dad344c5873159ce$var$rendersMap[appearance].size % sampleRate === 0) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("4NUlu", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAppearance", () => $d9ce436f8d702318$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $d9ce436f8d702318$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $d9ce436f8d702318$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "findInsertLocation", () => $d9ce436f8d702318$export$d770b562ead089d8);
$parcel$export(module.exports, "analyticsEventKey", () => $d9ce436f8d702318$export$288273ee3e3b6132);

var $d93fQ = parcelRequire("d93fQ");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");
const $d9ce436f8d702318$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $d9ce436f8d702318$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$d9ce436f8d702318$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $d9ce436f8d702318$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
function $d9ce436f8d702318$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $gZGBX.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $hFEwm.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $5r0mK.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
var $d9ce436f8d702318$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $d9ce436f8d702318$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';

});
parcelRegister("5r0mK", function(module, exports) {

$parcel$export(module.exports, "removeParentNodeOfType", () => $3f4fc20879d21ebe$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $3f4fc20879d21ebe$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $3f4fc20879d21ebe$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $3f4fc20879d21ebe$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $3f4fc20879d21ebe$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $3f4fc20879d21ebe$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $3f4fc20879d21ebe$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $3f4fc20879d21ebe$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $3f4fc20879d21ebe$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $3f4fc20879d21ebe$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $3f4fc20879d21ebe$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $3f4fc20879d21ebe$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $3f4fc20879d21ebe$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $3f4fc20879d21ebe$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $3f4fc20879d21ebe$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $3f4fc20879d21ebe$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $3f4fc20879d21ebe$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $3f4fc20879d21ebe$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $3f4fc20879d21ebe$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $3f4fc20879d21ebe$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $3f4fc20879d21ebe$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $3f4fc20879d21ebe$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $3f4fc20879d21ebe$export$2344b14b097df817);
// src/selection.ts

var $gZGBX = parcelRequire("gZGBX");

var $kCV8T = parcelRequire("kCV8T");
var $3f4fc20879d21ebe$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $3f4fc20879d21ebe$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $3f4fc20879d21ebe$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $3f4fc20879d21ebe$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$7d6e4e6663186878 = (tr)=>{
    if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $3f4fc20879d21ebe$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $3f4fc20879d21ebe$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $kCV8T.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $kCV8T.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $3f4fc20879d21ebe$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $3f4fc20879d21ebe$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $kCV8T.Node) && node.type && node.type.spec.selectable);
var $3f4fc20879d21ebe$var$shouldSelectNode = (node)=>$3f4fc20879d21ebe$var$isSelectableNode(node) && node.type.isLeaf;
var $3f4fc20879d21ebe$var$setSelection = (node, pos, tr)=>{
    if ($3f4fc20879d21ebe$var$shouldSelectNode(node)) return tr.setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve(pos)));
    return $3f4fc20879d21ebe$export$1df6d14df6b0b758(pos)(tr);
};
var $3f4fc20879d21ebe$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $3f4fc20879d21ebe$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($3f4fc20879d21ebe$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $3f4fc20879d21ebe$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $3f4fc20879d21ebe$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $3f4fc20879d21ebe$var$setSelection(content, pos, tr);
            }
        }
        if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $3f4fc20879d21ebe$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $3f4fc20879d21ebe$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $3f4fc20879d21ebe$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $3f4fc20879d21ebe$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $3f4fc20879d21ebe$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $gZGBX.NodeSelection);
};
var $3f4fc20879d21ebe$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $3f4fc20879d21ebe$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $3f4fc20879d21ebe$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($3f4fc20879d21ebe$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $3f4fc20879d21ebe$var$cloneTr(tr);
        }
        return tr;
    };
var $3f4fc20879d21ebe$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $kCV8T.Fragment) ? content : (0, $kCV8T.Fragment).from(content));
};
var $3f4fc20879d21ebe$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $3f4fc20879d21ebe$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $3f4fc20879d21ebe$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $kCV8T.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $kCV8T.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $3f4fc20879d21ebe$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $3f4fc20879d21ebe$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $3f4fc20879d21ebe$export$fe09644e3bc6166b($from, predicate);
    };
var $3f4fc20879d21ebe$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $3f4fc20879d21ebe$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $3f4fc20879d21ebe$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $3f4fc20879d21ebe$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
    };
var $3f4fc20879d21ebe$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $3f4fc20879d21ebe$export$dc159056ffdb4c76((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
    };
var $3f4fc20879d21ebe$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $3f4fc20879d21ebe$export$fe09644e3bc6166b($pos, (node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node));
};
var $3f4fc20879d21ebe$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $3f4fc20879d21ebe$export$178ecaf80f45fdb6((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
    };
var $3f4fc20879d21ebe$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $3f4fc20879d21ebe$export$8556d79fa8189214((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $3f4fc20879d21ebe$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($3f4fc20879d21ebe$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $3f4fc20879d21ebe$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $gZGBX.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $3f4fc20879d21ebe$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $3f4fc20879d21ebe$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $3f4fc20879d21ebe$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $3f4fc20879d21ebe$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $3f4fc20879d21ebe$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $3f4fc20879d21ebe$export$ddc1620722e25671 = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $3f4fc20879d21ebe$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $3f4fc20879d21ebe$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $3f4fc20879d21ebe$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $3f4fc20879d21ebe$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $3f4fc20879d21ebe$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$3f4fc20879d21ebe$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("hFEwm", function(module, exports) {

$parcel$export(module.exports, "CellSelection", () => $451fe475e5e2c47a$export$831cc7e2a83afa94);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $6MNnJ = parcelRequire("6MNnJ");

var $uOUlv = parcelRequire("uOUlv");

var $6hQQ3 = parcelRequire("6hQQ3");

var $6e6o8 = parcelRequire("6e6o8");

var $aKDxB = parcelRequire("aKDxB");

var $bQFBc = parcelRequire("bQFBc");
class $451fe475e5e2c47a$export$831cc7e2a83afa94 extends (0, $gZGBX.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $aKDxB.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $6hQQ3.pointsAtCell)($anchorCell) && (0, $6hQQ3.pointsAtCell)($headCell) && (0, $bQFBc.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $451fe475e5e2c47a$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $gZGBX.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $uOUlv.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $6e6o8.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $6e6o8.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy((0, $kCV8T.Fragment).from(rowContent)));
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $kCV8T.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $kCV8T.Slice).empty : content);
        }
        const sel = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $uOUlv.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $uOUlv.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $uOUlv.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $451fe475e5e2c47a$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $uOUlv.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $6MNnJ.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $gZGBX.Selection).jsonID('cell', $451fe475e5e2c47a$export$831cc7e2a83afa94);

});
parcelRegister("6MNnJ", function(module, exports) {

$parcel$export(module.exports, "CellBookmark", () => $7bc56074adb266b5$export$ca751a6394ad160e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $gZGBX = parcelRequire("gZGBX");

var $bQFBc = parcelRequire("bQFBc");
class $7bc56074adb266b5$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $7bc56074adb266b5$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $bQFBc.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $gZGBX.Selection).fromJSON(doc, data);
        }
        return (0, $gZGBX.Selection).near($headCell, 1);
    }
}

});
parcelRegister("bQFBc", function(module, exports) {

$parcel$export(module.exports, "isInTable", () => $e501ca8feab95168$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $e501ca8feab95168$export$debd62b44eb7e281);
function $e501ca8feab95168$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $e501ca8feab95168$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("uOUlv", function(module, exports) {

$parcel$export(module.exports, "Rect", () => $ca500cf7ecedd822$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $ca500cf7ecedd822$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $ca500cf7ecedd822$export$493da463fed0a57a);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $ca500cf7ecedd822$var$readFromCache, $ca500cf7ecedd822$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $ca500cf7ecedd822$var$readFromCache = (key)=>cache.get(key);
    $ca500cf7ecedd822$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = [];
    const cacheSize = 10;
    let cachePos = 0;
    $ca500cf7ecedd822$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $ca500cf7ecedd822$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $ca500cf7ecedd822$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $ca500cf7ecedd822$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $ca500cf7ecedd822$export$c60fae4049791eae = 140;
class $ca500cf7ecedd822$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $ca500cf7ecedd822$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $ca500cf7ecedd822$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $ca500cf7ecedd822$var$readFromCache(table) || $ca500cf7ecedd822$var$addToCache(table, $ca500cf7ecedd822$var$computeMap(table));
    }
}
// Compute a table map.
function $ca500cf7ecedd822$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = $ca500cf7ecedd822$var$findWidth(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new $ca500cf7ecedd822$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($ca500cf7ecedd822$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $ca500cf7ecedd822$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $ca500cf7ecedd822$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $ca500cf7ecedd822$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $ca500cf7ecedd822$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca500cf7ecedd822$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("6hQQ3", function(module, exports) {

$parcel$export(module.exports, "pointsAtCell", () => $6704a47d099ba366$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $6704a47d099ba366$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $6704a47d099ba366$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $6704a47d099ba366$export$172699367bb25225);

var $uOUlv = parcelRequire("uOUlv");
function $6704a47d099ba366$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $6704a47d099ba366$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $6704a47d099ba366$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $6704a47d099ba366$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $uOUlv.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("6e6o8", function(module, exports) {

$parcel$export(module.exports, "removeColSpan", () => $44eb8577da1c519b$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $44eb8577da1c519b$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $44eb8577da1c519b$export$147ee78a1321ac36);
function $44eb8577da1c519b$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $44eb8577da1c519b$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("aKDxB", function(module, exports) {

$parcel$export(module.exports, "getCellSelectionRanges", () => $d20b421410b3cfed$export$a60a444208fd5099);

var $gZGBX = parcelRequire("gZGBX");

var $uOUlv = parcelRequire("uOUlv");
function $d20b421410b3cfed$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $uOUlv.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $gZGBX.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});



parcelRegister("2KwKW", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $4210b4deee40727f$export$484b83e0462998d);

var $l1C1k = parcelRequire("l1C1k");
var $4210b4deee40727f$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $4210b4deee40727f$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $4210b4deee40727f$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $4210b4deee40727f$export$f9f8a29778652c3e.BLOCKING
    };
};
const $4210b4deee40727f$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $l1C1k.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $l1C1k.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $4210b4deee40727f$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $4210b4deee40727f$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("kgV4b", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $7ac8dee2b321f8fd$export$1daf15cbaf649dad);

var $3Y1bF = parcelRequire("3Y1bF");
function $7ac8dee2b321f8fd$export$1daf15cbaf649dad(adfDocument) {
    return (0, $3Y1bF.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("3Y1bF", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $de5bae64a9d3f36e$export$533b26079ad0b4b);

var $l1C1k = parcelRequire("l1C1k");
function $de5bae64a9d3f36e$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $l1C1k.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("fLTqo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3162b9aa01f33877$export$2e2bcd8739ae039);

var $kOFhM = parcelRequire("kOFhM");

var $e6OIt = parcelRequire("e6OIt");
class $3162b9aa01f33877$export$2e2bcd8739ae039 {
    constructor(schema){
        this.schema = schema;
        this.schema = schema;
    }
    serializeFragment(fragment) {
        const result = [];
        fragment.forEach((n)=>{
            result.push((0, $e6OIt.reduce)(n, this.schema));
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return result.join('\n').replace(/\n+/g, '\n');
    }
    static fromSchema(schema = (0, $kOFhM.defaultSchema)) {
        return new $3162b9aa01f33877$export$2e2bcd8739ae039(schema);
    }
}

});
parcelRegister("e6OIt", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $d81fee803f8be80c$export$533b26079ad0b4b);

var $3pmcr = parcelRequire("3pmcr");

var $dFTQc = parcelRequire("dFTQc");

var $gePJb = parcelRequire("gePJb");

var $kDX7I = parcelRequire("kDX7I");

var $imMk3 = parcelRequire("imMk3");

var $440xp = parcelRequire("440xp");

var $lFEBP = parcelRequire("lFEBP");

var $htHCj = parcelRequire("htHCj");

var $khjO4 = parcelRequire("khjO4");

var $6e3uf = parcelRequire("6e3uf");

var $3LUJO = parcelRequire("3LUJO");

var $eAfxp = parcelRequire("eAfxp");

var $aBdRK = parcelRequire("aBdRK");

var $hHZcb = parcelRequire("hHZcb");

var $3uDza = parcelRequire("3uDza");

var $jDcJt = parcelRequire("jDcJt");

var $ca29C = parcelRequire("ca29C");

var $70D85 = parcelRequire("70D85");
const $d81fee803f8be80c$export$533b26079ad0b4b = (node, schema)=>{
    const reducer = $d81fee803f8be80c$var$nodeToReducerMapping[node.type.name] || $d81fee803f8be80c$var$nodeToReducerMapping.unknown;
    return reducer(node, schema);
};
const $d81fee803f8be80c$var$nodeToReducerMapping = {
    blockquote: $3pmcr.default,
    bulletList: $dFTQc.default,
    date: $gePJb.default,
    decisionItem: $kDX7I.default,
    hardBreak: $imMk3.default,
    heading: $440xp.default,
    inlineCard: $lFEBP.default,
    listItem: $htHCj.default,
    mediaGroup: $khjO4.default,
    mention: $6e3uf.default,
    orderedList: $3LUJO.default,
    panel: $eAfxp.default,
    paragraph: $aBdRK.default,
    rule: $hHZcb.default,
    status: $3uDza.default,
    table: $jDcJt.default,
    taskItem: $ca29C.default,
    unknown: $70D85.default
};

});
parcelRegister("3pmcr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b783d74f3fa943e7$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $b783d74f3fa943e7$var$blockquote = (node, schema)=>{
    const result = [];
    node.content.forEach((n)=>{
        result.push((0, $e6OIt.reduce)(n, schema));
    });
    return `> ${result.join('')}`;
};
var $b783d74f3fa943e7$export$2e2bcd8739ae039 = $b783d74f3fa943e7$var$blockquote;

});

parcelRegister("dFTQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $749dbd2e6028b2d6$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $749dbd2e6028b2d6$var$bulletList = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push(`* ${(0, $e6OIt.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $749dbd2e6028b2d6$export$2e2bcd8739ae039 = $749dbd2e6028b2d6$var$bulletList;

});

parcelRegister("gePJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9583bb4b1b92a2c3$export$2e2bcd8739ae039);

var $cAMv0 = parcelRequire("cAMv0");

var $K5Jsy = parcelRequire("K5Jsy");
const $9583bb4b1b92a2c3$var$date = (node, schema)=>{
    return node.attrs.timestamp ? (0, $cAMv0.timestampToIsoFormat)(node.attrs.timestamp) : (0, $K5Jsy.getText)(node);
};
var $9583bb4b1b92a2c3$export$2e2bcd8739ae039 = $9583bb4b1b92a2c3$var$date;

});
parcelRegister("cAMv0", function(module, exports) {

$parcel$export(module.exports, "timestampToUTCDate", () => $c5b07ac9bae9c35c$export$56c3660a4ee2196a);
$parcel$export(module.exports, "todayTimestampInUTC", () => $c5b07ac9bae9c35c$export$6297728405c48562);
$parcel$export(module.exports, "timestampToString", () => $c5b07ac9bae9c35c$export$48755a044ef883a0);
$parcel$export(module.exports, "timestampToIsoFormat", () => $c5b07ac9bae9c35c$export$70a1b7b6fffe4dd1);
$parcel$export(module.exports, "isPastDate", () => $c5b07ac9bae9c35c$export$e6cc7bfc6e0e363e);
$parcel$export(module.exports, "timestampToTaskContext", () => $c5b07ac9bae9c35c$export$fbc04a9e57b04a80);

var $SzDmm = parcelRequire("SzDmm");

var $kUxFz = parcelRequire("kUxFz");
var $c5b07ac9bae9c35c$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($c5b07ac9bae9c35c$var$FORMATS || {});
const $c5b07ac9bae9c35c$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $c5b07ac9bae9c35c$export$6297728405c48562 = ()=>{
    const today = new Date(Date.now());
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $c5b07ac9bae9c35c$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $c5b07ac9bae9c35c$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $c5b07ac9bae9c35c$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $c5b07ac9bae9c35c$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $c5b07ac9bae9c35c$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$c5b07ac9bae9c35c$var$addLeadingZero(date.getUTCMonth() + 1)}-${$c5b07ac9bae9c35c$var$addLeadingZero(date.getUTCDate())}`;
};
const $c5b07ac9bae9c35c$export$e6cc7bfc6e0e363e = (timestamp)=>{
    return (0, $kUxFz.default)(new Date(Number(timestamp)), new Date(Number($c5b07ac9bae9c35c$export$6297728405c48562())));
};
const $c5b07ac9bae9c35c$export$fbc04a9e57b04a80 = (timestamp, intl)=>{
    const curDate = new Date(Number($c5b07ac9bae9c35c$export$6297728405c48562()));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $SzDmm.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $c5b07ac9bae9c35c$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $c5b07ac9bae9c35c$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};

});

parcelRegister("K5Jsy", function(module, exports) {

$parcel$export(module.exports, "ADFEncoder", () => $75b48ee07210971a$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $75b48ee07210971a$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $75b48ee07210971a$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $75b48ee07210971a$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $hYNZx = parcelRequire("hYNZx");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $75b48ee07210971a$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $75b48ee07210971a$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $kOFhM.defaultSchema));
        this.encode = $75b48ee07210971a$var$createEncoder(transformer, new (0, $hYNZx.JSONTransformer)());
    }
}
const $75b48ee07210971a$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $75b48ee07210971a$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $75b48ee07210971a$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $75b48ee07210971a$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});
parcelRegister("hYNZx", function(module, exports) {

$parcel$export(module.exports, "SchemaStage", () => $c960adc5c7547145$export$933e6445c497ffd5);
$parcel$export(module.exports, "JSONTransformer", () => $c960adc5c7547145$export$98cb1d9308d0944d);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ajpes = parcelRequire("ajpes");

var $8vlrc = parcelRequire("8vlrc");
var $cUwVZ = parcelRequire("cUwVZ");
var $7kC9H = parcelRequire("7kC9H");
var $29Vii = parcelRequire("29Vii");
var $8XeG6 = parcelRequire("8XeG6");
var $bIGZ7 = parcelRequire("bIGZ7");
var $7agO8 = parcelRequire("7agO8");
var $g7Cky = parcelRequire("g7Cky");
var $9UDEr = parcelRequire("9UDEr");

var $kOFhM = parcelRequire("kOFhM");

var $fVI2q = parcelRequire("fVI2q");

var $0Cgjx = parcelRequire("0Cgjx");
var $c960adc5c7547145$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $c960adc5c7547145$var$isType = (type)=>(node)=>node.type.name === type;
const $c960adc5c7547145$var$isCodeBlock = $c960adc5c7547145$var$isType('codeBlock');
const $c960adc5c7547145$var$isMediaNode = $c960adc5c7547145$var$isType('media');
const $c960adc5c7547145$var$isMediaInline = $c960adc5c7547145$var$isType('mediaInline');
const $c960adc5c7547145$var$isMediaSingleNode = $c960adc5c7547145$var$isType('mediaSingle');
const $c960adc5c7547145$var$isMentionNode = $c960adc5c7547145$var$isType('mention');
const $c960adc5c7547145$var$isParagraph = $c960adc5c7547145$var$isType('paragraph');
const $c960adc5c7547145$var$isHeading = $c960adc5c7547145$var$isType('heading');
const $c960adc5c7547145$var$isTable = $c960adc5c7547145$var$isType('table');
const $c960adc5c7547145$var$isTableCell = $c960adc5c7547145$var$isType('tableCell');
const $c960adc5c7547145$var$isTableHeader = $c960adc5c7547145$var$isType('tableHeader');
const $c960adc5c7547145$var$isLinkMark = $c960adc5c7547145$var$isType('link');
const $c960adc5c7547145$var$isUnsupportedMark = $c960adc5c7547145$var$isType('unsupportedMark');
const $c960adc5c7547145$var$isUnsupportedNodeAttributeMark = $c960adc5c7547145$var$isType('unsupportedNodeAttribute');
const $c960adc5c7547145$var$isExpand = $c960adc5c7547145$var$isType('expand');
const $c960adc5c7547145$var$isNestedExpand = $c960adc5c7547145$var$isType('nestedExpand');
const $c960adc5c7547145$var$isUnsupportedNode = (node)=>$c960adc5c7547145$var$isType('unsupportedBlock')(node) || $c960adc5c7547145$var$isType('unsupportedInline')(node);
const $c960adc5c7547145$var$isDataConsumer = $c960adc5c7547145$var$isType('dataConsumer');
const $c960adc5c7547145$var$isFragmentMark = $c960adc5c7547145$var$isType('fragment');
const $c960adc5c7547145$var$isHardBreak = $c960adc5c7547145$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c960adc5c7547145$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $c960adc5c7547145$var$filterNull(current);
    }
    return output;
};
const $c960adc5c7547145$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $c960adc5c7547145$var$emptyDoc = $c960adc5c7547145$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
const $c960adc5c7547145$var$toJSON = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($c960adc5c7547145$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($c960adc5c7547145$var$isMediaNode(node)) obj.attrs = (0, $7agO8.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMediaSingleNode(node)) obj.attrs = (0, $bIGZ7.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMediaInline(node)) obj.attrs = (0, $7agO8.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMentionNode(node)) obj.attrs = (0, $g7Cky.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isCodeBlock(node)) obj.attrs = (0, $8vlrc.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isTable(node)) obj.attrs = (0, $9UDEr.tableToJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isTableCell(node)) obj.attrs = (0, $9UDEr.toJSONTableCell)(node).attrs;
    else if ($c960adc5c7547145$var$isTableHeader(node)) obj.attrs = (0, $9UDEr.toJSONTableHeader)(node).attrs;
    else if ($c960adc5c7547145$var$isExpand(node) || $c960adc5c7547145$var$isNestedExpand(node)) obj.attrs = (0, $7kC9H.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $c960adc5c7547145$var$filterNull(obj.attrs);
    if ($c960adc5c7547145$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($c960adc5c7547145$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    // Hard break has optional attr.text which was added for PM <-> ADF compatibility.
    // No need to preserve it.
    if ($c960adc5c7547145$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($c960adc5c7547145$var$toJSON(child, mentionMap));
    });
    if ($c960adc5c7547145$var$isParagraph(node) || $c960adc5c7547145$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($c960adc5c7547145$var$isUnsupportedMark(mark)) return $c960adc5c7547145$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($c960adc5c7547145$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($c960adc5c7547145$var$isLinkMark(mark)) return (0, $8XeG6.toJSON)(mark);
            else if ($c960adc5c7547145$var$isDataConsumer(mark)) {
                const serialised = (0, $cUwVZ.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($c960adc5c7547145$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $29Vii.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($c960adc5c7547145$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$c960adc5c7547145$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $c960adc5c7547145$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $fVI2q.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $c960adc5c7547145$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $c960adc5c7547145$export$98cb1d9308d0944d {
    /**
	 * @param schema The current editor schema
	 * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
	 * mention node.attr.text values with mapped names.
	 */ constructor(schema = (0, $kOFhM.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $0Cgjx.sanitizeNode)($c960adc5c7547145$var$toJSON(child, this.mentionMap)));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(content, $c960adc5c7547145$var$emptyDoc.content)) return $c960adc5c7547145$var$createDocFromContent([]);
        return $c960adc5c7547145$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $kOFhM.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($c960adc5c7547145$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
	 * This method is used to encode a single node
	 */ encodeNode(node) {
        return (0, $0Cgjx.sanitizeNode)($c960adc5c7547145$var$toJSON(node, this.mentionMap));
    }
}

});
parcelRegister("fVI2q", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", () => $7f7cf8cf5d94f891$export$28e4e3c024cce988);
const $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $7f7cf8cf5d94f891$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour;
        default:
            return $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("0Cgjx", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", () => $45db1c8142107da9$export$48b382180baf8e88);

var $aSk3Q = parcelRequire("aSk3Q");

var $l1C1k = parcelRequire("l1C1k");

var $VSDnB = parcelRequire("VSDnB");

var $hRZSy = parcelRequire("hRZSy");
const $45db1c8142107da9$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $45db1c8142107da9$export$48b382180baf8e88(json) {
    const sanitizedJSON = (0, $l1C1k.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $hRZSy.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($45db1c8142107da9$var$hasNestedTable(node) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $aSk3Q.transformNestedTableNodeOutgoingDocument)(node);
        },
        tableHeader: (node)=>{
            if ($45db1c8142107da9$var$hasNestedTable(node) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $aSk3Q.transformNestedTableNodeOutgoingDocument)(node);
        },
        emoji: (0, $hRZSy.removeNonAnnotationMarks),
        mention: (0, $hRZSy.removeNonAnnotationMarks),
        date: (0, $hRZSy.removeNonAnnotationMarks),
        hardBreak: (0, $hRZSy.removeMarks),
        inlineCard: (0, $hRZSy.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("hRZSy", function(module, exports) {

$parcel$export(module.exports, "removeMarks", () => $7e7bed7752b3d3e8$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $7e7bed7752b3d3e8$export$8cae9126fc577085);
function $7e7bed7752b3d3e8$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $7e7bed7752b3d3e8$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});





parcelRegister("kDX7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bd72f6ac7c9da28$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $2bd72f6ac7c9da28$var$decisionItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $e6OIt.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `<> ${result.join('').trim()}`;
};
var $2bd72f6ac7c9da28$export$2e2bcd8739ae039 = $2bd72f6ac7c9da28$var$decisionItem;

});

parcelRegister("imMk3", function(module, exports) {

$parcel$export(module.exports, "default", () => $225150f21995c312$export$2e2bcd8739ae039);
const $225150f21995c312$var$hardBreak = ()=>{
    return '\n';
};
var $225150f21995c312$export$2e2bcd8739ae039 = $225150f21995c312$var$hardBreak;

});

parcelRegister("440xp", function(module, exports) {

$parcel$export(module.exports, "default", () => $138bcacc90088152$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $138bcacc90088152$var$heading = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $e6OIt.reduce)(n, schema));
    });
    return result.join('');
};
var $138bcacc90088152$export$2e2bcd8739ae039 = $138bcacc90088152$var$heading;

});

parcelRegister("lFEBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $624c2799ad9d8e95$export$2e2bcd8739ae039);

var $K5Jsy = parcelRequire("K5Jsy");
const $624c2799ad9d8e95$var$inlineCard = (node, schema)=>{
    return node.attrs.url || node.attrs.data?.url || (0, $K5Jsy.getText)(node);
};
var $624c2799ad9d8e95$export$2e2bcd8739ae039 = $624c2799ad9d8e95$var$inlineCard;

});

parcelRegister("htHCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a088bc6174fa44e$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $1a088bc6174fa44e$var$listItem = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $e6OIt.reduce)(n, schema));
    });
    return result.join('\n');
};
var $1a088bc6174fa44e$export$2e2bcd8739ae039 = $1a088bc6174fa44e$var$listItem;

});

parcelRegister("khjO4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e89926131a2312a$export$2e2bcd8739ae039);
const $8e89926131a2312a$var$mediaGroup = (node)=>{
    // count children which are media files
    // ignore card links
    let childMediaFilesCount = 0;
    node.content.forEach((childNode)=>{
        if (childNode.attrs.type === 'file') childMediaFilesCount += 1;
    });
    if (childMediaFilesCount) {
        const postfix = childMediaFilesCount > 1 ? 'Files' : 'File';
        return `\u{1F4CE} ${childMediaFilesCount} ${postfix}`;
    }
    return '';
};
var $8e89926131a2312a$export$2e2bcd8739ae039 = $8e89926131a2312a$var$mediaGroup;

});

parcelRegister("6e3uf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2977203c4602e2c5$export$2e2bcd8739ae039);
const $2977203c4602e2c5$var$mention = (node, schema)=>{
    if ([
        'all',
        'here'
    ].indexOf(node.attrs.id) !== -1) return `@${node.attrs.id}`;
    return `${node.attrs.text || '@unknown'}`;
};
var $2977203c4602e2c5$export$2e2bcd8739ae039 = $2977203c4602e2c5$var$mention;

});

parcelRegister("3LUJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f90d7afe39bccffc$export$2e2bcd8739ae039);

var $uTDrM = parcelRequire("uTDrM");

var $e6OIt = parcelRequire("e6OIt");
const $f90d7afe39bccffc$var$orderedList = (node, schema)=>{
    const result = [];
    const order = (0, $uTDrM.getOrderFromOrderedListNode)(node);
    node.forEach((n, _offset, index)=>{
        result.push(`${index + order}. ${(0, $e6OIt.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $f90d7afe39bccffc$export$2e2bcd8739ae039 = $f90d7afe39bccffc$var$orderedList;

});
parcelRegister("uTDrM", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", () => $ebe278356715a8a4$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $ebe278356715a8a4$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $ebe278356715a8a4$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $ebe278356715a8a4$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $ebe278356715a8a4$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $ebe278356715a8a4$export$35b2f400604e700);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $ebe278356715a8a4$export$8ef94ae42a3729bd = 1;
const $ebe278356715a8a4$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $ebe278356715a8a4$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $ebe278356715a8a4$export$d445360e2a3c026b(order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
};
const $ebe278356715a8a4$export$320582fc14ba1e0f = (options)=>{
    const order = $ebe278356715a8a4$export$d445360e2a3c026b(options.order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $ebe278356715a8a4$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $ebe278356715a8a4$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $ebe278356715a8a4$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});


parcelRegister("eAfxp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8f54e9a672bbbf1$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $e8f54e9a672bbbf1$var$panel = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $e6OIt.reduce)(n, schema));
    });
    return result.join('\n');
};
var $e8f54e9a672bbbf1$export$2e2bcd8739ae039 = $e8f54e9a672bbbf1$var$panel;

});

parcelRegister("aBdRK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bd298fed1fdb6b4$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $5bd298fed1fdb6b4$var$paragraph = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $e6OIt.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return result.join('').trim();
};
var $5bd298fed1fdb6b4$export$2e2bcd8739ae039 = $5bd298fed1fdb6b4$var$paragraph;

});

parcelRegister("hHZcb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b47562962a68bb7$export$2e2bcd8739ae039);
const $9b47562962a68bb7$var$rule = ()=>{
    return '';
};
var $9b47562962a68bb7$export$2e2bcd8739ae039 = $9b47562962a68bb7$var$rule;

});

parcelRegister("3uDza", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa78d4ec3c1edae$export$2e2bcd8739ae039);

var $K5Jsy = parcelRequire("K5Jsy");
const $ffa78d4ec3c1edae$var$status = (node, schema)=>{
    return node.attrs.text ? `[ ${node.attrs.text.toUpperCase()} ]` : (0, $K5Jsy.getText)(node);
};
var $ffa78d4ec3c1edae$export$2e2bcd8739ae039 = $ffa78d4ec3c1edae$var$status;

});

parcelRegister("jDcJt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc23c7a13259c83$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $3dc23c7a13259c83$var$table = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push($3dc23c7a13259c83$var$tableRow(n, schema));
    });
    return result.join('\n');
};
const $3dc23c7a13259c83$var$tableRow = (node, schema)=>{
    const result = [];
    const separator = '|';
    node.forEach((n)=>{
        result.push($3dc23c7a13259c83$var$tableCell(n, schema));
    });
    return `${separator}${result.join(`${separator}`)}${separator}`;
};
const $3dc23c7a13259c83$var$tableCell = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $e6OIt.reduce)(n, schema));
    });
    return result.join('\n');
};
var $3dc23c7a13259c83$export$2e2bcd8739ae039 = $3dc23c7a13259c83$var$table;

});

parcelRegister("ca29C", function(module, exports) {

$parcel$export(module.exports, "default", () => $8366ad5bb1422197$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $8366ad5bb1422197$var$taskItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    const state = node.attrs.state === 'DONE' ? '[x]' : '[]';
    node.forEach((n)=>{
        const text = (0, $e6OIt.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `${state} ${result.join('').trim()}`;
};
var $8366ad5bb1422197$export$2e2bcd8739ae039 = $8366ad5bb1422197$var$taskItem;

});

parcelRegister("70D85", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce6f7879b7465532$export$2e2bcd8739ae039);

var $K5Jsy = parcelRequire("K5Jsy");

var $e6OIt = parcelRequire("e6OIt");
const $ce6f7879b7465532$var$unknown = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $e6OIt.reduce)(n, schema));
    });
    if (result.length > 0) return result.join('');
    return (0, $K5Jsy.getText)(node);
};
var $ce6f7879b7465532$export$2e2bcd8739ae039 = $ce6f7879b7465532$var$unknown;

});





parcelRegister("gG69f", function(module, exports) {

$parcel$export(module.exports, "useLabelsValidator", () => $4bcb010f31b6b11e$export$990e7f2d0da9a96a);
$parcel$export(module.exports, "getProjectScopeLabelCheckboxValueFromLocalStorage", () => $4bcb010f31b6b11e$export$6181698b046b748f);
$parcel$export(module.exports, "setProjectScopeLabelCheckboxValueFromLocalStorage", () => $4bcb010f31b6b11e$export$9e31f8fbc2feb98f);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $b59wn = parcelRequire("b59wn");
const $4bcb010f31b6b11e$export$990e7f2d0da9a96a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const change = (0, $5uXOq.useCallback)((newValues)=>{
        for(let i = newValues.length - 1; i >= 0; i -= 1){
            const { __isNew__: __isNew__, value: value } = newValues[i];
            if (__isNew__ === true) {
                if (value.includes(' ')) return {
                    type: 'error',
                    message: formatMessage((0, $b59wn.default).newLabelContainsSpacesError)
                };
                if (value.length > (0, $c62873cf9aaa3f8d$export$e85fda072a12fed9)) return {
                    type: 'error',
                    message: formatMessage((0, $b59wn.default).newLabelTooLongError, {
                        maxLength: (0, $c62873cf9aaa3f8d$export$e85fda072a12fed9)
                    })
                };
            }
        }
        if (newValues.length > (0, $c62873cf9aaa3f8d$export$45f4d7adca48db10)) return {
            type: 'warning',
            message: formatMessage((0, $b59wn.default).maximumNumberOfLabelsExceededError, {
                maxNumberOfLabels: (0, $c62873cf9aaa3f8d$export$45f4d7adca48db10)
            })
        };
        return null;
    }, [
        formatMessage
    ]);
    return {
        change: change
    };
};
const $4bcb010f31b6b11e$export$f04a317778b8db56 = 'restrict_labels_to_projects_checkbox_value';
const $4bcb010f31b6b11e$export$b19885560047617b = (0, $bSSG7.createLocalStorageProvider)('project-scoped-labels');
const $4bcb010f31b6b11e$export$6181698b046b748f = ()=>{
    if (!(0, $4R6GH.fg)('labels_restricted_to_project_experiment')) return false;
    return $4bcb010f31b6b11e$export$b19885560047617b.get($4bcb010f31b6b11e$export$f04a317778b8db56) || false;
};
const $4bcb010f31b6b11e$export$9e31f8fbc2feb98f = (value)=>{
    return $4bcb010f31b6b11e$export$b19885560047617b.set($4bcb010f31b6b11e$export$f04a317778b8db56, value);
};

});
const $c62873cf9aaa3f8d$export$45f4d7adca48db10 = 55;
const $c62873cf9aaa3f8d$export$e85fda072a12fed9 = 255;

parcelRegister("b59wn", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cbf37cea727db27$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6cbf37cea727db27$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "issue-field-labels-inline-edit-view-full.labels.error-title",
        "defaultMessage": "We couldn't set the labels value"
    },
    errorMessage: {
        "id": "issue-field-labels-inline-edit-view-full.labels.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    noValueText: {
        "id": "issue-field-labels-inline-edit-view-full.labels.no-value-text",
        "defaultMessage": "None"
    },
    newLabelTooLongError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.new-label-too-long-error",
        "defaultMessage": "Labels can't be more than {maxLength} characters."
    },
    newLabelContainsSpacesError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.new-label-contains-spaces-error",
        "defaultMessage": "Labels can't have spaces."
    },
    maximumNumberOfLabelsExceededError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.maximum-number-of-labels-exceeded-error",
        "defaultMessage": "Can't have more than {maxNumberOfLabels} labels."
    }
});

});



parcelRegister("5GnJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $26cedbcf21b5127e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $26cedbcf21b5127e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.labels.trigger-button",
        "defaultMessage": "See more labels"
    }
});

});


parcelRegister("lExf8", function(module, exports) {

$parcel$export(module.exports, "MultiSelectCell", () => $8a83752c6ecc953a$export$4ae427e87d8482e2);

var $ikJ0H = parcelRequire("ikJ0H");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $hDEIr = parcelRequire("hDEIr");

var $jFYC8 = parcelRequire("jFYC8");

var $Br57E = parcelRequire("Br57E");

var $e9M6d = parcelRequire("e9M6d");
const $8a83752c6ecc953a$export$4ae427e87d8482e2 = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $ikJ0H.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDEIr.MultiSelectInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
};

});
parcelRegister("ikJ0H", function(module, exports) {

$parcel$export(module.exports, "default", () => $b272682962fc94a4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<35bf3f97067093f7601e1f59825819c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b272682962fc94a4$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "multiSelect_nativeIssueTable_MultiSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleSelectField"
};
$b272682962fc94a4$var$node.hash = "b76efba9f73e137476cc5523a3ecf23a";
var $b272682962fc94a4$export$2e2bcd8739ae039 = $b272682962fc94a4$var$node;

});

parcelRegister("hDEIr", function(module, exports) {

$parcel$export(module.exports, "MultiSelectInlineEditViewWithIsEditable", () => $bea12b7425afe437$export$2dcdfc567a992efd);

var $g1ySA = parcelRequire("g1ySA");

var $w3TGg = parcelRequire("w3TGg");

var $8xSLF = parcelRequire("8xSLF");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $l4Dsg = parcelRequire("l4Dsg");

var $8tUfk = parcelRequire("8tUfk");

var $jrRyX = parcelRequire("jrRyX");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $bea12b7425afe437$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.id));
    return b.every((option)=>aIdSet.has(option.id));
};
const $bea12b7425afe437$export$2dcdfc567a992efd = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $8xSLF.default), fragmentRef);
    const [commit] = (0, $8Uumt.useMutation)((0, $w3TGg.default));
    // #endregion Relay
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedOptions: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $5uXOq.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                id: edge?.node?.id ?? '',
                optionId: edge?.node?.optionId ?? '',
                value: edge?.node?.value ?? '',
                selectableLabel: edge?.node?.value ?? '',
                selectableGroupKey: null,
                selectableIconUrl: null
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable, overrideFieldOptionsFilter: overrideFieldOptionsFilter } = overriding;
    const fieldName = (0, $5uXOq.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const filterOptionsById = (0, $5uXOq.useMemo)(()=>overrideFieldOptionsFilter(null), [
        overrideFieldOptionsFilter
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $5uXOq.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleSelectField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedOptions: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.id ?? '',
                                            value: edge.selectableLabel ?? '',
                                            optionId: edge.optionId ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $bea12b7425afe437$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiSelect'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tUfk.MultiSelectReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover
        }), [
        data,
        isTruncated,
        isTruncatedWithHoverPopover
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            filterOptionsById: filterOptionsById,
            openMenuOnFocus: true,
            spacing: spacing
        });
    // #endregion Edit view
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $l4Dsg.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $bea12b7425afe437$export$9d754a44e976e46a = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $g1ySA.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bea12b7425afe437$export$2dcdfc567a992efd, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("g1ySA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a870f2fc2145170a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c8784dc5c6cf0181fba42792ac91445>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a870f2fc2145170a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectField"
};
$a870f2fc2145170a$var$node.hash = "d32e2ded197d2b2b4bc30729f9587a62";
var $a870f2fc2145170a$export$2e2bcd8739ae039 = $a870f2fc2145170a$var$node;

});

parcelRegister("w3TGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $517da199884e4a30$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab89800218576513b704c68f8ce1ac28>>
 * @relayHash b4af6905e862873a8846fa4a71f56a57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12ff733a258befd165b334ced2a9a4ad512afe20c3502276964dc077438a292d
const $517da199884e4a30$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiSelect_issueFieldMultiSelect_MultiSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiSelect_issueFieldMultiSelect_MultiSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optionId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "12ff733a258befd165b334ced2a9a4ad512afe20c3502276964dc077438a292d",
            "metadata": {},
            "name": "multiSelect_issueFieldMultiSelect_MultiSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$517da199884e4a30$var$node.hash = "cb08d7ecaba6a03f3f00edae8eb1b5a3";
var $517da199884e4a30$export$2e2bcd8739ae039 = $517da199884e4a30$var$node;

});

parcelRegister("8xSLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae5976400fe90e32$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<357beb53165a8a4df485e730345c9792>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ae5976400fe90e32$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "multiSelect_issueFieldMultiSelectReadviewFull_MultiSelectReadView"
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleSelectField"
    };
}();
$ae5976400fe90e32$var$node.hash = "51442265271466c01819bfe490c82976";
var $ae5976400fe90e32$export$2e2bcd8739ae039 = $ae5976400fe90e32$var$node;

});

parcelRegister("l4Dsg", function(module, exports) {

$parcel$export(module.exports, "default", () => $05a5d31e0b23d13e$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $05a5d31e0b23d13e$var$MultiSelectEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("4vvmD")), {
        moduleId: "f60cd571"
    }),
    getPreloadProps: ()=>({})
});
var $05a5d31e0b23d13e$export$2e2bcd8739ae039 = $05a5d31e0b23d13e$var$MultiSelectEditViewEntryPoint;

});
parcelRegister("4vvmD", function(module, exports) {

let $348262ee0e992570$var$load = (parcelRequire("28QjX"))(4);
module.exports = $348262ee0e992570$var$load("keP0k").then(()=>parcelRequire('ix1Mi'));

});


parcelRegister("8tUfk", function(module, exports) {

$parcel$export(module.exports, "MultiSelectReadView", () => $4191f07910bb7917$export$ecebbf80cc7a07f1);

var $lpKGA = parcelRequire("lpKGA");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $eZibI = parcelRequire("eZibI");

var $lpRLe = parcelRequire("lpRLe");

var $l8IoT = parcelRequire("l8IoT");

var $2bYmU = parcelRequire("2bYmU");

var $8IXo8 = parcelRequire("8IXo8");
const $4191f07910bb7917$export$ecebbf80cc7a07f1 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $lpKGA.default), fragmentRef);
    const transformedSelectedOptions = (0, $5uXOq.useMemo)(()=>{
        if (!data?.selectedOptions?.edges) return null;
        const selectedOptions = data.selectedOptions.edges.map((edge)=>edge?.node).filter((node)=>Boolean(node?.value));
        return selectedOptions.map((node)=>({
                key: node.id,
                name: node.value,
                color: null,
                isInteractive: false
            }));
    }, [
        data?.selectedOptions?.edges
    ]);
    if (!transformedSelectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        role: "group",
        xcss: isTruncatedWithHoverPopover && $4191f07910bb7917$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bYmU.default), {
        items: transformedSelectedOptions,
        ItemComponent: isTruncatedWithHoverPopover ? (0, $l8IoT.TagItem) : (0, $lpRLe.OptionTag),
        PopupContentWrapper: (0, $l8IoT.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $8IXo8.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        role: "group",
        shouldWrap: true
    }, transformedSelectedOptions.map(({ key: key, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
            key: key,
            ...restProps
        })));
};
const $4191f07910bb7917$var$inlineStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});
parcelRegister("lpKGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b00c8ca978a6427$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<24f8ea29f5b0a9e715aebdeec184bd0b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4b00c8ca978a6427$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiSelect_issueFieldMultiSelectReadviewFull_MultiSelectReadView",
    "selections": [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectField"
};
$4b00c8ca978a6427$var$node.hash = "30f1fb233423b8843508f947cb7c3c09";
var $4b00c8ca978a6427$export$2e2bcd8739ae039 = $4b00c8ca978a6427$var$node;

});

parcelRegister("lpRLe", function(module, exports) {

$parcel$export(module.exports, "OptionTag", () => $7e21718d85b37a90$export$5991b62d89f5cc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $ek97b = parcelRequire("ek97b");
const $7e21718d85b37a90$export$5991b62d89f5cc = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ name: name, color: color, isInteractive: isInteractive = true, showTooltip: showTooltip = false }, ref)=>{
    const { backgroundColor: tagColor } = (0, $ek97b.getColorMetadata)(color);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $7e21718d85b37a90$var$tagWrapperStyles,
            isInteractive && $7e21718d85b37a90$var$interactiveStyles
        ],
        "aria-label": name,
        testId: "option-color-picker.option-tag.field-tag-wrapper",
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e21718d85b37a90$var$StyledTag, {
        "data-testid": `option-color-picker.option-tag.${color || 'default'}`,
        color: tagColor
    }, name));
    return showTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: name
    }, content) : content;
}));
const $7e21718d85b37a90$var$tagWrapperStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    justifyContent: 'left',
    alignItems: 'center',
    transition: '0.3s',
    maxWidth: '100%',
    minWidth: '0',
    minHeight: '0',
    color: 'color.text'
});
const $7e21718d85b37a90$var$interactiveStyles = (0, $8CUq3.xcss)({
    ':hover': {
        cursor: 'pointer'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e21718d85b37a90$var$StyledTagBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1reo15vq _18m915vq _vwz4f6fq _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $7e21718d85b37a90$var$StyledTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $7e21718d85b37a90$var$StyledTagBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $lD23V.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko5n0m _19it11we _bfhk18uv _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8IXo8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ada9d80e0fe75362$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ada9d80e0fe75362$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-multi-select-readview-full.multi-select.compact.show-more-tooltip",
        "defaultMessage": "See more selected options"
    }
});

});




parcelRegister("dM1CQ", function(module, exports) {

$parcel$export(module.exports, "MultiUserPickerCell", () => $6f61ce7d7c7a4cce$export$900adf2a2bd19e48);

var $6U2bD = parcelRequire("6U2bD");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2JguU = parcelRequire("2JguU");

var $jFYC8 = parcelRequire("jFYC8");

var $Br57E = parcelRequire("Br57E");

var $e9M6d = parcelRequire("e9M6d");
const $6f61ce7d7c7a4cce$export$900adf2a2bd19e48 = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $6U2bD.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JguU.MultiUserPickerInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true
    });
};

});
parcelRegister("6U2bD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4b632dec7b81585$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d4dc2f91c60665fe027d57b6a9920fbb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c4b632dec7b81585$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "multiUserPicker_nativeIssueTable_MultiUserPickerCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleSelectUserPickerField"
};
$c4b632dec7b81585$var$node.hash = "6a94b62d1ee5b9d8e348b0b01dee08ff";
var $c4b632dec7b81585$export$2e2bcd8739ae039 = $c4b632dec7b81585$var$node;

});

parcelRegister("2JguU", function(module, exports) {

$parcel$export(module.exports, "MultiUserPickerInlineEditViewWithIsEditable", () => $fb9433fec991f7fe$export$2d98458340508c60);

var $b2p9C = parcelRequire("b2p9C");

var $8QkHX = parcelRequire("8QkHX");

var $ffsAj = parcelRequire("ffsAj");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $4mbgU = parcelRequire("4mbgU");

var $9mHqw = parcelRequire("9mHqw");

var $2lJZq = parcelRequire("2lJZq");

var $jrRyX = parcelRequire("jrRyX");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $fb9433fec991f7fe$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.id));
    return b.every((option)=>aIdSet.has(option.id));
};
const $fb9433fec991f7fe$export$2d98458340508c60 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact' })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $ffsAj.default), fragmentRef);
    const [commit] = (0, $8Uumt.useMutation)((0, $8QkHX.default));
    // #endregion
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedUsersConnection: selectedUsersConnection, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $5uXOq.useMemo)(()=>{
        if (!selectedUsersConnection?.edges) return null;
        return selectedUsersConnection?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
    }, [
        selectedUsersConnection?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $5uXOq.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $5uXOq.useCallback)((users, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(users);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: users?.map((user)=>user.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleSelectUserPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedUsersConnection: {
                                edges: users?.map((user)=>({
                                        node: {
                                            __typename: 'AtlassianAccountUser',
                                            ...user
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $fb9433fec991f7fe$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiUserPicker'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2lJZq.MultiUserPickerReadView), {
            fragmentRef: data
        }), [
        data
    ]);
    // #endregion
    // #region Edit view
    const transformedEditViewValue = (0, $5uXOq.useMemo)(()=>{
        if (!updatedValue) return null;
        return updatedValue.map((0, $4mbgU.transformAggToUserOption));
    }, [
        updatedValue
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            value: transformedEditViewValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            spacing: spacing
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $9mHqw.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $fb9433fec991f7fe$export$117723181a3f3b6b = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $b2p9C.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fb9433fec991f7fe$export$2d98458340508c60, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("b2p9C", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fab0f790bd2a34f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c4638e38e1d56970af022bce2a6a8dc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4fab0f790bd2a34f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectUserPickerField"
};
$4fab0f790bd2a34f$var$node.hash = "cce81be96601eacce28b3398c7aff2e6";
var $4fab0f790bd2a34f$export$2e2bcd8739ae039 = $4fab0f790bd2a34f$var$node;

});

parcelRegister("8QkHX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbb916a363be4181$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<66cd6416b55761810bcabaeaa23726f8>>
 * @relayHash c8257d74afaa8e2a4de1b61f4752e171
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71c4e49904469f656bf1a9edb542eb4f4a559d8a265dd802b3e7ae36a1a084cb
const $dbb916a363be4181$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraUserConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedUsersConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraUserEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountId"
                                                                },
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "picture"
                                                                },
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountStatus"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "email"
                                                                        }
                                                                    ],
                                                                    "type": "AtlassianAccountUser"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71c4e49904469f656bf1a9edb542eb4f4a559d8a265dd802b3e7ae36a1a084cb",
            "metadata": {},
            "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$dbb916a363be4181$var$node.hash = "66516ecfc9f74fa693150553eb2bae7f";
var $dbb916a363be4181$export$2e2bcd8739ae039 = $dbb916a363be4181$var$node;

});

parcelRegister("ffsAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ae98c54e1dbb9e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<87c2e0fc25d3c82a0a376ce7418f273f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ae98c54e1dbb9e0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "multiUserPicker_issueFieldMultiUserPickerReadviewFull_MultiUserPickerReadView"
            },
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "selectedUsersConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountStatus"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "email"
                                            }
                                        ],
                                        "type": "AtlassianAccountUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleSelectUserPickerField"
    };
}();
$6ae98c54e1dbb9e0$var$node.hash = "b0466005c00a3d3242fa4c867100b929";
var $6ae98c54e1dbb9e0$export$2e2bcd8739ae039 = $6ae98c54e1dbb9e0$var$node;

});

parcelRegister("4mbgU", function(module, exports) {

$parcel$export(module.exports, "transformAggToUserOption", () => $89d054e3cf2bcd18$export$e466b9791a3fee63);
const $89d054e3cf2bcd18$export$e466b9791a3fee63 = (user)=>({
        avatarUrl: user.picture,
        id: user.id,
        accountId: user.accountId,
        name: user.name,
        active: user.accountStatus === 'active',
        byline: user.email ?? undefined
    });

});

parcelRegister("9mHqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $321e77a3782d1b61$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $321e77a3782d1b61$var$MultiUserPickerEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("1tc1q")), {
        moduleId: "d8224b35"
    }),
    getPreloadProps: ()=>({})
});
var $321e77a3782d1b61$export$2e2bcd8739ae039 = $321e77a3782d1b61$var$MultiUserPickerEditViewEntryPoint;

});
parcelRegister("1tc1q", function(module, exports) {

let $1121d3328230fa4b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1121d3328230fa4b$var$load("jP2nA").then(()=>parcelRequire('eb65P'));

});


parcelRegister("2lJZq", function(module, exports) {

$parcel$export(module.exports, "MultiUserPickerReadView", () => $a9868ceabc60e141$export$183c102b43ea6c63);

var $2X7vp = parcelRequire("2X7vp");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jnhNB = parcelRequire("jnhNB");

var $eZibI = parcelRequire("eZibI");
const $a9868ceabc60e141$export$183c102b43ea6c63 = ({ fragmentRef: fragmentRef })=>{
    const { selectedUsersConnection: selectedUsersConnection } = (0, $8Uumt.useFragment)((0, $2X7vp.default), fragmentRef);
    const transformedData = (0, $5uXOq.useMemo)(()=>{
        const filteredEdges = selectedUsersConnection?.edges?.filter((edge)=>Boolean(edge?.node)) ?? [];
        return filteredEdges.map((edge)=>({
                name: edge.node.name,
                key: edge.node.accountId,
                src: edge.node.picture
            }));
    }, [
        selectedUsersConnection?.edges
    ]);
    if (transformedData.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jnhNB.default), {
        data: transformedData,
        size: "small"
    });
};

});
parcelRegister("2X7vp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a04f45ca547f637$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f931ef21191ed67113fe4de202f1f6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1a04f45ca547f637$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiUserPicker_issueFieldMultiUserPickerReadviewFull_MultiUserPickerReadView",
    "selections": [
        {
            "concreteType": "JiraUserConnection",
            "kind": "LinkedField",
            "name": "selectedUsersConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectUserPickerField"
};
$1a04f45ca547f637$var$node.hash = "9a92e933723ed56c13d8c6b22c70828b";
var $1a04f45ca547f637$export$2e2bcd8739ae039 = $1a04f45ca547f637$var$node;

});




parcelRegister("dCYi9", function(module, exports) {

$parcel$export(module.exports, "ConfluencePagesCell", () => $9f2cf02a7385bc79$export$486bd1bbeaa77e1b);

var $31DtL = parcelRequire("31DtL");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $rWFkZ = parcelRequire("rWFkZ");

var $4R6GH = parcelRequire("4R6GH");

var $jFYC8 = parcelRequire("jFYC8");

var $Br57E = parcelRequire("Br57E");

var $e9M6d = parcelRequire("e9M6d");
const $9f2cf02a7385bc79$export$486bd1bbeaa77e1b = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $31DtL.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled && (0, $4R6GH.fg)('jsc_confluence_pages_inline_edit') ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const shouldTruncate = (0, $e9M6d.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $rWFkZ.ConfluencePagesInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        isTruncated: shouldTruncate,
        menuPosition: "fixed",
        readViewFitContainerHeight: true
    });
};

});
parcelRegister("31DtL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e39ebf3bac07221$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f9be0af5fe3d8171a37c5def43a971c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e39ebf3bac07221$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "confluencePages_nativeIssueTable_ConfluencePagesCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraConfluenceRemoteIssueLinksField"
};
$3e39ebf3bac07221$var$node.hash = "0ec3d60cde87b4245ca941ac347b32b8";
var $3e39ebf3bac07221$export$2e2bcd8739ae039 = $3e39ebf3bac07221$var$node;

});

parcelRegister("rWFkZ", function(module, exports) {

$parcel$export(module.exports, "ConfluencePagesInlineEditViewWithIsEditable", () => $8c245a610f4d1d7d$export$efa01917dd201830);

var $laj48 = parcelRequire("laj48");

var $dPkvB = parcelRequire("dPkvB");

var $jKTHn = parcelRequire("jKTHn");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7Jxgt = parcelRequire("7Jxgt");

var $lXLX3 = parcelRequire("lXLX3");

var $7F8HM = parcelRequire("7F8HM");

var $f5VRv = parcelRequire("f5VRv");

var $7VNWx = parcelRequire("7VNWx");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $8c245a610f4d1d7d$var$isEqualOption = (a, b)=>{
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.url));
    return b.every((option)=>aIdSet.has(option.url));
};
const $8c245a610f4d1d7d$export$efa01917dd201830 = ({ editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncated: isTruncated })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $jKTHn.default), fragmentRef);
    const [commit] = (0, $8Uumt.useMutation)((0, $dPkvB.default));
    // #endregion
    // #region Common state
    const { id: uniqueFieldId, name: fieldName, type: fieldType, confluenceRemoteIssueLinks: confluenceRemoteIssueLinks } = data;
    const initialValue = (0, $5uXOq.useMemo)(()=>confluenceRemoteIssueLinks?.edges?.map((edge)=>edge?.node).filter(Boolean).map((node)=>({
                id: node.id,
                url: node.href ?? ''
            })) ?? [], [
        confluenceRemoteIssueLinks
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const handleSubmit = (0, $5uXOq.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            // Retain the ID of existing linked pages and use the URL for new links to add.
                            links: value.map(({ id: id, url: url })=>id ? {
                                    id: id
                                } : {
                                    href: url
                                }),
                            operation: 'SET'
                        }
                    ]
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateConfluenceRemoteIssueLinksField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateConfluenceRemoteIssueLinksField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            confluenceRemoteIssueLinks: {
                                totalCount: value.length,
                                edges: value.map((option)=>({
                                        node: {
                                            id: option.id ?? (0, $7Jxgt.v4)(),
                                            href: option.url
                                        }
                                    }))
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $7F8HM.useFieldInlineEditActions)({
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $8c245a610f4d1d7d$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue
    });
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VNWx.ConfluencePagesReadView), {
            isTruncated: isTruncated,
            fragmentRef: data
        });
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            initialIsOpen: true,
            value: updatedValue,
            menuPosition: menuPosition,
            onChange: handleChange,
            spacing: spacing
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $f5VRv.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hasReadViewTruncateDisabled: isTruncated,
        hideActionButtons: true
    });
};
const $8c245a610f4d1d7d$export$f4b4c94c27bd1239 = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $laj48.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8c245a610f4d1d7d$export$efa01917dd201830, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("laj48", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ec79d818f301363$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<af30466501d29bf9367df09283f83219>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0ec79d818f301363$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraConfluenceRemoteIssueLinksField"
};
$0ec79d818f301363$var$node.hash = "b82ba55e135c40c22b29327df36827d2";
var $0ec79d818f301363$export$2e2bcd8739ae039 = $0ec79d818f301363$var$node;

});

parcelRegister("dPkvB", function(module, exports) {

$parcel$export(module.exports, "default", () => $22b61ce9d6344e24$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<46f34e0dbaff7a790931598d5eb80697>>
 * @relayHash 71362fb7aaa6d0429d2aed33d89eb4ee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9675e340b6bb104d22e83d06403274891cc1b875c55fa638ac9c04906108c4f9
const $22b61ce9d6344e24$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraConfluenceRemoteIssueLink",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "href"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateConfluenceRemoteIssueLinksFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateConfluenceRemoteIssueLinksField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraConfluenceRemoteIssueLinksField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView"
                                        },
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                            "kind": "LinkedField",
                                            "name": "confluenceRemoteIssueLinks",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateConfluenceRemoteIssueLinksFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateConfluenceRemoteIssueLinksField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraConfluenceRemoteIssueLinksField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                            "kind": "LinkedField",
                                            "name": "confluenceRemoteIssueLinks",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                }
                                            ],
                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9675e340b6bb104d22e83d06403274891cc1b875c55fa638ac9c04906108c4f9",
            "metadata": {},
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$22b61ce9d6344e24$var$node.hash = "a9a457b54100bc9a68a78acaa2bbf10f";
var $22b61ce9d6344e24$export$2e2bcd8739ae039 = $22b61ce9d6344e24$var$node;

});

parcelRegister("jKTHn", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd9a5dd33f9ee926$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<16818de4fc298571f8a5370d99c1798e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dd9a5dd33f9ee926$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "href"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            }
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    };
}();
$dd9a5dd33f9ee926$var$node.hash = "0f9e69e7f6f14ef254011afc14f3f8bc";
var $dd9a5dd33f9ee926$export$2e2bcd8739ae039 = $dd9a5dd33f9ee926$var$node;

});

parcelRegister("f5VRv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bd23225af8ce16c$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $6bd23225af8ce16c$var$ConfluencePagesEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("hGGDr")), {
        moduleId: "7aa734f7"
    }),
    getPreloadProps: ()=>({})
});
var $6bd23225af8ce16c$export$2e2bcd8739ae039 = $6bd23225af8ce16c$var$ConfluencePagesEditViewEntryPoint;

});
parcelRegister("hGGDr", function(module, exports) {

let $ce076e619824b563$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ce076e619824b563$var$load("ffQaD"),
    $ce076e619824b563$var$load("kvRbA"),
    $ce076e619824b563$var$load("bw1s0")
]).then(()=>parcelRequire('5s88v'));

});


parcelRegister("7VNWx", function(module, exports) {

$parcel$export(module.exports, "ConfluencePagesReadView", () => $d4374f42bda985b8$export$10de55138ce5421b);

var $hKJGE = parcelRequire("hKJGE");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3Dy3s = parcelRequire("3Dy3s");

var $koVbs = parcelRequire("koVbs");

var $8qImc = parcelRequire("8qImc");

var $lE6ur = parcelRequire("lE6ur");

var $jVxIG = parcelRequire("jVxIG");
const $d4374f42bda985b8$export$10de55138ce5421b = ({ fragmentRef: fragmentRef, isTruncated: isTruncated = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { confluenceRemoteIssueLinks: confluenceRemoteIssueLinks } = (0, $8Uumt.useFragment)((0, $hKJGE.default), fragmentRef);
    const totalCount = confluenceRemoteIssueLinks?.totalCount ?? 0;
    const node = confluenceRemoteIssueLinks?.edges?.[0]?.node;
    const popupContentProps = (0, $5uXOq.useMemo)(()=>confluenceRemoteIssueLinks ? {
            fragmentRef: confluenceRemoteIssueLinks
        } : null, [
        confluenceRemoteIssueLinks
    ]);
    if (!popupContentProps || !node || totalCount === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Dy3s.ItemWithEntryPointPopup), {
        ItemComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8qImc.SimpleInlineSmartLink), {
            anchorTarget: "_blank",
            url: node.href ?? ''
        }),
        totalItems: Math.min(totalCount, 1000),
        entryPoint: (0, $lE6ur.confluencePagesPopupContentEntryPoint),
        entryPointParams: {},
        entryPointRuntimeProps: popupContentProps,
        showMoreTooltip: formatMessage((0, $jVxIG.default).showMore),
        actionSubjectIdPrefix: "confluencePages",
        isTruncated: isTruncated
    });
};

});
parcelRegister("hKJGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f32cc6ee1414433$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c91a79ca0472abe266a7e6cd7908dc4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2f32cc6ee1414433$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
            "kind": "LinkedField",
            "name": "confluenceRemoteIssueLinks",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "popupContent_issueFieldConfluencePagesReadviewFull"
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                {
                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraConfluenceRemoteIssueLink",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "href"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
        }
    ],
    "type": "JiraConfluenceRemoteIssueLinksField"
};
$2f32cc6ee1414433$var$node.hash = "9339f5dfa3bce053620f77695601921b";
var $2f32cc6ee1414433$export$2e2bcd8739ae039 = $2f32cc6ee1414433$var$node;

});

parcelRegister("lE6ur", function(module, exports) {

$parcel$export(module.exports, "confluencePagesPopupContentEntryPoint", () => $574c3e33403a4298$export$a98f421071b5b6ae);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $574c3e33403a4298$export$a98f421071b5b6ae = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("fVtkQ")), {
        moduleId: "5019f0bb"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fVtkQ", function(module, exports) {

let $b982ef4432297605$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b982ef4432297605$var$load("5a3mm").then(()=>parcelRequire('4jimO'));

});


parcelRegister("jVxIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad689c0931c385e7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ad689c0931c385e7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showMore: {
        "id": "confluence-pages-readview-full.ui.confluence-pages.show-more",
        "defaultMessage": "Show more"
    }
});

});




parcelRegister("8L8tK", function(module, exports) {

$parcel$export(module.exports, "NumberCell", () => $90a909c1d48a5c5d$export$da27302eef6199ea);

var $4J5n5 = parcelRequire("4J5n5");

var $2hNwm = parcelRequire("2hNwm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");

var $4PQMu = parcelRequire("4PQMu");

var $1zq75 = parcelRequire("1zq75");

var $4R6GH = parcelRequire("4R6GH");

var $65VLO = parcelRequire("65VLO");

var $k6gB1 = parcelRequire("k6gB1");

var $jFYC8 = parcelRequire("jFYC8");

var $Br57E = parcelRequire("Br57E");

var $e9M6d = parcelRequire("e9M6d");
const $90a909c1d48a5c5d$export$da27302eef6199ea = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $2hNwm.default), fieldRef);
    const isSingleRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    if (data.isStoryPointField || data.type === (0, $65VLO.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6gB1.StoryPointEstimateCell), {
        fieldRef: data,
        shouldRenderHoverPopover: isSingleRowHeightEnabled
    });
    return (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($90a909c1d48a5c5d$var$NumberInlineEditCell, {
        fieldRef: data,
        isSingleRowHeightEnabled: isSingleRowHeightEnabled,
        isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.050",
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4PQMu.NumberReadView), {
        fragmentRef: data,
        isSingleRowHeightEnabled: isSingleRowHeightEnabled
    }));
});
const $90a909c1d48a5c5d$var$NumberInlineEditCell = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, isSingleRowHeightEnabled: isSingleRowHeightEnabled, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $4J5n5.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1zq75.NumberInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        readViewFitContainerHeight: true,
        isSingleRowHeightEnabled: isSingleRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
});

});
parcelRegister("4J5n5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef0db19f7dbc3175$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ebb1fbf47d4719bad13771f2800b5f8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ef0db19f7dbc3175$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "number_nativeIssueTable_NumberInlineEditCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraNumberField"
};
$ef0db19f7dbc3175$var$node.hash = "8c280da2215ac59fe486945cc9e551a9";
var $ef0db19f7dbc3175$export$2e2bcd8739ae039 = $ef0db19f7dbc3175$var$node;

});

parcelRegister("2hNwm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7972cf251230728d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<17e7b3bb588145775d0b366cc52edffd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7972cf251230728d$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "number_nativeIssueTable_NumberCell_fieldRef",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "number_issueFieldNumberReadviewFull_NumberReadView"
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": v0 /*: any*/ ,
                        "kind": "FragmentSpread",
                        "name": "number_nativeIssueTable_NumberInlineEditCell_fieldRef"
                    }
                ]
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "storyPointEstimate_nativeIssueTable_StoryPointEstimateCell"
            }
        ],
        "type": "JiraNumberField"
    };
}();
$7972cf251230728d$var$node.hash = "a39feb75905be7bc84dc70d725916c5e";
var $7972cf251230728d$export$2e2bcd8739ae039 = $7972cf251230728d$var$node;

});

parcelRegister("4PQMu", function(module, exports) {

$parcel$export(module.exports, "NumberReadView", () => $3459fbb821c39146$export$9267d0b69e52e344);

var $7ag6O = parcelRequire("7ag6O");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dS3PR = parcelRequire("dS3PR");

var $7mPT9 = parcelRequire("7mPT9");

var $koVbs = parcelRequire("koVbs");

var $DVljb = parcelRequire("DVljb");

var $eZibI = parcelRequire("eZibI");

var $dpHMc = parcelRequire("dpHMc");

var $6nAWD = parcelRequire("6nAWD");

var $iv6X1 = parcelRequire("iv6X1");

var $4R6GH = parcelRequire("4R6GH");

var $46rDV = parcelRequire("46rDV");
const $3459fbb821c39146$export$9267d0b69e52e344 = ({ fragmentRef: fragmentRef, isSingleRowHeightEnabled: isSingleRowHeightEnabled = false })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $koVbs.default)();
    const noValueTextExperiment = formatMessage((0, $46rDV.default).noValueTextExperiment);
    const contentRef = (0, $5uXOq.useRef)(null);
    const locale = (0, $DVljb.useLocale)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    const fieldData = (0, $8Uumt.useFragment)((0, $7ag6O.default), fragmentRef);
    const { number: number, formatConfig: formatConfig } = fieldData;
    const children = // eslint-disable-next-line no-nested-ternary
    number === null || number === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    }) : formatConfig && formatConfig.formatStyle && (0, $4R6GH.fg)('frontier-currency-field-d1') ? (0, $6nAWD.formatNumberField)(number ?? 0, {
        formatStyle: formatConfig.formatStyle,
        formatUnit: formatConfig.formatUnit,
        locale: locale
    }) : formatNumber(number);
    if (isSingleRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: formatNumber(number ?? 0),
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            testId: "issue-field-number-readview-full.ui.number.text",
            ref: (0, $7mPT9.mergeRefs)(contentRef, ref),
            maxLines: 1
        }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": "issue-field-number-readview-full.ui.number.span"
    }, children);
};

});
parcelRegister("7ag6O", function(module, exports) {

$parcel$export(module.exports, "default", () => $c00ae6e8c6124320$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1a43ae805d43dbbe4d3a865aa6354c27>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c00ae6e8c6124320$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "number_issueFieldNumberReadviewFull_NumberReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraNumberFieldFormatConfig",
                    "kind": "LinkedField",
                    "name": "formatConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "formatStyle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "formatUnit"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$c00ae6e8c6124320$var$node.hash = "1c7d27c707db010357610ce0bf294301";
var $c00ae6e8c6124320$export$2e2bcd8739ae039 = $c00ae6e8c6124320$var$node;

});

parcelRegister("6nAWD", function(module, exports) {

$parcel$export(module.exports, "formatNumberField", () => $9b0426e4b7a06da2$export$d390e3b8d1c21e01);

/**
 * This is due to Jira commonly using the POSIX format (using '_' for defining locales),
 * such as in jira/src/packages/platform/utils/constants/src/supported-locales.tsx,
 * whereas the Intl Javascript API requires locales to be in the IETF BCP 47 format.
 */ const $9b0426e4b7a06da2$var$coerceBCPLocaleFormat = (locale)=>{
    return locale.replace('_', '-');
};
// Converts strings to lower case while also preventing string literal types from being converted
// into the more general `string` type as the String.prototype.toLowerCase() method always returns
// a `string` type, even if the string is a string literal. For example:
// const string = 'CONSTANT'; // type is `'CONSTANT'`;
// string.toLowerCase() // returned type is `string`;
// toLowerCase(string) // returned type is `'constant'`;
const $9b0426e4b7a06da2$var$toLowerCase = (inputString)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return inputString.toLocaleLowerCase();
};
const $9b0426e4b7a06da2$var$isSupportedCurrencyCode = (currencyCode)=>{
    // Check if the currency code is supported
    return Intl.supportedValuesOf($9b0426e4b7a06da2$var$toLowerCase((0, $ef69814f8c2ef982$export$a82896da99871ba4))).includes(currencyCode);
};
const $9b0426e4b7a06da2$var$isSupportedUnit = (unit)=>{
    // Check if the unit is supported
    return Intl.supportedValuesOf($9b0426e4b7a06da2$var$toLowerCase((0, $ef69814f8c2ef982$export$83551de9ca24925e))).includes(unit);
};
const $9b0426e4b7a06da2$export$3dc27271f5d5c629 = (amount, config = {})=>{
    const { currencyCode: currencyCode = (0, $ef69814f8c2ef982$export$c852e1f5bb177898), locale: locale, currencyDisplay: currencyDisplay = (0, $ef69814f8c2ef982$export$b9e50a64e0ca3437), ...rest } = config;
    // Check if the currency code is supported. fall back to decimal format if not.
    const formatOptions = $9b0426e4b7a06da2$var$isSupportedCurrencyCode(currencyCode) ? {
        style: (0, $ef69814f8c2ef982$export$a82896da99871ba4).toLocaleLowerCase(),
        currency: currencyCode,
        currencyDisplay: currencyDisplay,
        ...rest
    } : {
        style: (0, $ef69814f8c2ef982$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9b0426e4b7a06da2$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(amount ?? 0);
};
const $9b0426e4b7a06da2$export$32e6b1ae352e94d6 = (amount, config = {})=>{
    const { locale: locale, ...rest } = config;
    return new Intl.NumberFormat(locale && $9b0426e4b7a06da2$var$coerceBCPLocaleFormat(locale), {
        ...rest,
        style: (0, $ef69814f8c2ef982$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: (0, $ef69814f8c2ef982$export$97f1ae291e87b4b2)
    }).format(amount ?? 0);
};
const $9b0426e4b7a06da2$export$bd39b96f71da1885 = (number, config = {})=>{
    const { unit: unit, locale: locale, ...rest } = config;
    // Check if the unit code is supported. fall back to decimal format if not.
    const formatOptions = unit && $9b0426e4b7a06da2$var$isSupportedUnit(unit) ? {
        style: (0, $ef69814f8c2ef982$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: unit,
        ...rest
    } : {
        style: (0, $ef69814f8c2ef982$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9b0426e4b7a06da2$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(number ?? 0);
};
const $9b0426e4b7a06da2$export$845857f28dc08744 = (number, config = {})=>{
    const formatter = new Intl.NumberFormat(config.locale && $9b0426e4b7a06da2$var$coerceBCPLocaleFormat(config.locale), {
        style: (0, $ef69814f8c2ef982$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...config
    });
    return formatter.format(number ?? 0);
};
const $9b0426e4b7a06da2$export$d390e3b8d1c21e01 = (number, config = {
    formatStyle: (0, $ef69814f8c2ef982$export$768e3e8e60d01cea)
})=>{
    const { formatStyle: formatStyle, formatUnit: formatUnit, locale: locale } = config;
    switch(formatStyle){
        case 0, $ef69814f8c2ef982$export$a82896da99871ba4:
            return formatUnit ? $9b0426e4b7a06da2$export$3dc27271f5d5c629(number, {
                locale: locale,
                currencyCode: formatUnit
            }) : $9b0426e4b7a06da2$export$845857f28dc08744(number, {
                locale: locale
            });
        case 0, $ef69814f8c2ef982$export$e50c15d5408652a9:
            return $9b0426e4b7a06da2$export$32e6b1ae352e94d6(number, {
                locale: locale
            });
        case 0, $ef69814f8c2ef982$export$83551de9ca24925e:
            return formatUnit ? $9b0426e4b7a06da2$export$bd39b96f71da1885(number, {
                locale: locale,
                unit: formatUnit
            }) : $9b0426e4b7a06da2$export$845857f28dc08744(number, {
                locale: locale
            });
        default:
            return $9b0426e4b7a06da2$export$845857f28dc08744(number);
    }
};

});
const $ef69814f8c2ef982$export$c852e1f5bb177898 = 'USD';
const $ef69814f8c2ef982$export$b9e50a64e0ca3437 = 'narrowSymbol';
const $ef69814f8c2ef982$export$768e3e8e60d01cea = 'DECIMAL';
const $ef69814f8c2ef982$export$a82896da99871ba4 = 'CURRENCY';
const $ef69814f8c2ef982$export$e50c15d5408652a9 = 'PERCENT';
const $ef69814f8c2ef982$export$83551de9ca24925e = 'UNIT';
const $ef69814f8c2ef982$export$e0f41b79f8d902b5 = 'liter';
const $ef69814f8c2ef982$export$83a33c313ebf2c4a = 'meter';
const $ef69814f8c2ef982$export$32fca264df3a7957 = 'kilogram';
const $ef69814f8c2ef982$export$97f1ae291e87b4b2 = 'percent';


parcelRegister("46rDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9656145975350bd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c9656145975350bd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-number-readview-full.number.no-value-text-experiment",
        "defaultMessage": "Add number"
    }
});

});


parcelRegister("1zq75", function(module, exports) {

$parcel$export(module.exports, "NumberInlineEditViewWithIsEditable", () => $c6a3f3563d672f6b$export$96ce9815e2ea97b5);
$parcel$export(module.exports, "NumberInlineEditView", () => $c6a3f3563d672f6b$export$47665260b410f801);

var $fwCIW = parcelRequire("fwCIW");

var $lQTIG = parcelRequire("lQTIG");

var $h8JKK = parcelRequire("h8JKK");

var $fnnCo = parcelRequire("fnnCo");

var $j2SaK = parcelRequire("j2SaK");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $koVbs = parcelRequire("koVbs");

var $8tf7c = parcelRequire("8tf7c");

var $jrRyX = parcelRequire("jrRyX");

var $Fn2Vl = parcelRequire("Fn2Vl");

var $gGpyR = parcelRequire("gGpyR");

var $elGhN = parcelRequire("elGhN");

var $iILGz = parcelRequire("iILGz");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $cSD7y = parcelRequire("cSD7y");

var $4PQMu = parcelRequire("4PQMu");

var $adLrP = parcelRequire("adLrP");

var $8zOmE = parcelRequire("8zOmE");

var $3ySIl = parcelRequire("3ySIl");
const $c6a3f3563d672f6b$export$43034831b58d2012 = ({ fragmentRef: fragmentRef, isEditing: isEditingDefault = false, onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onEnter: onEnter, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed })=>{
    const data = (0, $8Uumt.useFragment)((0, $j2SaK.default), fragmentRef);
    const { id: uniqueFieldId, number: value, name: name } = data;
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const [commit] = (0, $8Uumt.useMutation)((0, $fnnCo.default));
    const [isEditing, setIsEditing] = (0, $adLrP.useOptionallyControlledEditingState)(isEditingDefault, uniqueFieldId);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(value);
    const isFieldEditable = overriding.overrideIsEditable(data.fieldConfig?.isEditable ?? false);
    (0, $5uXOq.useEffect)(()=>{
        if (error) setIsEditing(true);
        if (!isEditing) setUpdatedValue(value);
    }, [
        error,
        isEditing,
        value,
        setIsEditing
    ]);
    const save = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        if (updatedValue !== value) commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        number: updatedValue
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateNumberField) {
                    const { success: success, errors: responseErrors, field: field } = mutationData.jira?.updateNumberField;
                    if (success == null || success === false) {
                        if (responseErrors != null && responseErrors.length > 0) {
                            if (responseErrors[0].message && (0, $4R6GH.fg)('relay-migration-issue-fields-number')) setError(new (0, $jJZqs.ValidationError)(responseErrors[0].message != null ? responseErrors[0].message : 'Relay error encountered while updating number field'));
                            else setError(new Error(responseErrors[0].message != null ? responseErrors[0].message : 'Relay error encountered while updating number field'));
                        } else setError(new Error('Relay error encountered while updating number field'));
                    } else if (success && field != null) {
                        onSubmitSucceeded && onSubmitSucceeded(field.number);
                        setIsEditing(false);
                    }
                }
            },
            onError: (incomingError)=>{
                setError(incomingError);
                onSubmitFailed?.();
            },
            optimisticResponse: {
                jira: {
                    updateNumberField: {
                        success: true,
                        errors: [],
                        field: {
                            id: uniqueFieldId,
                            number: updatedValue != null ? updatedValue : null
                        }
                    }
                }
            },
            optimisticUpdater: ()=>{
                setIsEditing(false);
            }
        });
        else setIsEditing(false);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    }, [
        updatedValue,
        value,
        commit,
        uniqueFieldId,
        onSubmitSucceeded,
        setIsEditing,
        onSubmitFailed
    ]);
    const cancel = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        setError(null);
        setIsEditing(false);
        setUpdatedValue(value);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    }, [
        setError,
        setIsEditing,
        value
    ]);
    const onCancelRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onCancel && onCancel(analyticsEvent);
    }, [
        onCancel,
        cancel
    ]);
    const onConfirmRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        save(analyticsEvent);
        onSubmit?.(updatedValue);
    }, [
        onSubmit,
        save,
        updatedValue
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        onEdit && onEdit(analyticsEvent);
    }, [
        onEdit,
        setIsEditing
    ]);
    const onEscapeRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape && onEscape(analyticsEvent);
    }, [
        onEscape,
        cancel
    ]);
    const onEnterRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        onEnter && onEnter(analyticsEvent);
    }, [
        onEnter
    ]);
    const onChange = (0, $5uXOq.useCallback)((event)=>{
        setError(null);
        const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
        setUpdatedValue(typedValue);
    }, [
        setError,
        setUpdatedValue
    ]);
    const renderEditView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elGhN.NumberEditView), {
            label: name,
            defaultValue: updatedValue,
            isInvalid: !!error,
            onChange: onChange
        });
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Fn2Vl.ReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4PQMu.NumberReadView), {
            fragmentRef: data
        }));
    const InlineEditWrapper = isFieldEditable ? (0, $Fn2Vl.InlineEditContainer) : $c6a3f3563d672f6b$var$NumberInlineEditContainer;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tf7c.ErrorFlag), {
        description: (0, $3ySIl.default).errorMessage,
        error: error,
        title: formatMessage((0, $3ySIl.default).errorTitleWithFieldName, {
            fieldName: data.name
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InlineEditWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gGpyR.FieldInlineEditStateLess), {
        actionSubject: "numberInlineEdit",
        defaultValue: updatedValue,
        editView: renderEditView,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        readView: renderReadView,
        testId: "issue-field-number-inline-edit-full.ui.number.issue-field-number",
        fieldId: (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? uniqueFieldId : undefined,
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequested,
        onEnter: onEnterRequest,
        onEscape: onEscapeRequest
    })));
};
const $c6a3f3563d672f6b$export$96ce9815e2ea97b5 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, isSingleRowHeightEnabled: isSingleRowHeightEnabled })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $h8JKK.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, name: fieldName, type: type, number: initialValue } = data;
    const [commit] = (0, $8Uumt.useMutation)((0, $lQTIG.default)); // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const isFieldEditable = overriding.overrideIsEditable(isEditable ?? false); // #endregion
    // #region Handle new value
    const handleSubmit = (0, $5uXOq.useCallback)((newNumber, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newNumber);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        number: newNumber
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateNumberField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateNumberField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            number: newNumber
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        clipboardComponentType: 'numberNullable',
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue
    });
    const onChange = (0, $5uXOq.useCallback)((event)=>{
        const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
        handleChange(typedValue);
    }, [
        handleChange
    ]); // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4PQMu.NumberReadView), {
            fragmentRef: data,
            isSingleRowHeightEnabled: isSingleRowHeightEnabled
        }); // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            label: fieldName,
            defaultValue: updatedValue,
            onChange: onChange,
            spacing: spacing
        }); // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $iILGz.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hasReadViewTruncateDisabled: isSingleRowHeightEnabled
    });
};
const $c6a3f3563d672f6b$export$5a1b6dba6957de98 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $fwCIW.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c6a3f3563d672f6b$export$96ce9815e2ea97b5, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};
const $c6a3f3563d672f6b$export$47665260b410f801 = (0, $cSD7y.componentWithFG)('jsc_inline_editing_field_refactor', $c6a3f3563d672f6b$export$5a1b6dba6957de98, $c6a3f3563d672f6b$export$43034831b58d2012);
const $c6a3f3563d672f6b$var$readViewContainerSelectorName = 'jira-issue-field-inline-edit-read-view-container';
const $c6a3f3563d672f6b$var$READ_VIEW_CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$c6a3f3563d672f6b$var$readViewContainerSelectorName}"]`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c6a3f3563d672f6b$var$NumberInlineEditContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $Fn2Vl.InlineEditContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qi2wt _u5f3idpf _n3tdi2wt _19bvidpf _1ltvidpf _1bch1skh _1yb1idpf _79pa1l7b _1rhwyh40 _1bt6idpf _f8epkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fwCIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3c0cecd013249c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a41ce353c1fbfcb9b34059e57d9a6b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b3c0cecd013249c5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewNew_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$b3c0cecd013249c5$var$node.hash = "208597408b836a196e2e432d65098e64";
var $b3c0cecd013249c5$export$2e2bcd8739ae039 = $b3c0cecd013249c5$var$node;

});

parcelRegister("lQTIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f740361e747413b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9eac824a5d526dbdcbe1b4f030e7c4b8>>
 * @relayHash bac56b5a15fe2bdd371f393834598764
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9b5e7ad81080c3ef0caaf8a1945246c94639ab4dd9c2bfabbb0adde00cb670
const $5f740361e747413b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraNumberFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateNumberField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraNumberField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "number_issueFieldNumber_NumberField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "number_issueFieldNumber_NumberField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "5b9b5e7ad81080c3ef0caaf8a1945246c94639ab4dd9c2bfabbb0adde00cb670",
            "metadata": {},
            "name": "number_issueFieldNumber_NumberField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$5f740361e747413b$var$node.hash = "229bc4c46fc83a0e7aaf848fb3a4b543";
var $5f740361e747413b$export$2e2bcd8739ae039 = $5f740361e747413b$var$node;

});

parcelRegister("h8JKK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bae68d8ba2a3e4da$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ff658e2fa2e7e45dace0a64aa8643465>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bae68d8ba2a3e4da$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberReadviewFull_NumberReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraNumberField"
};
$bae68d8ba2a3e4da$var$node.hash = "bb1bee4e2db3c55d94055f595729b66a";
var $bae68d8ba2a3e4da$export$2e2bcd8739ae039 = $bae68d8ba2a3e4da$var$node;

});

parcelRegister("fnnCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad2a071b11027c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef48d192981f0f268b9ad7c92dd887db>>
 * @relayHash c8e36dd3f69248a71385ba85e14baf53
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11a4a1773edd0bed1ab5a91c27491612d6e74bcc2831efc2008ec42047a543f2
const $0ad2a071b11027c6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraNumberFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateNumberField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraNumberField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "number_issueFieldNumber_NumberFieldOld_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "number_issueFieldNumber_NumberFieldOld_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "11a4a1773edd0bed1ab5a91c27491612d6e74bcc2831efc2008ec42047a543f2",
            "metadata": {},
            "name": "number_issueFieldNumber_NumberFieldOld_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0ad2a071b11027c6$var$node.hash = "ac912bce87973eb366494b28c4298c64";
var $0ad2a071b11027c6$export$2e2bcd8739ae039 = $0ad2a071b11027c6$var$node;

});

parcelRegister("j2SaK", function(module, exports) {

$parcel$export(module.exports, "default", () => $da26ccfd37f70436$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a7b80001a3afd1cda2239b0d08823ccf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $da26ccfd37f70436$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewOld_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberReadviewFull_NumberReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$da26ccfd37f70436$var$node.hash = "30654c0fb3d781e263ba3a0f270acaf3";
var $da26ccfd37f70436$export$2e2bcd8739ae039 = $da26ccfd37f70436$var$node;

});

parcelRegister("elGhN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "NumberEditView", () => $40141f0b57c38671$export$a377d188591c514b);
$parcel$export(module.exports, "default", () => $40141f0b57c38671$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bU3PY = parcelRequire("bU3PY");

var $kY99m = parcelRequire("kY99m");

const $40141f0b57c38671$export$a377d188591c514b = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultValue: defaultValue, isInvalid: isInvalid = false, autoFocus: autoFocus = true, isDisabled: isDisabled = false, onWheel: onWheel, onChange: onChange, onBlur: onBlur, ariaLabelledBy: ariaLabelledBy, label: label, spacing: spacing } = props;
    const value = defaultValue == null || defaultValue === '' ? '' : Number(defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40141f0b57c38671$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        ref: ref,
        "aria-labelledby": ariaLabelledBy,
        "aria-label": label,
        autoFocus: autoFocus,
        isCompact: spacing === 'compact',
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        step: "any",
        type: "number",
        value: value,
        onWheel: onWheel,
        elemAfterInput: isInvalid === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40141f0b57c38671$var$WarningWrapper, {
            "data-testid": (0, $083d5c5d33b5aa16$export$ac421571f56485b8)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            label: "",
            color: "var(--ds-icon-warning, #E56910)",
            LEGACY_size: "medium",
            spacing: "spacious"
        })) : null,
        onChange: onChange,
        onBlur: onBlur
    }));
});
const $40141f0b57c38671$var$NumberEditViewEntryPoint = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40141f0b57c38671$export$a377d188591c514b, props);
var $40141f0b57c38671$export$2e2bcd8739ae039 = $40141f0b57c38671$var$NumberEditViewEntryPoint;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $40141f0b57c38671$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _80om1wug",
            __cmplp.className
        ])
    });
});
const $40141f0b57c38671$var$WarningWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0r5cr _2hwx1b66",
            __cmplp.className
        ])
    });
});

});
const $083d5c5d33b5aa16$export$ac421571f56485b8 = 'issue-field-number.edit.warning-icon';


parcelRegister("iILGz", function(module, exports) {

$parcel$export(module.exports, "default", () => $051b4288470f5d64$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $051b4288470f5d64$var$NumberEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("elGhN"))), {
        moduleId: "ac3a36e0"
    }),
    getPreloadProps: ()=>({})
});
var $051b4288470f5d64$export$2e2bcd8739ae039 = $051b4288470f5d64$var$NumberEditViewEntryPoint;

});

parcelRegister("3ySIl", function(module, exports) {

$parcel$export(module.exports, "default", () => $556fb1b2dc67aab2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $556fb1b2dc67aab2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitleWithFieldName: {
        "id": "issue-field-number-inline-edit-full.number.error-title-with-field-name",
        "defaultMessage": "We couldn't set the {fieldName} value"
    },
    errorMessage: {
        "id": "issue-field-number-inline-edit-full.number.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("k6gB1", function(module, exports) {

$parcel$export(module.exports, "StoryPointEstimateCell", () => $bc8a774757ad2706$export$78dcdef75b89353b);

var $kZd32 = parcelRequire("kZd32");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bifhU = parcelRequire("bifhU");

var $Br57E = parcelRequire("Br57E");

var $jFYC8 = parcelRequire("jFYC8");
const $bc8a774757ad2706$export$78dcdef75b89353b = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $kZd32.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bifhU.StoryPointEstimateInlineEditViewIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: shouldRenderHoverPopover
    });
});

});
parcelRegister("kZd32", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4eee3924ac9b2b9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70e48106f05bb968bcc0404240ec4f6b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f4eee3924ac9b2b9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "storyPointEstimate_nativeIssueTable_StoryPointEstimateCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraNumberField"
};
$f4eee3924ac9b2b9$var$node.hash = "cdb9181ba214ad4249622bb22a6ba8ed";
var $f4eee3924ac9b2b9$export$2e2bcd8739ae039 = $f4eee3924ac9b2b9$var$node;

});

parcelRegister("bifhU", function(module, exports) {

$parcel$export(module.exports, "StoryPointEstimateInlineEditViewIsEditable", () => $64762832583706d6$export$d2c15e488724d3b6);
$parcel$export(module.exports, "StoryPointEstimateInlineEditView", () => $64762832583706d6$export$53d82fd5560565fa);

var $fiJkE = parcelRequire("fiJkE");

var $9SpF9 = parcelRequire("9SpF9");

var $9k6LS = parcelRequire("9k6LS");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $8ikZj = parcelRequire("8ikZj");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $iILGz = parcelRequire("iILGz");

var $iLBvF = parcelRequire("iLBvF");

var $5fc53 = parcelRequire("5fc53");
const $64762832583706d6$export$d2c15e488724d3b6 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isFieldEditable, isEditing: startWithEditViewOpen, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, readViewFitContainerHeight: readViewFitContainerHeight, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $9k6LS.default), fragmentRef);
    const { id: uniqueFieldId, type: type, name: fieldName, number: initialValue } = data;
    const [commit] = (0, $8Uumt.useMutation)((0, $9SpF9.default));
    // #endregion
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const handleSubmit = (0, $5uXOq.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        number: value
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateNumberField) {
                    const { success: success, errors: responseErrors, field: field } = mutationData.jira.updateNumberField;
                    if (success && field != null) onSuccess();
                    else {
                        const errorMessage = responseErrors?.[0]?.message;
                        onFail(new Error(errorMessage || 'Relay error encountered while updating number field'), // Display server error message in flag if it exists
                        errorMessage ?? undefined);
                    }
                }
            },
            onError: (incomingError)=>{
                onFail(incomingError);
            },
            optimisticResponse: {
                jira: {
                    updateNumberField: {
                        success: true,
                        errors: [],
                        field: {
                            id: uniqueFieldId,
                            number: value != null ? value : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleChange: handleChange, handleConfirm: handleConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        clipboardComponentType: 'numberNullable',
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') ? {
            analyticsFieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE]
        } : {}
    });
    const onChange = (0, $5uXOq.useCallback)((event)=>{
        const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
        handleChange(typedValue);
    }, [
        handleChange
    ]);
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iLBvF.StoryPointEstimateReadView), {
            fragmentRef: data,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        }), [
        data,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            label: fieldName,
            defaultValue: updatedValue,
            isInvalid: invalidMessage != null || hasServerValidationError,
            onChange: onChange
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $iILGz.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage ?? undefined,
        isEditable: isFieldEditable,
        isEditing: isEditing || hasServerValidationError,
        keepEditViewOpenOnBlur: hasServerValidationError,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView
    });
};
const $64762832583706d6$export$53d82fd5560565fa = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $fiJkE.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($64762832583706d6$export$d2c15e488724d3b6, {
        ...props,
        fragmentRef: data,
        isEditable: data.isEditableInIssueView ?? false
    });
};

});
parcelRegister("fiJkE", function(module, exports) {

$parcel$export(module.exports, "default", () => $581634fcd768a651$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c5a0439ffc3e7985b2ffc49200c7c91a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $581634fcd768a651$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditViewIsEditable_fragmentRef"
        },
        {
            "kind": "ScalarField",
            "name": "isEditableInIssueView"
        }
    ],
    "type": "JiraNumberField"
};
$581634fcd768a651$var$node.hash = "e4b34a649ef5dd8533f5cabe75fe48a9";
var $581634fcd768a651$export$2e2bcd8739ae039 = $581634fcd768a651$var$node;

});

parcelRegister("9SpF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ec1aede7263f66c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3848ab8ba84307c52100812d34d678eb>>
 * @relayHash d31d751b8d2df6b00dba2227445c1922
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22c405c1466d19ac86bfc1ee91264decd40c73ed8fc34c324f886cba733f9321
const $4ec1aede7263f66c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraNumberFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateNumberField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraNumberField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "22c405c1466d19ac86bfc1ee91264decd40c73ed8fc34c324f886cba733f9321",
            "metadata": {},
            "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$4ec1aede7263f66c$var$node.hash = "cd8233b80d650588112eb0d15d581a9c";
var $4ec1aede7263f66c$export$2e2bcd8739ae039 = $4ec1aede7263f66c$var$node;

});

parcelRegister("9k6LS", function(module, exports) {

$parcel$export(module.exports, "default", () => $938ed154c108aff2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<104e7a7c30e42c208fb29f3aec68910d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $938ed154c108aff2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditViewIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraNumberField"
};
$938ed154c108aff2$var$node.hash = "c258cd7d5b4392c1e7419c5721e2a6cd";
var $938ed154c108aff2$export$2e2bcd8739ae039 = $938ed154c108aff2$var$node;

});

parcelRegister("iLBvF", function(module, exports) {

$parcel$export(module.exports, "StoryPointEstimateReadView", () => $20a9ed37a963c603$export$29398521b1f444c1);

var $hnkag = parcelRequire("hnkag");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $16T6Y = parcelRequire("16T6Y");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $eZibI = parcelRequire("eZibI");

var $dpHMc = parcelRequire("dpHMc");

var $7mPT9 = parcelRequire("7mPT9");

var $iv6X1 = parcelRequire("iv6X1");


var $bDPd5 = parcelRequire("bDPd5");
const $20a9ed37a963c603$export$29398521b1f444c1 = ({ fragmentRef: fragmentRef, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $koVbs.default)();
    const noValueTextExperiment = formatMessage((0, $bDPd5.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    const data = (0, $8Uumt.useFragment)((0, $hnkag.default), fragmentRef);
    const { number: number } = data;
    const contentRef = (0, $5uXOq.useRef)(null);
    if (number === null || number === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $8a4fe9052d00b8b0$export$d3d47c5f37010b20)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    }));
    if (shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        contentRef: contentRef,
        content: formatNumber(number)
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": (0, $8a4fe9052d00b8b0$export$d3d47c5f37010b20)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20a9ed37a963c603$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
            testId: (0, $8a4fe9052d00b8b0$export$3804bd7641b5a138)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            maxLines: 1,
            ref: (0, $7mPT9.default)(ref, contentRef)
        }, formatNumber(number))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $8a4fe9052d00b8b0$export$d3d47c5f37010b20)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20a9ed37a963c603$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        testId: (0, $8a4fe9052d00b8b0$export$3804bd7641b5a138)
    }, formatNumber(number))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $20a9ed37a963c603$var$BadgeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189eyh40 _1dqonqa1 _1h6d3acm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hnkag", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2e6032034f8b24f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8cba9120d9304692f56ff263b50af5a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2e6032034f8b24f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraNumberField"
};
$a2e6032034f8b24f$var$node.hash = "213e14801681adab521b885bb8cf8c60";
var $a2e6032034f8b24f$export$2e2bcd8739ae039 = $a2e6032034f8b24f$var$node;

});

const $8a4fe9052d00b8b0$export$3804bd7641b5a138 = 'issue-field-story-point-estimate-readview-full.ui.story-point-estimate.badge';
const $8a4fe9052d00b8b0$export$d3d47c5f37010b20 = 'issue-field-story-point-estimate-readview-full.ui.story-point-estimate';

parcelRegister("bDPd5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7508697a4e74249e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7508697a4e74249e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-story-point-estimate-readview-full.story-point-estimate.no-value-text-experiment",
        "defaultMessage": "Add story points"
    }
});

});





parcelRegister("jC6NH", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateCell", () => $44fe23764126bf6f$export$6ffde629399d0fd4);

var $8GvCJ = parcelRequire("8GvCJ");

var $dnik7 = parcelRequire("dnik7");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bsMib = parcelRequire("bsMib");

var $jFYC8 = parcelRequire("jFYC8");

var $Br57E = parcelRequire("Br57E");

var $e9M6d = parcelRequire("e9M6d");
const $44fe23764126bf6f$export$6ffde629399d0fd4 = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    // NOTE: original estimate type is used to get timeTrackingField data, which is used in underlying original estimate decomposed field.
    const data = (0, $8Uumt.useFragment)((0, $dnik7.default), fieldRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($44fe23764126bf6f$var$OriginalEstimateTimeTrackingFieldCell, {
        fieldRef: data.issue?.timeTrackingField ?? null,
        isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover
    });
};
const $44fe23764126bf6f$var$OriginalEstimateTimeTrackingFieldCell = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $8GvCJ.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = data && 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data?.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bsMib.OriginalEstimateInlineEditViewIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data ?? null,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
};

});
parcelRegister("8GvCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $800b97fd7e3a2d66$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc43b310bfeb98fe57b6af71c560fef1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $800b97fd7e3a2d66$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "originalEstimate_nativeIssueTable_OriginalEstimateTimeTrackingFieldCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraTimeTrackingField"
};
$800b97fd7e3a2d66$var$node.hash = "312db87c0c11a408da53829b2a0390aa";
var $800b97fd7e3a2d66$export$2e2bcd8739ae039 = $800b97fd7e3a2d66$var$node;

});

parcelRegister("dnik7", function(module, exports) {

$parcel$export(module.exports, "default", () => $03b6d1a6028540a2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39d8172b81adb6f2fe97ebd6a667a0ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03b6d1a6028540a2$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "originalEstimate_nativeIssueTable_OriginalEstimateCell_fieldRef",
    "selections": [
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraTimeTrackingField",
                    "kind": "LinkedField",
                    "name": "timeTrackingField",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isInlineEditingEnabled",
                                    "variableName": "isInlineEditingEnabled"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "originalEstimate_nativeIssueTable_OriginalEstimateTimeTrackingFieldCell_fieldRef"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraOriginalTimeEstimateField"
};
$03b6d1a6028540a2$var$node.hash = "a94aaa3cdea8a788b2dfde4610cb96bb";
var $03b6d1a6028540a2$export$2e2bcd8739ae039 = $03b6d1a6028540a2$var$node;

});

parcelRegister("bsMib", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateInlineEditViewIsEditable", () => $39e16b47334e239b$export$6b7ba0cc8e5fd10);
$parcel$export(module.exports, "OriginalEstimateInlineEditView", () => $39e16b47334e239b$export$63b1ca4384eabbd8);

var $lkIAY = parcelRequire("lkIAY");

var $1mYer = parcelRequire("1mYer");

var $afYF1 = parcelRequire("afYF1");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $jrRyX = parcelRequire("jrRyX");

var $kbw9K = parcelRequire("kbw9K");

var $dak2D = parcelRequire("dak2D");

var $dp3oS = parcelRequire("dp3oS");

var $lpMlR = parcelRequire("lpMlR");

var $lXLX3 = parcelRequire("lXLX3");

var $7F8HM = parcelRequire("7F8HM");

var $iv6X1 = parcelRequire("iv6X1");

var $ivc5x = parcelRequire("ivc5x");
const $39e16b47334e239b$export$6b7ba0cc8e5fd10 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, spacing: spacing = 'compact', readViewFitContainerHeight: readViewFitContainerHeight, isEditable: isEditable, isEditing: startWithEditViewOpen, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $afYF1.default), fragmentRef);
    const { id: uniqueFieldId = '', name: name = '', fieldId: fieldId = '', type: fieldType = '', originalEstimate: originalEstimate, timeTrackingSettings: timeTrackingSettings } = data || {};
    const { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: defaultFormat, defaultUnit: defaultUnit } = timeTrackingSettings ?? {};
    const [commit] = (0, $8Uumt.useMutation)((0, $1mYer.default));
    // #endregion
    // #region Common state
    const settingsInput = {
        workingHoursPerDay: workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek,
        defaultFormat: defaultFormat,
        defaultUnit: defaultUnit
    };
    const formatInputValue = (0, $dp3oS.useFormatInputValue)(settingsInput);
    const initialValue = (0, $5uXOq.useMemo)(()=>originalEstimate ? formatInputValue(originalEstimate.timeInSeconds ?? 0) : '', [
        formatInputValue,
        originalEstimate
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const validator = (0, $ivc5x.useOriginalEstimateValidator)(settingsInput);
    const parseTimeString = (0, $lpMlR.useParseTimeString)(settingsInput);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $5uXOq.useMemo)(()=>(0, $4R6GH.fg)('relay-migration-issue-fields-original-estimate') ? overrideLabel(name) : name, [
        name,
        overrideLabel
    ]);
    const isFieldEditable = (0, $4R6GH.fg)('relay-migration-issue-fields-original-estimate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>overrideIsEditable(isEditable), [
        isEditable,
        overrideIsEditable
    ]) : isEditable;
    // #region Action
    const handleSubmit = (0, $5uXOq.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        const timeInSeconds = parseTimeString(value) ?? 0;
        onSubmit?.(timeInSeconds);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    originalEstimate: {
                        timeInSeconds: timeInSeconds
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateTimeTrackingField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateTimeTrackingField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            originalEstimate: {
                                timeInSeconds: timeInSeconds
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        parseTimeString,
        uniqueFieldId
    ]);
    const handleSubmitSucceeded = (0, $5uXOq.useCallback)((value)=>onSubmitSucceeded?.(parseTimeString(value) ?? 0), [
        onSubmitSucceeded,
        parseTimeString
    ]);
    const actions = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        updatedValue: updatedValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        validator: validator,
        clipboardComponentType: 'originalEstimate'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = actions;
    // #region View
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbw9K.OriginalEstimateReadView), {
            fragmentRef: data ?? null,
            enableHover: isFieldEditable,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        }), [
        data,
        isFieldEditable,
        shouldRenderHoverPopover
    ]);
    const onChange = (0, $5uXOq.useCallback)((event)=>{
        handleChange(event.target.value);
    }, [
        handleChange
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            ...isExperimentEnabled ? {
                value: updatedValue === '0m' ? undefined : updatedValue
            } : {
                value: updatedValue
            },
            spacing: spacing,
            onChange: onChange,
            isInvalid: Boolean(invalidMessage)
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $dak2D.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage ?? undefined,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView
    });
};
const $39e16b47334e239b$export$63b1ca4384eabbd8 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $lkIAY.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($39e16b47334e239b$export$6b7ba0cc8e5fd10, {
        ...props,
        fragmentRef: data ?? null,
        isEditable: data?.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("lkIAY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dfd0acba302a279$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ecf5a6bb9641458cdf434ff38434eef3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4dfd0acba302a279$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$4dfd0acba302a279$var$node.hash = "5e2d79baa2633a5005ef945a7c8b3f28";
var $4dfd0acba302a279$export$2e2bcd8739ae039 = $4dfd0acba302a279$var$node;

});

parcelRegister("1mYer", function(module, exports) {

$parcel$export(module.exports, "default", () => $43c2e8c44765d40a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<81707b0a4ee0455bcaae6e531f239a91>>
 * @relayHash 3520cb3405bf5df677e699e027e38f90
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d5f6fe91ca3eeb49cf1444c59cbc5edd8accf64f7e09b2f84426f70b4a476e13
const $43c2e8c44765d40a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraTimeTrackingFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateTimeTrackingField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraTimeTrackingField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "JiraEstimate",
                                    "kind": "LinkedField",
                                    "name": "originalEstimate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "timeInSeconds"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "d5f6fe91ca3eeb49cf1444c59cbc5edd8accf64f7e09b2f84426f70b4a476e13",
            "metadata": {},
            "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$43c2e8c44765d40a$var$node.hash = "11dd5c5c4df23d2a67f16300cb79844d";
var $43c2e8c44765d40a$export$2e2bcd8739ae039 = $43c2e8c44765d40a$var$node;

});

parcelRegister("afYF1", function(module, exports) {

$parcel$export(module.exports, "default", () => $bac24f8c6d465ced$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<552dc3a05ed5f6d783af14a0f4b74a40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bac24f8c6d465ced$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "originalEstimate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                }
            ]
        },
        {
            "concreteType": "JiraTimeTrackingSettings",
            "kind": "LinkedField",
            "name": "timeTrackingSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "workingHoursPerDay"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingDaysPerWeek"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultFormat"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultUnit"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$bac24f8c6d465ced$var$node.hash = "92ecace176224672cc8283c177c6cb95";
var $bac24f8c6d465ced$export$2e2bcd8739ae039 = $bac24f8c6d465ced$var$node;

});

parcelRegister("kbw9K", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateReadView", () => $b9917035c3ae48c9$export$9fbd5776dc81fee9);

var $5ntP6 = parcelRequire("5ntP6");

var $eaoU9 = parcelRequire("eaoU9");

var $1BHHN = parcelRequire("1BHHN");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $16T6Y = parcelRequire("16T6Y");

var $cgL5K = parcelRequire("cgL5K");

var $koVbs = parcelRequire("koVbs");

var $iv6X1 = parcelRequire("iv6X1");

var $eZibI = parcelRequire("eZibI");

var $Fn2Vl = parcelRequire("Fn2Vl");

var $etKNj = parcelRequire("etKNj");

var $4R6GH = parcelRequire("4R6GH");

var $dpHMc = parcelRequire("dpHMc");

var $7mPT9 = parcelRequire("7mPT9");

var $dp3oS = parcelRequire("dp3oS");

var $dJJxF = parcelRequire("dJJxF");
const $b9917035c3ae48c9$export$3ebe0d7f11c619e2 = ({ fragmentRef: fragmentRef, enableHover: enableHover = false })=>{
    const testId = 'issue-field-original-estimate-read-view';
    const data = (0, $8Uumt.useFragment)((0, $1BHHN.default), fragmentRef);
    const intl = (0, $koVbs.default)();
    const value = data?.originalEstimate?.timeInSeconds;
    const noValueTextExperiment = intl.formatMessage((0, $dJJxF.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    const readTimeString = (0, $5uXOq.useMemo)(()=>(0, $etKNj.timeTrackingFormatterWithDefaults)(value || 0, {
            workingHoursPerDay: data?.timeTrackingSettings?.workingHoursPerDay,
            workingDaysPerWeek: data?.timeTrackingSettings?.workingDaysPerWeek,
            timeFormat: (0, $etKNj.transformAGGToJiraTimeFormat)(data?.timeTrackingSettings?.defaultFormat),
            defaultUnit: (0, $etKNj.transformAGGToJiraTimeUnit)(data?.timeTrackingSettings?.defaultUnit)
        }, intl), [
        intl,
        data?.timeTrackingSettings?.defaultFormat,
        data?.timeTrackingSettings?.defaultUnit,
        data?.timeTrackingSettings?.workingDaysPerWeek,
        data?.timeTrackingSettings?.workingHoursPerDay,
        value
    ]);
    const getRenderView = ()=>{
        const badge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
            testId: `${testId}.badge`
        }, readTimeString);
        if (enableHover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b9917035c3ae48c9$var$HoverContainer, null, badge);
        return badge;
    };
    if (!value && isExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), {
        emptyText: noValueTextExperiment
    });
    if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b9917035c3ae48c9$var$ReadViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b9917035c3ae48c9$var$BadgeWrapper, {
        "data-testid": "issue-field-original-estimate-readview-full.ui.original-estimate.test-id"
    }, getRenderView()));
};
const $b9917035c3ae48c9$export$99c86d7be9f97fdf = ({ fragmentRef: fragmentRef, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $eaoU9.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const noValueTextExperiment = formatMessage((0, $dJJxF.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    const settingsInput = {
        workingHoursPerDay: data?.timeTrackingSettings?.workingHoursPerDay,
        workingDaysPerWeek: data?.timeTrackingSettings?.workingDaysPerWeek,
        defaultFormat: data?.timeTrackingSettings?.defaultFormat,
        defaultUnit: data?.timeTrackingSettings?.defaultUnit
    };
    const formatInputValue = (0, $dp3oS.useFormatInputValue)(settingsInput);
    const timeString = (0, $5uXOq.useMemo)(()=>data ? formatInputValue(data.originalEstimate?.timeInSeconds ?? 0) : null, [
        data,
        formatInputValue
    ]);
    const contentRef = (0, $5uXOq.useRef)(null);
    if (!data?.originalEstimate?.timeInSeconds && isExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), {
        emptyText: noValueTextExperiment
    });
    if (timeString === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    if (shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        contentRef: contentRef,
        content: timeString
    }, ({ ref: ref })=>// Empty div to allow ellipsis
        // eslint-disable-next-line jira/react/no-empty-divs
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            maxLines: 1,
            ref: (0, $7mPT9.default)(ref, contentRef)
        }, timeString))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), null, timeString);
};
const $b9917035c3ae48c9$export$9fbd5776dc81fee9 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)(/* eslint-disable @atlassian/relay/graphql-naming */ (0, $5ntP6.default), fragmentRef);
    if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b9917035c3ae48c9$export$99c86d7be9f97fdf, {
        fragmentRef: data ?? null,
        ...props
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b9917035c3ae48c9$export$3ebe0d7f11c619e2, {
        fragmentRef: data ?? null,
        ...props
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b9917035c3ae48c9$var$ReadViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $Fn2Vl.ReadViewContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f3v77o _2hwx1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b9917035c3ae48c9$var$HoverContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80omtlke _vwz4gktf _ll8p16l4 _1lgi1hek",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b9917035c3ae48c9$var$BadgeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _kqswh2mm _19pk196n _otyr196n _2hwx1i6y _18u0v77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5ntP6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b48a8f34572a34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<71daf17df2b5557176e7ee592688e383>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a0b48a8f34572a34$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadView",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadViewNew_fragmentRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadViewOld_fragmentRef"
        }
    ],
    "type": "JiraTimeTrackingField"
};
$a0b48a8f34572a34$var$node.hash = "2a15c08b9114d781806c532c837870f5";
var $a0b48a8f34572a34$export$2e2bcd8739ae039 = $a0b48a8f34572a34$var$node;

});

parcelRegister("eaoU9", function(module, exports) {

$parcel$export(module.exports, "default", () => $88756148f3551cdd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4af30c9e76ced09dc57a6f90a33ebb20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $88756148f3551cdd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadViewNew_fragmentRef",
    "selections": [
        {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "originalEstimate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                }
            ]
        },
        {
            "concreteType": "JiraTimeTrackingSettings",
            "kind": "LinkedField",
            "name": "timeTrackingSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "workingHoursPerDay"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingDaysPerWeek"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultFormat"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultUnit"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$88756148f3551cdd$var$node.hash = "a3476e4eb2e47d4faef4bffed9ccd3fe";
var $88756148f3551cdd$export$2e2bcd8739ae039 = $88756148f3551cdd$var$node;

});

parcelRegister("1BHHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa11c49a305343a6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<df001974101b6e0f2a769d7013b44d6b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aa11c49a305343a6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadViewOld_fragmentRef",
    "selections": [
        {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "originalEstimate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                }
            ]
        },
        {
            "concreteType": "JiraTimeTrackingSettings",
            "kind": "LinkedField",
            "name": "timeTrackingSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "workingHoursPerDay"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingDaysPerWeek"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultFormat"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultUnit"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$aa11c49a305343a6$var$node.hash = "b4aba6775c0f3cf0df39e10598fc1144";
var $aa11c49a305343a6$export$2e2bcd8739ae039 = $aa11c49a305343a6$var$node;

});

parcelRegister("etKNj", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $5d7d4350edc91a82$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterWithDefaults", () => $5d7d4350edc91a82$export$71be3aa954f6065b);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $5d7d4350edc91a82$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $5d7d4350edc91a82$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $5d7d4350edc91a82$export$8516173ab945b52f);

var $gBj4V = parcelRequire("gBj4V");

var $lgkxY = parcelRequire("lgkxY");

var $4TB2x = parcelRequire("4TB2x");
const $5d7d4350edc91a82$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $5d7d4350edc91a82$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $5d7d4350edc91a82$var$timePrettyFormatter = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$var$timePrettyFormatterLongForm = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, formatMessage(units[1].suffix));
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, formatMessage(units[2].suffix));
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatter(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $gBj4V.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $gBj4V.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $gBj4V.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $gBj4V.defaultTimeTrackingOptions).defaultUnit
    };
    return $5d7d4350edc91a82$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $5d7d4350edc91a82$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitLongDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitLongHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitLongMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatterLongForm(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $gBj4V.TimeFormats).DAYS:
            return (0, $gBj4V.TimeFormats).DAYS;
        case (0, $gBj4V.TimeFormats).HOURS:
            return (0, $gBj4V.TimeFormats).HOURS;
        case (0, $gBj4V.TimeFormats).PRETTY:
            return (0, $gBj4V.TimeFormats).PRETTY;
        default:
            return (0, $gBj4V.TimeFormats).DAYS;
    }
};
const $5d7d4350edc91a82$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $gBj4V.TimeUnits).DAY:
            return (0, $gBj4V.TimeUnits).DAY;
        case (0, $gBj4V.TimeUnits).HOUR:
            return (0, $gBj4V.TimeUnits).HOUR;
        case (0, $gBj4V.TimeUnits).MINUTE:
            return (0, $gBj4V.TimeUnits).MINUTE;
        case (0, $gBj4V.TimeUnits).WEEK:
            return (0, $gBj4V.TimeUnits).WEEK;
        default:
            return (0, $gBj4V.TimeUnits).DAY;
    }
};

});
parcelRegister("gBj4V", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $f8bb2765f8828f08$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $f8bb2765f8828f08$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $f8bb2765f8828f08$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $f8bb2765f8828f08$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $f8bb2765f8828f08$export$f8d48c1fed813e90);
const $f8bb2765f8828f08$export$544c576050746347 = 60;
const $f8bb2765f8828f08$var$MINUTES_PER_HOUR = 60;
const $f8bb2765f8828f08$export$3cc7ae4b390f50a = $f8bb2765f8828f08$var$MINUTES_PER_HOUR * $f8bb2765f8828f08$export$544c576050746347;
const $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY = 'pretty';
const $f8bb2765f8828f08$var$TIME_FORMAT_DAYS = 'days';
const $f8bb2765f8828f08$var$TIME_FORMAT_HOURS = 'hours';
const $f8bb2765f8828f08$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY,
    DAYS: $f8bb2765f8828f08$var$TIME_FORMAT_DAYS,
    HOURS: $f8bb2765f8828f08$var$TIME_FORMAT_HOURS
});
const $f8bb2765f8828f08$var$TIME_UNIT_WEEK = 'week';
const $f8bb2765f8828f08$var$TIME_UNIT_DAY = 'day';
const $f8bb2765f8828f08$var$TIME_UNIT_HOUR = 'hour';
const $f8bb2765f8828f08$var$TIME_UNIT_MINUTE = 'minute';
const $f8bb2765f8828f08$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $f8bb2765f8828f08$var$TIME_UNIT_WEEK,
    DAY: $f8bb2765f8828f08$var$TIME_UNIT_DAY,
    HOUR: $f8bb2765f8828f08$var$TIME_UNIT_HOUR,
    MINUTE: $f8bb2765f8828f08$var$TIME_UNIT_MINUTE
});
const $f8bb2765f8828f08$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $f8bb2765f8828f08$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $f8bb2765f8828f08$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("lgkxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $00e424f4a1d744f3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $00e424f4a1d744f3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});

});

parcelRegister("4TB2x", function(module, exports) {

$parcel$export(module.exports, "createUnit", () => $d8f5ee4c356dec74$export$aab44654646f3ccc);
const $d8f5ee4c356dec74$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});


parcelRegister("dp3oS", function(module, exports) {

$parcel$export(module.exports, "useFormatInputValue", () => $1216a3ace1de11f1$export$249a26bf47be0b0b);

var $5uXOq = parcelRequire("5uXOq");

var $etKNj = parcelRequire("etKNj");

var $koVbs = parcelRequire("koVbs");


var $hEcb3 = parcelRequire("hEcb3");
const $1216a3ace1de11f1$var$toTimeFormat = (format)=>{
    return format ? (0, $hEcb3.toLowercaseTimeUnion)(format) : (0, $58ae3dfc3130ce0f$export$c4d2eaadfa3c28df);
};
const $1216a3ace1de11f1$var$toTimeUnit = (unit)=>{
    return unit ? (0, $hEcb3.toLowercaseTimeUnion)(unit) : (0, $58ae3dfc3130ce0f$export$2ee07242bbb09b61);
};
const $1216a3ace1de11f1$export$249a26bf47be0b0b = ({ workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: defaultFormat, defaultUnit: defaultUnit })=>{
    const intl = (0, $koVbs.default)();
    return (0, $5uXOq.useCallback)((value)=>{
        return (0, $etKNj.timeTrackingFormatter)(value, {
            workingHoursPerDay: workingHoursPerDay || (0, $58ae3dfc3130ce0f$export$8c7070611f332ef9),
            workingDaysPerWeek: workingDaysPerWeek || (0, $58ae3dfc3130ce0f$export$21ed1f454652d913),
            timeFormat: $1216a3ace1de11f1$var$toTimeFormat(defaultFormat),
            defaultUnit: $1216a3ace1de11f1$var$toTimeUnit(defaultUnit)
        }, intl);
    }, [
        workingHoursPerDay,
        workingDaysPerWeek,
        defaultFormat,
        defaultUnit,
        intl
    ]);
};

});
const $58ae3dfc3130ce0f$export$8c7070611f332ef9 = 8;
const $58ae3dfc3130ce0f$export$21ed1f454652d913 = 5;
const $58ae3dfc3130ce0f$export$c4d2eaadfa3c28df = 'pretty';
const $58ae3dfc3130ce0f$export$2ee07242bbb09b61 = 'minute';

parcelRegister("hEcb3", function(module, exports) {

$parcel$export(module.exports, "toLowercaseTimeUnion", () => $69d3f84bd3dfb52a$export$72046bdd228710d3);
// Exclude union value automatically added by Relay
// eslint-disable-next-line @atlassian/relay/no-future-added-value
const $69d3f84bd3dfb52a$export$72046bdd228710d3 = (union)=>union.toLowerCase();

});


parcelRegister("dJJxF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e22f42960c6115d4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e22f42960c6115d4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-original-estimate-readview-full.original-estimate.no-value-text-experiment",
        "defaultMessage": "Add estimate"
    }
});

});


parcelRegister("dak2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $98ed065c89dce1b3$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $98ed065c89dce1b3$var$OriginalEstimateEditViewWithFormattedValueEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("gzRMQ")), {
        moduleId: "78b5a554"
    }),
    getPreloadProps: ()=>({})
});
var $98ed065c89dce1b3$export$2e2bcd8739ae039 = $98ed065c89dce1b3$var$OriginalEstimateEditViewWithFormattedValueEntryPoint;

});
parcelRegister("gzRMQ", function(module, exports) {

let $c119a328a9ef34a3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c119a328a9ef34a3$var$load("6wiUh").then(()=>parcelRequire('iup85'));

});


parcelRegister("lpMlR", function(module, exports) {

$parcel$export(module.exports, "useValidateTimeString", () => $7f210f99ab60a621$export$27badca43bbaa0e);
$parcel$export(module.exports, "useParseTimeString", () => $7f210f99ab60a621$export$a1109322d92e0ba8);

var $5uXOq = parcelRequire("5uXOq");

var $axdWJ = parcelRequire("axdWJ");


var $hEcb3 = parcelRequire("hEcb3");
const $7f210f99ab60a621$var$toTimeFormat = (format)=>{
    return format ? (0, $hEcb3.toLowercaseTimeUnion)(format) : (0, $58ae3dfc3130ce0f$export$c4d2eaadfa3c28df);
};
const $7f210f99ab60a621$var$toTimeUnit = (unit)=>{
    return unit ? (0, $hEcb3.toLowercaseTimeUnion)(unit) : (0, $58ae3dfc3130ce0f$export$2ee07242bbb09b61);
};
const $7f210f99ab60a621$var$useTimeTrackingParsingConfig = ({ workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: defaultFormat, defaultUnit: defaultUnit })=>{
    return (0, $5uXOq.useMemo)(()=>({
            hoursPerDay: workingHoursPerDay || (0, $58ae3dfc3130ce0f$export$8c7070611f332ef9),
            daysPerWeek: workingDaysPerWeek || (0, $58ae3dfc3130ce0f$export$21ed1f454652d913),
            format: $7f210f99ab60a621$var$toTimeFormat(defaultFormat),
            defaultUnit: $7f210f99ab60a621$var$toTimeUnit(defaultUnit),
            isTimeTrackingEnabled: true
        }), [
        defaultFormat,
        defaultUnit,
        workingDaysPerWeek,
        workingHoursPerDay
    ]);
};
const $7f210f99ab60a621$export$27badca43bbaa0e = (input)=>{
    const config = $7f210f99ab60a621$var$useTimeTrackingParsingConfig(input);
    return (0, $5uXOq.useMemo)(()=>(0, $axdWJ.isValidTimeString)(config), [
        config
    ]);
};
const $7f210f99ab60a621$export$a1109322d92e0ba8 = (input)=>{
    const config = $7f210f99ab60a621$var$useTimeTrackingParsingConfig(input);
    return (0, $5uXOq.useMemo)(()=>(0, $axdWJ.parseTimeString)(config), [
        config
    ]);
};

});
parcelRegister("axdWJ", function(module, exports) {

$parcel$export(module.exports, "formatTimeString", () => $3e1d4e008ffe7726$export$2de90790c3ad23b1);
$parcel$export(module.exports, "isValidTimeString", () => $3e1d4e008ffe7726$export$669626963db3b187);
$parcel$export(module.exports, "parseTimeString", () => $3e1d4e008ffe7726$export$53148bfa4e677363);

var $caiLO = parcelRequire("caiLO");

var $khZ39 = parcelRequire("khZ39");

var $jXTQd = parcelRequire("jXTQd");

var $51HJa = parcelRequire("51HJa");

var $8KiHO = parcelRequire("8KiHO");

const $3e1d4e008ffe7726$export$2de90790c3ad23b1 = (config)=>(timeValue)=>(0, $khZ39.default)(config.daysPerWeek, config.hoursPerDay)(timeValue || 0);
const $3e1d4e008ffe7726$export$5eb9d332712102eb = (config)=>(value)=>{
        let trimmedValue = value.trim();
        // If user doesn't type the valid format (m, h, d, or w), use default unit format set in the configuration.
        const isValidNumber = (0, $51HJa.isNumeric)(trimmedValue.replaceAll(',', '.'));
        if (isValidNumber) {
            const { defaultUnit: defaultUnit } = config;
            trimmedValue = `${trimmedValue}${(0, $8KiHO.getDefaultTimeTrackingUnit)(defaultUnit)}`;
        }
        return trimmedValue;
    };
const $3e1d4e008ffe7726$export$669626963db3b187 = (config)=>(value)=>{
        const timeString = $3e1d4e008ffe7726$export$5eb9d332712102eb(config)(value);
        return timeString === '' || (0, $caiLO.default)(timeString);
    };
const $3e1d4e008ffe7726$export$53148bfa4e677363 = (config)=>(value)=>{
        const timeString = $3e1d4e008ffe7726$export$5eb9d332712102eb(config)(value);
        if (!$3e1d4e008ffe7726$export$669626963db3b187(config)(timeString)) return 0;
        return (0, $jXTQd.default)(config.daysPerWeek, config.hoursPerDay)(timeString);
    };

});
parcelRegister("caiLO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8041043484b2005f$export$2e2bcd8739ae039);

var $D5mr3 = parcelRequire("D5mr3");

var $jXTQd = parcelRequire("jXTQd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8041043484b2005f$export$2e2bcd8739ae039 = (timeString)=>{
    // We don't care about daysPerWeek or hoursPerDay - we only need to test that the value can be parsed.
    const result = (0, $jXTQd.default)(1, 1)(timeString);
    return result !== null && (0, (/*@__PURE__*/$parcel$interopDefault($D5mr3)))(result);
};

});
parcelRegister("D5mr3", function(module, exports) {

var $1V15E = parcelRequire("1V15E");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0757cd3024f91218$var$nativeIsFinite = $1V15E.isFinite;
/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */ function $0757cd3024f91218$var$isFinite(value) {
    return typeof value == 'number' && $0757cd3024f91218$var$nativeIsFinite(value);
}
module.exports = $0757cd3024f91218$var$isFinite;

});

parcelRegister("jXTQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $805a43ba842f3e63$export$2e2bcd8739ae039);
const $805a43ba842f3e63$var$MINUTES_PER_HOUR = 60;
const $805a43ba842f3e63$var$SECONDS_PER_MINUTE = 60;
// Supports both '.' and ',' as decimal separators
const $805a43ba842f3e63$var$UNIT_STRING_PATTERN = /^(\d+(?:[.,]\d+)?)([wdhm])$/;
const $805a43ba842f3e63$var$convertToUnitQuantity = (rawString)=>{
    const matches = $805a43ba842f3e63$var$UNIT_STRING_PATTERN.exec(rawString);
    if (!matches) return null;
    // Replace comma with a period for evaluating arithmetic decimal
    const normalizedQuantity = matches[1].replaceAll(',', '.');
    return {
        quantity: parseFloat(normalizedQuantity),
        unit: matches[2]
    };
};
const $805a43ba842f3e63$var$timeStringToSeconds = (daysPerWeek, hoursPerDay)=>{
    const unitDefinitions = [
        {
            unit: 'w',
            seconds: daysPerWeek * hoursPerDay * $805a43ba842f3e63$var$MINUTES_PER_HOUR * $805a43ba842f3e63$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'd',
            seconds: hoursPerDay * $805a43ba842f3e63$var$MINUTES_PER_HOUR * $805a43ba842f3e63$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'h',
            seconds: $805a43ba842f3e63$var$MINUTES_PER_HOUR * $805a43ba842f3e63$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'm',
            seconds: $805a43ba842f3e63$var$SECONDS_PER_MINUTE
        }
    ];
    return (timeString)=>{
        // Split up the time string, and parse it into an array of UnitQuantities.
        const unitQuantities = timeString.split(' ').map($805a43ba842f3e63$var$convertToUnitQuantity);
        let quantitiesConsumed = 0;
        let seconds = 0;
        for(let i = 0; i < unitDefinitions.length; i += 1){
            // If we have consumed all the quantity-unit pairs in the string
            // we are done.
            if (quantitiesConsumed === unitQuantities.length) break;
            const unitDefinition = unitDefinitions[i];
            const unitQuantity = unitQuantities[quantitiesConsumed];
            if (!unitQuantity) return null;
            // If the quantity-unit pair matches the unit definition we are up to, consume it.
            if (unitQuantity.unit === unitDefinition.unit) {
                seconds += unitQuantity.quantity * unitDefinition.seconds;
                quantitiesConsumed += 1;
            }
        }
        // We have made it through all the unit definitions, but there is still some left-over input
        if (quantitiesConsumed < unitQuantities.length) return null;
        return Math.floor(seconds);
    };
};
var $805a43ba842f3e63$export$2e2bcd8739ae039 = $805a43ba842f3e63$var$timeStringToSeconds;

});


parcelRegister("khZ39", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a56ddd74feeb1a3$export$2e2bcd8739ae039);
const $5a56ddd74feeb1a3$var$MINUTES_PER_HOUR = 60;
const $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE = 60;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5a56ddd74feeb1a3$export$2e2bcd8739ae039 = (daysPerWeek, hoursPerDay)=>{
    const units = [
        {
            suffix: 'w',
            seconds: daysPerWeek * hoursPerDay * $5a56ddd74feeb1a3$var$MINUTES_PER_HOUR * $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'd',
            seconds: hoursPerDay * $5a56ddd74feeb1a3$var$MINUTES_PER_HOUR * $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'h',
            seconds: $5a56ddd74feeb1a3$var$MINUTES_PER_HOUR * $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'm',
            seconds: $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE
        }
    ];
    return (seconds)=>{
        const initial = {
            secondsRemaining: seconds,
            timeString: ''
        };
        const result = units.reduce((acc, unit)=>{
            // Skip this unit if it doesn't have a valid number of seconds
            if (unit.seconds <= 0) return acc;
            const numUnits = Math.floor(acc.secondsRemaining / unit.seconds);
            const updatedSecondsRemaining = numUnits >= 1 ? acc.secondsRemaining % unit.seconds : acc.secondsRemaining;
            const updatedTimeString = numUnits >= 1 ? `${acc.timeString} ${numUnits}${unit.suffix}` : acc.timeString;
            return {
                secondsRemaining: updatedSecondsRemaining,
                timeString: updatedTimeString
            };
        }, initial);
        return result.timeString.trim() || '0m';
    };
};

});

parcelRegister("51HJa", function(module, exports) {

$parcel$export(module.exports, "isNumeric", () => $04c692f002b6b2cc$export$e90fb89750dba83f);
const $04c692f002b6b2cc$export$e90fb89750dba83f = (num)=>num.length > 0 && !Number.isNaN(Number(num));

});

parcelRegister("8KiHO", function(module, exports) {

$parcel$export(module.exports, "getDefaultTimeTrackingUnit", () => $1cda22112bbc1ffb$export$2b38dfc7401492ba);
// This is required to map the default time-tracking unit coming from the server (gira endpoint BENTO: 3334) to client
const $1cda22112bbc1ffb$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT = {
    minute: 'm',
    hour: 'h',
    day: 'd',
    week: 'w'
};
const $1cda22112bbc1ffb$export$2b38dfc7401492ba = (serverDefaultUnit)=>$1cda22112bbc1ffb$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT[serverDefaultUnit] || $1cda22112bbc1ffb$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT.minute;

});



parcelRegister("ivc5x", function(module, exports) {

$parcel$export(module.exports, "useOriginalEstimateValidator", () => $8136813c7a1cfefb$export$339bd53893728f75);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lpMlR = parcelRequire("lpMlR");

var $lrbxS = parcelRequire("lrbxS");
const $8136813c7a1cfefb$export$339bd53893728f75 = (settingsInput)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const validate = (0, $lpMlR.useValidateTimeString)(settingsInput);
    const submit = (0, $5uXOq.useCallback)((value)=>{
        if (!validate(value)) return {
            type: 'error',
            message: formatMessage((0, $lrbxS.default).invalidInput)
        };
        return null;
    }, [
        formatMessage,
        validate
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("lrbxS", function(module, exports) {

$parcel$export(module.exports, "default", () => $66fcb4dc2262fa56$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $66fcb4dc2262fa56$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    invalidInput: {
        "id": "issue-field-original-estimate-inline-edit-full.original-estimate.invalid-input",
        "defaultMessage": "Your estimate must be in the format 2w 4d 6h 45m"
    }
});

});




parcelRegister("cs56G", function(module, exports) {

$parcel$export(module.exports, "ParentCell", () => $a13d2d7eb1ab530b$export$d5a4cc78f8c5a2cd);

var $1c7FM = parcelRequire("1c7FM");

var $fD6Uy = parcelRequire("fD6Uy");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cgL5K = parcelRequire("cgL5K");

var $4R6GH = parcelRequire("4R6GH");

var $287DC = parcelRequire("287DC");

var $dVUnr = parcelRequire("dVUnr");

var $ousew = parcelRequire("ousew");

var $e9M6d = parcelRequire("e9M6d");

var $hKMVG = parcelRequire("hKMVG");

var $Br57E = parcelRequire("Br57E");

var $jFYC8 = parcelRequire("jFYC8");

var $a4kK7 = parcelRequire("a4kK7");
const $a13d2d7eb1ab530b$export$d5a4cc78f8c5a2cd = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, fieldType: fieldType = '', isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $fD6Uy.default), fieldRef);
    const isDensityFull = (0, $e9M6d.useIsDensityFull)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    /**
   * As part of the initiative to remove "Epic Link" and "Parent Link" fields from Jira,
   * we're rendering a "Replaced by Parent field" deprecation message in the "Parent Link" cell.
   * At the time of writing this comment, "Parent Link" is still used in ~1% of issue tables, and
   * we hope this message will help these users migrate and use the "Parent" field from now on.
   */ if (fieldType === 'com.atlassian.jpo:jpo-custom-field-parent' && (0, $4R6GH.fg)('replace-epic-parent-link-by-depreca-message-in-nin')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $a4kK7.default).replacedByParentField,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, chunks)
        }
    }));
    if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const inlineEditData = (0, $8Uumt.useFragment)((0, $1c7FM.default), data);
        // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
        // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
        const isEditable = 'lazyIsEditableInIssueView' in inlineEditData && isInlineEditingExtendedFieldSupportEnabled ? inlineEditData.lazyIsEditableInIssueView : false;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $Br57E.useLazyLoadEditability)(inlineEditData.id, isEditable);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dVUnr.ParentInlineEditViewIsEditable), {
            attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
            spacing: "default",
            editViewPopup: true,
            editViewPopupAlignBlock: "center",
            fragmentRef: inlineEditData,
            isTruncated: !isDensityFull || isSingleLineRowHeightEnabled,
            isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
            menuPosition: "fixed",
            readViewFitContainerHeight: true,
            // Render an empty string when there is no parent and experiment is off to mimic FG off state
            emptyText: isInlineEditingExtendedFieldSupportEnabled ? undefined : '',
            isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
        });
    }
    const { parentIssue: parentIssue } = data;
    if (!parentIssue) return null;
    if (parentIssue.key == null || parentIssue.summaryField?.text == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "parent",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $287DC.ParentReadView), {
        fragmentRef: data,
        isTruncated: !isDensityFull || isSingleLineRowHeightEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
    });
});

});
parcelRegister("1c7FM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d8913183ba17cae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b486690fc24de66310921e30e199c6eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4d8913183ba17cae$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "parent_nativeIssueTable_ParentCell_data",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraParentIssueField"
};
$4d8913183ba17cae$var$node.hash = "5bd5d278efda13fd8ec2a79f00dfd945";
var $4d8913183ba17cae$export$2e2bcd8739ae039 = $4d8913183ba17cae$var$node;

});

parcelRegister("fD6Uy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4d8d9e93578f478$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5cea65a179854d7e08a64f57841499df>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b4d8d9e93578f478$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "parent_nativeIssueTable_ParentCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "parentIssue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "JiraSingleLineTextField",
                    "kind": "LinkedField",
                    "name": "summaryField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "text"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "parent_issueFieldParentReadviewFull_ParentReadView"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "parent_nativeIssueTable_ParentCell_data"
                }
            ]
        }
    ],
    "type": "JiraParentIssueField"
};
$b4d8d9e93578f478$var$node.hash = "2a93235cfca7356f6c6155a5a26e263c";
var $b4d8d9e93578f478$export$2e2bcd8739ae039 = $b4d8d9e93578f478$var$node;

});

parcelRegister("287DC", function(module, exports) {

$parcel$export(module.exports, "ParentReadView", () => $5decd3d73b4c89b5$export$72990b9b43fe6c69);

var $68V7Z = parcelRequire("68V7Z");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $eZibI = parcelRequire("eZibI");

var $iv6X1 = parcelRequire("iv6X1");

var $dpHMc = parcelRequire("dpHMc");

var $hfkjT = parcelRequire("hfkjT");

var $03LN4 = parcelRequire("03LN4");
const $5decd3d73b4c89b5$export$72990b9b43fe6c69 = ({ fragmentRef: fragmentRef, disableClickAction: disableClickAction, emptyText: emptyText, onClick: onClick, isTruncated: isTruncated = true, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled })=>{
    const { parentIssue: parentIssue } = (0, $8Uumt.useFragment)((0, $68V7Z.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    const noValueTextExperiment = formatMessage((0, $hfkjT.default).noValueTextExperiment);
    const contentRef = (0, $5uXOq.useRef)(null);
    const issueType = parentIssue?.issueTypeField?.issueType;
    const label = `${parentIssue?.key} ${parentIssue?.summaryField?.text ?? ''}`;
    const iconUrl = issueType?.avatar?.xsmall;
    if (!parentIssue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : emptyText
    });
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.100",
        xcss: isTruncated ? $5decd3d73b4c89b5$var$containerStyles : null
    }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5decd3d73b4c89b5$var$Icon, {
        src: iconUrl,
        alt: formatMessage((0, $hfkjT.default).icon, {
            issueType: issueType?.name ?? ''
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $03LN4.Summary), {
        disableClickAction: disableClickAction,
        issueKey: parentIssue.key,
        label: label,
        colorKey: parentIssue.issueColorField?.color?.colorKey,
        onClick: onClick,
        isTruncated: isTruncated
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: label,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "center",
            space: "space.100",
            xcss: $5decd3d73b4c89b5$var$containerStyles,
            ref: ref
        }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5decd3d73b4c89b5$var$Icon, {
            src: iconUrl,
            alt: formatMessage((0, $hfkjT.default).icon, {
                issueType: issueType?.name ?? ''
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $03LN4.Summary), {
            disableClickAction: disableClickAction,
            issueKey: parentIssue?.key || '',
            label: label,
            colorKey: parentIssue?.issueColorField?.color?.colorKey,
            onClick: onClick,
            isTruncated: isTruncated,
            contentRef: contentRef
        })));
};
const $5decd3d73b4c89b5$var$containerStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5decd3d73b4c89b5$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f7vkz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("68V7Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $e09ea61408ca48a8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eee6ea3a8b3b25ed9fa4c9e85d091d71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e09ea61408ca48a8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "parent_issueFieldParentReadviewFull_ParentReadView",
    "selections": [
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "parentIssue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "JiraColorField",
                    "kind": "LinkedField",
                    "name": "issueColorField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "color",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "colorKey"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraIssueTypeField",
                    "kind": "LinkedField",
                    "name": "issueTypeField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "xsmall"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraSingleLineTextField",
                    "kind": "LinkedField",
                    "name": "summaryField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "text"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraParentIssueField"
};
$e09ea61408ca48a8$var$node.hash = "f9cdc2acd2c426037f13d9ef6280fd67";
var $e09ea61408ca48a8$export$2e2bcd8739ae039 = $e09ea61408ca48a8$var$node;

});

parcelRegister("hfkjT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9119f39cdea23b20$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9119f39cdea23b20$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    icon: {
        "id": "issue-field-parent-readview-full.parent.icon",
        "defaultMessage": "{issueType} icon"
    },
    noValueTextExperiment: {
        "id": "issue-field-parent.no-value-text-experiment",
        "defaultMessage": "Add parent"
    }
});

});

parcelRegister("03LN4", function(module, exports) {

$parcel$export(module.exports, "Summary", () => $81934a13d9aff585$export$46453a0401d6cd1a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jhmo0 = parcelRequire("jhmo0");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $iHPnC = parcelRequire("iHPnC");

var $kvDKs = parcelRequire("kvDKs");
const $81934a13d9aff585$export$46453a0401d6cd1a = ({ disableClickAction: disableClickAction, onClick: onClick, label: label, colorKey: colorKey, issueKey: issueKey, isTruncated: isTruncated, contentRef: contentRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const lozengeTheme = (0, $5uXOq.useMemo)(()=>colorKey ? (0, $iHPnC.getLozengeThemeByColor)((0, $iHPnC.asColor)(colorKey)) : undefined, [
        colorKey
    ]);
    if (disableClickAction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81934a13d9aff585$var$WrapperNoClick // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: lozengeTheme
    }, label);
    if (onClick != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81934a13d9aff585$var$ButtonText, {
        onClick: onClick,
        style: lozengeTheme
    }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        testId: (0, $4R6GH.fg)('relay-migration-issue-header-and-parent') ? 'issue-field-parent.ui.view-link' : 'issue-field-parent-readview-full.ui.parent.summary.view-link',
        href: `/browse/${issueKey}`,
        "aria-label": formatMessage((0, $kvDKs.default).parentTitle, {
            label: label
        }),
        style: lozengeTheme,
        xcss: [
            $81934a13d9aff585$var$linkTextStylesBase,
            isTruncated ? $81934a13d9aff585$var$linkTextStylesTruncated : $81934a13d9aff585$var$linkTextStylesNonTruncated
        ],
        ref: contentRef
    }, label);
};
const $81934a13d9aff585$var$linkTextStylesBase = (0, $8CUq3.xcss)({
    borderRadius: "var(--ds-border-radius, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $81934a13d9aff585$var$linkTextStylesNonTruncated = (0, $8CUq3.xcss)({
    overflowWrap: 'anywhere'
});
const $81934a13d9aff585$var$linkTextStylesTruncated = (0, $8CUq3.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $81934a13d9aff585$var$ButtonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _19itglyw _11q7glyw _11c82smr _12ji1r31 _1qu21kw7 _12y31o36 _2rko1l7b _1bto1l2s _o5721q9c _syaz1kw7 _vwz47vkz _80omtlke _4t3igktf _p12f1osq _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $81934a13d9aff585$var$WrapperNoClick = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c82smr _2rko1l7b _1bto1l2s _o5721q9c _1e0c1ule _vwz47vkz _4t3i7vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kvDKs", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd30dfed800eb433$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fd30dfed800eb433$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    parentTitle: {
        "id": "issue-field-parent-readview-full.parent.summary.parent-title",
        "defaultMessage": "Click to visit {label}"
    }
});

});



parcelRegister("dVUnr", function(module, exports) {

$parcel$export(module.exports, "ParentInlineEditViewIsEditable", () => $76cb8a49f9e2e6b6$export$ed7c5b45ec99cbc3);
$parcel$export(module.exports, "ParentInlineEditView", () => $76cb8a49f9e2e6b6$export$536c9a0501611e73);

var $cVORO = parcelRequire("cVORO");

var $3Eb51 = parcelRequire("3Eb51");

var $jMcWx = parcelRequire("jMcWx");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $ctrpc = parcelRequire("ctrpc");

var $jrRyX = parcelRequire("jrRyX");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $e9Nf8 = parcelRequire("e9Nf8");

var $aMPNC = parcelRequire("aMPNC");

var $287DC = parcelRequire("287DC");

var $7VpOq = parcelRequire("7VpOq");
const $76cb8a49f9e2e6b6$var$isEqualParent = (a, b)=>a?.value === b?.value;
const $76cb8a49f9e2e6b6$export$ed7c5b45ec99cbc3 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, isTruncated: isTruncated, spacing: spacing = 'compact', emptyText: emptyText, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $jMcWx.default), fragmentRef);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name } = data;
    const fieldName = overriding.overrideLabel(name);
    const isFieldEditable = overriding?.overrideIsEditable(isEditable);
    const [commit] = (0, $8Uumt.useMutation)((0, $3Eb51.default));
    // #endregion
    const initialValue = (0, $5uXOq.useMemo)(()=>{
        if (data?.parentIssue) return (0, $aMPNC.transformParentNode)(data.parentIssue);
        return null;
    }, [
        data.parentIssue
    ]);
    // #region Common state
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const handleSubmit = (0, $5uXOq.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.((0, $7VpOq.transformOptionToAgg)(option));
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value?.toString() || null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateParentField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateParentField: {
                        success: true,
                        errors: [],
                        field: (0, $7VpOq.transformOptionToOptimisticFieldResponse)(data, option?.aggValue)
                    }
                }
            }
        });
    }, [
        onSubmit,
        commit,
        uniqueFieldId,
        data
    ]);
    const handleSubmitSucceeded = (0, $5uXOq.useCallback)((option)=>{
        onSubmitSucceeded?.((0, $7VpOq.transformOptionToAgg)(option));
    }, [
        onSubmitSucceeded
    ]);
    const setAnalyticsAttributes = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)((value)=>{
        if (initialValue !== value) {
            const oldValId = initialValue?.issueId;
            const newValId = value?.issueId || null;
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, oldValId, newValId);
        }
    }, [
        fieldId,
        initialValue
    ]) : undefined;
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $76cb8a49f9e2e6b6$var$isEqualParent,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            setAnalyticsAttributes: setAnalyticsAttributes
        },
        clipboardComponentType: 'parent'
    });
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $287DC.ParentReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            emptyText: emptyText,
            isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
        }), [
        data,
        isTruncated,
        emptyText,
        isSingleLineRowHeightEnabled
    ]);
    const getEditViewProps = (0, $5uXOq.useCallback)((fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            menuIsOpen: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? true : undefined,
            spacing: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? spacing : undefined
        }), [
        fieldName,
        handleChangeAndConfirm,
        menuPosition,
        menuPortalTarget,
        uniqueFieldId,
        updatedValue,
        spacing
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $e9Nf8.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
};
const $76cb8a49f9e2e6b6$export$536c9a0501611e73 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $cVORO.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76cb8a49f9e2e6b6$export$ed7c5b45ec99cbc3, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("cVORO", function(module, exports) {

$parcel$export(module.exports, "default", () => $31294af2760deb0d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d698883de3c28ee2d0fd655b48eeea5a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $31294af2760deb0d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraParentIssueField"
};
$31294af2760deb0d$var$node.hash = "935d17179ef6e93f2b74d57828fd1128";
var $31294af2760deb0d$export$2e2bcd8739ae039 = $31294af2760deb0d$var$node;

});

parcelRegister("3Eb51", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8e43d2df58fd59f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98aec3610b4a379420401d7a48984375>>
 * @relayHash 704342047dcb7ee4a52313b8f0658874
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID accf04fb25123d2e32dfe1810c369693125ab90e13d970e53673888eca402ab4
const $d8e43d2df58fd59f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "text"
    }, v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "parent_issueFieldParent_ParentField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraParentIssueField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "parent_issueFieldParent_ParentField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraParentIssueField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "parentIssue",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "concreteType": "JiraColorField",
                                                    "kind": "LinkedField",
                                                    "name": "issueColorField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "color",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "colorKey"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraSingleLineTextField",
                                                    "kind": "LinkedField",
                                                    "name": "summaryField",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "summary",
                                                                "issuetype",
                                                                "status"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSingleLineTextField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "issueTypeId"
                                                                                        },
                                                                                        v6 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "hierarchy",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "level"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v4 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueTypeField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraStatus",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "status",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatusCategory",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "statusCategory",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "statusCategoryId"
                                                                                                },
                                                                                                v4 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v4 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraStatusField"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                }
                                            ]
                                        },
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "accf04fb25123d2e32dfe1810c369693125ab90e13d970e53673888eca402ab4",
            "metadata": {},
            "name": "parent_issueFieldParent_ParentField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d8e43d2df58fd59f$var$node.hash = "8b384097fdc3b65908abb3c6f1e54624";
var $d8e43d2df58fd59f$export$2e2bcd8739ae039 = $d8e43d2df58fd59f$var$node;

});

parcelRegister("jMcWx", function(module, exports) {

$parcel$export(module.exports, "default", () => $23cde83622f0a2d0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9abb1f8c9079ae0f3104a44a0eb1027f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $23cde83622f0a2d0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "parent_issueFieldParentReadviewFull_ParentReadView"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v2 /*: any*/ ,
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "issueId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "color",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "ids",
                                "value": [
                                    "summary",
                                    "issuetype",
                                    "status"
                                ]
                            }
                        ],
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fieldsById",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "text"
                                                    }
                                                ],
                                                "type": "JiraSingleLineTextField"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "issueType",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "issueTypeId"
                                                            },
                                                            v2 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "xsmall"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                "kind": "LinkedField",
                                                                "name": "hierarchy",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "level"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraIssueTypeField"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraStatus",
                                                        "kind": "LinkedField",
                                                        "name": "status",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusCategoryId"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraStatusField"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                    }
                ]
            }
        ],
        "type": "JiraParentIssueField"
    };
}();
$23cde83622f0a2d0$var$node.hash = "775c06e162963a8091f5ade16c4c6b33";
var $23cde83622f0a2d0$export$2e2bcd8739ae039 = $23cde83622f0a2d0$var$node;

});

parcelRegister("e9Nf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c84fb8ab6530543$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $4c84fb8ab6530543$var$ParentEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("cdY39")), {
        moduleId: "c1f15ee7"
    }),
    getPreloadProps: ()=>({})
});
var $4c84fb8ab6530543$export$2e2bcd8739ae039 = $4c84fb8ab6530543$var$ParentEditViewEntryPoint;

});
parcelRegister("cdY39", function(module, exports) {

let $8e65479957b8c892$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e65479957b8c892$var$load("8Cl38").then(()=>parcelRequire('ghAiI'));

});


parcelRegister("aMPNC", function(module, exports) {

$parcel$export(module.exports, "transformParentNode", () => $66b4c8ff32c675fa$export$1b622b80a5cf731f);
$parcel$export(module.exports, "transformToSuggestions", () => $66b4c8ff32c675fa$export$6cffaaeb4c7c0c18);

var $gULOk = parcelRequire("gULOk");

var $heWHN = parcelRequire("heWHN");
const $66b4c8ff32c675fa$export$1b622b80a5cf731f = (edgeNode)=>{
    const fieldsEdges = edgeNode?.fieldsById?.edges || [];
    const summaryField = fieldsEdges.find((field)=>field?.node?.fieldId === 'summary');
    const issueTypeField = fieldsEdges.find((field)=>field?.node?.fieldId === 'issuetype');
    const statusField = fieldsEdges.find((field)=>field?.node?.fieldId === 'status');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKey = edgeNode?.issueColorField?.color?.colorKey;
    const checkParentIssueIsDone = (statusCategoryId)=>{
        const doneStatusCategoryId = (0, $gULOk).StatusCategoryIds[(0, $gULOk).StatusCategoryTypes.DONE];
        return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
    };
    const isDone = checkParentIssueIsDone(statusField?.node?.status?.statusCategory?.statusCategoryId || '');
    return {
        id: edgeNode?.id || '',
        key: edgeNode?.key || '',
        issueId: edgeNode?.issueId || undefined,
        webUrl: edgeNode?.webUrl || undefined,
        fields: {
            issuetype: {
                id: issueTypeField?.node?.issueType?.issueTypeId || '',
                name: issueTypeField?.node?.issueType?.name || '',
                iconUrl: issueTypeField?.node?.issueType?.avatar?.xsmall || ''
            },
            summary: summaryField?.node?.text || ''
        },
        color: colorKey in (0, $heWHN.MAP_FROM_SERVER_COLOR) ? (0, $heWHN.MAP_FROM_SERVER_COLOR)[colorKey] : undefined,
        value: edgeNode?.id || '',
        label: `${edgeNode?.key || ''} ${summaryField?.node?.text || ''}`,
        isDone: isDone,
        aggValue: edgeNode
    };
};
const $66b4c8ff32c675fa$export$6cffaaeb4c7c0c18 = (fieldOptionsData)=>(fieldOptionsData?.edges || [])?.filter((edge)=>edge?.node).map((edge)=>$66b4c8ff32c675fa$export$1b622b80a5cf731f(edge?.node));

});

parcelRegister("7VpOq", function(module, exports) {

$parcel$export(module.exports, "transformOptionToAgg", () => $082f0ca02f094e17$export$4e115b8a3d13d179);
$parcel$export(module.exports, "transformOptionToOptimisticFieldResponse", () => $082f0ca02f094e17$export$728251e8d8f6eacb);
const $082f0ca02f094e17$export$4e115b8a3d13d179 = (option)=>{
    if (!option) return null;
    return {
        id: String(option?.id) || '',
        issueId: option?.issueId || '',
        webUrl: option?.webUrl || '',
        key: option?.key,
        issueColorField: {
            color: {
                colorKey: option?.color || ''
            }
        },
        issueTypeField: {
            issueType: {
                avatar: {
                    xsmall: option?.fields?.issuetype?.iconUrl || ''
                },
                name: option?.fields?.issuetype?.name || ''
            }
        },
        summaryField: {
            text: option?.fields.summary || ''
        }
    };
};
const $082f0ca02f094e17$export$728251e8d8f6eacb = (field, aggValue)=>{
    const summaryField = aggValue?.fieldsById?.edges?.find((edge)=>edge?.node?.__typename === 'JiraSingleLineTextField');
    const issueTypeField = aggValue?.fieldsById?.edges?.find((edge)=>edge?.node?.__typename === 'JiraIssueTypeField');
    return {
        id: field?.id,
        fieldId: field?.fieldId,
        type: field?.type,
        name: field?.name,
        parentIssue: aggValue ? {
            id: aggValue?.id,
            issueId: aggValue?.issueId,
            webUrl: aggValue?.webUrl,
            key: aggValue?.key,
            issueColorField: aggValue?.issueColorField,
            fieldsById: aggValue?.fieldsById,
            summaryField: {
                id: summaryField?.node?.id || '',
                text: summaryField?.node?.text || ''
            },
            issueTypeField: {
                id: issueTypeField?.node?.id || '',
                issueType: {
                    id: issueTypeField?.node?.issueType?.id || '',
                    avatar: {
                        xsmall: issueTypeField?.node?.issueType?.avatar?.xsmall || ''
                    },
                    name: issueTypeField?.node?.issueType?.name || ''
                }
            }
        } : null
    };
};

});


parcelRegister("a4kK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f7eba3dfbcbdc2c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4f7eba3dfbcbdc2c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    replacedByParentField: {
        "id": "native-issue-table.common.issue-cells.parent.replaced-by-parent-field",
        "defaultMessage": "Replaced by <strong>Parent</strong> field"
    }
});

});


parcelRegister("4q4lw", function(module, exports) {

$parcel$export(module.exports, "PlainTextCell", () => $62e5cf95eca051b3$export$4e4b42df80bf4dce);
$parcel$export(module.exports, "PlainTextCellOld", () => $62e5cf95eca051b3$export$8361effa71bec5d8);

var $3ZEEt = parcelRequire("3ZEEt");

var $bkoDp = parcelRequire("bkoDp");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");

var $9YRSH = parcelRequire("9YRSH");

var $eZibI = parcelRequire("eZibI");

var $dpHMc = parcelRequire("dpHMc");

var $7mPT9 = parcelRequire("7mPT9");

var $cD1mV = parcelRequire("cD1mV");

var $e9M6d = parcelRequire("e9M6d");

var $Br57E = parcelRequire("Br57E");

var $czfFt = parcelRequire("czfFt");
// Attributes for inline editing track events
const $62e5cf95eca051b3$var$attributes = {
    // If the update was made inline (and not via the issue view)
    isInlineEditing: true
};
const $62e5cf95eca051b3$export$4e4b42df80bf4dce = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $bkoDp.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const isDensityCompact = !(0, $e9M6d.useIsDensityFull)();
    const contentRef = (0, $5uXOq.useRef)(null);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    const renderCustomReadView = (0, $5uXOq.useCallback)((text)=>{
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
        if (isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
            content: text,
            contentRef: contentRef
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                ref: (0, $7mPT9.default)(contentRef, ref),
                maxLines: (0, $czfFt.MAX_LINE_WRAP_NEW),
                testId: "native-issue-table.common.ui.issue-cells.plain-text.text"
            }, text));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            maxLines: isDensityCompact ? 2 : undefined
        }, text);
    }, [
        isDensityCompact,
        isSingleLineRowHeightEnabled
    ]);
    if (!isInlineEditingExtendedFieldSupportEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($62e5cf95eca051b3$export$8361effa71bec5d8, {
        fieldRef: data
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YRSH.SingleLineTextInlineEditViewWithIsEditable), {
        attributes: $62e5cf95eca051b3$var$attributes,
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        maxLength: 255,
        readViewFitContainerHeight: true,
        renderCustomReadView: isReadOnlyWithoutHoverPopover ? undefined : renderCustomReadView,
        hideEditButton: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
});
const $62e5cf95eca051b3$export$8361effa71bec5d8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false })=>{
    const { text: text } = (0, $8Uumt.useFragment)((0, $3ZEEt.default), fieldRef);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(shouldOpenOnFirstRender);
    const contentRef = (0, $5uXOq.useRef)(null);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    if (isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: text,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingBlock: "space.050",
            paddingInline: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            ref: (0, $7mPT9.default)(contentRef, ref),
            maxLines: (0, $czfFt.MAX_LINE_WRAP_NEW),
            testId: "native-issue-table.common.ui.issue-cells.plain-text.text"
        }, text)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cD1mV.TruncatedTextWithPopup), {
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, text),
        triggerText: text ?? null
    });
});

});
parcelRegister("3ZEEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $62f3c839506cb929$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e82052d0b1365d9ea76e4cdcc375b79a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $62f3c839506cb929$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "plainText_nativeIssueTable_PlainTextCellOld_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$62f3c839506cb929$var$node.hash = "1a8cd11903dcf3b1dee4235893fe7cd3";
var $62f3c839506cb929$export$2e2bcd8739ae039 = $62f3c839506cb929$var$node;

});

parcelRegister("bkoDp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d216f715e4362e50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e42ee4fe58e0ffcde26272e806d5be3c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d216f715e4362e50$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "plainText_nativeIssueTable_PlainTextCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "plainText_nativeIssueTable_PlainTextCellOld_fieldRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$d216f715e4362e50$var$node.hash = "8353edf6c7248abbd34dfd87bef397f4";
var $d216f715e4362e50$export$2e2bcd8739ae039 = $d216f715e4362e50$var$node;

});

parcelRegister("cD1mV", function(module, exports) {

$parcel$export(module.exports, "TruncatedTextWithPopup", () => $e598f531fa9db4a2$export$a81ef5b6e801751b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $9fuVs = parcelRequire("9fuVs");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5oFIy = parcelRequire("5oFIy");

var $czfFt = parcelRequire("czfFt");

var $jC7Sx = parcelRequire("jC7Sx");
const $e598f531fa9db4a2$export$a81ef5b6e801751b = /*#__PURE__*/ (0, $5uXOq.memo)(({ triggerText: triggerText, content: content, triggerRefCallback: triggerRefCallback, onSetIsOpen: onSetIsOpen, isOpen: isOpen, maxLength: maxLength = (0, $czfFt.MAX_LINE_WRAP_OLD) })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (!triggerText) return null;
    const onClick = ()=>{
        onSetIsOpen(!isOpen);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'truncatedTextWithPopupButton');
    };
    const trigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e598f531fa9db4a2$var$TruncatedTextContainer, {
            onClick: onClick,
            ...triggerProps,
            ref: (element)=>{
                triggerRefCallback && triggerRefCallback(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref(element);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e598f531fa9db4a2$var$TruncatedText, {
            maxLength: maxLength
        }, triggerText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>onSetIsOpen(false),
        messageId: "native-issue-table.common.ui.truncated-text-cell-with-popup.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                sourceName: "TruncatedTextPopUpContent",
                sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
            }, content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null)),
        trigger: trigger,
        placement: "bottom",
        popupComponent: (0, $jC7Sx.PopupContainer)
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e598f531fa9db4a2$var$TruncatedTextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7glyw _19itglyw _11c82smr _1rjc1b66 _18zru2gc _80omtlke _1e0c1ule _vchhusvi _syaz1fxt _4t3i1osq _1bsb1osq _6sshglyw _1oex4v9p _nt751r31 _49pcglyw _1hvw1o36 _7ehi64oc _irr3166n",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e598f531fa9db4a2$var$TruncatedText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_jz2kj3": (0, $lD23V.default)(__cmplp.maxLength)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _y3gn1e5h _1e0ccj1k _1bto1l2s _sudp1e54 _1yyjpeh7 _1nmz1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jC7Sx", function(module, exports) {

$parcel$export(module.exports, "PopupContainer", () => $f7051aadc1239b42$export$cca08eed9de89ba9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $k5uoT = parcelRequire("k5uoT");
// Workaround for https://github.com/atlassian-labs/compiled/issues/1200
const $f7051aadc1239b42$var$layerValue = (0, $k5uoT.layers).layer;
/**
 * Styling the container itself removes the need for an additional nested `<div>`,
 * containing our custom styles, in the Popup content. Having an extra `<div>`
 * introduces problems with autofocus when popup is opened.
 *
 * Unfortunately the base PopupContainer styles are not exported from atlaskit,
 * so they had to be copy + pasted and extended with our custom styles.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f7051aadc1239b42$var$StyledPopupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2rko1sit _1reo1wug _18m91wug _189eyh40 _1dqonqa1 _1h6d1p6i _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _1bsbdgin _c71l1kdj _1tke12am _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $f7051aadc1239b42$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f7051aadc1239b42$var$StyledPopupContainer, {
        ...props,
        ref: ref
    }));

});



parcelRegister("9Xsfm", function(module, exports) {

$parcel$export(module.exports, "PriorityCell", () => $e717e4f5d6190830$export$b526cf238a0a0ab3);

var $9b6ss = parcelRequire("9b6ss");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5Ch5h = parcelRequire("5Ch5h");

var $Br57E = parcelRequire("Br57E");

var $jFYC8 = parcelRequire("jFYC8");

var $e9M6d = parcelRequire("e9M6d");
const $e717e4f5d6190830$export$b526cf238a0a0ab3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $9b6ss.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ch5h.PriorityInlineEditViewIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
});

});
parcelRegister("9b6ss", function(module, exports) {

$parcel$export(module.exports, "default", () => $f340766dad6ec4f5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ff13e98fbb419ea356adc53734e2cb24>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f340766dad6ec4f5$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "priority_nativeIssueTable_PriorityCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraPriorityField"
};
$f340766dad6ec4f5$var$node.hash = "6802a1e026f22ca790d9f99b07f6e464";
var $f340766dad6ec4f5$export$2e2bcd8739ae039 = $f340766dad6ec4f5$var$node;

});

parcelRegister("5Ch5h", function(module, exports) {

$parcel$export(module.exports, "PriorityInlineEditViewIsEditable", () => $ddec859721a707b6$export$90b66d052260aa39);
$parcel$export(module.exports, "PriorityInlineEditView", () => $ddec859721a707b6$export$934d144304ae7d88);

var $liCec = parcelRequire("liCec");

var $fqQPM = parcelRequire("fqQPM");

var $abZ4D = parcelRequire("abZ4D");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dpHMc = parcelRequire("dpHMc");

var $4R6GH = parcelRequire("4R6GH");

var $ctrpc = parcelRequire("ctrpc");

var $jrRyX = parcelRequire("jrRyX");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $eXGH2 = parcelRequire("eXGH2");

var $3hZGL = parcelRequire("3hZGL");

var $cIZbf = parcelRequire("cIZbf");

var $jTnIA = parcelRequire("jTnIA");
const $ddec859721a707b6$var$isEqualPriority = (a, b)=>a?.value === b?.value;
const $ddec859721a707b6$export$90b66d052260aa39 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isCompact: isCompact, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitNew: onSubmitNew, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, onSubmitSucceededNew: onSubmitSucceededNew, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $abZ4D.default), fragmentRef);
    const { overriding: overriding } = (0, $4R6GH.fg)('relay-migration-issue-fields-priority') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jrRyX.useInlineEditFieldInjections)() : {
        overriding: undefined
    };
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, priority: priority } = data;
    const fieldName = (0, $5uXOq.useMemo)(()=>overriding && (0, $4R6GH.fg)('relay-migration-issue-fields-priority') ? overriding?.overrideLabel(name) : name, [
        name,
        overriding
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overriding && (0, $4R6GH.fg)('relay-migration-issue-fields-priority') ? overriding?.overrideIsEditable(isEditable) : isEditable, [
        isEditable,
        overriding
    ]);
    const filterOptionsById = (0, $4R6GH.fg)('relay-migration-issue-fields-priority') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>overriding?.overrideFieldOptionsFilter(null), [
        overriding
    ]) : undefined;
    const [commit] = (0, $8Uumt.useMutation)((0, $fqQPM.default));
    // #endregion
    const initialValue = (0, $5uXOq.useMemo)(()=>priority ? {
            label: priority.name ?? '',
            value: priority.id,
            iconUrl: priority.iconUrl ?? ''
        } : null, [
        priority
    ]);
    // #region Common state
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const handleSubmit = (0, $5uXOq.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        const aggValue = (0, $4R6GH.fg)('relay-migration-issue-fields-priority') ? (0, $jTnIA.transformOptionToAgg)(option) : undefined;
        if ((0, $4R6GH.fg)('relay-migration-issue-fields-priority')) // TODO remove eslint on relay-migration-issue-fields-priority' cleanup
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onSubmitNew?.(aggValue);
        else onSubmit?.(option);
        if (option?.value != null) commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updatePriorityField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updatePriorityField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            priority: (0, $4R6GH.fg)('relay-migration-issue-fields-priority') ? {
                                // TODO remove below eslints on relay-migration-issue-fields-priority' cleanup
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                id: aggValue.id,
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                iconUrl: aggValue.iconUrl,
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                name: aggValue.name
                            } : {
                                id: option.value,
                                iconUrl: option.iconUrl,
                                name: option.label
                            }
                        }
                    }
                }
            }
        });
    }, [
        onSubmit,
        onSubmitNew,
        commit,
        uniqueFieldId
    ]);
    const handleSubmitSucceeded = (0, $4R6GH.fg)('relay-migration-issue-fields-priority') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)((value)=>{
        onSubmitSucceededNew?.((0, $jTnIA.transformOptionToAgg)(value));
    }, [
        onSubmitSucceededNew
    ]) : undefined;
    const setAnalyticsAttributes = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)((value)=>{
        /* TODO https://hello.jira.atlassian.cloud/browse/DEE-6534 - extract priorityId from fragment to use for attributes */ (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, (0, $cIZbf.getPriorityIdFromAri)(initialValue?.value), (0, $cIZbf.getPriorityIdFromAri)(value?.value));
    }, [
        fieldId,
        initialValue
    ]) : undefined;
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $ddec859721a707b6$var$isEqualPriority,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: (0, $4R6GH.fg)('relay-migration-issue-fields-priority') ? handleSubmitSucceeded : onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        clipboardComponentType: 'priority',
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            setAnalyticsAttributes: setAnalyticsAttributes
        }
    });
    const readViewContentRef = (0, $5uXOq.useRef)(null);
    const renderReadView = (0, $5uXOq.useCallback)((ref = null)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3hZGL.PriorityReadView), {
                fragmentRef: data,
                isCompact: isCompact,
                contentRef: readViewContentRef,
                ref: ref
            }), [
        data,
        isCompact
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            openMenuOnFocus: true,
            menuPosition: menuPosition,
            filterOptionsById: filterOptionsById
        });
    const content = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
            editViewPopup: editViewPopup,
            editViewPopupAlignBlock: editViewPopupAlignBlock,
            editViewPopupMinWidth: "small",
            editViewEntryPoint: (0, $eXGH2.default),
            editViewEntryPointParams: {},
            getEditViewProps: getEditViewProps,
            fieldName: fieldName,
            hasUnsubmittedChanges: hasServerValidationError,
            invalidMessage: invalidMessage,
            isEditing: isEditing,
            isEditable: isFieldEditable,
            onCancel: handleCancel,
            onConfirm: handleConfirm,
            onEdit: handleEdit,
            onCopy: handleCopy,
            onCut: handleCut,
            onPaste: handlePaste,
            readViewFitContainerHeight: readViewFitContainerHeight,
            readView: ref ? renderReadView(ref) : renderReadView(),
            hideActionButtons: true
        });
    if (!shouldRenderHoverPopover) return content();
    const renderWithPopover = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
            content: data.priority?.name,
            contentRef: readViewContentRef
        }, ({ ref: ref })=>content(ref));
    return isEditing ? content() : renderWithPopover();
};
const $ddec859721a707b6$export$934d144304ae7d88 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $liCec.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ddec859721a707b6$export$90b66d052260aa39, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("liCec", function(module, exports) {

$parcel$export(module.exports, "default", () => $66dee7a34051acb9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa62d4fc64bc2c74e04363ef91ec33f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $66dee7a34051acb9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$66dee7a34051acb9$var$node.hash = "a5f9582db120fe1c7d1ede5d19fc0614";
var $66dee7a34051acb9$export$2e2bcd8739ae039 = $66dee7a34051acb9$var$node;

});

parcelRegister("fqQPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $44eb66a09030abe9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb32ad0218f1234eb10ceea6afef44da>>
 * @relayHash afc6cf650d76ec77ae6c4e967b74c46b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e85774926933c84980d45da86dae031162c7414ce78af28e54effc3c4a04a2fa
const $44eb66a09030abe9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraPriority",
        "kind": "LinkedField",
        "name": "priority",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPriorityFieldPayload",
                            "kind": "LinkedField",
                            "name": "updatePriorityField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraPriorityField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPriorityFieldPayload",
                            "kind": "LinkedField",
                            "name": "updatePriorityField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraPriorityField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e85774926933c84980d45da86dae031162c7414ce78af28e54effc3c4a04a2fa",
            "metadata": {},
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$44eb66a09030abe9$var$node.hash = "e0f2a7894e2dd7cf045761e8324c5c39";
var $44eb66a09030abe9$export$2e2bcd8739ae039 = $44eb66a09030abe9$var$node;

});

parcelRegister("abZ4D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5912a7934fc1acc2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a915f86f984bf0d357677c111ce3d858>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5912a7934fc1acc2$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "priority_issueFieldPriorityReadviewFull_PriorityReadView"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            }
        ],
        "type": "JiraPriorityField"
    };
}();
$5912a7934fc1acc2$var$node.hash = "d2dd68625b79ae7cbb16126a5aa64c95";
var $5912a7934fc1acc2$export$2e2bcd8739ae039 = $5912a7934fc1acc2$var$node;

});

parcelRegister("eXGH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $913a9d1d5e311fda$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $913a9d1d5e311fda$var$PriorityEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("cbAX7")), {
        moduleId: "079c16d8"
    }),
    getPreloadProps: ()=>({})
});
var $913a9d1d5e311fda$export$2e2bcd8739ae039 = $913a9d1d5e311fda$var$PriorityEditViewEntryPoint;

});
parcelRegister("cbAX7", function(module, exports) {

let $8df32d20cd572197$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8df32d20cd572197$var$load("bKKzv").then(()=>parcelRequire('gWbLK'));

});


parcelRegister("3hZGL", function(module, exports) {

$parcel$export(module.exports, "PriorityReadView", () => $95e5779a5ef6d68b$export$9ff40693dcfb2eb3);

var $9nkD9 = parcelRequire("9nkD9");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jjlQu = parcelRequire("jjlQu");

var $eZibI = parcelRequire("eZibI");
const $95e5779a5ef6d68b$export$9ff40693dcfb2eb3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ fragmentRef: fragmentRef, isCompact: isCompact, contentRef: contentRef }, ref)=>{
    const data = (0, $8Uumt.useFragment)((0, $9nkD9.default), fragmentRef);
    const value = data.priority;
    if (isCompact && (!value?.name || !value?.iconUrl)) return null;
    if (!value?.name || !value?.iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95e5779a5ef6d68b$var$Wrapper, {
        "data-testid": "issue-field-priority-readview-full.ui.priority.wrapper",
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
        url: value.iconUrl,
        alt: isCompact ? value.name : undefined
    }), !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95e5779a5ef6d68b$var$Text, {
        ref: contentRef
    }, value.name));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95e5779a5ef6d68b$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _4t3igktf _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $95e5779a5ef6d68b$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _18u0u2gc _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9nkD9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf4be3863affb50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac973913f9060bb519739c5dc997ac7d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5cf4be3863affb50$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priority_issueFieldPriorityReadviewFull_PriorityReadView",
    "selections": [
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$5cf4be3863affb50$var$node.hash = "332bda8ea012bca1bc3e1ad5426cb13a";
var $5cf4be3863affb50$export$2e2bcd8739ae039 = $5cf4be3863affb50$var$node;

});

parcelRegister("jjlQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f7206d8a029d15$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");

var $cSD7y = parcelRequire("cSD7y");

var $ZjEAB = parcelRequire("ZjEAB");
const $e7f7206d8a029d15$export$c6d2b2df39d78e5b = (0, $gwIPs.gridSize) * 2;
/* Represents an asynchronous icon loader that handles loading of icons from URLs with error handling.
 * It displays the icon fetched from the provided URL. In case of an error or if the URL is undefined,
 * a fallback UI component or placeholder is displayed.
 * This component accepts various props like URL, title, alt text, dimensions, and a fallback component
 * to customize the behavior and presentation of the loaded or placeholder icon.
 * The component also includes functionality to prevent the icon from being draggable.
 */ // eslint-disable-next-line jira/react/no-class-components
class $e7f7206d8a029d15$var$AsyncIconClass extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            url: undefined,
            title: undefined,
            alt: undefined,
            width: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            height: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            fallback: undefined
        };
    }
    render() {
        const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
        const width = this.convertSize(this.props.width ?? $e7f7206d8a029d15$export$c6d2b2df39d78e5b);
        const height = this.convertSize(this.props.height ?? $e7f7206d8a029d15$export$c6d2b2df39d78e5b);
        if (this.state.isBroken && fallback) return fallback();
        if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$Image, {
            src: url,
            width: width,
            height: height,
            title: title ?? undefined,
            alt: alt ?? '',
            onError: this.onError,
            /**
       * Disabling dragging so drags happen on the parent instead of this icon.
       */ draggable: false,
            "data-vc": "common-components-async-icon"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $e7f7206d8a029d15$var$placeholderStyles,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                height: height,
                width: width
            },
            backgroundColor: "color.background.input.hovered",
            testId: "common-components-async-icon.placeholder"
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isBroken: false
        }, this.onError = ()=>{
            this.setState({
                isBroken: true
            });
        }, this.convertSize = (size)=>size ? `${size}px` : '0';
    }
}
const $e7f7206d8a029d15$var$AsyncIcon = (0, $cSD7y.componentWithFG)('vc90_async_icon_general_perf_improvements', (0, $ZjEAB.MemoedAsyncIcon), $e7f7206d8a029d15$var$AsyncIconClass);
// Needed for snapshot tests to work correctly
$e7f7206d8a029d15$var$AsyncIcon.displayName = 'AsyncIcon';
var $e7f7206d8a029d15$export$2e2bcd8739ae039 = $e7f7206d8a029d15$var$AsyncIcon;
const $e7f7206d8a029d15$var$placeholderStyles = (0, $8CUq3.xcss)({
    borderRadius: '3px',
    display: 'flex',
    flex: 'none'
});
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f7206d8a029d15$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ZjEAB", function(module, exports) {

$parcel$export(module.exports, "MemoedAsyncIcon", () => $a726363776ab5174$export$2c246cc50fc239e3);
/* MemoedAsyncIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gwIPs = parcelRequire("gwIPs");
const $a726363776ab5174$export$c6d2b2df39d78e5b = (0, $gwIPs.gridSize) * 2;
const $a726363776ab5174$export$2c246cc50fc239e3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ url: url, title: title, alt: alt, width: width, height: height, fallback: fallback })=>{
    const [isBroken, setIsBroken] = (0, $5uXOq.useState)(false);
    const onError = (0, $5uXOq.useCallback)(()=>{
        setIsBroken(true);
    }, []);
    const convertSize = (0, $5uXOq.useCallback)((size)=>size ? `${size}px` : '0', []);
    if (isBroken && fallback) return fallback();
    const convertedWidth = convertSize(width ?? $a726363776ab5174$export$c6d2b2df39d78e5b);
    const convertedHeight = convertSize(height ?? $a726363776ab5174$export$c6d2b2df39d78e5b);
    if (url) return /*#__PURE__*/ $5uXOq.createElement($a726363776ab5174$var$Image, {
        src: url,
        width: convertedWidth,
        height: convertedHeight,
        title: title ?? undefined,
        alt: alt ?? '',
        onError: onError,
        /**
     * Disabling dragging so drags happen on the parent instead of this icon.
     */ draggable: false,
        "data-vc": "common-components-async-icon"
    });
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: convertedHeight,
            width: convertedWidth
        },
        "data-testid": "common-components-async-icon.placeholder",
        className: (0, $bwpsq.default)([
            "_2rko1l7b _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _bfhk1d5g"
        ])
    });
});
const $a726363776ab5174$var$placeholderStyles = null;
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a726363776ab5174$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});



parcelRegister("jTnIA", function(module, exports) {

$parcel$export(module.exports, "transformOptionToAgg", () => $47a7b38705d00527$export$4e115b8a3d13d179);

var $4R6GH = parcelRequire("4R6GH");

var $cIZbf = parcelRequire("cIZbf");
const $47a7b38705d00527$export$4e115b8a3d13d179 = (option)=>option ? {
        id: option.value,
        iconUrl: option.iconUrl,
        name: option.label,
        priorityId: (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? (0, $cIZbf.getPriorityIdFromAri)(option.value) : option.value?.split('/')?.pop() || option.value
    } : option;

});



parcelRegister("jocEA", function(module, exports) {

$parcel$export(module.exports, "ProjectCell", () => $f58580a4bcdde27f$export$a0acc7707bde1d3);

var $dl3WC = parcelRequire("dl3WC");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $20ivj = parcelRequire("20ivj");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dpHMc = parcelRequire("dpHMc");

var $e9M6d = parcelRequire("e9M6d");

var $hKMVG = parcelRequire("hKMVG");
const $f58580a4bcdde27f$export$a0acc7707bde1d3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, isRequired: isRequired, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { project: project } = (0, $8Uumt.useFragment)((0, $dl3WC.default), fieldRef);
    const isDensityFull = (0, $e9M6d.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const contentRef = (0, $5uXOq.useRef)(null);
    if (!isRequired && project == null) return null;
    if (project == null || project.name == null || project.key == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "project",
        reason: "Missing required fields"
    });
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f58580a4bcdde27f$var$AlignmentFix, {
        hasAvatar: Boolean(project.avatar?.large)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $20ivj.ProjectReadView), {
        value: {
            key: project.key,
            name: project.name,
            avatarUrls: {
                '48x48': project.avatar?.large ?? ''
            }
        },
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'tableIssueLink');
        },
        isTruncated: !isDensityFull
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: project.name,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f58580a4bcdde27f$var$AlignmentFix, {
            hasAvatar: Boolean(project.avatar?.large),
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $20ivj.ProjectReadView), {
            value: {
                key: project.key,
                name: project.name,
                avatarUrls: {
                    '48x48': project.avatar?.large ?? ''
                }
            },
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                }), 'tableIssueLink');
            },
            isTruncated: !isDensityFull,
            contentRef: contentRef
        })));
});
// The Project component has a 4px padding plus the avatar inside has a 2px invisible border that we have to account for
// Refer to: src/packages/issue/fields/project/src/ui/view/main.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f58580a4bcdde27f$var$AlignmentFix = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasAvatar: hasAvatar, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ogwtze3t _6tinze3t _1cezze3t _m3zkze3t",
            __cmplp.hasAvatar ? "_18u01i6y" : "_18u0ze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dl3WC", function(module, exports) {

$parcel$export(module.exports, "default", () => $984fb642af5842fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d4391b734baea4c914f9e60292024f8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $984fb642af5842fe$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "project_nativeIssueTable_ProjectCell",
    "selections": [
        {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "large"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProjectField"
};
$984fb642af5842fe$var$node.hash = "c851920165e477cda5ca7d8297976e75";
var $984fb642af5842fe$export$2e2bcd8739ae039 = $984fb642af5842fe$var$node;

});

parcelRegister("20ivj", function(module, exports) {

$parcel$export(module.exports, "ProjectReadView", () => $8724762dba6fa853$export$5c3359f22f4596bc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $8724762dba6fa853$export$5c3359f22f4596bc = ({ value: value, noValueText: noValueText, onClick: onClick, isTruncated: isTruncated = true, contentRef: contentRef })=>{
    const onClickLink = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        e.stopPropagation();
        onClick && onClick(e);
    }, [
        onClick
    ]);
    if (value === undefined || value === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8724762dba6fa853$var$emptyValueContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8724762dba6fa853$var$EmptyValue, {
        "data-testid": "issue-field-project.ui.view-read-view-empty-value"
    }, noValueText || ''));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const stopPropagation = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8724762dba6fa853$var$ReadViewContainer, {
        "data-component-selector": "project-read-view-container"
    }, Boolean(value.avatarUrls['48x48']) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8724762dba6fa853$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "xsmall",
        src: value.avatarUrls['48x48'],
        borderColor: "transparent",
        testId: "issue-field-project.ui.project-avatar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8724762dba6fa853$var$labelContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        testId: "issue-field-project.ui.view-label-link",
        onClick: onClickLink,
        onKeyUp: stopPropagation,
        onKeyDown: stopPropagation,
        href: `/projects/${value.key}`,
        xcss: [
            $8724762dba6fa853$var$labelLinkStylesBase,
            isTruncated ? $8724762dba6fa853$var$labelLinkStylesTruncated : $8724762dba6fa853$var$labelLinkStylesNonTruncated
        ],
        ref: contentRef
    }, value.name)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8724762dba6fa853$var$EmptyValue = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});
const $8724762dba6fa853$var$ReadViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _p12fuuw1 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $8724762dba6fa853$var$emptyValueContainerStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.075'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8724762dba6fa853$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $8724762dba6fa853$var$labelContainerStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    minWidth: '0',
    marginRight: 'space.100'
});
const $8724762dba6fa853$var$labelLinkStylesBase = (0, $8CUq3.xcss)({
    display: 'inline-block',
    maxWidth: '100%',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $8724762dba6fa853$var$labelLinkStylesTruncated = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $8724762dba6fa853$var$labelLinkStylesNonTruncated = (0, $8CUq3.xcss)({
    overflowWrap: 'anywhere'
});

});


parcelRegister("9RbW4", function(module, exports) {

$parcel$export(module.exports, "RadioSelectCell", () => $e1f19eca876e29ff$export$fca29406b7991f70);

var $b9RMq = parcelRequire("b9RMq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $iXNqX = parcelRequire("iXNqX");

var $jFYC8 = parcelRequire("jFYC8");

var $Br57E = parcelRequire("Br57E");

var $e9M6d = parcelRequire("e9M6d");
const $e1f19eca876e29ff$export$fca29406b7991f70 = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $b9RMq.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXNqX.RadioSelectInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        maxLines: 1,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
};

});
parcelRegister("b9RMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $25634aa7223c0cb9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e866447ded66af1176c20edd32f4008a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $25634aa7223c0cb9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "radioSelect_nativeIssueTable_RadioSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraRadioSelectField"
};
$25634aa7223c0cb9$var$node.hash = "4ddf81d7a8f53773f53f258f07e3add7";
var $25634aa7223c0cb9$export$2e2bcd8739ae039 = $25634aa7223c0cb9$var$node;

});

parcelRegister("iXNqX", function(module, exports) {

$parcel$export(module.exports, "RadioSelectInlineEditViewWithIsEditable", () => $74d0cf7746b05c72$export$75b30b2e24d95c5b);

var $1HoXs = parcelRequire("1HoXs");

var $gKg9a = parcelRequire("gKg9a");

var $93bnX = parcelRequire("93bnX");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $8Ne5u = parcelRequire("8Ne5u");

var $6VRAM = parcelRequire("6VRAM");

var $jrRyX = parcelRequire("jrRyX");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $74d0cf7746b05c72$var$isEqualOption = (a, b)=>a?.value === b?.value;
const $74d0cf7746b05c72$export$75b30b2e24d95c5b = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, maxLines: maxLines, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $93bnX.default), fragmentRef);
    const [commit] = (0, $8Uumt.useMutation)((0, $gKg9a.default));
    const { id: uniqueFieldId, name: name, selectedOption: selectedOption, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $5uXOq.useMemo)(()=>{
        if (!selectedOption?.label) return null;
        return {
            value: selectedOption?.value ?? '',
            label: selectedOption?.label ?? ''
        };
    }, [
        selectedOption
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $5uXOq.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(option);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value ?? null
                    }
                }
            },
            onCompleted (response) {
                if (response.jira?.updateRadioSelectField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateRadioSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedOption: {
                                id: option?.value ?? '',
                                label: option?.label ?? '',
                                value: option?.value ?? ''
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $74d0cf7746b05c72$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'radioSelect'
    });
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6VRAM.RadioSelectReadView), {
            fragmentRef: data,
            maxLines: maxLines,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        }), [
        data,
        maxLines,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChangeAndConfirm,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $8Ne5u.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $74d0cf7746b05c72$export$2fe0a2918d206b4f = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $8Uumt.useFragment)((0, $1HoXs.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($74d0cf7746b05c72$export$75b30b2e24d95c5b, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("1HoXs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea6309f16feb5f2c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a9b2d76f8b35cc5bb4a87c0769a312f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ea6309f16feb5f2c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraRadioSelectField"
};
$ea6309f16feb5f2c$var$node.hash = "dd081df58866af7dd0bb2712ac60b258";
var $ea6309f16feb5f2c$export$2e2bcd8739ae039 = $ea6309f16feb5f2c$var$node;

});

parcelRegister("gKg9a", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b7148a35ef0575a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ea01358b1a136fbd5aaaddd170b218a>>
 * @relayHash 8d969d5c4138633fa2c8d684c8d49929
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a9727b3dde65ac24d78ecc1c5fbefd04f2f7ea21234ed28165e96f0478c25976
const $0b7148a35ef0575a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "radioSelect_issueFieldRadioSelect_RadioSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRadioSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateRadioSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraRadioSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "radioSelect_issueFieldRadioSelect_RadioSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRadioSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateRadioSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraRadioSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "selectedOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "label",
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "alias": "value",
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a9727b3dde65ac24d78ecc1c5fbefd04f2f7ea21234ed28165e96f0478c25976",
            "metadata": {},
            "name": "radioSelect_issueFieldRadioSelect_RadioSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0b7148a35ef0575a$var$node.hash = "c21145b09e3422aaf4c5cef7684d37b2";
var $0b7148a35ef0575a$export$2e2bcd8739ae039 = $0b7148a35ef0575a$var$node;

});

parcelRegister("93bnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $48d62b9f972c89e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<59c263de72de7e78a494bb2126d6f5c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $48d62b9f972c89e2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "selectedOption",
            "plural": false,
            "selections": [
                {
                    "alias": "value",
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "alias": "label",
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ],
    "type": "JiraRadioSelectField"
};
$48d62b9f972c89e2$var$node.hash = "e7794cc18631c54a9305078af2e6b52a";
var $48d62b9f972c89e2$export$2e2bcd8739ae039 = $48d62b9f972c89e2$var$node;

});

parcelRegister("8Ne5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $a49561c847f7265d$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $a49561c847f7265d$var$RadioSelectEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("8cJJu")), {
        moduleId: "d70243cc"
    }),
    getPreloadProps: ()=>({})
});
var $a49561c847f7265d$export$2e2bcd8739ae039 = $a49561c847f7265d$var$RadioSelectEditViewEntryPoint;

});
parcelRegister("8cJJu", function(module, exports) {

let $5f92eb442545f29a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f92eb442545f29a$var$load("phCSH").then(()=>parcelRequire('2wBQ6'));

});


parcelRegister("6VRAM", function(module, exports) {

$parcel$export(module.exports, "RadioSelectReadView", () => $e32cec467e6f5fb1$export$6455a2bb536ab8db);

var $1bGzd = parcelRequire("1bGzd");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dS3PR = parcelRequire("dS3PR");

var $eZibI = parcelRequire("eZibI");

var $dpHMc = parcelRequire("dpHMc");

var $7mPT9 = parcelRequire("7mPT9");
const $e32cec467e6f5fb1$export$6455a2bb536ab8db = ({ fragmentRef: fragmentRef, maxLines: maxLines, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $1bGzd.default), fragmentRef);
    const { selectedOption: selectedOption } = data;
    const contentRef = (0, $5uXOq.useRef)(null);
    if (!selectedOption?.label) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    if (shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: selectedOption?.label,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            maxLines: maxLines,
            ref: (0, $7mPT9.default)(ref, contentRef)
        }, selectedOption?.label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        maxLines: maxLines,
        ref: contentRef
    }, selectedOption?.label);
};

});
parcelRegister("1bGzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d807ebf9d2cf7ff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab557e702f4181aa0c25ff386cecf1ff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4d807ebf9d2cf7ff$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView",
    "selections": [
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "selectedOption",
            "plural": false,
            "selections": [
                {
                    "alias": "label",
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ],
    "type": "JiraRadioSelectField"
};
$4d807ebf9d2cf7ff$var$node.hash = "b7b019c3c9e9a0bdd2c7ccf008f19f38";
var $4d807ebf9d2cf7ff$export$2e2bcd8739ae039 = $4d807ebf9d2cf7ff$var$node;

});




parcelRegister("jDPUV", function(module, exports) {

$parcel$export(module.exports, "RequestTypeCell", () => $2a3f9855f6df20cc$export$f5707174b12c16a9);

var $lEghO = parcelRequire("lEghO");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $dpHMc = parcelRequire("dpHMc");

var $hKMVG = parcelRequire("hKMVG");

var $e9M6d = parcelRequire("e9M6d");
const $2a3f9855f6df20cc$var$REQUEST_TYPE_IMAGE_SIZE = 16;
const $2a3f9855f6df20cc$export$f5707174b12c16a9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { requestType: requestType } = (0, $8Uumt.useFragment)((0, $lEghO.default), fieldRef);
    const hoverPopoverEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const contentRef = (0, $5uXOq.useRef)(null);
    if (!requestType) return null;
    if (!requestType.name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "requestType",
        reason: "Missing required fields"
    });
    const content = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "center",
            space: "space.100",
            ref: ref
        }, requestType?.avatar?.xsmall && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $2a3f9855f6df20cc$var$imageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
            src: requestType.avatar.xsmall,
            width: $2a3f9855f6df20cc$var$REQUEST_TYPE_IMAGE_SIZE,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span",
            xcss: hoverPopoverEnabled ? $2a3f9855f6df20cc$var$textEllipsesStyles : $2a3f9855f6df20cc$var$textOverflowStyles,
            ref: contentRef
        }, requestType.name));
    if (hoverPopoverEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: requestType.name,
        contentRef: contentRef
    }, ({ ref: ref })=>content(ref));
    return content();
});
const $2a3f9855f6df20cc$var$imageContainerStyles = (0, $8CUq3.xcss)({
    display: 'inline',
    height: `${$2a3f9855f6df20cc$var$REQUEST_TYPE_IMAGE_SIZE}px`
});
const $2a3f9855f6df20cc$var$textOverflowStyles = (0, $8CUq3.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});
const $2a3f9855f6df20cc$var$textEllipsesStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordBreak: 'break-word'
});

});
parcelRegister("lEghO", function(module, exports) {

$parcel$export(module.exports, "default", () => $52e2645a9e5ccfc1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e711fe99884e965a8947360643fa4d6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $52e2645a9e5ccfc1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "requestType_nativeIssueTable_RequestTypeCell",
    "selections": [
        {
            "concreteType": "JiraServiceManagementRequestType",
            "kind": "LinkedField",
            "name": "requestType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "xsmall"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraServiceManagementRequestTypeField"
};
$52e2645a9e5ccfc1$var$node.hash = "e6355f63f017fb970ee2b3c6b04144d9";
var $52e2645a9e5ccfc1$export$2e2bcd8739ae039 = $52e2645a9e5ccfc1$var$node;

});


parcelRegister("f1enQ", function(module, exports) {

$parcel$export(module.exports, "ResolutionCell", () => $b29a9384c291419d$export$8b67413bfec99fe);

var $a36v3 = parcelRequire("a36v3");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $dpHMc = parcelRequire("dpHMc");

var $7mPT9 = parcelRequire("7mPT9");

var $e9M6d = parcelRequire("e9M6d");

var $dQ85J = parcelRequire("dQ85J");
const $b29a9384c291419d$export$8b67413bfec99fe = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { resolution: resolution } = (0, $8Uumt.useFragment)((0, $a36v3.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const contentRef = (0, $5uXOq.useRef)(null);
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b29a9384c291419d$var$Cell, {
        "data-vc": "native-issue-table-ui-resolution-cell"
    }, resolution?.name ?? formatMessage((0, $dQ85J.default).unresolved));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: resolution?.name ?? formatMessage((0, $dQ85J.default).unresolved),
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b29a9384c291419d$var$Cell, {
            "data-vc": "native-issue-table-ui-resolution-cell",
            ref: (0, $7mPT9.default)(contentRef, ref)
        }, resolution?.name ?? formatMessage((0, $dQ85J.default).unresolved)));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b29a9384c291419d$var$Cell = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a36v3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4c899b86500212e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c735683ae8c3dfc9825b7e9760388a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c4c899b86500212e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "resolution_nativeIssueTable_ResolutionCell",
    "selections": [
        {
            "concreteType": "JiraResolution",
            "kind": "LinkedField",
            "name": "resolution",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraResolutionField"
};
$c4c899b86500212e$var$node.hash = "f08df2df05baaf8922c9554fb39bd5f7";
var $c4c899b86500212e$export$2e2bcd8739ae039 = $c4c899b86500212e$var$node;

});

parcelRegister("dQ85J", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5882e7f4bfac1d8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a5882e7f4bfac1d8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unresolved: {
        "id": "native-issue-table.common.issue-cells.resolution.unresolved",
        "defaultMessage": "Unresolved"
    }
});

});


parcelRegister("eMbHQ", function(module, exports) {

$parcel$export(module.exports, "RichTextCell", () => $384b9ffa506d4339$export$b77590c339790c17);

var $bnLLr = parcelRequire("bnLLr");

var $1sYzb = parcelRequire("1sYzb");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eZJjh = parcelRequire("eZJjh");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $koeKL = parcelRequire("koeKL");

var $4mO32 = parcelRequire("4mO32");

var $dpHMc = parcelRequire("dpHMc");

var $7XluA = parcelRequire("7XluA");

var $79UpA = parcelRequire("79UpA");

var $e9M6d = parcelRequire("e9M6d");

var $czfFt = parcelRequire("czfFt");

var $3CS3w = parcelRequire("3CS3w");

var $3ruij = parcelRequire("3ruij");

var $fXlXK = parcelRequire("fXlXK");

var $bvTOt = parcelRequire("bvTOt");
const $384b9ffa506d4339$export$b77590c339790c17 = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueKey: issueKey, fieldRef: fieldRef, issueRef: issueRef, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { richText: richText, fieldId: fieldId } = (0, $8Uumt.useFragment)((0, $1sYzb.default), fieldRef);
    const issueData = (0, $8Uumt.useFragment)((0, $bnLLr.default), issueRef || null);
    const isDensityFull = (0, $e9M6d.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            fieldId: fieldId,
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        fieldId,
        cloudId,
        issueKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $fXlXK.richTextPopUpContentEntryPoint), entryPointParams);
    if (isSingleLineRowHeightEnabled && !isDensityFull) {
        const previewText = richText?.adfValue?.convertedPlainText?.plainText;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79UpA.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
                content: previewText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                    entryPointReferenceSubject: entryPointReferenceSubject,
                    id: "rich-text-popup-content",
                    packageName: (0, $czfFt.PACKAGE_NAME),
                    errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvTOt.ErrorState), null),
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                        size: "medium"
                    }),
                    runtimeProps: {}
                }),
                entryPointActions: entryPointActions,
                isInteractive: true,
                isFixedWidth: true
            }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
                    xcss: $384b9ffa506d4339$var$richTextCellWrapperStyles,
                    ref: ref,
                    ...props
                }, previewText))));
    }
    if (isDensityFull) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3ruij.RichTextCellFull), {
        issueKey: issueKey,
        richText: richText?.adfValue?.json || '',
        canBeExported: issueData?.canBeExported
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3CS3w.RichTextCellCompact), {
        fieldId: fieldId,
        plainText: richText?.adfValue?.convertedPlainText?.plainText || '',
        issueKey: issueKey,
        shouldOpenOnFirstRender: shouldOpenOnFirstRender
    });
});
const $384b9ffa506d4339$var$richTextCellWrapperStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    display: 'block',
    backgroundColor: 'color.background.neutral.subtle',
    boxSizing: 'border-box',
    height: '100%',
    font: 'font.body',
    width: '100%',
    textAlign: 'left',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderRadius: 'border.radius',
    // @ts-expect-error Transparent is not valid but should be
    borderColor: 'transparent',
    ':focus': {
        borderColor: 'color.border.focused',
        outline: 'none'
    }
});

});
parcelRegister("bnLLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $72b4f6a77e41f135$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7015fe40c096d2611995826fe9007308>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $72b4f6a77e41f135$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        }
    ],
    "kind": "Fragment",
    "name": "richText_nativeIssueTable_RichTextCell_issueRef",
    "selections": [
        {
            "condition": "isDensityFull",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canBeExported"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$72b4f6a77e41f135$var$node.hash = "6b89e8c15c1698f5f6af6c467470897f";
var $72b4f6a77e41f135$export$2e2bcd8739ae039 = $72b4f6a77e41f135$var$node;

});

parcelRegister("1sYzb", function(module, exports) {

$parcel$export(module.exports, "default", () => $83e3352ab44b4651$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bda41d384640311154c7f8d58b578860>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $83e3352ab44b4651$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        }
    ],
    "kind": "Fragment",
    "name": "richText_nativeIssueTable_RichTextCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "concreteType": "JiraRichText",
            "kind": "LinkedField",
            "name": "richText",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraADF",
                    "kind": "LinkedField",
                    "name": "adfValue",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isDensityFull",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAdfToConvertedPlainText",
                                    "kind": "LinkedField",
                                    "name": "convertedPlainText",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "plainText"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isDensityFull",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "json"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraRichTextField"
};
$83e3352ab44b4651$var$node.hash = "9735b308958216a9c39073bc5e73008a";
var $83e3352ab44b4651$export$2e2bcd8739ae039 = $83e3352ab44b4651$var$node;

});

parcelRegister("3CS3w", function(module, exports) {

$parcel$export(module.exports, "RichTextCellCompact", () => $d6cdcea47e0dc98e$export$367da69f6099f447);

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koeKL = parcelRequire("koeKL");

var $czfFt = parcelRequire("czfFt");

var $cD1mV = parcelRequire("cD1mV");

var $bvTOt = parcelRequire("bvTOt");

var $fXlXK = parcelRequire("fXlXK");
const $d6cdcea47e0dc98e$var$runtimeProps = {};
const $d6cdcea47e0dc98e$export$367da69f6099f447 = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueKey: issueKey, fieldId: fieldId, plainText: plainText, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            fieldId: fieldId,
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        fieldId,
        cloudId,
        issueKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $fXlXK.richTextPopUpContentEntryPoint), entryPointParams);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(shouldOpenOnFirstRender);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cD1mV.TruncatedTextWithPopup), {
        triggerText: plainText,
        triggerRefCallback: triggerRef,
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "rich-text-popup-content",
            packageName: (0, $czfFt.PACKAGE_NAME),
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvTOt.ErrorState), null),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "medium"
            }),
            runtimeProps: $d6cdcea47e0dc98e$var$runtimeProps
        })
    });
});

});
parcelRegister("bvTOt", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $a0ebde9dda3ceefe$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dD7Zc = parcelRequire("dD7Zc");

var $koVbs = parcelRequire("koVbs");

var $LbmDs = parcelRequire("LbmDs");

var $jlyS1 = parcelRequire("jlyS1");
const $a0ebde9dda3ceefe$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0ebde9dda3ceefe$var$StyledBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jlyS1.StyledText), null, formatMessage((0, $LbmDs.default).errorMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a0ebde9dda3ceefe$var$StyledBox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1tkeqkoa _1bah1h6o _19pkutpp _2hwx1ejb _otyrpxbi _18u01ejb _w8l5t9kd _1752t9kd",
            __cmplp.className
        ])
    });
});

});
parcelRegister("LbmDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb3f094048a146b1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $bb3f094048a146b1$var$messages = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "native-issue-table.common.issue-cells.rich-text.error-state.error-message",
        "defaultMessage": "Something went wrong. Close and re-open this modal to try again."
    }
});
var $bb3f094048a146b1$export$2e2bcd8739ae039 = $bb3f094048a146b1$var$messages;

});

parcelRegister("jlyS1", function(module, exports) {

$parcel$export(module.exports, "StyledText", () => $bc8efbb655cf08e0$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bc8efbb655cf08e0$var$StyledTextComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $bc8efbb655cf08e0$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc8efbb655cf08e0$var$StyledTextComponent, props));

});


parcelRegister("fXlXK", function(module, exports) {

$parcel$export(module.exports, "richTextPopUpContentEntryPoint", () => $50e34bcb9a00af2c$export$6c4574991456a42);

var $auBrj = parcelRequire("auBrj");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $50e34bcb9a00af2c$export$6c4574991456a42 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("kI8Ge")), {
        moduleId: "e30443a3"
    }),
    getPreloadProps: ({ issueKey: issueKey, fieldId: fieldId, cloudId: cloudId })=>({
            queries: {
                richTextContent: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $auBrj.default,
                    variables: {
                        issueKey: issueKey,
                        fieldId: fieldId,
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                issueKey: issueKey
            }
        })
});

});
parcelRegister("auBrj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d18bb083ff07a014$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<43f95445791158b53e4f62c754a7e121>>
 * @relayHash f3f5453a258ab6fd76ff8a41380a7ce3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2da8aad6f8f4b5efabc8cdc7b5e6df47535b423f8314048978d461b2553a816e
const $d18bb083ff07a014$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2da8aad6f8f4b5efabc8cdc7b5e6df47535b423f8314048978d461b2553a816e",
        "metadata": {},
        "name": "ui_RichTextPopUpContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d18bb083ff07a014$export$2e2bcd8739ae039 = $d18bb083ff07a014$var$node;

});

parcelRegister("kI8Ge", function(module, exports) {

let $f13ea664e835fe85$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f13ea664e835fe85$var$load("5HVOa").then(()=>parcelRequire('iRY9Q'));

});



parcelRegister("3ruij", function(module, exports) {

$parcel$export(module.exports, "RichTextCellFull", () => $96049b5680c83b77$export$e41920e4ba1d08f2);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $kJsz8 = parcelRequire("kJsz8");

var $kr1RU = parcelRequire("kr1RU");
const $96049b5680c83b77$export$e41920e4ba1d08f2 = /*#__PURE__*/ (0, $5uXOq.memo)(({ richText: richText, issueKey: issueKey, canBeExported: canBeExported })=>{
    const viewContext = (0, $kJsz8.useLazyMediaViewContext)(issueKey);
    const disableMediaDownload = canBeExported === false && (0, $4R6GH.fg)('block_attachment_download_on_data_export_dsp_rule');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $96049b5680c83b77$var$richTextCellWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kr1RU.AsyncRichTextRenderer), {
        mediaContext: {
            viewContext: viewContext,
            uploadContext: null,
            userAuth: null
        },
        adfDocument: richText,
        disableMediaDownload: disableMediaDownload
    }));
});
const $96049b5680c83b77$var$richTextCellWrapperStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100'
});

});
parcelRegister("kr1RU", function(module, exports) {

$parcel$export(module.exports, "AsyncRichTextRenderer", () => $a2553053894ff1a9$export$7e19ac09148aecfa);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $a2553053894ff1a9$var$LazyRichTextRenderer = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("lKnu9")), {
    moduleId: "./src/packages/platform/ui/issue-table/issue-table/src/common/ui/issue-cells/rich-text/rich-text-renderer/main.tsx"
});
const $a2553053894ff1a9$export$7e19ac09148aecfa = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-rich-text-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2553053894ff1a9$var$LazyRichTextRenderer, props));

});
parcelRegister("lKnu9", function(module, exports) {

let $fd501c87c0859462$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fd501c87c0859462$var$load("4pw5j").then(()=>parcelRequire('aJL6b'));

});




parcelRegister("cNbPb", function(module, exports) {

$parcel$export(module.exports, "SingleSelectCell", () => $6f283e136e165729$export$2574fb9bde9d7289);

var $kgMYf = parcelRequire("kgMYf");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $iaso1 = parcelRequire("iaso1");

var $jFYC8 = parcelRequire("jFYC8");

var $Br57E = parcelRequire("Br57E");

var $e9M6d = parcelRequire("e9M6d");
const $6f283e136e165729$export$2574fb9bde9d7289 = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $kgMYf.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaso1.SingleSelectInlineEditViewIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        shouldShowPopover: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
};

});
parcelRegister("kgMYf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c108782b3459c980$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d57f69fb6ad9a352f21f1cb6aee4989>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c108782b3459c980$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "singleSelect_nativeIssueTable_SingleSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectField"
};
$c108782b3459c980$var$node.hash = "aa28f66296203077a00025e9c2e0ba1b";
var $c108782b3459c980$export$2e2bcd8739ae039 = $c108782b3459c980$var$node;

});

parcelRegister("iaso1", function(module, exports) {

$parcel$export(module.exports, "SingleSelectInlineEditView", () => $1d48f3e5ebbc3bee$export$dd40a625fe2da362);
$parcel$export(module.exports, "SingleSelectInlineEditViewIsEditable", () => $1d48f3e5ebbc3bee$export$abac8bafb7f6b6d4);

var $e93yC = parcelRequire("e93yC");

var $jVlS7 = parcelRequire("jVlS7");

var $lmlbH = parcelRequire("lmlbH");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $hTdh6 = parcelRequire("hTdh6");

var $lXLX3 = parcelRequire("lXLX3");

var $7F8HM = parcelRequire("7F8HM");

var $jrRyX = parcelRequire("jrRyX");

var $aDaXQ = parcelRequire("aDaXQ");
const $1d48f3e5ebbc3bee$export$35f807a25e63be2d = (a, b)=>a?.value === b?.value;
const $1d48f3e5ebbc3bee$export$dd40a625fe2da362 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $lmlbH.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1d48f3e5ebbc3bee$export$abac8bafb7f6b6d4, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};
const $1d48f3e5ebbc3bee$export$abac8bafb7f6b6d4 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, spacing: spacing = 'compact', menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, readViewFitContainerHeight: readViewFitContainerHeight, isEditable: isEditable, shouldShowPopover: shouldShowPopover })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $jVlS7.default), fragmentRef);
    const [commit] = (0, $8Uumt.useMutation)((0, $e93yC.default));
    const { id: uniqueFieldId, name: name, fieldOption: fieldOption, fieldId: fieldId, type: fieldType } = data;
    // #endregion Relay
    // #region State
    const initialValue = (0, $5uXOq.useMemo)(()=>fieldOption ? {
            label: fieldOption.value ?? '',
            value: fieldOption.id ?? '',
            optionId: fieldOption.optionId ?? ''
        } : null, [
        fieldOption
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable, overrideFieldOptionsFilter: overrideFieldOptionsFilter } = overriding;
    const fieldName = (0, $5uXOq.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const filterOptionsById = (0, $5uXOq.useMemo)(()=>overrideFieldOptionsFilter(null), [
        overrideFieldOptionsFilter
    ]);
    // #endregion State
    // #region Action
    const handleSubmit = (0, $5uXOq.useCallback)((newOption, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newOption);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newOption?.value ?? null
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateSingleSelectField?.success) onSuccess();
                else {
                    const errorMessage = response.jira?.updateSingleSelectField?.errors?.[0]?.message ?? undefined;
                    errorMessage ? onFail(new Error(`Relay error encountered while updating single select field - ${errorMessage}`), errorMessage) : onFail();
                }
            },
            onError: (error)=>onFail(error, error.message),
            optimisticResponse: {
                jira: {
                    updateSingleSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: name,
                            fieldId: fieldId,
                            type: fieldType,
                            fieldOptions: null,
                            fieldOption: newOption ? {
                                id: newOption.value,
                                optionId: newOption.optionId,
                                value: newOption.label,
                                color: null
                            } : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldType,
        name,
        onSubmit,
        uniqueFieldId
    ]);
    const actions = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        isValueEqual: $1d48f3e5ebbc3bee$export$35f807a25e63be2d,
        clipboardComponentType: 'singleSelect'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = actions;
    // #endregion Action
    // #region View
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aDaXQ.SingleSelectReadView), {
            fieldType: fieldType,
            fragmentRef: data,
            shouldShowPopover: shouldShowPopover
        }), [
        data,
        fieldType,
        shouldShowPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            fieldType: fieldType,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChangeAndConfirm,
            filterOptionsById: filterOptionsById,
            spacing: spacing,
            openMenuOnFocus: true
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $hTdh6.default),
        editViewEntryPointParams: {
            id: uniqueFieldId,
            filterById: filterOptionsById
        },
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: shouldShowPopover
    });
// #endregion View
};

});
parcelRegister("e93yC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d97d624ec57005a6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<766d114d193503c03d18ed5f5929dd1f>>
 * @relayHash cb43a288f63b60e2fa551be1d76717b6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID de169d204e942b12f75b9dcea5d0d8f052def786a5205f0a25e9b939ae81055b

var $5qm7M = parcelRequire("5qm7M");

var $hBvdF = parcelRequire("hBvdF");
const $d97d624ec57005a6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "concreteType": "JiraColor",
            "kind": "LinkedField",
            "name": "color",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorKey"
                },
                v4 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "fieldOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "optionId"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "de169d204e942b12f75b9dcea5d0d8f052def786a5205f0a25e9b939ae81055b",
            "metadata": {},
            "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default)
            }
        }
    };
}();
$d97d624ec57005a6$var$node.hash = "4efc8e08a4925bceb3af2c617ed6d9ee";
var $d97d624ec57005a6$export$2e2bcd8739ae039 = $d97d624ec57005a6$var$node;

});

parcelRegister("jVlS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $cec07d2cf384f25e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf08ad1c8fb2273d225a10ddb1a04bd8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cec07d2cf384f25e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView"
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "optionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectField"
    };
}();
$cec07d2cf384f25e$var$node.hash = "28f321ab534b072c7deae95a3905b5dd";
var $cec07d2cf384f25e$export$2e2bcd8739ae039 = $cec07d2cf384f25e$var$node;

});

parcelRegister("lmlbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5490a57fd5bd1b8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<608f4af1a5cabdbfcda4b6156bf47821>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f5490a57fd5bd1b8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectField"
};
$f5490a57fd5bd1b8$var$node.hash = "91dade2591d1180af31cf3ea5a906996";
var $f5490a57fd5bd1b8$export$2e2bcd8739ae039 = $f5490a57fd5bd1b8$var$node;

});

parcelRegister("hTdh6", function(module, exports) {

$parcel$export(module.exports, "default", () => $76925b0d5225362e$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $4R6GH = parcelRequire("4R6GH");

var $dBbHW = parcelRequire("dBbHW");

const $76925b0d5225362e$var$SingleSelectEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("j1a1E")), {
        moduleId: "2f9b0ca9"
    }),
    getPreloadProps: ({ id: id, filterById: filterById })=>(0, $4R6GH.fg)('jsc_single_select_preload_on_hover') ? {
            queries: {
                singleSelectEditViewData: {
                    parameters: $dBbHW.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    variables: {
                        id: id,
                        filterById: filterById
                    }
                }
            }
        } : {}
});
var $76925b0d5225362e$export$2e2bcd8739ae039 = $76925b0d5225362e$var$SingleSelectEditViewEntryPoint;

});
parcelRegister("dBbHW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b243f8d6c3127134$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06b742fb19a2e6529885cdf09f5c8710>>
 * @relayHash 37af781a1179426a4b376a2a0406fd5a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2635dc65a51b8a59f0fbc9315844d072aac9ee6d4f9812cc638ef68b06c69d9b

var $hBvdF = parcelRequire("hBvdF");
const $b243f8d6c3127134$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "singleSelect_issueSelectableFieldQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "singleSelect_issueSelectableFieldQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                }
                            ],
                            "type": "JiraIssueField",
                            "abstractKey": "__isJiraIssueField"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "JiraFieldOperation",
                                    "kind": "LinkedField",
                                    "name": "fieldOperations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canEdit"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraSingleSelectField"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraSelectableValueConnection",
                                    "kind": "LinkedField",
                                    "name": "selectableValueOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSelectableValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableLabel"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableGroupKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableIconUrl"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDisabled"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optionId"
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraColor",
                                                                            "kind": "LinkedField",
                                                                            "name": "color",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "colorKey"
                                                                                },
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ],
                                                            "type": "JiraOption"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "versionId"
                                                                }
                                                            ],
                                                            "type": "JiraVersion"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "selectableValue_issueFieldEditviewFull_fieldOptions__selectableValueOptions",
                                    "kind": "LinkedHandle",
                                    "name": "selectableValueOptions"
                                }
                            ],
                            "type": "JiraHasSelectableValueOptions",
                            "abstractKey": "__isJiraHasSelectableValueOptions"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2635dc65a51b8a59f0fbc9315844d072aac9ee6d4f9812cc638ef68b06c69d9b",
            "metadata": {},
            "name": "singleSelect_issueSelectableFieldQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$b243f8d6c3127134$var$node.hash = "bbde42dda5618f7ad8e7a90fbd9941ed";
var $b243f8d6c3127134$export$2e2bcd8739ae039 = $b243f8d6c3127134$var$node;

});

parcelRegister("j1a1E", function(module, exports) {

let $dd85e33495697c41$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dd85e33495697c41$var$load("6oDYy").then(()=>parcelRequire('1JmKN'));

});


parcelRegister("aDaXQ", function(module, exports) {

$parcel$export(module.exports, "SingleSelectReadView", () => $5fb8179a4f006b70$export$68bfa072e694358d);

var $fBoRX = parcelRequire("fBoRX");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $MHKc7 = parcelRequire("MHKc7");

var $6s1PB = parcelRequire("6s1PB");

var $eZibI = parcelRequire("eZibI");

var $lpRLe = parcelRequire("lpRLe");

var $cYlTx = parcelRequire("cYlTx");

var $5fc53 = parcelRequire("5fc53");

var $dpHMc = parcelRequire("dpHMc");

var $4R6GH = parcelRequire("4R6GH");

var $7mPT9 = parcelRequire("7mPT9");
const $5fb8179a4f006b70$export$68bfa072e694358d = (props)=>{
    const { fragmentRef: fragmentRef, fieldType: fieldType, shouldShowPopover: shouldShowPopover } = props;
    const data = (0, $8Uumt.useFragment)((0, $fBoRX.default), fragmentRef);
    const contentRef = (0, $5uXOq.useRef)(null);
    if (!data.fieldOption?.value) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    const totalOptionsCount = data?.fieldOptions?.totalCount ?? 0;
    const isCategoryAndListExperimentON = props.fieldType === (0, $5fc53.CATEGORY_TYPE) && (0, $4R6GH.fg)('jsc_inline_editing_field_refactor');
    // Separate checks to assure exposure
    const isSingleSelectAndColourfulExperimentOn = fieldType === (0, $5fc53.SELECT_CF_TYPE) && totalOptionsCount <= (0, $cYlTx.FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST) && (0, $6s1PB.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false);
    if (isSingleSelectAndColourfulExperimentOn || isCategoryAndListExperimentON) {
        if (shouldShowPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
            content: data.fieldOption.value,
            contentRef: contentRef
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
                name: data.fieldOption?.value ?? '',
                color: data.fieldOption?.color?.colorKey ?? null,
                ref: (0, $7mPT9.default)(ref, contentRef)
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
            name: data.fieldOption.value,
            color: data?.fieldOption?.color?.colorKey ?? null,
            showTooltip: (0, $4R6GH.fg)('add_tooltip_to_single_select_options_read_view')
        });
    }
    return shouldShowPopover ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: data.fieldOption.value,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            ref: (0, $7mPT9.default)(ref, contentRef)
        }, data.fieldOption?.value ?? '')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, data.fieldOption?.value ?? '');
};

});
parcelRegister("fBoRX", function(module, exports) {

$parcel$export(module.exports, "default", () => $76f5d17d6ed20e4b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ca471c9c3ad28e06afcd91e53ac5368>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $76f5d17d6ed20e4b$var$node = function() {
    var v0 = [
        {
            "concreteType": "JiraColor",
            "kind": "LinkedField",
            "name": "color",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorKey"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView",
        "selections": [
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    }
                ]
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v0 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectField"
    };
}();
$76f5d17d6ed20e4b$var$node.hash = "10f576713aea3253f6151f9c99b9b5c5";
var $76f5d17d6ed20e4b$export$2e2bcd8739ae039 = $76f5d17d6ed20e4b$var$node;

});




parcelRegister("9uEyQ", function(module, exports) {

$parcel$export(module.exports, "SprintCell", () => $dc2294f8444c0da2$export$a092d4418bd765b8);

var $8RFGF = parcelRequire("8RFGF");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $iEIQF = parcelRequire("iEIQF");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");

var $6t9I3 = parcelRequire("6t9I3");

var $g5SwL = parcelRequire("g5SwL");

var $Br57E = parcelRequire("Br57E");

var $aB7bN = parcelRequire("aB7bN");

var $jFYC8 = parcelRequire("jFYC8");

var $e9M6d = parcelRequire("e9M6d");
/**
 * Expected JQL Output: `${jqlTerm} = ${sprintId}`
 */ const $dc2294f8444c0da2$var$getSprintJql = (jqlTerm, sprintId)=>{
    const jast = (0, $iEIQF.default).jast((0, $iEIQF.default).query((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field((0, $aB7bN.escapeBackslashes)(jqlTerm)), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS)), (0, $iEIQF.default).valueOperand(String(sprintId)))));
    return (0, $l0V05.print)(jast, {
        operatorCase: 'upper'
    });
};
const $dc2294f8444c0da2$export$a092d4418bd765b8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, projectKey: projectKey, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $8RFGF.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const [restrictSprints, { onRestrictSprints: onRestrictSprints }] = (0, $g5SwL.useRestrictSprints)();
    const getUrl = (0, $5uXOq.useCallback)((sprintId)=>{
        const jql = $dc2294f8444c0da2$var$getSprintJql(jqlTerm, sprintId);
        return `${issueSearchBaseUrl}?jql=${encodeURIComponent(jql)}`;
    }, [
        issueSearchBaseUrl,
        jqlTerm
    ]);
    const shouldTruncate = (0, $e9M6d.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6t9I3.SprintInlineEditViewIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        getUrl: getUrl,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        onRestrictSprints: onRestrictSprints,
        projectKey: projectKey,
        readViewFitContainerHeight: true,
        restrictSprints: restrictSprints,
        isTruncated: shouldTruncate
    });
});

});
parcelRegister("8RFGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c0c9800450663c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a62cc27130243d03242a5f5bc30151b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4c0c9800450663c5$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "sprint_nativeIssueTable_SprintCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSprintField"
};
$4c0c9800450663c5$var$node.hash = "a6a38290e680b03dbe7f0c69af281f9c";
var $4c0c9800450663c5$export$2e2bcd8739ae039 = $4c0c9800450663c5$var$node;

});

parcelRegister("6t9I3", function(module, exports) {

$parcel$export(module.exports, "SprintInlineEditViewIsEditable", () => $3d901802fe188ee3$export$e7a88b03161da897);
$parcel$export(module.exports, "SprintInlineEditView", () => $3d901802fe188ee3$export$c035f6dfde6d5d50);

var $fjbT2 = parcelRequire("fjbT2");

var $fvx8s = parcelRequire("fvx8s");

var $bWaGk = parcelRequire("bWaGk");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $ctrpc = parcelRequire("ctrpc");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $8M5Kj = parcelRequire("8M5Kj");

var $bclKu = parcelRequire("bclKu");

var $b8zDX = parcelRequire("b8zDX");

var $79UpA = parcelRequire("79UpA");

var $KohsJ = parcelRequire("KohsJ");
const $3d901802fe188ee3$var$isEqualSprint = (a, b)=>a?.value === b?.value;
const $3d901802fe188ee3$export$e7a88b03161da897 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, getUrl: getUrl, isEditable: isFieldEditable, isEditing: startWithEditViewOpen, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onRestrictSprints: onRestrictSprints, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, projectKey: projectKey, readViewFitContainerHeight: readViewFitContainerHeight, restrictSprints: restrictSprints, isTruncated: isTruncated })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $bWaGk.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: fieldName, selectedSprintsConnection: selectedSprintsConnection } = data;
    const [commit] = (0, $8Uumt.useMutation)((0, $fvx8s.default));
    const sprintEdges = (0, $5uXOq.useMemo)(()=>selectedSprintsConnection?.edges?.filter(Boolean) ?? [], [
        selectedSprintsConnection?.edges
    ]);
    const initialValue = (0, $5uXOq.useMemo)(()=>{
        const sprintNodes = sprintEdges.map(({ node: node })=>node).filter(Boolean);
        const currentSprint = (0, $bclKu.findActiveOrFutureSprint)(sprintNodes);
        return currentSprint && (0, $bclKu.isObjectWithSprintState)(currentSprint) ? {
            value: currentSprint.id,
            label: currentSprint.name ?? '',
            state: currentSprint.state,
            sprintId: currentSprint.sprintId
        } : null;
    }, [
        sprintEdges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const handleSubmit = (0, $5uXOq.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.((0, $KohsJ.transformOptionToAgg)(selectedSprintsConnection?.edges ?? [], option));
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSprintField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: (0, $KohsJ.toOptimisticResponse)(uniqueFieldId, option, sprintEdges)
        });
    }, [
        commit,
        onSubmit,
        selectedSprintsConnection?.edges,
        sprintEdges,
        uniqueFieldId
    ]);
    const handleSubmitSucceeded = (0, $5uXOq.useCallback)((value)=>{
        onSubmitSucceeded?.((0, $KohsJ.transformOptionToAgg)(selectedSprintsConnection?.edges ?? [], value));
    }, [
        onSubmitSucceeded,
        selectedSprintsConnection?.edges
    ]);
    const setAnalyticsAttributes = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)((value)=>{
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, initialValue?.sprintId, value?.sprintId || null);
    }, [
        fieldId,
        initialValue
    ]) : undefined;
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $3d901802fe188ee3$var$isEqualSprint,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'sprint',
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            setAnalyticsAttributes: setAnalyticsAttributes
        }
    });
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79UpA.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b8zDX.SprintReadView), {
            fragmentRef: data,
            getUrl: getUrl,
            isTruncated: isTruncated
        })), [
        data,
        getUrl,
        isTruncated
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            projectKey: projectKey,
            onRestrictSprints: onRestrictSprints,
            restrictSprints: restrictSprints,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $8M5Kj.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hasReadViewTruncateDisabled: isTruncated,
        hideActionButtons: true
    });
};
const $3d901802fe188ee3$export$c035f6dfde6d5d50 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $fjbT2.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d901802fe188ee3$export$e7a88b03161da897, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("fjbT2", function(module, exports) {

$parcel$export(module.exports, "default", () => $614f4635902a6a59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37eab354ffef704063d36bf755f8ce5b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $614f4635902a6a59$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSprintField"
};
$614f4635902a6a59$var$node.hash = "aba26260bac1c5d276c6291d7046e952";
var $614f4635902a6a59$export$2e2bcd8739ae039 = $614f4635902a6a59$var$node;

});

parcelRegister("fvx8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a53a90fec778226$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d38c11cbcc28d051d2caaff8b2100e27>>
 * @relayHash fe046116013b2c3336c51bcbbb0fadff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41bae81fc0a3022641c80d39ea76c8cb98023eb98fecc3699abf8ef4138c4e7
const $7a53a90fec778226$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSprintFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSprintField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSprintField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "sprint_issueFieldSprintReadviewFull_SprintReadView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSprintFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSprintField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSprintField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraSprintConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedSprintsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSprintEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSprint",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "sprintId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "endDate"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e41bae81fc0a3022641c80d39ea76c8cb98023eb98fecc3699abf8ef4138c4e7",
            "metadata": {},
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$7a53a90fec778226$var$node.hash = "10015ae363c37285aaa230e388ba466f";
var $7a53a90fec778226$export$2e2bcd8739ae039 = $7a53a90fec778226$var$node;

});

parcelRegister("bWaGk", function(module, exports) {

$parcel$export(module.exports, "default", () => $679299348dd352f5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac88ab127ac9ae040b14fea73c66a12b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $679299348dd352f5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "sprint_issueFieldSprintReadviewFull_SprintReadView"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSprintField"
    };
}();
$679299348dd352f5$var$node.hash = "52958eeea1ec618ec650c65098329a2d";
var $679299348dd352f5$export$2e2bcd8739ae039 = $679299348dd352f5$var$node;

});

parcelRegister("8M5Kj", function(module, exports) {

$parcel$export(module.exports, "default", () => $700e7fde38ae4261$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $700e7fde38ae4261$var$SprintEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("gvZNG")), {
        moduleId: "8d561192"
    }),
    getPreloadProps: ()=>({})
});
var $700e7fde38ae4261$export$2e2bcd8739ae039 = $700e7fde38ae4261$var$SprintEditViewEntryPoint;

});
parcelRegister("gvZNG", function(module, exports) {

let $c05f7ad954774412$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c05f7ad954774412$var$load("ih3hC").then(()=>parcelRequire('5sFi1'));

});


parcelRegister("bclKu", function(module, exports) {

$parcel$export(module.exports, "getRapidViewUrl", () => $c592400ba8928fe6$export$e6c9132cef5ee76f);
$parcel$export(module.exports, "findActiveOrFutureSprint", () => $c592400ba8928fe6$export$d53a51166e1544ba);
$parcel$export(module.exports, "isClosedSprint", () => $c592400ba8928fe6$export$7494fd835c1a1b3);
$parcel$export(module.exports, "filterClosedSprints", () => $c592400ba8928fe6$export$af48278faaf4e92d);
$parcel$export(module.exports, "isObjectWithSprintState", () => $c592400ba8928fe6$export$9ba6a679066a1e8c);

var $3spCR = parcelRequire("3spCR");
const $c592400ba8928fe6$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
const $c592400ba8928fe6$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state != null && sprint.state.toUpperCase() === state.toUpperCase();
const $c592400ba8928fe6$export$fb6b70a9c996212b = (sprints, state)=>sprints.find($c592400ba8928fe6$export$d2fec4e2fc5f065a(state));
const $c592400ba8928fe6$export$d53a51166e1544ba = (value)=>{
    const activeSprint = $c592400ba8928fe6$export$fb6b70a9c996212b(value, (0, $3spCR.ACTIVE_SPRINT_STATE));
    if (activeSprint) return activeSprint;
    const futureSprint = $c592400ba8928fe6$export$fb6b70a9c996212b(value, (0, $3spCR.FUTURE_SPRINT_STATE));
    if (futureSprint) return futureSprint;
    return null;
};
const $c592400ba8928fe6$export$7494fd835c1a1b3 = $c592400ba8928fe6$export$d2fec4e2fc5f065a((0, $3spCR.CLOSED_SPRINT_STATE));
const $c592400ba8928fe6$export$af48278faaf4e92d = (value)=>value.filter($c592400ba8928fe6$export$7494fd835c1a1b3);
const $c592400ba8928fe6$export$9ba6a679066a1e8c = (val)=>val.state ? val.state in (0, $3spCR.SPRINT_STATES) : false;

});
parcelRegister("3spCR", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $113c1ed08a0bda4f$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $113c1ed08a0bda4f$export$73a0206a4dc59760);
const $113c1ed08a0bda4f$export$3ebc9911a79d714f = 'ACTIVE';
const $113c1ed08a0bda4f$export$863e42082c6bde5 = 'FUTURE';
const $113c1ed08a0bda4f$export$86cdef09a89e8c4b = 'CLOSED';
const $113c1ed08a0bda4f$export$73a0206a4dc59760 = {
    ACTIVE: $113c1ed08a0bda4f$export$3ebc9911a79d714f,
    CLOSED: $113c1ed08a0bda4f$export$86cdef09a89e8c4b,
    FUTURE: $113c1ed08a0bda4f$export$863e42082c6bde5
};

});


parcelRegister("b8zDX", function(module, exports) {

$parcel$export(module.exports, "SprintReadView", () => $0304e6dca87cc77b$export$ea735e24cb7dd13);

var $lu0ZC = parcelRequire("lu0ZC");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fr1K2 = parcelRequire("fr1K2");

var $8Uumt = parcelRequire("8Uumt");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $gSPPL = parcelRequire("gSPPL");

var $dpHMc = parcelRequire("dpHMc");

var $79UpA = parcelRequire("79UpA");

var $7mPT9 = parcelRequire("7mPT9");

var $bclKu = parcelRequire("bclKu");

var $lJi8h = parcelRequire("lJi8h");

var $3YKgK = parcelRequire("3YKgK");
const $0304e6dca87cc77b$export$ea735e24cb7dd13 = ({ fragmentRef: fragmentRef, shouldHideSprintLink: shouldHideSprintLink = false, shouldHideClosedSprintsLinks: shouldHideClosedSprintsLinks = false, placeholder: placeholder, onSprintClick: onSprintClick, getUrl: getUrl = (0, $bclKu.getRapidViewUrl), isTruncated: isTruncated })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $koVbs.default)();
    const placeholderMessage = placeholder || formatMessage((0, $gSPPL.default).emptyFieldText);
    const { selectedSprintsConnection: selectedSprintsConnection } = (0, $8Uumt.useFragment)((0, $lu0ZC.default), fragmentRef);
    const sprints = (0, $5uXOq.useMemo)(()=>selectedSprintsConnection?.edges?.filter(Boolean).map(({ node: node })=>node).filter(Boolean).filter((0, $bclKu.isObjectWithSprintState)).map((node)=>({
                id: node.id,
                sprintId: parseInt(node.sprintId, 10),
                name: node.name,
                state: node.state,
                endDate: node.endDate ?? undefined
            })) ?? [], [
        selectedSprintsConnection?.edges
    ]);
    const value = (0, $5uXOq.useMemo)(()=>{
        const currentSprint = (0, $bclKu.findActiveOrFutureSprint)(sprints);
        if (!currentSprint) return null;
        const sprintOption = {
            label: currentSprint.name,
            value: currentSprint.id,
            href: getUrl(currentSprint.sprintId),
            state: currentSprint.state
        }; // If in backlog, use onSprintClick instead of href
        return onSprintClick ? (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(sprintOption, 'href') : sprintOption;
    }, [
        getUrl,
        onSprintClick,
        sprints
    ]);
    const closedSprints = (0, $5uXOq.useMemo)(()=>(0, $bclKu.filterClosedSprints)(sprints)?.map((closedSprint)=>({
                id: closedSprint.sprintId,
                name: closedSprint.name,
                href: getUrl(closedSprint.sprintId),
                endDate: formatDate(closedSprint.endDate, {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                })
            })), [
        formatDate,
        getUrl,
        sprints
    ]);
    const sprintContentRef = (0, $5uXOq.useRef)(null);
    const renderClosedSprints = (0, $5uXOq.useCallback)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79UpA.CellHoverProvider), null, closedSprints.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJi8h.default), props));
    }, [
        closedSprints
    ]);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: !isTruncated,
        xcss: $0304e6dca87cc77b$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
            content: value?.label,
            contentRef: sprintContentRef,
            shouldGetParentRef: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3YKgK.default), {
                value: value,
                shouldHideSprintLink: shouldHideSprintLink,
                placeholder: placeholderMessage,
                onClick: onSprintClick,
                sprintContentRef: (0, $7mPT9.default)(ref, sprintContentRef),
                hoverAttributes: props
            }))), renderClosedSprints({
        closedSprints: closedSprints,
        shouldHideLinks: shouldHideClosedSprintsLinks,
        isTruncated: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0304e6dca87cc77b$var$ReadWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3YKgK.default), {
        value: value,
        shouldHideSprintLink: shouldHideSprintLink,
        placeholder: placeholderMessage,
        onClick: onSprintClick
    }), renderClosedSprints({
        closedSprints: closedSprints,
        shouldHideLinks: shouldHideClosedSprintsLinks
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0304e6dca87cc77b$var$ReadWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _1bsb1osq _1n261g80",
            __cmplp.className
        ])
    });
});
const $0304e6dca87cc77b$var$inlineStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden'
});

});
parcelRegister("lu0ZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5050149ec590a855$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0ee21c1a385c649c86345ac0a88a0470>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5050149ec590a855$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sprint_issueFieldSprintReadviewFull_SprintReadView",
    "selections": [
        {
            "concreteType": "JiraSprintConnection",
            "kind": "LinkedField",
            "name": "selectedSprintsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSprintEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "sprintId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    "action": "THROW",
                                    "path": "selectedSprintsConnection.edges.node.name"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    "action": "THROW",
                                    "path": "selectedSprintsConnection.edges.node.state"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSprintField"
};
$5050149ec590a855$var$node.hash = "94ae9fbf007cadd0e44b60b0777f74f2";
var $5050149ec590a855$export$2e2bcd8739ae039 = $5050149ec590a855$var$node;

});

parcelRegister("lJi8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $3147822d822bb393$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $dS3PR = parcelRequire("dS3PR");

var $eHJxW = parcelRequire("eHJxW");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $hjSul = parcelRequire("hjSul");

var $dpHMc = parcelRequire("dpHMc");

var $a6KHw = parcelRequire("a6KHw");
const $3147822d822bb393$var$ClosedSprintsView = (props)=>{
    const { shouldHideLinks: shouldHideLinks = false, closedSprints: closedSprints, isTruncated: isTruncated } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isDialogOpen, setIsDialogOpen] = (0, $5uXOq.useState)(false);
    const handleButtonClick = (0, $5uXOq.useCallback)((e)=>{
        setIsDialogOpen(!isDialogOpen);
        e.stopPropagation();
    }, [
        isDialogOpen
    ]);
    const handleDialogClose = (0, $5uXOq.useCallback)((data)=>{
        setIsDialogOpen(data.isOpen);
    }, []);
    const handleDialogClick = (0, $5uXOq.useCallback)((e)=>{
        e.stopPropagation();
    }, []);
    const handleDialogMouseDown = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
    }, []);
    const closedSprintsLabel = (0, $5uXOq.useMemo)(()=>{
        const numberOfClosedSprints = closedSprints.length;
        return numberOfClosedSprints > 0 ? formatMessage((0, $a6KHw.default).closedSprintsLabel, {
            count: numberOfClosedSprints
        }) : null;
    }, [
        closedSprints,
        formatMessage
    ]);
    const renderInlineDialogContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "issue-field-sprint-readview-full.ui.sprint.closed-sprints.view-closed-sprint-inline-dialog-content-container"
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            weight: "medium"
        }, closedSprintsLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3147822d822bb393$var$Title, null, closedSprintsLabel), closedSprints.map((sprint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3147822d822bb393$var$ItemContainer, {
                key: sprint.name,
                "data-testid": `issue-field-sprint-readview-full.ui.sprint.closed-sprints.closed-sprint-item-${sprint.id}`
            }, shouldHideLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3147822d822bb393$var$NameSpan, null, sprint.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3147822d822bb393$var$NameLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
                href: sprint.href
            }, sprint.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3147822d822bb393$var$NoWrapDate, null, sprint.endDate))));
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.CellHoverRenderer), null, (hoverProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
            content: renderInlineDialogContent(),
            isInteractive: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3147822d822bb393$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                spacing: "none",
                ref: ref,
                testId: "issue-field-sprint-readview-full.ui.sprint.closed-sprints.button",
                ...hoverProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3147822d822bb393$var$ClosedSprintsCount, null, `+${closedSprints.length}`)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3147822d822bb393$var$Container, {
        onClick: handleDialogClick,
        onMouseDown: handleDialogMouseDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        content: renderInlineDialogContent(),
        isOpen: isDialogOpen,
        onClose: handleDialogClose,
        placement: "bottom",
        messageId: "issue-field-sprint-readview-full.ui.sprint.closed-sprints.inline-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: handleButtonClick,
        spacing: "none",
        isSelected: isDialogOpen,
        testId: "issue-field-sprint-readview-full.ui.sprint.closed-sprints.button",
        "aria-expanded": isDialogOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3147822d822bb393$var$ClosedSprintsCount, null, `+${closedSprints.length}`))));
};
var $3147822d822bb393$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $3147822d822bb393$var$ClosedSprintsView;
const $3147822d822bb393$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3147822d822bb393$var$ClosedSprintsCount = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _k48pi7a9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3147822d822bb393$var$ItemContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _1e0c1txw _1bah1yb4 _p12f1mjv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3147822d822bb393$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
});
const $3147822d822bb393$var$nameStyles = `
    margin-right: ${"var(--ds-space-300, 24px)"};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $3147822d822bb393$var$NameLinkContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2hwx1ejb _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $3147822d822bb393$var$NameSpan = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2hwx1ejb _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3147822d822bb393$var$NoWrapDate = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eHJxW", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $51c10262cffee11f$export$7ab52478615504b3);

var $5uXOq = parcelRequire("5uXOq");

var $ctg8C = parcelRequire("ctg8C");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $5uVz7 = parcelRequire("5uVz7");
const $51c10262cffee11f$export$7ab52478615504b3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVz7.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), rest);
};

});
parcelRegister("5uVz7", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $aa901de21f3fc2ba$export$44a404f218b0e66e);

var $ctg8C = parcelRequire("ctg8C");

var $fG5AJ = parcelRequire("fG5AJ");
const $aa901de21f3fc2ba$export$44a404f218b0e66e = (0, $fG5AJ.withChoreographedToggle)((0, $ctg8C.default), 'isOpen', 'content');

});


parcelRegister("a6KHw", function(module, exports) {

$parcel$export(module.exports, "default", () => $14d1edcf6976c0fd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $14d1edcf6976c0fd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    closedSprintsLabel: {
        "id": "issue-field-sprint-readview-full.sprint.closed-sprints.closed-sprints-label",
        "defaultMessage": "{count} completed {count, plural, one {sprint} other {sprints}}"
    }
});

});


parcelRegister("3YKgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1b42c9814125bbb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $b20Ji = parcelRequire("b20Ji");

var $iv6X1 = parcelRequire("iv6X1");

var $hjSul = parcelRequire("hjSul");

var $ecp5P = parcelRequire("ecp5P");
const $e1b42c9814125bbb$var$SprintContent = (props)=>{
    const { value: value, onClick: onClick, placeholder: placeholder, shouldHideSprintLink: shouldHideSprintLink = false, sprintContentRef: sprintContentRef, hoverAttributes: hoverAttributes } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const noValueTextExperiment = formatMessage((0, $ecp5P.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    const renderSprintContent = ()=>{
        if (shouldHideSprintLink) return value && value.label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            "data-testid": "issue-field-sprint-readview-full.ui.sprint.sprint-content.view-sprint-content-link",
            href: value?.href,
            onClick: onClick,
            ref: sprintContentRef,
            ...hoverAttributes
        }, value && value.label);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1b42c9814125bbb$var$Ellipsis, {
        "data-testid": "issue-field-sprint-readview-full.ui.sprint.sprint-content.view-sprint-content"
    }, value ? renderSprintContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b20Ji.default), null, isExperimentEnabled ? noValueTextExperiment : placeholder));
};
var $e1b42c9814125bbb$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $e1b42c9814125bbb$var$SprintContent;
const $e1b42c9814125bbb$var$Ellipsis = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b20Ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $178b01ea8a8ca247$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $178b01ea8a8ca247$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ecp5P", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c98a339e33663ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0c98a339e33663ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-sprint-readview-full.sprint.no-value-text-experiment",
        "defaultMessage": "Add sprint"
    }
});

});



parcelRegister("KohsJ", function(module, exports) {

$parcel$export(module.exports, "toOptimisticResponse", () => $7007fe5d379023a9$export$79353fa5e28d43d8);
$parcel$export(module.exports, "transformOptionToAgg", () => $7007fe5d379023a9$export$4e115b8a3d13d179);

var $bclKu = parcelRequire("bclKu");
const $7007fe5d379023a9$export$79353fa5e28d43d8 = (fieldId, option, previousEdges)=>{
    // Previously closed sprints should still be displayed for the updated field
    const selectedSprints = previousEdges.filter((edge)=>edge?.node && (0, $bclKu.isClosedSprint)(edge.node));
    if (option) selectedSprints.unshift({
        node: {
            id: option.value,
            name: option.label,
            state: option.state,
            sprintId: option.sprintId,
            endDate: null
        }
    });
    return {
        jira: {
            updateSprintField: {
                success: true,
                errors: null,
                field: {
                    id: fieldId,
                    selectedSprintsConnection: {
                        edges: selectedSprints
                    }
                }
            }
        }
    };
};
const $7007fe5d379023a9$export$4e115b8a3d13d179 = (currentEdges, option)=>{
    // Previously closed sprints should still be displayed for the updated field
    const selectedSprints = currentEdges.filter((edge)=>edge?.node && (0, $bclKu.isClosedSprint)(edge.node));
    if (option) selectedSprints.unshift({
        node: {
            id: option.value,
            name: option.label,
            state: option.state,
            sprintId: option.sprintId,
            endDate: null
        }
    });
    return {
        selectedSprintsConnection: {
            edges: selectedSprints
        }
    };
};

});


parcelRegister("g5SwL", function(module, exports) {

$parcel$export(module.exports, "useRestrictSprints", () => $d29517e98f194bb8$export$8fafa660b00d922);

var $bBVyF = parcelRequire("bBVyF");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $d29517e98f194bb8$var$initialState = {
    restrictSprints: (0, $bBVyF.getSharedRestrictSprintsValueFromLocalStorage)()
};
const $d29517e98f194bb8$var$actions = {
    onRestrictSprints: (restrictSprints)=>({ setState: setState })=>{
            (0, $bBVyF.setSharedRestrictSprintsValueInLocalStorage)(restrictSprints);
            setState({
                restrictSprints: restrictSprints
            });
        }
};
const $d29517e98f194bb8$var$RestrictSprintsStore = (0, $iXqE5.createStore)({
    initialState: $d29517e98f194bb8$var$initialState,
    actions: $d29517e98f194bb8$var$actions
});
const $d29517e98f194bb8$export$8fafa660b00d922 = (0, $3sQ5x.createHook)($d29517e98f194bb8$var$RestrictSprintsStore, {
    selector: (state)=>state.restrictSprints
});

});
parcelRegister("bBVyF", function(module, exports) {

$parcel$export(module.exports, "getSharedRestrictSprintsValueFromLocalStorage", () => $a88fb74bd6df29e4$export$7186d1e916f1211c);
$parcel$export(module.exports, "setSharedRestrictSprintsValueInLocalStorage", () => $a88fb74bd6df29e4$export$4e2f56cec9369837);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
// Helper functions to get the checkbox value in sprint edit component from local storage
const $a88fb74bd6df29e4$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY = 'edit_sprint_cache_value';
const $a88fb74bd6df29e4$var$storageProvider = (0, $bSSG7.createLocalStorageProvider)('', false);
const $a88fb74bd6df29e4$var$getRestrictSprintsValueFromLocalStorage = (key)=>{
    // SSR should not try to retrieve local storage values, so return default value
    if (false) return true;
    let value;
    try {
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) value = $a88fb74bd6df29e4$var$storageProvider.get(key);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        value = window.localStorage?.getItem(key);
        return value ? JSON.parse(value) : true;
    } catch  {
        return true;
    }
};
const $a88fb74bd6df29e4$var$setRestrictSprintsValueInLocalStorage = (key, value)=>{
    try {
        const valueToStore = String(value);
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) $a88fb74bd6df29e4$var$storageProvider.set(key, valueToStore);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.localStorage.setItem(key, valueToStore);
    } catch  {
    // do nothing
    }
};
const $a88fb74bd6df29e4$export$7186d1e916f1211c = ()=>$a88fb74bd6df29e4$var$getRestrictSprintsValueFromLocalStorage($a88fb74bd6df29e4$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY);
const $a88fb74bd6df29e4$export$4e2f56cec9369837 = (value)=>$a88fb74bd6df29e4$var$setRestrictSprintsValueInLocalStorage($a88fb74bd6df29e4$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY, value);

});



parcelRegister("8nXhj", function(module, exports) {

$parcel$export(module.exports, "TeamCell", () => $930ccbbd0f85ccbc$export$2ea8e60ef5e5f6ad);

var $9GWe6 = parcelRequire("9GWe6");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7Jxgt = parcelRequire("7Jxgt");

var $bShPO = parcelRequire("bShPO");

var $jFYC8 = parcelRequire("jFYC8");

var $Br57E = parcelRequire("Br57E");

var $e9M6d = parcelRequire("e9M6d");
const $930ccbbd0f85ccbc$export$2ea8e60ef5e5f6ad = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const sessionId = (0, $5uXOq.useRef)((0, $7Jxgt.v4)());
    const data = (0, $8Uumt.useFragment)((0, $9GWe6.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bShPO.TeamInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        sessionId: sessionId.current,
        maxLines: isSingleLineRowHeightEnabled ? 1 : 2
    });
};

});
parcelRegister("9GWe6", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ce5d774cc9e9fd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec77bf3f2635403a4d9a43c9c4b52a43>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $02ce5d774cc9e9fd$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "team_nativeIssueTable_TeamCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraTeamViewField"
};
$02ce5d774cc9e9fd$var$node.hash = "0c8231e21e67e20de3d4bc8ca26ff0ec";
var $02ce5d774cc9e9fd$export$2e2bcd8739ae039 = $02ce5d774cc9e9fd$var$node;

});

parcelRegister("bShPO", function(module, exports) {

$parcel$export(module.exports, "TeamInlineEditViewWithIsEditable", () => $da8ca980ed18357b$export$810a8205b15f6ef5);

var $3c5N6 = parcelRequire("3c5N6");

var $kvqfu = parcelRequire("kvqfu");

var $6zDXQ = parcelRequire("6zDXQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $1qWIA = parcelRequire("1qWIA");

var $9qg5m = parcelRequire("9qg5m");

var $94D70 = parcelRequire("94D70");

var $jrRyX = parcelRequire("jrRyX");

var $52xH0 = parcelRequire("52xH0");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $da8ca980ed18357b$var$isEqualOption = (a, b)=>a?.id === b?.id;
const $da8ca980ed18357b$export$810a8205b15f6ef5 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', sessionId: sessionId, maxLines: maxLines })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $6zDXQ.default), fragmentRef);
    // Team will not always be available in Jira when is recently created,
    // at least not right away, due to eventual consistency. We are retrying
    // to give time to Jira to receive the newly team and accepts the given
    // team ARI as a valid team
    const retryCommit = (0, $52xH0.useMutationWithRetriesCommit)((0, $5uXOq.useMemo)(()=>({
            retries: 3,
            isValidOnCompleted: (response)=>Boolean(response.jira?.updateTeamField?.success)
        }), []));
    const [commit] = (0, $8Uumt.useMutation)((0, $kvqfu.default), retryCommit);
    // #endregion
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedTeam: selectedTeam, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $5uXOq.useMemo)(()=>{
        if (!selectedTeam) return null;
        return {
            id: selectedTeam.jiraSuppliedId,
            name: selectedTeam.jiraSuppliedName ?? ''
        };
    }, [
        selectedTeam
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $5uXOq.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $5uXOq.useCallback)((value, { onFail: onFail, onSuccess: onSuccess })=>{
        onSubmit?.(value);
        const id = (0, $1qWIA.isRecentlyCreatedTeam)(value) ? value.teamAri : value?.id ?? null;
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: id
                    }
                }
            },
            onCompleted (response) {
                if (response.jira?.updateTeamField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateTeamField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedTeam: value && {
                                jiraSuppliedId: id ?? '',
                                jiraSuppliedName: value?.name ?? ''
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $da8ca980ed18357b$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'team'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $94D70.TeamReadView), {
            fragmentRef: data,
            maxLines: maxLines,
            triggerLinkType: isFieldEditable ? 'none' : 'link'
        });
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChangeAndConfirm,
            spacing: spacing,
            sessionId: sessionId
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $9qg5m.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $da8ca980ed18357b$export$d6fa94a3a6e2c653 = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $3c5N6.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da8ca980ed18357b$export$810a8205b15f6ef5, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("3c5N6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a77e4f4df8640f9c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<65a0c0d2951c8f6f84c344c3564c0df1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a77e4f4df8640f9c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraTeamViewField"
};
$a77e4f4df8640f9c$var$node.hash = "10546ea9458e9373d43b23a6a4446d16";
var $a77e4f4df8640f9c$export$2e2bcd8739ae039 = $a77e4f4df8640f9c$var$node;

});

parcelRegister("kvqfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9334dd2ab44bf5b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f20c59dab77492604598897b506d3fd>>
 * @relayHash ead4aeaad9bf490eb7d3435ec219e3a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c49ad7e0999f23413665b12454770bad160b1b9af9354368998b9abe8369bcc
const $b9334dd2ab44bf5b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "team_issueFieldTeam_TeamField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraTeamFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraTeamViewField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "team_issueFieldTeam_TeamField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraTeamFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraTeamViewField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraTeamView",
                                            "kind": "LinkedField",
                                            "name": "selectedTeam",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedName"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3c49ad7e0999f23413665b12454770bad160b1b9af9354368998b9abe8369bcc",
            "metadata": {},
            "name": "team_issueFieldTeam_TeamField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b9334dd2ab44bf5b$var$node.hash = "f3f61da99e07b74cee3d1344c1a154d1";
var $b9334dd2ab44bf5b$export$2e2bcd8739ae039 = $b9334dd2ab44bf5b$var$node;

});

parcelRegister("6zDXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e25406fc5cec0e4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7807a89c68ac9a44db6c3316858f4987>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e25406fc5cec0e4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "team_issueFieldTeamReadviewFull_TeamReadView"
        },
        {
            "concreteType": "JiraTeamView",
            "kind": "LinkedField",
            "name": "selectedTeam",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedId"
                },
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedName"
                }
            ]
        }
    ],
    "type": "JiraTeamViewField"
};
$3e25406fc5cec0e4$var$node.hash = "b9fb955ce9530b3f35116dcc41a56241";
var $3e25406fc5cec0e4$export$2e2bcd8739ae039 = $3e25406fc5cec0e4$var$node;

});

parcelRegister("1qWIA", function(module, exports) {

$parcel$export(module.exports, "isRecentlyCreatedTeam", () => $9f11830d093821e1$export$695c72729cb9130e);
const $9f11830d093821e1$export$695c72729cb9130e = (team)=>{
    return team != null && Object.hasOwn(team, 'isRecentlyCreated');
};

});

parcelRegister("9qg5m", function(module, exports) {

$parcel$export(module.exports, "default", () => $b208631e96998326$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $b208631e96998326$var$MultiUserPickerEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("fBKFZ")), {
        moduleId: "47e554b4"
    }),
    getPreloadProps: ()=>({})
});
var $b208631e96998326$export$2e2bcd8739ae039 = $b208631e96998326$var$MultiUserPickerEditViewEntryPoint;

});
parcelRegister("fBKFZ", function(module, exports) {

let $b5ce84ac96d5f80b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b5ce84ac96d5f80b$var$load("4F8sx").then(()=>parcelRequire('6S4DZ'));

});


parcelRegister("94D70", function(module, exports) {

$parcel$export(module.exports, "TeamReadView", () => $47b3a384d38391d8$export$87458045213a5f61);

var $iDDS1 = parcelRequire("iDDS1");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dS3PR = parcelRequire("dS3PR");

var $eZibI = parcelRequire("eZibI");

var $cq6Ui = parcelRequire("cq6Ui");
const $47b3a384d38391d8$export$87458045213a5f61 = ({ fragmentRef: fragmentRef, maxLines: maxLines, triggerLinkType: triggerLinkType })=>{
    const { selectedTeam: selectedTeam } = (0, $8Uumt.useFragment)((0, $iDDS1.default), fragmentRef);
    if (!selectedTeam?.jiraSuppliedName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cq6Ui.default), {
        teamId: selectedTeam.jiraSuppliedId,
        trigger: "hover-click",
        position: "left-start",
        triggerLinkType: triggerLinkType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        maxLines: maxLines
    }, selectedTeam.jiraSuppliedName));
};

});
parcelRegister("iDDS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ed4d995a632d0d1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2eecf37369c6c8c0d95dae02e8db59b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4ed4d995a632d0d1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "team_issueFieldTeamReadviewFull_TeamReadView",
    "selections": [
        {
            "concreteType": "JiraTeamView",
            "kind": "LinkedField",
            "name": "selectedTeam",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedId"
                },
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedName"
                }
            ]
        }
    ],
    "type": "JiraTeamViewField"
};
$4ed4d995a632d0d1$var$node.hash = "69af0ce99580e256b8a8c95839ad6bd2";
var $4ed4d995a632d0d1$export$2e2bcd8739ae039 = $4ed4d995a632d0d1$var$node;

});

parcelRegister("cq6Ui", function(module, exports) {

$parcel$export(module.exports, "default", () => $542f601a1b50d9f3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


const $542f601a1b50d9f3$var$ConditionalProfileCard = (parcelRequire("cVfTl")).default;
function $542f601a1b50d9f3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($542f601a1b50d9f3$var$ConditionalProfileCard, props);
}

});
parcelRegister("cVfTl", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
    return parcelRequire('3FCPe');
}, function() {
    return parcelRequire('1dNQ0');
});

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});




parcelRegister("52xH0", function(module, exports) {

$parcel$export(module.exports, "useMutationWithRetriesCommit", () => $06b64b6d5858829f$export$aaa0248df1ccb7fc);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");
const $06b64b6d5858829f$export$aaa0248df1ccb7fc = ({ retries: retries, isValidOnCompleted: isValidOnCompleted })=>{
    return (0, $5uXOq.useCallback)((environment, config)=>{
        let disposable;
        let optimisticDisposable = null;
        const handleCommitWithRetries = ({ retriesLeft: retriesLeft })=>{
            disposable = (0, $8Uumt.commitMutation)(environment, {
                ...config,
                onCompleted: (response, errors)=>{
                    if (isValidOnCompleted(response, errors)) {
                        config.onCompleted?.(response, errors);
                        return;
                    }
                    if (retriesLeft > 0) {
                        optimisticDisposable = (0, $8Uumt.applyOptimisticMutation)(environment, config);
                        // Wait 100ms before retrying
                        const timeout = setTimeout(()=>{
                            optimisticDisposable?.dispose();
                            handleCommitWithRetries({
                                retriesLeft: retriesLeft - 1
                            });
                        }, 100);
                        disposable = {
                            dispose: ()=>{
                                optimisticDisposable?.dispose();
                                clearTimeout(timeout);
                            }
                        };
                        return;
                    }
                    // Last retry needs to call onComplete
                    config.onCompleted?.(response, errors);
                }
            });
        };
        handleCommitWithRetries({
            retriesLeft: retries
        });
        // Return a new disposable that cleans up the optimistic AND committed operations
        return {
            dispose: ()=>{
                disposable?.dispose();
            }
        };
    }, [
        isValidOnCompleted,
        retries
    ]);
};

});



parcelRegister("3mocF", function(module, exports) {

$parcel$export(module.exports, "UserCell", () => $c3c47e8129b3ebfa$export$dc0ef711c0db7c30);

var $gaogj = parcelRequire("gaogj");

var $8AQu3 = parcelRequire("8AQu3");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $ujWmd = parcelRequire("ujWmd");

var $jpY8v = parcelRequire("jpY8v");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $gxQQ4 = parcelRequire("gxQQ4");

var $ki5vM = parcelRequire("ki5vM");

var $dPVUu = parcelRequire("dPVUu");

var $17T5l = parcelRequire("17T5l");


var $g5X3G = parcelRequire("g5X3G");

var $65VLO = parcelRequire("65VLO");

var $Br57E = parcelRequire("Br57E");

var $6wboE = parcelRequire("6wboE");

var $hKMVG = parcelRequire("hKMVG");

var $jFYC8 = parcelRequire("jFYC8");

var $e9M6d = parcelRequire("e9M6d");

var $9B8qu = parcelRequire("9B8qu");
const $c3c47e8129b3ebfa$export$afb022e5bfe0b377 = (accountId)=>(children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17T5l.default), {
            accountId: accountId ?? '',
            actions: [
                (0, $e6a2e0952e4731b8$export$23cedd3261bd8015)
            ]
        }, children);
const $c3c47e8129b3ebfa$export$dc0ef711c0db7c30 = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, projectKey: projectKey, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $8AQu3.default), fieldRef);
    if (data.fieldId === 'assignee' || data.fieldId === 'reporter' || (0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3c47e8129b3ebfa$export$df3d80016052952c, {
        fieldRef: data,
        projectKey: projectKey,
        menuPortalTarget: // Portal the menu outside of the scroll container, i.e., table body
        // to prevent clipping in Safari (see https://bugs.webkit.org/show_bug.cgi?id=160953#c20)
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        (0, $jpY8v.isSafari)() ? document.body : undefined,
        isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover
    });
    const { type: type, user: user } = data;
    const { name: name, accountId: accountId, picture: picture } = user ?? {};
    const displayText = name ?? formatMessage(type !== (0, $65VLO.KNOWN_COLUMN_TYPES).ASSIGNEE ? (0, $9B8qu.default).anonymous : (0, $9B8qu.default).unassigned);
    if (user != null && (name == null || accountId == null)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "user",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6wboE.ConditionalWrapper), {
        condition: accountId !== undefined,
        renderWrapper: $c3c47e8129b3ebfa$export$afb022e5bfe0b377(accountId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3c47e8129b3ebfa$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: picture,
        size: "small",
        borderColor: "transparent",
        name: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3c47e8129b3ebfa$var$Text, null, displayText)));
});
const $c3c47e8129b3ebfa$export$df3d80016052952c = ({ fieldRef: fieldRef, projectKey: projectKey, menuPortalTarget: menuPortalTarget, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $gaogj.default), fieldRef);
    const isAssigneeReporter = data.fieldId === 'assignee' || data.fieldId === 'reporter';
    const isCreatorField = data.fieldId === 'creator';
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isInlineEditingSupported = isAssigneeReporter || isInlineEditingExtendedFieldSupportEnabled; // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    // We can also disable editability of the creator field as it is never editable.
    let isEditable;
    if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingSupported && !isCreatorField ? data.lazyIsEditableInIssueView : false;
    else isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const shouldRenderHoverPopover = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    switch(data.fieldId){
        case 'assignee':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxQQ4.AssigneeInlineEditViewWithIsEditable), {
                attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "center",
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: "fixed",
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                projectKey: (0, $g5X3G.toProjectKey)(projectKey),
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        case 'reporter':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ki5vM.ReporterInlineEditViewWithIsEditable), {
                attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "center",
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: "fixed",
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        default:
            {
                const noneOptionLabel = isCreatorField ? formatMessage((0, $9B8qu.default).anonymous) : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPVUu.SingleUserPickerInlineEditViewWithIsEditable), {
                    attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                    spacing: "default",
                    editViewPopup: true,
                    editViewPopupAlignBlock: "center",
                    fragmentRef: data,
                    isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
                    menuPosition: "fixed",
                    portalElement: menuPortalTarget,
                    readViewFitContainerHeight: true,
                    noneOptionLabel: noneOptionLabel,
                    shouldRenderHoverPopover: shouldRenderHoverPopover && !isReadOnlyWithoutHoverPopover
                });
            }
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3c47e8129b3ebfa$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvu2gc _1reo15vq _1bto1l2s _o5721q9c _y3gn1e5h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3c47e8129b3ebfa$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _80om73ad _18u01i6y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gaogj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccb002183d6f39c8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<51281952c53ea8a9049c9fb9163738de>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ccb002183d6f39c8$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "user_nativeIssueTable_UserCellInternal_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$ccb002183d6f39c8$var$node.hash = "70c9b5cc4f6637fc8553932c9c90dc8f";
var $ccb002183d6f39c8$export$2e2bcd8739ae039 = $ccb002183d6f39c8$var$node;

});

parcelRegister("8AQu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff3aa276c93a53f9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3281df4ab3692851ab8562e9a5d372a1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ff3aa276c93a53f9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "user_nativeIssueTable_UserCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "user_nativeIssueTable_UserCellInternal_fieldRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$ff3aa276c93a53f9$var$node.hash = "a362c09fb0469678ce4210679cf0a5fa";
var $ff3aa276c93a53f9$export$2e2bcd8739ae039 = $ff3aa276c93a53f9$var$node;

});

parcelRegister("gxQQ4", function(module, exports) {

$parcel$export(module.exports, "AssigneeInlineEditViewWithIsEditable", () => $1a6e434f2597fd76$export$e07ee235d4f5b512);
$parcel$export(module.exports, "AssigneeInlineEditView", () => $1a6e434f2597fd76$export$9f32fa927ad908e5);

var $bLOxp = parcelRequire("bLOxp");

var $6Po9N = parcelRequire("6Po9N");

var $dL3hV = parcelRequire("dL3hV");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");

var $dRKyO = parcelRequire("dRKyO");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $pa9q9 = parcelRequire("pa9q9");

var $ctrpc = parcelRequire("ctrpc");

var $eqk5T = parcelRequire("eqk5T");

var $jrRyX = parcelRequire("jrRyX");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $8I57r = parcelRequire("8I57r");


var $jJZqs = parcelRequire("jJZqs");

var $5Wobd = parcelRequire("5Wobd");

var $ieDtd = parcelRequire("ieDtd");

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $kMUI7 = parcelRequire("kMUI7");

var $cg95v = parcelRequire("cg95v");

var $iAa6l = parcelRequire("iAa6l");
const $1a6e434f2597fd76$var$isEqualUser = (a, b)=>a?.id === b?.id;
const $1a6e434f2597fd76$export$e07ee235d4f5b512 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, portalElement: portalElement, onCancel: onCancel, onEdit: onEdit, isDisabledTooltipShown: isDisabledTooltipShown = false, projectKey: projectKey, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const isFieldEditable = (0, $4R6GH.fg)('relay-migration-issue-fields-assignee-fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>overriding.overrideIsEditable(isEditable || false), [
        isEditable,
        overriding
    ]) : isEditable;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_inviter_on_join_notification');
    const [assigneeIdFromQueryParam, setAssigneeIdFromQueryParam] = (0, $ieDtd.useQueryParam)('setAssignee');
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $dL3hV.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, user: user, fieldConfig: fieldConfig } = data;
    const fieldName = (0, $4R6GH.fg)('relay-migration-issue-fields-assignee-fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>overriding.overrideLabel(name), [
        name,
        overriding
    ]) : name;
    const isFieldRequired = fieldConfig?.isRequired ?? false;
    // Node: Change the MUTATION_NAME whenever the mutation name is also being changed
    const MUTATION_NAME = 'assignee_issueFieldAssignee_AssigneeField_Mutation';
    const [commit] = (0, $8Uumt.useMutation)((0, $6Po9N.default));
    // #endregion
    const initialValue = user ?? null;
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const handleSubmit = (0, $5uXOq.useCallback)((newUser, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newUser);
        (0, $5Wobd.startCapturingTraceIds)(MUTATION_NAME);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newUser?.id ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSingleSelectUserPickerField?.success) {
                    (0, $5Wobd.stopCapturingTraceIds)(MUTATION_NAME);
                    onSuccess();
                } else {
                    const traceIds = (0, $5Wobd.getTraceIds)(MUTATION_NAME);
                    (0, $5Wobd.stopCapturingTraceIds)(MUTATION_NAME);
                    const gqlError = mutationData.jira?.updateSingleSelectUserPickerField?.errors?.[0];
                    onFail(new (0, $jJZqs.default)(gqlError?.extensions?.statusCode || 0, gqlError?.message || undefined, traceIds[0]));
                }
            },
            onError (error) {
                onFail(error);
                (0, $5Wobd.stopCapturingTraceIds)(MUTATION_NAME);
            },
            optimisticResponse: {
                jira: {
                    updateSingleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            user: newUser ? {
                                id: newUser.id,
                                accountId: newUser.accountId,
                                accountStatus: newUser.accountStatus,
                                name: newUser.name,
                                picture: newUser.picture,
                                __typename: 'AtlassianAccountUser'
                            } : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        uniqueFieldId,
        onSubmit
    ]);
    const setAnalyticsAttributes = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)((value)=>{
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, initialValue?.accountId, value?.accountId || null);
    }, [
        fieldId,
        initialValue
    ]) : undefined;
    const validator = (0, $cg95v.useAssigneeValidator)(fieldName, isFieldRequired);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $1a6e434f2597fd76$var$isEqualUser,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        validator: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? validator : undefined,
        clipboardComponentType: 'singleUser',
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            setAnalyticsAttributes: setAnalyticsAttributes
        }
    });
    // #region Read view
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8I57r.SingleUserPickerWithProfileCardReadView), {
            fragmentRef: data,
            emptyUserLabel: formatMessage((0, $kMUI7.default).unassignedOption),
            profileCardAction: (0, $e6a2e0952e4731b8$export$6bef782d14a92db8),
            shouldRenderHoverPopover: shouldRenderHoverPopover,
            fieldId: fieldId
        }), [
        data,
        formatMessage,
        shouldRenderHoverPopover,
        fieldId
    ]);
    // #endregion
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            spacing: spacing,
            projectKey: projectKey,
            fetchSuggestionsOnMount: false,
            portalElement: portalElement,
            enablePeopleInvite: true,
            includeNoneOption: !isFieldRequired,
            isClearable: !isFieldRequired,
            menuPosition: menuPosition,
            label: fieldName,
            isInvalid: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? !!invalidMessage : undefined
        });
    const editButtonLabel = formatMessage((0, $dRKyO.default).extendedEditButtonLabel, {
        inputFieldValue: initialValue?.name ?? formatMessage((0, $kMUI7.default).unassignedOption),
        fieldName: fieldName
    });
    (0, $5uXOq.useEffect)(()=>{
        if (assigneeIdFromQueryParam && isFieldEditable && expConfig.get('isEnabled', false)) {
            if (initialValue !== null) showFlag({
                type: 'error',
                isAutoDismiss: true,
                title: formatMessage((0, $kMUI7.default).autoAssignErrorFlagTitle),
                description: formatMessage((0, $kMUI7.default).autoAssignErrorFlagBody),
                messageId: 'issue-field-assignee-inline-edit-full.ui.assignee.show-flag.error.auto-assign-fail',
                messageType: 'transactional'
            });
            else commit({
                variables: {
                    input: {
                        id: uniqueFieldId,
                        operation: {
                            operation: 'SET',
                            id: `ari:cloud:identity::user/${assigneeIdFromQueryParam}`
                        }
                    }
                },
                onCompleted: (mutationData)=>{
                    if (mutationData.jira?.updateSingleSelectUserPickerField?.success) {
                        (0, $5Wobd.stopCapturingTraceIds)(MUTATION_NAME);
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                            action: (0, $iAa6l.ONLOAD_ASSIGN_ANALYTICS).ACTION,
                            actionSubject: (0, $iAa6l.ONLOAD_ASSIGN_ANALYTICS).ACTION_SUBJECT
                        }));
                    } else (0, $5Wobd.stopCapturingTraceIds)(MUTATION_NAME);
                }
            });
            setAssigneeIdFromQueryParam(undefined);
        }
    }, [
        assigneeIdFromQueryParam,
        commit,
        createAnalyticsEvent,
        expConfig,
        formatMessage,
        initialValue,
        isFieldEditable,
        setAssigneeIdFromQueryParam,
        showFlag,
        uniqueFieldId
    ]);
    const inlineEditElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $eqk5T.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readView: renderReadView,
        hideActionButtons: true,
        editButtonLabel: editButtonLabel,
        readViewFitContainerHeight: readViewFitContainerHeight
    });
    return isDisabledTooltipShown && !isFieldEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $dRKyO.default).disabledReporterTooltip, {
            fieldName: fieldName
        }),
        position: "mouse"
    }, inlineEditElement) : inlineEditElement;
};
const $1a6e434f2597fd76$export$9f32fa927ad908e5 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $bLOxp.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1a6e434f2597fd76$export$e07ee235d4f5b512, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("bLOxp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5b6f3b193b894b6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9ea929c7ab7c075bed623095bf805b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b5b6f3b193b894b6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$b5b6f3b193b894b6$var$node.hash = "93c1d9e2338da6a23190803216172e69";
var $b5b6f3b193b894b6$export$2e2bcd8739ae039 = $b5b6f3b193b894b6$var$node;

});

parcelRegister("6Po9N", function(module, exports) {

$parcel$export(module.exports, "default", () => $120efd4ad8338ef4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e918e00b96147ea6bf09ae576e90430e>>
 * @relayHash edf533ecdfe81145f0d5ed0486a7d74c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d872673080e443d67f3c30873225e21fdfd2b89e010b0cfb4f1f1c7f8da5f301
const $120efd4ad8338ef4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v8 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d872673080e443d67f3c30873225e21fdfd2b89e010b0cfb4f1f1c7f8da5f301",
            "metadata": {},
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$120efd4ad8338ef4$var$node.hash = "6c6c314bdc60901e8c03415b7add3145";
var $120efd4ad8338ef4$export$2e2bcd8739ae039 = $120efd4ad8338ef4$var$node;

});

parcelRegister("dL3hV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2abb2e43b564b294$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e2149847065382e9713c221d19daf2fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2abb2e43b564b294$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accountStatus"
                    },
                    v0 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectUserPickerField"
    };
}();
$2abb2e43b564b294$var$node.hash = "3dea6b061e5fab4e19523a4247ac9c2d";
var $2abb2e43b564b294$export$2e2bcd8739ae039 = $2abb2e43b564b294$var$node;

});

parcelRegister("dRKyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6e52bd6588bf986$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d6e52bd6588bf986$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    confirmButtonLabel: {
        "id": "inline-edit.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "inline-edit.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "inline-edit.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    },
    addButtonLabel: {
        "id": "inline-edit.add-button-label",
        "defaultMessage": "Add {fieldName}"
    },
    extendedEditButtonLabel: {
        "id": "inline-edit.extended-edit-button-label",
        "defaultMessage": "{inputFieldValue}- edit {fieldName}"
    },
    disabledEditButtonLabel: {
        "id": "inline-edit.disabled-edit-button-label",
        "defaultMessage": "{fieldName} - can\u2019t be edited"
    },
    disabledReporterTooltip: {
        "id": "inline-edit.disabled-inline-edit-tooltip",
        "defaultMessage": "{fieldName} can\u2019t be edited"
    },
    columnTitleAriaLabel: {
        "id": "inline-edit.column-title-aria-label",
        "defaultMessage": "Add column name"
    }
});

});

parcelRegister("eqk5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $eed1f64e61506d37$export$2e2bcd8739ae039);

var $5ZUv0 = parcelRequire("5ZUv0");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $eed1f64e61506d37$var$AssigneeEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("dha1s")), {
        moduleId: "3f5ced6e"
    }),
    getPreloadProps: ()=>({
            queries: {
                rootData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $5ZUv0.default,
                    variables: {}
                }
            }
        })
});
var $eed1f64e61506d37$export$2e2bcd8739ae039 = $eed1f64e61506d37$var$AssigneeEditViewEntryPoint;

});
parcelRegister("5ZUv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $20091a513a380348$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c3533b181da4fe930f227b215516895>>
 * @relayHash c0a99e60ca7db3e867b3bb2039798d28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 06cc27c43b93217b220d59a67c5b60e54cc82db33ba6e684ea3f67b1f62fb4a0
const $20091a513a380348$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "06cc27c43b93217b220d59a67c5b60e54cc82db33ba6e684ea3f67b1f62fb4a0",
        "metadata": {},
        "name": "assigneeEditView_rootQuery",
        "operationKind": "query",
        "text": null
    }
};
var $20091a513a380348$export$2e2bcd8739ae039 = $20091a513a380348$var$node;

});

parcelRegister("dha1s", function(module, exports) {

let $9aa4a3238a765e0b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9aa4a3238a765e0b$var$load("hmsMN").then(()=>parcelRequire('lYdFI'));

});


parcelRegister("8I57r", function(module, exports) {

$parcel$export(module.exports, "SingleUserPickerWithProfileCardReadView", () => $6c5ba3942d56f082$export$2f1ab379ffebbded);

var $jleEX = parcelRequire("jleEX");

var $49C2A = parcelRequire("49C2A");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $ujWmd = parcelRequire("ujWmd");

var $cgL5K = parcelRequire("cgL5K");

var $4R6GH = parcelRequire("4R6GH");

var $dpHMc = parcelRequire("dpHMc");

var $koVbs = parcelRequire("koVbs");

var $eZibI = parcelRequire("eZibI");

var $iv6X1 = parcelRequire("iv6X1");


var $17T5l = parcelRequire("17T5l");

var $l8ruj = parcelRequire("l8ruj");

var $7RWSM = parcelRequire("7RWSM");
const $6c5ba3942d56f082$export$65db1532781bc51 = ({ fragmentRef: fragmentRef, emptyUserLabel: emptyUserLabel = null, shouldRenderHoverPopover: shouldRenderHoverPopover, fieldId: fieldId })=>{
    const data = (0, $8Uumt.useFragment)((0, $49C2A.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    const { name: name = emptyUserLabel ?? formatMessage((0, $7RWSM.default).anonymousOption), picture: picture, accountStatus: accountStatus } = data?.user || {};
    const contentRef = (0, $5uXOq.useRef)(null);
    if (!data?.user && fieldId !== 'assignee' && fieldId !== 'reporter' && isExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), {
        emptyText: formatMessage((0, $7RWSM.default).noValueTextExperiment)
    });
    if (shouldRenderHoverPopover && data?.user === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
        content: name,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c5ba3942d56f082$var$Container, {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            as: $6c5ba3942d56f082$var$AvatarAlignmentFix,
            src: picture,
            name: name,
            size: "small",
            borderColor: "transparent"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            maxLines: 1,
            ref: contentRef
        }, name)));
    return(// We use our own container element rather than an AvatarItem as we've observed hydration bugs with SSR+Emotion
    // when this component is wrapped in an async profile card, and this approach is the path of least friction.
    // Further context here https://atlassian.slack.com/archives/C060GTVV988/p1712624943348969.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c5ba3942d56f082$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        as: $6c5ba3942d56f082$var$AvatarAlignmentFix,
        src: picture,
        name: name,
        size: "small",
        borderColor: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c5ba3942d56f082$var$TextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, name), data?.user && accountStatus !== 'active' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c5ba3942d56f082$var$UserStatus, null, `(${formatMessage((0, $7RWSM.default).deactivated)})`))));
};
const $6c5ba3942d56f082$export$2f1ab379ffebbded = ({ fragmentRef: fragmentRef, emptyUserLabel: emptyUserLabel, profileCardAction: profileCardAction, shouldRenderHoverPopover: shouldRenderHoverPopover, fieldId: fieldId })=>{
    const data = (0, $8Uumt.useFragment)((0, $jleEX.default), fragmentRef);
    const accountId = data?.user?.accountId || null;
    const actions = (0, $5uXOq.useMemo)(()=>profileCardAction ? [
            (0, $e6a2e0952e4731b8$export$23cedd3261bd8015),
            profileCardAction
        ] : [
            (0, $e6a2e0952e4731b8$export$23cedd3261bd8015)
        ], [
        profileCardAction
    ]);
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "issue-field-single-user-picker-read-view",
        ...(0, $4R6GH.fg)('empanada_collapse_user_picker_segment_into_list') ? {
            mode: 'list'
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17T5l.default), {
        ...(0, $4R6GH.fg)('aria-label-for-issue-reporter-or-assignee-card') ? {
            prepopulatedData: {
                fullName: data?.user?.name
            }
        } : {},
        accountId: accountId,
        actions: actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c5ba3942d56f082$export$65db1532781bc51, {
        fragmentRef: data,
        emptyUserLabel: emptyUserLabel,
        shouldRenderHoverPopover: shouldRenderHoverPopover,
        fieldId: fieldId
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "issue-field-single-user-picker-read-view",
        ...(0, $4R6GH.fg)('empanada_collapse_user_picker_segment_into_list') ? {
            mode: 'list'
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c5ba3942d56f082$export$65db1532781bc51, {
        fragmentRef: data,
        emptyUserLabel: emptyUserLabel,
        shouldRenderHoverPopover: shouldRenderHoverPopover,
        fieldId: fieldId
    }));
};
/**
 * Component to pass for "as" prop of Avatar. It reverses the 2px margin added in the Avatar
 * component when a transparent border is used.
 *
 * Done using div + css because styled components are not compatible with Avatar's types.
 */ const $6c5ba3942d56f082$var$AvatarAlignmentFix = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_19pk1i6y _2hwx1i6y _otyr1i6y _18u01i6y"
        ])
    }));
const $6c5ba3942d56f082$var$avatarAlignmentStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c5ba3942d56f082$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c5ba3942d56f082$var$TextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c5ba3942d56f082$var$UserStatus = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _18u0v77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jleEX", function(module, exports) {

$parcel$export(module.exports, "default", () => $73bb5fbcaca20c24$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<75c9f0edae87b35dae025f46e4be4e99>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $73bb5fbcaca20c24$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$73bb5fbcaca20c24$var$node.hash = "c59dbeffeee9029f50284e101470f0fa";
var $73bb5fbcaca20c24$export$2e2bcd8739ae039 = $73bb5fbcaca20c24$var$node;

});

parcelRegister("49C2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1b7ed5c74e4cde$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ddc2cadf7150eb840bac96328f39a8a6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cf1b7ed5c74e4cde$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "ScalarField",
                    "name": "accountStatus"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$cf1b7ed5c74e4cde$var$node.hash = "83f7121fa6b0005e4cbdae4ef31fe6bb";
var $cf1b7ed5c74e4cde$export$2e2bcd8739ae039 = $cf1b7ed5c74e4cde$var$node;

});

const $e6a2e0952e4731b8$export$81319ffa9c0d18d7 = 'profileCardNext';
const $e6a2e0952e4731b8$export$50632e21ea714398 = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $e6a2e0952e4731b8$export$23cedd3261bd8015 = 'viewProfile';
const $e6a2e0952e4731b8$export$6bef782d14a92db8 = 'assignedIssues';
const $e6a2e0952e4731b8$export$6b36f20db7a18a86 = 'reportedIssues';
const $e6a2e0952e4731b8$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("17T5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a74b751ed05583f9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


const $a74b751ed05583f9$var$ConditionalProfileCard = (parcelRequire("8YNIc")).default;
function $a74b751ed05583f9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a74b751ed05583f9$var$ConditionalProfileCard, props);
}

});
parcelRegister("8YNIc", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
    return parcelRequire('kKeZ6');
}, function() {
    return parcelRequire('2QW4M');
});

});


parcelRegister("7RWSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9a8e9645a3d7f82$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d9a8e9645a3d7f82$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deactivated: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.deactivated",
        "defaultMessage": "Deactivated"
    },
    anonymousOption: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.anonymous-option",
        "defaultMessage": "Anonymous"
    },
    noValueTextExperiment: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.no-value-text-experiment",
        "defaultMessage": "Add user"
    }
});

});


parcelRegister("kMUI7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9de313c066302fc8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9de313c066302fc8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee-inline-edit-full.assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    assignToMe: {
        "id": "issue-field-assignee-inline-edit-full.assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    requiredErrorMessage: {
        "id": "issue-field-assignee-inline-edit-full.assignee.required-error-message",
        "defaultMessage": "{fieldName} is required"
    },
    autoAssignErrorFlagTitle: {
        "id": "issue-field-assignee-inline-edit-full.assignee.auto-assign-error-flag-title",
        "defaultMessage": "We can't automatically assign this work item"
    },
    autoAssignErrorFlagBody: {
        "id": "issue-field-assignee-inline-edit-full.assignee.auto-assign-error-flag-body",
        "defaultMessage": "To assign this work item you'll need to remove the existing assignee."
    }
});

});

parcelRegister("cg95v", function(module, exports) {

$parcel$export(module.exports, "useAssigneeValidator", () => $b3ec372c557cff90$export$37df2b94c6c5d4a3);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $kMUI7 = parcelRequire("kMUI7");
const $b3ec372c557cff90$export$37df2b94c6c5d4a3 = (fieldName, isRequired)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const submit = (0, $5uXOq.useCallback)((value)=>{
        if (isRequired && value === null) return {
            type: 'error',
            message: formatMessage((0, $kMUI7.default).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        submit: submit
    };
};

});

parcelRegister("iAa6l", function(module, exports) {

$parcel$export(module.exports, "ONLOAD_ASSIGN_ANALYTICS", () => $bdf562d01f01e878$export$f72b320e48c775d);
const $bdf562d01f01e878$export$f72b320e48c775d = Object.freeze({
    ACTION: 'viewed',
    ACTION_SUBJECT: 'assign'
});

});


parcelRegister("ki5vM", function(module, exports) {

$parcel$export(module.exports, "ReporterInlineEditViewWithIsEditable", () => $dc493525615f1251$export$f3ca6190158a888f);
$parcel$export(module.exports, "ReporterInlineEditView", () => $dc493525615f1251$export$981d7f2f0ffb0beb);

var $6PxiB = parcelRequire("6PxiB");

var $6uQZO = parcelRequire("6uQZO");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $dPVUu = parcelRequire("dPVUu");


var $9GIXc = parcelRequire("9GIXc");
const $dc493525615f1251$export$f3ca6190158a888f = ({ fragmentRef: fragmentRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $6uQZO.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPVUu.SingleUserPickerInlineEditViewWithIsEditable), {
        ...props,
        fragmentRef: data,
        noneOptionLabel: formatMessage((0, $9GIXc.default).anonymous),
        profileCardAction: (0, $e6a2e0952e4731b8$export$6b36f20db7a18a86)
    });
};
const $dc493525615f1251$export$981d7f2f0ffb0beb = ({ fragmentRef: fragmentRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $6PxiB.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPVUu.SingleUserPickerInlineEditView), {
        ...props,
        fragmentRef: data,
        noneOptionLabel: formatMessage((0, $9GIXc.default).anonymous),
        profileCardAction: (0, $e6a2e0952e4731b8$export$6b36f20db7a18a86)
    });
};

});
parcelRegister("6PxiB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9adedf9c82db4b42$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e444162d4db31fe2d8cf9ce3d49c500a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9adedf9c82db4b42$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditView_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$9adedf9c82db4b42$var$node.hash = "bd02fa384b206ea57830ba99674f24b9";
var $9adedf9c82db4b42$export$2e2bcd8739ae039 = $9adedf9c82db4b42$var$node;

});

parcelRegister("6uQZO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b3f908769d1f569$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb86f10febd7873bf5fcf89f85958c48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5b3f908769d1f569$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$5b3f908769d1f569$var$node.hash = "75550b2f1743d8a0b6176f6ded3b5c91";
var $5b3f908769d1f569$export$2e2bcd8739ae039 = $5b3f908769d1f569$var$node;

});

parcelRegister("dPVUu", function(module, exports) {

$parcel$export(module.exports, "SingleUserPickerInlineEditViewWithIsEditable", () => $f8a0c980df733480$export$c143582b21f1a708);
$parcel$export(module.exports, "SingleUserPickerInlineEditView", () => $f8a0c980df733480$export$f182346570197b8);

var $18avh = parcelRequire("18avh");

var $cXfiA = parcelRequire("cXfiA");

var $9ADr6 = parcelRequire("9ADr6");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dRKyO = parcelRequire("dRKyO");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $jrRyX = parcelRequire("jrRyX");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $8I57r = parcelRequire("8I57r");

var $5xr5P = parcelRequire("5xr5P");

var $4mbgU = parcelRequire("4mbgU");

var $fYcYF = parcelRequire("fYcYF");

var $8TzGZ = parcelRequire("8TzGZ");
const $f8a0c980df733480$var$isEqualUser = (a, b)=>a?.id === b?.id;
const $f8a0c980df733480$export$c143582b21f1a708 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, onCancel: onCancel, onEdit: onEdit, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, noneOptionLabel: noneOptionLabel, profileCardAction: profileCardAction, portalElement: portalElement, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $9ADr6.default), fragmentRef);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, user: user, fieldConfig: fieldConfig } = data;
    const isFieldRequired = (0, $5uXOq.useMemo)(()=>fieldConfig?.isRequired ?? false, [
        fieldConfig?.isRequired
    ]);
    const fieldName = (0, $5uXOq.useMemo)(()=>overriding.overrideLabel(name), [
        name,
        overriding
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overriding.overrideIsEditable(isEditable), [
        isEditable,
        overriding
    ]);
    const [commit] = (0, $8Uumt.useMutation)((0, $cXfiA.default));
    const initialValue = user ?? null;
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const handleSubmit = (0, $5uXOq.useCallback)((newUser, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newUser);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newUser?.id ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSingleSelectUserPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateSingleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            user: newUser ? {
                                id: newUser.id,
                                accountId: newUser.accountId,
                                accountStatus: newUser.accountStatus,
                                name: newUser.name,
                                picture: newUser.picture,
                                __typename: 'AtlassianAccountUser'
                            } : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        uniqueFieldId,
        onSubmit
    ]);
    const validator = (0, $8TzGZ.useSingleUserPickerValidator)(fieldName, isFieldRequired);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $f8a0c980df733480$var$isEqualUser,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        validator: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? validator : undefined,
        clipboardComponentType: 'singleUser'
    });
    // #region Read view
    const finalNoneOptionLabel = noneOptionLabel ?? formatMessage((0, $fYcYF.default).noneOption);
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8I57r.SingleUserPickerWithProfileCardReadView), {
            fragmentRef: data,
            emptyUserLabel: finalNoneOptionLabel,
            profileCardAction: profileCardAction,
            shouldRenderHoverPopover: shouldRenderHoverPopover,
            fieldId: fieldId
        }), [
        data,
        finalNoneOptionLabel,
        profileCardAction,
        shouldRenderHoverPopover,
        fieldId
    ]);
    // #endregion
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            autoFocus: true,
            value: updatedValue ? (0, $4mbgU.transformAggToUserOption)(updatedValue) : null,
            onChange: handleChangeAndConfirm,
            onClear: ()=>handleChangeAndConfirm(null),
            spacing: spacing,
            noneOptionLabel: finalNoneOptionLabel,
            includeNoneOption: !isFieldRequired,
            isClearable: !isFieldRequired,
            menuPosition: menuPosition,
            portalElement: portalElement,
            ariaLabel: fieldName,
            isInvalid: (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? !!invalidMessage : undefined
        });
    const editButtonLabel = formatMessage((0, $dRKyO.default).extendedEditButtonLabel, {
        inputFieldValue: initialValue?.name ?? finalNoneOptionLabel,
        fieldName: fieldName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $5xr5P.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readView: renderReadView,
        hideActionButtons: true,
        editButtonLabel: editButtonLabel,
        readViewFitContainerHeight: readViewFitContainerHeight
    });
};
const $f8a0c980df733480$export$f182346570197b8 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $18avh.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f8a0c980df733480$export$c143582b21f1a708, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("18avh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7019c1a14db8f610$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ece559cc75651d75622d9b47e5f4a4ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7019c1a14db8f610$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$7019c1a14db8f610$var$node.hash = "d6afe351b35e0beb2951194f3010ad16";
var $7019c1a14db8f610$export$2e2bcd8739ae039 = $7019c1a14db8f610$var$node;

});

parcelRegister("cXfiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6113239507b14a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08007f396db418a9d13cbce15739952a>>
 * @relayHash b249572b29f7cf45d6d7890c57510aed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8768a3b7a61167cb3f57c1ea183973ef7e13af793cc24d86f169fda9c41a20dd
const $b6113239507b14a9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8768a3b7a61167cb3f57c1ea183973ef7e13af793cc24d86f169fda9c41a20dd",
            "metadata": {},
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b6113239507b14a9$var$node.hash = "bd06a0600bf6d9530e408c77f4b2739a";
var $b6113239507b14a9$export$2e2bcd8739ae039 = $b6113239507b14a9$var$node;

});

parcelRegister("9ADr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $717c4921573d5d2f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<13beec71928bfcdc44a62173d9c393a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $717c4921573d5d2f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accountStatus"
                    },
                    v0 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectUserPickerField"
    };
}();
$717c4921573d5d2f$var$node.hash = "aebeab1812e893081e79766395b9288b";
var $717c4921573d5d2f$export$2e2bcd8739ae039 = $717c4921573d5d2f$var$node;

});

parcelRegister("5xr5P", function(module, exports) {

$parcel$export(module.exports, "default", () => $837042a9990c20f3$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $837042a9990c20f3$var$SingleUserPickerEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("1h5Yl")), {
        moduleId: "9f05df27"
    }),
    getPreloadProps: ()=>({})
});
var $837042a9990c20f3$export$2e2bcd8739ae039 = $837042a9990c20f3$var$SingleUserPickerEditViewEntryPoint;

});
parcelRegister("1h5Yl", function(module, exports) {

let $0edc02f81d206ed1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0edc02f81d206ed1$var$load("2FJis").then(()=>parcelRequire('fceYi'));

});


parcelRegister("fYcYF", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc7fed20cd1630ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bc7fed20cd1630ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noneOption: {
        "id": "issue-field-single-user-picker-inline-edit-full.single-user-picker.none-option",
        "defaultMessage": "None"
    },
    requiredErrorMessage: {
        "id": "issue-field-single-user-picker-inline-edit-full.single-user-picker.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});

});

parcelRegister("8TzGZ", function(module, exports) {

$parcel$export(module.exports, "useSingleUserPickerValidator", () => $29734d31f9cede41$export$fb9026d1d46dfabe);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $fYcYF = parcelRequire("fYcYF");
const $29734d31f9cede41$export$fb9026d1d46dfabe = (fieldName, isRequired)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const submit = (0, $5uXOq.useCallback)((value)=>{
        if (isRequired && value === null) return {
            type: 'error',
            message: formatMessage((0, $fYcYF.default).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        submit: submit
    };
};

});


parcelRegister("9GIXc", function(module, exports) {

$parcel$export(module.exports, "default", () => $42d4f56294b87647$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $42d4f56294b87647$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    anonymous: {
        "id": "issue-field-reporter-inline-edit-full.reporter.anonymous",
        "defaultMessage": "Anonymous"
    }
});

});


parcelRegister("6wboE", function(module, exports) {

$parcel$export(module.exports, "ConditionalWrapper", () => $88c0b1c59b295500$export$39aecc95f0365819);

var $5uXOq = parcelRequire("5uXOq");
const $88c0b1c59b295500$export$39aecc95f0365819 = ({ children: children, condition: condition, renderWrapper: renderWrapper })=>condition ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});

parcelRegister("9B8qu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec45a8e07a851edd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ec45a8e07a851edd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassigned: {
        "id": "native-issue-table.common.issue-cells.user.unassigned",
        "defaultMessage": "Unassigned"
    },
    anonymous: {
        "id": "native-issue-table.common.issue-cells.user.anonymous",
        "defaultMessage": "Anonymous"
    }
});

});


parcelRegister("D17bC", function(module, exports) {

$parcel$export(module.exports, "VersionsCell", () => $8ec1f7da77f5061e$export$77526ce3d3d3b8ba);

var $2eyzz = parcelRequire("2eyzz");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $iEIQF = parcelRequire("iEIQF");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");

var $koVbs = parcelRequire("koVbs");

var $2bYmU = parcelRequire("2bYmU");

var $l8IoT = parcelRequire("l8IoT");

var $aB7bN = parcelRequire("aB7bN");

var $hKMVG = parcelRequire("hKMVG");

var $ddCsQ = parcelRequire("ddCsQ");
/**
 * Expected JQL Output: `project = ${projectKey} AND ${jqlTerm} = ${name}`
 */ const $8ec1f7da77f5061e$var$getLinkJql = (projectKey, jqlTerm, name)=>{
    const jast = (0, $iEIQF.default).jast((0, $iEIQF.default).query((0, $iEIQF.default).compoundClause((0, $iEIQF.default).compoundOperator((0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97)), [
        (0, $iEIQF.default).terminalClause((0, $iEIQF.default).field('project'), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS)), (0, $iEIQF.default).valueOperand(projectKey)),
        (0, $iEIQF.default).terminalClause((0, $iEIQF.default).field((0, $aB7bN.escapeBackslashes)(jqlTerm)), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS)), (0, $iEIQF.default).valueOperand((0, $aB7bN.escapeBackslashes)(name)))
    ])));
    return (0, $l0V05.print)(jast, {
        operatorCase: 'upper'
    });
};
const $8ec1f7da77f5061e$export$77526ce3d3d3b8ba = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, projectKey: projectKey, jqlTerm: jqlTerm })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { name: fieldName, selectedVersionsConnection: selectedVersionsConnection } = (0, $8Uumt.useFragment)((0, $2eyzz.default), fieldRef);
    const versions = selectedVersionsConnection?.edges;
    const filteredVersions = (0, $5uXOq.useMemo)(()=>versions?.map((edge)=>edge?.node?.name != null ? {
                key: edge.node.name,
                name: edge.node.name,
                href: `${issueSearchBaseUrl}?jql=${encodeURIComponent($8ec1f7da77f5061e$var$getLinkJql(projectKey, jqlTerm, edge.node.name))}`
            } : null).filter((0, $aB7bN.isNonNullish)) ?? [], [
        versions,
        issueSearchBaseUrl,
        projectKey,
        jqlTerm
    ]);
    if (!versions || versions.length !== filteredVersions.length || !projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: "versions",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bYmU.default), {
        items: filteredVersions,
        ItemComponent: (0, $l8IoT.TagItem),
        PopupContentWrapper: (0, $l8IoT.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $ddCsQ.default).triggerButtonGeneric, {
            fieldName: fieldName
        })
    });
});

});
parcelRegister("2eyzz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea4490b5de45f7ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6f6ee0189b5f6db6af7efd8ebc406adf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ea4490b5de45f7ce$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "versions_nativeIssueTable_VersionsCell",
        "selections": [
            v0 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    };
}();
$ea4490b5de45f7ce$var$node.hash = "d633c7e45438df5a321f477c661de24c";
var $ea4490b5de45f7ce$export$2e2bcd8739ae039 = $ea4490b5de45f7ce$var$node;

});

parcelRegister("ddCsQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad94f0f6e8da1043$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ad94f0f6e8da1043$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    triggerButtonGeneric: {
        "id": "native-issue-table.common.issue-cells.versions.trigger-button-generic",
        "defaultMessage": "See more versions for \u2018{fieldName}\u2018"
    }
});

});


parcelRegister("8S46R", function(module, exports) {

$parcel$export(module.exports, "CommentSummaryCell", () => $f37c6967587e23ae$export$ec9db7e6afbd918a);

var $7xSuc = parcelRequire("7xSuc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bFmnZ = parcelRequire("bFmnZ");

var $koVbs = parcelRequire("koVbs");

var $eZibI = parcelRequire("eZibI");

var $2e4p8 = parcelRequire("2e4p8");

var $4R6GH = parcelRequire("4R6GH");

var $e9M6d = parcelRequire("e9M6d");

var $jtnoX = parcelRequire("jtnoX");
const $f37c6967587e23ae$export$ec9db7e6afbd918a = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef, issueKey: issueKey, onIssueLinkSelected: onIssueLinkSelected })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isEmbedMode = (0, $4R6GH.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2e4p8.useIsEmbedMode)() : false;
    const data = (0, $8Uumt.useFragment)((0, $7xSuc.default), fieldRef);
    const canAddComment = data?.commentSummary?.canAddComment;
    const totalCount = data?.commentSummary?.totalCount;
    const renderedCommentCount = (0, $5uXOq.useMemo)(()=>{
        // No comments, add comment
        if (!totalCount) return formatMessage((0, $jtnoX.default).addComment);
        // Less than 100 comments, show count
        if (totalCount < 100) return formatMessage((0, $jtnoX.default).commentsCount, {
            commentCount: totalCount
        });
        // More than 99 comments, show 99+
        return formatMessage((0, $jtnoX.default).moreComments);
    }, [
        formatMessage,
        totalCount
    ]);
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        // Use default browser event handling when a modifier key is pressed during the click event
        const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
        const handled = !isEmbedMode && !isModifierKeyUsed && onIssueLinkSelected !== undefined && onIssueLinkSelected(issueKey, true);
        if (handled) e.preventDefault();
    }, [
        isEmbedMode,
        issueKey,
        onIssueLinkSelected
    ]);
    const hoverPopoverEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    if (!totalCount && !canAddComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: `/browse/${issueKey}`,
        xcss: [
            $f37c6967587e23ae$var$buttonStyles,
            !totalCount && $f37c6967587e23ae$var$emptyStyles
        ],
        onClick: handleClick,
        backgroundColor: "color.background.neutral.subtle",
        paddingInline: "space.075",
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bFmnZ))), {
        color: "currentColor",
        label: formatMessage((0, $jtnoX.default).comments)
    }), hoverPopoverEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        maxLines: 1
    }, renderedCommentCount) : renderedCommentCount);
});
const $f37c6967587e23ae$var$buttonStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    borderRadius: 'border.radius',
    borderWidth: '2px',
    borderStyle: 'solid',
    // borderColor doesn't allow transparent as a value so we use inline/block which has looser typing
    borderInlineColor: 'transparent',
    borderBlockColor: 'transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minHeight: '100%',
    maxWidth: '100%',
    textDecoration: 'none',
    ':focus': {
        borderInlineColor: 'color.border.focused',
        borderBlockColor: 'color.border.focused',
        outline: 0,
        color: 'color.text',
        textDecoration: 'none'
    },
    ':focus-visible': {
        borderInlineColor: 'color.border.focused',
        borderBlockColor: 'color.border.focused',
        outline: 0
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text',
        textDecoration: 'none'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $f37c6967587e23ae$var$emptyStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    ':focus': {
        color: 'color.text.subtlest'
    },
    ':hover': {
        color: 'color.text.subtlest'
    }
});

});
parcelRegister("7xSuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $786b3664aa0426a0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d9cc54fc88782605eb9ffbd21f6adfd8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $786b3664aa0426a0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "commentSummary_nativeIssueTable_CommentSummaryCell",
    "selections": [
        {
            "concreteType": "JiraCommentSummary",
            "kind": "LinkedField",
            "name": "commentSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canAddComment"
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ]
        }
    ],
    "type": "JiraCommentSummaryField"
};
$786b3664aa0426a0$var$node.hash = "91bb4bde7c95d88894f72343be5f8adf";
var $786b3664aa0426a0$export$2e2bcd8739ae039 = $786b3664aa0426a0$var$node;

});

parcelRegister("bFmnZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e4e36d6c115ce9$var$_react = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e4e36d6c115ce9$var$_baseNew = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e4e36d6c115ce9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e4e36d6c115ce9$var$CommentIcon = (props)=>/*#__PURE__*/ $87e4e36d6c115ce9$var$_react.default.createElement($87e4e36d6c115ce9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$87e4e36d6c115ce9$var$CommentIcon.displayName = 'CommentIcon';
var $87e4e36d6c115ce9$var$_default = module.exports.default = $87e4e36d6c115ce9$var$CommentIcon;

});

parcelRegister("jtnoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $35e1d8f36f497939$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $35e1d8f36f497939$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    comments: {
        "id": "business-list.list-view.comments-cell.comments",
        "defaultMessage": "Comments"
    },
    commentsCount: {
        "id": "business-list.list-view.comments-cell.comments-count",
        "defaultMessage": "{commentCount, plural, one {# comment} other {# comments}}"
    },
    moreComments: {
        "id": "business-list.list-view.comments-cell.more-comments",
        "defaultMessage": "99+ comments"
    },
    addComment: {
        "id": "business-list.list-view.comments-cell.add-comment",
        "defaultMessage": "Add comment"
    }
});

});


parcelRegister("6ArGj", function(module, exports) {

$parcel$export(module.exports, "UrlCell", () => $4bd44e0c9cff932f$export$110272e30ac53e5);

var $a820h = parcelRequire("a820h");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3L3Mi = parcelRequire("3L3Mi");

var $jFYC8 = parcelRequire("jFYC8");

var $Br57E = parcelRequire("Br57E");

var $e9M6d = parcelRequire("e9M6d");
const $4bd44e0c9cff932f$export$110272e30ac53e5 = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $a820h.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3L3Mi.UrlInlineEditViewIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        readViewFitContainerHeight: true,
        isSimpleInlineSmartLinkEnabled: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
};

});
parcelRegister("a820h", function(module, exports) {

$parcel$export(module.exports, "default", () => $79d3e58dc6a24c47$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64289f346ee2a0194a0429d6fc081742>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $79d3e58dc6a24c47$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "url_nativeIssueTable_UrlCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraUrlField"
};
$79d3e58dc6a24c47$var$node.hash = "290582e90638b9296d772bdb0ec42416";
var $79d3e58dc6a24c47$export$2e2bcd8739ae039 = $79d3e58dc6a24c47$var$node;

});

parcelRegister("3L3Mi", function(module, exports) {

$parcel$export(module.exports, "UrlInlineEditViewIsEditable", () => $70cc5a1f40d849e8$export$b805891365234836);
$parcel$export(module.exports, "UrlInlineEditView", () => $70cc5a1f40d849e8$export$9c96a1eab7a0bc87);

var $8rS4z = parcelRequire("8rS4z");

var $eg7hE = parcelRequire("eg7hE");

var $6HMw3 = parcelRequire("6HMw3");

var $daX4I = parcelRequire("daX4I");

var $3KVXi = parcelRequire("3KVXi");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $jrRyX = parcelRequire("jrRyX");

var $gGpyR = parcelRequire("gGpyR");

var $4BImu = parcelRequire("4BImu");

var $eRz50 = parcelRequire("eRz50");

var $5Im19 = parcelRequire("5Im19");

var $8zOmE = parcelRequire("8zOmE");

var $cSD7y = parcelRequire("cSD7y");

var $lXLX3 = parcelRequire("lXLX3");

var $7F8HM = parcelRequire("7F8HM");

var $6Luyz = parcelRequire("6Luyz");

var $2xwl9 = parcelRequire("2xwl9");
const $70cc5a1f40d849e8$export$21e755188d829de2 = ({ fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, readViewFitContainerWidth: readViewFitContainerWidth = true, onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onConfirm: onConfirm, onEnter: onEnter, onUpdate: onUpdate, onUpdateFailed: onUpdateFailed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $3KVXi.default), fragmentRef);
    const { id: uniqueFieldId, uri: uri, fieldConfig: fieldConfig, name: name, fieldId: fieldId, type: type } = data;
    const [commit] = (0, $8Uumt.useMutation)((0, $daX4I.default));
    // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const editFieldRef = (0, $5uXOq.useRef)(null);
    const [isEditing, setIsEditing] = (0, $5uXOq.useState)(startWithEditViewOpen);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(uri || '');
    const [errors, setErrors] = (0, $5uXOq.useState)(null);
    const [invalidMessage, setInvalidMessage] = (0, $5uXOq.useState)(null);
    const [showValidationMessage, setShowValidationMessage] = (0, $5uXOq.useState)(false);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overriding.overrideIsEditable(fieldConfig?.isEditable || false), [
        fieldConfig,
        overriding
    ]);
    const analyticsData = (0, $5uXOq.useMemo)(()=>({
            fieldKey: fieldId,
            fieldType: type
        }), [
        fieldId,
        type
    ]); // #endregion
    // #region Handle new value
    const save = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        /**
     * This will execute the GraphQl mutation.
     */ commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        uri: updatedValue || '',
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateUrlField) {
                    const { success: success, errors: responseErrors } = mutationData.jira?.updateUrlField;
                    if (success) {
                        onUpdate?.(updatedValue || ''); // Field updated event is a core action used to track MCU as defined in https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition
                        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'field updated', analyticsData);
                        return;
                    }
                    setErrors(responseErrors);
                } else setErrors([]);
                setIsEditing(true);
            },
            onError (error) {
                setErrors([
                    {
                        message: error.message
                    }
                ]);
                onUpdateFailed?.(updatedValue || '');
                setIsEditing(true);
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            optimisticResponse: {
                jira: {
                    updateUrlField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            uri: updatedValue,
                            fieldConfig: {
                                isEditable: true
                            }
                        }
                    }
                }
            }
        });
        setIsEditing(false);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    }, [
        commit,
        uniqueFieldId,
        updatedValue,
        onUpdate,
        onUpdateFailed,
        analyticsData,
        createAnalyticsEvent
    ]);
    // #endregion
    // #region Common callbacks
    const cancel = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        setErrors(null);
        setIsEditing(false); // @ts-expect-error - Argument of type 'string | null | undefined' is not assignable to parameter of type 'SetStateAction<string | null>'.
        setUpdatedValue(uri);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    }, [
        setErrors,
        uri
    ]);
    const onCancelRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        setShowValidationMessage(false);
        setInvalidMessage(null);
        cancel(analyticsEvent);
        onCancel && onCancel(analyticsEvent);
    }, [
        onCancel,
        cancel
    ]);
    const onConfirmRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        if (invalidMessage) {
            setShowValidationMessage(true);
            editFieldRef.current?.focus();
        } else {
            save(analyticsEvent);
            onConfirm && onConfirm(analyticsEvent, updatedValue);
        }
    }, [
        onConfirm,
        save,
        invalidMessage,
        editFieldRef,
        updatedValue
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        onEdit && onEdit(analyticsEvent);
    }, [
        onEdit
    ]);
    const onEscapeRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        setShowValidationMessage(false);
        setInvalidMessage(null);
        cancel(analyticsEvent);
        onEscape && onEscape(analyticsEvent);
    }, [
        onEscape,
        cancel
    ]);
    const onEnterRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        onEnter && onEnter(analyticsEvent);
    }, [
        onEnter
    ]);
    const onChange = (0, $5uXOq.useCallback)((event)=>{
        setShowValidationMessage(false);
        let { validationMessage: validationMessage } = event.target;
        const typedValue = event.target.value === '' ? null : event.target.value;
        if (!(0, $2xwl9.isAllowed)(typedValue)) validationMessage = formatMessage((0, $6Luyz.default).validUrl);
        setInvalidMessage(validationMessage);
        setErrors(null);
        setUpdatedValue(typedValue);
    }, [
        setErrors,
        setUpdatedValue,
        formatMessage
    ]); // #endregion
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($70cc5a1f40d849e8$var$ReadViewContainer, {
            "data-testid": "issue-field-url-inline-edit-full.ui.url.read-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Im19.UrlReadView), {
            fragmentRef: data
        })); // #endregion
    // #region Edit view
    const renderEditView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($70cc5a1f40d849e8$var$EditViewContainer, {
            "data-testid": "issue-field-url-inline-edit-full.ui.url.edit-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4BImu.SingleLineTextEditView), {
            ariaLabel: name,
            autoFocus: true,
            type: "url",
            ref: editFieldRef,
            value: updatedValue,
            onChange: onChange,
            invalidMessage: (0, $2xwl9.validationForErrors)(showValidationMessage, invalidMessage, // @ts-expect-error - Argument of type 'readonly { readonly message: string | null | undefined; }[] | null | undefined' is not assignable to parameter of type 'typeOfErrors | undefined'.
            errors)
        }))); // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($70cc5a1f40d849e8$var$InlineEditContainer, {
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gGpyR.FieldInlineEditStateLess), {
        editView: renderEditView,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        isLabelHidden: true,
        readView: renderReadView,
        readViewFitContainerWidth: readViewFitContainerWidth,
        testId: "issue-field-url-inline-edit-full.ui.url.field-inline-edit-state-less",
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequested,
        onEnter: onEnterRequest,
        onEscape: onEscapeRequest,
        defaultValue: updatedValue,
        fieldId: (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? fieldId : undefined
    }));
};
const $70cc5a1f40d849e8$export$b805891365234836 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, spacing: spacing = 'compact', readViewFitContainerHeight: readViewFitContainerHeight, isEditable: isEditable, isSimpleInlineSmartLinkEnabled: isSimpleInlineSmartLinkEnabled, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $6HMw3.default), fragmentRef);
    const [commit] = (0, $8Uumt.useMutation)((0, $eg7hE.default));
    const { id: uniqueFieldId, name: name, fieldId: fieldId, type: fieldType } = data; // #endregion Relay
    // #region State
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const uri = data.uri ?? '';
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(uri);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $5uXOq.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]); // #endregion State
    // #region Action
    const handleSubmit = (0, $5uXOq.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        uri: value
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateUrlField?.success) onSuccess();
                else onFail();
            },
            onError: (error)=>{
                onFail(error, error.message);
            },
            optimisticResponse: {
                jira: {
                    updateUrlField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            fieldId: fieldId,
                            type: fieldType,
                            name: name,
                            uri: value
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldType,
        name,
        onSubmit,
        uniqueFieldId
    ]);
    const validator = (0, $5uXOq.useMemo)(()=>{
        const change = (value)=>{
            if (!(0, $2xwl9.isAllowed)(value)) return {
                type: 'error',
                message: formatMessage((0, $6Luyz.default).validUrl)
            };
            return null;
        };
        return {
            change: change
        };
    }, [
        formatMessage
    ]);
    const actions = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: uri,
        updatedValue: updatedValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        validator: validator,
        clipboardComponentType: 'url'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = actions;
    const onChange = (0, $5uXOq.useCallback)(({ target: target })=>{
        handleChange(target.value);
    }, [
        handleChange
    ]); // #endregion Action
    // #region View
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Im19.UrlReadView), {
            fragmentRef: data,
            isSimpleInlineSmartLinkEnabled: isSimpleInlineSmartLinkEnabled,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        }), [
        data,
        isSimpleInlineSmartLinkEnabled,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            value: updatedValue,
            spacing: spacing,
            onChange: onChange,
            type: 'url',
            isInvalid: Boolean(invalidMessage),
            ariaLabel: fieldName
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $eRz50.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView
    });
};
const $70cc5a1f40d849e8$export$80ddb9ab68316fce = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $8rS4z.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($70cc5a1f40d849e8$export$b805891365234836, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};
const $70cc5a1f40d849e8$export$9c96a1eab7a0bc87 = (0, $cSD7y.componentWithFG)('jsc_inline_editing_field_refactor', $70cc5a1f40d849e8$export$80ddb9ab68316fce, $70cc5a1f40d849e8$export$21e755188d829de2); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70cc5a1f40d849e8$var$EditViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbyowjs _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70cc5a1f40d849e8$var$ReadViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _1nmz1hna _kqswh2mm _vwz4gktf _19bv12x7 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $70cc5a1f40d849e8$var$nonEditableStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70cc5a1f40d849e8$var$InlineEditContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1gzc1txw _auuz1h6o _6vgs1osq _1rjezwfg",
            !__cmplp.isEditable && "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _1nmz1hna _kqswh2mm _vwz4gktf _19bv12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8rS4z", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e834af0159c680$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac98cf9c096d64b8daeafe340a7af26a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $61e834af0159c680$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewNew_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraUrlField"
};
$61e834af0159c680$var$node.hash = "e70af483ddd145941defdd9bbeb62107";
var $61e834af0159c680$export$2e2bcd8739ae039 = $61e834af0159c680$var$node;

});

parcelRegister("eg7hE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d18c757333ad1b9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0be98e9836b36a14f3ecb1a017a5a35e>>
 * @relayHash eae3f029eeffbe1e2da24bd39b35162a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50ce5ef04d3badd7a165b493b9dfe5db963fd356442508323160227190ab2bad
const $7d18c757333ad1b9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "url_issueFieldUrl_UrlField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUrlFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateUrlField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraUrlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "url_issueFieldUrl_UrlField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUrlFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateUrlField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraUrlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "uri"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "50ce5ef04d3badd7a165b493b9dfe5db963fd356442508323160227190ab2bad",
            "metadata": {},
            "name": "url_issueFieldUrl_UrlField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$7d18c757333ad1b9$var$node.hash = "60222c1fb24270ee0c27b8d3bfc763a4";
var $7d18c757333ad1b9$export$2e2bcd8739ae039 = $7d18c757333ad1b9$var$node;

});

parcelRegister("6HMw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $65923d0cbe72d03a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63b14e199759744cdf583eb0c109846a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $65923d0cbe72d03a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "uri"
        },
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlReadviewFull_UrlReadView"
        }
    ],
    "type": "JiraUrlField"
};
$65923d0cbe72d03a$var$node.hash = "f560c76a2ba024cc2bd7b741c47d14d9";
var $65923d0cbe72d03a$export$2e2bcd8739ae039 = $65923d0cbe72d03a$var$node;

});

parcelRegister("daX4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e4af12622acce46$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<12a95677cf45665401dc47bd877b6700>>
 * @relayHash b4f729a9efca3d2311f2007f882a964a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb9fa4f255f32274880c3fc55a657de8206f71fc5007482a2413c16cdad6ffd4
const $1e4af12622acce46$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "url_issueFieldUrl_UrlField_OldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUrlFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateUrlField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraUrlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewOld_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "url_issueFieldUrl_UrlField_OldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUrlFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateUrlField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraUrlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "uri"
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fb9fa4f255f32274880c3fc55a657de8206f71fc5007482a2413c16cdad6ffd4",
            "metadata": {},
            "name": "url_issueFieldUrl_UrlField_OldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$1e4af12622acce46$var$node.hash = "b908881d73f71a207c8e4cb38dc9a8b3";
var $1e4af12622acce46$export$2e2bcd8739ae039 = $1e4af12622acce46$var$node;

});

parcelRegister("3KVXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9dfa1c16e3565e9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2b9b556714e043c134344fab947d26bf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b9dfa1c16e3565e9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewOld_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "uri"
        },
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlReadviewFull_UrlReadView"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraUrlField"
};
$b9dfa1c16e3565e9$var$node.hash = "29215cce3863b3be49bd2b2a229e3ca5";
var $b9dfa1c16e3565e9$export$2e2bcd8739ae039 = $b9dfa1c16e3565e9$var$node;

});

parcelRegister("4BImu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "SingleLineTextEditView", () => $c01748f518286b26$export$c561aa75a6a0d51b);
$parcel$export(module.exports, "default", () => $c01748f518286b26$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $qfj8c = parcelRequire("qfj8c");

var $bU3PY = parcelRequire("bU3PY");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $chqpx = parcelRequire("chqpx");

var $kY99m = parcelRequire("kY99m");

var $7mPT9 = parcelRequire("7mPT9");

var $4R6GH = parcelRequire("4R6GH");
const $c01748f518286b26$var$SingleLineTextField = (props, ref)=>{
    const { spacing: spacing, type: type = 'text', value: value = '', placeholder: placeholder = '', invalidMessage: invalidMessage = null, onChange: onChange, onBlur: onBlur, onFocus: onFocus, autoFocus: autoFocus = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, inputId: inputId, 'aria-describedby': ariaDescribedby, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    const typeTracingRef = (0, $chqpx.default)('single-line-text-field-type-tracing');
    const fieldRef = (0, $7mPT9.default)(ref, typeTracingRef);
    const displayValue = value === null ? '' : value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        "aria-describedby": (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? ariaDescribedby : undefined,
        type: type,
        value: displayValue,
        placeholder: placeholder,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        isInvalid: !!invalidMessage || isInvalid,
        autoFocus: autoFocus,
        ref: fieldRef,
        isCompact: spacing === 'compact',
        isDisabled: isDisabled,
        id: inputId,
        elemAfterInput: !!invalidMessage === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c01748f518286b26$var$warningWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            color: "var(--ds-icon-warning, #E56910)",
            label: ""
        })) : null,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    }), invalidMessage !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, invalidMessage) : null);
};
$c01748f518286b26$var$SingleLineTextField.displayName = 'SingleLineTextField';
const $c01748f518286b26$export$c561aa75a6a0d51b = /*#__PURE__*/ (0, $5uXOq.forwardRef)($c01748f518286b26$var$SingleLineTextField);
const $c01748f518286b26$var$SingleLineTextEditViewEntryPoint = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c01748f518286b26$export$c561aa75a6a0d51b, props);
var $c01748f518286b26$export$2e2bcd8739ae039 = $c01748f518286b26$var$SingleLineTextEditViewEntryPoint;
const $c01748f518286b26$var$warningWrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.050',
    marginRight: 'space.050'
});

});
parcelRegister("chqpx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cc946b0f8d55c5c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gg6CF = parcelRequire("gg6CF");

var $7Jxgt = parcelRequire("7Jxgt");

var $5gx4p = parcelRequire("5gx4p");

var $fe1wc = parcelRequire("fe1wc");

var $bFU4G = parcelRequire("bFU4G");
const $4cc946b0f8d55c5c$var$getTypingMetadata = (times, computeStartTime, typingPerformanceTracingMethod)=>{
    let min = 0;
    let max = 0;
    let avg = 0;
    let index = 0;
    let below50count = 0;
    times.forEach((time)=>{
        if (time !== 0) {
            avg = (avg * index + time) / ++index;
            if (time > max) max = time;
            if (min === 0 || time < min) min = time;
            if (time < 50) below50count++;
        }
    });
    return {
        typing: {
            min: min,
            max: max,
            avg: avg,
            count: index,
            below50count: below50count,
            compute: performance.now() - computeStartTime,
            typeTracingMethod: typingPerformanceTracingMethod
        }
    };
};
function $4cc946b0f8d55c5c$var$typingPerformanceTracingTimeout(element, name, rate) {
    let tsubmit;
    let times = [];
    let isInteractionInitialised = false;
    let id;
    const start = ()=>{
        id = (0, $7Jxgt.v4)();
        (0, $bFU4G.addNewInteraction)(id, name, 'typing', performance.now(), rate, null, null);
        isInteractionInitialised = true;
    };
    const end = ()=>{
        isInteractionInitialised = false;
        const timesCopy = times;
        times = [];
        (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), ()=>{
            const computeStartTime = performance.now();
            const data = $4cc946b0f8d55c5c$var$getTypingMetadata(timesCopy, computeStartTime, 'timeout');
            (0, $bFU4G.addMetadata)(id, data);
            (0, $bFU4G.tryComplete)(id);
        });
    };
    const onKeyPressHandler = (event)=>{
        if (!isInteractionInitialised) start();
        const startTime = event.timeStamp;
        setTimeout(()=>{
            const endTime = performance.now();
            const time = endTime - startTime;
            times.push(time);
            clearTimeout(tsubmit);
            tsubmit = setTimeout(end, 2000); // debounce
        }, 0);
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    element.addEventListener('keypress', onKeyPressHandler);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.removeEventListener('keypress', onKeyPressHandler);
    };
}
function $4cc946b0f8d55c5c$var$typingPerformanceTracingTimeoutNoAlloc(element, name, rate) {
    let tsubmit;
    let isInteractionInitialised = false;
    let min = 0;
    let max = 0;
    let below50count = 0;
    let avg = 0;
    let count = 0;
    let id;
    const resetStats = ()=>{
        min = 0;
        max = 0;
        below50count = 0;
        avg = 0;
        count = 0;
    };
    const start = ()=>{
        id = (0, $7Jxgt.v4)();
        (0, $bFU4G.addNewInteraction)(id, name, 'typing', performance.now(), rate, null, null);
        isInteractionInitialised = true;
    };
    const end = ()=>{
        isInteractionInitialised = false;
        const typingMetaData = {
            typing: {
                min: min,
                max: max,
                avg: avg,
                count: count,
                below50count: below50count,
                typeTracingMethod: 'timeoutNoAlloc'
            }
        };
        resetStats();
        (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), ()=>{
            (0, $bFU4G.addMetadata)(id, typingMetaData);
            (0, $bFU4G.tryComplete)(id);
        });
    };
    const onKeyPressHandler = (event)=>{
        if (!isInteractionInitialised) start();
        const startTime = event.timeStamp;
        setTimeout(()=>{
            const endTime = performance.now();
            const time = endTime - startTime;
            if (time !== 0) {
                avg = (avg * count + time) / ++count;
                if (time > max) max = time;
                if (min === 0 || time < min) min = time;
                if (time < 50) below50count++;
            }
            clearTimeout(tsubmit);
            tsubmit = setTimeout(end, 2000); // debounce
        }, 0);
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    element.addEventListener('keypress', onKeyPressHandler);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.removeEventListener('keypress', onKeyPressHandler);
    };
}
function $4cc946b0f8d55c5c$var$typingPerformanceTracingMutationObserver(element, name, rate) {
    let eventTime = -1;
    let isInteractionInitialised = false;
    let count = 0;
    let id;
    let tsubmit;
    const keyLimit = 20;
    const times = new Float64Array(keyLimit);
    const resetTimesArray = ()=>{
        times.fill(0);
    };
    const resetEventTime = ()=>{
        eventTime = -1;
    };
    const start = ()=>{
        id = (0, $7Jxgt.v4)();
        (0, $bFU4G.addNewInteraction)(id, name, 'typing', performance.now(), rate, null, null);
        isInteractionInitialised = true;
    };
    const end = ()=>{
        isInteractionInitialised = false;
        if (count === 0) return;
        const timesCopy = new Float64Array(times);
        const countCopy = count;
        resetTimesArray();
        resetEventTime();
        count = 0;
        (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), ()=>{
            const computeStartTime = performance.now();
            const timesSubarray = timesCopy.subarray(0, countCopy);
            const data = $4cc946b0f8d55c5c$var$getTypingMetadata(timesSubarray, computeStartTime, 'mutationObserver');
            (0, $bFU4G.addMetadata)(id, data);
            (0, $bFU4G.tryComplete)(id);
        });
    };
    const onKeyPressHandler = (event)=>{
        if (!isInteractionInitialised) start();
        eventTime = event.timeStamp;
        setTimeout(()=>{
            clearTimeout(tsubmit);
            tsubmit = setTimeout(end, 2000); // debounce
        }, 0);
    };
    const mo = new MutationObserver((events)=>{
        const moTime = performance.now();
        if (eventTime === -1) return;
        if (count > keyLimit - 1) {
            end();
            return;
        }
        const startTime = eventTime;
        resetEventTime();
        events.forEach(()=>{
            requestAnimationFrame((firstFrameTime)=>{
                if (firstFrameTime < moTime) requestAnimationFrame((secondFrameTime)=>{
                    times[count] = secondFrameTime - startTime;
                    count++;
                });
                else {
                    times[count] = firstFrameTime - startTime;
                    count++;
                }
            });
        });
    });
    mo.observe(element, {
        attributeFilter: [
            'value'
        ],
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    element.addEventListener('keypress', onKeyPressHandler);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.removeEventListener('keypress', onKeyPressHandler);
        mo.disconnect();
    };
}
const $4cc946b0f8d55c5c$var$typingPerformanceTracingMethods = {
    timeout: $4cc946b0f8d55c5c$var$typingPerformanceTracingTimeout,
    timeoutNoAlloc: $4cc946b0f8d55c5c$var$typingPerformanceTracingTimeoutNoAlloc,
    mutationObserver: $4cc946b0f8d55c5c$var$typingPerformanceTracingMutationObserver
};
function $4cc946b0f8d55c5c$export$2e2bcd8739ae039(name) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const rate = (0, $fe1wc.getInteractionRate)(name, 'typing');
        if ((0, $5gx4p.default)(rate) && ref.current != null) {
            const method = (0, $fe1wc.getTypingPerformanceTracingMethod)();
            return $4cc946b0f8d55c5c$var$typingPerformanceTracingMethods[method](ref.current, name, rate);
        }
    }, [
        name
    ]);
    return ref;
}

});


parcelRegister("5Im19", function(module, exports) {

$parcel$export(module.exports, "UrlReadView", () => $fd1d580f4ee24148$export$7e9a6aefd9dafa88);

var $6yw1h = parcelRequire("6yw1h");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $eZibI = parcelRequire("eZibI");

var $184t6 = parcelRequire("184t6");

var $bgBAF = parcelRequire("bgBAF");

var $4R6GH = parcelRequire("4R6GH");

var $8qImc = parcelRequire("8qImc");

var $dpHMc = parcelRequire("dpHMc");

var $7mPT9 = parcelRequire("7mPT9");

var $iyzJ6 = parcelRequire("iyzJ6");
// eslint-disable-next-line no-script-url
const $fd1d580f4ee24148$var$forbiddenScheme = 'javascript:';
const $fd1d580f4ee24148$export$7e9a6aefd9dafa88 = ({ fragmentRef: fragmentRef, isSimpleInlineSmartLinkEnabled: isSimpleInlineSmartLinkEnabled, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { uri: value } = (0, $8Uumt.useFragment)((0, $6yw1h.default), fragmentRef);
    const [isUrlErrorState, setIsUrlErrorState] = (0, $5uXOq.useState)(false);
    const contentRef = (0, $5uXOq.useRef)(null);
    const handleSmartLinkError = ()=>{
        setIsUrlErrorState(true);
    };
    const handleHoverOut = ()=>{
        setIsUrlErrorState(false);
    };
    if (value == null || value === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    if (isSimpleInlineSmartLinkEnabled && (0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) {
        if (value.startsWith($fd1d580f4ee24148$var$forbiddenScheme)) return shouldRenderHoverPopover ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
            content: value,
            contentRef: contentRef,
            onHoverOut: handleHoverOut
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                maxLines: 1,
                ref: (0, $7mPT9.default)(ref, contentRef)
            }, value)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $fd1d580f4ee24148$var$truncatedStyles,
            ref: contentRef
        }, value);
        let renderContent = (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8qImc.SimpleInlineSmartLink), {
                anchorTarget: "_blank",
                url: (0, $bgBAF.default)(value, '//'),
                anchorRef: ref,
                onError: shouldRenderHoverPopover ? handleSmartLinkError : undefined
            });
        if ((0, $184t6.default)(value)) renderContent = (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8qImc.SimpleInlineSmartLink), {
                anchorTarget: "_blank",
                url: `mailto:${value}`,
                text: value,
                anchorRef: ref,
                onError: shouldRenderHoverPopover ? handleSmartLinkError : undefined
            });
        if (shouldRenderHoverPopover && isUrlErrorState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
            content: value,
            contentRef: contentRef,
            onHoverOut: handleHoverOut
        }, ({ ref: ref })=>renderContent((0, $7mPT9.default)(ref, contentRef)));
        return renderContent(undefined);
    }
    const lDisplayValue = (0, $iyzJ6.formatReadValue)(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd1d580f4ee24148$var$Ellipsis, {
        title: value
    }, lDisplayValue);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd1d580f4ee24148$var$Ellipsis = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $fd1d580f4ee24148$var$truncatedStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("6yw1h", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a856dc10891d225$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac257beb0cfe2cf1aea5cd1782c7ce81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9a856dc10891d225$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "url_issueFieldUrlReadviewFull_UrlReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "uri"
        }
    ],
    "type": "JiraUrlField"
};
$9a856dc10891d225$var$node.hash = "636e1f468ff8f541721bc22786d7eed9";
var $9a856dc10891d225$export$2e2bcd8739ae039 = $9a856dc10891d225$var$node;

});

parcelRegister("184t6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a00797b17725d914$export$2e2bcd8739ae039);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
var $a00797b17725d914$export$2e2bcd8739ae039 = (string)=>{
    if (!string || typeof string !== 'string') return false;
    return /\S+@\S+/.test(string);
};

});

parcelRegister("bgBAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ee70540922abdd3$export$2e2bcd8739ae039);

var $8xYPa = parcelRequire("8xYPa");
/**
 * Absolute URL regex
 */ const $6ee70540922abdd3$var$AbsoluteURLRegex = new RegExp(/^[a-z][a-z\d+.-]*:/);
var /**
 * Prefix url if it is url, return what we got if not
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$6ee70540922abdd3$export$2e2bcd8739ae039 = (string, prefix)=>{
    // The same line is in isUrl, but flow requires it here too
    if (typeof string !== 'string' || !prefix) return string;
    // Exit early
    if (!(0, $8xYPa.default)(string)) return string;
    // Double slash urls are absolute too, relative to the schema used in current window
    if (string.substring(0, 2) === '//') return string;
    // If it's an absolute URL, return it, no need to prefix
    if ($6ee70540922abdd3$var$AbsoluteURLRegex.test(string)) return string;
    // If it's a relative URL, prefix it with prefix
    return prefix + string;
};

});

parcelRegister("iyzJ6", function(module, exports) {

$parcel$export(module.exports, "formatReadValue", () => $570f8ac19995e860$export$7ff86f9bff10df25);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $4R6GH = parcelRequire("4R6GH");

var $184t6 = parcelRequire("184t6");

var $bgBAF = parcelRequire("bgBAF");

var $6s1PB = parcelRequire("6s1PB");

var $1RMb0 = parcelRequire("1RMb0");
// eslint-disable-next-line no-script-url
const $570f8ac19995e860$var$forbiddenScheme = 'javascript:';
const $570f8ac19995e860$export$7ff86f9bff10df25 = (value)=>{
    if (value.toString().startsWith($570f8ac19995e860$var$forbiddenScheme)) return value;
    if ((0, $184t6.default)(value)) {
        if ((0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'issue-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1RMb0.LazySingleLineSmartLink), {
            anchorTarget: "_blank",
            url: `mailto:${value}`,
            text: value,
            fieldType: "url"
        });
        return (0, $4R6GH.fg)('replace-anchor-with-link__issue-view---kenji') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
            href: `mailto:${value}`
        }, value) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: `mailto:${value}`
        }, value);
    }
    if ((0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'issue-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1RMb0.LazySingleLineSmartLink), {
        anchorTarget: "_blank",
        url: (0, $bgBAF.default)(value, '//'),
        fieldType: "url"
    });
    return (0, $4R6GH.fg)('replace-anchor-with-link__issue-view---kenji') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: (0, $bgBAF.default)(value, '//'),
        target: "_blank"
    }, value) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: (0, $bgBAF.default)(value, '//'),
        target: "_blank"
    }, value);
};

});
parcelRegister("1RMb0", function(module, exports) {

$parcel$export(module.exports, "LazySingleLineSmartLink", () => $1520f3a29774e13a$export$80092fcb07ccc4b4);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $7c22Q = parcelRequire("7c22Q");
const $1520f3a29774e13a$var$entryPointParams = {};
const $1520f3a29774e13a$export$80092fcb07ccc4b4 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7c22Q.SingleLineSmartLinkEntryPoint), $1520f3a29774e13a$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.issue-field.single-line-smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("7c22Q", function(module, exports) {

$parcel$export(module.exports, "SingleLineSmartLinkEntryPoint", () => $5f4ae65db2a1976a$export$e236c9b35543c8d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5f4ae65db2a1976a$export$e236c9b35543c8d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("lEZC9")).then((module)=>module.SingleLineSmartLink), {
        moduleId: "97818dc4"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lEZC9", function(module, exports) {

let $fc4d20b9422643e9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fc4d20b9422643e9$var$load("fliVL"),
    $fc4d20b9422643e9$var$load("eVTNs")
]).then(()=>parcelRequire('k2J4N'));

});





parcelRegister("6Luyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $825d2ade7b799ee5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $825d2ade7b799ee5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    validUrl: {
        "id": "issue-field-url-inline-edit-full.url.valid-url",
        "defaultMessage": "Please enter a valid URL."
    }
});

});

parcelRegister("2xwl9", function(module, exports) {

$parcel$export(module.exports, "validationForErrors", () => $5760da76e2df7872$export$cedaf0b5bc412527);
$parcel$export(module.exports, "isAllowed", () => $5760da76e2df7872$export$f023ae853add2e3e);

var $8xYPa = parcelRequire("8xYPa");
const $5760da76e2df7872$export$cedaf0b5bc412527 = (showValidationMessage, invalidMessage, errors)=>{
    if (showValidationMessage) return invalidMessage;
    if (errors && errors.length) return errors[0].message;
    return null;
};
const $5760da76e2df7872$export$5c13dfcb31dfce7a = 'javascript:';
const $5760da76e2df7872$export$f023ae853add2e3e = (value)=>{
    if (value === '' || value === null) return true;
    if ((0, $8xYPa.default)(value)) return true;
    if (!value.startsWith($5760da76e2df7872$export$5c13dfcb31dfce7a)) return true;
    return false;
};

});



parcelRegister("8fUkx", function(module, exports) {

$parcel$export(module.exports, "MultiVersionPickerCell", () => $e0eef82ca07369e4$export$5ca120a08ed26914);

var $iKCYn = parcelRequire("iKCYn");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aPO2R = parcelRequire("aPO2R");

var $jFYC8 = parcelRequire("jFYC8");

var $Br57E = parcelRequire("Br57E");

var $e9M6d = parcelRequire("e9M6d");
const $e0eef82ca07369e4$export$5ca120a08ed26914 = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $iKCYn.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $Br57E.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aPO2R.MultiVersionPickerInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};

});
parcelRegister("iKCYn", function(module, exports) {

$parcel$export(module.exports, "default", () => $365605a17f10bfb1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a83f7b6a3bf3a91c61f7514ba09b83a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $365605a17f10bfb1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "multiVersionPicker_nativeIssueTable_MultiVersionPickerCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$365605a17f10bfb1$var$node.hash = "bac54c5febc57f9040c4badd289dba78";
var $365605a17f10bfb1$export$2e2bcd8739ae039 = $365605a17f10bfb1$var$node;

});

parcelRegister("aPO2R", function(module, exports) {

$parcel$export(module.exports, "MultiVersionPickerInlineEditViewWithIsEditable", () => $506832793535591e$export$f431495591c5e674);

var $dDMF0 = parcelRequire("dDMF0");

var $kKz2e = parcelRequire("kKz2e");

var $7Mx3x = parcelRequire("7Mx3x");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $qluro = parcelRequire("qluro");

var $daHCC = parcelRequire("daHCC");

var $jrRyX = parcelRequire("jrRyX");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $506832793535591e$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.value));
    return b.every((option)=>aIdSet.has(option.value));
};
const $506832793535591e$export$f431495591c5e674 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $7Mx3x.default), fragmentRef);
    const [commit] = (0, $8Uumt.useMutation)((0, $kKz2e.default));
    const { id: uniqueFieldId, name: name, selectedVersionsConnection: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $5uXOq.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                id: edge?.node?.value ?? '',
                optionId: edge?.node?.versionId ?? '',
                value: edge?.node?.label ?? '',
                selectableLabel: edge?.node?.label ?? '',
                selectableGroupKey: null,
                selectableIconUrl: null
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $5uXOq.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleVersionPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleVersionPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedVersionsConnection: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.id ?? '',
                                            name: edge.selectableLabel ?? '',
                                            label: edge.selectableLabel ?? '',
                                            value: edge.id ?? '',
                                            versionId: edge.optionId ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $506832793535591e$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiVersionSelect'
    });
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daHCC.MultiVersionPickerReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover
        }), [
        data,
        isTruncated,
        isTruncatedWithHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $qluro.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $506832793535591e$export$39b0857e7fc9fc58 = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $8Uumt.useFragment)((0, $dDMF0.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($506832793535591e$export$f431495591c5e674, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("dDMF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $447cca92a8f58661$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2bc41e79d78b8f6ab7ab8377a87047ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $447cca92a8f58661$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$447cca92a8f58661$var$node.hash = "f3cd0ae179a2d6df739a19203f713cf5";
var $447cca92a8f58661$export$2e2bcd8739ae039 = $447cca92a8f58661$var$node;

});

parcelRegister("kKz2e", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9f84981f434802$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8342c4e836b7ec8b7c2b0ddfa6134252>>
 * @relayHash d19489d06d268f2aa2afd983864117f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 221728ae5b3c6aa07ca8d90d92a49ae0c66a238ebcf155f78b4ee1fc1d21e007
const $0d9f84981f434802$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiVersionPicker_issueFieldMultiVersionPicker_MultiVersionPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleVersionPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleVersionPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleVersionPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiVersionPicker_issueFieldMultiVersionPicker_MultiVersionPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleVersionPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleVersionPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleVersionPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraVersionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedVersionsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersion",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "alias": "value",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "versionId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "221728ae5b3c6aa07ca8d90d92a49ae0c66a238ebcf155f78b4ee1fc1d21e007",
            "metadata": {},
            "name": "multiVersionPicker_issueFieldMultiVersionPicker_MultiVersionPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0d9f84981f434802$var$node.hash = "c18481704920c57572e95641cfc0676b";
var $0d9f84981f434802$export$2e2bcd8739ae039 = $0d9f84981f434802$var$node;

});

parcelRegister("7Mx3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d359e08493756a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64112bc4a30b3469275bdfcb6eadd44c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4d359e08493756a9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "selectedVersionsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraVersion",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "value",
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "alias": "label",
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "versionId"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedVersionsConnection(first:1000)"
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$4d359e08493756a9$var$node.hash = "f3af5be7640f993ae73c44b61cc0fcb5";
var $4d359e08493756a9$export$2e2bcd8739ae039 = $4d359e08493756a9$var$node;

});

parcelRegister("qluro", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f58df5e8ac11033$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $8f58df5e8ac11033$var$MultiVersionPickerEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("7pvix")), {
        moduleId: "e516a23c"
    }),
    getPreloadProps: ()=>({})
});
var $8f58df5e8ac11033$export$2e2bcd8739ae039 = $8f58df5e8ac11033$var$MultiVersionPickerEditViewEntryPoint;

});
parcelRegister("7pvix", function(module, exports) {

let $5653255115c7697a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5653255115c7697a$var$load("9mzlP").then(()=>parcelRequire('6SiHj'));

});


parcelRegister("daHCC", function(module, exports) {

$parcel$export(module.exports, "MultiVersionPickerReadView", () => $1dc5141db6707a81$export$555d899a217b3354);

var $d6A45 = parcelRequire("d6A45");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $d9xxV = parcelRequire("d9xxV");

var $koVbs = parcelRequire("koVbs");

var $eZibI = parcelRequire("eZibI");

var $2bYmU = parcelRequire("2bYmU");

var $l8IoT = parcelRequire("l8IoT");

var $cxpj4 = parcelRequire("cxpj4");
const $1dc5141db6707a81$export$555d899a217b3354 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $d6A45.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectedOptions = data?.selectedVersionsConnection?.edges?.filter((edge)=>Boolean(edge?.node?.name)).map((edge)=>({
            name: edge?.node?.name || '',
            key: edge?.node?.id || ''
        })) || [];
    if (!selectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.050",
        xcss: isTruncatedWithHoverPopover && $1dc5141db6707a81$var$containerWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bYmU.default), {
        items: selectedOptions,
        ItemComponent: (0, $l8IoT.TagItem),
        PopupContentWrapper: (0, $l8IoT.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $cxpj4.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1dc5141db6707a81$var$containerWithNegativeMarginOffset
    }, selectedOptions.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
            key: item.key,
            text: item.name
        })));
};
const $1dc5141db6707a81$var$containerWithNegativeMarginOffset = (0, $8CUq3.xcss)({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    // Tag has a built-in margin of 4px, so we use a negative side margin to allow tags to align with their parent.
    marginTop: 'space.0',
    marginRight: 'space.negative.050',
    marginBottom: 'space.0',
    marginLeft: 'space.negative.050'
});
const $1dc5141db6707a81$var$containerWidthStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});
parcelRegister("d6A45", function(module, exports) {

$parcel$export(module.exports, "default", () => $b671882fc7f15363$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c210e8b6e67913f30c2d1a9eedbd636>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b671882fc7f15363$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "selectedVersionsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraVersion",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedVersionsConnection(first:1000)"
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$b671882fc7f15363$var$node.hash = "7940aec048cb5cd7c9f0feb1ad306f48";
var $b671882fc7f15363$export$2e2bcd8739ae039 = $b671882fc7f15363$var$node;

});

parcelRegister("cxpj4", function(module, exports) {

$parcel$export(module.exports, "default", () => $4742ae10d1f02b8d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4742ae10d1f02b8d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-multi-version-picker-readview-full.multi-version-picker.truncated.show-more-tooltip",
        "defaultMessage": "See more items"
    }
});

});




parcelRegister("dPslO", function(module, exports) {

$parcel$export(module.exports, "useHideDoneItems", () => $9e0546bfd3eb1f94$export$c2cb7b17819b92d4);

var $5uXOq = parcelRequire("5uXOq");

var $5FoyW = parcelRequire("5FoyW");

var $iQy3i = parcelRequire("iQy3i");

var $e9M6d = parcelRequire("e9M6d");

var $MMunf = parcelRequire("MMunf");
// For status update with hide done it will always be a single work item that is removed
const $9e0546bfd3eb1f94$var$NET_CHANGE_ISSUE_COUNT = -1;
function $9e0546bfd3eb1f94$export$c2cb7b17819b92d4({ groupConnectionId: groupConnectionId, itemsConnectionId: itemsConnectionId, recordId: recordId, projectKey: projectKey }) {
    const isHideDoneEnabled = (0, $e9M6d.useIsHideDoneItemsEnabled)();
    const { connections: connections } = (0, $5FoyW.useConnectionsList)();
    const getConnectionDetails = (0, $5uXOq.useCallback)(()=>Object.values(connections).find((connection)=>{
            return connection.connectionId === itemsConnectionId;
        }), [
        connections,
        itemsConnectionId
    ]);
    const updateConnectionDetails = (0, $MMunf.useUpdateConnectionDetails)();
    const removeConnection = (0, $5uXOq.useCallback)(({ store: store, remainingIssueCount: remainingIssueCount })=>{
        const connectionDetails = getConnectionDetails();
        if (!connectionDetails) return;
        updateConnectionDetails({
            store: store,
            connection: connectionDetails,
            remainingIssueCount: remainingIssueCount,
            netChangeInIssueCount: $9e0546bfd3eb1f94$var$NET_CHANGE_ISSUE_COUNT,
            groupConnectionId: groupConnectionId,
            projectKey: projectKey
        });
    }, [
        getConnectionDetails,
        groupConnectionId,
        projectKey,
        updateConnectionDetails
    ]);
    const handler = (0, $iQy3i.useHandleStatusUpdate)(itemsConnectionId, recordId, removeConnection, {
        isHideDoneEnabled: isHideDoneEnabled
    });
    return handler;
}

});
parcelRegister("iQy3i", function(module, exports) {

$parcel$export(module.exports, "useHandleStatusUpdate", () => $d95259faeeb0ac2c$export$9b67a4661b4d570a);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");


var $j636F = parcelRequire("j636F");

var $iDgJs = parcelRequire("iDgJs");
const $d95259faeeb0ac2c$var$DEFAULT_OPTIONS = {
    isHideDoneEnabled: false
};
function $d95259faeeb0ac2c$export$9b67a4661b4d570a(itemsConnectionId, recordId, removeConnection, options = $d95259faeeb0ac2c$var$DEFAULT_OPTIONS) {
    const updater = (0, $j636F.useDeleteRecord)(itemsConnectionId, recordId, removeConnection);
    const handler = (0, $iDgJs.useCommitLocalUpdate)(updater, options);
    return (0, $5uXOq.useCallback)((field)=>{
        try {
            handler(field);
        } catch (error) {
            if (error instanceof Error) (0, $jcw0u.default)({
                meta: {
                    id: 'issue-table-hide-done-status-update',
                    packageName: (0, $60ea362de9a3f71f$export$b8b9d90f9e5bd72b),
                    teamName: (0, $60ea362de9a3f71f$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    }, [
        handler
    ]);
}

});
const $60ea362de9a3f71f$export$b8b9d90f9e5bd72b = 'jiraIssueTableHideDoneToggle';
const $60ea362de9a3f71f$export$d57b6b390e78d90f = 'keystone';
const $60ea362de9a3f71f$export$6a7d6ab86cfdfcdc = 'hideDoneToggle';
const $60ea362de9a3f71f$export$f7109619a5e9e0d6 = 'jira-native-issue-table';

parcelRegister("j636F", function(module, exports) {

$parcel$export(module.exports, "useDeleteRecord", () => $7190a51e996944ca$export$4495a148dad9d147);

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");
function $7190a51e996944ca$export$4495a148dad9d147(itemsConnectionId, recordId, removeConnection) {
    return (0, $5uXOq.useCallback)((store)=>{
        $7190a51e996944ca$var$assert(itemsConnectionId, 'itemsConnectionId');
        $7190a51e996944ca$var$assert(recordId, 'recordId');
        const connectionRecord = store.get(itemsConnectionId);
        if (!connectionRecord) return;
        (0, $eiowN.ConnectionHandler).deleteNode(connectionRecord, recordId);
        removeConnection({
            store: store,
            remainingIssueCount: connectionRecord.getLinkedRecords('edges')?.length ?? 0
        });
    }, [
        itemsConnectionId,
        recordId,
        removeConnection
    ]);
}
function $7190a51e996944ca$var$assertString(value, paramName) {
    if (typeof value !== 'string') throw new Error(`${paramName} must be a string`);
}
function $7190a51e996944ca$var$assertNotEmpty(value, paramName) {
    if (value.trim().length === 0) throw new Error(`${paramName} must not be an empty string`);
}
function $7190a51e996944ca$var$assert(value, paramName) {
    $7190a51e996944ca$var$assertString(value, paramName);
    $7190a51e996944ca$var$assertNotEmpty(value, paramName);
}

});

parcelRegister("iDgJs", function(module, exports) {

$parcel$export(module.exports, "useCommitLocalUpdate", () => $b5e79e01389fbd47$export$f0d146dc82ca0c9c);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gULOk = parcelRequire("gULOk");
function $b5e79e01389fbd47$export$f0d146dc82ca0c9c(updater, { isHideDoneEnabled: isHideDoneEnabled }) {
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)((field)=>{
        if (!isHideDoneEnabled) return;
        if ((0, $gULOk.statusCategoryForId)(field.statusCategory?.statusCategoryId) !== (0, $gULOk.DONE)) return;
        (0, $8Uumt.commitLocalUpdate)(environment, updater);
    }, [
        environment,
        isHideDoneEnabled,
        updater
    ]);
}

});



parcelRegister("4faBS", function(module, exports) {

$parcel$export(module.exports, "MultiGroupPickerCell", () => $69bb61190e24f699$export$73d843f1843865aa);

var $a28m9 = parcelRequire("a28m9");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6Pp6n = parcelRequire("6Pp6n");

var $jFYC8 = parcelRequire("jFYC8");

var $Br57E = parcelRequire("Br57E");

var $e9M6d = parcelRequire("e9M6d");
const $69bb61190e24f699$export$73d843f1843865aa = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $8Uumt.useFragment)((0, $a28m9.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    const fieldId = typeof data.id === 'string' ? data.id : '';
    (0, $Br57E.useLazyLoadEditability)(fieldId, isEditable);
    // In edit mode, use the MultiGroupPickerEditView
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Pp6n.MultiGroupPickerInlineEditViewWithIsEditable), {
        attributes: (0, $jFYC8.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};

});
parcelRegister("a28m9", function(module, exports) {

$parcel$export(module.exports, "default", () => $94e570bad1fdad42$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<806abff1e975947b3de40cefa8a41b7b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $94e570bad1fdad42$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "multiGroupPicker_nativeIssueTable_MultiGroupPickerCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleGroupPickerField"
};
$94e570bad1fdad42$var$node.hash = "7c440756aab477bb66df5feaffeda0d0";
var $94e570bad1fdad42$export$2e2bcd8739ae039 = $94e570bad1fdad42$var$node;

});

parcelRegister("6Pp6n", function(module, exports) {

$parcel$export(module.exports, "MultiGroupPickerInlineEditViewWithIsEditable", () => $9253a1c80b5ec1b4$export$7acb84464848fc0e);

var $lu8vZ = parcelRequire("lu8vZ");

var $2TLCC = parcelRequire("2TLCC");

var $5HtjJ = parcelRequire("5HtjJ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7F8HM = parcelRequire("7F8HM");

var $lXLX3 = parcelRequire("lXLX3");

var $jrRyX = parcelRequire("jrRyX");

var $fpzev = parcelRequire("fpzev");

var $atyaN = parcelRequire("atyaN");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $9253a1c80b5ec1b4$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.id));
    return b.every((option)=>aIdSet.has(option.id));
};
const $9253a1c80b5ec1b4$export$7acb84464848fc0e = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $5HtjJ.default), fragmentRef);
    const [commit] = (0, $8Uumt.useMutation)((0, $2TLCC.default));
    // #endregion Relay
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedGroupsConnection: selectedGroupsConnection, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $5uXOq.useMemo)(()=>{
        if (!selectedGroupsConnection?.edges) return null;
        return selectedGroupsConnection.edges.map((edge)=>({
                id: edge?.node?.id ?? '',
                groupId: edge?.node?.groupId ?? '',
                name: edge?.node?.name ?? '',
                type: 'group'
            }));
    }, [
        selectedGroupsConnection?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(initialValue);
    const { overriding: overriding } = (0, $jrRyX.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable, overrideFieldOptionsFilter: overrideFieldOptionsFilter } = overriding;
    const fieldName = (0, $5uXOq.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $5uXOq.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const filterOptionsById = (0, $5uXOq.useMemo)(()=>overrideFieldOptionsFilter(null), [
        overrideFieldOptionsFilter
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $5uXOq.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleGroupPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleGroupPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedGroupsConnection: {
                                edges: values?.map((selection)=>({
                                        node: {
                                            id: selection.id,
                                            groupId: selection.groupId ?? '',
                                            name: selection.name
                                        }
                                    }))
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $7F8HM.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $9253a1c80b5ec1b4$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiGroupPicker'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $atyaN.MultiGroupPickerReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover
        }), [
        data,
        isTruncated,
        isTruncatedWithHoverPopover
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            value: updatedValue,
            menuPosition: menuPosition,
            onChange: handleChange,
            filterOptionsById: filterOptionsById,
            isMulti: true
        });
    // #endregion Edit view
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXLX3.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $fpzev.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $9253a1c80b5ec1b4$export$4caaf52d4af1250c = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $8Uumt.useFragment)((0, $lu8vZ.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9253a1c80b5ec1b4$export$7acb84464848fc0e, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("lu8vZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f42d0bd6aa68e497$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d5623bc30488e88f1d3982f57e69c5eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f42d0bd6aa68e497$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleGroupPickerField"
};
$f42d0bd6aa68e497$var$node.hash = "2b6dc2f7fb34ef75b6db441fb9ae7810";
var $f42d0bd6aa68e497$export$2e2bcd8739ae039 = $f42d0bd6aa68e497$var$node;

});

parcelRegister("2TLCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c86711bb1c7ed947$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02595abe4be4750a238e67d255544203>>
 * @relayHash cf7363cfea249c0b2da1cf11c7c42d39
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6ffaa25a287e76c421668cfe52d8e9f94b8ae3c13144e889b27b520dc510540
const $c86711bb1c7ed947$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleGroupPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleGroupPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleGroupPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleGroupPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleGroupPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleGroupPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraGroupConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedGroupsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraGroupEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraGroup",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "groupId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e6ffaa25a287e76c421668cfe52d8e9f94b8ae3c13144e889b27b520dc510540",
            "metadata": {},
            "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c86711bb1c7ed947$var$node.hash = "23b63517ce9fe10047fcdf0eced5f652";
var $c86711bb1c7ed947$export$2e2bcd8739ae039 = $c86711bb1c7ed947$var$node;

});

parcelRegister("5HtjJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9362b17c82bf223$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ab669355cea1b866d173b253a3cfa88>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a9362b17c82bf223$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView"
            },
            {
                "concreteType": "JiraGroupConnection",
                "kind": "LinkedField",
                "name": "selectedGroupsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "groupId"
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleGroupPickerField"
    };
}();
$a9362b17c82bf223$var$node.hash = "8432d03e246ec4da1c38b93c6858f003";
var $a9362b17c82bf223$export$2e2bcd8739ae039 = $a9362b17c82bf223$var$node;

});

parcelRegister("fpzev", function(module, exports) {

$parcel$export(module.exports, "default", () => $38c763be8bfbd1f6$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $38c763be8bfbd1f6$var$MultiSelectEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("ZqBOs")), {
        moduleId: "5031be7a"
    }),
    getPreloadProps: ()=>({})
});
var $38c763be8bfbd1f6$export$2e2bcd8739ae039 = $38c763be8bfbd1f6$var$MultiSelectEditViewEntryPoint;

});
parcelRegister("ZqBOs", function(module, exports) {

let $0b8a5696fb67ea2e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0b8a5696fb67ea2e$var$load("6kM20").then(()=>parcelRequire('3980j'));

});


parcelRegister("atyaN", function(module, exports) {

$parcel$export(module.exports, "MultiGroupPickerReadView", () => $efe77942eee4bbd1$export$247ad3b7069fda16);

var $6Mqtz = parcelRequire("6Mqtz");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $eZibI = parcelRequire("eZibI");

var $lpRLe = parcelRequire("lpRLe");

var $l8IoT = parcelRequire("l8IoT");

var $2bYmU = parcelRequire("2bYmU");

var $fzMg1 = parcelRequire("fzMg1");
const $efe77942eee4bbd1$export$247ad3b7069fda16 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $6Mqtz.default), fragmentRef);
    const transformedSelectedOptions = (0, $5uXOq.useMemo)(()=>{
        if (!data?.selectedGroupsConnection?.edges) return null;
        const selectedOptions = data.selectedGroupsConnection.edges.map((edge)=>edge?.node).filter((node)=>!!node);
        return selectedOptions.map((node)=>({
                key: node.id,
                name: node.name,
                color: null,
                isInteractive: false
            }));
    }, [
        data?.selectedGroupsConnection?.edges
    ]);
    if (!transformedSelectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZibI.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        role: "group",
        xcss: isTruncatedWithHoverPopover && $efe77942eee4bbd1$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bYmU.default), {
        items: transformedSelectedOptions,
        ItemComponent: isTruncatedWithHoverPopover ? (0, $l8IoT.TagItem) : (0, $lpRLe.OptionTag),
        PopupContentWrapper: (0, $l8IoT.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $fzMg1.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        role: "group",
        shouldWrap: true
    }, transformedSelectedOptions.map(({ key: key, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
            key: key,
            ...restProps
        })));
};
const $efe77942eee4bbd1$var$inlineStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});
parcelRegister("6Mqtz", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bdc38235d8089a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5e4a0b4f914cbdbb0312a353542384d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8bdc38235d8089a5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView",
    "selections": [
        {
            "concreteType": "JiraGroupConnection",
            "kind": "LinkedField",
            "name": "selectedGroupsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraGroup",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraMultipleGroupPickerField"
};
$8bdc38235d8089a5$var$node.hash = "e7a12645b4d832047ab02c9f7b91d410";
var $8bdc38235d8089a5$export$2e2bcd8739ae039 = $8bdc38235d8089a5$var$node;

});

parcelRegister("fzMg1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba16e7d741a2364a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ba16e7d741a2364a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-multi-group-picker-readview-full.multi-group-picker.compact.show-more-tooltip",
        "defaultMessage": "See more selected options"
    }
});

});




parcelRegister("7qJqb", function(module, exports) {

$parcel$export(module.exports, "WatchersCell", () => $12c599a83e3d26e4$export$1e71e15ea9d46d5d);

var $4yvaI = parcelRequire("4yvaI");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
const $12c599a83e3d26e4$var$styles = {
    watchesCell: "_1reo15vq _18m915vq _1rjc1b66 _p12f1osq _1bto1l2s"
};
const $12c599a83e3d26e4$export$1e71e15ea9d46d5d = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $4yvaI.default), fieldRef);
    const countValue = (0, $5uXOq.useMemo)(()=>{
        return data?.watch?.count;
    }, [
        data?.watch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $12c599a83e3d26e4$var$styles.watchesCell
    }, countValue);
});

});
parcelRegister("4yvaI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b94447a97f00e11a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b670cfd7835ce6be141562df87eac6e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b94447a97f00e11a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "watches_nativeIssueTable_WatchersCell",
    "selections": [
        {
            "concreteType": "JiraWatch",
            "kind": "LinkedField",
            "name": "watch",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "isWatching"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "JiraWatchesField"
};
$b94447a97f00e11a$var$node.hash = "093300cbc4b204e418f3c45d4c9b42cb";
var $b94447a97f00e11a$export$2e2bcd8739ae039 = $b94447a97f00e11a$var$node;

});


parcelRegister("doR3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $3982c8fd06519565$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $iXVV6 = parcelRequire("iXVV6");

var $czfFt = parcelRequire("czfFt");

var $hKMVG = parcelRequire("hKMVG");

var $1v6c5 = parcelRequire("1v6c5");

var $incAl = parcelRequire("incAl");
const $3982c8fd06519565$var$DefaultFallbackComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
const $3982c8fd06519565$var$IssueRowCellErrorFallback = ({ type: type, border: border })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1v6c5.TableCell), {
        border: border
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKMVG.default), {
        cellType: type,
        reason: "Unhandled error"
    }));
const $3982c8fd06519565$var$IssueRowCell = ({ type: type, beforeElement: beforeElement, cellElement: cellElement, border: border, spacing: spacing, multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment, FallbackComponent: FallbackComponent = $3982c8fd06519565$var$DefaultFallbackComponent, row: row, column: column, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            fieldType: type
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: (0, $czfFt.PACKAGE_NAME),
        teamName: (0, $czfFt.TEAM_NAME),
        id: "issueRowCellUnhandled",
        sendToPrivacyUnsafeSplunk: true,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3982c8fd06519565$var$IssueRowCellErrorFallback, {
                type: type,
                border: border
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1v6c5.TableCell), {
        spacing: spacing,
        border: border,
        ...(0, $4R6GH.fg)('jira_list_grid_pattern_keyboard_nav') && {
            row: row,
            column: column
        },
        ...(0, $4R6GH.fg)('issue_table_frozen_columns') && {
            isColumnSticky: isColumnSticky,
            stickyOffsets: stickyOffsets
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, beforeElement, Array.isArray(cellElement) && cellElement.length > 1 && (0, $4R6GH.fg)('jsc_duplicate_field_layout_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $incAl.MultipleCellElements), {
        cellElements: cellElement,
        type: type,
        multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment
    }) : cellElement ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FallbackComponent, null)))));
var $3982c8fd06519565$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($3982c8fd06519565$var$IssueRowCell);

});
parcelRegister("incAl", function(module, exports) {

$parcel$export(module.exports, "MultipleCellElements", () => $c623535cdbdc29e2$export$4b5a1f36c48df9b0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gJBT6 = parcelRequire("gJBT6");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2Yv61 = parcelRequire("2Yv61");

var $42CjB = parcelRequire("42CjB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $79UpA = parcelRequire("79UpA");

var $dpHMc = parcelRequire("dpHMc");

var $e9M6d = parcelRequire("e9M6d");

var $ft3Ir = parcelRequire("ft3Ir");
const $c623535cdbdc29e2$export$1d1457a281374128 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((fieldType, numberOfElements, createAnalyticsEvent)=>{
    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'tableCell multipleElementsRendered', {
        fieldType: fieldType,
        numberOfElements: numberOfElements
    });
});
const $c623535cdbdc29e2$var$MoreFieldsContent = ({ elements: elements })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c623535cdbdc29e2$var$moreFieldsHeaderRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
        color: "var(--ds-icon-information, #1D7AFC)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c623535cdbdc29e2$var$moreFieldsHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "medium",
        weight: "medium"
    }, formatMessage((0, $ft3Ir.default).duplicateFieldsHeader)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c623535cdbdc29e2$var$moreFieldsDescriptionStyles
    }, formatMessage((0, $ft3Ir.default).duplicateFieldsContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("hr", {
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c623535cdbdc29e2$var$fieldsContainerStyles
    }, elements.map((element)=>element)));
};
const $c623535cdbdc29e2$export$4b5a1f36c48df9b0 = ({ cellElements: cellElements, multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment = false, type: type })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    $c623535cdbdc29e2$export$1d1457a281374128(type, cellElements.length, createAnalyticsEvent);
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    if (isSingleLineRowHeightEnabled && cellElements.length > 0) {
        const firstElement = cellElements[0];
        const rest = cellElements.slice(1);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c623535cdbdc29e2$var$rowStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79UpA.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ...props,
                className: (0, $bwpsq.default)([
                    "_1reo15vq _18m915vq _1bto1l2s",
                    "_4t3i1osq",
                    "_1e38ugt7 _7glxv77o"
                ])
            }, firstElement))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79UpA.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpHMc.HoverPopover), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c623535cdbdc29e2$var$MoreFieldsContent, {
                    elements: rest
                }),
                isInteractive: true
            }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                    label: "",
                    appearance: "subtle",
                    ref: ref,
                    icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
                            ...iconProps,
                            color: "var(--ds-icon-information, #1D7AFC)"
                        }),
                    testId: "native-issue-table.ui.row.issue-row.cell.multiple-cell-elements.issue-table",
                    ...props
                })))));
    }
    return multipleFieldLayoutAdjustment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c623535cdbdc29e2$var$containerStyles
    }, cellElements.map((cellElement, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            key: index,
            xcss: $c623535cdbdc29e2$var$elementContainerStyles
        }, cellElement))) : cellElements;
};
const $c623535cdbdc29e2$var$rowStyle = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 'space.050',
    height: '100%'
});
const $c623535cdbdc29e2$var$containerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 'space.050'
});
const $c623535cdbdc29e2$var$elementContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '32px'
});
const $c623535cdbdc29e2$var$moreFieldsHeaderRowStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    marginBottom: 'space.050'
});
const $c623535cdbdc29e2$var$moreFieldsHeaderStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});
const $c623535cdbdc29e2$var$moreFieldsDescriptionStyles = (0, $8CUq3.xcss)({
    font: 'font.body.medium'
});
const $c623535cdbdc29e2$var$fieldsContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: 'space.050',
    width: '100%'
});
const $c623535cdbdc29e2$var$contentStyles = null;
const $c623535cdbdc29e2$var$fillHeight = null;
const $c623535cdbdc29e2$var$focusRingStyles = null;

});
parcelRegister("ft3Ir", function(module, exports) {

$parcel$export(module.exports, "default", () => $650296aec2b2218e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $650296aec2b2218e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    duplicateFieldsHeader: {
        "id": "native-issue-table.duplicate-fields-header",
        "defaultMessage": "Duplicate fields"
    },
    duplicateFieldsContent: {
        "id": "native-issue-table.duplicate-fields-content",
        "defaultMessage": "Configure columns to remove duplicates"
    }
});

});



parcelRegister("cIEJu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f23a559a38d9a7$export$2e2bcd8739ae039);

var $6ERB5 = parcelRequire("6ERB5");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $55mL9 = parcelRequire("55mL9");

var $e9M6d = parcelRequire("e9M6d");

var $5DTiT = parcelRequire("5DTiT");
/**
 * @deprecated should be removed when jira_list_merged_column_gate is cleaned up
 */ const $b8f23a559a38d9a7$var$FirstColumnCell = ({ isRowHoveredOrSelected: isRowHoveredOrSelected, itemsConnectionId: itemsConnectionId, depth: depth, issueRef: issueRef, triggerProps: triggerProps, isFormVisible: isFormVisible })=>{
    const issueData = (0, $8Uumt.useFragment)((0, $6ERB5.default), issueRef);
    const { hasChildren: hasChildren, canHaveChildIssues: canHaveChildIssues } = issueData;
    const { issueId: issueId } = issueData.node ?? {};
    const { groupId: groupId } = (0, $5DTiT.useRowContext)();
    const isChildIssueCreateEnabled = (0, $e9M6d.useIsChildIssueCreateEnabled)();
    const showCreateChildButton = isChildIssueCreateEnabled && isRowHoveredOrSelected && Boolean(canHaveChildIssues);
    return issueId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $55mL9.ExpandButtonWithCreateChildButton), {
        itemId: issueId,
        itemsConnectionId: itemsConnectionId,
        depth: depth,
        hasChildren: Boolean(hasChildren),
        showCreateChildButton: showCreateChildButton,
        isRowHoveredOrSelected: isRowHoveredOrSelected,
        isCreateChildFormVisible: isFormVisible,
        createChildTriggerProps: triggerProps,
        groupId: groupId
    });
};
var $b8f23a559a38d9a7$export$2e2bcd8739ae039 = $b8f23a559a38d9a7$var$FirstColumnCell;

});
parcelRegister("6ERB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe18437c96924392$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c8908458561d572f3260215943998593>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fe18437c96924392$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "firstColumnCell_nativeIssueTable",
    "selections": [
        {
            "condition": "shouldQueryHasChildren",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filterByProjectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "hasChildren"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canHaveChildIssues"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$fe18437c96924392$var$node.hash = "2a1a86d094950853f5ed2066834bdfcd";
var $fe18437c96924392$export$2e2bcd8739ae039 = $fe18437c96924392$var$node;

});


parcelRegister("lsEKV", function(module, exports) {

$parcel$export(module.exports, "MergedCell", () => $4b1206c988f3ffc9$export$91a9bd0bc931a6e5);

var $iA6Em = parcelRequire("iA6Em");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $55mL9 = parcelRequire("55mL9");

var $e9M6d = parcelRequire("e9M6d");
const $4b1206c988f3ffc9$var$CELL_PADDING = 8;
const $4b1206c988f3ffc9$var$ICON_WIDTH = 24;
const $4b1206c988f3ffc9$export$91a9bd0bc931a6e5 = ({ issueRef: issueRef, itemsConnectionId: itemsConnectionId, depth: depth, isRowHoveredOrSelected: isRowHoveredOrSelected, createChildTriggerProps: createChildTriggerProps, isCreateChildFormVisible: isCreateChildFormVisible, groupId: groupId, renderContent: renderContent, isHierarchyEnabled: isHierarchyEnabled })=>{
    const issueData = (0, $8Uumt.useFragment)((0, $iA6Em.default), issueRef);
    const hasChildren = Boolean(issueData?.hasChildren);
    const canHaveChildIssues = Boolean(issueData?.canHaveChildIssues);
    const issueId = issueData?.node?.issueId;
    const isChildIssueCreateEnabled = (0, $e9M6d.useIsChildIssueCreateEnabled)();
    const showCreateChildButton = isChildIssueCreateEnabled && isRowHoveredOrSelected && canHaveChildIssues;
    const childCreateButton = showCreateChildButton && issueId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $55mL9.CreateChildButtonWithExpandToggle), {
        depth: depth,
        itemId: issueId,
        groupId: groupId,
        itemsConnectionId: itemsConnectionId,
        createChildTriggerProps: createChildTriggerProps,
        isCreateChildFormVisible: isCreateChildFormVisible
    });
    // TODO: JSC-1774 Render contextual menu button here
    const actionButtons = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, childCreateButton);
    if (hasChildren && issueId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4b1206c988f3ffc9$var$cellStyles,
        tabIndex: 0,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            paddingLeft: `${$4b1206c988f3ffc9$var$ICON_WIDTH * depth + $4b1206c988f3ffc9$var$CELL_PADDING}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4b1206c988f3ffc9$var$expandButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $55mL9.ExpandButton), {
        itemId: issueId,
        itemsConnectionId: itemsConnectionId,
        depth: depth
    })), renderContent({
        actionButtons: actionButtons
    }));
    const cellPadding = isHierarchyEnabled ? $4b1206c988f3ffc9$var$ICON_WIDTH * depth + $4b1206c988f3ffc9$var$ICON_WIDTH + $4b1206c988f3ffc9$var$CELL_PADDING : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4b1206c988f3ffc9$var$cellStyles,
        tabIndex: 0,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            paddingLeft: `${cellPadding}px`
        }
    }, renderContent({
        actionButtons: actionButtons
    }));
};
const $4b1206c988f3ffc9$var$cellStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: ' 100%',
    position: 'relative'
});
const $4b1206c988f3ffc9$var$expandButtonStyle = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center'
});

});
parcelRegister("iA6Em", function(module, exports) {

$parcel$export(module.exports, "default", () => $248dd019eebcd48e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<09e6e7bbcc88e2827a2e1145936d8b0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $248dd019eebcd48e$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isJscM2Enabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "mergedCell_nativeIssueTable",
    "selections": [
        {
            "condition": "shouldQueryHasChildren",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filterByProjectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "hasChildren"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canHaveChildIssues"
                }
            ]
        },
        {
            "condition": "isJscM2Enabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$248dd019eebcd48e$var$node.hash = "c511176f8f0a10f587c8dd02f36f186e";
var $248dd019eebcd48e$export$2e2bcd8739ae039 = $248dd019eebcd48e$var$node;

});




parcelRegister("bGP8e", function(module, exports) {

$parcel$export(module.exports, "RowsAdditionalContentRenderer", () => $ee0e0e4174c6e272$export$62e57fc2b6b904bc);

var $92x8Q = parcelRequire("92x8Q");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1sTzn = parcelRequire("1sTzn");
const $ee0e0e4174c6e272$export$62e57fc2b6b904bc = ({ depth: depth, groupId: groupId, issues: issues })=>{
    const { RowsAdditionalContent: RowsAdditionalContent } = (0, $1sTzn.useCustomComponents)();
    const issuesData = (0, $8Uumt.useFragment)((0, $92x8Q.default), issues);
    return RowsAdditionalContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RowsAdditionalContent, {
        depth: depth,
        groupId: groupId,
        issues: issuesData
    });
};

});
parcelRegister("92x8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7753e09a7892257$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc76f7be13cfddaddb707ddb49a5a00c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b7753e09a7892257$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "rowsAdditionalContentRenderer_nativeIssueTable",
    "selections": [
        {
            "condition": "isTimelineEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "timelineRowsContent_issueTableTimeline"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$b7753e09a7892257$var$node.hash = "14936a88ab68218d38d76e038e65c173";
var $b7753e09a7892257$export$2e2bcd8739ae039 = $b7753e09a7892257$var$node;

});


parcelRegister("9JU2H", function(module, exports) {

$parcel$export(module.exports, "VirtualizedRows", () => $f0eef4f02eb93971$export$bfdb633a3745996);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("lASGB");
var $cDbvq = parcelRequire("cDbvq");

var $4R6GH = parcelRequire("4R6GH");

var $lR6JR = parcelRequire("lR6JR");
const $f0eef4f02eb93971$export$bfdb633a3745996 = ({ hasSpacers: hasSpacers, columnsCount: columnsCount, children: children })=>{
    const virtualizer = (0, $lR6JR.useVirtualization)();
    if (virtualizer == null) return children();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0eef4f02eb93971$var$VirtualizedRowsInner, {
        hasSpacers: hasSpacers,
        columnsCount: columnsCount,
        virtualizer: virtualizer
    }, children);
};
const $f0eef4f02eb93971$var$VirtualizedRowsInner = ({ hasSpacers: hasSpacers, columnsCount: columnsCount, virtualizer: virtualizer, children: children })=>{
    const virtualItemsMap = (0, $lR6JR.useVirtualItemsMap)();
    const virtualItemsMapRef = (0, $5uXOq.useRef)(virtualItemsMap);
    virtualItemsMapRef.current = virtualItemsMap;
    const isItemVirtual = (0, $5uXOq.useCallback)((key)=>Boolean(virtualItemsMapRef.current[key]), []);
    const items = virtualizer.getVirtualItems();
    // Calculates the height (top and bottom) of the non rendered portion of table
    const [before, after] = items.length > 0 ? [
        (0, $cDbvq.notUndefined)(items[0]).start - virtualizer.options.scrollMargin,
        virtualizer.getTotalSize() - (0, $cDbvq.notUndefined)(items.at(-1)).end
    ] : [
        0,
        0
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, hasSpacers && before > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", {
        ...(0, $4R6GH.fg)('nin-grid-keyboard-navigation') && {
            'aria-hidden': true
        },
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("td", {
        colSpan: columnsCount,
        // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
        style: {
            '--local-row-top-spacer-height': `${before}px`
        },
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1m6g"
        ])
    })), children(isItemVirtual, virtualizer.measureElement), hasSpacers && after > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", {
        ...(0, $4R6GH.fg)('nin-grid-keyboard-navigation') && {
            'aria-hidden': true
        },
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("td", {
        colSpan: columnsCount,
        // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
        style: {
            '--local-row-bottom-spacer-height': `${after}px`
        },
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3ibvba"
        ])
    })));
};
const $f0eef4f02eb93971$var$virtualRowStyles = null;
const $f0eef4f02eb93971$var$virtualTopSpacerStyles = null;
const $f0eef4f02eb93971$var$virtualBottomSpacerStyles = null;

});
parcelRegister("lASGB", function(module, exports) {

$parcel$export(module.exports, "observeElementRect", () => $fb876145852c2505$export$5a50ff2cde8c3802);
$parcel$export(module.exports, "observeWindowRect", () => $fb876145852c2505$export$e911b82c7a99311);
$parcel$export(module.exports, "observeElementOffset", () => $fb876145852c2505$export$fbc040aee017375a);
$parcel$export(module.exports, "observeWindowOffset", () => $fb876145852c2505$export$518998f8c5d09287);
$parcel$export(module.exports, "windowScroll", () => $fb876145852c2505$export$2162c5b3eeedd27);
$parcel$export(module.exports, "elementScroll", () => $fb876145852c2505$export$1cdb988e5ab69fe7);
$parcel$export(module.exports, "Virtualizer", () => $fb876145852c2505$export$89be5a243e59c4b2);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("cDbvq")).notUndefined);

var $cDbvq = parcelRequire("cDbvq");
const $fb876145852c2505$export$76974b428a49f15b = (index)=>index;
const $fb876145852c2505$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $fb876145852c2505$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $fb876145852c2505$var$addEventListenerOptions = {
    passive: true
};
const $fb876145852c2505$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $fb876145852c2505$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $fb876145852c2505$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $fb876145852c2505$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, $cDbvq.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $fb876145852c2505$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, $cDbvq.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $fb876145852c2505$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $fb876145852c2505$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $fb876145852c2505$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $fb876145852c2505$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $fb876145852c2505$export$76974b428a49f15b,
                rangeExtractor: $fb876145852c2505$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $fb876145852c2505$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $cDbvq.memo)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $cDbvq.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $cDbvq.memo)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $cDbvq.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset()
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $fb876145852c2505$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $cDbvq.memo)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $cDbvq.memo)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $cDbvq.notUndefined)(measurements[$fb876145852c2505$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $cDbvq.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (toOffset <= scrollOffset) align = "start";
                else if (toOffset >= scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
            if (!offsetAndAlign) return;
            const [offset, align] = offsetAndAlign;
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [latestOffset] = (0, $cDbvq.notUndefined)(this.getOffsetForIndex(index, align));
                    if (!(0, $cDbvq.approxEqual)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $fb876145852c2505$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $fb876145852c2505$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $fb876145852c2505$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("cDbvq", function(module, exports) {

$parcel$export(module.exports, "memo", () => $93220d646a94e11c$export$7c73462e0d25e514);
$parcel$export(module.exports, "notUndefined", () => $93220d646a94e11c$export$9a1adf421b69c6a);
$parcel$export(module.exports, "approxEqual", () => $93220d646a94e11c$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "debounce", () => $93220d646a94e11c$export$61fc7d43ac8f84b0);
function $93220d646a94e11c$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $93220d646a94e11c$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $93220d646a94e11c$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $93220d646a94e11c$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};

});



parcelRegister("1D5Yb", function(module, exports) {

$parcel$export(module.exports, "VirtualizedRows", () => $f7e8e8b597838e69$export$bfdb633a3745996);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("lASGB");
var $cDbvq = parcelRequire("cDbvq");

var $lR6JR = parcelRequire("lR6JR");

var $5DTiT = parcelRequire("5DTiT");
function $f7e8e8b597838e69$export$bfdb633a3745996({ children: children, renderRow: renderRow }) {
    const virtualItemsMap = (0, $lR6JR.useVirtualItemsMap)();
    const virtualizer = (0, $lR6JR.useVirtualization)();
    const { columns: columns } = (0, $5DTiT.useRowContext)();
    if (virtualizer == null) return children();
    const items = virtualizer.getVirtualItems();
    // Calculates the height (top and bottom) of the non rendered portion of table
    const [before, after] = items.length > 0 ? [
        (0, $cDbvq.notUndefined)(items[0]).start - virtualizer.options.scrollMargin,
        virtualizer.getTotalSize() - (0, $cDbvq.notUndefined)(items.at(-1)).end
    ] : [
        0,
        0
    ];
    const bottomStyle = {
        height: after
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, before > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", {
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("td", {
        colSpan: columns.length,
        style: {
            height: before
        }
    })), items.map((virtualRow)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: virtualRow.key
        }, renderRow(virtualRow.index, virtualizer.measureElement, virtualItemsMap))), after > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", {
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("td", {
        colSpan: columns.length,
        style: bottomStyle
    })));
}
const $f7e8e8b597838e69$var$virtualRowStyles = null;

});



parcelRegister("hTC96", function(module, exports) {

$parcel$export(module.exports, "Header", () => $3936bfc4a7a116ff$export$8b251419efc915eb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $12xYT = parcelRequire("12xYT");

var $biEfA = parcelRequire("biEfA");

var $9EGGH = parcelRequire("9EGGH");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("ii3zs");
var $a44uV = parcelRequire("a44uV");

var $65VLO = parcelRequire("65VLO");

var $dqoiX = parcelRequire("dqoiX");

var $cSD7y = parcelRequire("cSD7y");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $fc4cz = parcelRequire("fc4cz");

var $7XYc4 = parcelRequire("7XYc4");

var $gUWM9 = parcelRequire("gUWM9");

var $czfFt = parcelRequire("czfFt");

var $4nsZK = parcelRequire("4nsZK");

var $kYFm9 = parcelRequire("kYFm9");

var $e9M6d = parcelRequire("e9M6d");

var $9CFBJ = parcelRequire("9CFBJ");

var $euaFT = parcelRequire("euaFT");

var $bvkuz = parcelRequire("bvkuz");

var $ej9M2 = parcelRequire("ej9M2");
const $3936bfc4a7a116ff$var$BORDER_WIDTH = '1px';
const $3936bfc4a7a116ff$var$RESIZE_HANDLE_Z_INDEX = 1;
const $3936bfc4a7a116ff$var$MaybeInlineFieldCreateOnboardingProvider = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira_inline_field_config_gate'), (0, $euaFT.InlineFieldCreateOnboardingProvider), ({ children: children })=>children);
const $3936bfc4a7a116ff$var$baseHeaderContainerCellStyles = {
    backgroundColor: "var(--ds-surface-sunken, #F7F8F9)",
    borderColor: "var(--ds-border, #091E4224)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $3936bfc4a7a116ff$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $3936bfc4a7a116ff$var$BORDER_WIDTH,
    '&:first-of-type': {
        borderTopLeftRadius: "var(--ds-border-radius-200, 8px)"
    },
    '&:last-of-type': {
        borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
        borderRightWidth: 0
    }
};
const $3936bfc4a7a116ff$var$baseHeaderContainerCellKeyboardStyles = {
    backgroundColor: "var(--ds-surface-sunken, #F7F8F9)",
    borderColor: "var(--ds-border, #091E4224)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $3936bfc4a7a116ff$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $3936bfc4a7a116ff$var$BORDER_WIDTH,
    '&:first-of-type': {
        borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
        '&:focus::before': {
            left: '-1px',
            width: 'calc(100% + 3px)',
            height: 'calc(100% + 4px)',
            borderTopLeftRadius: "var(--ds-border-radius-200, 8px)"
        }
    },
    '&:last-of-type': {
        borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
        borderRightWidth: 0,
        '&:focus::before': {
            borderTopRightRadius: "var(--ds-border-radius-200, 8px)"
        }
    },
    '&:focus': {
        outline: 'unset',
        '&:before': {
            content: ' ',
            boxSizing: 'border-box',
            display: 'block',
            position: 'absolute',
            height: 'calc(100% + 4px)',
            width: 'calc(100% + 5px)',
            inset: '0px',
            left: '-3px',
            top: '-2px',
            border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
        }
    }
};
const $3936bfc4a7a116ff$var$HEADER_HEIGHT = 40;
const $3936bfc4a7a116ff$var$STICKY_CELL_Z_INDEX = $3936bfc4a7a116ff$var$RESIZE_HANDLE_Z_INDEX + 1;
const $3936bfc4a7a116ff$var$triggerColumnFlash = (table, index)=>{
    const columnCellsSelector = `th:nth-of-type(${index + 1}), td:nth-of-type(${index + 1})`;
    Array.from(table.querySelectorAll(columnCellsSelector)).filter((element)=>element instanceof HTMLElement).forEach((element)=>(0, $12xYT.triggerPostMoveFlash)(element));
};
const $3936bfc4a7a116ff$export$8b251419efc915eb = /*#__PURE__*/ (0, $5uXOq.memo)(({ columnPickerProps: columnPickerProps, columns: columns, canViewColumnConfiguration: canViewColumnConfiguration, canEditColumnConfiguration: canEditColumnConfiguration, isCompactColumnEnabled: isCompactColumnEnabled = false, resizeHandleType: resizeHandleType, onColumnsChange: onColumnsChange, onResizeColumn: onResizeColumn, tableRef: tableRef, tableBorderRadius: tableBorderRadius, showNoColumns: showNoColumns })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)(); // Unique identifier for the header of this particular issue table instance
    const [instanceId] = (0, $5uXOq.useState)(()=>Symbol('pdnd-issue-table-header'));
    const [lastReorderOperation, setLastReorderOperation] = (0, $5uXOq.useState)(null);
    const [screenReaderMessage, setScreenReaderMessage] = (0, $5uXOq.useState)('');
    const reorderColumn = (0, $5uXOq.useCallback)(({ startIndex: startIndex, indexOfTarget: indexOfTarget, closestEdgeOfTarget: closestEdgeOfTarget = null, analyticsAttributes: analyticsAttributes = {} })=>{
        const finishIndex = (0, $9EGGH.getReorderDestinationIndex)({
            axis: 'horizontal',
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            closestEdgeOfTarget: closestEdgeOfTarget
        });
        if (startIndex === finishIndex) return;
        const newColumns = (0, $a44uV.reorder)({
            list: columns,
            startIndex: startIndex,
            finishIndex: finishIndex
        });
        onColumnsChange?.(newColumns);
        setLastReorderOperation({
            finishIndex: finishIndex
        });
        setScreenReaderMessage(formatMessage((0, $ej9M2.default).movedColumn, {
            column: columns[startIndex]?.title,
            previousPosition: startIndex + 1,
            position: finishIndex + 1,
            // TODO: EM-7165 update to columns.length when excluding column picker
            total: columns.length - 1
        }));
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'reordered',
            actionSubject: 'columns'
        }), 'issueTable', analyticsAttributes);
    }, [
        columns,
        createAnalyticsEvent,
        formatMessage,
        onColumnsChange
    ]);
    const stickyColumnsWidth = (0, $4R6GH.fg)('issue_table_frozen_columns') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        let totalWidth = 0;
        columns.forEach((column)=>{
            const { id: id, isColumnSticky: isColumnSticky, defaultWidth: defaultWidth, customWidth: customWidth } = column;
            if (id === (0, $65VLO.COLUMN_ID_CHECKBOX) || id === (0, $65VLO.COLUMN_ID_EXPAND_BUTTON) || id === (0, $65VLO.COLUMN_ID_MERGED_COLUMN) || isColumnSticky) {
                if (id === (0, $65VLO.COLUMN_ID_EXPAND_BUTTON)) totalWidth += defaultWidth + (0, $czfFt.EXPAND_CELL_PADDING);
                else totalWidth += customWidth ?? defaultWidth;
            }
        });
        return totalWidth;
    }, [
        columns
    ]) : 0; // We use an object for lastReorderOperation so we can trigger the column flash
    // if the finish index is the same as the previous reorder operation.
    (0, $5uXOq.useEffect)(()=>{
        const table = tableRef?.current;
        if (table && lastReorderOperation !== null) $3936bfc4a7a116ff$var$triggerColumnFlash(table, lastReorderOperation.finishIndex);
    }, [
        lastReorderOperation,
        tableRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!canEditColumnConfiguration) return;
        return (0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                // Only monitor this particular instance id
                // (i.e. prevent monitoring entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            onDrop ({ source: source, location: location }) {
                const [destination] = location.current.dropTargets;
                if (!destination) return;
                const startIndex = columns.findIndex((column)=>column.id === source.data.id);
                if (startIndex === -1) return;
                const indexOfTarget = columns.findIndex((column)=>column.id === destination.data.id);
                if (indexOfTarget === -1) return;
                const closestEdgeOfTarget = (0, $biEfA.extractClosestEdge)(destination.data);
                reorderColumn({
                    startIndex: startIndex,
                    indexOfTarget: indexOfTarget,
                    closestEdgeOfTarget: closestEdgeOfTarget,
                    analyticsAttributes: {
                        operation: 'drop'
                    }
                });
            }
        });
    }, [
        columns,
        canEditColumnConfiguration,
        instanceId,
        reorderColumn,
        tableRef
    ]);
    const onMoveColumn = (index, position)=>{
        if (canEditColumnConfiguration && onColumnsChange !== undefined) switch(position){
            case 0, $czfFt.MOVE_COLUMN_FIRST:
                if (index > 0) reorderColumn({
                    startIndex: index,
                    indexOfTarget: 0,
                    closestEdgeOfTarget: 'left',
                    analyticsAttributes: {
                        operation: 'move-first'
                    }
                });
                break;
            case 0, $czfFt.MOVE_COLUMN_LEFT:
                if (index > 0) reorderColumn({
                    startIndex: index,
                    indexOfTarget: index - 1,
                    closestEdgeOfTarget: 'left',
                    analyticsAttributes: {
                        operation: 'move-left'
                    }
                });
                break;
            case 0, $czfFt.MOVE_COLUMN_RIGHT:
                // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                if (index < columns.length - 2) reorderColumn({
                    startIndex: index,
                    indexOfTarget: index + 1,
                    closestEdgeOfTarget: 'right',
                    analyticsAttributes: {
                        operation: 'move-right'
                    }
                });
                break;
            case 0, $czfFt.MOVE_COLUMN_LAST:
                // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                if (index < columns.length - 2) reorderColumn({
                    startIndex: index,
                    // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                    indexOfTarget: columns.length - 2,
                    closestEdgeOfTarget: 'right',
                    analyticsAttributes: {
                        operation: 'move-last'
                    }
                });
                break;
            default:
                throw new Error(`Unexpected target column position ${position}`);
        }
    };
    const onRemoveColumn = (index)=>{
        if (canEditColumnConfiguration && onColumnsChange !== undefined) {
            const newColumns = [
                ...columns
            ];
            newColumns.splice(index, 1);
            onColumnsChange(newColumns);
        }
    };
    const tableWidth = (0, $kYFm9.useElementSizeSelector)((size)=>size.width);
    const { hasShadowBottom: hasShadowBottom, hasShadowLeft: hasShadowLeft } = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>{
        const { scrollTop: scrollTop, scrollLeft: scrollLeft, width: containerWidth } = scrollState;
        return {
            hasShadowBottom: scrollTop > 0,
            // Scroll measurements are fractional, while width measurements are integer, so we need to round before comparing
            hasShadowLeft: containerWidth < tableWidth && Math.round(scrollLeft) < tableWidth - containerWidth
        };
    });
    const isFixedTableLayoutEnabled = (0, $e9M6d.useIsFixedTableLayoutEnabled)();
    const isInBetweenColumnPickerEnabled = (0, $e9M6d.useIsInBetweenColumnPickerEnabled)();
    const isInlineFieldConfigEnabled = (0, $e9M6d.useIsInlineFieldConfigEnabled)();
    let visibleDepth = 0;
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    visibleDepth = (0, $fc4cz.useVisibleDepth)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const handleDropdownStateChange = (isOpen)=>{
        setIsDropdownOpen(isOpen);
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, columns.map((column, index)=>{
        const { isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets } = column;
        const isExpandColumn = column.id === (0, $65VLO.COLUMN_ID_EXPAND_BUTTON) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes');
        const isMergedColumn = column.id === (0, $65VLO.COLUMN_ID_MERGED_COLUMN) && (0, $4R6GH.fg)('jira_list_merged_column_gate');
        const isMeatballMenu = column.id === (0, $czfFt.COLUMN_ID_MEATBALL_MENU);
        const defaultColumnWidth = column.customWidth ?? column.defaultWidth;
        const columnWidth = isExpandColumn || isMergedColumn ? (0, $4nsZK.getExpandColumnWidth)(visibleDepth) : defaultColumnWidth;
        let hasShadow = isExpandColumn ? false : canViewColumnConfiguration && hasShadowLeft;
        if ((0, $4R6GH.fg)('jira_list_merged_column_gate')) hasShadow = isMeatballMenu && canViewColumnConfiguration && hasShadowLeft;
        return(// TODO: EM-7165 – refactor column picker logic, separating it from regular columns
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: column.id
        }, // Empty cell to fill remaining space if configured columns are not wide enough to fill the table
        isFixedTableLayoutEnabled && column.id === (0, $czfFt.COLUMN_ID_MEATBALL_MENU) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3936bfc4a7a116ff$var$EmptyHeaderCell, {
            "aria-hidden": true
        }), column.customHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3936bfc4a7a116ff$export$429fd509d8532e18, {
            scope: "col",
            columnWidth: columnWidth,
            // read as the column title when a user is navigating between columns in the table content.
            "aria-label": column.title,
            isSticky: canViewColumnConfiguration,
            hasShadow: hasShadow,
            visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)(),
            isCompactColumnEnabled: isCompactColumnEnabled,
            tableBorderRadius: tableBorderRadius,
            index: index,
            ...(0, $4R6GH.fg)('nin-grid-keyboard-navigation') && {
                tabIndex: index === 0 ? 0 : -1
            },
            ...(0, $4R6GH.fg)('issue_table_frozen_columns') && {
                isColumnSticky: isColumnSticky,
                stickyOffsets: stickyOffsets
            }
        }, column.customHeader) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvkuz.HeaderCell), {
            column: column,
            hasColumnConfiguration: canEditColumnConfiguration,
            instanceId: instanceId,
            isCompactColumnEnabled: isCompactColumnEnabled,
            isFirst: index === 0,
            isLast: index === columns.length - 2,
            resizeHandleType: resizeHandleType,
            tableRef: tableRef,
            tableBorderRadius: tableBorderRadius,
            onMoveColumn: (position)=>onMoveColumn(index, position),
            ...(0, $4R6GH.fg)('jfp_a11y_team_fix_reading_order_for_expandable_btn') && {
                onDropdownStateChange: handleDropdownStateChange
            },
            onRemoveColumn: ()=>onRemoveColumn(index),
            onResizeColumn: onResizeColumn,
            index: index,
            ...(0, $4R6GH.fg)('issue_table_frozen_columns') && {
                stickyColumnsWidth: stickyColumnsWidth
            },
            ...(0, $4R6GH.fg)('nin-grid-keyboard-navigation') && {
                tabIndex: index === 0 ? 0 : -1
            }
        })));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3936bfc4a7a116ff$var$MaybeInlineFieldCreateOnboardingProvider, null, isInBetweenColumnPickerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUWM9.InsertColumnButton), {
        columns: columns,
        columnPickerProps: columnPickerProps
    }), (isInlineFieldConfigEnabled || isInBetweenColumnPickerEnabled) && !showNoColumns && (0, $4R6GH.fg)('jira_inline_field_config_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $euaFT.InlineFieldCreateOnboarding), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderCaption), {
        "aria-live": "assertive",
        "data-testid": "native-issue-table.ui.issue-table.header.screen-reader-caption"
    }, screenReaderMessage), (0, $4R6GH.fg)('jfp_a11y_team_fix_reading_order_for_expandable_btn') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("thead", {
        className: (0, $bwpsq.default)([
            (0, $4R6GH.fg)('issue_table_frozen_columns') ? "_kqsw1if8 _154iidpf _1pby11wp" : "_kqsw1if8 _154iidpf _1pbycs5v",
            isDropdownOpen && "_1pbyjwwv",
            hasShadowBottom && "_16qs1fgp"
        ])
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3936bfc4a7a116ff$var$StickyHeader, {
        hasShadow: hasShadowBottom,
        ...(0, $4R6GH.fg)('issue_table_frozen_columns') && {
            isStickyColumnsEnabled: true
        }
    }, content));
});
const $3936bfc4a7a116ff$var$baseStickyHeaderStylesOld = null; // When a column is frozen, the table cell has z-index: 2. The header must have a higher z-index(3) to avoid being visually covered by the cell during vertical scrolling.
const $3936bfc4a7a116ff$var$baseStickyHeaderStyles = null;
const $3936bfc4a7a116ff$var$increasedZIndexStyles = null;
const $3936bfc4a7a116ff$var$shadowStyles = null; // TODO: Remove isStickyColumnsEnabled prop when clean up fg issue_table_frozen_columns
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3936bfc4a7a116ff$var$StickyHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "thead", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isStickyColumnsEnabled: isStickyColumnsEnabled, hasShadow: hasShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_wa1yfy": (0, $lD23V.default)(__cmplp.isStickyColumnsEnabled ? 3 : (0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? 2 : 1)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _154iidpf _1pbyaigs",
            __cmplp.hasShadow && "_16qs1fgp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $3936bfc4a7a116ff$var$HeaderCellContainerStyledCell = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, hasShadow: hasShadow, visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $lD23V.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $lD23V.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $lD23V.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_1vpctke": (0, $lD23V.default)(__cmplp.stickyOffsets, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1h6dmuej _1dqonqa1 _1rjcze3t _18zru2gc _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcdpd34 _4x86pd34 _1nd4idpf _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr3108i",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv1l64",
            __cmplp.hasShadow && "_16qs1paq _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syaz1gjq" : "_syaz1dyx _k48p1wq8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $3936bfc4a7a116ff$var$HeaderCellContainerNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, hasShadow: hasShadow, visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $lD23V.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $lD23V.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $lD23V.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_1vpctke": (0, $lD23V.default)(__cmplp.stickyOffsets, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1h6dmuej _1dqonqa1 _1rjcze3t _18zru2gc _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcdpd34 _1av71n1a _jrfr1p7v _1vhm1pbc _cdlnpd34 _4x86pd34 _1nd4idpf _1obqpd34 _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e _nt751r31 _49pcn7od _1hvw1o36 _2qv9idpf _qzh6ugt7 _x7uvf705 _6i55usvi _1j5l1ule _1qtkstnw _1w0p1pbc _1814iopo _p0vij39m _1cl912gs _858upm4j _1ya5nqa1 _1mb8yh40",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr3108i",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv1l64",
            __cmplp.hasShadow && "_16qs1paq _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syaz1gjq" : "_syaz1dyx _k48p1wq8",
            __cmplp.className
        ])
    });
}); // Exported for testing
const $3936bfc4a7a116ff$export$429fd509d8532e18 = (0, $cSD7y.componentWithFG)('nin-grid-keyboard-navigation', $3936bfc4a7a116ff$var$HeaderCellContainerNew, $3936bfc4a7a116ff$var$HeaderCellContainerStyledCell); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $3936bfc4a7a116ff$var$EmptyHeaderCell = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1h6dmuej _1dqonqa1 _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jidpf _1rcdpd34 _4x86pd34 _1nd4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("12xYT", function(module, exports) {

$parcel$export(module.exports, "triggerPostMoveFlash", () => $fa7651cb4dd047e2$export$f5b5f29328df2633);

var $lObw7 = parcelRequire("lObw7");
function $fa7651cb4dd047e2$export$f5b5f29328df2633(element) {
    element.animate([
        {
            backgroundColor: "var(--ds-background-selected, #E9F2FF)"
        },
        {}
    ], {
        duration: (0, $lObw7.durations).large,
        /**
     * This is equivalent to the browser default, but we are making it
     * explicit to avoid relying on implicit behavior.
     *
     * This curve is not part of `@atlaskit/motion` but it was an intentional
     * design decision to use this curve.
     */ easing: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)',
        iterations: 1
    });
}

});

parcelRegister("gUWM9", function(module, exports) {

$parcel$export(module.exports, "InsertColumnButton", () => $3c8b2d62bfc0e92a$export$ce61804b1701b38c);

var $5uXOq = parcelRequire("5uXOq");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $bHZac = parcelRequire("bHZac");

var $fc4cz = parcelRequire("fc4cz");

var $6UDcM = parcelRequire("6UDcM");

var $euaFT = parcelRequire("euaFT");

var $65VLO = parcelRequire("65VLO");

var $4nsZK = parcelRequire("4nsZK");

var $50ctA = parcelRequire("50ctA");


var $czfFt = parcelRequire("czfFt");

var $e9M6d = parcelRequire("e9M6d");

var $96pci = parcelRequire("96pci");
// Height/width of the popup button
const $3c8b2d62bfc0e92a$var$DEFAULT_BUTTON_SIZE = 24;
// Height/width of the reference element the popup button is anchored to
const $3c8b2d62bfc0e92a$var$REFERENCE_SIZE = 1;
const $3c8b2d62bfc0e92a$var$constantModifiers = [
    {
        name: 'flip',
        enabled: false
    }
];
const $3c8b2d62bfc0e92a$export$96c0bbf49f7c219f = ({ columns: columns, columnPickerProps: columnPickerProps })=>{
    const [{ index: columnIndex }] = (0, $50ctA.useInlineFieldCreateActiveIndex)();
    const [{ isOpen: isOpen }, { close: close }] = (0, $bHZac.useColumnPickerOpenState)();
    const { lockIndex: lockIndex, clearIndex: clearIndex, clearIndexAfterDelay: clearIndexAfterDelay, setIndex: setIndex, setIsHovered: setIsHovered, clearIsHovered: clearIsHovered } = (0, $50ctA.useInlineCreateActiveIndexActions)();
    const { showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding } = (0, $euaFT.useInlineFieldCreateOnboardingContext)();
    const isInlineFieldConfigEnabled = (0, $e9M6d.useIsInlineFieldConfigEnabled)();
    let visibleDepth = 0;
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    visibleDepth = (0, $fc4cz.useVisibleDepth)();
    let isMergedColumnEnabled = false;
    if ((0, $4R6GH.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $e9M6d.useIsMergedColumnEnabled)();
    let isStickyColumnsEnabled = false;
    if ((0, $4R6GH.fg)('issue_table_frozen_columns')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsEnabled = (0, $e9M6d.useIsStickyColumnsEnabled)();
    const firstFieldColumnIndex = (0, $5uXOq.useMemo)(()=>{
        return columns.findIndex((column)=>!column.id.startsWith((0, $czfFt.COLUMN_ID_INTERNAL_COLUMN))) - 1;
    }, [
        columns
    ]);
    const hasShownOnboarding = (0, $5uXOq.useRef)(false);
    const shouldShowOnboarding = showInlineFieldCreateOnboarding && !hasShownOnboarding.current;
    if (shouldShowOnboarding) {
        setIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74), firstFieldColumnIndex);
        lockIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
        hasShownOnboarding.current = true;
    }
    const columnsWidth = (0, $5uXOq.useMemo)(()=>columns.map((column)=>{
            if (column.id === (0, $czfFt.COLUMN_ID_EXPAND_BUTTON)) return (0, $4nsZK.getExpandColumnWidth)(visibleDepth);
            return column.customWidth ?? column.defaultWidth;
        }), [
        columns,
        visibleDepth
    ]);
    const fixedColumnCount = (0, $5uXOq.useMemo)(()=>columns.filter((column)=>column.id === (0, $czfFt.COLUMN_ID_EXPAND_BUTTON) || column.id === (0, $czfFt.COLUMN_ID_CHECKBOX) || column.id === (0, $65VLO.COLUMN_ID_MERGED_COLUMN) || isStickyColumnsEnabled && column.isColumnSticky && (0, $4R6GH.fg)('issue_table_frozen_columns')).length, [
        columns,
        isStickyColumnsEnabled
    ]);
    const mergedColumnsCount = isMergedColumnEnabled && (0, $4R6GH.fg)('jira_list_merged_column_gate') ? (columns.find((column)=>column.id === (0, $65VLO.COLUMN_ID_MERGED_COLUMN))?.mergedColumns ?? []).length : 0;
    const isEmptyColumnExist = columnsWidth.length - columns.length === 1;
    const insertButtonXOffset = (0, $5uXOq.useMemo)(()=>{
        if (columnIndex != null && columnsWidth.length > 0) return columnsWidth.slice(0, columnIndex + 1).reduce((acc, width)=>acc + width, -$3c8b2d62bfc0e92a$var$REFERENCE_SIZE);
        return 0;
    }, [
        columnIndex,
        columnsWidth
    ]);
    const finalOffset = (0, $5uXOq.useMemo)(()=>// Negatively offset the popup by the button + reference size to center the button on the secondary axis
        [
            insertButtonXOffset,
            (0, $czfFt.INSERT_COLUMN_BUTTON_Y_OFFSET) - ($3c8b2d62bfc0e92a$var$DEFAULT_BUTTON_SIZE + $3c8b2d62bfc0e92a$var$REFERENCE_SIZE) / 2
        ], [
        insertButtonXOffset
    ]);
    const modifiers = (0, $5uXOq.useMemo)(()=>{
        // Adjust the overflow calculation for the primary axis so it is relative to the center of the button.
        const alongCenterOffset = -($3c8b2d62bfc0e92a$var$DEFAULT_BUTTON_SIZE / 2);
        // Retain the provided offset for the secondary axis
        const padding = {
            top: finalOffset[1],
            left: alongCenterOffset,
            right: alongCenterOffset
        };
        return [
            ...$3c8b2d62bfc0e92a$var$constantModifiers,
            {
                name: 'preventOverflow',
                options: {
                    mainAxis: true,
                    altAxis: true,
                    padding: padding,
                    altBoundary: true,
                    rootBoundary: 'viewport',
                    tether: false
                }
            },
            {
                name: 'eventListeners',
                options: {
                    // Only recompute position on scroll/resize events while the button is focused to reduce CPU load
                    scroll: isOpen,
                    resize: isOpen
                }
            }
        ];
    }, [
        finalOffset,
        isOpen
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        lockIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
    }, [
        lockIndex
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        !isOpen && clearIndexAfterDelay((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
    }, [
        clearIndexAfterDelay,
        isOpen
    ]);
    const handlePickerMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
    }, [
        setIsHovered
    ]);
    const handlePickerMouseLeave = (0, $5uXOq.useCallback)(()=>{
        clearIsHovered((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
    }, [
        clearIsHovered
    ]);
    const shouldNotShowInsertButton = (0, $5uXOq.useMemo)(()=>columnIndex == null || isEmptyColumnExist && columnIndex >= columnsWidth.length - 3 || // If an empty column exists, prevent inserting in the last two columns.
        columnIndex >= columnsWidth.length - 2 || // Prevent inserting on the left or right of the last column.
        columnIndex < fixedColumnCount - 1, [
        columnIndex,
        columnsWidth.length,
        fixedColumnCount,
        isEmptyColumnExist
    ]);
    if (shouldNotShowInsertButton) {
        if (!shouldShowOnboarding) {
            clearIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
            close();
        }
    }
    if (columnPickerProps) {
        const { components: components, ...props } = columnPickerProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkD4s.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1V7PR.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: [
                    $3c8b2d62bfc0e92a$var$referenceStyles,
                    $3c8b2d62bfc0e92a$var$visuallyHiddenStyles
                ],
                ref: ref
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oNEb.Popper), {
            placement: "bottom",
            offset: finalOffset,
            modifiers: modifiers
        }, ({ ref: ref, style: style })=>{
            const styleProps = {
                style: style
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                ref: ref,
                ...styleProps,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                xcss: [
                    $3c8b2d62bfc0e92a$var$buttonStyles,
                    shouldNotShowInsertButton && $3c8b2d62bfc0e92a$var$hideStyles
                ],
                testId: `native-issue-table.ui.issue-table.insert-column-button.popper${shouldNotShowInsertButton ? '-hidden' : ''}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UDcM.default), {
                ...props,
                components: {
                    ...components,
                    ...isInlineFieldConfigEnabled ? {
                        Footer: (0, $96pci.IFCFooter)
                    } : {}
                },
                columnInsertIndex: columnIndex ? columnIndex - fixedColumnCount + mergedColumnsCount + 1 : undefined,
                isInBetweenColumnPickerEnabled: true,
                showInlineFieldCreateOnboarding: columnIndex === firstFieldColumnIndex && showInlineFieldCreateOnboarding,
                onPickerMouseEnter: handlePickerMouseEnter,
                onPickerMouseLeave: handlePickerMouseLeave,
                isMergedColumnEnabled: isMergedColumnEnabled
            }));
        }));
    }
    return null;
};
const $3c8b2d62bfc0e92a$export$ce61804b1701b38c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bHZac.ColumnPickerContainer), {
        scope: (0, $czfFt.COLUMN_PICKER_ADD_COLUMN_CONTAINER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c8b2d62bfc0e92a$export$96c0bbf49f7c219f, props));
};
const $3c8b2d62bfc0e92a$var$buttonStyles = (0, $8CUq3.xcss)({
    zIndex: 'dialog'
});
const $3c8b2d62bfc0e92a$var$referenceStyles = (0, $8CUq3.xcss)({
    left: "var(--ds-space-0, 0px)",
    top: "var(--ds-space-0, 0px)"
});
const $3c8b2d62bfc0e92a$var$hideStyles = (0, $8CUq3.xcss)({
    display: 'none'
});
const $3c8b2d62bfc0e92a$var$visuallyHiddenStyles = (0, $8CUq3.xcss)({
    width: '1px',
    height: '1px',
    padding: 'space.0',
    position: 'absolute',
    border: 'none',
    clipPath: 'rect(1px 1px 1px 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});

});
parcelRegister("euaFT", function(module, exports) {

$parcel$export(module.exports, "InlineFieldCreateOnboardingProvider", () => $121ee1a72273c3a5$export$de078953583b045f);
$parcel$export(module.exports, "useInlineFieldCreateOnboardingContext", () => $121ee1a72273c3a5$export$9649d04db063d324);
$parcel$export(module.exports, "InlineFieldCreateOnboarding", () => $121ee1a72273c3a5$export$f07afb14f98859fd);

var $5uXOq = parcelRequire("5uXOq");

var $kbqIt = parcelRequire("kbqIt");

var $cgL5K = parcelRequire("cgL5K");

var $1QiBP = parcelRequire("1QiBP");

var $hxoiH = parcelRequire("hxoiH");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $ehdJY = parcelRequire("ehdJY");

var $eGLgs = parcelRequire("eGLgs");

var $ioD1B = parcelRequire("ioD1B");

var $itmJb = parcelRequire("itmJb");

var $dAfqg = parcelRequire("dAfqg");

var $4anLj = parcelRequire("4anLj");

var $50ctA = parcelRequire("50ctA");


var $k8K6G = parcelRequire("k8K6G");

var $ayToj = parcelRequire("ayToj");

var $hCst8 = parcelRequire("hCst8");

var $kps1S = parcelRequire("kps1S");

var $cPHwi = parcelRequire("cPHwi");
const $121ee1a72273c3a5$export$7749a74b05b28c3e = 'issue-navigator-inline-field-create';
const $121ee1a72273c3a5$var$STARGATE_URL = '/gateway/api';
const $121ee1a72273c3a5$var$InlineFieldCreateOnboardingContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $121ee1a72273c3a5$export$de078953583b045f = ({ children: children })=>{
    const [showInlineFieldCreateOnboarding, setShowInlineFieldCreateOnboarding] = (0, $5uXOq.useState)(false);
    const value = (0, $5uXOq.useMemo)(()=>({
            showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding,
            setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding
        }), [
        showInlineFieldCreateOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($121ee1a72273c3a5$var$InlineFieldCreateOnboardingContext.Provider, {
        value: value
    }, children);
};
const $121ee1a72273c3a5$export$9649d04db063d324 = ()=>{
    const inlineFieldCreateOnboardingContext = (0, $5uXOq.useContext)($121ee1a72273c3a5$var$InlineFieldCreateOnboardingContext);
    if (!inlineFieldCreateOnboardingContext) throw new Error('useInlineFieldCreateOnboardingContext must be used within a InlineFieldCreateOnboardingProvider');
    return inlineFieldCreateOnboardingContext;
};
const $121ee1a72273c3a5$var$ConfigureFieldsOnboardingComponent = ({ setActiveSpotlight: setActiveSpotlight, isTMPAdmin: isTMPAdmin })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { clearIndex: clearIndex } = (0, $50ctA.useInlineCreateActiveIndexActions)();
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const { setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding } = $121ee1a72273c3a5$export$9649d04db063d324();
    const actions = isTMPAdmin ? [
        {
            text: formatMessage((0, $cPHwi.default).nextButtonText),
            onClick: ()=>{
                setActiveSpotlight(1);
                clearIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
            }
        },
        {
            text: formatMessage((0, $cPHwi.default).createFieldDismiss),
            onClick: ()=>{
                setActiveSpotlight(null);
                setShowInlineFieldCreateOnboarding(false);
                clearIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
            }
        }
    ] : [
        {
            text: formatMessage((0, $cPHwi.default).createFieldDismiss),
            onClick: ()=>{
                setActiveSpotlight(null);
                setShowInlineFieldCreateOnboarding(false);
                clearIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        pulse: true,
        messageId: "native-issue-table.ui.inline-field-create-onboarding.jira-spotlight.inline-field-create-onboarding-column-picker-button.in-between",
        messageType: "engagement",
        actions: actions,
        dialogWidth: 320,
        target: "inline-field-create-onboarding-column-picker-button.in-between",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        image: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($kps1S))) : (0, (/*@__PURE__*/$parcel$interopDefault($hCst8))),
        actionsBeforeElement: isTMPAdmin ? '1/2' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $cPHwi.default).inlineColumnCreateBody, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                weight: "bold"
            }, chunks)
    })));
};
const $121ee1a72273c3a5$var$InlineFieldCreateOnboardingComponent = ({ setActiveSpotlight: setActiveSpotlight })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { clearIndex: clearIndex } = (0, $50ctA.useInlineCreateActiveIndexActions)();
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const { setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding } = $121ee1a72273c3a5$export$9649d04db063d324();
    if (!colorMode) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        pulse: true,
        messageId: "native-issue-table.ui.inline-field-create-onboarding.jira-spotlight.inline-field-create-onboarding-column-picker-button.default",
        messageType: "engagement",
        actions: [
            {
                text: formatMessage((0, $cPHwi.default).createFieldDismiss),
                onClick: ()=>{
                    setActiveSpotlight(null);
                    setShowInlineFieldCreateOnboarding(false);
                    clearIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
                }
            }
        ],
        dialogPlacement: "bottom right",
        dialogWidth: 320,
        target: "inline-field-create-onboarding-column-picker-button.default",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        image: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($ayToj))) : (0, (/*@__PURE__*/$parcel$interopDefault($k8K6G))),
        actionsBeforeElement: "2/2"
    }, formatMessage((0, $cPHwi.default).createFieldBody));
};
const $121ee1a72273c3a5$export$f07afb14f98859fd = ()=>{
    const { setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding } = $121ee1a72273c3a5$export$9649d04db063d324();
    const cloudId = (0, $koeKL.useCloudId)();
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(null);
    const isSiteAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = (0, $4anLj.useIsProjectAdmin)();
    const isTMP = (0, $dAfqg.useIsSimplifiedProject)();
    const isAdmin = isSiteAdmin || isProjectAdmin;
    const isTMPAdmin = isAdmin && isTMP;
    const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, $121ee1a72273c3a5$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $kbqIt.useCoordination)(coordinationClient, $121ee1a72273c3a5$export$7749a74b05b28c3e);
    const hasShownOnboarding = (0, $5uXOq.useRef)(false);
    if (isEnrolled && !hasShownOnboarding.current) {
        setShowInlineFieldCreateOnboarding(true);
        stopEnrolment(false);
        setActiveSpotlight(0);
        hasShownOnboarding.current = true;
    }
    const renderActiveSpotlight = ()=>{
        const spotlights = isTMPAdmin ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($121ee1a72273c3a5$var$ConfigureFieldsOnboardingComponent, {
                key: "configure-fields",
                setActiveSpotlight: setActiveSpotlight,
                isTMPAdmin: true
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($121ee1a72273c3a5$var$InlineFieldCreateOnboardingComponent, {
                key: "inline-field-create",
                setActiveSpotlight: setActiveSpotlight
            })
        ] : [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($121ee1a72273c3a5$var$ConfigureFieldsOnboardingComponent, {
                key: "configure-fields",
                setActiveSpotlight: setActiveSpotlight
            })
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isEnrolled && activeSpotlight !== null && renderActiveSpotlight()));
};

});
parcelRegister("k8K6G", function(module, exports) {
module.exports = new URL("configure-fields-light.fd3f907d.png", import.meta.url).toString();

});

parcelRegister("ayToj", function(module, exports) {
module.exports = new URL("configure-fields-dark.cda4df1f.png", import.meta.url).toString();

});

parcelRegister("hCst8", function(module, exports) {
module.exports = new URL("inline-column-create-light.25926891.png", import.meta.url).toString();

});

parcelRegister("kps1S", function(module, exports) {
module.exports = new URL("inline-column-create-dark.7d2ee1ec.png", import.meta.url).toString();

});

parcelRegister("cPHwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b75754dcbcff1cf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8b75754dcbcff1cf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createFieldBody: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.create-field-body",
        "defaultMessage": "Create and configure fields without leaving your view."
    },
    createFieldDismiss: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.create-field-dismiss",
        "defaultMessage": "Dismiss"
    },
    inlineColumnCreateBody: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.inline-column-create-body",
        "defaultMessage": "Select <b>+</b> to quickly add columns exactly where you want them."
    },
    nextButtonText: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.next-button-text",
        "defaultMessage": "Next"
    }
});

});


parcelRegister("4nsZK", function(module, exports) {

$parcel$export(module.exports, "getExpandColumnWidth", () => $8a25ec151ccd3d37$export$6344c84966147aa0);

var $czfFt = parcelRequire("czfFt");
const $8a25ec151ccd3d37$export$6344c84966147aa0 = (depth)=>depth * (0, $czfFt.DEPTH_WIDTH) + (0, $czfFt.EXPAND_BUTTON_WIDTH) + (0, $czfFt.CREATE_CHILD_BUTTON_WIDTH) + (0, $czfFt.EXPAND_CELL_PADDING);

});


parcelRegister("bvkuz", function(module, exports) {

$parcel$export(module.exports, "HeaderCell", () => $b892b9cfbb034dc0$export$efcbfab786023e1a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7nsd3 = parcelRequire("7nsd3");

var $34ck9 = parcelRequire("34ck9");

var $8Rkzz = parcelRequire("8Rkzz");

var $biEfA = parcelRequire("biEfA");

var $5uJ9N = parcelRequire("5uJ9N");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");

var $hjhoK = parcelRequire("hjhoK");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");

var $fmZmH = parcelRequire("fmZmH");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $65VLO = parcelRequire("65VLO");

var $4R6GH = parcelRequire("4R6GH");

var $7mPT9 = parcelRequire("7mPT9");

var $1XJ20 = parcelRequire("1XJ20");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $cSD7y = parcelRequire("cSD7y");


var $50ctA = parcelRequire("50ctA");

var $czfFt = parcelRequire("czfFt");

var $lP0j5 = parcelRequire("lP0j5");

var $efIPS = parcelRequire("efIPS");

var $e9M6d = parcelRequire("e9M6d");

var $9CFBJ = parcelRequire("9CFBJ");

var $16Qme = parcelRequire("16Qme");

var $kOoiQ = parcelRequire("kOoiQ");

var $8Jbp0 = parcelRequire("8Jbp0");
const $b892b9cfbb034dc0$var$DRAG_PREVIEW_MAX_WIDTH = 260;
const $b892b9cfbb034dc0$var$BORDER_WIDTH = '1px';
const $b892b9cfbb034dc0$var$HEADER_HEIGHT = 40; // ensure that the resize handle displays above subsequent header cells, but that a sticky cell will display above the
// resize handle. Improper z-index may cause the resize handle to render _above_ the column picker.
const $b892b9cfbb034dc0$var$RESIZE_HANDLE_Z_INDEX = 1;
const $b892b9cfbb034dc0$var$STICKY_CELL_Z_INDEX = $b892b9cfbb034dc0$var$RESIZE_HANDLE_Z_INDEX + 1;
const $b892b9cfbb034dc0$var$BOUNDARY = 70;
const $b892b9cfbb034dc0$var$MOUSE_MOVE_THROTTLE = 16;
const $b892b9cfbb034dc0$export$efcbfab786023e1a = ({ column: column, hasColumnConfiguration: hasColumnConfiguration, instanceId: instanceId, isCompactColumnEnabled: isCompactColumnEnabled = false, isFirst: isFirst, isLast: isLast, resizeHandleType: resizeHandleType = (0, $czfFt.COLUMN_RESIZE_HANDLE_FULL_HEIGHT), tableRef: tableRef, onMoveColumn: onMoveColumnProp, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumnProp, index: index, tableBorderRadius: tableBorderRadius, onDropdownStateChange: onDropdownStateChange, stickyColumnsWidth: stickyColumnsWidth = 0 })=>{
    const headerCellContainerRef = (0, $5uXOq.useRef)(null);
    const headerCellActionsTriggerRef = (0, $5uXOq.useRef)(null);
    const resizeHandleRef = (0, $5uXOq.useRef)(null);
    const isColumnResizingEnabled = (0, $e9M6d.useIsColumnResizingEnabled)();
    const isInBetweenColumnPickerEnabled = (0, $e9M6d.useIsInBetweenColumnPickerEnabled)();
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const handleDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        setIsDropdownOpen(isOpen);
        if (onDropdownStateChange && (0, $4R6GH.fg)('jfp_a11y_team_fix_reading_order_for_expandable_btn')) onDropdownStateChange(isOpen);
    }, [
        onDropdownStateChange
    ]);
    const [state, setState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    const [dropEdge, setDropEdge] = (0, $5uXOq.useState)(null);
    let clearIndex = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    let setIndex = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    let clearIndexAfterDelay = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    let columnIndex;
    let isInlineFieldCreateHovered;
    if (isInBetweenColumnPickerEnabled) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ clearIndex: clearIndex, setIndex: setIndex, clearIndexAfterDelay: clearIndexAfterDelay } = (0, $50ctA.useInlineCreateActiveIndexActions)());
        [{ index: columnIndex, isHovered: isInlineFieldCreateHovered }] = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $50ctA.useInlineFieldCreateActiveIndex)();
    }
    let isStickyColumnsEnabled = false;
    if ((0, $4R6GH.fg)('issue_table_frozen_columns')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsEnabled = (0, $e9M6d.useIsStickyColumnsEnabled)();
    const height = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>scrollState.height);
    let scrollElement;
    if ((0, $4R6GH.fg)('issue_table_frozen_columns')) // eslint-disable-next-line react-hooks/rules-of-hooks
    scrollElement = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>scrollState.scrollElement);
    const scrollElementToLeft = (0, $4R6GH.fg)('issue_table_frozen_columns') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        return scrollElement?.getBoundingClientRect().left ?? 0;
    }, [
        scrollElement
    ]) : 0;
    const stickyBoundary = scrollElementToLeft + stickyColumnsWidth;
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            fieldType: column.type
        }), [
        column.type
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const throttledHandler = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))((event)=>{
            if (!event.currentTarget) return;
            const rect = event.currentTarget.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const width = rect.right - rect.left;
            if (x < width / 2 && x <= $b892b9cfbb034dc0$var$BOUNDARY && rect.left >= stickyBoundary) setIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74), index - 1);
            else if (x >= width / 2 && x >= width - $b892b9cfbb034dc0$var$BOUNDARY) setIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74), index);
            else clearIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
        }, $b892b9cfbb034dc0$var$MOUSE_MOVE_THROTTLE), [
        stickyBoundary,
        setIndex,
        index,
        clearIndex
    ]);
    const calculateColumnIndex = (0, $5uXOq.useCallback)(throttledHandler, [
        throttledHandler
    ]);
    const onMouseEnter = (0, $5uXOq.useCallback)((event)=>{
        if (event.target === resizeHandleRef.current) // prevent showing "hovered" state when only the resize handle is hovered
        return;
        setIsHovered(true);
    }, []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
        if (isInBetweenColumnPickerEnabled) clearIndexAfterDelay((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
    }, [
        clearIndexAfterDelay,
        isInBetweenColumnPickerEnabled
    ]);
    const handleMouseMove = (0, $5uXOq.useCallback)((event)=>{
        event.persist(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (headerCellContainerRef.current?.contains(event.target)) calculateColumnIndex(event);
        else clearIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
    }, [
        calculateColumnIndex,
        clearIndex
    ]);
    const handleMouseClick = (0, $5uXOq.useCallback)((event)=>{
        if (event.target instanceof HTMLElement && headerCellContainerRef.current?.contains(event.target.closest('button'))) clearIndex((0, $7c774df2bdb90654$export$d6f887e0c1be1b74));
    }, [
        clearIndex
    ]);
    const { cellRef: cellRef, isSelected: isSelected } = (0, $4R6GH.fg)('jira_list_grid_pattern_keyboard_nav') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $lP0j5.useCellWrapper)({
        row: 0,
        col: index
    }) : {
        cellRef: null,
        isSelected: false
    };
    const cellRefs = (0, $4R6GH.fg)('jira_list_grid_pattern_keyboard_nav') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7mPT9.default)(headerCellContainerRef, cellRef) : headerCellContainerRef; // #region Column reordering
    const onMoveColumn = (0, $5uXOq.useCallback)((position)=>{
        onMoveColumnProp(position);
        setIsHovered(false);
    }, [
        onMoveColumnProp
    ]);
    let isMergedColumnEnabled = false;
    if ((0, $4R6GH.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $e9M6d.useIsMergedColumnEnabled)();
    const isMergedColumn = isMergedColumnEnabled && column.id === (0, $65VLO.COLUMN_ID_MERGED_COLUMN) && (0, $4R6GH.fg)('jira_list_merged_column_gate');
    (0, $5uXOq.useEffect)(()=>{
        const headerCellContainer = headerCellContainerRef.current;
        if (!hasColumnConfiguration || !headerCellContainer || isMergedColumn) return;
        return (0, $4hDdm.combine)((0, $7gWdR.draggable)({
            element: headerCellContainer,
            getInitialData () {
                if (isStickyColumnsEnabled) return {
                    operation: (0, $czfFt.COLUMN_OPERATION_REORDER),
                    id: column.id,
                    instanceId: instanceId,
                    isColumnSticky: column.isColumnSticky
                };
                return {
                    operation: (0, $czfFt.COLUMN_OPERATION_REORDER),
                    id: column.id,
                    instanceId: instanceId
                };
            },
            onDragStart () {
                setState({
                    type: 'reordering'
                });
            },
            onDrop () {
                setState({
                    type: 'idle'
                });
            },
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                const headerCellWidth = headerCellContainer.getBoundingClientRect().width;
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    getOffset () {
                        return {
                            x: 20,
                            y: 20
                        };
                    },
                    render ({ container: container }) {
                        // Cause a React re-render to create portal synchronously
                        setState({
                            type: 'preview',
                            container: container,
                            previewWidth: Math.min(headerCellWidth, $b892b9cfbb034dc0$var$DRAG_PREVIEW_MAX_WIDTH)
                        }); // Cause a React re-render to remove portal on cleanup
                        return ()=>setState({
                                type: 'reordering'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        }), (0, $7gWdR.dropTargetForElements)({
            element: headerCellContainer,
            canDrop ({ source: source }) {
                if (isStickyColumnsEnabled) // Only allow drops from the same instance id
                // (i.e. prevent dropping entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId && // Only allow columns to be dropped within their original section:
                // frozen columns into the frozen section, and unfrozen columns into the unfrozen section
                column.isColumnSticky === source.data.isColumnSticky;
                 // Only allow drops from the same instance id
                // (i.e. prevent dropping entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            getData ({ input: input, element: element }) {
                const data = {
                    id: column.id,
                    instanceId: instanceId
                };
                return (0, $biEfA.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                });
            },
            onDrag ({ self: self }) {
                const closestEdge = (0, $biEfA.extractClosestEdge)(self.data);
                if (!closestEdge) return;
                setDropEdge(closestEdge);
            },
            onDragLeave () {
                setDropEdge(null);
            },
            onDrop () {
                setDropEdge(null);
            }
        }), (0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                // Only monitor this particular instance id
                // (i.e. prevent monitoring entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            onDrag () {
                // Close the dropdown menu when a drag starts on any column
                setIsDropdownOpen(false);
            }
        }));
    }, [
        column.id,
        column.isColumnSticky,
        hasColumnConfiguration,
        instanceId,
        isMergedColumn,
        isStickyColumnsEnabled
    ]);
    // #endregion
    // #region Column resizing
    const [componentColumnWidth, setComponentColumnWidth] = (0, $5uXOq.useState)(column.customWidth ?? column.defaultWidth);
    const prevColumnConfigCustomWidth = (0, $1XJ20.usePreviousWithInitial)(column.customWidth);
    const [isResizePopupOpen, setIsResizePopupOpen] = (0, $5uXOq.useState)(false);
    const onResizeColumn = (0, $5uXOq.useCallback)((width, resizeMethod)=>{
        if (width === componentColumnWidth) // Skip state updates if column width has not changed
        return;
        setComponentColumnWidth(width);
        const resizeColumnId = column.resizeColumnId ?? column.id;
        onResizeColumnProp && onResizeColumnProp(resizeColumnId, width === column.defaultWidth ? undefined : width);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'column'
        }), 'issueTable', {
            ...analyticsAttributes,
            resizeMethod: resizeMethod,
            columnWidth: width
        });
    }, [
        componentColumnWidth,
        onResizeColumnProp,
        column.id,
        column.defaultWidth,
        column.resizeColumnId,
        createAnalyticsEvent,
        analyticsAttributes
    ]); // Header actions callbacks
    const onResizeColumnAction = (0, $5uXOq.useCallback)(()=>{
        setIsResizePopupOpen(true);
    }, []);
    const onResetColumnWidthAction = (0, $5uXOq.useCallback)(()=>{
        onResizeColumn(column.defaultWidth, 'reset');
    }, [
        onResizeColumn,
        column.defaultWidth
    ]); // Resize popup callbacks
    const onChangeResizePopup = (0, $5uXOq.useCallback)((width)=>{
        (0, $8Jbp0.setCssResizingWidth)(headerCellContainerRef.current, width);
    }, []);
    const onCloseResizePopup = (0, $5uXOq.useCallback)((event, overrideKeyboardCheck)=>{
        setIsResizePopupOpen(false);
        (0, $8Jbp0.clearCssResizingWidth)(headerCellContainerRef.current); // Focus header cell actions trigger if the resize popup was closed by keyboard
        // navigation or an override was requested
        //
        // `event.detail` docs: https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
        // (click count is 0 when using keyboard to activate a button)
        if (overrideKeyboardCheck === true || event && event.detail === 0) requestAnimationFrame(()=>headerCellActionsTriggerRef.current?.focus());
    }, []);
    const onSubmitResizePopup = (0, $5uXOq.useCallback)((width)=>{
        onResizeColumn(width, 'popup'); // No event available from form submission. We will re-focus the actions
        // trigger because submit can't be triggerd by clicking outside of popup,
        // so don't have to worry about stealing focus from what the user clicked
        onCloseResizePopup(undefined, true);
    }, [
        onResizeColumn,
        onCloseResizePopup
    ]); // Resize handle callbacks
    const onMouseEnterResizeHandle = (0, $5uXOq.useCallback)((event)=>{
        // prevent showing the drag & drop/reorder hover effect when resizing
        setIsHovered(false);
        event.stopPropagation();
    }, []);
    const onMouseLeaveResizeHandle = (0, $5uXOq.useCallback)((event)=>{
        // restore header hover state if mouse exits into the header element
        if (state.type !== 'resizing' && (event.relatedTarget === headerCellContainerRef.current || event.relatedTarget instanceof Node && headerCellContainerRef.current?.contains(event.relatedTarget))) setIsHovered(true);
    }, [
        state.type
    ]); // Update column width state if a change is made in the column config
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('restore-default-width-in-issue-table')) {
            const nextColumnWidth = column.customWidth ?? column.defaultWidth;
            if (prevColumnConfigCustomWidth !== nextColumnWidth && componentColumnWidth !== nextColumnWidth && nextColumnWidth != null) setComponentColumnWidth(nextColumnWidth);
        } else if (prevColumnConfigCustomWidth !== column.customWidth && componentColumnWidth !== column.customWidth && column.customWidth != null) setComponentColumnWidth(column.customWidth);
    }, [
        column.customWidth,
        column.defaultWidth,
        componentColumnWidth,
        prevColumnConfigCustomWidth
    ]); // Creates draggable resize handle
    (0, $5uXOq.useEffect)(()=>{
        const resizeHandle = resizeHandleRef.current;
        if (!resizeHandle || isResizePopupOpen) return;
        return (0, $7gWdR.draggable)({
            element: resizeHandle,
            getInitialData () {
                return {
                    operation: (0, $czfFt.COLUMN_OPERATION_RESIZE),
                    id: column.id
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // we will be moving the line to indicate a drag
                // we can disable the native drag preview
                (0, $hjhoK.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                }); // we don't want any native drop animation for when the user
                // does not drop on a drop target. we want the drag to finish immediately
                (0, $fmZmH.preventUnhandled).start();
            },
            onDragStart () {
                setState({
                    type: 'resizing'
                }); // Disable pointer events on the table while dragging in order to prevent buggy hover states in chrome
                // https://issues.chromium.org/issues/41129937#comment43
                (0, $8Jbp0.disableCssPointerEvents)(tableRef?.current);
            },
            onDrag ({ location: location }) {
                const proposedWidth = (0, $8Jbp0.getProposedWidth)({
                    initialWidth: componentColumnWidth,
                    location: location,
                    isCompactColumnEnabled: isCompactColumnEnabled,
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                });
                (0, $8Jbp0.setCssResizingWidth)(headerCellContainerRef.current, proposedWidth);
            },
            onDrop ({ location: location }) {
                (0, $fmZmH.preventUnhandled).stop();
                setState({
                    type: 'idle'
                });
                onResizeColumn((0, $8Jbp0.getProposedWidth)({
                    initialWidth: componentColumnWidth,
                    location: location,
                    isCompactColumnEnabled: isCompactColumnEnabled,
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                }), 'drag-and-drop'); // Re-enable pointer events to restore normal behaviour
                // https://issues.chromium.org/issues/41129937#comment43
                (0, $8Jbp0.enableCssPointerEvents)(tableRef?.current);
                (0, $8Jbp0.clearCssResizingWidth)(headerCellContainerRef.current);
            }
        });
    }, [
        isResizePopupOpen,
        column.id,
        componentColumnWidth,
        tableRef,
        onResizeColumn,
        isCompactColumnEnabled,
        column.type,
        isSingleLineRowHeightEnabled
    ]); // #endregion
    // #region Render
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b892b9cfbb034dc0$export$429fd509d8532e18, {
        ref: cellRefs,
        scope: "col",
        columnWidth: componentColumnWidth,
        minColumnWidth: !isColumnResizingEnabled ? column.customWidth : undefined,
        isDraggable: isMergedColumn ? false : hasColumnConfiguration,
        isHovered: isHovered || isSelected,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        isFirst: isFirst,
        isLast: isLast,
        index: index,
        ...isInBetweenColumnPickerEnabled && !(column.isColumnSticky && (0, $4R6GH.fg)('issue_table_frozen_columns')) && {
            onMouseMove: handleMouseMove
        },
        ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
            onClick: handleMouseClick
        },
        // read as the column title when a user is navigating between columns in the table content.
        "aria-label": column.title,
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)(),
        isCompactColumnEnabled: isCompactColumnEnabled,
        tableBorderRadius: tableBorderRadius,
        ...(0, $4R6GH.fg)('nin-grid-keyboard-navigation') && {
            tabIndex: index === 0 ? 0 : -1
        },
        ...(0, $4R6GH.fg)('issue_table_frozen_columns') && {
            isColumnSticky: column.isColumnSticky,
            stickyOffsets: column.stickyOffsets
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: state.type === 'reordering' && $b892b9cfbb034dc0$var$reorderingStyles,
        testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-container-inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $b892b9cfbb034dc0$var$overflowHiddenStyles
    }, column.warningText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efIPS.default), {
        tooltip: column.warningText
    }), (0, $4R6GH.fg)('jira_list_merged_column_gate') && column.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b892b9cfbb034dc0$var$Title, null, column.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16Qme.HeaderCellActions), {
        column: column,
        currentColumnWidth: componentColumnWidth,
        hasColumnConfiguration: hasColumnConfiguration,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isCompactColumnEnabled: isCompactColumnEnabled,
        isHeaderCellHovered: isHovered || isSelected,
        isFirst: isFirst,
        isLast: isLast,
        isOpen: isDropdownOpen,
        triggerRef: headerCellActionsTriggerRef,
        onMoveColumn: onMoveColumn,
        onOpenChange: handleDropdownOpenChange,
        onRemoveColumn: onRemoveColumn,
        onResizeColumn: onResizeColumnAction,
        onResetColumnWidth: onResetColumnWidthAction
    })), isColumnResizingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kOoiQ.ResizePopup), {
        columnTitle: column.title,
        initialWidth: componentColumnWidth,
        placement: "bottom-start",
        isOpen: isResizePopupOpen,
        isCompactColumnEnabled: isCompactColumnEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        trigger: $b892b9cfbb034dc0$var$resizePopupTarget,
        onChange: onChangeResizePopup,
        onCancel: onCloseResizePopup,
        onSubmit: onSubmitResizePopup
    }), !isResizePopupOpen && (0, $4R6GH.fg)('use_native_css_to_set_column_resize_handle_height') && (()=>{
        const commonProps = {
            ref: resizeHandleRef,
            isActive: state.type === 'resizing' || columnIndex === index && isInlineFieldCreateHovered && (0, $4R6GH.fg)('jira_inline_field_config_gate'),
            onMouseEnter: onMouseEnterResizeHandle,
            onMouseLeave: onMouseLeaveResizeHandle,
            onDoubleClick: onResetColumnWidthAction,
            'data-testid': 'native-issue-table.ui.issue-table.header.header-cell.resize-handle',
            'data-vc': 'native-issue-table-ui-resize-handle',
            ...isInBetweenColumnPickerEnabled && {
                onMouseMove: (e)=>e.stopPropagation()
            }
        };
        return resizeHandleType === (0, $czfFt.COLUMN_RESIZE_HANDLE_FULL_HEIGHT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b892b9cfbb034dc0$var$ResizeHandleFullHeight, commonProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b892b9cfbb034dc0$var$ResizeHandleHeaderOnly, commonProps);
    })(), !isResizePopupOpen && !(0, $4R6GH.fg)('use_native_css_to_set_column_resize_handle_height') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b892b9cfbb034dc0$var$ResizeHandleOld, {
        ref: resizeHandleRef,
        height: resizeHandleType === (0, $czfFt.COLUMN_RESIZE_HANDLE_FULL_HEIGHT) ? height : undefined,
        isActive: state.type === 'resizing' || columnIndex === index && isInlineFieldCreateHovered && (0, $4R6GH.fg)('jira_inline_field_config_gate'),
        onMouseEnter: onMouseEnterResizeHandle,
        onMouseLeave: onMouseLeaveResizeHandle,
        onDoubleClick: onResetColumnWidthAction,
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.resize-handle",
        "data-vc": "native-issue-table-ui-resize-handle",
        ...isInBetweenColumnPickerEnabled && {
            onMouseMove: (e)=>e.stopPropagation()
        }
    })), dropEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b892b9cfbb034dc0$var$DropTarget, {
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.drop-target",
        height: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uJ9N.DropIndicator), {
        edge: dropEdge,
        gap: $b892b9cfbb034dc0$var$BORDER_WIDTH,
        type: "no-terminal"
    })), state.type === 'preview' && /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b892b9cfbb034dc0$var$DragPreview, {
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.drag-preview",
        height: height,
        width: state.previewWidth
    }), state.container))); // #endregion
};
// #region Styles
/**
 * Invisible element to attach resizing popup to - the intermediate component is required to allow
 * passing the ref while blocking the other props from being passed to the underlying div.
 *
 * This is because the other props are intended for a trigger button, but we are only using this
 * for positioning pourposes.
 */ const $b892b9cfbb034dc0$var$resizePopupTarget = ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b892b9cfbb034dc0$var$ResizePopupTargetDiv, {
        ref: ref
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $b892b9cfbb034dc0$var$ResizePopupTargetDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbidpf _4t3iidpf _kqswstnw _1ltvidpf _94n517m2",
            __cmplp.className
        ])
    });
});
const $b892b9cfbb034dc0$var$reorderingStyles = (0, $8CUq3.xcss)({
    opacity: 0.4
}); // Add overflow: hidden to the inline div so that the title can collapse its width if needed
// and give space to the right-hand side icons (sort/actions)
const $b892b9cfbb034dc0$var$overflowHiddenStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden'
});
const $b892b9cfbb034dc0$var$baseHeaderContainerCellStyles = {
    backgroundColor: "var(--ds-surface-sunken, #F7F8F9)",
    borderColor: "var(--ds-border, #091E4224)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $b892b9cfbb034dc0$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $b892b9cfbb034dc0$var$BORDER_WIDTH,
    '&:first-of-type': {
        borderTopLeftRadius: "var(--ds-border-radius-200, 8px)"
    },
    '&:last-of-type': {
        borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
        borderRightWidth: 0
    }
};
const $b892b9cfbb034dc0$var$baseHeaderContainerCellKeyboardStyles = {
    backgroundColor: "var(--ds-surface-sunken, #F7F8F9)",
    borderColor: "var(--ds-border, #091E4224)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $b892b9cfbb034dc0$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $b892b9cfbb034dc0$var$BORDER_WIDTH,
    '&:focus': {
        outline: 'unset',
        borderRight: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
        boxShadow: `inset 0 2px 0 0 ${"var(--ds-border-focused, #388BFF)"}`,
        '&:before': {
            content: ' ',
            display: 'block',
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: '-3px',
            left: '-1px',
            right: '-1px',
            bottom: '-1px',
            border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
        }
    }
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b892b9cfbb034dc0$var$EmptyHeaderCellOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1h6dmuej _1dqonqa1 _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jidpf _1rcdpd34 _4x86pd34 _1nd4idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b892b9cfbb034dc0$var$EmptyHeaderCellNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1h6dmuej _1dqonqa1 _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jidpf _nt751r31 _49pcn7od _1hvw1o36 _qzh6ugt7 _x7uvf705 _1j5l1ule _1qtkstnw _1w0p1osq _18141osq _1cl9j39m _p0vi1n1a _t0aw1n1a _eahy1n1a _7u4sugt7 _7ehi14bn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
const $b892b9cfbb034dc0$export$653bef049c32a0cd = (0, $cSD7y.componentWithFG)('nin-grid-keyboard-navigation', $b892b9cfbb034dc0$var$EmptyHeaderCellNew, $b892b9cfbb034dc0$var$EmptyHeaderCellOld); // TODO: some stopgaps have been introduced to facilitate landing column config which should be addressed in EM-7165
const $b892b9cfbb034dc0$export$9042168979f79508 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, hasShadow: hasShadow, visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $lD23V.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $lD23V.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $lD23V.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_1vpctke": (0, $lD23V.default)(__cmplp.stickyOffsets, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1h6dmuej _1dqonqa1 _1rjcze3t _18zru2gc _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcdpd34 _4x86pd34 _1nd4idpf _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr3108i",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv1l64",
            __cmplp.hasShadow && "_16qs1paq _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syaz1gjq" : "_syaz1dyx _k48p1wq8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles
const $b892b9cfbb034dc0$export$9e6d1f7c4a75832 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirst: isFirst, index: index, tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, hasShadow: hasShadow, visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $lD23V.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $lD23V.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $lD23V.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_1vpctke": (0, $lD23V.default)(__cmplp.stickyOffsets, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1h6dmuej _1dqonqa1 _1rjcze3t _18zru2gc _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e _nt751r31 _49pcn7od _1hvw1o36 _qzh6ugt7 _x7uvf705 _1j5l1ule _1qtkstnw _1w0p1osq _18141osq _1cl9j39m _p0vi1n1a _t0aw1n1a _eahy1n1a _7u4sugt7 _7ehi14bn",
            __cmplp.isFirst && "_13lipd34 _qnecidpf",
            __cmplp.index === 2 && "_1n9didpf _12s81n1a _1hw81n1a _zzeu1n1a _1qc71hup",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr3108i",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv1l64",
            __cmplp.hasShadow && "_16qs1paq _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syaz1gjq" : "_syaz1dyx _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $b892b9cfbb034dc0$export$429fd509d8532e18 = (0, $cSD7y.componentWithFG)('nin-grid-keyboard-navigation', $b892b9cfbb034dc0$export$9e6d1f7c4a75832, $b892b9cfbb034dc0$export$9042168979f79508); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b892b9cfbb034dc0$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _u5f31b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b892b9cfbb034dc0$var$ResizeHandleFullHeight = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18zr1b66 _1y1m1ntv _1bsbyh40 _kqswstnw _154ize3t _1xi213c4 _4t3i1kxc _80omuf7j _1pbykb7n",
            __cmplp.isActive ? "_bfhk1yqz" : "_bfhk18uv",
            !__cmplp.isActive && "_irr37jlr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b892b9cfbb034dc0$var$ResizeHandleHeaderOnly = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18zr1b66 _1y1m1ntv _1bsbyh40 _kqswstnw _154ize3t _1xi213c4 _4t3i1osq _80omuf7j _1pbykb7n",
            __cmplp.isActive ? "_bfhk1yqz" : "_bfhk18uv",
            !__cmplp.isActive && "_irr37jlr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b892b9cfbb034dc0$var$ResizeHandleOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $lD23V.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18zr1b66 _1y1m1ntv _1bsbyh40 _kqswstnw _154ize3t _1xi213c4 _80omuf7j _1pbykb7n",
            __cmplp.isActive ? "_bfhk1yqz" : "_bfhk18uv",
            __cmplp.height != null ? "_4t3it1jn" : "_4t3i1osq",
            !__cmplp.isActive && "_irr37jlr",
            __cmplp.className
        ])
    });
}); // Invisible box surrounding the full column for the `DropIndicator` to attach to
const $b892b9cfbb034dc0$var$DropTarget = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154ize3t _1ltvze3t _4t3i2nrh _1bsb1osq",
            __cmplp.className
        ])
    });
}); // Custom drag preview that looks like a ghost blue column
const $b892b9cfbb034dc0$var$DragPreview = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`),
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _1h6d1p6i _1dqonqa1 _189e1bk5 _4t3i2nrh _c71l1kxc _1bsb1hdq _bfhk7wq0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("efIPS", function(module, exports) {

$parcel$export(module.exports, "default", () => $16e5d8a2f53b6574$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bU3PY = parcelRequire("bU3PY");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $1ftkV = parcelRequire("1ftkV");
const $16e5d8a2f53b6574$var$WarningIndicator = ({ tooltip: tooltip })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($16e5d8a2f53b6574$var$WarningIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        label: formatMessage((0, $1ftkV.default).warningLabel),
        color: "var(--ds-icon-warning, #E56910)",
        LEGACY_size: "small"
    })));
};
var $16e5d8a2f53b6574$export$2e2bcd8739ae039 = $16e5d8a2f53b6574$var$WarningIndicator;
const $16e5d8a2f53b6574$var$HEADER_CELL_HEIGHT = 3.5 * (0, $gwIPs.gridSize); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16e5d8a2f53b6574$var$WarningIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxv77o _4t3i1f4h _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1ftkV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35ca5ff204b10f8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a35ca5ff204b10f8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    warningLabel: {
        "id": "native-issue-table.common.warning-indicator.warning-label",
        "defaultMessage": "Warning"
    }
});

});


parcelRegister("16Qme", function(module, exports) {

$parcel$export(module.exports, "HeaderCellActions", () => $aaff47b374dc9775$export$1d48fcee1df11ffa);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $czfFt = parcelRequire("czfFt");

var $e9M6d = parcelRequire("e9M6d");

var $frJjZ = parcelRequire("frJjZ");

var $1teks = parcelRequire("1teks");
const $aaff47b374dc9775$export$1d48fcee1df11ffa = ({ column: column, currentColumnWidth: currentColumnWidth, hasColumnConfiguration: hasColumnConfiguration, isColumnResizingEnabled: isColumnResizingEnabled, isCompactColumnEnabled: isCompactColumnEnabled = false, isHeaderCellHovered: isHeaderCellHovered, isFirst: isFirst, isLast: isLast, isOpen: isOpen, triggerRef: triggerRef = null, onMoveColumn: onMoveColumn, onOpenChange: onOpenChange, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumn, onResetColumnWidth: onResetColumnWidth })=>{
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        setIsFocused(true);
    }, []);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        setIsFocused(false);
    }, []);
    const isSortable = column.onSortOrderChanged !== undefined && column.isSortable;
    const isFixedTableLayoutEnabled = (0, $e9M6d.useIsFixedTableLayoutEnabled)();
    // Header actions width must be static when fixed table layout is disabled to prevent column
    // widths shifting as the user hovers the table header
    const isStaticWidth = !isFixedTableLayoutEnabled;
    const isSingleLineRowHeightEnabled = (0, $e9M6d.useIsSingleLineRowHeightEnabled)();
    const minimumColumnWidth = isSingleLineRowHeightEnabled ? (0, $czfFt.SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH) : (0, $czfFt.MINIMUM_COLUMN_WIDTH);
    if (!isSortable && !hasColumnConfiguration && !isColumnResizingEnabled) return null;
    const isMoreActionsVisible = isHeaderCellHovered || isOpen || isFocused;
    const isSorted = column.currentSorting === (0, $czfFt.SORT_ASC) || column.currentSorting === (0, $czfFt.SORT_DESC);
    const isSortVisible = isMoreActionsVisible || isSorted;
    const isSortOnlyAction = isSortable && !hasColumnConfiguration && !isColumnResizingEnabled;
    const sortButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $aaff47b374dc9775$var$baseStyles,
            !isSortVisible && $aaff47b374dc9775$var$hiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1teks.SortButton), {
        column: column,
        onFocus: onFocus,
        onBlur: onBlur
    }));
    const moreActionsButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $aaff47b374dc9775$var$baseStyles,
            !isMoreActionsVisible && $aaff47b374dc9775$var$hiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frJjZ.MoreActions), {
        column: column,
        currentColumnWidth: currentColumnWidth,
        hasColumnConfiguration: hasColumnConfiguration,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isFirst: isFirst,
        isLast: isLast,
        isOpen: isOpen,
        triggerRef: triggerRef,
        onMoveColumn: onMoveColumn,
        onOpenChange: onOpenChange,
        onRemoveColumn: onRemoveColumn,
        onResizeColumn: onResizeColumn,
        onResetColumnWidth: onResetColumnWidth,
        onFocus: onFocus,
        onBlur: onBlur
    }));
    if (isSortOnlyAction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: [
            $aaff47b374dc9775$var$containerStyles,
            isStaticWidth && $aaff47b374dc9775$var$singleButtonWidth
        ]
    }, sortButton);
    if (!isSortable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: [
            $aaff47b374dc9775$var$containerStyles,
            isStaticWidth && $aaff47b374dc9775$var$singleButtonWidth
        ]
    }, moreActionsButton);
    if (isCompactColumnEnabled && currentColumnWidth < minimumColumnWidth) {
        if (column.currentSorting !== (0, $czfFt.SORT_NONE) && !isHeaderCellHovered) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $aaff47b374dc9775$var$containerStyles,
                isStaticWidth && $aaff47b374dc9775$var$singleButtonWidth
            ]
        }, sortButton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $aaff47b374dc9775$var$containerStyles,
                isStaticWidth && $aaff47b374dc9775$var$singleButtonWidth
            ]
        }, moreActionsButton);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: isStaticWidth ? 'end' : undefined,
        xcss: [
            $aaff47b374dc9775$var$containerStyles,
            // Animate between single and all button width when sorted (only when in a dynamic layout)
            !isStaticWidth && isSorted && $aaff47b374dc9775$var$singleButtonWidth,
            (isStaticWidth || isMoreActionsVisible) && $aaff47b374dc9775$var$allButtonsWidth
        ]
    }, sortButton, moreActionsButton);
};
const $aaff47b374dc9775$var$containerStyles = (0, $8CUq3.xcss)({
    gap: 'space.050',
    transition: 'width .25s'
});
const $aaff47b374dc9775$var$singleButtonWidth = (0, $8CUq3.xcss)({
    width: '24px'
});
const $aaff47b374dc9775$var$allButtonsWidth = (0, $8CUq3.xcss)({
    width: '52px'
});
const $aaff47b374dc9775$var$baseStyles = (0, $8CUq3.xcss)({
    transition: 'opacity .25s'
});
const $aaff47b374dc9775$var$hiddenStyles = (0, $8CUq3.xcss)({
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: 'space.negative.025',
    overflow: 'hidden',
    padding: 'space.0',
    opacity: 0,
    position: 'absolute',
    pointerEvents: 'none'
});

});
parcelRegister("frJjZ", function(module, exports) {

$parcel$export(module.exports, "MoreActions", () => $0d8f997eab47c19c$export$f2f44eb5b71ba65f);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $8U6zd = parcelRequire("8U6zd");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $aRoVz = parcelRequire("aRoVz");

var $filTW = parcelRequire("filTW");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $9fuVs = parcelRequire("9fuVs");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $7mPT9 = parcelRequire("7mPT9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $jpY8v = parcelRequire("jpY8v");

var $czfFt = parcelRequire("czfFt");

var $e9M6d = parcelRequire("e9M6d");

var $5VaIm = parcelRequire("5VaIm");

var $gzbU9 = parcelRequire("gzbU9");

var $1Oj7m = parcelRequire("1Oj7m");

var $41nJV = parcelRequire("41nJV");
const $0d8f997eab47c19c$export$f2f44eb5b71ba65f = ({ column: column, currentColumnWidth: currentColumnWidth, hasColumnConfiguration: hasColumnConfiguration, isColumnResizingEnabled: isColumnResizingEnabled, isFirst: isFirst, isLast: isLast, isOpen: isOpen, triggerRef: triggerRef = null, onMoveColumn: onMoveColumn, onOpenChange: onOpenChange, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumn, onResetColumnWidth: onResetColumnWidth, onFocus: onFocus, onBlur: onBlur })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isInlineFieldConfigEnabled = (0, $e9M6d.useIsInlineFieldConfigEnabled)();
    const { ifcConfig: ifcConfig } = (0, $4R6GH.fg)('jira_inline_field_config_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5VaIm.useIFCConfigContext)() : {
        ifcConfig: null
    };
    const editField = (0, $4R6GH.fg)('jira_inline_field_config_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $gzbU9.useIFCEditField)() : undefined;
    const sortAsc = (0, $5uXOq.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $czfFt.SORT_ASC));
    }, [
        column
    ]);
    const sortDesc = (0, $5uXOq.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $czfFt.SORT_DESC));
    }, [
        column
    ]);
    const clearSorting = (0, $5uXOq.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $czfFt.SORT_NONE));
    }, [
        column
    ]);
    const handleOnOpenChange = (0, $5uXOq.useCallback)(({ isOpen: newIsOpen })=>{
        if (newIsOpen) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        }), 'issueTableHeaderActions');
        onOpenChange(newIsOpen);
    }, [
        createAnalyticsEvent,
        onOpenChange
    ]);
    const isSortable = column.onSortOrderChanged !== undefined && column.isSortable;
    const triggerLabel = formatMessage((0, $41nJV.default).columnActions, {
        column: column.title
    });
    // Ensure a stable ref function is passed through to the trigger button
    const memoizedMergeRefs = (0, $5uXOq.useMemo)(()=>(0, $8QpSo.default)((0, $7mPT9.mergeRefs)), []);
    const customMessage = (0, $4R6GH.fg)('jira_inline_field_config_gate') ? (0, $41nJV.default).sortCustomNew : (0, $41nJV.default).sortCustom;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        placement: "bottom-start",
        trigger: ({ triggerRef: dropdownTriggerRef, ...triggerProps })=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...triggerProps,
                ref: memoizedMergeRefs(dropdownTriggerRef, triggerRef),
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: triggerLabel,
                onFocus: onFocus,
                onBlur: onBlur,
                isTooltipDisabled: false,
                spacing: "compact",
                appearance: "subtle",
                testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-actions.more-actions.icon-button"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: triggerLabel,
                delay: 0,
                ignoreTooltipPointerEvents: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $0d8f997eab47c19c$var$triggerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                ref: memoizedMergeRefs(dropdownTriggerRef, triggerRef),
                appearance: "subtle",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($filTW))), {
                    label: triggerLabel,
                    LEGACY_size: "small"
                }),
                onFocus: onFocus,
                onBlur: onBlur
            }))),
        shouldRenderToParent: (0, $jpY8v.isChrome)() && (0, $4R6GH.fg)('jfp_a11y_team_fix_reading_order_for_expandable_btn')
    }, isSortable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, column.currentSorting !== (0, $czfFt.SORT_ASC) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Oj7m.ActionItem), {
        actionType: "sortAsc",
        onClick: sortAsc
    }, column.ascText ?? false ? formatMessage(customMessage, {
        sortDescription: column.ascText
    }) : formatMessage((0, $41nJV.default).sortAsc)), column.currentSorting !== (0, $czfFt.SORT_DESC) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Oj7m.ActionItem), {
        actionType: "sortDesc",
        onClick: sortDesc
    }, column.descText ?? false ? formatMessage(customMessage, {
        sortDescription: column.descText
    }) : formatMessage((0, $41nJV.default).sortDesc)), column.currentSorting !== (0, $czfFt.SORT_NONE) && (0, $4R6GH.fg)('jsc_list_reranking_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Oj7m.ActionItem), {
        actionType: "clearSorting",
        onClick: clearSorting
    }, formatMessage((0, $41nJV.default).clearSorting))), hasColumnConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: isSortable
    }, !isFirst && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Oj7m.ActionItem), {
        actionType: "moveColumnFirst",
        onClick: ()=>onMoveColumn((0, $czfFt.MOVE_COLUMN_FIRST))
    }, (0, $4R6GH.fg)('jira_inline_field_config_gate') ? formatMessage((0, $41nJV.default).moveFirstNew) : formatMessage((0, $41nJV.default).moveFirst)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Oj7m.ActionItem), {
        actionType: "moveColumnLeft",
        onClick: ()=>onMoveColumn((0, $czfFt.MOVE_COLUMN_LEFT))
    }, (0, $4R6GH.fg)('jira_inline_field_config_gate') ? formatMessage((0, $41nJV.default).moveLeftNew) : formatMessage((0, $41nJV.default).moveLeft))), !isLast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Oj7m.ActionItem), {
        actionType: "moveColumnRight",
        onClick: ()=>onMoveColumn((0, $czfFt.MOVE_COLUMN_RIGHT))
    }, (0, $4R6GH.fg)('jira_inline_field_config_gate') ? formatMessage((0, $41nJV.default).moveRightNew) : formatMessage((0, $41nJV.default).moveRight)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Oj7m.ActionItem), {
        actionType: "moveColumnLast",
        onClick: ()=>onMoveColumn((0, $czfFt.MOVE_COLUMN_LAST))
    }, (0, $4R6GH.fg)('jira_inline_field_config_gate') ? formatMessage((0, $41nJV.default).moveLastNew) : formatMessage((0, $41nJV.default).moveLast))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Oj7m.ActionItem), {
        actionType: "removeColumn",
        onClick: onRemoveColumn
    }, formatMessage((0, $41nJV.default).removeColumn))), isColumnResizingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: isSortable || hasColumnConfiguration
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Oj7m.ActionItem), {
        actionType: "resizeColumn",
        onClick: onResizeColumn
    }, formatMessage((0, $41nJV.default).resizeColumn)), currentColumnWidth != null && currentColumnWidth !== column.defaultWidth && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Oj7m.ActionItem), {
        actionType: "resetColumnWidth",
        onClick: onResetColumnWidth
    }, formatMessage((0, $41nJV.default).resetColumnWidth))), isInlineFieldConfigEnabled && column.configureableFieldId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: true
    }, ifcConfig?.IFCTriggerRef && editField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ifcConfig.IFCTriggerRef, null, ({ triggerRef: ifcTriggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Oj7m.ActionItem), {
            ref: ifcTriggerRef,
            actionType: "editField",
            onClick: ()=>{
                if (column.configureableFieldId) editField(column.configureableFieldId, column.id);
            }
        }, formatMessage((0, $41nJV.default).editField)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null));
};
const $0d8f997eab47c19c$var$triggerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '24px',
    width: '24px'
});

});
parcelRegister("filTW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7b9c6249a1eec95e276a40edfd26c3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2298695ccdee45b$var$_react = $b2298695ccdee45b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2298695ccdee45b$var$_showMoreVertical = $b2298695ccdee45b$var$_interopRequireDefault((parcelRequire("6B7lo")));

var $b2298695ccdee45b$var$_moreVertical = $b2298695ccdee45b$var$_interopRequireDefault((parcelRequire("jl6fU")));
function $b2298695ccdee45b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreVerticalIcon.
 * This component is ShowMoreVerticalIcon, with `UNSAFE_fallbackIcon` set to "MoreVerticalIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2298695ccdee45b$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $b2298695ccdee45b$var$_react.default.createElement($b2298695ccdee45b$var$_showMoreVertical.default, Object.assign({
        LEGACY_fallbackIcon: $b2298695ccdee45b$var$_moreVertical.default
    }, props));
$b2298695ccdee45b$var$ShowMoreVerticalIcon.Name = 'ShowMoreVerticalIconMigration';
var $b2298695ccdee45b$var$_default = module.exports.default = $b2298695ccdee45b$var$ShowMoreVerticalIcon;

});
parcelRegister("6B7lo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02df73cd5dddff20d82e48f58fe7ce92>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4cdbe527bbb56462$var$_react = $4cdbe527bbb56462$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4cdbe527bbb56462$var$_baseNew = $4cdbe527bbb56462$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $4cdbe527bbb56462$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4cdbe527bbb56462$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $4cdbe527bbb56462$var$_react.default.createElement($4cdbe527bbb56462$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$4cdbe527bbb56462$var$ShowMoreVerticalIcon.displayName = 'ShowMoreVerticalIcon';
var $4cdbe527bbb56462$var$_default = module.exports.default = $4cdbe527bbb56462$var$ShowMoreVerticalIcon;

});

parcelRegister("jl6fU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e144d4b41783edfd$var$_react = $e144d4b41783edfd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e144d4b41783edfd$var$_showMoreVertical = $e144d4b41783edfd$var$_interopRequireDefault((parcelRequire("6B7lo")));
function $e144d4b41783edfd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e144d4b41783edfd$var$MoreVerticalIcon = (props)=>/*#__PURE__*/ $e144d4b41783edfd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="12" cy="19" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/></g></svg>`
    }, props, {
        newIcon: $e144d4b41783edfd$var$_showMoreVertical.default
    }));
$e144d4b41783edfd$var$MoreVerticalIcon.displayName = 'MoreVerticalIcon';
var $e144d4b41783edfd$var$_default = module.exports.default = $e144d4b41783edfd$var$MoreVerticalIcon;

});


parcelRegister("1Oj7m", function(module, exports) {

$parcel$export(module.exports, "ActionItem", () => $9d78cad52d0696f6$export$ac06cb4ab481cfab);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");
const $9d78cad52d0696f6$export$841c406d190a3baa = ({ actionType: actionType, children: children, onClick: onClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'issueTableHeaderActions', {
            actionType: actionType
        });
        onClick();
    }, [
        actionType,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleOnClick
    }, children);
};
const $9d78cad52d0696f6$export$ec2208c4baf896f0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ actionType: actionType, children: children, onClick: onClick }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'issueTableHeaderActions', {
            actionType: actionType
        });
        onClick();
    }, [
        actionType,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        ref: ref,
        onClick: handleOnClick
    }, children);
});
const $9d78cad52d0696f6$export$ac06cb4ab481cfab = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira_inline_field_config_gate'), $9d78cad52d0696f6$export$ec2208c4baf896f0, $9d78cad52d0696f6$export$841c406d190a3baa);

});

parcelRegister("41nJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d41861a57061121$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3d41861a57061121$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    columnActions: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.column-actions",
        "defaultMessage": "More actions for {column}"
    },
    sortAsc: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-asc",
        "defaultMessage": "Sort in ascending order"
    },
    sortDesc: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-desc",
        "defaultMessage": "Sort in descending order"
    },
    sortCustom: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-custom",
        "defaultMessage": "Sort {sortDescription}"
    },
    sortCustomNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-custom-new",
        "defaultMessage": "Sort {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    clearSorting: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.clear-sorting",
        "defaultMessage": "Clear sorting"
    },
    moveFirst: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-first",
        "defaultMessage": "Move column to the first position"
    },
    moveLeft: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-left",
        "defaultMessage": "Move column to the left"
    },
    moveRight: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-right",
        "defaultMessage": "Move column to the right"
    },
    moveLast: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-last",
        "defaultMessage": "Move column to the last position"
    },
    moveFirstNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-first-new",
        "defaultMessage": "Move column to first position"
    },
    moveLeftNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-left-new",
        "defaultMessage": "Move column to left"
    },
    moveRightNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-right-new",
        "defaultMessage": "Move column to right"
    },
    moveLastNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-last-new",
        "defaultMessage": "Move column to last position"
    },
    removeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.remove-column",
        "defaultMessage": "Remove column"
    },
    resizeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.resize-column",
        "defaultMessage": "Resize column"
    },
    resetColumnWidth: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.reset-column-width",
        "defaultMessage": "Reset column width"
    },
    editField: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.edit-field",
        "defaultMessage": "Edit field"
    }
});

});


parcelRegister("1teks", function(module, exports) {

$parcel$export(module.exports, "SortButton", () => $9cc4b9e7fb92d513$export$e464399b18ba2124);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $ls8Y7 = parcelRequire("ls8Y7");

var $kAObg = parcelRequire("kAObg");

var $2zbUZ = parcelRequire("2zbUZ");

var $4aXDc = parcelRequire("4aXDc");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $czfFt = parcelRequire("czfFt");

var $fzWg8 = parcelRequire("fzWg8");
const $9cc4b9e7fb92d513$var$ConditionalIconContainer = ({ children: children })=>{
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9cc4b9e7fb92d513$var$iconContainerStyles
    }, children, " ");
    return children;
};
const $9cc4b9e7fb92d513$var$useAccessibleLabel = ({ ascText: ascText, currentSorting: currentSorting, descText: descText, title: title })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const labelSuffix = (0, $5uXOq.useMemo)(()=>{
        const sortedTooltipMessage = (0, $4R6GH.fg)('jira_inline_field_config_gate') ? (0, $fzWg8.default).sortedTooltipNew : (0, $fzWg8.default).sortedTooltip;
        const sortPromptTooltipMessage = (0, $4R6GH.fg)('jira_inline_field_config_gate') ? (0, $fzWg8.default).sortPromptTooltipNew : (0, $fzWg8.default).sortPromptTooltip;
        switch(currentSorting){
            case 0, $czfFt.SORT_ASC:
                return ascText ?? false ? formatMessage(sortedTooltipMessage, {
                    sortDescription: ascText
                }) : formatMessage((0, $fzWg8.default).sortedDefaultAscendingTooltip);
            case 0, $czfFt.SORT_DESC:
                return descText ?? false ? formatMessage(sortedTooltipMessage, {
                    sortDescription: descText
                }) : formatMessage((0, $fzWg8.default).sortedDefaultDescendingTooltip);
            default:
                return ascText ?? false ? formatMessage(sortPromptTooltipMessage, {
                    sortDescription: ascText
                }) : formatMessage((0, $fzWg8.default).sortPromptDefaultTooltip);
        }
    }, [
        ascText,
        currentSorting,
        descText,
        formatMessage
    ]);
    return (0, $5uXOq.useMemo)(()=>`${title} \u{2022} ${labelSuffix}`, [
        labelSuffix,
        title
    ]);
};
const $9cc4b9e7fb92d513$export$e464399b18ba2124 = ({ column: column, onFocus: onFocus, onBlur: onBlur })=>{
    const label = $9cc4b9e7fb92d513$var$useAccessibleLabel(column);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        let nextDirection = (0, $czfFt.SORT_ASC);
        if (column.currentSorting === (0, $czfFt.SORT_ASC)) nextDirection = (0, $czfFt.SORT_DESC);
        else if (column.currentSorting === (0, $czfFt.SORT_DESC)) nextDirection = (0, $4R6GH.fg)('jsc_list_reranking_gate') ? (0, $czfFt.SORT_NONE) : (0, $czfFt.SORT_ASC);
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const attributes = {
            fieldType: column.type,
            sortOrder: nextDirection
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'sortOrderChange', attributes);
        column.onSortOrderChanged?.(column.jqlTerm, nextDirection);
    }, [
        column,
        createAnalyticsEvent
    ]);
    const Icon = column.currentSorting === (0, $czfFt.SORT_DESC) ? (0, (/*@__PURE__*/$parcel$interopDefault($2zbUZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($4aXDc)));
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: column.currentSorting === (0, $czfFt.SORT_DESC) ? (0, (/*@__PURE__*/$parcel$interopDefault($2zbUZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($4aXDc))),
        label: label,
        spacing: "compact",
        appearance: "subtle",
        isTooltipDisabled: false,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-actions.sort-button.icon-button"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        delay: 0,
        ignoreTooltipPointerEvents: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cc4b9e7fb92d513$var$ConditionalIconContainer, null, column.currentSorting === (0, $czfFt.SORT_DESC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            label: label,
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ls8Y7))),
            LEGACY_size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            label: label,
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kAObg))),
            LEGACY_size: "small"
        })),
        isSelected: column.currentSorting !== (0, $czfFt.SORT_NONE),
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    }));
};
const $9cc4b9e7fb92d513$var$iconContainerStyles = (0, $8CUq3.xcss)({
    margin: 'space.025'
});

});
parcelRegister("ls8Y7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9e32b81d01f795b$var$_react = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f9e32b81d01f795b$var$_arrowDown = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("cC5ib")));
function $f9e32b81d01f795b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f9e32b81d01f795b$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $f9e32b81d01f795b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props, {
        newIcon: $f9e32b81d01f795b$var$_arrowDown.default
    }));
$f9e32b81d01f795b$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $f9e32b81d01f795b$var$_default = module.exports.default = $f9e32b81d01f795b$var$ArrowDownIcon;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});


parcelRegister("kAObg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efde1844fc0ef421$var$_react = $efde1844fc0ef421$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $efde1844fc0ef421$var$_arrowUp = $efde1844fc0ef421$var$_interopRequireDefault((parcelRequire("kcHZS")));
function $efde1844fc0ef421$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $efde1844fc0ef421$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $efde1844fc0ef421$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $efde1844fc0ef421$var$_arrowUp.default
    }));
$efde1844fc0ef421$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $efde1844fc0ef421$var$_default = module.exports.default = $efde1844fc0ef421$var$ArrowUpIcon;

});
parcelRegister("kcHZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb570e807ab2e210$var$_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb570e807ab2e210$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;

});


parcelRegister("2zbUZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1e6357a99e20a8f7be8123461f296b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1de81856380abbdd$var$_react = $1de81856380abbdd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1de81856380abbdd$var$_baseNew = $1de81856380abbdd$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $1de81856380abbdd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1de81856380abbdd$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $1de81856380abbdd$var$_react.default.createElement($1de81856380abbdd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$1de81856380abbdd$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $1de81856380abbdd$var$_default = module.exports.default = $1de81856380abbdd$var$ArrowDownIcon;

});

parcelRegister("4aXDc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b97c8602ff8ab17fec6352425b80eb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30a65a1ef9243aed$var$_react = $30a65a1ef9243aed$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $30a65a1ef9243aed$var$_baseNew = $30a65a1ef9243aed$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $30a65a1ef9243aed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30a65a1ef9243aed$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $30a65a1ef9243aed$var$_react.default.createElement($30a65a1ef9243aed$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.47 1.22a.75.75 0 0 1 1.06 0l4 4-1.06 1.06-2.72-2.72V11h-1.5V3.56L2.53 6.28 1.47 5.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$30a65a1ef9243aed$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $30a65a1ef9243aed$var$_default = module.exports.default = $30a65a1ef9243aed$var$ArrowUpIcon;

});

parcelRegister("fzWg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $87352afee0de0d09$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87352afee0de0d09$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sortedTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-tooltip",
        "defaultMessage": "Sorted {sortDescription}"
    },
    sortedTooltipNew: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-tooltip-new",
        "defaultMessage": "Sorted {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    sortPromptTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-tooltip",
        "defaultMessage": "Sort {sortDescription}"
    },
    sortPromptTooltipNew: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-tooltip-new",
        "defaultMessage": "Sort {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    sortPromptDefaultTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-default-tooltip",
        "defaultMessage": "Sort in ascending order"
    },
    sortedDefaultAscendingTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-default-ascending-tooltip",
        "defaultMessage": "Sorted in ascending order"
    },
    sortedDefaultDescendingTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-default-descending-tooltip",
        "defaultMessage": "Sorted in descending order"
    }
});

});



parcelRegister("kOoiQ", function(module, exports) {

$parcel$export(module.exports, "ResizePopup", () => $caba7f78bda32d6e$export$8ddf8c84a74a26df);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $efXp3 = parcelRequire("efXp3");
var $h2dqn = parcelRequire("h2dqn");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $dTzvg = parcelRequire("dTzvg");

var $9fuVs = parcelRequire("9fuVs");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $czfFt = parcelRequire("czfFt");

var $8Jbp0 = parcelRequire("8Jbp0");

var $gecdt = parcelRequire("gecdt");
const $caba7f78bda32d6e$var$ResizePopupContent = ({ columnTitle: columnTitle, initialWidth: initialWidth, isCompactColumnEnabled: isCompactColumnEnabled = false, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, minimumWidth: minimumWidth, onChange: onChange, onCancel: onCancel, onSubmit: onSubmit, setInitialFocusRef: setInitialFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleDragOrTouchStart = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    const minimumColumnWidth = isSingleLineRowHeightEnabled ? (0, $czfFt.SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH) : (0, $czfFt.MINIMUM_COLUMN_WIDTH);
    const defaultMinWidth = isCompactColumnEnabled ? (0, $czfFt.MINIMUM_COLUMN_WIDTH_COMPACT) : minimumColumnWidth;
    const minWidth = minimumWidth || defaultMinWidth;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.200",
        xcss: $caba7f78bda32d6e$var$PopupContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: ({ width: width })=>onSubmit((0, $8Jbp0.ensureWidthWithinLimits)(width, isCompactColumnEnabled, isSingleLineRowHeightEnabled))
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h2dqn.default), {
            label: formatMessage((0, $gecdt.default).columnWidthLabel, {
                columnTitle: columnTitle
            }),
            name: "width",
            defaultValue: initialWidth
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTzvg.default), {
                ...fieldProps,
                ref: setInitialFocusRef,
                min: minWidth,
                max: (0, $czfFt.MAXIMUM_COLUMN_WIDTH),
                step: 5,
                onChange: (value)=>{
                    onChange(value);
                    fieldProps.onChange(value);
                },
                draggable: true,
                onDragStart: handleDragOrTouchStart,
                onTouchStart: handleDragOrTouchStart
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.100",
            alignInline: "end",
            xcss: $caba7f78bda32d6e$var$FormFooterStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            onClick: onCancel
        }, formatMessage((0, $gecdt.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            type: "submit",
            appearance: "primary"
        }, formatMessage((0, $gecdt.default).save))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null));
};
const $caba7f78bda32d6e$export$8ddf8c84a74a26df = ({ columnTitle: columnTitle, initialWidth: initialWidth, placement: placement, isOpen: isOpen, isCompactColumnEnabled: isCompactColumnEnabled = false, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, minimumWidth: minimumWidth, trigger: trigger, onChange: onChange, onCancel: onCancelProp, onSubmit: onSubmit })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onCancel = (0, $5uXOq.useCallback)((event, analyticsEventParam)=>{
        const analyticsEvent = analyticsEventParam ?? createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cancelColumnResize');
        onCancelProp(event);
    }, [
        onCancelProp,
        createAnalyticsEvent
    ]);
    const PopupContent = (0, $5uXOq.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($caba7f78bda32d6e$var$ResizePopupContent, {
            columnTitle: columnTitle,
            initialWidth: initialWidth,
            isCompactColumnEnabled: isCompactColumnEnabled,
            minimumWidth: minimumWidth,
            onChange: onChange,
            onCancel: onCancel,
            onSubmit: onSubmit,
            setInitialFocusRef: setInitialFocusRef,
            isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
        }), [
        columnTitle,
        initialWidth,
        isCompactColumnEnabled,
        isSingleLineRowHeightEnabled,
        minimumWidth,
        onChange,
        onCancel,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        testId: "native-issue-table.ui.issue-table.header.header-cell.resize-popup.resize-popup",
        placement: placement,
        isOpen: isOpen,
        onClose: onCancel,
        trigger: trigger,
        content: PopupContent,
        shouldRenderToParent: true,
        messageId: "native-issue-table.ui.issue-table.header.header-cell.resize-popup.popup",
        messageType: "transactional"
    });
};
const $caba7f78bda32d6e$var$PopupContentStyles = (0, $8CUq3.xcss)({
    fontWeight: "var(--ds-font-weight-regular, 400)",
    marginBlock: 'space.200',
    whiteSpace: 'normal'
});
const $caba7f78bda32d6e$var$FormFooterStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("h2dqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e93c5d83e9e62786$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");
/**
 * __Range field__
 *
 * A range field is where a user can submit a range input as a part of a form.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 */ const $e93c5d83e9e62786$var$RangeField = ({ children: children, ...strippedProps })=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        ...strippedProps,
        transform: Number,
        children: ({ fieldProps: { isInvalid: isInvalid, isRequired: isRequired, ...fieldProps }, ...rest })=>// isInvalid and isRequired are specifically invalid for range inputs
            children({
                fieldProps: fieldProps,
                ...rest
            })
    });
var $e93c5d83e9e62786$export$2e2bcd8739ae039 = $e93c5d83e9e62786$var$RangeField;

});

parcelRegister("dTzvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $828895913af446af$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $2vUKL = parcelRequire("2vUKL");
const $828895913af446af$var$snapToStep = (value, min, step)=>{
    // Normalise the value to allow for division properly with different min values
    const adjustedValue = value - min;
    // Find the number of steps the value covers
    const numSteps = Math.round(adjustedValue / step);
    // Convert numSteps back into original range
    return numSteps * step + min;
};
const $828895913af446af$var$getRoundedPercentValue = (value, min, max, step)=>{
    let percent = '0';
    if (min < max && value > min) {
        const snappedValue = $828895913af446af$var$snapToStep(value, min, step);
        percent = ((snappedValue - min) / (max - min) * 100).toFixed(2);
    }
    return percent;
};
const $828895913af446af$var$noop = (0, $eGmKJ.default);
/**
 * __Range__
 *
 * A range lets users choose an approximate value on a slider.
 *
 * - [Examples](https://atlassian.design/components/range/examples)
 * - [Code](https://atlassian.design/components/range/code)
 * - [Usage](https://atlassian.design/components/range/usage)
 */ const $828895913af446af$var$Range = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Range(props, ref) {
    const { isDisabled: isDisabled = false, defaultValue: defaultValue = 50, max: max = 100, min: min = 0, onChange: onChange = $828895913af446af$var$noop, step: step = 1, value: propsValue, testId: testId, ...rest } = props;
    const spreadProps = {
        max: max,
        min: min,
        step: step,
        ref: ref,
        ...rest
    };
    const [value, setValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const handleChange = (0, $5uXOq.useCallback)((e)=>{
        const newValue = Number(e.target.value);
        setValue(newValue);
        // Note use of newValue to ensure up=to-date value is used
        onChange(newValue);
    }, [
        onChange
    ]);
    const renderValue = propsValue !== undefined ? propsValue : value;
    const valuePercent = $828895913af446af$var$getRoundedPercentValue(renderValue, min, max, step);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2vUKL.Input), {
        type: "range",
        disabled: isDisabled,
        onChange: handleChange,
        value: renderValue,
        valuePercent: valuePercent,
        "data-testid": testId,
        ...spreadProps
    });
});
var $828895913af446af$export$2e2bcd8739ae039 = $828895913af446af$var$Range;

});
parcelRegister("2vUKL", function(module, exports) {

$parcel$export(module.exports, "Input", () => $c43d8ba865155e50$export$f5b8910cec6cf069);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
// Styles are split up to avoid edge-cases with TS implementations between `css` and `cssMap` with some
// of these edge-case pseudo-selectors.
// Previously, in Emotion, these selectors weren't consolidated, eg. `&::webkit-thumb, &::moz-thumb`
// would not be parsed by either browser, but this may no longer be the case in Compiled
const $c43d8ba865155e50$var$webkitStyles = null;
const $c43d8ba865155e50$var$firefoxStyles = null;
const $c43d8ba865155e50$var$baseStyles = null;
const $c43d8ba865155e50$var$themeStyles = null;
const $c43d8ba865155e50$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { valuePercent: valuePercent, style: style, ...strippedProps } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
        ...strippedProps,
        style: {
            // We are creating a css variable to control the "progress" portion of the range input
            // This avoids us needing to create a new css class for each new percentage value
            '--track-fg-width': `${valuePercent}%`
        },
        ref: ref,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1ylp _bfhk18uv _j5dh13gf _1j552wxo _nt751r31 _49pcglyw _1hvw1o36",
            "_wstuglyw _h2ksglyw _1kdl1q5u _m8f8g56u _1yz62hjt _1bdkusvi _u98z7vkz _1j707vkz _1esf5udg _4w431ik2 _yfyntlke _1sdc196n _18k7v77o _1cdcglyw _10lridpf _g6tdyh40 _vi4t2hjt _1g2h1osq _168l1y44 _9u3f2hce _1g741hsc _1d8tmgnk _np53xlkz _18tdtlke _1p201osq _1yte13gf _5i7a13gf",
            "_1yq0glyw _108m1q5u _1rf3g56u _1yeu2hjt _g4ppusvi _r7637vkz _1mn57vkz _12el5udg _1oqe1ik2 _10o7tlke _1kzev77o _15raidpf _e8hnidpf _37ywyh40 _1tcb2hjt _aoww1osq _1kd21y44 _vt2s1w6o _1ssqtlke _ru37idpf _1gvoyh40 _1nx42hjt _1f5t1osq _142y1y44 _d7w62hce _b3fmtlke _1vq313gf _1fov13gf _34m613gf",
            "_14h11kge _15dp1yrq _18lxyvsn _jxar1eo5 _ydqghkel _1jhc1eo5 _1ruc16ss _164c194a"
        ])
    });
});
$c43d8ba865155e50$export$f5b8910cec6cf069.displayName = 'InputRange';

});


parcelRegister("8Jbp0", function(module, exports) {

$parcel$export(module.exports, "setCssResizingWidth", () => $154ba6c50ae91b20$export$7bda7a969edeaaf9);
$parcel$export(module.exports, "clearCssResizingWidth", () => $154ba6c50ae91b20$export$c418ab97f3e5c176);
$parcel$export(module.exports, "disableCssPointerEvents", () => $154ba6c50ae91b20$export$b0074a660e898e0);
$parcel$export(module.exports, "enableCssPointerEvents", () => $154ba6c50ae91b20$export$1b5de7c0486b5e41);
$parcel$export(module.exports, "ensureWidthWithinLimits", () => $154ba6c50ae91b20$export$3a38b06f96ddcc2d);
$parcel$export(module.exports, "getProposedWidth", () => $154ba6c50ae91b20$export$39e6ff87d188b0e6);

var $czfFt = parcelRequire("czfFt");
const $154ba6c50ae91b20$var$CSS_RESIZING_WIDTH_PROPERTY = '--local-resizing-width';
const $154ba6c50ae91b20$export$7bda7a969edeaaf9 = (container, width)=>{
    container?.style.setProperty($154ba6c50ae91b20$var$CSS_RESIZING_WIDTH_PROPERTY, `${width}px`);
};
const $154ba6c50ae91b20$export$c418ab97f3e5c176 = (container)=>{
    container?.style.removeProperty($154ba6c50ae91b20$var$CSS_RESIZING_WIDTH_PROPERTY);
};
const $154ba6c50ae91b20$export$b0074a660e898e0 = (container)=>{
    container?.style.setProperty('pointer-events', 'none');
};
const $154ba6c50ae91b20$export$1b5de7c0486b5e41 = (container)=>{
    container?.style.removeProperty('pointer-events');
};
const $154ba6c50ae91b20$export$3a38b06f96ddcc2d = (width, isCompactColumnEnabled, isSingleLineRowHeightEnabled)=>{
    const minColumnWidth = isSingleLineRowHeightEnabled ? (0, $czfFt.SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH) : (0, $czfFt.MINIMUM_COLUMN_WIDTH);
    return Math.min(Math.max(isCompactColumnEnabled ? (0, $czfFt.MINIMUM_COLUMN_WIDTH_COMPACT) : minColumnWidth, width), (0, $czfFt.MAXIMUM_COLUMN_WIDTH));
};
const $154ba6c50ae91b20$export$39e6ff87d188b0e6 = ({ initialWidth: initialWidth, isCompactColumnEnabled: isCompactColumnEnabled, location: location, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    const proposedWidth = initialWidth + diffX;
    // ensure we don't go below the min allowed width
    return $154ba6c50ae91b20$export$3a38b06f96ddcc2d(proposedWidth, isCompactColumnEnabled, isSingleLineRowHeightEnabled);
};

});

parcelRegister("gecdt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d558b2f9f93874f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5d558b2f9f93874f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    columnWidthLabel: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.column-width-label",
        "defaultMessage": "Column width - {columnTitle}"
    },
    cancel: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.cancel",
        "defaultMessage": "Cancel"
    },
    save: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.save",
        "defaultMessage": "Save"
    }
});

});



parcelRegister("ej9M2", function(module, exports) {

$parcel$export(module.exports, "default", () => $545da246c25e00dc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $545da246c25e00dc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    movedColumn: {
        "id": "native-issue-table.issue-table.header.moved-column",
        "defaultMessage": "You\u2019ve moved {column} from {previousPosition} to {position} of {total}."
    }
});

});


parcelRegister("eT3Vu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d406c4821c2642$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f6d406c4821c2642$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issuesTableLabel: {
        "id": "native-issue-table.issue-table.issues-table-label",
        "defaultMessage": "Issues"
    },
    issuesTableLabelIssueTermRefresh: {
        "id": "native-issue-table.issue-table.issues-table-label-issue-term-refresh",
        "defaultMessage": "Work"
    }
});

});

parcelRegister("4nnug", function(module, exports) {

$parcel$export(module.exports, "default", () => $598871db70b8238c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $4Bpvs = parcelRequire("4Bpvs");

var $5oFIy = parcelRequire("5oFIy");

var $56vto = parcelRequire("56vto");

var $2BpVt = parcelRequire("2BpVt");
const $598871db70b8238c$var$NoColumnsRenderer = ({ NoColumns: NoColumns = (0, $56vto.NoColumns), hasColumnConfiguration: hasColumnConfiguration, isLoading: isLoading = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($598871db70b8238c$var$NoColumnsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NoColumns, {
        defaultNoColumnsGlyph: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $598871db70b8238c$var$ImageWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Bpvs.default), {
            alt: ""
        })),
        hasColumnConfiguration: hasColumnConfiguration
    }), isLoading && ((0, $4R6GH.fg)('add_nin_press_interactions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2BpVt.Overlay), {
        interactionName: "issue-table-no-columns-renderer-overlay"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2BpVt.OverlayOld), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTableNoColumns"
    }));
var $598871db70b8238c$export$2e2bcd8739ae039 = $598871db70b8238c$var$NoColumnsRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $598871db70b8238c$var$NoColumnsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _kqsw1if8 _1ltvidpf",
            __cmplp.className
        ])
    });
});
const $598871db70b8238c$var$ImageWrapperStyles = (0, $8CUq3.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("4Bpvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $029e22a35a3f42f7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("gZXfK")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("ieXL6")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $dCLgq = parcelRequire("dCLgq");

var $ieXL6 = parcelRequire("ieXL6");

var $gZXfK = parcelRequire("gZXfK");
const $029e22a35a3f42f7$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gZXfK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ieXL6))
});
var $029e22a35a3f42f7$export$2e2bcd8739ae039 = $029e22a35a3f42f7$var$Illustration;
// for advanced use only
const $029e22a35a3f42f7$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("ieXL6", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("gZXfK", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});


parcelRegister("56vto", function(module, exports) {

$parcel$export(module.exports, "NoColumns", () => $1e9e65187073fe12$export$a0e9f6d02eee4aa4);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");

var $koVbs = parcelRequire("koVbs");

var $bHZac = parcelRequire("bHZac");

var $8zOmE = parcelRequire("8zOmE");

var $9yV2W = parcelRequire("9yV2W");
const $1e9e65187073fe12$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ isOpen: isOpen }, actions] = (0, $bHZac.useColumnPickerOpenState)();
    const onOpenColumnPicker = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton');
        if (!isOpen) actions.open();
    }, [
        isOpen,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $9yV2W.default).noColumnsHeaderText),
        description: formatMessage((0, $9yV2W.default).noColumnsDescriptionText),
        testId: "native-issue-table.common.ui.components.no-columns.no-columns",
        primaryAction: hasColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            onClick: onOpenColumnPicker
        }, formatMessage((0, $9yV2W.default).configureColumns)) : undefined,
        renderImage: ()=>defaultNoColumnsGlyph
    }));
};

});
parcelRegister("9yV2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb37f0f12ee9177e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cb37f0f12ee9177e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noColumnsHeaderText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-header-text",
        "defaultMessage": "Configure your columns"
    },
    noColumnsDescriptionText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-description-text",
        "defaultMessage": "You haven't configured any columns yet. Add fields as columns to see search results and their information."
    },
    configureColumns: {
        "id": "native-issue-table.issue-table.no-columns.configure-columns",
        "defaultMessage": "Configure columns"
    }
});

});



parcelRegister("jWEOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $305bcdb438ff9e7a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $kjIEI = parcelRequire("kjIEI");

var $c7i3D = parcelRequire("c7i3D");

var $5oFIy = parcelRequire("5oFIy");

var $dCm1o = parcelRequire("dCm1o");

var $2BpVt = parcelRequire("2BpVt");

var $lMftd = parcelRequire("lMftd");
const $305bcdb438ff9e7a$var$NoIssuesRenderer = ({ NoIssues: NoIssues = (0, $lMftd.NoIssues), isLoading: isLoading = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($305bcdb438ff9e7a$var$EmptyIssuesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NoIssues, {
        defaultNoIssuesGlyph: (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $305bcdb438ff9e7a$var$ImageWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7i3D.default), {
            alt: ""
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $305bcdb438ff9e7a$var$ImageWrapperStylesOld
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjIEI.default), {
            alt: ""
        }))
    }), isLoading && ((0, $4R6GH.fg)('add_nin_press_interactions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2BpVt.Overlay), {
        interactionName: "issue-table-no-issues-renderer-overlay"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2BpVt.OverlayOld), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTableNoResults"
    }));
var $305bcdb438ff9e7a$export$2e2bcd8739ae039 = $305bcdb438ff9e7a$var$NoIssuesRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $305bcdb438ff9e7a$var$EmptyIssuesContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _kqsw1if8 _1ltvidpf _mezj18pt",
            __cmplp.className
        ])
    });
});
const $305bcdb438ff9e7a$var$ImageWrapperStylesOld = (0, $8CUq3.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});
const $305bcdb438ff9e7a$var$ImageWrapperStyles = (0, $8CUq3.xcss)({
    maxHeight: '165px',
    maxWidth: '150px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("kjIEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b511ca53b54ba8ce$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $dCLgq = parcelRequire("dCLgq");

var $aKIsO = parcelRequire("aKIsO");

var $47SnX = parcelRequire("47SnX");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $b511ca53b54ba8ce$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($47SnX)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($aKIsO))
});
var $b511ca53b54ba8ce$export$2e2bcd8739ae039 = $b511ca53b54ba8ce$var$Illustration;
// for advanced use only
const $b511ca53b54ba8ce$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("aKIsO", function(module, exports) {
module.exports = new URL("search-no-results-old-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("47SnX", function(module, exports) {
module.exports = new URL("search-no-results-old.10b14394.svg", import.meta.url).toString();

});


parcelRegister("c7i3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6eff2dc5f73fdbc$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $dCLgq = parcelRequire("dCLgq");

var $gXV7M = parcelRequire("gXV7M");

var $k0yDo = parcelRequire("k0yDo");
const $e6eff2dc5f73fdbc$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($k0yDo)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gXV7M))
});
var $e6eff2dc5f73fdbc$export$2e2bcd8739ae039 = $e6eff2dc5f73fdbc$var$Illustration;
// for advanced use only
const $e6eff2dc5f73fdbc$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    184
];

});
parcelRegister("gXV7M", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.c66ae5fb.svg", import.meta.url).toString();

});

parcelRegister("k0yDo", function(module, exports) {
module.exports = new URL("search-no-results.1d478205.svg", import.meta.url).toString();

});


parcelRegister("lMftd", function(module, exports) {

$parcel$export(module.exports, "NoIssues", () => $8c8a63608409a89b$export$a7a61a727a1d891b);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $kyCQk = parcelRequire("kyCQk");
const $8c8a63608409a89b$export$a7a61a727a1d891b = ({ defaultNoIssuesGlyph: defaultNoIssuesGlyph })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kyCQk.default).emptyIssuesIssueTermRefresh : (0, $kyCQk.default).emptyIssues),
        renderImage: ()=>defaultNoIssuesGlyph,
        testId: "native-issue-table.ui.issue-table.no-issues-renderer.no-issues.empty-state"
    }));
};

});
parcelRegister("kyCQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eda9d3ec8ac82a3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7eda9d3ec8ac82a3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyIssues: {
        "id": "native-issue-table.issue-table.empty-issues.empty-issues",
        "defaultMessage": "There are no issues"
    },
    emptyIssuesIssueTermRefresh: {
        "id": "native-issue-table.issue-table.no-issues-renderer.no-issues.empty-issues-issue-term-refresh",
        "defaultMessage": "There are no work items"
    }
});

});



parcelRegister("evoSk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a193212c0e2201e5$export$2e2bcd8739ae039);

var $4tl3L = parcelRequire("4tl3L");

var $aG8Uc = parcelRequire("aG8Uc");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $2q82p = parcelRequire("2q82p");

var $66i0J = parcelRequire("66i0J");

var $lFmEw = parcelRequire("lFmEw");

var $5DTiT = parcelRequire("5DTiT");

var $czfFt = parcelRequire("czfFt");

var $e9M6d = parcelRequire("e9M6d");

var $1v6c5 = parcelRequire("1v6c5");

var $9CFBJ = parcelRequire("9CFBJ");

var $4BEu7 = parcelRequire("4BEu7");

var $3I8L4 = parcelRequire("3I8L4");
const $a193212c0e2201e5$var$TableBody = ({ issueResults: issueResults, project: project, isGroupingSupported: isGroupingSupported, ...tableBodyProps })=>{
    const issueResultsData = (0, $8Uumt.useFragment)((0, $aG8Uc.default), issueResults);
    const projectData = (0, $8Uumt.useFragment)((0, $4tl3L.default), project); /**
                                                                                                                          * Passing those values down to ChildRowsLoader as props to avoid direct imports
                                                                                                                          */ 
    const jql = (0, $e9M6d.useJql)();
    const sortField = (0, $e9M6d.useSortField)();
    const sortDirection = (0, $e9M6d.useSortDirection)();
    const isReparentingEnabled = (0, $e9M6d.useIsReparentingEnabled)();
    const isTimelineEnabled = (0, $e9M6d.useIsTimelineEnabled)();
    const isHideDoneItemsEnabled = (0, $e9M6d.useIsHideDoneItemsEnabled)();
    const isFixedTableLayoutEnabled = (0, $e9M6d.useIsFixedTableLayoutEnabled)();
    const width = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>scrollState.width);
    const isIssueRankDescending = (0, $e9M6d.useIsIssueRankDescending)();
    const renderDraggableWrapper = (0, $5uXOq.useCallback)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3I8L4.DraggableRowsContainer), {
            issueConnectionId: props.issueConnectionId,
            instanceId: props.instanceId
        }, props.children);
    }, []);
    const renderChildRows = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2q82p.ChildRows), {
            ...props,
            projectKey: projectData?.key,
            isGroupingSupported: isGroupingSupported,
            childItemsExperience: (0, $czfFt.CHILD_ITEMS_EXPERIENCE),
            childItemsLoadMoreExperience: (0, $czfFt.CHILD_ITEMS_LOAD_MORE_EXPERIENCE),
            analyticsSource: (0, $czfFt.ANALYTICS_SOURCE),
            renderChildRowsLoader: (childRowsLoaderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $66i0J.ChildRowsLoader), {
                    ...childRowsLoaderProps,
                    jql: jql,
                    width: width,
                    sortField: sortField,
                    sortDirection: sortDirection,
                    columns: tableBodyProps.columns,
                    amountOfColumns: (0, $czfFt.MAX_COLUMNS),
                    actionColumns: (0, $czfFt.ACTION_COLUMNS),
                    pageSize: (0, $czfFt.CHILD_QUERY_PAGE_SIZE),
                    isReparentingEnabled: isReparentingEnabled,
                    isTimelineEnabled: isTimelineEnabled,
                    isIssueRankDescending: isIssueRankDescending,
                    isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                    isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
                    renderRows: (rowProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lFmEw.Rows), rowProps),
                    ...(0, $4R6GH.fg)('jsc_list_reranking_gate_technical') && {
                        renderDraggableWrapper: renderDraggableWrapper
                    },
                    renderTableCell: (tableCellProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1v6c5.TableCell), tableCellProps),
                    renderCreateIssueController: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4BEu7.CreateIssueController), {
                            ...args,
                            jql: jql
                        })
                })
        }), [
        projectData?.key,
        isGroupingSupported,
        tableBodyProps.columns,
        sortField,
        sortDirection,
        jql,
        isReparentingEnabled,
        isTimelineEnabled,
        isHideDoneItemsEnabled,
        isFixedTableLayoutEnabled,
        width,
        isIssueRankDescending,
        renderDraggableWrapper
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a193212c0e2201e5$var$StyledTableBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5DTiT.RowContextProvider), {
        ...tableBodyProps,
        renderChildRows: renderChildRows
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lFmEw.Rows), {
        issueResults: issueResultsData,
        parentItemId: "root",
        itemsConnectionId: issueResultsData.__id,
        ...(0, $4R6GH.fg)('jsc_list_reparenting') ? {
            projectKey: projectData?.key
        } : {}
    })));
};
var $a193212c0e2201e5$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a193212c0e2201e5$var$TableBody;
const $a193212c0e2201e5$var$StyledTableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tbody", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zlglyw _1reo15vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4tl3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9acfc4a76366dfd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8cf710fbe95a16b7b8fcff02894df348>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d9acfc4a76366dfd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "tableBody_nativeIssueTable_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraProject"
};
$d9acfc4a76366dfd$var$node.hash = "cfc6b38de1e391ca690f6cbf9793a14f";
var $d9acfc4a76366dfd$export$2e2bcd8739ae039 = $d9acfc4a76366dfd$var$node;

});

parcelRegister("aG8Uc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f9f07fd5effd4a1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e09e095b50d859f6b110470b4672769>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2f9f07fd5effd4a1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "tableBody_nativeIssueTable_issueResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "rows_nativeIssueTable"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$2f9f07fd5effd4a1$var$node.hash = "922033057dfd2b95ef6be698d0d0483a";
var $2f9f07fd5effd4a1$export$2e2bcd8739ae039 = $2f9f07fd5effd4a1$var$node;

});


parcelRegister("9uKCK", function(module, exports) {

$parcel$export(module.exports, "InitializeVirtualizer", () => $61eb167891423470$export$de49fec4748def14);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $1XJ20 = parcelRequire("1XJ20");

var $4R6GH = parcelRequire("4R6GH");

var $czfFt = parcelRequire("czfFt");

var $9CFBJ = parcelRequire("9CFBJ");

var $lmXG1 = parcelRequire("lmXG1");

var $lR6JR = parcelRequire("lR6JR");
const $61eb167891423470$var$estimateSize = ()=>(0, $czfFt.ROW_HEIGHT) + 1; // include border
const $61eb167891423470$var$InitializeVirtualizerInner = ({ rows: rows = 0, getItemKey: getItemKey, totalSizeRef: totalSizeRef })=>{
    const scrollElement = (0, $9CFBJ.useScrollElement)();
    const { setVirtualizer: setVirtualizer, setVirtualItemsMap: setVirtualItemsMap } = (0, $lR6JR.useVirtualizationActions)();
    const options = (0, $5uXOq.useMemo)(()=>({
            count: rows,
            getScrollElement: ()=>scrollElement,
            estimateSize: $61eb167891423470$var$estimateSize,
            getItemKey: getItemKey,
            overscan: 10
        }), [
        getItemKey,
        rows,
        scrollElement
    ]);
    const virtualizer = (0, $lmXG1.useSSRSafeVirtualizer)(options);
    const totalSize = virtualizer?.getTotalSize();
    const items = virtualizer?.getVirtualItems();
    // eslint-disable-next-line no-param-reassign
    totalSizeRef.current = totalSize ?? 0;
    const prevVirtualizer = (0, $1XJ20.usePrevious)(virtualizer);
    const prevItems = (0, $1XJ20.usePrevious)(items);
    if (prevVirtualizer !== virtualizer) setVirtualizer(virtualizer);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevItems, items)) {
        const virtualItemsMap = items?.reduce((acc, item)=>{
            acc[String(item.key)] = true;
            return acc;
        }, {});
        setVirtualItemsMap(virtualItemsMap);
    }
    return null;
};
const $61eb167891423470$export$de49fec4748def14 = (props)=>{
    // Skip any attempts to perform virtualization in SSR
    if (false && (0, $4R6GH.fg)('empanada_nin_fix_extra_remount_in_virtualization')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61eb167891423470$var$InitializeVirtualizerInner, props);
};

});
parcelRegister("lmXG1", function(module, exports) {

$parcel$export(module.exports, "useSSRSafeVirtualizer", () => $8ca54a126401d79c$export$e290ffcf7d3b6e02);

var $5uXOq = parcelRequire("5uXOq");

var $9suPc = parcelRequire("9suPc");
const $8ca54a126401d79c$export$f4c0efb17365077d = (options)=>{
    const { count: count, estimateSize: estimateSize, getItemKey: getItemKey } = options;
    const totalSize = count * estimateSize(0);
    let start = 0;
    const items = Array.from({
        length: count
    }).map((_, i)=>{
        const end = start + estimateSize(i);
        const item = {
            index: i,
            key: getItemKey?.(i) ?? i,
            start: start,
            end: end,
            lane: 0,
            size: estimateSize(i)
        };
        start = end;
        return item;
    });
    return {
        getTotalSize () {
            return totalSize;
        },
        getVirtualItems () {
            return items;
        }
    };
};
const $8ca54a126401d79c$var$dummyVirtualizer = {
    getTotalSize () {
        return 0;
    },
    getVirtualItems () {
        return [];
    }
};
const $8ca54a126401d79c$export$e290ffcf7d3b6e02 = (options)=>{
    const { getScrollElement: getScrollElement, count: count, estimateSize: estimateSize, getItemKey: getItemKey } = options;
    const [shouldUseSSRVirtualizer, setShouldUseSSRVirtualizer] = (0, $5uXOq.useState)(true);
    const serverVirtualizer = (0, $5uXOq.useMemo)(()=>{
        if (shouldUseSSRVirtualizer) // only calculated when is going to be used
        return $8ca54a126401d79c$export$f4c0efb17365077d({
            count: count,
            estimateSize: estimateSize,
            getItemKey: getItemKey
        });
        return $8ca54a126401d79c$var$dummyVirtualizer;
    }, [
        count,
        estimateSize,
        getItemKey,
        shouldUseSSRVirtualizer
    ]);
    const originalVirtualizer = (0, $9suPc.useVirtualizer)(options);
    /**
	 * We swap to real virtualization when we detect that the user has initiated a scroll
	 */ (0, $5uXOq.useEffect)(()=>{
        if (!shouldUseSSRVirtualizer) return;
        const element = getScrollElement();
        const onScroll = ()=>{
            if (!false) {
                setShouldUseSSRVirtualizer(false);
                element?.removeEventListener('scroll', onScroll);
            }
        };
        element?.addEventListener('scroll', onScroll);
        return ()=>{
            element?.removeEventListener('scroll', onScroll);
        };
    }, [
        shouldUseSSRVirtualizer,
        getScrollElement
    ]);
    /**
	 * We overwrite the methods to render the items and calculate size
	 * to assure that SSR renders the same as the frontend on the initial
	 * render
	 */ return (0, $5uXOq.useMemo)(()=>{
        if (shouldUseSSRVirtualizer) return {
            ...originalVirtualizer,
            ...serverVirtualizer
        };
        // Ensure we return a stable reference between renders when we stop using the SSR virtualizer
        return originalVirtualizer;
    }, [
        originalVirtualizer,
        serverVirtualizer,
        shouldUseSSRVirtualizer
    ]);
};

});
parcelRegister("9suPc", function(module, exports) {
$parcel$export(module.exports, "elementScroll", () => (parcelRequire("lASGB")).elementScroll);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("cDbvq")).notUndefined);
$parcel$export(module.exports, "observeElementOffset", () => (parcelRequire("lASGB")).observeElementOffset);
$parcel$export(module.exports, "observeElementRect", () => (parcelRequire("lASGB")).observeElementRect);
$parcel$export(module.exports, "observeWindowOffset", () => (parcelRequire("lASGB")).observeWindowOffset);
$parcel$export(module.exports, "observeWindowRect", () => (parcelRequire("lASGB")).observeWindowRect);
$parcel$export(module.exports, "Virtualizer", () => (parcelRequire("lASGB")).Virtualizer);
$parcel$export(module.exports, "windowScroll", () => (parcelRequire("lASGB")).windowScroll);

$parcel$export(module.exports, "useVirtualizer", () => $6e2ea3c4609c52d6$export$dd6d526d88b5a137);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $lASGB = parcelRequire("lASGB");
const $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
function $6e2ea3c4609c52d6$var$useVirtualizerBase(options) {
    const rerender = $5uXOq.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $7nsd3.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $5uXOq.useState(()=>new (0, $lASGB.Virtualizer)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $5uXOq.useEffect(()=>{
        return instance._didMount();
    }, []);
    $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $6e2ea3c4609c52d6$export$dd6d526d88b5a137(options) {
    return $6e2ea3c4609c52d6$var$useVirtualizerBase({
        observeElementRect: $lASGB.observeElementRect,
        observeElementOffset: $lASGB.observeElementOffset,
        scrollToFn: (0, $lASGB.elementScroll),
        ...options
    });
}
function $6e2ea3c4609c52d6$export$645722dcac657cb9(options) {
    return $6e2ea3c4609c52d6$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $lASGB.observeWindowRect),
        observeElementOffset: (0, $lASGB.observeWindowOffset),
        scrollToFn: (0, $lASGB.windowScroll),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}

});




parcelRegister("hUzfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6c049f4835cd2f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3Tty1 = parcelRequire("3Tty1");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lVJAU = parcelRequire("lVJAU");

var $4R6GH = parcelRequire("4R6GH");

var $fc4cz = parcelRequire("fc4cz");

var $1JFgA = parcelRequire("1JFgA");
const $2b6c049f4835cd2f$var$KeyboardShortcuts = ({ issueKeys: issueKeys = [], onIssueLinkSelected: onIssueLinkSelected })=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const [selectedRowIndex, { selectNextRow: selectNextRow, selectPrevRow: selectPrevRow }] = (0, $1JFgA.useSelectedRow)();
    const [selectedIssueKey] = (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? (0, $fc4cz.useSelectedIssueKey)() : [
        null
    ];
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const keyMap = (0, $5uXOq.useMemo)(()=>{
        const navigateToIssue = (issueKey)=>{
            push(`/browse/${issueKey}`);
        };
        return {
            arrowup: {
                callback: (e)=>{
                    // Prevent native browser scrolling as we provide auto-scroll functionality via scrollIntoView
                    e?.preventDefault();
                    selectPrevRow();
                }
            },
            arrowdown: {
                callback: (e)=>{
                    // Prevent native browser scrolling as we provide auto-scroll functionality via scrollIntoView
                    e?.preventDefault();
                    selectNextRow();
                }
            },
            k: {
                callback: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'rowItem pressed', 'navigateRowUp', {
                        rowIndex: selectedRowIndex,
                        keyPressed: 'k'
                    });
                    selectPrevRow();
                }
            },
            j: {
                callback: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'rowItem pressed', 'navigateRowDown', {
                        rowIndex: selectedRowIndex,
                        keyPressed: 'j'
                    });
                    selectNextRow();
                }
            },
            o: {
                callback: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'tableIssueLink', {
                        fieldType: 'unknown',
                        keyPressed: 'o',
                        tableRowNumber: selectedRowIndex,
                        keyboardShortcut: true
                    });
                    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) {
                        if (typeof selectedIssueKey === 'string' && selectedIssueKey.length > 0) {
                            const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(selectedIssueKey);
                            if (!handled) navigateToIssue(selectedIssueKey);
                        }
                        return;
                    }
                    if (typeof selectedRowIndex === 'number') {
                        const issueKey = issueKeys[selectedRowIndex];
                        if (typeof issueKey === 'string' && issueKey.length > 0) {
                            const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(issueKey);
                            if (!handled) navigateToIssue(issueKey);
                        }
                    }
                }
            },
            z: {
                callback: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'tableIssueLink', {
                        fieldType: 'unknown',
                        keyPressed: 'z',
                        tableRowNumber: selectedRowIndex,
                        keyboardShortcut: true
                    });
                    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) {
                        if (typeof selectedIssueKey === 'string' && selectedIssueKey.length > 0) {
                            const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(selectedIssueKey);
                            if (!handled) navigateToIssue(selectedIssueKey);
                        }
                        return;
                    }
                    if (typeof selectedRowIndex === 'number') {
                        const issueKey = issueKeys[selectedRowIndex];
                        if (typeof issueKey === 'string' && issueKey.length > 0) {
                            const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(issueKey);
                            if (!handled) navigateToIssue(issueKey);
                        }
                    }
                }
            }
        };
    }, [
        push,
        selectPrevRow,
        selectNextRow,
        createAnalyticsEvent,
        selectedRowIndex,
        selectedIssueKey,
        onIssueLinkSelected,
        issueKeys
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    });
};
var $2b6c049f4835cd2f$export$2e2bcd8739ae039 = $2b6c049f4835cd2f$var$KeyboardShortcuts;

});

parcelRegister("6EzQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d25306ee299d79$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $88d25306ee299d79$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    columnHeaderIssueType: {
        "id": "native-issue-table.column-header-issue-type",
        "defaultMessage": "Type"
    },
    columnHeaderIssueKey: {
        "id": "native-issue-table.column-header-issue-key",
        "defaultMessage": "Key"
    },
    columnHeaderIssueSummary: {
        "id": "native-issue-table.column-header-issue-summary",
        "defaultMessage": "Summary"
    },
    columnHeaderIssueAssignee: {
        "id": "native-issue-table.column-header-issue-assignee",
        "defaultMessage": "Assignee"
    },
    columnHeaderIssueReporter: {
        "id": "native-issue-table.column-header-issue-reporter",
        "defaultMessage": "Reporter"
    },
    columnHeaderIssuePriority: {
        "id": "native-issue-table.column-header-issue-priority",
        "defaultMessage": "P"
    },
    columnHeaderIssueStatus: {
        "id": "native-issue-table.column-header-issue-status",
        "defaultMessage": "Status"
    },
    columnHeaderIssueResolution: {
        "id": "native-issue-table.column-header-issue-resolution",
        "defaultMessage": "Resolution"
    },
    columnHeaderIssueCreatedDate: {
        "id": "native-issue-table.column-header-issue-created-date",
        "defaultMessage": "Created"
    },
    columnHeaderIssueUpdatedDate: {
        "id": "native-issue-table.column-header-issue-updated-date",
        "defaultMessage": "Updated"
    },
    columnHeaderIssueDueDate: {
        "id": "native-issue-table.column-header-issue-due-date",
        "defaultMessage": "Due"
    },
    columnHeaderIssueActions: {
        "id": "native-issue-table.column-header-issue-actions",
        "defaultMessage": "More actions"
    },
    aToZOrder: {
        "id": "native-issue-table.a-to-z-order",
        "defaultMessage": "A \u279E Z"
    },
    zToAOrder: {
        "id": "native-issue-table.z-to-a-order",
        "defaultMessage": "Z \u279E A"
    },
    oldestToNewestOrder: {
        "id": "native-issue-table.oldest-to-newest-order",
        "defaultMessage": "oldest \u279E newest"
    },
    newestToOldestOrder: {
        "id": "native-issue-table.newest-to-oldest-order",
        "defaultMessage": "newest \u279E oldest"
    },
    reorderColumnsErrorTitle: {
        "id": "native-issue-table.reorder-columns-error-title",
        "defaultMessage": "We couldn't reorder your columns"
    },
    reorderColumnsErrorDescription: {
        "id": "native-issue-table.reorder-columns-error-description",
        "defaultMessage": "Refresh and try again."
    },
    deprecatedParentLinkMessage: {
        "id": "native-issue-table.deprecated-parent-link-message",
        "defaultMessage": "<strong>Parent Link</strong> is replaced by <strong>Parent</strong>."
    }
});

});

parcelRegister("lT42R", function(module, exports) {

$parcel$export(module.exports, "RealtimeUpdater", () => $2018498139a9fd24$export$baf32da5b0b92d2b);

var $jDEof = parcelRequire("jDEof");

var $9ERDJ = parcelRequire("9ERDJ");

var $aHhQr = parcelRequire("aHhQr");

var $6HO9G = parcelRequire("6HO9G");

var $lm4xa = parcelRequire("lm4xa");

var $kIgsk = parcelRequire("kIgsk");

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $8Uumt = parcelRequire("8Uumt");

var $koeKL = parcelRequire("koeKL");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dXq4S = parcelRequire("dXq4S");

var $8mMQW = parcelRequire("8mMQW");

var $czfFt = parcelRequire("czfFt");

var $3duV9 = parcelRequire("3duV9");
const $2018498139a9fd24$var$REAL_TIME_EVENT_TYPE_KEY = 'realTimeEventType';
const $2018498139a9fd24$var$CREATE_ERROR_ID = 'realTimeIssueCreate';
const $2018498139a9fd24$var$UPDATE_ERROR_ID = 'realTimeIssueUpdate';
const $2018498139a9fd24$var$DELETE_ERROR_ID = 'realTimeIssueDelete';
const $2018498139a9fd24$export$d3ea91bf4184016b = 100;
const $2018498139a9fd24$export$2c7ede6e55079caa = 3000;
const $2018498139a9fd24$var$throttledFireTrackAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))((0, $8zOmE.fireTrackAnalytics), 1000);
const $2018498139a9fd24$var$issueCreatedSubscription = (0, $kIgsk.default);
const $2018498139a9fd24$var$issueUpdatedSubscription = (0, $lm4xa.default);
const $2018498139a9fd24$var$issueDeletedSubscription = (0, $6HO9G.default);
const $2018498139a9fd24$export$baf32da5b0b92d2b = ({ project: project, issues: issues, groups: groups, isHierarchyEnabled: isHierarchyEnabled, isStatusTrackingEnabled: isStatusTrackingEnabled, onRefetch: onRefetch })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const hasExceededMaxQueueSizeRef = (0, $5uXOq.useRef)(false);
    const showRealtimeUpdateExceededMaxFlag = (0, $3duV9.useRealtimeUpdateExceededMaxFlag)();
    const realtimeUpdatesForIssues = (0, $3duV9.useRealtimeUpdatesForIssues)();
    const cloudId = (0, $koeKL.useCloudId)();
    const issueConnection = (0, $8Uumt.useFragment)((0, $aHhQr.default), issues ?? null);
    const groupConnection = (0, $8Uumt.useFragment)((0, $9ERDJ.default), groups ?? null);
    const { projectId: projectId, key: projectKey } = (0, $8Uumt.useFragment)((0, $jDEof.default), project);
    const { issueDeleteUpdater: issueDeleteUpdater } = (0, $8mMQW.useIssueRealtimeUpdater)();
    const issueDeleteUpdaterRef = (0, $5uXOq.useRef)(issueDeleteUpdater);
    (0, $5uXOq.useEffect)(()=>{
        issueDeleteUpdaterRef.current = issueDeleteUpdater;
    }, [
        issueDeleteUpdater
    ]);
    const variables = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectId: projectId
        }), [
        cloudId,
        projectId
    ]);
    const queueRef = (0, $5uXOq.useRef)(new Map());
    const timeoutRef = (0, $5uXOq.useRef)(null);
    const processQueue = (0, $5uXOq.useCallback)(()=>{
        if (queueRef.current.size === 0 || hasExceededMaxQueueSizeRef.current) return;
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventQueueProcessing started', {
            queueSize: queueRef.current.size
        });
        if (queueRef.current.size > $2018498139a9fd24$export$d3ea91bf4184016b) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventsExceededMaxFlag shown', {
                queueSize: queueRef.current.size
            });
            hasExceededMaxQueueSizeRef.current = true;
            showRealtimeUpdateExceededMaxFlag({
                onRefresh: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventsExceededMaxRefresh clicked');
                    hasExceededMaxQueueSizeRef.current = false;
                    queueRef.current = new Map();
                    onRefetch?.();
                }
            });
        } else realtimeUpdatesForIssues({
            issues: Array.from(queueRef.current.values()),
            isHierarchyEnabled: isHierarchyEnabled ?? false,
            jql: issueConnection?.jql || groupConnection?.jql || '',
            groupByFieldId: groupConnection?.groupByField || undefined,
            groupConnectionId: groupConnection?.__id,
            numGroupsLoaded: groupConnection?.edges?.length ?? 0,
            projectKey: projectKey,
            isStatusTrackingEnabled: isStatusTrackingEnabled ?? false
        });
        queueRef.current = new Map();
    }, [
        createAnalyticsEvent,
        showRealtimeUpdateExceededMaxFlag,
        onRefetch,
        realtimeUpdatesForIssues,
        isHierarchyEnabled,
        issueConnection?.jql,
        groupConnection?.jql,
        groupConnection?.groupByField,
        groupConnection?.__id,
        groupConnection?.edges?.length,
        projectKey,
        isStatusTrackingEnabled
    ]);
    const triggerDelayedProcessingOfQueue = (0, $5uXOq.useCallback)(()=>{
        // Existing timeout exists, so we don't need to create a new one
        if (timeoutRef.current) return;
        timeoutRef.current = setTimeout(()=>{
            processQueue();
            timeoutRef.current = null;
        }, $2018498139a9fd24$export$2c7ede6e55079caa);
    }, [
        processQueue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    const handleCreateOrUpdateEvent = (0, $5uXOq.useCallback)((issueAri, issueId)=>{
        queueRef.current.set(issueAri, {
            issueAri: issueAri,
            issueId: issueId
        });
        triggerDelayedProcessingOfQueue();
    }, [
        triggerDelayedProcessingOfQueue
    ]);
    const handleCreateOrUpdateEventRef = (0, $5uXOq.useRef)(handleCreateOrUpdateEvent);
    (0, $5uXOq.useEffect)(()=>{
        handleCreateOrUpdateEventRef.current = handleCreateOrUpdateEvent;
    }, [
        handleCreateOrUpdateEvent
    ]);
    const createConfig = (0, $5uXOq.useMemo)(()=>({
            variables: variables,
            subscription: $2018498139a9fd24$var$issueCreatedSubscription,
            onNext: async (response)=>{
                try {
                    const resourceId = response?.jira?.onIssueCreatedByProjectNoEnrichment?.resource;
                    if (resourceId && (0, $dXq4S.isAri)(resourceId)) handleCreateOrUpdateEventRef.current(resourceId, (0, $dXq4S.getAriConfig)(resourceId).resourceId);
                } catch (error) {
                    (0, $jcw0u.default)({
                        meta: {
                            id: $2018498139a9fd24$var$CREATE_ERROR_ID,
                            packageName: (0, $czfFt.PACKAGE_NAME),
                            teamName: (0, $czfFt.TEAM_NAME)
                        },
                        attributes: {
                            logLocation: 'onNext'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $jcw0u.default)({
                    meta: {
                        id: $2018498139a9fd24$var$CREATE_ERROR_ID,
                        packageName: (0, $czfFt.PACKAGE_NAME),
                        teamName: (0, $czfFt.TEAM_NAME)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }), [
        variables
    ]);
    const updateConfig = (0, $5uXOq.useMemo)(()=>({
            variables: variables,
            subscription: $2018498139a9fd24$var$issueUpdatedSubscription,
            onNext: async (response)=>{
                try {
                    const resourceId = response?.jira?.onIssueUpdatedByProjectNoEnrichment?.resource;
                    if (resourceId && (0, $dXq4S.isAri)(resourceId)) handleCreateOrUpdateEventRef.current(resourceId, (0, $dXq4S.getAriConfig)(resourceId).resourceId);
                } catch (error) {
                    (0, $jcw0u.default)({
                        meta: {
                            id: $2018498139a9fd24$var$UPDATE_ERROR_ID,
                            packageName: (0, $czfFt.PACKAGE_NAME),
                            teamName: (0, $czfFt.TEAM_NAME)
                        },
                        attributes: {
                            logLocation: 'onNext'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $jcw0u.default)({
                    meta: {
                        id: $2018498139a9fd24$var$UPDATE_ERROR_ID,
                        packageName: (0, $czfFt.PACKAGE_NAME),
                        teamName: (0, $czfFt.TEAM_NAME)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }), [
        variables
    ]);
    const deleteConfig = (0, $5uXOq.useMemo)(()=>{
        return {
            variables: variables,
            subscription: $2018498139a9fd24$var$issueDeletedSubscription,
            updater: (store, response)=>{
                try {
                    if (response?.jira?.onIssueDeletedByProject?.resource) {
                        const wasDeleted = issueDeleteUpdaterRef.current({
                            store: store,
                            issueResourceId: response.jira.onIssueDeletedByProject.resource,
                            groupConnectionId: groupConnection?.__id,
                            projectKey: projectKey
                        });
                        wasDeleted && $2018498139a9fd24$var$throttledFireTrackAnalytics(createAnalyticsEvent({}), 'issueTableRealTimeEvent processed', {
                            [$2018498139a9fd24$var$REAL_TIME_EVENT_TYPE_KEY]: 'delete'
                        });
                    }
                } catch (error) {
                    (0, $jcw0u.default)({
                        meta: {
                            id: $2018498139a9fd24$var$DELETE_ERROR_ID,
                            packageName: (0, $czfFt.PACKAGE_NAME),
                            teamName: (0, $czfFt.TEAM_NAME)
                        },
                        attributes: {
                            logLocation: 'updater'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $jcw0u.default)({
                    meta: {
                        id: $2018498139a9fd24$var$DELETE_ERROR_ID,
                        packageName: (0, $czfFt.PACKAGE_NAME),
                        teamName: (0, $czfFt.TEAM_NAME)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
    }, [
        variables,
        groupConnection?.__id,
        projectKey,
        createAnalyticsEvent
    ]);
    (0, $8Uumt.useSubscription)(createConfig);
    (0, $8Uumt.useSubscription)(updateConfig);
    (0, $8Uumt.useSubscription)(deleteConfig);
    return null;
};

});
parcelRegister("jDEof", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fbb627d69bcef03$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7cb36164b5bb4bdee088db8cbf6ff35>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5fbb627d69bcef03$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "realtimeUpdater_nativeIssueTable_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraProject"
};
$5fbb627d69bcef03$var$node.hash = "54f3e67da3b1a5a78dd3e50777d39b59";
var $5fbb627d69bcef03$export$2e2bcd8739ae039 = $5fbb627d69bcef03$var$node;

});

parcelRegister("9ERDJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0444e0ffacf9fa7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cdf4eac0d7108a760c04d4abe4f1ad1c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e0444e0ffacf9fa7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "realtimeUpdater_nativeIssueTable_groups",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "groupByField"
        },
        {
            "concreteType": "JiraSpreadsheetGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$e0444e0ffacf9fa7$var$node.hash = "ef119ccb02ba7801b3514b38181f129c";
var $e0444e0ffacf9fa7$export$2e2bcd8739ae039 = $e0444e0ffacf9fa7$var$node;

});

parcelRegister("aHhQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $69622a95474a9a7b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf288cf061331c44eef6e6763c4066ce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $69622a95474a9a7b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "realtimeUpdater_nativeIssueTable_issues",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$69622a95474a9a7b$var$node.hash = "b4c334b7a561fdded3791060aeee02a7";
var $69622a95474a9a7b$export$2e2bcd8739ae039 = $69622a95474a9a7b$var$node;

});

parcelRegister("6HO9G", function(module, exports) {

$parcel$export(module.exports, "default", () => $61a21a51596952ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1dab65924f9c16744eaaf71efa50a300>>
 * @relayHash f117fb91c06f881fbe04e95f9257fc16
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e0665bec0712e49315eb39aff9bb1080876bc59e57382be0ffd4f37a469637b1
const $61a21a51596952ca$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectId",
                            "variableName": "projectId"
                        }
                    ],
                    "concreteType": "JiraIssueDeletedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueDeletedByProject",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "realtimeUpdater_issueDeleted_Subscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "realtimeUpdater_issueDeleted_Subscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "e0665bec0712e49315eb39aff9bb1080876bc59e57382be0ffd4f37a469637b1",
            "metadata": {},
            "name": "realtimeUpdater_issueDeleted_Subscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$61a21a51596952ca$var$node.hash = "d3d8f04ee66fc8e4f6135f2e2268776a";
var $61a21a51596952ca$export$2e2bcd8739ae039 = $61a21a51596952ca$var$node;

});

parcelRegister("lm4xa", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d588643bf94d34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a5be52bf2a0c5890570e2234deb934f>>
 * @relayHash 70c5cbd47116df92d038a359e0a381dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 25f49fe0ada85ace5a4512fd45e0bde5c33a1a1007a90ef950b6cf4cfbc381bb
const $86d588643bf94d34$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectId",
                            "variableName": "projectId"
                        }
                    ],
                    "concreteType": "JiraIssueUpdatedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueUpdatedByProjectNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "realtimeUpdater_issueUpdated_Subscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "realtimeUpdater_issueUpdated_Subscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "25f49fe0ada85ace5a4512fd45e0bde5c33a1a1007a90ef950b6cf4cfbc381bb",
            "metadata": {},
            "name": "realtimeUpdater_issueUpdated_Subscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$86d588643bf94d34$var$node.hash = "04520c3372a5e618b1581cb15407d4b5";
var $86d588643bf94d34$export$2e2bcd8739ae039 = $86d588643bf94d34$var$node;

});

parcelRegister("kIgsk", function(module, exports) {

$parcel$export(module.exports, "default", () => $63a8e404627a72e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f33348b088e2140f90d8c07f40fc6460>>
 * @relayHash 8216059cbb21289b715613ce0d8b2e51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3706e99a71c70f741da285a6437c04100694acb85ba97ba586fb317fc01be2ad
const $63a8e404627a72e2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectId",
                            "variableName": "projectId"
                        }
                    ],
                    "concreteType": "JiraIssueCreatedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueCreatedByProjectNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "realtimeUpdater_issueCreated_Subscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "realtimeUpdater_issueCreated_Subscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "3706e99a71c70f741da285a6437c04100694acb85ba97ba586fb317fc01be2ad",
            "metadata": {},
            "name": "realtimeUpdater_issueCreated_Subscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$63a8e404627a72e2$var$node.hash = "17e162496dfc818aef8a5e9ba2bb211d";
var $63a8e404627a72e2$export$2e2bcd8739ae039 = $63a8e404627a72e2$var$node;

});

parcelRegister("8mMQW", function(module, exports) {

$parcel$export(module.exports, "useIssueRealtimeUpdater", () => $1b10eaa66eba4acb$export$bf267694965fe0e3);

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");

var $iJZ8l = parcelRequire("iJZ8l");

var $5FoyW = parcelRequire("5FoyW");

var $MMunf = parcelRequire("MMunf");
const $1b10eaa66eba4acb$var$JIRA_ISSUE_TYPENAME = 'JiraIssue';
const $1b10eaa66eba4acb$export$6d61b264f874da2c = ({ store: store, connectionRecord: connectionRecord, fieldSetsRecordId: fieldSetsRecordId, issueRecordId: issueRecordId, position: position, projectKey: projectKey })=>{
    const issueRecord = store.get(issueRecordId);
    const fieldSetsRecord = fieldSetsRecordId ? store.get(fieldSetsRecordId) : undefined;
    if (!issueRecord || !fieldSetsRecord) return;
    const edge = (0, $eiowN.ConnectionHandler).createEdge(store, connectionRecord, issueRecord, 'JiraIssueEdge');
    const fieldSets = edge.getOrCreateLinkedRecord('fieldSets', 'JiraIssueFieldSetEdge', {
        first: 500
    });
    fieldSets.copyFieldsFrom(fieldSetsRecord);
    const updateArgs = projectKey ? {
        projectKey: projectKey
    } : undefined;
    const canHaveChildIssues = issueRecord.getValue('canHaveChildIssues', updateArgs);
    if (canHaveChildIssues) edge.setValue(true, 'canHaveChildIssues', updateArgs);
    // no before or after implies an empty connection, verify then create the edges list
    const { EDGES: EDGES } = (0, $eiowN.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES);
    if (!edges || position === -1 || position == null) return;
    const nextEdges = edges.slice(0, position).concat(edge).concat(edges.slice(position));
    connectionRecord.setLinkedRecords(nextEdges, EDGES);
};
const $1b10eaa66eba4acb$export$bf267694965fe0e3 = ()=>{
    const { connections: connections } = (0, $5FoyW.useConnectionsList)();
    const updateConnectionDetails = (0, $MMunf.useUpdateConnectionDetails)();
    const updateIssuesOnConnection = (0, $5uXOq.useCallback)(({ store: store, connection: connection, searchViewContexts: searchViewContexts, updatedIssues: updatedIssues, groupConnectionId: groupConnectionId, projectKey: projectKey })=>{
        const issuesProcessedAnalytics = {
            issuesUnmoved: new Set(),
            issuesMoved: new Set(),
            issuesRemoved: new Set(),
            issuesUnrelated: new Set()
        };
        const connectionRecord = store.get(connection.connectionId);
        if (!connectionRecord) return issuesProcessedAnalytics;
        const issuesWithContext = new Set(searchViewContexts?.flatMap((context)=>context?.sourceIssueId).filter(Boolean));
        const startingIssuesInConnection = new Set(connectionRecord.getLinkedRecords('edges')?.map((edge)=>edge?.getLinkedRecord('node')?.getDataID()));
        let changeInIssueCount = 0;
        updatedIssues.forEach((issue)=>{
            if (!issuesWithContext.has(issue.issueId)) {
                if (startingIssuesInConnection.has(issue.issueRecordId)) {
                    (0, $eiowN.ConnectionHandler).deleteNode(connectionRecord, issue.issueRecordId);
                    changeInIssueCount -= 1;
                    issuesProcessedAnalytics.issuesRemoved.add(issue.issueId);
                } else issuesProcessedAnalytics.issuesUnrelated.add(issue.issueId);
            }
        });
        searchViewContexts?.forEach((context)=>{
            const currentIssues = connectionRecord.getLinkedRecords('edges');
            const issueForContext = updatedIssues.get(context.sourceIssueId);
            if (!currentIssues || !issueForContext) return;
            const positionForIssue = (0, $MMunf.getIssueIndexInConnection)({
                issues: currentIssues,
                issuesWithContext: issuesWithContext,
                context: context
            });
            const issueAtPosition = currentIssues[positionForIssue];
            if (issueAtPosition && issueAtPosition.getLinkedRecord('node')?.getDataID() !== issueForContext.issueRecordId || context.position === currentIssues.length // the item would be the next loaded issue, insert in case the last page is loaded to ensure it appears in all cases
            ) {
                if (startingIssuesInConnection.has(issueForContext.issueRecordId)) (0, $eiowN.ConnectionHandler).deleteNode(connectionRecord, issueForContext.issueRecordId);
                else changeInIssueCount += 1;
                $1b10eaa66eba4acb$export$6d61b264f874da2c({
                    store: store,
                    connectionRecord: connectionRecord,
                    fieldSetsRecordId: issueForContext.fieldSetsRecordId,
                    issueRecordId: issueForContext.issueRecordId,
                    position: positionForIssue,
                    projectKey: projectKey
                });
                issuesProcessedAnalytics.issuesMoved.add(issueForContext.issueId);
            } else if (issueAtPosition != null) issuesProcessedAnalytics.issuesUnmoved.add(issueForContext.issueId);
            else if (positionForIssue > currentIssues.length && startingIssuesInConnection.has(issueForContext.issueRecordId)) {
                (0, $eiowN.ConnectionHandler).deleteNode(connectionRecord, issueForContext.issueRecordId);
                issuesProcessedAnalytics.issuesMoved.add(issueForContext.issueId);
                changeInIssueCount -= 1;
            } else issuesProcessedAnalytics.issuesUnrelated.add(issueForContext.issueId);
            // the issue has been handled, pop it so we can know its place in the list is trustworthy and will not be moved for relative positioning purposes
            issuesWithContext.delete(context.sourceIssueId);
        });
        updateConnectionDetails({
            store: store,
            connection: connection,
            netChangeInIssueCount: changeInIssueCount,
            remainingIssueCount: connectionRecord.getLinkedRecords('edges')?.length,
            groupConnectionId: groupConnectionId,
            projectKey: projectKey
        });
        return issuesProcessedAnalytics;
    }, [
        updateConnectionDetails
    ]);
    const updateNewParentsOnConnection = (0, $5uXOq.useCallback)(({ store: store, connection: connection, updatedParents: updatedParents, projectKey: projectKey })=>{
        const connectionRecord = store.get(connection.connectionId);
        const { EDGES: EDGES } = (0, $eiowN.ConnectionInterface).get();
        const edges = connectionRecord?.getLinkedRecords(EDGES);
        edges?.forEach((edge)=>{
            const parentIssueRecordId = edge?.getLinkedRecord('node')?.getDataID();
            if (parentIssueRecordId && updatedParents.has(parentIssueRecordId)) (0, $MMunf.updateParentHasChildren)({
                store: store,
                parentIssueEdgeRecordId: edge?.getDataID(),
                // this refers the the children connection of the parent, where this update is designed to work on parents where no connection can exist now
                connectionId: undefined,
                hasChildren: true,
                projectKey: projectKey
            });
        });
    }, []);
    const issueDeleteUpdater = (0, $5uXOq.useCallback)(({ store: store, issueResourceId: issueResourceId, groupConnectionId: groupConnectionId, projectKey: projectKey })=>{
        const id = (0, $iJZ8l.default)({
            id: issueResourceId
        }, $1b10eaa66eba4acb$var$JIRA_ISSUE_TYPENAME);
        let wasDeleted = false;
        if (!id) return wasDeleted;
        Object.values(connections).forEach((connection)=>{
            const connectionRecord = store.get(connection.connectionId);
            if (!connectionRecord) return;
            // check if the issue is in the connection
            if (connectionRecord.getLinkedRecords('edges')?.some((edge)=>edge?.getLinkedRecord('node')?.getDataID() === id)) {
                (0, $eiowN.ConnectionHandler).deleteNode(connectionRecord, id);
                updateConnectionDetails({
                    store: store,
                    connection: connection,
                    netChangeInIssueCount: -1,
                    remainingIssueCount: connectionRecord.getLinkedRecords('edges')?.length,
                    groupConnectionId: groupConnectionId,
                    projectKey: projectKey
                });
                wasDeleted = true;
            }
        });
        return wasDeleted;
    }, [
        connections,
        updateConnectionDetails
    ]);
    const groupsForIssueUpdater = (0, $5uXOq.useCallback)(({ store: store, groupConnectionId: groupConnectionId, groupsForIssue: groupsForIssue })=>{
        let wasUpdated = false;
        if (!groupConnectionId) return wasUpdated;
        const groupsConnection = store.get(groupConnectionId);
        if (!groupsConnection) return wasUpdated;
        let groupEdges = groupsConnection.getLinkedRecords('edges') || [];
        const existingGroupIds = new Set(groupEdges?.map((edge)=>edge?.getLinkedRecord('node')?.getValue('id')));
        groupsForIssue.forEach((group)=>{
            const newGroup = store.get(group.__id);
            if (!existingGroupIds.has(group.id) && newGroup) {
                groupEdges = (0, $MMunf.insertNewGroupInGroupsConnection)({
                    store: store,
                    groupsConnection: groupsConnection,
                    newGroup: newGroup,
                    groupEdges: groupEdges,
                    afterGroupId: group.afterGroupId
                });
                wasUpdated = true;
            }
        });
        groupsConnection.setLinkedRecords(groupEdges, 'edges');
        return wasUpdated;
    }, []);
    return {
        issueDeleteUpdater: issueDeleteUpdater,
        groupsForIssueUpdater: groupsForIssueUpdater,
        updateIssuesOnConnection: updateIssuesOnConnection,
        updateNewParentsOnConnection: updateNewParentsOnConnection
    };
};

});

parcelRegister("3duV9", function(module, exports) {

$parcel$export(module.exports, "useRealtimeUpdatesForIssues", () => $a9e40a9b60d0cdbc$export$9688da58398f9e26);
$parcel$export(module.exports, "useRealtimeUpdateExceededMaxFlag", () => $a9e40a9b60d0cdbc$export$b8dd0666e1c54372);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1jWct = parcelRequire("1jWct");

var $5yJb9 = parcelRequire("5yJb9");

var $koeKL = parcelRequire("koeKL");

var $5FoyW = parcelRequire("5FoyW");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $e9M6d = parcelRequire("e9M6d");

var $67mCE = parcelRequire("67mCE");

var $8mMQW = parcelRequire("8mMQW");

var $aG4Um = parcelRequire("aG4Um");

var $h8fZV = parcelRequire("h8fZV");

var $e1paH = parcelRequire("e1paH");
const $a9e40a9b60d0cdbc$export$cb618b52025e9ed0 = ({ connections: connections, isGroupingEnabled: isGroupingEnabled, groupedByFieldId: groupedByFieldId })=>{
    const expandedParents = [];
    const groups = [];
    let topLevelItemsLoaded = 0;
    Object.values(connections).forEach((connection)=>{
        if (connection.type === 'PARENT_CHILDREN') expandedParents.push({
            parentIssueId: connection.parentId,
            first: connection.first
        });
        else if (connection.type === 'GROUP_CHILDREN') groups.push({
            jql: connection.jql,
            fieldValue: connection.fieldValue,
            first: connection.first
        });
        else if (connection.type === 'ROOT_ISSUES') topLevelItemsLoaded = connection.first;
    });
    if (isGroupingEnabled && groupedByFieldId) return {
        expandedGroups: {
            groupedByFieldId: groupedByFieldId,
            groups: groups
        }
    };
    return {
        expandedParents: expandedParents,
        topLevelItemsLoaded: topLevelItemsLoaded
    };
};
const $a9e40a9b60d0cdbc$export$9688da58398f9e26 = ()=>{
    const environment = (0, $5yJb9.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { fieldSetIds: fieldSetIds } = (0, $67mCE.useIssueFetchQueryVariables)();
    const isDensityFull = (0, $e9M6d.useIsDensityFull)();
    const isInlineEditingEnabled = (0, $e9M6d.useIsInlineEditingEnabled)();
    const isHideDoneItemsEnabled = (0, $e9M6d.useIsHideDoneItemsEnabled)();
    const { connections: connections } = (0, $5FoyW.useConnectionsList)();
    const getGroupsForIssues = (0, $h8fZV.useGetGroupsForIssues)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const getRealtimeIssueDetails = (0, $aG4Um.useGetRealtimeIssueDetails)();
    const { updateIssuesOnConnection: updateIssuesOnConnection, groupsForIssueUpdater: groupsForIssueUpdater, updateNewParentsOnConnection: updateNewParentsOnConnection } = (0, $8mMQW.useIssueRealtimeUpdater)();
    return (0, $5uXOq.useCallback)(async ({ issues: issues, jql: jql, groupByFieldId: groupByFieldId, numGroupsLoaded: numGroupsLoaded, groupConnectionId: groupConnectionId, isHierarchyEnabled: isHierarchyEnabled, projectKey: projectKey, isStatusTrackingEnabled: isStatusTrackingEnabled })=>{
        const isGroupingEnabled = !!groupByFieldId;
        const searchViewContextInput = $a9e40a9b60d0cdbc$export$cb618b52025e9ed0({
            connections: connections,
            isGroupingEnabled: isGroupingEnabled,
            groupedByFieldId: groupByFieldId
        });
        const { issues: updatedIssues, searchViewContexts: searchViewContexts } = await getRealtimeIssueDetails({
            issues: issues,
            cloudId: cloudId,
            fieldSetIds: fieldSetIds,
            isInlineEditingEnabled: isInlineEditingEnabled,
            isDensityFull: isDensityFull,
            isHierarchyEnabled: isHierarchyEnabled,
            isGroupingEnabled: isGroupingEnabled,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            issueSearchInput: {
                jql: jql
            },
            searchViewContextInput: searchViewContextInput,
            projectKey: projectKey,
            isStatusTrackingEnabled: isStatusTrackingEnabled
        });
        let groupsToInsert;
        if (isGroupingEnabled && groupByFieldId) {
            const issueKeysWithContext = new Set(searchViewContexts?.flatMap((connection)=>{
                return connection.contexts?.map((context)=>context?.sourceIssueId);
            }).filter(Boolean));
            const issueChangesWithoutContext = updatedIssues?.reduce((acc, issue)=>{
                if (issue && !issueKeysWithContext.has(issue.issueId ?? '')) acc.push({
                    issueId: issue.issueId
                });
                return acc;
            }, []);
            groupsToInsert = await getGroupsForIssues({
                issueChanges: issueChangesWithoutContext,
                fieldId: groupByFieldId,
                numGroupsLoaded: numGroupsLoaded,
                issueSearchInput: {
                    jql: jql
                },
                staticViewInput: {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isGroupingEnabled: isGroupingEnabled,
                    isHideDoneEnabled: isHideDoneItemsEnabled
                }
            });
        }
        const eventDetails = {
            issuesUnmoved: new Set(),
            issuesUnrelated: new Set(),
            issuesUpdated: new Set()
        };
        const updatedIssuesMap = new Map(updatedIssues?.map(({ issueId: issueId, issueRecordId: issueRecordId, fieldSetsRecordId: fieldSetsRecordId })=>[
                issueId,
                {
                    issueId: issueId,
                    issueRecordId: issueRecordId,
                    fieldSetsRecordId: fieldSetsRecordId
                }
            ]));
        const updatedParents = new Set(updatedIssues.map((issue)=>issue.parentIssueRecordId).filter(Boolean));
        (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            Object.values(connections).forEach((connection)=>{
                updateNewParentsOnConnection({
                    store: store,
                    connection: connection,
                    updatedParents: updatedParents,
                    projectKey: projectKey
                });
                const matchingContext = searchViewContexts?.find((context)=>{
                    if (connection.type === 'PARENT_CHILDREN') return context?.parentIssueId === connection.parentId;
                    if (connection.type === 'GROUP_CHILDREN') return context?.jql === connection.jql;
                    return context?.jql == null && context?.parentIssueId == null;
                });
                const updatedDetails = updateIssuesOnConnection({
                    store: store,
                    connection: connection,
                    searchViewContexts: matchingContext?.contexts ?? [],
                    updatedIssues: updatedIssuesMap,
                    groupConnectionId: groupConnectionId,
                    projectKey: projectKey
                });
                updatedDetails.issuesMoved.forEach(eventDetails.issuesUpdated.add, eventDetails.issuesUpdated);
                updatedDetails.issuesUnmoved.forEach(eventDetails.issuesUnmoved.add, eventDetails.issuesUnmoved);
                updatedDetails.issuesUnrelated.forEach(eventDetails.issuesUnrelated.add, eventDetails.issuesUnrelated);
                updatedDetails.issuesRemoved.forEach(eventDetails.issuesUpdated.add, eventDetails.issuesUpdated);
            });
            if (groupsToInsert && groupsToInsert.length > 0) groupsForIssueUpdater({
                store: store,
                groupConnectionId: groupConnectionId,
                groupsForIssue: groupsToInsert
            });
        });
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventsIssueDetails Processed', {
            issuesInSamePosition: eventDetails.issuesUnmoved.size,
            issuesInNewPosition: eventDetails.issuesUpdated.size,
            issuesNotImpactingList: Array.from(eventDetails.issuesUnrelated).reduce((acc, issueId)=>eventDetails.issuesUpdated.has(issueId) || eventDetails.issuesUnmoved.has(issueId) ? acc : acc + 1, 0)
        });
    }, [
        connections,
        getRealtimeIssueDetails,
        cloudId,
        fieldSetIds,
        isInlineEditingEnabled,
        isDensityFull,
        isHideDoneItemsEnabled,
        environment,
        createAnalyticsEvent,
        getGroupsForIssues,
        updateNewParentsOnConnection,
        updateIssuesOnConnection,
        groupsForIssueUpdater
    ]);
};
const $a9e40a9b60d0cdbc$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID = 'native-issue-table.ui.realtime-updater.flag.info.native-issue-table.ui.realtime-update-exceeded-max-flag';
const $a9e40a9b60d0cdbc$export$b8dd0666e1c54372 = ()=>{
    const { showFlag: showFlag, hasFlag: hasFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const { connections: connections } = (0, $5FoyW.useConnectionsList)();
    const environment = (0, $5yJb9.default)();
    return (0, $5uXOq.useCallback)(({ onRefresh: onRefresh })=>{
        if (!hasFlag?.($a9e40a9b60d0cdbc$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID)) showFlag({
            type: 'info',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-information, #1D7AFC)"
            }),
            title: (0, $e1paH.default).realtimeUpdateExceededMaxHeader,
            description: (0, $e1paH.default).realtimeUpdateExceededMaxDescription,
            messageId: $a9e40a9b60d0cdbc$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID,
            id: $a9e40a9b60d0cdbc$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID,
            messageType: 'transactional',
            isAutoDismiss: true,
            actions: [
                {
                    content: (0, $e1paH.default).realtimeUpdateExceededMaxRefreshButton,
                    onClick: ()=>{
                        // This will reload all expanded parents/groups
                        environment.commitUpdate((store)=>{
                            Object.values(connections).forEach((connection)=>{
                                const connectionToInvalidate = store.get(connection.connectionId);
                                if (connectionToInvalidate) connectionToInvalidate.invalidateRecord();
                            });
                        });
                        dismissFlag($a9e40a9b60d0cdbc$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID);
                        onRefresh();
                    }
                }
            ]
        });
    }, [
        connections,
        dismissFlag,
        environment,
        hasFlag,
        showFlag
    ]);
};

});
parcelRegister("aG4Um", function(module, exports) {

$parcel$export(module.exports, "useGetRealtimeIssueDetails", () => $3558b3f380b9c411$export$d36444b54640c2df);

var $dPxfz = parcelRequire("dPxfz");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $5yJb9 = parcelRequire("5yJb9");

var $czfFt = parcelRequire("czfFt");
const $3558b3f380b9c411$export$d36444b54640c2df = ()=>{
    return (0, $5uXOq.useCallback)(async ({ issues: issues, cloudId: cloudId, fieldSetIds: fieldSetIds, isInlineEditingEnabled: isInlineEditingEnabled, isDensityFull: isDensityFull, isHierarchyEnabled: isHierarchyEnabled, isGroupingEnabled: isGroupingEnabled, isHideDoneItemsEnabled: isHideDoneItemsEnabled, issueSearchInput: issueSearchInput, searchViewContextInput: searchViewContextInput, projectKey: projectKey })=>{
        const environment = (0, $5yJb9.default)();
        try {
            // if the issue is in a loaded context, the issue is visible so we need to fetch the fields for display
            const result = await (0, $8Uumt.fetchQuery)(environment, (0, $dPxfz.default), {
                issueAris: issues.map((issue)=>issue.issueAri),
                cloudId: cloudId,
                fieldSetIds: fieldSetIds,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isDensityFull: isDensityFull,
                issueSearchInput: issueSearchInput,
                searchViewContextInput: searchViewContextInput,
                isHierarchyEnabled: isHierarchyEnabled ?? false,
                projectKey: projectKey,
                issueChanges: issues.map((issue)=>({
                        issueId: issue.issueId
                    })),
                staticViewInput: {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isGroupingEnabled: isGroupingEnabled,
                    isHideDoneEnabled: isHideDoneItemsEnabled
                }
            }, {
                fetchPolicy: 'network-only'
            }).toPromise();
            return {
                issues: result?.jira_issuesByIds?.filter(Boolean)?.map((issue)=>({
                        issueId: issue.issueId,
                        issueRecordId: issue.__id,
                        fieldSetsRecordId: issue.fieldSetsById?.__id,
                        parentIssueRecordId: issue.parentIssueField?.parentIssue?.__id
                    })) ?? [],
                searchViewContexts: result?.jira?.searchViewContexts?.edges?.map((edge)=>{
                    if (!edge?.node) return undefined;
                    return {
                        parentIssueId: edge.node.parentIssueId ?? undefined,
                        jql: edge.node.jql ?? undefined,
                        contexts: edge?.node?.contexts?.map((context)=>({
                                position: context.position,
                                sourceIssueId: context.sourceIssueId,
                                beforeIssueId: context.beforeIssueId,
                                afterIssueId: context.afterIssueId
                            })) ?? []
                    };
                }).filter(Boolean) ?? []
            };
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'realTimeFetchIssueFieldSetConnection',
                    packageName: (0, $czfFt.PACKAGE_NAME),
                    teamName: (0, $czfFt.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
            return Promise.resolve({
                issues: [],
                searchViewContexts: []
            });
        }
    }, []);
};

});
parcelRegister("dPxfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $83dc1334ab2a53f9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f49f73377f00aa0164d984eb6ad928cc>>
 * @relayHash 33c801201cc8886158cd3074dc17004b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 697844664319a45c41f739b71928b15fa89c4caf76b3846e80334084c9a13cab

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $iMyvd = parcelRequire("iMyvd");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $83dc1334ab2a53f9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHierarchyEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueAris"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueChanges"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchViewContextInput"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v11 = [
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "issueAris"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v13 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v14 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "id"
    }, v17 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v18 = {
        "args": [
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "canHaveChildIssues"
    }, v19 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueChanges",
            "variableName": "issueChanges"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "searchViewContextInput",
            "variableName": "searchViewContextInput"
        },
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "parentIssueId"
            }
        ],
        "type": "JiraIssueSearchBulkViewParentContexts"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jql"
            }
        ],
        "type": "JiraIssueSearchBulkViewGroupContexts"
    }, v22 = {
        "kind": "ScalarField",
        "name": "sourceIssueId"
    }, v23 = {
        "kind": "ScalarField",
        "name": "position"
    }, v24 = {
        "kind": "ScalarField",
        "name": "beforeIssueId"
    }, v25 = {
        "kind": "ScalarField",
        "name": "afterIssueId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "type"
    }, v27 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v28 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "name"
    }, v30 = {
        "kind": "ScalarField",
        "name": "value"
    }, v31 = [
        v30 /*: any*/ ,
        v16 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v32 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v33 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v34 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v35 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v36 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v37 = {
        "kind": "ScalarField",
        "name": "text"
    }, v38 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            v29 /*: any*/ ,
            v32 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v39 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v40 = [
        v39 /*: any*/ 
    ], v41 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v16 /*: any*/ 
        ]
    }, v42 = [
        v41 /*: any*/ 
    ], v43 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v44 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v45 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v46 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v47 = [
        v29 /*: any*/ ,
        v16 /*: any*/ 
    ], v48 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v49 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v50 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v49 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v51 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v52 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v53 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v54 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v53 /*: any*/ ,
                    v29 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            },
            v16 /*: any*/ 
        ]
    }, v55 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v56 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v50 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v57 = {
        "kind": "ScalarField",
        "name": "number"
    }, v58 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "realtimeIssueDetails_Query",
            "selections": [
                {
                    "args": v11 /*: any*/ ,
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "jira_issuesByIds",
                    "plural": true,
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "isDensityFull",
                                            "variableName": "isDensityFull"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isInlineEditingEnabled",
                                            "variableName": "isInlineEditingEnabled"
                                        }
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
                                },
                                v13 /*: any*/ 
                            ]
                        },
                        v15 /*: any*/ ,
                        {
                            "condition": "isHierarchyEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "progressSummary_issueViewChildIssuesPanel_statusAndResolved"
                        },
                        v13 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
                            "kind": "LinkedField",
                            "name": "searchViewContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchBulkViewContextMapping",
                                                    "kind": "LinkedField",
                                                    "name": "contexts",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v22 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.searchViewContexts.edges.node.contexts.sourceIssueId"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v23 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.searchViewContexts.edges.node.contexts.position"
                                                        },
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v10 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "realtimeIssueDetails_Query",
            "selections": [
                {
                    "args": v11 /*: any*/ ,
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "jira_issuesByIds",
                    "plural": true,
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v13 /*: any*/ 
                                    ]
                                },
                                v16 /*: any*/ 
                            ]
                        },
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v26 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldSetId"
                                                },
                                                {
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraIssueField"
                                                                        },
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "serviceId"
                                                                                                        },
                                                                                                        v29 /*: any*/ ,
                                                                                                        v16 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraAffectedServicesField"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraCascadingOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "cascadingOption",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentOptionValue",
                                                                                                    "plural": false,
                                                                                                    "selections": v31 /*: any*/ 
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "childOptionValue",
                                                                                                    "plural": false,
                                                                                                    "selections": v31 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v32 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraCascadingSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "args": v33 /*: any*/ ,
                                                                                            "concreteType": "JiraComponentConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedComponentsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponent",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v34 /*: any*/ ,
                                                                                                                v35 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                        },
                                                                                        v32 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraComponentsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v36 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v32 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDateTimePickerField"
                                                                                },
                                                                                v38 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCommentSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "commentSummary",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "canAddComment"
                                                                                                },
                                                                                                v39 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraCommentSummaryField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "uri"
                                                                                        },
                                                                                        v32 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraUrlField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOptionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldOptions",
                                                                                            "plural": false,
                                                                                            "selections": v40 /*: any*/ 
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldOption",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v30 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": v42 /*: any*/ 
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": v42 /*: any*/ 
                                                                                                },
                                                                                                v16 /*: any*/ ,
                                                                                                v43 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v32 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSingleSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOptionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedOptions",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v16 /*: any*/ ,
                                                                                                                v30 /*: any*/ ,
                                                                                                                v43 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v32 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOptionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedOptions",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v16 /*: any*/ ,
                                                                                                                v30 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v32 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraCheckboxesField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraUserConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedUsersConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v27 /*: any*/ ,
                                                                                                                v44 /*: any*/ ,
                                                                                                                v29 /*: any*/ ,
                                                                                                                v45 /*: any*/ ,
                                                                                                                v16 /*: any*/ ,
                                                                                                                v46 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "email"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v32 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraTeamView",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedTeam",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "jiraSuppliedId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "jiraSuppliedName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v32 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraTeamViewField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "timeTrackingField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        v32 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraEstimate",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "originalEstimate",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "timeInSeconds"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraTimeTrackingSettings",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "timeTrackingSettings",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "workingHoursPerDay"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "workingDaysPerWeek"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "defaultFormat"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "defaultUnit"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v28 /*: any*/ ,
                                                                                                        v29 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v16 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedOption",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": "label",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "value"
                                                                                                },
                                                                                                v16 /*: any*/ ,
                                                                                                v34 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v32 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraRadioSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "args": v33 /*: any*/ ,
                                                                                            "concreteType": "JiraVersionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedVersionsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v16 /*: any*/ ,
                                                                                                                v29 /*: any*/ ,
                                                                                                                v34 /*: any*/ ,
                                                                                                                v35 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "versionId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                        },
                                                                                        v32 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v16 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "args": v33 /*: any*/ ,
                                                                                            "concreteType": "JiraGoalConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedGoals",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoal",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v16 /*: any*/ ,
                                                                                                                v15 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v13 /*: any*/ 
                                                                                            ],
                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                        },
                                                                                        v32 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraGoalsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "args": v33 /*: any*/ ,
                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v16 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "href"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v39 /*: any*/ 
                                                                                            ],
                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                        },
                                                                                        v32 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "objectId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "label"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "mediaClientConfig",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "clientId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "fileId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "mediaJwtToken"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "url48"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "QueryError",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "errors",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "message"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraCMDBField"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": "componentsOld",
                                                                                            "concreteType": "JiraComponentConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedComponentsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponent",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": v47 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraComponentsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v37 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSingleLineTextField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "date"
                                                                                },
                                                                                v29 /*: any*/ ,
                                                                                v48 /*: any*/ ,
                                                                                v32 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraDatePickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v36 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraDateTimePickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraEpic",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "epic",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v15 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "summary"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "color"
                                                                                        },
                                                                                        v16 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraEpicLinkField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "renderedFieldHtml"
                                                                                }
                                                                            ],
                                                                            "type": "JiraFallbackField"
                                                                        },
                                                                        v38 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraStatusCategory",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "statusCategory",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        v49 /*: any*/ ,
                                                                                        v16 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraStatusCategoryField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraStatus",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "status",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "statusId"
                                                                                        },
                                                                                        v50 /*: any*/ ,
                                                                                        v16 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraStatusField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "args": v33 /*: any*/ ,
                                                                                    "concreteType": "JiraLabelConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedLabelsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraLabelEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraLabel",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v29 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v39 /*: any*/ 
                                                                                    ],
                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                },
                                                                                v29 /*: any*/ ,
                                                                                v32 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraLabelsField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAvatar",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "avatar",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "small"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v29 /*: any*/ ,
                                                                                        v16 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueTypeField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "parentIssue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v15 /*: any*/ ,
                                                                                        v51 /*: any*/ ,
                                                                                        v16 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "parentIssue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                v52 /*: any*/ ,
                                                                                                v54 /*: any*/ ,
                                                                                                v51 /*: any*/ ,
                                                                                                v16 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "parentIssue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                v52 /*: any*/ ,
                                                                                                v54 /*: any*/ ,
                                                                                                v51 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v12 /*: any*/ ,
                                                                                                v55 /*: any*/ ,
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "ids",
                                                                                                            "value": [
                                                                                                                "summary",
                                                                                                                "issuetype",
                                                                                                                "status"
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldsById",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        v16 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v37 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "issueTypeId"
                                                                                                                                        },
                                                                                                                                        v29 /*: any*/ ,
                                                                                                                                        v53 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                        v16 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v56 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraStatusField"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v29 /*: any*/ ,
                                                                                        v32 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraParentIssueField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraPriority",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "priority",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "iconUrl"
                                                                                        },
                                                                                        v16 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v29 /*: any*/ ,
                                                                                v32 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraPriorityField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraProject",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "project",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        v15 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraAvatar",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "avatar",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "large"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v16 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraProjectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraResolution",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "resolution",
                                                                                    "plural": false,
                                                                                    "selections": v47 /*: any*/ 
                                                                                }
                                                                            ],
                                                                            "type": "JiraResolutionField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprintConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedSprintsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraSprintEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprint",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "sprintId"
                                                                                                        },
                                                                                                        v29 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "state"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "endDate"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v29 /*: any*/ ,
                                                                                v32 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSprintField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        v45 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v16 /*: any*/ ,
                                                                                        v46 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v29 /*: any*/ ,
                                                                                v48 /*: any*/ ,
                                                                                v32 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v29 /*: any*/ ,
                                                                                {
                                                                                    "args": v33 /*: any*/ ,
                                                                                    "concreteType": "JiraVersionConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedVersionsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraVersionEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersion",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": v47 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                }
                                                                            ],
                                                                            "type": "JiraMultipleVersionPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraRichText",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "richText",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraADF",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "adfValue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "condition": "isDensityFull",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "convertedPlainText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "plainText"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "isDensityFull",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "json"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraRichTextField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "requestType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        v53 /*: any*/ ,
                                                                                        v16 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "first",
                                                                                            "value": 1
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueLinkConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v39 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v55 /*: any*/ ,
                                                                                                                v15 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "statusCategory"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v50 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                        },
                                                                                                                                        v16 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                },
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "relationName"
                                                                                                        },
                                                                                                        v16 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueLinkField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isStoryPointField"
                                                                                },
                                                                                v57 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        v57 /*: any*/ ,
                                                                                        v58 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        v57 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v32 /*: any*/ ,
                                                                                        v58 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v32 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNumberField"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraGroupConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedGroupsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroup",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v16 /*: any*/ ,
                                                                                                                v29 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "groupId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v32 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraFlag",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "flag",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFlagged"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraFlagField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraWatch",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "watch",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "count"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isWatching"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraWatchesField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": v40 /*: any*/ 
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v13 /*: any*/ 
                            ]
                        },
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "condition": "isHierarchyEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v16 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isResolved"
                                },
                                {
                                    "concreteType": "JiraStatusField",
                                    "kind": "LinkedField",
                                    "name": "statusField",
                                    "plural": false,
                                    "selections": [
                                        v56 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v13 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
                            "kind": "LinkedField",
                            "name": "searchViewContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchBulkViewContextMapping",
                                                    "kind": "LinkedField",
                                                    "name": "contexts",
                                                    "plural": true,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "697844664319a45c41f739b71928b15fa89c4caf76b3846e80334084c9a13cab",
            "metadata": {},
            "name": "realtimeIssueDetails_Query",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $iMyvd.default)
            }
        }
    };
}();
$83dc1334ab2a53f9$var$node.hash = "06ffec7b827cbc5cdf9caab380574530";
var $83dc1334ab2a53f9$export$2e2bcd8739ae039 = $83dc1334ab2a53f9$var$node;

});
parcelRegister("iMyvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd515d7ae24a1bd$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $ccd515d7ae24a1bd$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira-issue-view-child-issues-panel-realtime-update');
    }
};

});



parcelRegister("h8fZV", function(module, exports) {

$parcel$export(module.exports, "useGetGroupsForIssues", () => $b4dab12614af60ca$export$c756ae1e1c570081);

var $77Oek = parcelRequire("77Oek");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $5yJb9 = parcelRequire("5yJb9");

var $koeKL = parcelRequire("koeKL");

var $czfFt = parcelRequire("czfFt");
const $b4dab12614af60ca$export$c756ae1e1c570081 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    return (0, $5uXOq.useCallback)(async ({ issueChanges: issueChanges, staticViewInput: staticViewInput, fieldId: fieldId, issueSearchInput: issueSearchInput, numGroupsLoaded: numGroupsLoaded })=>{
        const environment = (0, $5yJb9.default)();
        try {
            const data = await (0, $8Uumt.fetchQuery)(environment, (0, $77Oek.default), {
                cloudId: cloudId,
                issueChanges: issueChanges,
                issueSearchInput: issueSearchInput,
                fieldId: fieldId,
                // Needs to be connection length + 1 to ensure a potentially new group at the end of the
                // currently loaded connection is included
                firstNGroupsToSearch: numGroupsLoaded + 1,
                staticViewInput: staticViewInput
            }, {
                fetchPolicy: 'network-only'
            }).toPromise();
            return data?.jira?.groupsForIssues?.edges?.map((edge)=>edge?.node ? {
                    __id: edge.node.__id,
                    id: edge.node.id,
                    afterGroupId: edge.node.afterGroupId
                } : undefined)?.filter(Boolean) ?? [];
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'realTimeFetchGroupsForIssue',
                    packageName: (0, $czfFt.PACKAGE_NAME),
                    teamName: (0, $czfFt.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
            return [];
        }
    }, [
        cloudId
    ]);
};

});
parcelRegister("77Oek", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f1bd8e697b8d552$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4da6146e31b63022d1da49b65c11c91d>>
 * @relayHash 49d20fd8302d0e487e0b2f5c1659590f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ddb6d5262d3e2f61e59e1430cf5d5339f71b13a9f7bc37762734b305c98b7cae
const $9f1bd8e697b8d552$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "firstNGroupsToSearch"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueChanges"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldId",
            "variableName": "fieldId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Variable",
            "name": "firstNGroupsToSearch",
            "variableName": "firstNGroupsToSearch"
        },
        {
            "kind": "Variable",
            "name": "issueChanges",
            "variableName": "issueChanges"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "afterGroupId"
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "groupsForIssues_realtimeUpdater_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetGroupConnection",
                            "kind": "LinkedField",
                            "name": "groupsForIssues",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroup",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "groupRow_issueTableGrouping_groupRow"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "groupsForIssues_realtimeUpdater_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetGroupConnection",
                            "kind": "LinkedField",
                            "name": "groupsForIssues",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroup",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldType"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fieldValue",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "priorityId"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountId"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraStatusCategory",
                                                                    "kind": "LinkedField",
                                                                    "name": "statusCategory",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "number"
                                                                }
                                                            ],
                                                            "type": "JiraJqlNumberFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "option",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "optionId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraColor",
                                                                            "kind": "LinkedField",
                                                                            "name": "color",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "colorKey"
                                                                                },
                                                                                v7 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlOptionFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "sprintId"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "endDate"
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGoal",
                                                                    "kind": "LinkedField",
                                                                    "name": "goal",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "score"
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlGoalsFieldValue"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueCount"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ddb6d5262d3e2f61e59e1430cf5d5339f71b13a9f7bc37762734b305c98b7cae",
            "metadata": {},
            "name": "groupsForIssues_realtimeUpdater_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9f1bd8e697b8d552$var$node.hash = "5b12b016130b4ac371febb9a4397fc68";
var $9f1bd8e697b8d552$export$2e2bcd8739ae039 = $9f1bd8e697b8d552$var$node;

});


parcelRegister("e1paH", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd02076cfcc424f5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fd02076cfcc424f5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    realtimeUpdateExceededMaxHeader: {
        "id": "native-issue-table.ui.realtime-updater.realtime-update-exceeded-max-header",
        "defaultMessage": "Updating those work items"
    },
    realtimeUpdateExceededMaxDescription: {
        "id": "native-issue-table.ui.realtime-updater.realtime-update-exceeded-max-description",
        "defaultMessage": "Refresh the page to see the updates"
    },
    realtimeUpdateExceededMaxRefreshButton: {
        "id": "native-issue-table.ui.realtime-updater.realtime-update-exceeded-max-refresh-button",
        "defaultMessage": "Refresh"
    }
});

});



parcelRegister("9zTUm", function(module, exports) {

$parcel$export(module.exports, "ScrollContainer", () => $16f685fb2b5342f3$export$2631a3ab3cdd158d);

var $5uXOq = parcelRequire("5uXOq");

var $3KYe6 = parcelRequire("3KYe6");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7mPT9 = parcelRequire("7mPT9");

var $1XJ20 = parcelRequire("1XJ20");

var $czfFt = parcelRequire("czfFt");

var $e9M6d = parcelRequire("e9M6d");

var $i9xcC = parcelRequire("i9xcC");

var $9CFBJ = parcelRequire("9CFBJ");

var $dSLRZ = parcelRequire("dSLRZ");

var $0147U = parcelRequire("0147U");

var $5S38a = parcelRequire("5S38a");
const $16f685fb2b5342f3$export$afb5fd3c74e214f9 = ({ loading: loading, resetScroll: resetScroll })=>{
    const prevLoading = (0, $1XJ20.usePrevious)(loading);
    // Reseting the scroll when the connection id change will cover any variable change
    (0, $5uXOq.useEffect)(()=>{
        if (prevLoading !== loading && prevLoading === true) resetScroll();
    });
};
const $16f685fb2b5342f3$export$2631a3ab3cdd158d = ({ children: children, footer: footer, loading: loading, isGrouping: isGrouping, ...infiniteScrollProps })=>{
    const scrollContainerRef = (0, $5uXOq.useRef)(null);
    const siblingIssueCreateOnScroll = (0, $dSLRZ.useSiblingIssueCreateOnScroll)();
    const isInfiniteScrollEnabled = (0, $e9M6d.useIsInfiniteScrollEnabled)();
    const resetScroll = (0, $5uXOq.useCallback)(()=>{
        if (scrollContainerRef.current != null && isInfiniteScrollEnabled) scrollContainerRef.current.scrollTop = 0;
    }, [
        isInfiniteScrollEnabled
    ]);
    $16f685fb2b5342f3$export$afb5fd3c74e214f9({
        loading: loading,
        resetScroll: resetScroll
    });
    const { onLoadingThresholdCheck: onLoadingThresholdCheck, onScroll: infiniteScrollOnScroll } = (0, $i9xcC.useInfiniteScrollHandler)(infiniteScrollProps);
    const onScroll = (0, $5uXOq.useCallback)((event)=>{
        siblingIssueCreateOnScroll?.(event);
        if (isInfiniteScrollEnabled) infiniteScrollOnScroll(event);
    }, [
        siblingIssueCreateOnScroll,
        isInfiniteScrollEnabled,
        infiniteScrollOnScroll
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Handle auto-scrolling for pragmatic dnd operations like column resizing
        const scrollableElement = scrollContainerRef.current;
        if (scrollableElement) return (0, $3KYe6.autoScrollForElements)({
            element: scrollableElement,
            canScroll: ({ source: source })=>source.data.operation !== (0, $czfFt.COLUMN_OPERATION_RESIZE)
        });
    }, []);
    const intersectionObsRef = (0, $0147U.useIntersectionObserver)();
    const ref = (0, $7mPT9.default)(intersectionObsRef, scrollContainerRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CFBJ.ScrollStateProvider), {
        scrollRef: scrollContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $16f685fb2b5342f3$var$loadingIndicatorContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $16f685fb2b5342f3$var$scrollContainerStyles,
        ref: ref,
        onScroll: onScroll,
        testId: "native-issue-table.ui.scroll-container.scroll-container"
    }, children), isInfiniteScrollEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5S38a.LoadingManager), {
        isLoadingPrevious: infiniteScrollProps.isLoadingPrevious,
        isLoadingNext: infiniteScrollProps.isLoadingNext,
        onLoadingThresholdCheck: onLoadingThresholdCheck,
        isGrouping: isGrouping
    })), footer);
};
const $16f685fb2b5342f3$var$HEADER_HEIGHT = 40;
const $16f685fb2b5342f3$var$scrollContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    position: 'relative',
    flexFlow: 'column nowrap',
    overflow: 'auto',
    // Since header is sticky, we need to specify a scroll padding that matches its height so that auto-scrolling
    // functionality accounts for this element in its calculations, otherwise header can overlap the selected row.
    scrollPaddingTop: `${$16f685fb2b5342f3$var$HEADER_HEIGHT}px`
});
const $16f685fb2b5342f3$var$loadingIndicatorContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexFlow: 'column nowrap',
    position: 'relative',
    overflow: 'hidden'
});

});
parcelRegister("3KYe6", function(module, exports) {

$parcel$export(module.exports, "autoScrollForElements", () => $5ea44a3a02963798$export$4b66ee8317094cdb);

var $7gWdR = parcelRequire("7gWdR");

var $1XBB4 = parcelRequire("1XBB4");
const $5ea44a3a02963798$var$api = (0, $1XBB4.makeApi)({
    monitor: (0, $7gWdR.monitorForElements)
});
const $5ea44a3a02963798$export$4b66ee8317094cdb = $5ea44a3a02963798$var$api.autoScroll;
const $5ea44a3a02963798$export$c9168f41de61f525 = $5ea44a3a02963798$var$api.autoScrollWindow;

});
parcelRegister("1XBB4", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $7c9f5b9e5aad06df$export$b8fa21320a811083);

var $4hDdm = parcelRequire("4hDdm");
parcelRequire("5p5cl");
var $jjNE9 = parcelRequire("jjNE9");

var $4HETl = parcelRequire("4HETl");

var $5DMYW = parcelRequire("5DMYW");

var $dN2fr = parcelRequire("dN2fr");
function $7c9f5b9e5aad06df$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $4hDdm.combine)((0, $5DMYW.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $jjNE9.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $jjNE9.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $dN2fr.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $4HETl.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("5p5cl", function(module, exports) {

$parcel$export(module.exports, "once", () => (parcelRequire("jjNE9")).once);

var $jjNE9 = parcelRequire("jjNE9");

});

parcelRegister("4HETl", function(module, exports) {

$parcel$export(module.exports, "getScheduler", () => $76249ae4e9f30f38$export$5cff7ac265db316a);
parcelRequire("i6e0j");
var $kKgsQ = parcelRequire("kKgsQ");

var $3d4ga = parcelRequire("3d4ga");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $76249ae4e9f30f38$var$schedulers = new Map();
function $76249ae4e9f30f38$export$5cff7ac265db316a(monitor) {
    const scheduler = $76249ae4e9f30f38$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $76249ae4e9f30f38$var$makeScheduler(monitor);
    $76249ae4e9f30f38$var$schedulers.set(monitor, created);
    return created;
}
function $76249ae4e9f30f38$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $3d4ga.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $3d4ga.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("i6e0j", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("kKgsQ")).getElementFromPointWithoutHoneypot);

var $kKgsQ = parcelRequire("kKgsQ");

});

parcelRegister("3d4ga", function(module, exports) {

$parcel$export(module.exports, "markAndGetEngagement", () => $cdcee60ad04716da$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $cdcee60ad04716da$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $cdcee60ad04716da$export$13ae770ed39b71ea);
const $cdcee60ad04716da$var$ledger = new Map();
const $cdcee60ad04716da$var$requested = new Set();
function $cdcee60ad04716da$export$8c764c3f2fc3d2d2(element) {
    $cdcee60ad04716da$export$1cb7cbb266b6f6fa(element);
    const entry = $cdcee60ad04716da$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $cdcee60ad04716da$var$ledger.set(element, fresh);
    return fresh;
}
function $cdcee60ad04716da$export$1cb7cbb266b6f6fa(element) {
    $cdcee60ad04716da$var$requested.add(element);
}
function $cdcee60ad04716da$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $cdcee60ad04716da$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $cdcee60ad04716da$var$ledger.forEach((_, element)=>{
        if (!$cdcee60ad04716da$var$requested.has(element)) $cdcee60ad04716da$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $cdcee60ad04716da$var$requested.clear();
}
function $cdcee60ad04716da$export$13ae770ed39b71ea() {
    $cdcee60ad04716da$var$ledger.clear();
}

});


parcelRegister("5DMYW", function(module, exports) {

$parcel$export(module.exports, "selector", () => $05e8460564c70d18$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $05e8460564c70d18$export$4ec12fb57dfebd53);
const $05e8460564c70d18$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $05e8460564c70d18$export$aea217a45095ce11 = `[${$05e8460564c70d18$export$4b152ab55cad4fd6}="true"]`;
function $05e8460564c70d18$export$4ec12fb57dfebd53(element) {
    element.setAttribute($05e8460564c70d18$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($05e8460564c70d18$export$4b152ab55cad4fd6);
}

});

parcelRegister("dN2fr", function(module, exports) {

$parcel$export(module.exports, "tryScroll", () => $95daf559d8aa786a$export$233199807749476d);

var $kjAuM = parcelRequire("kjAuM");

var $3d4ga = parcelRequire("3d4ga");

var $5DMYW = parcelRequire("5DMYW");

var $i4SSA = parcelRequire("i4SSA");
function $95daf559d8aa786a$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $95daf559d8aa786a$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$95daf559d8aa786a$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $5DMYW.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $95daf559d8aa786a$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $3d4ga.markAndGetEngagement)(element);
    const config = (0, $kjAuM.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $i4SSA.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $95daf559d8aa786a$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $3d4ga.markAndGetEngagement)(element);
        const config = (0, $kjAuM.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $i4SSA.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $95daf559d8aa786a$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $95daf559d8aa786a$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$95daf559d8aa786a$var$isScrollingAvailable(remainder)) return;
    $95daf559d8aa786a$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("kjAuM", function(module, exports) {

$parcel$export(module.exports, "getInternalConfig", () => $8aedd24a4f7bb643$export$e96028ec7ff9d079);
const $8aedd24a4f7bb643$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $8aedd24a4f7bb643$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $8aedd24a4f7bb643$export$e96028ec7ff9d079(provided) {
    return {
        ...$8aedd24a4f7bb643$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $8aedd24a4f7bb643$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("i4SSA", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $f221acff344cd122$export$6cfa6dfe6898b98f);

var $iduok = parcelRequire("iduok");

var $ffSUw = parcelRequire("ffSUw");

var $c3M8M = parcelRequire("c3M8M");

var $gfxd2 = parcelRequire("gfxd2");

var $hTDOm = parcelRequire("hTDOm");

var $2dwAb = parcelRequire("2dwAb");
function $f221acff344cd122$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $f221acff344cd122$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $f221acff344cd122$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $ffSUw.edges).reduce((map, edge)=>{
        const hitbox = (0, $c3M8M.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $ffSUw.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $hTDOm.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $2dwAb.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $iduok.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("iduok", function(module, exports) {

$parcel$export(module.exports, "canScrollOnEdge", () => $dc24cd2fd79e74bd$export$ccd6d9407403fcad);
const $dc24cd2fd79e74bd$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("ffSUw", function(module, exports) {

$parcel$export(module.exports, "edges", () => $77e5ecf85ecb98dd$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $77e5ecf85ecb98dd$export$7fc144124ccf8292);
const $77e5ecf85ecb98dd$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $77e5ecf85ecb98dd$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("c3M8M", function(module, exports) {

$parcel$export(module.exports, "getOverElementHitbox", () => $4e0c1489e6f6f1ed$export$b9a449c20abb0e9);

var $9w8nT = parcelRequire("9w8nT");

var $aHtK2 = parcelRequire("aHtK2");
function $4e0c1489e6f6f1ed$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $9w8nT.axisLookup)[axis];
        const side = (0, $aHtK2.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $4e0c1489e6f6f1ed$export$b9a449c20abb0e9 = {
    top: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("9w8nT", function(module, exports) {

$parcel$export(module.exports, "axisLookup", () => $4007ed2af13415f1$export$42e42cdab35a2b96);
const $4007ed2af13415f1$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $4007ed2af13415f1$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $4007ed2af13415f1$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $4007ed2af13415f1$var$vertical,
        crossAxis: $4007ed2af13415f1$var$horizontal
    },
    horizontal: {
        mainAxis: $4007ed2af13415f1$var$horizontal,
        crossAxis: $4007ed2af13415f1$var$vertical
    }
};

});

parcelRegister("aHtK2", function(module, exports) {

$parcel$export(module.exports, "mainAxisSideLookup", () => $4b97aced6f7f08e4$export$a45c0cd714a4dbaa);
const $4b97aced6f7f08e4$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("gfxd2", function(module, exports) {

$parcel$export(module.exports, "getScrollChange", () => $b3ae2158089b2ceb$export$470a2ff46db8cee8);

var $9w8nT = parcelRequire("9w8nT");

var $lUX3m = parcelRequire("lUX3m");

var $aHtK2 = parcelRequire("aHtK2");
// We want a consistent scroll speed across devices, regardless of framerate
function $b3ae2158089b2ceb$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $b3ae2158089b2ceb$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $9w8nT.axisLookup)[axis];
    const side = (0, $aHtK2.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $lUX3m.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $lUX3m.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $b3ae2158089b2ceb$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $b3ae2158089b2ceb$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $b3ae2158089b2ceb$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $lUX3m.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $aHtK2.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("lUX3m", function(module, exports) {

$parcel$export(module.exports, "getPercentageInRange", () => $15bc8d2c21c8e1e4$export$1a29de000a332d74);
function $15bc8d2c21c8e1e4$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("hTDOm", function(module, exports) {

$parcel$export(module.exports, "isAxisAllowed", () => $9d9969f3e7f53880$export$7120fdbd90bd1292);
function $9d9969f3e7f53880$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("2dwAb", function(module, exports) {

$parcel$export(module.exports, "isWithin", () => $df40d0415a8c41aa$export$cda7a9d4399bf2e3);
function $df40d0415a8c41aa$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});





parcelRegister("i9xcC", function(module, exports) {

$parcel$export(module.exports, "useInfiniteScrollHandler", () => $b2b86989bea72b31$export$ee8d81e7d8c9f22d);

var $5uXOq = parcelRequire("5uXOq");

var $czfFt = parcelRequire("czfFt");

var $dbaUr = parcelRequire("dbaUr");
const $b2b86989bea72b31$var$DEFAULT_ACTIVATION_THRESHOLD = 10 * (0, $czfFt.ROW_HEIGHT);
const $b2b86989bea72b31$export$ee8d81e7d8c9f22d = ({ onLoadNext: onLoadNextProp, onLoadPrevious: onLoadPreviousProp, ...dataProps })=>{
    // Keep props as ref so the callback is stable across rerenders.
    const dataPropsRef = (0, $5uXOq.useRef)(dataProps);
    dataPropsRef.current = dataProps;
    const onLoadNext = (0, $dbaUr.useThrottle)(onLoadNextProp);
    const onLoadPrevious = (0, $dbaUr.useThrottle)(onLoadPreviousProp);
    const onLoadingThresholdCheck = (0, $5uXOq.useCallback)(({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop })=>{
        const { isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, activationThreshold: activationThreshold = $b2b86989bea72b31$var$DEFAULT_ACTIVATION_THRESHOLD } = dataPropsRef.current;
        const scrollBottom = scrollHeight - clientHeight - scrollTop;
        const isLoading = isLoadingNext || isLoadingPrevious;
        // Prioritising loading next over loading previous to fill results downwards first,
        // to hopefully feel more natural.
        if (hasNext && !isLoading && scrollBottom <= activationThreshold) onLoadNext?.();
        else if (hasPrevious && !isLoading && scrollTop <= activationThreshold) onLoadPrevious?.();
    }, // Ensure that the callback is not recreated when props change.
    // onLoadNext & onLoadPrevious should be throttled & stable.
    [
        onLoadNext,
        onLoadPrevious
    ]);
    const onScroll = (0, $5uXOq.useCallback)((event)=>{
        onLoadingThresholdCheck(event.currentTarget);
    }, // Ensure that the callback is not recreated when props change.
    // onLoadingThresholdCheck should be stable.
    [
        onLoadingThresholdCheck
    ]);
    return {
        onLoadingThresholdCheck: onLoadingThresholdCheck,
        onScroll: onScroll
    };
};

});
parcelRegister("dbaUr", function(module, exports) {

$parcel$export(module.exports, "useThrottle", () => $9793367875371ab2$export$8b7b9481d6186f21);

var $5uXOq = parcelRequire("5uXOq");
const $9793367875371ab2$export$8b7b9481d6186f21 = (fn, wait = 100)=>{
    const fnRef = (0, $5uXOq.useRef)(fn);
    fnRef.current = fn;
    const waitRef = (0, $5uXOq.useRef)(wait);
    waitRef.current = wait;
    const timeout = (0, $5uXOq.useRef)(undefined);
    const throttled = (0, $5uXOq.useCallback)(()=>{
        if (timeout.current !== undefined) return;
        fnRef.current?.();
        timeout.current = setTimeout(()=>{
            timeout.current = undefined;
        }, waitRef.current);
    // Ensure the callback is not recreated when props change,
    // dependency array should be empty.
    }, []);
    // Cleanup the timeout on unmount.
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (timeout.current !== undefined) clearTimeout(timeout.current);
        };
    }, []);
    return throttled;
};

});


parcelRegister("5S38a", function(module, exports) {

$parcel$export(module.exports, "LoadingManager", () => $95a30e151ecde18a$export$99cc795e99919eed);

var $5uXOq = parcelRequire("5uXOq");

var $dqoiX = parcelRequire("dqoiX");

var $koVbs = parcelRequire("koVbs");

var $1XJ20 = parcelRequire("1XJ20");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $kYFm9 = parcelRequire("kYFm9");

var $9CFBJ = parcelRequire("9CFBJ");

var $1UnsW = parcelRequire("1UnsW");

var $4OJRB = parcelRequire("4OJRB");
const $95a30e151ecde18a$var$getLoadingA11YMessage = ({ isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasFinishedLoadingNext: hasFinishedLoadingNext, hasFinishedLoadingPrevious: hasFinishedLoadingPrevious, isGrouping: isGrouping })=>{
    if (isGrouping) {
        if (isLoadingPrevious) return (0, $4OJRB.default).loadStartA11YMessageTopWithGrouping;
        if (hasFinishedLoadingPrevious) return (0, $4OJRB.default).loadEndA11YMessageTopWithGrouping;
        if (isLoadingNext) return (0, $4OJRB.default).loadStartA11YMessageBottomWithGrouping;
        if (hasFinishedLoadingNext) return (0, $4OJRB.default).loadEndA11YMessageBottomWithGrouping;
    }
    if (isLoadingPrevious) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4OJRB.default).loadStartA11YMessageTopIssueTermRefresh : (0, $4OJRB.default).loadStartA11YMessageTop;
    if (hasFinishedLoadingPrevious) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4OJRB.default).loadEndA11YMessageTopIssueTermRefresh : (0, $4OJRB.default).loadEndA11YMessageTop;
    if (isLoadingNext) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4OJRB.default).loadStartA11YMessageBottomIssueTermRefresh : (0, $4OJRB.default).loadStartA11YMessageBottom;
    if (hasFinishedLoadingNext) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4OJRB.default).loadEndA11YMessageBottomIssueTermRefresh : (0, $4OJRB.default).loadEndA11YMessageBottom;
    return undefined;
};
const $95a30e151ecde18a$export$99cc795e99919eed = ({ isLoadingPrevious: isLoadingPrevious, isLoadingNext: isLoadingNext, isGrouping: isGrouping, onLoadingThresholdCheck: onLoadingThresholdCheck })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Table has height 0 during first render due to virtualization. Some checks need to wait for the table to have a height.
    const hasTableHeight = (0, $kYFm9.useElementSizeSelector)((tableState)=>Boolean(tableState.height));
    const scrollElement = (0, $9CFBJ.useScrollElement)();
    const height = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>scrollState.height);
    // #region After-load Handler
    /**
   * After initial render and any subsequent loading events, make sure that we continue loading in more issues if
   * necessary because a single load may not have enough issues to fill the scroll container.
   */ (0, $5uXOq.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasTableHeight && !isLoadingPrevious && !isLoadingNext && !(0, $4R6GH.fg)('refactor_nin_to_jira_view_schema')) onLoadingThresholdCheck(scrollElement);
    }, [
        hasTableHeight,
        isLoadingPrevious,
        isLoadingNext,
        onLoadingThresholdCheck,
        scrollElement
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasTableHeight && !isLoadingPrevious && !isLoadingNext && height && (0, $4R6GH.fg)('refactor_nin_to_jira_view_schema')) onLoadingThresholdCheck(scrollElement);
    }, [
        hasTableHeight,
        isLoadingPrevious,
        isLoadingNext,
        onLoadingThresholdCheck,
        scrollElement,
        height
    ]);
    // #endregion
    // #endregion
    // #region Resize Handler
    /**
   * Check the loading boundaries when resizing the scroll container, as the new size may require loading more issues.
   */ const prevHeight = (0, $1XJ20.usePreviousWithInitial)(height);
    (0, $5uXOq.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasTableHeight && height > prevHeight && !(0, $4R6GH.fg)('refactor_nin_to_jira_view_schema')) onLoadingThresholdCheck(scrollElement);
    }, [
        hasTableHeight,
        height,
        prevHeight,
        onLoadingThresholdCheck,
        scrollElement
    ]);
    // #region Top Scroll Handler
    /**
   * A component that ensures that the scroll position is kept stable when loading previous issues.
   * This is necessary because sometimes the browser does scroll to keep existing rows in view when new rows are prepended.
   *
   * Without this, we may see issues like continuously loading all previous issues until there are none left.
   */ const prevIsLoadingPrevious = (0, $1XJ20.usePreviousWithInitial)(isLoadingPrevious);
    const hasStartedLoadingPrevious = !prevIsLoadingPrevious && isLoadingPrevious;
    const hasFinishedLoadingPrevious = prevIsLoadingPrevious && !isLoadingPrevious;
    // Hook's scrollHeight doesn't update the height information when the scroll height changes due to DOM mutations
    // Need to track this separately when loading starts
    const scrollHeightRef = (0, $5uXOq.useRef)(0);
    (0, $5uXOq.useEffect)(()=>{
        if (scrollElement && hasStartedLoadingPrevious) scrollHeightRef.current = scrollElement.scrollHeight;
    }, [
        hasStartedLoadingPrevious,
        scrollElement
    ]);
    // Ensure that the scroll is kept in place after loading previous issues - browser doesn't always handle this properly
    // Using a layout effect to make sure this happens as quickly as possible to reduce visible movement
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (scrollElement && hasFinishedLoadingPrevious) {
            const newScrollHeight = scrollElement.scrollHeight;
            if (newScrollHeight > scrollHeightRef.current) {
                const heightIncrease = newScrollHeight - scrollHeightRef.current;
                scrollElement.scrollBy(0, heightIncrease);
            }
            scrollHeightRef.current = newScrollHeight;
        }
    }, [
        hasFinishedLoadingPrevious,
        scrollElement
    ]);
    // #endregion
    // #region Loading A11y
    const prevIsLoadingNext = (0, $1XJ20.usePreviousWithInitial)(isLoadingNext);
    const hasFinishedLoadingNext = prevIsLoadingNext && !isLoadingNext;
    const loadingCompleteLiveMessage = (0, $5uXOq.useRef)(undefined);
    loadingCompleteLiveMessage.current = $95a30e151ecde18a$var$getLoadingA11YMessage({
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        hasFinishedLoadingNext: hasFinishedLoadingNext,
        hasFinishedLoadingPrevious: hasFinishedLoadingPrevious,
        isGrouping: isGrouping
    });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isLoadingPrevious && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1UnsW.LoadingIndicator), {
        position: "top",
        isGrouping: isGrouping
    }), isLoadingNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1UnsW.LoadingIndicator), {
        position: "bottom",
        isGrouping: isGrouping
    }), loadingCompleteLiveMessage.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        role: "alert",
        "aria-live": "polite"
    }, formatMessage(loadingCompleteLiveMessage.current)));
};

});
parcelRegister("1UnsW", function(module, exports) {

$parcel$export(module.exports, "LoadingIndicator", () => $cd221068d9a06edf$export$7c20be4c1d342248);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $bpM2N = parcelRequire("bpM2N");
const $cd221068d9a06edf$export$7c20be4c1d342248 = ({ position: position, isGrouping: isGrouping })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getLoadingMessage = ()=>{
        if (isGrouping) return (0, $bpM2N.default).loadingMessageWithGrouping;
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bpM2N.default).loadingMessageIssueTermRefresh : (0, $bpM2N.default).loadingMessage;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "center",
        xcss: [
            $cd221068d9a06edf$var$containerStyles,
            position === 'top' ? $cd221068d9a06edf$var$positionTopStyles : $cd221068d9a06edf$var$positionBottomStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        grow: "hug",
        xcss: $cd221068d9a06edf$var$loadingIndicatorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        appearance: "invert",
        size: "small",
        interactionName: (0, $4R6GH.fg)('add_nin_press_interactions') ? 'issue-table-infinite-scroll-loading' : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.inverse"
    }, formatMessage(getLoadingMessage()))));
};
// Account for the sticky header row height
const $cd221068d9a06edf$var$HEADER_HEIGHT = 40;
const $cd221068d9a06edf$var$positionTopStyles = (0, $8CUq3.xcss)({
    top: `${$cd221068d9a06edf$var$HEADER_HEIGHT}px`
});
const $cd221068d9a06edf$var$positionBottomStyles = (0, $8CUq3.xcss)({
    bottom: 'space.0'
});
const $cd221068d9a06edf$var$loadingIndicatorStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay',
    color: 'color.text.inverse',
    marginBlock: 'space.200',
    padding: 'space.100'
});
const $cd221068d9a06edf$var$containerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    width: '100%'
});

});
parcelRegister("bpM2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $6adefd2e0101af96$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6adefd2e0101af96$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadingMessage: {
        "id": "native-issue-table.scroll-container.loading-manager.loading-indicator.loading-message",
        "defaultMessage": "Loading more issues"
    },
    loadingMessageIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.loading-indicator.loading-message-issue-term-refresh",
        "defaultMessage": "Loading more"
    },
    loadingMessageWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.loading-indicator.loading-message-with-grouping",
        "defaultMessage": "Loading more groups"
    }
});

});


parcelRegister("4OJRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $22f149d993dfac16$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $22f149d993dfac16$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadStartA11YMessageTop: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-top",
        "defaultMessage": "Loading more issues at the top of the table."
    },
    loadEndA11YMessageTop: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-top",
        "defaultMessage": "Finished loading more issues at the top of the table."
    },
    loadStartA11YMessageBottom: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-bottom",
        "defaultMessage": "Loading more issues at the bottom of the table."
    },
    loadEndA11YMessageBottom: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-bottom",
        "defaultMessage": "Finished loading more issues at the bottom of the table."
    },
    loadStartA11YMessageTopIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Loading more work items at the top of the table."
    },
    loadEndA11YMessageTopIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the top of the table."
    },
    loadStartA11YMessageBottomIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Loading more work items at the bottom of the table."
    },
    loadEndA11YMessageBottomIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the bottom of the table."
    },
    loadStartA11YMessageTopWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-top-with-grouping",
        "defaultMessage": "Loading more groups at the top of the table."
    },
    loadEndA11YMessageTopWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-top-with-grouping",
        "defaultMessage": "Finished loading more groups at the top of the table."
    },
    loadStartA11YMessageBottomWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-bottom-with-grouping",
        "defaultMessage": "Loading more groups at the bottom of the table."
    },
    loadEndA11YMessageBottomWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-bottom-with-grouping",
        "defaultMessage": "Finished loading more groups at the bottom of the table."
    }
});

});



parcelRegister("dFuGx", function(module, exports) {

$parcel$export(module.exports, "IssueTableSelectedIssuesProvider", () => $4ffbb6165359c10b$export$8560e956e1937d5);

var $5uXOq = parcelRequire("5uXOq");

var $48rMm = parcelRequire("48rMm");
const $4ffbb6165359c10b$export$8560e956e1937d5 = (Component)=>{
    const SelectedIssuesWrapperComponent = (props)=>{
        if (props.enableMultiSelect) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $48rMm.IssueTableSelectedIssuesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
    };
    return SelectedIssuesWrapperComponent;
};

});

parcelRegister("1MqPV", function(module, exports) {

$parcel$export(module.exports, "CopyPasteContainer", () => $c4eda7eadc00ecf0$export$f22393f54af5c587);

var $5uXOq = parcelRequire("5uXOq");

var $6MvyO = parcelRequire("6MvyO");

var $cSD7y = parcelRequire("cSD7y");

var $e9M6d = parcelRequire("e9M6d");
const $c4eda7eadc00ecf0$var$CopyPasteContainerInternal = ({ children: children })=>{
    const isInlineEditingEnabled = (0, $e9M6d.useIsInlineEditingEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $e9M6d.useIsInlineEditingExtendedFieldSupportEnabled)();
    return isInlineEditingEnabled && isInlineEditingExtendedFieldSupportEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6MvyO.CopyPasteContextProvider), null, children) : children;
};
const $c4eda7eadc00ecf0$export$f22393f54af5c587 = (0, $cSD7y.componentWithFG)('jsc_inline_editing_field_refactor', $c4eda7eadc00ecf0$var$CopyPasteContainerInternal, ({ children: children })=>children);

});

parcelRegister("lIAUI", function(module, exports) {

$parcel$export(module.exports, "ConnectionsSubscriberContainer", () => $76aecf221adc1d1a$export$dca2df00a75a6b37);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $5FoyW = parcelRequire("5FoyW");

var $4R6GH = parcelRequire("4R6GH");

var $MMunf = parcelRequire("MMunf");
const $76aecf221adc1d1a$export$dca2df00a75a6b37 = ({ ConnectionsSubscriber: ConnectionsSubscriber })=>{
    const { connections: connections } = (0, $4R6GH.fg)('decouple_connection_register_hooks_from_realtime') ? (0, $5FoyW.useConnectionsList)() : {
        connections: {}
    };
    const updateConnectionDetails = (0, $4R6GH.fg)('decouple_connection_register_hooks_from_realtime') ? (0, $MMunf.useUpdateConnectionDetails)() : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConnectionsSubscriber, {
        connections: connections,
        updateConnectionDetails: updateConnectionDetails
    });
};

});

parcelRegister("7BEpL", function(module, exports) {

$parcel$export(module.exports, "RootConnectionRegister", () => $d5b4838ae36085f2$export$f2eeecab3dd535b2);

var $k9lLz = parcelRequire("k9lLz");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5FoyW = parcelRequire("5FoyW");
const $d5b4838ae36085f2$export$f2eeecab3dd535b2 = ({ issues: issues })=>{
    const issueConnection = (0, $8Uumt.useFragment)((0, $k9lLz.default), issues ?? null);
    const rootConnectionDetails = (0, $5uXOq.useMemo)(()=>{
        if (issueConnection && issueConnection.__id) return {
            type: 'ROOT_ISSUES',
            connectionId: issueConnection.__id,
            first: issueConnection?.edges?.length ?? 0
        };
        return undefined;
    }, [
        issueConnection
    ]);
    (0, $5FoyW.useRegisterConnection)(rootConnectionDetails);
    return null;
};

});
parcelRegister("k9lLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c97ecea7ac2b85f6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3b6024a55d0f932f442c9b98e73b03a5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c97ecea7ac2b85f6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "rootConnectionRegister_nativeIssueTable_issues",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$c97ecea7ac2b85f6$var$node.hash = "5283567b68955e1a7394bdb870c16539";
var $c97ecea7ac2b85f6$export$2e2bcd8739ae039 = $c97ecea7ac2b85f6$var$node;

});


parcelRegister("iTiuC", function(module, exports) {

$parcel$export(module.exports, "useKeyboardNavigation", () => $930d3307fa817275$export$4da28cf324280418);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $930d3307fa817275$export$4da28cf324280418 = (ref)=>{
    const lastFocusedElement = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        const table = ref.current;
        if (!table) return;
        if (!(0, $4R6GH.fg)('nin-grid-keyboard-navigation')) return;
        const getCell = (ele)=>ele?.closest('td') ?? ele?.closest('th');
        const getFocusableElements = ()=>Array.from(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.querySelectorAll([
                'a[href]:not([tabindex="-1"]):not([href=""]):not([href="javascript:;"])',
                'button:not([tabindex="-1"])',
                'input:not([tabindex="-1"], [type="hidden"])',
                'select:not([tabindex="-1"])',
                'textarea:not([tabindex="-1"])',
                "[tabindex]:not([tabindex='-1'])"
            ].join(',')));
        const onKeyDown = (event)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const activeElement = document.activeElement;
            const currentTr = activeElement?.closest('tr');
            if (event.key === 'Escape') {
                event.preventDefault();
                getCell(activeElement)?.focus();
                return;
            }
            if (event.key === 'Tab' && event.shiftKey && activeElement instanceof Element) {
                /*
					If focus would move from our cell to another cell when pressing shift+tab;
					Prevent default and focus first cell in the table.
				*/ const isCell = getCell(activeElement) === activeElement;
                const index = activeElement.getAttribute('tabindex');
                if (isCell) activeElement.setAttribute('tabindex', '0');
                const focusable = getFocusableElements();
                const currentFocusableElementsCell = getCell(activeElement);
                const nextFocusableElementsCell = getCell(focusable[focusable.indexOf(activeElement) - 1]);
                if (isCell) activeElement.setAttribute('tabindex', index ?? '-1');
                if (currentFocusableElementsCell === nextFocusableElementsCell || !nextFocusableElementsCell) return;
                const firstElementInsideTable = focusable.find((ele)=>table.contains(ele));
                event.preventDefault();
                firstElementInsideTable?.focus();
                return;
            }
            if (event.key === 'Tab' && activeElement) {
                /*
					If focus would move from our cell to another cell when pressing tab;
					Prevent default and focus first interactable thing outside the table. (probably create button but not always)
				*/ const isCell = getCell(activeElement) === activeElement;
                const index = activeElement.getAttribute('tabindex');
                if (isCell) activeElement.setAttribute('tabindex', '0');
                const focusable = getFocusableElements();
                const currentFocusableElementsCell = getCell(activeElement);
                const nextFocusableElementsCell = getCell(focusable[focusable.indexOf(activeElement) + 1]);
                if (isCell) activeElement.setAttribute('tabindex', index ?? '-1');
                if (currentFocusableElementsCell === nextFocusableElementsCell || !nextFocusableElementsCell) return;
                const nextFocusableElementOutsideTable = focusable.slice(focusable.indexOf(activeElement)).find((ele)=>!table.contains(ele));
                if (!nextFocusableElementOutsideTable) {
                    const lastInsideTable = focusable.slice(focusable.indexOf(activeElement)).at(-1);
                    if (!(lastInsideTable instanceof HTMLElement)) return;
                    lastInsideTable.focus({
                        preventScroll: true
                    });
                    return;
                }
                event.preventDefault();
                nextFocusableElementOutsideTable?.focus();
                return;
            }
            if (!activeElement || !(activeElement instanceof HTMLElement)) return;
            if (!currentTr || !(currentTr instanceof HTMLTableRowElement)) return;
            const currentTd = getCell(activeElement);
            if (!currentTd) return;
            const currentTds = Array.from(currentTr.children).filter((n)=>{
                return n.getAttribute('aria-hidden') !== 'true';
            });
            const currentTdIndex = currentTds.indexOf(currentTd);
            const rows = Array.from(table.querySelectorAll('tr:not([aria-hidden="true"])'));
            const currentTrIndex = rows.indexOf(currentTr);
            const isKeyboardNavigableElement = activeElement instanceof HTMLTableCellElement || activeElement instanceof HTMLButtonElement && activeElement.getAttribute('aria-hidden') === 'false';
            if (!isKeyboardNavigableElement) return;
            const next = (()=>{
                if (event.key === 'ArrowUp' || event.key === 'j') {
                    /* same index, in next row or first index in next row [grouped] */ const children = Array.from(rows[currentTrIndex - 1]?.children ?? []).filter((ele)=>{
                        return ele.getAttribute('aria-hidden') !== 'true';
                    });
                    return children[currentTdIndex] ?? rows[currentTrIndex - 1].children[0];
                }
                if (event.key === 'ArrowDown' || event.key === 'k') {
                    /* same index, in next row or first index in next row [grouped] */ const children = Array.from(rows[currentTrIndex + 1]?.children ?? []).filter((ele)=>{
                        return ele.getAttribute('aria-hidden') !== 'true';
                    });
                    return children[currentTdIndex] ?? rows[currentTrIndex + 1].children[0];
                }
                if (event.key === 'ArrowLeft') return currentTds[currentTdIndex - 1];
                if (event.key === 'ArrowRight') return currentTds[currentTdIndex + 1];
                if (event.key === 'End') return currentTds[currentTds.length - 1];
                if (event.key === 'Home') return currentTds[0];
                if (event.key === 'Enter') return currentTd.click();
            })();
            if (!(next instanceof HTMLElement)) return;
            event.stopImmediatePropagation(); // Stop meatball menu onKeyDown hijacking focus
            event.preventDefault();
            const button = next.querySelector('button[aria-hidden="false"]');
            if (button && button instanceof HTMLElement) return button.focus();
            return next.focus();
        };
        const onFocusIn = (e)=>{
            /* Focus first element inside table, if we've referred focus from outside table (shift+tab back into table) */ const target = e.target;
            if (!(target instanceof HTMLElement) || !(e.relatedTarget instanceof Element) || table.contains(e.relatedTarget)) {
                if (target instanceof HTMLElement) lastFocusedElement.current = getCell(target);
                return;
            }
            const focusable = getFocusableElements();
            const indexOfTable = focusable.findIndex((ele)=>table.contains(ele));
            const indexOfRelatedTarget = focusable.indexOf(e.relatedTarget);
            if (indexOfRelatedTarget < indexOfTable) lastFocusedElement.current = undefined;
        };
        const onKeyDownWindow = (e)=>{
            /*
				If focus is on the first element outside the table.
				prevent the default behaviour and move focus either to the last focuse element inside the table, or the first table cell.
			*/ if (e.key === 'Tab' && e.shiftKey) {
                const focusable = getFocusableElements();
                const elementOutsideTable = focusable.slice(focusable.findIndex((ele)=>table.contains(ele))).find((ele)=>!table.contains(ele));
                if (elementOutsideTable === e.target) {
                    e.preventDefault();
                    if (lastFocusedElement.current && table.contains(lastFocusedElement.current)) return lastFocusedElement.current.focus();
                    focusable.find((ele)=>table.contains(ele))?.focus();
                }
            }
        };
        table.addEventListener('keydown', onKeyDown);
        table.addEventListener('focusin', onFocusIn);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', onKeyDownWindow);
        return ()=>{
            table.removeEventListener('keydown', onKeyDown);
            table.removeEventListener('focusin', onFocusIn);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', onKeyDownWindow);
        };
    // RefObject is a constant reference.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref.current
    ]);
};

});



//# sourceMappingURL=async-issue-navigator-native-issue-table.74e47dd7.js.map
